import fetch$1 from 'isomorphic-fetch';
import createLogger from 'debug';
import { useLocation, useHistory, Link as Link$2, useRouteMatch, matchPath } from 'react-router-dom';
import * as React$2 from 'react';
import React__default, { useContext, useRef, useState, useEffect, createContext, useCallback, useMemo, forwardRef, useLayoutEffect, Component, Fragment as Fragment$1, Children, isValidElement, cloneElement, createElement } from 'react';
import { KeyboardDatePicker as KeyboardDatePicker$1, MuiPickersUtilsProvider } from '@material-ui/pickers';
import styled, { css as css$1, ThemeProvider as ThemeProvider$1, createGlobalStyle, keyframes, useTheme as useTheme$3 } from 'styled-components';
import { FormControl as FormControl$1, makeStyles as makeStyles$1, Select as Select$1, MenuItem, InputLabel, FormHelperText, createMuiTheme as createMuiTheme$1, jssPreset as jssPreset$1, StylesProvider, ThemeProvider, Link as Link$1, DialogTitle as DialogTitle$1, Typography, IconButton as IconButton$5, CircularProgress, Menu as Menu$1, Dialog as Dialog$6, DialogContent, DialogActions, Button, SvgIcon as SvgIcon$2, Modal, Collapse, Toolbar, useMediaQuery, Badge as Badge$2, NoSsr, useTheme as useTheme$2, List, ListItem, ListItemText, ListItemSecondaryAction as ListItemSecondaryAction$1, Tooltip as Tooltip$2, Chip as Chip$1, TextField as TextField$1, Card as Card$1, CardContent, Popover, Checkbox as Checkbox$1, BottomNavigationAction, Popper, FormControlLabel, Portal, Paper, Box, Divider as Divider$1, ListSubheader, MuiThemeProvider, Input, Switch as Switch$1, ListItemIcon, MenuList, Accordion, AccordionSummary as AccordionSummary$1, AccordionDetails, DialogContentText, FormGroup, Drawer as Drawer$1, ListItemAvatar, Avatar as Avatar$1, OutlinedInput, Tabs as Tabs$4, createStyles, Grid as Grid$1, InputAdornment, Hidden, ButtonGroup, Table, TableHead, TableRow, TableCell, TableBody, FormLabel, RadioGroup, Radio } from '@material-ui/core';
import { useIntl, IntlProvider, FormattedRelativeTime, FormattedMessage, FormattedDate } from 'react-intl';
import useSWR, { mutate } from 'swr';
import { shouldPolyfill } from '@formatjs/intl-relativetimeformat/should-polyfill';
export { shouldPolyfill as shouldPolyfillRelativeTime } from '@formatjs/intl-relativetimeformat/should-polyfill';
import { shouldPolyfill as shouldPolyfill$1 } from '@formatjs/intl-pluralrules/should-polyfill';
export { shouldPolyfill as shouldPolyfillPlurals } from '@formatjs/intl-pluralrules/should-polyfill';
import { create, createRule, RuleList, hasCSSTOMSupport, toCssValue, getDynamicStyles } from 'jss';
import rtl from 'jss-rtl';
import { ExpandLess, ExpandMore as ExpandMore$1 } from '@material-ui/icons';
import clsx, { clsx as clsx$1 } from 'clsx';
import { MdClose, MdVisibilityOff, MdVisibility, MdLock, MdOutlineVisibility, MdOutlineVisibilityOff, MdEvent, MdOutlineReport, MdOutlineEdit, MdOutlineEditOff, MdSave, MdPublishedWithChanges, MdAdd, MdOutlineFileUpload, MdOutlineKeyboardArrowUp, MdOutlineKeyboardArrowDown, MdDeleteOutline, MdEdit, MdLogin, MdOutlinePersonOff, MdSend, MdNotifications, MdMic, MdTranslate, MdAutoFixHigh, MdAutoAwesome, MdBookmark, MdNoteAdd, MdArrowBack, MdShare, MdExpandLess, MdExpandMore, MdExpandCircleDown, MdMenu, MdGroups, MdEditNote, MdSearch, MdSettings, MdPause, MdPlayArrow, MdFastRewind, MdFastForward, MdSpeed, MdNotes, MdVolumeUp, MdErrorOutline, MdBookmarkAdded, MdInfo, MdWarning, MdLayers, MdMenuBook, MdFavorite, MdAccountBalance, MdCheck, MdContentCopy, MdAttachFile, MdLocationPin, MdPhone, MdOutlineMail, MdPerson, MdCalendarToday, MdOpenInNew, MdChevronLeft, MdChevronRight, MdAudiotrack, MdVideocam, MdImage, MdLocationOn, MdHome, MdTimer, MdGroup, MdOutlineBackspace, MdOutlineWatchLater, MdFilterList, MdHeadphones, MdCheckCircle, MdSentimentDissatisfied, MdPersonOutline, MdAutoStories, MdCardMembership, MdPrivacyTip, MdOutlineOpenInNew, MdError, MdLanguage, MdDelete, MdPostAdd, MdSchedule, MdReplay, MdRefresh, MdScheduleSend, MdFolderOpen, MdOutlineClear, MdOutlineClose, MdLockOpen, MdCloudUpload, MdInsertDriveFile, MdClear, MdUpload, MdDownload, MdFileDownload, MdOutlinePostAdd, MdStop, MdOutlineCheck, MdOutlinePlayArrow, MdMoreHoriz, MdKeyboardArrowRight, MdCheckBox, MdCheckBoxOutlineBlank, MdSwapVert, MdPublish, MdUnpublished } from 'react-icons/md';
export { MdEvent as EventIcon, MdOutlineReport as FlagIcon, MdNotifications as NotificationsIcon, MdAccountCircle as UsersIcon } from 'react-icons/md';
import { IoMdHelpCircleOutline, IoIosHeart, IoIosHeartEmpty, IoIosClose, IoMdLink } from 'react-icons/io';
export { IoMdHelpCircleOutline as HelpIcon, IoMdLink as LinkIcon, IoMdShare as ShareIcon } from 'react-icons/io';
import { HiOutlineCurrencyDollar, HiTag, HiOutlineLightBulb, HiInformationCircle, HiExternalLink } from 'react-icons/hi';
export { HiOutlineLightBulb as IdeaIcon, HiUsers as OnlineUsersIcon } from 'react-icons/hi';
import { BsQuestion, BsFileText, BsCardChecklist, BsGear, BsShare, BsThreeDotsVertical, BsReply, BsListNested, BsChevronDown, BsPersonPlus, BsSortNumericDown, BsSortNumericDownAlt, BsArrowsCollapse, BsChevronExpand, BsFile, BsFileWord, BsFileExcel, BsFileImage, BsFilePdf, BsTrash, BsChatDots, BsImageAlt, BsHeadphones, BsExclamation, BsPlay } from 'react-icons/bs';
export { BsCardChecklist as CompletedIcon, BsGear as ConfigIcon, BsExclamation as ExclamationIcon, BsFileText as NotesIcon, BsPlay as PlayIcon, BsFileText as PostIcon, BsQuestion as QuestionIcon, BsReply as ReplyIcon } from 'react-icons/bs';
import { FaGoogle, FaRegBell, FaRegFileAudio, FaRegCalendarCheck, FaRegUserCircle, FaUserEdit } from 'react-icons/fa';
export { FaHandPointer as HandPointerIcon, FaRegBellSlash as NotificationsOffOutlineIcon, FaRegBell as NotificationsOutlineIcon, FaRegPaperPlane as PaperPlaneIcon, FaSearch as SearchIcon } from 'react-icons/fa';
import { BiDotsVerticalRounded, BiBuildingHouse, BiEdit, BiUserPlus, BiRegistered, BiGroup, BiRefresh, BiMessageRoundedAdd, BiSearchAlt, BiPlusCircle, BiError } from 'react-icons/bi';
export { BiEdit as ArticleIcon, BiBuildingHouse as AssetIcon, BiError as ErrorIcon } from 'react-icons/bi';
import { AiOutlineClockCircle, AiOutlineSearch, AiOutlineClose, AiOutlineEdit, AiOutlineSound, AiFillPushpin } from 'react-icons/ai';
export { AiOutlineHistory as HistoryIcon, AiFillPushpin as PinIcon } from 'react-icons/ai';
import Imgix from 'react-imgix';
import { useEventEmitter, useThrottleFn, useUnmount, useMemoizedFn, useCreation, useBoolean, useTimeout, useRequest, useDeepCompareEffect, useThrottleEffect, useKeyPress, useAsyncEffect, useUpdateEffect, useDynamicList, useLocalStorageState as useLocalStorageState$1, useSetState, useUpdate, useSize, useInterval, useUnmountedRef, useDebounceFn, useClickAway, useControllableValue, useDocumentVisibility, configResponsive, useResponsive } from 'ahooks';
import { toast as toast$1, ToastContainer as ToastContainer$1 } from 'react-toastify';
import { useFloating, offset, flip, shift, autoUpdate, size } from '@floating-ui/react-dom';
import * as ReactDOM from 'react-dom';
import { createPortal } from 'react-dom';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, WhatsappShareButton, WhatsappIcon } from 'react-share';
import VisibilitySensor from 'react-visibility-sensor';
import { io } from 'socket.io-client';
import deepEqual from 'fast-deep-equal';
import { useDropzone } from 'react-dropzone';
import MomentUtils from '@date-io/moment';
import { Autocomplete as Autocomplete$1, ToggleButton as ToggleButton$1, Alert as Alert$2, AlertTitle as AlertTitle$2, TreeView, TreeItem, ToggleButtonGroup } from '@material-ui/lab';
import { LiaWindowClose, LiaMapMarkedAltSolid } from 'react-icons/lia';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { PiGear, PiColumns } from 'react-icons/pi';
import { GraphQLClient } from 'graphql-request';
import { TbWorld, TbMessage, TbMessageOff } from 'react-icons/tb';
import { LuFolderTree } from 'react-icons/lu';
import { IconContext as IconContext$1 } from 'react-icons';
import fuzzysort from 'fuzzysort';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { MarkerClusterer, NoopAlgorithm, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import { AutoSizer, InfiniteLoader, List as List$1 } from 'react-virtualized';

const getSearchParam = (name) => {
  try {
    const params = new URLSearchParams(typeof document === "undefined" ? "" : document.location.search);
    return params.get(name);
  } catch (error) {
    console.error(error);
  }
};
const buildQueryString = (params) => {
  const searchParams = new URLSearchParams();
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const value = params[key];
      if (value) {
        searchParams.append(key, value);
      }
    }
  }
  const query = searchParams.toString();
  return query ? "?" + query : "";
};

const getQueryStringParams = (query) => {
  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split("&").reduce((params, param) => {
    let [key, value] = param.split("=");
    params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
    return params;
  }, {}) : {};
};
const object2QueryString = (object) => {
  const str = [];
  for (var p in object)
    if (object.hasOwnProperty(p)) {
      const value = object[p];
      if (value === void 0 || value === "") {
        continue;
      }
      str.push(encodeURIComponent(p) + "=" + (typeof value === "string" ? encodeURIComponent(value) : value));
    }
  return str.join("&");
};
const setQueryStringParams = (params) => {
  window.location.hash = "?" + object2QueryString(params);
};
const useQueryStringParams = () => {
  const location = useLocation();
  const hash = location.hash.slice(1);
  if (!hash) {
    return {};
  }
  const paramsPart = hash.split("?")[1];
  if (!paramsPart) {
    return {};
  }
  return getQueryStringParams(paramsPart);
};

const buildUrlWithParams = (baseUrl, params) => {
  if (!params || Object.keys(params).length === 0) {
    return baseUrl;
  }
  const queryString = object2QueryString(params);
  if (!queryString) {
    return baseUrl;
  }
  const separator = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${separator}${queryString}`;
};

const createApiError = (type, details) => {
  const error = new Error(details.message);
  error.name = "ApiError";
  error.type = type;
  error.status = details.status;
  error.code = details.status;
  error.statusText = details.statusText;
  error.response = details.response;
  return error;
};
const createUploadError = (type, details) => {
  const error = createApiError(type, details);
  error.name = "UploadError";
  return error;
};
const parseApiResponse = async (response) => {
  try {
    const text = await response.text();
    if (!text)
      return null;
    try {
      return JSON.parse(text);
    } catch {
      return text;
    }
  } catch {
    return null;
  }
};
const parseErrorResponse = async (xhr) => {
  try {
    if (xhr.response) {
      if (typeof xhr.response === "string") {
        return JSON.parse(xhr.response);
      }
      return xhr.response;
    }
    return null;
  } catch {
    return xhr.responseText || xhr.response;
  }
};
const handleApiError = async (response, parsedResponse) => {
  const status = response.status;
  const statusText = "statusText" in response ? response.statusText : "";
  let errorResponse = parsedResponse;
  if (!errorResponse && "text" in response) {
    errorResponse = await parseApiResponse(response);
  }
  const message = getErrorMessage(status, statusText || "", errorResponse);
  const error = createApiError("server", {
    message,
    status,
    statusText,
    response: errorResponse
  });
  if (errorResponse && typeof errorResponse === "object") {
    if (errorResponse.errors) {
      error.errors = errorResponse.errors;
    } else {
      error.errors = errorResponse;
    }
  }
  return error;
};
const getErrorMessage = (status, statusText, response) => {
  if (response && typeof response === "object") {
    if (response.message)
      return response.message;
    if (response.error && response.error.message)
      return response.error.message;
    if (response.errors && Array.isArray(response.errors) && response.errors[0]) {
      return response.errors[0].message || response.errors[0];
    }
  }
  switch (status) {
    case 400:
      return "Invalid request. Please check your input and try again.";
    case 401:
      return "Authentication required. Please log in and try again.";
    case 403:
      return "You do not have permission to perform this action.";
    case 404:
      return "The requested resource was not found.";
    case 413:
      return "Request too large. Please reduce the size and try again.";
    case 415:
      return "Media type not supported. Please use a different format.";
    case 422:
      return "Validation failed. Please check your input and try again.";
    case 429:
      return "Too many requests. Please wait a moment and try again.";
    case 500:
      return "Server error occurred. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Service temporarily unavailable. Please try again later.";
    default:
      return statusText || `Request failed with status ${status}`;
  }
};
const isRetryableApiError = (error) => {
  if (error.type === "network" || error.type === "timeout") {
    return true;
  }
  if (error.type === "server" && error.status) {
    return error.status >= 500 || error.status === 429;
  }
  return false;
};
const getRetryDelay = (attemptNumber, baseDelay = 1e3) => {
  return Math.min(baseDelay * Math.pow(2, attemptNumber - 1), 3e4);
};

const info$9 = createLogger("info:ui");
const DEFAULT_PAGE_SIZE = 100;
const DEFAULT_RANGE = { start: 1, end: DEFAULT_PAGE_SIZE };
const simulateErrors = typeof localStorage !== "undefined" && localStorage.simulateErrors && parseInt(localStorage.simulateErrors);
class API {
  constructor({ root = "/ua", domain, credentials, tokenAuth = false, bearerOnly = false }) {
    this.expires = 0;
    this.root = root;
    this.rootWebsockets = root.replace("/ua", "/websockets").replace(":3002", ":3004");
    this.domain = domain;
    this.credentials = credentials;
    this.tokenAuth = tokenAuth;
    this.bearerOnly = bearerOnly;
    this.isEmailAvailable = this.isEmailAvailable.bind(this);
    this.isUsernameAvailable = this.isUsernameAvailable.bind(this);
  }
  setAuthToken(token) {
    this.authToken = token;
    this.jwtToken = void 0;
    this.expires = 0;
  }
  getServiceRoot(service) {
    return this.rootWebsockets;
  }
  createEndpoint(path, { service }) {
    if (path.startsWith("https://") || path.startsWith("http://")) {
      return path;
    }
    const cleaned = path[0] === "/" ? path.slice(1) : path;
    let root;
    if (service) {
      root = this.getServiceRoot(service);
    } else {
      root = cleaned.startsWith(this.root.slice(1) + "/") ? "" : this.root;
    }
    const endpoint = `${root}/${cleaned}`;
    return endpoint;
  }
  createHeaders(opts, req) {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json"
    };
    if (this.bearerOnly)
      headers["X-NewsSocial-Auth"] = "bearer";
    if (this.domain) {
      headers["X-Forwarded-Host"] = this.domain;
      headers["X-Domain"] = this.domain;
    }
    if (this.credentials) {
      const cookie = Object.getOwnPropertyNames(this.credentials).reduce((r, n) => r.length ? `${r};${n}=${this.credentials[n]}` : `${n}=${this.credentials[n]}`, "");
      headers["Cookie"] = cookie;
    }
    if (opts) {
      Object.getOwnPropertyNames(opts).forEach((name) => {
        headers[name] = opts[name];
      });
    }
    if (req.service && typeof this.jwtToken === "string") {
      headers["Authorization"] = `Bearer ${this.jwtToken}`;
    } else if (this.tokenAuth && this.authToken) {
      headers["Authorization"] = `Bearer ${this.authToken}`;
    }
    return headers;
  }
  buildUrl(path, params) {
    const endpoint = this.createEndpoint(path, { service: void 0 });
    return buildUrlWithParams(endpoint, params);
  }
  buildServiceUrl(path, service, params) {
    const endpoint = this.createEndpoint(path, { service });
    return buildUrlWithParams(endpoint, params);
  }
  upload(opts) {
    return new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = opts.timeout || 3e5;
        xhr.addEventListener("load", async () => {
          try {
            if (xhr.status >= 200 && xhr.status <= 300) {
              const response = JSON.parse(xhr.response);
              resolve(response);
            } else {
              const errorResponse = await parseErrorResponse(xhr);
              const message = getErrorMessage(xhr.status, xhr.statusText, errorResponse);
              reject(createUploadError("server", {
                message,
                status: xhr.status,
                statusText: xhr.statusText,
                response: errorResponse
              }));
            }
          } catch (parseError) {
            reject(createUploadError("parse", {
              message: "Failed to parse server response",
              status: xhr.status,
              statusText: xhr.statusText,
              response: xhr.response
            }));
          }
        });
        xhr.addEventListener("error", () => {
          reject(createUploadError("network", {
            message: "Network error occurred during upload. Please check your connection and try again.",
            status: xhr.status,
            statusText: xhr.statusText
          }));
        });
        xhr.addEventListener("abort", () => {
          reject(createUploadError("abort", {
            message: "Upload was cancelled",
            status: xhr.status,
            statusText: xhr.statusText
          }));
        });
        xhr.addEventListener("timeout", () => {
          reject(createUploadError("timeout", {
            message: "Upload timed out. Please try again or select a smaller file.",
            status: xhr.status,
            statusText: xhr.statusText
          }));
        });
        xhr.withCredentials = !this.bearerOnly;
        xhr.upload.addEventListener("progress", function(ev) {
          if (ev.lengthComputable) {
            const percent = Math.round(ev.loaded / ev.total * 100);
            if (opts.onProgress)
              opts.onProgress(percent);
          }
        });
        const data = new FormData();
        Object.getOwnPropertyNames(opts).forEach((name) => {
          if (name !== "path" && name !== "onProgress" && name !== "timeout" && opts[name] !== void 0) {
            data.append(name, opts[name]);
          }
        });
        xhr.open("POST", this.createEndpoint(opts.path || "uploads", opts));
        if (this.bearerOnly)
          xhr.setRequestHeader("X-NewsSocial-Auth", "bearer");
        if (this.tokenAuth && this.authToken) {
          xhr.setRequestHeader("Authorization", `Bearer ${this.authToken}`);
        }
        xhr.send(data);
      } catch (e) {
        reject(createUploadError("unknown", {
          message: e instanceof Error ? e.message : "Unknown error occurred during upload setup"
        }));
      }
    });
  }
  async get(opts) {
    return await this.makeRequest({ ...opts, method: "GET" });
  }
  async post(opts) {
    return await this.makeRequest({ ...opts, method: "POST" });
  }
  async delete(opts) {
    return await this.makeRequest({ ...opts, method: "DELETE" });
  }
  async patch(opts) {
    return await this.makeRequest({ ...opts, method: "PATCH" });
  }
  async activityRequest(opts) {
    await this.loadJwt();
    return this.makeRequest({ service: "activity", ...opts });
  }
  async makeRequest(opts) {
    if (opts.description) {
      info$9("%s: %o", opts.description, opts);
    } else {
      info$9("makeRequest: %o", opts);
    }
    try {
      if (simulateErrors) {
        const up = localStorage.simulateErrors && parseInt(localStorage.simulateErrors) || -1;
        if (Math.random() <= up / 10) {
          console.error("simulating error for request:", { ...opts });
          throw new Error("Simulated error: " + opts.path);
        }
      }
      const path = opts.params ? buildUrlWithParams(opts.path, opts.params) : opts.path;
      const uri = this.createEndpoint(path, opts);
      const response = await fetch$1(uri, {
        credentials: this.bearerOnly ? "omit" : "include",
        mode: "cors",
        method: opts.method || "GET",
        headers: this.createHeaders(opts.headers, opts),
        body: JSON.stringify(opts.body)
      });
      if (opts.raw) {
        return response;
      }
      if (response.status >= 200 && response.status < 400) {
        if (response.status === 204) {
          return void 0;
        } else {
          return await response.json();
        }
      } else {
        const parsedResponse = await parseApiResponse(response);
        const apiError = await handleApiError(response, parsedResponse);
        throw apiError;
      }
    } catch (err) {
      console.error(err);
      if (err && err.type)
        throw err;
      throw createApiError("network", {
        message: err && err.message ? err.message : "Network error"
      });
    }
  }
  async loadJwt() {
    if (!this.jwtToken || this.expires <= Date.now()) {
      this.expires = void 0;
      this.jwtToken = this.get({
        path: "users/jwt"
      }).then((v) => {
        const token = v.token;
        const parsed = this.parseJwt(token);
        const d = new Date(0);
        d.setUTCSeconds(parsed.exp);
        this.expires = d.getTime();
        this.jwtToken = token;
        return token;
      }).catch((e) => {
        this.jwtToken = void 0;
        console.error(e);
        throw e;
      });
    }
    return this.jwtToken;
  }
  parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(window.atob(base64).split("").map(function(c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return JSON.parse(jsonPayload);
  }
  async loadInstanceInfo() {
    return await this.get({
      path: "info"
    });
  }
  async loginWithEmail(credentials) {
    return await this.post({
      path: "login/credentials",
      body: credentials
    });
  }
  async loginWithFacebook(fb) {
    return await this.post({
      path: "login/facebook",
      body: fb
    });
  }
  async logout() {
    return await this.post({
      path: "logout"
    });
  }
  async loadProfile(adminInfo = false) {
    let path = "profile";
    if (adminInfo) {
      path += "?admin=1";
    }
    return await this.get({
      path
    });
  }
  async updateProfile(profile) {
    return await this.post({
      path: `profile`,
      body: { profile }
    });
  }
  async loadOnboardingTags() {
    return await this.get({
      path: "onboarding/tags"
    });
  }
  async loadUserByEmail(email) {
    return await this.get({
      path: `users/by-email/${email}`
    });
  }
  async isEmailAvailable(email) {
    try {
      const user = await this.loadUserByEmail(email);
      return !user;
    } catch (err) {
      if (err.code === 404) {
        return true;
      } else {
        return false;
      }
    }
  }
  async loadUserByUsername({ username }) {
    return await this.get({
      path: `users/by-username/${encodeURIComponent(username)}`
    });
  }
  async isUsernameAvailable(username) {
    try {
      return !await this.loadUserByUsername({ username });
    } catch (err) {
      if (err.code === 404) {
        return true;
      } else {
        return false;
      }
    }
  }
  async suggestUsers(opts) {
    let filter = typeof opts === "string" ? opts : opts.filter;
    return await this.get({
      path: `users/suggest/${filter}`
    });
  }
  async registerWithEmail(user) {
    return await this.post({
      path: "users/_new/email",
      body: user
    });
  }
  async registerWithFacebook(fb) {
    return await this.post({
      path: "users/_new/facebook",
      body: fb
    });
  }
  async confirmEmailWithPin({ userId, pin }) {
    return await this.get({
      path: `users/confirm-registration/${userId}/${pin}`
    });
  }
  async confirmEmailWithToken(token) {
    return await this.get({
      path: `users/confirm-registration/${token}`
    });
  }
  async requestPhoneOtp(phone, channel, turnstileToken) {
    return await this.post({
      path: "users/otp/request",
      body: { phone, channel, turnstileToken }
    });
  }
  async verifyPhoneOtp({ phone, code, mobiles, dial }) {
    return await this.post({
      path: "users/otp/verify",
      body: { phone, code, mobiles, dial }
    });
  }
  async refreshSession(refreshToken) {
    return await this.post({
      path: "users/token/refresh",
      body: { refreshToken }
    });
  }
  async revokeRefreshTokens() {
    return await this.post({
      path: "users/token/revoke",
      body: {}
    });
  }
  async webauthnRegisterOptions() {
    return await this.post({ path: "users/webauthn/register/options", body: {} });
  }
  async webauthnRegisterVerify({ response, name }) {
    return await this.post({ path: "users/webauthn/register/verify", body: { response, name } });
  }
  async webauthnCredentials() {
    return await this.get({ path: "users/webauthn/credentials" });
  }
  async webauthnLoginOptions(identifier) {
    return await this.post({ path: "users/webauthn/login/options", body: { identifier } });
  }
  async webauthnLoginVerify({ challengeId, response }) {
    return await this.post({ path: "users/webauthn/login/verify", body: { challengeId, response } });
  }
  async loginWithJwt(token) {
    return await this.post({
      path: "login/jwt",
      body: { token }
    });
  }
  async loginCookies(token) {
    const response = await this.post({
      path: "login/jwt",
      body: { token },
      raw: true
    });
    try {
      const cookies = response.headers["_headers"]["set-cookie"];
      const cookieValues = cookies.reduce((acc, setter) => {
        const first = setter.split(";")[0].split("=");
        const key = first[0];
        const value = first.slice(1).join("=");
        acc[key] = value;
        return acc;
      }, {});
      this.credentials = cookieValues;
    } catch (error) {
      console.error("loginCookies", error);
    }
    return response;
  }
  async forgotPassword(email) {
    return await this.get({
      path: `users/forgot-password/${email}`
    });
  }
  async resetPassword(user) {
    return await this.post({
      path: `users/reset-password`,
      body: { password: user.password }
    });
  }
  async loadDrafts(opts) {
    const filter = opts.filter || "_ALL";
    const range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `drafts/${filter}/${range.start}-${range.end}`
    });
  }
  async loadDraft(opts) {
    return await this.get({
      path: `drafts/${opts._id}`
    });
  }
  async loadUnpublishedDraft(opts) {
    return await this.get({
      path: `drafts/unpublished-responses/${opts.responseTo}`
    });
  }
  async upsertDraft(opts) {
    if (opts._id) {
      return await this.post({
        path: `drafts/${opts._id}`,
        body: opts
      });
    } else {
      return await this.post({
        path: `drafts/_new`,
        body: opts
      });
    }
  }
  publishEvent(opts) {
    return this.post({
      path: `events/publish/${opts.id}`,
      body: opts
    });
  }
  async deleteDraft(opts) {
    return await this.delete({
      path: `drafts/${opts._id}`
    });
  }
  async publish(draft) {
    return await this.post({
      path: `drafts/${draft._id}/_publish`,
      body: { draft }
    });
  }
  async loadMemberPosts(opts) {
    const filter = opts.filter || "_ALL";
    const range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `users/${opts.author}/posts/${filter}/${range.start}-${range.end}`
    });
  }
  async loadMemberEvents(opts) {
    const filter = opts.filter || "_ALL";
    const range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `users/${opts.author}/events/${filter}/${range.start}-${range.end}`
    });
  }
  async loadMemberResponses(opts) {
    const filter = opts.filter || "_ALL";
    const range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `users/${opts.author}/responses/${filter}/${range.start}-${range.end}`
    });
  }
  async loadPostByUsernameAndPostName(opts) {
    return await this.get({
      path: `users/${encodeURIComponent(opts.username)}/posts/${encodeURIComponent(opts.name)}`
    });
  }
  async loadPostById(opts) {
    return await this.get({
      path: `posts/${opts._id}`
    });
  }
  async loadPostByDraft(draftId) {
    return await this.get({
      path: `drafts/${draftId}/post`
    });
  }
  async unpublishPost(opts) {
    let path = `posts/${opts._id}`;
    if (opts.as_admin) {
      path = `${path}/${opts.as_admin}`;
    }
    return await this.delete({ path });
  }
  async addZoomToPost(opts) {
    return await this.post({
      path: `posts/${opts.post}/zoom`,
      body: opts
    });
  }
  async createZoomMeeting(opts) {
    return await this.post({
      path: `zoom/meeting`,
      body: opts
    });
  }
  async ratePost(opts) {
    return await this.post({
      path: `posts/${opts.post}/ratings`,
      body: opts
    });
  }
  async concludePost(opts) {
    return await this.post({
      path: `posts/${opts.post}/conclusion`,
      body: opts
    });
  }
  async zoomDraft(opts) {
    return await this.post({
      path: `zoomdraft/${opts.post}`,
      body: opts
    });
  }
  async follow(opts) {
    return await this.post({
      path: `${opts.entityType}/${opts.entityId}/followers/${opts.followerId}`
    });
  }
  async unfollow(opts) {
    return await this.delete({
      path: `${opts.entityType}/${opts.entityId}/followers/${opts.followerId}`
    });
  }
  async isFollowing(opts) {
    return await this.get({
      path: `${opts.entityType}/${opts.entityId}/followers/${opts.followerId}`
    });
  }
  async isFollowingMany(opts) {
    return await this.post({
      path: `${opts.entityType}/_ALL/followers/${opts.followerId}`,
      body: {
        entities: opts.entities
      }
    });
  }
  async followUser(opts) {
    return await this.follow({ ...opts, entityType: "user" });
  }
  async unfollowUser(opts) {
    return await this.unfollow({ ...opts, entityType: "user" });
  }
  async isFollowingUser(opts) {
    return await this.isFollowing({ ...opts, entityType: "user" });
  }
  async followTag(opts, getState) {
    const {
      session: { value: profile }
    } = getState();
    let o = typeof opts === "string" ? { entityId: opts } : opts;
    if (profile) {
      return await this.follow({
        ...o,
        entityType: "tag",
        followerId: profile._id
      });
    } else {
      throw new Error({ code: 401, message: "authentication_required" });
    }
  }
  async unfollowTag(opts, getState) {
    const {
      session: { value: profile }
    } = getState();
    let o = typeof opts === "string" ? { entityId: opts } : opts;
    if (profile) {
      return await this.unfollow({
        ...o,
        entityType: "tag",
        followerId: profile._id
      });
    } else {
      throw new Error({ code: 401, message: "authentication_required" });
    }
  }
  async isFollowingTag(opts) {
    return await this.isFollowing({ ...opts, entityType: "tag" });
  }
  async isFollowingTags(opts) {
    return await this.isFollowingMany({ ...opts, entityType: "tag" });
  }
  async loadActivities(type, opts) {
    let filter = opts.filter || "_ALL";
    let path = `activities/${type}/${filter}`;
    if (opts.limit) {
      if (opts.before) {
        path = `${path}/${opts.limit}/${opts.before}`;
      } else {
        path = `${path}/${opts.limit}`;
      }
    }
    return await this.get({ path });
  }
  async loadFlatActivities(opts) {
    return await this.loadActivities("flat", opts);
  }
  async loadAggregatedActivities(opts) {
    return await this.loadActivities("aggregated", opts);
  }
  async loadGroupActivities(opts) {
    let filter = opts.filter || "_ALL";
    let path = `group-activities/${opts.group}/aggregated/${filter}`;
    if (opts.limit) {
      if (opts.before) {
        path = `${path}/${opts.limit}/${opts.before}`;
      } else {
        path = `${path}/${opts.limit}`;
      }
    }
    return await this.get({ path });
  }
  createPathWithLimitAndBefore(path, opts) {
    if (opts.limit) {
      if (opts.before) {
        return `${path}/${opts.limit}/${opts.before}`;
      } else {
        return `${path}/${opts.limit}`;
      }
    } else {
      return `${path}/${DEFAULT_PAGE_SIZE}`;
    }
  }
  async loadTaggedPosts(opts) {
    const range = opts.range || DEFAULT_RANGE;
    const filter = opts.filter || "_ALL";
    const path = `tagged-posts/${encodeURIComponent(opts.tag)}/${encodeURIComponent(filter)}/${range.start}-${range.end}`;
    return await this.get({ path });
  }
  async loadFilteredPosts(opts) {
    const filter = opts.filter || "_ALL";
    const range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `posts/${filter}/${range.start}-${range.end}`
    });
  }
  async loadFilteredEvents(opts) {
    const filter = opts.filter || "_ALL";
    const range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `events/${filter}/${range.start}-${range.end}`
    });
  }
  async loadInterestingPosts(opts) {
    const filter = opts.filter || "_ALL";
    const range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `interesting-posts/${filter}/${range.start}-${range.end}`
    });
  }
  async loadInterestingEvents(opts) {
    const filter = opts.filter || "_ALL";
    const range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `interesting-events/${filter}/${range.start}-${range.end}`
    });
  }
  async loadNotifications(opts) {
    return await this.get({
      path: this.createPathWithLimitAndBefore("notifications", opts)
    });
  }
  async loadResponses(opts) {
    const range = opts.range || DEFAULT_RANGE;
    return this.get({
      path: `posts/${opts._id}/responses/${opts.depth || 1}/${range.start}-${range.end}` + buildQueryString({ lang: opts.language })
    });
  }
  async findInterestingPeople({
    filter,
    before = "_ALL",
    limit = DEFAULT_PAGE_SIZE
  } = { filter: "_ALL" }) {
    const f = filter;
    return this.get({ path: `users/interesting/${f}/${before}-${limit}` });
  }
  async findIconsForTags(tags) {
    return this.post({
      path: "icons",
      body: {
        tags
      }
    });
  }
  async upsertGroup(opts) {
    if (opts._id) {
      return await this.post({
        path: `groups/${opts._id}`,
        body: opts
      });
    } else {
      return await this.post({
        path: `groups/_new`,
        body: opts
      });
    }
  }
  async loadGroup(opts) {
    return await this.get({
      path: `groups/${opts._id}`
    });
  }
  async closeGroup(opts) {
    let path = `groups/${opts.group}/_close`;
    return await this.post({
      path,
      body: {
        outcome: opts.outcome
      }
    });
  }
  async reOpenGroup(opts) {
    let path = `groups/${opts.group}/_reopen`;
    return await this.post({ path });
  }
  async increasePrivacy(opts) {
    let path = `groups/${opts.group}/_increase_privacy`;
    return await this.post({ path });
  }
  async updateEndUserDigestFrequency(opts) {
    let path = `groups/${opts.group}/_update_content_digest_frequency`;
    return await this.post({
      path,
      body: {
        frequency: opts.frequency
      }
    });
  }
  async pinIntroToGroup(opts) {
    return await this.post({
      path: `groups/${opts.group}/_intro`,
      body: {
        post: opts.post
      }
    });
  }
  async loadJoinedGroups(opts) {
    let path = `groups/joined`;
    if (opts.access) {
      path = `${path}/${opts.access}`;
    } else {
      path = `${path}/_ALL`;
    }
    if (opts.status) {
      path = `${path}/${opts.status}`;
    } else {
      path = `${path}/_ALL`;
    }
    let range = opts.range || DEFAULT_RANGE;
    let filter = opts.filter || "_ALL";
    let fullPath = `${path}/${filter}/${range.start}-${range.end}`;
    return await this.get({
      path: fullPath
    });
  }
  async joinGroup(opts) {
    return await this.post({
      path: `groups/${opts._id}/members/_new`
    });
  }
  async leaveGroup(opts) {
    return await this.delete({
      path: `groups/${opts._id}/members`
    });
  }
  async discardInvitation(opts) {
    return await this.delete({
      path: `groups/${opts._id}/invitations/_discard`
    });
  }
  async loadAvailableGroups(opts = {}) {
    let path = `groups/discover`;
    let range = opts.range || DEFAULT_RANGE;
    let filter = opts.filter || "_ALL";
    return await this.get({
      path: `${path}/${filter}/${range.start}-${range.end}`
    });
  }
  async loadGroupPosts(opts) {
    const { intro, noIntro, language, chat } = opts;
    const main = `groups/${opts.group}/${opts.events ? "events" : "posts"}`;
    const range = opts.range || DEFAULT_RANGE;
    const filter = opts.filter || "_ALL";
    let path = `${main}/${filter}/${range.start}-${range.end}` + buildQueryString({ intro, noIntro, lang: language, chat });
    return await this.get({
      path
    });
  }
  async loadReferencesForGroup(opts) {
    let path = `groups/${opts.group}/references`;
    let range = opts.range || DEFAULT_RANGE;
    let filter = opts.filter || "_ALL";
    return await this.get({
      path: `${path}/${filter}/${range.start}-${range.end}`
    });
  }
  async loadSubGroups(opts) {
    let path = `groups/${opts.group}/groups`;
    let range = opts.range || DEFAULT_RANGE;
    let filter = opts.filter || "_ALL";
    return await this.get({
      path: `${path}/${filter}/${range.start}-${range.end}`
    });
  }
  async findUsersToInvite(opts) {
    let path = `groups/${opts.group}/non-members/${opts.filter}`;
    return await this.get({ path });
  }
  async invite(opts) {
    let path = `groups/${opts.group}/invitations`;
    return await this.post({
      path,
      body: {
        invitees: opts.invitees
      }
    });
  }
  async loadMembers(opts) {
    let path = `groups/${opts.group}/members`;
    let range = opts.range || DEFAULT_RANGE;
    let filter = opts.filter || "_ALL";
    return await this.get({
      path: `${path}/${filter}/${range.start}-${range.end}`
    });
  }
  async loadInvites(opts) {
    let path = `groups/${opts.group}/invitations`;
    let range = opts.range || DEFAULT_RANGE;
    let filter = opts.filter || "_ALL";
    return await this.get({
      path: `${path}/${filter}/${range.start}-${range.end}`
    });
  }
  async requestGroupAccess(opts) {
    let path = `groups/${opts.group}/requests`;
    return await this.post({ path });
  }
  async loadAccessRequests(opts) {
    let filter = opts.filter || "_ALL";
    let range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `groups/${opts.group}/requests/${filter}/${range.start}-${range.end}`
    });
  }
  async grantAccessRequest(opts) {
    return await this.post({
      path: `groups/${opts.group}/requests/_accept/${opts.from._id}`
    });
  }
  async denyAccessRequest(opts) {
    return await this.post({
      path: `groups/${opts.group}/requests/_reject/${opts.from._id}`
    });
  }
  async updateMembership({ group, user, update }) {
    let path = `groups/${group}/members/${user}`;
    return await this.post({
      path,
      body: update
    });
  }
  async suggestTags(opts) {
    let filter = opts.filter || "_ALL";
    let language = opts.language || "en";
    let range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `tags/${language}/suggest/${filter}/${range.start}-${range.end}`
    });
  }
  async suggestPosts(opts) {
    let filter = opts.filter || "_ALL";
    let language = opts.language || "en";
    let range = opts.range || DEFAULT_RANGE;
    return await this.get({
      path: `posts/${language}/suggest/${filter}/${range.start}-${range.end}`
    });
  }
  async loadReactions(opts) {
    return await this.post({
      path: `reactions`,
      body: {
        ids: opts.ids
      }
    });
  }
  async updateReaction(opts) {
    return await this.post({
      path: `reactions/${opts.post}`,
      body: {
        reactions: opts.reactions
      }
    });
  }
}

const ApiContext = React__default.createContext(null);
const useApi = () => {
  return useContext(ApiContext);
};

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1=React__default,g$1=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h$1=Symbol.for;g$1=h$1("react.element");reactJsxRuntime_production_min.Fragment=h$1("react.fragment");}var m$1=f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n$1=Object.prototype.hasOwnProperty,p$1={key:!0,ref:!0,__self:!0,__source:!0};
function q$1(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n$1.call(a,b)&&!p$1.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g$1,type:c,key:e,ref:l,props:d,_owner:m$1.current}}reactJsxRuntime_production_min.jsx=q$1;reactJsxRuntime_production_min.jsxs=q$1;

{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}

const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;

const APIProvider = ({
  api,
  children
}) => {
  return /* @__PURE__ */ jsx(ApiContext.Provider, {
    value: api,
    children: React__default.Children.only(children)
  });
};

const formControlCss = css$1`
  margin-top: ${({
  theme
}) => theme.spacing(2)}px;
  margin-bottom: ${({
  theme
}) => theme.spacing(2)}px;
  max-width: 430px;
  width: 100%;
`;
const FormControl = styled(FormControl$1).attrs({
  fullWidth: false,
  variant: "outlined"
})`
    && {
        ${formControlCss}
    }
`;

const KeyboardDatePicker = styled(KeyboardDatePicker$1)`
  && {
    ${formControlCss}
  }
`;

const useDateStyles = makeStyles$1((_) => {
  return {
    menuPaper: {
      maxHeight: 250
    }
  };
});

const DurationSelector = ({
  startDate,
  time,
  duration,
  onChangeDuration,
  ...rest
}) => {
  const intl = useIntl();
  const classes = useDateStyles();
  const value = duration || 18e5;
  if (value !== duration) {
    setTimeout(() => onChangeDuration(value), 0);
  }
  const handleChange = React$2.useCallback((event) => {
    const value2 = event.target.value;
    onChangeDuration(value2);
  }, []);
  return /* @__PURE__ */ jsxs(Select$1, {
    ...rest,
    value,
    onChange: handleChange,
    MenuProps: {
      classes: {
        paper: classes.menuPaper
      }
    },
    children: [/* @__PURE__ */ jsx(MenuItem, {
      value: ""
    }), /* @__PURE__ */ jsx(MenuItem, {
      value: 18e5,
      children: intl.formatMessage({
        id: "compose.new.thirtyMins"
      })
    }), /* @__PURE__ */ jsx(MenuItem, {
      value: 36e5,
      children: intl.formatMessage({
        id: "compose.new.SixtyMins"
      })
    }), /* @__PURE__ */ jsx(MenuItem, {
      value: 54e5,
      children: intl.formatMessage({
        id: "compose.new.NinetyMins"
      })
    }), /* @__PURE__ */ jsx(MenuItem, {
      value: 72e5,
      children: intl.formatMessage({
        id: "compose.new.OneTwentyMins"
      })
    }), /* @__PURE__ */ jsx(MenuItem, {
      value: 150 * 60 * 1e3,
      children: intl.formatMessage({
        id: "compose.new.minutes150"
      })
    }), /* @__PURE__ */ jsx(MenuItem, {
      value: 180 * 60 * 1e3,
      children: intl.formatMessage({
        id: "compose.new.minutes180"
      })
    }), /* @__PURE__ */ jsx(MenuItem, {
      value: 240 * 60 * 1e3,
      children: intl.formatMessage({
        id: "compose.new.minutes240"
      })
    })]
  });
};

const FormDatePicker = ({
  date,
  onChangeDate,
  ...other
}) => {
  const intl = useIntl();
  const dateStartTime = new Date(date);
  dateStartTime.setHours(0, 0, 0, 0);
  return /* @__PURE__ */ jsx(KeyboardDatePicker, {
    autoOk: true,
    fullWidth: true,
    variant: "inline",
    inputVariant: "outlined",
    label: other.label || intl.formatMessage({
      id: "compose.new.date"
    }),
    format: "DD/MM/yyyy",
    value: dateStartTime,
    InputAdornmentProps: {
      position: "start"
    },
    onChange: (date2) => {
      if (!date2) {
        return;
      }
      const next = new Date(date2.toDate());
      next.setHours(0, 0, 0, 0);
      onChangeDate(next);
    },
    ...other
  });
};

const EndDateSelector = ({
  startDate,
  duration,
  time,
  onChangeDuration
}) => {
  const intl = useIntl();
  if (!duration) {
    duration = 0;
  }
  const date = new Date(startDate.getTime() + time + duration);
  const setDate = (nextDate) => {
    const prev = new Date(date);
    prev.setHours(0, 0, 0, 0);
    onChangeDuration(-prev.getTime() + duration + nextDate.getTime());
  };
  return /* @__PURE__ */ jsx(FormDatePicker, {
    label: intl.formatMessage({
      id: "compose.new.end_date"
    }),
    date,
    onChangeDate: setDate,
    minDate: startDate
  });
};

const MINUTE$1 = 60 * 1e3;
const parseISOLocal = (s) => {
  if (typeof s === "number") {
    return new Date(s);
  }
  if (!s) {
    console.error("wrong date format!");
    return new Date();
  }
  const b = s.split(/\D/).map((s2) => parseInt(s2));
  return new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5]);
};
const dateTime2Day = (date) => {
  const date2 = new Date(date);
  date2.setHours(0, 0, 0, 0);
  return date2;
};
const beginningOfTheDay = (time = 0, date) => {
  date = date ? new Date(date) : new Date();
  date.setHours(0, 0, 0, 0);
  if (time) {
    date = new Date(date.getTime() + time);
  }
  return date;
};
class EventTemporalData {
  constructor(event) {
    const nodata = !event || !event.startTime;
    if (!nodata) {
      this.startTime = parseISOLocal(event.startTime).getTime();
      this.endTime = parseISOLocal(event.endTime).getTime();
      this.localStartTime = new Date(event.startTime);
      this.localEndTime = new Date(event.endTime);
      this.tzOffset2 = event.tzOffset2;
      this.tzOffset = event.tzOffset;
      this.timezone = event.timezone;
    }
    if (nodata) {
      this.startTime = new Date().getTime();
      this.duration = 0;
    }
    const dateTime1 = this.timezone && this.tzOffset && new Date(this.startTime - MINUTE$1 * this.tzOffset) || new Date(this.startTime);
    const date1 = dateTime2Day(dateTime1);
    if (!nodata) {
      this.duration = this.endTime - this.startTime;
      if (typeof event.tzOffset2 === "number") {
        this.duration -= MINUTE$1 * (event.tzOffset2 - this.tzOffset);
      }
      this.tzOffset = 0;
    }
    this.time = this.time1 = dateTime1.getTime() - date1.getTime();
    this.date1 = this.selectedDate = date1;
    const dateTime2 = new Date(dateTime1.getTime() + this.duration);
    const date2 = dateTime2Day(dateTime2);
    this.date2 = date2;
    this.time2 = dateTime2.getTime() - date2.getTime();
    this.nodata = nodata;
  }
}
class EventData extends EventTemporalData {
  constructor(post) {
    super(post.event);
    this.post = post;
    this.participants = post.participants;
    let nodata = !post.event;
    if (!nodata) {
      const event = post.event;
      this.meetingId = event.meetingId;
      this.join_url = event.join_url;
      this.eventType = event.eventType || "external";
      this.label = event.label;
      this.url = event.url;
      this.label2 = event.label2;
      this.url2 = event.url2;
      this.streamingInfo = event.streamingInfo;
      this.streamingUrl = event.streamingUrl;
      this.finished = event.finished;
      nodata = false;
    }
    if (nodata) {
      this.eventType = "external";
    }
  }
}

const SECOND = 1e3;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const TimeFormSelector = ({
  labelId = "time-label",
  id = "time-select",
  label: labelProp,
  ...other
}) => {
  const intl = useIntl();
  const label = labelProp || intl.formatMessage({
    id: "compose.new.time"
  });
  return /* @__PURE__ */ jsxs(FormControl, {
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: labelId,
      disableAnimation: true,
      children: label
    }), /* @__PURE__ */ jsx(TimeSelector, {
      labelId,
      id,
      label,
      ...other
    })]
  });
};
const TimeFormSelectorStateless = ({
  labelId = "time-label",
  id = "time-select",
  isTimeError,
  label: labelProp,
  ...other
}) => {
  const intl = useIntl();
  const label = labelProp || intl.formatMessage({
    id: "compose.new.time"
  });
  return /* @__PURE__ */ jsxs(FormControl, {
    error: isTimeError,
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: labelId,
      disableAnimation: true,
      children: label
    }), /* @__PURE__ */ jsx(TimeSelector, {
      labelId,
      id,
      label,
      stateless: true,
      ...other
    }), isTimeError && /* @__PURE__ */ jsx(FormHelperText, {
      children: "Time should not be before minimal time"
    })]
  });
};
const TimeSelector = ({
  time,
  stateless,
  onChangeTime = () => null,
  ...rest
}) => {
  const classes = useDateStyles();
  const reported = useRef();
  const [value, setValue] = React$2.useState(time || getClosestDefault());
  const handleChange = React$2.useCallback((event) => {
    const value2 = event.target.value;
    if (stateless) {
      onChangeTime(value2);
    } else {
      setValue(value2);
    }
  }, [onChangeTime]);
  if (!stateless && reported.current !== value) {
    reported.current = value;
    onChangeTime(value);
  }
  const selected = findClosestTime(stateless ? time : value);
  if (!stateless && selected !== value) {
    reported.current = selected;
    setValue(selected);
    onChangeTime(selected);
  }
  return /* @__PURE__ */ jsx(Select$1, {
    ...rest,
    value: selected,
    onChange: handleChange,
    MenuProps: {
      classes: {
        paper: classes.menuPaper
      }
    },
    children: selectable.map((h) => /* @__PURE__ */ jsx(MenuItem, {
      value: HOUR * h,
      children: selectorText(h)
    }, h))
  });
};
let selectable;
const menuItems = () => {
  selectable = [];
  for (let hours = 6; hours < 24; hours += 0.25) {
    selectable.push(hours);
  }
};
menuItems();
const selectorText = (h) => {
  const hours = Math.floor(h);
  const delta = h - hours;
  const minutes = delta > 0.6 ? "45" : delta > 0.4 ? "30" : delta < 0.15 ? "00" : "15";
  return `${hours}:${minutes}`;
};
const findClosestTime = (now) => {
  now = typeof now === "number" ? beginningOfTheDay(now) : now;
  const hours = now.getHours();
  const min = now.getMinutes();
  const searched = Math.round((hours + min / 60) * 100) / 100;
  let i = 0;
  for (; i < selectable.length; i++) {
    if (selectable[i] >= searched) {
      break;
    }
  }
  if (i >= selectable.length) {
    i = selectable.length - 1;
  }
  return HOUR * selectable[i];
};
const getClosestDefault = () => {
  const now = new Date();
  return findClosestTime(now);
};

const EndTimeSelector = ({
  startDate,
  duration,
  time,
  onChangeDuration
}) => {
  const intl = useIntl();
  if (!duration) {
    duration = 0;
  }
  const date = new Date(startDate.getTime() + time + duration);
  const dateStart = new Date(date);
  dateStart.setHours(0, 0, 0, 0);
  const endTime = date.getTime() - dateStart.getTime();
  const onChangeTime = (nextTime) => {
    onChangeDuration(-endTime + duration + nextTime);
  };
  return /* @__PURE__ */ jsx(TimeFormSelector, {
    labelId: "end-time-label",
    time: endTime,
    onChangeTime,
    label: intl.formatMessage({
      id: "compose.new.end_time"
    })
  });
};

const EndDateTimeSelector = ({
  showDuration,
  ...props
}) => {
  const intl = useIntl();
  if (showDuration) {
    const label = intl.formatMessage({
      id: "compose.new.Duration"
    });
    return /* @__PURE__ */ jsxs(FormControl, {
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "duration-label",
        disableAnimation: true,
        children: label
      }), /* @__PURE__ */ jsx(DurationSelector, {
        labelId: "duration-label",
        id: "duration-select",
        label,
        ...props
      })]
    });
  }
  const {
    duration,
    onChangeDuration,
    time,
    startDate: date
  } = props;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(EndDateSelector, {
      startDate: date,
      duration,
      onChangeDuration,
      time
    }), /* @__PURE__ */ jsx(EndTimeSelector, {
      startDate: date,
      duration,
      onChangeDuration,
      time
    })]
  });
};

const info$8 = createLogger("info:ui");
const formatGMTOffset = (signed) => {
  const offset = Math.abs(signed);
  const hours = Math.floor(offset / 60);
  const minutes = offset - hours * 60;
  const sing = -signed >= 0 ? "+" : "-";
  const strMinutes = minutes.toString();
  const padded = strMinutes.length < 2 ? "0" + strMinutes : strMinutes;
  return "GMT" + sing + hours + ":" + padded;
};
const localDateTime = (dateObj) => {
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const day = String(dateObj.getDate()).padStart(2, "0");
  const year = dateObj.getFullYear();
  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const seconds = String(dateObj.getSeconds()).padStart(2, "0");
  const milliseconds = String(dateObj.getMilliseconds());
  return year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds + "." + milliseconds;
};
const useTimezones = () => {
  const api = useApi();
  const result = useSWR("/timezones", async (path) => {
    const data = await api.makeRequest({
      path,
      method: "GET"
    });
    const timezones = data.csv.split(";").map((v) => {
      const [name, strOffset] = v.split(":");
      return {
        name,
        offset: parseInt(strOffset)
      };
    });
    info$8("timezones: %o", timezones);
    return timezones;
  }, swrLoadOnce);
  return result;
};
const getUserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (_) {
  }
};
const findClosest = (timezones, tz) => {
  const parts = tz && tz.split("/");
  if (parts && parts.length > 1) {
    const part1 = parts[0];
    timezones = timezones.filter((t) => t.name.indexOf(part1) !== -1);
  }
  const offset = new Date().getTimezoneOffset();
  const closest = timezones.reduce((current, t) => {
    if (Math.abs(current.offset - offset) > Math.abs(t.offset - offset)) {
      return t;
    }
    return current;
  }, timezones[0]);
  return closest;
};
const defaultTimezoneOption = (timezone, tzOffset) => {
  const name = timezone || getUserTimezone();
  const offset = tzOffset || new Date().getTimezoneOffset();
  const tzOption = {
    label: tzLabel(name, offset),
    value: name,
    offset
  };
  return tzOption;
};
const tzLabel = (name, offset) => `(${formatGMTOffset(offset)}) ${name}`;
const tzOptionsSorter = (a, b) => a.offset - b.offset;
const SelectTimezone = ({
  timezone,
  tzOffset,
  onChangeTimezone = () => null,
  ...rest
}) => {
  const classes = useDateStyles();
  const options = useRef();
  const reported = useRef();
  const initialized = useRef();
  const [value, setValue] = React$2.useState(() => {
    const tz = timezone || getUserTimezone();
    return tz;
  });
  const {
    data: timezones
  } = useTimezones();
  const handleChange = React$2.useCallback((event) => {
    const value2 = event.target.value;
    setValue(value2);
  }, [onChangeTimezone]);
  if (!options.current) {
    options.current = (() => {
      const tzOption = defaultTimezoneOption(timezone, tzOffset);
      if (!tzOption) {
        return [];
      }
      return [tzOption];
    })();
  }
  if (timezones && !initialized.current) {
    options.current = (() => {
      const options2 = timezones.map((t) => {
        const name = t.name;
        const current = {
          label: tzLabel(t.name, t.offset),
          value: name,
          offset: t.offset
        };
        return current;
      });
      const tz = timezone || getUserTimezone();
      const unknownTz = !options2.find((v) => v.value === tz);
      if (unknownTz) {
        const tzOption = defaultTimezoneOption(timezone, tzOffset);
        if (tzOption) {
          options2.push(tzOption);
        }
        if (!value) {
          setValue(findClosest(timezones, tz).name);
        }
      }
      return options2.sort(tzOptionsSorter);
    })();
  }
  if (reported.current !== value) {
    reported.current = value;
    onChangeTimezone(value);
  }
  return /* @__PURE__ */ jsx(Select$1, {
    ...rest,
    value,
    placeholder: "Timezone ...",
    onChange: handleChange,
    MenuProps: {
      classes: {
        paper: classes.menuPaper
      }
    },
    children: options.current.map((o) => /* @__PURE__ */ jsx(MenuItem, {
      value: o.value,
      children: o.label
    }, o.value))
  });
};

const canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);

const useDirectionality = () => {
  const intl = useIntl();
  return getDirection$1(intl.locale);
};
const ARABIC = "ar";
const DEFAULT_LANGUAGE = "en";
const AVAILABLE_LANGUAGES = [ARABIC, DEFAULT_LANGUAGE];
const getBrowserLanguage = () => {
  return (typeof localStorage !== "undefined" && localStorage && localStorage.language || typeof navigator !== "undefined" && (navigator.language || navigator["userLanguage"] || navigator["browserLanguage"]) || DEFAULT_LANGUAGE).split("-")[0];
};
const rtlLanguages = ["ar", "ku", "ur", "fa"];
const getDirection$1 = (language) => {
  if (rtlLanguages.includes(language)) {
    return "rtl";
  }
  return "ltr";
};
const getDirectionality = () => {
  return getDirection$1(appLanguage);
};
let appLanguage;
const getLanguage = () => appLanguage;
const useLanguage = (browserLanguage, options) => {
  const {
    loadPolyfills
  } = options;
  const [data, setData] = useState(setupLanguage(browserLanguage, options));
  const {
    language,
    loading
  } = data;
  translations = data.translations;
  appLanguage = language;
  useEffect(() => {
    if (loading) {
      loadPolyfills({
        language
      }).then(() => setData((data2) => ({
        ...data2,
        loading: false
      })));
    }
  }, [language, loading]);
  return data;
};
const chooseLanguage = (browserLanguage) => {
  let language = DEFAULT_LANGUAGE;
  if (browserLanguage) {
    if (AVAILABLE_LANGUAGES.find((lang) => lang === browserLanguage)) {
      language = browserLanguage;
    }
  }
  return language;
};
const setupLanguage = (browserLanguage, options) => {
  const {
    shouldPolyfill = () => false,
    getTranslation
  } = options;
  const language = chooseLanguage(browserLanguage);
  const translations2 = getTranslation(language);
  return {
    language,
    translations: translations2,
    loading: shouldPolyfill()
  };
};
let translations;
if (typeof window !== "undefined") {
  window["translations"] = () => translations;
}

const flatten = (json) => {
  let result = {};
  Object.getOwnPropertyNames(json).forEach((name) => {
    let v = json[name];
    if (typeof v === "string") {
      result[name] = v;
    } else {
      let nested = flatten(v);
      Object.getOwnPropertyNames(nested).forEach((n) => {
        result[`${name}.${n}`] = nested[n];
      });
    }
  });
  return result;
};

const plurals$1 = {
  and_one_other: 'وواحد آخر',
  and_n_others: 'و {n} آخرون',
  view: 'مشاهدة',
  one_response: 'استجابة واحدة',
  n_responses: '{responseCount} استجابات',
  one_elided_post: 'مشاركة واحدة',
  n_elided_posts: '{length} مشاركات',
  one_member: 'عضو واحد',
  n_members: '{memberCount} أعضاء}',
  one_post: 'مشاركة واحدة',
  n_posts: '{postCount} مشاركات',
  one_pending_request: 'مشاركة واحدة معلقة',
  n_pending_requests: '{access_request_count} طلبات معلقة}'
};

var ar = {
  chat: {
    pin: "تثبيت الرسالة",
    unpin: "إلغاء تثبيت الرسالة",
    edit: "يحرر",
    loadMore: "تحميل المزيد...",
    search1: "أدخل أي سؤال في نافذة البحث، مثل 'الخدمات الصحية في بريستون'، ثم انقر فوق زر تحليل الذكاء الاصطناعي، أو اضغط على 'رجوع'",
    search2: "للبحث بالذكاء الاصطناعي، انقر على أيقونة CAIR، ثم انقر على زر البحث بالذكاء الاصطناعي، أو اضغط على Return",
    search3: "للبحث عن الكلمات الرئيسية، انقر على أيقونة العدسة المكبرة ثم أدخل الكلمة الرئيسية ثم اضغط على 'رجوع'"
  },
  auth: {
    or: "أو",
    newPassword: "كلمة المرور الجديدة",
    change2: "يتغير...",
    change: "تغيير كلمة المرور",
    forgot: "هل نسيت كلمة السر؟",
    verify2: "يؤكد...",
    verify: "تأكيد",
    verificationCode: "رمز التحقق",
    confirmationCode: "رمز التأكيد",
    emailOrPhone: "البريد الإلكتروني أو رقم الهاتف",
    resetting: "إعادة الضبط...",
    reset: "إعادة تعيين كلمة المرور",
    sentEmail: "لقد أرسلنا إليك رابطًا لإعادة تعيين كلمة المرور. يرجى التحقق من بريدك الإلكتروني.",
    phoneNoPassword: "هل سجلت باستخدام هاتفك؟ لا تحتاج إلى كلمة مرور \u2014 سجل الدخول برقم هاتفك وسنرسل إليك رمزًا في رسالة نصية.",
    resetLinkExpired: "انتهت صلاحية رابط إعادة تعيين كلمة المرور. يرجى طلب رابط جديد.",
    changeFailed: "لم نتمكن من تغيير كلمة المرور، يرجى المحاولة مرة أخرى.",
    noSuchAccount: "لم نتمكن من العثور على حساب بهذا البريد الإلكتروني.",
    emailBounced: "لا يمكننا إرسال بريد إلكتروني إلى هذا العنوان. يرجى التواصل مع الدعم.",
    resetFailed: "لم نتمكن من إرسال بريد إعادة التعيين، يرجى المحاولة مرة أخرى.",
    register2: "مستخدم جديد؟ قم بالتسجيل!",
    registerWithPhone: "سجل باستخدام هاتفك",
    phone: "رقم التليفون",
    email: "بريد إلكتروني",
    password: "كلمة المرور",
    confirm: "تأكيد كلمة المرور",
    register: "يسجل",
    registering: "جاري إنشاء الحساب...",
    agree: "أوافق على شروط الخدمة",
    alreadyHaveAccount: "هل لديك حساب بالفعل؟ قم بتسجيل الدخول!",
    registerWithPhone: "سجل برقم الهاتف",
    login2access: "الرجاء تسجيل الدخول للوصول إلى هذه الصفحة",
    authRequired: "مطلوب المصادقة",
    register: "إنشاء حساب",
    login: "المستخدم الحالي: تسجيل الدخول",
    login2: "تسجيل الدخول",
    login3: "جاري تسجيل الدخول...",
    continueWithPhone: "المتابعة باستخدام الهاتف",
    phone2: "الهاتف",
    country: "الدولة",
    sendCode: "إرسال الرمز",
    sendingCode: "جاري إرسال الرمز...",
    codeSent: "لقد أرسلنا رمز التحقق إلى هاتفك عبر رسالة نصية.",
    phoneLengthExact: "يجب أن يتكون رقم الهاتف من {n} أرقام (بدون الصفر في البداية).",
    phoneLengthRange: "يجب أن يتكون رقم الهاتف من {min} إلى {max} رقمًا (بدون الصفر في البداية).",
    enterCode: "رمز التحقق",
    resendCode: "إعادة إرسال الرمز",
    resendCodeIn: "إعادة إرسال الرمز خلال {seconds} ثانية",
    sendCodeWhatsApp: "استلام الرمز عبر واتساب",
    changePhone: "استخدام رقم هاتف آخر",
    otpInvalid: "الرمز غير صحيح، يرجى المحاولة مرة أخرى.",
    otpExpired: "انتهت صلاحية الرمز، يرجى طلب رمز جديد.",
    otpTooManyAttempts: "محاولات كثيرة جدًا، يرجى طلب رمز جديد.",
    otpCooldown: "يرجى الانتظار دقيقة قبل طلب رمز آخر.",
    otpRateLimited: "طلبات كثيرة جدًا، يرجى المحاولة لاحقًا.",
    smsSendFailed: "تعذر إرسال الرسالة النصية، يرجى المحاولة مرة أخرى.",
    otpCountryNotSupported: "لا يمكننا إرسال رموز إلى هذا البلد. يرجى التسجيل بالبريد الإلكتروني.",
    otpCaptchaPending: "جارٍ التحقق من متصفحك\u2026",
    otpFailed: "حدث خطأ ما، يرجى المحاولة مرة أخرى.",
    biometricLogin: "تسجيل الدخول بالبصمة",
    biometricFailed: "فشل تسجيل الدخول بالبصمة، يرجى تسجيل الدخول مرة أخرى.",
    passkeyLogin: "تسجيل الدخول بمفتاح المرور",
    passkeyFailed: "فشل تسجيل الدخول بمفتاح المرور، يرجى المحاولة مرة أخرى.",
    passkeyAdd: "إضافة مفتاح مرور",
    passkeyAdded: "تمت إضافة مفتاح المرور",
    passkeyEnrollFailed: "تعذر إضافة مفتاح المرور، يرجى المحاولة مرة أخرى."
  },
  CloseDiscussion: 'اغلق النقاش مع هذه كمحصلة',
  reopen: 'أعد فتح المناقشة',
  toggleReponse: 'تبديل الردود',
  CreateZoomMeeting: "إنشاء اجتماع التكبير",
  close: "أغلق",
  people: "اشخاص",
  outcome: 'المحصلة',
  StartaDiscussion: "ابدأ مناقشة",

  authentication_required: 'يستلزم التوثيق',
  statusShort: {
    event: {
      comeLater: "انتظار",
      reportAvailable: "تم الانتهاء من",
      aboutToStart: "ابتداء",
      joinMeeting: "حي",
    }
  },
  ai: {
    details: "تفاصيل مساعد الذكاء الاصطناعي",
    name: "اسم المساعد",
    description: "وصف مساعد",
    selectAvatar: "حدد الصورة الرمزية للمساعد",
    selectIcon: "انقر لتحديد الرمز",
    operation: "عملية مساعد الذكاء الاصطناعي",
    selectMainPrompt: "حدد الموجه الرئيسي",
    freq: "تكرار تنفيذ الموجه (بالثواني)",
    manual: "يدوي",
    schedule: "جدول",
    off: "عن",
    hideUI: "إخفاء العمليات التي يدعمها المستخدم",
    showUI: "إظهار العمليات التي يدعمها المستخدم",
    promptSelection: "اختيار سريع",
    add: "يضيف",
    selectPrompt: "حدد مطالبة",
    thread: "موضوع المناقشة",
    editor: "قائمة المحرر",
    circle: "قائمة الدائرة",
    alias: "الاسم المستعار للقائمة",
    delete: "يمسح",
    cancel: "يلغي",
    save: "يحفظ",
    clickOn: "انقر فوق ثم أدخل التعليمات الخاصة بمساعدة الذكاء الاصطناعي في نافذة المحرر",
    ask: "رسالة",
    disable: "تعطيل الذكاء الاصطناعي",
    enable: "تمكين الذكاء الاصطناعي",
    addAI: "إضافة مساعد الذكاء الاصطناعي",
    active: "نشيط",
    notActive: "غير فعال",
    edit: "يحرر",
    delete: "يمسح",
    createdBy: "انشأ من قبل",
    refresh: "ينعش",
    running: "جري",
    notRunning: "لا يعمل",
    lastExecuted: "تم تنفيذه مؤخرًا",
    service: "خدمة",
    update: "تحديث",
    success: "نجاح",
    logs: "السجلات",
    stop: "قف",
    start: "يبدأ",
    continue: "يكمل",
    pause: "يوقف",
  },
  common: {
    create: "إنشاء حلقة",
  },
  dashboard: {
    breadcrumb: "لوحة التحكم",
    goToBookCair: "الذهاب إلى BOOK CAIR",
    tooltip: {
      profile: "عالمي: ملفي الشخصي والمحتوى الخاص بي",
      allPosts: "مساهمات للعلامات التي أتابعها من جميع الحلقات التي يمكنني الوصول إليها",
      circles: "الحلقات التي انضممت إليها",
      discussions: "المناقشات التي أنا عضو فيها",
      meetings: "الاجتماعات التي أنا مدعو إليها",
      subCircles: "انقر لمشاهدة الدوائر الفرعية",
      parentCircle: "انقر لرؤية الدائرة الرئيسية",
      postDetails: "انقر للحصول على مزيد من التفاصيل",
    },
    circles: "حلقاتي",
    discussions: "نقاشاتي",
    meetings: "اجتماعاتي",
    allPosts: "جميع المشاركات",
    showMore: "أظهار المزيد",
    discover: "اكتشاف",
    completeProfile: "الرجاء إكمال الملف الشخصي",
  },
  event: {
    types: {
      Music: "موسيقى",
      Culture: "ثقافة",
      Training: "تمرين",
      Meeting: "اجتماع",
      Sport: "رياضة",
      Information: "معلومة"
    },
    responded: "استجاب",
    maybe: "ربما",
    no: "لا",
    yes: "نعم شخصيا",
    yes_v: "نعم، انضم افتراضيًا",
    yes1: "نعم",
    going: "ذاهب",
    show_more: "أظهر المزيد",
    respondents: "قائمة المستجيبين",
    organizer: "منظم",
    address: "عنوان",
    start: "بداية الحدث",
    end: "نهاية الحدث",
    addTags: "اضف اشارة",
    name: "اسم",
    address: "عنوان",
    priority: "أولوية الحدث",
    moreInfo: "إضافة المزيد من المعلومات/نموذج التمديد",
    collapse: "طي النموذج",
    cancel: "يلغي",
    save: "يحفظ",
    roles: "تحديد الأدوار لاجتماع أو حدث تدريب",
    location: "موقع الحدث",
    startAndEnd: "بداية ونهاية الحدث",
    eventType: "نوع الحدث",
    describe: "قم بوصف الحدث الخاص بك",
    sponsor: "المنظمة الراعية (أصول البحث)",
    noData: "لا توجد أحداث لهذه الحلقة، لماذا لا تبدأ بحدث جديد للحلقة!",
    finishMeeting: "انتهى الاجتماع",
    listing: "قائمة",
    upcoming: "القادمة",
    recent: "مؤخرا",
    hosting: "الاستضافة",
    speaking: "مشاركة",
    andOthers: "و {count} آخرين",
    startsPrefix: "يبدأ:",
    endsPrefix: "ينتهي:",
    comeLater: "انضم إلى الحدث هنا:",
    reportAvailable: "تقارير الاجتماع متوفرة أدناه ، نرحب بالتعليقات",
    reportAvailableAdmin: "يرجى كتابة نتيجة الاجتماع أدناه عندما تكون جاهزًا",
    aboutToStart: "الاجتماع على وشك أن يبدأ",
    joinMeeting: "انضم للاجتماع",
    openZoomApp: "افتح باستخدام تطبيق Zoom",
    openZoomAppBefore: "يفتح قبل 30 دقيقة من البدء",
    webClient: "عميل الويب ({op})",
    Host: "مضيف",
    Join: "ينضم",
    Assistant: "مساعد",
    more: "أكثر",
    see: "نرى",
    sendInvitation: "إرسال رسائل البريد الإلكتروني للدعوة",
    all_party: "جميع أعضاء حلقة النقاش",
    templates: {
      created: "تم إنشاء الحدث",
      eventsReminder24: "تذكير قبل 24 ساعة",
      eventsReminder1: "تذكير قبل ساعة واحدة",
      eventsFinished: "انتهى الحدث",
    },
  },
  general: {
    ok: 'موافق',
    MeetingTime: "وقت الاجتماع:",
    cancel: 'إلغاء',
    prev: 'سابق',
    next: 'تالى',
    or: 'أو',
    requires_registration: 'التسجيل مطلوب',
    access_denied: "تم الرفض",
    request_access_to_circle: "طلب الوصول إلى الدائرة",
    request_access_to_circle2: "عذرًا، ليس لديك حقوق الوصول إلى هذه الدائرة. انقر أعلاه للانضمام",
    or_click: "أو أضغط هنا.",
    join2read: "انضم إلى الدائرة لقراءة المشاركة",
    automatically_redirect2circle: "سنقوم بإعادة توجيهك تلقائيًا إلى الدائرة للانضمام.",
    no_rights2view_post: "عذرًا، ليس لديك حقوق الوصول لعرض هذه المشاركة.",
    requires_registration_details:
      'سجّل حساب لتمكين مجموعة من الوظائف الإضافية.',
    already_a_member: 'هل أنت عضوا؟',
    sign_up: 'إشترك',
    sign_in: 'تسجيل الدخول',
    untitled: 'مقالة بدون عنوان',
    loading: 'جاري التحميل الرجاءالانتظار ...',
    please_wait: 'الرجاء الانتظار ...',
    error: 'شيء ما حدث بشكل خاطئ',
    view_profile: 'عرض الصفحة الشخصية',
    more: 'اظهار الكل',
    coming_soon: 'نحن لسنا جاهزين بعد - هذه الميزة ستصل قريبًا!',
    generating_art: 'توليد صورة مرفقة',
    type_to_find_person: 'ابدأ في الكتابة للعثور على أشخاص ...',
    type_to_find_group: 'ابدأ الكتابة للعثور على حلقات النقاش ...',
    type_to_find_tag: 'ابدأ في الكتابة للعثور على العلامات ...',
    type_to_find_post: 'جارٍ البدء في الكتابة للعثور على مشاركات ...',
    no_people: 'لاشئ للعرض',
    no_groups: 'لاشئ للعرض',
    cannot_be_undone: 'تحذير: لا يمكن التراجع عن هذا الإجراء!',
    privacy_policy: 'سياسة الخصوصية',
    terms_and_conditions: 'الأحكام والشروط'
  },
  search: {
    placeholder: 'ابدأ في الكتابة للبحث'
  },
  embed: {
    loading: 'تحميل المحتوى المضمن ...'
  },
  validation_error: {
    username_exists: 'اسم المستخدم مستخدم بالفعل',
    email_exists: 'البريد الإلكتروني مسجل بالفعل',
    invalid_url: 'URL غير صالح',
    required_field: 'الحقل مطلوب',
    required: '{field} مطلوب',
    invalid_username: 'اسم المستخدم قصير جدًا',
    invalid_email: 'عنوان البريد الإلكتروني غير صالح',
    invalid_phone_number: 'رقم الهاتف غير صالح',
    password_must_include_digits: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل',
    password_too_short: 'يجب أن تتكون كلمة المرور من 8 أحرف على الأقل',
    passwords_must_match: 'كلمتا المرور غير متطابقتين',
    invalid_domain_name: 'اسم نطاق صالح مطلوب على سبيل المثال. www.google.com'
  },
  navigation: {
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    '/home': 'الصفحة الرئيسية',
    'home/activity': 'نشاط',
    'home/news': 'مقالات',
    'home/events': 'الأحداث',
    'home/news/tag/posts': 'مقالات',
    'home/news/tag/circles': 'حلقات نقاش',
    'home/people': 'أشخاص',
    '/notifications': 'إشعارات',
    'notifications/notifications': 'إشعارات',
    create: 'إنشاء',
    createEvent: "قم بإنشاء حدث اجتماع",
    groups: 'حلقات نقاش',
    'groups/home': 'حلقات نقاش',
    'groups/discover': 'اكتشف',
    'groups/group/activity': 'نشاط',
    'groups/group/outcome': 'نتيجة',
    'groups/group/posts': 'مشاركات',
    'groups/group/reference': 'مراجع',
    'groups/group/groups': 'حلقات نقاش',
    'groups/group/events': 'الأحداث',
    'profile/public': 'الملف الشخصي',
    'profile/posts': 'الملف الشخصي',
    'profile/drafts': 'مسودات',
    'profile/bookmarks': 'إشارات مرجعية',
    'profile/public/posts': 'مشاركات',
    'profile/public/events': 'احداث',
    'profile/public/responses': 'الردود',
    'profile/public/recommends': 'توصي',
    'profile/public/bio': 'السيرة الذاتية',
    'home/member': ' ',
    'home/member/posts': 'مشاركات',
    'home/member/events': 'الأحداث',
    'home/member/responses': 'الردود',
    'home/member/recommends': 'توصي',
    'home/member/bio': 'السيرة الذاتية',
    'groups/group/membership/access_requests': 'طلبات',
    'groups/group/membership/invites': 'دعوات',
    'groups/group/membership/members': 'أعضاء',
    search: 'بحث'
  },
  login: {
    title: 'تسجيل الدخول',
    email: 'عنوان البريد الإلكتروني',
    password: 'كلمة السر',
    login: 'قدم',
    account_not_verified: 'لم يتم التحقق من عنوان البريد الإلكتروني',
    invalid_credentials: 'بيانات الاعتماد غير صالحة',
    login_with_email: 'تسجيل الدخول باستخدام البريد الإلكتروني وكلمة المرور',
    login_with_facebook: 'تسجيل الدخول باستخدام الفيسبوك',
    no_such_user: 'هذا الحساب غير مسجل',
    reset_password: 'إعادة تعيين كلمة السر',
    sent_password_reset_mail:
      'تم إرسال البريد الإلكتروني لإعادة تعيين كلمة السر لك، يرجى التحقق من بريدك الإلكتروني.'
  },
  logout: {
    signing_out: 'تسجيل الخروج ...'
  },
  landing: {
    line_1: 'التفكير الجماعي في حلقات النقاش الميسرة لإيجاد الحلول',
    line_2:
      'انضم إلى حلقة نقاش ، أنشئ حلقاتك العامة أو الخاصة ، انشر المقالات وتواصل مع الآخرين',
    register_button: 'البدء',
    browse_as_a_guest: 'أو تصفح كضيف'
  },
  registration: {
    register_with_email: 'سجل ببريدك الالكتروني',
    welcome: 'تم تأكيد عنوان بريدك الإلكتروني الآن',
    continue_to_the_app: 'استمر',
    confirmation_required_title: 'أكد عنوان بريدك الألكتروني',
    confirmation_required_text:
      'لقد أرسلنا بريدًا إلكترونيًا إلى {email} يحتوي على رقم التعريف الشخصي لإكمال تسجيلك.',
    confirmation_pin_field: 'رقم التعريف الشخصي',
    confirm_registration: 'قدم رقم التعريف الشخصي للتحقق',
    continue_with_facebook: 'تواصل مع الفيسبوك',
    continue_with_twitter: 'تواصل مع Twitter',
    continue_with_google: 'تواصل مع Google',
    waiting_for_facebook: 'في انتظار المصادقة',
    completing_registration: 'استكمال اشتراكك',
    completed_registration: 'اكتمل الاشتراك ، وإعادة التوجيه ...'
  },
  registration_form: {
    register: 'اشترك',
    username_field: 'اسم المستخدم',
    email_field: 'عنوان البريد الإلكتروني',
    password_field: 'كلمة السر',
    password_again_field: 'أعد إدخال كلمة السر',
    already_registered: '{field}مسجل مسبقا ',
    already_registered2: 'تم تسجيله بالفعل',
    password_reset_button: 'إعادة تعيين',
    confirm_password_button: 'يتأكد',
  },
  password_reset: {
    success: 'نجاح إعادة التعيين‫!‬',
    failed: 'فشل إعادة التعيين!',
    linkLabel: 'استمر',
    signing_in: 'تسجيلك‫...‬'
  },
  onboarding: {
    choose_n_tags: 'اختر ٣ علامات على الأقل لتخصيص المحتوى الخاص بك'
  },
  profile: {
    view: 'عرض الصفحة الشخصية',
    new_post: 'مشاركة جديدة',
    new_event: "حدث جديد",
    edit_button: "تحرير المعلومات الشخصية",
    my_short_bio_default: 'إضافة سيرة ذاتية مختصرة',
    their_short_bio_default: 'يفضل هذا المستخدم الحفاظ على جو من الخصوصية',
    reputation_label: 'سمعة',
    followers_label: 'متابعون',
    following_label: 'يتبع',
    title: 'تعديل الملف الشخصي',
    firstname_field: 'الاسم الاول',
    lastname_field: 'اللقب',
    gender_field: 'الجنس',
    gender_male: 'ذكر',
    gender_female: 'أنثى',
    bio_field: 'السيرة الذاتية',
    profile_photo: 'الصوره الشخصيه',
    save: 'حفظ',
    edit_profile_title: 'تعديل الملف الشخصي',
    view_profile_title: 'الملف الشخصي',
    load_profile: 'تحميل الملف الشخصي',
    follow: {
      is: 'متابعة',
      is_not: 'يتبع',
      checking: 'يتبع'
    },
    choose_avatar_label: 'اختر صورة شخصية',
    drag_image_label: 'انقر أو اسحب الصورة',
    error_user_404: 'المستخدم غير موجود',
    logout: 'تسجيل خروج {username}'
  },
  people: {
    search_for_people:
      'استخدم البحث عن الكلمات الرئيسية أعلاه للبحث عن الأسماء والسير الذاتية.',
    interesting_people:
      'إليك بعض الأشخاص المثيرون للاهتمام الذين قد تودون متابعتهم.',
    no_results: 'لم نعثر على أي شخص يطابق هذا الاستعلام'
  },
  import: {
    drop_here:
      'إسقاط Microsoft Word (.docx) أو ملف PDF هنا ، أو انقر للاستعراض',
    not_a_word_doc: 'يمكن استيراد ملفات PDF أو Microsoft Word .docx فقط.',
    try_again: 'حاول مرة أخري',
    uploading: 'استيراد وثيقة',
    redirecting_you: 'إعادة توجيه'
  },
  compose: {
    unknown_type: 'نوع مشاركة غير معروفة `{type}`',
    new: {
      chat_placeholder: "ندخل النص لـ تحسين أو ندخل سؤالاً للحصول على الـ مساعدة، ثم ننقر على الزر المناسب. ننقر على “نشر” لتقديم تعليقنا.",
      page_title: 'مقالة جديدة',
      new_public_post: 'إنشاء مشاركة جديدة',
      page_event: "حدث جديد",
      event_title: "عنوان الحدث",
      page_evt_title: "إنشاء الحدث",
      start_date: "تاريخ البدء",
      date: "تاريخ",
      evt: "أدخل عنوانًا وتاريخًا لاجتماعك",
      end_date: "تاريخ الانتهاء",
      category: "الفئة",
      time: "زمن",
      submiting: "تقديم",
      CreateMeeting: "إنشاء اجتماع",
      Duration: "المدة الزمنية",
      new_public_post: 'إنشاء مشاركة جديدة',
      create_event: "انشاء حدث",
      event_description: "وصف الحدث",
      add_participant: "إضافة مشارك",
      choose_moderator: "اختر وسيط",
      warning:
        'ستكون مقالتك متوفرة للجميع مبدئياً. ولكن يمكنك التحكم في الخصوصية من خلال اختيار حلقة في خطوة النشر النهائية.',
      what: 'ماذا تريد أن تنشأ؟',
      post_an_article: 'نشر مقالة',
      import_a_document: 'استيراد مستند',
      announce_an_event: 'الإعلان عن حدث',
      thirtyMins: "ثلاثون دقيقة",
      SixtyMins: "ستين دقيقة",
      NinetyMins: "تسعون دقيقة",
      OneTwentyMins: "مائة وعشرون دقيقة",
      minutes150: "150 دقيقة",
      minutes180: "180 دقيقة",
      minutes240: "240 دقيقة",
    },
    tag: {
      page_title: 'أضف علامة على مقالتك',
      page_title_Event: 'ضع علامة على الحدث الخاص بك',
      choose_n_tags: 'علم مقالتك لـ{n} علامات',
      choose_n_tags_events: "العلامات{n}ضع علامة على الحدث الخاص بك مع ما يصل إلى",
      atLeastOneTag: "الرجاء إضافة علامة واحدة على الأقل!",
      tag: 'علامة'
    },
    event: {
      title_schedule_event: "جدولة الحدث الخاص بك",
      title_schedule_discussion: "حدد موعدًا لمناقشتك",
      role: "دور",
      timezone: "وحدة زمنية",
      meeting_info: "قدم معلومات الاجتماع",
      suggested: "مقترح",
      title_roles: "الجمهور والأدوار",
      roles_header: "حدد دورًا وأضف الأشخاص إليه",
      by_name_and_email: "البحث بالاسم أو البريد الإلكتروني",
      schedule_header_event: "حدد التاريخ والوقت ونوع الحدث",
      schedule_header_discussion: "جدولة بداية ونهاية المناقشة",
      event_type: "نوع الحدث",
      label: 'معلومات إضافية (مثل "الانضمام إلى اجتماع Zoom"، وما إلى ذلك)',
      url: "URL لمعلومات إضافية",
      label2: "مزيد من المعلومات الإضافية، على سبيل المثال رابط البث على YouTube",
      url2: "رابط لمزيد من المعلومات الإضافية",
      streamingInfo: "معلومات إضافية حول خدمة البث المستخدمة",
      streamingUrl: "URL لعرض خدمة البث المستخدمة",
      all_party: 'جميع أعضاء حلقة النقاش',
      types: {
        google: "Google",
        jitsi: "Jitsi",
        zoom: "Zoom",
        external: "خارجي",
      },
      roles: {
        expert: "خبير",
        host: "مضيف",
        moderator: "مشرف",
        speaker: "مكبر الصوت",
        guest_expert: "ضيف خبير",
        panelist: "المتحدث",
        participant: "مشارك",
        trainer: "مدرب",
      },
      all_members_invited: "جميع أعضاء الدائرة مدعوون إلى هذا الاجتماع كمشاركين",
    },
    audience: {
      page_title: 'جمهورك',
      publish: 'نشر',
      publishing: 'النشر',
      control_visibility:
        'قرر من يمكنه مشاهدة مقالتك عن طريق النشر بشكل عام أو إلى حلقة تشارك فيها',
      public_title: 'نشر عام',
      public_description: 'يمكن لأي شخص مشاهدة هذه المقالة',
      group_title: 'حلقة نقاش',
      group_description: 'يتم التحكم في مستوى الإطلاع من خلال إعدادات الحلقة',
      choose_group: 'اختر حلقة النقاش',
      change_group: 'تغيير'
    },
    share: {
      title: 'شارك ما أنشئت',
      published_successfully: 'تم نشر مقالتك بنجاح',
      share_post: 'تم',
      share_article: 'حدد وانسخ الرابط أدناه للمشاركة'
    },
    next: 'التالي',
    external_link: 'رابط خارجي',
    link_post: 'رابط للمشاركة',
    embed_post: 'ضمّن مشاركة',
    link_field: 'رابط',
    link_placeholder: 'أدخل عنوان URL (عناوين) URL صالح',
    description_field: 'وصف',
    description_placeholder: 'الوصف (يظهر في قسم الروابط)',
    uploading: 'تحميل {name}',
    link: {
      manager_title: 'تعديل الرابط',
      update: 'تحديث الرابط'
    },
    embed: {
      manager_title: 'تحرير التضمين',
      update: 'تحديث التضمين'
    }
  },
  attachments: {
    manager_title: 'إدارة المرفقات',
    no_attachments: 'لم ترفق أي ملفات حتى الآن.',
    drop_here: 'أفلت الملفات هنا أو انقر لفتح منتقي الملفات.',
    describe: 'وصّف هذا المرفق'
  },
  activity: {
    publish: 'نشر في',
    publish_publicly: 'نشر علنا',
    publish_to_all: 'نشر علنا',
    follow: 'يتبع',
    reply: 'رد على مشاركتك',
    react: 'رد على المقالة',
    'create-group': 'بدأ الحلقة {name}',
    'created-group': 'بدأ الحلقة {name}', // deprecate
    'join-group': 'انضم إلى حلقة {name}',
    'joined-group': 'انضم إلى حلقة {name}', // deprecated
    'close-group': 'أنهيت الحلقة {name}',
    'reopen-group': 'إعادة فتح الحلقة {name}',
    'invite-to-group': 'دعاك للانضمام إلى حلقة نقاش',
    'request-access': 'طلبت الوصول إلى الحلقة "{name}"',
    'removed-post': 'تم إزالة مشاركة',
    you: 'أنت',
    in_group: 'في',
    verbs: {
      publish: 'نشرت {activity_count} مقالات', // todo: plurals
      follow: 'تابعت {activity_count} أشخاص', // todo: plurals
      reply: 'أجبت على مقالتك',
      react: 'تم الرد على مقالتك',
      'join-group': 'شاركت بحلقة',
      'create-group': 'شاركت بحلقة نقاش جديدة',
      'invite-to-group': 'دعاك للانضمام إلى حلقة',
      'reopen-group': 'أعادة فتح حلقة',
      'close-group': 'اختتم الحلقة',
      'request-access': 'طلب الوصول إلى الحلقات',
      'removed-post': 'إزالة منشور'
    },
    name_comma: ', ',
    name_and: ' و ',
    mentioned_you: 'قام بذكرك',
    and_n_others: `{n, plural, one {${plurals$1.and_one_other}} other {${plurals$1.and_n_others}}}`,
    n_people: '{n} أشخاص',
    tap_groups: 'انقر على "الحلقات"',
    join_some_groups: 'لاكتشاف الحلقات التي تتوافق مع اهتماماتك',
    tap_create: 'انقر على "إضافة"',
    post_some_content: 'لإنشاء مشاركاتك الخاصة',
    view_posts_matching_your_tags:
      'اضغط على "مقالات" لمشاهدة أحدث المقالات والأخبار التي تطابق العلامات الخاصة بك',
    view_events_matching_your_tags:
      'اضغط على "الأحداث" لمشاهدة أحدث الأحداث التي تطابق العلامات الخاصة بك',
    follow_some_people:
      "أو تجد أشخاصًا مثيرين للاهتمام لمتابعة من القائمة أدناه",
  },
  drafts: {
    delete: 'احذف هذه المسودة',
    count: '{count, plural, zero {لا مسودات} one {مسودة واحدة} two {مسودتان} few {# مسودات} many {# مسودة} other {# مسودة}}'
  },
  posts: {
    send_reminder: "إرسال بريد إلكتروني للتذكير",
    open_thread: "افتح الموضوع في نافذة جديدة",
    empty_list_placeholder: 'لا يوجد شيء يمكن رؤيته هنا حتى الآن.',
    n_minute_read: '{value} للقراءة',
    unpublish: 'ألغي نشر هذه المشاركة',
    edit: 'تحرير هذه المشاركة',
    edit_metadata: 'تحرير البيانات الوصفية',
    in_group: ', في {name}',
    pin_and_close_group: 'عرف كمغلق لحلقة النقاش',
    pin_as_group_intro: 'عرف كمقدمة لحلقة النقاش',
    search_placeholder: 'اكتب للبحث عن المشاركات'
  },
  post: {
    continue: "إستمر",
    proceed: "الانتقال إلى صفحة تسجيل الدخول",
    please_login: "هذه المشاركة للأعضاء. يرجى تسجيل الدخول لقراءتها.",
    register_login: "يرجى الاشتراك/تسجيل الدخول أولا من أجل الرد.",
    proceed_join: "الاشتراك في الحلقة",
    join2respond: "يرجى الانضمام إلى الحلقة لكتابة الرد.",
    join: "انضمام",
    cancel: "إلغاء",
    startNewDiscussionThread: "بدء موضوع مناقشة جديد",
    respond2Thread: "الرد على الموضوع",
    closeDiscussionThread: "إغلاق موضوع المناقشة",
    unflag: "إلغاء إبلاغ عن صورة غير ملائمة",
    unpublished: 'المشاركة متوفرة',
    unpublished_description: 'تمت إزالة هذه المشاركة من قبل المؤلف أو المشرف',
    responses: 'استجابات',
    responses_discussion: 'مواضيع المناقشة',
    respond: 'انقر هنا لكتابة إجابتك {name}',
    respond_discussion: "انقر هنا لبدء سلسلة نقاش جديدة",
    conversation_with: 'محادثة مع {name}',
    n_responses: `${plurals$1.view} {responseCount, plural, one {${plurals$1.one_response}} other {${plurals$1.n_responses}}}`,
    maximize_conversation: 'شاهد المحادثة بأكملها',
    minimize_conversation: 'إخفاء هذه المحادثة',
    references: 'المراجع والمصادر',
    response_removed: 'تمت إزالة هذه الاستجابة',
    response_removed_by: "لم يتم نشر التعليق بواسطة",
    responding_to_thread: 'ردا على هذا الموضوع:',
    main_post: 'وثيقة النقاش الرئيسية',
    go_back_to_main_post: 'انقر على العنوان أدناه للذهاب الى وثيقة النقاش الرئيسية',
    owner_thread: 'سلسلة النقاش الأم:',
    go_to_owner_thread: '(انقر أدناه للذهاب لسلسة النقاش الأم)',
    current_thread: 'الرجاء الاجابة للنقاش أدناه:',
    n_other_posts: `{length, plural, one {${plurals$1.one_elided_post}} other {${plurals$1.n_elided_posts}}}`,
    full_screen_composer: 'شاشة كاملة',
    publish: 'نشر',
    discard: 'تجاهل',
    share: 'شارك هذه المقالة',
    reactions: {
      title: 'ردود فعل',
      agreement: 'اتفاقية',
      agreement_desc: 'مقياس لمدى موافقتك على الحجج العامة المقدمة في المشاركة',
      give_feedback: "يرجى تقييم اقتراح المناقشة",
      eloquence: 'بلاغة',
      eloquence_desc:
        'مقياس لنمط ونوعية وإقناع الكتابة في هذا المنشور ، بصرف النظر عن موافقتك',
      relevance: 'ملاءمة',
      relevance_desc:
        'مقياس لمدى ملائمة هذه المشاركة بالمجموعة و / أو علامات المشاركة',
      average: 'متوسط التقييم',
      yours: 'تقيمك',
      cannot_react_to_own_post: 'لا يمكنك تقييم مشاركتك الخاصة!'
    }
  },
  tags: {
    follow: 'إتبع',
    following: 'متابعة',
    minimum_required: 'يرجى تقديم على الأقل {n} علامات',
    tag_field: 'العلامة',
    home_following: 'هنالك متابعة لهذه العلامة',
    home_unfollowing: 'ليس هنالك متابعة لهذه العلامة'
  },
  group: {
    pages: "الصفحات",
    notify_on: "قم بتشغيل إشعارات الهاتف المحمول",
    notify_off: "قم بإيقاف تشغيل إشعارات الهاتف المحمول",
    recentActivities: "أنشطة حالية",
    createPost: "إنشاء مشاركة",
    tabs: {
      all: "كل المشاركات",
      discussions: "المناقشات",
      meetings: "الأحداث",
      articles: "المقالات",
      references: "المراجع",
      subCircles: "حلقات فرعية",
      map: "خريطة",
    },
    actions: {
      startDiscussion: "بدأ مناقشة",
      announceEvent: "أعلن عن الحدث",
      announce: "الإعلان عن اجتماع",
      writeArticle: "كتابة مقالة",
      import: "استيراد مستند",
      record: "تسجيل أصل",
      createInterview: 'إنشاء منشور وسائط',
    },
    tooltips: {
      dashboard: "لوحة التحكم",
      help: "صفحة المساعدة",
      notifications: "أحدث إخطارات",
      members: "أعضاء هذه الحلقة",
    },
    totalResponses: 'إجمالي الردود',
    searchHere: "البحث هنا",
    empty_list_placeholder: 'لا يبدو أنك تشارك في أي حلقات نقاش',
    discover_some_groups:
      'انقر على "اكتشاف" للعثور على الحلقات التي تطابق اهتماماتك',
    tap_add: 'انقر على "إضافة"',
    create_your_own_groups: 'لبدء حلقاتك الخاصة ودعوة أعضاء آخرين للانضمام!',
    no_activity: 'لا يوجد شيء يمكن رؤيته هنا حتى الآن.',
    post_something: 'انشر شيئًا',
    import_a_document: 'استيراد وثيقة',
    edit_group: 'تعديل هذه الدائرة',
    new_sub_group: 'إنشاء حلقة فرعية',
    invite: 'دعوة أعضاء جدد',
    send_invite: 'إرسال',
    pending_invite: 'قد دعي',
    already_a_member: 'هو بالفعل عضو',
    request_access_to_circle: 'طلب الدخول',
    request_access: {
      title: 'طلب الدخول إلى الحلقة',
      request: 'طلب الدخول',
      description:
        'اضغط على الزر أدناه لطلب الدخول إلى هذه الحلقة. سيتم إشعار مديري الحلقة بطلبك.',
      already_requested: 'لديك بالفعل طلب معلق للانضمام إلى هذه الحلقة.',
      already_rejected: 'تم رفض طلبك الحالي للانضمام إلى هذه الحلقة.'
    },
    only_visible_to_members: 'المحتوى مرئي فقط لأعضاء الحلقة',
    join: 'انضم إلى هذه الدائرة',
    login_to_join: 'سجّل الدخول للانضمام إلى هذه الحلقة',
    leave: 'غادر هذه الحلقة',
    reopen: 'أعد فتح هذه الحلقة',
    close: 'اغلق هذه الحلقة',
    close_did_you_know:
      'عند إنهاء الحلقة ، يمكنك اختيار مشاركة واحدة داخل الحلقة من أجل "تثبيت" "نتيجة" للحلقة.',
    close_how_to_pin: 'للإغلاق مع مشاركة مثبتة "النتيجة":',
    close_find_post:
      'في علامة التبويب "المشاركات" ، ابحث عن المشاركة التي تريد تثبيتها',
    close_tap_overflow:
      'افتح قائمة السياقات من خلال النقر على رمز الفائض في المشاركة',
    close_pin_as_outcome:
      'في قائمة السياق ، انقر على "عرف كنتيجة لحلقة النقاش"',
    close_is_better_with_outcome: 'ينصح بشدة بإغلاق الحلقة بنتيجة مثبتة',
    close_without_outcome: 'أغلق بدون تثبيت',
    you_are_closing_this_group:
      'تحذير: أنت على وشك إنهاء هذه الحلقة ، التي ستمنع نشر المشاركات الجديدة في هذه الحلقة.',
    close_and_set_outcome: 'أغلق مع نتيجة',
    outcome_to_be_pinned: 'تثبيت المشاركة‫-‬النتيجة‫:‬',
    increase_privacy_by_one_level: 'زيادة خصوصية هذه الدائرة إلى مستوى أعلى:',
    make_more_private: 'زيادة الخصوصية',
    enable_content_digest: "قم بتضمين ملخص البريد الإلكتروني اليومي",
    disable_content_digest: "استبعاد ملخص البريد الإلكتروني اليومي",
    summary: {
      privacy: {
        PUBLIC: 'عام',
        public: 'عام', // deprecated
        REGISTERED: 'الاعضاء المسجلين فقط',
        registered: 'الاعضاء المسجلين فقط', // deprecated
        PRIVATE: 'المدعوون فقط',
        private: 'المدعوون فقط' // deprecated
      },
      stats: `{memberCount, plural, one {${plurals$1.one_member}} other {${plurals$1.n_members}}, {postCount, plural, one {${plurals$1.one_post}} other {${plurals$1.n_posts}}}`
    },
    info: {
      privacy: {
        PUBLIC: 'متاح للجمهور',
        public: 'متاح للجمهور', // deprecated
        REGISTERED: 'يمكن الوصول إليها من قبل المستخدمين المسجلين',
        registered: 'يمكن الوصول إليها من قبل المستخدمين المسجلين', // deprecated
        PRIVATE: 'الوصول عن طريق الدعوة فقط',
        private: 'الوصول عن طريق الدعوة فقط', // deprecated
        cannot_be_less_private_than_parent:
          'لا يمكن أن تكون الدوائر الفرعية أقل خصوصية من دائرة أصلها.'
      },
      intro: 'اقرأ هذا أولا!',
      closed: '(مغلقة إلى مزيد من النشاط)',
      pending_access_requests: `{access_request_count, plural, one {${plurals$1.one_pending_request}} other {${plurals$1.n_pending_requests}}`,
      membership: {
        ADMIN: {
          true: 'أنت مشرف حلقة',
          false: 'أنت مشرف حلقة'
        },
        MEMBER: {
          true: 'أنت عضو (للقراءة فقط)',
          false: 'أنت عضو'
        },
        undefined: 'انت لست عضو'
      },
      guest: 'المشاهدة كضيف',
      members: `{memberCount, plural, one {${plurals$1.one_member}} other {${plurals$1.n_members}}`,
      posts: `{postCount, plural, one {${plurals$1.one_post}} other {${plurals$1.n_posts}}}`,
      view_members: '(مشاهدة الاعضاء)'
    },
    discover: {
      invitations: 'دعوات',
      suggestions: 'اقترح لك',
      invited_you: 'دعاك‫/‬دعتك للانضمام إلى هذه الدائرة',
      nothing_to_see: 'إنها هادئة قليلاً هنا ، حاول مرة أخرى في وقت لاحق!',
      join: 'انضم إلى الدائرة',
      dont_join: 'تجاهل الدعوة',
      discarded: 'لقد تم تجاهل هذه الدعوة',
      joined: 'لقد انضممت إلى هذه الحلقة',
      go_to_group: 'زيارة الحلقة'
    },
    create: {
      basics_page_title: 'ابدأ بحلقة',
      privacy_page_title: 'إعدادات الخصوصية',
      select_privacy: "الرجاء تحديد إعدادات الخصوصية الخاصة بك",
      privacy_subcircle: "إذا كنت تقوم بإنشاء دائرة فرعية، فلا يمكن أن تكون خصوصيتها أقل من خصوصية الدائرة الرئيسية",
      members_page_title: 'دعوة أعضاء',
      schedule_page_title: 'جدول',
      tags: 'العلامات',
      next: 'التالي',
      finish: 'إنشاء',
      name_field: 'إسم الحلقة',
      name_placeholder: 'أدخل اسمًا لحلقتك',
      members_read_only_field: 'للقراءة فقط لغير المشرفين',
      only_admins_can_post: 'يمكن للمشرفين فقط النشر',
      members_and_admins_can_post: 'يمكن للأعضاء والمشرفين النشر',
      specify_at_least_one_tag: 'حدد علامة واحدة على الأقل تصف دائرتك',
      privacy: 'الخصوصية',
      privacy_public_title: 'عام',
      privacy_public_description:
        'يمكن لأي شخص قراءة المشاركات في هذه الحلقة. يمكن لأي مستخدم مسجل المساهمة بالمحتوى في الحلقة.',
      privacy_registered_title: 'المستخدمون المسجلون',
      privacy_registered_description:
        'يمكن للمستخدمين المسجلين فقط قراءة المحتوى ونشره في هذه الحلقة.',
      privacy_private_title: 'خاصة',
      privacy_private_description:
        'يمكن فقط للأشخاص الذين تدعوهم الانضمام إلى دائرة القراءة والمساهمة.',
      send_invitations_to: 'دعوات',
      invite_some_people: 'لم تقم بدعوة أي شخص حتى الآن',
      sponsor_page_title: 'رعاية',
      sponsor: 'Sponsor',
      associate_sponsor: 'ربط أحد الرعاة لهذه الحلقة ، إذا كان لديك واحد',
      schedule: 'Schedule'
    },
    invitation: {
      page_title: "أنشئ كلمة مرورك الآن",
      invited_header: "أنت مدعو للانضمام إلى الدائرة",
      circle: "الدائرة:",
      invited_by: "بدعوة من:",
      agree_to_terms: "أوافق على سياسة الخصوصية والشروط والأحكام",
      intro: "بعد تأكيد كلمة المرور الخاصة بك ، ستتمكن من الانضمام إلى الأحداث والوصول إلى خدمات النظام الأساسي الأخرى",
    },
    invitations: {
      page_title: "قم بدعوة أعضاء جدد لهذه الدائرة",
      intro: "قم بتوسيع مجتمعك! يمكنك التواصل عبر البريد الإلكتروني مع الأفراد الذين لم يصبحوا جزءًا من المنصة بعد ، وتشجيعهم على التسجيل والانضمام إلى دائرتك. بدلاً من ذلك ، يمكنك أيضًا الاختيار من بين مستخدمي النظام الأساسي الحاليين ودعوتهم لإثراء دائرتك كأعضاء جدد.",
      email_header: "قم بدعوة مستخدمين جدد عن طريق إرسال رسائل بريد إلكتروني إليهم للتسجيل والانضمام إلى الدائرة",
      emails_field: "سرد رسائل البريد الإلكتروني (مفصولة بفواصل) ...",
      send_email_button: "التحقق من صحة وإرسال رسائل البريد الإلكتروني للدعوة",
      registered_toast: "دعوة المستخدمين ...",
      register_msg: "يسجل",
      invite_registered: "قم بدعوة المستخدمين المسجلين بالفعل للانضمام إلى هذه الدائرة",
      person_picker: "ابدأ الكتابة للعثور على أسماء المستخدمين واختر دعوة…",
      invite: "يدعو",
      invited_toast: "المستخدمون مدعوون",
      invite_msg: "دعوة",
    },
    edit: {
      basics_page_title: 'عدل الحلقة',
      finish: 'حفظ'
    },
    members_page: {
      title: 'اعضاء في {name}',
      since: 'انضم',
      role: {
        ADMIN: '(مشرف)',
        MEMBER: '(عضو)'
      },
      invited_by: 'بدعوة من',
      promote_to_admin: 'الترقية إلى مسؤول الحلقة',
      demote_to_member: 'تخفيض إلى عضو في الحلقة'
    },
    access_requests: {
      manage: 'إدارة الحلقة',
      accept: 'منح الدخول',
      reject: 'رفظ الدخول',
      confirmation_required_title: 'التأكيد مطلوب',
      user_will_be_notified_of_rejection:
        'اضغط على الزر أدناه لرفض طلب الوصول هذا. سيتم إشعار المستخدم الذي قدم الطلب بأن طلبه قد تم رفضه.',
      REJECTED: 'مرفوض من طرف {username}',
      ACCEPTED: 'قبلت من قبل {username}'
    }
  },
  buttons: {
    zoom_meeting: 'Join Zoom Meeting',
    ok: 'نعم',
    cancel: 'يلغي'
  },
  post_dialog: {
    pre_welcome: 'مرحبًا بكم في مناقشتنا قم',
    post_welcome: 'هذه المناقشة مفتوحة الآن لمساهمتك في الاقتراحات أدناه.',
    tour_help: 'بجولة لمعرفة المزيد. يمكنك دائمًا الوصول إلى شاشة المساعدة هذه لاحقًا من رمز المساعدة (علامة الاستفهام) في شريط التطبيقات.    ',
    post_closed: 'تم إغلاق هذه المناقشة من قبل المنسق. يرجى قراءة المناقشات ونتائجها أدناه.',
    line_1: 'مساعدتك في الرد على',
    line_2_1: 'يمكنك الرد على مستوى أعلى ، بالنقر فوق الزر',
    line_2_2: 'الردود ، أو يمكنك الرد على تعليق بالضغط على',
    line_2_3: 'بجانب التعليق.',
    line_3: 'المنسق قادر دائمًا على إغلاق المناقشة مع نتيجة أو إعادة فتحها مرة أخرى',
    line_4: 'المشاركة في المناقشات',
    tab_1: 'مقدمة',
    tab_2: 'الاستجابة',
    tab_3: 'حصيلة',
    button: 'جولة',
    discussion_outcome: 'المنسق قادر دائمًا على إغلاق المناقشة مع نتيجة أو إعادة فتحها مرة أخرى من القائمة الكاملة.',
    comment_response: 'التعليق على رد معين. يمكنك دائمًا الصعود في التسلسل الهرمي لسلسلة الردود من خلال النقر على زر أعلى. يمكنك أيضًا بدء سلسلة محادثات جديدة تمامًا من حقل الردود في الأعلى.',
    response_menu_moderator: 'يمكن للمنسق إدخال رد أو اختيار رد موجود وإغلاق المناقشات لتصبح النتيجة. لا مزيد من تحرير المناقشة ممكن ما لم يختار المنسق إعادة فتح المناقشة من القائمة الكاملة للنتيجة.',
    profile: 'في ملف تعريف المستخدم ، يمكنك رؤية منشوراتهم الأخيرة أو متابعة منشوراتهم الجديدة. يتم الاحتفاظ بنسخة من ردودك بأمان في ملف التعريف الخاص بك ، ويمكن الوصول إليها من القائمة الرئيسية. من هناك يمكنك تعديل أو إلغاء نشر ردودك!',
    rate: 'انقر فوق "الرجاء تقييم اقتراح المناقشة" لإعطاء انطباعك الأول عن الاقتراح.',
    online_users: 'يُظهر الرمز عدد الزملاء الذين فتحوا نفس المناقشة وربما يشاركون. اضغط عليها لتجد أسمائهم.',
    Notifications: 'يقوم الرمز بتبديل اللوحة الجانبية لإظهار التنبيهات مثل إعلام وصول الردود الجديدة.',
    respond: 'إذا كنت المستجيب الأول الفخور ، فاكتب الرد الأول ضمن "الردود" وانقر فوق نشر!',
    fullscreen: 'في الردود والتعليقات ، يمكنك تنسيق النص في السطر. للقيام بالمزيد ، مثل إرفاق صورة أو إضافة رابط أو تضمين مرجع مستند أو مقطع فيديو ، انقر على "الشاشة الكاملة" أثناء الرد.',
    response_menu_authour: 'بصفتك مؤلفًا ، يمكنك إلغاء نشر ردك أو تعديله بعد نشره. إذا كنت مشرفًا / مشرفًا في دائرة ، فيمكنك أيضًا تعديل أو إلغاء نشر الرد مع المؤلف الأصلي المخول بتعديله وإعادة نشره.',
    circle: {
      title: 'مرحبًا بك في حلقتك للنقاش',
      line_1: 'يمكنك متابعة المقالات والمناقشات وأحداث الاجتماعات في حلقة النقاش هذه. يمكنك أيضًا كتابة مساهمتك الخاصة أو بدء حدثك الخاص. سنأخذك في جولة سريعة في حلقة النقاش هذه.',
      line_2: 'يمكنك دائمًا زيارة هذه الجولة لاحقًا من رمز المساعدة (علامة الاستفهام) في شريط التطبيقات.',
      button: 'Features tour',
    },
  },
  email_registration: {
    agree: 'أوافق على',
    privacy: 'سياسة الخصوصية',
    post_privacy: 'و',
    terms: 'الشروط والأحكام',
  },
  dialogs: {
    online: 'مستخدمين على الهواء',
    configure_notifications: 'إظهار الإخطارات',
    show_toasts: 'إظهار الإخطارات المنبثقة',
    show_notifications: 'إظهار إخطارات سطح المكتب',
  },
  accordion: {
    recent_notes: 'التصويتات الأخيرة',
    recent_votes: 'التصويت الأول ما رأيك؟',
  },
  placeholders: {
    opinion: 'رأي قصير',
  },
  toolbars: {
    notifications: 'إشعارات',
    report: 'الإبلاغ عن موضوع غير ملائم',
  },
  no_such_post: 'لم نتمكن من العثور على هذه المشاركة!',
  circle_listing: {
    collapse: 'تصغير الدوائر الفرعية',
    expand: 'قم بتوسيع الدوائر الفرعية',
    c_posts: 'مشاركات',
    c_members: 'أعضاء',
    go_to_circle: 'انقر للذهاب إلى الدائرة',
  },
  br: {
    exit: 'خروج',
    share: 'مشاركة',
    viewDetails: 'عرض تفاصيل الكتاب',
    savedText: 'النص المحفوظ',
    selText: 'النص المحدد',
    back: 'رجوع',

    bm: {
      title: 'إشارة مرجعية',
      titleAdd: 'إضافة إشارة مرجعية',
      name: 'الاسم',
      ph: 'اسم الإشارة المرجعية',
      save: 'حفظ الإشارة المرجعية',
      remove: 'حذف الإشارة المرجعية',
    },

    note: {
      title: 'ملاحظة',
      titleAdd: 'إضافة ملاحظة',
      label: 'ملاحظة',
      ph: 'اكتب ملاحظتك\u2026',
      save: 'حفظ الملاحظة',
      remove: 'حذف الملاحظة',
    },

    ai: {
      title: 'اسأل كير',
      ph: 'اسأل أي شيء',
      disclaimer: 'تقتصر إجابات الذكاء الاصطناعي على هذا الكتاب فقط',
      ask: 'اسأل',
      searching: 'جارٍ البحث\u2026',
      sources: '{count, plural, zero {لا مصادر} one {مصدر واحد} two {مصدران} few {# مصادر} many {# مصدراً} other {# مصدر}}',
      readAloud: 'قراءة بصوت عالٍ',
      stopReading: 'إيقاف القراءة',
      newQ: 'سؤال جديد',
    },
    prefs: {
      title: 'تفضيلات القارئ',
      reset: 'إعادة التعيين',
      fontType: 'نوع الخط',
      fontSize: 'حجم الخط',
      lineSpacing: 'تباعد الأسطر',
      theme: 'المظهر',
      font: {
        inter: { label: 'Inter', sub: 'بدون ضريف' },
        times: { label: 'Times New Roman', sub: 'تقليدي' },
        opendyslexic: { label: 'OpenDyslexic', sub: 'سهل القراءة' },
        'arabic-naskh': { label: '\u0646\u0648\u062a\u0648 \u0646\u0633\u062e \u0639\u0631\u0628\u064a', sub: 'عربي مضلع' },
        'arabic-kufi': { label: '\u0643\u0648\u0641\u064a \u0639\u0631\u0628\u064a', sub: 'عربي كوفي' },
        'arabic-muna': { label: 'منى', sub: 'نسخ عربي' },
      },
      themes: {
        light: 'فاتح',
        sepia: 'بني فاتح',
        dark: 'داكن',
      },
    },
    content: {
      title: 'المحتوى',
      close: 'إغلاق',
      toc: 'جدول المحتويات',
      bookmarks: 'الإشارات المرجعية',
      noBm: 'لا توجد إشارات مرجعية',
      notes: 'الملاحظات',
      noNotes: 'لا توجد ملاحظات',
      continue: 'متابعة القراءة',
      search: 'بحث',
    },
    sel: {
      askAi: 'اسأل كير',
      bookmark: 'إشارة مرجعية',
      note: 'ملاحظة',
    },
    dial: {
      search: 'بحث',
      askAi: 'اسأل الذكاء الاصطناعي',
      settings: 'إعدادات القارئ',
      translate: 'ترجمة',
      toc: 'جدول المحتويات',
      save: 'حفظ إشارة مرجعية',
      open: 'فتح قائمة الإجراءات',
      close: 'إغلاق قائمة الإجراءات',
    },
    audio: {
      play: 'تشغيل',
      pause: 'إيقاف مؤقت',
      skipBack: 'تخطي للخلف',
      skipFwd: 'تخطي للأمام',
      speed: 'سرعة التشغيل',
      progress: 'تقدم الصوت',
    },
    hdr: {
      openContents: 'فتح المحتويات',
      chOf: 'الفصل {index} من {total}',
      pageOf: 'ص. {page} من {total}',
    },
    snack: {
      bmAdded: 'تمت إضافة الإشارة المرجعية',
      noteSaved: 'تم حفظ الملاحظة',
    },
  },
  interview: {
    narrator: 'المؤلف / الراوي',
    bornYear: 'من مواليد {year}',
    fieldResearcher: 'الباحثة الميدانية: {name}',
    recordingDate: 'تاريخ التسجيل: {date}',
    recordingDateLabel: 'تاريخ التسجيل',
    summary: 'ملخّص',
    details: 'تفاصيل المقابلة',
    birthPlace: 'مكان الميلاد',
    placeOfOrigin: 'البلد الأصلي والقضاء',
    currentAddress: 'العنوان الحالي',
    recordingPlace: 'مكان التسجيل',
    duration: 'المدة',
    durationMin: '{min} دقيقة',
    fieldResearcherLabel: 'الباحثة الميدانية',
    organization: 'الجهة المشرفة',
    supervisingResearcher: 'الباحثة المشرفة',
    audio: 'تسجيل صوتي',
    video: 'فيديو',
    image: 'صورة',
    prevSlide: 'الشريحة السابقة',
    nextSlide: 'الشريحة التالية',
    transcript: 'النص الكامل',
    transcriptExpand: 'انقر للتوسعة',
    transcriptReadTime: 'قراءة {min} دقيقة تقريباً',
    mediaItem: 'عنصر {index}',
    previewUnavailable: 'المعاينة غير متاحة.',
    openFile: 'فتح الملف',
    openFullSize: 'فتح بالحجم الكامل',
  },
  meta: {
    tab: {
      core: 'عام',
      interview: 'الوسائط المتعددة',
      pricing: 'التسعير والوصول',
    },
    field: {
      narratorName: {
        label: 'اسم الراوي',
        desc: 'الاسم الكامل للراوي.',
      },
      narratorImage: {
        label: 'صورة الراوي',
        desc: 'صورة شخصية تظهر في ترويسة سيرة الراوي.',
      },
      birthYear: {
        label: 'سنة الميلاد',
        desc: 'السنة التي وُلد فيها الراوي.',
      },
      birthPlace: {
        label: 'مكان الميلاد',
        desc: 'المدينة أو القرية التي وُلد فيها الراوي.',
      },
      originalTownDistrict: {
        label: 'البلدة الأصلية / القضاء',
        desc: 'بلدة الراوي الأصلية أو قضاؤه.',
      },
      recordingPlace: {
        label: 'مكان التسجيل',
        desc: 'المكان الذي جرى فيه تسجيل المقابلة.',
      },
      recordingDate: {
        label: 'تاريخ التسجيل',
        desc: 'تاريخ تسجيل المقابلة. يُحفَظ بصيغة سنة-شهر-يوم.',
      },
      addressLocation: {
        label: 'العنوان / الموقع',
        desc: 'العنوان أو الموقع الحالي للراوي.',
      },
      recordingDurationMinutes: {
        label: 'مدة التسجيل (بالدقائق)',
        desc: 'إجمالي مدة التسجيل بالدقائق.',
      },
      fieldResearcher: {
        label: 'الباحث الميداني',
        desc: 'اسم الباحث الذي أجرى المقابلة.',
      },
      supervisingOrganization: {
        label: 'الجهة المشرفة',
        desc: 'الجهة التي أشرفت على البحث أو كلّفت به.',
      },
      supervisingResearcher: {
        label: 'الباحث المشرف',
        desc: 'اسم الباحث الذي أشرف على العمل الميداني.',
      },
      title: {
        label: 'العنوان / الترويسة',
        desc: 'يُدخِله المشرف أو المؤلف. إذا تُرك فارغًا، يُملأ تلقائيًا من نص العنوان الرئيسي أو السطر الأول من المستند.',
      },
      author: {
        label: 'المؤلف / التوقيع',
        desc: 'اسم المؤلف أو المصدر. يُدخِله المشرف أو المؤلف، ويُملأ مبدئيًا باسم المؤلف من نظام النشر أو المستند.',
      },
      authorAvatar: {
        label: 'صورة المؤلف',
        desc: 'صورة المؤلف. ارفع صورة لعرضها بجانب اسم المؤلف.',
      },
      publicationDate: {
        label: 'تاريخ النشر',
        desc: 'التاريخ الأصلي لنشر العنصر. يُدخِله المشرف أو المؤلف.',
      },
      summary: {
        label: 'الملخص / الخلاصة',
        desc: 'ملخص قصير للمحتوى. يمكن كتابته يدويًا أو توليده بالذكاء الاصطناعي. إذا تُرك فارغًا، يُملأ تلقائيًا من الفقرة الأولى بعد العنوان.',
      },
      creationDate: {
        label: 'تاريخ الإنشاء',
        desc: 'التاريخ الذي أنشأ فيه النظام المنشور أو المستند.',
      },
      tags: {
        label: 'الوسوم',
        desc: 'مجموعة من الوسوم أو الكلمات المفتاحية التي تصف المحتوى. يمكن إكمالها شبه يدويًا باستخدام قوائم مفردات مضبوطة. حاليًا، حتى ٨ وسوم للمقالات وغير محدودة للأصول.',
      },
      documentType: {
        label: 'نوع المستند',
        desc: 'يختار المنسّق هذا الحقل من خيارات محددة مسبقًا (مثل: كتاب، مقالة، قصيدة، رسالة، صورة، فيديو، صوت).',
      },
      sourceInstitution: {
        label: 'المؤسسة المصدر / الناشر',
        desc: 'معلومات مُسجَّلة يدويًا أو بواسطة النظام عن المؤسسة المصدر أو الناشر.',
      },
      rights: {
        label: 'الحقوق / الترخيص',
        desc: 'يحددها فريق المشروع أو الفريق القانوني. إذا كان المحتوى محفوظ الحقوق، أضِف رابطًا إلى موقع الناشر.',
      },
    },
  },
};

const plurals = {
  and_one_other: 'and one other',
  and_n_others: 'and {n} others',
  view: 'View',
  one_response: 'One response',
  n_responses: '{responseCount} responses',
  one_elided_post: 'One elided post',
  n_elided_posts: '{length} elided posts',
  one_member: 'One member',
  n_members: '{memberCount} members}',
  one_post: 'One post',
  n_posts: '{postCount} posts',
  one_pending_request: 'One pending request',
  n_pending_requests: '{access_request_count} pending requests}'
};

var en = {
  chat: {
    pin: "Pin message",
    unpin: "Unpin message",
    edit: "Edit",
    loadMore: "Load more...",
    search1: "Enter any question in the search window, such as ‘Health services in Preston’, then click on the AI Analysis Button, or just hit Return",
    search2: "For AI search click on the CAIR, Head, icon then click on AI Search button, or just hit Return",
    search3: "For keyword search click on the magnifying glass icon then enter keyword followed by hitting Return"
  },
  auth: {
    or: "OR",
    newPassword: "New Password",
    change2: "Change...",
    change: "Change Password",
    forgot: "Forgot password?",
    verify2: "Verify...",
    verify: "Verify",
    verificationCode: "Verification Code",
    confirmationCode: "Confirmation Code",
    emailOrPhone: "Email or Phone number",
    resetting: "Resetting...",
    reset: "Reset Password",
    sentEmail: "We have emailed you a link to reset your password. Please check your inbox.",
    phoneNoPassword: "Signed up with your phone? You do not need a password \u2014 sign in with your phone number and we will text you a code.",
    resetLinkExpired: "This password-reset link has expired. Please request a new one.",
    changeFailed: "We could not change your password, please try again.",
    noSuchAccount: "We could not find an account with that email address.",
    emailBounced: "We cannot send email to that address. Please contact support.",
    resetFailed: "We could not send the reset email, please try again.",
    register2: "New user? Register!",
    registerWithPhone: "Register with your phone",
    phone: "Phone Number",
    email: "Email",
    password: "Password",
    confirm: "Confirm Password",
    register: "Register",
    registering: "Creating account...",
    agree: "I agree to the Terms of Service",
    alreadyHaveAccount: "Already have an account? Login!",
    registerWithPhone: "Register with phone number",
    login2access: "Please log in to access this page",
    authRequired: "Authentication required",
    register: "Create account",
    login: "Existing user: Login",
    login2: "Login",
    login3: "Logging in...",
    continueWithPhone: "Continue with phone",
    phone2: "Phone",
    country: "Country",
    sendCode: "Send code",
    sendingCode: "Sending code...",
    codeSent: "We sent a verification code to your phone by SMS.",
    phoneLengthExact: "The phone number should be {n} digits (not counting the leading 0).",
    phoneLengthRange: "The phone number should be {min}–{max} digits (not counting the leading 0).",
    enterCode: "Verification code",
    resendCode: "Resend code",
    resendCodeIn: "Resend code in {seconds}s",
    sendCodeWhatsApp: "Get the code on WhatsApp",
    changePhone: "Use a different phone number",
    otpInvalid: "That code is not correct, please try again.",
    otpExpired: "That code has expired, please request a new one.",
    otpTooManyAttempts: "Too many attempts, please request a new code.",
    otpCooldown: "Please wait a minute before requesting another code.",
    otpRateLimited: "Too many requests, please try again later.",
    smsSendFailed: "We could not send the SMS, please try again.",
    otpCountryNotSupported: "We cannot send codes to that country. Please sign up with your email instead.",
    otpCaptchaPending: "Checking your browser\u2026",
    otpFailed: "Something went wrong, please try again.",
    biometricLogin: "Sign in with biometrics",
    biometricFailed: "Biometric sign-in failed, please sign in again.",
    passkeyLogin: "Sign in with a passkey",
    passkeyFailed: "Passkey sign-in failed, please try again.",
    passkeyAdd: "Add a passkey",
    passkeyAdded: "Passkey added",
    passkeyEnrollFailed: "Could not add a passkey, please try again."
  },
  CloseDiscussion: 'Close with this outcome',
  reopen: 'Reopen Discussion',
  close: "close",
  people: "people",
  toggleReponse: 'toggle reponses',
  CreateZoomMeeting: "Create zoom meeting",
  outcome: 'Outcome',
  StartaDiscussion: "Start a Discussion",
  authentication_required: 'Authentication Required',
  statusShort: {
    event: {
      comeLater: "waiting",
      reportAvailable: "finished",
      aboutToStart: "starting",
      joinMeeting: "live",
    }
  },
  ai: {
    details: "AI assistant details",
    name: "Assistant name",
    description: "Assistant description",
    selectAvatar: "Select assistant avatar image",
    selectIcon: "Click to select icon",
    operation: "AI assistant operation",
    selectMainPrompt: "Select Main Prompt",
    freq: "Frequency of Prompt's execution (in seconds)",
    manual: "Manual",
    schedule: "Schedule",
    off: "Off",
    hideUI: "Hide user-enabled processes",
    showUI: "Show user-enabled processes",
    promptSelection: "Prompt selection",
    add: "Add",
    selectPrompt: "Select Prompt",
    thread: "Discussion thread",
    editor: "Editor Menu",
    circle: "Circle Menu",
    alias: "Menu alias",
    delete: "Delete",
    cancel: "Cancel",
    save: "Save",
    clickOn: "Click-on then enter instruction for the AI assistance in the Editor window",
    ask: "Message",
    disable: "Disable AI",
    enable: "Enable AI",
    addAI: "Add AI assistant",
    active: "Active",
    notActive: "Not active",
    edit: "Edit",
    delete: "Delete",
    createdBy: "Created by",
    refresh: "refresh",
    running: "Running",
    notRunning: "Not Running",
    lastExecuted: "Last executed",
    service: "Service",
    update: "Update",
    success: "success",
    logs: "Logs",
    stop: "Stop",
    start: "Start",
    continue: "Continue",
    pause: "Pause",
  },
  common: {
    create: "Create",
  },
  dashboard: {
    breadcrumb: "Dashboard",
    goToBookCair: "Go to BOOK CAIR",
    tooltip: {
      profile: "My World: My Profile and my content",
      allPosts: "Posts for tags I follow from all Circles that I can access",
      circles: "Circles that I have joined",
      discussions: "Discussions that I am member of",
      meetings: "Meetings that I am invited to",
      subCircles: "Click to see sub-Circles",
      parentCircle: "Click to see Parent Circle",
      postDetails: "Click for more details",
    },
    circles: "My Circles",
    discussions: "My Discussions",
    meetings: "My Meetings",
    allPosts: "All Posts",
    showMore: "Show More",
    discover: "Discover",
    completeProfile: "Click here to complete your profile",
  },
  event: {
    types: {
      Music: "Music",
      Culture: "Culture",
      Training: "Training",
      Meeting: "Meeting",
      Sport: "Sport",
      Information: "Information"
    },
    responded: "responded",
    maybe: "Maybe",
    no: "No",
    yes: "Yes, in Person",
    yes_v: "Yes, join virtually",
    yes1: "Yes",
    going: "Going",
    show_more: "show more",
    respondents: "List of respondents",
    organizer: "Organizer",
    address: "Address",
    start: "Event start",
    end: "Event end",
    addTags: "Add Tags",
    name: "Name",
    address: "Address",
    priority: "Event Priority",
    moreInfo: "Add more info /Extend Form",
    collapse: "Collapse form",
    cancel: "Cancel",
    save: "Save",
    roles: "Define roles for a Meeting or Training Event",
    location: "Event's Location",
    startAndEnd: "Start and end of Event",
    eventType: "Event Type",
    describe: "Describe your event",
    sponsor: "Sponsor organization (search assets)",
    noData: "No Events scheduled for this Circle, why don't you start an Event!",
    finishMeeting: "Meeting is finished",
    listing: "Listing",
    upcoming: "Upcoming",
    recent: "Recent",
    hosting: "hosting",
    speaking: "participating",
    andOthers: "and {count} others",
    startsPrefix: "starts:",
    endsPrefix: "ends:",
    comeLater: "Join the event here:",
    reportAvailable: "Meeting Reports available below, comments welcome",
    reportAvailableAdmin: "Please write meeting Outcome below when ready",
    aboutToStart: "Meeting is about to start",
    joinMeeting: "Join the Meeting",
    openZoomApp: "Open with Zoom App",
    openZoomAppBefore: "Opens 30 minutes before start",
    webClient: "Web client ({op})",
    Host: "Host",
    Join: "Join",
    Assistant: "Assistant",
    more: "more",
    see: "see",
    sendInvitation: "Send invitation emails",
    all_party: "Notify all Circle members",
    templates: {
      created: "Event created",
      eventsReminder24: "Remind 24 hours before",
      eventsReminder1: "Remind 1 hours before",
      eventsFinished: "Event finished",
    },
  },
  general: {
    ok: 'OK',
    MeetingTime: "Meeting time:",
    cancel: 'Cancel',
    prev: 'prev',
    next: 'next',
    or: 'or',
    requires_registration: 'Registration Required',
    access_denied: "Access denied",
    request_access_to_circle: "Request access to the circle",
    request_access_to_circle2: "Sorry, you have no access rights to this Circle. Click above to join",
    or_click: "Or you can click here.",
    join2read: "Join Circle to read Post",
    automatically_redirect2circle: "We will automatically redirect you to the Circle to join.",
    no_rights2view_post: "Sorry, you have no access rights to view this post.",
    requires_registration_details:
      'Register an account to enable a host of additional functionality.',
    already_a_member: 'Already a member?',
    sign_up: 'Sign Up',
    sign_in: 'Sign In',
    untitled: 'Untitled Post',
    loading: 'Loading, please wait ...',
    please_wait: 'Please wait ...',
    error: 'Oops, something went wrong',
    view_profile: 'View Profile',
    more: 'see all',
    coming_soon: "We're not quite ready yet - this feature is arriving soon!",
    generating_art: 'Generating a cover image',
    type_to_find_person: 'Start typing to find people ...',
    type_to_find_group: 'Start typing to find circles ...',
    type_to_find_tag: 'Start typing to find tags ...',
    type_to_find_post: 'Start typing to find posts ...',
    no_people: 'Nothing to show',
    no_groups: 'Nothing to show',
    cannot_be_undone: 'WARNING: This action cannot be undone!',
    privacy_policy: 'Privacy Policy',
    terms_and_conditions: 'Terms and Conditions'
  },
  search: {
    placeholder: 'Type to search'
  },
  embed: {
    loading: 'Loading embedded content ...'
  },
  validation_error: {
    username_exists: "User name already exists",
    email_exists: "Email already registered",
    invalid_url: 'Invalid URL',
    required: '{field} is required',
    required_field: 'Field is required',
    invalid_username: 'Username too short',
    invalid_email: 'Invalid Email Address',
    invalid_phone_number: 'Invalid phone number',
    password_must_include_digits: 'Password must include at least one number',
    password_too_short: 'Password must be at least 8 characters',
    passwords_must_match: 'Passwords do not match',
    invalid_domain_name: 'Valid domain name required e.g. www.google.com'
  },
  navigation: {
    login: 'Sign In',
    logout: 'Sign out',
    '/home': 'Home',
    'home/activity': 'Activity',
    'home/news': 'Posts',
    'home/events': 'Events',
    'home/news/tag/posts': 'Posts',
    'home/news/tag/circles': 'Circles',
    'home/people': 'People',
    '/notifications': 'Notifications',
    'notifications/notifications': 'Notifications',
    create: 'Create',
    createEvent: "Create a Meeting Event",
    groups: 'Circles',
    'groups/home': 'My Circles',
    'groups/discover': 'Discover Circles',
    'groups/group/activity': 'Activity',
    'groups/group/outcome': 'Outcome',
    'groups/group/posts': 'Posts',
    'groups/group/reference': 'Reference',
    'groups/group/groups': 'SubCircles',
    'groups/group/events': 'Events',
    'profile/public': 'Profile',
    'profile/posts': 'Profile',
    'profile/drafts': 'Drafts',
    'profile/bookmarks': 'Bookmarks',
    'profile/public/posts': 'Posts',
    'profile/public/events': 'Events',
    'profile/public/responses': 'Responses',
    'profile/public/recommends': 'Recommends',
    'profile/public/bio': 'Bio',
    'home/member': ' ',
    'home/member/posts': 'Posts',
    'home/member/events': 'Events',
    'home/member/responses': 'Responses',
    'home/member/recommends': 'Recommends',
    'home/member/bio': 'Bio',
    'groups/group/membership/access_requests': 'Requests',
    'groups/group/membership/invites': 'Invites',
    'groups/group/membership/members': 'Members',
    search: 'Search'
  },
  login: {
    title: 'Sign In',
    email: 'Email Address',
    password: 'Password',
    login: 'Submit',
    account_not_verified: 'Email address not verified',
    invalid_credentials: 'Invalid Credentials',
    login_with_email: 'Login with Email & Password',
    login_with_facebook: 'Login with Facebook',
    no_such_user: 'This account is not registered',
    reset_password: 'Reset Password',
    sent_password_reset_mail:
      'A password-reset email has been sent to you, please check your email.'
  },
  logout: {
    signing_out: 'Signing out ...'
  },
  landing: {
    line_1: 'Ideation in circles of facilitated discussions to find solutions',
    line_2:
      'Join a Circle, create your own public or private Circles, publish Posts and follow others',
    register_button: 'Get Started',
    browse_as_a_guest: 'or browse as a guest'
  },
  registration: {
    terms: "terms",
    privacy_policy: "privacy policy",
    register_with_email: 'Register with Email',
    welcome: 'Your email address is now confirmed',
    continue_to_the_app: 'Continue',
    confirmation_required_title: 'Confirm your Email',
    confirmation_required_text:
      'We sent an email to {email} containing a PIN to complete your registration.',
    confirmation_pin_field: 'Verification PIN',
    confirm_registration: 'Submit verification PIN',
    continue_with_facebook: 'Continue with Facebook',
    continue_with_twitter: 'Continue with Twitter',
    continue_with_google: 'Continue with Google',
    waiting_for_facebook: 'Waiting for authentication',
    completing_registration: 'Completing your registration',
    completed_registration: 'Registration complete, redirecting ...'
  },
  registration_form: {
    register: 'Register',
    username_field: 'Username',
    email_field: 'Email Address',
    password_field: 'Password',
    password_again_field: 'Re-type Password',
    already_registered: '{field} is already registered',
    already_registered2: 'already registered',
    password_reset_button: 'Reset',
    confirm_password_button: "Confirm"
  },
  password_reset: {
    success: 'Reset Success!',
    failed: 'Password Reset Failed!',
    linkLabel: 'continue',
    signing_in: 'Signing you in ...'
  },
  onboarding: {
    choose_n_tags: 'Choose at least 3 tags to personalize your news feed'
  },
  profile: {
    view: 'View Profile',
    new_post: 'New Post',
    new_event: "New Event",
    edit_button: 'Edit personal information',
    my_short_bio_default: 'Add a short bio',
    their_short_bio_default:
      'This user prefers to keep an air of mystery about them',
    reputation_label: 'reputation',
    followers_label: 'followers',
    following_label: 'following',
    title: 'Edit Profile',
    firstname_field: 'First Name',
    lastname_field: 'Last Name',
    gender_field: 'Gender',
    gender_male: 'Male',
    gender_female: 'Female',
    bio_field: 'Bio',
    profile_photo: 'Profile Pic',
    save: 'save',
    edit_profile_title: 'Edit Profile',
    view_profile_title: 'Profile',
    load_profile: 'Loading Profile',
    follow: {
      is: 'Following',
      is_not: 'Follow',
      checking: 'Follow'
    },
    choose_avatar_label: 'Choose an avatar image',
    drag_image_label: 'Click or Drag Image',
    error_user_404: 'User Does Not Exist',
    logout: 'Logout {username}'
  },
  people: {
    search_for_people:
      'Use keyword search (above right) to search names and biographies.',
    interesting_people:
      'Here are some interesting people you might like to follow.',
    no_results: "We didn't find anyone matching that query"
  },
  import: {
    drop_here:
      'Drop a Microsoft Word (.docx) or PDF file here, or click to browse',
    not_a_word_doc: 'Only PDF or Microsoft Word .docx files can be imported.',
    try_again: 'Try Again',
    uploading: 'Importing Document',
    redirecting_you: 'Redirecting ...'
  },
  compose: {
    unknown_type: 'Unknown Post type `{type}`',
    new: {
      page_title: 'New Post',
      page_evt_title: "Create Event",
      new_public_post: 'Create a New Post',
      page_event: "New Event",
      date: "date",
      thirtyMins: "30 minutes",
      SixtyMins: "60 minutes",
      NinetyMins: "90 minutes",
      OneTwentyMins: "120 minutes",
      CreateMeeting: "create meeting",
      submiting: "submiting",
      Duration: "Duration",
      time: "time",
      end_time: "end time",
      chat_placeholder: "Enter text to Enhance or enter a question for Assist then click the appropriate button, click on Publish to submit your comment.",
      event_title: "Event title",
      create_event: "Create event",
      start_date: "Start date",
      end_date: "end date",
      event_description: "Event description",
      category: "category",
      choose_moderator: "Choose moderator",
      add_participant: "add participant",
      warning:
        'Your post will be public by default. You can control privacy by choosing a Circle at the final publishing step.',
      what: 'What do you want to create?',
      post_an_article: 'Write an Article',
      import_a_document: 'Import a Document',
      announce_an_event: 'Announce an Event',
      thirtyMins: "Thirty minutes",
      SixtyMins: "Sixty minutes",
      NinetyMins: "Ninety minutes",
      minutes150: "150 minutes",
      minutes180: "180 minutes",
      minutes240: "240 minutes",
    },
    tag: {
      page_title: 'Tag your Post',
      page_title_Event: 'Tag your event',
      choose_n_tags: 'Tag your post with up to {n} tags',
      choose_n_tags_events: 'Tag your event with up to {n} tags',
      atLeastOneTag: "Please add at least one tag!",
      tag: 'Tag'
    },
    event: {
      title_schedule_event: "Schedule your event",
      title_schedule_discussion: "Schedule your discussion",
      role: "Role",
      suggested: "Suggested",
      title_roles: "Audience and Roles",
      roles_header: "Select a role and add people to it",
      schedule_header_event: "Set date and time and the type of the event",
      schedule_header_discussion: "Schedule the start and end of the discussion",
      by_name_and_email: "Search by name or email",
      timezone: "timezone",
      meeting_info: "Provide meeting information",
      event_type: "Event Type",
      label: "Additional Information (e.g ‘Join Zoom Meeting’, etc.)",
      url: "URL to additional information",
      label2: "More additional information, e.g link to YouTube streaming",
      url2: "Link for more additional information",
      streamingInfo: "Additional information about streaming service used",
      streamingUrl: "URL for viewing the streaming service used",
      types: {
        google: "Google",
        jitsi: "Jitsi",
        zoom: "Zoom",
        external: "External",
      },
      roles: {
        expert: "Expert",
        host: "Host",
        moderator: "Moderator",
        speaker: "Speaker",
        guest_expert: "Guest Expert",
        panelist: "Panelist",
        participant: "Participant",
        trainer: "Trainer",
      },
      all_members_invited: "All Circle members are invited to this meeting as participants",
    },
    audience: {
      page_title: 'Your Audience',
      publish: 'publish',
      publishing: 'publishing',
      control_visibility:
        'Manage who can see your post by posting publicly or to a Circle you are participating in',
      public_title: 'Public',
      public_description: 'Anyone can see this post',
      group_title: 'Circle',
      group_description: 'Visiblity is controlled by Circle settings',
      choose_group: 'Choose Circle',
      change_group: 'Change'
    },
    share: {
      title: 'Share your creation',
      published_successfully: 'Your post was published successfully.',
      share_post: 'done',
      share_article: 'Select and copy the link below to share:'
    },
    next: 'next',
    external_link: 'External Link',
    link_post: 'Link to a Post',
    embed_post: 'Embed a Post',
    link_field: 'URL',
    link_placeholder: 'Enter a valid http(s) URL',
    description_field: 'Description',
    description_placeholder: 'Description (appears in links section)',
    uploading: 'Uploading {name}',
    link: {
      manager_title: 'Edit Link',
      update: 'Update Link'
    },
    embed: {
      manager_title: 'Edit Embed',
      update: 'Update Embed'
    }
  },
  attachments: {
    manager_title: 'Manage Attachments',
    no_attachments: "You haven't attached any files yet.",
    drop_here: 'Drop files here, or tap to open a file-picker.',
    describe: 'Describe this attachment'
  },
  activity: {
    publish: 'posted in',
    publish_publicly: 'posted publicly',
    publish_to_all: 'posted publicly',
    follow: 'followed',
    reply: 'replied to your post',
    react: 'reacted to a post',
    'create-group': 'started Circle {name}',
    'created-group': 'started Circle {name}', // deprecate
    'join-group': 'joined Circle {name}',
    'joined-group': 'joined Circle {name}', // deprecated
    'close-group': 'ended Circle {name}',
    'reopen-group': 'reopened Circle {name}',
    'invite-to-group': 'invited you to join a Circle',
    'request-access': 'requested access to the Circle "{name}"',
    'removed-post': 'removed a post',
    you: 'You',
    in_group: 'in',
    verbs: {
      publish: 'published {activity_count} posts', // todo: plurals
      follow: 'followed {activity_count} people', // todo: plurals
      reply: 'replied to your post',
      react: 'reacted to a post',
      'join-group': 'joined a Circle',
      'create-group': 'started a new Circle',
      'invite-to-group': 'invited you to join a Circle',
      'reopen-group': 'reopened a Circle',
      'close-group': 'concluded a Circle',
      'request-access': 'requested access to Circles',
      'removed-post': 'removed a post'
    },
    name_comma: ', ',
    name_and: ' and ',
    mentioned_you: 'mentioned you',
    and_n_others: `{n, plural, one {${plurals.and_one_other}} other {${plurals.and_n_others}}}`,
    n_people: '{n} people',
    tap_groups: 'Tap "Circles"',
    join_some_groups: 'to discover Circles that match your interests',
    tap_create: 'Tap "Add"',
    post_some_content: 'to create your own posts',
    view_posts_matching_your_tags:
      'Tap "Posts" to see latest posts and news that match your tags',
    view_events_matching_your_tags:
      'Tap "Events" to see latest events that match your tags',
    follow_some_people: 'Or find interesting people to follow from list below'
  },
  drafts: {
    delete: 'Delete this draft',
    count: '{count, plural, one {# draft} other {# drafts}}'
  },
  posts: {
    send_reminder: "Send reminder email",
    open_thread: "Open thread in a new window",
    empty_list_placeholder: "There's nothing to see here yet.",
    n_minute_read: '{value} min read',
    unpublish: 'Unpublish this post',
    edit: 'Edit this post',
    edit_metadata: 'Edit metadata',
    in_group: ', in {name}',
    pin_and_close_group: 'Pin and close Circle',
    pin_as_group_intro: 'Pin as Circle intro',
    search_placeholder: 'Type to find posts'
  },
  post: {
    continue: "Continue",
    proceed: "Proceeding to Login Page",
    please_login: "This post is for members. Please log in to read it.",
    register_login: "Please register/login first in order to respond.",
    proceed_join: "Joining the Circle",
    join2respond: "Please join the Circle to write a response.",
    join: "Join",
    cancel: "Cancel",
    startNewDiscussionThread: "Start a new discussion thread",
    respond2Thread: "Respond to thread",
    closeDiscussionThread: "Close Discussion thread",
    unflag: "Cancel Report as inappropriate",
    unpublished: 'Post Unavailable',
    unpublished_description:
      'This post has been removed by the author or a moderator',
    responses: 'Responses',
    responses_discussion: 'Discussion Threads',
    respond: 'Click here to write a response to {name}',
    respond_discussion: 'Click here to start a new discussion thread',
    conversation_with: 'Conversation with {name}',
    n_responses: `${plurals.view} {responseCount, plural, one {${plurals.one_response}} other {${plurals.n_responses}}}`,
    maximize_conversation: 'See the whole conversation',
    minimize_conversation: 'Minimize this conversation',
    references: 'Resources and References',
    response_removed: 'This response has been removed',
    response_removed_by: "Comment unpublished by",
    main_post: 'Main discussion post',
    go_back_to_main_post: 'Click on the title below to go to the main post',
    owner_thread: 'Owner thread:',
    go_to_owner_thread: '(Click below to go to owner thread)',
    current_thread: 'Please respond to this thread below: ',
    n_other_posts: `{length, plural, one {${plurals.one_elided_post}} other {${plurals.n_elided_posts}}}`,
    full_screen_composer: 'full screen',
    publish: 'Publish',
    discard: 'discard',
    share: 'Share this Post',
    reactions: {
      title: 'Reactions',
      agreement: 'Agreement',
      agreement_desc:
        'A measure of how much you agree with the overall arguments presented in the post',
      give_feedback: "Please rate the discussion proposal",
      eloquence: 'Eloquence',
      eloquence_desc:
        'A measure of the style, quality and persuasiveness of the writing in this post, regardless if you agree',
      relevance: 'Relevance',
      relevance_desc:
        "A measure of how relevant the post is to the group, and/or the post's tags",
      average: 'Average Rating',
      yours: 'Your Rating',
      cannot_react_to_own_post: 'You cannot react to your own post!'
    }
  },
  tags: {
    follow: 'Follow',
    following: 'Following',
    minimum_required: 'Please provide at least {n} tags',
    tag_field: 'Tag',
    home_following: 'You are currently following this tag',
    home_unfollowing: 'You are not following this tag'
  },
  group: {
    pages: "pages",
    notify_on: "Turn on mobile push notifications",
    notify_off: "Turn off mobile push notifications",
    recentActivities: "Recent Activities",
    createPost: "Create a Post",
    tabs: {
      all: "All Posts",
      discussions: "Discussions",
      meetings: "Events",
      articles: "Articles",
      references: "References",
      subCircles: "SubCircles",
      map: "Map",
    },
    actions: {
      startDiscussion: "Start a Discussion",
      announceEvent: "Announce event",
      announce: "Announce a meeting",
      writeArticle: "Write an Article",
      import: "Import a Document",
      record: "Record an Asset",
      createInterview: "Create Media Post",
    },
    tooltips: {
      dashboard: "Your Dashboard",
      help: "Help page",
      notifications: "Latest notification",
      members: "Members of this Circle",
    },
    totalResponses: "Total responses",
    searchHere: "Search here",
    empty_list_placeholder:
      "You don't appear to be participating in any Circles",
    discover_some_groups:
      'Tap "Discover" to find Circles that match your interests',
    tap_add: 'Tap "Add"',
    create_your_own_groups:
      'to start your own Circles and invite other members to join!',
    no_activity: "There's nothing to see here yet.",
    post_something: 'Post something',
    import_a_document: 'import a document',
    edit_group: 'Edit this Circle',
    new_sub_group: 'Create Sub-Circle',
    invite: 'Invite new members',
    send_invite: 'send',
    pending_invite: 'has been invited',
    already_a_member: 'is already a Member',
    request_access_to_circle: 'Request Access',
    request_access: {
      title: 'Request access to Circle',
      request: 'Request Access',
      description:
        'Tap the button below to request access to this Circle. The administrators of the Circle will be notified of your request.',
      already_requested:
        'You already have a pending request to join this Circle.',
      already_rejected:
        'Your existing request to join this Circle was rejected.'
    },
    only_visible_to_members: 'Content is only visible to members of the Circle',
    join: 'Join this Circle',
    login_to_join: 'Login to join this Circle',
    leave: 'Leave this Circle',
    reopen: 'Re-Open this Circle',
    close: 'Close this Circle',
    close_did_you_know:
      'When ending a Circle you can choose one post within the Circle to "pin" as a representative post or "outcome" for the Circle.',
    close_how_to_pin: 'To close with a pinned "outcome" post:',
    close_find_post: 'In the "Posts" tab, find the post you want to pin',
    close_tap_overflow:
      'Open the context menu by tapping the overflow icon on the post',
    close_pin_as_outcome: 'In the context menu, tap "Pin as Circle outcome"',
    close_is_better_with_outcome:
      'Closing with a pinned outcome is highly recommended',
    close_without_outcome: 'Close without pinning',
    you_are_closing_this_group:
      'Warning: You are about to end this Circle, which will prevent new posts being published to this Circle.',
    close_and_set_outcome: 'Close with Outcome',
    outcome_to_be_pinned: 'Outcome post to be pinned:',
    increase_privacy_by_one_level:
      'Increase the privacy of this Circle to the next access-level:',
    make_more_private: 'Increase Privacy',
    enable_content_digest: 'Include daily email digest',
    disable_content_digest: 'Exclude daily email digest',
    summary: {
      privacy: {
        PUBLIC: 'Public',
        public: 'Public', // deprecated
        REGISTERED: 'Registered Users Only',
        registered: 'Registered Users Only', // deprecated
        PRIVATE: 'Invitation Only',
        private: 'Invitation Only', // deprecated
        PERSONAL: 'Personal Circle',
        personal: 'Personal Circle', // deprecated
      },
      stats: `{memberCount, plural, one {${plurals.one_member}} other {${plurals.n_members}}, {postCount, plural, one {${plurals.one_post}} other {${plurals.n_posts}}}`
    },
    info: {
      privacy: {
        PUBLIC: 'Publicly Accessible',
        public: 'Publicly Accessible', // deprecated
        REGISTERED: 'Accessible by registered users',
        registered: 'Accessible by registered users', // deprecated
        PRIVATE: 'Access by invitation only',
        private: 'Access by invitation only', // deprecated
        PERSONAL: 'Personal Circle',
        personal: 'Personal Circle', // deprecated
        cannot_be_less_private_than_parent:
          'Sub-circles cannot be less private than their parent circle.'
      },
      intro: 'Read this first!',
      closed: '(closed to further activity)',
      pending_access_requests: `{access_request_count, plural, one {${plurals.one_pending_request}} other {${plurals.n_pending_requests}}`,
      membership: {
        ADMIN: {
          true: 'You are an administrator',
          false: 'You are an administrator'
        },
        MEMBER: {
          true: 'You are a member (read-only)',
          false: 'You are a member'
        },
        undefined: 'You are not a member'
      },
      guest: 'Viewing as a guest',
      members: `{memberCount, plural, one {${plurals.one_member}} other {${plurals.n_members}}`,
      posts: `{postCount, plural, one {${plurals.one_post}} other {${plurals.n_posts}}}`,
      view_members: '(view members)'
    },
    discover: {
      invitations: 'Invitations',
      suggestions: 'Suggested for you',
      invited_you: 'invited you to join this Circle',
      nothing_to_see: "It's a bit quiet around here, try again later!",
      join: 'Join Circle',
      dont_join: 'Discard Invitation',
      discarded: 'This invitation has been discarded',
      joined: "You've joined this Circle",
      go_to_group: 'Visit Circle'
    },
    create: {
      basics_page_title: 'Start a Circle',
      privacy_page_title: 'Privacy Settings',
      select_privacy: "Please select your privacy settings",
      privacy_subcircle: "If your are creating a sub-circle, its privacy can not be lower than that of its parent",
      members_page_title: 'Invite Members',
      schedule_page_title: 'Schedule',
      tags: 'Tags',
      next: 'next',
      finish: 'create',
      name_field: 'Circle Name',
      name_placeholder: 'Enter a name for your Circle',
      members_read_only_field: 'Read-Only for non-admins',
      only_admins_can_post: 'Only admins can post',
      members_and_admins_can_post: 'Members and admins can post',
      community: 'Community',
      accessible_by_all_users: 'Accessible by all users',
      members_are_invited: 'Members are invited',
      specify_at_least_one_tag:
        'Specify at least one tag that describes your Circle',
      privacy: 'Privacy',
      privacy_public_title: 'Public',
      privacy_public_description:
        'Anyone can read posts in this Circle. Any registered user can contribute content to the Circle.',
      privacy_registered_title: 'Registered Users',
      privacy_registered_description:
        'Only registered users can read and post content in this Circle.',
      privacy_private_title: 'Private',
      privacy_private_description:
        'Only people you invite can join the Circle to read and contribute.',
      privacy_personal_title: 'Personal',
      privacy_personal_description:
        'Only you can join the Circle to read and contribute.',
      send_invitations_to: 'Invitations',
      invite_some_people: "You haven't invited anyone yet",
      sponsor_page_title: 'Sponsorship',
      sponsor: 'Sponsor',
      associate_sponsor: 'Associate a sponsor for this Circle, if you have one',
      schedule: 'Schedule'
    },
    invitation: {
      page_title: "Create your password now",
      invited_header: "You are invited to join the circle",
      circle: "The circle:",
      invited_by: "Invited by:",
      agree_to_terms: "I agree to the Privacy Policy and the Terms and Conditions",
      intro: "After you confirm your password, you will be able to join events and get access to other platform services",
    },
    invitations: {
      page_title: "Invite new members to this circle",
      intro: "Expand your community! You can reach out via email to individuals who aren't yet part of the platform, encouraging them to register and join your Circle. Alternatively, you can also choose from existing platform users and invite them to enrich your Circle as new members.",
      email_header: "Invite new users by sending them emails to register and join the circle",
      emails_field: "List emails (comma-separated) …",
      send_email_button: "Validate and Send emails to invite",
      registered_toast: "inviting users …",
      register_msg: "Register",
      invite_registered: "Invite already registered users to join this circle",
      person_picker: "Start typing to find usernames and pick to invite …",
      invite: "Invite",
      invited_toast: "Users are invited",
      invite_msg: "Inviting",
    },
    edit: {
      basics_page_title: 'Edit Circle',
      finish: 'save'
    },
    members_page: {
      title: 'Members of {name}',
      since: 'joined',
      role: {
        ADMIN: '(Administrator)',
        MEMBER: '(Member)'
      },
      invited_by: 'Invited by',
      promote_to_admin: 'Promote to Circle Administrator',
      demote_to_member: 'Demote to Circle Member'
    },
    access_requests: {
      manage: 'Manage Circle',
      accept: 'Grant Access',
      reject: 'Deny Access',
      confirmation_required_title: 'Confirmation Required',
      user_will_be_notified_of_rejection:
        'Tap the button below to deny this access request. The user who made the request will be notified that their request has been rejected.',
      REJECTED: 'Rejected by {username}',
      ACCEPTED: 'Accepted by {username}'
    },
    drafts: {

    }
  },
  buttons: {
    zoom_meeting: 'Join Zoom Meeting',
    ok: 'Ok',
    cancel: 'Cancel',
  },
  post_dialog: {
    pre_welcome: 'Welcome to our discussion',
    post_welcome: 'This discussion is now open for your contribution to the proposals below.',
    tour_help: 'Take the tour to learn more. You can always access this help screen later from the help (questionmark) icon in the appbar.',
    post_closed: 'This discussion has been closed by the Moderator. Please read the discussions and their outcome below.',
    line_1: 'Helping you with responding to',
    line_2_1: 'You can respond at a higher level, clicking in the',
    line_2_2: 'Responses field, or you can respond to a Comment by clicking on the',
    line_2_3: 'next to the comment.',
    line_3: 'Moderator is always able to close discussion with Outcome or re-open it again.',
    line_4: 'Taking Part in Discussions',
    tab_1: 'Tour',
    tab_2: 'Responding',
    tab_3: 'Outcome',
    button: 'tour',
    discussion_outcome: 'Moderator is always able to close discussion with Outcome or re-open it again from overflow menu.',
    comment_response: 'Comment on a particular response. You can always go up the thread’s hierarchy by clicking on a button higher up. You may also start a completely new thread from the Responses field at the top.',
    response_menu_moderator: 'The Moderator can enter a response or choose an existing response and close the discussions with it becoming the Outcome. No more editing of the discussion is possible unless the Moderator chooses to reopen the discussion from the outcome’s overflow menu.',
    profile: 'In the author profile you can see their recent posts or follow their new posts. A copy of your responses are kept safe in your own Profile, accessible from the main menu. From there you can edit or unpublish your responses!',
    rate: 'Click on ‘Please rate the discussion’s proposal’ to give your first impression of the proposal.',
    online_users: 'The icon shows the  number of colleagues that have opened the same discussion and may be taking part. Click on it to find their names.',
    Notifications: 'The icon toggles the side panel to show alerts such as notifying new Responses arriving.',
    respond: 'If you are the proud first responder, write the first response under "Responses" and click Publish!',
    fullscreen: 'In responses and comments you can format text inline. To do more, such as attaching an image, adding a link or embedding a document reference or a video, click on ‘full screen’ while responding.',
    response_menu_authour: 'As author, you can unpublish or edit your response after you have published it. If you are a Circle Admin / Moderator you can also edit or unpublish the response with the original author empowered to edit and republish it. ',
    circle: {
      title: 'Welcome to your Circle',
      line_1: 'You can follow articles, discussions and meeting events in this circle. You can also author your own contribution or start your own event. We will take you through a quick tour of this Circle.',
      line_2: 'You can always revisit this tour later from the help (question mark) icon in the appbar.',
      button: 'Features tour',
    },
  },
  email_registration: {
    agree: 'I agree to the',
    privacy: 'Privacy Policy',
    post_privacy: 'and the',
    terms: 'Terms and Conditions',
  },
  dialogs: {
    online: 'Online users',
    configure_notifications: 'Configure notifications',
    show_toasts: 'Show toasts (pop-up notifications)',
    show_notifications: 'Show desktop notifications',
  },
  accordion: {
    recent_notes: 'Recent notes',
    recent_votes: 'Recent votes',
  },
  placeholders: {
    opinion: 'Short opinion',
  },
  toolbars: {
    notifications: 'Notifications',
    report: 'Report as inappropriate',
  },
  no_such_post: "We couldn't find that post!",
  circle_listing: {
    collapse: 'Collapse sub circles',
    expand: 'Expand sub circles',
    c_posts: 'posts',
    c_members: 'members',
    go_to_circle: 'Click to go to circle'
  },
  br: {
    exit: 'Exit',
    share: 'Share',
    viewDetails: 'View book details',
    savedText: 'Saved text',
    selText: 'Selected text',
    back: 'Back',

    bm: {
      title: 'Bookmark',
      titleAdd: 'Add Bookmark',
      name: 'Name',
      ph: 'Bookmark name',
      save: 'Save bookmark',
      remove: 'Remove bookmark',
    },

    note: {
      title: 'Note',
      titleAdd: 'Add Note',
      label: 'Note',
      ph: 'Write your note\u2026',
      save: 'Save note',
      remove: 'Remove note',
    },
    ai: {
      title: 'Ask CAIR',
      ph: 'Ask anything',
      disclaimer: 'AI responses are scoped to this document only',
      ask: 'Ask',
      searching: 'Searching\u2026',
      sources: '{count, plural, one {1 Source} other {# Sources}}',
      readAloud: 'Read aloud',
      stopReading: 'Stop reading',
      newQ: 'New question',
    },
    prefs: {
      title: 'Reader Preferences',
      reset: 'Reset to defaults',
      fontType: 'Font Type',
      fontSize: 'Font Size',
      lineSpacing: 'Line Spacing',
      theme: 'Theme',
      font: {
        inter: { label: 'Inter', sub: 'Sans-serif' },
        times: { label: 'Times New Roman', sub: 'Traditional' },
        opendyslexic: { label: 'OpenDyslexic', sub: 'Accessibility' },
        'arabic-naskh': { label: '\u0646\u0648\u062a\u0648 \u0646\u0633\u062e \u0639\u0631\u0628\u064a', sub: 'Arabic Serif' },
        'arabic-kufi': { label: '\u0643\u0648\u0641\u064a \u0639\u0631\u0628\u064a', sub: 'Arabic Sans' },
        'arabic-muna': { label: 'منى', sub: 'Arabic Naskh' },
      },
      themes: {
        light: 'Light',
        sepia: 'Sepia',
        dark: 'Dark',
      },
    },
    content: {
      title: 'Content',
      close: 'Close',
      toc: 'Table of content',
      bookmarks: 'Bookmarks',
      noBm: 'No bookmarks yet',
      notes: 'Notes',
      noNotes: 'No notes yet',
      continue: 'Continue Reading',
      search: 'Search',
    },
    sel: {
      askAi: 'Ask CAIR',
      bookmark: 'Bookmark',
      note: 'Note',
    },
    dial: {
      search: 'Search',
      askAi: 'Ask AI',
      settings: 'Reader settings',
      translate: 'Translate',
      toc: 'Table of contents',
      save: 'Save bookmark',
      open: 'Open actions menu',
      close: 'Close actions menu',
    },
    audio: {
      play: 'Play',
      pause: 'Pause',
      skipBack: 'Skip back',
      skipFwd: 'Skip forward',
      speed: 'Playback speed',
      progress: 'Audio progress',
    },
    hdr: {
      openContents: 'Open contents',
      chOf: 'Ch {index} of {total}',
      pageOf: 'p. {page} of {total}',
    },
    snack: {
      bmAdded: 'Bookmark added',
      noteSaved: 'Note saved',
    },
  },
  interview: {
    narrator: 'Author/Narrator',
    bornYear: 'b. {year}',
    fieldResearcher: 'Field researcher: {name}',
    recordingDate: 'Recording date: {date}',
    recordingDateLabel: 'Recording date',
    summary: 'Summary',
    details: 'Interview details',
    birthPlace: 'Birthplace',
    placeOfOrigin: 'Place of origin',
    currentAddress: 'Current address',
    recordingPlace: 'Recording place',
    duration: 'Duration',
    durationMin: '{min} min',
    fieldResearcherLabel: 'Field researcher',
    organization: 'Organization',
    supervisingResearcher: 'Supervising researcher',
    audio: 'Audio',
    video: 'Video',
    image: 'Image',
    prevSlide: 'Previous slide',
    nextSlide: 'Next slide',
    transcript: 'TRANSCRIPT',
    transcriptExpand: 'tap to expand',
    transcriptReadTime: '~{min} min read',
    mediaItem: 'Item {index}',
    previewUnavailable: 'Preview unavailable.',
    openFile: 'Open file',
    openFullSize: 'Open full size',
  },
  meta: {
    tab: {
      core: 'General',
      interview: 'Multimedia',
      pricing: 'Pricing & Access',
    },
    field: {
      narratorName: {
        label: 'Narrator Name',
        desc: 'Full name of the narrator / interviewee.',
      },
      narratorImage: {
        label: 'Narrator Image',
        desc: 'Portrait photo shown in the narrator bio header.',
      },
      birthYear: {
        label: 'Birth Year',
        desc: 'Year the narrator was born.',
      },
      birthPlace: {
        label: 'Birthplace',
        desc: 'City or village where the narrator was born.',
      },
      originalTownDistrict: {
        label: 'Original Town / District',
        desc: "The narrator's town or district of origin.",
      },
      recordingPlace: {
        label: 'Recording Place',
        desc: 'Location where the interview was recorded.',
      },
      recordingDate: {
        label: 'Recording Date',
        desc: 'Date the interview was recorded. Stored as YYYY-MM-DD.',
      },
      addressLocation: {
        label: 'Address / Location',
        desc: 'Current address or location of the narrator.',
      },
      recordingDurationMinutes: {
        label: 'Recording Duration (minutes)',
        desc: 'Total length of the recording in minutes.',
      },
      fieldResearcher: {
        label: 'Field Researcher',
        desc: 'Name of the researcher who conducted the interview.',
      },
      supervisingOrganization: {
        label: 'Supervising Organization',
        desc: 'Organization that supervised or commissioned the research.',
      },
      supervisingResearcher: {
        label: 'Supervising Researcher',
        desc: 'Name of the researcher who supervised the field work.',
      },
      title: {
        label: 'Title / Headline',
        desc: 'Entered by Admin or author. If empty, auto-filled by the heading 1 text or the first line of the document.',
      },
      author: {
        label: 'Author / Byline',
        desc: "The name of the author or source. Entered by Admin or author, initially auto-filled by the author's name from the publishing system or document.",
      },
      authorAvatar: {
        label: 'Author Photo',
        desc: "Photo of the author. Upload an image to display alongside the author's name.",
      },
      publicationDate: {
        label: 'Date of Publication',
        desc: 'The date the item was originally published. Entered by Admin or author.',
      },
      summary: {
        label: 'Summary / Abstract',
        desc: 'A short summary of the content. Can be manually created or generated using an AI/LLM. If empty, auto-filled from the first paragraph after the title.',
      },
      creationDate: {
        label: 'Date of Creation',
        desc: 'The system-generated date when the post or document was created.',
      },
      tags: {
        label: 'Tags',
        desc: 'A set of tags or keywords describing the content. Can be completed semi-manually using controlled vocabulary lists. Currently, up to 8 tags for articles and unlimited for assets.',
      },
      documentType: {
        label: 'Document Type',
        desc: 'The curator selects this field from predefined options (e.g., Book, Article, Poem, Letter, Photo, Video, Audio).',
      },
      sourceInstitution: {
        label: 'Source Institution/Publisher',
        desc: 'Manually recorded or system-logged information about the source institution or publisher.',
      },
      rights: {
        label: 'Rights / License',
        desc: "Determined by the project or legal team. If copyrighted, include a link to the publisher's website.",
      },
    },
  },
};

const getTranslation = (language) => {
  return language === ARABIC ? flatten(ar) : flatten(en);
};

const loadPolyfills = async ({
  language
}) => {
  try {
    await Promise.all([polyfillRelativeTimeFormat(language), polyfillPlurals(language)]);
  } catch (e) {
    console.error("loading polyfills:", e);
  }
};
async function polyfillRelativeTimeFormat(locale) {
  if (shouldPolyfill()) {
    await import('@formatjs/intl-relativetimeformat/polyfill');
  }
  if (Intl.RelativeTimeFormat["polyfilled"]) {
    if (locale === ARABIC) {
      await import('@formatjs/intl-relativetimeformat/locale-data/ar');
    } else {
      await import('@formatjs/intl-relativetimeformat/locale-data/en');
    }
  }
}
async function polyfillPlurals(locale) {
  if (shouldPolyfill$1()) {
    await import('@formatjs/intl-pluralrules/polyfill');
  }
  if (Intl.PluralRules["polyfilled"]) {
    if (locale === "ar") {
      await import('@formatjs/intl-pluralrules/locale-data/ar');
    } else {
      await import('@formatjs/intl-pluralrules/locale-data/en');
    }
  }
}

const getLanguageOptions = () => {
  return {
    loadPolyfills,
    shouldPolyfill: () => !!shouldPolyfill$1() || !!shouldPolyfill(),
    getTranslation
  };
};

const I18nProvider = ({
  browserLanguage,
  options,
  children
}) => {
  if (!options) {
    options = localStorage && localStorage.getItem("noLanguageOptions") ? {
      getTranslation: () => ({})
    } : getLanguageOptions();
  }
  const {
    language,
    translations,
    loading
  } = useLanguage(browserLanguage || getBrowserLanguage(), options);
  if (loading) {
    return null;
  }
  const dir = getDirection$1(language);
  if (canUseDOM) {
    const el = document.querySelector(".lang");
    if (el) {
      el.setAttribute("dir", dir);
    }
  }
  return /* @__PURE__ */ jsx(IntlProvider, {
    locale: language,
    messages: translations,
    children: /* @__PURE__ */ jsx("div", {
      className: "lang",
      dir,
      children
    })
  });
};

const useTheme$1 = () => {
  const direction = useDirectionality();
  const primaryMainColor = "#4D4D4D";
  const secondaryMainColor = "#B3B3B3";
  const theme = createMuiTheme$1({
    direction,
    palette: {
      primary: {
        main: primaryMainColor
      },
      secondary: {
        main: secondaryMainColor
      }
    },
    appDrawer: {
      width: 225
    },
    iconSize: 35,
    bottomNavSize: 56,
    leftNavSize: 100
  });
  return theme;
};
const useJss = () => {
  const jss = useRef();
  if (!jss.current) {
    jss.current = create({
      plugins: [...jssPreset$1().plugins, rtl()]
    });
  }
  return jss.current;
};
const MuiProvider = ({
  children
}) => {
  const theme = useTheme$1();
  const jss = useJss();
  return /* @__PURE__ */ jsx(StylesProvider, {
    jss,
    children: /* @__PURE__ */ jsx(ThemeProvider, {
      theme,
      children: /* @__PURE__ */ jsx(ThemeProvider$1, {
        theme,
        children
      })
    })
  });
};

const NS_CSS_PREFIX = "nsui-";

const LinkToggle = ({
  children,
  open,
  onClick,
  className,
  ...other
}) => {
  const css_base = NS_CSS_PREFIX + "link-toggle";
  return /* @__PURE__ */ jsxs(LinkToggleWrapper, {
    href: "#",
    onClick,
    className: clsx(css_base, className, {
      [css_base + "--open"]: open,
      [css_base + "--closed"]: !open
    }),
    ...other,
    children: [children, open ? /* @__PURE__ */ jsx(ExpandLess, {}) : /* @__PURE__ */ jsx(ExpandMore$1, {})]
  });
};
const LinkToggleWrapper = styled(Link$1)`
  display: flex;
  align-items: center;
`;

const OpenedContext = createContext({
  opened: {},
  setOpened: () => null
});
const useOpened = (id) => {
  const {
    opened,
    setOpened
  } = useContext(OpenedContext);
  return {
    opened: opened[id],
    setOpened: (v) => setOpened(id, v)
  };
};
const OpenedContextProvider = ({
  children,
  initial
}) => {
  const [opened, setObjectOpened] = useState(initial || {});
  const setOpened = (key, v) => {
    if (typeof v === "function") {
      setObjectOpened((o) => {
        return {
          ...opened,
          [key]: v(opened[key])
        };
      });
      return;
    }
    setObjectOpened({
      ...opened,
      [key]: v
    });
  };
  return /* @__PURE__ */ jsx(OpenedContext.Provider, {
    value: {
      opened,
      setOpened
    },
    children
  });
};

const ContextLinkToggle = ({
  id,
  children
}) => {
  const {
    opened,
    setOpened
  } = useOpened(id);
  const toggle = (e) => {
    e.preventDefault();
    setOpened((v) => {
      return !v;
    });
  };
  return /* @__PURE__ */ jsx(LinkToggle, {
    onClick: toggle,
    open: opened,
    children
  });
};

const InfoBox = ({
  title,
  children,
  component = Content$5,
  ...other
}) => {
  return /* @__PURE__ */ jsx(OpenedContextProvider, {
    initial: {
      body: true
    },
    children: /* @__PURE__ */ jsxs(Alert$1, {
      ...other,
      children: [/* @__PURE__ */ jsxs(AlertTitle$1, {
        children: [/* @__PURE__ */ jsx("h2", {
          children: title
        }), /* @__PURE__ */ jsx(ContextLinkToggle, {
          id: "body"
        })]
      }), /* @__PURE__ */ jsx(InfoContent, {
        id: "body",
        component,
        children
      })]
    })
  });
};
const Alert$1 = styled.div`
    --info-color: 130 90% 96%;
    --ns-bg-opacity: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: hsla(var(--info-color) / var(--ns-bg-opacity,1));
    padding: 1rem;
    border-radius: var(--rounded-box,1rem);
`;
const AlertTitle$1 = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  & > h4 {
    margin: 0;
  }
`;
const Content$5 = styled.div`
  padding: 1rem;
`;
const InfoContent = ({
  id,
  children,
  component: Component = Content$5
}) => {
  const {
    opened
  } = useOpened(id);
  if (!opened) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Component, {
    children: [" ", children, " "]
  });
};

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = React__default.createContext && /*#__PURE__*/React__default.createContext(DefaultContext);

var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty$1(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$1(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function Tree2Element(tree) {
  return tree && tree.map((node, i) => /*#__PURE__*/React__default.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  return props => /*#__PURE__*/React__default.createElement(IconBase, _extends$1({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = conf => {
    var {
        attr,
        size,
        title
      } = props,
      svgProps = _objectWithoutProperties$1(props, _excluded);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return /*#__PURE__*/React__default.createElement("svg", _extends$1({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /*#__PURE__*/React__default.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? /*#__PURE__*/React__default.createElement(IconContext.Consumer, null, conf => elem(conf)) : elem(DefaultContext);
}

// THIS FILE IS AUTO GENERATED
function FiChevronsRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"polyline","attr":{"points":"13 17 18 12 13 7"},"child":[]},{"tag":"polyline","attr":{"points":"6 17 11 12 6 7"},"child":[]}]})(props);
}function FiDownload (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"},"child":[]},{"tag":"polyline","attr":{"points":"7 10 12 15 17 10"},"child":[]},{"tag":"line","attr":{"x1":"12","y1":"15","x2":"12","y2":"3"},"child":[]}]})(props);
}function FiFileText (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"},"child":[]},{"tag":"polyline","attr":{"points":"14 2 14 8 20 8"},"child":[]},{"tag":"line","attr":{"x1":"16","y1":"13","x2":"8","y2":"13"},"child":[]},{"tag":"line","attr":{"x1":"16","y1":"17","x2":"8","y2":"17"},"child":[]},{"tag":"polyline","attr":{"points":"10 9 9 9 8 9"},"child":[]}]})(props);
}function FiMaximize2 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"polyline","attr":{"points":"15 3 21 3 21 9"},"child":[]},{"tag":"polyline","attr":{"points":"9 21 3 21 3 15"},"child":[]},{"tag":"line","attr":{"x1":"21","y1":"3","x2":"14","y2":"10"},"child":[]},{"tag":"line","attr":{"x1":"3","y1":"21","x2":"10","y2":"14"},"child":[]}]})(props);
}function FiMinimize2 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"polyline","attr":{"points":"4 14 10 14 10 20"},"child":[]},{"tag":"polyline","attr":{"points":"20 10 14 10 14 4"},"child":[]},{"tag":"line","attr":{"x1":"14","y1":"10","x2":"21","y2":"3"},"child":[]},{"tag":"line","attr":{"x1":"3","y1":"21","x2":"10","y2":"14"},"child":[]}]})(props);
}function FiThumbsDown (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"},"child":[]}]})(props);
}function FiThumbsUp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"},"child":[]}]})(props);
}

// THIS FILE IS AUTO GENERATED
function RiArrowDropDownFill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M12 14L8 10H16L12 14Z"},"child":[]}]})(props);
}function RiArrowDropRightFill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M14 12L10 16V8L14 12Z"},"child":[]}]})(props);
}function RiPlayListAddLine (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M2 18H12V20H2V18ZM2 11H22V13H2V11ZM2 4H22V6H2V4ZM18 18V15H20V18H23V20H20V23H18V20H15V18H18Z"},"child":[]}]})(props);
}function RiScales3Fill (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"currentColor"},"child":[{"tag":"path","attr":{"d":"M12.9985 2L12.9979 3.278L17.9985 4.94591L21.631 3.73509L22.2634 5.63246L19.2319 6.643L22.3272 15.1549C21.2353 16.2921 19.6996 17 17.9985 17C16.2975 17 14.7618 16.2921 13.6699 15.1549L16.7639 6.643L12.9979 5.387V19H16.9985V21H6.99854V19H10.9979V5.387L7.23192 6.643L10.3272 15.1549C9.23528 16.2921 7.69957 17 5.99854 17C4.2975 17 2.76179 16.2921 1.66992 15.1549L4.76392 6.643L1.73363 5.63246L2.36608 3.73509L5.99854 4.94591L10.9979 3.278L10.9985 2H12.9985ZM17.9985 9.10267L16.5809 13H19.4159L17.9985 9.10267ZM5.99854 9.10267L4.58092 13H7.41592L5.99854 9.10267Z"},"child":[]}]})(props);
}

// THIS FILE IS AUTO GENERATED
function GiArtificialIntelligence (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256.016 17.824C153.28 17.824 68 123.394 68 255.984c0 55.725 15.08 106.68 40.17 147.034 42.033 17.992 95.622 27.594 149.34 27.644 51.828.046 103.59-8.786 145.04-25.588C428.41 364.4 444 312.66 444 255.982c0-132.59-85.25-238.156-187.982-238.158h-.002zm1.746 18.7c80.525 0 145.63 65.072 145.63 145.6 0 80.526-65.105 145.63-145.63 145.63-80.53 0-145.6-65.104-145.6-145.63 0-80.53 65.07-145.6 145.6-145.6zm-27.69 40.02c-2.586 5.774-5.09 11.292-7.52 16.843-.543 1.243-1.193 1.538-2.622 1.636-5.436.377-10.875.927-16.25 1.8-1.77.29-2.69.21-3.723-1.294-3.335-4.866-6.823-9.626-10.352-14.565L167.268 97.3c3.778 5.304 7.298 10.362 10.962 15.315.976 1.318.846 2.18.102 3.567-1.747 3.258-3.268 6.647-4.7 10.058-.835 1.984-.724 4.898-2.126 5.967-1.56 1.19-4.355.774-6.615 1.035-4.747.548-9.5 1.08-14.443 1.64l2.727 27.526c6.937-.78 13.47-1.57 20.017-2.195 1.164-.11 2.92.056 3.503.8 3.262 4.16 6.248 8.535 9.602 13.22l-9.477 21.26 25.057 11.216c3.057-6.812 6.036-13.325 8.89-19.894.658-1.518 1.386-2.035 3.143-2.064 4.032-.066 8.11-.283 12.063-1.02 2.293-.426 3.46-.018 4.757 1.844 3.998 5.74 8.2 11.337 12.386 17.076l16.084-11.722 5.537 9.588-19.986 20.01-24.428-14.034-13.035 23.715c8.287 4.824 16.284 9.48 23.567 13.722-2.152 9.085-4.15 17.682-6.29 26.244-.156.616-1.35 1.37-2.072 1.383-6.587.105-13.18.063-19.77.063h-6.585v26.434c.67.318 1.345.628 2.02.935h26.087c.75 3.174 1.477 6.206 2.182 9.203C235.314 310.028 244.536 311 254 311c15.906 0 31.138-2.728 45.236-7.723-8.264-13.37-6.265-30.49 3.118-41.173 13.284-15.13 36.56-16.175 50.794-2.032 1.167 1.16 2.232 2.366 3.21 3.61C374.897 241.53 386 213.237 386 182.412c0-6.172-.454-12.24-1.314-18.18-.236-.12-.427-.22-.686-.35-.132-.068-.31-.047-.664-.09-4.587 7.96-9.21 15.986-13.56 23.54l-27.532-7.566v-27.21h-27.32v27.24c-9.023 2.44-17.696 4.787-26.645 7.206-4.342-7.55-8.898-15.472-13.47-23.426l-18.232 10.235c-1.31-1.825-2.425-3.512-3.685-5.087-.825-1.03-.648-1.725-.028-2.86 2.178-3.98 4.357-7.992 6.06-12.185.805-1.988 1.693-2.632 3.73-2.81 6.453-.557 12.885-1.36 19.616-2.102-.92-9.32-1.82-18.397-2.72-27.522-6.795.652-13.1 1.22-19.396 1.89-1.49.157-2.1-.388-2.888-1.66-2.787-4.495-5.686-8.944-8.89-13.144-1.16-1.518-1.426-2.46-.63-4.148 2.537-5.387 4.9-10.854 7.393-16.438-8.45-3.774-16.663-7.445-25.068-11.2zm-13.455 42.845c12.335.102 22.195 10.073 22.092 22.337-.105 12.433-10.133 22.24-22.595 22.093-12.426-.145-22.047-10.12-21.908-22.72.134-12.086 10.174-21.814 22.41-21.71zm-45.183 214.63c18.315 0 33.066 14.8 33.066 33.41 0 18.608-14.75 33.437-33.064 33.437-18.315 0-33.036-14.83-33.036-33.437 0-18.61 14.72-33.41 33.034-33.41zm165.334.732a33 33 0 0 1 33 33 33 33 0 0 1-33 33 33 33 0 0 1-33-33 33 33 0 0 1 33-33zm-208.372 96.002v.006c.003 0 .005 0 .008.002l-.008-.008zm.008.008c11.484 13.443 24.29 25.074 38.108 34.586l-7.076-26.303c-10.648-2.343-21.013-5.113-31.032-8.283zm253.89 1.52c-8.87 2.67-17.994 5.016-27.33 7.046l-6.42 23.903c12.14-8.723 23.46-19.12 33.75-30.943v-.004zM179.82 443V443l9.565 35.686c11.31 5.452 23.12 9.55 35.31 12.156l-5.048-43.006c-13.472-1.002-26.797-2.645-39.828-4.838zm154.793.252c-10.124 1.667-20.447 2.983-30.85 3.96l-4.802 40.702c9.11-2.72 17.96-6.292 26.522-10.63l9.133-34.028v-.002l-.002-.002zm-49.77 5.297l-.005.03h.006l-.002-.03zm-.005.03c-9.08.502-18.206.753-27.324.753-6.344-.005-12.686-.126-19.012-.377l5.297 44.72c4.04.377 8.112.503 12.216.503 8.003 0 15.89-.626 23.652-1.905l5.17-43.692z"},"child":[]}]})(props);
}function GiDiscussion (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M165.262 25.154c-38.376 0-73.092 6.462-97.408 16.405-12.159 4.97-21.669 10.834-27.706 16.67-6.036 5.835-8.459 11.144-8.459 16.218 0 5.075 2.423 10.384 8.46 16.219 6.036 5.835 15.546 11.699 27.705 16.67 24.316 9.942 59.032 16.404 97.408 16.404.162 0 .32-.006.482-.006l-38.95 108.504 88.065-112.265c18.283-2.87 34.592-7.232 47.81-12.637 12.16-4.971 21.671-10.835 27.708-16.67 6.037-5.836 8.459-11.144 8.459-16.219 0-5.074-2.422-10.383-8.46-16.219-6.036-5.835-15.548-11.698-27.706-16.67-24.316-9.942-59.032-16.404-97.408-16.404zm183.797 94.815c-38.377 0-73.092 6.462-97.409 16.404-12.158 4.971-21.668 10.835-27.705 16.67-6.036 5.835-8.459 11.144-8.459 16.219 0 5.074 2.423 10.385 8.46 16.22 6.036 5.836 15.546 11.697 27.704 16.668 3.106 1.27 6.387 2.481 9.819 3.631l82.965 105.764-34.2-95.274c12.3 1.47 25.327 2.284 38.825 2.284 38.376 0 73.091-6.462 97.408-16.405 12.158-4.97 21.67-10.832 27.707-16.668 6.036-5.835 8.459-11.146 8.459-16.22 0-5.075-2.423-10.384-8.46-16.219-6.036-5.835-15.548-11.699-27.706-16.67-24.317-9.942-59.032-16.404-97.408-16.404zM96 249c-25.37 0-47 23.91-47 55s21.63 55 47 55 47-23.91 47-55-21.63-55-47-55zm320 0c-25.37 0-47 23.91-47 55s21.63 55 47 55 47-23.91 47-55-21.63-55-47-55zM58.166 363.348c-7.084 8.321-13.03 19.258-17.738 31.812-10.33 27.544-14.433 62.236-15.131 91.84h141.406c-.698-29.604-4.802-64.296-15.13-91.84-4.709-12.554-10.655-23.49-17.739-31.812C123.246 371.9 110.235 377 96 377c-14.235 0-27.246-5.1-37.834-13.652zm320 0c-7.084 8.321-13.03 19.258-17.738 31.812-10.33 27.544-14.433 62.236-15.131 91.84h141.406c-.698-29.604-4.802-64.296-15.13-91.84-4.709-12.554-10.655-23.49-17.739-31.812C443.246 371.9 430.235 377 416 377c-14.235 0-27.246-5.1-37.834-13.652z"},"child":[]}]})(props);
}function GiHamburgerMenu (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M32 96v64h448V96H32zm0 128v64h448v-64H32zm0 128v64h448v-64H32z"},"child":[]}]})(props);
}

const CssLink = ({
  href
}) => /* @__PURE__ */ jsx("link", {
  rel: "stylesheet",
  type: "text/css",
  href
});

const MS_PER_SECOND = 1e3;
const SECS_PER_MIN = 60;
const SECS_PER_HOUR = SECS_PER_MIN * 60;
const SECS_PER_DAY = SECS_PER_HOUR * 24;
const SECS_PER_WEEK = SECS_PER_DAY * 7;
function selectUnit({ from, to, thresholds, unit }) {
  if (typeof from === "string") {
    from = Date.parse(from);
  }
  if (to === void 0) {
    to = Date.now();
  }
  const resolvedThresholds = { ...DEFAULT_THRESHOLDS, ...thresholds };
  const secs = (+from - +to) / MS_PER_SECOND;
  if (Math.abs(secs) < resolvedThresholds.second || unit === "second") {
    return {
      value: Math.round(secs),
      unit: "second"
    };
  }
  const mins = secs / SECS_PER_MIN;
  if (Math.abs(mins) < resolvedThresholds.minute || unit === "minute") {
    return {
      value: Math.round(mins),
      unit: "minute"
    };
  }
  const hours = secs / SECS_PER_HOUR;
  if (Math.abs(hours) < resolvedThresholds.hour || unit === "hour") {
    return {
      value: Math.round(hours),
      unit: "hour"
    };
  }
  const days = secs / SECS_PER_DAY;
  if (Math.abs(days) < resolvedThresholds.day || unit === "day") {
    return {
      value: Math.round(days),
      unit: "day"
    };
  }
  const fromDate = new Date(from);
  const toDate = new Date(to);
  const years = fromDate.getFullYear() - toDate.getFullYear();
  const months = years * 12 + fromDate.getMonth() - toDate.getMonth();
  if (Math.round(Math.abs(months)) > 12 || unit === "year") {
    return {
      value: Math.round(months / 12),
      unit: "year"
    };
  }
  if (Math.round(Math.abs(months)) > 0 || unit === "month") {
    return {
      value: Math.round(months),
      unit: "month"
    };
  }
  const weeks = secs / SECS_PER_WEEK;
  return {
    value: Math.round(weeks),
    unit: "week"
  };
}
const DEFAULT_THRESHOLDS = {
  second: 45,
  minute: 45,
  hour: 22,
  day: 60
};

const RelativeTime = ({
  className,
  value: from,
  unit: hint
}) => {
  if (!from) {
    return /* @__PURE__ */ jsx("div", {
      children: "--"
    });
  }
  const {
    value,
    unit
  } = selectUnit({
    from,
    unit: hint
  });
  const strTime = from && from.toString() || "";
  return /* @__PURE__ */ jsx("time", {
    dateTime: strTime,
    title: strTime,
    className,
    children: /* @__PURE__ */ jsx(FormattedRelativeTime, {
      value,
      unit
    })
  });
};

const baseUrl = (instanceName, instanceNameOverride) => {
  return `${IMAGE_CDN_ROOT}${instanceNameOverride || instanceName}`;
};
const DEFAULT_INSTANCE_NAME = "newssocial.uk";
const IMAGE_CDN_ROOT = "https://newssocial1.imgix.net/";
const FILE_CDN_ROOT = "https://s3.eu-west-2.amazonaws.com";
const CDNImageContext = React__default.createContext({
  cdnRoot: IMAGE_CDN_ROOT,
  instanceName: DEFAULT_INSTANCE_NAME,
  baseUrl(instanceNameOverride) {
    return baseUrl(DEFAULT_INSTANCE_NAME, instanceNameOverride);
  }
});
const useCDNImageContext = () => {
  return useContext(CDNImageContext);
};

const ScaledImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ScaledImageImgix = ({
  className,
  uuid,
  w,
  h,
  crop,
  instanceNameOverride,
  scaleWithContainer,
  component: Wrapper = ScaledImageWrapper,
  onClick
}) => {
  const {
    baseUrl,
    instanceName
  } = useCDNImageContext();
  if (!uuid) {
    return null;
  }
  const fit = crop ? "facearea" : "clip";
  const url = baseUrl(instanceNameOverride) + `/${uuid}?w=${w}&h=${h}&fit=${fit}&facepad=50&auto=format`;
  if (scaleWithContainer) {
    return /* @__PURE__ */ jsx("img", {
      className,
      width: "100%",
      src: url
    });
  }
  if (crop) {
    const style = {
      width: w,
      height: h,
      minWidth: w,
      minHeight: h
    };
    return /* @__PURE__ */ jsx(Wrapper, {
      className,
      style,
      children: /* @__PURE__ */ jsx("img", {
        className,
        width: w,
        height: h,
        src: url,
        style,
        onClick
      })
    });
  }
  return /* @__PURE__ */ jsx(Wrapper, {
    className,
    style: {
      width: w,
      height: h,
      minWidth: w,
      minHeight: h
    },
    children: /* @__PURE__ */ jsx("img", {
      src: url,
      onClick
    })
  });
};

const isLocalhost = () => {
  if (typeof location === "undefined") {
    return false;
  }
  const host = location.host;
  return host.startsWith("localhost") || host.startsWith("192.");
};

const getInstanceHost$4 = () => {
  if (typeof location === "undefined")
    return "";
  const parts = location.hostname.split(".").filter(Boolean);
  return parts.slice(-2).join(".");
};
const getProxyOrigin$3 = () => isLocalhost() ? "http://localhost:3002" : `https://cdn.${getInstanceHost$4()}`;
const ScaledImageProxy = ({
  className,
  uuid,
  w,
  h,
  crop,
  instanceNameOverride,
  scaleWithContainer,
  component: Wrapper = ScaledImageWrapper,
  onClick
}) => {
  if (!uuid) {
    return null;
  }
  const query = crop ? `w=${w}&h=${h}&fit=facearea` : `w=${w}&h=${h}`;
  const url = `${getProxyOrigin$3()}/ua/ip/${uuid}?${query}`;
  if (scaleWithContainer) {
    return /* @__PURE__ */ jsx("img", {
      className,
      width: "100%",
      src: url
    });
  }
  if (crop) {
    const style = {
      width: w,
      height: h,
      minWidth: w,
      minHeight: h
    };
    return /* @__PURE__ */ jsx(Wrapper, {
      className,
      style,
      children: /* @__PURE__ */ jsx("img", {
        className,
        width: w,
        height: h,
        src: url,
        style,
        onClick
      })
    });
  }
  return /* @__PURE__ */ jsx(Wrapper, {
    className,
    style: {
      width: w,
      height: h,
      minWidth: w,
      minHeight: h
    },
    children: /* @__PURE__ */ jsx("img", {
      src: url,
      onClick
    })
  });
};

const DEFAULT_SIZE = 32;
const AvatarWrapper$1 = styled(ScaledImageWrapper)`
  display: inline-flex;
  border-radius: 50%;
  overflow: hidden;
  background-color: #ccc;
`;
const Avatar = ({
  avatar,
  size = DEFAULT_SIZE,
  className
}) => {
  if (avatar) {
    return /* @__PURE__ */ jsx(ScaledImageProxy, {
      className,
      uuid: avatar.uuid,
      w: size,
      h: size,
      crop: true,
      component: AvatarWrapper$1
    });
  }
  return /* @__PURE__ */ jsx(AvatarWrapper$1, {
    className,
    children: /* @__PURE__ */ jsx("div", {
      style: {
        width: size,
        height: size
      }
    })
  });
};

const Wrapper$P = styled(DialogTitle$1)`
    display: flex;
    align-items: center;
    margin: 0;
    padding: ${({
  theme
}) => theme.spacing(2)}px;
    & > .MuiTypography-root {
        margin-right: 24px;
    }
    & > .Dialog-close-button {
        position: absolute;
        right: ${({
  theme
}) => theme.spacing(1)}px;
        top: ${({
  theme
}) => theme.spacing(1)}px;
        color: ${({
  theme
}) => theme.palette.grey[500]};
    }    
`;
const DialogIcon = styled.div`
    margin: 0 5px;
`;
const DialogTitle = (props) => {
  const {
    children,
    icon,
    onClose,
    noTitle,
    ...other
  } = props;
  return /* @__PURE__ */ jsxs(Wrapper$P, {
    disableTypography: true,
    ...other,
    children: [!noTitle && /* @__PURE__ */ jsxs(Fragment, {
      children: [icon, /* @__PURE__ */ jsx(Typography, {
        variant: "h6",
        children
      })]
    }), onClose && /* @__PURE__ */ jsx(IconButton$5, {
      "aria-label": "close",
      className: "Dialog-close-button",
      onClick: (ev) => {
        ev.stopPropagation();
        onClose(ev, "backdropClick");
      },
      children: /* @__PURE__ */ jsx(MdClose, {})
    })]
  });
};

const getColor = (props) => {
  if (props.isDragAccept) {
    return "#00e676";
  }
  if (props.isDragReject) {
    return "#ff1744";
  }
  if (props.isDragActive) {
    return "#2196f3";
  }
  return "#eeeeee";
};
const DropZoneContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${(props) => getColor(props)};
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border .24s ease-in-out;
`;
const DropZoneSection = styled.section`
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
  & > p {
    font-size: 1rem;
  }
  & > em {
    font-size: .8rem;
  }

  & > * {
      margin-bottom: 10px;
  }
`;
const DropZone$1 = (props) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    className,
    children
  } = props;
  return /* @__PURE__ */ jsxs(DropZoneSection, {
    className: clsx("DropZone-section relative", className),
    children: [children, /* @__PURE__ */ jsxs(DropZoneContainer, {
      ...getRootProps({
        isDragActive,
        isDragAccept,
        isDragReject
      }),
      children: [/* @__PURE__ */ jsx("input", {
        ...getInputProps()
      }), /* @__PURE__ */ jsx(FormattedMessage, {
        id: "attachments.drop_here"
      })]
    })]
  });
};

const useStyles$3 = makeStyles$1({
  spinner: {
    color: "#008000",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12
  }
});
const MuiSpinner = ({
  timeout = 3e3,
  visible = true
}) => {
  const classes = useStyles$3();
  const [show, setShow] = useState();
  useEffect(() => {
    if (!visible) {
      return;
    }
    const t = setTimeout(() => setShow(true), timeout);
    return () => clearTimeout(t);
  }, [timeout, visible]);
  if (!show || !visible) {
    return null;
  }
  return /* @__PURE__ */ jsx(CircularProgress, {
    size: 24,
    className: classes.spinner
  });
};

const DEFAULT_SIZES$2 = {
  "(min-width: 768px)": {
    width: 768
  },
  "(min-width: 640px)": {
    width: 640
  },
  "(min-width: 512px)": {
    width: 512
  },
  "(min-width: 320px)": {
    width: 320
  },
  "(max-width: 240px)": {
    width: 240
  }
};
const ImageWrapper$6 = styled.div`
  display: flex;
  justify-content: center;
  & picture {
    display: flex;
    justify-content: center;
  }
`;
const ResponsiveImageImgix = React__default.forwardRef(({
  instanceNameOverride,
  data,
  sizes = DEFAULT_SIZES$2,
  ...other
}, ref) => {
  const {
    instanceName,
    cdnRoot
  } = useCDNImageContext();
  if (!data) {
    return null;
  }
  const {
    uuid
  } = data;
  if (uuid && uuid.startsWith("obs/")) {
    const obsUrl = `https://obs.${instanceNameOverride || instanceName}/${uuid}`;
    return /* @__PURE__ */ jsx(ImageWrapper$6, {
      ref,
      ...other,
      children: /* @__PURE__ */ jsx("img", {
        src: obsUrl
      })
    });
  }
  const sharedProps = {
    src: `${cdnRoot}${instanceNameOverride || instanceName}/${uuid}`,
    fit: "crop",
    faces: true
  };
  return /* @__PURE__ */ jsx(ImageWrapper$6, {
    ref,
    ...other,
    children: /* @__PURE__ */ jsx(Imgix, {
      ...sharedProps,
      type: "picture",
      children: Object.getOwnPropertyNames(sizes).map((media) => /* @__PURE__ */ jsx(Imgix, {
        ...sharedProps,
        width: sizes[media].width,
        height: sizes[media].height,
        type: "source",
        imgProps: {
          media
        }
      }, sharedProps.src))
    })
  });
});

const DEFAULT_SIZES$1 = {
  "(min-width: 768px)": {
    width: 768
  },
  "(min-width: 640px)": {
    width: 640
  },
  "(min-width: 512px)": {
    width: 512
  },
  "(min-width: 320px)": {
    width: 320
  },
  "(max-width: 240px)": {
    width: 240
  }
};
const ImageWrapper$5 = styled.div`
  display: flex;
  justify-content: center;
  & picture {
    display: flex;
    justify-content: center;
  }
`;
const getInstanceHost$3 = () => {
  if (typeof location === "undefined")
    return "";
  const parts = location.hostname.split(".").filter(Boolean);
  return parts.slice(-2).join(".");
};
const getProxyOrigin$2 = () => isLocalhost() ? "http://localhost:3002" : `https://cdn.${getInstanceHost$3()}`;
const ResponsiveImageProxy = React__default.forwardRef(({
  instanceNameOverride,
  data,
  sizes = DEFAULT_SIZES$1,
  ...other
}, ref) => {
  const {
    instanceName,
    cdnRoot
  } = useCDNImageContext();
  if (!data) {
    return null;
  }
  const {
    uuid
  } = data;
  if (uuid && uuid.startsWith("obs/")) {
    const proxyUrl = `${getProxyOrigin$2()}/ua/ip/${uuid}`;
    return /* @__PURE__ */ jsx(ImageWrapper$5, {
      ref,
      ...other,
      children: /* @__PURE__ */ jsx("img", {
        src: proxyUrl
      })
    });
  }
  const sharedProps = {
    src: `${cdnRoot}${instanceNameOverride || instanceName}/${uuid}`,
    fit: "crop",
    faces: true
  };
  return /* @__PURE__ */ jsx(ImageWrapper$5, {
    ref,
    ...other,
    children: /* @__PURE__ */ jsx(Imgix, {
      ...sharedProps,
      type: "picture",
      children: Object.getOwnPropertyNames(sizes).map((media) => /* @__PURE__ */ jsx(Imgix, {
        ...sharedProps,
        width: sizes[media].width,
        height: sizes[media].height,
        type: "source",
        imgProps: {
          media
        }
      }, sharedProps.src))
    })
  });
});

const isMobileWrapper = () => {
  const userAgent = typeof navigator !== "undefined" && navigator.userAgent;
  const isMobile = userAgent && /NewsSocial/i.test(userAgent) || typeof window !== "undefined" && window.isNativeApp;
  return !!isMobile;
};
const isExpoWrapper = () => {
  const isMobile = typeof window !== "undefined" && window.isNativeApp;
  return !!isMobile;
};
const mobileAppOs = () => {
  return typeof window === "undefined" ? "web" : window["mobilePlatform"] || "web";
};
const nsEnvironment = () => {
  return typeof window === "undefined" ? "prod" : window["nsEnvironment"] || "prod";
};

const isStaging = () => {
  if (typeof location === "undefined") {
    return false;
  }
  const host = location.host;
  return host.startsWith("localhost") || host.startsWith("staging") || host.startsWith("192.");
};
const checkDevConsoleAlert = () => {
  if (isStaging()) {
    alert("error adding asset, see stack trace in Dev console");
  }
};
const Staging = ({
  children
}) => {
  if (typeof location === "undefined") {
    return null;
  }
  const host = location.host;
  if (host.startsWith("localhost") || host.startsWith("staging") || host.startsWith("192.")) {
    return /* @__PURE__ */ jsx(Fragment, {
      children
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    children: ["no staging for host:", host]
  });
};
const StyledLink$1 = styled("a")`
margin: 5px 10px;
`;
const PlaygroundLink = ({
  children
}) => {
  const env = nsEnvironment();
  if (env === "prod") {
    return null;
  }
  const url = "/playground/lib";
  return /* @__PURE__ */ jsxs(StyledLink$1, {
    href: url,
    children: ["playground (", url, ")"]
  });
};

const getPersonName = (person = {}, context = {}) => {
  if (!person || typeof person !== "object") {
    return "---";
  }
  const { username, firstname, lastname } = person;
  let name = firstname && lastname ? `${firstname} ${lastname}` : firstname || lastname || username;
  if (context.addUserName && name !== username) {
    name += ` (${username})`;
  }
  if (!name) {
    return "---";
  }
  return name;
};

const EDIT_PROFILE_URL = "profile/public/_edit";
const memberProfileUrl = (user) => "/members/@" + encodeURIComponent(user.username);
const PROFILE_URL = "/profile";
const userOrMeSlug = (user, me) => {
  if (!me || user._id !== me._id) {
    return memberProfileUrl(user);
  }
  return PROFILE_URL;
};

const AuthorName = ({
  author,
  ...other
}) => {
  const displayName = getPersonName(author);
  return /* @__PURE__ */ jsx(AuthorText, {
    ...other,
    children: displayName
  });
};
const AuthorText = styled.span`
  font-size: 14px;
`;

const noop$B = () => null;
const PostInfoContext = React__default.createContext({
  rating: {},
  userVote: {},
  notesInfo: {},
  post: void 0,
  loadPost: () => null,
  loadResponses: () => null,
  event$: {
    emit: noop$B,
    useSubscription: noop$B
  },
  postCircleError: null,
  postError: null,
  profileError: null
});

const usePostInfoContext = () => {
  return useContext(PostInfoContext);
};

const REPLY_POST_EVENT = "REPLY_POST_EVENT";
const EDIT_POST_EVENT = "EDIT_POST_EVENT";
const REQUEST_POST_EVENT = "REQUEST_POST_EVENT";
const SHOW_POST_EVENT = "SHOW_POST_EVENT";

const useFindResponseFn = () => {
  const {
    event$
  } = usePostInfoContext();
  return useCallback((postId) => {
    const ev = {
      type: REQUEST_POST_EVENT,
      postId
    };
    let count = 0;
    return new Promise((resolve, reject) => {
      const test = () => {
        event$.emit(ev);
        count++;
        if (ev.found) {
          resolve(ev);
          return;
        }
        if (count > 30) {
          reject();
          return;
        }
        setTimeout(test, 300);
      };
      test();
    });
  }, []);
};

const useScrollToPostFn = () => {
  const findResponse = useFindResponseFn();
  return useCallback((postId) => {
    return findResponse(postId).then(({
      scrollIntoView
    }) => {
      scrollIntoView();
    });
  }, []);
};

const noops$1 = () => {
};
const PostUpdatesContext = React__default.createContext({
  wasSeen: noops$1,
  postViewData: void 0,
  updated: {},
  refreshResponses: noops$1,
  openReply: () => null,
  openPostEvents$: {
    emit: noops$1,
    useSubscription: noops$1
  }
});
const PostUpdatesContextProvider = ({
  children,
  helper
}) => {
  const {
    updated,
    wasSeen,
    refreshResponses
  } = helper;
  const scrollToPost = useScrollToPostFn();
  const openPostEvents$ = useEventEmitter();
  const openReply = (id) => {
    scrollToPost(id);
  };
  const updatesContext = useMemo(() => ({
    updated,
    wasSeen,
    postViewData: helper,
    refreshResponses,
    openReply,
    openPostEvents$
  }), [updated]);
  return /* @__PURE__ */ jsx(PostUpdatesContext.Provider, {
    value: updatesContext,
    children
  });
};
const usePostUpdatesContext = () => {
  return useContext(PostUpdatesContext);
};
const usePostRefreshResponses = () => {
  return useContext(PostUpdatesContext).refreshResponses;
};

const MsgWrapper = styled.div`
  cursor: pointer;
  padding: 0.5em;
  text-align: center;
  font-size: 0.75em;
  background-color: #eee;
  color: #333;
`;
const Wrapper$O = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5em;
`;
const Disclosure = (props) => {
  const {
    first,
    rest,
    moreLabel,
    lessLabel,
    postId
  } = props;
  const [open, setOpen] = useState(props.open);
  const {
    openPostEvents$
  } = usePostUpdatesContext();
  openPostEvents$.useSubscription(({
    parentPosts
  }) => {
    if (parentPosts[postId]) {
      setOpen(true);
    }
  });
  const id = open ? lessLabel : moreLabel;
  return /* @__PURE__ */ jsxs(Wrapper$O, {
    children: [first, /* @__PURE__ */ jsx(MsgWrapper, {
      onClick: () => setOpen((open2) => !open2),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id,
        defaultMessage: id
      })
    }), /* @__PURE__ */ jsx("div", {
      style: {
        display: open ? "block" : "none"
      },
      children: rest
    })]
  });
};

const MenuContent$1 = ({
  fn,
  target,
  onClick
}) => {
  return /* @__PURE__ */ jsx("div", {
    onClick,
    children: fn(target)
  });
};
const Menu = styled(Menu$1)`
  & .MuiList-padding {
    padding: 0;
  }
  & .MuiMenu-paper {
    border-radius: 0.5em;
  }
`;
const OverflowIcon$3 = styled.div`
  cursor:pointer;
`;
const OverflowMenu = forwardRef((props, ref) => {
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };
  const handleClose = (event) => {
    setAnchorEl(null);
    event.stopPropagation();
  };
  const {
    fn,
    target,
    hidden,
    children,
    contentComponent: Content = MenuContent$1,
    button: Button,
    ...other
  } = props;
  if (hidden) {
    return null;
  }
  const menu = /* @__PURE__ */ jsx(Menu, {
    id: "simple-menu",
    anchorEl,
    keepMounted: false,
    open: Boolean(anchorEl),
    onClose: handleClose,
    children: /* @__PURE__ */ jsx(Content, {
      fn,
      target,
      onClick: handleClose
    })
  });
  if (Button) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Button, {
        ref,
        ...other,
        onClick: handleClick
      }), menu]
    });
  }
  return /* @__PURE__ */ jsxs("span", {
    ref,
    ...other,
    children: [/* @__PURE__ */ jsx(OverflowIcon$3, {
      onClick: handleClick,
      children: children || /* @__PURE__ */ jsx(BiDotsVerticalRounded, {
        size: 28
      })
    }), menu]
  });
});

const CardStyled = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 0.1em;
  margin-bottom: 0.005em;

  ${({
  selected
}) => selected && css$1`
    border: 0.05em solid orange;
  `}
`;
const Card = forwardRef(({
  className,
  children,
  selected,
  ...props
}, ref) => {
  return /* @__PURE__ */ jsx(CardStyled, {
    ref,
    selected,
    className,
    ...props,
    children
  });
});
Card.displayName = "Card";

const TitleContainer = styled.h3`
  overflow: hidden;
  text-overflow: ellipsis;
  margin: ${({
  theme
}) => 0.5 * theme.spacing(1)}px;
  margin-top: 0;
`;
const Title$2 = ({
  value,
  ...other
}) => /* @__PURE__ */ jsx(TitleContainer, {
  ...other,
  children: value || /* @__PURE__ */ jsx(FormattedMessage, {
    id: "general.untitled"
  })
});

const ConfirmDialog = ({
  content,
  children,
  title,
  ...other
}) => {
  const {
    open,
    onClose
  } = other;
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$6, {
    ...other,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: title || "Votes in Circle"
    }), /* @__PURE__ */ jsx(DialogContent, {
      dividers: true,
      children: content
    }), children && /* @__PURE__ */ jsx(DialogActions, {
      children
    })]
  });
};

const GlobalStyles$1 = createGlobalStyle`
.Toastify__toast-container {
    z-index          : 9999;
    -webkit-transform: translate3d(0, 0, 9999px);
    position         : fixed;
    padding          : 4px;
    width            : 320px;
    box-sizing       : border-box;
    color            : #fff;
  }

  .Toastify__toast-container--top-left {
    top : 1em;
    left: 1em;
  }

  .Toastify__toast-container--top-center {
    top      : 1em;
    left     : 50%;
    transform: translateX(-50%);
  }

  .Toastify__toast-container--top-right {
    top  : 1em;
    right: 1em;
  }

  .Toastify__toast-container--bottom-left {
    bottom: 1em;
    left  : 1em;
  }

  .Toastify__toast-container--bottom-center {
    bottom   : 1em;
    left     : 50%;
    transform: translateX(-50%);
  }

  .Toastify__toast-container--bottom-right {
    bottom: 1em;
    right : 1em;
  }

  @media only screen and (max-width : 480px) {
    .Toastify__toast-container {
      width  : 100vw;
      padding: 0;
      left   : 0;
      margin : 0;
    }

    .Toastify__toast-container--top-left,
    .Toastify__toast-container--top-center,
    .Toastify__toast-container--top-right {
      top      : 0;
      transform: translateX(0);
    }

    .Toastify__toast-container--bottom-left,
    .Toastify__toast-container--bottom-center,
    .Toastify__toast-container--bottom-right {
      bottom   : 0;
      transform: translateX(0);
    }

    .Toastify__toast-container--rtl {
      right: 0;
      left : initial;
    }
  }

  .Toastify__toast {
    position       : relative;
    min-height     : 64px;
    box-sizing     : border-box;
    margin-bottom  : 1rem;
    padding        : 8px;
    border-radius  : 1px;
    box-shadow     : 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
    display        : -ms-flexbox;
    display        : flex;
    -ms-flex-pack  : justify;
    justify-content: space-between;
    max-height     : 800px;
    overflow       : hidden;
    font-family    : sans-serif;
    cursor         : pointer;
    direction      : ltr;
  }

  .Toastify__toast--rtl {
    direction: rtl;
  }

  .Toastify__toast--dark {
    background: #121212;
    color     : #fff;
  }

  .Toastify__toast--default {
    background: #fff;
    color     : #aaa;
  }

  .Toastify__toast--info {
    background: #3498db;
  }

  .Toastify__toast--success {
    background: #07bc0c;
  }

  .Toastify__toast--warning {
    background: #f1c40f;
  }

  .Toastify__toast--error {
    background: #e74c3c;
  }

  .Toastify__toast-body {
    margin  : auto 0;
    -ms-flex: 1 1 auto;
    flex    : 1 1 auto;
  }

  @media only screen and (max-width : 480px) {
    .Toastify__toast {
      margin-bottom: 0;
    }
  }

  .Toastify__close-button {
    color              : #fff;
    background         : transparent;
    outline            : none;
    border             : none;
    padding            : 0;
    cursor             : pointer;
    opacity            : 0.7;
    transition         : 0.3s ease;
    -ms-flex-item-align: start;
    align-self         : flex-start;
  }

  .Toastify__close-button--default {
    color  : #000;
    opacity: 0.3;
  }

  .Toastify__close-button>svg {
    fill  : currentColor;
    height: 16px;
    width : 14px;
  }

  .Toastify__close-button:hover,
  .Toastify__close-button:focus {
    opacity: 1;
  }

  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1);
    }

    100% {
      transform: scaleX(0);
    }
  }

  .Toastify__progress-bar {
    position        : absolute;
    bottom          : 0;
    left            : 0;
    width           : 100%;
    height          : 5px;
    z-index         : 9999;
    opacity         : 0.7;
    background-color: rgba(255, 255, 255, 0.7);
    transform-origin: left;
  }

  .Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards;
  }

  .Toastify__progress-bar--controlled {
    transition: transform 0.2s;
  }

  .Toastify__progress-bar--rtl {
    right           : 0;
    left            : initial;
    transform-origin: right;
  }

  .Toastify__progress-bar--default {
    background: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  }

  .Toastify__progress-bar--dark {
    background: #bb86fc;
  }

  @keyframes Toastify__bounceInRight {

    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    from {
      opacity  : 0;
      transform: translate3d(3000px, 0, 0);
    }

    60% {
      opacity  : 1;
      transform: translate3d(-25px, 0, 0);
    }

    75% {
      transform: translate3d(10px, 0, 0);
    }

    90% {
      transform: translate3d(-5px, 0, 0);
    }

    to {
      transform: none;
    }
  }

  @keyframes Toastify__bounceOutRight {
    20% {
      opacity  : 1;
      transform: translate3d(-20px, 0, 0);
    }

    to {
      opacity  : 0;
      transform: translate3d(2000px, 0, 0);
    }
  }

  @keyframes Toastify__bounceInLeft {

    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity  : 0;
      transform: translate3d(-3000px, 0, 0);
    }

    60% {
      opacity  : 1;
      transform: translate3d(25px, 0, 0);
    }

    75% {
      transform: translate3d(-10px, 0, 0);
    }

    90% {
      transform: translate3d(5px, 0, 0);
    }

    to {
      transform: none;
    }
  }

  @keyframes Toastify__bounceOutLeft {
    20% {
      opacity  : 1;
      transform: translate3d(20px, 0, 0);
    }

    to {
      opacity  : 0;
      transform: translate3d(-2000px, 0, 0);
    }
  }

  @keyframes Toastify__bounceInUp {

    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    from {
      opacity  : 0;
      transform: translate3d(0, 3000px, 0);
    }

    60% {
      opacity  : 1;
      transform: translate3d(0, -20px, 0);
    }

    75% {
      transform: translate3d(0, 10px, 0);
    }

    90% {
      transform: translate3d(0, -5px, 0);
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0);
    }

    40%,
    45% {
      opacity  : 1;
      transform: translate3d(0, 20px, 0);
    }

    to {
      opacity  : 0;
      transform: translate3d(0, -2000px, 0);
    }
  }

  @keyframes Toastify__bounceInDown {

    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }

    0% {
      opacity  : 0;
      transform: translate3d(0, -3000px, 0);
    }

    60% {
      opacity  : 1;
      transform: translate3d(0, 25px, 0);
    }

    75% {
      transform: translate3d(0, -10px, 0);
    }

    90% {
      transform: translate3d(0, 5px, 0);
    }

    to {
      transform: none;
    }
  }

  @keyframes Toastify__bounceOutDown {
    20% {
      transform: translate3d(0, 10px, 0);
    }

    40%,
    45% {
      opacity  : 1;
      transform: translate3d(0, -20px, 0);
    }

    to {
      opacity  : 0;
      transform: translate3d(0, 2000px, 0);
    }
  }

  .Toastify__bounce-enter--top-left,
  .Toastify__bounce-enter--bottom-left {
    animation-name: Toastify__bounceInLeft;
  }

  .Toastify__bounce-enter--top-right,
  .Toastify__bounce-enter--bottom-right {
    animation-name: Toastify__bounceInRight;
  }

  .Toastify__bounce-enter--top-center {
    animation-name: Toastify__bounceInDown;
  }

  .Toastify__bounce-enter--bottom-center {
    animation-name: Toastify__bounceInUp;
  }

  .Toastify__bounce-exit--top-left,
  .Toastify__bounce-exit--bottom-left {
    animation-name: Toastify__bounceOutLeft;
  }

  .Toastify__bounce-exit--top-right,
  .Toastify__bounce-exit--bottom-right {
    animation-name: Toastify__bounceOutRight;
  }

  .Toastify__bounce-exit--top-center {
    animation-name: Toastify__bounceOutUp;
  }

  .Toastify__bounce-exit--bottom-center {
    animation-name: Toastify__bounceOutDown;
  }

  @keyframes Toastify__zoomIn {
    from {
      opacity  : 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
      opacity: 1;
    }
  }

  @keyframes Toastify__zoomOut {
    from {
      opacity: 1;
    }

    50% {
      opacity  : 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }

    to {
      opacity: 0;
    }
  }

  .Toastify__zoom-enter {
    animation-name: Toastify__zoomIn;
  }

  .Toastify__zoom-exit {
    animation-name: Toastify__zoomOut;
  }

  @keyframes Toastify__flipIn {
    from {
      transform                : perspective(400px) rotate3d(1, 0, 0, 90deg);
      animation-timing-function: ease-in;
      opacity                  : 0;
    }

    40% {
      transform                : perspective(400px) rotate3d(1, 0, 0, -20deg);
      animation-timing-function: ease-in;
    }

    60% {
      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
      opacity  : 1;
    }

    80% {
      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    }

    to {
      transform: perspective(400px);
    }
  }

  @keyframes Toastify__flipOut {
    from {
      transform: perspective(400px);
    }

    30% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      opacity  : 1;
    }

    to {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      opacity  : 0;
    }
  }

  .Toastify__flip-enter {
    animation-name: Toastify__flipIn;
  }

  .Toastify__flip-exit {
    animation-name: Toastify__flipOut;
  }

  @keyframes Toastify__slideInRight {
    from {
      transform : translate3d(110%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__slideInLeft {
    from {
      transform : translate3d(-110%, 0, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__slideInUp {
    from {
      transform : translate3d(0, 110%, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__slideInDown {
    from {
      transform : translate3d(0, -110%, 0);
      visibility: visible;
    }

    to {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes Toastify__slideOutRight {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform : translate3d(110%, 0, 0);
    }
  }

  @keyframes Toastify__slideOutLeft {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform : translate3d(-110%, 0, 0);
    }
  }

  @keyframes Toastify__slideOutDown {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform : translate3d(0, 500px, 0);
    }
  }

  @keyframes Toastify__slideOutUp {
    from {
      transform: translate3d(0, 0, 0);
    }

    to {
      visibility: hidden;
      transform : translate3d(0, -500px, 0);
    }
  }

  .Toastify__slide-enter--top-left,
  .Toastify__slide-enter--bottom-left {
    animation-name: Toastify__slideInLeft;
  }

  .Toastify__slide-enter--top-right,
  .Toastify__slide-enter--bottom-right {
    animation-name: Toastify__slideInRight;
  }

  .Toastify__slide-enter--top-center {
    animation-name: Toastify__slideInDown;
  }

  .Toastify__slide-enter--bottom-center {
    animation-name: Toastify__slideInUp;
  }

  .Toastify__slide-exit--top-left,
  .Toastify__slide-exit--bottom-left {
    animation-name: Toastify__slideOutLeft;
  }

  .Toastify__slide-exit--top-right,
  .Toastify__slide-exit--bottom-right {
    animation-name: Toastify__slideOutRight;
  }

  .Toastify__slide-exit--top-center {
    animation-name: Toastify__slideOutUp;
  }

  .Toastify__slide-exit--bottom-center {
    animation-name: Toastify__slideOutDown;
  }
`;

if (typeof window !== "undefined") {
  window["toast"] = toast$1;
}
const toast = canUseDOM ? toast$1 : () => null;
const Toasts = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(GlobalStyles$1, {}), /* @__PURE__ */ jsx(ToastContainer$1, {
      rtl: getDirectionality() === "rtl"
    })]
  });
};

const errorMessage = (e, count = 0) => {
  if (!e) {
    return "<unknown>";
  }
  if (typeof e === "string") {
    try {
      e = JSON.parse(e);
    } catch (err) {
      return e;
    }
  }
  if (e.message) {
    return e.message;
  }
  if (e.errorMessage) {
    return e.errorMessage;
  }
  if (e.error && count < 5) {
    return errorMessage(e.error, count + 1);
  }
  try {
    return JSON.stringify(e);
  } catch (err) {
    return e;
  }
};

class AppError extends Error {
  constructor() {
    super(...arguments);
    this.shown = true;
  }
}
const errorToast = ({
  error,
  message
}) => {
  if (error && error.shown) {
    return error;
  }
  if (typeof error === "object") {
    error.shown = true;
  }
  const fullMessage = message ? `${message}: ${errorMessage(error)}` : errorMessage(error);
  const err = new AppError(fullMessage);
  toast(/* @__PURE__ */ jsx("div", {
    dangerouslySetInnerHTML: {
      __html: fullMessage
    }
  }), {
    type: "error"
  });
  return err;
};
if (typeof window !== "undefined") {
  window.errorToast = errorToast;
}
const noop$A = () => null;
const errorsReported = (f, {
  message = "",
  onFinished = noop$A
} = {}) => {
  const wrapper = (...args) => {
    try {
      const rt = f.apply(globalThis, args);
      if (!rt || !(rt.then && rt.catch)) {
        onFinished();
        return rt;
      }
      return rt.then((v) => {
        onFinished();
        return v;
      }, (error) => {
        errorToast({
          error,
          message
        });
        onFinished();
        throw error;
      });
    } catch (error) {
      onFinished();
      errorToast({
        error,
        message
      });
      throw error;
    }
  };
  return wrapper;
};

const useLoading = (f, { onFinished = () => null, ...opts } = {}) => {
  const [loading, setLoading] = useState();
  const onClick = errorsReported(async (v) => {
    if (loading) {
      return null;
    }
    setLoading(true);
    const rt = await f(v);
    return rt;
  }, {
    ...opts,
    onFinished() {
      setLoading(false);
      onFinished();
    }
  });
  return { onClick, loading };
};

const backgroundColor = (background) => {
  switch (background) {
    case "blue":
      return "#4a90ce";
    case "red":
      return "#ef4444";
  }
  return background;
};
const LoadingButtonStyled = styled(Button)`
  &.MuiButtonBase-root {
    display: flex;
    margin: ${({
  theme
}) => theme.spacing(1)}px 0;
    position: relative;
    background: ${({
  theme,
  background
}) => background ? backgroundColor(background) : theme.palette.secondary.main};
    border-radius: 3px;
    border: 0;
    color: white;
  }

  & .MuiButton-label {
    text-transform: none;
  }

  & .MuiCircularProgress-root {
    color: #4caf50;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -12px;
    margin-left: -12px;    
  }
`;
const LoadingButton = ({
  loading,
  disabled,
  component: Button = LoadingButtonStyled,
  hidden,
  children,
  ...props
}) => {
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Button, {
    color: "primary",
    variant: "contained",
    ...props,
    disabled: disabled || loading,
    children: [loading && /* @__PURE__ */ jsx(CircularProgress, {
      size: 24
    }), children]
  });
};

const noop$z = () => null;
const SearchContext = React__default.createContext({
  filter$: {
    emit: noop$z,
    useSubscription: noop$z
  },
  currentFilterRef: {
    current: ""
  }
});
const useSearchContext = () => {
  const context = useContext(SearchContext);
  return context;
};
const useSearchFilter$1 = () => {
  const {
    currentFilterRef,
    filter$
  } = useSearchContext();
  const [filter, setFilter] = useState(currentFilterRef.current);
  filter$.useSubscription(({
    filter: filter2
  }) => {
    setFilter(filter2);
  });
  return filter;
};
const useSearchContext2 = () => {
  const context = useContext(SearchContext);
  const {
    currentFilterRef,
    filter$
  } = context;
  const [filter, setFilterState] = useState(currentFilterRef.current || "");
  const {
    run: emitFilter
  } = useThrottleFn((filter2) => {
    filter$.emit({
      filter: filter2
    });
  }, {
    wait: 500
  });
  const setFilter = (filter2) => {
    emitFilter(filter2);
    setFilterState(filter2);
  };
  const location = useLocation();
  useEffect(() => {
    setFilter("");
  }, [location.pathname]);
  useUnmount(() => {
    setFilter("");
  });
  const handleChange = useMemoizedFn((e) => {
    const filter2 = e.target.value;
    setFilter(filter2);
  });
  return {
    ...context,
    handleChange,
    filter,
    setFilter
  };
};
const useClearSearchContext = () => {
  const {
    filter$
  } = useSearchContext();
  useUnmount(() => {
    filter$.emit({
      filter: ""
    });
  });
};
const SearchContextProvider = ({
  children
}) => {
  const ref = useRef("");
  const filter$ = useEventEmitter();
  filter$.useSubscription(({
    filter
  }) => {
    ref.current = filter;
  });
  const context = useCreation(() => {
    return {
      filter$,
      currentFilterRef: ref
    };
  }, []);
  return /* @__PURE__ */ jsx(SearchContext.Provider, {
    value: context,
    children
  });
};

const loaded$1 = {};
async function loadJsLibs(urls, reload = false) {
  const libs = urls.filter((url) => !loaded$1[url]);
  if (!libs.length && !reload) {
    return;
  }
  const all = libs.map(async (url) => {
    if (loaded$1[url]) {
      return loaded$1[url];
    }
    const response = await fetch$1(url);
    return await response.text();
  });
  const resolved = await Promise.all(all);
  resolved.forEach((v, i) => {
    const url = libs[i];
    try {
      eval.call(window, v);
      loaded$1[url] = v;
    } catch (e) {
      const message = `error loading ${url}: ${e && e.message}`;
      console.error(e);
      throw new Error(message);
    }
  });
}

const GirlIcon = () => {
  return /* @__PURE__ */ jsx(SvgIcon$2, {
    viewBox: "0 0 213.88 212.9",
    style: {
      fontSize: "4.8em"
    },
    children: /* @__PURE__ */ jsxs("g", {
      id: "OBJECTS",
      children: [/* @__PURE__ */ jsx("path", {
        fill: "#6511bc",
        d: "M150.57,135.29,175.86,213H149l-11.66-27.7S139.31,141.3,150.57,135.29Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#373543",
        d: "M98.87,93.41a17,17,0,0,1-7.66-22.53,1.63,1.63,0,0,1,.11-.23c4.23-9,10.19-21.42,10.19-21.42,13.23-26.77,43-19.82,43-19.82C180.58,37.1,180,69.62,174.21,85.46c-.4,1.07-.84,2.16-1.32,3.22l0,.09a50.85,50.85,0,0,1-4.11,7.88,30.33,30.33,0,0,1-38.94,11.91Q114.23,101.23,98.87,93.41Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#373543",
        d: "M160.33,35.57s-6-36-40.57-23.16-30.08,89.2-61.54,85c0,0,9.61,15.39,31.34,9.18S107.41,23.48,160.33,35.57Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#8028d8",
        d: "M61.64,213h75.68c.24-1.55,1.41-6.29,1.91-9.78,0-.33.08-.67.12-1s.06-.53.1-.78h0l.38-.68.18-.33c3.31-5.86,5.08-9.25,6.22-13.52,3.6-13.48.9-22-.07-30.52.78-3.91,3.54-17.14,4.41-21l-17.28-6.67-3.6-1.39-.21-.08h0l-3.69-1.42-.27-.1a62,62,0,0,0-26.16-4c-.58,0-1.16.07-1.74.13L91,122.3l-.25,0-4.24.38L62,124.88Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#b17f49",
        d: "M86.52,122.69c8,16.16,27.64,34.21,37.7,28.64,6.18-3.42,8.71-14.65,9.08-22.7l-3.61-1.39-.22-.08h0l-3.68-1.41-.28-.11a61.93,61.93,0,0,0-26.15-4l-.91.12-.83.1-6.61.5-.26,0Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M160.51,86.43s7.14-4.48,9,2-8.79,19.84-16.42,12.92Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M157.43,101.71a1.74,1.74,0,1,0,2.23-1A1.74,1.74,0,0,0,157.43,101.71Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M156.68,97.33a.8.8,0,0,0,.92-.27c3.07-4.2,8.87-4.28,8.93-4.28a.75.75,0,0,0,.77-.77.81.81,0,0,0-.82-.76c-.27,0-6.67.06-10.2,4.9a.76.76,0,0,0,.21,1.08Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M162.7,96.81a.86.86,0,0,0,.45,0,.74.74,0,0,0,.58-.91,7.09,7.09,0,0,0-2.06-3.19.82.82,0,0,0-1.13,0,.76.76,0,0,0,0,1.09,5.67,5.67,0,0,1,1.6,2.42A.81.81,0,0,0,162.7,96.81Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M111.2,104.73l-6.67,18.67s6.29,9.8,12.85,12.8,11.75-4.14,11.75-4.14l6.21-17.38Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#fc8664",
        d: "M110.55,106.56,107.88,114c2.75,6.66,10.18,11.33,22.75,13.83l4.05-11.33Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#b17f49",
        d: "M160.93,94.58c-.86,1.73-1.77,3.47-2.75,5.18-6.48,11.38-18.85,21.76-29.34,20.49C106.2,117.53,103.37,98,104.36,84.63c.11-1.48,1.36-2.77,1.63-4.47.66-4,.67-8.88,1.83-13.24.81-3,1.68-6,2.49-8.64a18.23,18.23,0,0,1,16.62-13c11-.39,26.71,1.8,37.66,14.87a18.38,18.38,0,0,1,3.21,17.65A138.36,138.36,0,0,1,160.93,94.58Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M132,94.85a.86.86,0,0,1-.56-1,.85.85,0,0,1,1-.69l3,.52-.18-11.62a.86.86,0,1,1,1.72,0l.22,13.72-5-.89Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#373543",
        d: "M160.17,71.24C167,77.9,161,86.7,162,92.57c.07.38.23.5.49.41a136.68,136.68,0,0,0,7-17.12,18.62,18.62,0,0,0-3.57-18.09c-11.64-13.5-28.16-15.91-39.71-15.64A18.55,18.55,0,0,0,108.9,55.27c-.83,2.72-1.7,5.74-2.52,8.82,1.07,1.29,4.26,2.85,3.62,5.08-1.7,5.91-2.83,10-1.5,10,2.25.14,6-6.4,5.3-11.76,0,0,3-2.38,11.64-2.59A157.41,157.41,0,0,0,148,62.38s4.52-.91,6.81-2.85A18.46,18.46,0,0,0,160.17,71.24Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#373543",
        d: "M146.38,84.69c-.64,1.79-.23,3.57.91,4s2.58-.72,3.22-2.51.24-3.57-.9-4S147,82.9,146.38,84.69Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#373543",
        d: "M124.08,76.72c-.64,1.79-.23,3.58.91,4s2.58-.71,3.22-2.5.24-3.58-.9-4S124.72,74.93,124.08,76.72Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#373543",
        d: "M157,78.9a41.58,41.58,0,0,0-8.32-3.8,1.57,1.57,0,0,0-2.1.93v0a1.4,1.4,0,0,0,1.16,1.48c2.5.68,8.85,3,11.5,4.94a1.61,1.61,0,0,0-.16-1.51A5.22,5.22,0,0,0,157,78.9Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#373543",
        d: "M123.73,67.44a42,42,0,0,1,8.88,2.21,1.56,1.56,0,0,1,1.06,2h0a1.4,1.4,0,0,1-1.82.44c-2.39-1-8.8-3.17-12.08-3.3.06-.46.51-.82,1.06-1.08A5.31,5.31,0,0,1,123.73,67.44Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#fff",
        d: "M139.3,102.92c-1.62,2.63-5.5,7.16-12.26,4.75s-7-7.89-6.42-11.43Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M125.39,112.61a8.38,8.38,0,0,0,4.13.24.84.84,0,0,0,.65-1,.83.83,0,0,0-1-.65h0A6.88,6.88,0,0,1,126,111a7.3,7.3,0,0,1-2.76-2,.85.85,0,1,0-1.31,1.07A9,9,0,0,0,125.39,112.61Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M110.07,68.35s-3.24-9-8.41-5.18S96,83.46,105.55,82.8Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M100.23,81.27a1.75,1.75,0,0,0,1,2.23,1.74,1.74,0,1,0-1-2.23Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M105.37,77.59a.77.77,0,0,1-.49-.76c.35-5-3.72-8.56-3.76-8.59a.74.74,0,0,1-.08-1,.73.73,0,0,1,1-.08c.2.16,4.68,4,4.28,9.83a.75.75,0,0,1-.79.69Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#925f36",
        d: "M101.42,73.58a.76.76,0,0,1-.34-.25.74.74,0,0,1,.14-1,6.84,6.84,0,0,1,3.38-1.17.73.73,0,0,1,.79.68.75.75,0,0,1-.68.8,5.35,5.35,0,0,0-2.59.87A.74.74,0,0,1,101.42,73.58Z"
      }), /* @__PURE__ */ jsx("path", {
        fill: "#6511bc",
        d: "M25.88,213c-.73-.58-.45,9.23-.45,9.22h0c-1-14.67,8.3-39.34,14.78-60.92C44.49,147,50.13,129.78,62,125c2.09,2.45,5.94,12.6,6.2,17.76.64,12.5-2.76,25.08-5.09,32-3.35,10-5.68,22.71-8.74,32.67,0,0,.24,5.52.25,5.53"
      })]
    })
  });
};
const AssistantIcon = ({
  blackAndWite,
  ...other
}) => {
  if (blackAndWite) {
    return /* @__PURE__ */ jsx(BsQuestion, {
      size: "1em",
      ...other
    });
  }
  return /* @__PURE__ */ jsx(GirlIcon, {});
};

const GlobalCss = () => {
  const directionality = useDirectionality();
  const location = useLocation();
  const coreOnly = location.pathname.includes("/posts/post/");
  const rtl = directionality === "rtl";
  if (coreOnly) {
    return /* @__PURE__ */ jsx(GlobalStyleCore, {
      rtl
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(GlobalStyle, {
      rtl
    }), /* @__PURE__ */ jsx(GlobalStyleCore, {
      rtl
    })]
  });
};
const GlobalStyleCore = createGlobalStyle`
* {
  padding: 0;
  margin: 0;
}

@font-face {
  font-family: 'droid_arabic_kufi';
  src: url('/static/fonts/DroidArabicKufi.woff2') format('woff2'),
       url('/static/fonts/DroidArabicKufi.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'MunaOT';
  src: url('/static/fonts/MunaOT-Regular.woff2') format('woff2'),
       url('/static/fonts/MunaOT-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  size-adjust: 160%;
}

@font-face {
  font-family: 'MunaOT';
  src: url('/static/fonts/MunaOT-Bold.woff2') format('woff2'),
       url('/static/fonts/MunaOT-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
  size-adjust: 160%;
}

@import url('https://fonts.googleapis.com/css?family=Noto+Naskh+Arabic');

html, body {
  width: 100%;
  height: 100%;
  overflow: initial;
  padding: 0;
  margin: 0;
  display: flex;
  font-family: ${({
  rtl
}) => rtl ? `'droid_arabic_kufi', 'roboto', 'serif'` : `"Helvetica", sans-serif`} !important;
}

h1:not(.ns *) {
  font-size: 30px;
  line-height: 32px;
}

h2:not(.ns *) {
  font-size: 22px;
  line-height: 28px;
}

h3:not(.ns *) {
  font-size: 16px;
  line-height: 22px;
}

h1:not(.ns *), h2:not(.ns *), h3:not(.ns *) {
  margin-bottom: 1em;
}

body {
  display: flex;
  flex: 1;
  background-color: black;
  overflow: hidden;
}

.root {
  display: flex;
  flex: 1;
}

`;
const GlobalStyle = createGlobalStyle`
body > #root {
  display: flex;
  flex: 1;
}

div[dir=ltr][class=lang]:not(.text-2xs,.text-xs,.text-sm,.text-base,.text-lg,.text-xl,.text-2xl,.text-3xl,.text-4xl,.text-5xl,.text-6xl,.text-7xl,.text-8xl,.text-9xl,.flex,.ns *,.block,.inline,.inline-block) {
  font-size: 16px;
  line-height: 1.2;  /* deliberately unitless */
}

div[dir=ltr][class=lang] *[dir=rtl]:not(.text-2xs,.text-xs,.text-sm,.text-base,.text-lg,.text-xl,.text-2xl,.text-3xl,.text-4xl,.text-5xl,.text-6xl,.text-7xl,.text-8xl,.text-9xl,.flex,.ns *,.block,.inline,.inline-block) {
  line-height: 1.3; /* deliberately unitless */
}

div[dir=rtl][class=lang]:not(.text-2xs,.text-xs,.text-sm,.text-base,.text-lg,.text-xl,.text-2xl,.text-3xl,.text-4xl,.text-5xl,.text-6xl,.text-7xl,.text-8xl,.text-9xl,.flex,.ns *,.block,.inline,.inline-block) {
  font-size: 15px;
}

div[dir=ltr][class=lang] *[dir=ltr]:not(.text-2xs,.text-xs,.text-sm,.text-base,.text-lg,.text-xl,.text-2xl,.text-3xl,.text-4xl,.text-5xl,.text-6xl,.text-7xl,.text-8xl,.text-9xl,.flex,.ns *,.block,.inline,.inline-block) {
  line-height: 1.2;  /* deliberately unitless */
}

a:not(.ns *) {
  cursor: pointer;
  text-decoration: none;
}

a:not(.ns *),a:not(.ns *):visited, a:not(.ns *):hover, a:not(.ns *):active {
  color: inherit;
}

*:not(.ns *):focus {
  outline: none;
}

`;

const useAutoJoinCircleFn = () => {
  const api = useApi();
  return async () => {
    if (localStorage.joinCircle) {
      return api.joinGroup({
        _id: localStorage.joinCircle
      }).then(() => {
        delete localStorage.joinCircle;
      });
    }
  };
};

let onLoginUrl;
let onLogin;
const AUTH_HASH_KEYS = ["state", "token", "pin", "userId"];
const stripAuthHash = (url) => {
  const hashIndex = url.indexOf("#");
  if (hashIndex === -1) {
    return url;
  }
  const base = url.slice(0, hashIndex);
  const hash = url.slice(hashIndex + 1);
  const queryIndex = hash.indexOf("?");
  if (queryIndex === -1) {
    return url;
  }
  const route = hash.slice(0, queryIndex);
  const params = getQueryStringParams(hash.slice(queryIndex + 1));
  AUTH_HASH_KEYS.forEach((key) => delete params[key]);
  const query = object2QueryString(params);
  if (!route && !query) {
    return base;
  }
  return `${base}#${route}${query ? "?" + query : ""}`;
};
const useSetOnLoginUrl = () => {
  onLoginUrl = typeof window !== "undefined" && stripAuthHash(window.location.href);
};
const useSetOnLoginAction = (f) => {
  onLogin = f;
};
const runOnLogin = async (result) => {
  if (onLogin) {
    try {
      return await onLogin(result);
    } finally {
      onLogin = null;
    }
  }
};
const openUrl = (url) => {
  const target = stripAuthHash(url);
  if (stripAuthHash(window.location.href) === target) {
    window.history.replaceState(null, "", target);
    window.location.reload();
    return;
  }
  window.location.href = target;
};
const getLoginUrl = () => {
  return onLoginUrl;
};
const useOnLoginSuccess = () => {
  const autoJoinCircle = useAutoJoinCircleFn();
  return async ({ location = "/", result } = {}) => {
    const action = await runOnLogin(result);
    try {
      await autoJoinCircle();
    } catch (e) {
    }
    if (action && action.handled) {
      onLoginUrl = void 0;
      return;
    }
    if (onLoginUrl) {
      openUrl(onLoginUrl);
      onLoginUrl = void 0;
      return;
    }
    openUrl(location);
  };
};

const AppComponentsContext = createContext({});
const useAppComponents = () => {
  return useContext(AppComponentsContext);
};
const AppComponentsContextProvider = ({
  children,
  ...other
}) => {
  const parentContext = useAppComponents();
  const context = {
    ...parentContext,
    ...other
  };
  return /* @__PURE__ */ jsx(AppComponentsContext.Provider, {
    value: context,
    children
  });
};

const CardIconImpl = ({
  icon: Icon
}) => {
  return /* @__PURE__ */ jsx(Icon, {});
};
const HeaderIcon = ({
  icon
}) => {
  const {
    CardIcon = CardIconImpl
  } = useAppComponents();
  if (!icon) {
    return null;
  }
  return /* @__PURE__ */ jsx(CardIcon, {
    icon
  });
};
const TitleWrapper$3 = styled.span`
  font-size: 16px;
  margin-left: 0.5em;
  margin-right: 0.5em;
`;
const Title$1 = ({
  icon,
  title
}) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(HeaderIcon, {
      icon
    }), /* @__PURE__ */ jsx(TitleWrapper$3, {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: title
      })
    })]
  });
};
const HeaderColumn = styled.div`
  display: flex;
  flex-direction: column; 
`;
const SubtitleWrapper = styled.div`
  padding: 0;
  padding-top: 1.5em;
`;
const HeaderContent = ({
  icon,
  title,
  subtitle
}) => {
  if (!subtitle) {
    return /* @__PURE__ */ jsx(Title$1, {
      icon,
      title
    });
  }
  return /* @__PURE__ */ jsxs(HeaderColumn, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(Title$1, {
        icon,
        title
      })
    }), /* @__PURE__ */ jsx(SubtitleWrapper, {
      children: subtitle
    })]
  });
};
const CardHeader = styled.header`
  display: flex;
  align-items: center;
  padding: 0.5em 1em 0.5em 0;
  margin: 0 0 0.5em 0;
  color: #000000;
  font-size: 14px;
  padding: 0.5em 1em;
`;
const CardBody = styled.div`
  display: flex;
  flex-direction: column;
`;
const CardWithHeader = ({
  className,
  children,
  cardProps = {},
  ...other
}) => /* @__PURE__ */ jsxs(Card, {
  className,
  ...cardProps,
  children: [/* @__PURE__ */ jsx(CardHeader, {
    children: /* @__PURE__ */ jsx(HeaderContent, {
      ...other
    })
  }), /* @__PURE__ */ jsx(CardBody, {
    children
  })]
});

const Wrapper$N = styled.span`
  align-self: center;
  text-align: center;
  margin: 2em;
  color: #4D4D4D;
`;
const ImportantMessage = ({
  i18nKey,
  values,
  className
}) => /* @__PURE__ */ jsx(Wrapper$N, {
  className,
  children: /* @__PURE__ */ jsx(FormattedMessage, {
    id: i18nKey,
    values
  })
});

const Wrapper$M = styled.div`
  display: flex;
  color: #4D4D4D;
  font-size: 0.8em;
  margin: 0.2em;
  height: 1em;
  justify-content: center;
`;
const ErrorMessage = ({
  error,
  errorValues,
  className
}) => /* @__PURE__ */ jsx(Wrapper$M, {
  className,
  children: error ? /* @__PURE__ */ jsx(FormattedMessage, {
    id: error && error.message || error,
    defaultMessage: error && error.message || error,
    values: errorValues ? errorValues : {}
  }) : null
});

const Wrapper$L = styled.div`
  color: #4D4D4D;
  background-color: #f9d2d2;
  padding: 3em;
  margin: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25em;
`;
const ErrorPlaceholder = ({
  error
}) => {
  return /* @__PURE__ */ jsx(Wrapper$L, {
    children: /* @__PURE__ */ jsx(ErrorMessage, {
      error: error || "general.error"
    })
  });
};

const noop$y = () => null;
const RegistrationContext = React__default.createContext({
  pin: null,
  state: "main",
  setState: noop$y,
  userId: null,
  token: null,
  setUserId: noop$y
});
const useRegistrationContext = () => {
  return useContext(RegistrationContext);
};
const MemoryRegistrationContextProvider = ({
  children,
  initialState
}) => {
  const [state, setState] = useState(initialState || "main");
  const [userId, setUserIdRaw] = useState();
  const setUserId = useMemoizedFn((id) => {
    setUserIdRaw(id || void 0);
    if (id) {
      setState("verify");
    }
  });
  const context = useMemo(() => {
    return {
      state,
      setState,
      userId,
      setUserId,
      token: null,
      pin: null
    };
  }, [state, userId]);
  return /* @__PURE__ */ jsx(RegistrationContext.Provider, {
    value: context,
    children
  });
};
const UrlRegistrationContextProvider = ({
  children,
  initialState
}) => {
  const [userId, setUserIdRaw] = useState();
  const params = useQueryStringParams();
  const [token, setToken] = useState();
  const [state, setStateRaw] = useState(initialState || "main");
  const setState = useMemoizedFn((name) => {
    setStateRaw(name);
    setQueryStringParams({
      ...params,
      state: name,
      userId
    });
  });
  const setUserId = useMemoizedFn((id) => {
    setQueryStringParams({
      ...params,
      state: id ? "verify" : state,
      userId: id || void 0
    });
  });
  useEffect(() => {
    const value = params.state || initialState || "main";
    if (value === state) {
      return;
    }
    setStateRaw(value);
  }, [params.state]);
  useEffect(() => {
    const value = params.token || "";
    setToken(value);
  }, [params.token]);
  useEffect(() => {
    const value = params.userId || void 0;
    if (value === state) {
      return;
    }
    setUserIdRaw(value || void 0);
  }, [params.userId]);
  const context = useMemo(() => {
    return {
      state,
      setState,
      userId,
      setUserId,
      token,
      pin: params.pin
    };
  }, [state, userId, token, params.pin]);
  return /* @__PURE__ */ jsx(RegistrationContext.Provider, {
    value: context,
    children
  });
};
const RegistrationContextProvider = ({
  children,
  syncToUrl = true,
  initialState
}) => {
  if (!syncToUrl) {
    return /* @__PURE__ */ jsx(MemoryRegistrationContextProvider, {
      initialState,
      children
    });
  }
  return /* @__PURE__ */ jsx(UrlRegistrationContextProvider, {
    initialState,
    children
  });
};

const noop$x = () => null;
const ToastContext = createContext({
  toasts: [],
  addToast: noop$x,
  removeToast: noop$x,
  clearAllToasts: noop$x
});
const ToastProvider = ({
  children,
  maxToasts = 5
}) => {
  const [toasts, setToasts] = useState([]);
  const addToast = useCallback((toast) => {
    const id = `toast-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    const newToast = {
      ...toast,
      id,
      duration: typeof toast.duration === "number" ? toast.duration : toast.type === "error" ? 8e3 : 5e3
    };
    setToasts((current) => {
      const updated = [newToast, ...current].slice(0, maxToasts);
      return updated;
    });
    if (newToast.duration && newToast.duration > 0) {
      setTimeout(() => {
        removeToast(id);
      }, newToast.duration);
    }
    return id;
  }, [maxToasts]);
  const removeToast = useCallback((id) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);
  const clearAllToasts = useCallback(() => {
    setToasts([]);
  }, []);
  return /* @__PURE__ */ jsx(ToastContext.Provider, {
    value: {
      toasts,
      addToast,
      removeToast,
      clearAllToasts
    },
    children
  });
};
const useToast = () => {
  const context = useContext(ToastContext);
  return context;
};

const useAsyncOperation = (operation, defaultOptions) => {
  const { addToast } = useToast();
  const [state, setState] = useState({
    isLoading: false,
    error: null,
    isSuccess: false,
    data: null
  });
  const [lastOperation, setLastOperation] = useState(null);
  const execute = useMemoizedFn(async (arg, options) => {
    if (!options) {
      options = defaultOptions || {};
    }
    const {
      showSuccessToast = false,
      showErrorToast = true,
      successTitle = "Success",
      errorTitle = "Error",
      onSuccess,
      onError,
      retryable = false
    } = options;
    if (retryable) {
      setLastOperation({ arg, options });
    }
    setState((prev) => ({
      ...prev,
      isLoading: true,
      error: null,
      isSuccess: false
    }));
    try {
      const result = await operation(arg);
      setState((prev) => ({
        ...prev,
        isLoading: false,
        isSuccess: true,
        data: result,
        error: null
      }));
      if (showSuccessToast) {
        const message = typeof showSuccessToast === "string" ? showSuccessToast : "Operation completed successfully";
        addToast({
          type: "success",
          title: successTitle,
          message
        });
      }
      if (onSuccess) {
        onSuccess(result);
      }
      return result;
    } catch (error) {
      const errorObj = error instanceof Error ? error : new Error(String(error));
      setState((prev) => ({
        ...prev,
        isLoading: false,
        error: errorObj,
        isSuccess: false
      }));
      if (showErrorToast) {
        const message = typeof showErrorToast === "string" ? showErrorToast : errorObj.message || "An unexpected error occurred";
        addToast({
          type: "error",
          title: errorTitle,
          message,
          duration: retryable ? 0 : void 0,
          action: retryable ? {
            label: "Retry",
            onClick: () => retry()
          } : void 0
        });
      }
      if (onError) {
        onError(errorObj);
      }
      throw error;
    }
  });
  const retry = useCallback(async () => {
    if (!lastOperation) {
      console.warn("No operation to retry");
      return void 0;
    }
    return execute(lastOperation.arg, lastOperation.options);
  }, [lastOperation, execute]);
  const reset = useCallback(() => {
    setState({
      isLoading: false,
      error: null,
      isSuccess: false,
      data: null
    });
    setLastOperation(null);
  }, []);
  return {
    ...state,
    execute,
    reset,
    retry
  };
};

const OrRuler = () => {
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex items-center justify-center my-4",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex-grow border-t border-gray-300"
    }), /* @__PURE__ */ jsx("span", {
      className: "px-4 text-gray-500",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.or"
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-grow border-t border-gray-300"
    })]
  });
};

const viewport = () => {
  let e = window, a = "inner";
  if (!("innerWidth" in window)) {
    a = "client";
    e = document.documentElement || document.body;
  }
  return {
    width: e[a + "Width"] || 0,
    height: e[a + "Height"] || 0
  };
};

const popupFeatures = ({
  width: screenWidth,
  height: screenHeight
}) => {
  const common = "toolbar=no, menubar=no";
  const width = Math.min(Math.max(screenWidth, 350), 500);
  const left = Math.round(Math.max(screenWidth - width, 0) / 2);
  const height = Math.min(Math.max(screenHeight, 400), 560);
  const top = Math.round(Math.max(screenHeight - height, 0) / 2);
  return `width=${width}, left=${left}, height=${height}, top=${top}, ${common}`;
};

const OAUTH_URL_GOOGLE = "https://accounts.google.com/o/oauth2/auth";
const params2popupUrl = (params) => {
  return OAUTH_URL_GOOGLE + "?" + Object.entries(params).map(([key, value]) => {
    return key + "=" + value;
  }).join("&");
};

const options$1 = {
  scopes: ["https://www.googleapis.com/auth/userinfo.email", "https://www.googleapis.com/auth/userinfo.profile"]
};

const useGoogleAuthHelper = (callback, {
  client_id
}) => {
  const ref = useRef();
  if (!ref.current) {
    ref.current = new GoogleAuthHelper(callback, {
      ...options$1,
      client_id
    });
  }
  useEffect(() => {
    ref.current.listenForAuthReply();
    return () => ref.current.clear();
  }, []);
  return ref.current;
};
const GoogleAuthContext = React__default.createContext({
  access_token: null
});
const GoogleAuthContextProvider = ({
  children,
  ...other
}) => {
  return /* @__PURE__ */ jsx(GoogleAuthContext.Provider, {
    value: other,
    children
  });
};
const useGoogleApiAccessToken = () => {
  return {
    accessToken: useContext(GoogleAuthContext).access_token
  };
};
const REDIRECT = "/gpopup/";
const TYPE = "token";
const redirectUrl = (origin) => {
  if (origin) {
    return origin + REDIRECT;
  }
  return (typeof window !== "undefined" ? window.location.origin : "http://localhost:3000") + REDIRECT;
};
class GoogleAuthHelper {
  constructor(callback, options2) {
    this.callback = callback;
    this.options = options2;
    this.openAccessTokenPopup = (options2) => {
      this.window = window.open(this.popupUrl4AccessToken(options2), "Google Auth", popupFeatures(viewport()));
      this.window.focus();
    };
    this.openOfflinePopup = (options2) => {
      this.window = window.open(this.popupUrl4AOffline(options2), "Google Auth", popupFeatures(viewport()));
      this.window.focus();
    };
    this.updateAuthInfo = (ev) => {
      const newValue = ev.newValue;
      if (ev.key == "__goo" && newValue && this.returnUrlRef !== newValue) {
        this.returnUrlRef = newValue;
        const queryString = newValue.split("?")[1] || newValue.split("#")[1];
        this.result = getQueryStringParams(queryString);
        try {
          this.callback(this.result);
        } finally {
          this.closePopup();
        }
      }
    };
  }
  defaultAccessTokenUrlOptions() {
    const {
      scopes,
      client_id
    } = this.options;
    return {
      scope: scopes.join(" "),
      client_id,
      redirect_uri: redirectUrl(),
      response_type: TYPE
    };
  }
  popupUrl4AccessToken(options2) {
    const params = {
      ...this.defaultAccessTokenUrlOptions(),
      ...options2
    };
    return params2popupUrl(params);
  }
  defaultOfflineOptions() {
    const {
      scopes,
      client_id
    } = this.options;
    return {
      scope: scopes.join(" "),
      client_id,
      redirect_uri: window.location.origin + REDIRECT,
      response_type: "code",
      access_type: "offline"
    };
  }
  popupUrl4AOffline(options2) {
    const params = {
      ...this.defaultOfflineOptions(),
      ...options2
    };
    return params2popupUrl(params);
  }
  closePopup() {
    this.window.close();
  }
  listenForAuthReply() {
    window.addEventListener("storage", this.updateAuthInfo);
  }
  clear() {
    window.removeEventListener("storage", this.updateAuthInfo);
  }
}

const ProfileContext = React__default.createContext({
  profile: void 0,
  instance: void 0,
  error: void 0
});
const useProfileContext = () => {
  return useContext(ProfileContext);
};
const ProfileContextProvider = ({
  children,
  profile,
  instance,
  error
}) => {
  const context = useCreation(() => {
    return {
      profile,
      instance,
      error,
      authenticationRequired: error && (error.response === "authentication_required" || error.status === 401)
    };
  }, [profile, instance, error]);
  return /* @__PURE__ */ jsx(ProfileContext.Provider, {
    value: context,
    children
  });
};

const useToastHelpers = () => {
  const { addToast } = useToast();
  const showSuccess = useCallback((message, title) => {
    return addToast({
      type: "success",
      title: title || "Success",
      message
    });
  }, [addToast]);
  const showError = useCallback((message, title) => {
    return addToast({
      type: "error",
      title: title || "Error",
      message,
      duration: 8e3
    });
  }, [addToast]);
  const showWarning = useCallback((message, title) => {
    return addToast({
      type: "warning",
      title: title || "Warning",
      message
    });
  }, [addToast]);
  const showInfo = useCallback((message, title) => {
    return addToast({
      type: "info",
      title: title || "Info",
      message
    });
  }, [addToast]);
  const showGraphQLErrors = useCallback((errors, title) => {
    const message = errors.length === 1 ? errors[0] : `Multiple errors occurred:
${errors.map((err, i) => `${i + 1}. ${err}`).join("\n")}`;
    return addToast({
      type: "error",
      title: title || "GraphQL Error",
      message,
      duration: 1e4
    });
  }, [addToast]);
  return {
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showGraphQLErrors,
    addToast
  };
};

const GoogleButtonInner = ({
  children,
  client_id,
  className,
  onSuccess
}) => {
  const {
    showError
  } = useToastHelpers();
  const defaultOnSuccess = useOnLoginSuccess();
  const handleSuccess = onSuccess || defaultOnSuccess;
  const join = useAutoJoinCircleFn();
  const api = useApi();
  const handleError = (error) => {
    if (typeof window !== "undefined" && window.errorToast) {
      window.errorToast({
        error
      });
    }
    showError(errorMessage(error));
  };
  const helper = useGoogleAuthHelper(async (result) => {
    try {
      const user = await api.makeRequest({
        path: "/users/_new/google",
        body: result,
        method: "POST"
      });
      try {
        await join();
      } catch (error) {
        console.error(error);
      }
      handleSuccess({
        result: user
      });
    } catch (error) {
      handleError(error);
    }
  }, {
    client_id
  });
  return /* @__PURE__ */ jsxs("button", {
    className,
    onClick: () => helper.openAccessTokenPopup(),
    children: [/* @__PURE__ */ jsx(FaGoogle, {}), children]
  });
};
const GoogleButton = (props) => {
  const {
    instance
  } = useProfileContext();
  if (!instance || !instance.googleClientId) {
    return null;
  }
  const client_id = instance.googleClientId;
  return /* @__PURE__ */ jsx(GoogleButtonInner, {
    ...props,
    client_id
  });
};

const buttonClassName = "border-2 rounded border-gray-500 border-solid flex gap-1 p-3 items-center text-white justify-center";
const colorRed = "bg-[#e93f2e]";
const NewGoogleButton = () => {
  if (isMobileWrapper()) {
    return null;
  }
  return /* @__PURE__ */ jsx(GoogleButton, {
    className: `${buttonClassName} ${colorRed}`,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "registration.continue_with_google"
    })
  });
};

const swrLoadOnce = {
  revalidateOnMount: true,
  revalidateOnFocus: false,
  revalidateOnReconnect: false
};

let counterGlobal = 0;
const execute = (name, data) => {
  if (typeof window === "undefined") {
    return;
  }
  if (!window.ReactNativeWebView) {
    console.warn("Cant't execute:", name, data);
    return;
  }
  const counter = counterGlobal++;
  const message = {
    counter,
    name,
    data
  };
  const th = data && data.__noExecutionTimeout === true ? void 0 : setTimeout(() => {
    if (!window["ReactNativeWebViewResult" + counter]) {
      return;
    }
    window["ReactNativeWebViewResult" + counter].reject(new Error("timeout"));
    delete window["ReactNativeWebViewResult" + counter];
  }, 5e3);
  const result = new Promise((resolveOriginal, rejectOriginal) => {
    const clear = () => {
      clearTimeout(th);
      delete window["ReactNativeWebViewResult" + counter];
    };
    const resolve = (v) => {
      clear();
      resolveOriginal(v);
    };
    const reject = (v) => {
      clear();
      rejectOriginal(v);
    };
    window["ReactNativeWebViewResult" + counter] = {
      resolve,
      reject
    };
  });
  window.ReactNativeWebView.postMessage(JSON.stringify(message));
  return result;
};

const getDeviceState = () => execute("getDeviceState");
const promptForPushNotificationsWithUserResponse = () => execute("promptForPushNotificationsWithUserResponse");
const clearOneSignalNotifications = () => execute("clearOneSignalNotifications");
const setNotificationWillShowInForegroundHandler = () => execute("setNotificationWillShowInForegroundHandler");
const setNotificationOpenedHandler = () => execute("setNotificationOpenedHandler");

const logToNative = (data) => execute("logToNative", data);

const mobilePhoneData2Save = async () => {
  if (!isMobileWrapper()) {
    return null;
  }
  const {
    userId: player,
    pushToken: token,
    appId
  } = await getDeviceState();
  return {
    player,
    token,
    appId
  };
};
const useAddMobile = ({
  profile
} = {}) => {
  const api = useApi();
  const result = useSWR(profile ? "add-mobile" : null, async () => {
    if (!isMobileWrapper()) {
      return {
        error: "not in mobile"
      };
    }
    try {
      const mobile = await mobilePhoneData2Save();
      const result2 = await api.makeRequest({
        path: "/users/mobile",
        method: "POST",
        body: mobile
      });
      return result2;
    } catch (error) {
      logToNative({
        message: error.message
      });
    }
  }, swrLoadOnce);
  return result;
};

const biometricAvailability = () => {
  if (!isExpoWrapper()) {
    return Promise.resolve({
      available: false,
      hasCredential: false
    });
  }
  return execute("biometricAvailability");
};
const storeBiometricToken = (refreshToken) => {
  return execute("biometricStoreToken", {
    token: refreshToken
  });
};
const getBiometricToken = () => {
  return execute("biometricGetToken");
};
const clearBiometricToken = () => {
  return execute("biometricClearToken");
};

const useBiometricLogin = () => {
  const api = useApi();
  const onLoginSuccess = useOnLoginSuccess();
  const [available, setAvailable] = useState(false);
  const [hasCredential, setHasCredential] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let cancelled = false;
    biometricAvailability().then(({ available: available2, hasCredential: hasCredential2 }) => {
      if (!cancelled) {
        setAvailable(available2);
        setHasCredential(hasCredential2);
      }
    }).catch(() => {
    });
    return () => {
      cancelled = true;
    };
  }, []);
  const loginWithBiometric = async () => {
    setLoading(true);
    try {
      const { token } = await getBiometricToken();
      if (!token) {
        return;
      }
      const user = await api.refreshSession(token);
      if (user && user.refreshToken) {
        await storeBiometricToken(user.refreshToken).catch(() => {
        });
      }
      await onLoginSuccess({ result: user });
    } catch (e) {
      await clearBiometricToken().catch(() => {
      });
      setHasCredential(false);
      throw e;
    } finally {
      setLoading(false);
    }
  };
  return { available, hasCredential, loading, loginWithBiometric };
};
const enableBiometricForSession = async (refreshToken) => {
  if (!refreshToken) {
    return;
  }
  const { available, hasCredential } = await biometricAvailability().catch(() => ({ available: false, hasCredential: false }));
  if (!available || hasCredential) {
    return;
  }
  await storeBiometricToken(refreshToken).catch(() => {
  });
};

const FEATURE_WHATSAPP_OTP = false;

const TURNSTILE_SITEKEY = "0x4AAAAAAEFSfh6aYO7-7NbH";
const TURNSTILE_ACTION = "otp_request";
const DUMMY_SITEKEYS = ["1x00000000000000000000AA", "2x00000000000000000000AB", "3x00000000000000000000FF"];
const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
const MAX_CHALLENGE_RETRIES = 2;
var loadPromise = null;
const loadTurnstile = () => {
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = new Promise((resolve, reject) => {
    if (typeof window === "undefined" || typeof document === "undefined") {
      reject(new Error("turnstile_no_dom"));
      return;
    }
    const existing = window.turnstile;
    if (existing) {
      resolve(existing);
      return;
    }
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      const api = window.turnstile;
      if (api) {
        resolve(api);
      } else {
        reject(new Error("turnstile_missing_after_load"));
      }
    };
    script.onerror = () => {
      script.remove();
      reject(new Error("turnstile_script_blocked"));
    };
    document.head.appendChild(script);
  });
  loadPromise.catch(() => {
    loadPromise = null;
  });
  return loadPromise;
};
const useTurnstile = (visible) => {
  const enabled = Boolean(TURNSTILE_SITEKEY);
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);
  const retriesRef = useRef(0);
  const [token, setToken] = useState("");
  const [blocked, setBlocked] = useState(false);
  const [armed, setArmed] = useState(false);
  useEffect(() => {
    if (visible && !armed) {
      setArmed(true);
    }
  }, [visible, armed]);
  useEffect(() => {
    if (!enabled || !armed) {
      return;
    }
    if (DUMMY_SITEKEYS.indexOf(TURNSTILE_SITEKEY) !== -1) {
      console.warn("Turnstile: still using Cloudflare's dummy sitekey \u2014 replace TURNSTILE_SITEKEY before enabling enforcement");
    }
    var cancelled = false;
    loadTurnstile().then((api) => {
      if (cancelled || !containerRef.current || widgetIdRef.current) {
        return;
      }
      widgetIdRef.current = api.render(containerRef.current, {
        sitekey: TURNSTILE_SITEKEY,
        action: TURNSTILE_ACTION,
        callback: (value) => {
          retriesRef.current = 0;
          setToken(value);
        },
        "expired-callback": () => setToken(""),
        "error-callback": () => {
          setToken("");
          retriesRef.current += 1;
          if (retriesRef.current > MAX_CHALLENGE_RETRIES) {
            setBlocked(true);
            return;
          }
          if (widgetIdRef.current) {
            api.reset(widgetIdRef.current);
          }
        }
      });
    }).catch((e) => {
      if (!cancelled) {
        console.error("Turnstile failed to load:", e);
        setBlocked(true);
      }
    });
    return () => {
      cancelled = true;
      const api = window.turnstile;
      if (api && widgetIdRef.current) {
        api.remove(widgetIdRef.current);
        widgetIdRef.current = null;
      }
    };
  }, [enabled, armed]);
  const reset = useCallback(() => {
    setToken("");
    const api = window.turnstile;
    if (api && widgetIdRef.current) {
      api.reset(widgetIdRef.current);
    }
  }, []);
  return { enabled, containerRef, token, pending: enabled && armed && !token && !blocked, blocked, reset };
};

const COUNTRY_DIAL_CODES = [
  { iso: "AF", name: "Afghanistan", dial: "93" },
  { iso: "AL", name: "Albania", dial: "355" },
  { iso: "DZ", name: "Algeria", dial: "213" },
  { iso: "AD", name: "Andorra", dial: "376" },
  { iso: "AO", name: "Angola", dial: "244" },
  { iso: "AG", name: "Antigua and Barbuda", dial: "1268" },
  { iso: "AR", name: "Argentina", dial: "54" },
  { iso: "AM", name: "Armenia", dial: "374" },
  { iso: "AU", name: "Australia", dial: "61" },
  { iso: "AT", name: "Austria", dial: "43" },
  { iso: "AZ", name: "Azerbaijan", dial: "994" },
  { iso: "BS", name: "Bahamas", dial: "1242" },
  { iso: "BH", name: "Bahrain", dial: "973" },
  { iso: "BD", name: "Bangladesh", dial: "880" },
  { iso: "BB", name: "Barbados", dial: "1246" },
  { iso: "BY", name: "Belarus", dial: "375" },
  { iso: "BE", name: "Belgium", dial: "32" },
  { iso: "BZ", name: "Belize", dial: "501" },
  { iso: "BJ", name: "Benin", dial: "229" },
  { iso: "BT", name: "Bhutan", dial: "975" },
  { iso: "BO", name: "Bolivia", dial: "591" },
  { iso: "BA", name: "Bosnia and Herzegovina", dial: "387" },
  { iso: "BW", name: "Botswana", dial: "267" },
  { iso: "BR", name: "Brazil", dial: "55" },
  { iso: "BN", name: "Brunei", dial: "673" },
  { iso: "BG", name: "Bulgaria", dial: "359" },
  { iso: "BF", name: "Burkina Faso", dial: "226" },
  { iso: "BI", name: "Burundi", dial: "257" },
  { iso: "KH", name: "Cambodia", dial: "855" },
  { iso: "CM", name: "Cameroon", dial: "237" },
  { iso: "CA", name: "Canada", dial: "1" },
  { iso: "CV", name: "Cape Verde", dial: "238" },
  { iso: "CF", name: "Central African Republic", dial: "236" },
  { iso: "TD", name: "Chad", dial: "235" },
  { iso: "CL", name: "Chile", dial: "56" },
  { iso: "CN", name: "China", dial: "86" },
  { iso: "CO", name: "Colombia", dial: "57" },
  { iso: "KM", name: "Comoros", dial: "269" },
  { iso: "CG", name: "Congo", dial: "242" },
  { iso: "CD", name: "DR Congo", dial: "243" },
  { iso: "CR", name: "Costa Rica", dial: "506" },
  { iso: "CI", name: "Ivory Coast", dial: "225" },
  { iso: "HR", name: "Croatia", dial: "385" },
  { iso: "CU", name: "Cuba", dial: "53" },
  { iso: "CY", name: "Cyprus", dial: "357" },
  { iso: "CZ", name: "Czechia", dial: "420" },
  { iso: "DK", name: "Denmark", dial: "45" },
  { iso: "DJ", name: "Djibouti", dial: "253" },
  { iso: "DM", name: "Dominica", dial: "1767" },
  { iso: "DO", name: "Dominican Republic", dial: "1" },
  { iso: "EC", name: "Ecuador", dial: "593" },
  { iso: "EG", name: "Egypt", dial: "20" },
  { iso: "SV", name: "El Salvador", dial: "503" },
  { iso: "GQ", name: "Equatorial Guinea", dial: "240" },
  { iso: "ER", name: "Eritrea", dial: "291" },
  { iso: "EE", name: "Estonia", dial: "372" },
  { iso: "SZ", name: "Eswatini", dial: "268" },
  { iso: "ET", name: "Ethiopia", dial: "251" },
  { iso: "FJ", name: "Fiji", dial: "679" },
  { iso: "FI", name: "Finland", dial: "358" },
  { iso: "FR", name: "France", dial: "33" },
  { iso: "GA", name: "Gabon", dial: "241" },
  { iso: "GM", name: "Gambia", dial: "220" },
  { iso: "GE", name: "Georgia", dial: "995" },
  { iso: "DE", name: "Germany", dial: "49" },
  { iso: "GH", name: "Ghana", dial: "233" },
  { iso: "GR", name: "Greece", dial: "30" },
  { iso: "GD", name: "Grenada", dial: "1473" },
  { iso: "GT", name: "Guatemala", dial: "502" },
  { iso: "GN", name: "Guinea", dial: "224" },
  { iso: "GW", name: "Guinea-Bissau", dial: "245" },
  { iso: "GY", name: "Guyana", dial: "592" },
  { iso: "HT", name: "Haiti", dial: "509" },
  { iso: "HN", name: "Honduras", dial: "504" },
  { iso: "HK", name: "Hong Kong", dial: "852" },
  { iso: "HU", name: "Hungary", dial: "36" },
  { iso: "IS", name: "Iceland", dial: "354" },
  { iso: "IN", name: "India", dial: "91" },
  { iso: "ID", name: "Indonesia", dial: "62" },
  { iso: "IR", name: "Iran", dial: "98" },
  { iso: "IQ", name: "Iraq", dial: "964" },
  { iso: "IE", name: "Ireland", dial: "353" },
  { iso: "IL", name: "Israel", dial: "972" },
  { iso: "IT", name: "Italy", dial: "39" },
  { iso: "JM", name: "Jamaica", dial: "1" },
  { iso: "JP", name: "Japan", dial: "81" },
  { iso: "JO", name: "Jordan", dial: "962" },
  { iso: "KZ", name: "Kazakhstan", dial: "7" },
  { iso: "KE", name: "Kenya", dial: "254" },
  { iso: "KI", name: "Kiribati", dial: "686" },
  { iso: "XK", name: "Kosovo", dial: "383" },
  { iso: "KW", name: "Kuwait", dial: "965" },
  { iso: "KG", name: "Kyrgyzstan", dial: "996" },
  { iso: "LA", name: "Laos", dial: "856" },
  { iso: "LV", name: "Latvia", dial: "371" },
  { iso: "LB", name: "Lebanon", dial: "961" },
  { iso: "LS", name: "Lesotho", dial: "266" },
  { iso: "LR", name: "Liberia", dial: "231" },
  { iso: "LY", name: "Libya", dial: "218" },
  { iso: "LI", name: "Liechtenstein", dial: "423" },
  { iso: "LT", name: "Lithuania", dial: "370" },
  { iso: "LU", name: "Luxembourg", dial: "352" },
  { iso: "MO", name: "Macau", dial: "853" },
  { iso: "MG", name: "Madagascar", dial: "261" },
  { iso: "MW", name: "Malawi", dial: "265" },
  { iso: "MY", name: "Malaysia", dial: "60" },
  { iso: "MV", name: "Maldives", dial: "960" },
  { iso: "ML", name: "Mali", dial: "223" },
  { iso: "MT", name: "Malta", dial: "356" },
  { iso: "MH", name: "Marshall Islands", dial: "692" },
  { iso: "MR", name: "Mauritania", dial: "222" },
  { iso: "MU", name: "Mauritius", dial: "230" },
  { iso: "MX", name: "Mexico", dial: "52" },
  { iso: "FM", name: "Micronesia", dial: "691" },
  { iso: "MD", name: "Moldova", dial: "373" },
  { iso: "MC", name: "Monaco", dial: "377" },
  { iso: "MN", name: "Mongolia", dial: "976" },
  { iso: "ME", name: "Montenegro", dial: "382" },
  { iso: "MA", name: "Morocco", dial: "212" },
  { iso: "MZ", name: "Mozambique", dial: "258" },
  { iso: "MM", name: "Myanmar", dial: "95" },
  { iso: "NA", name: "Namibia", dial: "264" },
  { iso: "NR", name: "Nauru", dial: "674" },
  { iso: "NP", name: "Nepal", dial: "977" },
  { iso: "NL", name: "Netherlands", dial: "31" },
  { iso: "NZ", name: "New Zealand", dial: "64" },
  { iso: "NI", name: "Nicaragua", dial: "505" },
  { iso: "NE", name: "Niger", dial: "227" },
  { iso: "NG", name: "Nigeria", dial: "234" },
  { iso: "KP", name: "North Korea", dial: "850" },
  { iso: "MK", name: "North Macedonia", dial: "389" },
  { iso: "NO", name: "Norway", dial: "47" },
  { iso: "OM", name: "Oman", dial: "968" },
  { iso: "PK", name: "Pakistan", dial: "92" },
  { iso: "PW", name: "Palau", dial: "680" },
  { iso: "PS", name: "Palestine", dial: "970" },
  { iso: "PA", name: "Panama", dial: "507" },
  { iso: "PG", name: "Papua New Guinea", dial: "675" },
  { iso: "PY", name: "Paraguay", dial: "595" },
  { iso: "PE", name: "Peru", dial: "51" },
  { iso: "PH", name: "Philippines", dial: "63" },
  { iso: "PL", name: "Poland", dial: "48" },
  { iso: "PT", name: "Portugal", dial: "351" },
  { iso: "QA", name: "Qatar", dial: "974" },
  { iso: "RO", name: "Romania", dial: "40" },
  { iso: "RU", name: "Russia", dial: "7" },
  { iso: "RW", name: "Rwanda", dial: "250" },
  { iso: "KN", name: "Saint Kitts and Nevis", dial: "1869" },
  { iso: "LC", name: "Saint Lucia", dial: "1758" },
  { iso: "VC", name: "Saint Vincent and the Grenadines", dial: "1784" },
  { iso: "WS", name: "Samoa", dial: "685" },
  { iso: "SM", name: "San Marino", dial: "378" },
  { iso: "ST", name: "Sao Tome and Principe", dial: "239" },
  { iso: "SA", name: "Saudi Arabia", dial: "966" },
  { iso: "SN", name: "Senegal", dial: "221" },
  { iso: "RS", name: "Serbia", dial: "381" },
  { iso: "SC", name: "Seychelles", dial: "248" },
  { iso: "SL", name: "Sierra Leone", dial: "232" },
  { iso: "SG", name: "Singapore", dial: "65" },
  { iso: "SK", name: "Slovakia", dial: "421" },
  { iso: "SI", name: "Slovenia", dial: "386" },
  { iso: "SB", name: "Solomon Islands", dial: "677" },
  { iso: "SO", name: "Somalia", dial: "252" },
  { iso: "ZA", name: "South Africa", dial: "27" },
  { iso: "KR", name: "South Korea", dial: "82" },
  { iso: "SS", name: "South Sudan", dial: "211" },
  { iso: "ES", name: "Spain", dial: "34" },
  { iso: "LK", name: "Sri Lanka", dial: "94" },
  { iso: "SD", name: "Sudan", dial: "249" },
  { iso: "SR", name: "Suriname", dial: "597" },
  { iso: "SE", name: "Sweden", dial: "46" },
  { iso: "CH", name: "Switzerland", dial: "41" },
  { iso: "SY", name: "Syria", dial: "963" },
  { iso: "TW", name: "Taiwan", dial: "886" },
  { iso: "TJ", name: "Tajikistan", dial: "992" },
  { iso: "TZ", name: "Tanzania", dial: "255" },
  { iso: "TH", name: "Thailand", dial: "66" },
  { iso: "TL", name: "Timor-Leste", dial: "670" },
  { iso: "TG", name: "Togo", dial: "228" },
  { iso: "TO", name: "Tonga", dial: "676" },
  { iso: "TT", name: "Trinidad and Tobago", dial: "1868" },
  { iso: "TN", name: "Tunisia", dial: "216" },
  { iso: "TR", name: "Turkey", dial: "90" },
  { iso: "TM", name: "Turkmenistan", dial: "993" },
  { iso: "TV", name: "Tuvalu", dial: "688" },
  { iso: "UG", name: "Uganda", dial: "256" },
  { iso: "UA", name: "Ukraine", dial: "380" },
  { iso: "AE", name: "United Arab Emirates", dial: "971" },
  { iso: "GB", name: "United Kingdom", dial: "44" },
  { iso: "US", name: "United States", dial: "1" },
  { iso: "UY", name: "Uruguay", dial: "598" },
  { iso: "UZ", name: "Uzbekistan", dial: "998" },
  { iso: "VU", name: "Vanuatu", dial: "678" },
  { iso: "VA", name: "Vatican City", dial: "379" },
  { iso: "VE", name: "Venezuela", dial: "58" },
  { iso: "VN", name: "Vietnam", dial: "84" },
  { iso: "YE", name: "Yemen", dial: "967" },
  { iso: "ZM", name: "Zambia", dial: "260" },
  { iso: "ZW", name: "Zimbabwe", dial: "263" }
];
const findCountry = (iso) => {
  return COUNTRY_DIAL_CODES.find((c) => c.iso === iso);
};
const NSN_RANGES = {
  EG: [10, 10],
  IQ: [10, 10],
  GB: [9, 10],
  US: [10, 10],
  CA: [10, 10],
  DO: [10, 10],
  JM: [10, 10],
  BR: [10, 11],
  SA: [9, 9],
  AE: [8, 9],
  KW: [8, 8],
  QA: [8, 8],
  BH: [8, 8],
  OM: [8, 8],
  JO: [9, 9],
  LB: [7, 8],
  SY: [9, 9],
  YE: [9, 9],
  PS: [9, 9],
  TR: [10, 10],
  IR: [10, 10],
  IN: [10, 10],
  PK: [10, 10],
  BD: [10, 10],
  LK: [9, 9],
  FR: [9, 9],
  DE: [7, 11],
  ES: [9, 9],
  IT: [8, 10],
  NL: [9, 9],
  BE: [8, 9],
  CH: [9, 9],
  PT: [9, 9],
  GR: [10, 10],
  PL: [9, 9],
  RO: [9, 9],
  UA: [9, 9],
  RU: [10, 10],
  KZ: [10, 10],
  MA: [9, 9],
  DZ: [9, 9],
  TN: [8, 8],
  SD: [9, 9],
  ET: [9, 9],
  KE: [9, 9],
  NG: [10, 10],
  GH: [9, 9],
  ZA: [9, 9],
  CN: [11, 11],
  JP: [10, 10],
  KR: [9, 10],
  AU: [9, 9],
  NZ: [8, 10],
  MX: [10, 10]
};
const nationalLengthRange = (country) => {
  return NSN_RANGES[country.iso] || [5, 15 - country.dial.length];
};
const flagEmoji = (iso) => {
  return iso.toUpperCase().split("").map((ch) => String.fromCodePoint(127462 + ch.charCodeAt(0) - 65)).join("");
};
const guessDefaultCountry = (language) => {
  const languages = typeof navigator !== "undefined" && navigator.languages && navigator.languages.length ? navigator.languages : typeof navigator !== "undefined" && navigator.language ? [navigator.language] : [];
  for (const lang of languages) {
    const parts = String(lang).split("-");
    if (parts.length > 1) {
      const region = parts[parts.length - 1].toUpperCase();
      if (findCountry(region)) {
        return region;
      }
    }
  }
  if (language && language.indexOf("ar") === 0) {
    return "IQ";
  }
  return "GB";
};
const toAsciiDigits = (input) => {
  return input.replace(/[٠-٩۰-۹]/g, (ch) => {
    const code = ch.charCodeAt(0);
    if (code >= 1632 && code <= 1641) {
      return String(code - 1632);
    }
    return String(code - 1776);
  });
};
const composeInternationalPhone = (dial, nationalNumber) => {
  const normalized = toAsciiDigits(nationalNumber).trim();
  let international = "";
  if (normalized.indexOf("+") === 0) {
    international = normalized.substring(1).replace(/\D/g, "");
  } else if (normalized.indexOf("00") === 0) {
    international = normalized.substring(2).replace(/\D/g, "");
  }
  if (international && international.indexOf(dial) === 0) {
    const national = international.substring(dial.length).replace(/^0+/, "");
    return `+${dial}${national}`;
  }
  const digits = normalized.replace(/\D/g, "").replace(/^0+/, "");
  return `+${dial}${digits}`;
};

const falsyToString = (value)=>typeof value === "boolean" ? `${value}` : value === 0 ? "0" : value;
const cx = clsx$1;
const cva = (base, config)=>(props)=>{
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return cx(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        const { variants, defaultVariants } = config;
        const getVariantClassNames = Object.keys(variants).map((variant)=>{
            const variantProp = props === null || props === void 0 ? void 0 : props[variant];
            const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param)=>{
            let [key, value] = param;
            if (value === undefined) {
                return acc;
            }
            acc[key] = value;
            return acc;
        }, {});
        const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce((acc, param)=>{
            let { class: cvClass, className: cvClassName, ...compoundVariantOptions } = param;
            return Object.entries(compoundVariantOptions).every((param)=>{
                let [key, value] = param;
                return Array.isArray(value) ? value.includes({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                }[key]) : ({
                    ...defaultVariants,
                    ...propsWithoutUndefined
                })[key] === value;
            }) ? [
                ...acc,
                cvClass,
                cvClassName
            ] : acc;
        }, []);
        return cx(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };

const spinnerVariants = cva("animate-spin", {
  variants: {
    size: {
      xs: "h-3 w-3",
      sm: "h-4 w-4",
      md: "h-5 w-5",
      lg: "h-6 w-6",
      xl: "h-8 w-8"
    },
    colorScheme: {
      current: "text-current",
      white: "text-white",
      green: "text-green-500",
      gray: "text-gray-500",
      blue: "text-blue-500",
      red: "text-red-500"
    }
  },
  defaultVariants: {
    size: "md",
    colorScheme: "current"
  }
});
const Spinner = ({
  className,
  size,
  colorScheme,
  ...props
}) => {
  return /* @__PURE__ */ jsxs("svg", {
    className: spinnerVariants({
      size,
      colorScheme,
      className
    }),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: [/* @__PURE__ */ jsx("circle", {
      className: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      strokeWidth: "4"
    }), /* @__PURE__ */ jsx("path", {
      className: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })]
  });
};

const FloatingPortal = ({
  children,
  id = "floating-portal-root",
  root = null
}) => {
  const [portalElement, setPortalElement] = useState(null);
  useEffect(() => {
    let element;
    if (root) {
      element = root;
    } else {
      element = document.getElementById(id);
      if (!element) {
        element = document.createElement("div");
        element.id = id;
        element.style.position = "fixed";
        element.style.top = "0";
        element.style.left = "0";
        element.style.width = "100%";
        element.style.height = "100%";
        element.style.pointerEvents = "none";
        element.style.zIndex = "10000";
        document.body.appendChild(element);
      }
    }
    setPortalElement(element);
    return () => {
      if (!root && element && element.parentNode) {
        const hasOtherChildren = element.children.length > 0;
        if (!hasOtherChildren) {
          element.parentNode.removeChild(element);
        }
      }
    };
  }, [id, root]);
  if (!portalElement) {
    return null;
  }
  return createPortal(children, portalElement);
};

const tooltipVariants = cva("px-2 py-1 text-sm rounded shadow-lg z-50 max-w-xs break-words", {
  variants: {
    variant: {
      default: "bg-gray-900 text-white",
      light: "bg-white text-gray-900 border border-gray-200",
      error: "bg-red-600 text-white",
      success: "bg-green-600 text-white"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const Tooltip$1 = ({
  content,
  children,
  placement = "top",
  variant,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const timeoutRef = useRef();
  const {
    refs,
    x,
    y,
    strategy
  } = useFloating({
    placement,
    middleware: [offset(8), flip(), shift({
      padding: 8
    })],
    whileElementsMounted: isOpen ? autoUpdate : void 0
  });
  const handleMouseEnter = () => {
    if (disabled || !content)
      return;
    timeoutRef.current = setTimeout(() => setIsOpen(true), 200);
  };
  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsOpen(false);
  };
  if (disabled || !content) {
    return /* @__PURE__ */ jsx(Fragment, {
      children
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("span", {
      ref: refs.setReference,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onFocus: handleMouseEnter,
      onBlur: handleMouseLeave,
      className: "inline-flex",
      children
    }), isOpen && /* @__PURE__ */ jsx(FloatingPortal, {
      children: /* @__PURE__ */ jsx("div", {
        ref: refs.setFloating,
        style: {
          position: strategy,
          top: y || 0,
          left: x || 0,
          pointerEvents: "none"
        },
        className: tooltipVariants({
          variant
        }),
        children: content
      })
    })]
  });
};

const useRipple = () => {
  const [ripples, setRipples] = useState([]);
  const nextKey = useRef(0);
  const createRipple = useMemoizedFn((e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top - size / 2;
    const key = nextKey.current;
    nextKey.current = nextKey.current + 1;
    setRipples((prev) => [...prev, { key, x, y, size }]);
  });
  const removeRipple = useMemoizedFn((key) => {
    setRipples((prev) => prev.filter((r) => r.key !== key));
  });
  return { ripples, createRipple, removeRipple };
};

const actionButtonVariants = cva("overflow-hidden relative inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium transition-colors focus:outline-none disabled:opacity-50 disabled:pointer-events-none", {
  variants: {
    intent: {
      primary: "bg-blue-600 text-white hover:bg-blue-700",
      secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300",
      danger: "bg-red-600 text-white hover:bg-red-700",
      amber: "bg-amber-500 text-white hover:bg-amber-600",
      green: "bg-green-600 text-white hover:bg-green-700",
      white: "bg-white text-black border border-gray-200 hover:bg-gray-50",
      black: "bg-black text-white hover:bg-gray-900",
      whiteOutline: "bg-white text-black border-2 border-black border-solid hover:bg-gray-50",
      blackOutline: "bg-transparent text-black border-2 border-solid border-black hover:bg-black hover:text-white",
      gray: "bg-[#B3B3B3] text-white hover:bg-[#4D4D4D]",
      blue: "bg-[#4a90ce] text-white hover:bg-[#3a80be]",
      red: "bg-[#ef4444] text-white hover:bg-[#dc2626]",
      cairPrimary: "bg-[var(--cair-accent)] text-[var(--cair-accent-foreground)] hover:bg-[var(--cair-accent-hover)] hover:text-white border border-[var(--cair-accent)]",
      cairDefault: "bg-[var(--cair-surface-elevated)] text-[var(--cair-text-secondary)] border border-[var(--cair-border)] hover:bg-[var(--cair-surface-elevated-hover)]",
      cairSubtle: "bg-[var(--cair-accent-subtle)] text-[var(--cair-text-secondary)] border border-[var(--cair-border)] hover:bg-[var(--cair-border)]"
    },
    size: {
      xs: "h-[26px] px-[10px] text-xs",
      sm: "h-9 px-3 text-sm",
      md: "h-10 px-4",
      lg: "h-11 px-8"
    },
    rounded: {
      default: "rounded-md",
      minimal: "rounded-[3px]",
      sm: "rounded-[4px]"
    },
    margin: {
      none: "",
      vertical: "my-2"
    }
  },
  defaultVariants: {
    intent: "primary",
    size: "md",
    rounded: "default",
    margin: "none"
  }
});
const ActionButton = forwardRef(({
  className,
  intent,
  size,
  rounded,
  margin,
  isLoading,
  loadingText,
  leftIcon,
  rightIcon,
  tooltip,
  tooltipPlacement,
  children,
  ...props
}, ref) => {
  const {
    ripples,
    createRipple,
    removeRipple
  } = useRipple();
  const handleClick = useMemoizedFn((e) => {
    if (isLoading) {
      return;
    }
    if (props.onClick) {
      props.onClick(e);
    }
    createRipple(e);
  });
  const button = /* @__PURE__ */ jsxs("button", {
    ref,
    className: actionButtonVariants({
      intent,
      size,
      rounded,
      margin,
      className
    }),
    disabled: isLoading || props.disabled,
    ...props,
    onClick: handleClick,
    children: [ripples.map((ripple) => /* @__PURE__ */ jsx("span", {
      className: "absolute rounded-full bg-white/30 animate-ripple pointer-events-none",
      style: {
        left: ripple.x,
        top: ripple.y,
        width: ripple.size,
        height: ripple.size
      },
      onAnimationEnd: () => removeRipple(ripple.key)
    }, ripple.key)), isLoading ? /* @__PURE__ */ jsx(Spinner, {
      size: size === "sm" ? "xs" : "sm",
      className: "mr-2 shrink-0"
    }) : leftIcon ? /* @__PURE__ */ jsx("span", {
      className: "me-2 inline-flex shrink-0",
      children: leftIcon
    }) : null, isLoading && loadingText ? loadingText : children, rightIcon && !isLoading && /* @__PURE__ */ jsx("span", {
      className: "ms-2 inline-flex shrink-0",
      children: rightIcon
    })]
  });
  if (!tooltip) {
    return button;
  }
  return /* @__PURE__ */ jsx(Tooltip$1, {
    content: tooltip,
    placement: tooltipPlacement || "top",
    children: button
  });
});
ActionButton.displayName = "ActionButton";

const LoadingButtonTW = ({
  loading,
  disabled,
  component: CustomComponent,
  hidden,
  children,
  background,
  ...props
}) => {
  if (hidden) {
    return null;
  }
  const intent = background || "gray";
  if (CustomComponent) {
    return /* @__PURE__ */ jsx(CustomComponent, {
      disabled: disabled || loading,
      isLoading: loading,
      ...props,
      children
    });
  }
  return /* @__PURE__ */ jsx(ActionButton, {
    intent,
    size: "md",
    rounded: "minimal",
    margin: "vertical",
    isLoading: loading,
    disabled: disabled || loading,
    ...props,
    children
  });
};

const textInputVariants = cva("w-full px-3 py-2 border rounded-md text-sm transition-colors focus:outline-none focus:ring-2 focus:border-transparent", {
  variants: {
    variant: {
      default: "border-gray-300 focus:ring-blue-500",
      error: "border-red-300 focus:ring-red-500",
      success: "border-green-300 focus:ring-green-500"
    },
    size: {
      sm: "px-2 py-1 text-xs",
      md: "px-3 py-2 text-sm",
      lg: "px-4 py-3 text-base"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
});
const TextInput = forwardRef(({
  className,
  variant,
  size,
  label,
  helperText,
  error,
  ...props
}, ref) => {
  const inputVariant = error ? "error" : variant;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-1 w-full",
    children: [label && /* @__PURE__ */ jsx("label", {
      className: "text-sm font-medium text-gray-700",
      children: label
    }), /* @__PURE__ */ jsx("input", {
      ref,
      className: textInputVariants({
        variant: inputVariant,
        size,
        className
      }),
      ...props
    }), (helperText || error) && /* @__PURE__ */ jsx("span", {
      className: `text-xs ${error ? "text-red-500" : "text-gray-500"}`,
      children: error || helperText
    })]
  });
});
TextInput.displayName = "TextInput";

const RESEND_COOLDOWN_SECONDS = 60;
const OTP_ERROR_KEYS = {
  otp_invalid: "auth.otpInvalid",
  otp_expired: "auth.otpExpired",
  otp_too_many_attempts: "auth.otpTooManyAttempts",
  otp_cooldown: "auth.otpCooldown",
  otp_rate_limited: "auth.otpRateLimited",
  sms_send_failed: "auth.smsSendFailed",
  otp_country_not_supported: "auth.otpCountryNotSupported",
  invalid_phone: "validation_error.invalid_phone_number"
};
const errorKey$2 = (error) => error && OTP_ERROR_KEYS[error.response] || "auth.otpFailed";
const inputClassName = "w-full px-3 py-2 border border-gray-300 rounded-md text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent";
const PhoneOtpFields = () => {
  const api = useApi();
  const intl = useIntl();
  const onLoginSuccess = useOnLoginSuccess();
  const [country, setCountry] = useState(() => guessDefaultCountry(intl.locale));
  const [nationalNumber, setNationalNumber] = useState("");
  const [code, setCode] = useState("");
  const [codeSent, setCodeSent] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  useEffect(() => {
    if (!cooldown) {
      return;
    }
    const timer = setTimeout(() => setCooldown(cooldown - 1), 1e3);
    return () => clearTimeout(timer);
  }, [cooldown]);
  const countries = useMemo(() => {
    let displayNames = null;
    try {
      displayNames = new Intl.DisplayNames([intl.locale], {
        type: "region"
      });
    } catch (e) {
    }
    const localized = COUNTRY_DIAL_CODES.map((c) => {
      let name = c.name;
      if (displayNames) {
        try {
          const translated = displayNames.of(c.iso);
          if (translated && translated !== c.iso) {
            name = translated;
          }
        } catch (e) {
        }
      }
      return {
        ...c,
        name
      };
    });
    return localized.sort((a, b) => a.name.localeCompare(b.name, intl.locale));
  }, [intl.locale]);
  const selected = findCountry(country) || COUNTRY_DIAL_CODES[0];
  const phone = composeInternationalPhone(selected.dial, nationalNumber);
  const nationalDigits = phone.substring(1 + selected.dial.length);
  const [minDigits, maxDigits] = nationalLengthRange(selected);
  const phoneComplete = nationalDigits.length >= minDigits && nationalDigits.length <= maxDigits;
  const turnstile = useTurnstile(Boolean(nationalNumber));
  const captchaReady = !turnstile.enabled || Boolean(turnstile.token) || turnstile.blocked;
  const request = useAsyncOperation(async (channel) => {
    try {
      await api.requestPhoneOtp(phone, channel === "whatsapp" ? "whatsapp" : "sms", turnstile.token);
    } finally {
      turnstile.reset();
    }
    setCodeSent(true);
    setCooldown(RESEND_COOLDOWN_SECONDS);
  }, {
    showErrorToast: false
  });
  const verify = useAsyncOperation(async () => {
    const mobile = await mobilePhoneData2Save();
    const user = await api.verifyPhoneOtp({
      phone,
      code: toAsciiDigits(code).trim(),
      mobiles: mobile ? [mobile] : null,
      dial: selected.dial
    });
    await enableBiometricForSession(user.refreshToken);
    await onLoginSuccess({
      result: user
    });
  }, {
    showErrorToast: false
  });
  const error = verify.error || request.error;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-1 w-full",
      children: [/* @__PURE__ */ jsx("label", {
        className: "text-sm font-medium text-gray-700",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.country"
        })
      }), /* @__PURE__ */ jsx("select", {
        className: `${inputClassName} bg-white`,
        value: country,
        onChange: (e) => setCountry(e.target.value),
        disabled: codeSent,
        children: countries.map((c) => /* @__PURE__ */ jsxs("option", {
          value: c.iso,
          children: [flagEmoji(c.iso), " ", c.name, " (+", c.dial, ")"]
        }, c.iso))
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-1 w-full",
      children: [/* @__PURE__ */ jsx("label", {
        className: "text-sm font-medium text-gray-700",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.phone"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full",
        dir: "ltr",
        children: [/* @__PURE__ */ jsxs("span", {
          className: "px-3 py-2 border border-gray-300 border-r-0 rounded-md rounded-r-none bg-gray-50 text-sm text-gray-600 whitespace-nowrap select-none",
          children: ["+", selected.dial]
        }), /* @__PURE__ */ jsx("input", {
          type: "tel",
          className: `${inputClassName} rounded-l-none`,
          value: nationalNumber,
          onChange: (e) => setNationalNumber(e.target.value),
          disabled: codeSent
        })]
      })]
    }), nationalNumber && !phoneComplete && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm",
      children: minDigits === maxDigits ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.phoneLengthExact",
        values: {
          n: minDigits
        }
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.phoneLengthRange",
        values: {
          min: minDigits,
          max: maxDigits
        }
      })
    }), !codeSent && phoneComplete && /* @__PURE__ */ jsx("div", {
      className: "text-xs text-gray-500 w-full",
      dir: "ltr",
      children: phone
    }), codeSent && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "text-sm text-gray-600",
        children: [/* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.codeSent"
        }), " ", /* @__PURE__ */ jsx("span", {
          dir: "ltr",
          children: phone
        })]
      }), /* @__PURE__ */ jsx(TextInput, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.enterCode"
        }),
        type: "text",
        value: code,
        onChange: (e) => setCode(e.target.value)
      })]
    }), turnstile.enabled && /* @__PURE__ */ jsxs("div", {
      className: "w-full flex flex-col items-center gap-1",
      children: [/* @__PURE__ */ jsx("div", {
        ref: turnstile.containerRef
      }), turnstile.pending && /* @__PURE__ */ jsx("div", {
        className: "text-xs text-gray-500",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.otpCaptchaPending"
        })
      })]
    }), error && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: errorKey$2(error)
      })
    }), !codeSent ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
        background: "primary",
        loading: request.isLoading,
        disabled: !phoneComplete || !captchaReady,
        onClick: () => request.execute(),
        className: "w-full",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: request.isLoading ? "auth.sendingCode" : "auth.sendCode"
        })
      }), FEATURE_WHATSAPP_OTP ]
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
        background: "primary",
        loading: verify.isLoading,
        disabled: !code,
        onClick: verify.execute,
        className: "w-full",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: verify.isLoading ? "auth.verify2" : "auth.verify"
        })
      }), /* @__PURE__ */ jsx("button", {
        className: "bg-transparent border-none p-0 m-0 text-blue-500 underline hover:text-blue-700 cursor-pointer text-sm disabled:text-gray-400 disabled:no-underline disabled:cursor-default",
        disabled: cooldown > 0 || request.isLoading || !captchaReady,
        onClick: () => {
          verify.reset();
          request.execute();
        },
        children: cooldown > 0 ? /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.resendCodeIn",
          values: {
            seconds: cooldown
          }
        }) : /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.resendCode"
        })
      }), FEATURE_WHATSAPP_OTP , /* @__PURE__ */ jsx("button", {
        className: "bg-transparent border-none p-0 m-0 text-blue-500 underline hover:text-blue-700 cursor-pointer text-sm",
        onClick: () => {
          setCodeSent(false);
          setCode("");
        },
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.changePhone"
        })
      })]
    })]
  });
};
const PhoneOtpForm = () => {
  const {
    state,
    setState
  } = useRegistrationContext();
  return /* @__PURE__ */ jsxs("div", {
    className: `flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto ${state === "phone-otp" ? "flex" : "hidden"}`,
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.continueWithPhone"
      })
    }), /* @__PURE__ */ jsx(PhoneOtpFields, {}), /* @__PURE__ */ jsx("button", {
      className: "bg-transparent border-none p-0 m-0 text-blue-500 underline hover:text-blue-700 cursor-pointer",
      onClick: () => setState("login"),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.alreadyHaveAccount"
      })
    })]
  });
};

const BiometricLoginButton = () => {
  const {
    available,
    hasCredential,
    loading,
    loginWithBiometric
  } = useBiometricLogin();
  const [failed, setFailed] = useState(false);
  if (!available || !hasCredential) {
    return null;
  }
  const onClick = async () => {
    setFailed(false);
    try {
      await loginWithBiometric();
    } catch (e) {
      setFailed(true);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
      background: "secondary",
      loading,
      onClick,
      className: "w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.biometricLogin"
      })
    }), failed && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.biometricFailed"
      })
    })]
  });
};

function base64urlToBuffer(b64url) {
  var b64 = b64url.replace(/-/g, "+").replace(/_/g, "/");
  var pad = b64.length % 4 ? 4 - b64.length % 4 : 0;
  for (var p = 0; p < pad; p++) {
    b64 += "=";
  }
  var str = atob(b64);
  var buf = new ArrayBuffer(str.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i < str.length; i++) {
    view[i] = str.charCodeAt(i);
  }
  return buf;
}
function bufferToBase64url(buf) {
  var view = new Uint8Array(buf);
  var str = "";
  for (var i = 0; i < view.length; i++) {
    str += String.fromCharCode(view[i]);
  }
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
async function startRegistration(options) {
  var publicKey = Object.assign({}, options);
  publicKey.challenge = base64urlToBuffer(options.challenge);
  publicKey.user = Object.assign({}, options.user, { id: base64urlToBuffer(options.user.id) });
  if (options.excludeCredentials) {
    publicKey.excludeCredentials = options.excludeCredentials.map(function(c) {
      return Object.assign({}, c, { id: base64urlToBuffer(c.id) });
    });
  }
  var cred = await navigator.credentials.create({ publicKey });
  var response = cred.response;
  var transports = [];
  if (typeof response.getTransports === "function") {
    transports = response.getTransports();
  }
  return {
    id: cred.id,
    rawId: bufferToBase64url(cred.rawId),
    type: cred.type,
    response: {
      clientDataJSON: bufferToBase64url(response.clientDataJSON),
      attestationObject: bufferToBase64url(response.attestationObject),
      transports
    },
    clientExtensionResults: typeof cred.getClientExtensionResults === "function" ? cred.getClientExtensionResults() : {}
  };
}
async function startAuthentication(options) {
  var publicKey = Object.assign({}, options);
  publicKey.challenge = base64urlToBuffer(options.challenge);
  if (options.allowCredentials) {
    publicKey.allowCredentials = options.allowCredentials.map(function(c) {
      return Object.assign({}, c, { id: base64urlToBuffer(c.id) });
    });
  }
  var cred = await navigator.credentials.get({ publicKey });
  var response = cred.response;
  var userHandle = response.userHandle ? bufferToBase64url(response.userHandle) : void 0;
  return {
    id: cred.id,
    rawId: bufferToBase64url(cred.rawId),
    type: cred.type,
    response: {
      clientDataJSON: bufferToBase64url(response.clientDataJSON),
      authenticatorData: bufferToBase64url(response.authenticatorData),
      signature: bufferToBase64url(response.signature),
      userHandle
    },
    clientExtensionResults: typeof cred.getClientExtensionResults === "function" ? cred.getClientExtensionResults() : {}
  };
}

const PasskeyLoginButton = () => {
  const api = useApi();
  const onLoginSuccess = useOnLoginSuccess();
  const [show, setShow] = useState(false);
  useEffect(() => {
    {
      return;
    }
  }, []);
  const login = useAsyncOperation(async () => {
    try {
      const {
        options,
        challengeId
      } = await api.webauthnLoginOptions();
      const assertion = await startAuthentication(options);
      const user = await api.webauthnLoginVerify({
        challengeId,
        response: assertion
      });
      await onLoginSuccess({
        result: user
      });
    } catch (e) {
      console.error("passkey login failed:", e && e.name, e && e.message, e);
      throw e;
    }
  }, {
    showErrorToast: false
  });
  if (!show) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
      background: "secondary",
      loading: login.isLoading,
      onClick: () => login.execute(),
      className: "w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.passkeyLogin"
      })
    }), login.error && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.passkeyFailed"
      })
    })]
  });
};

const PasswordInput = ({
  label,
  value,
  onChange,
  error,
  className
}) => {
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);
  return /* @__PURE__ */ jsxs("div", {
    className: `flex flex-col gap-1 w-full ${className || ""}`,
    children: [label && /* @__PURE__ */ jsx("label", {
      className: "text-sm text-gray-600",
      children: label
    }), /* @__PURE__ */ jsxs("div", {
      className: "relative",
      children: [/* @__PURE__ */ jsx("input", {
        type: show ? "text" : "password",
        value,
        onChange,
        className: ["w-full px-3 py-2 pr-10 rounded border bg-gray-50 text-sm", "focus:outline-none focus:ring-2 focus:ring-blue-300", error ? "border-red-400" : "border-gray-300"].join(" ")
      }), /* @__PURE__ */ jsx("button", {
        type: "button",
        tabIndex: -1,
        onClick: handleToggle,
        className: "absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600 focus:outline-none",
        children: show ? /* @__PURE__ */ jsx(MdVisibilityOff, {
          size: 18
        }) : /* @__PURE__ */ jsx(MdVisibility, {
          size: 18
        })
      })]
    }), error && /* @__PURE__ */ jsx("span", {
      className: "text-red-500 text-xs",
      children: error
    })]
  });
};

const toggleClassName$1 = (active) => `flex-1 py-2 text-sm font-medium border-none cursor-pointer transition-colors ${active ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-100"}`;
const LoginForm$1 = () => {
  const {
    state,
    setState
  } = useRegistrationContext();
  const api = useApi();
  const onLoginSuccess = useOnLoginSuccess();
  const [method, setMethod] = useState("email");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const submit = useAsyncOperation(async () => {
    const user = await api.loginWithEmail({
      email,
      password
    });
    await onLoginSuccess({
      result: user
    });
  }, {
    showErrorToast: false
  });
  return /* @__PURE__ */ jsxs("div", {
    className: `flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto ${state === "login" || state === "main" ? "flex" : "hidden"}`,
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.login2"
      })
    }), /* @__PURE__ */ jsx(BiometricLoginButton, {}), /* @__PURE__ */ jsx(PasskeyLoginButton, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex w-full rounded-md border border-gray-300 overflow-hidden",
      role: "tablist",
      children: [/* @__PURE__ */ jsx("button", {
        role: "tab",
        "aria-selected": method === "email",
        className: toggleClassName$1(method === "email"),
        onClick: () => setMethod("email"),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.email"
        })
      }), /* @__PURE__ */ jsx("button", {
        role: "tab",
        "aria-selected": method === "phone",
        className: toggleClassName$1(method === "phone"),
        onClick: () => setMethod("phone"),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.phone2"
        })
      })]
    }), method === "email" ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(TextInput, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.email"
        }),
        type: "email",
        value: email,
        onChange: handleEmailChange
      }), /* @__PURE__ */ jsx(PasswordInput, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.password"
        }),
        value: password,
        onChange: handlePasswordChange
      }), /* @__PURE__ */ jsx(LoadingButtonTW, {
        background: "primary",
        loading: submit.isLoading,
        onClick: submit.execute,
        className: "w-full",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: submit.isLoading ? "auth.login3" : "auth.login2"
        })
      }), submit.error && /* @__PURE__ */ jsx("div", {
        className: "text-red-500 text-sm w-full",
        children: submit.error.message || /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.otpFailed"
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "text-blue-500 underline hover:text-blue-700 cursor-pointer",
        onClick: () => setState("forgot"),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.forgot"
        })
      })]
    }) : /* @__PURE__ */ jsx(PhoneOtpFields, {}), /* @__PURE__ */ jsx("button", {
      className: "bg-transparent border-none p-0 m-0 text-blue-500 underline hover:text-blue-700 cursor-pointer",
      onClick: () => setState("register"),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.register2"
      })
    }), /* @__PURE__ */ jsx(OrRuler, {}), /* @__PURE__ */ jsx(NewGoogleButton, {})]
  });
};

const EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
const isValidateEmail = (email) => {
  if (!EMAIL_REGEX.test(email) || /\s/.test(email)) {
    return "validation_error.invalid_email";
  }
};

const CONTAINS_NUMBER = /[\d]+/;
const isValidPassword = (password) => {
  if (password === void 0 || password === null || password.length < 8) {
    return "validation_error.password_too_short";
  }
  if (!CONTAINS_NUMBER.test(password)) {
    return "validation_error.password_must_include_digits";
  }
};

const isValidPhoneNumber = (phone) => {
  const regex = /^\+?[\d]+$/;
  if (!regex.test(stripAllWhitespaces(phone))) {
    return "Phone number may contain only digits (0-9) and + sign";
  }
  return null;
};
const stripAllWhitespaces = (input) => {
  return input.replace(/\s+/g, "");
};

const privacy_policy_en = `Privacy Policy
Based on an original by Creative Commons \u2013 adapted with thanks.

1. Preamble
This Privacy Policy explains the collection, use, processing, transferring and disclosure of personal information by NewsSocial Ltd.
This Privacy Policy is incorporated into and made part of NewsSocial\u2019s Terms of Use (\u201CMaster Terms\u201D) located at https://www.mushtarek.org/terms.
Unless otherwise noted on a particular website or service hosted by NewsSocial, this Privacy Policy applies to your use of all websites that NewsSocial operates. These include https://newssocial.news, https://mushtarek.org, https://argon.today, together with all other subdomains thereof, (collectively, the \u201CWebsites\u201D). This Privacy Policy also applies to all products, information, and services provided through the Websites.
By accessing or using any of the Services, you are accepting and agreeing to the practices described in this Privacy Policy.

2. Our Principles
NewsSocial has designed this policy to be consistent with the following principles:
Privacy policies should be human readable and easy to find.
Data collection, storage, and processing should be simplified as much as possible to enhance security, ensure consistency, and make the practices easy for users to understand. 
Data practices should always meet the reasonable expectations of users. 

3. Personal Information NewsSocial Collects and How it is Used
As used in this policy, \u201Cpersonal information\u201D means information that would allow someone to identify you, including your name, email address, IP address, or other information from which someone could deduce your identity.
NewsSocial collects and uses personal information in the following ways: 
Website and Fundraising Analytics: When you visit our Websites and use our Services, NewsSocial collects some information about your activities through tools such as Google Analytics. The type of information that we collect focuses on general information such as country or city where you are located, pages visited, time spent on pages, heat-map of visitors\u2019 activity on the site, information about the browser you are using, etc. NewsSocial collects and uses this information pursuant to our legitimate interest in enhancing the security and utility of our Services. The information we gather and process is used in the aggregate to spot trends without deliberately identifying individuals, except in cases where you engage in a transaction with NewsSocial by donating money, purchasing merchandise, or buying a ticket for an event or program. In those cases, NewsSocial retains certain information about your visit to the Services pursuant to its legitimate interest in understanding its community of supporters for fundraising purposes, and this information is stored in connection with other personal information you provide to NewsSocial. 
Note that you can learn about Google\u2019s practices in connection with its analytics services and how to opt out of it by downloading the Google Analytics opt-out browser add-on, available at https://tools.google.com/dlpage/gaoptout. If you would like to opt out of NewsSocial\u2019s fundraising analytics, please contact info@newssocial.co.uk with your request. 
Information from Cookies: We and our service providers (for example, Google Analytics as described above) may collect information using cookies or similar technologies for the purposes described above and below. Cookies are pieces of information that are stored by your browser on the hard drive or memory of your computer or other Internet access device.  Cookies may enable us to personalize your experience on the Services, maintain a persistent session, passively collect demographic information about your computer, and monitor advertisements and other activities. The Websites may use different kinds of cookies and other types of local storage (such as browser-based or plugin-based local storage).
Log-In Services:  When you register to obtain a user account on any of the Services, you will be asked to provide personal information to create your account and establish a password and profile. NewsSocial collects and uses this personal information pursuant to its legitimate interest in establishing and maintaining your account providing you with the features we provide Registered Users. We may use your email address to contact you regarding changes to this policy or other applicable policies. The name or nickname you provide in connection with your account may be used to attribute you in connection with any content you submit to any Service. 
User-Uploaded Pictures and Files Privacy: We recognize the importance of protecting the privacy and security of our users' uploaded pictures and files. As part of our commitment to safeguarding your information, we maintain strict security measures to prevent unauthorized access, disclosure, alteration, or destruction of the pictures and files you upload to our website. Access to your uploaded pictures and files is restricted to authorized personnel and service providers who require access to perform their job functions or provide essential services, and they are bound by confidentiality agreements.
We do not sell, rent, or share your uploaded pictures and files with third parties without your explicit consent, except when required by law or as necessary to protect our rights or comply with legal processes. It is important to note that by using our website and uploading pictures and files, you grant us a license to use, store, and display these materials in accordance with our Terms of Service. We encourage you to review our Terms of Service for further information on how we handle user-generated content. We continuously review and update our security practices to ensure the ongoing protection of your uploaded pictures and files. However, please be aware that no security measures can guarantee absolute protection, and we cannot ensure or warrant the security of any information you transmit to us. By using our website and uploading pictures and files, you acknowledge and accept these risks.
Events: When you sign up for an event hosted or supported by NewsSocial, you will be asked to provide some personal information, including your name, email address, and other information as needed. NewsSocial collects and uses this personal information pursuant to its legitimate interest in organizing and running the relevant event. We may share your personal information with vendors, third party contractors, partner organizations, and volunteers for the purpose of organizing and running the event and related activities.
Emails and Newsletters: When you sign up to receive updates from NewsSocial or otherwise subscribe to one of our mailing lists, you may be asked to provide some personal information. NewsSocial collects and uses this personal information pursuant to its legitimate interest in providing news and updates to, and collaborating with, its supporters and volunteers. 
Email Analytics: When you receive communications from NewsSocial after signing up for the NewsSocial newsletter, campaign updates, or other ongoing email communications from NewsSocial, we use analytics to track whether you open the mail, click on the links, and otherwise interact with what we send. You may opt out of this tracking by choosing to get plain-text emails from NewsSocial. NewsSocial collects and uses this personal information pursuant to its legitimate interest in understanding the interests of its community of supporters and volunteers in order to provide more relevant news and updates. 
Donations:  When you donate money to NewsSocial, pay for using some of NewsSocial services, or pay for attendance at an event or participation in the NewsSocial Certificate program, you will be asked to provide personal information, including payment information. NewsSocial collects and uses this personal information pursuant to its legitimate interest in raising funds to ensure the sustainability of our nonprofit organization and, where applicable, to provide you with the merchandise, event, or program you purchased. 
Other Voluntarily Provided Information: 
When you provide feedback to NewsSocial, sign a petition distributed by NewsSocial, or otherwise submit personal information to NewsSocial, NewsSocial collects and uses this personal information pursuant to its legitimate interest in better understanding our community of supporters and volunteers and in furtherance of the particular program or activity to which you provided feedback or other input. 

4. Retention of Personal Information
The majority of the personal information collected and used as explained in Section 3 above is aggregated and stored in a central database provided by a third party service provider. NewsSocial aggregates this data pursuant to its legitimate interest in having information stored in a single location to minimize complexity, increase consistency in internal practices, better understand its community of supporters and volunteers, and enhance the security of the data.  
NewsSocial erases the web browser logs described above on a regular, rolling basis.
5. Access to Your Personal Information
You are generally entitled to access personal information that NewsSocial holds and to have inaccurate data corrected or removed to the extent NewsSocial still maintains it. In certain circumstances, you also may have the right to object for legitimate reasons to the processing or transfer of personal information. If you wish to exercise any of these rights, please write to info@mushtarek.org explaining your request.
6. Disclosure of Your Personal Information
NewsSocial does not disclose personal information to third parties except as specified elsewhere in this policy and in the following instances:
NewsSocial may share personal information with our contractors and service providers in order to undertake the activities described in Section 3.  
We may disclose your personal information to third parties in a good faith belief that such disclosure is reasonably necessary to (a) take action regarding suspected illegal activities; (b) enforce or apply our Master Terms and this Privacy Policy; (c) enforce our Charter, including the Code of Conduct and policies contained and incorporated therein, or (d) comply with legal process, such as a search warrant, subpoena, statute, or court order.
7. Security of Your Personal Information
NewsSocial has implemented reasonable physical, technical, and organizational security measures for personal information that NewsSocial processes against accidental or unlawful destruction, or accidental loss, alteration, unauthorized disclosure or access, in compliance with applicable law. However, no website can fully eliminate security risks. Third parties may circumvent our security measures to unlawfully intercept or access transmissions or private communications. If any data breach occurs, we will post a reasonably prominent notice to the Websites and comply with all other applicable data privacy requirements including, when required, personal notice to you if you have provided and we have maintained an email address for you.
The NewsSocial Login Services account systems have security risks in addition to those described above. Among other things, they are vulnerable to DNS attacks, and using any NewsSocial Login Service may increase the risk of phishing. 

8. Children
The Services are not directed at children under the age of 13. Consistent with the U.S. federal Children\u2019s Online Privacy Protection Act of 1998 (COPPA), we will never knowingly request personal information from anyone under the age of 13 without requiring parental consent. Our Master Terms specifically prohibit anyone using our Services from submitting any personally identifiable information about persons under 13 years of age. Any person who provides their personal information to NewsSocial through the Services represents that they are 13 years of age or older.

9. Third Party Service Providers
NewsSocial uses many third party service providers in connection with the Services, including website hosting services, database management, credit card processing, and many more. Some of these service providers may place session cookies on your computer, and they may collect and store your personal information on our behalf in accordance with the data practices and purposes explained above in Section 3. 
10. Third Party Sites
The Services may provide links to a wide variety of third party websites. You should consult the respective privacy policies of these third-party websites. This Privacy Policy does not apply to, and we cannot control the activities of, such other websites.

11. Transferring Data to Other Countries
If you are accessing or using the Services in regions with laws governing data collection, processing, transfer and use, please note that when we use and share your data as specified in this policy, we may transfer your information to recipients in countries other than the country in which the information was originally collected. Those countries may not have the same data protection laws as the country in which you initially provided the information. 
The Services are currently hosted in the United States and the United Kingdom, which means your personal information may be located on servers in the United States and/or the United Kingdom. The majority of contractors that NewsSocial is using as of the effective date of this Privacy Policy are located in the United Kingdom and Republic of Ireland, but this may change from time to time. 
Data transferred from the European Union to the United States or outside the European Union will be made on the grounds of a certification to the E.U./U.S. Privacy Shield regime and/or a data transfer agreement based on the Standard Contractual Clauses approved of by the European Commission respectively, consistent with applicable data privacy requirements.
12. Changes to this Privacy Policy
We may occasionally update this Privacy Policy. When we do, we will provide you with notice of such update through (at a minimum) a reasonably prominent notice on the Websites and Services, and will revise the Effective Date below. We encourage you to periodically review this Privacy Policy to stay informed about how we are protecting, using, processing and transferring the personal information we collect.
Effective Date: 25 July 2021.`;

const terms_and_conditions_en = `Terms of Use
NewsSocial terms of use
Based on an original by Creative Commons \u2013 adapted with thanks.

Effective as of 25 May 2022

1. General Information Regarding These Terms of Use
Thank you for your interest in NewsSocial.
NewsSocial is dedicated to building inclusive, democratic, evidenced-based, rational, and moderated discourse.  The process employed by NewsSocial and partners, commonly known as \u201CGroup Ideation\u201D (or \u201CCrowd Sourcing of Ideas and Designs\u201D; for short Ideation), with its associated methods, are designed to accelerate change via engagement and mobilization of a lot of people. The collaborative ideation of those engaged in the process is directed at developing the adequate and feasible solution to pressing social, economic, organizational, and educational problems.
To balance the needs and interests of all stakeholders, NewsSocial protects expressions that meet the Terms of Use outlined on this page.
Please read these terms. They will help you understand what type of expression is acceptable, and what type of content may be reported and removed.
Unless otherwise noted on a particular site or service, these master terms of use (\u201CMaster Terms\u201D) apply to your use of all of the websites that NewsSocial operates. These include https://newssocial.news, https://mushtarek.org, https://argon.today, together with all other subdomains thereof, (collectively, the \u201CWebsites\u201D). The Master Terms also apply to all products, information, and services provided through the Websites.
Additional terms: In addition to the Master Terms, your use of any Services may also be subject to specific terms applicable to a particular Service (\u201CAdditional Terms\u201D). If there is any conflict between the Additional Terms and the Master Terms, then the Additional Terms apply in relation to the relevant Service.
Collectively, the Terms: The Master Terms, together with any Additional Terms, form a binding legal agreement between you and NewsSocial in relation to your use of the Services. Collectively, this legal agreement is referred to below as the \u201CTerms.\u201D
Human-readable summary of Sec 1: These terms, together with any special terms for particular websites, create a contract between you and NewsSocial. The contract governs your use of all websites operated by NewsSocial, unless a particular website indicates otherwise. These human-readable summaries of each section are not part of the contract, but are intended to help you understand its terms.

2. Your Agreement to the Terms
BY CLICKING \u201CI ACCEPT\u201D OR OTHERWISE ACCESSING OR USING ANY OF THE SERVICES (INCLUDING THE LICENSES, PUBLIC DOMAIN TOOLS, AND CHOOSERS), YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREED TO BE BOUND BY THE TERMS. By clicking \u201CI ACCEPT\u201D or otherwise accessing or using any Services you also represent that you have the legal authority to accept the Terms on behalf of yourself and any party you represent in connection with your use of any Services. If you do not agree to the Terms, you are not authorized to use any Services. If you are an individual who is entering into these Terms on behalf of an entity, you represent and warrant that you have the power to bind that entity, and you hereby agree on that entity\u2019s behalf to be bound by these Terms, with the terms \u201Cyou,\u201D and \u201Cyour\u201D applying to you, that entity, and other users accessing the Services on behalf of that entity.
Human-readable summary of Sec 2: Please read these terms and only use our sites and services if you agree to them.

3. Changes to the Terms
From time to time, NewsSocial may change, remove, or add to the Terms, and reserves the right to do so in its discretion. In that case, we will post updated Terms and indicate the date of revision. If we feel the modifications are material, we will make reasonable efforts to post a prominent notice on the relevant Website(s) and notify those of you with a current NewsSocial Login Service account via email. All new and/or revised Terms take effect immediately and apply to your use of the Services from that date on, except that material changes will take effect 30 days after the change is made and identified as material. Your continued use of any Services after new and/or revised Terms are effective indicates that you have read, understood, and agreed to those Terms.
Human-readable summary of Sec 3: These terms may change. When the changes are important, we will put a notice on the website. If you continue to use the sites after the changes are made, you agree to the changes.

4. No Legal Advice
NewsSocial is not a law firm, does not provide legal advice, and is not a substitute for a law firm. Sending us an email or using any of the Services, including the licenses, public domain tools, and choosers, does not constitute legal advice or create an attorney-client relationship.
Human-readable summary of Sec 4: Some of us are lawyers, but we aren\u2019t your lawyer. Please consult your own attorney if you need legal advice.

5. Content Available through the Services
Provided as-is: You acknowledge that NewsSocial does not make any representations or warranties about the material, data, and information, such as data files, text, computer software, code, music, audio files or other sounds, photographs, videos, or other images (collectively, the \u201CContent\u201D) which you may have access to as part of, or through your use of, the Services. Under no circumstances is NewsSocial liable in any way for any Content, including, but not limited to: any infringing Content, any errors or omissions in Content, or for any loss or damage of any kind incurred as a result of the use of any Content posted, transmitted, linked from, or otherwise accessible through or made available via the Services. You understand that by using the Services, you may be exposed to Content that is offensive, indecent, or objectionable.
You agree that you are solely responsible for your reuse of Content made available through the Services, including providing proper attribution. You should review the terms of the applicable license before you use the Content so that you know what you can and cannot do.
Licensing: NewsSocial-owned public content: Other than the text of NewsSocial licenses.
Search Tools: On some of its Websites, NewsSocial provides website search tools which return Content based on any license information our search tools are able to locate and interpret. Those search tools may return Content that is not NewsSocial licensed, and you should independently verify the terms of the license attached to any Content you intend to use.
Human-readable summary of Sec 5: We try our best to have useful information on our sites, but we cannot promise that everything is accurate or appropriate for your situation. Public Content on the site is licensed under CC BY 4.0 unless it says it is available under different terms. If you find content through a link on our websites, be sure to check the license terms before using it.

6. Content Supplied by You
Your responsibility: You represent, warrant, and agree that no Content posted or otherwise shared by you on or through any of the Services (\u201CYour Content\u201D), violates or infringes upon the rights of any third party, including copyright, trademark, privacy, publicity, or other personal or proprietary rights, breaches or conflicts with any obligation, such as a confidentiality obligation, or contains libelous, defamatory, or otherwise unlawful material.
Licensing Your Content: You retain any copyright that you may have in Your Content. You hereby agree that Your Public Content: (a) is hereby licensed under the Creative Commons Attribution 4.0 License and may be used under the terms of that license or any later version of a Creative Commons Attribution License, or (b) is in the public domain (such as Content that is not copyrightable or Content you make available under CC0), or (c) if not owned by you, (i) is available under a Creative Commons Attribution 4.0 License or (ii) is a media file that is available under any Creative Commons license or that you are authorized by law to post or share through any of the Services, such as under the fair use doctrine, and that is prominently marked as being subject to third party copyright. All of Your Content must be appropriately marked with licensing (or other permission status such as fair use) and attribution information.
Removal: NewsSocial may, but is not obligated to, review Your Content and may delete or remove Your Content (without notice) from any of the Services in its sole discretion. Removal of any of Your Content from the Services (by you or NewsSocial) does not impact any rights you granted in Your Content under the terms of a NewsSocial license.
Human-readable summary of Sec 6: We do not take any ownership of your content when you post it on our sites. If you post Public content you own, you agree it can be used under the terms of CC BY 4.0 or any future version of that license. If you do not own the content, then you should not post it unless it is in the public domain or licensed CC BY 4.0, except that you may also post pictures and videos if you are authorized to use them under law (e.g., fair use) or if they are available under any CC license. You must note that information on the file when you upload it. You are responsible for any content you upload to our sites.

7. Joining in NewsSocial Circles or Groups: Registered Users
By registering for an account through any of the Services, including securing a NewsSocial Login Service account you represent and warrant that you are the age of majority in your jurisdiction (typically age 18). Services offered to registered users are provided subject to these Master Terms, the NewsSocial Privacy Policy, and any Additional Terms specified on the relevant Website(s), all of which are hereby incorporated by reference into these Terms.
Registration: You agree to (a) only provide accurate and current information about yourself (though use of an alias or nickname in lieu of your legal name is encouraged in connection with the NewsSocial Login Service), (b) maintain the security of your passwords and identification, (c) promptly update the email address listed in connection with your account to keep it accurate so that we can contact you, and (d) be fully responsible for all uses of your account. You must not set up an account on behalf of another individual or entity unless you are authorized to do so.
No Membership in NewsSocial: Creating a NewsSocial Login Service account or using any of the related Websites or Services does not and shall not be deemed to make you a member, shareholder or affiliate of NewsSocial for any purposes whatsoever, nor shall you have any of the rights of statutory members as defined under UK law or any other law.
Termination: NewsSocial reserves the right to modify or discontinue your account or your membership at any time for any reason or no reason at all.
Human-readable summary of Sec 7: Please do not register for an account on our sites unless you are 18 years old. NewsSocial has the right to end your account at any time. You are responsible for use of your account. And of course, please do not set up an account for someone else unless you have permission to do so. Setting up an account doesn\u2019t make you a member of NewsSocial.

8. Prohibited Conduct
You agree not to engage in any of the following activities:
8.1 Violating laws and rights:
You may not (a) use any Service for any illegal purpose or in violation of any local, state, national, or international laws, (b) violate or encourage others to violate any right of or obligation to a third party, including by infringing, misappropriating, or violating intellectual property, confidentiality, or privacy rights.
8.2 Solicitation:
You may not use the Services or any information provided through the Services for the transmission of advertising or promotional materials, including junk mail, spam, chain letters, pyramid schemes, or any other form of unsolicited or unwelcome solicitation.
8.3 Disruption:
You may not use the Services in any manner that could disable, overburden, damage, or impair the Services, or interfere with any other party\u2019s use and enjoyment of the Services; including by (a) uploading or otherwise disseminating any virus, adware, spyware, worm or other malicious code, or (b) interfering with or disrupting any network, equipment, or server connected to or used to provide any of the Services, or violating any regulation, policy, or procedure of any network, equipment, or server.
8.4 Harming others:
You may not post or transmit Content on or through the Services that is harmful, offensive, obscene, abusive, invasive of privacy, defamatory, hateful or otherwise discriminatory, false or misleading, or incites an illegal act;
You may not intimidate or harass another through the Services; and, you may not post or transmit any personally identifiable information about persons under 13 years of age on or through the Services.
8.5 Impersonation or unauthorized access:
You may not impersonate another person or entity, or misrepresent your affiliation with a person or entity when using the Services;
You may not use or attempt to use another\u2019s account or personal information without authorization; and
You may not attempt to gain unauthorized access to the Services, or the computer systems or networks connected to the Services, through hacking password mining or any other means.
Human-readable summary of Sec 8: Play nice. Be yourself. Don\u2019t break the law or be disruptive.

9. Participating in Circles: Discussing, Moderating and Reporting
As a registered user you will hopefully find that engagement with others in NewsSocial reflects cooperative values and is respectful, tolerant, engaged and committed.
Apps like NewsSocial with user-generated content must take precautions to moderate content and prevent abusive behaviour. These terms are clear that there is no tolerance for objectionable content or abusive users.
Any registered user may apply the provided mechanism to flag and report objectionable content to the Circle Administrator.
A filtering mechanism is provided to search and check inappropriate content.
NewsSocial is obliged to act on objectionable content reports within 24 hours.
Circle Administrators are empowered to remove content and to block users if necessary.
Human-readable summary of Sec 9: Engage as intended, report as necessary.

10. DISCLAIMER OF WARRANTIES
TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NEWSSOCIAL OFFERS THE SERVICES (INCLUDING ALL CONTENT AVAILABLE ON OR THROUGH THE SERVICES) AS-IS AND MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND CONCERNING THE SERVICES, EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING WITHOUT LIMITATION, WARRANTIES OF TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. NEWSSOCIAL DOES NOT WARRANT THAT THE FUNCTIONS OF THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE, THAT CONTENT MADE AVAILABLE ON OR THROUGH THE SERVICES WILL BE ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR THAT ANY SERVERS USED BY NEWSSOCIAL ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. NEWSSOCIAL DOES NOT WARRANT OR MAKE ANY REPRESENTATION REGARDING USE OF THE CONTENT AVAILABLE THROUGH THE SERVICES IN TERMS OF ACCURACY, RELIABILITY, OR OTHERWISE.
Human-readable summary of Sec 10: NewsSocial does not make any guarantees about the sites, services, or content available on the sites.

11. LIMITATION OF LIABILITY
TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT WILL NEWSSOCIAL BE LIABLE TO YOU ON ANY LEGAL THEORY FOR ANY INCIDENTAL, DIRECT, INDIRECT, PUNITIVE, ACTUAL, CONSEQUENTIAL, SPECIAL, EXEMPLARY, OR OTHER DAMAGES, INCLUDING WITHOUT LIMITATION, LOSS OF REVENUE OR INCOME, LOST PROFITS, PAIN AND SUFFERING, EMOTIONAL DISTRESS, COST OF SUBSTITUTE GOODS OR SERVICES, OR SIMILAR DAMAGES SUFFERED OR INCURRED BY YOU OR ANY THIRD PARTY THAT ARISE IN CONNECTION WITH THE SERVICES (OR THE TERMINATION THEREOF FOR ANY REASON), EVEN IF NEWSSOCIAL HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NEWSSOCIAL IS NOT RESPONSIBLE OR LIABLE WHATSOEVER IN ANY MANNER FOR ANY CONTENT POSTED ON OR AVAILABLE THROUGH THE SERVICES (INCLUDING CLAIMS OF INFRINGEMENT RELATING TO THAT CONTENT), FOR YOUR USE OF THE SERVICES, OR FOR THE CONDUCT OF THIRD PARTIES ON OR THROUGH THE SERVICES.
Certain jurisdictions do not permit the exclusion of certain warranties or limitation of liability for incidental or consequential damages, which means that some of the above limitations may not apply to you. IN THESE JURISDICTIONS, THE FOREGOING EXCLUSIONS AND LIMITATIONS WILL BE ENFORCED TO THE GREATEST EXTENT PERMITTED BY APPLICABLE LAW.
Human-readable summary of Sec 11: NEWSSOCIAL is not responsible for the content on the sites, your use of our services, or for the conduct of others on our sites.

12. Indemnification
To the extent authorized by law, you agree to indemnify and hold harmless NewsSocial, their employees, officers, directors, affiliates, and agents from and against any and all claims, losses, expenses, damages, and costs, including reasonable attorneys\u2019 fees, resulting directly or indirectly from or arising out of (a) your violation of the Terms, (b) your use of any of the Services, and/or (c) the Content you make available on any of the Services.
Human-readable summary of Sec 12: If something happens because you violate these terms, because of your use of the services, or because of the content you post on the sites, you agree to repay NewsSocial for the damage it causes.

13. Privacy Policy
NewsSocial is committed to responsibly handling the information and data we collect through our Services in compliance with our Privacy Policy, which is incorporated by reference into these Master Terms. Please review the Privacy Policy so you are aware of how we collect and use your personal information.
Human-readable summary of Sec 13: Please read our Privacy Policy. It is part of these terms, too.

14. Trademark Policy
NewsSocial\u2019s name, logos, icons, and other trademarks may only be used in accordance with our Trademark Policy, which is incorporated by reference into these Master Terms. Please review the Trademark Policy so you understand how NewsSocial\u2019s trademarks may be used.
Human-readable summary of Sec 14: Please read our Trademark Policy. It is part of these terms, too.

15. Copyright Complaints
NewsSocial respects copyright, and we prohibit users of the Services from submitting, uploading, posting, or otherwise transmitting any Content on the Services that violates another person\u2019s proprietary rights.
To report allegedly infringing Content hosted on a website owned or controlled by NewsSocial, send a Notice of Infringing Materials to info@newssocial.co.uk
Human-readable summary of Sec 15: Please let us know if you find infringing content on our websites.

16. Termination
By NewsSocial: NewsSocial may modify, suspend, or terminate the operation of, or access to, all or any portion of the Services at any time for any reason. Additionally, your individual access to, and use of, the Services may be terminated by NewsSocial at any time and for any reason.
By you: If you wish to terminate this agreement, you may immediately stop accessing or using the Services at any time.
Automatic upon breach: Your right to access and use the Services (including use of your NewsSocial Login Service account) automatically ceases upon your breach of any of the Terms.
Survival: The disclaimer of warranties, the limitation of liability, and the jurisdiction and applicable law provisions will survive any termination. The license grants applicable to Your Content are not impacted by the termination of the Terms and shall continue in effect subject to the terms of the applicable license. Your warranties and indemnification obligations will survive for one year after termination.
Human-readable summary of Sec 16: If you violate these terms, you may no longer use our sites.
17. Miscellaneous Terms
Choice of law: The Terms are governed by and construed by the laws of the United Kingdom.
Dispute resolution: The parties agree that any disputes between NewsSocial and you concerning these Terms, and/or any of the Services may only be brought in a UK court.
No waiver: Either party\u2019s failure to insist on or enforce strict performance of any of the Terms will not be construed as a waiver of any provision or right.
Severability: If any part of the Terms is held to be invalid or unenforceable by any law or regulation or final determination of a competent court or tribunal, that provision will be deemed severable and will not affect the validity and enforceability of the remaining provisions.
No agency relationship: The parties agree that no joint venture, partnership, employment, or agency relationship exists between you and NewsSocial as a result of the Terms or from your use of any of the Services.
Integration: These Master Terms and any applicable Additional Terms constitute the entire agreement between you and NewsSocial relating to this subject matter and supersede any and all prior communications and/or agreements between you and NewsSocial relating to access and use of the Services.
Human-readable summary of Sec 17: If there is a lawsuit arising from these terms, it should be in UK law. We are glad you use our sites, but this agreement does not mean we are partners.`;

const make_readable$1 = (text) => text.split(/(\r|\n)/);
const PrivacyText$1 = () => /* @__PURE__ */ jsx("div", {
  className: "font-mono text-xs leading-relaxed",
  children: make_readable$1(privacy_policy_en).map((t, i) => /* @__PURE__ */ jsx("p", {
    className: "mt-3",
    children: t
  }, `_${i}`))
});
const TermsText$1 = () => /* @__PURE__ */ jsx("div", {
  className: "font-mono text-xs leading-relaxed",
  children: make_readable$1(terms_and_conditions_en).map((t, i) => /* @__PURE__ */ jsx("p", {
    className: "mt-3",
    children: t
  }, `_${i}`))
});
const PolicyDialog = ({
  title,
  onClose,
  children
}) => {
  return createPortal(/* @__PURE__ */ jsxs("div", {
    className: "fixed inset-0 z-50 flex items-center justify-center",
    children: [/* @__PURE__ */ jsx("div", {
      className: "absolute inset-0 bg-black/50",
      onClick: onClose
    }), /* @__PURE__ */ jsxs("div", {
      className: "relative bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 flex flex-col max-h-[80vh]",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between px-6 py-4 border-b border-gray-200",
        children: [/* @__PURE__ */ jsx("h2", {
          className: "text-base font-semibold",
          children: title
        }), /* @__PURE__ */ jsx("button", {
          onClick: onClose,
          className: "text-gray-500 hover:text-gray-800 text-xl leading-none",
          "aria-label": "Close",
          children: "\xD7"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "overflow-y-auto px-6 py-4 flex-1",
        children
      })]
    })]
  }), document.body);
};
const PrivacyPolicyDialog$1 = ({
  onClose
}) => /* @__PURE__ */ jsx(PolicyDialog, {
  title: /* @__PURE__ */ jsx(FormattedMessage, {
    id: "general.privacy_policy"
  }),
  onClose,
  children: /* @__PURE__ */ jsx(PrivacyText$1, {})
});
const TermsAndConditionsDialog$1 = ({
  onClose
}) => /* @__PURE__ */ jsx(PolicyDialog, {
  title: /* @__PURE__ */ jsx(FormattedMessage, {
    id: "general.terms_and_conditions"
  }),
  onClose,
  children: /* @__PURE__ */ jsx(TermsText$1, {})
});

const REREGISTER_FLAG$1 = false;
const REGISTRATION_ERROR_KEYS = {
  email_exists: "validation_error.email_exists",
  username_exists: "validation_error.username_exists"
};
const toggleClassName = (active) => `flex-1 py-2 text-sm font-medium border-none cursor-pointer transition-colors ${active ? "bg-blue-600 text-white" : "bg-white text-gray-700 hover:bg-gray-100"}`;
const RegistrationForm$1 = ({
  postId
}) => {
  const {
    state,
    setUserId,
    setState
  } = useRegistrationContext();
  const api = useApi();
  const [method, setMethod] = useState("email");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useBoolean(false);
  const [alreadyRegistered, setAlreadyRegistered] = useBoolean(false);
  const [validEmailError, setValidEmailError] = useState("");
  const [validPasswordError, setValidPasswordError] = useState("");
  const [passwordsDoNotMatchError, setPasswordsDoNotMatchError] = useState("");
  const [showPrivacy, setShowPrivacy] = useBoolean();
  const [showTerms, setShowTerms] = useBoolean();
  const isValueAvailable = async (value) => {
    try {
      const user = await api.loadUserByEmail(value);
      return !user;
    } catch (err) {
      if (err.code === 404) {
        return true;
      } else {
        return false;
      }
    }
  };
  const passwordsMatch = () => {
    if (password !== confirmPassword) {
      setPasswordsDoNotMatchError("validation_error.passwords_must_match");
    } else {
      setPasswordsDoNotMatchError("");
    }
  };
  useEffect(() => {
    passwordsMatch();
  }, [password, confirmPassword]);
  const handleEmailChange = async (e) => {
    const value = e.target.value;
    setEmail(value);
    setValidEmailError(isValidateEmail(value));
    const available = await isValueAvailable(value);
    setAlreadyRegistered.set(!available);
  };
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setValidPasswordError(isValidPassword(value));
    passwordsMatch();
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    passwordsMatch();
  };
  const handleAgreeToTermsChange = () => {
    setAgreeToTerms.toggle();
  };
  const submit = useAsyncOperation(async () => {
    const parts = location.href.split("#");
    const mobile = await mobilePhoneData2Save();
    const result = await api.registerWithEmail({
      mobiles: mobile ? [mobile] : null,
      password: stripAllWhitespaces(password),
      email: stripAllWhitespaces(email),
      postId,
      tags: [],
      url: parts[0] + "#?state=verify&pin=<pin>&userId=<userId>"
    });
    if (result.email || result.phone) {
      setUserId(result._id);
    } else {
      throw new Error(typeof result === "string" ? result : result.error || "Registration failed");
    }
  }, {
    showErrorToast: false
  });
  const thereAreErrors = !password || !email || alreadyRegistered || validEmailError || validPasswordError || passwordsDoNotMatchError;
  return /* @__PURE__ */ jsxs("div", {
    className: `flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto overflow-y-auto max-h-full ${state === "register" ? "flex" : "hidden"}`,
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.register"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex w-full rounded-md border border-gray-300 overflow-hidden",
      role: "tablist",
      children: [/* @__PURE__ */ jsx("button", {
        role: "tab",
        "aria-selected": method === "email",
        className: toggleClassName(method === "email"),
        onClick: () => setMethod("email"),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.email"
        })
      }), /* @__PURE__ */ jsx("button", {
        role: "tab",
        "aria-selected": method === "phone",
        className: toggleClassName(method === "phone"),
        onClick: () => setMethod("phone"),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.phone2"
        })
      })]
    }), method === "email" ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(TextInput, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.email"
        }),
        type: "email",
        value: email,
        onChange: handleEmailChange
      }), alreadyRegistered && /* @__PURE__ */ jsx("div", {
        className: "text-red-500 text-sm",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "registration_form.already_registered2"
        })
      }), validEmailError && /* @__PURE__ */ jsx("div", {
        className: "text-red-500 text-sm",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: validEmailError
        })
      }), /* @__PURE__ */ jsx(PasswordInput, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.password"
        }),
        value: password,
        onChange: handlePasswordChange,
        error: validPasswordError ? /* @__PURE__ */ jsx(FormattedMessage, {
          id: validPasswordError
        }) : void 0
      }), /* @__PURE__ */ jsx(PasswordInput, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.confirm"
        }),
        value: confirmPassword,
        onChange: handleConfirmPasswordChange,
        error: passwordsDoNotMatchError ? /* @__PURE__ */ jsx(FormattedMessage, {
          id: passwordsDoNotMatchError
        }) : void 0
      }), /* @__PURE__ */ jsxs("label", {
        className: "flex items-center gap-2 cursor-pointer text-sm self-start",
        children: [/* @__PURE__ */ jsx("input", {
          type: "checkbox",
          checked: agreeToTerms,
          onChange: handleAgreeToTermsChange,
          className: "w-4 h-4"
        }), /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.agree"
        })]
      }), /* @__PURE__ */ jsx(LoadingButtonTW, {
        background: "primary",
        loading: submit.isLoading,
        disabled: (!agreeToTerms || !!thereAreErrors) && !REREGISTER_FLAG$1,
        onClick: submit.execute,
        className: "w-full",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: submit.isLoading ? "auth.registering" : "auth.register"
        })
      }), submit.error && /* @__PURE__ */ jsx("div", {
        className: "text-red-500 text-sm w-full",
        children: REGISTRATION_ERROR_KEYS[submit.error.message] ? /* @__PURE__ */ jsx(FormattedMessage, {
          id: REGISTRATION_ERROR_KEYS[submit.error.message]
        }) : submit.error.message || /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.otpFailed"
        })
      })]
    }) : /* @__PURE__ */ jsx(PhoneOtpFields, {}), /* @__PURE__ */ jsx("button", {
      className: "bg-transparent border-none p-0 m-0 text-blue-500 underline hover:text-blue-700 cursor-pointer",
      onClick: () => setState("login"),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.alreadyHaveAccount"
      })
    }), /* @__PURE__ */ jsx(OrRuler, {}), /* @__PURE__ */ jsx(NewGoogleButton, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center justify-center text-xs",
      children: [/* @__PURE__ */ jsx("button", {
        onClick: setShowPrivacy.toggle,
        className: "bg-transparent border-none p-0 m-0 cursor-pointer text-blue-500 underline hover:text-blue-700",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "registration.privacy_policy"
        })
      }), /* @__PURE__ */ jsx("button", {
        onClick: setShowTerms.toggle,
        className: "bg-transparent border-none p-0 m-0 cursor-pointer text-blue-500 underline hover:text-blue-700",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "registration.terms"
        })
      })]
    }), showPrivacy && /* @__PURE__ */ jsx(PrivacyPolicyDialog$1, {
      onClose: setShowPrivacy.toggle
    }), showTerms && /* @__PURE__ */ jsx(TermsAndConditionsDialog$1, {
      onClose: setShowTerms.toggle
    })]
  });
};

const CONFIRM_ERROR_KEYS = {
  invalid_pin: "auth.otpInvalid",
  no_such_user: "auth.otpInvalid",
  invalid_link: "auth.otpInvalid"
};
const ConfirmationCode$1 = () => {
  const {
    state,
    setState,
    userId,
    pin
  } = useRegistrationContext();
  const api = useApi();
  const onLoginSuccess = useOnLoginSuccess();
  const [code, setCode] = useState("");
  const trimmedCode = code.trim();
  const handleCodeChange = (e) => {
    setCode(e.target.value);
  };
  useEffect(() => {
    setCode(pin || "");
  }, [pin]);
  const submit = useAsyncOperation(async () => {
    if (!trimmedCode) {
      return;
    }
    const user = await api.confirmEmailWithPin({
      userId,
      pin: trimmedCode
    });
    if (user && user.verified && user._id === userId) {
      await onLoginSuccess({
        result: user
      });
    } else {
      throw Error("Verification failed, try again!");
    }
  }, {
    showErrorToast: false
  });
  useEffect(() => {
    if (pin === code && userId && pin) {
      submit.execute();
    }
  }, [code, userId, pin]);
  return /* @__PURE__ */ jsxs("div", {
    className: `flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto ${state === "verify" ? "flex" : "hidden"}`,
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.verificationCode"
      })
    }), /* @__PURE__ */ jsx(TextInput, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.confirmationCode"
      }),
      type: "text",
      value: code,
      onChange: handleCodeChange
    }), /* @__PURE__ */ jsx(LoadingButtonTW, {
      background: "primary",
      loading: submit.isLoading,
      disabled: !trimmedCode,
      onClick: submit.execute,
      className: "w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: submit.isLoading ? "auth.verify2" : "auth.verify"
      })
    }), submit.error && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm w-full",
      children: CONFIRM_ERROR_KEYS[submit.error.response] ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: CONFIRM_ERROR_KEYS[submit.error.response]
      }) : submit.error.message || /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.otpFailed"
      })
    }), /* @__PURE__ */ jsx("button", {
      className: "bg-transparent border-none p-0 m-0 text-blue-500 underline hover:text-blue-700 cursor-pointer",
      onClick: () => setState("login"),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.alreadyHaveAccount"
      })
    })]
  });
};

const FORGOT_PASSWORD_ERROR_KEYS = {
  "no_such_user": "auth.noSuchAccount",
  "email_address_hard_bounced": "auth.emailBounced"
};
const errorKey$1 = (error) => error && FORGOT_PASSWORD_ERROR_KEYS[error.response] || "auth.resetFailed";
const looksLikePhoneNumber$1 = (value) => !!value.trim() && isValidPhoneNumber(value.trim()) === null;
const ForgotPassword$1 = () => {
  const {
    state,
    setState
  } = useRegistrationContext();
  const api = useApi();
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
  const isPhoneNumber = looksLikePhoneNumber$1(email);
  const submit = useAsyncOperation(async () => {
    setEmailSent(false);
    const parts = location.href.split("#");
    await api.post({
      path: "/public/users/forgot-password",
      body: {
        email: email.trim(),
        url: parts[0] + "#?state=change-password&token=<token>"
      }
    });
    setEmailSent(true);
  }, {
    showErrorToast: false
  });
  return /* @__PURE__ */ jsxs("div", {
    className: `flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto overflow-y-auto max-h-full ${state === "forgot" ? "flex" : "hidden"}`,
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.reset"
      })
    }), /* @__PURE__ */ jsx(TextInput, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.email"
      }),
      type: "text",
      value: email,
      onChange: handleChange
    }), /* @__PURE__ */ jsx("div", {
      className: `${isPhoneNumber ? "text-red-500" : "text-gray-500"} text-sm w-full`,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.phoneNoPassword"
      })
    }), /* @__PURE__ */ jsx(LoadingButtonTW, {
      background: "primary",
      loading: submit.isLoading,
      disabled: isPhoneNumber,
      onClick: submit.execute,
      className: "w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: submit.isLoading ? "auth.resetting" : "auth.reset"
      })
    }), /* @__PURE__ */ jsx("button", {
      className: "bg-transparent border-none p-0 m-0 text-blue-500 underline hover:text-blue-700 cursor-pointer",
      onClick: () => setState("register"),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.register2"
      })
    }), submit.error && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: errorKey$1(submit.error)
      })
    }), emailSent && /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.sentEmail"
      })
    })]
  });
};

const CHANGE_PASSWORD_ERROR_KEYS = {
  "Token expired": "auth.resetLinkExpired",
  "Signature verification failed": "auth.resetLinkExpired",
  "Not enough or too many segments": "auth.resetLinkExpired",
  "No token supplied": "auth.resetLinkExpired",
  "Token not yet active": "auth.resetLinkExpired",
  "no_such_user": "auth.resetLinkExpired",
  "Bad Request": "validation_error.password_too_short"
};
const errorKey = (error) => error && CHANGE_PASSWORD_ERROR_KEYS[error.response] || "auth.changeFailed";
const ChangePassword$1 = () => {
  const {
    state,
    token
  } = useRegistrationContext();
  const api = useApi();
  const onLoginSuccess = useOnLoginSuccess();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validPasswordError, setValidPasswordError] = useState("");
  const [passwordsDoNotMatchError, setPasswordsDoNotMatchError] = useState("");
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setValidPasswordError(isValidPassword(value));
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };
  useEffect(() => {
    setPasswordsDoNotMatchError(password && confirmPassword && password !== confirmPassword ? "validation_error.passwords_must_match" : "");
  }, [password, confirmPassword]);
  const thereAreErrors = !password || !confirmPassword || !!validPasswordError || !!passwordsDoNotMatchError;
  const submit = useAsyncOperation(async () => {
    const user = await api.loginWithJwt(token);
    await api.resetPassword({
      password
    });
    await onLoginSuccess({
      result: user
    });
  }, {
    showErrorToast: false
  });
  return /* @__PURE__ */ jsxs("div", {
    className: `flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto overflow-y-auto max-h-full ${state === "change-password" ? "flex" : "hidden"}`,
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.change"
      })
    }), /* @__PURE__ */ jsx(PasswordInput, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.newPassword"
      }),
      value: password,
      onChange: handlePasswordChange,
      error: validPasswordError ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: validPasswordError
      }) : void 0
    }), /* @__PURE__ */ jsx(PasswordInput, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.confirm"
      }),
      value: confirmPassword,
      onChange: handleConfirmPasswordChange,
      error: passwordsDoNotMatchError ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: passwordsDoNotMatchError
      }) : void 0
    }), /* @__PURE__ */ jsx(LoadingButtonTW, {
      background: "primary",
      loading: submit.isLoading,
      disabled: !!thereAreErrors,
      onClick: submit.execute,
      className: "w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: submit.isLoading ? "auth.change2" : "auth.change"
      })
    }), submit.error && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: errorKey(submit.error)
      })
    })]
  });
};

const AuthForms = () => {
  return /* @__PURE__ */ jsxs(RegistrationContextProvider, {
    children: [/* @__PURE__ */ jsx(LoginForm$1, {}), /* @__PURE__ */ jsx(RegistrationForm$1, {}), /* @__PURE__ */ jsx(PhoneOtpForm, {}), /* @__PURE__ */ jsx(ConfirmationCode$1, {}), /* @__PURE__ */ jsx(ForgotPassword$1, {}), /* @__PURE__ */ jsx(ChangePassword$1, {})]
  });
};
const AuthDialogInner = ({
  onClose
}) => {
  useSetOnLoginUrl();
  return /* @__PURE__ */ jsx(Modal, {
    open: true,
    onClose,
    "aria-labelledby": "authentication modal",
    "aria-describedby": "authentication required",
    children: /* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-center min-h-screen p-4 overflow-y-auto",
      children: /* @__PURE__ */ jsx(AuthForms, {})
    })
  });
};
const AuthDialog = ({
  open,
  onClose
}) => {
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsx(AuthDialogInner, {
    onClose
  });
};

const TermsWrapper = styled.div`
  margin: auto;
  overflow: hidden;
  & > span {
    padding: 30px;
  }
  & a {
    margin-right: 10px;
  }
`;
const SignInWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 2em;
  margin-bottom: 2em;
`;
const Wrapper$K = styled.div`
  display: flex;
  flex-direction: column;
  
`;
const RequiresRegistration = () => {
  useSetOnLoginUrl();
  return /* @__PURE__ */ jsx(Wrapper$K, {
    className: "w-full min-h-screen",
    children: /* @__PURE__ */ jsxs(CardWithHeader, {
      title: "general.requires_registration",
      icon: MdLock,
      children: [/* @__PURE__ */ jsx(ImportantMessage, {
        i18nKey: "general.requires_registration_details"
      }), /* @__PURE__ */ jsxs(SignInWrapper, {
        children: [/* @__PURE__ */ jsx(AuthForms, {}), /* @__PURE__ */ jsx(TermsWrapper, {
          children: /* @__PURE__ */ jsxs("span", {
            children: [/* @__PURE__ */ jsx(Link$1, {
              underline: "always",
              href: "/privacy",
              target: "_blank",
              children: "privacy policy"
            }), "\xA0", /* @__PURE__ */ jsx(Link$1, {
              underline: "always",
              href: "/terms",
              target: "_blank",
              children: "terms"
            })]
          })
        })]
      })]
    })
  });
};

const Wrapper$J = styled.div`
  display: flex;
  flex-direction: column;
`;
const AccessDenied = ({
  children
}) => {
  useSetOnLoginUrl();
  return /* @__PURE__ */ jsx(Wrapper$J, {
    children: /* @__PURE__ */ jsxs(CardWithHeader, {
      title: "general.access_denied",
      icon: MdLock,
      children: [/* @__PURE__ */ jsx(ImportantMessage, {
        i18nKey: "general.request_access_to_circle"
      }), children]
    })
  });
};
const AccessDeniedAction = () => {
  const {
    circle
  } = usePostInfoContext();
  if (!circle) {
    return null;
  }
  console.log(circle);
  if (circle.privacy === "REGISTERED") {
    return /* @__PURE__ */ jsx(JoinButton, {
      circle
    });
  }
  return /* @__PURE__ */ jsx(RedirectLink, {
    circle
  });
};
const JoinButton = ({
  circle
}) => {
  const api = useApi();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    await api.joinGroup(circle);
    location.reload();
  }, {
    message: "Join Circle"
  });
  return /* @__PURE__ */ jsx(LoadingButton, {
    onClick,
    loading,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "general.join2read"
    })
  });
};
const RedirectLink = ({
  circle
}) => {
  const circleId = circle && circle._id;
  const url = circleId && `/groups/${circleId}`;
  const history = useHistory();
  useEffect(() => {
    if (!url) {
      return;
    }
    const h = setTimeout(() => history.push(url), 5 * 1e3);
    return () => {
      clearTimeout(h);
    };
  }, [url]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(FormattedMessage, {
      id: "general.automatically_redirect2circle"
    }), "\xA0", /* @__PURE__ */ jsx(Link$1, {
      to: url,
      component: Link$2,
      className: "inline",
      underline: "always",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "general.or_click"
      })
    })]
  });
};
const AccessDeniedPostView = ({
  children
}) => {
  useSetOnLoginUrl();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 items-center w-full font-semibold flex-wrap",
    children: [/* @__PURE__ */ jsx(MdLock, {}), /* @__PURE__ */ jsx(FormattedMessage, {
      id: "general.no_rights2view_post"
    }), "\xA0", /* @__PURE__ */ jsx(AccessDeniedAction, {})]
  });
};
const AccessDeniedCircle = ({
  children
}) => {
  useSetOnLoginUrl();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 items-center w-full font-semibold",
    children: [/* @__PURE__ */ jsx(MdLock, {}), /* @__PURE__ */ jsx(ImportantMessage, {
      i18nKey: "general.request_access_to_circle2"
    })]
  });
};

const info$7 = createLogger("info:ui");
const isAuthError$1 = (error) => !!error && (error.code === 401 || error.message === "authentication_required");
const PostAuthRequired = () => {
  const [open, setOpen] = useState(false);
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col items-center gap-2 py-10 text-center text-gray-600",
    children: [/* @__PURE__ */ jsx("div", {
      className: "text-base",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "post.please_login"
      })
    }), /* @__PURE__ */ jsx("button", {
      className: "bg-transparent border-none text-blue-600 underline cursor-pointer text-base p-0",
      onClick: () => setOpen(true),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.login2"
      })
    }), /* @__PURE__ */ jsx(AuthDialog, {
      open,
      onClose: () => setOpen(false)
    })]
  });
};
const ErrorPanel$2 = ({
  error
}) => {
  info$7("error panel: %o", error);
  const msg = error.message || error;
  switch (msg) {
    case "authentication_required":
      return /* @__PURE__ */ jsx(RequiresRegistration, {});
    case "access_denied":
      return /* @__PURE__ */ jsx(AccessDenied, {});
  }
  return /* @__PURE__ */ jsx(ErrorPlaceholder, {
    error: msg
  });
};
const ErrorPanelPostView = ({
  error
}) => {
  const msg = !error ? "<unknown error>" : error.message || error;
  if (isAuthError$1(error)) {
    return /* @__PURE__ */ jsx("div", {
      className: "w-full",
      children: /* @__PURE__ */ jsx(PostAuthRequired, {})
    });
  }
  return /* @__PURE__ */ jsx("div", {
    className: "w-full",
    children: /* @__PURE__ */ jsx(ErrorPlaceholder, {
      error: msg
    })
  });
};
const ErrorPanelCircle = ({
  error
}) => {
  info$7("error panel: %o", error);
  const msg = error.message || error;
  switch (msg) {
    case "authentication_required":
      return /* @__PURE__ */ jsx(RequiresRegistration, {});
    case "access_denied":
      return /* @__PURE__ */ jsx(AccessDeniedCircle, {});
  }
  return /* @__PURE__ */ jsx(ErrorPlaceholder, {
    error: msg
  });
};
const ErrorPanelV2 = (props) => {
  return /* @__PURE__ */ jsx("div", {
    className: "w-full",
    children: /* @__PURE__ */ jsx(ErrorPanel$2, {
      ...props
    })
  });
};

const WaitingWrapper$1 = ({
  children
}) => {
  const [timeout, setTimeout] = useState(false);
  useTimeout(() => {
    setTimeout(true);
  }, 1e3);
  if (!timeout) {
    return null;
  }
  return /* @__PURE__ */ jsx(Fragment, {
    children
  });
};

const Wrapper$I = styled.div`
  color: #999;
  background-color: #ddd;
  padding: 3em;
  margin: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25em;
`;
const PleaseWait = ({
  i18nKey = "general.please_wait",
  className
}) => /* @__PURE__ */ jsx(Wrapper$I, {
  className,
  children: /* @__PURE__ */ jsx(FormattedMessage, {
    id: i18nKey
  })
});
const LoadingPlaceholder$1 = () => /* @__PURE__ */ jsx(PleaseWait, {
  i18nKey: "general.loading"
});
const PleaseWaitV2 = ({
  i18nKey = "general.please_wait",
  className
}) => /* @__PURE__ */ jsx("div", {
  className: "w-full p-10",
  children: /* @__PURE__ */ jsx("div", {
    className: clsx("bg-gray-300 w-full text-center p-20", className),
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: i18nKey
    })
  })
});
const PleaseWaitDelayed = (props) => {
  return /* @__PURE__ */ jsx(WaitingWrapper$1, {
    children: /* @__PURE__ */ jsx(PleaseWaitV2, {
      ...props
    })
  });
};
const EmptyList$1 = (props) => {
  return /* @__PURE__ */ jsx(PleaseWaitV2, {
    i18nKey: "posts.empty_list_placeholder",
    ...props
  });
};

const PageCssOverrides$1 = createGlobalStyle`
  #body, body {
    overflow-y: scroll;
    background-color: white;
  }
  
  #root > * {
    min-width: 100%;
    width: 100%;
  }
`;

const CalendarIcon = ({
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsx("svg", {
    viewBox: "0 0 40 40",
    className: clsx("w-[24px] h-[24px]", className),
    ...props,
    children: /* @__PURE__ */ jsx("g", {
      children: /* @__PURE__ */ jsx("path", {
        d: "m28.8 21.3v7.5h-7.5v-7.5h7.5z m-2.5-16.3h3.7v2.5h1.9c1.7 0 3.1 1.4 3.1 3.1v21.3c0 1.7-1.4 3.1-3.1 3.1h-23.8c-1.7 0-3.1-1.4-3.1-3.1v-21.3c0-1.7 1.4-3.1 3.1-3.1h1.9v-2.5h3.8v2.5h12.5v-2.5z m5.6 26.9v-16.6h-23.8v16.6h23.8z"
      })
    })
  });
};

const eventPageUrl = (draftId, step, type = "event") => {
  return `/profile/drafts/_editevent/${type}/${draftId}/${step}`;
};
const tagUrl = (draftId) => `/profile/drafts/_editevent/event/${draftId}/tag`;
const postCalendarLink = (post) => `/ua/event/calendar/${post._id}/calendar.ics`;
const EventPostSteps = ["tag", "roles", "schedule"];
const useEventPostPagePath = () => {
  const match = useRouteMatch("/profile/drafts/_editevent/:type/:id/:step");
  if (!match) {
    return {};
  }
  return {
    id: match.params.id,
    step: match.params.step || "roles",
    postType: match.params.type
  };
};

const Wrapper$H = styled.div`
  color: #999999;
  white-space: nowrap;
`;
const EntityName = ({
  name
}) => /* @__PURE__ */ jsx(Wrapper$H, {
  children: name
});

const usePersonName = ({ person, you }) => {
  const intl = useIntl();
  const context = useContext(PersonNameContext);
  return you && you._id === person._id ? intl.formatMessage({ id: "activity.you" }) : getPersonName(person, context);
};
const PersonNameContext = createContext({});

const PersonName = ({
  person,
  you
}) => {
  const name = usePersonName({
    person,
    you
  });
  return /* @__PURE__ */ jsx(EntityName, {
    name
  });
};

const isComponent = (child) => {
  if (child) {
    const typeType = typeof child.type;
    switch (typeType) {
      case "string":
        return /[A-Z]+/.test(child.type);
      case "function":
        return true;
      case "object":
        return true;
    }
  }
};
const WhenLoggedIn = ({
  children
}) => {
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  const child = React__default.Children.only(children);
  if (isComponent(child)) {
    return React__default.cloneElement(child, {
      profile,
      ...child.props
    });
  } else {
    return child;
  }
};

const WhenNotLoggedIn = ({
  children,
  logged = null
}) => {
  const {
    profile
  } = useProfileContext();
  if (profile) {
    return logged;
  }
  return children;
};

const wrapperCss = css$1`
  display: flex;
  flex-direction: row;
  align-items: center;

  & > * {
    margin: 0.125em;
  }

  & > div {
    display: flex;
    flex-direction: column;
  }  
`;
const StyledLink = styled(Link$1)`
  ${wrapperCss}
`;
const StyledWrapper = styled.div`
  ${wrapperCss}
`;
const MemberLink = ({
  className,
  user,
  children,
  inSeparateWindow
}) => {
  const to = memberProfileUrl(user);
  const history = useHistory();
  const onOpen = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (inSeparateWindow) {
      window.open(to, "_blank");
    } else {
      history.push(to);
    }
  };
  return /* @__PURE__ */ jsx(StyledLink, {
    component: Link$2,
    to,
    underline: "none",
    className,
    onClick: onOpen,
    children
  });
};
const ProfileOrMemberLink = ({
  className,
  user,
  profile,
  children,
  inSeparateWindow
}) => {
  if (profile && profile._id === user._id) {
    const to = PROFILE_URL;
    const onOpen = (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      window.open(to, "_blank");
    };
    return /* @__PURE__ */ jsx(StyledLink, {
      component: Link$2,
      to: PROFILE_URL,
      underline: "none",
      className,
      onClick: inSeparateWindow ? onOpen : null,
      children
    });
  }
  return /* @__PURE__ */ jsx(MemberLink, {
    className,
    user,
    inSeparateWindow,
    children
  });
};
const Contents = ({
  profile,
  user,
  avatarSize,
  children
}) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Avatar, {
      avatar: user && user.avatar,
      size: avatarSize
    }, "avatar"), /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx(PersonName, {
        person: user,
        you: profile
      }), children]
    }, "meta")]
  });
};
const Badge$1 = ({
  className,
  user,
  children,
  avatarSize,
  inSeparateWindow,
  linkToProfile = true
}) => {
  if (!user) {
    return null;
  }
  if (linkToProfile) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(WhenLoggedIn, {
        children: /* @__PURE__ */ jsx(ProfileOrMemberLink, {
          user,
          className,
          inSeparateWindow,
          children: /* @__PURE__ */ jsx(Contents, {
            user,
            avatarSize,
            children
          })
        })
      }, "wli"), /* @__PURE__ */ jsx(WhenNotLoggedIn, {
        children: /* @__PURE__ */ jsx(MemberLink, {
          user,
          className,
          inSeparateWindow,
          children: /* @__PURE__ */ jsx(Contents, {
            user,
            avatarSize,
            children
          })
        })
      }, "wnli")]
    });
  }
  return /* @__PURE__ */ jsxs(StyledWrapper, {
    className,
    children: [/* @__PURE__ */ jsx(WhenLoggedIn, {
      children: /* @__PURE__ */ jsx(Contents, {
        user,
        avatarSize,
        children
      })
    }), /* @__PURE__ */ jsx(WhenNotLoggedIn, {
      children: /* @__PURE__ */ jsx(Contents, {
        user,
        avatarSize,
        children
      })
    })]
  });
};

const OverflowIcon$2 = (props) => /* @__PURE__ */ jsx("svg", {
  viewBox: "0 0 40 40",
  ...props,
  children: /* @__PURE__ */ jsx("g", {
    children: /* @__PURE__ */ jsx("path", {
      d: "m23.3 10.6c0 1.7-1.5 3.2-3.2 3.2s-3.1-1.5-3.1-3.2 1.4-3.1 3.1-3.1 3.2 1.4 3.2 3.1z m0 18.8c0 1.7-1.5 3.1-3.2 3.1s-3.1-1.4-3.1-3.1 1.4-3.1 3.1-3.1 3.2 1.4 3.2 3.1z m0-9.4c0 1.7-1.5 3.1-3.2 3.1s-3.1-1.4-3.1-3.1 1.4-3.1 3.1-3.1 3.2 1.4 3.2 3.1z"
    })
  })
});

const PrimaryButtonStyled = styled(Button)`
  &.MuiButtonBase-root {
    padding: 8px 18px !important;
    background-color: #8028D8;
    border-radius: 24px;
    color: #fff;
    display: inline-block;
    text-decoration: none;
    text-transform: capitalize;
    margin: 10px 0;
    cursor: pointer;
  }

  &.MuiButtonBase-root:hover {     
    background-color: #8028D8;
    box-shadow: 5px 5px 6px #ccc;
  }

  & .MuiButton-label {
    text-transform: none;
  }

  &.MuiButtonBase-root.Mui-disabled,
  &.MuiButton-root.Mui-disabled {    
    color: #aaa;
    background-color: #ccc;
    pointer-events: none !important;
    cursor: default;
  }

  &.MuiButtonBase-root span div {
    margin: 0;
  }
  
`;
const PrimaryButton = ({
  component: Button = PrimaryButtonStyled,
  ...props
}) => {
  return /* @__PURE__ */ jsx(Button, {
    color: "primary",
    variant: "contained",
    ...props
  });
};

const share_buttons = "_share_buttons_12sy2_1";
var styles$e = {
	share_buttons: share_buttons
};

const SharingButtons = ({
  url,
  title,
  tags
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$e.share_buttons,
    children: [/* @__PURE__ */ jsx(FacebookShareButton, {
      url,
      hashtag: tags && tags.length && `#${tags[0]}`,
      children: /* @__PURE__ */ jsx(FacebookIcon, {
        round: true
      })
    }), /* @__PURE__ */ jsx(TwitterShareButton, {
      url,
      hashtags: tags,
      children: /* @__PURE__ */ jsx(TwitterIcon, {
        round: true
      })
    }), /* @__PURE__ */ jsx(WhatsappShareButton, {
      url,
      title,
      children: /* @__PURE__ */ jsx(WhatsappIcon, {
        round: true
      })
    })]
  });
};

const fields$1 = "_fields_v087g_37";
const field = "_field_v087g_37";
const required = "_required_v087g_47";
const feedback = "_feedback_v087g_51";
const error$1 = "_error_v087g_58";
const warning = "_warning_v087g_62";
const buttons = "_buttons_v087g_66";
const radioGroupBox = "_radioGroupBox_v087g_74";
const radioGroupLabel = "_radioGroupLabel_v087g_80";
const smallprint = "_smallprint_v087g_85";
var formStyles = {
	fields: fields$1,
	field: field,
	required: required,
	feedback: feedback,
	error: error$1,
	warning: warning,
	buttons: buttons,
	radioGroupBox: radioGroupBox,
	radioGroupLabel: radioGroupLabel,
	smallprint: smallprint
};

const labelled_field = "_labelled_field_fh6iq_1";
var labelledFieldStyles = {
	labelled_field: labelled_field,
	"async-validating": "_async-validating_fh6iq_9"
};

const styles$d = {
  ...formStyles,
  ...labelledFieldStyles
};
const LabelledField = ({
  required,
  label,
  hideLabel,
  meta = {},
  className,
  children
}) => {
  const intl = useIntl();
  const {
    asyncValidating,
    touched,
    error,
    warning
  } = meta;
  return /* @__PURE__ */ jsxs("div", {
    className: `${className ? className : ""} ${styles$d.field} ${styles$d.labelled_field} ${asyncValidating ? styles$d["async-validating"] : ""}`,
    children: [/* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsxs("label", {
        children: [label && !hideLabel ? /* @__PURE__ */ jsx(FormattedMessage, {
          id: label
        }) : null, required ? /* @__PURE__ */ jsx("span", {
          className: styles$d.required,
          children: "*"
        }) : null]
      }), children]
    }), /* @__PURE__ */ jsx("div", {
      className: [styles$d.feedback, styles$d[error ? "error" : warning ? "warning" : ""]].join(" "),
      children: touched && (error && /* @__PURE__ */ jsx(FormattedMessage, {
        id: error,
        values: label && {
          field: intl.formatMessage({
            id: label
          })
        }
      }) || warning && /* @__PURE__ */ jsx(FormattedMessage, {
        id: warning,
        values: label && {
          field: label
        }
      }))
    })]
  });
};

const TextField = (props) => {
  const [type, setType] = useState("");
  const intl = useIntl();
  const {
    className: className1,
    ...other1
  } = props.input || {};
  const {
    className: className2,
    ...other2
  } = props.inputProps || {};
  const toggle = () => {
    setType((v) => {
      if (!v) {
        return "input";
      }
      return "";
    });
  };
  return /* @__PURE__ */ jsx(LabelledField, {
    ...props,
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex w-full items-center",
      children: [/* @__PURE__ */ jsx("input", {
        ...other1,
        ...other2,
        placeholder: intl.formatMessage({
          id: props.placeholder || props.label
        }),
        className: clsx("flex-grow min-w-0", className1, className2),
        type: type || props.type
      }), props.type === "password" && /* @__PURE__ */ jsx(Fragment, {
        children: !type ? /* @__PURE__ */ jsx(MdOutlineVisibility, {
          onClick: toggle,
          className: "m-1"
        }) : /* @__PURE__ */ jsx(MdOutlineVisibilityOff, {
          onClick: toggle,
          className: "m-1"
        })
      })]
    })
  });
};
const LoginTextField = (props) => {
  const {
    className,
    label
  } = props;
  const [type, setType] = useState("");
  const intl = useIntl();
  const {
    className: className1,
    ...other1
  } = props.input || {};
  const {
    className: className2,
    ...other2
  } = props.inputProps || {};
  const toggle = () => {
    setType((v) => {
      if (!v) {
        return "input";
      }
      return "";
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    className,
    children: [/* @__PURE__ */ jsx("label", {
      className: "mx-2",
      children: label
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex w-full items-center",
      children: [/* @__PURE__ */ jsx("input", {
        ...other1,
        ...other2,
        placeholder: props.placeholder && intl.formatMessage({
          id: props.placeholder
        }),
        className: clsx("flex-grow min-w-0 m-2", className1, className2),
        type: type || props.type
      }), props.type === "password" && /* @__PURE__ */ jsx(Fragment, {
        children: !type ? /* @__PURE__ */ jsx(MdOutlineVisibility, {
          onClick: toggle,
          className: "m-1"
        }) : /* @__PURE__ */ jsx(MdOutlineVisibilityOff, {
          onClick: toggle,
          className: "m-1"
        })
      })]
    })]
  });
};

const isLocalPlayground = () => {
  if (typeof location === "undefined") {
    return false;
  }
  if (!isLocalhost()) {
    return false;
  }
  if (location.port !== "3030") {
    return false;
  }
  return true;
};

class BackOff {
  constructor(f, {
    onError = (error) => null,
    onSuccess = (data2) => null,
    data
  } = {}) {
    this.f = f;
    this.execute = async (data) => {
      if (data) {
        this.data = data;
      }
      if (this.running.running) {
        return;
      }
      this.clearTimeout();
      const running = this.running = {
        running: true
      };
      try {
        const rt = await this.f(this.data);
        this.init();
        if (running.running) {
          this.onSuccess(rt);
        }
        return rt;
      } catch (error) {
        if (running.running) {
          this.onError(error);
          if (this.timeout < 30 * 1e3) {
            this.timeout += 300;
          }
          this.h = setTimeout(this.execute, this.timeout);
        } else {
          this.init();
        }
      } finally {
        running.running = false;
      }
    };
    this.running = {
      running: false
    };
    this.onError = (e) => {
      try {
        onError(e);
      } catch (e2) {
        console.error(e2);
      }
    };
    this.onSuccess = (data2) => {
      try {
        onSuccess(data2);
      } catch (e) {
        console.error(e);
      }
    };
    this.data = data;
    this.init();
  }
  init() {
    this.timeout = 300;
  }
  isRunning() {
    return this.running.running || !!this.h;
  }
  clone() {
    const next = new BackOff(this.f, {
      onError: this.onError,
      onSuccess: this.onSuccess,
      data: this.data
    });
    return next;
  }
  clearTimeout() {
    if (this.h) {
      clearTimeout(this.h);
      this.h = void 0;
    }
  }
  stop() {
    this.clearTimeout();
    this.running.running = false;
    this.running = {
      running: false
    };
    this.init();
  }
  send(data) {
    this.stop();
    this.execute(data);
  }
}

class Polling {
  constructor(f, {
    timeout = 1e3,
    onError = (error) => null,
    onSuccess = (data2) => null,
    data
  } = {}) {
    this.finished = (data) => {
      this.h = setTimeout(this.run, this.timeout);
      this.onSuccess(data);
    };
    this.run = async () => {
      return this.f.execute(this.data);
    };
    this.execute = async (data) => {
      if (data) {
        this.data = data;
      }
      if (this.isRunning()) {
        return;
      }
      return this.f.execute(this.data);
    };
    this.f = new BackOff(f, {
      onSuccess: this.finished,
      onError
    });
    this.onSuccess = onSuccess;
    this.timeout = timeout;
    this.data = data;
  }
  isRunning() {
    return this.f.isRunning() || !!this.h;
  }
  setTimeout(timeout) {
    const old = this.h;
    this.clearTimeout();
    this.timeout = timeout;
    if (old) {
      this.h = setTimeout(this.run, this.timeout);
    }
  }
  clearTimeout() {
    if (this.h) {
      clearTimeout(this.h);
      this.h = void 0;
    }
  }
  stop() {
    this.clearTimeout();
    this.f.stop();
    this.f = this.f.clone();
  }
  schedule() {
    this.stop();
    this.h = setTimeout(this.run, this.timeout);
  }
}

const isSSR = () => {
  return typeof window === "undefined";
};

const delay$1 = (timeout = 200) => {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
};

const humanFileSize = (bytes, si = true) => {
  var thresh = si ? 1e3 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }
  var units = si ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + " " + units[u];
};

const useJwtCookies = (token) => {
  const api = useApi();
  useRequest(async () => {
    await api.loginWithJwt(token);
  }, {
    ready: !!token,
    retryCount: -1
  });
};

class Emitter {
  constructor() {
    this.listeners = {};
  }
  addEventListener(type, callback) {
    if (!(type in this.listeners)) {
      this.listeners[type] = [];
    }
    this.listeners[type].push(callback);
  }
  removeEventListener(type, callback) {
    if (!(type in this.listeners)) {
      return;
    }
    var stack = this.listeners[type];
    for (var i = 0, l = stack.length; i < l; i++) {
      if (stack[i] === callback) {
        stack.splice(i, 1);
        return;
      }
    }
  }
  dispatchEvent(type, event) {
    if (!(type in this.listeners)) {
      return true;
    }
    var stack = this.listeners[type].slice();
    for (var i = 0, l = stack.length; i < l; i++) {
      stack[i](event);
    }
    return true;
  }
}
const functionNames = [
  "addEventListener",
  "dispatchEvent",
  "removeEventListener"
];
const implementEventEmitter = (obj) => {
  const delegate = new Emitter();
  functionNames.forEach((f) => obj[f] = (...xs) => delegate[f](...xs));
};

const emitterSubscription = (emitter) => (type, handler, deps) => {
  useEffect(() => {
    emitter.addEventListener(type, handler);
    return () => {
      emitter.removeEventListener(type, handler);
    };
  }, deps || [handler]);
};

const SCROLL_TO_EVENT = "scroll-to";
const responsesEmitter = new Emitter();
const dispatchResponseEvent = (type, event) => {
  return responsesEmitter.dispatchEvent(type, event);
};
const useResponseEmitterSubscription = emitterSubscription(responsesEmitter);

const imageDimensions = (dimensions, el) => {
  const { width = 0, height = 0 } = dimensions || {};
  let aspect = !width ? 1 : height / width;
  let w = Math.min(el.offsetWidth, width);
  let h = w * aspect;
  return { w, h };
};

const isValidTag = (tag) => {
  tag = tag.trim();
  return tag[0] === "<" && tag[tag.length - 1] === ">";
};

const positionRelativePage = (element) => {
  const body = document.body;
  var doc = document.documentElement;
  var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  const scrollLeft = window.pageXOffset || doc.scrollLeft || body.scrollLeft;
  const clientLeft = doc.clientLeft || body.clientLeft || 0;
  const box = element.getBoundingClientRect();
  const y = box.top + top;
  const x = box.left + scrollLeft - clientLeft;
  return {
    top: y,
    left: x,
    behavior: "smooth"
  };
};
const scrollIntoView = (element, yOffset = -75) => {
  if (!element) {
    return;
  }
  const {
    top
  } = positionRelativePage(element);
  window.scrollTo({
    top: top + yOffset,
    behavior: "smooth"
  });
};

const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d.getTime());
};

const adminsToolsVisibleKey = "adminsToolsVisible";
const AdminToolsContext = createContext({
  adminTools: false,
  setAdminTools: () => null
});
const AdminToolsContextProvider = ({
  children
}) => {
  const [adminTools, setAdminTools] = useState(() => typeof localStorage !== "undefined" && localStorage.getItem(adminsToolsVisibleKey) === "true");
  return /* @__PURE__ */ jsx(AdminToolsContext.Provider, {
    value: {
      adminTools,
      setAdminTools
    },
    children
  });
};

const AdminToolsToggle = ({
  isAdmin = true
}) => {
  const {
    adminTools,
    setAdminTools
  } = useContext(AdminToolsContext);
  if (!isAdmin) {
    return null;
  }
  const toggleAdminTools = (e) => {
    e.preventDefault();
    setAdminTools((v) => {
      localStorage.setItem(adminsToolsVisibleKey, String(!v));
      return !v;
    });
  };
  return /* @__PURE__ */ jsx(LinkToggle, {
    onClick: toggleAdminTools,
    open: adminTools,
    style: {
      marginLeft: 10
    },
    children: "Admin tools"
  });
};

const MILLISECONDS = 1e3;
const MINUTES = 60 * MILLISECONDS;
const TIME_TO_PREPARE = 30 * MINUTES;
const getEventStatusInfo = (event) => {
  if (!event) {
    return void 0;
  }
  if (event.finished) {
    return {
      isFinished: true,
      active: true,
      inProgress: false,
      aboutToStart: false,
      outOfHours: true,
      future: false
    };
  }
  const now = Date.now();
  const {
    localEndTime,
    localStartTime
  } = event;
  const startTime = localStartTime ? localStartTime.getTime() : now;
  const active = now > startTime - TIME_TO_PREPARE;
  const isFinished = now > (localEndTime && localEndTime.getTime());
  const inProgress = !isFinished && now > startTime;
  const aboutToStart = now < startTime && now > startTime - TIME_TO_PREPARE;
  const future = now < startTime;
  const outOfHours = (future || isFinished) && !aboutToStart;
  return {
    isFinished,
    inProgress,
    aboutToStart,
    outOfHours,
    future,
    active
  };
};

const InfoMessageStyled = styled(Button)`
  &.MuiButtonBase-root {
    display: inline-block;
    text-decoration: none;
    text-transform: capitalize;
    padding: 5px !important;
    background-color: #fff;
    cursor: default;
    color: rgba(0, 0, 0, 0.87);
    box-shadow: none;
  }

  &.MuiButtonBase-root:hover {
    background-color: #fff;
    box-shadow: none;
  }
  
`;
const InfoButton = ({
  component: Button = InfoMessageStyled,
  ...props
}) => {
  return /* @__PURE__ */ jsx(Button, {
    color: "primary",
    variant: "contained",
    ...props
  });
};

const FinishEventButton = ({
  event
}) => {
  const {
    loadPost
  } = usePostInfoContext();
  const [finished, setFinished] = useState(() => event.finished);
  const api = useApi();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    await api.makeRequest({
      path: "/event/finish/" + event.post._id,
      method: "POST",
      body: {}
    });
    await loadPost();
    setFinished(true);
  }, {
    message: "Finish meeting"
  });
  return /* @__PURE__ */ jsx(InfoButton, {
    onClick,
    loading,
    disabled: finished,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "event.finishMeeting"
    })
  });
};

const AdditionalEventControls = ({
  isAdmin,
  post
}) => {
  if (!isAdmin || !post.event) {
    return null;
  }
  const event = new EventData(post);
  return /* @__PURE__ */ jsx("div", {
    children: /* @__PURE__ */ jsx(FinishEventButton, {
      event
    })
  });
};

const AdminToolsPanel = ({
  isAdmin,
  post
}) => {
  const {
    adminTools
  } = useContext(AdminToolsContext);
  if (!isAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx(Collapse, {
    in: adminTools,
    timeout: "auto",
    unmountOnExit: true,
    children: /* @__PURE__ */ jsx(Toolbar, {
      children: /* @__PURE__ */ jsx(AdditionalEventControls, {
        isAdmin,
        post
      })
    })
  });
};

const getEventStatusId$1 = (event) => {
  const {
    outOfHours,
    future,
    isFinished,
    aboutToStart,
    inProgress
  } = getEventStatusInfo(event);
  if (outOfHours && future) {
    return "event.comeLater";
  }
  if (outOfHours && isFinished) {
    return "event.reportAvailable";
  }
  if (aboutToStart) {
    return "event.aboutToStart";
  }
  if (inProgress) {
    return "event.joinMeeting";
  }
};
const ControlsContainer = styled.div`
  margin: ${({
  theme
}) => theme.spacing(1)}px;
`;
const EventStatus = ({
  event,
  isAdmin: isAdmin2
}) => {
  const statusId = getEventStatusId$1(event);
  if (!statusId) {
    return null;
  }
  const id = statusId === "event.reportAvailable" && isAdmin2 ? statusId + "Admin" : statusId;
  return /* @__PURE__ */ jsx(ControlsContainer, {
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id
    })
  });
};
const EventUrl = ({
  event
}) => {
  if (!event.url && !event.label) {
    return null;
  }
  const {
    isFinished
  } = getEventStatusInfo(event);
  return /* @__PURE__ */ jsx(ControlsContainer, {
    children: /* @__PURE__ */ jsx(Link, {
      href: event.url,
      disabled: isFinished,
      children: /* @__PURE__ */ jsx(PrimaryButton, {
        children: event.label || /* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.see"
        })
      })
    })
  });
};
const Link = ({
  href,
  disabled,
  children
}) => {
  if (disabled) {
    return /* @__PURE__ */ jsx(Fragment, {
      children
    });
  }
  return /* @__PURE__ */ jsx("a", {
    href,
    target: "_blank",
    children
  });
};
const EventControls = () => {
  const {
    post,
    membership
  } = usePostInfoContext();
  const admin = isAdmin(membership);
  if (post.type !== "event") {
    return null;
  }
  if (!(post.event || post.zoom)) {
    return null;
  }
  const event = new EventData(post);
  if (!isValidDate(event.localStartTime)) {
    return null;
  }
  return /* @__PURE__ */ jsxs(AdminToolsContextProvider, {
    children: [/* @__PURE__ */ jsxs(Toolbar, {
      style: {
        padding: "0"
      },
      children: [/* @__PURE__ */ jsx(EventStatus, {
        event,
        isAdmin: admin
      }), /* @__PURE__ */ jsx(EventUrl, {
        event
      }), /* @__PURE__ */ jsx(AdminToolsToggle, {
        isAdmin: admin
      })]
    }), /* @__PURE__ */ jsx(AdminToolsPanel, {
      post,
      isAdmin: admin,
      event
    })]
  });
};

const scrollIntoViewImpl = (element, yOffset = -75) => {
  var doc = document.documentElement;
  var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  const y = element.getBoundingClientRect().top + top + yOffset;
  window.scrollTo({
    top: y,
    behavior: "smooth"
  });
};
const ResponseRoutesContext = React__default.createContext({
  responseId: void 0,
  scrollIntoView: () => null
});
const useResponseRoutesContext = () => {
  return useContext(ResponseRoutesContext);
};
const ResponseRoutesProvider = ({
  children
}) => {
  const [responseId, setResponseId] = useState(null);
  const shown = useRef(false);
  const location = useLocation();
  const matched = matchPath(location.hash.slice(1), "/response/:responseId");
  const matchedId = matched && matched.params.responseId;
  useEffect(() => {
    if (matchedId !== responseId) {
      setResponseId(matchedId);
      shown.current = false;
    }
  }, [matchedId, responseId]);
  const scrollIntoView = useCallback((id, element) => {
    if (!element || id !== responseId || shown.current) {
      return;
    }
    shown.current = true;
    scrollIntoViewImpl(element);
  }, [responseId]);
  return useMemo(() => /* @__PURE__ */ jsx(ResponseRoutesContext.Provider, {
    value: {
      scrollIntoView,
      responseId
    },
    children
  }), [responseId, children]);
};

const noop$w = () => null;
const PostContext = React__default.createContext({
  post: void 0,
  rating: void 0,
  userVote: void 0,
  notesInfo: void 0,
  responding: false,
  setResponding: noop$w,
  isClosed: false,
  hidden: false
});
const usePostContext = () => {
  return useContext(PostContext);
};
const PostContextProvider = ({
  post,
  hidden,
  children
}) => {
  const {
    isClosed: parentIsClosed
  } = usePostContext();
  const [responding, setResponding] = useState(false);
  const postId = post && post._id;
  const info = usePostInfoContext();
  const rating = info.rating[postId], userVote = info.userVote[postId], notesInfo = info.notesInfo[postId];
  const context = useMemo(() => {
    return {
      post,
      rating,
      userVote,
      notesInfo,
      responding,
      setResponding,
      isClosed: parentIsClosed || post && post.completed,
      hidden
    };
  }, [rating, userVote, notesInfo, post, responding, parentIsClosed, hidden]);
  return /* @__PURE__ */ jsx(PostContext.Provider, {
    value: context,
    children
  });
};

const ResponsesContext = React__default.createContext({
  showMenu: false,
  expanded: true,
  setExpanded: () => {
  },
  sortAscending: true,
  setSortAscending: () => {
  },
  treeView: true,
  setTreeView: () => {
  },
  columnView: false,
  setColumnView: () => {
  },
  numbering: true,
  setNumbering: () => {
  },
  Response: () => null,
  Conclusion: () => null
});
const useResponsesContext = () => {
  return useContext(ResponsesContext);
};
const ResponsesContextProvider = ({
  children,
  response,
  conclusion
}) => {
  const [expanded, setExpanded] = useState(true);
  const [sortAscending, setSortAscending] = useState(true);
  const [treeView, setTreeView] = useState(true);
  const [columnView, setColumnView] = useState(() => {
    if (typeof window === "undefined") {
      return false;
    }
    const {
      width
    } = viewport();
    return width < 500;
  });
  const [numbering, setNumbering] = useState(true);
  const context = useMemo(() => ({
    numbering,
    setNumbering,
    expanded,
    setExpanded,
    sortAscending,
    setSortAscending,
    treeView,
    setTreeView,
    columnView,
    setColumnView,
    showMenu: true,
    Response: response || (() => null),
    Conclusion: conclusion || (() => null)
  }), [expanded, treeView, columnView, numbering, sortAscending]);
  return /* @__PURE__ */ jsx(ResponsesContext.Provider, {
    value: context,
    children
  });
};

const Numbering = () => {
  const {
    post: response
  } = usePostContext();
  const {
    numbering: showNumbering
  } = useResponsesContext();
  if (!showNumbering || !response.numbering) {
    return null;
  }
  const numbering = response.numbering;
  return /* @__PURE__ */ jsx("div", {
    children: numbering.map((_v, id) => /* @__PURE__ */ jsx(SingleNumber, {
      numbering,
      id
    }, id))
  });
};
const SingleNumber = ({
  numbering,
  id
}) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Link$1, {
      underline: "always",
      children: numbering[id] + 1
    }), numbering.length === id + 1 ? null : "."]
  });
};
const NumberingAndAuthor = styled.div`
  display: flex;
  align-items: center;
  & > div:first-child {
    margin-right: 5px;
    margin-left: 5px;
  }
`;

const ResponsesCssOverrides = createGlobalStyle`
div[dir=ltr][class=lang] .responses .conversation .nested {
  border-left: 0.5em solid #eee;
}

div[dir=rtl][class=lang] .responses .conversation .nested {
  border-right: 0.5em solid #eee;
}

div[dir=ltr][class=lang] .responses .conversation .nested .nested {
  border-left: 0.5em solid #ddd;
}

div[dir=rtl][class=lang] .responses .conversation .nested .nested {
  border-left: 0;
  border-right: 0.5em solid #ddd;
}

div[dir=ltr][class=lang] .responses .conversation .nested .nested .nested {
  border-left: 0.5em solid #ccc;
}

div[dir=rtl][class=lang] .responses .conversation .nested .nested .nested {
  border-left: 0;
  border-right: 0.5em solid #ccc;
}

div[dir=ltr][class=lang] .responses .conversation .nested .nested .nested .nested{
  border-left: 0.5em solid #bbb;
}

div[dir=rtl][class=lang] .responses .conversation .nested .nested .nested .nested{
  border-left: 0;
  border-right: 0.5em solid #bbb;
}

div[dir=ltr][class=lang] .responses .conversation .nested .nested .nested .nested .nested{
  border-left: 0.5em solid #aaa;
}

div[dir=rtl][class=lang] .responses .conversation .nested .nested .nested .nested .nested{
  border-left: 0;
  border-right: 0.5em solid #aaa;
}
`;

const TitleWrapper$2 = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  min-width: 200px;
`;
const ResponseTitle = () => {
  const {
    post: response
  } = usePostContext();
  const {
    expanded
  } = useResponsesContext();
  if (expanded) {
    return null;
  }
  return /* @__PURE__ */ jsx(TitleWrapper$2, {
    children: response.title
  });
};
const ConversationStyled = styled.section.attrs(() => ({
  className: "conversation"
}))`
  background-color: #fff;
`;
const RenderFirst = (props) => {
  const {
    response
  } = props;
  const {
    Response,
    Conclusion
  } = useResponsesContext();
  return /* @__PURE__ */ jsxs(ConversationStyled, {
    id: "render-first",
    children: [/* @__PURE__ */ jsx(Response, {
      response
    }), response.completed && /* @__PURE__ */ jsx(Conclusion, {
      title: "outcome",
      language: response.language,
      content: response.conclusion
    })]
  });
};
const RenderRest = (props) => {
  const {
    response
  } = props;
  const {
    Response
  } = useResponsesContext();
  return /* @__PURE__ */ jsx(ConversationStyled, {
    id: "render-rest",
    children: /* @__PURE__ */ jsx("div", {
      className: "nested",
      children: response.responses.map((r) => {
        if (r.responses.length) {
          return /* @__PURE__ */ jsx(Conversation, {
            response: r
          }, r._id);
        }
        return /* @__PURE__ */ jsx(Response, {
          response: r,
          showResponseCount: true
        }, r._id);
      })
    })
  });
};
const Conversation = (props) => {
  const intl = useIntl();
  const {
    response
  } = props;
  const responseCount = response.responses && response.responses.length;
  if (responseCount) {
    const maximize_label = intl.formatMessage({
      id: "post.n_responses"
    }, {
      responseCount
    });
    return /* @__PURE__ */ jsx(Disclosure, {
      postId: response._id,
      first: /* @__PURE__ */ jsx(RenderFirst, {
        ...props
      }),
      rest: /* @__PURE__ */ jsx(RenderRest, {
        ...props
      }),
      moreLabel: maximize_label,
      lessLabel: "post.minimize_conversation",
      open: response.completed ? false : true
    });
  }
  return /* @__PURE__ */ jsx(RenderFirst, {
    ...props
  });
};
const ColumnsWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  & > div {
    max-width: 400px;
    border: 1px solid black;
    margin-right: 10px;
  }
`;
const ResponsesStyled = styled.div.attrs(() => ({
  className: "responses"
}))`
  display: flex;
  flex-direction: column;
`;
const Columns = ({
  responses,
  order
}) => {
  return /* @__PURE__ */ jsx(ColumnsWrapper, {
    children: order.map((id) => {
      const response = responses[id];
      const key = response._id;
      return /* @__PURE__ */ jsx(ResponsesStyled, {
        children: /* @__PURE__ */ jsx(Conversation, {
          response
        }, key)
      });
    })
  });
};
const ResponsesWrapper = ({
  children
}) => {
  return /* @__PURE__ */ jsx(ResponsesStyled, {
    children
  });
};
const ResponseOuterDiv = styled.div.attrs(() => ({
  className: "response"
}))`
  display: flex;
  flex-direction: column;
  padding-top: 0.5em;
`;
const ResponsesRoot = ({
  order: originalOrder,
  responses
}) => {
  const {
    columnView,
    sortAscending
  } = useResponsesContext();
  const order = useMemo(() => {
    if (!originalOrder || sortAscending) {
      return originalOrder;
    }
    return [...originalOrder].reverse();
  }, [originalOrder, sortAscending]);
  if (!order) {
    return null;
  }
  if (columnView) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(ResponsesCssOverrides, {}), /* @__PURE__ */ jsx(Columns, {
        responses,
        order
      })]
    });
  }
  return /* @__PURE__ */ jsxs(ResponsesWrapper, {
    children: [/* @__PURE__ */ jsx(ResponsesCssOverrides, {}), order.map((id) => {
      const response = responses[id];
      const key = response._id;
      return /* @__PURE__ */ jsx(Conversation, {
        response
      }, key);
    })]
  });
};
const ResponseHeader = styled.header`
  flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  padding: 5px;
`;

const MESSAGE_ID = {
  id: "posts.n_minute_read"
};
const ReadTime = ({
  className,
  value = 2
}) => {
  const intl = useIntl();
  return /* @__PURE__ */ jsx("span", {
    className,
    children: intl.formatMessage(MESSAGE_ID, {
      value
    })
  });
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.5em;
  margin-right: 0.5em;
  overflow: hidden;
`;
const CircleInfo$1 = ({
  circle
}) => {
  if (!circle || !circle.name) {
    return null;
  }
  return /* @__PURE__ */ jsx(FormattedMessage, {
    id: "posts.in_group",
    values: circle
  });
};
const OneLine$1 = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Additional = styled.div`
  color: #aaa;
  font-size: 12px;
  display: flex;
  white-space: nowrap;
  div[dir="rtl"][class="lang"] & {
    margin-top: -5px;
  }

`;
const PostsListItemAuthor = (props) => {
  const {
    author,
    created,
    readTime
  } = props;
  const mobile = useMediaQuery("(max-width:600px)");
  const postAuthor = author || {};
  return /* @__PURE__ */ jsxs(Container, {
    children: [/* @__PURE__ */ jsx(Avatar, {
      avatar: postAuthor.avatar
    }), /* @__PURE__ */ jsxs(Column, {
      children: [/* @__PURE__ */ jsx(OneLine$1, {
        children: /* @__PURE__ */ jsx(AuthorName, {
          author: postAuthor
        })
      }), /* @__PURE__ */ jsxs(Additional, {
        children: [/* @__PURE__ */ jsx(RelativeTime, {
          value: created
        }), !mobile && /* @__PURE__ */ jsxs("span", {
          children: [" \xB7", " "]
        }), /* @__PURE__ */ jsx(ReadTime, {
          value: readTime
        })]
      })]
    })]
  });
};
const AuthorAndMeta = ({
  author,
  created,
  readTime,
  group
}) => {
  if (!author) {
    author = {};
  }
  return /* @__PURE__ */ jsxs(Container, {
    children: [/* @__PURE__ */ jsx(Avatar, {
      avatar: author.avatar
    }), /* @__PURE__ */ jsxs(Column, {
      children: [/* @__PURE__ */ jsxs(OneLine$1, {
        children: [/* @__PURE__ */ jsx(AuthorName, {
          author
        }), /* @__PURE__ */ jsx(CircleInfo$1, {
          circle: group && group.group
        })]
      }), /* @__PURE__ */ jsxs(Additional, {
        children: [/* @__PURE__ */ jsx(RelativeTime, {
          value: created
        }), "\xA0 \xB7 \xA0", /* @__PURE__ */ jsx(ReadTime, {
          value: readTime
        })]
      })]
    })]
  });
};

class VisibilityNotifications {
  constructor() {
    this.isNew = false;
  }
  setIsNew(isNew) {
    if (this.isNew === isNew) {
      return;
    }
    this.isNew = isNew;
    if (!isNew) {
      this.clearPending();
      return;
    }
    if (this.isVisible) {
      this.clearPending();
      this.scheduleWasSeen();
    }
  }
  setIsVisible(isVisible) {
    if (this.isVisible === isVisible) {
      return;
    }
    this.isVisible = isVisible;
    if (!this.isNew) {
      return;
    }
    if (!isVisible) {
      this.clearPending();
      return;
    }
    this.scheduleWasSeen();
  }
  scheduleWasSeen() {
    if (this.pending) {
      return;
    }
    this.pending = setTimeout(() => {
      this.onWasSeen();
    }, 500);
  }
  clearPending() {
    clearTimeout(this.pending);
    this.pending = null;
  }
}
class VisibilityController {
  constructor(scrollintoView) {
    this.scrollintoView = scrollintoView;
  }
  setIsVisible(isVisible) {
    if (isVisible) {
      this.clearPending();
    }
    this.isVisible = isVisible;
  }
  schedule(count = 0) {
    if (this.pending || count > 5) {
      console.log("visibiliti limit");
      return;
    }
    this.scrollintoView();
    this.pending = setTimeout(() => {
      this.pending = null;
      if (!this.isVisible) {
        this.schedule(count + 1);
      }
    }, 2e3);
  }
  clearPending() {
    if (!this.pending) {
      return;
    }
    clearTimeout(this.pending);
    this.pending = null;
  }
}
const highlightAnimation = keyframes`
  0% {outline-width: 0;}
  50% {outline-width: 5px;}
  100% {outline-width: 0;}
`;
const highlightPostWrapperCss = css$1`
  background-color: ${(props) => props.highlighted ? `#c7fac7` : `inherit`};
  outline: solid 5px #FC5185;
  outline-width: 0;
  margin-top: 1em;
  ${({
  animation
}) => animation ? css$1`animation: ${highlightAnimation} 0.7s linear;` : ""}   
`;
const SimpleWrapper = styled.div`
  ${highlightPostWrapperCss}
`;
const scrollColumnToView = (el) => {
  const column = findAncestor(el, ".responses-thread");
  if (column) {
    scrollTo(column);
  }
};
const findAncestor = (el, sel) => {
  while ((el = el.parentElement) && !(el.matches || el.matchesSelector).call(el, sel))
    ;
  return el;
};
const scrollTo = (el) => {
  const elRight = el.offsetLeft + el.offsetWidth;
  const elLeft = el.offsetLeft;
  const elParentRight = el.parentNode.offsetLeft + el.parentNode.offsetWidth;
  const elParentLeft = el.parentNode.offsetLeft;
  if (elRight > elParentRight + el.parentNode.scrollLeft) {
    el.parentNode.scrollLeft = elRight - elParentRight;
  } else if (elLeft < elParentLeft + el.parentNode.scrollLeft) {
    el.parentNode.scrollLeft = elLeft - elParentLeft;
  }
};
const useVisibilityController = (elementRef) => {
  const intoView = useCreation(() => {
    const scrollWrapperIntoView = () => {
      scrollIntoView(elementRef.current);
      scrollColumnToView(elementRef.current);
    };
    return new VisibilityController(scrollWrapperIntoView);
  }, []);
  useUnmount(() => {
    intoView.clearPending();
  });
  return intoView;
};
const noop$v = () => null;
const useVisibilitySensor = (intoView, onVisible = noop$v, onHidden = noop$v) => {
  return useCreation(() => {
    const onChange = (isVisible) => {
      intoView.setIsVisible(isVisible);
      if (isVisible) {
        onVisible();
      } else {
        onHidden();
      }
    };
    const Sensor = ({
      children
    }) => {
      return /* @__PURE__ */ jsx(VisibilitySensor, {
        onChange,
        partialVisibility: true,
        minTopValue: 100,
        children
      });
    };
    return Sensor;
  }, [onVisible]);
};
const PostWrapper = (props) => {
  const {
    children,
    className,
    post,
    usePostWrapperHook = () => null,
    wrapper: Wrapper = SimpleWrapper
  } = props;
  const [counter, setCounter] = useState(0);
  const notifyWasSeen = useCreation(() => new VisibilityNotifications(), []);
  const elementRef = useRef();
  const {
    updated,
    wasSeen,
    openPostEvents$
  } = usePostUpdatesContext();
  const postId = post._id;
  const intoView = useVisibilityController(elementRef);
  openPostEvents$.useSubscription((ev) => {
    if (ev.post !== postId) {
      intoView.clearPending();
      return;
    }
    intoView.schedule();
  });
  const numbering = post.numbering;
  usePostWrapperHook({
    postId,
    numbering,
    elementRef,
    setCounter
  });
  const isNew = updated[post._id] ? updated[post._id].isNew : false;
  notifyWasSeen.setIsNew(isNew);
  notifyWasSeen.onWasSeen = () => {
    wasSeen(post._id);
  };
  const onVisible = useCallback(() => {
    notifyWasSeen.setIsVisible(true);
  }, []);
  const VisibilitySensor2 = useVisibilitySensor(intoView, onVisible);
  return /* @__PURE__ */ jsx(VisibilitySensor2, {
    children: /* @__PURE__ */ jsx(Wrapper, {
      className,
      highlighted: notifyWasSeen.isNew,
      ref: elementRef,
      animation: counter,
      children
    }, counter)
  });
};

const noop$u = () => null;
const CircleContext = React__default.createContext({
  id: void 0,
  circle: void 0,
  postsFilter: "all",
  setPostsFilter: noop$u,
  profile: void 0,
  requests: void 0,
  membership: void 0,
  invitation: void 0,
  requestAccess: false,
  setRequestAccess: noop$u,
  refresh: noop$u,
  error: void 0,
  event$: {
    emit: noop$u,
    useSubscription: noop$u
  },
  loading: false,
  testPromptDialogOpen: null,
  setTestPromptDialogOpen: noop$u,
  instance: {},
  initialPosts: null
});
const useCircleContext = () => {
  return useContext(CircleContext);
};

const WebsocketsContext = React__default.createContext({
  socket: null
});
const useWebsockets = () => {
  const {
    socket
  } = useContext(WebsocketsContext);
  return socket;
};
const WebsocketsContextProvider = ({
  children
}) => {
  const socket = useWebsocketsConnection();
  return /* @__PURE__ */ jsx(WebsocketsContext.Provider, {
    value: {
      socket
    },
    children
  });
};
const hostname = () => {
  const domain = typeof process !== "undefined" && process.env && ({}).API_DOMAIN;
  if (domain) {
    return window.location.origin;
  }
  return "http://localhost:3004/";
};
const connections = {};
const useWebsocketsConnection = () => {
  const connectionRef = useRef();
  if (typeof window === "undefined") {
    return null;
  }
  if (!connectionRef.current && typeof window !== "undefined") {
    const {
      host,
      protocol
    } = window.location;
    const URL = host.startsWith("localhost") ? hostname() : `${protocol}//${host}`;
    const socket = connections[URL] || io(URL);
    connections[URL] = connectionRef.current = socket;
    socket.on("connect_error", () => {
      console.log("connection error");
    });
  }
  return connectionRef.current;
};

const info$6 = createLogger("info:ui");
const noop$t = () => null;
const useWebsocketSubscription = (handler, {
  type,
  data,
  disconnected,
  connected,
  started
}, dep) => {
  const ref = useRef();
  const con = useWebsockets();
  ref.current = {
    disconnected: disconnected || noop$t,
    connected: connected || noop$t,
    started: started || noop$t
  };
  useEffect(() => {
    if (!data || !con) {
      return;
    }
    let timer;
    let last = false;
    let oldData;
    const watchdog = () => {
      if (con.connected) {
        con.emit(type + ":start", data);
      }
      schedulerWatchdog();
    };
    const schedulerWatchdog = () => {
      if (timer) {
        clearTimeout(timer);
      }
      const SECOND = 1e3;
      const time = (last ? 5 : 1) * 60 * SECOND;
      timer = setTimeout(watchdog, time);
    };
    const onConnected = () => {
      info$6("ws subscription: %o", data);
      con.emit(type + ":start", data);
      ref.current.connected();
    };
    con.on("connect", onConnected);
    const onDisconnected = () => {
      last = false;
      schedulerWatchdog();
      ref.current.disconnected();
    };
    con.on("disconnect", onDisconnected);
    if (con.connected) {
      con.emit(type + ":start", data);
    }
    const onData = (data2) => {
      if (!last && data2.type === "started") {
        ref.current.started();
      }
      last = true;
      schedulerWatchdog();
      try {
        const json = JSON.stringify(data2);
        if (json === oldData) {
          return;
        }
        oldData = json;
      } catch (e) {
        console.error("checking stale data", e);
      }
      handler(data2);
    };
    con.on(data.id, onData);
    schedulerWatchdog();
    return () => {
      if (!data) {
        return;
      }
      con.emit(type + ":end", data);
      con.off("connected", onConnected);
      con.off("disconnect", onDisconnected);
      con.off(data.id, onData);
      clearTimeout(timer);
    };
  }, dep || [con, data]);
  return con;
};

const useJwt = () => {
  const api = useApi();
  const {
    data
  } = useSWR("jwt", () => api.loadJwt(), {
    ...swrLoadOnce,
    refreshInterval: 1e3 * 60 * 60,
    dedupingInterval: 1e3 * 60 * 60,
    onErrorRetry: (error, key, config, revalidate, {
      retryCount
    }) => {
      const delay = Math.min(5e3 * Math.pow(2, retryCount), 6e4);
      setTimeout(() => revalidate({
        retryCount
      }), delay);
    }
  });
  return data;
};

const info$5 = createLogger("info:ui");
const noop$s = () => null;
const ActivityContext = React__default.createContext({
  activities$: {
    emit: noop$s,
    useSubscription: noop$s
  }
});
const useActivityContext = () => {
  return useContext(ActivityContext);
};
const ActivityContextProvider = ({
  children
}) => {
  const jwt = useJwt();
  const activities$ = useEventEmitter();
  if (typeof window !== "undefined") {
    window["activities$"] = activities$;
  }
  const disconnected = () => {
    info$5("disconnected");
  };
  const started = () => {
    info$5("activity:started");
  };
  const payload = useCreation(() => {
    if (!jwt) {
      return null;
    }
    return {
      id: "activity",
      jwt
    };
  }, [jwt]);
  const {
    run: notifyActivity
  } = useThrottleFn((data) => {
    info$5("subscription: %o", data);
    activities$.emit(data);
  }, {
    wait: 5 * 1e3
  });
  useWebsocketSubscription((data) => {
    notifyActivity(data);
  }, {
    type: "activity",
    data: payload,
    disconnected,
    started
  }, [payload]);
  return /* @__PURE__ */ jsx(ActivityContext.Provider, {
    value: {
      activities$
    },
    children
  });
};

const activityRrefreshInterval = 1e3 * 60 * 5;

const useCircleVotesActivity = (circleId, op) => {
  const api = useApi();
  const options = {
    ...swrLoadOnce,
    ...op,
    refreshInterval: activityRrefreshInterval
  };
  const result = useSWR(circleId ? `/activities/circle/${circleId}/votes` : null, (path) => {
    return api.makeRequest({
      path
    });
  }, options);
  const {
    activities$
  } = useActivityContext();
  activities$.useSubscription(({
    type
  }) => {
    if (type !== "vote") {
      return;
    }
    if (!options.revalidateOnMount) {
      return;
    }
    const {
      mutate,
      isValidating
    } = result;
    if (!isValidating) {
      mutate();
    }
  });
  return result;
};

const votesCount = (history) => {
  return history.reduce((count, v) => {
    return v.castedVote ? count : count + 1;
  }, 0);
};
const votingBadgeProps = (history) => {
  const notVotedCount = votesCount(history);
  const total = history.length;
  if (!notVotedCount) {
    return {
      badgeContent: total,
      color: "secondary"
    };
  }
  if (total === notVotedCount) {
    return {
      badgeContent: total,
      color: "error"
    };
  }
  return {
    badgeContent: `${notVotedCount}/${total}`,
    color: "error"
  };
};

const CirclePostVotingIcon = ({
  circleId,
  postId,
  ...others
}) => {
  const {
    data
  } = useCircleVotesActivity(circleId, {
    revalidateOnMount: false
  });
  if (!data) {
    return null;
  }
  const {
    history
  } = data;
  const postVotes = history.filter((h) => h.root._id === postId);
  if (!postVotes.length) {
    return null;
  }
  const notVotedCount = votesCount(postVotes);
  if (!notVotedCount) {
    return null;
  }
  return /* @__PURE__ */ jsx(IconButton$5, {
    ...others,
    children: /* @__PURE__ */ jsx(Badge$2, {
      ...votingBadgeProps(postVotes),
      children: /* @__PURE__ */ jsx(RiScales3Fill, {})
    })
  });
};

const useCirclePostsActivity = (circleId, op) => {
  const api = useApi();
  const options = {
    ...swrLoadOnce,
    ...op,
    refreshInterval: activityRrefreshInterval
  };
  const result = useSWR(circleId ? `/activities/circle/${circleId}/posts` : null, (path) => api.makeRequest({
    path
  }), options);
  const {
    activities$
  } = useActivityContext();
  activities$.useSubscription(({
    type
  }) => {
    if (type !== "post") {
      return;
    }
    if (!options.revalidateOnMount) {
      return;
    }
    const {
      mutate,
      isValidating
    } = result;
    if (!isValidating) {
      mutate();
    }
  });
  return result;
};

const postsCount = (history) => {
  return history.reduce((count, v) => {
    return v.wasSeen ? count : count + 1;
  }, 0);
};
const postsBadgeProps = (history) => {
  const count = postsCount(history);
  const total = history.length;
  if (!count) {
    return {
      badgeContent: total,
      color: "secondary"
    };
  }
  if (total === count) {
    return {
      badgeContent: total,
      color: "error"
    };
  }
  return {
    badgeContent: `${count}/${total}`,
    color: "error"
  };
};

const CirclePostRepliesIcon = ({
  circleId,
  postId,
  ...others
}) => {
  const {
    data
  } = useCirclePostsActivity(circleId, {
    revalidateOnMount: false
  });
  if (!data) {
    return null;
  }
  const {
    history
  } = data;
  const postActivity = history.filter((h) => h.rootPost._id === postId);
  if (!postActivity.length) {
    return null;
  }
  const count = postsCount(postActivity);
  if (count <= 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(IconButton$5, {
    ...others,
    children: /* @__PURE__ */ jsx(Badge$2, {
      ...postsBadgeProps(postActivity),
      children: /* @__PURE__ */ jsx(BsFileText, {})
    })
  });
};
const CirclePostRepliesBadge = ({
  circleId,
  postId,
  children,
  ...others
}) => {
  const {
    data
  } = useCirclePostsActivity(circleId, {
    revalidateOnMount: false
  });
  if (!data) {
    return /* @__PURE__ */ jsx(Fragment, {
      children
    });
  }
  const {
    history
  } = data;
  const postActivity = history.filter((h) => h.rootPost._id === postId);
  if (!postActivity.length) {
    return /* @__PURE__ */ jsx(Fragment, {
      children
    });
  }
  const count = postsCount(postActivity);
  if (count <= 0) {
    return /* @__PURE__ */ jsx(Fragment, {
      children
    });
  }
  return /* @__PURE__ */ jsx(Badge$2, {
    ...postsBadgeProps(postActivity),
    ...others,
    children
  });
};

const IconsWrappers = styled.div`
  display: flex;
  align-items: center;
  padding: 0px;
  && > * {
    margin-right: 3px;
  }
  && .MuiIconButton-root {
    padding: 0;
  }
`;
const PostIcon = ({
  icon: Icon,
  type
}) => {
  const theme = useTheme$2();
  const size = theme.iconSize;
  const {
    setPostsFilter,
    postsFilter
  } = useContext(CircleContext);
  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setPostsFilter((v) => {
      if (v === type) {
        return "all";
      }
      return type;
    });
  };
  return /* @__PURE__ */ jsx(IconButton$5, {
    onClick,
    color: postsFilter === type ? "primary" : "secondary",
    children: /* @__PURE__ */ jsx(Icon, {
      size
    })
  });
};
const getPostTypeIcon = (post) => {
  switch (post.type) {
    case "discussion":
      return GiDiscussion;
    case "article":
      return BiEdit;
    case "event":
      return MdEvent;
    case "asset":
      return BiBuildingHouse;
  }
};
const PostIconsInner = ({
  post,
  ...other
}) => {
  const {
    showNotifications
  } = useCircleContext();
  const circleId = post.group && post.group.group && (post.group.group._id || post.group.group);
  if (!circleId) {
    console.error("no circle id on post:", post);
  }
  const icons = [];
  if (post.flagged) {
    icons.push(/* @__PURE__ */ jsx(PostIcon, {
      icon: MdOutlineReport,
      type: "flag"
    }, "flag"));
  }
  let postTypeIcon;
  switch (post.type) {
    case "discussion":
      postTypeIcon = /* @__PURE__ */ jsx(PostIcon, {
        icon: GiDiscussion,
        type: "discussion"
      }, "discussion");
      break;
    case "article":
      postTypeIcon = /* @__PURE__ */ jsx(PostIcon, {
        icon: BiEdit,
        type: "article"
      }, "article");
      break;
    case "event":
      postTypeIcon = /* @__PURE__ */ jsx(PostIcon, {
        icon: MdEvent,
        type: "event"
      }, "event");
      break;
    case "asset":
      postTypeIcon = /* @__PURE__ */ jsx(PostIcon, {
        icon: BiBuildingHouse,
        type: "asset"
      }, "asset");
      break;
  }
  postTypeIcon = /* @__PURE__ */ jsx(CirclePostRepliesBadge, {
    postId: post._id,
    circleId,
    children: postTypeIcon
  });
  icons.push(postTypeIcon);
  if (post.completed) {
    icons.push(/* @__PURE__ */ jsx(PostIcon, {
      icon: BsCardChecklist,
      type: "complete"
    }, "complete"));
  }
  if (showNotifications) {
    icons.push(/* @__PURE__ */ jsx(CirclePostVotingIcon, {
      postId: post._id,
      circleId
    }, "votes"));
  }
  return /* @__PURE__ */ jsx(IconsWrappers, {
    ...other,
    children: icons
  });
};
const PostIcons = (props) => {
  return /* @__PURE__ */ jsx(NoSsr, {
    children: /* @__PURE__ */ jsx(PostIconsInner, {
      ...props
    })
  });
};

const TagLink = styled(Link$2)`
  display: inline-flex;
  font-size: 0.8em;
  line-height: 1em;

  border-radius: 0.7em;
  padding: 0.2em;
  padding-left: 1em;
  padding-right: 1em;

  margin: 0.1em;

  &&& {
    color: #fff;
    background-color: #23a7df;
  }
`;
const ConnectedTag = ({
  tag
}) => {
  const onClick = (ev) => {
    ev.stopPropagation();
  };
  return /* @__PURE__ */ jsx(TagLink, {
    to: `/news/${encodeURIComponent(tag)}`,
    onClick,
    children: tag
  });
};
const TagsWrapper$2 = styled.div`
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;

  && .MuiIconButton-root {
    padding: 0;

  }

  && .MuiIconButton-root svg {
    margin: 0;
    height: 1em;
    width: 1em;
  }
`;
const Tags$2 = ({
  tags
}) => {
  return /* @__PURE__ */ jsx(TagsWrapper$2, {
    children: tags && tags.map((tag) => /* @__PURE__ */ jsx(ConnectedTag, {
      tag
    }, tag))
  });
};
const ArticleImageStyled = styled(ScaledImageProxy)`
  padding-right: 5px;
  padding-left: 5px;
  justify-content: flex-end;
  align-items: flex-start;
`;
const ArticleImage = ({
  article
}) => {
  if (!article.image) {
    return null;
  }
  return /* @__PURE__ */ jsx(ArticleImageStyled, {
    uuid: article.image.uuid,
    w: 120,
    h: 100,
    crop: true
  });
};
const ArticleMenu = ({
  article,
  overflowMenu,
  membership,
  profile
}) => {
  const userId = profile && profile._id;
  if (!userId) {
    return null;
  }
  const authorId = article.author && article.author._id;
  const role = membership && membership.role;
  if (authorId !== userId && role !== "ADMIN") {
    return null;
  }
  if (!overflowMenu) {
    return null;
  }
  if (article.unpub === true || article.draft !== void 0) {
    return /* @__PURE__ */ jsx(OverflowMenu, {
      fn: overflowMenu,
      target: article
    });
  }
  return null;
};
const ArticleTitleStyled = styled(Title$2)`
  flex: 1;
`;
const ArticleTitle = ({
  article
}) => {
  if (article.zoom || article.event) {
    const event = new EventData(article);
    const value = /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(FormattedDate, {
        value: event.localStartTime,
        year: "numeric",
        month: "long",
        day: "2-digit"
      }), "\xA0 \xB7 \xA0", /* @__PURE__ */ jsx(RelativeTime, {
        value: event.localStartTime,
        unit: "day"
      }), " ", "\xA0 \xB7 \xA0", /* @__PURE__ */ jsx("span", {
        dir: "auto",
        style: {
          marginTop: "auto"
        },
        children: article.title
      })]
    });
    return /* @__PURE__ */ jsx(ArticleTitleStyled, {
      value
    });
  }
  return /* @__PURE__ */ jsx(ArticleTitleStyled, {
    value: /* @__PURE__ */ jsx("span", {
      dir: "auto",
      children: article.title
    })
  });
};
const Placeholder = styled.div`
  flex-grow: 1;  
`;
const SummaryWrapper = styled.div`
  display: flex;
  max-width: 100vw;
  padding: 5px;
`;
const SummaryWrapperInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const SummaryWrapperInner2 = styled.div`
  display: flex;
  flex-direction: column;
`;
const ImageWrapper$4 = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
`;
const SummaryBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const PostListItemHeader$1 = styled.div`
  display: flex;
`;
const OverflowIcon$1 = styled.div`
  &:hover{
    background-color: #faf9f9;
    padding: 3px;
    border-radius: 50%;
  }

  & svg {
    width: 20px;
    height: 20px;
    color: #4d4d4d;
  }
`;
const SummaryTags = styled.div`
  display: flex;
  justify-content: left;
  margin-left: 40px;
  flex-wrap: wrap;
`;
const ArticleWrapperInfo = styled.div`
  display: flex;
`;
const SummaryWithImage = (props) => {
  const {
    article,
    ArticleInfo = AuthorAndMeta,
    menu
  } = props;
  return /* @__PURE__ */ jsx(SummaryWrapper, {
    children: /* @__PURE__ */ jsx(SummaryWrapperInner, {
      children: /* @__PURE__ */ jsx(SummaryWrapperInner2, {
        children: /* @__PURE__ */ jsxs(ImageWrapper$4, {
          children: [/* @__PURE__ */ jsx(ArticleImage, {
            article
          }), /* @__PURE__ */ jsxs(SummaryBody, {
            children: [/* @__PURE__ */ jsxs(PostListItemHeader$1, {
              children: [/* @__PURE__ */ jsx(PostIcons, {
                post: article
              }), /* @__PURE__ */ jsx(ArticleTitle, {
                article
              }), /* @__PURE__ */ jsx(OverflowIcon$1, {
                children: menu
              })]
            }), /* @__PURE__ */ jsx(SummaryTags, {
              children: /* @__PURE__ */ jsx(Tags$2, {
                tags: article.tags
              })
            }), /* @__PURE__ */ jsxs(ArticleWrapperInfo, {
              children: [/* @__PURE__ */ jsx(ArticleInfo, {
                ...article
              }), /* @__PURE__ */ jsx(Placeholder, {})]
            })]
          })]
        })
      })
    })
  });
};
const ArticleSummaryLink = styled.a`
  & button svg {
    height: 20px;
    width: 20px;
    color: #202124;
    text-transform: initial;
  }

  & button:first-child svg {
    margin-left: 8px;
    margin-right: 8px;    
  }
`;
const ArticleSummaryCore = (props) => {
  const {
    membership,
    profile
  } = props;
  const handleClick = () => {
    const {
      article: article2,
      onClick
    } = props;
    if (onClick)
      onClick(article2);
  };
  const {
    article,
    overflowMenu,
    className,
    ArticleInfo,
    selected
  } = props;
  return /* @__PURE__ */ jsx(Card, {
    className,
    selected,
    children: /* @__PURE__ */ jsx(ArticleSummaryLink, {
      onClick: handleClick,
      children: /* @__PURE__ */ jsx(SummaryWithImage, {
        article,
        menu: /* @__PURE__ */ jsx(ArticleMenu, {
          article,
          overflowMenu,
          membership,
          profile
        }),
        ArticleInfo
      })
    })
  });
};

const cardsTheme = (theme) => theme.cards;

const scalar = (v) => {
  if (typeof v === "string") {
    return v;
  }
  return v + "px";
};

const NORMAL_IMAGE_SIZE$1 = 85;
const BIG_IMAGE_SIZE$1 = 100;
const SMALL_IMAGE_SIZE$1 = 50;
const DEFAULT_CARDS_THEME = {
  imageRadius: NORMAL_IMAGE_SIZE$1,
  linkToPage: false,
  cardShadow: true,
  cardImage: true,
  cardBackground: "white",
  menu: void 0,
  notifications: void 0,
  closer: false,
  levelIndentationSize: 39,
  onLinkClick: () => null,
  linkConfig: {}
};
const sizesMap = {
  "small": SMALL_IMAGE_SIZE$1,
  "normal": NORMAL_IMAGE_SIZE$1,
  "big": BIG_IMAGE_SIZE$1
};
const imageRadius = (v) => {
  const predefined = sizesMap[v];
  if (predefined) {
    return predefined;
  }
  if (!v) {
    console.error("Wrong image size:", v);
    v = NORMAL_IMAGE_SIZE$1;
  }
  return v;
};
const imageRadiusScalar = (v) => {
  const r = imageRadius(v);
  return scalar(r);
};
const WHITE_COLOR = "white";
const GREY_COLOR = "#f2f2f5";
const colorMap = {
  "white": WHITE_COLOR,
  "grey": GREY_COLOR
};
const colorScalar = (v) => {
  const predefined = colorMap[v];
  if (predefined) {
    return predefined;
  }
  return v;
};
const useCardsTheme = (props, startNewTheme = false) => {
  const theme = useTheme$3();
  return {
    ...DEFAULT_CARDS_THEME,
    ...!startNewTheme && cardsTheme(theme),
    ...props
  };
};
const CardThemeProvider = ({
  children,
  startNewTheme = false,
  ...props
}) => {
  const theme = useTheme$3();
  const cards = useCardsTheme(props, startNewTheme);
  const value = {
    ...theme,
    cards
  };
  return /* @__PURE__ */ jsx(ThemeProvider$1, {
    theme: value,
    children
  });
};

const CardOuter = styled.div`
    padding: 5px;
    overflow: hidden;
    position: relative;
    
    border-radius: 8px;
    margin: 0;
    margin-bottom: 1px;
    background-color: #fff;
    ${({
  theme,
  identation,
  selected
}) => {
  const {
    cardBackground,
    cardShadow,
    levelIndentationSize
  } = cardsTheme(theme);
  const shadow = cardShadow && css$1`
            box-shadow: 0px 4px 8px rgb(0 0 0 / 12%);
        `;
  const border = selected && css$1`
            border: 0.05em solid orange;
        `;
  return css$1`
            padding-left: ${scalar(identation ? levelIndentationSize : 5)};
            background-color: ${colorScalar(cardBackground)};
            ${shadow}
            ${border}
        `;
}}  
`;

const Separator = () => {
  return /* @__PURE__ */ jsx("span", {
    children: "\xA0\xA0\xA0"
  });
};

const Title = ({
  children,
  ...other
}) => {
  return /* @__PURE__ */ jsx(TitleWrapper$1, {
    ...other,
    children
  });
};
const TitleWrapper$1 = styled.h2`
    display: inline-flex;
    font-weight: bold;
    color: #000;
    text-transform: capitalize;
    font-size: 16px;
    line-height: 17px;
    margin: 0;
    margin-top: 5px;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100%;
    & > a {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

const themeOverrides = (props) => {
  if (!props.data) {
    return null;
  }
  const foundOverrides = overrideProps.find((name) => name in props);
  if (!foundOverrides) {
    return null;
  }
  const {
    bg,
    sw = true,
    link,
    menu,
    notifications,
    closer,
    onLinkClick
  } = props;
  const override = {};
  if ("bg" in props) {
    override.cardBackground = bg;
  }
  if ("sw" in props) {
    override.cardShadow = sw;
  }
  if ("link" in props) {
    override.linkToPage = link;
  }
  if ("menu" in props) {
    override.menu = menu;
  }
  override.onLinkClick = onLinkClick;
  if ("notifications" in props) {
    override.notifications = notifications;
  }
  if ("closer" in props) {
    override.closer = closer;
  }
  return override;
};
const overrideProps = ["bg", "sw", "link", "menu", "notifications", "closer", "onLinkClick"];

const CARD_PADDING = 10;

const Image$1 = (props) => {
  const {
    image
  } = props;
  if (!image || !image.uuid) {
    return null;
  }
  const {
    size,
    square,
    imagePadding
  } = props;
  if (size || square || imagePadding !== void 0) {
    const override = {
      imagePadding
    };
    if (size) {
      override.imageRadius = size;
    }
    if (square) {
      override.cardImage = false;
    }
    return /* @__PURE__ */ jsx(CardThemeProvider, {
      ...override,
      children: /* @__PURE__ */ jsx(ImageImpl, {
        ...props
      })
    });
  }
  return /* @__PURE__ */ jsx(ImageImpl, {
    ...props
  });
};
const ImageWrapper$3 = styled.div`
    ${({
  theme
}) => {
  const {
    imageRadius: imageRadius2,
    cardImage,
    imagePadding = CARD_PADDING
  } = cardsTheme(theme);
  const borderRadius = cardImage ? css$1`border-radius: 50%;` : "";
  return css$1`
            border: 2px solid rgb(221, 221, 221);
            box-sizing: content-box;
            background-color: #ddd;
            margin-right: ${imagePadding}px;
            ${borderRadius}
            position: relative;
            & img {
                ${borderRadius}
                width: ${imageRadiusScalar(imageRadius2)};
                height: ${imageRadiusScalar(imageRadius2)};
                position: absolute;
                left: 0;
                top: 0;
            }
        `;
}}
`;
const ImageImpl = (props) => {
  const {
    image,
    size,
    square,
    ...other
  } = props;
  const {
    imageRadius: radius
  } = useCardsTheme();
  return /* @__PURE__ */ jsx(ScaledImageProxy, {
    component: ImageWrapper$3,
    uuid: image.uuid,
    w: imageRadius(radius),
    h: imageRadius(radius),
    crop: true,
    ...other
  });
};

const SubText = styled.div`
    font-size: 10px;
    padding-top: 0;            
    display: flex;
    margin-top: 3px;
    align-items: center;
    flex-wrap: wrap;
`;

const CardChip$1 = ({
  children,
  color,
  chipInner: Inner = ChipInner,
  ...other
}) => {
  return /* @__PURE__ */ jsx(ChipWrapper, {
    color,
    ...other,
    children: /* @__PURE__ */ jsx(Inner, {
      children
    })
  });
};
const ChipWrapper = styled.div`             
    margin: 10px 0 8px;
    max-width: 100px;    
     
    padding: 0 5px;
    border: 1px solid #ddd;
    border-radius: 20px;
    background-color: ${({
  color
}) => color ? color : "#E1E4E9"};
    text-transform: uppercase;
`;
const ChipInner = styled.div`
    border: 0;            
    display: flex;
    margin: 0 auto;
    font-size: 10px;
`;

const PostDataContext$1 = React__default.createContext({
  data: void 0
});
const usePostData$1 = () => {
  return useContext(PostDataContext$1);
};

const PostProvider$1 = ({
  children,
  data,
  override
}) => {
  const [closed, setClosed] = useState(false);
  if (!data) {
    return null;
  }
  const context = {
    data,
    closed,
    setClosed
  };
  if (!override) {
    return /* @__PURE__ */ jsx(PostDataContext$1.Provider, {
      value: context,
      children
    });
  }
  return /* @__PURE__ */ jsx(PostDataContext$1.Provider, {
    value: context,
    children: /* @__PURE__ */ jsx(CardThemeProvider, {
      ...override,
      children
    })
  });
};

const PostCard$2 = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(PostProvider$1, {
    data,
    override,
    children: /* @__PURE__ */ jsx(PostCardImp$1, {
      ...props
    })
  });
};
const ContentOuter$6 = styled.div`
    display: flex;
`;
const ContentOuterLink$4 = styled(ContentOuter$6).attrs({
  as: "a"
})`
    cursor: pointer;
`;
const ContentBodyWrapper$6 = styled.div`
    flex: auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;
const TitleStyled = styled(Title)`
    flex: 1;
    min-width: 0;
    display: block;
    white-space: break-spaces;
    font-size: 15px;
    line-height: 1.1;
    margin: 0;
    padding: 0 3px;

`;
const PostTitle$2 = ({
  underline = "always",
  ...other
}) => {
  useCardsTheme();
  const {
    data
  } = usePostData$1();
  const {
    title
  } = data;
  return /* @__PURE__ */ jsx(TitleStyled, {
    ...other,
    children: title
  });
};
const PostListIcons = styled(PostIcons)`
  & button svg {
    height: 20px;
    width: 20px;
    color: #202124;
    text-transform: initial;
  }

  & button:first-child svg {
    margin-left: 8px;
    margin-right: 8px;    
  }
`;
const PostListItemHeader = styled.div`
  display: flex;
  align-items: center;
`;
const OverflowIcon = styled.div`
    width: 23px;
    height: 23px;
    position: relative;
    overflow: hidden;
    &:hover{
        background-color: #faf9f9;
        padding: 3px;
        border-radius: 50%;
    }

    & svg {
        width: 20px;
        height: 20px;
        color: #4d4d4d;
    }
`;
const TagsWrapper$1 = styled.ul`
    display: flex;
    list-style: none;
    align-items: center;
    flex-wrap: wrap;
`;
const TagChip = styled(CardChip$1)`
    max-width: none;
    text-transform: none;
    margin-right: 0.1em;
    min-width: 30px;
    cursor: pointer;
`;
const ToggleChip = styled(TagChip)`
    min-width: auto;
`;
const Tag$1 = ({
  tag,
  className,
  chipInner
}) => {
  const onClick = (ev) => {
    ev.stopPropagation();
  };
  return /* @__PURE__ */ jsx(Link$2, {
    to: `/news/${encodeURIComponent(tag)}`,
    onClick,
    children: /* @__PURE__ */ jsx(TagChip, {
      className,
      chipInner,
      children: tag
    })
  });
};
const Tags$1 = ({
  tags,
  tagClassName,
  chipInner,
  showAll = false,
  className,
  limit = 2
}) => {
  const [open, setOpen] = useState(showAll);
  if (!tags || !tags.length) {
    return null;
  }
  const total = tags.length;
  const filtered = open || total <= limit ? tags : tags.slice(0, limit);
  const onClick = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    setOpen(true);
  };
  const toggle = showAll ? null : open || total <= limit ? null : /* @__PURE__ */ jsx(ToggleChip, {
    onClick,
    children: "..."
  });
  return /* @__PURE__ */ jsxs(TagsWrapper$1, {
    className,
    children: [filtered.map((tag) => /* @__PURE__ */ jsx(Tag$1, {
      tag,
      className: clsx("ns-post-tag", tagClassName),
      chipInner
    }, tag)), toggle]
  });
};
const PostLine = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
const PostAuthorName = styled(AuthorName)`
    margin: 0;
    margin-left: 0.2em;
    flex: 1;
`;
const AdditionalText = styled(SubText)`
    font-size: 12px;
    margin: 0 8px;
`;
const AdditionalInfo = ({
  post
}) => {
  const {
    type
  } = post;
  if (type !== "event" && type !== "discussion") {
    return null;
  }
  const event = new EventData(post);
  const startedText = type === "event" ? "Event on" : "Discussions started on";
  return /* @__PURE__ */ jsxs(AdditionalText, {
    children: [startedText, "\xA0", /* @__PURE__ */ jsx(FormattedDate, {
      value: event.localStartTime,
      year: "numeric",
      month: "long",
      day: "2-digit"
    })]
  });
};
const PostContentBody$1 = () => {
  const {
    menu
  } = useCardsTheme();
  const {
    data: post
  } = usePostData$1();
  const {
    tags,
    created,
    readTime,
    author
  } = post;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(PostListItemHeader, {
      children: [/* @__PURE__ */ jsx(PostListIcons, {
        post
      }), /* @__PURE__ */ jsx(PostTitle$2, {}), /* @__PURE__ */ jsx(OverflowIcon, {
        children: menu
      })]
    }), /* @__PURE__ */ jsx(AdditionalInfo, {
      post
    }), /* @__PURE__ */ jsxs(AdditionalText, {
      children: ["Published\xA0", /* @__PURE__ */ jsx(RelativeTime, {
        value: created
      }), /* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(ReadTime, {
        value: readTime
      })]
    }), /* @__PURE__ */ jsxs(PostLine, {
      children: [/* @__PURE__ */ jsx(Avatar, {
        avatar: author.avatar
      }), /* @__PURE__ */ jsx(PostAuthorName, {
        author
      })]
    }), /* @__PURE__ */ jsx(Tags$1, {
      tags
    })]
  });
};
const PostContentWrapper = ({
  children
}) => {
  const {
    linkToPage,
    onLinkClick = () => null
  } = useCardsTheme();
  const {
    data: post
  } = usePostData$1();
  if (!linkToPage) {
    return /* @__PURE__ */ jsx(ContentOuter$6, {
      children
    });
  }
  const onClick = (ev) => {
    ev.stopPropagation();
    ev.preventDefault();
    onLinkClick(ev, post);
  };
  return /* @__PURE__ */ jsx(ContentOuterLink$4, {
    onClick,
    children
  });
};
const PostOuter = styled(CardOuter)`

`;
const PostCardImp$1 = (props) => {
  const {
    cardImage
  } = useCardsTheme();
  const {
    data,
    ...other
  } = props;
  if (cardImage) {
    const {
      image
    } = data;
    return /* @__PURE__ */ jsx(PostOuter, {
      ...other,
      children: /* @__PURE__ */ jsxs(PostContentWrapper, {
        children: [/* @__PURE__ */ jsx(Image$1, {
          image,
          square: true
        }), /* @__PURE__ */ jsx(ContentBodyWrapper$6, {
          children: /* @__PURE__ */ jsx(PostContentBody$1, {})
        })]
      })
    });
  }
  return /* @__PURE__ */ jsx(PostOuter, {
    ...other,
    children: /* @__PURE__ */ jsx(PostContentWrapper, {
      children: /* @__PURE__ */ jsx(PostContentBody$1, {})
    })
  });
};
const ArticleSummaryCore2 = (props) => {
  const {
    membership,
    profile
  } = props;
  const handleClick = () => {
    const {
      article,
      onClick
    } = props;
    if (onClick) {
      onClick(article);
    }
  };
  const {
    article: post,
    overflowMenu,
    className,
    selected
  } = props;
  return /* @__PURE__ */ jsx(PostCard$2, {
    link: true,
    showImage: true,
    className,
    selected,
    data: post,
    onLinkClick: handleClick,
    menu: /* @__PURE__ */ jsx(ArticleMenu, {
      article: post,
      overflowMenu,
      membership,
      profile
    })
  });
};

const createEvent = (event) => execute("createEvent", event);

const openSettings = () => execute("openSettings");

const useOpenSettingsDialog = () => {
  if (!isExpoWrapper()) {
    return {
      dialog: null
    };
  }
  const [openSettingsDialog, setOpenSettingsDialog] = useState(false);
  const onOpenSettings = () => {
    setOpenSettingsDialog(false);
    openSettings();
  };
  const dialog = /* @__PURE__ */ jsx(ConfirmDialog, {
    content: "Calendar permission is required. Open your application settings!",
    open: openSettingsDialog,
    onClose: () => setOpenSettingsDialog(false),
    children: /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: onOpenSettings,
      children: "Open Settings"
    })
  });
  return {
    dialog,
    setOpenSettingsDialog
  };
};

const useCalendar = () => {
  if (!isExpoWrapper()) {
    return {
      dialog: null
    };
  }
  const {
    dialog,
    setOpenSettingsDialog
  } = useOpenSettingsDialog();
  const createEventMobile = errorsReported(async (event) => {
    const result = await createEvent(event);
    if (result.needsSetup) {
      setOpenSettingsDialog(true);
      return;
    }
    toast$1("Added to your calendar");
    return result;
  });
  return {
    dialog,
    createEvent: createEventMobile
  };
};

const isAdmin = (membership) => membership && membership.role === "ADMIN";
const isAuthor = (target, profile) => {
  return profile && target && (target.author["_id"] === profile._id || target.author === profile._id);
};

const useSendInvitation = (options) => {
  const api = useApi();
  const {
    onClick,
    loading
  } = useLoading(async (req) => {
    const {
      template,
      post
    } = req || options;
    await api.makeRequest({
      path: "/events/send-invitation/" + post._id,
      method: "POST",
      body: {
        template
      }
    });
    toast("Invitation was sent");
    await delay$1(1e3);
  }, {
    message: "Sending invitation"
  });
  return {
    onClick,
    loading
  };
};

const deleteCircleApi$1 = (api, id) => {
  return api.makeRequest({
    path: `/groups/${id}`,
    method: "DELETE"
  });
};

const useJoinedCircles = () => {
  const api = useApi();
  return useSWR(!isSSR() && `/groups/joined/`, () => api.loadJoinedGroups({
    access: "READ_WRITE",
    status: "open"
  }), swrLoadOnce);
};

const info$4 = createLogger("info:ui");
const Dialog$5 = styled(Dialog$6)`
    & .MuiDialog-paperScrollPaper {
        max-width: 80%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    & .MuiListItemText-primary {
        max-height: 1.5em;
        overflow: hidden;
    }

`;
const MoveToCircleList = ({
  post: moved,
  onSuccess = () => null
}) => {
  const api = useApi();
  const {
    data
  } = useJoinedCircles();
  if (!data) {
    return null;
  }
  info$4("membership data: %o", data);
  const circles = data.values.map((membership) => membership.group).filter((g) => g._id !== moved.group.group._id);
  const circleSelected = async (circle) => {
    const old = await api.loadDraft({
      _id: moved.draft
    });
    console.log("old", old);
    const draft = await api.upsertDraft({
      ...old,
      group: {
        group: circle._id,
        privacy: circle.privacy
      }
    });
    console.log("draft:", draft);
    const post = await api.publish(draft);
    console.log("post:", post);
    onSuccess();
  };
  return /* @__PURE__ */ jsx(List, {
    dense: true,
    children: circles.map((circle) => {
      const id = circle._id;
      return /* @__PURE__ */ jsxs(ListItem, {
        children: [/* @__PURE__ */ jsx(ListItemText, {
          primary: circle.name
        }), /* @__PURE__ */ jsx(ListItemSecondaryAction$1, {
          children: /* @__PURE__ */ jsx(IconButton$5, {
            edge: "end",
            "aria-label": "move to circle",
            onClick: () => circleSelected(circle),
            children: /* @__PURE__ */ jsx(FiChevronsRight, {})
          })
        })]
      }, id);
    })
  });
};
const MoveAssetDialog = (props) => {
  const {
    open,
    onClose
  } = props;
  if (!open) {
    return null;
  }
  const {
    post,
    ...other
  } = props;
  return /* @__PURE__ */ jsxs(Dialog$5, {
    ...other,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose: () => onClose(),
      children: "Move to other circle"
    }), /* @__PURE__ */ jsx(MoveToCircleList, {
      post,
      onSuccess: () => onClose(true)
    })]
  });
};

const CloseGroupDialog = () => {
  const api = useApi();
  const {
    circle
  } = useCircleContext();
  const {
    outcome,
    setOutcome
  } = useCircleModalDialogsContext();
  if (!outcome) {
    return null;
  }
  const onClose = () => {
    setOutcome(void 0);
  };
  const closeGroupWithOutcome = errorsReported(async (ev) => {
    await api.closeGroup({
      group: circle._id,
      outcome
    });
    window.location.reload();
  });
  return /* @__PURE__ */ jsxs(Dialog$6, {
    onClose: () => onClose(),
    "aria-labelledby": "close-group-with_outcome",
    open: true,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose: () => onClose(),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.close"
      })
    }), /* @__PURE__ */ jsxs(DialogContent, {
      dividers: true,
      children: [/* @__PURE__ */ jsx("h2", {
        children: /* @__PURE__ */ jsx(ImportantMessage, {
          i18nKey: "group.you_are_closing_this_group"
        })
      }), /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("span", {
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "group.outcome_to_be_pinned"
          })
        }), /* @__PURE__ */ jsxs("span", {
          children: ['"', outcome.title, '"']
        })]
      })]
    }), /* @__PURE__ */ jsxs(DialogActions, {
      children: [/* @__PURE__ */ jsx(Button, {
        color: "primary",
        onClick: closeGroupWithOutcome,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.close_and_set_outcome"
        })
      }), /* @__PURE__ */ jsx(Button, {
        onClick: onClose,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "general.cancel"
        })
      })]
    })]
  });
};

const PostInfoContextForDraft = ({
  children,
  profile,
  draft
}) => {
  const event$ = useEventEmitter();
  const infoContext = useMemo(() => ({
    rating: {},
    userVote: {},
    notesInfo: {},
    post: draft,
    profile,
    loadResponses: noop$B,
    loadPost: noop$B,
    event$,
    postCircleError: null,
    postError: null,
    profileError: null
  }), [profile, draft]);
  return /* @__PURE__ */ jsx(PostInfoContext.Provider, {
    value: infoContext,
    children
  });
};

const blocksApi = (api, draftId, options) => {
  return api.makeRequest({
    path: `/drafts/${draftId}/blocks`,
    method: "POST",
    body: options
  });
};
const publishBlocksApi = (api, draftId) => {
  return api.makeRequest({
    path: `/drafts/${draftId}/publish-blocks`,
    method: "POST"
  });
};

const cleanContentBlocks = (cb) => {
  if (!cb) {
    return cb;
  }
  const {
    order,
    blocks
  } = cb;
  const order1 = order.filter((o) => blocks[o]);
  const blocks1 = {};
  order1.forEach((id) => {
    blocks1[id] = blocks[id];
  });
  return {
    order: order1,
    blocks: blocks1
  };
};

const BLOCK_MAIN = "main";
const BLOCK_REPLIES = "replies";
const BLOCK_TINY = "tiny";
const BLOCK_ATTACHMENT = "attachment";
const BLOCK_TITLE = "title";

const noop$r = () => null;
const BlocksOrderContext = React__default.createContext({
  order: [],
  addBlock: noop$r,
  moveBlock: noop$r,
  removeBlock: noop$r,
  setOrder: noop$r
});
const defaultOrder = () => [BLOCK_MAIN, BLOCK_REPLIES];
const BlocksOrderContextProvider = ({
  children,
  blocksOrder
}) => {
  const api = useApi();
  const {
    draftId,
    edited
  } = useBlocksContext();
  const {
    run: runSaveRequest,
    cancel: cancelSave
  } = useRequest(async (order2) => {
    await blocksApi(api, draftId, {
      order: order2
    });
  }, {
    manual: true,
    retryCount: -1
  });
  const [order, setOrder] = useState(() => blocksOrder || defaultOrder());
  useEffect(() => {
    if (!edited) {
      cancelSave();
      return;
    }
    runSaveRequest(order);
  }, [order]);
  useDeepCompareEffect(() => {
    setOrder(blocksOrder || defaultOrder());
  }, [blocksOrder]);
  const addBlock = useCallback((blockId, afterId) => {
    setOrder((order2) => {
      if (!afterId) {
        return [blockId, ...order2];
      }
      const old = order2.slice();
      const pos = order2.indexOf(afterId);
      old.splice(pos + 1, 0, blockId);
      return old;
    });
  }, []);
  const moveBlock = useCallback((blockId, pos) => {
    setOrder((order2) => {
      const old = order2.slice();
      old.splice(pos, 0, old.splice(old.indexOf(blockId), 1)[0]);
      return old;
    });
  }, []);
  const removeBlock = useCallback((blockId) => {
    setOrder((order2) => {
      const old = order2.slice();
      old.splice(old.indexOf(blockId), 1);
      return old;
    });
  }, []);
  const context = useMemo(() => {
    return {
      order,
      setOrder,
      addBlock,
      moveBlock,
      removeBlock
    };
  }, [order]);
  return /* @__PURE__ */ jsx(BlocksOrderContext.Provider, {
    value: context,
    children
  });
};
const BlocksContext = React__default.createContext({
  draftId: void 0,
  blocks: {},
  edited: void 0,
  setEdited: noop$r,
  saveBlock: noop$r,
  removeBlock: noop$r,
  event$: {
    emit: noop$r,
    useSubscription: noop$r
  }
});
const useBlocksContext = () => {
  return useContext(BlocksContext);
};
const useBlocksOrderContext = () => {
  return useContext(BlocksOrderContext);
};
const defaultBlocks = () => {
  return {
    [BLOCK_MAIN]: {
      type: BLOCK_MAIN,
      id: BLOCK_MAIN
    },
    [BLOCK_REPLIES]: {
      type: BLOCK_REPLIES,
      id: BLOCK_REPLIES
    }
  };
};
const BLOCK_EVENT_SAVE = "save";
const BlocksContextProvider = ({
  children,
  post,
  edited: editedInitially
}) => {
  const [edited, setEdited] = useState(() => {
    return cleanContentBlocks(editedInitially && post && post.contentBlocks);
  });
  const event$ = useEventEmitter();
  const postContentBlocks = post && post.contentBlocks;
  const contentBlocks = edited ? edited.blocks : postContentBlocks && postContentBlocks.blocks;
  const blocksOrder = edited ? edited.order : postContentBlocks && postContentBlocks.order;
  const draftId = post && (post.draft || post._id);
  const [blocks, setBlocks] = useState(() => {
    if (contentBlocks) {
      return contentBlocks;
    }
    return defaultBlocks();
  });
  const saveBlock = useCallback((block) => {
    setBlocks((blocks2) => {
      return {
        ...blocks2,
        [block.id]: block
      };
    });
  }, []);
  const removeBlock = useCallback((blockId) => {
    setBlocks((blocks2) => {
      const all = {
        ...blocks2
      };
      delete all[blockId];
      return all;
    });
  }, []);
  useDeepCompareEffect(() => {
    setBlocks(contentBlocks || defaultBlocks());
  }, [contentBlocks]);
  const context = useMemo(() => {
    return {
      draftId,
      blocks,
      edited,
      saveBlock,
      setEdited,
      removeBlock,
      event$
    };
  }, [blocks, edited, draftId]);
  return /* @__PURE__ */ jsx(BlocksContext.Provider, {
    value: context,
    children: /* @__PURE__ */ jsx(BlocksOrderContextProvider, {
      blocksOrder,
      children
    })
  });
};

const generateUUID = () => {
  var d = new Date().getTime();
  var d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1e3 || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : r & 3 | 8).toString(16);
  });
};
const useLastCreated = (id) => {
  const v = lastCreated === id;
  if (v) {
    lastCreated = void 0;
  }
  return v;
};
let lastCreated;
const useAddBlock = () => {
  const api = useApi();
  const {
    saveBlock,
    draftId
  } = useBlocksContext();
  const {
    addBlock
  } = useBlocksOrderContext();
  const insertBlock = (id) => {
    const block = {
      id: generateUUID(),
      type: BLOCK_TINY
    };
    lastCreated = block.id;
    saveBlock(block);
    addBlock(block.id, id);
    blocksApi(api, draftId, {
      block
    });
  };
  return {
    insertBlock
  };
};

const noop$q = () => null;
const BlockContext = React__default.createContext({
  block: void 0,
  edited: false,
  active: false,
  setEdited: noop$q,
  drop: noop$q,
  add: noop$q,
  save: noop$q,
  up: noop$q,
  down: noop$q,
  event$: {
    emit: noop$q,
    useSubscription: noop$q
  }
});
const useBlockContext = () => {
  return useContext(BlockContext);
};
const BlockContextProvider = React__default.memo(({
  children,
  id,
  pos,
  total
}) => {
  const api = useApi();
  const {
    blocks,
    edited: active,
    saveBlock,
    draftId,
    event$,
    removeBlock
  } = useBlocksContext();
  const {
    insertBlock
  } = useAddBlock();
  const {
    removeBlock: removeBlockFromOrder,
    moveBlock
  } = useBlocksOrderContext();
  const {
    run: runSaveRequest,
    cancel: cancelSaveBlock
  } = useRequest(async (block2) => {
    await blocksApi(api, draftId, {
      block: block2
    });
  }, {
    manual: true,
    retryCount: -1
  });
  const block = blocks && blocks[id];
  const justCreated = useLastCreated(id);
  const [edited, setEdited] = useState(justCreated);
  const add = useMemoizedFn(() => {
    setEdited(false);
    insertBlock(id);
  });
  const save = useMemoizedFn((saved) => {
    if (deepEqual(block, saved)) {
      return;
    }
    saveBlock(saved);
    runSaveRequest(saved);
  });
  const drop = useMemoizedFn(() => {
    removeBlock(id);
    removeBlockFromOrder(id);
    blocksApi(api, draftId, {
      deleted: id
    });
  });
  const up = useMemoizedFn(() => {
    if (!pos) {
      return;
    }
    moveBlock(id, pos - 1);
  });
  const down = useMemoizedFn(() => {
    if (pos === total - 1) {
      return;
    }
    moveBlock(id, pos + 1);
  });
  useEffect(() => {
    if (!active) {
      cancelSaveBlock();
    }
  }, [active]);
  const context = useMemo(() => {
    return {
      block,
      edited,
      setEdited,
      active: !!active,
      add,
      save,
      event$,
      drop,
      up,
      down
    };
  }, [block, edited, !!active]);
  return /* @__PURE__ */ jsx(BlockContext.Provider, {
    value: context,
    children
  });
});

const useCanEditPost = () => {
  const {
    membership,
    post,
    profile
  } = usePostInfoContext();
  if (!post || !profile) {
    return false;
  }
  const author = typeof post.author === "string" ? post.author : post.author._id;
  if (author === profile._id) {
    return true;
  }
  if (!membership) {
    return false;
  }
  return membership.role !== "ADMIN";
};

const noop$p = () => null;
const EditPostToggleButton = () => {
  const {
    notifyBlocks
  } = useSaveBlocks({
    onSave() {
      setEdited(void 0);
    }
  });
  const api = useApi();
  usePostInfoContext();
  const {
    edited,
    setEdited,
    draftId
  } = useBlocksContext();
  const canEdit = useCanEditPost();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    if (edited) {
      await notifyBlocks();
      return;
    }
    const draft = await api.loadDraft({
      _id: draftId
    });
    setEdited(cleanContentBlocks(draft.contentBlocks) || {
      order: defaultOrder(),
      blocks: defaultBlocks()
    });
  }, {
    message: edited ? "Saving draft" : "Loading post draft"
  });
  if (!canEdit) {
    return null;
  }
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Edit/save draft",
    children: /* @__PURE__ */ jsx(IconButton$5, {
      onClick,
      children: loading ? /* @__PURE__ */ jsx(CircularProgress, {}) : !edited ? /* @__PURE__ */ jsx(MdOutlineEdit, {}) : /* @__PURE__ */ jsx(MdOutlineEditOff, {})
    })
  });
};

const useCreateDraftFn = () => {
  const api = useApi();
  const create = async (update = {}) => {
    const {
      title = "New post"
    } = update;
    const titleBlock = {
      id: "title",
      type: BLOCK_TITLE,
      content: title
    };
    const draft = await api.upsertDraft({
      attachments: [],
      tags: [],
      content: {
        "blocks": [{
          "key": "bi6ur",
          "text": title,
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }],
        "entityMap": {}
      },
      contentBlocks: {
        order: ["title"],
        blocks: {
          title: titleBlock
        }
      },
      ...update
    });
    return draft;
  };
  return create;
};
const useUpdateDraftFn = () => {
  const api = useApi();
  const update = async (update2) => {
    const {
      title,
      _id
    } = update2;
    const draft = await api.upsertDraft({
      _id,
      content: {
        "blocks": [{
          "key": "bi6ur",
          "text": title,
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }],
        "entityMap": {}
      },
      ...update2
    });
    return draft;
  };
  return update;
};

const useSaveBlocks = ({
  onSaveError = noop$p,
  onSave = noop$p,
  publish
} = {}) => {
  const api = useApi();
  const updateDraft = useUpdateDraftFn();
  const {
    order
  } = useBlocksOrderContext();
  const {
    draftId,
    event$
  } = useBlocksContext();
  const saveBlocks = (options) => (block) => {
    const {
      blocks,
      resolve
    } = options;
    if (block) {
      blocks[block.id] = block;
    }
    options.total = !options.total ? 1 : options.total + 1;
    if (options.total === order.length) {
      saveDraft(blocks, resolve);
    }
  };
  const saveDraft = async (blocks, resolve) => {
    try {
      await blocksApi(api, draftId, cleanContentBlocks({
        blocks,
        order
      }));
      const titleId = order.find((id) => {
        if (blocks[id] && blocks[id].type === BLOCK_TITLE) {
          return true;
        }
      });
      if (titleId) {
        const titleBlock = blocks[titleId];
        const title = titleBlock.content;
        await updateDraft({
          title,
          _id: draftId
        });
      }
      if (publish) {
        await publishBlocksApi(api, draftId);
      }
      onSave();
    } catch (error) {
      console.error(error);
      errorToast({
        error
      });
      onSaveError(error);
    } finally {
      resolve();
    }
  };
  const notifyBlocks = () => {
    return new Promise((resolve, reject) => {
      event$.emit({
        type: BLOCK_EVENT_SAVE,
        saveBlock: saveBlocks({
          blocks: {},
          total: 0,
          resolve
        })
      });
    });
  };
  return {
    saveBlocks,
    notifyBlocks
  };
};

const SaveBlocksButton = () => {
  const {
    notifyBlocks
  } = useSaveBlocks({
    onSave() {
      toast("Successfully saved");
    }
  });
  const canEdit = useCanEditPost();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    await notifyBlocks();
  }, {
    message: "Saving draft"
  });
  if (!canEdit) {
    return null;
  }
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Edit/save draft",
    children: /* @__PURE__ */ jsx(IconButton$5, {
      onClick,
      children: loading ? /* @__PURE__ */ jsx(CircularProgress, {}) : /* @__PURE__ */ jsx(MdSave, {})
    })
  });
};

const PublishBlocksButton = () => {
  const {
    notifyBlocks
  } = useSaveBlocks({
    onSave() {
      toast("Successfully published");
    },
    publish: true
  });
  const canEdit = useCanEditPost();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    await notifyBlocks();
  }, {
    message: "Saving draft"
  });
  if (!canEdit) {
    return null;
  }
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Save and publish post",
    children: /* @__PURE__ */ jsx(Button, {
      variant: "outlined",
      color: "primary",
      size: "small",
      onClick,
      children: loading ? /* @__PURE__ */ jsx(CircularProgress, {}) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(MdPublishedWithChanges, {}), /* @__PURE__ */ jsx("span", {
          children: "\xA0Publish"
        })]
      })
    })
  });
};

const AddBlockButton = () => {
  const {
    insertBlock
  } = useAddBlock();
  const canEdit = useCanEditPost();
  if (!canEdit) {
    return null;
  }
  const onClick = () => {
    insertBlock();
  };
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Add new block",
    children: /* @__PURE__ */ jsx(IconButton$5, {
      onClick,
      children: /* @__PURE__ */ jsx(MdAdd, {})
    })
  });
};

const useBlockSaver = ({
  update = (v) => v
} = {}) => {
  const {
    block,
    event$
  } = useBlockContext();
  event$.useSubscription((event) => {
    console.log("Event:", event);
    const {
      type
    } = event;
    switch (type) {
      case BLOCK_EVENT_SAVE:
        event.saveBlock(update(block));
        break;
    }
  });
};

const TagsWrapper = styled.div`
    margin-bottom: 32px;
    & .MuiChip-outlined {
        border: none;
        background-color: #23a7df;
        color: #fff;        
    }

    & .MuiTypography-colorPrimary {
        color: #fff;
    }

    & .NsTag-view {
        cursor: pointer;
        margin-right: 10px;
    }

    & .MuiChip-root {
        height: 21px;
    }
`;
const TagsLineWrapper = styled(TagsWrapper)`
    margin-right: 10px;
`;
const Tag = ({
  view,
  ...other
}) => {
  const {
    label,
    ...props
  } = other;
  if (view) {
    return /* @__PURE__ */ jsx(Link$1, {
      component: Link$2,
      to: `/news/${label}`,
      underline: "none",
      children: /* @__PURE__ */ jsx(Chip$1, {
        variant: "outlined",
        className: clsx(view && "NsTag-view", "NsTag"),
        ...other
      })
    });
  }
  return /* @__PURE__ */ jsx(Chip$1, {
    variant: "outlined",
    className: clsx(view && "NsTag-view", "NsTag"),
    ...props,
    label: /* @__PURE__ */ jsx(Link$1, {
      component: Link$2,
      to: `/news/${label}`,
      underline: "none",
      children: label
    })
  });
};
const TagsLine = ({
  tags = []
}) => {
  if (!tags.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(TagsLineWrapper, {
    children: tags.map((tag) => /* @__PURE__ */ jsx(Tag, {
      label: tag,
      view: true
    }, tag))
  });
};
const TagsPicker$2 = () => {
  const [options, setOptions] = useState([]);
  const api = useApi();
  const helper = useFormContext();
  const {
    tags = []
  } = useFormData();
  useEffect(() => {
    helper.tags = tags;
  }, tags);
  return /* @__PURE__ */ jsx(TagsWrapper, {
    children: /* @__PURE__ */ jsx(Autocomplete$1, {
      multiple: true,
      id: "tags-filled",
      options,
      defaultValue: tags,
      freeSolo: true,
      renderTags: (value, getTagProps) => value.map((option, index) => /* @__PURE__ */ jsx(Tag, {
        label: option,
        ...getTagProps({
          index
        })
      }, option)),
      renderInput: (params) => /* @__PURE__ */ jsx(TextField$1, {
        ...params,
        placeholder: "Add Tags"
      }),
      onChange: (event, newValue) => {
        helper.tags = newValue;
      },
      onInputChange: async (_event, newInputValue) => {
        const result = await api.suggestTags({
          filter: newInputValue,
          range: {
            start: 1,
            end: 10
          }
        });
        const tags2 = (result.values || []).map((v) => v.tag);
        setOptions(tags2);
      }
    })
  });
};

const noop$o = () => null;
const uploadFiles = async (api, attached, onProgress = noop$o) => {
  const saved = await api.upload(attached.filter((f) => !f.uuid).reduce((r, f, i) => {
    r[i] = f;
    return r;
  }, {
    onProgress
  }));
  console.log("saved files:", saved);
  let lastFromSaved = 0;
  const combined = attached.map((f) => {
    if (f.uuid) {
      return f;
    }
    return saved[lastFromSaved++];
  });
  console.log("combined files:", combined);
  return combined;
};

const useImageUrl = (value) => {
  const {
    instanceName,
    cdnRoot
  } = useCDNImageContext();
  const {
    uuid
  } = value;
  return `${cdnRoot}${instanceName}/${uuid}`;
};
const useImageUrlFn = () => {
  const {
    instanceName,
    cdnRoot
  } = useCDNImageContext();
  return (value) => {
    const {
      uuid
    } = value;
    return `${cdnRoot}${instanceName}/${uuid}`;
  };
};

const FileViewWrapper$1 = styled.div`
    margin-bottom: 10px;
    && > * {
        margin-right: 10px;
    }
`;
const FileView = ({
  value,
  onRemove,
  children
}) => {
  const url = useImageUrl(value);
  const {
    uuid,
    contentType,
    originalFileName,
    originalFileSize
  } = value;
  if (contentType && contentType.startsWith("image/")) {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-start gap-1",
      children: [/* @__PURE__ */ jsx(Link$1, {
        href: url,
        download: true,
        target: "_blank",
        underline: "always",
        children: /* @__PURE__ */ jsx(ScaledImageProxy, {
          h: 70,
          w: 140,
          uuid
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col self-start flex-grow overflow-hidden",
        children: [/* @__PURE__ */ jsx("div", {
          className: "text-ellipsis overflow-hidden max-w-xs whitespace-nowrap",
          children: originalFileName
        }), /* @__PURE__ */ jsx("div", {
          children: humanFileSize(originalFileSize)
        })]
      }), onRemove && /* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx(IconButton$5, {
          onClick: onRemove,
          children: /* @__PURE__ */ jsx(LiaWindowClose, {
            size: 18
          })
        })
      })]
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [originalFileName, /* @__PURE__ */ jsxs(FileViewWrapper$1, {
      children: [/* @__PURE__ */ jsx(Link$1, {
        href: url,
        download: true,
        target: "_blank",
        underline: "always",
        children: "download"
      }), children]
    })]
  });
};

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center
    align-content: center;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
`;
const FormPage = styled.div`
    background-color: rgb(240, 235, 248);
`;
const fields = [{
  title: "Asset name (becomes Title of Post)",
  name: "name"
}, {
  title: "Asset address (if appropriate)",
  name: "address"
}, {
  title: "Asset preferred contact details (if appropriate)",
  name: "contact"
}, {
  title: "Asset description (what does it offer the local community and when)",
  name: "link_description"
}, {
  title: "Please upload any photos you have of the asset",
  name: "pictures",
  type: "file"
}];
const FieldCardWrapper = styled(Card$1)`
    margin-bottom: 2rem;
    width: 100%;
`;
const FormTitle = styled(Typography).attrs({
  variant: "h3",
  component: "h3"
})`
    &.MuiTypography-root {
        margin-bottom: 2rem;        
    }
`;
const FieldCard = (field) => {
  const helper = useFormField(field);
  const {
    old
  } = useFormData();
  const {
    title,
    type,
    name
  } = field;
  const InputComponent = helper.getComponent();
  old && old[name];
  if (type === "file") {
    console.log();
  }
  return /* @__PURE__ */ jsx(FieldCardWrapper, {
    children: /* @__PURE__ */ jsxs(CardContent, {
      children: [/* @__PURE__ */ jsx(Typography, {
        variant: "h5",
        component: "h5",
        children: title
      }), /* @__PURE__ */ jsx(InputComponent, {
        style: {
          width: "100%"
        },
        ...helper.getProps(old)
      })]
    })
  });
};
const FormFilesView = ({
  value
}) => {
  if (!Array.isArray(value)) {
    return null;
  }
  return /* @__PURE__ */ jsx(Fragment, {
    children: value.map((v, i) => /* @__PURE__ */ jsx(FileView, {
      value: v
    }, i))
  });
};
const FieldCardView = ({
  field,
  value
}) => {
  const {
    title,
    name,
    type
  } = field;
  const content = value[name];
  if (content === void 0) {
    return null;
  }
  const display = type === "file" ? /* @__PURE__ */ jsx(FormFilesView, {
    value: content
  }) : content;
  return /* @__PURE__ */ jsx(FieldCardWrapper, {
    children: /* @__PURE__ */ jsxs(CardContent, {
      children: [/* @__PURE__ */ jsx(Typography, {
        variant: "h5",
        component: "h5",
        children: title
      }), display]
    })
  });
};
const FormActionsWrapper = styled.div`
    margin-bottom: 2rem;
`;
const FormActions = ({
  onCreated = () => null
}) => {
  const helper = useFormActions();
  const api = useApi();
  const {
    circleId,
    old = {},
    draftId
  } = useFormData();
  const onSubmit = async () => {
    const value = helper.values();
    console.log("value:", value);
    const files = fields.filter((f) => f.type === "file" && value[f.name]);
    if (files.length) {
      for (const file of files) {
        const attached = value[file.name];
        const combined = await uploadFiles(api, attached);
        value[file.name] = combined;
      }
    }
    const data = Object.fromEntries(Object.entries({
      ...old,
      ...value
    }).filter(([_, v]) => v !== ""));
    const image = fields.filter((f) => f.type === "file" && (value[f.name] || old[f.name])).flatMap((f) => value[f.name] || old[f.name]).find((p) => {
      const {
        contentType
      } = p;
      return contentType && contentType.startsWith("image/");
    });
    const title = value.name === void 0 ? old.name || "new asset" : value.name || "new asset";
    const draft = await api.upsertDraft({
      _id: draftId || void 0,
      attachments: [],
      tags: helper.tags() || [],
      group: {
        group: circleId
      },
      image,
      content: {
        "blocks": [{
          "key": "bi6ur",
          "text": title,
          "type": "unstyled",
          "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }],
        "entityMap": {}
      },
      form: {
        data
      },
      type: "asset"
    });
    console.log("draft:", draft);
    const post = await api.publish(draft);
    console.log("post:", post);
    onCreated({
      post,
      draft
    });
  };
  return /* @__PURE__ */ jsx(FormActionsWrapper, {
    children: /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: onSubmit,
      children: "Submit"
    })
  });
};
class FormHelper {
  constructor() {
    this.fields = {};
    this.actions = [];
  }
  valueChanged(field) {
    Object.values(this.fields).filter((f) => f !== field).forEach((f) => f.valueChanged(field));
    this.actions.forEach((a) => a.valueChanged(field));
  }
  addField(field, helper) {
    this.fields[field.name] = helper;
  }
  addActions(current) {
    this.actions.push(current);
  }
  values() {
    return Object.values(this.fields).reduce((data, field) => {
      const value = field.getValue();
      if (value !== void 0) {
        data[field.name] = value;
      }
      return data;
    }, {});
  }
}
class FormFieldHelper {
  constructor(field, form, setCounter) {
    this.field = field;
    this.form = form;
    this.setCounter = setCounter;
    this.onBlur = () => {
    };
    this.onChange = (e) => {
      const {
        value
      } = e.target;
      this.value = value;
      this.form.valueChanged(this);
      this.triggerUpdate();
    };
    this.name = field.name;
  }
  isModified() {
    return this.value !== void 0;
  }
  valueChanged(field) {
  }
  getValue() {
    return this.value;
  }
  getComponent() {
    switch (this.field.type) {
      case "date":
        return FormDatePicker;
      case "file":
        return UploadFileButton;
    }
    return TextField$1;
  }
  getProps(old) {
    const name = this.field.name;
    switch (this.field.type) {
      case "date":
        return {
          date: this.value ? this.value : old && old[name] || new Date(),
          label: "Your answer",
          onChangeDate: (date) => {
            this.onChange({
              target: {
                value: date
              }
            });
          }
        };
      case "file":
        return {
          field: this.field,
          onFilesChanged: (acceptedFiles) => {
            this.onChange({
              target: {
                value: acceptedFiles
              }
            });
          }
        };
    }
    return {
      label: "Your answer",
      name,
      onBlur: this.onBlur,
      onChange: this.onChange,
      defaultValue: old && old[name]
    };
  }
  triggerUpdate() {
    this.setCounter((v) => v + 1);
  }
}
const FormContext = React__default.createContext(void 0);
const useFormContext = () => {
  return useContext(FormContext);
};
const useFormField = (field) => {
  const helper = useFormContext();
  const fieldHelperRef = useRef();
  const [_, setCounter] = useState(0);
  if (!fieldHelperRef.current) {
    fieldHelperRef.current = new FormFieldHelper(field, helper, setCounter);
    helper.addField(field, fieldHelperRef.current);
  }
  return fieldHelperRef.current;
};
class FormActionsHelper {
  constructor(form, setCounter) {
    this.form = form;
    this.setCounter = setCounter;
  }
  valueChanged(field) {
  }
  triggerUpdate() {
    this.setCounter((v) => v + 1);
  }
  values() {
    return this.form.values();
  }
  tags() {
    return this.form.tags;
  }
}
const useFormActions = () => {
  const helper = useFormContext();
  const actionsHelperRef = useRef();
  const [_, setCounter] = useState(0);
  if (!actionsHelperRef.current) {
    actionsHelperRef.current = new FormActionsHelper(helper, setCounter);
    helper.addActions(actionsHelperRef.current);
  }
  return actionsHelperRef.current;
};
const FormContextProvider = ({
  children
}) => {
  const helperRef = useRef();
  if (!helperRef.current) {
    helperRef.current = new FormHelper();
  }
  return /* @__PURE__ */ jsx(FormContext.Provider, {
    value: helperRef.current,
    children
  });
};
const FormDataContext = React__default.createContext({
  circleId: void 0,
  old: void 0,
  draftId: void 0,
  tags: void 0
});
const FormDataContextProvider = ({
  children,
  tags,
  old,
  ...other
}) => {
  const value = {
    tags: old ? tags : ["entry", "community asset mapping"],
    old,
    ...other
  };
  return /* @__PURE__ */ jsx(FormDataContext.Provider, {
    value,
    children
  });
};
const useFormData = () => {
  return useContext(FormDataContext);
};
const FormView = ({
  value,
  tags
}) => {
  if (!value) {
    return null;
  }
  return /* @__PURE__ */ jsx(FormPage, {
    children: /* @__PURE__ */ jsxs(FormWrapper, {
      children: [/* @__PURE__ */ jsx(FormTitle, {
        children: "Asset"
      }), /* @__PURE__ */ jsx(TagsLine, {
        tags
      }), fields.map((f) => /* @__PURE__ */ jsx(FieldCardView, {
        field: f,
        value
      }, f.name))]
    })
  });
};
const FillForm = ({
  onCreated = () => null
}) => {
  return /* @__PURE__ */ jsx(MuiPickersUtilsProvider, {
    locale: getBrowserLanguage(),
    utils: MomentUtils,
    children: /* @__PURE__ */ jsx(FormContextProvider, {
      children: /* @__PURE__ */ jsx(FormPage, {
        children: /* @__PURE__ */ jsxs(FormWrapper, {
          children: [/* @__PURE__ */ jsx(FormTitle, {
            children: "Asset register form"
          }), /* @__PURE__ */ jsx(TagsPicker$2, {}), fields.map((f) => /* @__PURE__ */ jsx(FieldCard, {
            ...f
          }, f.name)), /* @__PURE__ */ jsx(FormActions, {
            onCreated
          })]
        })
      })
    })
  });
};

const ActionsWrapper = styled.div`
    margin-bottom: 10px;
`;
const FileImage = ({
  file
}) => {
  const [dataUrl, setDateUrl] = useState("");
  useEffect(() => {
    const fileType = file["type"];
    const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
    const notImage = !validImageTypes.includes(fileType);
    if (notImage) {
      return;
    }
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setDateUrl(reader.result);
    }, false);
    reader.readAsDataURL(file);
  }, [file]);
  if (!dataUrl) {
    return null;
  }
  return /* @__PURE__ */ jsx("img", {
    src: dataUrl,
    height: "200"
  });
};
const UploadFileButton = ({
  onFilesChanged,
  field
}) => {
  const {
    old
  } = useFormData();
  const last = old && old[field.name];
  const defaultValue = last || [];
  return /* @__PURE__ */ jsx(UploadButton$1, {
    defaultValue,
    onFilesChanged
  });
};
const UploadButton$1 = ({
  onFilesChanged,
  defaultValue,
  value
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const api = useApi();
  const onClick = () => {
    setDialogOpen(true);
  };
  const [files, setFiles] = value ? [value, (f) => typeof f === "function" ? f(value) : null] : useState(defaultValue || []);
  const onRemove = (ev, file, _id) => {
    ev.preventDefault();
    setFiles((files2) => {
      const removed = files2.filter((f) => f !== file);
      onFilesChanged(removed);
      return removed;
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex flex-col items-stretch w-full gap-2",
      children: files.map((file, i) => {
        const f = file;
        const removeButton = /* @__PURE__ */ jsx(Link$1, {
          href: "#",
          underline: "always",
          onClick: (ev) => onRemove(ev, file),
          children: "remove"
        });
        if (f.name) {
          return /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx(FileImage, {
              file: f
            }), /* @__PURE__ */ jsx("div", {
              className: "overflow-hidden",
              children: f.name
            }), /* @__PURE__ */ jsx(ActionsWrapper, {
              children: removeButton
            })]
          }, i);
        }
        return /* @__PURE__ */ jsx(FileView, {
          value: file,
          onRemove: (ev) => onRemove(ev, file),
          children: removeButton
        }, i);
      })
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick,
      children: /* @__PURE__ */ jsx(MdOutlineFileUpload, {})
    }), /* @__PURE__ */ jsx(UploadFileDialog$1, {
      open: dialogOpen,
      onClose: async (ev) => {
        setDialogOpen(false);
        if (ev.type === "files") {
          const {
            acceptedFiles
          } = ev.detail;
          const all = [...files, ...acceptedFiles];
          const updated = await uploadFiles(api, all);
          setFiles(updated);
          onFilesChanged(updated);
        }
      }
    })]
  });
};
const Dialog$4 = styled(Dialog$6)`
    & .MuiDialogContent-root {
        padding: 5px 24px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    & .MuiList-root {
        overflow-y: auto;
    }

    & .MuiDialog-paperScrollPaper {
        width: calc(100% - 64px);
        max-width: calc(100% - 64px);
    }
`;
const UploadFileDialog$1 = (props) => {
  const {
    open,
    onClose
  } = props;
  if (!open) {
    return null;
  }
  const onDrop = useCallback(async (acceptedFiles) => {
    console.log("files", acceptedFiles);
    onClose(new CustomEvent("files", {
      detail: {
        acceptedFiles
      }
    }), "backdropClick");
  }, []);
  const dropzone = useDropzone({
    onDrop
  });
  return /* @__PURE__ */ jsxs(Dialog$4, {
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    ...props,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: "Add files"
    }), /* @__PURE__ */ jsx(DropZone$1, {
      ...dropzone
    })]
  });
};

const FileViewWrapper = styled.div`
    margin-bottom: 10px;
    && > * {
        margin-right: 10px;
    }
`;
const AttachmentView = ({
  value,
  children
}) => {
  const url = useImageUrl(value);
  const {
    originalFileName
  } = value;
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsxs(FileViewWrapper, {
      children: [/* @__PURE__ */ jsx(Link$1, {
        href: url,
        download: true,
        target: "_blank",
        underline: "always",
        children: originalFileName
      }), children]
    })
  });
};

const useUploadFilesFn = () => {
  const api = useApi();
  const handler = useMemoizedFn(async (files) => {
    return uploadFiles(api, files);
  });
  return handler;
};
const AttachmentBlockEditor = () => {
  const upload = useUploadFilesFn();
  const {
    block: currentBlock,
    edited,
    save
  } = useBlockContext();
  const block = currentBlock;
  useBlockSaver();
  const {
    files
  } = block;
  if (!edited) {
    if (!files || !files.length) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", {
      children: files.map((f) => /* @__PURE__ */ jsx(AttachmentView, {
        value: f
      }, f.uuid))
    });
  }
  const onFilesChanged = async (acceptedFiles) => {
    const files2 = await upload(acceptedFiles);
    save({
      ...block,
      files: files2
    });
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(UploadButton$1, {
      defaultValue: files,
      onFilesChanged
    })
  });
};

const NotFound = () => {
  useBlockSaver();
  return /* @__PURE__ */ jsx(Fragment, {});
};

const getTinyPluginManager = () => {
  return window["tinymce"]["PluginManager"];
};
const URL_PREVIEW_PLUGIN = "urlpreview";
const createUrlPreviewPlugin = ({ linkPreview }) => {
  if (!getTinyPluginManager().get(URL_PREVIEW_PLUGIN)) {
    const urlPattern = new RegExp("^(https?:\\/\\/)?((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-zA-Z\\d%@_.~+&:]*)*(\\?[;&a-zA-Z\\d%@_.,~+&:=-]*)?(\\#[-a-zA-Z\\d_]*)?$", "i");
    const isTextLink = (text) => {
      return urlPattern.test(text);
    };
    getTinyPluginManager().add(URL_PREVIEW_PLUGIN, (editor) => {
      editor.on("paste", async (e) => {
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData("Text");
        const url = pastedData.trim();
        if (isTextLink(url)) {
          e.preventDefault();
          try {
            const metadata = await linkPreview({ url });
            const previewHtml = getLinkPreviewHtml(metadata);
            editor.insertContent(previewHtml);
          } catch (error) {
            console.error("URL preview failed", error);
            editor.insertContent(url);
          }
        }
      });
    });
  }
};
const getLinkPreviewHtml = (metadata) => {
  switch (metadata.type) {
    case "error":
      return metadata.url;
    case "youtube":
      return getYouTubeVideoPreviewHtml(metadata);
    default:
      return getGeneralLinkPreviewHtml(metadata);
  }
};
const getGeneralLinkPreviewHtml = (metadata) => {
  const { url, favicons, siteName, title, description, images } = metadata;
  const name = siteName || new URL(url).hostname;
  const favicon = favicons && favicons[0];
  const previewHtml = `
<div class="url-preview" data-original-url="${url}">
<a href="${url}" target="_blank">
<div class="url-preview-inner">
<h3 class="url-preview-header">
${favicon ? `<img src="${favicon}" alt="Favicon" class="favicon" />` : ""}
<span class="site-name">${name}</span> <span>:</span>
<span>${title || ""}</span>
</h3>
<p>${description || "No description available"}</p>
${images && images[0] ? `<img src="${images[0]}" alt="Preview"/>` : ""}
</div>
</a>
</div>
`;
  return previewHtml;
};
const getThumbnail = (thumbnails) => {
  const screenWidth = window.innerWidth;
  if (screenWidth >= 480 && thumbnails.high) {
    return thumbnails.high;
  } else if (screenWidth >= 320 && thumbnails.medium) {
    return thumbnails.medium;
  } else {
    return thumbnails.default;
  }
};
const getYouTubeVideoPreviewHtml = (videoDetails) => {
  const { title, description, publishedAt, channelTitle, thumbnails, url } = videoDetails;
  const selectedThumbnail = getThumbnail(thumbnails);
  const thumbnailUrl = selectedThumbnail.url;
  const previewHtml = `
  <div class="youtube-video-preview">
  <a href=${url} target="_blank">
  <div class="youtube-video-preview-inner">
  <img src="${thumbnailUrl}" alt="Thumbnail" class="video-thumbnail" />
  <h3 class="video-title">${title}</h3>
  <p class="video-description">${description || "No description available"}</p>
  <div class="video-meta">
  <span class="channel-title">${channelTitle}</span>
  <span class="published-date">${new Date(publishedAt).toLocaleDateString()}</span>
  </div>
  </div>
  </a>
  </div>
  `;
  return previewHtml;
};

const getTiny = () => {
  return window["tinymce"];
};
const getTinyEditorById = (id) => {
  return getTiny().get(id);
};
const paidPlugins = () => {
  let plugins = "anchor charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount";
  plugins += " checklist mediaembed casechange export formatpainter pageembed directionality";
  plugins += " permanentpen powerpaste advtable advcode editimage tableofcontents inlinecss";
  return plugins;
};
const freePlugins = () => {
  return "searchreplace save directionality code visualblocks visualchars fullscreen image link media codesample table charmap anchor lists wordcount emoticons";
};
const getPlugins = ({
  free,
  autoresize,
  addAutoLink
}) => {
  let plugins = free ? freePlugins() : paidPlugins();
  if (addAutoLink) {
    plugins += "  autolink";
  }
  if (autoresize) {
    plugins += "  autoresize";
  }
  return plugins;
};
const getId = (free) => {
  if (free) {
    return "ntiy9m8xo0ylv0ncpf5dz2l2u5lrb7kk9fv2i8c44dw8us90";
  }
  return "tkplz7lb38laruc5kvl0iyz69kcmgzzdsgm18wwlcd10896n";
};
const getUrl = (free) => {
  if (!free) {
    return `https://cdn.tiny.cloud/1/${getId(free)}/tinymce/7/tinymce.min.js`;
  }
  return "/static/tinymce/js/tinymce.min.js";
};
let previousFree;
const initTiny = async ({
  id,
  free,
  autoresize,
  initializePlugins
}, options = {}) => {
  const reloadTiny = previousFree !== free;
  if (typeof window !== "undefined" && reloadTiny) {
    delete window["tinymce"];
  }
  await loadJsLibs([getUrl(free)], reloadTiny);
  previousFree = free;
  const tinymce = getTiny();
  const addUrlPreview = (options.plugins || "").includes(URL_PREVIEW_PLUGIN);
  const commonPlugins = getPlugins({
    free,
    autoresize,
    addAutoLink: !addUrlPreview
  });
  let toolbar = "undo redo | ltr rtl | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table pageembed ";
  toolbar += " | align lineheight | checklist numlist bullist indent outdent | forecolor backcolor | emoticons charmap | removeformat";
  const config = {
    selector: "#" + id,
    contextmenu: false,
    toolbar,
    auto_focus: id,
    branding: false,
    browser_spellcheck: true,
    height: "100%",
    ...options,
    plugins: commonPlugins + (options.plugins ? " " + options.plugins : "")
  };
  if (free) {
    config.base_url = "/static/tinymce/js/";
  }
  initializePlugins();
  tinymce.init(config);
  return tinymce.get(id);
};

// THIS FILE IS AUTO GENERATED
function CgSpinner (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none"},"child":[{"tag":"path","attr":{"opacity":"0.2","fillRule":"evenodd","clipRule":"evenodd","d":"M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z","fill":"currentColor"},"child":[]},{"tag":"path","attr":{"d":"M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z","fill":"currentColor"},"child":[]}]})(props);
}

const IMGIX_HOSTNAME_RE = /^newssocial.*\.imgix\.net$/;
const getInstanceHost$2 = () => {
  if (typeof location === "undefined")
    return "";
  const parts = location.hostname.split(".").filter(Boolean);
  return parts.slice(-2).join(".");
};
const rewriteImgixUrl = (url) => {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (!IMGIX_HOSTNAME_RE.test(parsed.hostname))
    return null;
  const segments = parsed.pathname.split("/").filter(Boolean);
  if (segments.length < 4 || segments[1] !== "obs")
    return null;
  const uuid = segments[2];
  const filename = segments.slice(3).join("/");
  const path = `/ua/ip/obs/${uuid}/${filename}${parsed.search}`;
  if (isLocalhost())
    return `http://localhost:3002${path}`;
  return `https://cdn.${getInstanceHost$2()}${path}`;
};

const ORIGINAL_SRC_ATTR = "data-ns-original-src";
const rewriteImageSrcForDisplay = (html) => {
  const template = document.createElement("template");
  template.innerHTML = html;
  const images = template.content.querySelectorAll("img");
  images.forEach((img) => {
    if (img.hasAttribute(ORIGINAL_SRC_ATTR))
      return;
    const src = img.getAttribute("src");
    if (!src)
      return;
    const rewritten = rewriteImgixUrl(src) || src;
    if (rewritten === src)
      return;
    console.log("[rewriteImageSrcForDisplay]", { src, rewritten });
    img.setAttribute(ORIGINAL_SRC_ATTR, src);
    img.setAttribute("src", rewritten);
  });
  return template.innerHTML;
};
const restoreImageSrcForSave = (html) => {
  const template = document.createElement("template");
  template.innerHTML = html;
  const images = template.content.querySelectorAll("img[" + ORIGINAL_SRC_ATTR + "]");
  images.forEach((img) => {
    const original = img.getAttribute(ORIGINAL_SRC_ATTR);
    if (!original)
      return;
    console.log("[restoreImageSrcForSave]", { original });
    img.setAttribute("src", original);
    img.removeAttribute(ORIGINAL_SRC_ATTR);
  });
  return template.innerHTML;
};

const getInstanceHost$1 = () => {
  if (typeof location === "undefined")
    return "";
  const parts = location.hostname.split(".").filter(Boolean);
  return parts.slice(-2).join(".");
};
const getProxyOrigin$1 = () => isLocalhost() ? "http://localhost:3002" : `https://cdn.${getInstanceHost$1()}`;
const getImageUrlProxy = (image) => {
  return `${getProxyOrigin$1()}/ua/ip/${image.uuid}`;
};
const useImageUploadHandler = () => {
  const api = useApi();
  return useMemoizedFn(async (blobInfo, progress) => {
    const allImages = await api.upload({
      0: blobInfo.blob()
    });
    const info = allImages[0];
    return getImageUrlProxy(info);
  });
};

let lastId = 0;
const getContentStyle = (rtl) => {
  return `
    @font-face {
        font-family: 'droid_arabic_kufi';
        src: url('/static/fonts/DroidArabicKufi.woff2') format('woff2'),
             url('/static/fonts/DroidArabicKufi.woff') format('woff');
        font-weight: normal;
        font-style: normal;
      }

      @font-face {
        font-family: 'MunaOT';
        src: url('/static/fonts/MunaOT-Regular.woff2') format('woff2'),
             url('/static/fonts/MunaOT-Regular.ttf') format('truetype');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
        size-adjust: 160%;
      }

      @font-face {
        font-family: 'MunaOT';
        src: url('/static/fonts/MunaOT-Bold.woff2') format('woff2'),
             url('/static/fonts/MunaOT-Bold.ttf') format('truetype');
        font-weight: 700;
        font-style: normal;
        font-display: swap;
        size-adjust: 160%;
      }
      
      @import url('https://fonts.googleapis.com/css?family=Noto+Naskh+Arabic');
      
      html, body {
        font-family: ${rtl ? `'droid_arabic_kufi', 'roboto', 'serif'` : `'droid_arabic_kufi', "Helvetica", sans-serif`} !important;
      }

      .url-preview-header {
        display: flex;
        gap: 0.5rem;
        flex-wrap: wrap;
        align-items: center;
      }
      

      body.mce-content-body {
        margin: 16px 24px;
        font-size: 16px;
        line-height: 2.0;
        font-family: 'Verdana', 'roboto', 'serif';
        overflow: hodden; 
      }

   
      .mce-content-body ol, .mce-content-body ul {
        list-style: circle;
        margin: 0;
        margin-left: 2em;
        margin-right: 2em;
        padding: 0;
      }

      .mce-content-body ol {
        list-style: decimal;    
      }

      body .mce-content-body li {
        margin: 0;    
      }

      .mce-content-body a {
        color: rgb(85, 26, 139);
        cursor: pointer;
        text-decoration: underline;
      }

      .mce-content-body > * {
        margin: 0;
        margin-block-start:0; margin-block-end:0; margin-inline-start:0; margin-inline-end:0;
        padding-block-start:0; padding-block-end:0; padding-inline-start:0; padding-inline-end:0;
      }
    
      .mce-content-body > h1,
      .mce-content-body > h2,
      .mce-content-body > h3,
      .mce-content-body > h4,
      .mce-content-body > h5,
      .mce-content-body > h6 {
        font-weight: bold;
        line-height: 1.1;
        margin-bottom: 1em;
        margin-top: 1em;
      }
      
      h1 {
        font-size: 24px;
      }
      
      h2 {
        font-size: 20px;
      }
      
      h3 {
        font-size: 16px;
      }
    
      p {
        font-size: 14px;
        line-height: 2.0;
      }
    `;
};
const TinyEditor = ({
  content,
  setEditor,
  settings,
  autoresize,
  free
}) => {
  const uploadHandler = useImageUploadHandler();
  const api = useApi();
  const [id] = useState("tiny" + String(lastId++));
  const directionality = useDirectionality();
  const editorRef = useRef();
  const [loading, setLoading] = useState(false);
  const errorCounterRef = useRef(0);
  const rtl = directionality === "rtl";
  useUnmount(() => {
    if (editorRef.current) {
      editorRef.current.destroy();
      editorRef.current = null;
    }
  });
  useThrottleEffect(() => {
    if (editorRef.current) {
      return;
    }
    setLoading(true);
  }, [], {
    wait: 500
  });
  useRequest(async () => {
    if (editorRef.current) {
      return;
    }
    try {
      await loadEditor();
    } catch (error) {
      errorCounterRef.current++;
      throw error;
    }
    setLoading(false);
  }, {
    retryCount: -1
  });
  const loadEditor = async () => {
    const linkPreview = async ({
      url
    }) => {
      const metadata = await api.post({
        path: "/posts/link-preview",
        body: {
          url
        }
      });
      return {
        ...metadata,
        url
      };
    };
    const language = getLanguage();
    let options = {
      relative_urls: false,
      directionality: getDirectionality(),
      content_style: getContentStyle(rtl),
      font_family_formats: `Andale Mono=andale mono,times;
Droid Arabic Kufi=droid_arabic_kufi, roboto, serif;
MunaOT=MunaOT, droid_arabic_kufi, sans-serif;
Noto Naskh Arabic=Noto Naskh Arabic, serif;
Arial=arial,helvetica,sans-serif; 
Arial Black=arial black,avant garde;
Book Antiqua=book antiqua,palatino;
Comic Sans MS=comic sans ms,sans-serif;
Courier New=courier new,courier;
Georgia=georgia,palatino;
Helvetica=helvetica;
Impact=impact,chicago;
Symbol=symbol;
Tahoma=tahoma,arial,helvetica,sans-serif;
Terminal=terminal,monaco;
Times New Roman=times new roman,times;
Trebuchet MS=trebuchet ms,geneva;
Verdana=verdana,geneva; Webdings=webdings;
Wingdings=wingdings,zapf dingbats`.replace(/(\r\n|\n|\r)/gm, ""),
      ...settings
    };
    const callerSetup = settings && settings.setup;
    options = {
      ...options,
      setup: (editor2) => {
        editor2.on("BeforeSetContent", (e) => {
          e.content = rewriteImageSrcForDisplay(e.content);
        });
        editor2.on("GetContent", (e) => {
          e.content = restoreImageSrcForSave(e.content);
        });
        if (callerSetup) {
          callerSetup(editor2);
        }
      },
      images_upload_handler: uploadHandler
    };
    if (language !== "en") {
      options = {
        ...options,
        language_url: `/static/tinymce/${language}.js`,
        language
      };
    }
    const initializePlugins = () => {
      createUrlPreviewPlugin({
        linkPreview
      });
    };
    const editor = await initTiny({
      id,
      free,
      autoresize,
      initializePlugins
    }, options);
    if (!editor) {
      throw Error("Not able to initialize  editor");
    }
    editor.getElement().style.display = null;
    editorRef.current = editor;
    setEditor(editor);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("textarea", {
      id: String(id),
      defaultValue: content,
      style: {
        display: "none"
      },
      dir: "auto"
    }), loading && /* @__PURE__ */ jsxs("div", {
      className: "flex items-center p-2",
      children: [/* @__PURE__ */ jsx(CgSpinner, {
        size: 50,
        className: "animate-spin"
      }), "Loading editor..."]
    })]
  });
};

const TinyEditorBlock = () => {
  useImageUrlFn();
  const [editor, setEditor] = useState();
  const {
    block: tiny,
    edited,
    save
  } = useBlockContext();
  const block = tiny;
  const content = block.content || "";
  useApi();
  useBlockSaver({
    update(block2) {
      if (!editor || !edited) {
        return block2;
      }
      const content2 = editor.getContent();
      return {
        ...block2,
        content: content2
      };
    }
  });
  useUnmount(() => {
    if (editor) {
      editor.destroy();
    }
  });
  useEffect(() => {
    if (edited || !editor) {
      return;
    }
    const content2 = editor.getContent();
    editor.destroy();
    setEditor(void 0);
    save({
      ...block,
      content: content2
    });
  }, [edited]);
  const images_upload_handler = null;
  if (!edited) {
    return /* @__PURE__ */ jsx("div", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    });
  }
  const settings = {
    images_upload_handler,
    menubar: false
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(TinyEditor, {
      setEditor,
      content,
      settings
    })
  });
};

const TitleTextField = styled(TextField$1)`
    width: 100%;
`;
const TitleEditorBlock = () => {
  const ref = useRef();
  const contentRef = useRef("");
  const {
    block: one,
    edited,
    save,
    setEdited
  } = useBlockContext();
  const block = one;
  const {
    content = "New post"
  } = block;
  useKeyPress("enter", (event) => {
    console.log("11111111111111", ref.current.value);
    setEdited(false);
  }, {
    events: ["keyup"],
    target: ref
  });
  useBlockSaver({
    update(block2) {
      const content2 = contentRef.current;
      if (!content2) {
        return block2;
      }
      return {
        ...block2,
        content: content2
      };
    }
  });
  useEffect(() => {
    if (edited) {
      return;
    }
    const content2 = contentRef.current;
    if (!content2) {
      return;
    }
    save({
      ...block,
      content: content2
    });
  }, [edited]);
  if (!edited) {
    return /* @__PURE__ */ jsx(Typography, {
      variant: "h4",
      component: "h1",
      gutterBottom: true,
      children: content
    });
  }
  const handlePostChange = (e) => {
    contentRef.current = e.target.value;
  };
  return /* @__PURE__ */ jsx(TitleTextField, {
    inputRef: ref,
    autoFocus: true,
    placeholder: "Title",
    defaultValue: content,
    onChange: handlePostChange
  });
};

const blockTypeComponents = {
  [BLOCK_TINY]: TinyEditorBlock,
  [BLOCK_ATTACHMENT]: AttachmentBlockEditor,
  [BLOCK_TITLE]: TitleEditorBlock
};
const getBlockComponent = (type) => {
  const component = blockTypeComponents[type];
  if (component) {
    return component;
  }
  return NotFound;
};
const setBlockComponent = (type, component) => {
  blockTypeComponents[type] = component;
};

const BlockNames = {
  [BLOCK_TINY]: "HTML",
  [BLOCK_ATTACHMENT]: "Attachment",
  [BLOCK_REPLIES]: "Replies",
  [BLOCK_MAIN]: "Main",
  [BLOCK_TITLE]: "Title"
};
const getBlockTypeName = (type) => {
  return BlockNames[type];
};
const blockTypes = [BLOCK_TITLE, BLOCK_TINY, BLOCK_ATTACHMENT, BLOCK_REPLIES, BLOCK_MAIN];
const TypesToolbar = () => {
  const {
    block,
    save
  } = useBlockContext();
  if (!block) {
    return null;
  }
  const {
    type
  } = block;
  const changeType = (type2) => {
    if (block.type === type2) {
      return;
    }
    save({
      ...block,
      type: type2
    });
  };
  return /* @__PURE__ */ jsxs(Toolbar, {
    children: [/* @__PURE__ */ jsx("span", {
      children: "Select block type: \xA0"
    }), blockTypes.map((buttonType) => {
      return /* @__PURE__ */ jsx(ToggleButton$1, {
        selected: type === buttonType,
        onClick: () => changeType(buttonType),
        size: "small",
        children: getBlockTypeName(buttonType)
      }, buttonType);
    })]
  });
};

const BlocksList$1 = () => {
  const {
    order
  } = useBlocksOrderContext();
  const total = order ? order.length : 0;
  return /* @__PURE__ */ jsx(Fragment, {
    children: order.map((id, pos) => {
      return /* @__PURE__ */ jsx(OneBlock, {
        id,
        pos,
        total
      }, id);
    })
  });
};
const BlockWrapper = styled.div`
    ${({}) => {
  return css$1`
            position: relative;
            border: 0.05em solid orange;        
        `;
}}
`;
let count$2 = 0;
const BlockTests = () => {
  const {
    block,
    save
  } = useBlockContext();
  const onUpdate = () => {
    save({
      ...block,
      count: count$2++
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    children: [JSON.stringify(block), /* @__PURE__ */ jsx(Toolbar, {
      children: /* @__PURE__ */ jsx(Button, {
        variant: "contained",
        color: "primary",
        onClick: onUpdate,
        children: "update"
      })
    })]
  });
};
const showBlockTests = () => {
  return typeof localStorage !== "undefined" && localStorage.blockTests;
};
const ToggleEditButton = () => {
  const {
    setEdited,
    edited
  } = useBlockContext();
  const onClick = (ev) => {
    ev.stopPropagation();
    setEdited((v) => !v);
  };
  return /* @__PURE__ */ jsx(IconButton$5, {
    edge: "start",
    color: "inherit",
    "aria-label": "add block",
    onClick,
    children: /* @__PURE__ */ jsx(MdEdit, {})
  });
};
const BlockContent = ({
  last
}) => {
  const [types, setTypes] = useState(false);
  const {
    add,
    drop,
    up,
    down,
    setEdited,
    block,
    active,
    edited
  } = useBlockContext();
  if (!block) {
    return /* @__PURE__ */ jsx(NotFound, {});
  }
  const {
    type
  } = block;
  const Content = getBlockComponent(type);
  if (!active) {
    return /* @__PURE__ */ jsx(Content, {}, "view");
  }
  const onAdd = () => {
    add();
    setEdited(false);
  };
  const controls = !edited ? null : /* @__PURE__ */ jsxs(Fragment, {
    children: [showBlockTests() && /* @__PURE__ */ jsx(BlockTests, {}), /* @__PURE__ */ jsxs(Toolbar, {
      children: [/* @__PURE__ */ jsx(IconButton$5, {
        edge: "start",
        color: "inherit",
        "aria-label": "add block",
        onClick: onAdd,
        children: /* @__PURE__ */ jsx(MdAdd, {})
      }), /* @__PURE__ */ jsx(ToggleEditButton, {}), /* @__PURE__ */ jsx(IconButton$5, {
        edge: "start",
        color: "inherit",
        "aria-label": "add block",
        onClick: up,
        children: /* @__PURE__ */ jsx(MdOutlineKeyboardArrowUp, {})
      }), /* @__PURE__ */ jsx(IconButton$5, {
        edge: "start",
        color: "inherit",
        "aria-label": "add block",
        onClick: down,
        children: /* @__PURE__ */ jsx(MdOutlineKeyboardArrowDown, {})
      }), /* @__PURE__ */ jsx(Button, {
        variant: "outlined",
        color: "primary",
        size: "small",
        onClick: () => setTypes((v) => !v),
        children: type
      }), /* @__PURE__ */ jsx(IconButton$5, {
        color: "inherit",
        "aria-label": "drop block",
        onClick: drop,
        children: /* @__PURE__ */ jsx(MdDeleteOutline, {})
      })]
    }), types && /* @__PURE__ */ jsx(TypesToolbar, {})]
  });
  const onClick = (ev) => {
    ev.stopPropagation();
    setEdited(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(BlockWrapper, {
      "data-block-id": block.id,
      onClick,
      children: [/* @__PURE__ */ jsx(Content, {}, "edit"), controls]
    }), !last || edited ? null : /* @__PURE__ */ jsx(Toolbar, {
      children: /* @__PURE__ */ jsx(IconButton$5, {
        edge: "start",
        color: "inherit",
        "aria-label": "add block",
        onClick: onAdd,
        children: /* @__PURE__ */ jsx(MdAdd, {})
      })
    })]
  });
};
const BlocksToolbar = () => {
  const {
    edited
  } = useBlocksContext();
  if (!edited) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Toolbar, {
    children: [/* @__PURE__ */ jsx(AddBlockButton, {}), /* @__PURE__ */ jsx(SaveBlocksButton, {}), /* @__PURE__ */ jsx(PublishBlocksButton, {})]
  });
};
const OneBlock = ({
  id,
  pos,
  total
}) => {
  const {
    edited
  } = useBlocksContext();
  const active = !!edited;
  return /* @__PURE__ */ jsx(BlockContextProvider, {
    id,
    pos,
    total,
    children: /* @__PURE__ */ jsx(BlockContent, {
      last: pos + 1 === total
    })
  }, String(active));
};

const BlocksEditorDialog = (props) => {
  const {
    open,
    onClose = () => {
    }
  } = props;
  const [draft, setDraft] = useState();
  const [profile, setProfile] = useState();
  const createDraft = useCreateDraftFn();
  const api = useApi();
  const {
    draft: edited,
    circleId,
    ...other
  } = props;
  useAsyncEffect(async () => {
    if (!open) {
      setDraft(void 0);
      setProfile(void 0);
      return;
    }
    const [draft2, profile2] = await Promise.all([edited ? api.loadDraft({
      _id: edited._id
    }) : createDraft({
      type: "article",
      group: {
        group: circleId
      }
    }), api.loadProfile()]);
    setDraft(draft2);
    setProfile(profile2);
  }, [open]);
  if (!open || !draft || !profile) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$6, {
    fullScreen: true,
    ...other,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: "Author Post"
    }), /* @__PURE__ */ jsx(PostInfoContextForDraft, {
      draft,
      profile,
      children: /* @__PURE__ */ jsxs(BlocksContextProvider, {
        post: draft,
        edited: true,
        children: [/* @__PURE__ */ jsx(BlocksToolbar, {}), /* @__PURE__ */ jsx(BlocksList$1, {})]
      })
    })]
  });
};

const editPostUrl2 = (post) => {
  const {
    type
  } = post;
  return `/trans/edit-${type}/` + (post.draft || post._id);
};
const useOpenEditEventFn = () => {
  const api = useApi();
  return async (postOrDraft, draft = false) => {
    const {
      _id
    } = postOrDraft;
    if (!draft) {
      const post = draft ? await api.loadPostByDraft(_id) : await api.loadPostById({
        _id
      });
      window.location.href = editPostUrl2(post);
    }
  };
};
const useAssetEditor = (onClose = () => null, v2 = true) => {
  const api = useApi();
  const history = useHistory();
  const editAsset = async (post, draft = false) => {
    const {
      type,
      _id
    } = post;
    if (type === "asset") {
      const post2 = draft ? await api.loadPostByDraft(_id) : await api.loadPostById({
        _id
      });
      history.push(editPostUrl2(post2));
      return true;
    }
    return false;
  };
  const editDialog = null;
  return {
    editAsset,
    editDialog
  };
};
const useDraftEditor = (onClose = () => null) => {
  const [draft, setDraft] = useState(null);
  const editDraft = (post) => {
    if (post.contentBlocks) {
      setDraft(post);
      return true;
    }
    return false;
  };
  const editDraftDialog = /* @__PURE__ */ jsx(BlocksEditorDialog, {
    open: !!draft,
    onClose: (ev) => {
      setDraft(null);
      if (ev.type !== "created") {
        return;
      }
      onClose(draft);
    },
    draft
  });
  return {
    editDraft,
    editDraftDialog
  };
};

var PostFeatures;
(function(PostFeatures2) {
  PostFeatures2["PAGE"] = "page";
  PostFeatures2["BOOK"] = "book";
})(PostFeatures || (PostFeatures = {}));

var CircleStatTypes;
(function(CircleStatTypes2) {
  CircleStatTypes2[CircleStatTypes2["Members"] = 0] = "Members";
  CircleStatTypes2[CircleStatTypes2["Posts"] = 1] = "Posts";
})(CircleStatTypes || (CircleStatTypes = {}));

const isBook = (post) => {
  return post && post.features && post.features.includes("book");
};
const isPage = (post) => {
  if (!post || !post.features) {
    return false;
  }
  return post.features.includes(PostFeatures.PAGE) || typeof post.documentPageNumber === "number";
};

const getResponseUrl = (response, noPrefix = false) => {
  if (typeof response === "string") {
    return `/trans/post-view/${response}`;
  }
  if (!response.group) {
    return `/trans/post-view/${response._id}`;
  }
  const prefix = getUrlPrefix(noPrefix);
  const circle = response.group.group && response.group.group._id || response.group.group;
  if (!circle) {
    return `/trans/post-view/${response._id}`;
  }
  const start = isLocalPlayground() ? "/playground/lib/single-circle/post-view" : `${prefix}/groups/${circle}/posts/post`;
  if (!response.thread || !response.thread.length) {
    return `${start}/${response._id}`;
  }
  const isPagePost = isPage(response);
  if (isPagePost) {
    return `${start}/${response.thread[0]}#?page=${response._id}`;
  }
  return `${start}/${response.thread[0]}#?response=${response._id}`;
};
const getUrlPrefix = (noPrefix = false) => {
  if (noPrefix) {
    return "";
  }
  const isCore = checkIsCoreUrl();
  return isCore ? LOCAL_PLAYGROUND$3.replace(":3030", ":3000") : "";
};
const checkIsCoreUrl = () => location.href.startsWith(LOCAL_PLAYGROUND$3);
const LOCAL_PLAYGROUND$3 = "http://localhost:3030";

const circleIdForPost = (post) => {
  if (!post || !post.group || !post.group.group) {
    return void 0;
  }
  const g = post.group.group;
  return g._id || g;
};

const createPostUrl = (id) => `/profile/drafts/_create/article/${id}`;
const editPostUrl = (post) => {
  if (post.pages && post.pages.length) {
    return `/trans/edit-post/${post.draft}`;
  }
  return `/profile/drafts/_edit/${post.type}/${post.draft}`;
};
const postAudienceUrl = (post) => {
  return editPostUrl(post) + "/audience";
};
const objectId = (v) => !v ? v : v._id || v;
const importDocumentUrl = (id) => `/profile/drafts/_import/${id}`;
const circleUrl = (id) => {
  if (!id) {
    id = "";
  }
  if (typeof id !== "string") {
    id = id._id;
  }
  if (isLocalPlayground()) {
    return "/playground/lib/single-circle/design/" + id;
  }
  return `/groups/${id}`;
};
const myCirclesUrl = () => {
  if (isLocalPlayground()) {
    return "/playground/lib/single-circle/my-circles/";
  }
  return `/groups`;
};
const dashboardUrl = () => {
  if (isLocalPlayground()) {
    return "/playground/lib/single-circle/dashboard";
  }
  return `/`;
};
const postCircleUrl = (post) => circleUrl(postCircleId(post));
const circleMembersUrl = (id) => `/groups/${id}/membership`;
const postCircleId = (post) => {
  if (!post || !post.group || !post.group.group) {
    return "";
  }
  const group = post.group.group;
  if (group._id) {
    return group._id;
  }
  if (typeof group === "string") {
    return group;
  }
  return "";
};
const circlePostUrl = ({ circleId, postId }) => {
  if (isLocalPlayground()) {
    return "/playground/lib/single-circle/post-view/" + postId;
  }
  return postUrl({ circleId, postId });
};
const postUrl = ({ circleId, postId }) => `/groups/${circleId}/posts/post/${postId}`;
const bookCairPath = (seg, suffix = "") => isLocalPlayground() ? `/playground/lib/single-circle/${seg}${suffix}` : `/${seg}${suffix}`;
const bookCairBrowseUrl = (circleId) => bookCairPath("book-cair-browse", `/${circleId}`);
const bookCairProfileUrl = () => bookCairPath("book-cair-profile");
const bookCairLibraryUrl = () => bookCairPath("book-cair-library");
const bookCairPurchasesUrl = () => bookCairPath("book-cair-purchases");
const bookCairDashboardUrl = (circleId) => bookCairPath("book-cair-dashboard", circleId ? `/${circleId}` : "");
const bookCairPaymentUrl = (query = "") => bookCairPath("book-cair-payment", query);
const bookCairPaymentResultUrl = (query = "") => bookCairPath("book-cair-payment-result", query);
const bookCairDesktopUrl = (postId) => bookCairPath("live-book-cair-desktop", `/${postId}`);
const bookCairMobileUrl = (postId) => bookCairPath("live-book-cair-mobile", `/${postId}`);
const bookCairReaderUrl = (postId) => typeof window !== "undefined" && window.innerWidth < 768 ? bookCairMobileUrl(postId) : bookCairDesktopUrl(postId);
const url4post = (post) => {
  if (!post) {
    return "/";
  }
  return getResponseUrl(post, true);
};
const eventCalendarLink = (post) => `/ua/event/calendar/${post._id}/calendar.ics`;

const INTERVIEW_TAG = "_interview";
const MEDIA_TAG = "_media";
const isMediaPost = (post) => post.tags !== void 0 && (post.tags.includes(INTERVIEW_TAG) || post.tags.includes(MEDIA_TAG));
const editInterviewUrl = (post) => {
  return `/trans/edit-interview/${post._id}`;
};
const createInterviewUrl = (post) => {
  return `/trans/upload-interview/${post._id}`;
};
const interviewMetadataUrl = (post) => {
  return `/trans/interview-metadata/${post._id}`;
};
const editMetadataUrl = (post) => {
  if (isMediaPost(post)) {
    return interviewMetadataUrl(post);
  }
  return `/trans/post-metadata/${post._id}`;
};

const useOnEditClickFn = () => {
  const openEditEvent = useOpenEditEventFn();
  const {
    editAsset
  } = useAssetEditor((asset) => {
    window.location.reload();
  });
  const onEditClick = async (post) => {
    const {
      type,
      features
    } = post;
    if (type === "asset") {
      await editAsset(post);
      return;
    }
    if (type === "event") {
      await openEditEvent(post);
      return;
    }
    if (isMediaPost(post)) {
      window.location.href = editInterviewUrl(post);
      return;
    }
    if (isBook(post)) {
      window.location.href = "/trans/edit-post/" + post.draft;
      return;
    }
    window.location.href = editPostUrl(post);
  };
  return {
    onEditClick
  };
};

const noop$n = () => null;
const CircleModalDialogsContext = React__default.createContext({
  showPromptExecution: false,
  setShowPromptExecution: noop$n,
  openDeleteDialog: false,
  setOpenDeleteDialog: noop$n,
  openChangePrivacyDialog: false,
  setOpenChangePrivacyDialog: noop$n,
  onMove: noop$n,
  outcome: void 0,
  duplicated: void 0,
  setDuplicated: noop$n,
  exported: void 0,
  setExported: noop$n,
  setOutcome: noop$n,
  onEditClick: noop$n
});
const CircleModalDialogsContextProvider = ({
  children
}) => {
  const {
    onEditClick
  } = useOnEditClickFn();
  const api = useApi();
  const [outcome, setOutcome] = useState();
  const [move, setMove] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openChangePrivacyDialog, setOpenChangePrivacyDialog] = useState(false);
  const [duplicated, setDuplicated] = useState(null);
  const [showPromptExecution, setShowPromptExecution] = useState(false);
  const [exported, setExported] = useState(null);
  const onMove = useCallback(async (selected) => {
    const {
      _id
    } = selected;
    const post = await api.loadPostById({
      _id
    });
    setMove(post);
  }, []);
  return /* @__PURE__ */ jsxs(CircleModalDialogsContext.Provider, {
    value: {
      openDeleteDialog,
      setOpenDeleteDialog,
      openChangePrivacyDialog,
      setOpenChangePrivacyDialog,
      onMove,
      outcome,
      setOutcome,
      duplicated,
      setDuplicated,
      exported,
      setExported,
      onEditClick,
      showPromptExecution,
      setShowPromptExecution
    },
    children: [!!move && /* @__PURE__ */ jsx(MoveAssetDialog, {
      open: !!move,
      post: move,
      onClose: (moved) => {
        setMove(null);
        if (moved) {
          window.location.reload();
        }
      }
    }), !!outcome && /* @__PURE__ */ jsx(CloseGroupDialog, {}), children]
  });
};
const useCircleModalDialogsContext = () => {
  return useContext(CircleModalDialogsContext);
};
const ConfirmDeleteCircle = () => {
  const api = useApi();
  const history = useHistory();
  const {
    openDeleteDialog,
    setOpenDeleteDialog
  } = useCircleModalDialogsContext();
  const {
    circle
  } = useCircleContext();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    if (!circle) {
      return;
    }
    await deleteCircleApi$1(api, circle._id);
    setOpenDeleteDialog(false);
    toast("Circle was deleted");
    history.replace("/groups");
  }, {
    message: "Delete circle"
  });
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsx(ConfirmDialog, {
    title: "Confirm circle deletion",
    open: openDeleteDialog,
    content: /* @__PURE__ */ jsxs("span", {
      children: ["Do you wish to DELETE circle `", circle.name, "`?"]
    }),
    onClose: () => setOpenDeleteDialog(false),
    children: /* @__PURE__ */ jsx(LoadingButton, {
      onClick,
      loading,
      children: "Delete"
    })
  });
};
const DeleteCircleMenuItem = () => {
  const {
    profile
  } = useCircleContext();
  const {
    setOpenDeleteDialog
  } = useCircleModalDialogsContext();
  if (!profile || profile.role !== "ADMIN") {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: () => setOpenDeleteDialog(true),
    children: "Delete Circle"
  });
};

var Search = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJqSURBVHgBvZbbSxVRGMXX6YCnvEDaVUuPXSwoiuhCPdZTD9VT/2r4UBEEQVAUlUGURmWWYUkXo1KO5lrsNTjo7HNzHxf82Htm9szal2++vUuory6ymxwhB0gPKfvZT/KDvCPT5B9aUClyXx8/Qc6SSu5+jfx1hyrr3nlJXpDfaNO4l1wlu3z9GWFU4k+uncz3kaNkzPcWyAPyES0aD5BrZAf5Sh6SL2isPnKOHPP1I/Ks3gvlXF0jvUG6yQS5iyanjVoi710fQogHjX4eTRjftPlT97gdzZJFMuwOTLlTUWMF0SH38jY2pzmE9Zexlm6yqNE2Nzru61tIoycII9eUDyJiXEUIDkXvAtJI0zvhehUR4xHX3yCtsu+NIWLc7/oc0kp/hGZQv2ZPkbEC4D9C+kutXy4LjaVFdEY1l2UUGK9gY95Npa7YAxlrLZQ6+5BeAy7ni4xnXB9FWmmTqdh0qcj4retVpNUpl4U7lYz1G2m7U4obRBop52f54RUixsvksa8vo05AtKCLZDtCEinMhlmYax20qe9xOYn2pX35pA3vo8HuJOncpLOVgkLTNBN7KSLN3iVyxtfj5Huscd5YU/4BIbr7Xco4upnnpNi44o5n6vb3VhoZA2snCf0GQzbXcaY3114j0/rt9fML5Lzb6Lik6d3v5xrAdJF57JQp6WBwGmHNG0l5/jl57Wslo+suZXwP65at1MRHd5KDCNOpkWoKazb7hvA7zha8lzf/RO7kzZsx3ozy5urgeGZeRmclEwWYsqLytmZOmXK508Z58xGbq5zaCuPMXEE2ihAzw1tlnJnrnH2YlFcBSxF6nNHi4W8AAAAASUVORK5CYII=";

const className4Icon = "w-[22px] h-[22px]";
const commonIconProps = {
  className: className4Icon,
  color: "#4A90CE",
  style: {
    stroke: "#4A90CE"
  }
};
const StyledButton = ({
  icon: Icon,
  className,
  children,
  ...other
}) => {
  return /* @__PURE__ */ jsxs("button", {
    className: clsx("flex justify-start items-center p-1 relative w-[30px] h-[30px]", className),
    ...other,
    children: [/* @__PURE__ */ jsx(Icon, {
      ...commonIconProps
    }), children]
  });
};

const Tooltip = ({
  className,
  children,
  position
}) => {
  return /* @__PURE__ */ jsx("span", {
    className: clsx("pointer-events-none absolute w-max opacity-0 transition-opacity group-hover:opacity-100 bg-gray-600 text-white rounded-md p-1 z-20", position ? position : "-bottom-7 -right-3", className),
    children
  });
};

const useProfile = (op) => {
  const api = useApi();
  const result = useSWR(`/profile`, () => api.loadProfile(), {
    ...swrLoadOnce,
    ...op
  });
  return result;
};

const ProfileIcon = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    data: profile
  } = useProfile();
  const ref = (el) => {
    setAnchorEl(el);
  };
  profile && (!profile.lastname || !profile.firstname);
  const id = "user-profile";
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(Link$2, {
      to: "/profile",
      className: "relative group",
      children: /* @__PURE__ */ jsxs("div", {
        ref,
        "aria-describedby": id,
        children: [/* @__PURE__ */ jsx(Avatar, {
          avatar: profile && profile.avatar,
          size: 30
        }), /* @__PURE__ */ jsx(Tooltip, {
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "dashboard.tooltip.profile"
          })
        })]
      })
    })
  });
};
const MyProfileIcon = () => {
  const {
    data: profile
  } = useProfile();
  const [anchorEl, setAnchorEl] = useState(null);
  const api = useApi();
  if (!profile) {
    return null;
  }
  const username = getPersonName(profile);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };
  const onLogout = async (event) => {
    handleClose(event);
    await api.logout();
    window.location.href = "/welcome";
  };
  return /* @__PURE__ */ jsxs("div", {
    onClick: handleClick,
    className: "relative group cursor-pointer",
    children: [/* @__PURE__ */ jsx(Avatar, {
      avatar: profile && profile.avatar,
      size: 30
    }), /* @__PURE__ */ jsx(Tooltip, {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.tooltip.profile"
      })
    }), /* @__PURE__ */ jsx(Menu$1, {
      id: "profile-menu",
      anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose,
      children: /* @__PURE__ */ jsx(MenuItem, {
        onClick: onLogout,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "profile.logout",
          values: {
            username
          }
        })
      })
    })]
  });
};

const HelpContext = React__default.createContext({
  profile: void 0,
  page: void 0,
  open: false,
  setOpen: () => null
});
const useHelpContext = () => {
  return useContext(HelpContext);
};
const pageKey = (page) => "welcomePage:" + page;
const HelpContextProvider = ({
  profile,
  page,
  children
}) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (typeof localStorage === "undefined") {
      return;
    }
  }, [page]);
  useUpdateEffect(() => {
    if (!open) {
      localStorage[pageKey(page)] = true;
    }
  }, [open]);
  const context = useMemo(() => {
    return {
      profile,
      page,
      open,
      setOpen
    };
  }, [profile, page, open]);
  return /* @__PURE__ */ jsx(HelpContext.Provider, {
    value: context,
    children
  });
};

const testError = () => {
  if (typeof localStorage === "undefined") {
    return;
  }
  const count = parseInt(localStorage.errors);
  if (Number.isNaN(count)) {
    return;
  }
  if (count < 1) {
    return;
  }
  localStorage.errors = count - 1;
  throw new Error("Test error #" + count);
};

const ErrorAlert = ({
  error
}) => {
  if (!error) {
    return null;
  }
  return /* @__PURE__ */ jsx(Alert$2, {
    severity: "error",
    children: errorMessage(error)
  });
};

createLogger("info:ui");
const Content$4 = styled(DialogContent)`
    display: flex;
    flex-direction: column;

`;
const ConfigureHelpDialog = (props) => {
  const {
    open
  } = props;
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsx(ConfigureHelpDialogInner, {
    ...props
  });
};
const useSavePageConfig = (page, postId, onDone) => {
  const api = useApi();
  return useLoading(async () => {
    testError();
    await api.makeRequest({
      path: `/help/${page}/_help-config`,
      method: "POST",
      body: {
        helpPost: postId.trim()
      }
    });
    if (onDone) {
      onDone();
    }
  });
};
const ConfigureHelpDialogInner = ({
  open,
  setOpen
}) => {
  const {
    page
  } = useHelpContext();
  const api = useApi();
  const [helpPost, setPostId] = useState("6408c5dbaa79299227b4f7d9");
  const {
    onClick,
    loading
  } = useSavePageConfig(page, helpPost, () => setOpen(false));
  const {
    data: configData,
    error
  } = useRequest(async () => {
    testError();
    const config = await api.makeRequest({
      path: `/help/${page}/_help-config?edit=1`,
      method: "GET"
    });
    setPostId(config.help || "");
    return true;
  }, {
    retryCount: -1
  });
  const onPostId = (e) => {
    setPostId(e.target.value);
  };
  return /* @__PURE__ */ jsxs(Dialog$6, {
    onClose: () => setOpen(false),
    "aria-labelledby": "customized-dialog-title",
    open,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose: () => setOpen(false),
      icon: /* @__PURE__ */ jsx(DialogIcon, {
        children: /* @__PURE__ */ jsx(BsGear, {})
      }),
      children: /* @__PURE__ */ jsxs("div", {
        "data-id": "page-welcome-dialog",
        children: ["Configure help for page", /* @__PURE__ */ jsxs("span", {
          children: [" `", page, "`"]
        })]
      })
    }), /* @__PURE__ */ jsxs(Content$4, {
      dividers: true,
      children: [/* @__PURE__ */ jsx(ErrorAlert, {
        error
      }), !configData && /* @__PURE__ */ jsx(CircularProgress, {
        color: "secondary"
      }), configData && /* @__PURE__ */ jsx(Fragment, {
        children: /* @__PURE__ */ jsx(TextField$1, {
          label: "Post Id of help for this page",
          value: helpPost,
          onChange: onPostId
        })
      })]
    }), /* @__PURE__ */ jsx(DialogActions, {
      children: /* @__PURE__ */ jsx(LoadingButton, {
        loading,
        onClick,
        disabled: !configData,
        children: "Save"
      })
    })]
  });
};

const ConfigureHelpButton = ({
  onConfigChange = () => null
}) => {
  const [open, setOpenState] = React__default.useState(false);
  const {
    profile
  } = useHelpContext();
  if (!profile || profile.role !== "ADMIN") {
    return null;
  }
  const setOpen = (v) => {
    setOpenState(v);
    if (!v) {
      onConfigChange();
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      "aria-label": "welcome to circle dialog",
      color: "inherit",
      onClick: () => setOpen(true),
      children: /* @__PURE__ */ jsx(BsGear, {})
    }), /* @__PURE__ */ jsx(ConfigureHelpDialog, {
      open,
      setOpen
    })]
  });
};

const TinyContent = styled.div`

  body &.mce-content-body {
    margin: 0;
    font-size: ${({
  fontSize
}) => fontSize || 14}px;
    line-height: 2.0;
    font-family: 'droid_arabic_kufi', "Helvetica", 'roboto', 'serif';
    overflow: hidden; 
  }

  .url-preview-header {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    align-items: center;
  }

  &.mce-content-body a {
    color: rgb(85, 26, 139);
    cursor: pointer;
    text-decoration: underline;
  }

  &.mce-content-body ol, &.mce-content-body ul {
    margin: 1em 0;
    padding-left: 2.5em;
    list-style-position: outside;
  }

  &.mce-content-body ul {
    list-style-type: disc;
  }

  &.mce-content-body ol {
    list-style-type: decimal;
  }

  &.mce-content-body li {
    margin: 0.5em 0;
    padding-left: 0.5em;
  }

  /* Nested lists */
  &.mce-content-body ul ul {
    list-style-type: circle;
  }

  &.mce-content-body ul ul ul {
    list-style-type: square;
  }

  &.mce-content-body ol ol {
    list-style-type: lower-alpha;
  }

  &.mce-content-body ol ol ol {
    list-style-type: lower-roman;
  }

  /* RTL support for Arabic */
  &.mce-content-body[dir="rtl"] ol, 
  &.mce-content-body[dir="rtl"] ul {
    padding-left: 0;
    padding-right: 2.5em;
  }

  &.mce-content-body[dir="rtl"] li {
    padding-left: 0;
    padding-right: 0.5em;
  }


/* Blockquote styling */
  &.mce-content-body blockquote {
    margin: 1em 0;
    padding: 1em 1.5em;
    border-left: 4px solid rgb(85, 26, 139);
    background-color: rgba(85, 26, 139, 0.05);
    font-style: italic;
    color: rgba(0, 0, 0, 0.8);
  }

  &.mce-content-body blockquote p {
    margin: 0.5em 0;
  }

  &.mce-content-body blockquote p:first-child {
    margin-top: 0;
  }

  &.mce-content-body blockquote p:last-child {
    margin-bottom: 0;
  }

  /* RTL blockquote */
  &.mce-content-body[dir="rtl"] blockquote {
    border-left: none;
    border-right: 4px solid rgb(85, 26, 139);
  }  

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: bold;
    line-height: 1.1;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  
  h1 {
    font-size: 24px;
  }
  
  h2 {
    font-size: 20px;
  }
  
  h3 {
    font-size: 16px;
  }

  p {
    font-size: ${({
  fontSize
}) => fontSize || 14}px;
    line-height: 2.0;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

createLogger("info:ui");
const WelcomeToPageDialog = (props) => {
  const {
    open
  } = useHelpContext();
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsx(WelcomeToPageDialogInner, {
    ...props
  });
};
const WelcomeMessage$1 = () => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(Typography, {
      gutterBottom: true,
      children: "Help is not configured yet"
    })
  });
};
const usePageHTML = (page) => {
  const api = useApi();
  return useRequest(async () => {
    testError();
    if (!page) {
      return {
        html: ""
      };
    }
    const config = await api.makeRequest({
      path: `/help/${page}/_help-config`,
      method: "GET"
    });
    return {
      html: config.help,
      id: config.id
    };
  }, {
    retryCount: -1
  });
};
const HTMLView = forwardRef(({
  html
}, ref) => {
  if (!html) {
    return null;
  }
  return /* @__PURE__ */ jsx(TinyContent, {
    dangerouslySetInnerHTML: {
      __html: html
    },
    className: "mce-content-body",
    ref
  });
});
const WelcomeToPageDialogInner = ({
  buttons,
  defaultMessage
}) => {
  const [fullScreen, setFullScreen] = useState(false);
  const {
    page,
    open,
    setOpen
  } = useHelpContext();
  const {
    data: configData,
    error,
    run
  } = usePageHTML(page);
  const onConfigChange = () => {
    run();
  };
  return /* @__PURE__ */ jsxs(Dialog$6, {
    fullScreen,
    onClose: () => setOpen(false),
    "aria-labelledby": "customized-dialog-title",
    open,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose: () => setOpen(false),
      icon: /* @__PURE__ */ jsx(DialogIcon, {
        children: /* @__PURE__ */ jsx(AssistantIcon, {})
      }),
      children: /* @__PURE__ */ jsx("div", {
        "data-id": "welcome-dialog",
        children: "Welcome to Help."
      })
    }), /* @__PURE__ */ jsxs(DialogContent, {
      dividers: true,
      children: [/* @__PURE__ */ jsx(ErrorAlert, {
        error
      }), !configData && /* @__PURE__ */ jsx(CircularProgress, {
        color: "secondary"
      }), configData && !configData.html && (defaultMessage ? defaultMessage : /* @__PURE__ */ jsx(WelcomeMessage$1, {})), /* @__PURE__ */ jsx(HTMLView, {
        html: configData && configData.html
      })]
    }), /* @__PURE__ */ jsxs(DialogActions, {
      children: [/* @__PURE__ */ jsx(ConfigureHelpButton, {
        onConfigChange
      }), /* @__PURE__ */ jsx(IconButton$5, {
        onClick: () => setFullScreen(!fullScreen),
        children: fullScreen ? /* @__PURE__ */ jsx(FiMinimize2, {}) : /* @__PURE__ */ jsx(FiMaximize2, {})
      }), buttons]
    })]
  });
};

const WelcomeToPageButton = ({
  buttons,
  defaultMessage,
  button: Button,
  ...other
}) => {
  const {
    setOpen
  } = useHelpContext();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [!Button && /* @__PURE__ */ jsx(IconButton$5, {
      "aria-label": "welcome to page dialog",
      color: "inherit",
      onClick: () => setOpen(true),
      ...other,
      children: /* @__PURE__ */ jsx(AssistantIcon, {
        blackAndWite: true
      })
    }), Button && /* @__PURE__ */ jsx(Button, {
      onClick: () => setOpen(true)
    }), /* @__PURE__ */ jsx(WelcomeToPageDialog, {
      buttons,
      defaultMessage
    })]
  });
};

const VoteDataContext = React__default.createContext({
  data: void 0
});
const useVoteData = () => {
  return useContext(VoteDataContext);
};

const VoteProvider = ({
  children,
  data,
  override
}) => {
  if (!data) {
    return null;
  }
  const context = {
    data
  };
  if (!override) {
    return /* @__PURE__ */ jsx(VoteDataContext.Provider, {
      value: context,
      children
    });
  }
  return /* @__PURE__ */ jsx(VoteDataContext.Provider, {
    value: context,
    children: /* @__PURE__ */ jsx(CardThemeProvider, {
      ...override,
      children
    })
  });
};

const VoteActivityCard$1 = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(VoteProvider, {
    data,
    override,
    children: /* @__PURE__ */ jsx(VoteCardImp, {
      ...props
    })
  });
};
const ContentOuter$5 = styled.div`
    display: flex;
`;
const ContentOuterLink$3 = styled(ContentOuter$5).attrs({
  as: "a"
})`
    cursor: pointer;
`;
const ContentBodyWrapper$5 = styled.div`
    flex: auto;
    min-width: 0;
`;
const LOCAL_PLAYGROUND$2 = "http://localhost:3030";
const VoteTitle$1 = () => {
  const {
    linkToPage,
    menu,
    onLinkClick,
    linkConfig
  } = useCardsTheme();
  const {
    data
  } = useVoteData();
  const {
    post,
    circle,
    root,
    poll
  } = data;
  const {
    title: text1
  } = post;
  const {
    description
  } = poll;
  const text = text1 ? text1 : "<none>";
  const isCore = location.href.startsWith(LOCAL_PLAYGROUND$2);
  const prefix = isCore ? LOCAL_PLAYGROUND$2.replace(":3030", ":3000") : "";
  const {
    info = true
  } = linkConfig;
  const urlBase = `${prefix}/groups/${circle}/posts/post/${root._id}#?response=${post._id}`;
  const urlWithInfo = info ? urlBase + "&info=vote" : urlBase;
  const url = urlWithInfo;
  const onClick = (ev) => {
    onLinkClick(ev, data);
  };
  const title = linkToPage ? text : /* @__PURE__ */ jsx(Link$1, {
    to: !isCore && url,
    component: isCore ? "a" : Link$2,
    underline: "always",
    href: isCore && url,
    onClick,
    children: description || text
  });
  return /* @__PURE__ */ jsxs(Title, {
    children: [title, menu]
  });
};
const VotesDescriptionCardChip = styled(CardChip$1)`
    max-width: 95%;
`;
const VotesDescriptionChip = () => {
  const {
    data
  } = useVoteData();
  const {
    poll
  } = data;
  if (!poll.description) {
    return null;
  }
  const text = poll.description;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(VotesDescriptionCardChip, {
      children: text
    })]
  });
};
const VoteTimeChip = () => {
  const {
    data
  } = useVoteData();
  const {
    poll
  } = data;
  const {
    date
  } = poll;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(CardChip$1, {
      children: /* @__PURE__ */ jsx(RelativeTime, {
        value: date
      })
    })]
  });
};
const VoteResultChip = () => {
  const {
    data
  } = useVoteData();
  const {
    castedVote
  } = data;
  if (!castedVote) {
    return /* @__PURE__ */ jsx(CardChip$1, {
      color: "#f44336",
      children: "not voted"
    });
  }
  const {
    up,
    text
  } = castedVote;
  const vote = up > 0 ? "+1" : "-1";
  return /* @__PURE__ */ jsxs(CardChip$1, {
    children: [vote, " : ", text]
  });
};
const VotesTotalChip = () => {
  const {
    data
  } = useVoteData();
  const {
    poll: {
      value = {
        up: 0,
        down: 0
      }
    }
  } = data;
  const {
    up,
    down
  } = value;
  const vote = `+${up}/-${down}`;
  return /* @__PURE__ */ jsx(CardChip$1, {
    children: vote
  });
};
const VoteContentBody = () => {
  const {
    notifications
  } = useCardsTheme();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(VoteTitle$1, {}), /* @__PURE__ */ jsxs(SubText, {
      children: [/* @__PURE__ */ jsx(VoteResultChip, {}), /* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(VotesTotalChip, {}), /* @__PURE__ */ jsx(VotesDescriptionChip, {}), /* @__PURE__ */ jsx(VoteTimeChip, {}), notifications]
    })]
  });
};
const VoteContentWrapper$1 = ({
  children,
  data,
  ...other
}) => {
  const {
    _id
  } = data;
  const {
    content: contentOuterComponen
  } = other;
  const {
    linkToPage
  } = useCardsTheme();
  const ContentLink = useMemo(() => {
    if (!linkToPage) {
      return null;
    }
    return ({
      children: children2
    }) => /* @__PURE__ */ jsx(Link$2, {
      to: "/groups/" + _id,
      component: ContentOuterLink$3,
      children: children2
    });
  }, [linkToPage, _id]);
  const Content = contentOuterComponen || ContentLink || ContentOuter$5;
  return /* @__PURE__ */ jsx(Content, {
    children
  });
};
const VoteCardImp = (props) => {
  const {
    data
  } = props;
  const {
    cardImage
  } = useCardsTheme();
  if (cardImage) {
    const {
      root
    } = data;
    const {
      image
    } = root;
    return /* @__PURE__ */ jsx(CardOuter, {
      children: /* @__PURE__ */ jsxs(VoteContentWrapper$1, {
        ...props,
        children: [/* @__PURE__ */ jsx(Image$1, {
          image,
          square: true
        }), /* @__PURE__ */ jsx(ContentBodyWrapper$5, {
          children: /* @__PURE__ */ jsx(VoteContentBody, {})
        })]
      })
    });
  }
  return /* @__PURE__ */ jsx(CardOuter, {
    children: /* @__PURE__ */ jsx(VoteContentBody, {})
  });
};

const CardsList$2 = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: column;
 `;
const VotesListDialog = ({
  data,
  startNewTheme = true,
  ...other
}) => {
  const {
    open,
    onClose,
    title
  } = other;
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$6, {
    fullScreen: true,
    ...other,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: title || "Votes in Circle"
    }), /* @__PURE__ */ jsx(DialogContent, {
      dividers: true,
      children: /* @__PURE__ */ jsx(CardsList$2, {
        children: /* @__PURE__ */ jsx(CardThemeProvider, {
          cardImage: true,
          startNewTheme,
          children: data && data.history.map((d) => {
            return /* @__PURE__ */ jsx(VoteActivityCard$1, {
              data: d
            }, d._id);
          })
        })
      })
    })]
  });
};

const usePostVotesActivity = (postId, op) => {
  const api = useApi();
  const result = useSWR(postId ? `/activities-votes/post/${postId}/votes` : null, (path) => api.activityRequest({
    path
  }), {
    ...swrLoadOnce,
    ...op,
    refreshInterval: activityRrefreshInterval
  });
  const {
    activities$
  } = useActivityContext();
  activities$.useSubscription(({
    type
  }) => {
    if (type !== "vote") {
      return;
    }
    const {
      mutate,
      isValidating
    } = result;
    if (!isValidating) {
      mutate();
    }
  });
  return result;
};

const VoteIcon = ({
  size,
  ...props
}) => {
  return /* @__PURE__ */ jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M10.1068 14.0796C10.5482 14.4331 11.1899 14.3636 11.5434 13.9222C14.4757 10.2685 18.8304 8.17388 23.4977 8.17388C28.165 8.17388 32.5197 10.2685 35.452 13.9222C35.6543 14.1736 35.9527 14.3043 36.251 14.3043C36.4758 14.3043 36.7005 14.2307 36.8886 14.0795C37.3279 13.7259 37.3994 13.0822 37.0459 12.643C33.7233 8.50492 28.7862 6.13043 23.4977 6.13043C18.2091 6.13043 13.2701 8.50492 9.94944 12.643C9.59589 13.0823 9.66744 13.726 10.1068 14.0796Z",
      fill: "#4A90CE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M27.587 28.6087C28.151 28.6087 28.6088 28.1509 28.6088 27.5869V20.4347H30.6522C31.2162 20.4347 31.674 19.977 31.674 19.413C31.674 18.849 31.2162 18.3913 30.6522 18.3913H24.5218C23.9578 18.3913 23.5 18.8491 23.5 19.4131C23.5 19.9771 23.9578 20.4348 24.5218 20.4348H26.5652V27.5869C26.5652 28.1509 27.023 28.6087 27.587 28.6087Z",
      fill: "#4A90CE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M16.3477 21.4565V25.5435C16.3477 27.2335 17.7229 28.6087 19.4129 28.6087C21.1029 28.6087 22.4781 27.2335 22.4781 25.5435V21.4565C22.4781 19.7665 21.1029 18.3913 19.4129 18.3913C17.7229 18.3913 16.3477 19.7665 16.3477 21.4565ZM20.4345 21.4565V25.5435C20.4345 26.1075 19.9768 26.5653 19.4128 26.5653C18.8488 26.5653 18.3911 26.1075 18.3911 25.5435V21.4565C18.3911 20.8925 18.8489 20.4347 19.4129 20.4347C19.9769 20.4347 20.4345 20.8925 20.4345 21.4565Z",
      fill: "#4A90CE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M34.6118 34.0361C31.6815 37.1238 27.7355 38.826 23.5015 38.826C19.2674 38.826 15.3215 37.1259 12.3911 34.0361C12.0049 33.6274 11.3571 33.6111 10.9464 33.9973C10.5356 34.3856 10.5192 35.0314 10.9076 35.4421C14.2261 38.9426 18.6993 40.8695 23.4995 40.8695C28.2996 40.8695 32.7728 38.9426 36.0955 35.4421C36.4817 35.0314 36.4653 34.3835 36.0567 33.9973C35.6479 33.6111 35.0001 33.6274 34.6118 34.0361Z",
      fill: "#4A90CE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M23.5 0C10.5423 0 0 10.5423 0 23.5C0 36.4576 10.5423 46.9999 23.5 46.9999C36.4576 46.9999 46.9999 36.4576 46.9999 23.5C46.9999 10.5423 36.4577 0 23.5 0ZM23.5 44.9565C11.6682 44.9565 2.04344 35.3317 2.04344 23.5C2.04344 11.6682 11.6682 2.04344 23.5 2.04344C35.3317 2.04344 44.9565 11.6682 44.9565 23.5C44.9565 35.3317 35.3317 44.9565 23.5 44.9565Z",
      fill: "#4A90CE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M37.8041 26.5652H34.7389V24.5217H35.7606C36.3246 24.5217 36.7824 24.064 36.7824 23.5C36.7824 22.936 36.3246 22.4782 35.7606 22.4782H34.7389V20.4347H37.8041C38.3681 20.4347 38.8258 19.977 38.8258 19.413C38.8258 18.849 38.3681 18.3913 37.8041 18.3913H33.7171C33.1531 18.3913 32.6953 18.8491 32.6953 19.4131V27.5869C32.6953 28.1509 33.1531 28.6087 33.7171 28.6087H37.8041C38.3681 28.6087 38.8258 28.1509 38.8258 27.5869C38.8258 27.0229 38.3681 26.5652 37.8041 26.5652Z",
      fill: "#4A90CE"
    }), /* @__PURE__ */ jsx("path", {
      d: "M11.1742 27.9466L14.2394 19.7727C14.4376 19.2435 14.17 18.655 13.6427 18.4567C13.1114 18.2605 12.525 18.5241 12.3267 19.0534L10.2178 24.677L8.10897 19.0534C7.91079 18.5262 7.32227 18.2625 6.79294 18.4567C6.26572 18.6549 5.998 19.2434 6.19628 19.7727L9.26149 27.9466C9.41064 28.3451 9.79283 28.6087 10.2178 28.6087C10.6429 28.6087 11.0249 28.3451 11.1742 27.9466Z",
      fill: "#4A90CE"
    })]
  });
};

const PostVotingIcon = (props) => {
  const {
    openReply
  } = usePostUpdatesContext();
  const {
    post
  } = usePostContext();
  const [open, setOpen] = useState(false);
  const {
    data
  } = usePostVotesActivity(post && post._id);
  if (!data) {
    return null;
  }
  const {
    history
  } = data;
  if (!history.length) {
    return null;
  }
  const onLinkClick = (ev, data2) => {
    ev.preventDefault();
    ev.stopPropagation();
    setOpen(false);
    openReply(data2.post._id);
  };
  return /* @__PURE__ */ jsxs(CardThemeProvider, {
    onLinkClick,
    startNewTheme: true,
    linkConfig: {
      info: false
    },
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      onClick: () => setOpen(true),
      children: /* @__PURE__ */ jsx(Badge$2, {
        ...votingBadgeProps(history),
        children: /* @__PURE__ */ jsx(VoteIcon, {
          ...commonIconProps,
          ...props
        })
      })
    }), /* @__PURE__ */ jsx(VotesListDialog, {
      fullScreen: false,
      open,
      onClose: () => setOpen(false),
      data,
      title: `Votes in the Post "${post && post.title}"`,
      startNewTheme: false
    })]
  });
};

const PostUIContext = React__default.createContext({
  share: void 0,
  dialog: false,
  open: false,
  drawer: false,
  setOpen: noop$B,
  setShare: noop$B
});

const usePostUIContext = () => {
  return useContext(PostUIContext);
};

const ShareMenuItem = ({
  response
}) => {
  const {
    membership,
    profile
  } = usePostInfoContext();
  const {
    setShare
  } = usePostUIContext();
  if (!response) {
    return null;
  }
  const notAuthor = !isAuthor(response, profile);
  if (!isAdmin(membership) && notAuthor) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: () => setShare(response),
    children: "Share..."
  });
};
const ShareIconButton = ({
  response
}) => {
  const {
    setShare
  } = usePostUIContext();
  if (!response) {
    return null;
  }
  return /* @__PURE__ */ jsx(IconButton$5, {
    onClick: () => setShare(response),
    children: /* @__PURE__ */ jsx(BsShare, {})
  });
};
const SocialButtons = ({
  url,
  post
}) => {
  if (isMobileWrapper()) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className: "flex items-center justify-center gap-3 w-full p-2",
    children: /* @__PURE__ */ jsx(SharingButtons, {
      ...post,
      url
    })
  });
};
const ShareSection = ({
  post
}) => {
  const {
    instance
  } = useProfileContext();
  const url = url4post(post);
  const {
    domainName
  } = instance;
  const fullURL = `https://${domainName}${url}`;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(SocialButtons, {
      post,
      url: fullURL
    }), /* @__PURE__ */ jsx("div", {
      className: "w-full flex justify-center p-2",
      children: /* @__PURE__ */ jsx("span", {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "compose.share.share_article"
        })
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "self-center",
      children: [/* @__PURE__ */ jsx("span", {
        className: "break-words overflow-hidden",
        children: fullURL
      }), /* @__PURE__ */ jsx("span", {
        className: "inline m-2 self-center",
        children: /* @__PURE__ */ jsx(CopyToClipboard, {
          text: fullURL,
          onCopy: () => toast("Copied to clipboard"),
          children: /* @__PURE__ */ jsx(Button, {
            variant: "contained",
            className: "inline",
            children: "Copy"
          })
        })
      })]
    })]
  });
};
const SharePostDialog = (props) => {
  const {
    share,
    setShare
  } = usePostUIContext();
  if (!share) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$6, {
    open: true,
    ...props,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      icon: /* @__PURE__ */ jsx(DialogIcon, {
        children: /* @__PURE__ */ jsx(BsShare, {})
      }),
      onClose: () => setShare(null),
      children: "Share"
    }), /* @__PURE__ */ jsx(DialogContent, {
      dividers: true,
      children: /* @__PURE__ */ jsx(ShareSection, {
        post: share
      })
    })]
  });
};

const tabsIconClassName = "w-4 h-4 lg:w-6 lg:h-6 xl:w-8 xl:h-8 ";
const ColumnHeader = ({
  children,
  icon,
  iconComponent: IconComponent,
  tooltip,
  always
}) => {
  const iconClassName = tabsIconClassName;
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex-col items-center gap-0 w-full", !always ? "hidden lg:flex" : "flex"),
    children: [icon && /* @__PURE__ */ jsx("img", {
      className: iconClassName,
      src: icon
    }), IconComponent && /* @__PURE__ */ jsx(IconComponent, {
      className: iconClassName,
      color: "#4A90CE"
    }), /* @__PURE__ */ jsxs("div", {
      className: "group relative",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold flex items-center",
        children
      }), tooltip && /* @__PURE__ */ jsx(Tooltip, {
        children: tooltip
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "w-full border-b border-gray-500"
    })]
  });
};

const TabItem = (props) => {
  const {
    icon,
    iconComponent: IconComponent,
    className
  } = props;
  const iconClassName = tabsIconClassName;
  return /* @__PURE__ */ jsxs("button", {
    onClick: props.onClick,
    className: clsx("flex flex-col justify-start items-center relative gap-2 w-fit sm:w-auto cursor-pointer", className),
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex justify-start items-end gap-1 w-max",
      children: [icon && /* @__PURE__ */ jsx("img", {
        className: iconClassName,
        src: icon
      }), IconComponent && /* @__PURE__ */ jsx(IconComponent, {
        className: iconClassName,
        color: "#4A90CE"
      }), /* @__PURE__ */ jsx("p", {
        className: "w-max text-xs md:text-sm xl:text-base font-semibold text-left text-black inline-flex justify-end items-end",
        children: props.title
      }), props.active && /* @__PURE__ */ jsx("svg", {
        width: "6",
        height: "6",
        viewBox: "0 0 6 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "xMidYMid meet",
        className: "absolute top-0 -right-1",
        children: /* @__PURE__ */ jsx("circle", {
          cx: "3",
          cy: "3",
          r: "3",
          fill: "#FE975D"
        })
      })]
    }), /* @__PURE__ */ jsx("svg", {
      width: "134",
      height: "4",
      viewBox: "0 0 134 4",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: `w-full h-1 ${props.active ? "" : "opacity-0"}`,
      preserveAspectRatio: "none",
      children: /* @__PURE__ */ jsx("path", {
        d: "M0 2H133.5",
        stroke: "black",
        strokeWidth: "4"
      })
    })]
  });
};

const noop$m = () => null;
const emptyDynamicList = () => {
  return {
    list: [],
    insert: noop$m,
    merge: noop$m,
    replace: noop$m,
    remove: noop$m,
    getKey: noop$m,
    getIndex: noop$m,
    move: noop$m,
    push: noop$m,
    pop: noop$m,
    unshift: noop$m,
    shift: noop$m,
    sortList: noop$m,
    resetList: noop$m
  };
};

const noop$l = () => null;
const CirclePostsContext = React__default.createContext({
  content: {},
  order: [],
  posts: emptyDynamicList(),
  error: void 0,
  loading: false,
  updatePost: noop$l,
  deletePost: noop$l,
  refresh: noop$l
});
const useCirclePostsContext = () => {
  return useContext(CirclePostsContext);
};
const getPostsList = (content, order) => order.map((id) => content[id]);
const CirclePostsContextProvider = ({
  content,
  order,
  error,
  loading,
  mutate,
  children
}) => {
  const first = useRef(content).current;
  const posts = useDynamicList(getPostsList(content || {}, order || []));
  const [current, setCurrent] = useState(content);
  useEffect(() => {
    if (!content || !order || first === content) {
      return;
    }
    posts.resetList(getPostsList(content, order));
    if (content !== current) {
      setCurrent(content);
    }
  }, [content, order]);
  const updatePost = useMemoizedFn((post) => {
    const id = posts.list.findIndex((p) => {
      return p._id === post._id;
    });
    if (id === -1) {
      posts.push(post);
      mutate();
      setCurrent({
        ...current,
        [post._id]: post
      });
      return;
    }
    posts.replace(id, post);
    setCurrent({
      ...current,
      [post._id]: post
    });
  });
  const deletePost = useMemoizedFn((post) => {
    const id = posts.list.findIndex((p) => {
      return p._id === post._id;
    });
    if (id === -1) {
      return;
    }
    posts.remove(id);
    const updated = {
      ...current
    };
    delete updated[post._id];
    setCurrent(updated);
  });
  const refresh = useMemoizedFn(() => {
    mutate();
  });
  const context = useMemo(() => {
    return {
      order,
      content: current,
      posts,
      error,
      loading,
      updatePost,
      deletePost,
      refresh
    };
  }, [order, current, posts, error, loading]);
  return /* @__PURE__ */ jsx(CirclePostsContext.Provider, {
    value: context,
    children
  });
};

const StyledMenuButton$1 = (props) => {
  return /* @__PURE__ */ jsx("button", {
    className: "p-[3px] sm:p-[6px] w-max rounded-full flex justify-between items-center hover:bg-slate-200 active:scale-125 active:bg-slate-300",
    ...props,
    children: /* @__PURE__ */ jsx(BsThreeDotsVertical, {
      className: "w-[24px] h-[24px] sm:w-[30px] sm:h-[30px]"
    })
  });
};

const PostAuthor$1 = ({
  post,
  className,
  textSize,
  children,
  ...other
}) => {
  const {
    author
  } = post;
  const metadata = post.metadata || {};
  const {
    authorAvatar,
    author: authorName
  } = metadata;
  const displayName = getPersonName(author);
  const differentAuthor = authorName && authorName !== displayName;
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex justify-start items-center relative gap-2.5", className),
    ...other,
    children: [/* @__PURE__ */ jsx(Avatar, {
      avatar: differentAuthor ? authorAvatar : author.avatar,
      size: 24
    }), /* @__PURE__ */ jsxs("p", {
      className: clsx("text-black", textSize ? textSize : "text-2xs"),
      children: [/* @__PURE__ */ jsx("span", {
        children: authorName || displayName
      }), differentAuthor && /* @__PURE__ */ jsxs("span", {
        className: "text-gray-400 opacity-70",
        children: ["\xA0Added by:\xA0", displayName]
      })]
    }), children]
  });
};

const Wrapper$G = ({
  children
}) => /* @__PURE__ */ jsx(Fragment, {
  children
});
const PostImage = ({
  post,
  width,
  height,
  className
}) => {
  const {
    image
  } = post;
  if (!image || !image.uuid) {
    return /* @__PURE__ */ jsx("div", {
      style: {
        width,
        height,
        minWidth: width,
        minHeight: height
      }
    });
  }
  return /* @__PURE__ */ jsx(ScaledImageProxy, {
    component: Wrapper$G,
    className,
    uuid: image.uuid,
    w: width,
    h: height,
    crop: true
  });
};

const TimeIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      d: "M18 19V23.7C18.7058 23.458 19.348 23.0602 19.879 22.536L22.535 19.878C23.0598 19.3477 23.458 18.7057 23.7 18H19C18.7348 18 18.4804 18.1054 18.2929 18.2929C18.1054 18.4804 18 18.7348 18 19Z",
      fill: "#767676"
    }), /* @__PURE__ */ jsx("path", {
      d: "M7.172 13.8279C6.80042 14.1994 6.50566 14.6404 6.30457 15.1258C6.10347 15.6112 5.99998 16.1315 6 16.6569V17.9999H7.343C7.86841 17.9999 8.38868 17.8964 8.87409 17.6953C9.3595 17.4942 9.80053 17.1995 10.172 16.8279L21.5 5.49988C21.8978 5.10206 22.1213 4.56249 22.1213 3.99988C22.1213 3.43727 21.8978 2.89771 21.5 2.49988C21.1022 2.10206 20.5626 1.87856 20 1.87856C19.4374 1.87856 18.8978 2.10206 18.5 2.49988L7.172 13.8279Z",
      fill: "#767676"
    }), /* @__PURE__ */ jsx("path", {
      d: "M24 4.952C23.8297 5.6938 23.4557 6.37332 22.92 6.914L11.586 18.243C11.0301 18.8019 10.3688 19.2449 9.64049 19.5465C8.91218 19.8481 8.13128 20.0022 7.343 20H6C5.46957 20 4.96086 19.7893 4.58579 19.4142C4.21071 19.0391 4 18.5304 4 18V16.657C3.99781 15.8688 4.15207 15.088 4.45384 14.3598C4.75561 13.6316 5.1989 12.9706 5.758 12.415L17.086 1.086C17.6226 0.549539 18.2983 0.173439 19.037 0C19.024 0 19.013 0 19 0H5C3.6744 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.6744 0 5V19C0.00158786 20.3256 0.528882 21.5964 1.46622 22.5338C2.40356 23.4711 3.6744 23.9984 5 24H16V19C16 18.2044 16.3161 17.4413 16.8787 16.8787C17.4413 16.3161 18.2044 16 19 16H24V5C24 4.984 24 4.969 24 4.952Z",
      fill: "#767676"
    })]
  });
};

const ReadTimeIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ...props,
    children: [/* @__PURE__ */ jsx("g", {
      clipPath: "url(#clip0_110_974)",
      children: /* @__PURE__ */ jsx("path", {
        d: "M22.2 2.16297C21.6299 1.68733 20.9611 1.34462 20.242 1.15971C19.523 0.974805 18.7718 0.952348 18.043 1.09397L16.279 1.52597C15.3584 1.69467 14.5262 2.18081 13.9271 2.89979C13.3279 3.61878 12.9999 4.52508 13 5.46097V20.928C12.3369 21.025 11.6631 21.025 11 20.928V5.46097C11.0033 4.53371 10.6828 3.63438 10.0939 2.91818C9.50493 2.20197 8.68444 1.71382 7.774 1.53797L5.9 1.08197C5.17916 0.950066 4.43813 0.978222 3.72938 1.16445C3.02062 1.35067 2.36147 1.69042 1.79857 2.15963C1.23567 2.62884 0.782786 3.21604 0.471982 3.87968C0.161178 4.54332 4.88125e-05 5.26716 0 5.99997L0 16.793C5.74559e-05 17.9638 0.410977 19.0974 1.16113 19.9963C1.91129 20.8952 2.95311 21.5024 4.105 21.712L10.391 22.855C11.455 23.0483 12.545 23.0483 13.609 22.855L19.9 21.712C21.051 21.5014 22.0916 20.8938 22.8408 19.9949C23.5899 19.0961 24.0002 17.9631 24 16.793V5.99997C24.0005 5.26742 23.8394 4.54377 23.5283 3.88057C23.2171 3.21736 22.7636 2.63091 22.2 2.16297V2.16297Z",
        fill: "#767676"
      })
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_110_974",
        children: /* @__PURE__ */ jsx("rect", {
          width: "24",
          height: "24",
          fill: "white"
        })
      })
    })]
  });
};

const ResponsesIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    ...props,
    children: [/* @__PURE__ */ jsx("g", {
      children: /* @__PURE__ */ jsx("path", {
        d: "M8.7 17.9999H3C1.507 17.9999 0 16.8659 0 14.3339V9.29392C0.0210272 6.99609 0.881427 4.78523 2.41918 3.07766C3.95693 1.3701 6.06592 0.283652 8.349 0.0229194C9.63736 -0.0706063 10.9308 0.114301 12.1413 0.565077C13.3518 1.01585 14.4512 1.72193 15.3646 2.63534C16.278 3.54874 16.9841 4.64807 17.4348 5.85862C17.8856 7.06916 18.0705 8.36256 17.977 9.65092C17.7159 11.9349 16.6286 14.0446 14.9198 15.5825C13.211 17.1203 10.9988 17.9801 8.7 17.9999ZM20 9.07992H19.988C19.988 9.31692 19.988 9.55392 19.976 9.79192C19.59 15.1999 14.647 19.7779 9.084 19.9809V19.9959C9.7846 21.211 10.7924 22.2206 12.0062 22.9233C13.2201 23.6261 14.5974 23.9974 16 23.9999H21C21.7956 23.9999 22.5587 23.6839 23.1213 23.1212C23.6839 22.5586 24 21.7956 24 20.9999V15.9999C23.9986 14.597 23.6282 13.2192 22.9262 12.0046C22.2241 10.79 21.2149 9.78137 20 9.07992Z",
        fill: "#767676"
      })
    }), /* @__PURE__ */ jsx("defs", {})]
  });
};

const useLoginPopup = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [authOpen, setAuthOpen] = useState(false);
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const login = () => {
    setAnchorEl(null);
    setAuthOpen(true);
  };
  const open = Boolean(anchorEl);
  const id = open ? "login-popover" : void 0;
  return {
    id,
    open,
    login,
    handleClick,
    handleClose,
    anchorEl,
    authOpen,
    setAuthOpen
  };
};
const LoginPopup = ({
  state
}) => {
  const {
    id,
    open,
    login,
    handleClose,
    anchorEl,
    authOpen,
    setAuthOpen
  } = state;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Popover, {
      id,
      open,
      anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      children: open && /* @__PURE__ */ jsx("div", {
        className: "p-2 flex items-center",
        onClick: login,
        children: /* @__PURE__ */ jsxs("div", {
          className: "p-2 underline flex items-center cursor-pointer bg-red-600 rounded-md gap-2 text-white",
          children: [/* @__PURE__ */ jsx(MdLogin, {}), /* @__PURE__ */ jsx(FormattedMessage, {
            id: "group.login_to_join"
          })]
        })
      })
    }), /* @__PURE__ */ jsx(AuthDialog, {
      open: authOpen,
      onClose: () => setAuthOpen(false)
    })]
  });
};

const info$3 = createLogger("info:ui");
const useResponsesDataCore = (raw) => {
  return useCreation(() => {
    if (!raw) {
      raw = {};
    }
    const {
      responses,
      authors,
      order
    } = raw;
    if (!responses) {
      return {
        order: [],
        responses: {},
        authors: {},
        lastNotes: [],
        lastRatings: []
      };
    }
    const processed = processResponses(authors, responses, order);
    return {
      ...raw,
      ...processed
    };
  }, [raw]);
};
const processResponses = (authors, all, order) => {
  const responsesById = {};
  const flat = [];
  const processOne = (one, numbering) => {
    const copied = {
      ...one,
      numbering
    };
    flat.push(copied);
    copied.author = authors[one.author];
    if (one.responses) {
      copied.responses = one.responses.map((r, i) => processOne(r, [...numbering, i]));
    }
    responsesById[one._id] = copied;
    return copied;
  };
  const responses = {};
  order.forEach((id, i) => {
    responses[id] = processOne(all[id], [i]);
  });
  const rt = {
    responses,
    responsesById,
    all: flat
  };
  info$3("processed responses: %o", rt);
  return rt;
};

const ResponsesDataContext = React__default.createContext({
  id: void 0,
  responses: {},
  order: [],
  authors: {},
  loading: false,
  error: void 0,
  lastNotes: [],
  lastRatings: [],
  responsesById: {},
  timestamp: "",
  all: []
});
const useResponsesDataContext = () => {
  return useContext(ResponsesDataContext);
};
const ResponsesDataContextProvider = ({
  children,
  responsesRequestResult
}) => {
  const data = useResponsesDataCore(responsesRequestResult);
  return /* @__PURE__ */ jsx(ResponsesDataContext.Provider, {
    value: data,
    children
  });
};

const useLocalStorageState = (localStorageName) => {
  const [open, setOpenMem] = useState(() => {
    return typeof localStorage !== "undefined" && localStorage[localStorageName];
  });
  const setOpen = useCallback((v) => {
    if (v) {
      localStorage[localStorageName] = v;
    } else {
      delete localStorage[localStorageName];
    }
    setOpenMem(v);
  }, []);
  return [open, setOpen];
};

const localStorageName = "notificationsOpen";
const PostUIContextProvider = ({
  dialog,
  children
}) => {
  const [open, setOpen] = useLocalStorageState(localStorageName);
  const [share, setShare] = useState();
  const drawer = useMediaQuery("(max-width:600px)");
  const context = useMemo(() => ({
    open,
    setOpen,
    drawer,
    share,
    setShare,
    dialog
  }), [open, drawer, setOpen, share, dialog]);
  return /* @__PURE__ */ jsx(PostUIContext.Provider, {
    value: context,
    children
  });
};

const wasSeen = (api, postId, modified) => {
  return api.makeRequest({
    path: `/visits/posts/${postId}/seen`,
    method: "POST",
    body: {
      modified
    }
  });
};

const useWasSeen = (post, profile) => {
  const api = useApi();
  const postIdRef = useRef();
  if (!post || !profile) {
    return;
  }
  const authorId = post.author._id;
  const userId = profile._id;
  if (userId === authorId) {
    return;
  }
  const postId = post._id;
  if (postIdRef.current === postId) {
    return;
  }
  postIdRef.current = postId;
  wasSeen(api, postId, post.modified);
};

const PostViewDataContextCoreProviderInner = ({
  children,
  profile,
  post,
  helper,
  responsesRequestResult,
  response = {},
  circle,
  membership,
  invitation,
  loadPost,
  loadResponses,
  postCircleError,
  postError,
  profileError,
  dialog
}) => {
  const [_, setCounter] = useState(0);
  helper.setCounter = setCounter;
  helper.profile = profile;
  helper.setMainPost(post);
  helper.setResponsesResult(responsesRequestResult);
  useWasSeen(post, profile);
  const event$ = useEventEmitter();
  const {
    rating,
    userVote,
    notesInfo
  } = helper;
  const infoContext = useMemo(() => ({
    rating,
    userVote,
    notesInfo,
    circle,
    membership,
    invitation,
    profile,
    post,
    loadPost: loadPost || noop$B,
    loadResponses: loadResponses || noop$B,
    event$,
    postCircleError,
    postError,
    profileError
  }), [rating, userVote, notesInfo, circle, membership, invitation, profile, post, loadPost, loadResponses, postCircleError, postError, profileError]);
  return /* @__PURE__ */ jsx(PostInfoContext.Provider, {
    value: infoContext,
    children: /* @__PURE__ */ jsx(PostUpdatesContextProvider, {
      helper,
      children: /* @__PURE__ */ jsx(PostUIContextProvider, {
        dialog,
        children: /* @__PURE__ */ jsx(ResponsesContextProvider, {
          ...response,
          children: /* @__PURE__ */ jsx(ResponsesDataContextProvider, {
            responsesRequestResult: helper.responsesRequestResult,
            children: /* @__PURE__ */ jsx(PostContextProvider, {
              post,
              children: /* @__PURE__ */ jsx(AccessContextProvider, {
                children: /* @__PURE__ */ jsx(PostPageVisitor, {
                  children
                })
              })
            })
          })
        })
      })
    })
  });
};
const PostViewDataContextCoreProvider = (props) => {
  return /* @__PURE__ */ jsx(PostViewDataContextCoreProviderInner, {
    ...props
  });
};

const flattenResponses = (all) => {
  const flattened = {};
  const flattenOne = (one) => {
    flattened[one._id] = one;
    if (one.responses) {
      one.responses.forEach(flattenOne);
    }
  };
  Object.values(all).forEach(flattenOne);
  return flattened;
};

const extractResponsesData = (responsesResult) => {
  if (!responsesResult.extra) {
    responsesResult.extra = {};
  }
  const extra = responsesResult.extra;
  if (!extra.timestamp) {
    extra.timestamp = new Date().toISOString();
  }
  const {
    map: responses,
    list: { loading, error, values: order } = {}
  } = responsesResult;
  return { responses, loading, error, order, ...extra };
};

const EMPTY_RANGE = {
  start: 0,
  end: 0,
  total: 0
};
const listRequest2Redux = (result, state = {}) => {
  const { values = [], range = EMPTY_RANGE, extra } = result;
  return {
    ...state,
    map: Object.assign({}, state.map, mapById(values)),
    list: {
      loading: false,
      values: values.map((p) => p._id || p.id),
      range
    },
    extra
  };
};
const mapById = (list) => list.reduce((r, p) => {
  r[p._id || p.id] = p;
  return r;
}, {});

const LanguageSelectionContext = React__default.createContext(void 0);
const useLanguageSelectionContext = () => {
  const context = useContext(LanguageSelectionContext);
  if (context === void 0) {
    throw new Error("useLanguageSelectionContext must be used within a LanguageSelectionContextProvider");
  }
  return context;
};
const isValidLanguageCode = (value) => {
  return typeof value === "string" && (value.length === 2 || value.length === 3);
};
const LanguageSelectionContextProvider = ({
  children
}) => {
  const [language, setLanguageRaw] = useLocalStorageState$1("lang", {
    defaultValue: "",
    serializer: (value) => value,
    deserializer: (value) => {
      if (isValidLanguageCode(value)) {
        return value;
      }
      return "";
    }
  });
  const setLanguage = (lang) => {
    if (!lang || !isValidLanguageCode(lang)) {
      setLanguageRaw(void 0);
    } else {
      setLanguageRaw(lang);
    }
  };
  const context = useMemo(() => ({
    language: language || "",
    setLanguage
  }), [language]);
  return React__default.createElement(LanguageSelectionContext.Provider, {
    value: context
  }, children);
};

const loadResponses = async (api, postId, language) => {
  const opts = {
    _id: postId,
    language
  };
  const result = await api.loadResponses(opts);
  const responsesRequestResult = extractResponsesData(listRequest2Redux(result));
  return responsesRequestResult;
};
const loadPage = async (api, postId, options = {}) => {
  return api.get({
    path: `/post-page/${postId}` + buildQueryString(options)
  });
};
const loadPost = async (api, postId, options = {}) => {
  return api.get({
    path: `/post-view/${postId}` + buildQueryString(options)
  });
};
const postResponsesPath = (postId) => `/post-view-responses/${postId}`;
const mutatePostResponses = (postId) => mutate(postResponsesPath(postId));
const useLoadResponses = (postId, op) => {
  const api = useApi();
  const {
    language
  } = useLanguageSelectionContext();
  const result = useSWR(postId ? [postResponsesPath(postId), language] : null, async () => {
    return loadResponses(api, postId, language);
  }, {
    ...swrLoadOnce,
    ...op
  });
  return result;
};
const usePostGroupData = (postId, op) => {
  const api = useApi();
  const result = useSWR(postId ? `/posts/${postId}/group` : null, async () => {
    return loadPostCircleData(api, postId);
  }, {
    ...swrLoadOnce,
    ...op
  });
  return result;
};
const loadPostCircleData = async (api, postId) => {
  return api.makeRequest({
    path: `/posts/${postId}/group`
  });
};
const loadPostViewData = async (api, postId) => {
  const [responsesRequestResult, {
    group,
    membership,
    invitation
  }] = await Promise.all([loadResponses(api, postId), loadPostCircleData(api, postId)]);
  return {
    responsesRequestResult,
    group,
    membership,
    invitation
  };
};

const useDimensionsState = () => {
  const [selectedPersons, setSelectedPersons] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedOrganizations, setSelectedOrganizations] = useState([]);
  return {
    selectedPersons,
    setSelectedPersons,
    selectedLocations,
    setSelectedLocations,
    selectedOrganizations,
    setSelectedOrganizations
  };
};

const useTrackExecution = (id, interval = 5e3) => {
  const api = useApi();
  const {
    data,
    error,
    isValidating
  } = useSWR(id ? `/async-execution/item/${id}` : null, async (path) => {
    return await api.get({
      path: "/async-execution/item/?id=" + id
    });
  }, {
    refreshInterval: (data2) => {
      if (!data2 || !data2.execution) {
        return 0;
      }
      const {
        status: status2
      } = data2.execution;
      if (!status2) {
        return 0;
      }
      return status2 === "executing" ? interval : 0;
    },
    revalidateOnFocus: false
  });
  const execution = data && data.execution;
  const status = execution && execution.status;
  const loading = isValidating || status === "executing";
  return {
    status,
    loading,
    execution,
    error
  };
};

const useCircleSearch = (request, options) => {
  const api = useApi();
  const {
    analyze,
    counter,
    language,
    postId,
    circleId,
    question,
    selectedPersons,
    selectedLocations,
    selectedOrganizations,
    prompt
  } = request;
  const result = useSWR(counter ? [counter, "/admin/vector/search", language, postId, circleId, question, selectedPersons, selectedLocations, selectedOrganizations, prompt].flatMap((v) => v) : null, async (path) => {
    const result2 = await api.post({
      path: `/admin/vector/search?lang=${language || ""}`,
      body: {
        postId,
        circleId,
        question,
        selectedPersons,
        selectedLocations,
        selectedOrganizations,
        analyze,
        prompt
      }
    });
    return result2;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};

const htmlElementText = (el) => {
  return (el.textContent || el.innerText || "").trim();
};

const html2text = (content) => {
  const tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = content;
  return htmlElementText(tempDivElement);
};

const aiAnswerIntro = ({
  content,
  profile
}) => {
  return `<div class="ai-answer-intro">'${html2text(content)}'. In response to the above message by '${getPersonName(profile)}':</div>`;
};

const useCircle = (circleId, options) => {
  const api = useApi();
  return useSWR(circleId ? `/groups/${circleId}` : null, async () => {
    const data = await api.loadGroup({
      _id: circleId
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
};
const useSubCircles = (circleId, options) => {
  const api = useApi();
  return useSWR(circleId ? `/groups/${circleId}/groups/` : null, async () => {
    const result = await api.loadSubGroups({
      group: circleId
    });
    return result.values;
  }, {
    ...swrLoadOnce,
    ...options
  });
};
const useInstance = (options) => {
  const api = useApi();
  return useSWR(`/info`, () => api.loadInstanceInfo(), {
    ...swrLoadOnce,
    ...options
  });
};
const useAccessRequests = (circleId, options) => {
  const api = useApi();
  return useSWR(circleId ? `/groups/${circleId}/requests` : null, async () => {
    const result = await api.loadAccessRequests({
      group: circleId
    });
    return result.values;
  }, {
    ...swrLoadOnce,
    ...options
  });
};

const CircleContextProvider = ({
  children,
  id,
  circle,
  profile,
  requests,
  membership,
  invitation,
  error,
  event$,
  loading,
  instance,
  initialPosts
}) => {
  const [testPromptDialogOpen, setTestPromptDialogOpen] = useState(null);
  const [requestAccess, setRequestAccess] = useState(false);
  const [postsFilter, setPostsFilter] = useState("all");
  if (!circle) {
    return null;
  }
  const refresh = () => {
    window.location.reload();
  };
  const context = {
    id,
    postsFilter,
    setPostsFilter,
    showNotifications: true,
    circle,
    profile,
    requests,
    membership,
    invitation,
    requestAccess,
    setRequestAccess,
    refresh,
    error,
    event$,
    loading,
    testPromptDialogOpen,
    setTestPromptDialogOpen,
    instance,
    initialPosts
  };
  return /* @__PURE__ */ jsx(CircleContext.Provider, {
    value: context,
    children
  });
};

const CIRCLE_EVENT_REFRESH = "refresh";
const CIRCLE_EVENT_REFRESH_POSTS = "posts.refresh";

const LoadCircleData = ({
  circleId,
  initial = {},
  children,
  initialPosts,
  swrOptions
}) => {
  if (initial.group) {
    initial.circle = initial.group;
  }
  const {
    data: circleData,
    error,
    mutate
  } = useCircle(circleId, {
    ...swrOptions,
    onSuccess() {
      setLoading(false);
    },
    fallbackData: initial
  });
  const {
    data: profile
  } = useProfile({
    ...swrOptions,
    fallbackData: initial.profile
  });
  const {
    data: requests
  } = useAccessRequests(circleId, {
    ...swrOptions,
    fallbackData: initial.requests
  });
  const {
    data: instance
  } = useInstance({
    ...swrOptions,
    fallbackData: initial.instance
  });
  const event$ = useEventEmitter();
  const [loading, setLoading] = useState(!initial);
  event$.useSubscription((event) => {
    switch (event.type) {
      case CIRCLE_EVENT_REFRESH: {
        setLoading(true);
        mutate();
        break;
      }
    }
  });
  return /* @__PURE__ */ jsx(CircleContextProvider, {
    id: circleId,
    circle: circleData && circleData.group,
    invitation: circleData && circleData.invitation,
    membership: circleData && circleData.membership,
    profile,
    requests,
    error,
    event$,
    loading,
    instance,
    initialPosts,
    children
  });
};

const extractPosts = (posts) => {
  const {
    map: content,
    list
  } = posts;
  const {
    values: order
  } = list || {};
  return {
    content,
    order,
    intro: false,
    pinned: []
  };
};
const loadCirclePosts = async (api, circleId, filter = "", options = {}) => {
  const opts = {
    group: circleId,
    filter,
    ...options
  };
  const result = await api.loadGroupPosts(opts);
  const responsesRequestResult = extractPosts(listRequest2Redux(result));
  responsesRequestResult.intro = result.intro;
  responsesRequestResult.pinned = result.pinned;
  return responsesRequestResult;
};
const loadCircleReferences = async (api, circleId, filter = "") => {
  const opts = {
    group: circleId,
    filter
  };
  const result = await api.loadReferencesForGroup(opts);
  const responsesRequestResult = extractPosts(listRequest2Redux(result));
  return responsesRequestResult;
};

let counter$5 = 0;
const useAssistant$2 = (id, options) => {
  const api = useApi();
  const result = useSWR(id ? `/group-assistant/${id}` : null, async (path) => {
    const data = await api.get({
      path
    });
    counter$5++;
    return { ...data, counter: counter$5 };
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};

const useAssistants = (circleId, options) => {
  const api = useApi();
  const result = useSWR(circleId ? `/groups/${circleId}/assistants/` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};

const MAX_POSTS$1 = 25;
const isPermissionError = (error) => {
  if (!error)
    return false;
  const status = error.status;
  return status === 403 || status === 401;
};
const data2posts$1 = (data) => {
  const {
    content,
    order
  } = data;
  const posts = [];
  for (let i = 0; i < order.length; i++) {
    posts[i] = content[order[i]];
  }
  return posts;
};
const mappedPinned$1 = (data) => {
  const {
    pinned
  } = data;
  if (!pinned) {
    return {};
  }
  const result = {};
  for (const id of pinned) {
    result[id] = true;
  }
  return result;
};
const useCirclePostsState$2 = (circleId, options) => {
  const {
    chat,
    chatId,
    limit
  } = options || {};
  const [state, setState] = useSetState({
    moreLoading: false,
    loadMoreIndex: -1,
    intro: null,
    pinned: {}
  });
  const maxPosts = typeof limit === "number" ? limit : MAX_POSTS$1;
  const {
    loadMoreIndex,
    moreLoading,
    intro
  } = state;
  const firstLoaded = loadMoreIndex >= maxPosts;
  const [posts, setPosts] = useState();
  const [more, setMore] = useState([]);
  const {
    circle
  } = useCircleContext();
  const {
    language
  } = useLanguageSelectionContext();
  const api = useApi();
  const deletePost = useMemoizedFn((post) => {
    const idPosts = posts.findIndex((p) => {
      return p._id === post._id;
    });
    const idMore = more.findIndex((p) => {
      return p._id === post._id;
    });
    const notFound = idPosts === -1 && idMore === -1;
    if (notFound) {
      return;
    }
    const all2 = idPosts !== -1 ? posts : more;
    const setAll = idPosts !== -1 ? setPosts : setMore;
    setAll(all2.filter((p) => {
      if (p._id === post._id) {
        return false;
      }
      return true;
    }));
  });
  const togglePin = useMemoizedFn(async (id) => {
    const pinned = {
      ...state.pinned
    };
    const alreadyPinned = !!pinned[id];
    await api.post({
      path: alreadyPinned ? "/posts/pin/remove" : "/posts/pin",
      body: {
        ids: [id],
        group: circleId
      }
    });
    if (pinned[id]) {
      delete pinned[id];
    } else {
      pinned[id] = true;
    }
    setState({
      ...state,
      pinned
    });
  });
  const updatePost = useMemoizedFn((post) => {
    const idPosts = posts.findIndex((p) => {
      return p._id === post._id;
    });
    const idMore = more.findIndex((p) => {
      return p._id === post._id;
    });
    const notFound = idPosts === -1 && idMore === -1;
    if (notFound) {
      setPosts([post, ...posts]);
      return;
    }
    const all2 = idPosts !== -1 ? posts : more;
    const setAll = idPosts !== -1 ? setPosts : setMore;
    setAll(all2.map((p) => {
      if (p._id === post._id) {
        return post;
      }
      return p;
    }));
  });
  const load = async ({
    startIndex,
    stopIndex,
    noIntro
  }) => {
    if (!circleId) {
      return {
        content: {},
        order: [],
        pinned: [],
        intro: false
      };
    }
    const data = await loadCirclePosts(api, circleId, "", {
      intro: !noIntro && circle && circle.intro,
      noIntro,
      language,
      range: {
        start: startIndex + 1,
        end: stopIndex + 1
      },
      chat
    });
    return data;
  };
  useUpdateEffect(() => {
    if (isPermissionError(loadError))
      return;
    loadFirstRows();
  }, [language]);
  const {
    run: loadFirstRows,
    error: loadError,
    cancel: cancelLoadFirstRows
  } = useRequest(async () => {
    const range = {
      startIndex: 0,
      stopIndex: maxPosts - 1
    };
    const data = await load(range);
    const posts2 = data2posts$1(data);
    setState(({
      loadMoreIndex: loadMoreIndex2
    }) => {
      return {
        intro: data.intro && posts2[0] && posts2[0]._id,
        loadMoreIndex: Math.max(data.intro ? posts2.length - 1 : posts2.length, loadMoreIndex2),
        pinned: mappedPinned$1(data)
      };
    });
    setPosts(posts2);
  }, {
    manual: true,
    retryCount: -1,
    onError: (error) => {
      if (isPermissionError(error))
        cancelLoadFirstRows();
    }
  });
  const {
    run: loadMore
  } = useRequest(async () => {
    if (!firstLoaded) {
      loadFirstRows();
      return;
    }
    setState({
      moreLoading: true
    });
    const range = {
      startIndex: loadMoreIndex,
      stopIndex: loadMoreIndex + maxPosts - 1,
      noIntro: circle && circle.intro
    };
    const data = await load(range);
    const posts2 = data2posts$1(data);
    setState(({
      loadMoreIndex: loadMoreIndex2
    }) => {
      return {
        moreLoading: false,
        loadMoreIndex: loadMoreIndex2 + posts2.length,
        pinned: mappedPinned$1(data)
      };
    });
    setMore((prev) => [...prev, ...posts2]);
  }, {
    manual: true,
    retryCount: -1
  });
  useCreation(() => {
    if (!circle || !circleId) {
      return;
    }
    loadFirstRows();
  }, [!!circle, circleId]);
  const {
    activities$
  } = useActivityContext();
  const {
    run: loadFirstRowsThrottled
  } = useThrottleFn(async () => {
    loadFirstRows();
  }, {
    wait: 5e3
  });
  activities$.useSubscription((message) => {
    if (isPermissionError(loadError))
      return;
    const {
      type,
      circleId: circleId2
    } = message;
    if (type === "post" && !chat) {
      loadFirstRowsThrottled();
      return;
    }
    if (!chat) {
      return;
    }
    if (type === "chat" && circleId2 === chatId) {
      loadFirstRowsThrottled();
    }
  });
  const all = useCreation(() => {
    if (!posts) {
      return [];
    }
    const ids = {};
    return [...posts, ...more].filter((p) => {
      const id = p._id;
      if (ids[id]) {
        return false;
      }
      ids[id] = true;
      return true;
    });
  }, [posts, more]);
  return {
    posts,
    postsLoaded: !!posts,
    updatePost,
    deletePost,
    circle,
    state,
    firstLoaded,
    moreLoading,
    loadMore,
    more,
    all,
    intro,
    togglePin,
    loadError
  };
};
const noop$k = () => null;
const CirclePostsStateContext$1 = React__default.createContext({
  posts: void 0,
  postsLoaded: false,
  updatePost: noop$k,
  circle: void 0,
  state: {},
  firstLoaded: false,
  moreLoading: false,
  loadMore: noop$k,
  deletePost: noop$k,
  more: [],
  all: [],
  intro: void 0,
  togglePin: noop$k,
  loadError: void 0
});
const useCirclePostsStateContext$1 = () => {
  return useContext(CirclePostsStateContext$1);
};
const CirclePostsStateContextProvider$1 = ({
  children,
  state
}) => {
  return /* @__PURE__ */ jsx(CirclePostsStateContext$1.Provider, {
    value: state,
    children
  });
};

const usePostAssets = (postId, options) => {
  const api = useApi();
  const result = useSWR(postId ? `/posts/${postId}/asset/` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};

const usePost = (postId, options) => {
  const api = useApi();
  const result = useSWR(postId ? `/posts/${postId}` : null, async (path) => {
    const data = await api.loadPostById({
      _id: postId
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};

const BookAuthGateInner = ({
  postId,
  onClose
}) => {
  useSetOnLoginUrl();
  return /* @__PURE__ */ jsxs("div", {
    className: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 overflow-y-auto py-8",
    onClick: onClose ? (e) => {
      if (e.target === e.currentTarget)
        onClose();
    } : void 0,
    children: [onClose && /* @__PURE__ */ jsx("button", {
      type: "button",
      "aria-label": "Close",
      onClick: onClose,
      className: "fixed top-4 right-4 z-[51] w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-md hover:bg-gray-100 text-[20px] leading-none text-[color:var(--cair-text,#020203)]",
      children: "\u2715"
    }), /* @__PURE__ */ jsx(LoginForm$1, {}), /* @__PURE__ */ jsx(RegistrationForm$1, {
      postId
    }), /* @__PURE__ */ jsx(PhoneOtpForm, {}), /* @__PURE__ */ jsx(ConfirmationCode$1, {}), /* @__PURE__ */ jsx(ForgotPassword$1, {}), /* @__PURE__ */ jsx(ChangePassword$1, {})]
  });
};
const BookAuthGate = ({
  postId,
  onClose
}) => /* @__PURE__ */ jsx(RegistrationContextProvider, {
  children: /* @__PURE__ */ jsx(BookAuthGateInner, {
    postId,
    onClose
  })
});

const useCircle4Search = ({
  inPost
}) => {
  const {
    id: circleId,
    circle
  } = useCircleContext();
  const {
    circle: postCircle,
    post
  } = usePostInfoContext();
  if (inPost) {
    return {
      circleId: postCircle && postCircle._id,
      circle: postCircle,
      postId: post && post._id
    };
  }
  return {
    circleId,
    circle,
    postId: null
  };
};

const CircleSearchContext = React__default.createContext({
  asyncId: void 0,
  chat: void 0,
  isAdvisorEnabled: false,
  hasEmbeddingsOrAdvisor: false,
  isAIMode: false,
  setIsAIMode: noop$u,
  isSearchMode: false,
  setIsSearchMode: noop$u,
  prompt: "",
  setPrompt: noop$u,
  found: [],
  postsById: {},
  onSearch: noop$u,
  searchLoading: false,
  aiResponse: null,
  aiSearch: false,
  chunkTranslations: {},
  setAISearch: noop$u,
  setWebsocketMessage: noop$u
});
const useCircleSearchContext = () => {
  return useContext(CircleSearchContext);
};
const CircleSearchContextProvider = ({
  children,
  inPost
}) => {
  const {
    circleId,
    circle,
    postId
  } = useCircle4Search({
    inPost
  });
  const {
    language
  } = useLanguageSelectionContext();
  const [counter, setCounter] = useState(0);
  const [websocketMessage, setWebsocketMessage] = useState();
  const [state, setState] = useState({
    asyncId: void 0,
    chat: void 0,
    found: void 0,
    aiResponse: "",
    postsById: {},
    chunkTranslations: {}
  });
  const [isAIMode, setIsAIMode] = useState(false);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [prompt, setPrompt] = useState("");
  const dimensions = useDimensionsState();
  const [aiSearch, setAISearch] = useState(false);
  const [isAdvisorEnabled, setIsAdvisorEnabled] = useState(false);
  const [hasEmbeddingsOrAdvisor, setHasEmbeddingsOrAdvisor] = useState(false);
  const {
    execution
  } = useTrackExecution(!websocketMessage && state.asyncId, 10 * 1e3);
  useEffect(() => {
    if (!execution || !execution.data || execution.data.asyncId != state.asyncId) {
      return;
    }
    setWebsocketMessage(execution.data);
  }, [execution && execution.data && execution.data.asyncId]);
  const [question, setQuestion] = useState("");
  const {
    data,
    isValidating: searchLoading
  } = useCircleSearch({
    ...dimensions,
    language,
    postId,
    circleId,
    question,
    counter,
    analyze: isAIMode
  });
  useEffect(() => {
    if (!data) {
      return;
    }
    setState(data);
  }, [data]);
  useEffect(() => {
    if (!data || !websocketMessage) {
      return;
    }
    if (websocketMessage.asyncId !== data.asyncId) {
      setWebsocketMessage(void 0);
    }
  }, [data && data.asyncId]);
  useEffect(() => {
    if (!circle) {
      return;
    }
    const aiSearch2 = circle.embeddings || circle.aiSearch;
    setHasEmbeddingsOrAdvisor(circle.embeddings || circle.aiSearch);
    setAISearch(aiSearch2);
    setIsAdvisorEnabled(circle.aiSearch);
    if (circle.aiSearch) {
      setIsAIMode(true);
    }
  }, [circle]);
  const onSearchLoading = useMemoizedFn(async () => {
    setQuestion(prompt);
    setCounter((v) => v + 1);
  });
  const onSearch = useMemoizedFn(() => {
    return onSearchLoading();
  });
  const context = useMemo(() => {
    return {
      isAIMode,
      setIsAIMode,
      isSearchMode,
      setIsSearchMode,
      prompt,
      setPrompt,
      ...state,
      onSearch,
      searchLoading,
      aiSearch,
      setAISearch,
      isAdvisorEnabled,
      hasEmbeddingsOrAdvisor,
      websocketMessage,
      setWebsocketMessage
    };
  }, [isAIMode, isSearchMode, prompt, searchLoading, aiSearch, state, isAdvisorEnabled, hasEmbeddingsOrAdvisor, websocketMessage]);
  return /* @__PURE__ */ jsx(CircleSearchContext.Provider, {
    value: context,
    children
  });
};

const useCircleInvites = (circleId, op) => {
  const api = useApi();
  const result = useSWR(circleId ? `/groups/${circleId}/invitations-page/` : null, (path) => api.makeRequest({ path }), {
    ...swrLoadOnce,
    ...op
  });
  return result;
};

const InvitesDataContext = React__default.createContext({
  data: void 0,
  user: void 0
});
const useInvitesData = () => {
  return useContext(InvitesDataContext);
};

const CircleInvitesProvider = ({
  children,
  data,
  me,
  override
}) => {
  if (!data) {
    return null;
  }
  const context = {
    data,
    user: me
  };
  if (!override) {
    return /* @__PURE__ */ jsx(InvitesDataContext.Provider, {
      value: context,
      children
    });
  }
  return /* @__PURE__ */ jsx(InvitesDataContext.Provider, {
    value: context,
    children: /* @__PURE__ */ jsx(CardThemeProvider, {
      ...override,
      children
    })
  });
};

const urlFromSlug = (slug) => {
  const isCore = location.href.startsWith(LOCAL_PLAYGROUND$1);
  const prefix = isCore ? LOCAL_PLAYGROUND$1.replace(":3030", ":3000") : "";
  return {
    url: prefix + slug,
    isCore
  };
};
const LOCAL_PLAYGROUND$1 = "http://localhost:3030";
const linkPropsForSlug = (slug) => {
  const {
    url,
    isCore
  } = urlFromSlug(slug);
  if (isCore) {
    return {
      component: "a",
      href: url
    };
  }
  return {
    to: url,
    component: Link$2
  };
};

const CircleInviteCard = (props) => {
  const {
    data,
    me
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(CircleInvitesProvider, {
    data,
    override,
    me,
    children: /* @__PURE__ */ jsx(InviteCardImp, {
      ...props
    })
  });
};
const ContentOuter$4 = styled.div`
    display: flex;
`;
const ContentOuterLink$2 = styled(ContentOuter$4).attrs({
  as: "a"
})`
    cursor: pointer;
`;
const ContentBodyWrapper$4 = styled.div`
    flex: auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;
const EmailTitle = styled(Title)`
    text-transform: none;
`;
const InviteTitle = () => {
  const {
    menu
  } = useCardsTheme();
  const {
    data
  } = useInvitesData();
  if (data.to) {
    return /* @__PURE__ */ jsx(ToTitle, {});
  }
  return /* @__PURE__ */ jsxs(EmailTitle, {
    children: [data.email, menu]
  });
};
const ToTitle = () => {
  const {
    menu
  } = useCardsTheme();
  const {
    data,
    user
  } = useInvitesData();
  const {
    to
  } = data;
  const text = usePersonName({
    person: to,
    you: user
  });
  const title = /* @__PURE__ */ jsx(Link$1, {
    underline: "always",
    ...linkPropsForSlug(userOrMeSlug(to, user)),
    children: text
  });
  return /* @__PURE__ */ jsxs(Title, {
    children: [title, menu]
  });
};
const SmallLink = styled(Link$1)`
    && {
        color: #999999;
    }

    font-size: 0.8em;
`;
const InvitedByText = styled(SubText)`
    font-size: 16px;
`;
const InviteDescription = () => {
  const {
    data,
    user
  } = useInvitesData();
  const {
    from
  } = data;
  const text = usePersonName({
    person: from,
    you: user
  });
  return /* @__PURE__ */ jsxs(InvitedByText, {
    children: [/* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.members_page.invited_by"
    }), /* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(SmallLink, {
      underline: "none",
      ...linkPropsForSlug(userOrMeSlug(from, user)),
      children: text
    }), /* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(When, {}), /* @__PURE__ */ jsx(NewUser, {}), /* @__PURE__ */ jsx(JoinedUser, {}), /* @__PURE__ */ jsx(RegisteredUser, {}), /* @__PURE__ */ jsx(CircleInviteResponse, {})]
  });
};
const When = () => {
  const {
    data
  } = useInvitesData();
  const {
    when
  } = data;
  return /* @__PURE__ */ jsx(RelativeTime, {
    value: when
  });
};
const NewUser = () => {
  const {
    data: {
      registered
    }
  } = useInvitesContext();
  const {
    data
  } = useInvitesData();
  const {
    to,
    email
  } = data;
  if (to) {
    return null;
  }
  if (registered[email]) {
    return null;
  }
  return /* @__PURE__ */ jsxs(InvitedByText, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(BiUserPlus, {}), "\xA0invited"]
  });
};
const RegisteredUser = () => {
  const {
    data: {
      registered,
      joined
    }
  } = useInvitesContext();
  const {
    data
  } = useInvitesData();
  const {
    to,
    email
  } = data;
  if (to) {
    return null;
  }
  if (!registered[email]) {
    return null;
  }
  if (joined[email]) {
    return null;
  }
  return /* @__PURE__ */ jsxs(InvitedByText, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(BiRegistered, {}), "\xA0registered"]
  });
};
const JoinedUser = () => {
  const {
    data: {
      joined,
      registered
    }
  } = useInvitesContext();
  const {
    data
  } = useInvitesData();
  const {
    to,
    email
  } = data;
  if (to) {
    return null;
  }
  if (!joined[email]) {
    return null;
  }
  return /* @__PURE__ */ jsxs(InvitedByText, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(BiGroup, {}), "\xA0joined"]
  });
};
const CircleInviteResponse = () => {
  const {
    data
  } = useInvitesData();
  const {
    to,
    joined
  } = data;
  if (!to) {
    return null;
  }
  if (!joined) {
    return null;
  }
  const text = joined === 1 ? "joined" : "rejected";
  const Icon = joined === 1 ? BiGroup : MdOutlinePersonOff;
  return /* @__PURE__ */ jsxs(InvitedByText, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(Icon, {}), "\xA0", text]
  });
};
const InviteContentBody = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(InviteTitle, {}), /* @__PURE__ */ jsx(InviteDescription, {})]
  });
};
const InviteContentWrapper = ({
  children,
  data,
  ...other
}) => {
  const {
    _id
  } = data;
  const {
    content: contentOuterComponent
  } = other;
  const {
    linkToPage
  } = useCardsTheme();
  const ContentLink = useMemo(() => {
    if (!linkToPage) {
      return null;
    }
    return ({
      children: children2
    }) => /* @__PURE__ */ jsx(Link$2, {
      to: "/groups/" + _id,
      component: ContentOuterLink$2,
      children: children2
    });
  }, [linkToPage, _id]);
  const Content = contentOuterComponent || ContentLink || ContentOuter$4;
  return /* @__PURE__ */ jsx(Content, {
    children
  });
};
const AvatarWrapper = styled.div`
    margin-right: ${CARD_PADDING}px;
`;
const InviteImage = () => {
  const {
    data
  } = useInvitesData();
  const avatar = data.to && data.to.avatar;
  return /* @__PURE__ */ jsx(AvatarWrapper, {
    children: /* @__PURE__ */ jsx(Avatar, {
      avatar,
      size: 64
    })
  });
};
const InviteCheckbox = () => {
  const {
    data
  } = useInvitesData();
  const {
    _id,
    email,
    joined: circleInvitationStatus
  } = data;
  const {
    selected,
    data: {
      joined
    }
  } = useInvitesContext();
  const {
    list,
    push,
    remove
  } = selected;
  const index = list.indexOf(_id);
  const onChange = useMemoizedFn((event, checked) => {
    if (checked) {
      push(_id);
    } else {
      remove(index);
    }
  });
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Click to select",
    children: /* @__PURE__ */ jsx(Checkbox$1, {
      disabled: joined[email] || !!circleInvitationStatus,
      onChange,
      checked: index !== -1,
      color: "primary",
      inputProps: {
        "aria-label": "item selection"
      }
    })
  });
};
const InviteCardOuter = styled(CardOuter)`
    display: flex;
    flex-direction: row;
`;
const InviteCardImp = (props) => {
  return /* @__PURE__ */ jsxs(InviteCardOuter, {
    children: [/* @__PURE__ */ jsx(InviteCheckbox, {}), /* @__PURE__ */ jsxs(InviteContentWrapper, {
      ...props,
      children: [/* @__PURE__ */ jsx(InviteImage, {}), /* @__PURE__ */ jsx(ContentBodyWrapper$4, {
        children: /* @__PURE__ */ jsx(InviteContentBody, {})
      })]
    })]
  });
};

const ReInviteButton = () => {
  const {
    selected,
    sendInvitations
  } = useInvitesContext();
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Click to re invite people selected",
    children: /* @__PURE__ */ jsxs(Button, {
      variant: "contained",
      color: "primary",
      disabled: !selected.list.length,
      startIcon: /* @__PURE__ */ jsx(MdSend, {}),
      onClick: sendInvitations,
      children: ["re-invite (", selected.list.length, ")"]
    })
  });
};
const InvitesPlaceholder = styled.div`
  flex-grow: 1;  
`;
const InvitesToolbarWrapper = styled(Toolbar)`
    && {
        padding: 0 5px;
    }
`;
const SelectAllInvites = () => {
  const {
    selected,
    total,
    selectAll
  } = useInvitesContext();
  const {
    list,
    resetList
  } = selected;
  const color = list.length === total ? "primary" : "secondary";
  const value = list.length > 0;
  const onChange = useMemoizedFn((event, checked) => {
    if (list.length < total) {
      selectAll();
    } else {
      resetList([]);
    }
  });
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Click to Select All",
    children: /* @__PURE__ */ jsx(Checkbox$1, {
      disabled: total === 0,
      onChange,
      checked: value,
      color,
      inputProps: {
        "aria-label": "select all"
      }
    })
  });
};
const InvitesToolbar = () => {
  return /* @__PURE__ */ jsxs(InvitesToolbarWrapper, {
    children: [/* @__PURE__ */ jsx(SelectAllInvites, {}), /* @__PURE__ */ jsx(InvitesPlaceholder, {}), /* @__PURE__ */ jsx(ReInviteButton, {})]
  });
};

const noop$j = () => null;
const InvitesContext = createContext({
  selected: emptyDynamicList(),
  total: 0,
  selectAll: noop$j,
  sendInvitations: noop$j,
  data: void 0
});
const useInvitesContext = () => {
  return useContext(InvitesContext);
};
const notJoined = (data) => {
  const {
    joined
  } = data;
  return data.userInvitations.filter((i) => !joined[i.email]);
};
const noResponse = (data) => {
  return data.invitations.filter((i) => !i.joined);
};
const InvitesContextProvider = ({
  children,
  data,
  circleId
}) => {
  const api = useApi();
  const selected = useDynamicList();
  const selectAll = useMemoizedFn(() => {
    selected.resetList([...noResponse(data).map((v) => v._id), ...notJoined(data).map((v) => v._id)]);
  });
  const sendInvitations = useMemoizedFn(async () => {
    try {
      const all = {};
      data.invitations.forEach((i) => {
        all[i._id] = i;
      });
      data.userInvitations.forEach((i) => {
        all[i._id] = i;
      });
      const invites = selected.list.map((id) => all[id]);
      await api.makeRequest({
        path: `/groups/${circleId}/reinvite`,
        method: "POST",
        body: {
          invites
        }
      });
      toast("Sending invitations");
    } catch (error) {
      errorToast({
        error
      });
    }
  });
  const context = useMemo(() => {
    return {
      selected,
      total: noResponse(data).length + notJoined(data).length,
      selectAll,
      sendInvitations,
      data
    };
  }, [selected, data]);
  return /* @__PURE__ */ jsx(InvitesContext.Provider, {
    value: context,
    children
  });
};
const InvitesList = ({
  circleId,
  profile,
  waiting,
  empty,
  header
}) => {
  const {
    data
  } = useCircleInvites(circleId);
  if (!data) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: waiting
    });
  }
  if (!data.userInvitations.length && !data.invitations.length) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: empty
    });
  }
  return /* @__PURE__ */ jsx(InvitesContextProvider, {
    data,
    circleId,
    children: /* @__PURE__ */ jsxs("div", {
      className: "ns",
      children: [header || /* @__PURE__ */ jsx(InvitesToolbar, {}), /* @__PURE__ */ jsxs(CardThemeProvider, {
        children: [data.userInvitations.map((d) => {
          return /* @__PURE__ */ jsx(CircleInviteCard, {
            data: d,
            me: profile
          }, d._id);
        }), data.invitations.map((d) => {
          return /* @__PURE__ */ jsx(CircleInviteCard, {
            data: d,
            me: profile
          }, d._id);
        })]
      })]
    })
  });
};

const changeCirclePrivacyApi = (api, id, privacy) => {
  return api.makeRequest({
    path: `/groups/${id}/change-privacy`,
    body: {
      privacy
    },
    method: "POST"
  });
};
const ChangeCirclePrivacyDialog = () => {
  const api = useApi();
  const {
    openChangePrivacyDialog,
    setOpenChangePrivacyDialog
  } = useCircleModalDialogsContext();
  const {
    circle
  } = useCircleContext();
  const {
    onClick: changePrivacy,
    loading
  } = useLoading(async (privacy) => {
    if (!circle) {
      return;
    }
    await changeCirclePrivacyApi(api, circle._id, privacy);
    setOpenChangePrivacyDialog(false);
    toast("Circle privacy changed");
    location.reload();
  }, {
    message: "Change circle privacy"
  });
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ConfirmDialog, {
    title: "Confirm circle privacy changed",
    open: openChangePrivacyDialog,
    content: /* @__PURE__ */ jsxs("span", {
      children: ["Do you wish to change circle `", circle.name, "` privacy (`", circle.privacy, "`)?"]
    }),
    onClose: () => setOpenChangePrivacyDialog(false),
    children: [/* @__PURE__ */ jsx(LoadingButton, {
      onClick: () => changePrivacy("PRIVATE"),
      loading,
      children: "Private"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: () => changePrivacy("REGISTERED"),
      loading,
      children: "Registered Users"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: () => changePrivacy("PUBLIC"),
      loading,
      children: "Public"
    })]
  });
};
const ChangeCirclePrivacyMenuItem = () => {
  const {
    profile
  } = useCircleContext();
  const {
    openChangePrivacyDialog,
    setOpenChangePrivacyDialog
  } = useCircleModalDialogsContext();
  if (!profile || profile.role !== "ADMIN") {
    return null;
  }
  const onClick = () => {
    console.log("openChangePrivacyDialog", openChangePrivacyDialog);
    setOpenChangePrivacyDialog(true);
  };
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: "Change Circle Privacy"
  });
};

const noop$i = () => null;
const CircleApiContext = React__default.createContext({
  importDocument: noop$i,
  createSubCircle: noop$i
});
const useCircleApiContext = () => {
  return useContext(CircleApiContext);
};

const useCreateDraftToEditFn = () => {
  const api = useApi();
  const create = async (update = {}) => {
    const { title = "New post" } = update;
    const draft = await api.upsertDraft({
      attachments: [],
      tags: [],
      content: {
        nsTitle: title,
        nsHtml: ""
      },
      ...update
    });
    return draft;
  };
  return create;
};
const useUpdateEditedDraftFn = () => {
  const api = useApi();
  const update = async (update2) => {
    const draft = await api.upsertDraft(update2);
    return draft;
  };
  return update;
};

const useCreatePostFn2 = () => {
  const {
    id: circleId1
  } = useCircleContext();
  const createDraft = useCreateDraftToEditFn();
  const createPost = async (type, options) => {
    const circleId = (typeof options === "string" ? options : options && options.circleId) || circleId1;
    const request = {
      type,
      group: {
        group: circleId
      }
    };
    if (type === "asset") {
      request["form"] = {
        data: {}
      };
    }
    if (typeof options === "object" && options.interview) {
      request["tags"] = ["_interview"];
    }
    const draft = await createDraft(request);
    return draft;
  };
  return createPost;
};
const useCreatePostFn = () => {
  const create = useCreatePostFn2();
  const createPost = async (type) => {
    const draft = await create(type);
    if (type !== "asset") {
      window.location.href = `/profile/drafts/_edit/${type}/` + draft._id;
    }
    return draft;
  };
  return createPost;
};

const PostDataContext = React__default.createContext({
  data: void 0
});
const usePostData = () => {
  return useContext(PostDataContext);
};

const PostProvider = ({
  children,
  data,
  override
}) => {
  if (!data || !data.post) {
    return null;
  }
  const context = {
    data
  };
  if (!override) {
    return /* @__PURE__ */ jsx(PostDataContext.Provider, {
      value: context,
      children
    });
  }
  return /* @__PURE__ */ jsx(PostDataContext.Provider, {
    value: context,
    children: /* @__PURE__ */ jsx(CardThemeProvider, {
      ...override,
      children
    })
  });
};

const PostActivityCard$1 = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(PostProvider, {
    data,
    override,
    children: /* @__PURE__ */ jsx(PostCardImp, {
      ...props
    })
  });
};
const ContentOuter$3 = styled.div`
    display: flex;
`;
const ContentOuterLink$1 = styled(ContentOuter$3).attrs({
  as: "a"
})`
    cursor: pointer;
`;
const ContentBodyWrapper$3 = styled.div`
    flex: auto;
    min-width: 0;
`;
const PostTitle$1 = () => {
  const {
    linkToPage,
    menu
  } = useCardsTheme();
  const {
    data
  } = usePostData();
  const {
    post
  } = data;
  const {
    title: text1
  } = post;
  const text = text1 ? text1 : "<none>";
  const isCore = checkIsCoreUrl();
  const url = getResponseUrl(post);
  const title = linkToPage ? text : /* @__PURE__ */ jsx(Link$1, {
    to: !isCore && url,
    component: isCore ? "a" : Link$2,
    underline: "always",
    href: isCore && url,
    children: text
  });
  return /* @__PURE__ */ jsxs(Title, {
    children: [title, menu]
  });
};
const PostAuthor = () => {
  const {
    data
  } = usePostData();
  const {
    post
  } = data;
  return /* @__PURE__ */ jsx(AuthorAndMeta, {
    author: post.author,
    created: post.created,
    readTime: post.readTime
  });
};
const TopLevelChip = () => {
  const {
    data
  } = usePostData();
  const {
    post,
    chat
  } = data;
  if (chat) {
    return null;
  }
  const {
    thread
  } = post;
  if (thread && thread.length) {
    return null;
  }
  let Icon;
  let name;
  switch (post.type) {
    case "discussion":
      Icon = GiDiscussion;
      name = "discussion";
      break;
    case "article":
      Icon = BiEdit;
      name = "article";
      break;
    case "event":
      Icon = MdEvent;
      name = "event";
      break;
    case "asset":
      Icon = BiBuildingHouse;
      name = "asset";
      break;
    default:
      throw new Error("unknown post type");
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsxs(CardChip$1, {
      children: [/* @__PURE__ */ jsx(Icon, {
        size: 15
      }), "\xA0", name]
    })]
  });
};
const ConclusionChip = () => {
  const {
    data
  } = usePostData();
  const {
    post
  } = data;
  const {
    conclusion
  } = post;
  if (!conclusion) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsxs(CardChip$1, {
      children: [/* @__PURE__ */ jsx(BsCardChecklist, {
        size: 15
      }), "\xA0Closed"]
    })]
  });
};
const ReplyChip = () => {
  const {
    data
  } = usePostData();
  const {
    isReply
  } = data;
  if (!isReply) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsxs(CardChip$1, {
      children: [/* @__PURE__ */ jsx(BsReply, {
        size: 15
      }), "\xA0Reply"]
    })]
  });
};
const ChatChip = () => {
  const {
    data
  } = usePostData();
  const {
    chat
  } = data;
  if (!chat) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(CardChip$1, {
      children: "Chat"
    })]
  });
};
const ThreadChip = () => {
  const {
    data
  } = usePostData();
  const {
    post
  } = data;
  const {
    thread
  } = post;
  if (!thread || thread.length !== 1) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsxs(CardChip$1, {
      children: [/* @__PURE__ */ jsx(BsListNested, {
        size: 15
      }), "\xA0Thread"]
    })]
  });
};
const TimeChip = () => {
  const {
    data
  } = usePostData();
  const {
    post,
    wasSeen
  } = data;
  const {
    modified
  } = post;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(CardChip$1, {
      color: wasSeen ? void 0 : "red",
      children: /* @__PURE__ */ jsx(RelativeTime, {
        value: modified
      })
    })]
  });
};
const PostContentBody = () => {
  const {
    notifications
  } = useCardsTheme();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PostTitle$1, {}), /* @__PURE__ */ jsxs(SubText, {
      children: [/* @__PURE__ */ jsx(TopLevelChip, {}), /* @__PURE__ */ jsx(ThreadChip, {}), /* @__PURE__ */ jsx(ConclusionChip, {}), /* @__PURE__ */ jsx(TimeChip, {}), /* @__PURE__ */ jsx(ReplyChip, {}), notifications]
    }), /* @__PURE__ */ jsx(PostAuthor, {})]
  });
};
const VoteContentWrapper = ({
  children,
  data,
  ...other
}) => {
  const {
    _id
  } = data;
  const {
    content: contentOuterComponen
  } = other;
  const {
    linkToPage
  } = useCardsTheme();
  const ContentLink = useMemo(() => {
    if (!linkToPage) {
      return null;
    }
    return ({
      children: children2
    }) => /* @__PURE__ */ jsx(Link$2, {
      to: "/groups/" + _id,
      component: ContentOuterLink$1,
      children: children2
    });
  }, [linkToPage, _id]);
  const Content = contentOuterComponen || ContentLink || ContentOuter$3;
  return /* @__PURE__ */ jsx(Content, {
    children
  });
};
const PostCardImp = (props) => {
  const {
    data
  } = props;
  const {
    cardImage
  } = useCardsTheme();
  if (cardImage) {
    const {
      rootPost
    } = data;
    const {
      image
    } = rootPost;
    return /* @__PURE__ */ jsx(CardOuter, {
      children: /* @__PURE__ */ jsxs(VoteContentWrapper, {
        ...props,
        children: [/* @__PURE__ */ jsx(Image$1, {
          image,
          square: true
        }), /* @__PURE__ */ jsx(ContentBodyWrapper$3, {
          children: /* @__PURE__ */ jsx(PostContentBody, {})
        })]
      })
    });
  }
  return /* @__PURE__ */ jsx(CardOuter, {
    children: /* @__PURE__ */ jsx(PostContentBody, {})
  });
};

const Counter = ({
  value,
  children
}) => {
  const displayValue = typeof value === "number" && (!value || value < 0) ? 0 : value;
  return /* @__PURE__ */ jsxs("div", {
    className: "inline-block",
    children: [/* @__PURE__ */ jsx("span", {
      children: displayValue
    }), /* @__PURE__ */ jsx("span", {
      className: "ml-1.5",
      children
    })]
  });
};

const CircleDataContext = React__default.createContext({
  data: void 0,
  closed: false,
  setClosed: () => null
});
const useCircleData = () => {
  return useContext(CircleDataContext);
};

const OpenTreeButton = () => {
  const {
    closed,
    setClosed,
    data
  } = useCircleData();
  const {
    closer
  } = useCardsTheme();
  if (!closer) {
    return null;
  }
  const onClick = () => {
    setClosed((v) => !v);
  };
  const stop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const {
    subcircles = []
  } = data;
  if (!subcircles.length) {
    return /* @__PURE__ */ jsx(OpennerWrapper, {
      onClick: stop
    });
  }
  return /* @__PURE__ */ jsx(OpennerWrapper, {
    onClick: stop,
    children: /* @__PURE__ */ jsx(TreeButton, {
      onClick,
      children: closed ? /* @__PURE__ */ jsx(RiArrowDropRightFill, {}) : /* @__PURE__ */ jsx(RiArrowDropDownFill, {})
    })
  });
};
const TreeButton = styled(IconButton$5)`
    height: 36px;
    width: 36px;
    &&.MuiIconButton-root {
        padding: 6px;
    }
`;
const OpennerWrapper = styled.div`
   min-height: 100%;
   padding-right: 3px;

   cursor: default;
   ${({
  theme
}) => {
  const {
    levelIndentationSize
  } = cardsTheme(theme);
  return css$1`
            min-width: ${scalar(levelIndentationSize)};
        `;
}}
`;

const Tags = ({
  tags
}) => {
  if (!tags || !tags.length) {
    return null;
  }
  return /* @__PURE__ */ jsx(SubText, {
    children: /* @__PURE__ */ jsx("ul", {
      style: {
        listStyle: "none"
      },
      children: tags.map((tag) => /* @__PURE__ */ jsxs(TagWrapper, {
        children: ["#", tag]
      }, tag))
    })
  });
};
const TagWrapper = styled.li`
    display: inline-flex;
    line-height: 13px;
    color: #636972;
    border-radius: 0.7em;
    padding: 0 5px 0 0;
    pointer-events: none;
    cursor: none;
`;

const CircleProvider = ({
  children,
  data,
  override
}) => {
  const [closed, setClosed] = useState(false);
  if (!data) {
    return null;
  }
  const context = {
    data,
    closed,
    setClosed
  };
  if (!override) {
    return /* @__PURE__ */ jsx(CircleDataContext.Provider, {
      value: context,
      children
    });
  }
  return /* @__PURE__ */ jsx(CircleDataContext.Provider, {
    value: context,
    children: /* @__PURE__ */ jsx(CardThemeProvider, {
      ...override,
      children
    })
  });
};

const circlePostsCounter = (circle) => {
  const count = circle && circle.stats && circle.stats.postCount;
  if (!count) {
    return "0";
  }
  if (count >= 1e4) {
    return "10K+";
  }
  return String(circle.stats.postCount);
};

const CircleCard$1 = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(CircleProvider, {
    data,
    override,
    children: /* @__PURE__ */ jsx(CircleCardImp, {
      ...props,
      className: "circle-card"
    })
  });
};
const ContentOuter$2 = styled.div`
    display: flex;
`;
const ContentOuterLink = styled(ContentOuter$2).attrs({
  as: "a"
})`
    cursor: pointer;
`;
const ContentBodyWrapper$2 = styled.div`
    flex: auto;
`;
const CircleTitle$1 = ({
  underline = "always",
  ...other
}) => {
  const {
    linkToPage,
    menu
  } = useCardsTheme();
  const {
    data
  } = useCircleData();
  const {
    name,
    _id
  } = data;
  const title = linkToPage ? name : /* @__PURE__ */ jsx(Link$1, {
    to: circleUrl(_id),
    component: Link$2,
    underline,
    children: name
  });
  return /* @__PURE__ */ jsxs(Title, {
    ...other,
    children: [title, menu]
  });
};
const CircleContentBody = () => {
  const {
    notifications
  } = useCardsTheme();
  const {
    data
  } = useCircleData();
  const {
    stats: {
      memberCount
    },
    tags,
    privacy,
    status,
    closed
  } = data;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(CircleTitle$1, {}), /* @__PURE__ */ jsx(Tags, {
      tags
    }), /* @__PURE__ */ jsxs(SubText, {
      children: [status && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(CardChip$1, {
          style: {
            maxWidth: 300
          },
          color: "red",
          children: "Awaiting approval"
        }), /* @__PURE__ */ jsx(Separator, {})]
      }), closed && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(CardChip$1, {
          color: "red",
          children: "Closed"
        }), /* @__PURE__ */ jsx(Separator, {})]
      }), /* @__PURE__ */ jsx(CardChip$1, {
        children: privacy
      }), /* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(Counter, {
        value: circlePostsCounter(data),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "circle_listing.c_posts"
        })
      }), /* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(Counter, {
        value: memberCount,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "circle_listing.c_members"
        })
      }), notifications]
    })]
  });
};
const CircleContentWrapper$1 = ({
  children,
  data,
  ...other
}) => {
  const {
    _id
  } = data;
  const {
    content: contentOuterComponen
  } = other;
  const {
    linkToPage
  } = useCardsTheme();
  const ContentLink = useMemo(() => {
    if (!linkToPage) {
      return null;
    }
    return ({
      children: children2
    }) => /* @__PURE__ */ jsx(Link$2, {
      to: circleUrl(_id),
      component: ContentOuterLink,
      children: children2
    });
  }, [linkToPage, _id]);
  const Content = contentOuterComponen || ContentLink || ContentOuter$2;
  return /* @__PURE__ */ jsx(Content, {
    children
  });
};
const Subcircles$1 = (props) => {
  const {
    data,
    ...other
  } = props;
  const {
    closed
  } = useCircleData();
  const {
    closer
  } = useCardsTheme();
  const {
    subcircles = []
  } = data;
  const circles = subcircles.filter((e) => e.privacy !== "PERSONAL").map((c) => {
    return /* @__PURE__ */ jsx(CircleCard$1, {
      data: c,
      ...other,
      identation: true
    }, c._id);
  });
  if (!closer) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: circles
    });
  }
  return /* @__PURE__ */ jsx(Collapse, {
    in: !closed,
    children: circles
  });
};
const CircleCardImp = (props) => {
  const {
    data,
    showImage,
    identation,
    className
  } = props;
  if (showImage) {
    const {
      image
    } = data;
    return /* @__PURE__ */ jsxs(CardOuter, {
      identation,
      className,
      children: [/* @__PURE__ */ jsxs(CircleContentWrapper$1, {
        ...props,
        children: [/* @__PURE__ */ jsx(OpenTreeButton, {}), /* @__PURE__ */ jsx(Image$1, {
          image
        }), /* @__PURE__ */ jsx(ContentBodyWrapper$2, {
          children: /* @__PURE__ */ jsx(CircleContentBody, {})
        })]
      }), /* @__PURE__ */ jsx(Subcircles$1, {
        ...props
      })]
    });
  }
  return /* @__PURE__ */ jsxs(CardOuter, {
    identation,
    children: [/* @__PURE__ */ jsx(CircleContentBody, {}), /* @__PURE__ */ jsx(Subcircles$1, {
      ...props
    })]
  });
};

const key$4 = `/activities/user-votes/`;
const getVotingActivity = (api) => api.makeRequest({
  path: key$4
});
const useVotesActivity = (opt) => {
  const api = useApi();
  const options = {
    ...swrLoadOnce,
    ...opt,
    refreshInterval: activityRrefreshInterval
  };
  const result = useSWR(key$4, () => getVotingActivity(api), options);
  const {
    activities$
  } = useActivityContext();
  activities$.useSubscription(({
    type
  }) => {
    if (type !== "vote") {
      return;
    }
    if (!options.revalidateOnMount) {
      return;
    }
    const {
      mutate,
      isValidating
    } = result;
    if (!isValidating) {
      mutate();
    }
  });
  return result;
};

const MyCircleVotingIcon = ({
  revalidateOnMount = false,
  className
}) => {
  const [open, setOpen] = useState(false);
  const {
    data: {
      _id: circleId,
      name
    }
  } = useCircleData();
  const {
    data
  } = useVotesActivity({
    revalidateOnMount
  });
  if (!data) {
    return null;
  }
  const votes = {
    history: data.history.filter((h) => h.circle === circleId)
  };
  const {
    history
  } = votes;
  const notVotedCount = votesCount(history);
  if (!notVotedCount) {
    return null;
  }
  const onClick = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    setOpen(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      onClick,
      className,
      children: /* @__PURE__ */ jsx(Badge$2, {
        ...votingBadgeProps(history),
        children: /* @__PURE__ */ jsx(RiScales3Fill, {})
      })
    }), /* @__PURE__ */ jsx(VotesListDialog, {
      open,
      onClose: () => setOpen(false),
      data: votes,
      title: `Votes in the Circle "${name}"`
    })]
  });
};

const key$3 = `/activities/user-posts/`;
const usePostsActivity = (opt) => {
  const api = useApi();
  const options = {
    ...swrLoadOnce,
    ...opt,
    refreshInterval: activityRrefreshInterval
  };
  const result = useSWR(key$3, (path) => api.makeRequest({
    path
  }), options);
  const {
    activities$
  } = useActivityContext();
  activities$.useSubscription(({
    type
  }) => {
    if (type !== "post") {
      return;
    }
    if (!options.revalidateOnMount) {
      return;
    }
    const {
      mutate,
      isValidating
    } = result;
    if (!isValidating) {
      mutate();
    }
  });
  return result;
};
const useChatActivity = (opt) => {
  const api = useApi();
  const options = {
    ...swrLoadOnce,
    ...opt,
    refreshInterval: activityRrefreshInterval
  };
  const result = useSWR("/activities/user-chats", (path) => api.makeRequest({
    path
  }), options);
  const {
    activities$
  } = useActivityContext();
  activities$.useSubscription(({
    type
  }) => {
  });
  return result;
};

const myCircles = (circles) => {
  if (!circles) {
    return null;
  }
  const groups = circles.map((v) => {
    return {
      ...v
    };
  });
  const byId = groups.reduce((all, g) => {
    all[g._id] = g;
    return all;
  }, {});
  groups.forEach((g) => {
    g.subcircles = [];
  });
  groups.forEach((g) => {
    if (!g.parent) {
      return;
    }
    const parent = byId[g.parent];
    if (!parent) {
      console.error("lost parent:", g.parent);
      g.parent = void 0;
      return;
    }
    parent.subcircles.push(g);
  });
  return groups;
};
const useMyCircles$1 = ({
  filter = (v) => v,
  buildTree = true,
  idle
} = {}) => {
  const api = useApi();
  const result = useSWR(idle ? null : ["my circles"], async () => {
    const result2 = await api.makeRequest({
      method: "GET",
      path: "/groups/my"
    });
    const groups = result2.values.filter((v) => v.group).map((v) => {
      return {
        mail_prefs: v.mail_prefs,
        ...v.group
      };
    });
    return groups;
  }, {
    ...swrLoadOnce
  });
  const {
    data
  } = result;
  const filtered = useCreation(() => {
    if (!data || !buildTree) {
      return data && filter(data);
    }
    return myCircles(filter(data));
  }, [data, filter, buildTree]);
  return {
    ...result,
    data: filtered
  };
};
const circleNameFilter = (filter, circles) => {
  if (!filter) {
    return null;
  }
  return circles.filter((c) => {
    return c.name.toLocaleLowerCase().includes(filter);
  });
};
const circleFuzzyNameFilter = (filter, circles) => {
  if (!filter) {
    return null;
  }
  try {
    return fuzzysort.go(filter, circles, {
      key: "name"
    }).map((r) => r.obj);
  } catch (e) {
    return circleNameFilter(filter, circles);
  }
};
const useMyCirclesWithFilter = ({
  filter: filterFn,
  idle
} = {}) => {
  const {
    filter$,
    currentFilterRef
  } = useSearchContext();
  const [filter, setFilter] = useState(currentFilterRef.current || "");
  filter$.useSubscription(({
    filter: filter2
  }) => {
    setFilter(!filter2 ? "" : filter2.toLocaleLowerCase());
  });
  const result = useMyCircles$1({
    buildTree: !filter,
    filter: filterFn,
    idle
  });
  if (!result.data) {
    return result;
  }
  const filtered = circleFuzzyNameFilter(filter, result.data);
  return {
    ...result,
    data: filter ? filtered : result.data.filter((g) => !g.parent),
    allCircles: result.data
  };
};

const CircleVotingIcon = ({
  circleId,
  circle
}) => {
  const [open, setOpen] = useState(false);
  const {
    data
  } = useCircleVotesActivity(circleId);
  if (!data) {
    return null;
  }
  const {
    history
  } = data;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      onClick: () => setOpen(true),
      "data-testid": "circle-activity-votes-icon",
      children: /* @__PURE__ */ jsx(Badge$2, {
        ...votingBadgeProps(history),
        children: /* @__PURE__ */ jsx(RiScales3Fill, {})
      })
    }), /* @__PURE__ */ jsx(VotesListDialog, {
      open,
      onClose: () => setOpen(false),
      data,
      title: circle && `Votes in the Circle "${circle.name}"`
    })]
  });
};

const CardsList$1 = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: column;
 `;
const PostsListDialog = (props) => {
  const {
    open,
    onClose,
    data,
    title
  } = props;
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$6, {
    fullScreen: true,
    ...props,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: title || "Votes in Circle"
    }), /* @__PURE__ */ jsx(DialogContent, {
      dividers: true,
      children: /* @__PURE__ */ jsx(CardsList$1, {
        children: /* @__PURE__ */ jsx(CardThemeProvider, {
          cardImage: true,
          startNewTheme: true,
          children: data && data.history.map((d) => {
            return /* @__PURE__ */ jsx(PostActivityCard$1, {
              data: d
            }, d._id);
          })
        })
      })
    })]
  });
};

const CirclePostsIcon = ({
  circleId,
  circle
}) => {
  const [open, setOpen] = useState(false);
  const {
    data
  } = useCirclePostsActivity(circleId);
  if (!data) {
    return null;
  }
  const {
    history
  } = data;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      onClick: () => setOpen(true),
      "data-testid": "circle-activity-posts-icon",
      children: /* @__PURE__ */ jsx(Badge$2, {
        ...postsBadgeProps(history),
        children: /* @__PURE__ */ jsx(BsFileText, {})
      })
    }), /* @__PURE__ */ jsx(PostsListDialog, {
      open,
      onClose: () => setOpen(false),
      data,
      title: circle && `Posts in the Circle "${circle.name}"`
    })]
  });
};

const key$2 = `/user-activity/exists`;
const useCheckActivity = (opt) => {
  const api = useApi();
  const options = {
    ...swrLoadOnce,
    ...opt,
    refreshInterval: activityRrefreshInterval
  };
  const result = useSWR(key$2, (path) => api.makeRequest({
    path
  }), options);
  const {
    activities$
  } = useActivityContext();
  activities$.useSubscription(({
    type
  }) => {
    if (type !== "vote" && type !== "post") {
      return;
    }
    if (!options.revalidateOnMount) {
      return;
    }
    const {
      mutate,
      isValidating
    } = result;
    if (!isValidating) {
      mutate();
    }
  });
  return result;
};
const useCheckActivityBadge = (opt) => {
  const {
    data
  } = useCheckActivity(opt);
  if (!data || !data.found) {
    return {
      invisible: false
    };
  }
  return {
    color: "error",
    variant: "dot"
  };
};

const useCirclesFilterWithActivityFn = () => {
  const {
    data
  } = useVotesActivity({
    revalidateOnMount: true
  });
  const circleIds = useCreation(() => {
    if (!data) {
      return {};
    }
    return data.history.reduce((a, h) => {
      if (h.castedVote) {
        return a;
      }
      a[h.circle] = true;
      return a;
    }, {});
  }, [data]);
  const filter = useCallback((data2) => {
    return data2.filter((c) => circleIds[c._id]);
  }, [circleIds]);
  return filter;
};

const MyCirclePostsIcon = ({
  revalidateOnMount = false,
  className
}) => {
  const [open, setOpen] = useState(false);
  const {
    data: {
      _id: circleId,
      name
    }
  } = useCircleData();
  const {
    data
  } = usePostsActivity({
    revalidateOnMount
  });
  if (!data) {
    return null;
  }
  const votes = {
    history: data.history.filter((h) => h.circle === circleId)
  };
  const {
    history
  } = votes;
  const notActiveCount = postsCount(history);
  if (!notActiveCount) {
    return null;
  }
  const onClick = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    setOpen(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      onClick,
      className,
      children: /* @__PURE__ */ jsx(Badge$2, {
        ...postsBadgeProps(history),
        children: /* @__PURE__ */ jsx(BsFileText, {})
      })
    }), /* @__PURE__ */ jsx(PostsListDialog, {
      open,
      onClose: () => setOpen(false),
      data: votes,
      title: `Posts in the Circle "${name}"`
    })]
  });
};

const MyCirclesList = ({
  waiting,
  empty,
  error: Error = () => null,
  filter = (v) => v,
  revalidateActivityOnMount = true
}) => {
  const {
    data,
    error,
    isValidating
  } = useMyCirclesWithFilter({
    filter
  });
  const filtered = data;
  console.log("FILTERED", filtered);
  if (!data && error && !isValidating) {
    return /* @__PURE__ */ jsx(Error, {
      error
    });
  }
  if (!data) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: waiting
    });
  }
  if (!filtered.length) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: empty
    });
  }
  return /* @__PURE__ */ jsx(CardThemeProvider, {
    cardShadow: false,
    linkToPage: true,
    closer: true,
    children: filtered.filter((e) => e.privacy !== "PERSONAL").map((g, i) => /* @__PURE__ */ jsx(CircleCard$1, {
      showImage: true,
      data: g,
      notifications: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(MyCircleVotingIcon, {
          revalidateOnMount: revalidateActivityOnMount && i === 0,
          className: "circle-voting"
        }), /* @__PURE__ */ jsx(MyCirclePostsIcon, {
          revalidateOnMount: revalidateActivityOnMount && i === 0,
          className: "circle-activity"
        })]
      })
    }, g._id))
  });
};
const MyCirclesWithActivity = (props) => {
  const circlesWithActivity = useCirclesFilterWithActivityFn();
  return /* @__PURE__ */ jsx(MyCirclesList, {
    filter: circlesWithActivity,
    revalidateActivityOnMount: false,
    ...props
  });
};

const NotificationBadge = styled(Badge$2)`
  & .MuiBadge-badge {
    transform: none;
    top: 5px;
    right: 5px;
    min-width: 10px;
    height: 10px;
    border-radius: 5px;
  }
`;
const href = "/notifications";
const Icon = ({
  selected,
  selectedColor
}) => {
  const location = useLocation();
  const color = selected || location.pathname.startsWith(href) ? selectedColor || "white" : void 0;
  return /* @__PURE__ */ jsx(MdNotifications, {
    size: 35,
    color
  });
};
const NotificationsActionItem = (props) => {
  return /* @__PURE__ */ jsx(BottomNavigationAction, {
    label: "page",
    icon: /* @__PURE__ */ jsx(NotificationBadge, {
      ...useCheckActivityBadge(),
      children: /* @__PURE__ */ jsx(Icon, {
        ...props
      })
    }),
    component: Link$2,
    to: href,
    showLabel: false
  });
};

var Rightarrow = "data:image/svg+xml;base64,PHN2Zwogd2lkdGg9IjExIgogaGVpZ2h0PSIxNiIKIHZpZXdCb3g9IjAgMCAxMSAxNiIKIGZpbGw9Im5vbmUiCiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiBjbGFzc05hbWU9IiIKIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiCj4KIDxwYXRoCiAgZD0iTTkuOTA4NTMgOC45Mzc1OUwzLjExMDQgMTUuNDE2OUMyLjY0MDUzIDE1Ljg2NDcgMS44OTg1NSAxNS44NDY5IDEuNDU1NiAxNS4zNzcxTDAuMzc4ODk1IDE0LjI0NzVDLTAuMDY4OTM3OSAxMy43Nzc2IC0wLjA1MTEyMDIgMTMuMDM1NiAwLjQxODYzNCAxMi41OTI3TDUuMjM3MzEgNy45OTk5OEwwLjY0NDYzNyAzLjE4MTMxQzAuMTk2ODA0IDIuNzExNDQgMC4yMTQ2MjIgMS45Njk0NiAwLjY4NDM3NSAxLjUyNjUxTDEuODE0MDYgMC40NDk4MDRDMi4yODM5NCAwLjAwMTk3MDgzIDMuMDI1OTEgMC4wMTk3ODg2IDMuNDY4ODYgMC40ODk1NDJMOS45NDgxNSA3LjI4NzY3QzEwLjM5NjIgNy43NDc3OCAxMC4zNzg0IDguNDg5NzYgOS45MDg1MyA4LjkzNzU5WiIKICBmaWxsPSIjNDY0NTQ1IgogPjwvcGF0aD4KPC9zdmc+Cg==";

const StyledBreadCrumb = ({
  children,
  className
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: clsx("text-xs sm:text-sm flex font-extralight text-left text-[#464545]", className),
    children
  });
};
const Next = () => {
  return /* @__PURE__ */ jsx("img", {
    src: Rightarrow,
    alt: "rightarrow",
    className: "h-[6px] sm:w-3 sm:h-4 object-cover"
  });
};

const InstanceLogoImage = ({
  instance,
  className,
  size = 64
}) => {
  const uuid = instance && instance.smallLogo && instance.smallLogo.uuid;
  if (!uuid) {
    return null;
  }
  return /* @__PURE__ */ jsx(ScaledImageProxy, {
    className,
    instanceNameOverride: instance.instanceName,
    uuid,
    w: size,
    h: size,
    crop: false
  });
};

const NotificationsBadge = () => {
  const {
    color
  } = useCheckActivityBadge();
  if (!color) {
    return null;
  }
  return /* @__PURE__ */ jsx("span", {
    className: "absolute right-2 top-2 rounded-full w-2 h-2 bg-red-400"
  });
};

var dashboardStyleguide = '';

const useIsInstanceAdmin = () => {
  const {
    profile
  } = useProfileContext();
  return profile && profile.role === "ADMIN";
};
const useIsNewsSocial = () => {
  const {
    profile
  } = useProfileContext();
  return profile && profile.email.includes("@newssocial.co.uk");
};
const isInstanceAdmin = (profile) => {
  return profile && profile.role === "ADMIN";
};

const InstanceConfigButton = () => {
  const isInstanceAdmin = useIsInstanceAdmin();
  if (!isInstanceAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx(Link$2, {
    to: "/trans/config",
    children: /* @__PURE__ */ jsx(StyledButton, {
      className: "group relative",
      icon: PiGear,
      children: /* @__PURE__ */ jsx(Tooltip, {
        children: "Instance settings"
      })
    })
  });
};

const DashboardNavigation = ({
  initial = {}
}) => {
  const {
    data: instance
  } = useInstance({
    fallbackData: initial.instance
  });
  const {
    filter$
  } = useSearchContext();
  const {
    run: emitFilter
  } = useThrottleFn((filter) => {
    filter$.emit({
      filter
    });
  }, {
    wait: 500
  });
  const handleChange = (e) => {
    const filter = e.target.value;
    emitFilter(filter);
  };
  const intl = useIntl();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 sm:justify-start items-center w-full  bg-white shadow-lg relative px-1",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: "hidden lg:block",
      children: /* @__PURE__ */ jsx(InstanceLogoImage, {
        instance,
        className: "w-8 h-8 shadow-md shadow-slate-300 p-1",
        size: 32
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "hidden sm:flex justify-end items-center gap-2.5 px-1 rounded-full border border-black/30 w-full max-w-2xl",
      children: [/* @__PURE__ */ jsx("img", {
        src: Search,
        className: "hidden sm:block w-4 h-4 object-cover"
      }), /* @__PURE__ */ jsx("input", {
        onChange: handleChange,
        placeholder: intl.formatMessage({
          id: "group.searchHere"
        }) + "...",
        type: "text",
        className: "outline-none w-full h-6 opacity-50 text-xl text-black  ltr:text-left rtl:text-right"
      })]
    }), /* @__PURE__ */ jsx("input", {
      onChange: handleChange,
      placeholder: intl.formatMessage({
        id: "group.searchHere"
      }) + "...",
      type: "text",
      className: "rounded-full border-2 border-black/30 outline-none text-xl ltr:text-left rtl:text-right text-black sm:hidden bg-white z-10 inset-0 w-full px-1 focus:absolute focus:border-0 focus:px-4"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-end items-center relative gap-4  ltr:ml-auto rtl:mr-auto",
      children: [/* @__PURE__ */ jsx(Link$2, {
        to: "/notifications",
        children: /* @__PURE__ */ jsxs(StyledButton, {
          icon: FaRegBell,
          className: "group relative",
          children: [/* @__PURE__ */ jsx(NotificationsBadge, {}), /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.notifications"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(InstanceConfigButton, {}), /* @__PURE__ */ jsx(OpenHelpButton$6, {}), /* @__PURE__ */ jsx(ProfileIcon, {})]
    })]
  });
};
const OpenHelpButton$6 = () => {
  const {
    profile: profile2
  } = useDashboardPageContext();
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(HelpContextProvider, {
      page: "dashboard",
      profile: profile2,
      children: /* @__PURE__ */ jsx(WelcomeToPageButton, {
        button: (props) => {
          return /* @__PURE__ */ jsx(Fragment, {
            children: /* @__PURE__ */ jsx(StyledButton, {
              className: "group relative",
              icon: IoMdHelpCircleOutline,
              ...props,
              children: /* @__PURE__ */ jsx(Tooltip, {
                children: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: "group.tooltips.help"
                })
              })
            })
          });
        }
      })
    })
  });
};

const DropDown = (props) => {
  const {
    className,
    tooltip,
    tooltipPosition,
    iconClass,
    ...other
  } = props;
  return /* @__PURE__ */ jsxs("button", {
    className: clsx("group flex justify-start items-center p-1 relative border-none", className),
    ...other,
    children: [tooltip && /* @__PURE__ */ jsx(Tooltip, {
      position: tooltipPosition,
      children: tooltip
    }), /* @__PURE__ */ jsx(BsChevronDown, {
      className: clsx("w-[20px] h-[20px]", iconClass)
    })]
  });
};

var Discussions = "data:image/svg+xml;base64,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";

var Events = "data:image/svg+xml;base64,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";

const postType$1 = (post) => {
  const type = post.type;
  if (type === "event") {
    return "meeting";
  }
  return type;
};
styled.div`
  & .ns-post-tag {
    margin-top: 0;
    margin-bottom: 0;
  }
  line-height: 1.2;
`;
const Div$2 = (props) => /* @__PURE__ */ jsx("div", {
  ...props
});
const toggle$1 = (v) => !v;
const PostCard1 = ({
  post,
  showType
}) => {
  const url = url4post(post);
  useState(false);
  const TypeIcon = getPostTypeIcon(post);
  !!post.image;
  const circle = post.group && post.group.group || {};
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col w-full bg-white card-shadow overflow-hidden p-1 gap-1 text-2xs sm:text-sm",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "justify-start items-start relative gap-3 p-0  flex w-full overflow-hidden leading-tight",
      children: [/* @__PURE__ */ jsx(PostImage, {
        post,
        width: 60,
        height: 60,
        className: "flex"
      }), /* @__PURE__ */ jsxs("div", {
        className: clsx("flex flex-col justify-between items-stretch gap-0 overflow-hidden w-full max-h-[120px]"),
        children: [showType && /* @__PURE__ */ jsxs("div", {
          className: "hidden sm:flex gap-2 items-center opacity-70 font-medium text-black",
          children: [/* @__PURE__ */ jsx(TypeIcon, {
            className: "min-w-[16px] min-h-[16px]",
            size: 16
          }), /* @__PURE__ */ jsx("p", {
            children: postType$1(post)
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "inline-block relative min-h-0 overflow-hidden",
          children: [showType && /* @__PURE__ */ jsx(TypeIcon, {
            className: "sm:hidden min-w-[16px] min-h-[16px] inline mr-1 mt-1",
            size: 16
          }), /* @__PURE__ */ jsx(Link$2, {
            to: url,
            children: /* @__PURE__ */ jsx("p", {
              className: "inline text-sm font-semibold break-words",
              children: post.title
            })
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex justify-between items-center",
          children: [/* @__PURE__ */ jsx("p", {
            className: "w-full",
            children: /* @__PURE__ */ jsx(RelativeTime, {
              className: "w-4 h-4",
              value: post.created
            })
          }), /* @__PURE__ */ jsx("div", {
            className: "flex gap-3 items-center",
            children: /* @__PURE__ */ jsxs("p", {
              children: [post.responseCount, " ", /* @__PURE__ */ jsx(FormattedMessage, {
                id: "group.totalResponses"
              })]
            })
          })]
        }), /* @__PURE__ */ jsx(EventDate, {
          post
        })]
      })]
    }), /* @__PURE__ */ jsx(PostAuthor$1, {
      post,
      className: "flex-wrap",
      textSize: "text-2xs sm:text-sm",
      children: /* @__PURE__ */ jsx(Tags$1, {
        tags: post.tags,
        tagClassName: "text-2xs sm:text-sm",
        chipInner: Div$2
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-start items-center relative gap-2.5 flex-nowrap",
      children: [/* @__PURE__ */ jsx(Image$1, {
        size: 20,
        image: circle.image,
        imagePadding: 0
      }), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circle._id),
        children: /* @__PURE__ */ jsx("div", {
          children: circle.name
        })
      })]
    })]
  });
};
const PostCard$1 = ({
  post,
  showType
}) => {
  const url = url4post(post);
  const [expanded, setExpanded] = useState(false);
  const TypeIcon = getPostTypeIcon(post);
  !!post.image;
  const circle = post.group && post.group.group || {};
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col w-full bg-white card-shadow overflow-hidden p-1 gap-1 text-2xs sm:text-sm",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "justify-start items-start relative gap-3 p-0  flex w-full overflow-hidden leading-tight",
      children: [/* @__PURE__ */ jsx(PostImage, {
        post,
        width: 60,
        height: 60,
        className: "flex"
      }), /* @__PURE__ */ jsxs("div", {
        className: clsx("flex flex-col justify-between gap-0 overflow-hidden w-full max-h-[120px] items-stretch"),
        children: [showType && /* @__PURE__ */ jsxs("div", {
          className: "hidden sm:flex gap-2 items-center opacity-70 font-medium text-black",
          children: [/* @__PURE__ */ jsx(TypeIcon, {
            className: "min-w-[16px] min-h-[16px]",
            size: 16
          }), /* @__PURE__ */ jsx("p", {
            children: postType$1(post)
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "inline-block relative min-h-0 overflow-hidden",
          children: [showType && /* @__PURE__ */ jsx(TypeIcon, {
            className: "sm:hidden min-w-[16px] min-h-[16px] inline mr-1 mt-1",
            size: 16
          }), /* @__PURE__ */ jsx(Link$2, {
            to: url,
            children: /* @__PURE__ */ jsx("p", {
              className: "inline text-sm font-semibold break-words",
              children: post.title
            })
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex justify-between items-center",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex gap-3 items-center",
            children: [/* @__PURE__ */ jsx(TimeIcon, {
              className: "w-4 h-4"
            }), /* @__PURE__ */ jsx("p", {
              className: "w-full",
              children: /* @__PURE__ */ jsx(RelativeTime, {
                className: "w-4 h-4",
                value: post.created
              })
            })]
          }), expanded && /* @__PURE__ */ jsxs("div", {
            className: "flex gap-3 items-center",
            children: [/* @__PURE__ */ jsx(ResponsesIcon, {}), /* @__PURE__ */ jsxs("p", {
              children: [post.responseCount, " ", /* @__PURE__ */ jsx(FormattedMessage, {
                id: "group.totalResponses"
              })]
            })]
          }), !expanded && /* @__PURE__ */ jsx(DropDown, {
            onClick: () => setExpanded(toggle$1),
            tooltip: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "dashboard.tooltip.postDetails"
            }),
            tooltipPosition: "-top-7 right-0"
          })]
        })]
      })]
    }), expanded && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(EventDate, {
        post
      }), /* @__PURE__ */ jsx(PostAuthor$1, {
        post,
        className: "flex-wrap",
        textSize: "text-2xs sm:text-sm",
        children: /* @__PURE__ */ jsx(Tags$1, {
          tags: post.tags,
          tagClassName: "text-2xs sm:text-sm",
          chipInner: Div$2
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex justify-between items-center relative gap-2.5 flex-nowrap w-full",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex justify-start items-center relative gap-2.5 flex-nowrap",
          children: [/* @__PURE__ */ jsx(Image$1, {
            size: 20,
            image: circle.image,
            imagePadding: 0
          }), /* @__PURE__ */ jsx(Link$2, {
            to: circleUrl(circle._id),
            children: /* @__PURE__ */ jsx("div", {
              children: circle.name
            })
          })]
        }), /* @__PURE__ */ jsx(DropDown, {
          onClick: () => setExpanded(toggle$1),
          className: "min-w-[20px] rotate-180"
        })]
      })]
    })]
  });
};

// THIS FILE IS AUTO GENERATED
function SiCircle (props) {
  return GenIcon({"tag":"svg","attr":{"role":"img","viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M20.788 3.832c-.101-.105-.197-.213-.301-.317-.103-.103-.211-.202-.32-.302A11.903 11.903 0 0 0 12 0a11.926 11.926 0 0 0-8.486 3.514C-1.062 8.09-1.16 15.47 3.213 20.168c.099.108.197.214.3.32.104.103.21.2.317.3A11.92 11.92 0 0 0 12 24c3.206 0 6.22-1.247 8.487-3.512 4.576-4.576 4.673-11.956.301-16.656zm-16.655.301A11.057 11.057 0 0 1 12 .874c2.825 0 5.49 1.048 7.55 2.958l-1.001 1.002A9.646 9.646 0 0 0 12 2.292a9.644 9.644 0 0 0-6.865 2.844A9.644 9.644 0 0 0 2.292 12c0 2.448.9 4.753 2.542 6.549L3.831 19.55C-.201 15.191-.101 8.367 4.133 4.133zm13.798 1.318v.002l-1.015 1.014A7.346 7.346 0 0 0 12 4.589 7.357 7.357 0 0 0 6.761 6.76 7.362 7.362 0 0 0 4.589 12a7.34 7.34 0 0 0 1.877 4.913l-1.014 1.016A8.77 8.77 0 0 1 3.167 12a8.77 8.77 0 0 1 2.588-6.245A8.771 8.771 0 0 1 12 3.167c2.213 0 4.301.809 5.931 2.284zM18.537 12c0 1.745-.681 3.387-1.916 4.622S13.746 18.538 12 18.538a6.491 6.491 0 0 1-4.296-1.621l-.001-.004c-.11-.094-.22-.188-.324-.291a6.027 6.027 0 0 1-.293-.326A6.47 6.47 0 0 1 5.466 12c0-1.746.679-3.387 1.914-4.621A6.488 6.488 0 0 1 12 5.465c1.599 0 3.105.576 4.295 1.62.111.096.224.19.326.295.104.104.2.214.295.324A6.482 6.482 0 0 1 18.537 12zM7.084 17.534h.001A7.349 7.349 0 0 0 12 19.413a7.35 7.35 0 0 0 5.239-2.174A7.354 7.354 0 0 0 19.412 12a7.364 7.364 0 0 0-1.876-4.916l1.013-1.012A8.777 8.777 0 0 1 20.834 12a8.765 8.765 0 0 1-2.589 6.246A8.764 8.764 0 0 1 12 20.834a8.782 8.782 0 0 1-5.93-2.285l1.014-1.015zm12.783 2.333A11.046 11.046 0 0 1 12 23.125a11.042 11.042 0 0 1-7.551-2.957l1.004-1.001a9.64 9.64 0 0 0 6.549 2.542 9.639 9.639 0 0 0 6.865-2.846A9.642 9.642 0 0 0 21.71 12a9.64 9.64 0 0 0-2.543-6.548l1.001-1.002c4.031 4.359 3.935 11.182-.301 15.417z"},"child":[]}]})(props);
}

var Tabs$3 = '';

var Subcircles = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTkuMDAwMyIgY3k9IjE5LjAwMDMiIHI9IjQuODMzMzMiIHN0cm9rZT0iIzRBOTBDRSIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxjaXJjbGUgY3g9IjE4Ljk5OTciIGN5PSIxOC45OTk3IiByPSIxMS4xNjY3IiBzdHJva2U9IiM0QTkwQ0UiIHN0cm9rZS13aWR0aD0iMyIvPgo8Y2lyY2xlIGN4PSIxOSIgY3k9IjE5IiByPSIxNy41IiBzdHJva2U9IiM0QTkwQ0UiIHN0cm9rZS13aWR0aD0iMyIvPgo8cGF0aCBkPSJNMi4xMTEzMyAyNy40NDQ3TDEzLjcyMjQgMjEuMTExMyIgc3Ryb2tlPSIjNEE5MENFIiBzdHJva2Utd2lkdGg9IjMiLz4KPHBhdGggZD0iTTI0IDE2TDM1IDEwIiBzdHJva2U9IiM0QTkwQ0UiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";

const CooperativelyDeveloping = ({
  className,
  ...other
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: clsx("w-full bg-gray-100 text-primary font-semibold p-1", className),
    ...other,
    children: "Cooperatively developing solutions in Circles"
  });
};

const OtherCircles = () => {
  const [number, setNumber] = useState(4);
  const {
    other,
    active
  } = useDashboardPageContext();
  if (!other) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("lg:flex flex-col items-center gap-2 col-span-2 row-start-2 col-start-7 row-span-3", active === "allPosts" ? "flex" : "hidden"),
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full hidden lg:block -mt-2",
      children: [/* @__PURE__ */ jsx(CooperativelyDeveloping, {
        className: "text-lg"
      }), /* @__PURE__ */ jsx("img", {
        src: "/static/images/workshop.jpg",
        className: "aspect-[3/2] w-full"
      })]
    }), /* @__PURE__ */ jsx(ColumnHeader, {
      iconComponent: OtherIcons,
      tooltip: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.tooltip.allPosts"
      }),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.allPosts"
      })
    }), other.slice(0, number).map((post) => {
      return /* @__PURE__ */ jsx(PostCard$1, {
        post,
        showType: true
      }, post._id);
    }), other.length > number && /* @__PURE__ */ jsx("button", {
      className: "flex justify-center items-end relative gap-2.5 p-1.5 rounded-[10px] bg-primary mt-2",
      onClick: () => setNumber(other.length),
      children: /* @__PURE__ */ jsx("p", {
        className: "text-base text-center text-white",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.showMore"
        })
      })
    })]
  });
};
const OtherIcons = (props) => {
  return /* @__PURE__ */ jsx("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M26.5 2.66667H5.91667C4.12174 2.66667 2.66667 4.12174 2.66667 5.91667V34.0833C2.66667 35.8783 4.12174 37.3333 5.91667 37.3333H26.5V2.66667ZM28.6667 2.66667V37.3333H34.0833C35.8783 37.3333 37.3333 35.8783 37.3333 34.0833V5.91667C37.3333 4.12174 35.8783 2.66667 34.0833 2.66667H28.6667ZM0.5 5.91667C0.5 2.92512 2.92512 0.5 5.91667 0.5H34.0833C37.0749 0.5 39.5 2.92512 39.5 5.91667V34.0833C39.5 37.0749 37.0749 39.5 34.0833 39.5H5.91667C2.92512 39.5 0.5 37.0749 0.5 34.0833V5.91667ZM8.08333 11.3333C7.48502 11.3333 7 10.8483 7 10.25C7 9.65169 7.48502 9.16667 8.08333 9.16667H21.0833C21.6816 9.16667 22.1667 9.65169 22.1667 10.25C22.1667 10.8483 21.6816 11.3333 21.0833 11.3333H8.08333ZM8.08333 15.6667C7.48502 15.6667 7 15.1816 7 14.5833C7 13.985 7.48502 13.5 8.08333 13.5H21.0833C21.6816 13.5 22.1667 13.985 22.1667 14.5833C22.1667 15.1816 21.6816 15.6667 21.0833 15.6667H8.08333ZM8.08333 20C7.48502 20 7 19.515 7 18.9167C7 18.3184 7.48502 17.8333 8.08333 17.8333H16.75C17.3483 17.8333 17.8333 18.3184 17.8333 18.9167C17.8333 19.515 17.3483 20 16.75 20H8.08333ZM8.08333 26.5C7.48502 26.5 7 26.015 7 25.4167C7 24.8184 7.48502 24.3333 8.08333 24.3333H21.0833C21.6816 24.3333 22.1667 24.8184 22.1667 25.4167C22.1667 26.015 21.6816 26.5 21.0833 26.5H8.08333ZM8.08333 30.8333C7.48502 30.8333 7 30.3483 7 29.75C7 29.1517 7.48502 28.6667 8.08333 28.6667H16.75C17.3483 28.6667 17.8333 29.1517 17.8333 29.75C17.8333 30.3483 17.3483 30.8333 16.75 30.8333H8.08333Z",
      fill: "#4A90CE"
    })
  });
};

const Tabs$2 = () => {
  const {
    active,
    setActive
  } = useDashboardPageContext();
  const tabs = useCreation(() => {
    return [{
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.circles"
      }),
      icon: Subcircles,
      name: "circles"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.discussions"
      }),
      icon: Discussions,
      name: "discussions"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.meetings"
      }),
      icon: Events,
      name: "meetings"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.allPosts"
      }),
      iconComponent: OtherIcons,
      name: "allPosts"
    }];
  }, []);
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      className: "lg:hidden flex max-w-full overflow-x-scroll gap-1 sm:gap-2 w-full pr-6 items-center justify-between border-b-2 border-gray-300 scrollbar-hide pt-2 pb-4",
      children: tabs.map((tab, index) => {
        return /* @__PURE__ */ jsx(TabItem, {
          title: tab.title,
          icon: tab.icon,
          iconComponent: tab.iconComponent,
          active: active === tab.name,
          onClick: () => {
            setActive(tab.name);
          }
        }, index);
      })
    })
  });
};

const CircleItem$1 = ({
  circle,
  className,
  noSubCircles
}) => {
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const {
    subcircles
  } = circle;
  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : void 0;
  const totalSubCircles = subcircles ? subcircles.length : 0;
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex items-center px-2 w-1/3", className),
    children: [/* @__PURE__ */ jsx(Image$1, {
      size: 85,
      image: circle.image
    }), /* @__PURE__ */ jsx(Link$2, {
      to: circleUrl(circle._id),
      children: /* @__PURE__ */ jsx("p", {
        className: "font-semibold text-base",
        children: circle.name
      })
    }), !noSubCircles && totalSubCircles > 0 && /* @__PURE__ */ jsx(DropDown, {
      onClick: handleClick,
      iconClass: open && "rotate-180",
      tooltip: open ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.tooltip.parentCircle"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.tooltip.subCircles"
      })
    }), /* @__PURE__ */ jsx(Popper, {
      id,
      open,
      anchorEl,
      placement: "bottom-end",
      children: /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-4 card-shadow bg-white mt-1 p-2",
        children: subcircles && subcircles.map((c) => /* @__PURE__ */ jsx(CircleItem$1, {
          circle: c,
          className: "card-shadow py-2",
          noSubCircles: true
        }, c._id))
      })
    })]
  });
};
const uniq = (a) => {
  var seen = {};
  return a.filter(function(item) {
    return seen.hasOwnProperty(item) ? false : seen[item] = true;
  });
};
const EmptyBox = () => {
  return /* @__PURE__ */ jsxs("svg", {
    width: "115",
    height: "115",
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ jsx("path", {
      d: "M74.1211 11.5898L57.3203 20.125L39.6211 11.0508L3.59375 32.5234L20.3047 42.1367V81.9375L57.3203 62.2617L93.7969 81.9375V42.1367L111.406 31.9844L74.1211 11.5898Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M20.3047 82.8359C20.125 82.8359 19.9453 82.8359 19.8555 82.7461C19.5859 82.5664 19.4062 82.2969 19.4062 81.9375V42.5859L3.14453 33.2422C2.875 33.1523 2.69531 32.793 2.69531 32.5234C2.69531 32.2539 2.875 31.8945 3.14453 31.7148L39.1719 10.2422C39.4414 10.0625 39.8008 10.0625 40.0703 10.2422L57.4102 19.1367L73.6719 10.7813C73.9414 10.6016 74.2109 10.6914 74.4805 10.7813L111.766 31.1758C112.035 31.3555 112.215 31.625 112.215 31.9844C112.215 32.3437 112.035 32.6133 111.766 32.793L94.6055 42.6758V82.0273C94.6055 82.3867 94.4258 82.6562 94.1562 82.8359C93.8867 83.0156 93.5273 83.0156 93.2578 82.8359L57.3203 63.25L20.7539 82.7461C20.5742 82.8359 20.4844 82.8359 20.3047 82.8359ZM5.39062 32.5234L20.7539 41.3281C21.0234 41.5078 21.2031 41.7773 21.2031 42.1367V80.5L56.8711 61.4531C57.1406 61.2734 57.5 61.2734 57.6797 61.4531L92.8086 80.5V42.1367C92.8086 41.7773 92.9883 41.5078 93.2578 41.3281L109.609 31.9844L74.0312 12.668L58.3984 20.5742C58.3984 20.6641 58.3086 20.6641 58.3086 20.7539C58.0391 21.2031 57.5 21.293 57.0508 21.0234L56.8711 20.8438H56.7812L39.6211 12.0391L5.39062 32.5234Z",
      fill: "#6A576D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M57.3203 20.125L93.7969 42.1367V81.9375L57.3203 62.2617V20.125Z",
      fill: "#CE894A",
      "fill-opacity": "0.8"
    }), /* @__PURE__ */ jsx("path", {
      d: "M57.3203 20.125L20.3047 42.1367V81.9375L57.3203 62.2617V20.125Z",
      fill: "#CE894A",
      "fill-opacity": "0.8"
    }), /* @__PURE__ */ jsx("path", {
      d: "M93.7969 82.8359C93.6172 82.8359 93.5273 82.8359 93.3477 82.7461L56.8711 62.9805C56.6016 62.8008 56.4219 62.5312 56.4219 62.1719V20.125C56.4219 19.7656 56.6016 19.4961 56.8711 19.3164C57.1406 19.1367 57.5 19.1367 57.7695 19.3164L94.2461 41.3281C94.5156 41.5078 94.6953 41.7773 94.6953 42.1367V82.0273C94.6953 82.3867 94.5156 82.6562 94.2461 82.8359H93.7969ZM58.2188 61.7227L92.8984 80.5V42.5859L58.2188 21.7422V61.7227Z",
      fill: "#6A576D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M20.3047 82.8359C20.125 82.8359 19.9453 82.8359 19.8555 82.7461C19.5859 82.5664 19.4062 82.2969 19.4062 81.9375V42.1367C19.4062 41.7773 19.5859 41.5078 19.8555 41.3281L56.8711 19.3164C57.1406 19.1367 57.5 19.1367 57.7695 19.3164C58.0391 19.4961 58.2188 19.7656 58.2188 20.125V62.2617C58.2188 62.6211 58.0391 62.8906 57.7695 63.0703L20.7539 82.8359H20.3047ZM21.2031 42.5859V80.5L56.4219 61.7227V21.7422L21.2031 42.5859Z",
      fill: "#6A576D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M57.3203 61.8125L41.7773 55.7031L20.3047 42.0469V81.9375L57.3203 103.949L93.7969 81.9375V42.0469L77.3555 54.2656L57.3203 61.8125Z",
      fill: "#CE894A",
      "fill-opacity": "0.8"
    }), /* @__PURE__ */ jsx("path", {
      d: "M57.3203 104.848C57.1406 104.848 56.9609 104.848 56.8711 104.758L19.8555 82.7461C19.5859 82.5664 19.4062 82.2969 19.4062 81.9375V42.0469C19.4062 41.6875 19.5859 41.418 19.8555 41.2383C20.125 41.0586 20.4844 41.0586 20.7539 41.2383L42.2266 54.8945L57.4102 60.9141L76.9961 53.457L93.2578 41.3281C93.5273 41.1484 93.8867 41.0586 94.1562 41.2383C94.4258 41.418 94.6055 41.6875 94.6055 42.0469V81.9375C94.6055 82.2969 94.4258 82.5664 94.1562 82.7461L57.6797 104.758C57.6797 104.758 57.5 104.848 57.3203 104.848ZM21.2031 81.4883L57.3203 102.961L92.8984 81.4883V43.8437L77.8945 54.9844C77.8047 55.0742 77.7148 55.0742 77.7148 55.0742L57.6797 62.7109C57.5 62.8008 57.2305 62.8008 57.0508 62.7109L41.5078 56.6016C41.418 56.6016 41.418 56.5117 41.3281 56.5117L21.2031 43.7539V81.4883Z",
      fill: "#6A576D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M57.3203 103.949L93.7969 81.9375V42.0469L74.75 55.6133L57.3203 61.8125V103.949Z",
      fill: "#CE894A",
      "fill-opacity": "0.8"
    }), /* @__PURE__ */ jsx("path", {
      d: "M57.3203 104.848C57.1406 104.848 57.0508 104.848 56.8711 104.758C56.6016 104.578 56.4219 104.309 56.4219 103.949V61.8125C56.4219 61.4531 56.6914 61.0937 57.0508 61.0039L74.3906 54.8047L93.2578 41.3281C93.5273 41.1484 93.8867 41.1484 94.1563 41.2383C94.4258 41.418 94.6055 41.6875 94.6055 42.0469V81.9375C94.6055 82.2969 94.4258 82.5664 94.1563 82.7461L57.6797 104.758C57.6797 104.758 57.5 104.848 57.3203 104.848ZM58.2188 62.4414V102.332L92.8984 81.4883V43.8437L75.2891 56.332C75.1992 56.4219 75.1094 56.4219 75.1094 56.4219L58.2188 62.4414Z",
      fill: "#6A576D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M28.3906 67.832L57.3203 84.1836V61.8125L40.7891 56.2422L20.3047 42.0469L28.3906 67.832Z",
      fill: "#CE894A",
      "fill-opacity": "0.8"
    }), /* @__PURE__ */ jsx("path", {
      d: "M3.59375 51.6602L20.3047 42.0469L57.3203 61.8125L39.5312 71.9648L3.59375 51.6602Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M74.0313 77.8945L93.7969 67.7422V42.1367L77.7148 53.9961L57.5898 61.6328L57.3203 61.8125L74.0313 77.8945Z",
      fill: "#CE894A",
      "fill-opacity": "0.8"
    }), /* @__PURE__ */ jsx("path", {
      d: "M57.3203 61.8125L74.0313 71.4258L111.406 52.1992L93.7969 42.1367L57.3203 61.8125Z",
      fill: "white"
    }), /* @__PURE__ */ jsx("path", {
      d: "M39.5312 72.8633C39.3516 72.8633 39.2617 72.8633 39.082 72.7734L3.14453 52.4688C2.875 52.2891 2.69531 52.0195 2.69531 51.6602C2.69531 51.3008 2.875 51.0312 3.14453 50.8516L19.8555 41.3281C20.125 41.1484 20.4844 41.1484 20.7539 41.3281L57.7695 61.0938C58.0391 61.2734 58.2188 61.543 58.2188 61.9023C58.2188 62.2617 58.0391 62.5313 57.7695 62.7109L39.9805 72.7734C39.8906 72.8633 39.7109 72.8633 39.5312 72.8633ZM5.39062 51.6602L39.5312 70.9766L55.4336 61.9023L20.3047 43.125L5.39062 51.6602Z",
      fill: "#6A576D"
    }), /* @__PURE__ */ jsx("path", {
      d: "M74.0313 72.3242C73.8516 72.3242 73.7617 72.3242 73.582 72.2344L56.8711 62.6211C56.6016 62.4414 56.4219 62.1719 56.4219 61.8125C56.4219 61.4531 56.6016 61.1836 56.8711 61.0039L93.3477 41.2383C93.6172 41.0586 93.9766 41.0586 94.2461 41.2383L111.855 51.3906C112.125 51.5703 112.305 51.8398 112.305 52.1992C112.305 52.5586 112.125 52.8281 111.855 53.0078L74.4805 72.2344C74.3008 72.3242 74.2109 72.3242 74.0313 72.3242ZM59.207 61.8125L74.1211 70.3477L109.609 52.1094L93.707 43.125L59.207 61.8125Z",
      fill: "#6A576D"
    })]
  });
};
const EmptyList = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("p", {
      className: "text-lg font-semibold mt-20",
      children: "There is nothing for you!"
    }), /* @__PURE__ */ jsx(EmptyBox, {})]
  });
};
const DashBoardMain = () => {
  const [discussionsNumber, setDiscussionsNumber] = useState(4);
  const [meetingsNumber, setMeetingsNumber] = useState(4);
  const {
    posts,
    circles,
    active
  } = useDashboardPageContext();
  const filtered = useCreation(() => {
    if (!circles) {
      return [];
    }
    const byId = circles.reduce((all, g) => {
      all[g._id] = g;
      return all;
    }, {});
    const CIRCLES_NUM = 3;
    const idsFromPosts = uniq(posts.map((p) => p.group.group._id));
    const ids = uniq([...idsFromPosts, ...circles.filter((c) => !c.parent).map((c) => c._id)]);
    return ids.map((id) => byId[id]).filter((v) => v).slice(0, CIRCLES_NUM);
  }, [posts, circles]);
  const {
    discussions,
    meetings
  } = useCreation(() => {
    const discussions2 = posts.filter((p) => p.type === "discussion");
    const meetings2 = posts.filter((p) => p.type === "event");
    return {
      discussions: discussions2,
      meetings: meetings2
    };
  }, [posts]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Tabs$2, {}), /* @__PURE__ */ jsx("div", {
      className: "hidden lg:flex flex-col col-span-6",
      children: /* @__PURE__ */ jsx(ColumnHeader, {
        iconComponent: SiCircle,
        tooltip: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.tooltip.circles"
        }),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: clsx("lg:flex flex-col col-span-6", active === "circles" ? "flex" : "hidden"),
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col lg:flex-row w-full items-start lg:items-center gap-2 justify-center mt-2",
        children: [!filtered.length && /* @__PURE__ */ jsx("div", {
          className: "w-full flex flex-col items-center gap-2",
          children: /* @__PURE__ */ jsx(EmptyList, {})
        }), filtered.map((c) => /* @__PURE__ */ jsx(CircleItem$1, {
          circle: c
        }, c._id))]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full items-center gap-4 justify-center my-3",
        children: [/* @__PURE__ */ jsx(Link$2, {
          to: "/groups",
          children: /* @__PURE__ */ jsx("div", {
            className: "text-primary font-semibold",
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "dashboard.showMore"
            })
          })
        }), /* @__PURE__ */ jsx(Link$2, {
          to: "/groups/discover",
          children: /* @__PURE__ */ jsx("div", {
            className: "text-primary font-semibold",
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "dashboard.discover"
            })
          })
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: clsx("w-full lg:flex flex-col items-center gap-2 col-span-3", active === "discussions" ? "flex" : "hidden"),
      children: [/* @__PURE__ */ jsx(ColumnHeader, {
        icon: Discussions,
        tooltip: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.tooltip.discussions"
        }),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.discussions"
        })
      }), !discussions.length && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(EmptyList, {}), /* @__PURE__ */ jsxs("p", {
          children: [/* @__PURE__ */ jsx(Link$2, {
            to: "/groups/discover",
            className: "underline",
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "dashboard.discover"
            })
          }), " Circles you can Join and take part in Discussions"]
        })]
      }), discussions.slice(0, discussionsNumber).map((post) => {
        return /* @__PURE__ */ jsx(PostCard1, {
          post
        }, post._id);
      }), discussions.length > discussionsNumber && /* @__PURE__ */ jsx("button", {
        className: "flex justify-center items-end relative gap-2.5 p-1.5 rounded-[10px] bg-primary mt-2",
        onClick: () => setDiscussionsNumber(discussions.length),
        children: /* @__PURE__ */ jsx("p", {
          className: "text-center text-white",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "dashboard.showMore"
          })
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: clsx("w-full lg:flex flex-col items-center gap-2 col-span-3", active === "meetings" ? "flex" : "hidden"),
      children: [/* @__PURE__ */ jsx(ColumnHeader, {
        icon: Events,
        tooltip: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.tooltip.meetings"
        }),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.meetings"
        })
      }), !meetings.length && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(EmptyList, {}), /* @__PURE__ */ jsxs("p", {
          children: [/* @__PURE__ */ jsx(Link$2, {
            to: "/groups/discover",
            className: "underline",
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "dashboard.discover"
            })
          }), " Circles you can Join and take part in Meetings"]
        })]
      }), meetings.slice(0, meetingsNumber).map((post) => {
        return /* @__PURE__ */ jsx(PostCard1, {
          post
        }, post._id);
      }), meetings.length > meetingsNumber && /* @__PURE__ */ jsx("button", {
        className: "flex justify-center items-end relative gap-2.5 p-1.5 rounded-[10px] bg-primary mt-2",
        onClick: () => setMeetingsNumber(meetings.length),
        children: /* @__PURE__ */ jsx("p", {
          className: "text-center text-white",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "dashboard.showMore"
          })
        })
      })]
    })]
  });
};

const useCirclePosts = (circleId, op, filter = "", {
  events,
  chat
} = {}) => {
  const api = useApi();
  const {
    language
  } = useLanguageSelectionContext();
  return useSWR(circleId ? [`/groups/${circleId}/${events ? "events" : "posts"}/${filter}`, language] : null, () => loadCirclePosts(api, circleId, filter, {
    events,
    chat,
    language
  }), {
    ...swrLoadOnce,
    ...op
  });
};
const useCircleReferences = (circleId, op, filter = "") => {
  const api = useApi();
  return useSWR(circleId ? `/groups/${circleId}/references/${filter}` : null, () => loadCircleReferences(api, circleId, filter), {
    ...swrLoadOnce,
    ...op
  });
};
const useDashboardData = (mode, op) => {
  const api = useApi();
  const {
    currentFilterRef,
    filter$
  } = useSearchContext();
  const update = useUpdate();
  const {
    activities$
  } = useActivityContext();
  filter$.useSubscription(update);
  const result = useSWR(mode === "simple" ? null : `/pages/dashboard/${currentFilterRef.current || ""}`, () => api.get({
    path: "/pages/dashboard/" + (!currentFilterRef.current ? "" : "?filter=" + encodeURIComponent(currentFilterRef.current))
  }), {
    ...swrLoadOnce,
    ...op
  });
  const {
    run
  } = useThrottleFn(() => {
    if (mode === "simple") {
      return;
    }
    const {
      mutate
    } = result;
    mutate();
  }, {
    wait: 5e3
  });
  activities$.useSubscription(({
    type
  }) => {
    if (mode === "simple") {
      return;
    }
    if (type !== "post") {
      return;
    }
    const {
      isValidating
    } = result;
    if (!isValidating) {
      run();
    }
  });
  return result;
};
const useDiscover = (op) => {
  const api = useApi();
  const {
    currentFilterRef,
    filter$
  } = useSearchContext();
  const update = useUpdate();
  filter$.useSubscription(update);
  return useSWR(`/groups/discover/${currentFilterRef.current || ""}`, () => api.loadAvailableGroups({
    filter: encodeURIComponent(currentFilterRef.current)
  }), {
    ...swrLoadOnce,
    ...op
  });
};

const noop$h = () => null;
const DashboardPageContext = React__default.createContext({
  posts: [],
  other: [],
  profile: void 0,
  isNotLogged: false,
  circles: [],
  active: "discussions",
  setActive: noop$h,
  mode: "simple",
  setMode: noop$h
});
const useDashboardPageContext = () => {
  return useContext(DashboardPageContext);
};
const EMPTY = [];
const DashboardPageContextProvider = ({
  children,
  ignoreProfile
}) => {
  const [mode, setMode] = useState("simple");
  const [active, setActive] = useState("discussions");
  const [community, setCommunity] = useState([]);
  const {
    allCircles
  } = useMyCirclesWithFilter({
    idle: mode === "simple"
  });
  const {
    data: dashboard
  } = useDashboardData(mode);
  const {
    data: profile,
    isValidating
  } = useProfile();
  const isNotLogged = !profile && !isValidating;
  const history = useHistory();
  useEffect(() => {
    if (dashboard && dashboard.community) {
      setCommunity(dashboard.community);
    }
  }, [dashboard]);
  useEffect(() => {
    if (ignoreProfile) {
      setMode("advanced");
      return;
    }
    if (!profile) {
      if (isNotLogged) {
        history.push("/welcome");
      }
      return;
    }
    if (!profile.dashboard || profile.dashboard === "/") {
      setMode("advanced");
      return;
    }
    history.push(profile.dashboard);
  }, [profile, isNotLogged]);
  const context = useMemo(() => {
    return {
      ...dashboard || {
        posts: EMPTY,
        other: EMPTY
      },
      profile,
      isNotLogged,
      circles: isNotLogged ? community : allCircles,
      active,
      setActive,
      mode,
      setMode
    };
  }, [profile, dashboard, allCircles, community, active, mode]);
  return /* @__PURE__ */ jsx(DashboardPageContext.Provider, {
    value: context,
    children
  });
};
const DashboardPageInner = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(ChangeCirclePrivacyDialog, {}), /* @__PURE__ */ jsx(ConfirmDeleteCircle, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns sm:px-[54px] overflow-x-hidden text-2xs sm:text-sm w-full",
      children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full flex-col gap-2 p-2",
        children: [/* @__PURE__ */ jsx(DashboardNavigation, {}), /* @__PURE__ */ jsx(DashboardBreadCrumbs, {})]
      }), /* @__PURE__ */ jsxs("div", {
        className: "lg:grid grid-cols-8 mb-2 gap-2",
        children: [/* @__PURE__ */ jsx(CooperativelyDeveloping, {
          className: "lg:hidden text-sm"
        }), /* @__PURE__ */ jsx("img", {
          src: "/static/images/workshop-mobile.jpg",
          className: "aspect-[28/10] w-full lg:hidden"
        }), /* @__PURE__ */ jsx(DashBoardMain, {}), /* @__PURE__ */ jsx(OtherCircles, {})]
      })]
    })]
  });
};
const DashboardPage = (props) => {
  return /* @__PURE__ */ jsx(DashboardPageContextProvider, {
    ...props,
    children: /* @__PURE__ */ jsx(DashboardPageInner, {})
  });
};

const Stop = () => {
  return /* @__PURE__ */ jsx("div", {
    className: "sm:w-3",
    children: "|"
  });
};
const DashboardBreadCrumbs = () => {
  useDashboardPageContext();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx("div", {
      className: "flex-grow"
    })]
  });
};

const useDashboardLink = () => {
  const {
    profile
  } = useProfileContext();
  const profileDashboardUrl = profile && profile.dashboard;
  const url = (profileDashboardUrl && profileDashboardUrl === "/" ? dashboardUrl() : profileDashboardUrl) || dashboardUrl();
  return url;
};
const DashboardLink = () => {
  const url = useDashboardLink();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Link$2, {
      to: url,
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.breadcrumb"
        })
      })
    }), /* @__PURE__ */ jsx(Stop, {})]
  });
};

const NotificationsBreadCrumbs = () => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: "/notifications",
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "toolbars.notifications"
        })
      })
    })]
  });
};

const useUserPage = (page, op) => {
  const api = useApi();
  const { profile } = useProfileContext();
  const result = useSWR(profile ? `/users/page?page=` + page : null, async (url) => {
    const page2 = await api.get({
      path: url
    });
    return page2 || {};
  }, {
    ...swrLoadOnce,
    ...op
  });
  return result;
};

const OpenConfigButton = () => {
  const [dialog, setDialog] = useState(false);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(StyledButton, {
      className: "group relative",
      icon: PiGear,
      onClick: () => setDialog(true),
      children: /* @__PURE__ */ jsx(Tooltip, {
        children: "Notifications settings"
      })
    }), dialog && /* @__PURE__ */ jsx(SettingsDialog, {
      onClose: () => setDialog(false)
    })]
  });
};

const HamburgerMenu = () => {
  const url = useDashboardLink();
  return /* @__PURE__ */ jsx(Link$2, {
    to: url,
    children: /* @__PURE__ */ jsx(StyledButton, {
      icon: GiHamburgerMenu,
      className: "group relative",
      children: /* @__PURE__ */ jsx(Tooltip, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.tooltips.dashboard"
        })
      })
    })
  });
};

const NotificationsNavigation = () => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-6 sm:justify-start items-center w-full p-4 bg-white shadow-lg px-[9px] py-[7px] relative ",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: "block",
      children: /* @__PURE__ */ jsx(HamburgerMenu, {})
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-end items-center relative gap-4  ltr:ml-auto rtl:mr-auto",
      children: [/* @__PURE__ */ jsx(OpenConfigButton, {}), /* @__PURE__ */ jsx(OpenHelpButton$5, {}), /* @__PURE__ */ jsx(ProfileIcon, {})]
    })]
  });
};
const SettingsDialog = ({
  onClose
}) => {
  const api = useApi();
  const {
    data
  } = useUserPage("notify");
  const [days, setDays] = useState(15);
  const handleChange = (e) => {
    const v = parseInt(e.target.value);
    setDays(v);
  };
  useEffect(() => {
    if (!data) {
      return;
    }
    const {
      days: days2 = 15
    } = data && data.value || {};
    setDays(days2);
  }, [data]);
  const {
    onClick: onSave,
    loading
  } = useLoading(async () => {
    await api.post({
      path: "/users/page",
      body: {
        page: "notify",
        days
      }
    });
    window.location.reload();
  });
  const content = data ? /* @__PURE__ */ jsxs(FormControl$1, {
    className: "w-full",
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: "execution-type",
      children: "Show history for (days)"
    }), /* @__PURE__ */ jsx(Select$1, {
      labelId: "execution-type",
      value: days,
      variant: "outlined",
      onChange: handleChange,
      children: [...Array(3).keys()].map((id) => {
        const value = (id + 1) * 5;
        return /* @__PURE__ */ jsx(MenuItem, {
          value,
          children: value
        }, id);
      })
    })]
  }) : /* @__PURE__ */ jsx(CircularProgress, {
    color: "secondary"
  });
  return /* @__PURE__ */ jsxs(ConfirmDialog, {
    title: "Notification settings",
    open: true,
    content,
    onClose,
    children: [/* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSave,
      loading,
      children: "Ok"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onClose,
      children: "Cancel"
    })]
  });
};
const OpenHelpButton$5 = () => {
  const {
    data: profile
  } = useProfile();
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(HelpContextProvider, {
      page: "notifications",
      profile,
      children: /* @__PURE__ */ jsx(WelcomeToPageButton, {
        button: (props) => /* @__PURE__ */ jsx(StyledButton, {
          className: "group relative",
          icon: IoMdHelpCircleOutline,
          ...props,
          children: /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.help"
            })
          })
        })
      })
    })
  });
};

const DAYS_TO_RETAIN_NOTIFICATIONS = 1e3;
const noop$g = () => null;
const NotificationsContext = React__default.createContext({
  daysToRetain: DAYS_TO_RETAIN_NOTIFICATIONS,
  setDays2Retain: noop$g
});
const useNotificationsContext = () => {
  return useContext(NotificationsContext);
};
const NotificationsContextProvider = ({
  children
}) => {
  useApi();
  const [daysToRetain, setDays2Retain] = useState(DAYS_TO_RETAIN_NOTIFICATIONS);
  const context = useMemo(() => {
    return {
      daysToRetain,
      setDays2Retain
    };
  }, [daysToRetain]);
  return /* @__PURE__ */ jsx(NotificationsContext.Provider, {
    value: context,
    children
  });
};
const NotificationsPage = (props) => {
  const {
    children,
    ...other
  } = props;
  const {
    data: profile,
    isValidating
  } = useProfile();
  const isNotLoggedIn = !profile && !isValidating;
  return /* @__PURE__ */ jsx(NotificationsContextProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "ns sm:px-[54px] overflow-hidden text-base/3 w-full pb-4",
      children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), children, /* @__PURE__ */ jsxs("div", {
        className: "flex w-full flex-col gap-3 p-2",
        children: [/* @__PURE__ */ jsx(NotificationsNavigation, {}), /* @__PURE__ */ jsx(NotificationsBreadCrumbs, {}), !isNotLoggedIn && /* @__PURE__ */ jsx(Fragment, {
          children: /* @__PURE__ */ jsxs(ActivityContextProvider, {
            children: [/* @__PURE__ */ jsx(NotificationsList$1, {
              ...other
            }), /* @__PURE__ */ jsx("div", {
              className: "text-xs p-2 w-full text-center",
              children: "You can still view expired notifications under the Recent Activities tab on the appropriate Circle Page"
            })]
          })
        })]
      }), isNotLoggedIn && /* @__PURE__ */ jsx(RequiresRegistration, {})]
    })
  });
};

const postGroupId = (post) => {
  return post && post.group && post.group.group && (typeof post.group.group === "string" ? post.group.group : post.group.group._id);
};
const postAuthorId = (post) => {
  return post && (typeof post.author === "string" ? post.author : post.author._id);
};

const ONE_MINUTE_IN_MILLISECONDS = 1e3 * 60;
const ONE_HOUR_IN_MILLISECONDS = ONE_MINUTE_IN_MILLISECONDS * 60;
const ONE_DAY_IN_MILLISECONDS = ONE_HOUR_IN_MILLISECONDS * 24 * 1;
const compare = (a, b) => {
  if (a.lastActivityTime < b.lastActivityTime) {
    return 1;
  }
  if (a.lastActivityTime === b.lastActivityTime) {
    return 0;
  }
  return -1;
};
const updateCircleActivityTimesVotes = (history, initial) => {
  return history.reduce((times, activity) => {
    if (!times[activity.circle]) {
      times[activity.circle] = activity.poll.date;
      return times;
    }
    if (times[activity.circle] < activity.poll.date) {
      times[activity.circle] = activity.poll.date;
    }
    return times;
  }, initial);
};
const updateCircleActivityTimesPosts = (history, initial) => {
  return history.reduce((times, activity) => {
    if (!times[activity.circle]) {
      times[activity.circle] = activity.modified;
      return times;
    }
    if (times[activity.circle] < activity.modified) {
      times[activity.circle] = activity.modified;
    }
    return times;
  }, initial);
};
const updateCircleActivityTimesChats = (history, initial) => {
  return history.reduce((times, activity) => {
    if (!times[activity.group]) {
      times[activity.group] = activity.created;
      return times;
    }
    if (times[activity.group] < activity.created) {
      times[activity.group] = activity.created;
    }
    return times;
  }, initial);
};
const useDaysAgoString = (daysToRetain) => {
  const lastDay = useMemo(() => {
    return new Date(Date.now() - ONE_DAY_IN_MILLISECONDS * daysToRetain).toISOString();
  }, [daysToRetain]);
  return lastDay;
};
const keepPostsHistory = (postsData, profile) => {
  if (!postsData || !profile) {
    return void 0;
  }
  return postsData.history.filter((d) => !d.wasSeen || postAuthorId(d.post) !== profile._id);
};
const keepChatsHistory = (postsData, profile) => {
  if (!postsData || !profile) {
    return void 0;
  }
  return postsData;
};
const keepVotesHistory = (votesData, profile) => {
  if (!votesData || !profile) {
    return void 0;
  }
  return votesData.history.filter((d) => !d.castedVote || d.poll.creator !== profile._id);
};
const useNotificationsLastDayString = () => {
  const {
    daysToRetain
  } = useNotificationsContext();
  return useDaysAgoString(daysToRetain);
};
const NotificationsList$1 = ({
  waiting,
  empty,
  error: Error = () => null
}) => {
  const {
    data: circlesData,
    error,
    isValidating
  } = useMyCircles$1({
    buildTree: false
  });
  const {
    data: votesData
  } = useVotesActivity({
    revalidateOnMount: true
  });
  const {
    data: postsData
  } = usePostsActivity({
    revalidateOnMount: true
  });
  const {
    data: chatsData
  } = useChatActivity({
    revalidateOnMount: true
  });
  const {
    profile
  } = useProfileContext();
  const votes = useMemo(() => keepVotesHistory(votesData, profile), [votesData]);
  const posts = useMemo(() => keepPostsHistory(postsData, profile), [postsData]);
  const chats = useMemo(() => keepChatsHistory(chatsData, profile), [postsData]);
  const votesActivityTimes = useMemo(() => {
    if (!votes) {
      return {};
    }
    const circleActivityTimes2 = updateCircleActivityTimesVotes(votes, {});
    return circleActivityTimes2;
  }, [votes]);
  const postsActivityTimes = useMemo(() => {
    if (!posts) {
      return votesActivityTimes;
    }
    const circleActivityTimes2 = updateCircleActivityTimesPosts(posts, {
      ...votesActivityTimes
    });
    return circleActivityTimes2;
  }, [posts, votesActivityTimes]);
  const chatsActivityTimes = useMemo(() => {
    if (!chats) {
      return postsActivityTimes;
    }
    const chatsActivityTimes2 = updateCircleActivityTimesChats(chats, {
      ...postsActivityTimes
    });
    return chatsActivityTimes2;
  }, [chats, postsActivityTimes]);
  const circleActivityTimes = chatsActivityTimes;
  const filtered = useMemo(() => {
    if (!circlesData) {
      return circlesData;
    }
    const filtered2 = circlesData.filter((g) => circleActivityTimes[g._id]).map((c) => {
      return {
        ...c,
        lastActivityTime: circleActivityTimes[c._id]
      };
    });
    return filtered2.sort(compare);
  }, [circlesData, circleActivityTimes]);
  if (!circlesData && error && !isValidating) {
    return /* @__PURE__ */ jsx(Error, {
      error
    });
  }
  if (!circlesData || !votes || !posts) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: waiting
    });
  }
  if (!filtered.length) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: empty
    });
  }
  const community = filtered.filter((g) => g.community);
  const notCommunity = filtered.filter((g) => !g.community);
  const circles = [...notCommunity, ...community];
  const enabled = circles.filter((g) => g.privacy !== "PERSONAL");
  return /* @__PURE__ */ jsx("div", {
    className: "ns",
    children: /* @__PURE__ */ jsxs(CardThemeProvider, {
      cardShadow: false,
      linkToPage: false,
      closer: true,
      children: [enabled.map((g, i) => /* @__PURE__ */ jsx(NotificationsCard, {
        showImage: true,
        data: g
      }, g._id)), !enabled.length && /* @__PURE__ */ jsx(Message, {
        children: "Notifications in disabled circles only"
      })]
    })
  });
};
const Message = styled.div`
    padding: 10px;
`;

const NotificationsCard = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(CircleProvider, {
    data,
    override,
    children: /* @__PURE__ */ jsx(NotificationsCardImpl, {
      ...props
    })
  });
};
const ContentOuter$1 = styled.div`
    display: flex;
`;
const ContentBodyWrapper$1 = styled.div`
    flex: auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
`;
const LOCAL_PLAYGROUND = "http://localhost:3030";
const StyledTitle = styled(Title)`
    flex: 1;
    font-size: 14px;
    && {
        min-width: 200px;
    }

`;
const VoteTitle = (props) => {
  const {
    linkToPage,
    menu
  } = useCardsTheme();
  const {
    data
  } = useVoteData();
  const {
    post,
    circle,
    root,
    poll
  } = data;
  const {
    title: postTitle
  } = post;
  const {
    description
  } = poll;
  const isCore = location.href.startsWith(LOCAL_PLAYGROUND);
  const prefix = isCore ? LOCAL_PLAYGROUND.replace(":3030", ":3000") : "";
  const url = `${prefix}/groups/${circle}/posts/post/${root._id}#?info=vote&response=${post._id}`;
  const title = linkToPage ? postTitle : /* @__PURE__ */ jsx(Link$1, {
    to: !isCore && url,
    component: isCore ? "a" : Link$2,
    underline: "hover",
    href: isCore && url,
    children: description || postTitle
  });
  return /* @__PURE__ */ jsxs(StyledTitle, {
    ...props,
    children: [title, menu]
  });
};
const PostTitle = (props) => {
  const {
    linkToPage,
    menu
  } = useCardsTheme();
  const {
    data
  } = usePostData();
  const {
    post,
    chat,
    circle
  } = data;
  const {
    title: text
  } = post;
  const isCore = checkIsCoreUrl();
  const url = chat ? `/trans/circle-chat/${objectId(circle)}` : getResponseUrl(post);
  const title = linkToPage ? text : /* @__PURE__ */ jsx(Link$1, {
    to: !isCore && url,
    component: isCore ? "a" : Link$2,
    underline: "hover",
    href: isCore && url,
    children: text
  });
  return /* @__PURE__ */ jsxs(StyledTitle, {
    children: [title, menu]
  });
};
const VoteStarted = () => {
  const {
    data
  } = useVoteData();
  const {
    poll
  } = data;
  const {
    date
  } = poll;
  return /* @__PURE__ */ jsx(RelativeTime, {
    value: date
  });
};
const PostModified = () => {
  const {
    data
  } = usePostData();
  const {
    modified
  } = data;
  return /* @__PURE__ */ jsx(RelativeTime, {
    value: modified
  });
};
const VoteTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: 5px;
    min-width: 100%;
    & > * {
        margin: 0;
        margin-right: 5px;
    }

    & > time {
        font-size: 12px;
        min-width: 0;
        white-space: break-spaces;
        flex-shrink: 10;
    }
`;
const VoteActivityCard = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(VoteProvider, {
    data,
    override,
    children: /* @__PURE__ */ jsxs(VoteTitleWrapper, {
      "data-testid": "vote-activity-card",
      className: clsx("notification-card", data.castedVote && "opacity-60"),
      children: [/* @__PURE__ */ jsx(VoteIcon, {
        ...commonIconProps
      }), /* @__PURE__ */ jsx(VoteTitle, {}), /* @__PURE__ */ jsx(VoteStarted, {})]
    })
  });
};
const PostBodyMiddle = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    flex-wrap: wrap;
    & > * {
        min-width: 0;       
    }
`;
const PostActivityCard = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  if (!data) {
    return null;
  }
  return /* @__PURE__ */ jsx(PostProvider, {
    data,
    override,
    children: /* @__PURE__ */ jsxs(VoteTitleWrapper, {
      className: clsx("notification-card", data.wasSeen && "opacity-60"),
      children: [/* @__PURE__ */ jsx(PostAuthorAvatar, {}), /* @__PURE__ */ jsxs(PostBodyMiddle, {
        children: [/* @__PURE__ */ jsx(PostAuthorNameChip, {}), /* @__PURE__ */ jsx(TopLevelChip, {}), /* @__PURE__ */ jsx(ThreadChip, {}), /* @__PURE__ */ jsx(ReplyChip, {}), /* @__PURE__ */ jsx(ChatChip, {}), /* @__PURE__ */ jsx(ConclusionChip, {}), /* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(PostTitle, {})]
      }), /* @__PURE__ */ jsx(PostModified, {})]
    })
  });
};
const NameChip = styled(CardChip$1)`
    max-width: 150px;
    flex-shrink: 3;
    & > * {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        text-transform: none;
    }

`;
const PostAuthorNameChip = () => {
  const {
    data
  } = usePostData();
  const {
    post
  } = data;
  const {
    author
  } = post;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Separator, {}), /* @__PURE__ */ jsx(NameChip, {
      children: getPersonName(author)
    })]
  });
};
const PostAuthorAvatar = () => {
  const {
    data
  } = usePostData();
  const {
    post
  } = data;
  const {
    author
  } = post;
  return /* @__PURE__ */ jsx(Avatar, {
    avatar: author.avatar
  });
};
const CircleTitleWrapper = styled.div`
    display: flex;
    align-items: center;
    && .MuiIconButton-root {
        padding: 2px;
        margin: 0;
        margin-left: 5px;
        margin-right: 40px;
    }
    & .MuiBadge-badge {
        transform: none;
        right: auto;
        left: 100%;
        top: 0;
    }
`;
const StyledCircleTitle = styled(CircleTitle$1)`
    font-size: 16px;
    margin-top: 0;
`;
const compareByModificationTime = (a, b) => {
  if (a.modified < b.modified) {
    return 1;
  }
  if (a.modified === b.modified) {
    return 0;
  }
  return -1;
};
const CircleHeader$1 = () => {
  return /* @__PURE__ */ jsxs(CircleTitleWrapper, {
    children: [/* @__PURE__ */ jsx(StyledCircleTitle, {
      underline: "hover",
      className: "circle-title"
    }), /* @__PURE__ */ jsx(Tooltip$2, {
      title: "Click to see all voting for this Circle",
      children: /* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx(MyCircleVotingIcon, {})
      })
    })]
  });
};
const NotificationsContentBody = () => {
  const {
    data: votesData
  } = useVotesActivity({
    revalidateOnMount: false
  });
  const {
    data: postsData
  } = usePostsActivity({
    revalidateOnMount: false
  });
  const {
    data: chatsData
  } = useChatActivity({
    revalidateOnMount: false
  });
  const {
    data: circleData
  } = useCircleData();
  const {
    profile
  } = useProfileContext();
  const circleId = circleData && circleData._id;
  const votes = useCreation(() => {
    if (!votesData) {
      return [];
    }
    const history = keepVotesHistory(votesData, profile);
    return history.filter((a) => a.circle === circleId).map((v) => {
      return {
        type: "vote",
        modified: v.poll.date,
        data: v
      };
    });
  }, [votesData, circleId]);
  const posts = useCreation(() => {
    if (!postsData) {
      return [];
    }
    const history = keepPostsHistory(postsData, profile);
    const filtered = history.filter((a) => a.circle === circleId).map((v) => {
      return {
        type: "post",
        modified: v.modified,
        data: v
      };
    });
    return filtered;
  }, [postsData, circleId]);
  const chats = useCreation(() => {
    if (!chatsData) {
      return [];
    }
    const filtered = chatsData.filter((a) => a.group === circleId).map((v) => {
      const {
        post,
        author
      } = v;
      const {
        _id,
        modified
      } = post;
      const data = {
        _id,
        circle: circleData,
        post: {
          ...post,
          author
        },
        rootPost: post,
        user: author,
        modified,
        wasSeen: false,
        isReply: false,
        chat: true
      };
      return {
        type: "chats",
        data
      };
    });
    return filtered;
  }, [chatsData, circleId]);
  const all = [...votes, ...posts].sort(compareByModificationTime);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [chats.map((a) => {
      return /* @__PURE__ */ jsx(PostActivityCard, {
        data: a.data
      }, a.data._id);
    }), all.map((a) => {
      if (a.type === "post") {
        return /* @__PURE__ */ jsx(PostActivityCard, {
          data: a.data
        }, a.data._id);
      }
      return /* @__PURE__ */ jsx(VoteActivityCard, {
        data: a.data
      }, a.data._id);
    })]
  });
};
const CircleContentWrapper = ({
  children
}) => {
  const Content = ContentOuter$1;
  return /* @__PURE__ */ jsx(Content, {
    children
  });
};
const ImageWrapper$2 = styled.div`
    margin: 0;
    margin-top: 5px;
    padding: 0;
`;
const NotificationsCardImpl = (props) => {
  const {
    data
  } = props;
  const {
    image
  } = data;
  const matches = useMediaQuery("(min-width:600px)");
  if (image) {
    if (!matches) {
      return /* @__PURE__ */ jsxs(CardOuter, {
        children: [/* @__PURE__ */ jsxs(CircleContentWrapper, {
          ...props,
          children: [/* @__PURE__ */ jsx(ImageWrapper$2, {
            children: /* @__PURE__ */ jsx(Image$1, {
              image
            })
          }), /* @__PURE__ */ jsx(ContentBodyWrapper$1, {
            children: /* @__PURE__ */ jsx(CircleHeader$1, {})
          })]
        }), /* @__PURE__ */ jsx(NotificationsContentBody, {})]
      });
    }
    return /* @__PURE__ */ jsx(CardOuter, {
      children: /* @__PURE__ */ jsxs(CircleContentWrapper, {
        ...props,
        children: [/* @__PURE__ */ jsx(ImageWrapper$2, {
          children: /* @__PURE__ */ jsx(Image$1, {
            image
          })
        }), /* @__PURE__ */ jsxs(ContentBodyWrapper$1, {
          children: [/* @__PURE__ */ jsx(CircleHeader$1, {}), /* @__PURE__ */ jsx(NotificationsContentBody, {})]
        })]
      })
    });
  }
  return /* @__PURE__ */ jsx(CardOuter, {
    children: /* @__PURE__ */ jsxs(ContentBodyWrapper$1, {
      children: [/* @__PURE__ */ jsx(CircleHeader$1, {}), /* @__PURE__ */ jsx(NotificationsContentBody, {})]
    })
  });
};

const BigStyledButton = ({
  children,
  className,
  icon: Icon,
  text,
  fitContent,
  bg,
  ...other
}) => {
  return /* @__PURE__ */ jsxs("button", {
    className: clsx("flex items-center gap-2 py-1 px-3 rounded-md text-white font-medium relative", fitContent ? "w-fit" : "w-full", bg ? bg : "bg-primary", className),
    ...other,
    children: [Icon && /* @__PURE__ */ jsx(Icon, {
      alt: text,
      className: "h-6  fill-white"
    }), /* @__PURE__ */ jsx("span", {
      className: "text-left text-white",
      children: children || text
    })]
  });
};

const createInterview = async (api, circleId) => {
  const result = await api.post({
    path: "/v2/media",
    body: {
      title: "New media post",
      type: "article",
      circleId,
      tags: [INTERVIEW_TAG, MEDIA_TAG]
    }
  });
  return result;
};
const saveInterview = async (api, postId, input) => {
  const result = await api.patch({
    path: `v2/posts/${postId}`,
    body: input
  });
  return result;
};
const createInterviewPage = async (api, root, input) => {
  const result = await api.post({
    path: "v2/posts",
    body: {
      title: "New page",
      type: root.type,
      responseTo: root._id,
      features: ["page"],
      tags: root.tags || [],
      circleId: circleIdForPost(root),
      ...input
    }
  });
  return result;
};
const loadInterviewPost = async (api, postId) => {
  const result = await api.get({
    path: `v2/posts/${postId}`
  });
  return result;
};
const publishInterviewPost = async (api, postId) => {
  await api.post({ path: `v2/posts/${postId}/publish` });
};
const publishInterviewDraft = async (api, postId) => {
  const result = await api.post({ path: `v2/interviews/${postId}/publish` });
  return result;
};

const useCreateInterviewFn = () => {
  const api = useApi();
  const { id: circleId } = useCircleContext();
  return useMemoizedFn(async () => {
    const result = await createInterview(api, circleId);
    return result;
  });
};

const CreateInterviewButton = (props) => {
  const history = useHistory();
  const createInterview = useCreateInterviewFn();
  const onClick = async () => {
    const result = await createInterview();
    history.push(createInterviewUrl(result.post));
  };
  return /* @__PURE__ */ jsx(BigStyledButton, {
    onClick,
    text: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.actions.createInterview"
    }),
    icon: MdMic,
    ...props
  });
};

const StartDiscussionIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.349 16.1422C9.90313 16.4017 9.52944 16.6576 9.23493 16.8776C8.91413 17.1173 8.43034 16.9125 8.44669 16.5124C8.46405 16.0879 8.50911 15.5667 8.61211 15.0203C8.77595 14.1512 9.08638 13.2182 9.665 12.5089C9.23825 11.687 9.00296 10.7871 9.00296 9.84375C9.00296 5.96049 12.9904 2.8125 17.9092 2.8125C22.828 2.8125 26.8154 5.96049 26.8154 9.84375C26.8154 13.727 22.828 16.875 17.9092 16.875C15.7492 16.875 13.7687 16.268 12.2267 15.2581C11.5072 15.5221 10.8774 15.8347 10.349 16.1422ZM11.7552 12.4655C11.8413 12.6315 11.8206 12.8329 11.7024 12.9778L11.1383 13.6692C11.2823 13.6105 11.4299 13.5532 11.581 13.4978L12.2444 13.2545C12.3836 13.2034 12.5387 13.2212 12.6627 13.3024L13.2539 13.6896C14.4747 14.489 16.0945 15 17.9092 15C22.2298 15 24.9404 12.3026 24.9404 9.84375C24.9404 7.38491 22.2298 4.6875 17.9092 4.6875C13.5886 4.6875 10.8779 7.38491 10.8779 9.84375C10.8779 10.4682 11.0323 11.0734 11.3291 11.6449L11.7552 12.4655Z"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M30.0967 9.375C29.0166 9.375 28.0862 9.59981 27.3249 9.96234C26.658 10.2721 26.0956 10.6904 25.6849 11.1829C25.8113 10.752 25.8779 10.3038 25.8779 9.84375C25.8779 9.45619 25.8306 9.07703 25.7401 8.70953C26.938 7.95212 28.4513 7.5 30.0967 7.5C33.9799 7.5 37.1279 10.0184 37.1279 13.125C37.1279 13.9184 36.9225 14.6735 36.552 15.358C36.4694 15.5108 36.4683 15.6951 36.5442 15.8513C36.6335 16.0352 36.708 16.2272 36.7701 16.4215C36.9393 16.9515 37.0161 17.4993 37.0486 17.9503C37.0775 18.3498 36.5937 18.5592 36.2654 18.3298C35.9653 18.1199 35.5846 17.8827 35.1324 17.658C35.0442 17.6142 34.9532 17.5709 34.8597 17.5282C34.7157 17.4628 34.549 17.4809 34.4148 17.5646C33.2231 18.3075 31.7245 18.75 30.0967 18.75C26.7499 18.75 23.9492 16.8793 23.2393 14.3737C23.9454 13.8876 24.5373 13.3062 24.9803 12.6562C24.9539 12.8097 24.9404 12.9662 24.9404 13.125C24.9404 14.454 25.8911 15.6216 27.3248 16.2877C28.0861 16.6502 29.0166 16.875 30.0967 16.875C32.935 16.875 35.2377 15.2072 35.2529 13.1455C35.2529 13.1387 35.2529 13.1318 35.2529 13.125C35.2529 13.1223 35.2529 13.1197 35.2529 13.1169C35.2491 11.7913 34.2994 10.6271 32.8687 9.96244C32.1074 9.59981 31.1768 9.375 30.0967 9.375Z"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.1875 29.0625C13.7418 29.0625 15 27.8043 15 26.25C15 24.6957 13.7418 23.4375 12.1875 23.4375C10.6332 23.4375 9.375 24.6957 9.375 26.25C9.375 27.8043 10.6332 29.0625 12.1875 29.0625ZM12.1875 30.9375C14.7773 30.9375 16.875 28.8398 16.875 26.25C16.875 23.6602 14.7773 21.5625 12.1875 21.5625C9.59766 21.5625 7.5 23.6602 7.5 26.25C7.5 28.8398 9.59766 30.9375 12.1875 30.9375Z"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.27017 36.3643C4.81455 36.823 4.6875 37.193 4.6875 37.5V38.4375H21.5625V37.5C21.5625 37.193 21.4355 36.823 20.9798 36.3643C20.5071 35.8883 19.7709 35.418 18.8211 35.0029C16.9113 34.1682 14.5889 33.75 13.125 33.75C11.6611 33.75 9.33877 34.1682 7.42892 35.0029C6.47903 35.418 5.7429 35.8883 5.27017 36.3643ZM13.125 31.875C9.68325 31.875 2.8125 33.7594 2.8125 37.5V40.3125H23.4375V37.5C23.4375 33.7594 16.5668 31.875 13.125 31.875Z"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32.8125 29.0625C34.3668 29.0625 35.625 27.8043 35.625 26.25C35.625 24.6957 34.3668 23.4375 32.8125 23.4375C31.2582 23.4375 30 24.6957 30 26.25C30 27.8043 31.2582 29.0625 32.8125 29.0625ZM32.8125 30.9375C35.4023 30.9375 37.5 28.8398 37.5 26.25C37.5 23.6602 35.4023 21.5625 32.8125 21.5625C30.2227 21.5625 28.125 23.6602 28.125 26.25C28.125 28.8398 30.2227 30.9375 32.8125 30.9375Z"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.5 27.1875C23.5363 27.1875 24.375 26.3488 24.375 25.3125C24.375 24.2762 23.5363 23.4375 22.5 23.4375C21.4637 23.4375 20.625 24.2762 20.625 25.3125C20.625 26.3488 21.4637 27.1875 22.5 27.1875ZM22.5 29.0625C24.5719 29.0625 26.25 27.3844 26.25 25.3125C26.25 23.2406 24.5719 21.5625 22.5 21.5625C20.4281 21.5625 18.75 23.2406 18.75 25.3125C18.75 27.3844 20.4281 29.0625 22.5 29.0625Z"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.0202 36.3643C23.5645 36.823 23.4375 37.193 23.4375 37.5V38.4375H40.3125V37.5C40.3125 37.193 40.1855 36.823 39.7298 36.3643C39.2571 35.8883 38.5209 35.418 37.5711 35.0029C35.6613 34.1682 33.3389 33.75 31.875 33.75C30.4111 33.75 28.0887 34.1682 26.1789 35.0029C25.2291 35.418 24.4929 35.8883 24.0202 36.3643ZM31.875 31.875C28.4332 31.875 21.5625 33.7594 21.5625 37.5V40.3125H42.1875V37.5C42.1875 33.7594 35.3168 31.875 31.875 31.875Z"
    }), /* @__PURE__ */ jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.4999 31.875C19.3974 31.875 17.2234 33.3211 16.6003 33.9442L15.2744 32.6183C16.2139 31.679 18.8523 30 22.4999 30C26.1474 30 28.7858 31.679 29.7253 32.6183L28.3994 33.9442C27.7764 33.3211 25.6023 31.875 22.4999 31.875Z"
    })]
  });
};
const WriteArticleIcon = (props) => {
  return /* @__PURE__ */ jsxs("svg", {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx("g", {
      clipPath: "url(#clip0_317_1776)",
      children: /* @__PURE__ */ jsx("path", {
        d: "M30 32H2C0.897 32 0 31.103 0 30V5C0 3.897 0.897 3 2 3H8C9.10457 3 10 2.10457 10 1C10 0.448 10.448 0 11 0C11.552 0 12 0.448 12 1C12 2.10457 12.8954 3 14 3H18C19.1046 3 20 2.10457 20 1C20 0.448 20.448 0 21 0C21.552 0 22 0.448 22 1C22 2.10457 22.8954 3 24 3H30C31.103 3 32 3.897 32 5V30C32 31.103 31.103 32 30 32ZM23 5C22.4477 5 22 5.44772 22 6C22 6.552 21.552 7 21 7C20.448 7 20 6.552 20 6C20 5.44772 19.5523 5 19 5H13C12.4477 5 12 5.44772 12 6C12 6.552 11.552 7 11 7C10.448 7 10 6.552 10 6C10 5.44772 9.55229 5 9 5H6C3.79086 5 2 6.79086 2 9V25C2 27.7614 4.23858 30 7 30H24.9976C27.7588 30 29.9973 27.7618 29.9976 25.0006L29.9995 9.00024C29.9998 6.79105 28.209 5 25.9998 5H23ZM25 24H23C22.448 24 22 23.552 22 23V21C22 20.448 22.448 20 23 20H25C25.552 20 26 20.448 26 21V23C26 23.552 25.552 24 25 24ZM25 16H23C22.448 16 22 15.552 22 15V13C22 12.448 22.448 12 23 12H25C25.552 12 26 12.448 26 13V15C26 15.552 25.552 16 25 16ZM17 24H15C14.448 24 14 23.552 14 23V21C14 20.448 14.448 20 15 20H17C17.552 20 18 20.448 18 21V23C18 23.552 17.552 24 17 24ZM17 16H15C14.448 16 14 15.552 14 15V13C14 12.448 14.448 12 15 12H17C17.552 12 18 12.448 18 13V15C18 15.552 17.552 16 17 16ZM9 24H7C6.448 24 6 23.552 6 23V21C6 20.448 6.448 20 7 20H9C9.552 20 10 20.448 10 21V23C10 23.552 9.552 24 9 24ZM9 16H7C6.448 16 6 15.552 6 15V13C6 12.448 6.448 12 7 12H9C9.552 12 10 12.448 10 13V15C10 15.552 9.552 16 9 16Z"
      })
    }), /* @__PURE__ */ jsx("defs", {
      children: /* @__PURE__ */ jsx("clipPath", {
        id: "clip0_317_1776",
        children: /* @__PURE__ */ jsx("rect", {
          width: "32",
          height: "32",
          rx: "5"
        })
      })
    })]
  });
};
const AnnounceMeetingIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", {
    viewBox: "0 0 31 35",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M7.96875 30H5.15625C3.8625 30 2.8125 28.95 2.8125 27.6562V5.15625C2.8125 3.8625 3.8625 2.8125 5.15625 2.8125H12.1875V11.7187C12.1875 12.4875 12.825 13.125 13.5937 13.125H22.5937C22.7812 13.6687 23.2875 14.0625 23.9062 14.0625C24.675 14.0625 25.3125 13.425 25.3125 12.6562V11.7187C25.3125 11.5312 25.275 11.3437 25.2 11.175C25.125 11.0062 25.0312 10.8562 24.9 10.725L14.5875 0.4125C14.4562 0.28125 14.3062 0.1875 14.1375 0.1125C13.9687 0.0374999 13.7812 0 13.5937 0H5.15625C2.30625 0 0 2.30625 0 5.15625V27.6562C0 30.5062 2.30625 32.8125 5.15625 32.8125H7.96875C8.7375 32.8125 9.375 32.175 9.375 31.4062C9.375 30.6375 8.7375 30 7.96875 30ZM15 4.8L20.5125 10.3125H15V4.8ZM29.7375 16.1625C29.025 15.45 27.975 15.0187 26.8875 15C25.7625 14.9437 24.6938 15.375 23.9813 16.1062L12 28.1062C11.7562 28.35 11.625 28.65 11.5875 28.9875L11.25 33.1687C11.2125 33.5812 11.3625 33.9937 11.6625 34.275C11.925 34.5375 12.2812 34.6875 12.6562 34.6875C12.6937 34.6875 12.7312 34.6875 12.7875 34.6875L17.0062 34.2937C17.325 34.2562 17.6437 34.125 17.8687 33.8812L29.85 21.8812C31.35 20.4 31.2937 17.7187 29.7375 16.1625ZM27.8625 19.8937L16.2375 31.5375L14.1937 31.725L14.3437 29.7375L25.9688 18.0937C26.1562 17.9062 26.4937 17.8312 26.8312 17.8125C27.2062 17.8125 27.5437 17.9437 27.75 18.15C28.2 18.5812 28.2562 19.5 27.8625 19.8937Z"
    })
  });
};
const ImportDocumentIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", {
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M23.325 27.6562H7.03125C6.2625 27.6562 5.625 27.0187 5.625 26.25C5.625 25.4813 6.2625 24.8438 7.03125 24.8438H23.325L20.1 21.6187C19.5563 21.075 19.5563 20.175 20.1 19.6313C20.6438 19.0875 21.5437 19.0875 22.0875 19.6313L27.7125 25.2563C27.8438 25.3875 27.9375 25.5375 28.0125 25.7062C28.1625 26.0438 28.1625 26.4375 28.0125 26.775C27.9375 26.9438 27.8438 27.0938 27.7125 27.225L22.0875 32.85C21.8062 33.1313 21.45 33.2625 21.0938 33.2625C20.7375 33.2625 20.3813 33.1313 20.1 32.85C19.5563 32.3063 19.5563 31.4062 20.1 30.8625L23.325 27.6375V27.6562ZM39.375 17.8125V33.75C39.375 36.6 37.0688 38.9062 34.2188 38.9062H20.1562C17.3062 38.9062 15 36.6 15 33.75V31.875C15 31.1063 15.6375 30.4688 16.4062 30.4688C17.175 30.4688 17.8125 31.1063 17.8125 31.875V33.75C17.8125 35.0438 18.8625 36.0938 20.1562 36.0938H34.2188C35.5125 36.0938 36.5625 35.0438 36.5625 33.75V19.2188H27.6562C26.8875 19.2188 26.25 18.5813 26.25 17.8125V8.90625H20.1562C18.8625 8.90625 17.8125 9.95625 17.8125 11.25V20.625C17.8125 21.3938 17.175 22.0312 16.4062 22.0312C15.6375 22.0312 15 21.3938 15 20.625V11.25C15 8.4 17.3062 6.09375 20.1562 6.09375H27.6562C28.0312 6.09375 28.3875 6.24375 28.65 6.50625L38.9625 16.8188C39.225 17.0813 39.375 17.4375 39.375 17.8125ZM29.0625 16.4062H34.575L29.0625 10.8937V16.4062Z"
    })
  });
};
const RecordAssetIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", {
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M5.24684 40.4379C4.36994 40.4379 3.67809 40.1561 3.1713 39.5924C2.7035 39.072 2.45161 38.3891 2.41563 37.5436L2.41113 37.3289V7.12666C2.41113 6.17002 2.66452 5.41268 3.1713 4.85464C3.63911 4.33952 4.2646 4.06216 5.04776 4.02253L5.24684 4.01758H26.7882C27.6537 4.01758 28.3398 4.2966 28.8466 4.85464C29.3144 5.36975 29.5663 6.05469 29.6023 6.90944L29.6068 7.12666L29.6064 12.4221L39.7709 12.4223C40.5699 12.4223 41.216 12.6625 41.7093 13.1428L41.8295 13.2679C42.2973 13.7883 42.5492 14.4712 42.5852 15.3166L42.5897 15.5313V37.3289C42.5897 38.2741 42.3363 39.0286 41.8295 39.5924C41.3616 40.1127 40.741 40.3929 39.9675 40.4329L39.7709 40.4379H5.24684ZM29.6068 37.3289C29.6068 37.4519 29.6025 37.5716 29.5939 37.6881L38.8655 37.6876C39.1958 37.6876 39.4407 37.6079 39.6002 37.4485C39.7369 37.3118 39.8151 37.1082 39.8346 36.8377L39.8395 36.6968V16.1634C39.8395 15.8217 39.7597 15.5712 39.6002 15.4118C39.4635 15.2751 39.264 15.197 39.0018 15.1775L38.8655 15.1726L29.6064 15.172L29.6068 37.3289ZM25.8828 6.76792H6.15223C5.81058 6.76792 5.56004 6.84764 5.4006 7.00708C5.26394 7.14374 5.18584 7.34734 5.16632 7.61787L5.16144 7.75871V36.6968C5.16144 37.0385 5.24116 37.289 5.4006 37.4485C5.53726 37.5851 5.74086 37.6632 6.01139 37.6828L6.15223 37.6876L10.0635 37.6872L10.0642 32.6482C10.0642 31.9753 10.203 31.4647 10.4807 31.1164L10.5681 31.0168C10.8735 30.7011 11.3272 30.5288 11.9291 30.5001L12.1141 30.4958H19.9038C20.6099 30.4958 21.1281 30.6695 21.4583 31.0168C21.7586 31.3326 21.9223 31.8107 21.9496 32.4512L21.9537 32.6482L21.9532 37.6872L25.8828 37.6876C26.213 37.6876 26.4579 37.6079 26.6173 37.4485C26.754 37.3118 26.8321 37.1082 26.8516 36.8377L26.8565 36.6968V7.75871C26.8565 7.41706 26.7768 7.16652 26.6173 7.00708C26.4579 6.84764 26.213 6.76792 25.8828 6.76792ZM19.1693 32.7336H12.8487C12.5174 32.7336 12.3367 32.8842 12.3065 33.1854L12.302 33.2803L12.3015 37.6872H19.7152L19.7159 33.2803C19.7159 32.949 19.5653 32.7683 19.2642 32.7382L19.1693 32.7336ZM36.0982 31.0424C36.4531 31.0424 36.6453 31.2051 36.6749 31.5305L36.6789 31.6233V34.2882C36.6789 34.6431 36.5163 34.8354 36.1909 34.865L36.0982 34.869H33.348C33.0034 34.869 32.8168 34.7063 32.7881 34.3809L32.7842 34.2882V31.6233C32.7842 31.2683 32.9421 31.0761 33.2579 31.0465L33.348 31.0424H36.0982ZM36.0982 24.5169C36.4531 24.5169 36.6453 24.6795 36.6749 25.0049L36.6789 25.0977V27.7626C36.6789 28.1175 36.5163 28.3098 36.1909 28.3394L36.0982 28.3434H33.348C33.0034 28.3434 32.8168 28.1807 32.7881 27.8553L32.7842 27.7626V25.0977C32.7842 24.7427 32.9421 24.5505 33.2579 24.5209L33.348 24.5169H36.0982ZM13.6686 23.1332C14.0997 23.1332 14.3317 23.3321 14.3649 23.7299L14.369 23.8336V27.0622C14.369 27.4932 14.1701 27.7253 13.7722 27.7584L13.6686 27.7626H10.3375C9.92751 27.7626 9.70675 27.5636 9.67521 27.1658L9.67127 27.0622V23.8336C9.67127 23.4025 9.86049 23.1705 10.2389 23.1373L10.3375 23.1332H13.6686ZM21.6634 23.1332C22.0944 23.1332 22.3264 23.3321 22.3596 23.7299L22.3637 23.8336V27.0622C22.3637 27.4932 22.1648 27.7253 21.767 27.7584L21.6634 27.7626H18.3493C17.9288 27.7626 17.7024 27.5636 17.67 27.1658L17.666 27.0622V23.8336C17.666 23.4025 17.8601 23.1705 18.2482 23.1373L18.3493 23.1332H21.6634ZM36.0982 17.9912C36.4531 17.9912 36.6453 18.1539 36.6749 18.4793L36.6789 18.5721V21.237C36.6789 21.5919 36.5163 21.7842 36.1909 21.8137L36.0982 21.8178H33.348C33.0034 21.8178 32.8168 21.6551 32.7881 21.3297L32.7842 21.237V18.5721C32.7842 18.2171 32.9421 18.0249 33.2579 17.9953L33.348 17.9912H36.0982ZM13.6686 16.3684C14.0997 16.3684 14.3317 16.5673 14.3649 16.9652L14.369 17.0688V20.2974C14.369 20.7284 14.1701 20.9605 13.7722 20.9937L13.6686 20.9978H10.3375C9.92751 20.9978 9.70675 20.7989 9.67521 20.401L9.67127 20.2974V17.0688C9.67127 16.6378 9.86049 16.4057 10.2389 16.3726L10.3375 16.3684H13.6686ZM21.6634 16.3684C22.0944 16.3684 22.3264 16.5673 22.3596 16.9652L22.3637 17.0688V20.2974C22.3637 20.7284 22.1648 20.9605 21.767 20.9937L21.6634 20.9978H18.3493C17.9288 20.9978 17.7024 20.7989 17.67 20.401L17.666 20.2974V17.0688C17.666 16.6378 17.8601 16.4057 18.2482 16.3726L18.3493 16.3684H21.6634ZM13.6686 9.60363C14.0997 9.60363 14.3317 9.80256 14.3649 10.2004L14.369 10.304V13.5327C14.369 13.9637 14.1701 14.1958 13.7722 14.2289L13.6686 14.2331H10.3375C9.92751 14.2331 9.70675 14.0341 9.67521 13.6363L9.67127 13.5327V10.304C9.67127 9.87302 9.86049 9.64093 10.2389 9.60777L10.3375 9.60363H13.6686ZM21.6634 9.60363C22.0944 9.60363 22.3264 9.80256 22.3596 10.2004L22.3637 10.304V13.5327C22.3637 13.9637 22.1648 14.1958 21.767 14.2289L21.6634 14.2331H18.3493C17.9288 14.2331 17.7024 14.0341 17.67 13.6363L17.666 13.5327V10.304C17.666 9.87302 17.8601 9.64093 18.2482 9.60777L18.3493 9.60363H21.6634Z"
    })
  });
};
const StartDiscussionButton = (props) => {
  const createPost = useCreatePostFn();
  const onClick = () => {
    createPost("discussion");
  };
  return /* @__PURE__ */ jsx(BigStyledButton, {
    onClick,
    text: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.actions.startDiscussion"
    }),
    icon: StartDiscussionIcon,
    ...props
  });
};
const WriteArticleButton = (props) => {
  const createPost = useCreatePostFn();
  const onClick = () => {
    createPost("article");
  };
  return /* @__PURE__ */ jsx(BigStyledButton, {
    onClick,
    text: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.actions.writeArticle"
    }),
    icon: AnnounceMeetingIcon,
    ...props
  });
};
const ImportDocumentButton = (props) => {
  const {
    id
  } = useCircleContext();
  const history = useHistory();
  useCircleApiContext();
  const onClick = () => {
    history.push(`/trans/pdf-import/${id}`);
  };
  return /* @__PURE__ */ jsx(BigStyledButton, {
    onClick,
    text: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.actions.import"
    }),
    icon: ImportDocumentIcon,
    ...props
  });
};
const RecordAssetButton = (props) => {
  const history = useHistory();
  const createPost = useCreatePostFn();
  const onClick = async () => {
    const draft = await createPost("asset");
    history.push(editPostUrl2(draft));
  };
  return /* @__PURE__ */ jsx(BigStyledButton, {
    onClick,
    text: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.actions.record"
    }),
    icon: RecordAssetIcon,
    ...props
  });
};
const AnnounceEventButton = (props) => {
  const history = useHistory();
  const createPost = useCreatePostFn2();
  const onClick = async () => {
    const draft = await createPost("event");
    history.push(editPostUrl2(draft));
  };
  return /* @__PURE__ */ jsx(BigStyledButton, {
    onClick,
    text: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.actions.announceEvent"
    }),
    icon: WriteArticleIcon,
    ...props
  });
};
const useCreatePostButtonsDescription = () => {
  return useCreation(() => {
    return [{
      title: "group.actions.startDiscussion",
      component: StartDiscussionButton,
      id: "startDiscussion"
    }, {
      title: "group.actions.announceEvent",
      component: AnnounceEventButton,
      id: "announce"
    }, {
      title: "group.actions.writeArticle",
      component: WriteArticleButton,
      id: "writeArticle"
    }, {
      title: "group.actions.import",
      component: ImportDocumentButton,
      id: "import"
    }, {
      title: "group.actions.record",
      component: RecordAssetButton,
      id: "record"
    }, {
      title: "group.actions.createInterview",
      component: CreateInterviewButton,
      id: "interview"
    }].filter((v) => v);
  }, []);
};
const CreateButtons = () => {
  const buttons = useCreatePostButtonsDescription();
  const {
    circle
  } = useCircleContext();
  const defaultPostType = circle && circle.defaultPostType;
  const isDefault = (button) => {
    if (!button) {
      return false;
    }
    const {
      id
    } = button;
    return defaultPostType === id;
  };
  const render = (button) => {
    if (!button) {
      return null;
    }
    const {
      component: Component,
      id
    } = button;
    return /* @__PURE__ */ jsx(Component, {}, id);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [render(buttons.find(isDefault)), buttons.filter((b) => !isDefault(b)).map(render)]
  });
};
const ACTIVITIES_ON_PAGE = 3;
const RightSection = () => {
  return /* @__PURE__ */ jsxs("div", {
    className: " bg-white p-0 hidden lg:block",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "create-post-container",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col justify-start items-center relative gap-px",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-xl font-semibold text-left text-black",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "group.createPost"
          })
        }), /* @__PURE__ */ jsx("svg", {
          width: "368",
          height: "4",
          viewBox: "0 0 368 4",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "none",
          className: "w-full",
          children: /* @__PURE__ */ jsx("path", {
            d: "M0 2H368",
            stroke: "black",
            strokeWidth: "4"
          })
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col mt-2 gap-1",
        children: /* @__PURE__ */ jsx(CreateButtons, {})
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "hidden lg:flex flex-col gap-2 items-stretch",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col justify-start items-center relative gap-px",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-xl font-semibold text-left text-black",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "group.recentActivities"
          })
        }), /* @__PURE__ */ jsx("svg", {
          width: "369",
          height: "4",
          viewBox: "0 0 369 4",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "none",
          className: "w-full",
          children: /* @__PURE__ */ jsx("path", {
            d: "M0.5 2H368.5",
            stroke: "black",
            strokeWidth: "4"
          })
        })]
      }), /* @__PURE__ */ jsx(Activities, {})]
    })]
  });
};
const Activities = () => {
  const {
    id,
    circle
  } = useCircleContext();
  const circleId = id;
  const {
    data: postsData
  } = useCirclePostsActivity(id);
  const {
    data: votesData
  } = useCircleVotesActivity(id);
  const [more, setMore] = useState(true);
  const votes = useCreation(() => {
    if (!votesData) {
      return [];
    }
    return votesData.history.filter((a) => a.circle === circleId).map((v) => {
      return {
        type: "vote",
        modified: v.poll.date,
        data: v
      };
    });
  }, [votesData, circleId]);
  const posts = useCreation(() => {
    if (!postsData) {
      return [];
    }
    const filtered2 = postsData.history.filter((a) => a.circle === circleId).map((v) => {
      return {
        type: "post",
        modified: v.modified,
        data: v
      };
    });
    return filtered2;
  }, [postsData, circleId]);
  const all = [...votes, ...posts].sort(compareByModificationTime);
  const {
    currentFilterRef,
    filter$
  } = useSearchContext();
  const update = useUpdate();
  filter$.useSubscription(update);
  const filter = currentFilterRef.current ? currentFilterRef.current.toLocaleLowerCase() : "";
  const searched = !filter ? all : all.filter((v) => {
    let title = "";
    switch (v.type) {
      case "post": {
        const activity = v.data;
        title = activity.post.title;
        break;
      }
      default: {
        const activity = v.data;
        title = activity.post.title;
        break;
      }
    }
    if (!title) {
      return false;
    }
    title = title.toLocaleLowerCase();
    return title.indexOf(filter) !== -1;
  });
  const filtered = more ? searched.slice(0, ACTIVITIES_ON_PAGE) : searched;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(ActivitiesWrapper, {
      className: "flex flex-col gap-2",
      children: /* @__PURE__ */ jsx(CardThemeProvider, {
        cardImage: false,
        startNewTheme: true,
        children: filtered.map((a) => {
          if (a.type === "post") {
            return /* @__PURE__ */ jsx(PostActivityCard$1, {
              data: a.data
            }, a.data._id);
          }
          return /* @__PURE__ */ jsx(VoteActivityCard$1, {
            data: a.data
          }, a.data._id);
        })
      })
    }), more && searched.length > ACTIVITIES_ON_PAGE && /* @__PURE__ */ jsx("div", {
      className: "flex justify-center items-center",
      children: /* @__PURE__ */ jsx("button", {
        className: "p-1 rounded-[10px] bg-blue-500",
        onClick: () => setMore(false),
        children: /* @__PURE__ */ jsx("p", {
          className: "text-sm text-white",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "dashboard.showMore"
          })
        })
      })
    })]
  });
};
const ActivitiesWrapper = styled.div`
  & .MuiLink-root {
    text-decoration: none;
    font-size: 14px;
  }

`;

const withRetry = async (request, options = {}) => {
  const {
    maxRetries = 3,
    baseDelay = 1e3,
    isCancelled,
    onRetry,
    onSuccess,
    onFinalFailure
  } = options;
  let lastError;
  let attempt = 0;
  while (attempt <= maxRetries) {
    try {
      const result = await request();
      if (onSuccess && attempt > 0) {
        onSuccess(result, attempt + 1);
      }
      return result;
    } catch (error) {
      lastError = error;
      attempt++;
      if (!isRetryableApiError(error)) {
        if (onFinalFailure) {
          onFinalFailure(error, attempt);
        }
        throw error;
      }
      if (isCancelled && isCancelled()) {
        if (onFinalFailure) {
          onFinalFailure(error, attempt);
        }
        throw error;
      }
      if (attempt > maxRetries) {
        if (onFinalFailure) {
          onFinalFailure(error, attempt);
        }
        throw error;
      }
      const delay = getRetryDelay(attempt, baseDelay);
      if (onRetry) {
        onRetry(attempt, error);
      }
      await new Promise((resolve) => setTimeout(resolve, delay));
    }
  }
  throw lastError;
};

const useExecutePrompt = (posId) => {
  const {
    id
  } = useCircleContext();
  const api = useApi();
  const {
    isLoading,
    execute
  } = useAsyncOperation(async () => {
    const {
      finished,
      error
    } = await withRetry(() => api.get({
      path: "/ai/group/execute-prompt?circle=" + id + "&post=" + posId
    }));
    if (error) {
      errorToast({
        error
      });
      return;
    }
    if (finished) {
      toast("Prompt was executed!!");
    } else {
      toast("Long running task, wait until execution is finished!");
    }
  });
  return {
    onClick: () => execute(),
    loading: isLoading
  };
};

const dialogVariants = cva("relative bg-white rounded-lg shadow-xl flex flex-col", {
  variants: {
    size: {
      sm: "max-w-md w-full max-h-[85vh]",
      md: "max-w-2xl w-full max-h-[85vh]",
      lg: "max-w-4xl w-full max-h-[85vh]",
      xl: "max-w-6xl w-full max-h-[85vh]",
      full: "w-[calc(100vw-4rem)] h-[calc(100vh-4rem)]"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const Dialog$3 = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size,
  closeOnBackdropClick = true,
  showCloseButton = true,
  placement = "center"
}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  const handleBackdropClick = useMemoizedFn(() => {
    if (closeOnBackdropClick) {
      onClose();
    }
  });
  const handleDialogClick = useMemoizedFn((e) => {
    e.stopPropagation();
  });
  useEffect(() => {
    if (!isOpen)
      return;
    const handleEsc = (e) => {
      if (e.key === "Escape")
        onClose();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);
  if (!isOpen || !mounted)
    return null;
  const isBottom = placement === "bottom";
  return createPortal(/* @__PURE__ */ jsxs("div", {
    className: isBottom ? "fixed inset-0 z-[9999] flex items-end" : "fixed inset-0 z-[9999] flex items-center justify-center p-4",
    onClick: handleBackdropClick,
    children: [/* @__PURE__ */ jsx("div", {
      className: "absolute inset-0 bg-black/30 backdrop-blur-sm"
    }), /* @__PURE__ */ jsxs("div", {
      className: isBottom ? "relative w-full max-h-[85vh] flex flex-col" : dialogVariants({
        size
      }),
      onClick: handleDialogClick,
      children: [!isBottom && (title || showCloseButton) && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between px-6 py-4 border-b",
        children: [title && /* @__PURE__ */ jsx("h2", {
          className: "text-xl font-semibold text-gray-900",
          children: title
        }), showCloseButton && /* @__PURE__ */ jsx("button", {
          onClick: onClose,
          className: "p-1 text-gray-400 hover:text-gray-600 rounded transition-colors",
          "aria-label": "Close dialog",
          children: /* @__PURE__ */ jsx(MdClose, {
            className: "w-6 h-6"
          })
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: isBottom ? "cair-dialog__content flex-1 min-h-0 flex flex-col" : "cair-dialog__content flex-1 min-h-0 overflow-auto",
        children
      }), !isBottom && footer && /* @__PURE__ */ jsx("div", {
        className: "px-6 py-4 border-t bg-gray-50",
        children: footer
      })]
    })]
  }), document.body);
};

const checkboxVariants = cva("border rounded transition-colors focus:ring-2", {
  variants: {
    variant: {
      default: "text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500",
      error: "text-red-600 bg-red-50 border-red-300 focus:ring-red-500",
      success: "text-green-600 bg-green-50 border-green-300 focus:ring-green-500"
    },
    size: {
      sm: "w-3 h-3",
      md: "w-4 h-4",
      lg: "w-5 h-5"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
});
const Checkbox = forwardRef(({
  className,
  variant,
  size,
  label,
  helperText,
  ...props
}, ref) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsxs("label", {
      className: "flex items-center gap-2 cursor-pointer",
      children: [/* @__PURE__ */ jsx("input", {
        ref,
        type: "checkbox",
        className: checkboxVariants({
          variant,
          size,
          className
        }),
        ...props
      }), label && /* @__PURE__ */ jsx("span", {
        className: "text-sm font-medium text-gray-700",
        children: label
      })]
    }), helperText && /* @__PURE__ */ jsx("span", {
      className: "text-xs text-gray-500 ml-6",
      children: helperText
    })]
  });
});
Checkbox.displayName = "Checkbox";

const documentTypeOptions = ["Book", "Article", "Poem", "Letter", "Photo", "Video", "Audio"];
const metadataFields = [{
  name: "Title / Headline",
  shortName: "title",
  labelId: "meta.field.title.label",
  descriptionId: "meta.field.title.desc",
  description: "Entered by Admin or author. If empty, auto-filled by the heading 1 text or the first line of the document.",
  type: "string"
}, {
  name: "Author / Byline",
  shortName: "author",
  labelId: "meta.field.author.label",
  descriptionId: "meta.field.author.desc",
  description: "The name of the author or source. Entered by Admin or author, initially auto-filled by the author's name from the publishing system or document.",
  type: "string"
}, {
  name: "Author Photo",
  shortName: "authorAvatar",
  labelId: "meta.field.authorAvatar.label",
  descriptionId: "meta.field.authorAvatar.desc",
  description: "Photo of the author. Upload an image to display alongside the author's name.",
  type: "attachment",
  attachmentConfig: {
    accept: [".jpeg", ".png", ".gif"],
    maxSizeMB: 5,
    previewSize: 120,
    showPreview: true
  }
}, {
  name: "Date of Publication",
  shortName: "publicationDate",
  labelId: "meta.field.publicationDate.label",
  descriptionId: "meta.field.publicationDate.desc",
  description: "The date the item was originally published. Entered by Admin or author.",
  type: "Date"
}, {
  name: "Summary / Abstract",
  shortName: "summary",
  labelId: "meta.field.summary.label",
  descriptionId: "meta.field.summary.desc",
  description: "A short summary of the content. Can be manually created or generated using an AI/LLM. If empty, auto-filled from the first paragraph after the title.",
  type: "string"
}, {
  name: "Date of Creation",
  shortName: "creationDate",
  labelId: "meta.field.creationDate.label",
  descriptionId: "meta.field.creationDate.desc",
  description: "The system-generated date when the post or document was created.",
  type: "Date"
}, {
  name: "Tags",
  shortName: "tags",
  labelId: "meta.field.tags.label",
  descriptionId: "meta.field.tags.desc",
  description: "A set of tags or keywords describing the content. Can be completed semi-manually using controlled vocabulary lists. Currently, up to 8 tags for articles and unlimited for assets.",
  type: "string[]"
}, {
  name: "Document Type",
  shortName: "documentType",
  labelId: "meta.field.documentType.label",
  descriptionId: "meta.field.documentType.desc",
  description: "The curator selects this field from predefined options (e.g., Book, Article, Poem, Letter, Photo, Video, Audio).",
  type: "enum",
  options: documentTypeOptions
}, {
  name: "Source Institution/Publisher",
  shortName: "sourceInstitution",
  labelId: "meta.field.sourceInstitution.label",
  descriptionId: "meta.field.sourceInstitution.desc",
  description: "Manually recorded or system-logged information about the source institution or publisher.",
  type: "string"
}, {
  name: "Rights / License",
  shortName: "rights",
  labelId: "meta.field.rights.label",
  descriptionId: "meta.field.rights.desc",
  description: "Determined by the project or legal team. If copyrighted, include a link to the publisher's website.",
  type: "string"
}, {
  name: "Original File Reference",
  shortName: "originalFile",
  description: "Imported file name",
  type: "string"
}];

const interviewFields = [
  {
    name: "Narrator Name",
    shortName: "narratorName",
    labelId: "meta.field.narratorName.label",
    descriptionId: "meta.field.narratorName.desc",
    description: "Full name of the narrator / interviewee.",
    type: "string",
    tab: "interview"
  },
  {
    name: "Narrator Image",
    shortName: "narratorImage",
    labelId: "meta.field.narratorImage.label",
    descriptionId: "meta.field.narratorImage.desc",
    description: "Portrait photo shown in the narrator bio header.",
    type: "attachment",
    tab: "interview",
    attachmentConfig: {
      accept: [".jpeg", ".jpg", ".png", ".webp"],
      maxSizeMB: 10,
      previewSize: 96,
      showPreview: true
    }
  },
  {
    name: "Birth Year",
    shortName: "birthYear",
    labelId: "meta.field.birthYear.label",
    descriptionId: "meta.field.birthYear.desc",
    description: "Year the narrator was born.",
    type: "number",
    tab: "interview"
  },
  {
    name: "Birthplace",
    shortName: "birthPlace",
    labelId: "meta.field.birthPlace.label",
    descriptionId: "meta.field.birthPlace.desc",
    description: "City or village where the narrator was born.",
    type: "string",
    tab: "interview"
  },
  {
    name: "Original Town / District",
    shortName: "originalTownDistrict",
    labelId: "meta.field.originalTownDistrict.label",
    descriptionId: "meta.field.originalTownDistrict.desc",
    description: "The narrator's town or district of origin.",
    type: "string",
    tab: "interview"
  },
  {
    name: "Recording Place",
    shortName: "recordingPlace",
    labelId: "meta.field.recordingPlace.label",
    descriptionId: "meta.field.recordingPlace.desc",
    description: "Location where the interview was recorded.",
    type: "string",
    tab: "interview"
  },
  {
    name: "Recording Date",
    shortName: "recordingDate",
    labelId: "meta.field.recordingDate.label",
    descriptionId: "meta.field.recordingDate.desc",
    description: "Date the interview was recorded. Stored as YYYY-MM-DD.",
    type: "Date",
    tab: "interview"
  },
  {
    name: "Address / Location",
    shortName: "addressLocation",
    labelId: "meta.field.addressLocation.label",
    descriptionId: "meta.field.addressLocation.desc",
    description: "Current address or location of the narrator.",
    type: "string",
    tab: "interview"
  },
  {
    name: "Recording Duration (minutes)",
    shortName: "recordingDurationMinutes",
    labelId: "meta.field.recordingDurationMinutes.label",
    descriptionId: "meta.field.recordingDurationMinutes.desc",
    description: "Total length of the recording in minutes.",
    type: "number",
    tab: "interview"
  },
  {
    name: "Field Researcher",
    shortName: "fieldResearcher",
    labelId: "meta.field.fieldResearcher.label",
    descriptionId: "meta.field.fieldResearcher.desc",
    description: "Name of the researcher who conducted the interview.",
    type: "string",
    tab: "interview"
  },
  {
    name: "Supervising Organization",
    shortName: "supervisingOrganization",
    labelId: "meta.field.supervisingOrganization.label",
    descriptionId: "meta.field.supervisingOrganization.desc",
    description: "Organization that supervised or commissioned the research.",
    type: "string",
    tab: "interview"
  },
  {
    name: "Supervising Researcher",
    shortName: "supervisingResearcher",
    labelId: "meta.field.supervisingResearcher.label",
    descriptionId: "meta.field.supervisingResearcher.desc",
    description: "Name of the researcher who supervised the field work.",
    type: "string",
    tab: "interview"
  }
];

const DEFAULT_VISIBLE_METADATA_FIELDS = [];
const STORAGE_KEY = "metadata:visible-fields";
const useVisibleMetadataFields = () => useLocalStorageState$1(STORAGE_KEY, {
  defaultValue: DEFAULT_VISIBLE_METADATA_FIELDS
});

const ConfigureMetadataFieldsDialog = ({
  onClose
}) => {
  const [visible, setVisible] = useVisibleMetadataFields();
  const toggle = (field) => {
    const list = visible || [];
    const next = list.includes(field.shortName) ? list.filter((name) => name !== field.shortName) : [...list, field.shortName];
    setVisible(next);
  };
  const renderSection = (title, fields) => /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-1 mb-4",
    children: [/* @__PURE__ */ jsx("h3", {
      className: "text-sm font-semibold text-gray-700",
      children: title
    }), fields.map((field) => /* @__PURE__ */ jsx(Checkbox, {
      checked: (visible || []).includes(field.shortName),
      onChange: () => toggle(field),
      label: field.name
    }, field.shortName))]
  });
  return /* @__PURE__ */ jsx(Dialog$3, {
    isOpen: true,
    onClose,
    title: "Configure Visible Fields",
    size: "sm",
    footer: /* @__PURE__ */ jsx(ActionButton, {
      onClick: onClose,
      children: "Done"
    }),
    children: /* @__PURE__ */ jsxs("div", {
      className: "p-4",
      children: [/* @__PURE__ */ jsxs("p", {
        className: "text-sm text-gray-500 mb-4",
        children: ["Choose which metadata fields you want to see on posts. This only affects your own view \u2014 ", (visible || []).length, " selected."]
      }), renderSection("General metadata", metadataFields), renderSection("Interview metadata", interviewFields)]
    })
  });
};

const useIsDeveloper = () => {
  const isInstanceAdmin = useIsInstanceAdmin();
  const { profile } = useProfileContext();
  const email = profile && profile.email;
  if (!isInstanceAdmin) {
    return false;
  }
  return Boolean(email && email.includes("@newssocial.co.uk"));
};

const useGroupIsClosed = () => {
  const {
    circle
  } = useCircleContext();
  return circle && circle.closed;
};
const useIsCircleAdmin = () => {
  const {
    membership
  } = useCircleContext();
  return membership && membership.role === "ADMIN";
};
const ReopenCircleMenuItem = () => {
  const closed = useGroupIsClosed();
  const {
    refresh,
    circle
  } = useCircleContext();
  const isCircleAdmin = useIsCircleAdmin();
  const api = useApi();
  if (!closed) {
    return null;
  }
  if (!isCircleAdmin) {
    return null;
  }
  const reopenGroup = errorsReported(async () => {
    await api.reOpenGroup({
      group: circle._id
    });
    await refresh();
  });
  const key = `group.reopen`;
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: reopenGroup,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: key
    })
  });
};
const EditCircleMenuItem = () => {
  const closed = useGroupIsClosed();
  const {
    circle
  } = useCircleContext();
  const isCircleAdmin = useIsCircleAdmin();
  const history = useHistory();
  if (closed) {
    return null;
  }
  if (!isCircleAdmin) {
    return null;
  }
  const openEditCircle = async () => {
    history.push(`/groups/${circle._id}/_edit`);
  };
  const key = `group.edit_group`;
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: openEditCircle,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: key
    })
  });
};
const MakeCircleMorePrivateMenuItem = ({
  setChangeAccess
}) => {
  const closed = useGroupIsClosed();
  const {
    circle
  } = useCircleContext();
  const isCircleAdmin = useIsCircleAdmin();
  if (closed) {
    return null;
  }
  if (!isCircleAdmin) {
    return null;
  }
  if (circle.privacy === "PRIVATE") {
    return null;
  }
  const key = `group.make_more_private`;
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: () => setChangeAccess(true),
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: key
    })
  });
};
const useInviteNewMembersFn = () => {
  const closed = useGroupIsClosed();
  const {
    circle,
    membership
  } = useCircleContext();
  const isCircleAdmin = useIsCircleAdmin();
  const history = useHistory();
  if (closed || !circle || !membership) {
    return null;
  }
  if (!isCircleAdmin && circle.privacy === "PRIVATE") {
    return null;
  }
  return () => {
    history.push(`/groups/${circle._id}/membership/invites/_create`);
  };
};
const InviteNewMembersMenuItem = () => {
  const onClick = useInviteNewMembersFn();
  if (!onClick) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.invite"
    })
  });
};
const CreateSubgroupMenuItem = () => {
  const closed = useGroupIsClosed();
  const {
    createSubCircle
  } = useCircleApiContext();
  const isCircleAdmin = useIsCircleAdmin();
  if (closed) {
    return null;
  }
  if (!isCircleAdmin) {
    return null;
  }
  const onClick = () => {
    createSubCircle();
  };
  const key = `group.new_sub_group`;
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: key
    })
  });
};
const LeaveCircleMenuItem = () => {
  const closed = useGroupIsClosed();
  const {
    refresh,
    membership,
    circle
  } = useCircleContext();
  const isCircleAdmin = useIsCircleAdmin();
  const api = useApi();
  if (closed || !membership) {
    return null;
  }
  if (isCircleAdmin) {
    return null;
  }
  const onClick = errorsReported(async () => {
    await api.leaveGroup(circle);
    refresh();
  });
  const key = `group.leave`;
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: key
    })
  });
};
const JoinCircleMenuItem = () => {
  const closed = useGroupIsClosed();
  const {
    refresh,
    membership,
    circle,
    setRequestAccess
  } = useCircleContext();
  const api = useApi();
  if (closed || membership) {
    return null;
  }
  let name;
  let action;
  if (circle.privacy !== "PRIVATE") {
    name = "join";
    action = errorsReported(async () => {
      await api.joinGroup(circle);
      refresh();
    });
  } else {
    name = "request_access_to_circle";
    action = () => {
      setRequestAccess(true);
    };
  }
  const onClick = () => {
    action();
  };
  const key = `group.${name}`;
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: key
    })
  });
};
const ConfigureCircleMapMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/configure-circle-map/" + id,
    target: "_blank",
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Configure circle map"
    })
  });
};
const ConfigureCircleMapClusteringMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/map-clustering-config/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Configure clustering (circle map)"
    })
  });
};
const OperationsCircleMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/combine-posts/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Posts operations"
    })
  });
};
const EnableCircleMenuItem = () => {
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    circle,
    refresh
  } = useCircleContext();
  const api = useApi();
  if (!isInstanceAdmin || !circle) {
    return null;
  }
  const {
    aiEnabled
  } = circle;
  const onClick = async () => {
    await api.post({
      path: `/groups/${circle._id}/_partial`,
      body: {
        aiEnabled: !aiEnabled
      }
    });
    refresh();
  };
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: aiEnabled ? /* @__PURE__ */ jsx(FormattedMessage, {
      id: "ai.disable"
    }) : /* @__PURE__ */ jsx(FormattedMessage, {
      id: "ai.enable"
    })
  });
};
const ConfigureCircleMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/circle-config-ui/" + id,
    target: "_blank",
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Configure circle UI"
    })
  });
};
const VectorSearchMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/admin/vector-search-index/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Configure Circle AI search"
    })
  });
};
const ExecuteMigrationMenuItem = () => {
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    id
  } = useCircleContext();
  if (!isInstanceAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/admin/execute-migrations/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Execute Migration"
    })
  });
};
const CircleDeveloperDashboardMenuItem = () => {
  const isDeveloper = useIsDeveloper();
  const {
    id
  } = useCircleContext();
  if (!isDeveloper) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/admin/circle-dev-dashboard/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Developer Dashboard"
    })
  });
};
const FiltersMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/admin/configure-filters/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Configure Circle Filters"
    })
  });
};
const ReindexElasticMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/admin/circle-search/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Reindex for Circle Text Search"
    })
  });
};
const ImportDocumentMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/playground/lib/circles/ocr/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Import images for OCR"
    })
  });
};
const ShowPromptExecutionMenuItem = () => {
  const {
    showPromptExecution,
    setShowPromptExecution
  } = useCircleModalDialogsContext();
  const isCircleAdmin = useIsCircleAdmin();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: () => setShowPromptExecution(!showPromptExecution),
    children: showPromptExecution ? "Hide prompts execution" : "Show prompts execution"
  });
};
const ConfigureCircleTranslateMenuItem = () => {
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    id
  } = useCircleContext();
  if (!isInstanceAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/circle-config-translation/" + id,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Configure circle translation"
    })
  });
};
const ConfigureHarvestingMenuItem = ({
  setOpen
}) => {
  const {
    id
  } = useCircleContext();
  const isCircleAdmin = useIsCircleAdmin();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("a", {
      href: "/trans/configure-harvesting/" + id,
      target: "_blank",
      children: /* @__PURE__ */ jsx(MenuItem, {
        children: "Configure harvesting"
      })
    }), /* @__PURE__ */ jsx("a", {
      href: "/trans/configure-wair-harvesting/" + id,
      target: "_blank",
      children: /* @__PURE__ */ jsx(MenuItem, {
        children: "Configure harvesting (WAIR)"
      })
    })]
  });
};
const ConfigureTabsMenuItem = ({
  setOpen
}) => {
  const isCircleAdmin = useIsCircleAdmin();
  if (!isCircleAdmin) {
    return null;
  }
  const onClick = () => {
    setOpen(true);
  };
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: "Configure circle tabs"
  });
};
const ConfigureMetadataFieldsMenuItem = ({
  setOpen
}) => {
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: () => setOpen(true),
    children: "Configure visible fields"
  });
};
const useCanExecutePrompt = () => {
  const {
    profile
  } = useProfileContext();
  const isCircleAdmin = useIsCircleAdmin();
  const {
    circle
  } = useCircleContext();
  return profile && profile.role === "ADMIN" || isCircleAdmin && circle && circle.aiEnabled;
};
const useTestPrompt = (posId) => {
  const {
    id,
    setTestPromptDialogOpen
  } = useCircleContext();
  const api = useApi();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    const result = await api.get({
      path: "/ai/group/test-prompt?circle=" + id + "&post=" + posId
    });
    console.log("test prompt!!!!!!", result);
    setTestPromptDialogOpen(result);
  });
  return {
    onClick,
    loading
  };
};
const TestPromptMenuItem = ({
  post
}) => {
  const {
    onClick
  } = useTestPrompt(post && post._id);
  const canExecutePrompt = useCanExecutePrompt();
  if (!canExecutePrompt) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: "Test Prompt"
  });
};
const ExecutePromptMenuItem = ({
  post
}) => {
  const {
    onClick
  } = useExecutePrompt(post && post._id);
  const canExecutePrompt = useCanExecutePrompt();
  if (!canExecutePrompt) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: "Execute Prompt"
  });
};
const ChangeDefaultPostTypeMenuItem = ({
  setOpen
}) => {
  const isCircleAdmin = useIsCircleAdmin();
  if (!isCircleAdmin) {
    return null;
  }
  const onClick = () => {
    setOpen(true);
  };
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: "Change default post type"
  });
};
const TTSMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: `/trans/tts/${id}`,
    target: "_blank",
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Text to Speech (TTS)"
    })
  });
};
const TTSConverterMenuItem = () => {
  const isCircleAdmin = useIsCircleAdmin();
  const {
    id
  } = useCircleContext();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: `/trans/tts-converter/${id}`,
    target: "_blank",
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Convert to TTS"
    })
  });
};
const DigestMenuItem = () => {
  const closed = useGroupIsClosed();
  const {
    refresh,
    membership,
    circle
  } = useCircleContext();
  const api = useApi();
  if (closed || !membership) {
    return null;
  }
  const setEndUserDigestFrequencyNever = async () => {
    await api.updateEndUserDigestFrequency({
      group: circle._id,
      frequency: "NEVER"
    });
  };
  const setEndUserDigestFrequencyDaily = async () => {
    await api.updateEndUserDigestFrequency({
      group: circle._id,
      frequency: "DAILY"
    });
  };
  const mail_prefs = membership.mail_prefs;
  let action;
  let name;
  if (mail_prefs) {
    if (mail_prefs.content_digest_frequency === "DAILY") {
      name = "disable_content_digest";
      action = setEndUserDigestFrequencyNever;
    } else {
      name = "enable_content_digest";
      action = setEndUserDigestFrequencyDaily;
    }
  } else {
    name = "enable_content_digest";
    action = setEndUserDigestFrequencyDaily;
  }
  const onClick = errorsReported(async () => {
    await action();
    refresh();
  });
  const key = `group.${name}`;
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: key
    })
  });
};
const NotifyMenuItem = () => {
  const closed = useGroupIsClosed();
  const {
    refresh,
    membership,
    circle
  } = useCircleContext();
  const api = useApi();
  if (closed || !membership) {
    return null;
  }
  const setNotify = async (notify2 = true) => {
    await api.post({
      path: `/groups/${circle._id}/_push_notifications`,
      body: {
        notify: notify2
      }
    });
  };
  const mail_prefs = membership.mail_prefs;
  const notify = !mail_prefs.notifications_off;
  const onNotify = errorsReported(async () => {
    await setNotify(!notify);
    refresh();
  });
  const key = `group.notify_${notify ? "off" : "on"}`;
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: onNotify,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: key
    })
  });
};
const CircleMenu = ({
  button
}) => {
  const [making_more_private, setChangeAccess] = useState(false);
  const [configureTabs, setConfigureTabs] = useState(false);
  const [defaultPostTypeDialog, setDefaultPostTypeDialog] = useState(false);
  const [configureMetadataFields, setConfigureMetadataFields] = useState(false);
  const circleClosed = useGroupIsClosed();
  const isCircleAdmin = useIsCircleAdmin();
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    circle,
    refresh,
    membership
  } = useCircleContext();
  const api = useApi();
  const closePrivacyDialog = () => {
    setChangeAccess(false);
  };
  const makeMorePrivate = async () => {
    await api.increasePrivacy({
      group: circle._id
    });
    refresh();
    closePrivacyDialog();
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(OverflowMenu, {
      button,
      hidden: !membership || circleClosed && !isCircleAdmin && !isInstanceAdmin,
      contentComponent: ({
        onClick
      }) => /* @__PURE__ */ jsxs("div", {
        onClick,
        children: [/* @__PURE__ */ jsx(DeleteCircleMenuItem, {}), /* @__PURE__ */ jsx(ChangeCirclePrivacyMenuItem, {}), /* @__PURE__ */ jsx(ReopenCircleMenuItem, {}), /* @__PURE__ */ jsx(EditCircleMenuItem, {}), /* @__PURE__ */ jsx(MakeCircleMorePrivateMenuItem, {
          setChangeAccess
        }), /* @__PURE__ */ jsx(InviteNewMembersMenuItem, {}), /* @__PURE__ */ jsx(CreateSubgroupMenuItem, {}), /* @__PURE__ */ jsx(LeaveCircleMenuItem, {}), /* @__PURE__ */ jsx(DigestMenuItem, {}), /* @__PURE__ */ jsx(NotifyMenuItem, {}), /* @__PURE__ */ jsx(JoinCircleMenuItem, {}), /* @__PURE__ */ jsx(ChangeDefaultPostTypeMenuItem, {
          setOpen: setDefaultPostTypeDialog
        }), /* @__PURE__ */ jsx(ConfigureTabsMenuItem, {
          setOpen: setConfigureTabs
        }), /* @__PURE__ */ jsx(ConfigureMetadataFieldsMenuItem, {
          setOpen: setConfigureMetadataFields
        }), /* @__PURE__ */ jsx(ConfigureHarvestingMenuItem, {}), /* @__PURE__ */ jsx(ConfigureCircleMapMenuItem, {}), /* @__PURE__ */ jsx(ConfigureCircleMapClusteringMenuItem, {}), /* @__PURE__ */ jsx(ConfigureCircleMenuItem, {}), /* @__PURE__ */ jsx(ConfigureCircleTranslateMenuItem, {}), /* @__PURE__ */ jsx(VectorSearchMenuItem, {}), /* @__PURE__ */ jsx(ImportDocumentMenuItem, {}), /* @__PURE__ */ jsx(ShowPromptExecutionMenuItem, {}), /* @__PURE__ */ jsx(OperationsCircleMenuItem, {}), /* @__PURE__ */ jsx(EnableCircleMenuItem, {}), /* @__PURE__ */ jsx(TTSMenuItem, {}), /* @__PURE__ */ jsx(TTSConverterMenuItem, {}), /* @__PURE__ */ jsx(ReindexElasticMenuItem, {}), /* @__PURE__ */ jsx(FiltersMenuItem, {}), /* @__PURE__ */ jsx(ExecuteMigrationMenuItem, {}), /* @__PURE__ */ jsx(CircleDeveloperDashboardMenuItem, {})]
      }),
      "data-intro": "circle-overflow"
    }), making_more_private && /* @__PURE__ */ jsx(PrivacyDialog, {
      hidden: !making_more_private,
      onClose: closePrivacyDialog,
      onMakeMorePrivate: makeMorePrivate,
      currentPrivacy: circle.privacy
    }), defaultPostTypeDialog && /* @__PURE__ */ jsx(DefaultPostTypeDialog, {
      onClose: () => setDefaultPostTypeDialog(false)
    }), configureTabs && /* @__PURE__ */ jsx(ConfigureTabsDialog, {
      onClose: () => setConfigureTabs(false)
    }), configureMetadataFields && /* @__PURE__ */ jsx(ConfigureMetadataFieldsDialog, {
      onClose: () => setConfigureMetadataFields(false)
    })]
  });
};
const getNextLevel = (currentLevel) => {
  if (currentLevel === "PUBLIC") {
    return "REGISTERED";
  } else {
    if (currentLevel === "REGISTERED") {
      return "PRIVATE";
    }
  }
};
const PrivacyDialog = ({
  hidden,
  onMakeMorePrivate,
  onClose,
  currentPrivacy
}) => {
  if (hidden) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$6, {
    fullScreen: true,
    onClose,
    "aria-labelledby": "increase-privacy",
    open: true,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.make_more_private"
      })
    }), /* @__PURE__ */ jsxs(DialogContent, {
      dividers: true,
      children: [/* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.increase_privacy_by_one_level"
        }), /* @__PURE__ */ jsx(FormattedMessage, {
          id: `group.summary.privacy.${getNextLevel(currentPrivacy)}`
        })]
      }), /* @__PURE__ */ jsx(Important, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "general.cannot_be_undone"
        })
      })]
    }), /* @__PURE__ */ jsxs(DialogActions, {
      children: [/* @__PURE__ */ jsx(LoadingButton, {
        onClick: onMakeMorePrivate,
        autoFocus: true,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.make_more_private"
        })
      }), /* @__PURE__ */ jsx(Button, {
        variant: "text",
        onClick: onClose,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "general.cancel"
        })
      })]
    })]
  });
};
const useConfiguredTabs = () => {
  const {
    tabs: staticConfig
  } = useTabs();
  const [tabs, setTabs] = useState();
  const {
    circle
  } = useCircleContext();
  useEffect(() => {
    if (!circle) {
      return;
    }
    const config = circle && circle.tabs || {};
    const tabs2 = staticConfig.map((tab) => {
      return {
        ...tab,
        ...config[tab.id]
      };
    });
    tabs2.sort((t1, t2) => t1.order - t2.order);
    setTabs(tabs2);
  }, [staticConfig, circle]);
  return [tabs, setTabs];
};
const ConfigureTabsDialog = ({
  onClose
}) => {
  const {
    circle,
    refresh
  } = useCircleContext();
  const [tabs, setTabs] = useConfiguredTabs();
  const [moved, setMoved] = useState(-1);
  const api = useApi();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    const updated = {};
    tabs.forEach((tab, order) => {
      const {
        defaultActive,
        hidden
      } = tab;
      updated[tab.id] = {
        defaultActive,
        hidden,
        order
      };
    });
    const group = await api.post({
      path: `/groups/${circle._id}/_partial`,
      body: {
        tabs: updated
      }
    });
    console.log("Updated Circle:", group);
    refresh();
  });
  const toggleVisible = (id) => {
    tabs[id].hidden = !tabs[id].hidden;
    setTabs([...tabs]);
  };
  const moveTo = (id) => {
    const buff = tabs[moved];
    tabs[moved] = null;
    tabs.splice(id, 0, buff);
    setTabs(tabs.filter((v) => v));
    setMoved(-1);
  };
  const setDefault = (id) => {
    setTabs(tabs.map((v, i) => {
      const one = {
        ...v
      };
      if (i === id) {
        one.defaultActive = !one.defaultActive;
      } else {
        delete one["defaultActive"];
      }
      return one;
    }));
  };
  return /* @__PURE__ */ jsxs(Dialog$6, {
    onClose,
    "aria-labelledby": "increase-privacy",
    open: true,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: "Configure tabs"
    }), /* @__PURE__ */ jsx(DialogContent, {
      dividers: true,
      children: /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-1 text-base",
        children: tabs && tabs.map((tab, id) => {
          const {
            hidden,
            defaultActive
          } = tab;
          const showId = moved === -1 || moved === id || moved + 1 === id;
          return /* @__PURE__ */ jsxs("div", {
            className: "flex gap-2 items-center",
            children: [/* @__PURE__ */ jsx("div", {
              className: clsx(showId && "min-w-[12x]"),
              children: showId ? /* @__PURE__ */ jsx("span", {
                children: id + 1
              }) : /* @__PURE__ */ jsx(Button, {
                className: "w-3 text-base",
                onClick: () => moveTo(id),
                variant: "outlined",
                children: id + 1
              })
            }), /* @__PURE__ */ jsx("div", {
              className: clsx("min-w-[90px] rounded w-[90px] overflow-hidden", defaultActive && "outline outline-green-200"),
              children: tab.title
            }), /* @__PURE__ */ jsx(Button, {
              onClick: () => toggleVisible(id),
              children: hidden ? "show" : "hide"
            }), /* @__PURE__ */ jsx(Button, {
              onClick: () => setDefault(id),
              children: "default"
            }), /* @__PURE__ */ jsx(Button, {
              onClick: () => setMoved(moved === -1 ? id : -1),
              disabled: moved !== -1 && moved !== id,
              children: "move"
            })]
          }, tab.id);
        })
      })
    }), /* @__PURE__ */ jsxs(DialogActions, {
      children: [/* @__PURE__ */ jsx(LoadingButton, {
        loading,
        onClick,
        autoFocus: true,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "general.ok"
        })
      }), /* @__PURE__ */ jsx(Button, {
        variant: "text",
        onClick: onClose,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "general.cancel"
        })
      })]
    })]
  });
};
const DefaultPostTypeDialog = ({
  onClose
}) => {
  const buttons = useCreatePostButtonsDescription();
  const {
    circle,
    refresh
  } = useCircleContext();
  const defaultType = circle && circle.defaultPostType;
  const [type, setType] = useState(defaultType);
  const api = useApi();
  const handleChange = (e) => {
    const value = e.target.value;
    setType(value);
  };
  const {
    onClick,
    loading
  } = useLoading(async () => {
    const group = await api.post({
      path: `/groups/${circle._id}/_partial`,
      body: {
        defaultPostType: type
      }
    });
    console.log("Updated Circle:", group);
    refresh();
  });
  return /* @__PURE__ */ jsxs(Dialog$6, {
    onClose,
    "aria-labelledby": "increase-privacy",
    open: true,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: "Change default post type"
    }), /* @__PURE__ */ jsx(DialogContent, {
      dividers: true,
      children: /* @__PURE__ */ jsxs(FormControl$1, {
        children: [/* @__PURE__ */ jsx(InputLabel, {
          id: "circle-post-type-label",
          children: "Highlighted Default Button "
        }), /* @__PURE__ */ jsxs(Select$1, {
          labelId: "circle-post-type-label",
          value: type || "",
          variant: "outlined",
          onChange: handleChange,
          className: "min-w-[300px]",
          children: [/* @__PURE__ */ jsx(MenuItem, {
            value: "",
            children: "None"
          }), buttons && buttons.map((tab) => {
            return /* @__PURE__ */ jsx(MenuItem, {
              value: tab.id,
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: tab.title
              })
            }, tab.id);
          })]
        })]
      })
    }), /* @__PURE__ */ jsxs(DialogActions, {
      children: [/* @__PURE__ */ jsx(LoadingButton, {
        loading,
        onClick,
        autoFocus: true,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "general.ok"
        })
      }), /* @__PURE__ */ jsx(Button, {
        variant: "text",
        onClick: onClose,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "general.cancel"
        })
      })]
    })]
  });
};
const Important = styled.div`
  align-self: center;
  text-align: center;
  margin: 2em;
  color: #4D4D4D;
`;

const AuthContext = createContext(null);
const AuthProvider = ({
  children
}) => {
  const [open, setOpen] = useState(false);
  return /* @__PURE__ */ jsx(AuthContext.Provider, {
    value: {
      open,
      setOpen
    },
    children
  });
};
const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("AuthContext is not defined");
  }
  return context;
};

const useLoginFn = () => {
  const history = useHistory();
  return useCallback(() => {
    history.push(isLocalPlayground() ? "/playground/lib/single-circle/login" : "/welcome/login");
  }, []);
};
const LinkButton = styled.button`
  border: none;
  text-decoration: underline;
  cursor: pointer;

  background: none;
  color: #fff;
  text-transform: lowercase;
  padding: 0;
  margin-top: 0;
  margin-bottom: 0;
`;
const useUnauthenticatedCircleMessageV2 = () => {
  const {
    setOpen
  } = useAuthContext();
  const {
    profile,
    circle,
    id
  } = useCircleContext();
  const onClick = () => {
    if (circle && circle.privacy === "PUBLIC") {
      localStorage.joinCircle = id;
    }
    setOpen(true);
  };
  if (profile) {
    return null;
  }
  return {
    onClick,
    Text: () => {
      return /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.login_to_join"
      });
    },
    Dialogs: () => {
      return null;
    }
  };
};
const UnauthenticatedCircleMessage = () => {
  useSetOnLoginUrl();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.info.guest"
    }), /* @__PURE__ */ jsx(LinkButton, {
      style: {
        fontWeight: "bold"
      },
      children: /* @__PURE__ */ jsx(Link$2, {
        to: "/welcome/login",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.login_to_join"
        })
      })
    })]
  });
};
const useRequestAccessButtonV2 = () => {
  const {
    profile,
    membership,
    invitation,
    circle,
    setRequestAccess
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  const {
    privacy
  } = circle;
  if (membership || !profile) {
    return null;
  }
  if (privacy !== "PRIVATE" || invitation) {
    return null;
  }
  const onClick = () => {
    setRequestAccess(true);
  };
  return {
    onClick,
    Text: () => /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.request_access.request"
    })
  };
};
const RequestAccessButton = () => {
  const {
    invitation,
    circle,
    setRequestAccess
  } = useCircleContext();
  const {
    privacy
  } = circle;
  if (privacy !== "PRIVATE" || invitation) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    children: /* @__PURE__ */ jsx(LinkButton, {
      onClick: () => setRequestAccess(true),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.request_access.request"
      })
    })
  });
};
const useJoinCircleFn = () => {
  const {
    circle
  } = useCircleContext();
  const api = useApi();
  return async () => {
    await api.joinGroup(circle);
    location.reload();
  };
};
const JoinCircleButton = () => {
  const join = useJoinCircleFn();
  return /* @__PURE__ */ jsx(LinkButton, {
    onClick: join,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.join"
    })
  });
};
const useViewingAsGuest = () => {
  const {
    profile,
    membership,
    invitation,
    circle
  } = useCircleContext();
  const {
    privacy
  } = circle || {};
  if (membership || !profile || !circle) {
    return false;
  }
  if (privacy === "PRIVATE" && !invitation) {
    return false;
  }
  return true;
};
const useJoinCircleV2 = () => {
  const {
    id
  } = useCircleContext();
  const guest = useViewingAsGuest();
  const onClick = useJoinCircleFn();
  useEffect(() => {
    if (!guest || !id) {
      return;
    }
    if (localStorage.joinCircle === id) {
      onClick().then(() => {
        delete localStorage.joinCircle;
      });
    }
  }, [guest]);
  if (!guest) {
    return null;
  }
  return {
    onClick,
    Text: () => /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.join"
    })
  };
};
const ViewingAsGuest = () => {
  const guest = useViewingAsGuest();
  if (!guest) {
    return null;
  }
  return /* @__PURE__ */ jsx("span", {
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.info.guest"
    })
  });
};
const JoinCircle = () => {
  const {
    invitation,
    circle
  } = useCircleContext();
  const {
    privacy
  } = circle;
  if (privacy === "PRIVATE" && !invitation) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.info.guest"
    }), /* @__PURE__ */ jsx(JoinCircleButton, {})]
  });
};
const GuestWithJoinOption = () => {
  const {
    membership,
    profile
  } = useCircleContext();
  if (membership) {
    return null;
  }
  if (profile) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(RequestAccessButton, {}), /* @__PURE__ */ jsx(JoinCircle, {})]
    });
  }
  return /* @__PURE__ */ jsx(UnauthenticatedCircleMessage, {});
};
const useGuestWithJoinOptionV2 = () => {
  const invite = useInviteNewMembersFn();
  const requestAccess = useRequestAccessButtonV2();
  const join = useJoinCircleV2();
  const login = useUnauthenticatedCircleMessageV2();
  const className = "bg-red-600";
  if (login) {
    return {
      Icon: MdLogin,
      className,
      ...login
    };
  }
  if (requestAccess) {
    return {
      Icon: BsPersonPlus,
      className,
      ...requestAccess
    };
  }
  if (join) {
    return {
      Icon: BsPersonPlus,
      className,
      ...join
    };
  }
  if (!invite) {
    return null;
  }
  return {
    Icon: BsPersonPlus,
    Text: () => /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.invite"
    }),
    className: "",
    onClick: invite
  };
};

const CircleNotifications = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  const {
    _id
  } = circle;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(CircleVotingIcon, {
      circleId: _id,
      circle
    }), /* @__PURE__ */ jsx(CirclePostsIcon, {
      circleId: _id,
      circle
    })]
  });
};

const AccessWrapper = styled.span`
  display: flex;
  flex-direction: column;
  min-height: auto;
  flex: 0 0 auto;
`;
const AccessRequestLink = forwardRef((props, ref) => {
  const {
    circle,
    membership,
    requests
  } = useCircleContext();
  if (!circle || !membership || !requests || !requests.length || !requests.filter((r) => !r.decision || !r.decision.status).length) {
    return null;
  }
  if (circle.closed || membership.role !== "ADMIN" || circle.privacy !== "PRIVATE") {
    return null;
  }
  return /* @__PURE__ */ jsx(Link$2, {
    to: `/groups/${circle._id}/membership/access_requests`,
    ...props,
    ref,
    children: /* @__PURE__ */ jsx(HighlightedText, {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: `group.info.pending_access_requests`,
        values: {
          access_request_count: requests.length
        }
      })
    })
  });
});
const CirclePrivacyMessage = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsx(FormattedMessage, {
    id: `group.info.privacy.${circle.privacy}`
  });
};
const HighlightedText = styled.span`
  color: #600;
  margin-left: 0.5em;
  margin-right: 0.5em;
`;
const CircleClosedMessage = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle || !circle.closed) {
    return null;
  }
  return /* @__PURE__ */ jsx(HighlightedText, {
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "group.info.closed"
    })
  });
};
const MembershipMessage = () => {
  const {
    membership
  } = useCircleContext();
  if (!membership) {
    return null;
  }
  return /* @__PURE__ */ jsx(FormattedMessage, {
    id: `group.info.membership.${membership.role}.${membership.read_only}`
  });
};
const CircleAccess = () => {
  return /* @__PURE__ */ jsxs(AccessWrapper, {
    children: [/* @__PURE__ */ jsxs("span", {
      children: [/* @__PURE__ */ jsx(CirclePrivacyMessage, {}), /* @__PURE__ */ jsx(CircleClosedMessage, {}), /* @__PURE__ */ jsx(AccessRequestLink, {}), /* @__PURE__ */ jsx(CircleNotifications, {})]
    }), /* @__PURE__ */ jsx(MembershipMessage, {}), /* @__PURE__ */ jsx(GuestWithJoinOption, {})]
  });
};
const CircleAccessV2 = () => {
  return /* @__PURE__ */ jsxs(AccessWrapper, {
    children: [/* @__PURE__ */ jsxs("span", {
      children: [/* @__PURE__ */ jsx(CirclePrivacyMessage, {}), /* @__PURE__ */ jsx(CircleClosedMessage, {}), /* @__PURE__ */ jsx(AccessRequestLink, {})]
    }), /* @__PURE__ */ jsx(ViewingAsGuest, {}), /* @__PURE__ */ jsx(MembershipMessage, {})]
  });
};

const Absolute = css$1`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;
const Info = styled.div`
  ${Absolute}
  padding: 0.5em;
  padding-left: 1.5em;
  line-height: 1.5em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
  overflow: hidden;
  & ul {
    list-style-type: none;
  }
`;
const Summary$1 = styled.div`
  position: relative;
  height: 128px;

  @media (min-width:768px) {
      height: 192px;
  }

`;
const Cover = styled.div`
  ${Absolute}
  & > * {
    ${Absolute}
  }
`;
const Shade = styled.div`
  ${Absolute}
  background-color:#999999;
  opacity: 0.7;
`;
const Header = styled.h1`
  margin: 0;
  overflow: hidden;
  line-height: 1.12em;
  min-height: 1em;
`;
const CircleHeaderImage = () => {
  const {
    circle
  } = useCircleContext();
  return /* @__PURE__ */ jsxs(Cover, {
    children: [/* @__PURE__ */ jsx(ResponsiveImageProxy, {
      data: circle.image,
      sizes: {
        "(min-width: 1440px)": {
          width: 1920,
          height: 192
        },
        "(min-width: 1280px)": {
          width: 1440,
          height: 192
        },
        "(min-width: 1024px)": {
          width: 1280,
          height: 192
        },
        "(min-width: 768px)": {
          width: 1023,
          height: 192
        },
        "(min-width: 640px)": {
          width: 767,
          height: 128
        },
        "(min-width: 512px)": {
          width: 639,
          height: 128
        },
        "(min-width: 320px)": {
          width: 511,
          height: 128
        },
        "(min-width: 240px)": {
          width: 319,
          height: 128
        }
      }
    }), /* @__PURE__ */ jsx(Shade, {})]
  });
};
const CoverV2 = styled.div`
  ${Absolute}
  display: block;
  pointer-events: none;
  z-index: 0;
  & > * {
    ${Absolute}
    display: block;
  }
  & > div > picture {
    ${Absolute}
    max-height: 250px;    
  }
`;
const CircleHeaderImageV2 = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsx(CircleHeaderImageInnerV2, {
    image: circle.image
  });
};
const CircleHeaderImageInnerV2 = ({
  image
}) => {
  return /* @__PURE__ */ jsxs(CoverV2, {
    children: [/* @__PURE__ */ jsx(ResponsiveImageProxy, {
      data: image,
      sizes: {
        "(min-width: 1440px)": {
          width: 1920
        },
        "(min-width: 1280px)": {
          width: 1440
        },
        "(min-width: 1024px)": {
          width: 1280
        },
        "(min-width: 768px)": {
          width: 1023
        },
        "(min-width: 640px)": {
          width: 767
        },
        "(min-width: 512px)": {
          width: 639
        },
        "(min-width: 320px)": {
          width: 511
        },
        "(min-width: 240px)": {
          width: 319
        }
      }
    }), /* @__PURE__ */ jsx(Shade, {})]
  });
};
const EventImage = ({
  image
}) => {
  return /* @__PURE__ */ jsx(CoverV2, {
    children: /* @__PURE__ */ jsx(ResponsiveImageProxy, {
      data: image,
      sizes: {
        "(min-width: 1440px)": {
          width: 1920
        },
        "(min-width: 1280px)": {
          width: 1440
        },
        "(min-width: 1024px)": {
          width: 1280
        },
        "(min-width: 768px)": {
          width: 1023
        },
        "(min-width: 640px)": {
          width: 767
        },
        "(min-width: 512px)": {
          width: 639
        },
        "(min-width: 320px)": {
          width: 511
        },
        "(min-width: 240px)": {
          width: 319
        }
      }
    })
  });
};
const CircleHeader = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Summary$1, {
    children: [/* @__PURE__ */ jsx(CircleHeaderImage, {}), /* @__PURE__ */ jsxs(Info, {
      children: [/* @__PURE__ */ jsx(Header, {
        children: circle.name
      }), /* @__PURE__ */ jsx(CircleAccess, {})]
    })]
  });
};

const TestPageCssOverrides$4 = createGlobalStyle`
  #root, #root>* {
    min-width: 100%;
    margin: 0;
    padding: 0;    
  }

  html body {
    overflow: auto;
    overflow-x: hidden;
    max-width: 100%;
    margin: 0;
    padding: 0;
  }
`;

const usePostsList$1 = (tags, op) => {
  const api = useApi();
  const result = useSWR(`/posts/all/tagged?tags=` + encodeURIComponent(tags.join(",")), (path) => {
    return api.get({
      path
    });
  }, {
    ...swrLoadOnce,
    ...op
  });
  return result;
};

const TaggedPostsSelector = ({
  setId,
  id,
  tags
}) => {
  const {
    data
  } = usePostsList$1(tags);
  const handleChange = async (e) => {
    const id2 = e.target.value;
    setId(id2);
  };
  return /* @__PURE__ */ jsxs(FormControl$1, {
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: "prompts-label",
      children: "HTML template"
    }), /* @__PURE__ */ jsxs(Select$1, {
      labelId: "prompts-label",
      value: id || "",
      variant: "outlined",
      onChange: handleChange,
      children: [/* @__PURE__ */ jsx(MenuItem, {
        value: "",
        children: "Select.."
      }), data && data.posts.map((prompt) => {
        return /* @__PURE__ */ jsx(MenuItem, {
          value: prompt._id,
          children: prompt.title
        }, prompt._id);
      })]
    })]
  });
};

const SWRProfileContextProvider = ({
  children
}) => {
  const {
    data: profile,
    error
  } = useProfile({});
  const {
    data: instance
  } = useInstance({});
  return /* @__PURE__ */ jsx(ProfileContextProvider, {
    profile,
    instance,
    error,
    children
  });
};

const LoginForm = () => {
  const {
    state,
    setState
  } = useRegistrationContext();
  const api = useApi();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const {
    onClick: handleSubmit,
    loading
  } = useLoading(async () => {
    const result = await api.loginWithEmail({
      email,
      password
    });
    console.log("login:", result);
    window.location.reload();
  });
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto", state === "login" ? "flex" : "hidden"),
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.login2"
      })
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.emailOrPhone"
      }),
      type: "email",
      input: {
        variant: "outlined",
        value: email,
        onChange: handleEmailChange
      },
      className: clsx("bg-gray-50 w-full", "focus:outline-none")
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.password"
      }),
      type: "password",
      input: {
        variant: "outlined",
        value: password,
        onChange: handlePasswordChange
      },
      className: clsx("bg-gray-50 w-full", "focus:outline-none")
    }), /* @__PURE__ */ jsxs(Button, {
      type: "submit",
      variant: "contained",
      color: "primary",
      fullWidth: true,
      disabled: loading,
      className: "py-2",
      onClick: handleSubmit,
      children: [loading && /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      }), loading ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.login3"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.login2"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "text-blue-500 underline hover:text-blue-700 cursor-pointer",
      onClick: () => setState("forgot"),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.forgot"
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "text-blue-500 underline hover:text-blue-700",
      children: /* @__PURE__ */ jsx("a", {
        href: "#?state=register",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.register2"
        })
      })
    }), /* @__PURE__ */ jsx(OrRuler, {}), /* @__PURE__ */ jsx(NewGoogleButton, {})]
  });
};

const policy_dialog = "_policy_dialog_1unuh_1";
var styles$c = {
	policy_dialog: policy_dialog
};

const make_readable = (text) => {
  return text.split(/(\r|\n)/);
};
const TextWrapper = styled.div`
  & > p {
    font-family: monospace;
    font-size: 0.8em;
    margin-top: 1em;
  }
`;
const PrivacyText = () => {
  return /* @__PURE__ */ jsx(TextWrapper, {
    children: make_readable(privacy_policy_en).map((t, i) => /* @__PURE__ */ jsx("p", {
      children: t
    }, `_${i}`))
  });
};
const PrivacyPolicyDialog = ({
  onClose
}) => {
  return /* @__PURE__ */ jsx(ConfirmDialog, {
    title: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "general.privacy_policy"
    }),
    open: true,
    onClose,
    className: styles$c.policy_dialog,
    content: /* @__PURE__ */ jsx(PrivacyText, {})
  });
};
const TermsText = () => {
  return /* @__PURE__ */ jsx(TextWrapper, {
    children: make_readable(terms_and_conditions_en).map((t, i) => /* @__PURE__ */ jsx("p", {
      children: t
    }, `_${i}`))
  });
};
const TermsAndConditionsDialog = ({
  onClose
}) => {
  return /* @__PURE__ */ jsx(ConfirmDialog, {
    title: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "general.terms_and_conditions"
    }),
    open: true,
    onClose,
    className: styles$c.policy_dialog,
    content: /* @__PURE__ */ jsx(TermsText, {})
  });
};

const REREGISTER_FLAG = false;
const RegistrationForm = ({
  isEmailRegistration = true,
  circleId
}) => {
  const {
    state,
    setUserId,
    setState
  } = useRegistrationContext();
  const api = useApi();
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [agreeToTerms, setAgreeToTerms] = useBoolean(false);
  const [alreadyRegistered, setAlreadyRegistered] = useBoolean(false);
  const [validEmailError, setValidEmailError] = useState("");
  const [validPhoneNumberError, setValidPhoneNumberError] = useState("");
  const [validPasswordError, setValidPasswordError] = useState("");
  const [passwordsDoNotMatchError, setPasswordsDoNotMatchError] = useState("");
  const [showPrivacy, setShowPrivacy] = useBoolean();
  const [showTerms, setShowTerms] = useBoolean();
  const onPhone = () => {
    setState("phone");
  };
  const isValueAvailable = async (value2) => {
    try {
      const user = await api.loadUserByEmail(value2);
      return !user;
    } catch (err) {
      if (err.code === 404) {
        return true;
      } else {
        return false;
      }
    }
  };
  const passwordsMatch = () => {
    if (password !== confirmPassword) {
      setPasswordsDoNotMatchError("validation_error.passwords_must_match");
    } else {
      setPasswordsDoNotMatchError("");
    }
  };
  useEffect(() => {
    passwordsMatch();
  }, [password, confirmPassword]);
  const handleEmailChange = async (e) => {
    const value2 = e.target.value;
    setEmail(value2);
    setValidEmailError(isValidateEmail(value2));
    const available = await isValueAvailable(value2);
    setAlreadyRegistered.set(!available);
  };
  const handlePhoneNumberChange = async (e) => {
    const value2 = e.target.value;
    setPhoneNumber(value2);
    setValidPhoneNumberError(isValidPhoneNumber(value2));
    const available = await isValueAvailable(value2);
    setAlreadyRegistered.set(!available);
  };
  const handlePasswordChange = (e) => {
    const value2 = e.target.value;
    setPassword(value2);
    setValidPasswordError(isValidPassword(value2));
    passwordsMatch();
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    passwordsMatch();
  };
  const handleAgreeToTermsChange = () => {
    setAgreeToTerms.toggle();
  };
  const {
    onClick: onRegister,
    loading
  } = useLoading(async () => {
    const href = location.href;
    const parts = href.split("#");
    const mobile = await mobilePhoneData2Save();
    const result = await api.registerWithEmail({
      phone: stripAllWhitespaces(phoneNumber) || void 0,
      mobiles: mobile ? [mobile] : null,
      password: stripAllWhitespaces(password),
      email: stripAllWhitespaces(email),
      joinCircleId: circleId,
      tags: [],
      url: parts[0] + "#?state=verify&pin=<pin>&userId=<userId>"
    });
    console.log("registration:", result);
    if (result.email || result.phone) {
      setUserId(result._id);
    } else {
      throw new Error(typeof result === "string" ? result : result.error || "Registration failed");
    }
  });
  const value = isEmailRegistration ? email : phoneNumber;
  const validValueError = isEmailRegistration ? validEmailError : validPhoneNumberError;
  const thereAreErrors = !password || !value || alreadyRegistered || validValueError || validPasswordError || passwordsDoNotMatchError;
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto overflow-y-auto max-h-full", state === (isEmailRegistration ? "register" : "phone") ? "flex" : "hidden"),
    children: [isEmailRegistration && /* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.register"
      })
    }), !isEmailRegistration && /* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.registerWithPhone"
      })
    }), !isEmailRegistration && /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.phone"
      }),
      type: "tel",
      input: {
        variant: "outlined",
        value: phoneNumber,
        onChange: handlePhoneNumberChange
      },
      className: clsx("bg-gray-50 w-full", "focus:outline-none")
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.email"
      }),
      type: "email",
      input: {
        variant: "outlined",
        value: email,
        onChange: handleEmailChange
      },
      className: clsx("bg-gray-50 w-full", "focus:outline-none")
    }), alreadyRegistered && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "registration_form.already_registered2"
      })
    }), validValueError && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: validValueError
      })
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.password"
      }),
      type: "password",
      input: {
        variant: "outlined",
        value: password,
        onChange: handlePasswordChange
      },
      className: clsx("bg-gray-50 w-full", "focus:outline-none")
    }), validPasswordError && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: validPasswordError
      })
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.confirm"
      }),
      type: "password",
      input: {
        variant: "outlined",
        value: confirmPassword,
        onChange: handleConfirmPasswordChange
      },
      className: clsx("bg-gray-50 w-full", "focus:outline-none")
    }), passwordsDoNotMatchError && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: passwordsDoNotMatchError
      })
    }), /* @__PURE__ */ jsx(FormControlLabel, {
      control: /* @__PURE__ */ jsx(Checkbox$1, {
        checked: agreeToTerms,
        onChange: handleAgreeToTermsChange,
        color: "primary"
      }),
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.agree"
      })
    }), /* @__PURE__ */ jsxs(Button, {
      type: "submit",
      variant: "contained",
      color: "primary",
      fullWidth: true,
      disabled: (loading || !agreeToTerms || !!thereAreErrors) && !REREGISTER_FLAG,
      className: "py-2",
      onClick: onRegister,
      children: [loading && /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      }), loading ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.registering"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.register"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "text-blue-500 underline hover:text-blue-700",
      children: /* @__PURE__ */ jsx("a", {
        href: "#?state=login",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.alreadyHaveAccount"
        })
      })
    }), /* @__PURE__ */ jsx(OrRuler, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col items-stretch gap-2",
      children: [/* @__PURE__ */ jsx(NewGoogleButton, {}), isEmailRegistration && (isMobileWrapper() || isStaging()) && /* @__PURE__ */ jsx("button", {
        className: clsx(buttonClassName, "bg-[#2196f3]"),
        onClick: onPhone,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.registerWithPhone"
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center justify-center text-xs top-2",
      children: [/* @__PURE__ */ jsx("button", {
        onClick: setShowPrivacy.toggle,
        className: "bg-transparent border-none p-0 m-0 cursor-pointer text-blue-500 underline hover:text-blue-700",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "registration.privacy_policy"
        })
      }), /* @__PURE__ */ jsx("div", {
        onClick: setShowTerms.toggle,
        className: "bg-transparent border-none p-0 m-0 cursor-pointer text-blue-500 underline hover:text-blue-700",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "registration.terms"
        })
      })]
    }), showPrivacy && /* @__PURE__ */ jsx(PrivacyPolicyDialog, {
      onClose: setShowPrivacy.toggle
    }), showTerms && /* @__PURE__ */ jsx(TermsAndConditionsDialog, {
      onClose: setShowTerms.toggle
    })]
  });
};

const ConfirmationCode = () => {
  const {
    state,
    userId,
    pin
  } = useRegistrationContext();
  const api = useApi();
  const [code, setCode] = useState("");
  const handleCodeChange = (e) => {
    const value = e.target.value;
    setCode(value);
  };
  useEffect(() => {
    setCode(pin);
  }, [pin]);
  const {
    onClick: handleSubmit,
    loading
  } = useLoading(async () => {
    const user = await api.confirmEmailWithPin({
      userId,
      pin: code
    });
    if (user && user.verified && user._id === userId) {
      window.location.reload();
    } else {
      throw Error("Verification failed, try again!");
    }
  });
  useEffect(() => {
    if (pin === code && userId && pin) {
      handleSubmit();
    }
  }, [code, userId, pin]);
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto", state === "verify" ? "flex" : "hidden"),
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.verificationCode"
      })
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.confirmationCode"
      }),
      type: "text",
      input: {
        variant: "outlined",
        value: code,
        onChange: handleCodeChange
      },
      className: clsx("bg-gray-50 w-full", "focus:outline-none")
    }), /* @__PURE__ */ jsxs(Button, {
      type: "submit",
      variant: "contained",
      color: "primary",
      fullWidth: true,
      disabled: loading,
      className: "py-2",
      onClick: handleSubmit,
      children: [loading && /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      }), loading ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.verify2"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.verify"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "text-blue-500 underline hover:text-blue-700",
      children: /* @__PURE__ */ jsx("a", {
        href: "#?state=login",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.alreadyHaveAccount"
        })
      })
    })]
  });
};

const looksLikePhoneNumber = (value) => !!value.trim() && isValidPhoneNumber(value.trim()) === null;
const ForgotPassword = () => {
  const {
    state
  } = useRegistrationContext();
  const api = useApi();
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const handleChange = (e) => {
    setEmailOrPhone(e.target.value);
  };
  const isPhoneNumber = looksLikePhoneNumber(emailOrPhone);
  const {
    onClick: handleSubmit,
    loading
  } = useLoading(async () => {
    setEmailSent(false);
    const href = location.href;
    const parts = href.split("#");
    await api.post({
      path: "/public/users/forgot-password",
      body: {
        email: emailOrPhone.trim(),
        url: parts[0] + "#?state=change-password&token=<token>"
      }
    });
    setEmailSent(true);
  });
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto overflow-y-auto max-h-full", state === "forgot" ? "flex" : "hidden"),
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.reset"
      })
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.email"
      }),
      type: "text",
      input: {
        variant: "outlined",
        value: emailOrPhone,
        onChange: handleChange
      },
      className: "bg-gray-50 w-full"
    }), /* @__PURE__ */ jsx("div", {
      className: `${isPhoneNumber ? "text-red-500" : "text-gray-500"} text-sm w-full`,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.phoneNoPassword"
      })
    }), /* @__PURE__ */ jsxs(Button, {
      type: "submit",
      variant: "contained",
      color: "primary",
      fullWidth: true,
      disabled: loading || isPhoneNumber,
      className: "py-2",
      onClick: handleSubmit,
      children: [loading && /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      }), loading ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.resetting"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.reset"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "text-blue-500 underline hover:text-blue-700",
      children: /* @__PURE__ */ jsx("a", {
        href: "#?state=register",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.register2"
        })
      })
    }), emailSent && /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.sentEmail"
      })
    })]
  });
};

const ChangePassword = () => {
  const {
    state,
    token
  } = useRegistrationContext();
  const api = useApi();
  const onLoginSuccess = useOnLoginSuccess();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [validPasswordError, setValidPasswordError] = useState("");
  const [passwordsDoNotMatchError, setPasswordsDoNotMatchError] = useState("");
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setValidPasswordError(isValidPassword(value));
  };
  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
  };
  useEffect(() => {
    if (password !== confirmPassword) {
      setPasswordsDoNotMatchError("validation_error.passwords_must_match");
    } else {
      setPasswordsDoNotMatchError("");
    }
  }, [password, confirmPassword]);
  const thereAreErrors = !password || !confirmPassword || validPasswordError || passwordsDoNotMatchError;
  const {
    onClick: handleSubmit,
    loading
  } = useLoading(async () => {
    const user = await api.loginWithJwt(token);
    await api.resetPassword({
      password
    });
    await onLoginSuccess({
      result: user
    });
  });
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto overflow-y-auto max-h-full", state === "change-password" ? "flex" : "hidden"),
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-xl font-bold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.change"
      })
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.newPassword"
      }),
      type: "password",
      input: {
        variant: "outlined",
        value: password,
        onChange: handlePasswordChange
      },
      className: "bg-gray-50 w-full"
    }), validPasswordError && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: validPasswordError
      })
    }), /* @__PURE__ */ jsx(LoginTextField, {
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.confirm"
      }),
      type: "password",
      input: {
        variant: "outlined",
        value: confirmPassword,
        onChange: handleConfirmPasswordChange
      },
      className: "bg-gray-50 w-full"
    }), passwordsDoNotMatchError && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: passwordsDoNotMatchError
      })
    }), /* @__PURE__ */ jsxs(Button, {
      type: "submit",
      variant: "contained",
      color: "primary",
      fullWidth: true,
      disabled: loading || !!thereAreErrors,
      className: "py-2",
      onClick: handleSubmit,
      children: [loading && /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      }), loading ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.change2"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.change"
      })]
    })]
  });
};

const SignUpOrLoginPanel = () => {
  const history = useHistory();
  const quickLogin = !isMobileWrapper();
  const onRegister = () => {
    history.push("/welcome/register/email");
  };
  const onLogin = () => {
    history.push("/welcome/login/email#?state=login");
  };
  const buttonClassName2 = "border-2 rounded border-gray-500 border-solid flex gap-1 p-3 items-center text-white justify-center";
  const colorRed2 = "bg-[#e93f2e]";
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 items-center text-xs sm:text-sm",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "general.sign_up"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2 items-stretch",
      children: [/* @__PURE__ */ jsx(NoSsr, {
        children: quickLogin && /* @__PURE__ */ jsx(GoogleButton, {
          className: clsx(buttonClassName2, colorRed2),
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "registration.continue_with_google"
          })
        })
      }), /* @__PURE__ */ jsx("button", {
        className: clsx(buttonClassName2, colorRed2),
        onClick: onRegister,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "registration.register_with_email"
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-1 items-center",
      children: [/* @__PURE__ */ jsx(FormattedMessage, {
        id: "general.already_a_member"
      }), /* @__PURE__ */ jsx("button", {
        className: clsx(buttonClassName2, "bg-[#2196f3]"),
        onClick: onLogin,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "general.sign_in"
        })
      })]
    })]
  });
};
const SignUpOrLoginPanel2 = ({
  circleId
}) => {
  return /* @__PURE__ */ jsx(RegistrationContextProvider, {
    children: /* @__PURE__ */ jsx(SignUpOrLoginPanelMain, {
      circleId
    })
  });
};
const SignUpOrLoginPanelMain = ({
  circleId
}) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(SignUpOrLoginMain, {}), /* @__PURE__ */ jsx(LoginForm, {}), /* @__PURE__ */ jsx(RegistrationForm, {
      isEmailRegistration: true,
      circleId
    }), /* @__PURE__ */ jsx(RegistrationForm, {
      isEmailRegistration: false,
      circleId
    }), /* @__PURE__ */ jsx(ConfirmationCode, {}), /* @__PURE__ */ jsx(ForgotPassword, {}), /* @__PURE__ */ jsx(ChangePassword, {})]
  });
};
const SignUpOrLoginMain = () => {
  const {
    setState,
    state
  } = useRegistrationContext();
  const {
    data: instance
  } = useInstance();
  const {
    circle
  } = useCircleContext();
  const showCircleImage = circle && !!circle.image;
  const onRegister = () => {
    setState("register");
  };
  const onLogin = () => {
    setState("login");
  };
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex-col items-center p-6 space-y-4 bg-white shadow-md rounded-lg w-full max-w-md mx-auto", state === "main" ? "flex" : "hidden"),
    children: [showCircleImage && /* @__PURE__ */ jsx("a", {
      href: circleUrl(circle),
      children: /* @__PURE__ */ jsx(CardThemeProvider, {
        cardShadow: false,
        linkToPage: true,
        closer: true,
        children: /* @__PURE__ */ jsx(Image$1, {
          image: circle.image
        })
      })
    }), !showCircleImage && /* @__PURE__ */ jsx("a", {
      href: "/welcome",
      children: /* @__PURE__ */ jsx(InstanceLogoImage, {
        instance,
        className: "w-8 h-8 shadow-md shadow-slate-300 p-1",
        size: 32
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "font-semibold",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.authRequired"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.authRequired"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-stretch flex-wrap",
      children: [/* @__PURE__ */ jsx("button", {
        className: clsx(buttonClassName, colorRed),
        onClick: onRegister,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.register"
        })
      }), /* @__PURE__ */ jsx("button", {
        className: clsx(buttonClassName, "bg-[#2196f3]"),
        onClick: onLogin,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "auth.login"
        })
      })]
    })]
  });
};

const useLoginButtons = () => {
  const [buttons, setButtons] = useState();
  const ref = (element) => {
    if (!element) {
      return;
    }
    const container = element.getElementsByClassName("buttons");
    if (!container.length) {
      return;
    }
    setButtons(container[0]);
  };
  const buttonsBlock = buttons && /* @__PURE__ */ jsx(Portal, {
    container: buttons,
    children: /* @__PURE__ */ jsx(SignUpOrLoginPanel, {})
  });
  return {
    buttons,
    ref,
    buttonsBlock
  };
};
const WelcomeHtml = forwardRef(({
  html
}, ref) => {
  if (!html) {
    return null;
  }
  const html1 = html.replaceAll("{buttons}", `<div class="buttons"></div>`);
  return /* @__PURE__ */ jsx(HTMLView, {
    html: html1,
    ref
  });
});
const ConfigurePagePanel = ({
  page,
  edit
}) => {
  const [id, setId] = useState("");
  const {
    buttonsBlock,
    ref
  } = useLoginButtons();
  const {
    data: configData,
    error,
    run
  } = usePageHTML(page);
  const html = configData && configData.html || "";
  const postId = configData && configData.id;
  useEffect(() => {
    setId(postId);
  }, [postId]);
  const {
    onClick: save,
    loading
  } = useSavePageConfig(page, id, () => run());
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2 p-2",
    ref,
    children: [/* @__PURE__ */ jsx(TaggedPostsSelector, {
      id,
      setId,
      tags: ["html template"]
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: save,
      loading,
      children: "Save"
    }), /* @__PURE__ */ jsx(WelcomeHtml, {
      html,
      ref
    }), buttonsBlock]
  });
};
const ConfigurationPage = ({
  page,
  edit
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "ns sm:px-[54px] overflow-hidden text-base w-full pb-4 min-h-screen configuration-page",
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(ConfigurePagePanel, {
      page,
      edit
    })]
  });
};
const ConfigurablePageTest = () => {
  return /* @__PURE__ */ jsxs(SWRProfileContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(ConfigurePagePanel, {
      page: "welcome"
    })]
  });
};

const MANUAL_MODE$1 = 0;
const SCHEDULE_MODE$1 = 1;
const DISABLED_MODE$1 = 2;

const editCircleAssistantUrl = (idOrAssistant) => `/trans/circle-assistant/${typeof idOrAssistant === "string" ? idOrAssistant : idOrAssistant._id}`;
const viewCircleAssistantUrl = (idOrAssistant) => `/trans/circle-view-assistant/${typeof idOrAssistant === "string" ? idOrAssistant : idOrAssistant._id}`;
const EditAssistantMenuItem = ({
  assistant
}) => {
  const url = editCircleAssistantUrl(assistant);
  return /* @__PURE__ */ jsx("a", {
    href: url,
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.edit"
      })
    })
  });
};
const DisableAssistantMenuItem = ({
  assistant,
  onDisable
}) => {
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: () => onDisable(assistant._id),
    children: "Disable"
  });
};
const DeleteAssistantMenuItem = ({
  assistant,
  onDelete
}) => {
  const isInstanceAdmin = useIsInstanceAdmin();
  if (!isInstanceAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: () => onDelete(assistant._id),
    children: "Delete"
  });
};
const AssistantMenu = ({
  assistant,
  className,
  onDelete,
  onDisable
}) => {
  const canEdit = useCanExecutePrompt();
  if (!canEdit) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className,
    children: /* @__PURE__ */ jsx("div", {
      className: "relative inline-block",
      children: /* @__PURE__ */ jsx(OverflowMenu, {
        contentComponent: (props) => /* @__PURE__ */ jsxs(Paper, {
          ...props,
          children: [/* @__PURE__ */ jsx(EditAssistantMenuItem, {
            assistant
          }), /* @__PURE__ */ jsx(DisableAssistantMenuItem, {
            assistant,
            onDisable
          }), /* @__PURE__ */ jsx(DeleteAssistantMenuItem, {
            assistant,
            onDelete
          })]
        })
      })
    })
  });
};
const AssistantListItem = ({
  assistant,
  onDisable,
  onDelete
}) => {
  const {
    name,
    active,
    paused,
    mode
  } = assistant;
  return /* @__PURE__ */ jsxs("div", {
    className: "grow w-full relative",
    children: [/* @__PURE__ */ jsx(AssistantMenu, {
      className: "absolute ltr:right-0 rtl:left-0 top-0 mt-0 mr-0 z-10",
      assistant,
      onDisable,
      onDelete
    }), /* @__PURE__ */ jsx("a", {
      href: viewCircleAssistantUrl(assistant),
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx(Avatar, {
          avatar: assistant && assistant.avatar,
          size: 64
        }, "avatar"), /* @__PURE__ */ jsxs("div", {
          className: "grow flex-col",
          children: [/* @__PURE__ */ jsx("div", {
            className: "text-sm text-gray-500",
            children: name
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex items-center",
            children: [/* @__PURE__ */ jsx(Chip$1, {
              size: "small",
              avatar: /* @__PURE__ */ jsx(GiArtificialIntelligence, {}),
              label: "Assistant"
            }), "\xA0", /* @__PURE__ */ jsx("div", {
              className: "flex bg-red-400  p-0.5 text-white rounded-md justify-center text-sm mx-1",
              children: !paused && active ? /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.active"
              }) : /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.notActive"
              })
            }), mode === DISABLED_MODE$1 && /* @__PURE__ */ jsx("div", {
              className: "flex bg-gray-500  p-0.5 text-white rounded-md justify-center text-sm mx-1",
              children: "Disabled"
            }), /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.members_page.since"
            }), "\xA0", /* @__PURE__ */ jsx(RelativeTime, {
              value: assistant.created
            })]
          })]
        })]
      })
    })]
  });
};
const CircleListInner = () => {
  const {
    profile
  } = useProfileContext();
  const {
    circle,
    id: circleId
  } = useCircleContext();
  const {
    data,
    mutate
  } = useAssistants(circleId);
  const [assistants, setAssistants] = useState([]);
  const isAdmin = profile && profile.role === "ADMIN";
  useEffect(() => {
    if (!data) {
      return;
    }
    const {
      assistants: assistants2
    } = data;
    setAssistants(assistants2);
  }, [data]);
  const api = useApi();
  const {
    onClick: onCreate,
    loading: createLoading
  } = useLoading(async () => {
    const {
      assistant
    } = await api.post({
      path: `/group-assistant`,
      body: {
        name: "New Assistant",
        group: circleId
      }
    });
    setAssistants((assistants2) => [assistant, ...assistants2]);
  });
  const {
    onClick: onDelete
  } = useLoading(async (id) => {
    await api.delete({
      path: `/group-assistant/${id}`
    });
    mutate();
  });
  const {
    onClick: onDisable
  } = useLoading(async (id) => {
    await api.get({
      path: `/group-assistant/${id}/disable`
    });
    mutate();
  });
  if (!circle || !data) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "ns w-full p-2 flex flex-col gap-2 text-sm",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex gap-1",
      children: isAdmin && /* @__PURE__ */ jsx(LoadingButton, {
        background: "blue",
        onClick: onCreate,
        loading: createLoading,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.addAI"
        })
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2 w-full",
      children: assistants.map((assistant) => {
        const {
          _id
        } = assistant;
        return /* @__PURE__ */ jsx(AssistantListItem, {
          assistant,
          onDelete,
          onDisable
        }, _id);
      })
    })]
  });
};
const CircleAssistantsList = ({
  circleId
}) => {
  return /* @__PURE__ */ jsxs(LoadCircleData, {
    circleId,
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(CircleListInner, {})]
  });
};
const CircleAssistantsListTest = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[4] ? path[4] : circleIdDefault;
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(CircleAssistantsList, {
      circleId
    })
  });
};

const toastVariants = cva(["relative flex items-start gap-3 p-4 rounded-lg shadow-lg border", "max-w-sm w-full sm:max-w-md", "transform transition-all duration-300 ease-in-out", "backdrop-blur-sm bg-opacity-95"], {
  variants: {
    type: {
      success: ["bg-green-50 border-green-200 text-green-800", "dark:bg-green-900/20 dark:border-green-800 dark:text-green-200"],
      error: ["bg-red-50 border-red-200 text-red-800", "dark:bg-red-900/20 dark:border-red-800 dark:text-red-200"],
      warning: ["bg-amber-50 border-amber-200 text-amber-800", "dark:bg-amber-900/20 dark:border-amber-800 dark:text-amber-200"],
      info: ["bg-blue-50 border-blue-200 text-blue-800", "dark:bg-blue-900/20 dark:border-blue-800 dark:text-blue-200"]
    },
    state: {
      entering: "translate-x-0 opacity-100",
      exiting: "translate-x-full opacity-0"
    }
  },
  defaultVariants: {
    type: "info",
    state: "entering"
  }
});
const ToastIcon = ({
  type
}) => {
  const iconClasses = "w-5 h-5 flex-shrink-0 mt-0.5";
  switch (type) {
    case "success":
      return /* @__PURE__ */ jsx("svg", {
        className: iconClasses,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /* @__PURE__ */ jsx("path", {
          fillRule: "evenodd",
          d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
          clipRule: "evenodd"
        })
      });
    case "error":
      return /* @__PURE__ */ jsx("svg", {
        className: iconClasses,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /* @__PURE__ */ jsx("path", {
          fillRule: "evenodd",
          d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z",
          clipRule: "evenodd"
        })
      });
    case "warning":
      return /* @__PURE__ */ jsx("svg", {
        className: iconClasses,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /* @__PURE__ */ jsx("path", {
          fillRule: "evenodd",
          d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
          clipRule: "evenodd"
        })
      });
    case "info":
      return /* @__PURE__ */ jsx("svg", {
        className: iconClasses,
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /* @__PURE__ */ jsx("path", {
          fillRule: "evenodd",
          d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
          clipRule: "evenodd"
        })
      });
    default:
      return null;
  }
};
const ToastItem = ({
  toast,
  onClose
}) => {
  const [isExiting, setIsExiting] = useState(false);
  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => onClose(toast.id), 300);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: toastVariants({
      type: toast.type,
      state: isExiting ? "exiting" : "entering"
    }),
    children: [/* @__PURE__ */ jsx(ToastIcon, {
      type: toast.type
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex-1 min-w-0",
      children: [toast.title && /* @__PURE__ */ jsx("h3", {
        className: "text-sm font-medium mb-1",
        children: toast.title
      }), /* @__PURE__ */ jsx("p", {
        className: "text-sm opacity-90",
        children: toast.message
      }), toast.action && /* @__PURE__ */ jsx("button", {
        onClick: toast.action.onClick,
        className: "mt-2 text-sm font-medium underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-current rounded",
        children: toast.action.label
      })]
    }), /* @__PURE__ */ jsx("button", {
      onClick: handleClose,
      className: "flex-shrink-0 ml-2 p-1 rounded hover:bg-black/5 dark:hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-current transition-colors",
      "aria-label": "Close notification",
      children: /* @__PURE__ */ jsx("svg", {
        className: "w-4 h-4",
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /* @__PURE__ */ jsx("path", {
          fillRule: "evenodd",
          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
          clipRule: "evenodd"
        })
      })
    })]
  });
};
const ToastContainer = () => {
  const {
    toasts,
    removeToast
  } = useToast();
  const [mounted, setMounted] = useState(false);
  const {
    refs,
    floatingStyles
  } = useFloating({
    placement: "top-end",
    middleware: [offset(16), flip(), shift({
      padding: 16
    })],
    whileElementsMounted: autoUpdate
  });
  useEffect(() => {
    setMounted(true);
    const updatePosition = () => {
      if (refs.setReference) {
        refs.setReference({
          getBoundingClientRect() {
            return {
              x: window.innerWidth - 16,
              y: 16,
              width: 0,
              height: 0,
              top: 16,
              right: window.innerWidth - 16,
              bottom: 16,
              left: window.innerWidth - 16
            };
          }
        });
      }
    };
    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, [refs.setReference]);
  if (!mounted || toasts.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(FloatingPortal, {
    children: /* @__PURE__ */ jsx("div", {
      ref: refs.setFloating,
      style: floatingStyles,
      className: "z-50 flex flex-col gap-2 pointer-events-none",
      children: toasts.map((toast) => /* @__PURE__ */ jsx("div", {
        className: "pointer-events-auto",
        children: /* @__PURE__ */ jsx(ToastItem, {
          toast,
          onClose: removeToast
        })
      }, toast.id))
    })
  });
};

const GlobalStyles = ({
  styles
}) => {
  useEffect(() => {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = styles;
    styleElement.setAttribute("data-global-styles", "true");
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [styles]);
  return null;
};

const pageOverrideStyles = `
  #body, body {
    overflow-y: scroll;
    background-color: white;
  }
  
  #root > * {
    min-width: 100%;
    width: 100%;
  }
`;
const PageCssOverrides = () => {
  return /* @__PURE__ */ jsx(GlobalStyles, {
    styles: pageOverrideStyles
  });
};

const fullViewportStyles = `
  .PlaygroundRoot {
    position: fixed;
    inset: 0;
    overflow: hidden;
  }
`;
const FullViewportCssOverrides = () => /* @__PURE__ */ jsx(GlobalStyles, {
  styles: fullViewportStyles
});

const ProfileCDNImageContextProvider = ({
  children
}) => {
  const {
    instance
  } = useProfileContext();
  const instanceName = instance && instance.instanceName;
  return /* @__PURE__ */ jsx(CDNImageContext.Provider, {
    value: {
      cdnRoot: IMAGE_CDN_ROOT,
      instanceName,
      baseUrl(instanceNameOverride) {
        return `${IMAGE_CDN_ROOT}${instanceNameOverride || instanceName}`;
      }
    },
    children
  });
};

const getToken = () => {
  try {
    return new URLSearchParams(window.location.search).get("token");
  } catch {
    return null;
  }
};
const stripToken = () => {
  try {
    const u = new URL(window.location.href);
    if (u.searchParams.has("token")) {
      u.searchParams.delete("token");
      window.history.replaceState({}, "", u.toString());
    }
  } catch {
  }
};
const ReaderTokenGate = ({
  children
}) => {
  const api = useApi();
  const [ready, setReady] = useState(() => !getToken());
  useEffect(() => {
    const token = getToken();
    if (!token)
      return;
    let cancelled = false;
    const run = async () => {
      try {
        await api.loginWithJwt(token);
      } catch {
      } finally {
        stripToken();
        if (!cancelled)
          setReady(true);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [api]);
  if (!ready)
    return null;
  return /* @__PURE__ */ jsx(Fragment, {
    children
  });
};

const DEFAULT_READER_PREFS = {
  font: "arabic-kufi",
  fontSize: 16,
  lineSpacing: 1.6,
  theme: "light"
};
const useReaderPrefs = (storageKey = "cair:reader-prefs") => useLocalStorageState$1(storageKey, {
  defaultValue: DEFAULT_READER_PREFS
});

const FONT_FAMILY = {
  inter: "Inter, sans-serif",
  times: '"Times New Roman", serif',
  opendyslexic: "OpenDyslexic, sans-serif",
  monospace: "monospace",
  "arabic-naskh": '"Noto Naskh Arabic", "Amiri", "Maqroo", serif',
  "arabic-kufi": 'droid_arabic_kufi, "Tajawal", "Noto Sans Arabic", sans-serif',
  "arabic-muna": 'MunaOT, droid_arabic_kufi, "Noto Sans Arabic", sans-serif'
};
const FONT_HREF = {
  opendyslexic: "https://fonts.cdnfonts.com/css/opendyslexic",
  "arabic-naskh": "https://fonts.googleapis.com/css2?family=NotoNaskhArabic:wght@400;700&family=Amiri:ital,wght@0,400;0,700;1,400&display=swap"
};
const FONT_LINK_ID = "cair-reader-font";
const CairThemeContext = createContext({
  theme: DEFAULT_READER_PREFS.theme,
  font: DEFAULT_READER_PREFS.font,
  fontSize: DEFAULT_READER_PREFS.fontSize,
  lineSpacing: DEFAULT_READER_PREFS.lineSpacing,
  setTheme: () => void 0,
  setFont: () => void 0,
  setFontSize: () => void 0,
  setLineSpacing: () => void 0,
  resetPrefs: () => void 0
});
const CairThemeProvider = ({
  children,
  storageKey
}) => {
  const [prefs, setPrefs] = useReaderPrefs(storageKey);
  const active = prefs || DEFAULT_READER_PREFS;
  useEffect(() => {
    document.body.setAttribute("data-cair-theme", active.theme);
    document.body.style.setProperty("--cair-reader-font-family", FONT_FAMILY[active.font]);
    document.body.style.setProperty("--cair-reader-font-size", `${active.fontSize}px`);
    document.body.style.setProperty("--cair-reader-line-spacing", `${active.lineSpacing}`);
    const href = FONT_HREF[active.font];
    let link = document.getElementById(FONT_LINK_ID);
    if (href) {
      if (!link) {
        link = document.createElement("link");
        link.id = FONT_LINK_ID;
        link.rel = "stylesheet";
        document.head.appendChild(link);
      }
      if (link.getAttribute("href") !== href)
        link.href = href;
    } else if (link) {
      link.remove();
    }
    return () => {
      document.body.removeAttribute("data-cair-theme");
      document.body.style.removeProperty("--cair-reader-font-family");
      document.body.style.removeProperty("--cair-reader-font-size");
      document.body.style.removeProperty("--cair-reader-line-spacing");
    };
  }, [active.theme, active.font, active.fontSize, active.lineSpacing]);
  const set = (patch) => setPrefs({
    ...active,
    ...patch
  });
  const value = {
    theme: active.theme,
    font: active.font,
    fontSize: active.fontSize,
    lineSpacing: active.lineSpacing,
    setTheme: (v) => set({
      theme: v
    }),
    setFont: (v) => set({
      font: v
    }),
    setFontSize: (v) => set({
      fontSize: v
    }),
    setLineSpacing: (v) => set({
      lineSpacing: v
    }),
    resetPrefs: () => setPrefs(DEFAULT_READER_PREFS)
  };
  return /* @__PURE__ */ jsx(CairThemeContext.Provider, {
    value,
    children
  });
};
const useCairTheme = () => useContext(CairThemeContext);

const CAIR_TOKENS_CSS = `
:root {
  /* Surfaces */
  --cair-surface-background:   #ffffff;
  --cair-surface:              #f2f2f2;
  --cair-surface-elevated:     #ffffff;
  --cair-surface-elevated-hover: #e8e8e8;

  /* Borders & Dividers */
  --cair-border:               #d9d9d9;
  --cair-border-strong:        #b3b3b3;
  --cair-divider:              #f2f2f2;

  /* Text */
  --cair-text:                 #020203;
  --cair-text-secondary:       #4d4d4e;
  --cair-text-tertiary:        #808081;

  /* Interactive \u2014 General */
  --cair-accent:               #1e2c44;
  --cair-accent-subtle:        #e8e9ec;
  --cair-accent-foreground:    #ffffff;
  --cair-accent-hover:         #2d4570;

  /* Interactive \u2014 Premium */
  --cair-premium:              #c7933f;
  --cair-premium-hover:        #9f7532;
  --cair-premium-subtle:       #f9f4eb;

  /* States */
  --cair-selection:            #e8e9ec;

  /* Status \u2014 Success */
  --cair-success-lightest:     #f6ffed;
  --cair-success-light:        #95de64;
  --cair-success-dark:         #389e0d;
  --cair-success-darker:       #237804;

  /* Status \u2014 Error */
  --cair-error-light:          #ff7875;
  --cair-error-dark:           #cf1322;
  --cair-error-darker:         #a8071a;

  /* Status \u2014 Info */
  --cair-info-darker:          #0050b3;

  /* Status \u2014 Warning */
  --cair-warning-dark:         #d48806;

  /* Disabled text (input placeholders) */
  --cair-text-disabled:        #b3b3b3;

  /* Neutral */
  --cair-white:                #ffffff;
  --cair-transparent:          #ffffff00;
  --cair-neutral-overlay:      #02020399;
  --cair-gold-lighter:         #f3e9d8;

  /* Border Radius */
  --cair-radius-sm:            4px;
  --cair-radius-md:            8px;
  --cair-radius-lg:            12px;

  /* Font Sizes */
  --cair-text-tiny:            12px;
  --cair-text-small:           14px;
  --cair-text-regular:         16px;
  --cair-text-large:           18px;

  /* Shadows */
  --cair-shadow-sm:            0px 1px 2px 0px rgba(0,0,0,0.05);
  --cair-shadow-md:            0px 4px 6px -2px rgba(0,0,0,0.08),
                               0px 12px 16px -4px rgba(0,0,0,0.08);
  --cair-shadow-float:         0px 4px 6px -4px rgba(0,0,0,0.1),
                               0px 10px 15px -3px rgba(0,0,0,0.1);
}

/* \u2500\u2500 Sepia theme overrides \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
/* Verified against Figma node 10447:19646 on 2026-03-27                    */
[data-cair-theme="sepia"] {
  --cair-surface-background:   #f5efe7;
  --cair-surface:              #ede4d8;
  --cair-surface-elevated:     #f5efe7;
  --cair-surface-elevated-hover: #e0d8ce;
  --cair-border:               #d4c4b0;
  --cair-border-strong:        #8b6f47;
  --cair-divider:              #ede4d8;
  --cair-text:                 #3d2817;
  --cair-text-secondary:       #4a3d28;
  --cair-text-tertiary:        #6b5638;
  --cair-text-disabled:        #d4c4b0;
  --cair-accent:               #8b6f47;
  --cair-accent-subtle:        #f5efe7;
  --cair-accent-foreground:    #ffffff;
  --cair-accent-hover:         #7a6140;
  --cair-selection:            #ede4d8;
  /* TODO: confirm against a Figma frame showing premium badge in sepia */
  --cair-premium-subtle:       #ede3d0;
}

/* \u2500\u2500 Dark theme overrides \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
/* Verified against Figma node 10447:19994 on 2026-03-27                    */
/* Design intent: accent=#ffffff (not gold \u2014 fails contrast on navy)         */
/*                borders use rgba alpha, not hex                            */
[data-cair-theme="dark"] {
  --cair-surface-background:   #090d14;
  --cair-surface:              #182336;
  --cair-surface-elevated:     #1e2c44;
  --cair-surface-elevated-hover: #2a3f60;
  --cair-border:               rgba(255, 255, 255, 0.10);
  --cair-border-strong:        rgba(255, 255, 255, 0.20);
  --cair-divider:              rgba(255, 255, 255, 0.05);
  --cair-text:                 #ffffff;
  --cair-text-secondary:       #f2f2f2;
  --cair-text-tertiary:        #d9d9d9;
  --cair-text-disabled:        #b3b3b3;
  --cair-accent:               #ffffff;
  --cair-accent-foreground:    #090d14;
  --cair-accent-subtle:        #1e2c44;
  --cair-accent-hover:         #2d4570;
  --cair-selection:            #1e2c44;
  --cair-neutral-overlay:      rgba(0, 0, 0, 0.60);
  /* TODO: confirm against a Figma frame showing premium badge in dark */
  --cair-premium-subtle:       #2a2215;
}

/* \u2500\u2500 Annotation highlights \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
/* Matches CSS.highlights key 'ann' in applyBookmarkHighlights.ts            */
/*                                                                            */
/* text-decoration inside ::highlight() is Chrome-only; background-color     */
/* is supported across Chrome, Edge, Firefox and Safari.                     */
/*                                                                            */
/* CSS custom properties (var()) do not resolve reliably inside              */
/* ::highlight() in Firefox and Edge, so theme accent colours are            */
/* repeated as literal rgba() values. The color-mix() declaration            */
/* overrides the literal in browsers that support it (Chrome, Safari 16.4+). */
/*                                                                            */
/* Accent hex values per theme:                                               */
/*   light  --cair-accent: #1e2c44  \u2192 rgba(30,  44,  68,  0.20)             */
/*   sepia  --cair-accent: #8b6f47  \u2192 rgba(139, 111, 71,  0.20)             */
/*   dark   --cair-accent: #ffffff  \u2192 rgba(255, 255, 255, 0.20)             */

::highlight(ann) {
  background-color: rgba(30, 44, 68, 0.20);
  background-color: color-mix(in srgb, #1e2c44 20%, transparent);
  color: inherit;
}

[data-cair-theme="sepia"] ::highlight(ann) {
  background-color: rgba(139, 111, 71, 0.20);
  background-color: color-mix(in srgb, #8b6f47 20%, transparent);
}

[data-cair-theme="dark"] ::highlight(ann) {
  background-color: rgba(255, 255, 255, 0.20);
  background-color: color-mix(in srgb, #ffffff 20%, transparent);
}

/* Plain-text search match \u2014 yellow, distinct from the accent annotation tint. */
::highlight(book-search) {
  background-color: rgba(255, 208, 0, 0.50);
  background-color: color-mix(in srgb, #ffd000 50%, transparent);
  color: inherit;
}

[data-cair-theme="dark"] ::highlight(book-search) {
  background-color: rgba(255, 208, 0, 0.40);
  background-color: color-mix(in srgb, #ffd000 40%, transparent);
}

`;
const CairTokensProvider = ({
  children,
  storageKey
}) => /* @__PURE__ */ jsxs(CairThemeProvider, {
  storageKey,
  children: [/* @__PURE__ */ jsx(GlobalStyles, {
    styles: CAIR_TOKENS_CSS
  }), children]
});

const defaultValue = {
  postId: "",
  post: null,
  postError: null,
  pageIds: [],
  totalPages: 0,
  isLoading: false,
  language: "",
  getPageId: () => null,
  getPageIndex: () => -1
};
const BookReaderContext = createContext(defaultValue);
const useBookReader = () => useContext(BookReaderContext);

const loadBookEntry = async (api, postId, options = {}) => {
  return api.get({
    path: `/book-cair/${postId}` + buildQueryString(options)
  });
};
const useBookPost = (postId) => {
  const api = useApi();
  const { language } = useLanguageSelectionContext();
  const { data, error, isValidating: isLoading, mutate } = useSWR(postId ? ["/book-cair/post", postId, language] : null, () => loadBookEntry(api, postId, { language }), swrLoadOnce);
  const reload = useMemoizedFn(async () => {
    await mutate();
  });
  return {
    post: data || null,
    isLoading,
    error,
    reload
  };
};

const BookReaderProvider = ({
  postId,
  children
}) => {
  const {
    post,
    isLoading,
    error
  } = useBookPost(postId);
  const value = useCreation(() => {
    const pageIds = post && post.pages && post.pages.length ? post.pages : post ? [post._id.toString()] : [];
    const language = post && post.language || "";
    return {
      postId,
      post: post || null,
      postError: error || null,
      pageIds,
      totalPages: pageIds.length,
      isLoading,
      language,
      getPageId: (index) => {
        if (index < 0 || index >= pageIds.length)
          return null;
        return pageIds[index];
      },
      getPageIndex: (id) => pageIds.indexOf(id)
    };
  }, [postId, post, error, isLoading]);
  return /* @__PURE__ */ jsx(BookReaderContext.Provider, {
    value,
    children
  });
};

const usePagesHeights = (options = {}) => {
  const {
    defaultHeight = 600,
    minHeight = 200,
    throttleMs = 300
  } = options;
  const [pageHeights, setPageHeights] = useState({});
  const calculateAverage = useMemoizedFn(() => {
    const knownHeights = Object.values(pageHeights);
    if (knownHeights.length === 0) {
      return defaultHeight;
    }
    const sum = knownHeights.reduce((acc, h) => acc + h, 0);
    return Math.round(sum / knownHeights.length);
  });
  const {
    run: throttledCalculateAverage
  } = useThrottleFn(calculateAverage, {
    wait: throttleMs
  });
  const averageHeight = useMemo(() => {
    return calculateAverage();
  }, [pageHeights, calculateAverage]);
  const updatePageHeight = useMemoizedFn((pageId, height) => {
    if (height < minHeight)
      return;
    if (pageHeights[pageId] === height)
      return;
    setPageHeights((prev) => ({
      ...prev,
      [pageId]: height
    }));
    throttledCalculateAverage();
  });
  const getEstimatedHeight = useMemoizedFn((pageId) => {
    if (pageHeights[pageId]) {
      return pageHeights[pageId];
    }
    return averageHeight;
  });
  const getTotalKnownPages = useMemoizedFn(() => {
    return Object.keys(pageHeights).length;
  });
  return {
    updatePageHeight,
    getEstimatedHeight,
    averageHeight,
    getTotalKnownPages
  };
};

const useChunkNavigation = () => {
  const {
    chunk
  } = useQueryStringParams();
  return useMemo(() => {
    if (!chunk) {
      return {
        pageId: null,
        chunkId: null
      };
    }
    const parts = chunk.split("-");
    return {
      pageId: parts[0] || null,
      chunkId: parts[1] || null
    };
  }, [chunk]);
};

const ReaderAnnotationContext = createContext(null);
const useReaderAnnotation = () => {
  const ctx = useContext(ReaderAnnotationContext);
  if (!ctx) {
    throw new Error("useReaderAnnotation must be used inside ReaderAnnotationProvider");
  }
  return ctx;
};

const usePageScrollTarget = ({
  chunkPageId,
  annotationPageId,
  resumePageId
}) => {
  const [targetPageId, setTargetPageId] = useState(null);
  const prevRef = useRef({
    chunk: null,
    annotation: null,
    resume: null,
    first: true
  });
  useEffect(() => {
    const prev = prevRef.current;
    const chunkNew = !!chunkPageId && chunkPageId !== prev.chunk;
    const annotationNew = !!annotationPageId && annotationPageId !== prev.annotation;
    const resumeNew = !!resumePageId && resumePageId !== prev.resume;
    let first = prev.first;
    if (chunkNew) {
      first = false;
      setTargetPageId(chunkPageId);
    } else if (annotationNew) {
      first = false;
      setTargetPageId(annotationPageId);
    } else if (resumeNew && first) {
      first = false;
      setTargetPageId(resumePageId);
    }
    prevRef.current = {
      chunk: chunkPageId,
      annotation: annotationPageId,
      resume: resumePageId,
      first
    };
  }, [chunkPageId, annotationPageId, resumePageId]);
  const clearTarget = useMemoizedFn(() => setTargetPageId(null));
  return { targetPageId, clearTarget };
};

const usePageVisibility = (options = {}) => {
  const {
    rootMargin = "200px",
    threshold = 0,
    triggerOnce = true
  } = options;
  const [isVisible, setIsVisible] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      const visible = entry.isIntersecting;
      setIsVisible(visible);
      if (visible) {
        setShouldLoad(true);
        if (triggerOnce && ref.current) {
          observer.unobserve(ref.current);
        }
      }
    }, {
      rootMargin,
      threshold
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, [rootMargin, threshold, triggerOnce]);
  return {
    ref,
    isVisible,
    shouldLoad
  };
};

const usePageHeight = (options = {}) => {
  const {
    defaultHeight = 600,
    minHeight = 200,
    onHeightChange
  } = options;
  const ref = useRef(null);
  const size = useSize(ref);
  const [measuredHeight, setMeasuredHeight] = useState(null);
  useEffect(() => {
    if (size && size.height && size.height >= minHeight) {
      const newHeight = size.height;
      setMeasuredHeight(newHeight);
      if (onHeightChange) {
        onHeightChange(newHeight);
      }
    }
  }, [size, minHeight, onHeightChange]);
  const height = measuredHeight || defaultHeight;
  const isHeightKnown = measuredHeight !== null;
  return {
    ref,
    height,
    isHeightKnown
  };
};

const PagePlaceholder = forwardRef(({
  height,
  pageNumber,
  error,
  className = ""
}, ref) => {
  return /* @__PURE__ */ jsx("div", {
    ref,
    className: `bg-gray-50 border border-gray-200 flex items-center justify-center ${className}`,
    style: {
      height
    },
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col items-center gap-2",
      children: [/* @__PURE__ */ jsx(Spinner, {}), pageNumber && /* @__PURE__ */ jsxs("span", {
        className: "text-gray-600",
        children: ["Loading page ", pageNumber, "..."]
      }), error && /* @__PURE__ */ jsx("div", {
        className: "text-red-500 text-sm text-center max-w-xs",
        children: error
      })]
    })
  });
});
PagePlaceholder.displayName = "PagePlaceholder";

const useBookPage = (index) => {
  const api = useApi();
  const { language } = useLanguageSelectionContext();
  const { getPageId } = useBookReader();
  const pageId = index !== null ? getPageId(index) : null;
  const { data, error, isValidating: isLoading, mutate } = useSWR(pageId ? ["/post-page", pageId, language] : null, () => loadPage(api, pageId, { language }), swrLoadOnce);
  const reload = useMemoizedFn(async () => {
    await mutate();
  });
  return {
    pageId,
    page: data || null,
    isLoading,
    error,
    reload
  };
};

const useTranslatePost = (requiresTranslation, post, language) => {
  const api = useApi();
  const postId = post._id;
  const { data } = useSWR(postId && requiresTranslation ? [`/post-view/${postId}/translate`, language] : null, () => api.post({
    path: `/post-view/${postId}/translate`,
    body: { language }
  }), { ...swrLoadOnce });
  return { ...data };
};

const postITooBigToTranslate = (post) => post && post.content && post.content.nsHtml && post.content.nsHtml.length >= 204800;
const usePostTranslation = (post) => {
  const ctx = useLanguageSelectionContext();
  const userLanguage = ctx.language;
  const requiresTranslation = !!(userLanguage && post.translate && !postITooBigToTranslate(post));
  const { html } = useTranslatePost(requiresTranslation, post, userLanguage);
  const translatedHtml = requiresTranslation && html ? html : null;
  const showWaiter = requiresTranslation && !translatedHtml;
  const rawHtml = translatedHtml || post.content && post.content.nsHtml || null;
  const displayLanguage = translatedHtml ? userLanguage : post.language || "";
  return { rawHtml, showWaiter, displayLanguage };
};

const TranslationWaiter = ({
  size = 20,
  wrapperClassName = "flex flex-col items-center gap-2 py-6",
  spinnerClassName = "animate-spin text-gray-400",
  labelClassName = "text-sm text-gray-400",
  label = "Translating\u2026"
}) => /* @__PURE__ */ jsxs("div", {
  className: wrapperClassName,
  children: [/* @__PURE__ */ jsx(CgSpinner, {
    size,
    className: spinnerClassName
  }), /* @__PURE__ */ jsx("span", {
    className: labelClassName,
    children: label
  })]
});

const HtmlContent = ({
  html,
  dir = "auto",
  className,
  style
}) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el)
      return;
    el.querySelectorAll("table").forEach((table) => {
      if (table.parentElement && table.parentElement.dataset["tableScroll"])
        return;
      const wrapper = document.createElement("div");
      wrapper.dataset["tableScroll"] = "1";
      wrapper.style.overflowX = "auto";
      wrapper.style.width = "100%";
      wrapper.style.marginBottom = "0";
      const parent = table.parentElement;
      if (!parent)
        return;
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
    const imgs = el.querySelectorAll("img");
    if (!imgs.length)
      return;
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting)
          return;
        const img = entry.target;
        const src = img.getAttribute("data-src");
        if (src) {
          img.src = src;
          img.removeAttribute("data-src");
        }
        obs.unobserve(img);
      });
    }, {
      rootMargin: "50px",
      threshold: 0.01
    });
    imgs.forEach((img) => {
      if (img.src) {
        const proxied = rewriteImgixUrl(img.src);
        img.setAttribute("data-src", proxied || img.src);
        img.removeAttribute("src");
      }
      observer.observe(img);
    });
    return () => observer.disconnect();
  }, [html]);
  return /* @__PURE__ */ jsx("div", {
    ref,
    dir,
    style,
    className: ["html-content", className || ""].join(" ").trim(),
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};

const BookReaderHtmlContent = (props) => /* @__PURE__ */ jsx(HtmlContent, {
  ...props,
  className: ["book-cair-page-content mce-content-body", props.className || ""].join(" ").trim()
});

const TINY_CONTENT_CSS = `
  .mce-content-body {
    margin: 0;
    font-size: var(--cair-reader-font-size, 14px);
    line-height: var(--cair-reader-line-spacing, 2.0);
    font-family: var(--cair-reader-font-family, 'droid_arabic_kufi', 'Helvetica', 'roboto', serif);
    overflow-x: clip;   /* blocks bleed-out without creating a scroll context */
    overflow-y: visible;
  }

  .mce-content-body a {
    color: rgb(85, 26, 139);
    cursor: pointer;
    text-decoration: underline;
  }

  .mce-content-body ol,
  .mce-content-body ul {
    margin: 1em 0;
    padding-left: 2.5em;
    list-style-position: outside;
  }

  .mce-content-body ul {
    list-style-type: disc;
  }

  .mce-content-body ol {
    list-style-type: decimal;
  }

  .mce-content-body li {
    margin: 0.5em 0;
    padding-left: 0.5em;
  }

  .mce-content-body ul ul          { list-style-type: circle; }
  .mce-content-body ul ul ul       { list-style-type: square; }
  .mce-content-body ol ol          { list-style-type: lower-alpha; }
  .mce-content-body ol ol ol       { list-style-type: lower-roman; }

  .mce-content-body[dir="rtl"] ol,
  .mce-content-body[dir="rtl"] ul {
    padding-left: 0;
    padding-right: 2.5em;
  }

  .mce-content-body[dir="rtl"] li {
    padding-left: 0;
    padding-right: 0.5em;
  }

  .mce-content-body blockquote {
    margin: 1em 0;
    padding: 1em 1.5em;
    border-left: 4px solid rgb(85, 26, 139);
    background-color: rgba(85, 26, 139, 0.05);
    font-style: italic;
    color: rgba(0, 0, 0, 0.8);
  }

  .mce-content-body blockquote p        { margin: 0.5em 0; }
  .mce-content-body blockquote p:first-child { margin-top: 0; }
  .mce-content-body blockquote p:last-child  { margin-bottom: 0; }

  .mce-content-body[dir="rtl"] blockquote {
    border-left: none;
    border-right: 4px solid rgb(85, 26, 139);
  }

  .mce-content-body h1,
  .mce-content-body h2,
  .mce-content-body h3,
  .mce-content-body h4,
  .mce-content-body h5,
  .mce-content-body h6 {
    font-weight: bold;
    line-height: 1.1;
    margin-top: 1em;
    margin-bottom: 1em;
  }

  .mce-content-body h1 { font-size: 24px; }
  .mce-content-body h2 { font-size: 20px; }
  .mce-content-body h3 { font-size: 16px; }

  .mce-content-body p {
   font-size: var(--cair-reader-font-size, 14px);
   line-height: var(--cair-reader-line-spacing, 2.0);
  }

  .mce-content-body img {
    max-width: 100%;
    height: auto;
  }

  .url-preview-header {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    align-items: center;
  }

  .mce-content-body table {
    border-collapse: collapse;
    width: 100%;
    margin: 1.5em 0;
  }

  .mce-content-body th,
  .mce-content-body td {
    border: 2px solid var(--cair-border-strong);
    padding: 10px;
    text-align: left;
  }

  .mce-content-body[dir="rtl"] th,
  .mce-content-body[dir="rtl"] td {
    text-align: right;
  }

  .mce-content-body th {
    background-color: var(--cair-surface);
    font-weight: bold;
  }

  .mce-content-body .pdf-page {
    overflow-y: hidden;
  }  
    
  .html-content[dir="auto"] :where(p, h1, h2, h3, h4, h5, h6, li, blockquote, td, th):not([dir]) {
    unicode-bidi: plaintext;
    text-align: start;
  }
`;
const TinyContentStyles = () => /* @__PURE__ */ jsx(GlobalStyles, {
  styles: TINY_CONTENT_CSS
});

const BookReaderContent = ({
  post
}) => {
  const {
    rawHtml,
    showWaiter,
    displayLanguage
  } = usePostTranslation(post);
  if (!rawHtml && !showWaiter)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "relative w-full px-4 py-6 bg-[var(--cair-surface-background)] text-[color:var(--cair-text)]",
    lang: displayLanguage,
    style: {
      fontFamily: "var(--cair-reader-font-family)",
      fontSize: "var(--cair-reader-font-size)",
      lineHeight: "var(--cair-reader-line-spacing)"
    },
    children: [/* @__PURE__ */ jsx(TinyContentStyles, {}), showWaiter && /* @__PURE__ */ jsx(TranslationWaiter, {}), rawHtml && /* @__PURE__ */ jsx(BookReaderHtmlContent, {
      html: rawHtml,
      dir: "auto"
    })]
  });
};

const HIGHLIGHT_KEY$1 = "ann";
let sharedHighlight$1 = null;
const getSharedHighlight$1 = () => {
  if (!sharedHighlight$1) {
    const HighlightCtor = window.Highlight;
    sharedHighlight$1 = new HighlightCtor();
    CSS.highlights.set(HIGHLIGHT_KEY$1, sharedHighlight$1);
    console.log('[ann] shared Highlight instance created and registered as "ann"');
  }
  return sharedHighlight$1;
};
const pageRanges = new WeakMap();
const pageRangeToEntry = new WeakMap();
const activeHandlers = new WeakMap();
const BOOKMARK_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12"><path d="M0 0h10v12l-5-3.6L0 12V0z" fill="var(--cair-accent)"/></svg>`;
const NOTE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11"><rect x="0" y="0" width="11" height="11" rx="2" fill="var(--cair-premium)"/><rect x="2" y="3" width="7" height="1.3" rx="0.6" fill="var(--cair-surface)"/><rect x="2" y="5.5" width="5" height="1.3" rx="0.6" fill="var(--cair-surface)"/><rect x="2" y="8" width="6" height="1.3" rx="0.6" fill="var(--cair-surface)"/></svg>`;
const walkTextNodes = (root) => {
  const segments = [];
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let accumulated = 0;
  let node = walker.nextNode();
  while (node) {
    const len = node.length;
    segments.push({ node, rawStart: accumulated, rawEnd: accumulated + len });
    accumulated += len;
    node = walker.nextNode();
  }
  return segments;
};
const resolveOffset = (segments, globalOffset, atEnd = false) => {
  for (let i = 0; i < segments.length; i++) {
    const seg = segments[i];
    if (globalOffset >= seg.rawStart && globalOffset < seg.rawEnd) {
      return { node: seg.node, localOffset: globalOffset - seg.rawStart };
    }
    if (atEnd && globalOffset === seg.rawEnd) {
      return { node: seg.node, localOffset: seg.node.length };
    }
  }
  return null;
};
const insertAnchorAtRangeEnd = (anchor, range) => {
  const endNode = range.endContainer;
  const endOffset = range.endOffset;
  const endParent = endNode.parentElement;
  if (!endParent) {
    console.warn("[ann] insertAnchorAtRangeEnd \u2014 endContainer has no parentElement, skipping");
    return;
  }
  if (endOffset >= endNode.length) {
    endParent.insertBefore(anchor, endNode.nextSibling);
    console.log("[ann] anchor (A \u2014 end of node) inside", endParent.tagName);
  } else {
    const afterNode = endNode.splitText(endOffset);
    endParent.insertBefore(anchor, afterNode);
    console.log("[ann] anchor (B \u2014 mid-text split) inside", endParent.tagName, "at offset", endOffset);
  }
};
const removeAnnotationHighlights = (root) => {
  console.log("[ann] removeAnnotationHighlights for page", root.getAttribute("data-page-id"));
  const highlight = sharedHighlight$1;
  const ranges = pageRanges.get(root);
  if (highlight && ranges) {
    ranges.forEach((r) => highlight.delete(r));
    console.log("[ann] removed", ranges.size, "range(s) from shared Highlight \u2014 remaining:", highlight.size);
  }
  pageRanges.delete(root);
  pageRangeToEntry.delete(root);
  const anchors = root.querySelectorAll("[data-annotation-anchor]");
  console.log("[ann] removing", anchors.length, "anchor span(s)");
  anchors.forEach((el) => el.remove());
  root.normalize();
  const handler = activeHandlers.get(root);
  if (handler) {
    root.removeEventListener("pointerdown", handler);
    activeHandlers.delete(root);
    console.log("[ann] pointerdown listener removed");
  }
  if (highlight && highlight.size === 0) {
    CSS.highlights.delete(HIGHLIGHT_KEY$1);
    sharedHighlight$1 = null;
    console.log("[ann] shared Highlight cleared \u2014 no ranges remain");
  }
};
const applyBookmarkHighlights = (root, entries, onEntryClick) => {
  console.group("[ann] applyBookmarkHighlights \u2014 page", root.getAttribute("data-page-id"));
  console.log("entries:", entries.length, entries.map((e) => ({ id: e.id, type: e.type, startOffset: e.startOffset, endOffset: e.endOffset })));
  if (typeof CSS === "undefined" || !("highlights" in CSS)) {
    console.error("[ann] CSS Custom Highlight API is not supported in this browser");
    console.groupEnd();
    return;
  }
  removeAnnotationHighlights(root);
  if (!entries.length) {
    console.log("[ann] no entries for this page \u2014 done");
    console.groupEnd();
    return;
  }
  const segments = walkTextNodes(root);
  console.log("[ann] segments:", segments.length, segments.map((s) => ({ rawStart: s.rawStart, rawEnd: s.rawEnd, text: s.node.textContent ? s.node.textContent.slice(0, 40) : "" })));
  const highlight = getSharedHighlight$1();
  const myRanges = new Set();
  const rangeToEntry = new Map();
  const resolved = [];
  entries.forEach((entry) => {
    console.group("[ann] resolving entry", entry.id);
    const start = resolveOffset(segments, entry.startOffset, false);
    const end = resolveOffset(segments, entry.endOffset, true);
    console.log("startOffset:", entry.startOffset, "\u2192", start);
    console.log("endOffset:  ", entry.endOffset, "\u2192", end);
    if (!start || !end) {
      console.warn("[ann] could not resolve offsets \u2014 entry skipped");
      console.groupEnd();
      return;
    }
    const range = document.createRange();
    range.setStart(start.node, start.localOffset);
    range.setEnd(end.node, end.localOffset);
    console.log("range text:", range.toString().slice(0, 60));
    console.log("endContainer:", range.endContainer.nodeName, "| endOffset:", range.endOffset, "| endNode.length:", range.endContainer.length, "| parentElement:", range.endContainer.parentElement);
    highlight.add(range);
    myRanges.add(range);
    rangeToEntry.set(range, entry);
    resolved.push({ entry, range });
    console.groupEnd();
  });
  pageRanges.set(root, myRanges);
  pageRangeToEntry.set(root, rangeToEntry);
  console.log("[ann] resolved:", resolved.length, "/", entries.length, "| shared Highlight total size:", highlight.size);
  let highlightRuleFound = false;
  for (let i = 0; i < document.styleSheets.length; i++) {
    try {
      const rules = document.styleSheets[i].cssRules;
      for (let j = 0; j < rules.length; j++) {
        if (rules[j].cssText && rules[j].cssText.includes("::highlight(ann)")) {
          highlightRuleFound = true;
          console.log("[ann] ::highlight(ann) rule found in stylesheet", i, ":", rules[j].cssText.slice(0, 120));
        }
      }
    } catch (_) {
    }
  }
  if (!highlightRuleFound) {
    console.warn("[ann] ::highlight(ann) CSS rule NOT found in any stylesheet \u2014 highlights will be invisible");
  }
  resolved.forEach(({ entry, range }) => {
    const anchor = document.createElement("span");
    anchor.setAttribute("data-annotation-anchor", entry.id);
    anchor.style.cssText = "position:relative;width:0;display:inline";
    const icon = document.createElement("span");
    icon.style.cssText = [
      "position:absolute",
      "top:0",
      "inset-inline-start:2px",
      "display:inline-flex",
      "align-items:center",
      "line-height:0",
      "cursor:pointer",
      "user-select:none"
    ].join(";");
    icon.innerHTML = entry.type === "note" ? NOTE_SVG : BOOKMARK_SVG;
    icon.addEventListener("click", (e) => {
      e.stopPropagation();
      onEntryClick(entry);
    });
    anchor.appendChild(icon);
    insertAnchorAtRangeEnd(anchor, range);
  });
  const clickHandler = (e) => {
    const pe = e;
    let offsetNode = null;
    let offset = 0;
    if (typeof document.caretPositionFromPoint === "function") {
      const pos = document.caretPositionFromPoint(pe.clientX, pe.clientY);
      if (pos) {
        offsetNode = pos.offsetNode;
        offset = pos.offset;
      }
    } else if (typeof document.caretRangeFromPoint === "function") {
      const r = document.caretRangeFromPoint(pe.clientX, pe.clientY);
      if (r) {
        offsetNode = r.startContainer;
        offset = r.startOffset;
      }
    }
    if (!offsetNode)
      return;
    const map = pageRangeToEntry.get(root);
    if (!map)
      return;
    for (const [range, entry] of map) {
      if (range.isPointInRange(offsetNode, offset)) {
        console.log("[ann] click matched entry", entry.id);
        onEntryClick(entry);
        return;
      }
    }
  };
  root.addEventListener("pointerdown", clickHandler);
  activeHandlers.set(root, clickHandler);
  console.log("[ann] pointerdown listener attached");
  console.groupEnd();
};

const useAnnotationHighlights = (rootRef, page, entries, onEntryClick) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root || !page)
      return;
    applyBookmarkHighlights(root, entries, onEntryClick);
    return () => removeAnnotationHighlights(root);
  }, [page, entries, onEntryClick]);
};

const keepElementInViewWithObserver = (element, options = {}) => {
  if (!element) {
    return () => {
    };
  }
  const {
    maxDuration = 1e4,
    stableTime = 2e3,
    scrollOptions = {
      behavior: "smooth",
      block: "center",
      inline: "nearest"
    },
    visibilityThreshold = 0.1,
    onStabilized,
    onTimeout
  } = options;
  let stableTimer = null;
  let maxTimer = null;
  let isCleanedUp = false;
  const startTime = Date.now();
  const cleanup = () => {
    if (isCleanedUp)
      return;
    isCleanedUp = true;
    observer.disconnect();
    if (stableTimer) {
      clearTimeout(stableTimer);
      stableTimer = null;
    }
    if (maxTimer) {
      clearTimeout(maxTimer);
      maxTimer = null;
    }
  };
  const handleIntersection = (entries) => {
    if (isCleanedUp)
      return;
    const entry = entries[0];
    const isVisible = entry && entry.isIntersecting;
    if (isVisible) {
      if (!stableTimer) {
        stableTimer = setTimeout(() => {
          if (!isCleanedUp) {
            if (onStabilized) {
              onStabilized();
            }
            cleanup();
          }
        }, stableTime);
      }
    } else {
      if (stableTimer) {
        clearTimeout(stableTimer);
        stableTimer = null;
      }
      const elapsedTime = Date.now() - startTime;
      if (elapsedTime < maxDuration && !isCleanedUp) {
        requestAnimationFrame(() => {
          if (!isCleanedUp) {
            element.scrollIntoView(scrollOptions);
          }
        });
      }
    }
  };
  const observer = new IntersectionObserver(handleIntersection, {
    threshold: visibilityThreshold,
    rootMargin: "50px"
  });
  element.scrollIntoView(scrollOptions);
  observer.observe(element);
  maxTimer = setTimeout(() => {
    if (!isCleanedUp) {
      if (onTimeout) {
        onTimeout();
      }
      cleanup();
    }
  }, maxDuration);
  return cleanup;
};

const useScrollToAnnotation = (rootRef, page, entries, scrollToAnnotationId, onScrolled) => {
  useEffect(() => {
    if (!scrollToAnnotationId || !page)
      return;
    const root = rootRef.current;
    if (!root)
      return;
    const anchor = root.querySelector(`[data-annotation-anchor="${scrollToAnnotationId}"]`);
    if (!anchor)
      return;
    return keepElementInViewWithObserver(anchor, {
      onStabilized: onScrolled,
      onTimeout: onScrolled
    });
  }, [page, entries, scrollToAnnotationId, onScrolled]);
};

const splitHtmlIntoChunks = (rootElement, chunkSize) => {
  const chunks = [];
  let currentChunk = [];
  let currentSize = 0;
  const accumulateText = (element) => {
    const childNodes = element.childNodes;
    for (const node of childNodes) {
      if (node.nodeType === Node.TEXT_NODE) {
        const size = node.textContent.trim().length;
        if (!size) {
          continue;
        }
        currentSize += 1 + size;
        currentChunk.push(node);
        if (currentSize > chunkSize) {
          currentSize = 0;
          chunks.push(currentChunk);
          currentChunk = [];
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        accumulateText(node);
      }
    }
  };
  accumulateText(rootElement);
  if (currentChunk.length) {
    chunks.push(currentChunk);
  }
  return chunks;
};
const unwrapTextNodes = (root) => {
  const spans = root.querySelectorAll("span.__ns-chunk-marker");
  spans.forEach((span) => {
    const textNode = document.createTextNode(span.textContent || "");
    const parentElement = span.parentNode;
    if (parentElement) {
      parentElement.insertBefore(textNode, span);
      parentElement.removeChild(span);
    }
  });
};

const useVectorSearchOptions = (circleId, options) => {
  const api = useApi();
  const type = "vector-store";
  const result = useSWR(circleId !== "wait" ? [`/admin/options`, type, circleId] : null, async (path) => {
    const data = await api.get({
      path: path + "?type=" + type + "&circleId=" + (circleId || "")
    });
    return data;
  }, {
    ...swrLoadOnce,
    refreshInterval: 1e3 * 60 * 5,
    ...options
  });
  return {
    ...result
  };
};

const wrapAndGetFirstTextNode = (chunk) => {
  if (chunk.length === 0) {
    console.log("No text nodes provided");
    return null;
  }
  let firstSpanElement = null;
  chunk.forEach((node, index) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const spanElement = document.createElement("span");
      spanElement.className = "__ns-chunk-marker";
      spanElement.style.color = "blue";
      spanElement.style.backgroundColor = "yellow";
      spanElement.textContent = node.textContent;
      const parentElement = node.parentNode;
      if (parentElement) {
        parentElement.insertBefore(spanElement, node);
        parentElement.removeChild(node);
        if (!firstSpanElement) {
          firstSpanElement = spanElement;
        }
      }
    }
  });
  return firstSpanElement;
};

const useScrollToChunk = ({ scrollRef, page }) => {
  const { pageId: chunkPageId, chunkId } = useChunkNavigation();
  const circleId = page ? postGroupId(page) : "";
  const { data } = useVectorSearchOptions(circleId || "wait");
  const chunkSize = data && data.options && (data.options.chunkSize || 1);
  const isMatch = !!(page && chunkPageId && page._id === chunkPageId && chunkId);
  useEffect(() => {
    if (!isMatch || !chunkSize)
      return;
    const container = scrollRef.current;
    if (!container)
      return;
    const root = container.querySelector(".book-cair-page-content");
    if (!root)
      return;
    unwrapTextNodes(root);
    const chunks = splitHtmlIntoChunks(root, chunkSize * 1e3);
    const idx = parseInt(chunkId, 10);
    if (isNaN(idx))
      return;
    const chunk = chunks[idx];
    if (!chunk)
      return;
    const firstSpan = wrapAndGetFirstTextNode(chunk);
    if (!firstSpan)
      return;
    const cleanup = keepElementInViewWithObserver(firstSpan, {
      scrollOptions: { behavior: "instant", block: "center" }
    });
    return cleanup;
  }, [isMatch, chunkId, chunkSize, scrollRef]);
};

const HIGHLIGHT_KEY = "book-search";
const supported = () => typeof CSS !== "undefined" && "highlights" in CSS && typeof window.Highlight === "function";
let sharedHighlight = null;
const getSharedHighlight = () => {
  if (!sharedHighlight) {
    sharedHighlight = new window.Highlight();
    CSS.highlights.set(HIGHLIGHT_KEY, sharedHighlight);
  }
  return sharedHighlight;
};
const clearSearchHighlight = () => {
  if (typeof CSS === "undefined" || !("highlights" in CSS))
    return;
  CSS.highlights.delete(HIGHLIGHT_KEY);
  sharedHighlight = null;
};
const AR_DIACRITIC = /[ً-ْٰـ]/;
const AR_ALEF = /[آأإٱ]/;
const normalizeQuery = (q) => (q || "").trim().replace(/[ً-ْٰـ]/g, "").replace(/[آأإٱ]/g, "\u0627").replace(/\s+/g, " ").toLowerCase();
const buildNormalized = (root) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let text = "";
  const map = [];
  let prevSpace = true;
  let node = walker.nextNode();
  while (node) {
    const data = node.data;
    for (let i = 0; i < data.length; i++) {
      const ch = data[i];
      if (/\s/.test(ch)) {
        if (prevSpace)
          continue;
        text += " ";
        map.push({ node, offset: i });
        prevSpace = true;
      } else if (AR_DIACRITIC.test(ch)) {
        continue;
      } else {
        text += AR_ALEF.test(ch) ? "\u0627" : ch.toLowerCase();
        map.push({ node, offset: i });
        prevSpace = false;
      }
    }
    node = walker.nextNode();
  }
  return { text, map };
};
const locateRange = (root, query, occurrence) => {
  const needle = normalizeQuery(query);
  if (!needle)
    return null;
  const { text, map } = buildNormalized(root);
  const hay = text.toLowerCase();
  const starts = [];
  let from = 0;
  while (true) {
    const i = hay.indexOf(needle, from);
    if (i === -1)
      break;
    starts.push(i);
    from = i + needle.length;
  }
  if (starts.length === 0)
    return null;
  const useIndex = occurrence < starts.length ? occurrence : 0;
  const idx = starts[useIndex];
  const startPos = map[idx];
  const endPos = map[idx + needle.length - 1];
  if (!startPos || !endPos)
    return null;
  const range = document.createRange();
  range.setStart(startPos.node, startPos.offset);
  range.setEnd(endPos.node, endPos.offset + 1);
  return range;
};
const showSearchHighlight = (root, query, occurrence) => {
  if (!supported())
    return null;
  const range = locateRange(root, query, occurrence);
  if (!range)
    return null;
  const highlight = getSharedHighlight();
  highlight.add(range);
  const anchor = range.startContainer.parentElement || root;
  const stopObserver = keepElementInViewWithObserver(anchor, {
    scrollOptions: { behavior: "smooth", block: "center" }
  });
  return () => {
    if (stopObserver)
      stopObserver();
    try {
      highlight.delete(range);
    } catch (_) {
    }
    if (highlight.size === 0)
      clearSearchHighlight();
  };
};

const ReaderSearchContext = createContext(null);
const useReaderSearch = () => {
  const ctx = useContext(ReaderSearchContext);
  if (!ctx) {
    throw new Error("useReaderSearch must be used inside ReaderSearchProvider");
  }
  return ctx;
};

const RETRY_INTERVAL_MS = 150;
const MAX_RETRIES = 60;
const useSearchHighlight = ({ scrollRef, page }) => {
  const { activeHighlight } = useReaderSearch();
  const isMatch = !!(page && activeHighlight && String(page._id) === activeHighlight.pageId);
  const query = activeHighlight ? activeHighlight.query : "";
  const occurrence = activeHighlight ? activeHighlight.occurrence : 0;
  const token = activeHighlight ? activeHighlight.token : 0;
  useEffect(() => {
    if (!isMatch || !query)
      return;
    let cleanup = null;
    let cancelled = false;
    let tries = 0;
    let timer = null;
    const attempt = () => {
      if (cancelled)
        return;
      const container = scrollRef.current;
      const root = container ? container.querySelector(".book-cair-page-content") : null;
      if (root && root.textContent && root.textContent.trim().length > 0) {
        cleanup = showSearchHighlight(root, query, occurrence);
        if (cleanup)
          return;
      }
      tries++;
      if (tries < MAX_RETRIES) {
        timer = setTimeout(attempt, RETRY_INTERVAL_MS);
      }
    };
    attempt();
    return () => {
      cancelled = true;
      if (timer)
        clearTimeout(timer);
      if (cleanup)
        cleanup();
    };
  }, [isMatch, query, occurrence, token, scrollRef]);
};

const EMPTY_ENTRIES = [];
const BookReaderPage = ({
  pageIndex,
  estimatedHeight,
  onHeightChange,
  shouldPreload,
  isTargetPage,
  onScrolled
}) => {
  const scrollRef = useRef(null);
  const {
    ref: visibilityRef,
    shouldLoad
  } = usePageVisibility();
  const hasLoadedRef = useRef(false);
  const {
    getPageId
  } = useBookReader();
  const {
    activeHighlight
  } = useReaderSearch();
  const thisPageId = getPageId(pageIndex);
  const isSearchTarget = !!(activeHighlight && thisPageId && activeHighlight.pageId === thisPageId);
  const shouldFetch = shouldLoad || shouldPreload || isTargetPage || isSearchTarget || hasLoadedRef.current;
  const {
    pageId,
    page
  } = useBookPage(shouldFetch ? pageIndex : null);
  if (page && !hasLoadedRef.current)
    hasLoadedRef.current = true;
  const {
    ref: heightRef
  } = usePageHeight({
    defaultHeight: estimatedHeight,
    onHeightChange: useMemoizedFn((height) => {
      if (page) {
        onHeightChange(page._id, height);
      }
    })
  });
  const onScrolledStable = useMemoizedFn(() => onScrolled && onScrolled());
  useEffect(() => {
    if (!isTargetPage || !page || !scrollRef.current)
      return;
    const rafId = requestAnimationFrame(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollIntoView({
          block: "start"
        });
        onScrolledStable();
      }
    });
    return () => cancelAnimationFrame(rafId);
  }, [isTargetPage, page]);
  const {
    annotations,
    scrollToAnnotationId,
    clearAnnotationScroll,
    setActiveAnnotation
  } = useReaderAnnotation();
  const pageEntries = useCreation(() => pageId ? annotations.filter((a) => a.pageId === pageId) : EMPTY_ENTRIES, [annotations, pageId]);
  useAnnotationHighlights(scrollRef, page, pageEntries, setActiveAnnotation);
  useScrollToAnnotation(scrollRef, page, pageEntries, scrollToAnnotationId, clearAnnotationScroll);
  useScrollToChunk({
    scrollRef,
    page
  });
  useSearchHighlight({
    scrollRef,
    page
  });
  if (!shouldFetch) {
    return /* @__PURE__ */ jsx(PagePlaceholder, {
      ref: visibilityRef,
      height: estimatedHeight,
      pageNumber: pageIndex + 1
    });
  }
  if (!page) {
    return /* @__PURE__ */ jsx(PagePlaceholder, {
      ref: heightRef,
      height: estimatedHeight,
      pageNumber: pageIndex + 1
    });
  }
  return /* @__PURE__ */ jsx("div", {
    ref: (node) => {
      heightRef.current = node;
      scrollRef.current = node;
    },
    className: "border-b border-[var(--cair-border)] last:border-b-0",
    "data-page-id": pageId,
    children: /* @__PURE__ */ jsx(BookReaderContent, {
      post: page
    })
  });
};

const BookReaderPages = ({
  resumePageId
}) => {
  const {
    totalPages,
    getPageId,
    getPageIndex
  } = useBookReader();
  const {
    updatePageHeight,
    averageHeight
  } = usePagesHeights();
  const {
    pageId: chunkPageId
  } = useChunkNavigation();
  const history = useHistory();
  const {
    annotations,
    scrollToAnnotationId,
    clearAnnotationScroll
  } = useReaderAnnotation();
  const annotationPageId = scrollToAnnotationId ? (annotations.find((a) => a.id === scrollToAnnotationId) || {
    pageId: ""
  }).pageId : null;
  const {
    targetPageId,
    clearTarget
  } = usePageScrollTarget({
    chunkPageId: chunkPageId || null,
    annotationPageId,
    resumePageId: resumePageId || null
  });
  useEffect(() => {
    if (chunkPageId) {
      clearAnnotationScroll();
    }
  }, [chunkPageId, clearAnnotationScroll]);
  const handleScrolled = useMemoizedFn(() => {
    if (chunkPageId) {
      history.replace({
        hash: ""
      });
    }
    clearTarget();
  });
  if (!totalPages)
    return null;
  const chunkTargetIndex = chunkPageId ? getPageIndex(chunkPageId) : -1;
  return /* @__PURE__ */ jsx("div", {
    className: "w-full",
    children: Array.from({
      length: totalPages
    }, (_, index) => {
      const pageId = getPageId(index);
      const isTargetPage = !!(targetPageId && pageId === targetPageId);
      const shouldPreload = chunkTargetIndex >= 0 && index === chunkTargetIndex;
      return /* @__PURE__ */ jsx(BookReaderPage, {
        pageIndex: index,
        estimatedHeight: averageHeight,
        onHeightChange: updatePageHeight,
        shouldPreload,
        isTargetPage,
        onScrolled: isTargetPage ? handleScrolled : void 0
      }, pageId || index);
    })
  });
};

const PanelShell = ({
  icon,
  title,
  titleColor = "accent",
  onClose,
  footer,
  children,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: ["panel-shell", "bg-[var(--cair-surface-elevated)]", "border-b border-[var(--cair-border-strong)]", "flex flex-col items-start", "flex-1 min-h-0", "rounded-tl-[var(--cair-radius-lg)] rounded-tr-[var(--cair-radius-lg)]", "shadow-[var(--cair-shadow-sm)]", "w-full", className || ""].join(" "),
  children: [/* @__PURE__ */ jsx("div", {
    className: "bg-[var(--cair-surface-elevated)] border-b border-[var(--cair-border)] rounded-tl-[var(--cair-radius-lg)] rounded-tr-[var(--cair-radius-lg)] shrink-0 w-full",
    children: /* @__PURE__ */ jsx("div", {
      className: "flex items-start pb-[17px] pt-[16px] px-[16px]",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex flex-1 items-center justify-between min-w-0",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex gap-[8px] items-center shrink-0",
          children: [/* @__PURE__ */ jsx("span", {
            className: "shrink-0 w-[20px] h-[20px] flex items-center justify-center",
            children: icon
          }), /* @__PURE__ */ jsx("span", {
            className: ["font-medium leading-[1.75]", "text-[length:var(--cair-text-small)] whitespace-nowrap", titleColor === "premium" ? "text-[color:var(--cair-premium)]" : "text-[color:var(--cair-accent)]"].join(" "),
            children: title
          })]
        }), /* @__PURE__ */ jsx("button", {
          onClick: onClose,
          className: "shrink-0 w-[20px] h-[20px] flex items-center justify-center",
          "aria-label": "Close",
          children: /* @__PURE__ */ jsx(MdClose, {
            size: 20,
            className: "text-[color:var(--cair-text-secondary)]"
          })
        })]
      })
    })
  }), /* @__PURE__ */ jsx("div", {
    className: "flex-1 overflow-y-auto min-h-0 w-full",
    children
  }), footer && /* @__PURE__ */ jsx("div", {
    className: "bg-[var(--cair-surface)] border-t border-[var(--cair-border)] shrink-0 w-full",
    children: /* @__PURE__ */ jsx("div", {
      className: "flex gap-[8px] items-start pb-[16px] pt-[17px] px-[16px]",
      children: footer
    })
  })]
});

const optionCell = cva("flex flex-col items-start px-[12px] py-[8px] rounded-[var(--cair-radius-md)] cursor-pointer w-full", {
  variants: {
    selected: {
      true: "bg-[var(--cair-surface)] border border-[var(--cair-border-strong)]",
      false: "bg-[var(--cair-surface-elevated)] border border-[var(--cair-border)]"
    }
  },
  defaultVariants: {
    selected: false
  }
});
const PanelOptionCell = ({
  primary,
  secondary,
  selected,
  onClick,
  primaryClassName,
  primaryDir,
  primaryStyle
}) => /* @__PURE__ */ jsxs("button", {
  onClick,
  className: optionCell({
    selected
  }),
  style: selected ? {
    outline: "2px solid var(--cair-accent)",
    outlineOffset: "1px"
  } : {},
  children: [/* @__PURE__ */ jsx("span", {
    dir: primaryDir,
    className: ["font-medium text-[length:var(--cair-text-small)] text-[color:var(--cair-text)]", "leading-[1.75] h-[28px] flex items-center w-full", primaryClassName || ""].join(" "),
    style: primaryStyle,
    children: primary
  }), /* @__PURE__ */ jsx("span", {
    className: "font-normal text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] leading-[1.5] h-[28px] flex items-center",
    children: secondary
  })]
});

const LANGUAGE_OPTIONS = [{
  value: "",
  label: "Default"
}, {
  value: "ar",
  label: "\u0639\u0631\u0628\u064A"
}, {
  value: "ckb",
  label: "\u06A9\u0648\u0631\u062F\u06CC\u06CC \u0633\u06C6\u0631\u0627\u0646\u06CC"
}, {
  value: "ur",
  label: "\u0627\u0631\u062F\u0648"
}, {
  value: "en",
  label: "English"
}, {
  value: "es",
  label: "Espa\xF1ol"
}, {
  value: "zh",
  label: "\u4E2D\u6587"
}, {
  value: "ru",
  label: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
}, {
  value: "hu",
  label: "Magyar nyelv"
}, {
  value: "pl",
  label: "Polski"
}, {
  value: "fr",
  label: "Fran\xE7ais"
}, {
  value: "it",
  label: "Italiano"
}, {
  value: "de",
  label: "Deutsch"
}, {
  value: "fa",
  label: "\u0641\u0627\u0631\u0633\u06CC"
}, {
  value: "ne",
  label: "\u0928\u0947\u092A\u093E\u0932\u0940 \u092D\u093E\u0937\u093E"
}, {
  value: "tr",
  label: "T\xFCrk\xE7e"
}];

const LanguageTranslationPanel = ({
  selectedCode,
  onSelectLanguage,
  onSave,
  onClose,
  isSaving
}) => /* @__PURE__ */ jsx(PanelShell, {
  icon: /* @__PURE__ */ jsx(MdTranslate, {
    size: 20,
    className: "text-[color:var(--cair-accent)]"
  }),
  title: "Language & Translation",
  onClose,
  footer: /* @__PURE__ */ jsx(ActionButton, {
    intent: "cairPrimary",
    size: "md",
    rounded: "sm",
    className: "flex-1 h-[46px]",
    onClick: onSave,
    isLoading: isSaving,
    loadingText: "Saving\u2026",
    children: "Apply & Save"
  }),
  children: /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-[20px] px-[24px] py-[20px] w-full",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[12px]",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-medium text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] leading-[1.75]",
        children: "Reading Language"
      }), /* @__PURE__ */ jsx("div", {
        className: "grid grid-cols-2 gap-[8px]",
        children: LANGUAGE_OPTIONS.map((lang) => /* @__PURE__ */ jsx(PanelOptionCell, {
          primary: lang.label,
          secondary: lang.value,
          selected: selectedCode === lang.value,
          primaryDir: "auto",
          onClick: () => onSelectLanguage(lang.value)
        }, lang.value))
      })]
    })
  })
});

const ConnectedLanguageTranslationPanel = ({
  onClose
}) => {
  const {
    language,
    setLanguage
  } = useLanguageSelectionContext();
  const [pendingCode, setPendingCode] = useState(language || "");
  const handleSave = useMemoizedFn(() => {
    setLanguage(pendingCode);
    onClose();
  });
  return /* @__PURE__ */ jsx(LanguageTranslationPanel, {
    selectedCode: pendingCode,
    onSelectLanguage: setPendingCode,
    onSave: handleSave,
    onClose
  });
};

const WandIcon = () => /* @__PURE__ */ jsx(MdAutoFixHigh, {
  size: 24,
  className: "text-[color:var(--cair-accent-foreground)]",
  "aria-hidden": "true"
});
const SpeakButton = ({
  onClick,
  className
}) => /* @__PURE__ */ jsx("button", {
  onClick,
  className: `flex items-center justify-center w-[48px] h-[48px] rounded-full bg-[var(--cair-accent)] overflow-hidden cursor-pointer ${className || ""}`,
  style: {
    boxShadow: "var(--cair-shadow-float)"
  },
  "aria-label": "Ask AI",
  children: /* @__PURE__ */ jsx(WandIcon, {})
});

const menuItemBase = ["flex items-center gap-[8px]", "pl-[12px] pr-[16px] py-[6px]", "bg-[var(--cair-surface-elevated)]", "border border-[var(--cair-border)]", "rounded-[var(--cair-radius-md)]", "shadow-[var(--cair-shadow-md)]", "whitespace-nowrap"].join(" ");
const menuItemText = ["font-medium", "text-[length:var(--cair-text-tiny)]", "leading-[1.5]"].join(" ");
const SelectionMenu = ({
  onAskAi,
  onBookmark,
  onNote
}) => {
  const intl = useIntl();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-[8px] items-start",
    children: [/* @__PURE__ */ jsxs("button", {
      onClick: onAskAi,
      className: menuItemBase,
      children: [/* @__PURE__ */ jsx(MdAutoAwesome, {
        size: 20,
        className: "shrink-0 text-[color:var(--cair-premium)]"
      }), /* @__PURE__ */ jsx("span", {
        className: `${menuItemText} text-[color:var(--cair-premium)]`,
        children: intl.formatMessage({
          id: "br.sel.askAi"
        })
      })]
    }), /* @__PURE__ */ jsxs("button", {
      onClick: onBookmark,
      className: menuItemBase,
      children: [/* @__PURE__ */ jsx(MdBookmark, {
        size: 20,
        className: "shrink-0 text-[color:var(--cair-accent)]"
      }), /* @__PURE__ */ jsx("span", {
        className: `${menuItemText} text-[color:var(--cair-accent)]`,
        children: intl.formatMessage({
          id: "br.sel.bookmark"
        })
      })]
    }), /* @__PURE__ */ jsxs("button", {
      onClick: onNote,
      className: menuItemBase,
      children: [/* @__PURE__ */ jsx(MdNoteAdd, {
        size: 20,
        className: "shrink-0 text-[color:var(--cair-accent)]"
      }), /* @__PURE__ */ jsx("span", {
        className: `${menuItemText} text-[color:var(--cair-accent)]`,
        children: intl.formatMessage({
          id: "br.sel.note"
        })
      })]
    })]
  });
};

const DESKTOP_BREAKPOINT = 1280;
const MOBILE_BREAKPOINT = 768;
const FORCE_LAYOUT_KEY = "cair_force_layout";
const getForcedLayout = () => {
  try {
    const v = localStorage.getItem(FORCE_LAYOUT_KEY);
    return v === "mobile" || v === "desktop" ? v : null;
  } catch {
    return null;
  }
};
const toMobilePath = (p) => p.replace("-desktop", "-mobile");
const toDesktopPath = (p) => p.replace("-mobile", "-desktop");
const getDesktopMode = (w) => w >= DESKTOP_BREAKPOINT ? "desktop" : "tablet";
const useReaderLayoutMode = (source) => {
  const history = useHistory();
  const location = useLocation();
  const [layoutMode, setLayoutMode] = useState(source === "desktop" ? getDesktopMode(window.innerWidth) : "mobile");
  useEffect(() => {
    const update = () => {
      const forced = getForcedLayout();
      if (forced) {
        if (forced !== source) {
          history.push(forced === "mobile" ? toMobilePath(location.pathname) : toDesktopPath(location.pathname));
        }
        return;
      }
      const w = window.innerWidth;
      if (source === "desktop" && w < MOBILE_BREAKPOINT) {
        history.push(toMobilePath(location.pathname));
        return;
      }
      if (source === "mobile" && w >= MOBILE_BREAKPOINT) {
        history.push(toDesktopPath(location.pathname));
        return;
      }
      if (source === "desktop") {
        setLayoutMode(getDesktopMode(w));
      }
    };
    update();
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
    };
  }, [history, location.pathname, source]);
  return layoutMode;
};

const truncateLabel = (text, max = 40) => {
  if (!text)
    return "";
  return text.length > max ? `${text.slice(0, max)}\u2026` : text;
};
const displayLabel = (entry) => {
  if (!entry)
    return "";
  if (entry.name && entry.name.trim().length > 0)
    return entry.name;
  return truncateLabel(entry.selectedText);
};

const noopCacheStore = {
  list: async () => [],
  add: async () => {
  },
  remove: async () => {
  }
};
const base = (postId) => `book-cair/${postId}`;
const createApiBookmarkStore = (api) => ({
  list: async (postId) => {
    const [bookmarks, notes] = await Promise.all([
      api.get({ path: `${base(postId)}/bookmarks` }),
      api.get({ path: `${base(postId)}/notes` })
    ]);
    return [...bookmarks || [], ...notes || []];
  },
  add: async (postId, entry) => {
    await api.post({
      path: `${base(postId)}/interactions`,
      body: {
        type: entry.type,
        clientId: entry.id,
        pageId: entry.pageId,
        startOffset: entry.startOffset,
        endOffset: entry.endOffset,
        name: entry.name,
        selectedText: entry.selectedText
      }
    });
  },
  remove: async (postId, id) => {
    await api.delete({ path: `${base(postId)}/interactions/${id}` });
  }
});
const createCachedBookmarkStore = (api, callbacks, cache = noopCacheStore) => {
  const apiStore = createApiBookmarkStore(api);
  const { onServerData, onServerError } = callbacks;
  return {
    list: async (postId) => {
      const cached = await cache.list(postId);
      apiStore.list(postId).then((serverEntries) => {
        writeThrough(cache, postId, serverEntries);
        onServerData(serverEntries);
      }).catch((err) => {
        if (onServerError)
          onServerError(err);
      });
      return cached;
    },
    add: async (postId, entry) => {
      await cache.add(postId, entry);
      apiStore.add(postId, entry).catch(() => {
      });
    },
    remove: async (postId, id) => {
      await cache.remove(postId, id);
      apiStore.remove(postId, id).catch(() => {
      });
    }
  };
};
const writeThrough = async (cache, postId, entries) => {
  const existing = await cache.list(postId);
  await Promise.allSettled(existing.map((e) => cache.remove(postId, e.id)));
  await Promise.allSettled(entries.map((e) => cache.add(postId, e)));
};

const generateId = () => typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
const useBookmarks = (postId) => {
  const api = useApi();
  const [entries, setEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const store = useMemo(() => createCachedBookmarkStore(api, {
    onServerData: setEntries
  }), [api]);
  useEffect(() => {
    if (!postId) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    store.list(postId).then((cached) => {
      setEntries(cached);
      setIsLoading(false);
    });
  }, [postId]);
  const addEntry = useMemoizedFn((type, partial) => {
    const full = {
      ...partial,
      type,
      id: generateId(),
      createdAt: new Date().toISOString()
    };
    setEntries((prev) => [...prev, full]);
    store.add(postId, full);
  });
  const addBookmark = useMemoizedFn((entry) => addEntry("bookmark", entry));
  const addNote = useMemoizedFn((entry) => addEntry("note", entry));
  const remove = useMemoizedFn((id) => {
    setEntries((prev) => prev.filter((e) => e.id !== id));
    store.remove(postId, id);
  });
  const bookmarks = useCreation(() => entries.filter((e) => e.type === "bookmark"), [entries]);
  const notes = useCreation(() => entries.filter((e) => e.type === "note"), [entries]);
  return { bookmarks, notes, addBookmark, addNote, remove, isLoading };
};

const ReaderAnnotationProvider = ({
  postId,
  children
}) => {
  const {
    bookmarks,
    notes,
    addBookmark,
    addNote,
    remove
  } = useBookmarks(postId);
  const [activeAnnotation, setActiveAnnotation] = useState(null);
  const [scrollToAnnotationId, setScrollToAnnotationId] = useState(null);
  const scrollToAnnotation = useMemoizedFn((id) => {
    setScrollToAnnotationId(id);
  });
  const clearAnnotationScroll = useMemoizedFn(() => {
    setScrollToAnnotationId(null);
  });
  useEffect(() => {
    if (!scrollToAnnotationId)
      return;
    const handler = () => clearAnnotationScroll();
    document.addEventListener("wheel", handler, {
      passive: true
    });
    document.addEventListener("touchstart", handler, {
      passive: true
    });
    return () => {
      document.removeEventListener("wheel", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [scrollToAnnotationId, clearAnnotationScroll]);
  const annotations = useCreation(() => [...bookmarks, ...notes], [bookmarks, notes]);
  return /* @__PURE__ */ jsx(ReaderAnnotationContext.Provider, {
    value: {
      annotations,
      bookmarks,
      notes,
      addBookmark,
      addNote,
      remove,
      activeAnnotation,
      setActiveAnnotation,
      scrollToAnnotationId,
      scrollToAnnotation,
      clearAnnotationScroll
    },
    children
  });
};

const getInstanceHost = () => {
  if (typeof location === "undefined")
    return "";
  const parts = location.hostname.split(".").filter(Boolean);
  return parts.slice(-2).join(".");
};
const getProxyOrigin = () => isLocalhost() ? "http://localhost:3002" : `https://cdn.${getInstanceHost()}`;
const ScaledImageTwProxy = ({
  className = "",
  uuid,
  w,
  h,
  crop,
  instanceNameOverride,
  scaleWithContainer,
  onClick
}) => {
  if (!uuid) {
    return null;
  }
  const dpr = typeof window !== "undefined" && window.devicePixelRatio ? Math.min(window.devicePixelRatio, 3) : 1;
  const pixelW = Math.round(w * dpr);
  const pixelH = Math.round(h * dpr);
  const query = crop ? `w=${pixelW}&h=${pixelH}&fit=facearea` : `w=${pixelW}&h=${pixelH}`;
  const url = `${getProxyOrigin()}/ua/ip/${uuid}?${query}`;
  if (scaleWithContainer) {
    return /* @__PURE__ */ jsx("img", {
      className,
      width: "100%",
      src: url,
      alt: ""
    });
  }
  if (crop) {
    return /* @__PURE__ */ jsx("div", {
      className: `flex items-center justify-center ${className}`,
      style: {
        width: w,
        height: h,
        minWidth: w,
        minHeight: h
      },
      children: /* @__PURE__ */ jsx("img", {
        width: w,
        height: h,
        src: url,
        alt: "",
        onClick,
        className: onClick ? "cursor-pointer" : ""
      })
    });
  }
  return /* @__PURE__ */ jsx("div", {
    className: `flex items-center justify-center ${className}`,
    style: {
      width: w,
      height: h,
      minWidth: w,
      minHeight: h
    },
    children: /* @__PURE__ */ jsx("img", {
      src: url,
      alt: "",
      onClick,
      className: onClick ? "cursor-pointer" : ""
    })
  });
};

const bookCoverVariants = cva("relative shrink-0 overflow-hidden bg-[var(--cair-text-tertiary)]", {
  variants: {
    radius: {
      sm: "rounded-[var(--cair-radius-sm)]",
      md: "rounded-[var(--cair-radius-md)]"
    }
  },
  defaultVariants: {
    radius: "sm"
  }
});
const BookCover = ({
  image,
  height = 160,
  width,
  radius,
  className
}) => /* @__PURE__ */ jsx("div", {
  className: bookCoverVariants({
    radius,
    className
  }),
  style: {
    height,
    width: width || "100%"
  },
  children: /* @__PURE__ */ jsx(ScaledImageTwProxy, {
    uuid: image && image.uuid || "",
    w: width || 400,
    h: height,
    scaleWithContainer: true,
    className: "absolute inset-0 w-full h-full object-cover"
  })
});

const BookCairDesktopSidebarHeader = ({
  title,
  subtitle,
  author,
  accessType,
  image,
  onBack,
  onShare,
  onViewDetails
}) => {
  const intl = useIntl();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-[12px] p-[16px] border-b border-[var(--cair-divider)]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsxs(ActionButton, {
        intent: "cairSubtle",
        size: "xs",
        rounded: "sm",
        onClick: onBack,
        children: [/* @__PURE__ */ jsx(MdArrowBack, {
          size: 14,
          className: "mr-[4px]"
        }), /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.back"
        })]
      }), /* @__PURE__ */ jsxs(ActionButton, {
        intent: "cairSubtle",
        size: "xs",
        rounded: "sm",
        onClick: onShare,
        children: [/* @__PURE__ */ jsx(MdShare, {
          size: 14,
          className: "mr-[4px]"
        }), /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.share"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-[12px] items-start",
      children: [/* @__PURE__ */ jsx(BookCover, {
        image,
        alt: title,
        width: 112,
        height: 112,
        radius: "sm"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[4px] flex-1 min-w-0 pt-[4px]",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-start gap-[6px]",
          children: [accessType === "locked" && /* @__PURE__ */ jsx(MdLock, {
            size: 14,
            className: "text-[color:var(--cair-text-secondary)] shrink-0 mt-[3px]"
          }), /* @__PURE__ */ jsx("p", {
            className: "text-[20px] font-semibold text-[color:var(--cair-text)] leading-[1.25] line-clamp-3",
            children: title
          })]
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[13px] text-[color:var(--cair-text-secondary)] leading-[1.5] line-clamp-2",
          children: subtitle
        })]
      })]
    }), /* @__PURE__ */ jsx("p", {
      className: "text-[14px] text-[color:var(--cair-text-secondary)] leading-[1.4]",
      children: author
    }), onViewDetails && /* @__PURE__ */ jsx("button", {
      onClick: onViewDetails,
      className: "text-[12px] text-[color:var(--cair-text-secondary)] underline leading-[1.2] text-left self-start mt-[-8px]",
      children: intl.formatMessage({
        id: "br.viewDetails"
      })
    })]
  });
};

const SectionRow = ({
  section,
  onTocNavigate
}) => /* @__PURE__ */ jsx("button", {
  dir: "auto",
  onClick: () => onTocNavigate && onTocNavigate(section),
  className: "w-full flex items-center pl-[24px] pr-[8px] py-[8px] rounded-[var(--cair-radius-md)] text-left",
  children: /* @__PURE__ */ jsx("span", {
    className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text)] font-normal leading-[1.2]",
    children: section.title
  })
});

const ChapterRow = ({
  chapter,
  onTocNavigate
}) => {
  const hasSections = !!(chapter.sections && chapter.sections.length > 0);
  const [expanded, setExpanded] = useLocalStorageState$1(`toc-expanded-${chapter.id}`, {
    defaultValue: false
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full border-b border-[var(--cair-border)] last:border-b-0",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full flex items-start px-[24px] py-[12px] gap-[8px]",
      children: [/* @__PURE__ */ jsxs("button", {
        onClick: () => onTocNavigate && onTocNavigate(chapter),
        className: "flex-1 min-w-0 flex flex-col gap-[4px] items-start text-left",
        children: [/* @__PURE__ */ jsx("span", {
          dir: "auto",
          className: `
                            text-[length:var(--cair-text-small)] leading-[1.5] w-full
                            ${chapter.isActive ? "font-medium text-[color:var(--cair-accent)]" : "font-normal text-[color:var(--cair-text)]"}
                        `,
          children: chapter.title
        }), chapter.pages !== void 0 && chapter.pages > 0 && /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-[16px] pt-[4px]",
          children: [/* @__PURE__ */ jsxs("span", {
            className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] leading-[1.2]",
            children: [chapter.pages, " pages"]
          }), chapter.audioTime && /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] leading-[1.2]",
              children: "\u2022"
            }), /* @__PURE__ */ jsxs("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] leading-[1.2]",
              children: [chapter.audioTime, " audio"]
            })]
          })]
        })]
      }), hasSections ? /* @__PURE__ */ jsx("button", {
        onClick: () => setExpanded((prev) => !prev),
        className: "pt-[4px] shrink-0 text-[color:var(--cair-text-secondary)]",
        children: expanded ? /* @__PURE__ */ jsx(MdExpandLess, {
          size: 20
        }) : /* @__PURE__ */ jsx(MdExpandMore, {
          size: 20
        })
      }) : /* @__PURE__ */ jsx("div", {
        className: "pt-[10px] shrink-0",
        children: /* @__PURE__ */ jsx("div", {
          className: `
                                w-[8px] h-[8px] rounded-full
                                ${chapter.isActive ? "bg-[var(--cair-accent)]" : "bg-[var(--cair-text-disabled,#b3b3b3)]"}
                            `
        })
      })]
    }), expanded && hasSections && /* @__PURE__ */ jsx("div", {
      className: "flex flex-col px-[24px] pb-[12px]",
      children: chapter.sections.map((sec) => /* @__PURE__ */ jsx(SectionRow, {
        section: sec,
        onTocNavigate
      }, sec.id))
    })]
  });
};

const CairSidebarSection = ({
  label,
  children,
  defaultExpanded = true
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const handleToggle = useMemoizedFn(() => setExpanded((v) => !v));
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col border-t border-[var(--cair-divider)]",
    children: [/* @__PURE__ */ jsxs("button", {
      onClick: handleToggle,
      className: "flex items-center justify-between px-[16px] py-[12px] w-full",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-[13px] font-semibold text-[color:var(--cair-text)]",
        children: label
      }), /* @__PURE__ */ jsx(MdExpandCircleDown, {
        size: 16,
        className: "text-[color:var(--cair-text-secondary)] transition-transform duration-200" + (expanded ? " rotate-180" : "")
      })]
    }), expanded && children]
  });
};

const BookCairDesktopToc = ({
  chapters,
  onTocNavigate
}) => {
  const intl = useIntl();
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col",
    children: /* @__PURE__ */ jsx(CairSidebarSection, {
      label: intl.formatMessage({
        id: "br.content.toc"
      }),
      children: chapters.map((ch) => /* @__PURE__ */ jsx(ChapterRow, {
        chapter: ch,
        onTocNavigate
      }, ch.id))
    })
  });
};

const BookCairDesktopSidebar = ({
  book,
  toc,
  bookmarks,
  notes,
  onBack,
  onShare,
  onBookmarkClick,
  onNoteClick,
  onTocNavigate,
  onViewDetails
}) => {
  const intl = useIntl();
  return /* @__PURE__ */ jsxs("div", {
    className: "w-[320px] flex-none flex flex-col h-full overflow-y-auto border-r border-[var(--cair-divider)] bg-[var(--cair-surface)]",
    children: [/* @__PURE__ */ jsx(BookCairDesktopSidebarHeader, {
      title: book.title,
      subtitle: book.subtitle,
      author: book.author,
      accessType: book.accessType,
      image: book.image || void 0,
      onBack,
      onShare,
      onViewDetails
    }), /* @__PURE__ */ jsx(BookCairDesktopToc, {
      chapters: toc,
      onTocNavigate
    }), /* @__PURE__ */ jsx(CairSidebarSection, {
      label: intl.formatMessage({
        id: "br.content.bookmarks"
      }),
      children: bookmarks.map((bm) => /* @__PURE__ */ jsx(SidebarListItem, {
        title: bm.name,
        location: bm.chapterLabel,
        onClick: onBookmarkClick ? () => onBookmarkClick(bm.id) : void 0
      }, bm.id))
    }), /* @__PURE__ */ jsx(CairSidebarSection, {
      label: intl.formatMessage({
        id: "br.content.notes"
      }),
      children: notes.map((n) => /* @__PURE__ */ jsx(SidebarListItem, {
        title: n.name,
        location: n.chapterLabel,
        onClick: onNoteClick ? () => onNoteClick(n.id) : void 0
      }, n.id))
    })]
  });
};
const SidebarListItem = ({
  title,
  location,
  onClick
}) => /* @__PURE__ */ jsxs("div", {
  className: "px-[16px] py-[8px] hover:bg-[var(--cair-surface-elevated)] transition-colors",
  style: {
    cursor: onClick ? "pointer" : "default"
  },
  onClick,
  children: [/* @__PURE__ */ jsx("p", {
    className: "text-[12px] font-medium text-[color:var(--cair-text)] leading-[1.4]",
    children: title
  }), /* @__PURE__ */ jsx("p", {
    className: "text-[11px] text-[color:var(--cair-text-secondary)]",
    children: location
  })]
});

const trackVariants$1 = cva("relative w-full overflow-hidden rounded-full bg-[var(--cair-surface)]", {
  variants: {
    height: {
      4: "h-[4px]",
      6: "h-[6px]",
      8: "h-[8px]"
    }
  },
  defaultVariants: {
    height: 4
  }
});
const fillVariants = cva("absolute inset-y-0 left-0 rounded-full", {
  variants: {
    variant: {
      accent: "bg-[var(--cair-accent)]",
      premium: "bg-[var(--cair-premium)]"
    }
  },
  defaultVariants: {
    variant: "accent"
  }
});
const ReadingProgressBar = ({
  percent,
  variant,
  height,
  label,
  showPercent = false,
  className
}) => {
  const clamped = Math.min(100, Math.max(0, percent));
  return /* @__PURE__ */ jsxs("div", {
    className: `flex flex-col gap-[4px] w-full ${className || ""}`,
    children: [label && /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-tertiary)] leading-[16px]",
        children: label
      }), showPercent && /* @__PURE__ */ jsxs("span", {
        className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-tertiary)] leading-[16px]",
        children: [clamped, "%"]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: trackVariants$1({
        height
      }),
      children: /* @__PURE__ */ jsx("div", {
        className: fillVariants({
          variant
        }),
        style: {
          width: `${clamped}%`
        },
        role: "progressbar",
        "aria-valuenow": clamped,
        "aria-valuemin": 0,
        "aria-valuemax": 100
      })
    })]
  });
};

const BookCairDesktopReadingHeader = ({
  chapterIndex,
  chapterTotal,
  progressPercent,
  currentPage,
  pageTotal,
  toolbarExpanded,
  rightPanelMode,
  onOpenPanel,
  isTablet,
  onToggleSidebar
}) => {
  const intl = useIntl();
  const {
    profile
  } = useProfileContext();
  const history = useHistory();
  const {
    post
  } = useBookReader();
  const isInstanceAdmin = profile && profile.role === "ADMIN";
  const handleOpenCircle = useMemoizedFn(() => {
    if (postCircleId(post)) {
      history.push(circleUrl(postCircleId(post)));
    }
  });
  const handleEditPost = useMemoizedFn(() => {
    if (post) {
      history.push(editPostUrl(post));
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center h-[65px] px-[24px] gap-[16px] flex-none border-b border-[var(--cair-divider)] bg-[var(--cair-surface)]",
    children: [isTablet && /* @__PURE__ */ jsx(HeaderIconBtn, {
      icon: /* @__PURE__ */ jsx(MdMenu, {
        size: 20
      }),
      label: intl.formatMessage({
        id: "br.hdr.openContents"
      }),
      active: false,
      onClick: onToggleSidebar
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-[12px] flex-1 min-w-0",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-[12px] text-[color:var(--cair-text-secondary)] whitespace-nowrap shrink-0",
        children: pageTotal && pageTotal > 1 && /* @__PURE__ */ jsx("span", {
          className: "ml-[8px] opacity-60",
          children: intl.formatMessage({
            id: "br.hdr.pageOf"
          }, {
            page: currentPage || 1,
            total: pageTotal
          })
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "flex-1 min-w-0",
        children: /* @__PURE__ */ jsx(ReadingProgressBar, {
          percent: progressPercent,
          variant: "premium",
          height: 4,
          showPercent: true
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-[2px] shrink-0",
      children: [isInstanceAdmin && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx("button", {
          onClick: handleOpenCircle,
          className: "w-[32px] h-[32px] flex items-center justify-center rounded-[var(--cair-radius-sm)] hover:bg-[var(--cair-surface)]",
          title: "Open circle",
          "aria-label": "Open circle",
          children: /* @__PURE__ */ jsx(MdGroups, {
            size: 20,
            className: "text-[color:var(--cair-premium)]"
          })
        }), /* @__PURE__ */ jsx("button", {
          onClick: handleEditPost,
          className: "w-[32px] h-[32px] flex items-center justify-center rounded-[var(--cair-radius-sm)] hover:bg-[var(--cair-surface)]",
          title: "Edit post",
          "aria-label": "Edit post",
          children: /* @__PURE__ */ jsx(MdEditNote, {
            size: 20,
            className: "text-[color:var(--cair-premium)]"
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "w-[1px] h-[16px] bg-[var(--cair-border)] mx-[4px]"
        })]
      }), toolbarExpanded && /* @__PURE__ */ jsx(HeaderIconBtn, {
        icon: /* @__PURE__ */ jsx(MdSearch, {
          size: 18
        }),
        label: intl.formatMessage({
          id: "br.dial.search"
        }),
        active: rightPanelMode === "search",
        onClick: () => onOpenPanel("search")
      }), toolbarExpanded && /* @__PURE__ */ jsx(HeaderIconBtn, {
        icon: /* @__PURE__ */ jsx(MdAutoAwesome, {
          size: 18
        }),
        label: intl.formatMessage({
          id: "br.ai.title"
        }),
        active: rightPanelMode === "ask-ai",
        onClick: () => onOpenPanel("ask-ai")
      }), /* @__PURE__ */ jsx(HeaderIconBtn, {
        icon: /* @__PURE__ */ jsx(MdSettings, {
          size: 18
        }),
        label: intl.formatMessage({
          id: "br.dial.settings"
        }),
        active: rightPanelMode === "preferences",
        onClick: () => onOpenPanel("preferences")
      }), /* @__PURE__ */ jsx(HeaderIconBtn, {
        icon: /* @__PURE__ */ jsx(MdTranslate, {
          size: 18
        }),
        label: intl.formatMessage({
          id: "br.dial.translate"
        }),
        active: rightPanelMode === "language",
        onClick: () => onOpenPanel("language")
      }), toolbarExpanded && /* @__PURE__ */ jsx(HeaderIconBtn, {
        icon: /* @__PURE__ */ jsx(MdBookmark, {
          size: 18
        }),
        label: intl.formatMessage({
          id: "br.dial.save"
        }),
        active: rightPanelMode === "bookmark",
        onClick: () => onOpenPanel("bookmark")
      })]
    })]
  });
};
const HeaderIconBtn = ({
  icon,
  label,
  active,
  onClick
}) => /* @__PURE__ */ jsx("button", {
  "aria-label": label,
  title: label,
  className: "w-[34px] h-[34px] flex items-center justify-center rounded-[6px] transition-colors " + (active ? "bg-[var(--cair-accent)] text-[color:var(--cair-accent-foreground)]" : "text-[color:var(--cair-text-secondary)] hover:bg-[var(--cair-surface-elevated)]"),
  onClick,
  children: icon
});

const AudioPlayerDock = ({
  title,
  currentTime,
  duration,
  progress,
  playing,
  onPlayPause,
  onSkipBack,
  onSkipForward,
  onSpeedChange,
  onSeek,
  speedLabel,
  className
}) => {
  const intl = useIntl();
  const clamped = Math.min(100, Math.max(0, progress));
  const handleScrubberClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const pct = Math.round(x / rect.width * 100);
    onSeek(pct);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `
        w-full
        bg-[var(--cair-surface)] border-t border-[var(--cair-border-strong)]
        px-[16px] pt-[17px] pb-[16px]
        flex flex-col gap-[8px]
        ${className || ""}
      `,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between w-full",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center flex-1 min-w-0",
        children: [/* @__PURE__ */ jsx("button", {
          onClick: onPlayPause,
          className: "shrink-0 w-[32px] h-[32px] rounded-full bg-[var(--cair-accent)] flex items-center justify-center",
          "aria-label": intl.formatMessage({
            id: playing ? "br.audio.pause" : "br.audio.play"
          }),
          children: playing ? /* @__PURE__ */ jsx(MdPause, {
            size: 20,
            className: "text-[color:var(--cair-accent-foreground)]"
          }) : /* @__PURE__ */ jsx(MdPlayArrow, {
            size: 20,
            className: "text-[color:var(--cair-accent-foreground)]"
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-[4px] pl-[12px] min-w-0 flex-1",
          children: [/* @__PURE__ */ jsx("p", {
            className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-medium leading-[1.5] line-clamp-2",
            children: title
          }), /* @__PURE__ */ jsxs("p", {
            className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-tertiary)] font-light leading-[1.5] whitespace-nowrap",
            children: [currentTime, " / ", duration]
          })]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center shrink-0",
        children: [/* @__PURE__ */ jsx("button", {
          onClick: onSkipBack,
          className: "flex items-center justify-center px-[8px] py-[6px]",
          "aria-label": intl.formatMessage({
            id: "br.audio.skipBack"
          }),
          children: /* @__PURE__ */ jsx(MdFastRewind, {
            size: 18,
            className: "text-[color:var(--cair-text-secondary)]"
          })
        }), /* @__PURE__ */ jsx("button", {
          onClick: onSkipForward,
          className: "flex items-center justify-center px-[8px] py-[6px]",
          "aria-label": intl.formatMessage({
            id: "br.audio.skipFwd"
          }),
          children: /* @__PURE__ */ jsx(MdFastForward, {
            size: 18,
            className: "text-[color:var(--cair-text-secondary)]"
          })
        }), /* @__PURE__ */ jsxs("button", {
          onClick: onSpeedChange,
          className: "flex items-center justify-center gap-[4px] px-[8px] py-[6px]",
          "aria-label": intl.formatMessage({
            id: "br.audio.speed"
          }),
          children: [/* @__PURE__ */ jsx(MdSpeed, {
            size: 18,
            className: "text-[color:var(--cair-text-secondary)]"
          }), speedLabel && /* @__PURE__ */ jsx("span", {
            className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-medium leading-none",
            children: speedLabel
          })]
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "w-full h-[4px] rounded-full bg-[var(--cair-border)] relative cursor-pointer",
      onClick: handleScrubberClick,
      role: "slider",
      "aria-valuenow": clamped,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-label": intl.formatMessage({
        id: "br.audio.progress"
      }),
      children: /* @__PURE__ */ jsx("div", {
        className: "absolute inset-y-0 left-0 rounded-full bg-[var(--cair-accent)]",
        style: {
          width: `${clamped}%`
        }
      })
    })]
  });
};

const useBookPageAudio = (pageId, circleId) => {
  const api = useApi();
  const refreshTimerRef = useRef(null);
  const key = pageId ? ["tts-page-audio", pageId, circleId || ""] : null;
  const { data, error, isValidating, mutate } = useSWR(key, async () => {
    try {
      const qs = circleId ? `contentId=${pageId}&circleId=${circleId}` : `contentId=${pageId}`;
      const response = await api.get({ path: `/tts/page-audio?${qs}` });
      if (response && response.success && response.data) {
        return response.data;
      }
      return null;
    } catch (err) {
      const status = err && err.status;
      const message = err && err.message || "";
      if (status === 404 || /not generated|not found/i.test(message)) {
        return null;
      }
      throw err;
    }
  }, {
    revalidateOnFocus: false,
    dedupingInterval: 6e4
  });
  useEffect(() => {
    if (refreshTimerRef.current) {
      clearTimeout(refreshTimerRef.current);
      refreshTimerRef.current = null;
    }
    if (!data || !data.cacheId || !data.audioUrlExpiresIn)
      return;
    const ms = Math.max(6e4, data.audioUrlExpiresIn * 900);
    refreshTimerRef.current = setTimeout(() => {
      mutate();
    }, ms);
    return () => {
      if (refreshTimerRef.current)
        clearTimeout(refreshTimerRef.current);
    };
  }, [data, mutate]);
  return {
    audio: data || null,
    loading: !data && isValidating,
    notGenerated: !!key && !isValidating && data === null && !error,
    error,
    refresh: () => mutate()
  };
};

const SPEEDS = [1, 1.25, 1.5, 1.75, 2, 0.75];
const SKIP_SECONDS = 15;
const AUTO_ADVANCE_KEY = "cair_audio_auto_advance";
const AUTOPLAY_TIMEOUT_MS = 5e3;
const formatTime$1 = (seconds) => {
  if (!isFinite(seconds) || seconds < 0)
    return "0:00";
  const total = Math.floor(seconds);
  const m = Math.floor(total / 60);
  const s = total % 60;
  if (m >= 60) {
    const h = Math.floor(m / 60);
    const mm = m % 60;
    return `${h}:${String(mm).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }
  return `${m}:${String(s).padStart(2, "0")}`;
};
const BookCairDesktopAudioPlayer = ({
  visible,
  chapterTitle,
  pageId,
  circleId,
  onAdvance
}) => {
  const audioRef = useRef(null);
  const {
    audio,
    loading,
    notGenerated
  } = useBookPageAudio(pageId, circleId);
  const audioUrl = audio ? audio.audioUrl : "";
  const audioDurationFromCache = audio ? audio.duration : void 0;
  const [playing, setPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [speedIndex, setSpeedIndex] = useState(0);
  const [autoAdvance, setAutoAdvance] = useState(() => {
    try {
      const v = localStorage.getItem(AUTO_ADVANCE_KEY);
      return v === null ? true : v === "1";
    } catch {
      return true;
    }
  });
  const expectedNextRef = useRef(null);
  const autoplayIntentRef = useRef(false);
  const [autoplayBlocked, setAutoplayBlocked] = useState(false);
  const clearExpected = () => {
    expectedNextRef.current = null;
    autoplayIntentRef.current = false;
  };
  useEffect(() => () => clearExpected(), []);
  useEffect(() => {
    setCurrentTime(0);
    setDuration(audioDurationFromCache || 0);
    setAutoplayBlocked(false);
    const expected = expectedNextRef.current;
    if (!expected) {
      autoplayIntentRef.current = false;
      return;
    }
    if (pageId !== expected.nextId || Date.now() > expected.expiresAt) {
      clearExpected();
      return;
    }
    autoplayIntentRef.current = true;
  }, [pageId, audioDurationFromCache]);
  useEffect(() => {
    const el = audioRef.current;
    if (!el || !audioUrl || el.src === audioUrl)
      return;
    el.src = audioUrl;
    el.load();
  }, [audioUrl]);
  useEffect(() => {
    const el = audioRef.current;
    if (!el)
      return;
    const onTimeUpdate = () => setCurrentTime(el.currentTime);
    const onLoadedMetadata = () => setDuration(el.duration || 0);
    const onLoadStart = () => {
      setPlaying(false);
      setCurrentTime(0);
    };
    const onPlay = () => {
      setPlaying(true);
      setAutoplayBlocked(false);
    };
    const onPause = () => setPlaying(false);
    const onCanPlay = () => {
      el.playbackRate = SPEEDS[speedIndex];
      if (!autoplayIntentRef.current)
        return;
      autoplayIntentRef.current = false;
      clearExpected();
      const p = el.play();
      if (p && typeof p.catch === "function") {
        p.catch((err) => {
          if (err && err.name === "NotAllowedError")
            setAutoplayBlocked(true);
        });
      }
    };
    const onEndedEvt = () => {
      setPlaying(false);
      setCurrentTime(0);
      if (!autoAdvance || !onAdvance || !pageId)
        return;
      const nextId = onAdvance(pageId);
      if (!nextId)
        return;
      expectedNextRef.current = {
        nextId,
        expiresAt: Date.now() + AUTOPLAY_TIMEOUT_MS
      };
      autoplayIntentRef.current = true;
    };
    el.addEventListener("timeupdate", onTimeUpdate);
    el.addEventListener("loadedmetadata", onLoadedMetadata);
    el.addEventListener("loadstart", onLoadStart);
    el.addEventListener("canplay", onCanPlay);
    el.addEventListener("play", onPlay);
    el.addEventListener("pause", onPause);
    el.addEventListener("ended", onEndedEvt);
    return () => {
      el.removeEventListener("timeupdate", onTimeUpdate);
      el.removeEventListener("loadedmetadata", onLoadedMetadata);
      el.removeEventListener("loadstart", onLoadStart);
      el.removeEventListener("canplay", onCanPlay);
      el.removeEventListener("play", onPlay);
      el.removeEventListener("pause", onPause);
      el.removeEventListener("ended", onEndedEvt);
    };
  }, [autoAdvance, onAdvance, pageId, speedIndex]);
  useEffect(() => {
    const el = audioRef.current;
    if (el)
      el.playbackRate = SPEEDS[speedIndex];
  }, [speedIndex]);
  const onPlayPause = () => {
    const el = audioRef.current;
    if (!el || !audioUrl)
      return;
    clearExpected();
    setAutoplayBlocked(false);
    if (el.paused) {
      const p = el.play();
      if (p && typeof p.catch === "function") {
        p.catch((err) => {
          if (err && err.name === "NotAllowedError")
            setAutoplayBlocked(true);
        });
      }
    } else {
      el.pause();
    }
  };
  const onSkipBack = () => {
    const el = audioRef.current;
    if (!el)
      return;
    el.currentTime = Math.max(0, el.currentTime - SKIP_SECONDS);
  };
  const onSkipForward = () => {
    const el = audioRef.current;
    if (!el)
      return;
    el.currentTime = Math.min(el.duration || el.currentTime, el.currentTime + SKIP_SECONDS);
  };
  const onSpeedChange = () => {
    setSpeedIndex((i) => (i + 1) % SPEEDS.length);
  };
  const onSeek = (percent) => {
    const el = audioRef.current;
    if (!el || !duration)
      return;
    el.currentTime = Math.max(0, Math.min(duration, percent / 100 * duration));
  };
  const toggleAutoAdvance = () => {
    setAutoAdvance((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(AUTO_ADVANCE_KEY, next ? "1" : "0");
      } catch {
      }
      return next;
    });
  };
  const progress = useMemo(() => {
    if (!duration)
      return 0;
    return Math.max(0, Math.min(100, currentTime / duration * 100));
  }, [currentTime, duration]);
  if (!visible)
    return null;
  const titleSuffix = notGenerated ? " \u2014 audio not generated for this page" : loading && !audio ? " \u2014 loading\u2026" : "";
  return /* @__PURE__ */ jsxs("div", {
    className: "relative",
    children: [/* @__PURE__ */ jsx("audio", {
      ref: audioRef,
      preload: "metadata",
      playsInline: true
    }), /* @__PURE__ */ jsx(AudioPlayerDock, {
      title: `${chapterTitle || ""}${titleSuffix}`,
      currentTime: formatTime$1(currentTime),
      duration: formatTime$1(duration),
      progress,
      playing,
      onPlayPause,
      onSkipBack,
      onSkipForward,
      onSpeedChange,
      onSeek,
      speedLabel: `${SPEEDS[speedIndex]}x`
    }), autoplayBlocked && /* @__PURE__ */ jsx("button", {
      type: "button",
      onClick: onPlayPause,
      className: "absolute inset-0 z-20 flex items-center justify-center bg-black/40 text-white text-sm font-medium rounded cursor-pointer",
      "aria-label": "Tap to resume audio",
      children: "Tap to resume"
    }), /* @__PURE__ */ jsx("div", {
      className: "absolute top-[10px] right-[12px] flex items-center text-xs text-[color:var(--cair-text-secondary)]",
      children: /* @__PURE__ */ jsxs("label", {
        className: "flex items-center gap-1 cursor-pointer select-none",
        children: [/* @__PURE__ */ jsx("input", {
          type: "checkbox",
          checked: autoAdvance,
          onChange: toggleAutoAdvance
        }), "Auto-advance"]
      })
    })]
  });
};

const VoiceTextInput = ({
  value,
  onChange,
  placeholder = "",
  onVoiceInput,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: ["bg-[var(--cair-surface)] border border-[var(--cair-border)]", "flex gap-[8px] h-[48px] items-center", "pl-[16px] pr-[8px] py-[8px]", "rounded-[var(--cair-radius-md)]", "w-full", className || ""].join(" "),
  children: [/* @__PURE__ */ jsx("input", {
    type: "text",
    value,
    onChange: (e) => onChange(e.target.value),
    placeholder,
    dir: "auto",
    className: ["flex-1 min-w-0 bg-transparent outline-none", "font-normal leading-[1.75]", "text-[length:var(--cair-text-regular)]", "text-[color:var(--cair-text)]", "placeholder:text-[color:var(--cair-text-disabled)]"].join(" ")
  }), onVoiceInput && /* @__PURE__ */ jsx("button", {
    onClick: onVoiceInput,
    className: "shrink-0 flex items-center justify-center",
    "aria-label": "Voice input",
    children: /* @__PURE__ */ jsx("span", {
      className: "bg-[var(--cair-accent)] flex items-center justify-center rounded-full w-[32px] h-[32px]",
      children: /* @__PURE__ */ jsx(MdMic, {
        size: 16,
        className: "text-white"
      })
    })
  })]
});

const AddBookmarkPanel = (props) => {
  const intl = useIntl();
  const isView = props.mode === "view";
  const displayText = isView ? props.entry.selectedText : props.selectedText;
  const excerpt = displayText && displayText.length > 120 ? displayText.slice(0, 120) + "\u2026" : displayText;
  return /* @__PURE__ */ jsx(PanelShell, {
    title: intl.formatMessage({
      id: isView ? "br.bm.title" : "br.bm.titleAdd"
    }),
    icon: /* @__PURE__ */ jsx(MdBookmark, {
      size: 20,
      className: "text-[color:var(--cair-text)]"
    }),
    onClose: props.onClose,
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[16px] px-[16px] py-[16px]",
      children: [excerpt && /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[12px] text-[color:var(--cair-text-secondary)] mb-[4px]",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: isView ? "br.savedText" : "br.selText"
          })
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[13px] italic text-[color:var(--cair-text-secondary)] leading-[1.6]",
          children: excerpt
        })]
      }), /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[12px] text-[color:var(--cair-text-secondary)] mb-[4px]",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "br.bm.name"
          })
        }), isView ? /* @__PURE__ */ jsx("p", {
          className: "text-[14px] font-medium text-[color:var(--cair-text)]",
          children: props.entry.name
        }) : /* @__PURE__ */ jsx(VoiceTextInput, {
          value: props.name,
          onChange: props.onChange,
          placeholder: intl.formatMessage({
            id: "br.bm.ph"
          }),
          onVoiceInput: props.onVoiceInput
        })]
      }), isView ? /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairSubtle",
        size: "md",
        rounded: "sm",
        className: "w-full mt-[8px]",
        onClick: () => {
          props.onRemove(props.entry.id);
          props.onClose();
        },
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.bm.remove"
        })
      }) : /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        className: "w-full",
        onClick: props.onSave,
        disabled: !props.name.trim(),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.bm.save"
        })
      })]
    })
  });
};

const AddNotePanel = (props) => {
  const intl = useIntl();
  const isView = props.mode === "view";
  const displayText = isView ? props.entry.selectedText : props.selectedText;
  const excerpt = displayText && displayText.length > 120 ? displayText.slice(0, 120) + "\u2026" : displayText;
  return /* @__PURE__ */ jsx(PanelShell, {
    title: intl.formatMessage({
      id: isView ? "br.note.title" : "br.note.titleAdd"
    }),
    icon: /* @__PURE__ */ jsx(MdNotes, {
      size: 20,
      className: "text-[color:var(--cair-text)]"
    }),
    onClose: props.onClose,
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[16px] px-[16px] py-[16px]",
      children: [excerpt && /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[12px] text-[color:var(--cair-text-secondary)] mb-[4px]",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: isView ? "br.savedText" : "br.selText"
          })
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[13px] italic text-[color:var(--cair-text-secondary)] leading-[1.6]",
          children: excerpt
        })]
      }), /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[12px] text-[color:var(--cair-text-secondary)] mb-[4px]",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "br.note.label"
          })
        }), isView ? /* @__PURE__ */ jsx("p", {
          className: "text-[14px] font-medium text-[color:var(--cair-text)] leading-[1.6]",
          children: displayLabel(props.entry)
        }) : /* @__PURE__ */ jsx(VoiceTextInput, {
          value: props.text,
          onChange: props.onChange,
          placeholder: intl.formatMessage({
            id: "br.note.ph"
          }),
          onVoiceInput: props.onVoiceInput
        })]
      }), isView ? /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairSubtle",
        size: "md",
        rounded: "sm",
        className: "w-full mt-[8px]",
        onClick: () => {
          props.onRemove(props.entry.id);
          props.onClose();
        },
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.note.remove"
        })
      }) : /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        className: "w-full",
        onClick: props.onSave,
        disabled: !props.text.trim(),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.note.save"
        })
      })]
    })
  });
};

const cardClass = ["flex flex-col gap-[6px] px-[12px] py-[10px] rounded-[6px] w-full text-left", "bg-[var(--cair-surface)] border border-[var(--cair-border)]", "cursor-pointer hover:bg-[var(--cair-accent-subtle)] hover:border-[var(--cair-accent)]", "transition-colors no-underline"].join(" ");
const ChunkRefList = ({
  items,
  label,
  onItemClick
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col gap-[8px]",
  children: [label && /* @__PURE__ */ jsx("span", {
    className: "font-medium text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] leading-[1.5] uppercase tracking-wide",
    children: label
  }), /* @__PURE__ */ jsx("ol", {
    className: "flex flex-col gap-[6px] list-none m-0 p-0",
    children: items.map((item, index) => {
      const inner = /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-[8px]",
          children: [/* @__PURE__ */ jsx("span", {
            className: "flex-none flex items-center justify-center w-[20px] h-[20px] rounded-full bg-[var(--cair-accent-subtle)] text-[color:var(--cair-text-secondary)] text-[10px] font-semibold leading-none",
            children: index + 1
          }), /* @__PURE__ */ jsx("span", {
            className: "font-medium text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] leading-[1.5] truncate",
            children: item.location
          })]
        }), /* @__PURE__ */ jsx("p", {
          dir: "auto",
          className: "font-normal text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text)] leading-[1.6] line-clamp-2 m-0",
          children: item.excerpt
        })]
      });
      return /* @__PURE__ */ jsx("li", {
        children: item.href ? /* @__PURE__ */ jsx("a", {
          href: item.href,
          className: cardClass,
          children: inner
        }) : /* @__PURE__ */ jsx("button", {
          className: cardClass,
          onClick: onItemClick ? () => onItemClick(item) : void 0,
          disabled: !onItemClick,
          children: inner
        })
      }, item.id);
    })
  })]
});

const MARKED_CDN_URL = "https://cdn.jsdelivr.net/npm/marked@11.1.1/marked.min.js";
const useMarked = () => {
  const [ready, setReady] = useState(!!window.marked);
  useEffect(() => {
    if (window.marked)
      return;
    let cancelled = false;
    loadJsLibs([MARKED_CDN_URL]).then(() => {
      if (cancelled)
        return;
      setReady(true);
    }).catch(() => {
      if (cancelled)
        return;
      setReady(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return {
    parse: ready ? (src) => window.marked.parse(src) : null,
    loading: !ready
  };
};

const AnswerBody = ({
  answer,
  refs,
  isSubmitting,
  isVoice,
  onToggleVoice,
  onRefClick
}) => {
  const intl = useIntl();
  const {
    parse
  } = useMarked();
  return /* @__PURE__ */ jsxs("div", {
    className: "px-[24px] py-[20px] flex flex-col gap-[16px] w-full",
    children: [answer && (parse ? /* @__PURE__ */ jsx("div", {
      dir: "auto",
      className: "font-normal text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] leading-[1.75] [&_ul]:list-disc [&_ul]:pl-4 [&_ol]:list-decimal [&_ol]:pl-4 [&_p]:m-0 [&_p+p]:mt-2",
      dangerouslySetInnerHTML: {
        __html: parse(answer)
      }
    }) : /* @__PURE__ */ jsx("p", {
      dir: "auto",
      className: "font-normal text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] leading-[1.75] m-0",
      children: answer
    })), isSubmitting && /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-[8px]",
      children: [/* @__PURE__ */ jsx(Spinner, {
        size: "sm"
      }), !answer && /* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-small)] text-[color:var(--cair-text-tertiary)]",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.ai.searching"
        })
      })]
    }), refs && refs.length > 0 && /* @__PURE__ */ jsx(ChunkRefList, {
      items: refs,
      label: intl.formatMessage({
        id: "br.ai.sources"
      }, {
        count: refs.length
      }),
      onItemClick: onRefClick ? (item) => {
        const ref = refs.find((r) => r.id === item.id);
        if (ref)
          onRefClick(ref);
      } : void 0
    }), onToggleVoice && !isSubmitting && /* @__PURE__ */ jsx(ActionButton, {
      intent: isVoice ? "cairPrimary" : "cairDefault",
      size: "xs",
      rounded: "sm",
      className: "self-start",
      leftIcon: /* @__PURE__ */ jsx(MdVolumeUp, {
        size: 16
      }),
      onClick: onToggleVoice,
      "aria-label": intl.formatMessage({
        id: "br.ai.readAloud"
      }),
      children: isVoice ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "br.ai.stopReading"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "br.ai.readAloud"
      })
    })]
  });
};
const NewQuestionBar = ({
  onClear
}) => /* @__PURE__ */ jsx("div", {
  className: "border-t border-[var(--cair-border)] px-[24px] py-[12px] w-full",
  children: /* @__PURE__ */ jsx(ActionButton, {
    intent: "cairSubtle",
    size: "xs",
    rounded: "sm",
    leftIcon: /* @__PURE__ */ jsx(MdClose, {
      size: 16
    }),
    onClick: onClear,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "br.ai.newQ"
    })
  })
});
const AskAiPanel = ({
  query,
  onQueryChange,
  onSubmit,
  onVoiceInput,
  isVoice,
  onToggleVoice,
  onRefClick,
  state,
  onClose,
  isSubmitting
}) => {
  const intl = useIntl();
  const isIdle = state.phase === "idle";
  const hasAnswer = state.phase === "answer" || state.phase === "answer-ref";
  return /* @__PURE__ */ jsxs(PanelShell, {
    icon: /* @__PURE__ */ jsx(MdAutoAwesome, {
      size: 20,
      className: "text-[color:var(--cair-premium)]"
    }),
    title: intl.formatMessage({
      id: "br.ai.title"
    }),
    titleColor: "premium",
    onClose,
    footer: void 0,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "px-[24px] py-[20px] w-full flex flex-col gap-[4px]",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex gap-[8px] items-center",
        onKeyDown: (e) => {
          if (e.key === "Enter" && query.trim().length > 0)
            onSubmit();
        },
        children: /* @__PURE__ */ jsx(VoiceTextInput, {
          value: query,
          onChange: onQueryChange,
          placeholder: intl.formatMessage({
            id: "br.ai.ph"
          }),
          onVoiceInput
        })
      }), isIdle && /* @__PURE__ */ jsx("p", {
        className: "font-light text-[length:var(--cair-text-small)] text-[color:var(--cair-text-secondary)] leading-[1.75]",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.ai.disclaimer"
        })
      }), query.trim().length > 0 && /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "xs",
        rounded: "sm",
        className: "self-end mt-[4px]",
        onClick: onSubmit,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.ai.ask"
        })
      })]
    }), isSubmitting && !hasAnswer && /* @__PURE__ */ jsxs("div", {
      className: "px-[24px] py-[24px] flex items-center gap-[10px]",
      children: [/* @__PURE__ */ jsx(Spinner, {
        size: "sm"
      }), /* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-small)] text-[color:var(--cair-text-tertiary)]",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.ai.searching"
        })
      })]
    }), hasAnswer && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(AnswerBody, {
        answer: "answer" in state ? state.answer : "",
        refs: "refs" in state ? state.refs : void 0,
        isSubmitting,
        isVoice,
        onToggleVoice,
        onRefClick
      }), !isSubmitting && /* @__PURE__ */ jsx(NewQuestionBar, {
        onClear: () => onQueryChange("")
      })]
    })]
  });
};

const FONT_OPTIONS = [{
  value: "inter",
  label: "Inter",
  sub: "Sans-serif",
  className: "font-sans"
}, {
  value: "times",
  label: "Times New Roman",
  sub: "Traditional",
  className: "font-serif"
}, {
  value: "opendyslexic",
  label: "OpenDyslexic",
  sub: "Accessibility",
  className: "font-sans"
}, {
  value: "arabic-naskh",
  label: "\u0646\u0648\u062A\u0648 \u0646\u0633\u062E \u0639\u0631\u0628\u064A",
  sub: "Arabic Serif",
  className: "",
  style: {
    fontFamily: '"Noto Naskh Arabic", "Amiri", serif'
  },
  dir: "rtl"
}, {
  value: "arabic-kufi",
  label: "\u0643\u0648\u0641\u064A \u0639\u0631\u0628\u064A",
  sub: "Arabic Sans",
  className: "",
  style: {
    fontFamily: '"Droid Arabic Kufi", "Tajawal", "Noto Sans Arabic", sans-serif'
  },
  dir: "rtl"
}, {
  value: "arabic-muna",
  label: "\u0645\u0646\u0649",
  sub: "Arabic Naskh",
  className: "",
  style: {
    fontFamily: "MunaOT, droid_arabic_kufi, sans-serif"
  },
  dir: "rtl"
}];
const SliderRow = ({
  label,
  value,
  display,
  min,
  max,
  step,
  minLabel,
  maxLabel,
  onChange
}) => {
  const pct = (value - min) / (max - min) * 100;
  const decrement = () => onChange(Math.max(min, value - step));
  const increment = () => onChange(Math.min(max, value + step));
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-[8px]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-medium text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] leading-[1.75]",
        children: label
      }), /* @__PURE__ */ jsx("span", {
        className: "font-normal text-[length:var(--cair-text-small)] text-[color:var(--cair-text-secondary)] leading-[1.5]",
        children: display
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-[0px]",
      children: [/* @__PURE__ */ jsx("div", {
        className: "w-[48px] flex items-center pr-[16px]",
        children: /* @__PURE__ */ jsx("button", {
          onClick: decrement,
          className: "w-[32px] h-[32px] border border-[var(--cair-surface)] rounded-full flex items-center justify-center shrink-0 text-[color:var(--cair-text-secondary)] text-[18px] leading-none",
          "aria-label": `Decrease ${label}`,
          children: "\u2212"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "relative flex-1 h-[8px] bg-[var(--cair-surface)] rounded-full",
        children: [/* @__PURE__ */ jsx("div", {
          className: "absolute top-0 left-0 h-[8px] bg-[var(--cair-accent)] rounded-full",
          style: {
            width: `${pct}%`
          }
        }), /* @__PURE__ */ jsx("input", {
          type: "range",
          min,
          max,
          step,
          value,
          onChange: (e) => onChange(parseFloat(e.target.value)),
          className: "absolute inset-0 w-full h-full opacity-0 cursor-pointer"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "w-[48px] flex items-center pl-[16px]",
        children: /* @__PURE__ */ jsx("button", {
          onClick: increment,
          className: "w-[32px] h-[32px] border border-[var(--cair-surface)] rounded-full flex items-center justify-center shrink-0 text-[color:var(--cair-text-secondary)] text-[18px] leading-none",
          "aria-label": `Increase ${label}`,
          children: "+"
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between px-[48px]",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-normal text-[length:var(--cair-text-small)] text-[color:var(--cair-text-secondary)] leading-[1.5]",
        children: minLabel
      }), /* @__PURE__ */ jsx("span", {
        className: "font-normal text-[length:var(--cair-text-small)] text-[color:var(--cair-text-secondary)] leading-[1.5]",
        children: maxLabel
      })]
    })]
  });
};
const THEME_SWATCHES = [{
  value: "light",
  label: "Light",
  bg: "#e8e9ec",
  border: "#e8e9ec",
  selectedOutline: "#1e2c44"
}, {
  value: "sepia",
  label: "Sepia",
  bg: "#f9f4eb",
  border: "#c7933f",
  selectedOutline: "#c7933f"
}, {
  value: "dark",
  label: "Dark",
  bg: "#090d14",
  border: "rgba(255, 255, 255, 0.30)",
  selectedOutline: "#ffffff"
}];
const ReaderPreferencesPanel = ({
  onClose
}) => {
  const intl = useIntl();
  const {
    theme,
    font,
    fontSize,
    lineSpacing,
    setTheme,
    setFont,
    setFontSize,
    setLineSpacing,
    resetPrefs
  } = useCairTheme();
  return /* @__PURE__ */ jsx(PanelShell, {
    icon: /* @__PURE__ */ jsx(MdSettings, {
      size: 20,
      className: "text-[color:var(--cair-accent)]"
    }),
    title: intl.formatMessage({
      id: "br.prefs.title"
    }),
    onClose,
    footer: /* @__PURE__ */ jsx(ActionButton, {
      intent: "cairSubtle",
      size: "md",
      rounded: "sm",
      className: "flex-1 h-[46px]",
      onClick: resetPrefs,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "br.prefs.reset"
      })
    }),
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[20px] px-[24px] py-[20px] w-full",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[12px]",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] leading-[1.75]",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "br.prefs.fontType"
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "grid grid-cols-2 gap-[8px]",
          children: FONT_OPTIONS.map(({
            value,
            className,
            style,
            dir
          }) => /* @__PURE__ */ jsx(PanelOptionCell, {
            primary: intl.formatMessage({
              id: `br.prefs.font.${value}.label`
            }),
            secondary: intl.formatMessage({
              id: `br.prefs.font.${value}.sub`
            }),
            selected: font === value,
            primaryClassName: className,
            primaryStyle: style,
            primaryDir: dir,
            onClick: () => setFont(value)
          }, value))
        })]
      }), /* @__PURE__ */ jsx(SliderRow, {
        label: intl.formatMessage({
          id: "br.prefs.fontSize"
        }),
        value: fontSize,
        display: `${fontSize}px`,
        min: 12,
        max: 24,
        step: 1,
        minLabel: "12px",
        maxLabel: "24px",
        onChange: setFontSize
      }), /* @__PURE__ */ jsx(SliderRow, {
        label: intl.formatMessage({
          id: "br.prefs.lineSpacing"
        }),
        value: lineSpacing,
        display: `${lineSpacing.toFixed(1)}x`,
        min: 1.2,
        max: 2,
        step: 0.1,
        minLabel: "1.2x",
        maxLabel: "2.0x",
        onChange: setLineSpacing
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[12px]",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] leading-[1.75]",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "br.prefs.theme"
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "grid grid-cols-3 gap-[8px]",
          children: THEME_SWATCHES.map(({
            value,
            bg,
            border,
            selectedOutline
          }) => /* @__PURE__ */ jsxs("button", {
            onClick: () => setTheme(value),
            className: "flex gap-[8px] items-center px-[12px] py-[8px] rounded-[var(--cair-radius-md)] bg-[var(--cair-surface-elevated)] border border-[var(--cair-border-strong)]",
            style: theme === value ? {
              outline: `2px solid ${selectedOutline}`,
              outlineOffset: "1px"
            } : {},
            children: [/* @__PURE__ */ jsx("span", {
              className: "shrink-0 w-[20px] h-[20px] rounded-full",
              style: {
                background: bg,
                border: `1px solid ${border}`
              }
            }), /* @__PURE__ */ jsx("span", {
              className: "font-normal text-[length:var(--cair-text-small)] text-[color:var(--cair-text-secondary)] leading-[1.5] whitespace-nowrap",
              children: intl.formatMessage({
                id: `br.prefs.themes.${value}`
              })
            })]
          }, value))
        })]
      })]
    })
  });
};

const snackbarVariants = cva(["inline-flex gap-[6px] items-center", "pl-[8px] pr-[10px] py-[4px]", "rounded-[4px]", "shadow-[0px_12px_16px_0px_rgba(0,0,0,0.08),0px_4px_6px_0px_rgba(0,0,0,0.03)]"], {
  variants: {
    type: {
      error: "bg-[var(--cair-error-darker)]",
      success: "bg-[var(--cair-success-darker)]",
      info: "bg-[var(--cair-info-darker)]",
      warning: "bg-[var(--cair-warning-dark)]"
    }
  },
  defaultVariants: {
    type: "info"
  }
});
const snackbarIcons = {
  error: MdErrorOutline,
  success: MdBookmarkAdded,
  info: MdInfo,
  warning: MdWarning
};
const CairSnackbar = ({
  type,
  message,
  visible = true,
  className
}) => {
  if (!visible)
    return null;
  const Icon = snackbarIcons[type];
  return /* @__PURE__ */ jsxs("div", {
    className: snackbarVariants({
      type,
      className
    }),
    children: [/* @__PURE__ */ jsx(Icon, {
      size: 16,
      className: "text-white shrink-0"
    }), /* @__PURE__ */ jsx("span", {
      className: "font-medium leading-[1.5] text-[length:var(--cair-text-tiny)] text-white whitespace-nowrap",
      children: message
    })]
  });
};
const INITIAL = {
  type: "info",
  message: "",
  visible: false
};
const useCairSnackbar = (durationMs = 2500) => {
  const [state, setState] = useState(INITIAL);
  const timerRef = useRef(null);
  const show = useCallback((type, message) => {
    if (timerRef.current)
      clearTimeout(timerRef.current);
    setState({
      type,
      message,
      visible: true
    });
    timerRef.current = setTimeout(() => setState((s) => ({
      ...s,
      visible: false
    })), durationMs);
  }, [durationMs]);
  const hide = useCallback(() => {
    if (timerRef.current)
      clearTimeout(timerRef.current);
    setState((s) => ({
      ...s,
      visible: false
    }));
  }, []);
  return {
    show,
    hide,
    props: state
  };
};

const SearchPanel = ({
  query,
  onQueryChange,
  onSearch,
  onVoiceInput,
  results,
  onSelectResult,
  onClose,
  isSubmitting
}) => {
  const handleKey = (e) => {
    if (e.key === "Enter")
      onSearch();
  };
  return /* @__PURE__ */ jsxs(PanelShell, {
    icon: /* @__PURE__ */ jsx(MdSearch, {
      size: 20,
      className: "text-[color:var(--cair-accent)]"
    }),
    title: "Search",
    onClose,
    footer: void 0,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "border-b border-[var(--cair-border)] px-[24px] py-[20px] w-full flex flex-col gap-[12px]",
      onKeyDown: handleKey,
      children: [/* @__PURE__ */ jsx(VoiceTextInput, {
        value: query,
        onChange: onQueryChange,
        placeholder: "Search\u2026",
        onVoiceInput
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "xs",
        rounded: "sm",
        disabled: !query.trim() || isSubmitting,
        onClick: onSearch,
        leftIcon: isSubmitting ? /* @__PURE__ */ jsx(Spinner, {
          size: "sm"
        }) : /* @__PURE__ */ jsx(MdSearch, {
          size: 16
        }),
        children: isSubmitting ? "Searching\u2026" : "Search"
      })]
    }), results.length > 0 && /* @__PURE__ */ jsx("div", {
      className: "px-[24px] py-[20px] w-full",
      children: /* @__PURE__ */ jsx(ChunkRefList, {
        items: results,
        onItemClick: onSelectResult
      })
    })]
  });
};

const ConnectedSearchPanel = ({
  onClose,
  closeOnSelect = true
}) => {
  const search = useReaderSearch();
  const handleSelectResult = (result) => {
    search.handleSelectResult(result);
    if (closeOnSelect)
      onClose();
  };
  const handleClose = () => {
    onClose();
  };
  return /* @__PURE__ */ jsx(SearchPanel, {
    query: search.query,
    onQueryChange: search.setQuery,
    onSearch: search.onSubmit,
    results: search.results,
    onSelectResult: handleSelectResult,
    onClose: handleClose,
    isSubmitting: search.isSubmitting
  });
};

const BookCairDesktopRightPanel = ({
  mode,
  onClose,
  onTtsToggle
}) => {
  const snackbar = useCairSnackbar();
  const [bookmarkName, setBookmarkName] = useState("");
  const [noteText, setNoteText] = useState("");
  const [aiQuery, setAiQuery] = useState("");
  const [aiState, setAiState] = useState({
    phase: "idle"
  });
  const [langCode, setLangCode] = useState("en");
  useState(false);
  const handleSaveBookmark = useMemoizedFn(() => {
    snackbar.show("success", "Bookmark saved");
    setBookmarkName("");
    onClose();
  });
  const handleSaveNote = useMemoizedFn(() => {
    snackbar.show("success", "Note saved");
    setNoteText("");
    onClose();
  });
  const handleAiSubmit = useMemoizedFn(() => {
    if (!aiQuery.trim())
      return;
    setAiState({
      phase: "answer-ref",
      answer: "Academic research frameworks guide inquiry, data collection, and interpretation. Mixed-method approaches integrate quantitative and qualitative methods for comprehensive insight.",
      refs: [{
        id: "1",
        excerpt: "The foundation of rigorous academic research lies in the careful selection of appropriate methodological frameworks.",
        location: "Chapter 3 \xB7 L53"
      }, {
        id: "2",
        excerpt: "Mixed-method approaches integrate quantitative and qualitative methods for comprehensive insight.",
        location: "Chapter 3 \xB7 L82"
      }]
    });
  });
  const handleAiClose = useMemoizedFn(() => {
    setAiState({
      phase: "idle"
    });
    setAiQuery("");
    onClose();
  });
  useMemoizedFn(() => {
    snackbar.show("success", "Preferences saved");
    onClose();
  });
  const handleSaveLang = useMemoizedFn(() => {
    snackbar.show("success", "Language saved");
    onClose();
  });
  const isOpen = mode !== null;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "absolute bottom-[16px] right-[16px] z-[50] pointer-events-none w-[288px]",
      children: /* @__PURE__ */ jsx(CairSnackbar, {
        ...snackbar.props
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "absolute right-0 top-[65px] bottom-0 w-[320px] z-[30] flex flex-col bg-[var(--cair-surface)] border-l border-[var(--cair-divider)] transition-transform duration-200 " + (isOpen ? "translate-x-0" : "translate-x-full"),
      children: [mode === "bookmark" && /* @__PURE__ */ jsx(AddBookmarkPanel, {
        name: bookmarkName,
        onChange: setBookmarkName,
        onSave: handleSaveBookmark,
        onClose
      }), mode === "note" && /* @__PURE__ */ jsx(AddNotePanel, {
        text: noteText,
        onChange: setNoteText,
        onSave: handleSaveNote,
        onClose
      }), mode === "search" && /* @__PURE__ */ jsx(ConnectedSearchPanel, {
        onClose,
        closeOnSelect: false
      }), mode === "ask-ai" && /* @__PURE__ */ jsx(AskAiPanel, {
        query: aiQuery,
        onQueryChange: setAiQuery,
        onSubmit: handleAiSubmit,
        state: aiState,
        onToggleVoice: onTtsToggle,
        onClose: handleAiClose
      }), mode === "preferences" && /* @__PURE__ */ jsx(ReaderPreferencesPanel, {
        onClose
      }), mode === "language" && /* @__PURE__ */ jsx(LanguageTranslationPanel, {
        selectedCode: langCode,
        onSelectLanguage: setLangCode,
        onSave: handleSaveLang,
        onClose
      })]
    })]
  });
};

const clientIdKey = (postId) => `cair_pos_id_${postId}`;
const getOrCreateClientId = (postId) => {
  try {
    const existing = localStorage.getItem(clientIdKey(postId));
    if (existing)
      return existing;
    const id = typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(clientIdKey(postId), id);
    return id;
  } catch {
    return `${postId}-pos`;
  }
};
const findCurrentPageId = (container) => {
  const pages = Array.from(container.querySelectorAll("[data-page-id]"));
  if (!pages.length)
    return null;
  const containerRect = container.getBoundingClientRect();
  const mid = containerRect.top + containerRect.height / 2;
  for (let i = 0; i < pages.length; i++) {
    const rect = pages[i].getBoundingClientRect();
    if (rect.bottom >= mid) {
      return pages[i].getAttribute("data-page-id") || null;
    }
  }
  const last = pages[pages.length - 1];
  return last.getAttribute("data-page-id") || null;
};
const SAVE_DEBOUNCE_MS = 2e3;
const useReadPosition = (postId, containerRef) => {
  const api = useApi();
  const [resumePageId, setResumePageId] = useState(null);
  const saveTimerRef = useRef(null);
  const lastPageIdRef = useRef(null);
  useEffect(() => {
    if (!postId)
      return;
    api.get({ path: `book-cair/${postId}/position` }).then((pos) => {
      if (pos && pos.pageId) {
        setResumePageId(pos.pageId);
      }
    }).catch(() => {
    });
  }, [postId]);
  const savePosition = useMemoizedFn(() => {
    if (!postId || !containerRef.current)
      return;
    const currentPageId = findCurrentPageId(containerRef.current);
    if (!currentPageId)
      return;
    lastPageIdRef.current = currentPageId;
    api.post({
      path: `book-cair/${postId}/interactions`,
      body: {
        type: "read_position",
        clientId: getOrCreateClientId(postId),
        pageId: currentPageId,
        scrollOffset: containerRef.current.scrollTop
      }
    }).catch(() => {
    });
  });
  useEffect(() => {
    if (!postId)
      return;
    const el = containerRef.current;
    if (!el)
      return;
    const onScroll = () => {
      if (saveTimerRef.current)
        clearTimeout(saveTimerRef.current);
      saveTimerRef.current = setTimeout(savePosition, SAVE_DEBOUNCE_MS);
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      el.removeEventListener("scroll", onScroll);
      if (saveTimerRef.current)
        clearTimeout(saveTimerRef.current);
      savePosition();
    };
  }, [postId, containerRef.current]);
  return { resumePageId };
};

var PostTypeEnum;
(function(PostTypeEnum2) {
  PostTypeEnum2["ARTICLE"] = "ARTICLE";
  PostTypeEnum2["ASSET"] = "ASSET";
  PostTypeEnum2["DISCUSSION"] = "DISCUSSION";
  PostTypeEnum2["EVENT"] = "EVENT";
})(PostTypeEnum || (PostTypeEnum = {}));
const BatchCircleOptionsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "BatchCircleOptions" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "input" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "BatchGetCircleOptionsInput" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "merged" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Boolean" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "batchCircleOptions" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "input" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "input" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "merged" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "merged" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "circleId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "options" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "type" } }, { "kind": "Field", "name": { "kind": "Name", "value": "options" } }] } }] } }] } }] };
const SaveBatchCircleOptionsDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "SaveBatchCircleOptions" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "input" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "BatchSaveCircleOptionsInput" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "saveBatchCircleOptions" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "input" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "input" } } }] }] } }] };
const GetSessionDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetSession" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "token" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "getSession" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "token" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "token" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "token" } }, { "kind": "Field", "name": { "kind": "Name", "value": "userId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "expiresAt" } }] } }] } }] };
const GetPostMetadataDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "GetPostMetadata" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "postId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ID" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "post" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "postId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "postId" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "title" } }, { "kind": "Field", "name": { "kind": "Name", "value": "author" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "lastname" } }, { "kind": "Field", "name": { "kind": "Name", "value": "firstname" } }, { "kind": "Field", "name": { "kind": "Name", "value": "username" } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "content" } }, { "kind": "Field", "name": { "kind": "Name", "value": "group" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "group" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "name" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriptionMonthlyPrice" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriptionYearlyPrice" } }] } }] } }, { "kind": "Field", "name": { "kind": "Name", "value": "metadata" } }, { "kind": "Field", "name": { "kind": "Name", "value": "created" } }, { "kind": "Field", "name": { "kind": "Name", "value": "tags" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accessType" } }, { "kind": "Field", "name": { "kind": "Name", "value": "price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "allowedDomains" } }, { "kind": "Field", "name": { "kind": "Name", "value": "image" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "uuid" } }] } }] } }] } }] };
const configurePostAccessDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "configurePostAccess" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "postId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ID" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "accessType" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "price" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Float" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "allowedDomains" } }, "type": { "kind": "ListType", "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "configurePostAccess" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "postId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "postId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "accessType" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "accessType" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "price" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "price" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "allowedDomains" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "allowedDomains" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "accessType" } }, { "kind": "Field", "name": { "kind": "Name", "value": "price" } }, { "kind": "Field", "name": { "kind": "Name", "value": "allowedDomains" } }] } }] } }] };
const configureCircleStripeDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "configureCircleStripe" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "circleId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ID" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "stripeMonthlyPriceId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "stripeYearlyPriceId" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "monthlyPrice" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Float" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "yearlyPrice" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "Float" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "configureCircleStripe" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "circleId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "circleId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "stripeMonthlyPriceId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "stripeMonthlyPriceId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "stripeYearlyPriceId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "stripeYearlyPriceId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "monthlyPrice" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "monthlyPrice" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "yearlyPrice" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "yearlyPrice" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "_id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "stripeMonthlyPriceId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "stripeYearlyPriceId" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriptionMonthlyPrice" } }, { "kind": "Field", "name": { "kind": "Name", "value": "subscriptionYearlyPrice" } }] } }] } }] };
const savePostMetadataDocument = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "savePostMetadata" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "postId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ID" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "metadata" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "JSON" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "savePostMetadata" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "postId" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "postId" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "metadata" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "metadata" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "_id" } }] } }] } }] };

const createGraphQLClient = async (api) => {
  const jwt = await api.loadJwt();
  return new GraphQLClient(isLocalhost() ? "http://localhost:3006/main/graphql/" : "/main/graphql/", {
    headers: {
      authorization: jwt && `Bearer ${jwt}`
    }
  });
};
const authorizationHeader = async (api) => {
  const jwt = await api.loadJwt();
  return {
    authorization: jwt && `Bearer ${jwt}`
  };
};
const useGraphQLClientFn = () => {
  const api = useApi();
  return useCallback(() => {
    return createGraphQLClient(api);
  }, [api]);
};

const usePostMetadata = (variables, op) => {
  const graphQLClient = useGraphQLClientFn();
  const result = useSWR(variables.postId ? [GetPostMetadataDocument, variables.postId] : null, async () => {
    const graphqlClient = await graphQLClient();
    const result2 = await graphqlClient.request(GetPostMetadataDocument, variables);
    return result2;
  }, {
    ...swrLoadOnce,
    revalidateOnFocus: true,
    ...op
  });
  return result;
};

const useBookAccessCheck = (postId) => {
  const api = useApi();
  const { data, error, isValidating, mutate } = useSWR(postId ? ["/post-access", postId] : null, async () => {
    return api.get({ path: `/post-access/${postId}` });
  }, {
    revalidateOnMount: true,
    revalidateOnFocus: true,
    revalidateOnReconnect: true
  });
  return {
    access: data || null,
    isLoading: isValidating && !data,
    error,
    reload: mutate
  };
};

const VALID_ACCESS_TYPES = new Set([
  "free",
  "free_donation",
  "purchase",
  "subscription",
  "domain",
  "admin"
]);
function parseAccessType(raw) {
  if (raw && VALID_ACCESS_TYPES.has(raw))
    return raw;
  return "free";
}
function toUiAccessType(accessType) {
  switch (accessType) {
    case "free":
      return "free";
    case "free_donation":
      return "support";
    case "purchase":
      return "locked";
    case "subscription":
      return "collection";
    case "domain":
      return "institutional";
    case "admin":
      return "locked";
  }
}
function toBadgeAccessType(accessType) {
  switch (accessType) {
    case "free":
    case "free_donation":
      return "free";
    case "subscription":
      return "collection";
    case "purchase":
    case "domain":
    case "admin":
    default:
      return "locked";
  }
}
function derivePaymentType(accessType, _hasCollection) {
  switch (accessType) {
    case "purchase":
      return "one_time";
    case "subscription":
      return "collection";
    case "free_donation":
      return "donation";
    default:
      return null;
  }
}

const DONATE_DISMISSED_PREFIX = "cair_donate_dismissed_";
function isDonationDismissed(postId) {
  if (!postId)
    return false;
  try {
    return localStorage.getItem(DONATE_DISMISSED_PREFIX + postId) === "1";
  } catch {
    return false;
  }
}
function setDonationDismissed(postId) {
  if (!postId)
    return;
  try {
    localStorage.setItem(DONATE_DISMISSED_PREFIX + postId, "1");
  } catch {
  }
}
const useBookAccess = () => {
  const { postId, post, isLoading: postLoading } = useBookReader();
  const { data: metaData, isValidating: metaValidating, error: metaError } = usePostMetadata({ postId });
  const { access: accessCheck, isLoading: accessLoading } = useBookAccessCheck(postId);
  const gqlPost = metaData && metaData.post;
  const preview = accessCheck && accessCheck.preview;
  const rawAccessType = parseAccessType(accessCheck && accessCheck.accessType || gqlPost && gqlPost.accessType || void 0);
  const uiAccessType = toUiAccessType(rawAccessType);
  const paymentType = derivePaymentType(rawAccessType);
  const userHasAccess = !!(accessCheck && accessCheck.hasAccess);
  const wouldBeLocked = uiAccessType === "locked" || uiAccessType === "collection" || uiAccessType === "institutional";
  const isLocked = accessCheck ? !accessCheck.hasAccess : wouldBeLocked && !userHasAccess;
  const isSupportable = uiAccessType === "support";
  const isFree = uiAccessType === "free";
  const metaLoading = metaValidating && !metaData && !metaError;
  const isReady = !!postId && !postLoading && !metaLoading && !accessLoading;
  const circleId = gqlPost && gqlPost.group && gqlPost.group.group ? gqlPost.group.group._id : preview && preview.circleId || void 0;
  const circleName = gqlPost && gqlPost.group && gqlPost.group.group && gqlPost.group.group.name || preview && preview.circleName || "";
  const allowedDomains = gqlPost && gqlPost.allowedDomains || preview && preview.allowedDomains || [];
  const metadata = gqlPost ? gqlPost.metadata : null;
  const metadataTitle = metadata && typeof metadata.title === "string" && metadata.title || gqlPost && gqlPost.title || preview && preview.title || "";
  const metadataSummary = metadata && typeof metadata.summary === "string" && metadata.summary || preview && preview.summary || "";
  const gqlAuthor = gqlPost ? gqlPost.author : null;
  const metadataAuthor = useMemo(() => {
    if (metadata && typeof metadata.author === "string" && metadata.author)
      return metadata.author;
    if (gqlAuthor) {
      const name = [gqlAuthor.firstname, gqlAuthor.lastname].filter(Boolean).join(" ") || gqlAuthor.username || "";
      if (name)
        return name;
    }
    return preview && preview.author || "";
  }, [metadata, gqlAuthor, preview]);
  const metadataLanguage = post && post.language || preview && preview.language || "";
  const [donateDismissed, setDonateDismissedState] = useState(() => isDonationDismissed(postId));
  useMemo(() => {
    if (postId) {
      const dismissed = isDonationDismissed(postId);
      if (dismissed !== donateDismissed)
        setDonateDismissedState(dismissed);
    }
  }, [postId]);
  const dismissDonate = useCallback(() => {
    setDonationDismissed(postId);
    setDonateDismissedState(true);
  }, [postId]);
  const navigateToPayment = useMemoizedFn(() => {
    if (!paymentType || !postId)
      return;
    const path = window.location.pathname;
    const sourceMatch = path.match(/\/live-book-cair-(desktop|mobile)/);
    const source = sourceMatch ? sourceMatch[1] : "";
    const params = new URLSearchParams({
      type: paymentType,
      accessType: rawAccessType,
      documentId: postId,
      ...circleId ? { circleId } : {},
      ...source ? { source } : {}
    });
    window.location.href = bookCairPaymentUrl(`?${params}`);
  });
  return {
    rawAccessType,
    uiAccessType,
    paymentType,
    isLocked,
    isSupportable,
    isFree,
    isReady,
    circleId,
    circleName,
    metadataTitle,
    metadataSummary,
    metadataAuthor,
    metadataLanguage,
    allowedDomains,
    donateDismissed,
    dismissDonate,
    navigateToPayment
  };
};

const RTL_CHARS$2 = "\\u0590-\\u08FF\\u200F\\u202B\\u202E\\uFB1D-\\uFDFF\\uFE70-\\uFEFF";
const LTR_CHARS = "A-Za-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02B8\\u0370-\\u058F\\u0900-\\u1FFF\\u200E\\u2C00-\\uFB1C\\uFE00-\\uFE6F\\uFF00-\\uFFFF";
const NEUTRAL = `[^${LTR_CHARS}${RTL_CHARS$2}]*`;
const STARTS_RTL = new RegExp(`^${NEUTRAL}[${RTL_CHARS$2}]`);
const STARTS_LTR = new RegExp(`^${NEUTRAL}[${LTR_CHARS}]`);
const detectTextDirection = (text) => {
  if (!text)
    return null;
  if (STARTS_RTL.test(text))
    return "rtl";
  if (STARTS_LTR.test(text))
    return "ltr";
  return null;
};
const isRtlText = (text) => detectTextDirection(text) === "rtl";
const resolveTextDirection = (language, ...texts) => {
  for (const text of texts) {
    const detected = detectTextDirection(text);
    if (detected)
      return detected;
  }
  return language ? getDirection$1(language) : "ltr";
};

const BookLockedLanding = ({
  title,
  summary,
  accessType,
  rawAccessType,
  collectionName,
  allowedDomains,
  language,
  onUnlock
}) => {
  const isCollection = accessType === "collection";
  const isInstitutional = accessType === "institutional";
  const isAdminOnly = rawAccessType === "admin";
  const dir = resolveTextDirection(language, summary, title);
  const isRtl = dir === "rtl";
  const buttonLabel = isCollection ? collectionName ? isRtl ? `\u0627\u0634\u062A\u0631\u0643 \u0641\u064A ${collectionName}` : `Subscribe to ${collectionName}` : isRtl ? "\u0627\u0634\u062A\u0631\u0643" : "Subscribe" : isInstitutional ? isRtl ? "\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u0648\u0635\u0648\u0644" : "Verify access" : isAdminOnly ? void 0 : isRtl ? "\u0627\u0641\u062A\u062D \u0647\u0630\u0627 \u0627\u0644\u0643\u062A\u0627\u0628" : "Unlock this book";
  const freeSummaryLabel = isRtl ? "\u0645\u0644\u062E\u0635 \u0645\u062C\u0627\u0646\u064A" : "Free summary";
  const ButtonIcon = isCollection ? MdLayers : MdLock;
  return /* @__PURE__ */ jsx("div", {
    className: "flex-1 overflow-y-auto bg-[var(--cair-surface-background)]",
    dir,
    children: /* @__PURE__ */ jsxs("div", {
      className: "w-full max-w-[560px] mx-auto px-[24px] py-[48px] flex flex-col gap-[24px]",
      children: [/* @__PURE__ */ jsx("span", {
        className: "inline-flex items-center self-start px-[12px] py-[4px] rounded-[4px] text-[14px] font-normal leading-[1.4]",
        style: {
          backgroundColor: "#ffffff",
          border: "1px solid #52c41a",
          color: "#52c41a"
        },
        children: freeSummaryLabel
      }), /* @__PURE__ */ jsx("h1", {
        dir: "auto",
        className: "text-[24px] font-semibold text-[color:var(--cair-text)] leading-[1.4]",
        children: title
      }), /* @__PURE__ */ jsx("hr", {
        className: "border-[var(--cair-divider)] w-full"
      }), summary && /* @__PURE__ */ jsx("p", {
        dir: "auto",
        className: "text-[length:var(--cair-text-regular)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.75] whitespace-pre-wrap",
        children: summary
      }), isInstitutional && allowedDomains && allowedDomains.length > 0 && /* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
        children: isRtl ? `\u0633\u062C\u0651\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0628\u0631\u064A\u062F \u0645\u0624\u0633\u0633\u062A\u0643 (${allowedDomains.map((d) => `@${d}`).join("\u060C ")}) \u0644\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0647\u0630\u0627 \u0627\u0644\u0643\u062A\u0627\u0628.` : `Log in with your institutional email (${allowedDomains.map((d) => `@${d}`).join(", ")}) to access this book.`
      }), isAdminOnly && /* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
        children: isRtl ? "\u0647\u0630\u0627 \u0627\u0644\u0643\u062A\u0627\u0628 \u0645\u062A\u0627\u062D \u0644\u0645\u0634\u0631\u0641\u064A \u0627\u0644\u062F\u0627\u0626\u0631\u0629 \u0641\u0642\u0637." : "This book is restricted to circle administrators."
      }), buttonLabel && /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        onClick: onUnlock,
        className: "w-full max-w-[320px]",
        leftIcon: /* @__PURE__ */ jsx(ButtonIcon, {
          size: 16
        }),
        children: buttonLabel
      })]
    })
  });
};

const SupportHeartIcon = function(props) {
  var s = props.size || 24;
  var h = Math.round(s * (18 / 23));
  return /* @__PURE__ */ jsx("svg", {
    width: s,
    height: h,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: props.className,
    style: props.style,
    children: /* @__PURE__ */ jsx("path", {
      d: "M0 5.5365C0 3.99033 0.518417 2.681 1.55525 1.6085C2.59225 0.536166 3.87367 0 5.3995 0C6.34667 0 7.22317 0.214833 8.029 0.644499C8.83467 1.07433 9.5415 1.70625 10.1495 2.54025C10.8575 1.66025 11.6017 1.01683 12.382 0.609999C13.1623 0.203332 14.0008 0 14.8975 0C16.2108 0 17.3284 0.433333 18.2502 1.3C19.1723 2.16667 19.7598 3.229 20.013 4.487C20.0663 4.711 20.0301 4.91592 19.9043 5.10175C19.7786 5.28775 19.6033 5.4055 19.3785 5.455C19.1537 5.50467 18.9491 5.4675 18.7647 5.3435C18.5802 5.2195 18.4616 5.04483 18.4088 4.8195C18.2668 3.93483 17.8903 3.19525 17.2793 2.60075C16.6681 2.00642 15.8739 1.70925 14.8968 1.70925C14.0352 1.70925 13.2615 1.95967 12.5755 2.4605C11.8893 2.96117 11.3499 3.6055 10.9573 4.3935C10.8659 4.55083 10.746 4.67808 10.5975 4.77525C10.4492 4.87258 10.2915 4.92125 10.1245 4.92125C9.95467 4.92125 9.80042 4.87358 9.66175 4.77825C9.52308 4.68308 9.41017 4.55483 9.323 4.3935C8.93417 3.6015 8.39942 2.95617 7.71875 2.4575C7.03808 1.95867 6.26383 1.70925 5.396 1.70925C4.31033 1.70925 3.4245 2.07533 2.7385 2.8075C2.05233 3.53967 1.70925 4.44858 1.70925 5.53425C1.70925 6.18975 1.83758 6.82558 2.09425 7.44175C2.35092 8.05792 2.79692 8.75792 3.43225 9.54175C4.06775 10.3256 4.93258 11.2402 6.02675 12.2857C7.12092 13.3312 8.49517 14.6212 10.1495 16.1555L12.2875 14.2815C12.4412 14.1283 12.6302 14.0567 12.8547 14.0667C13.0792 14.0767 13.2712 14.16 13.4305 14.3165C13.6008 14.4798 13.685 14.6838 13.683 14.9283C13.681 15.1729 13.5867 15.3718 13.4 15.525L11.3 17.386C11.1342 17.5352 10.9497 17.6429 10.7465 17.7092C10.5435 17.7756 10.3424 17.8088 10.1433 17.8088C9.94425 17.8088 9.7465 17.7737 9.55 17.7035C9.35367 17.6333 9.17833 17.5212 9.024 17.367C8.11133 16.5242 7.1295 15.6342 6.0785 14.697C5.02767 13.7598 4.05233 12.7911 3.1525 11.7907C2.25267 10.7904 1.50233 9.76208 0.9015 8.70575C0.3005 7.64942 0 6.593 0 5.5365ZM17.1245 11.073H14.7263C14.4858 11.073 14.2837 10.9907 14.12 10.826C13.9563 10.6615 13.8745 10.4584 13.8745 10.2168C13.8745 9.97525 13.9563 9.77367 14.12 9.612C14.2837 9.45033 14.4858 9.3695 14.7263 9.3695H17.1245V6.97125C17.1245 6.73092 17.2067 6.52892 17.3713 6.36525C17.5357 6.20142 17.7388 6.1195 17.9805 6.1195C18.2222 6.1195 18.4238 6.20142 18.5855 6.36525C18.747 6.52892 18.8277 6.73092 18.8277 6.97125V9.3695H21.2263C21.4666 9.3695 21.6686 9.45183 21.8323 9.6165C21.9959 9.781 22.0777 9.98408 22.0777 10.2257C22.0777 10.4672 21.9959 10.6688 21.8323 10.8305C21.6686 10.9922 21.4666 11.073 21.2263 11.073H18.8277V13.4712C18.8277 13.7116 18.7455 13.9136 18.581 14.0772C18.4165 14.2411 18.2134 14.323 17.9718 14.323C17.7301 14.323 17.5285 14.2411 17.367 14.0772C17.2053 13.9136 17.1245 13.7116 17.1245 13.4712V11.073Z",
      fill: "currentColor"
    })
  });
};

const badgeVariants = cva("border border-solid flex items-center p-[4px] rounded-[16px] shrink-0", {
  variants: {
    type: {
      free: "bg-[var(--cair-surface-elevated)] border-[var(--cair-accent-subtle)]",
      support: "bg-[var(--cair-surface-elevated)] border-[var(--cair-accent-subtle)]",
      locked: "bg-[var(--cair-accent)] border-[var(--cair-accent)]",
      institutional: "bg-[var(--cair-accent)] border-[var(--cair-accent)]",
      collection: "bg-[var(--cair-premium-subtle)] border-[var(--cair-premium-subtle)]"
    }
  },
  defaultVariants: {
    type: "free"
  }
});
const iconColors = {
  free: "text-[color:var(--cair-accent)]",
  support: "text-[color:var(--cair-accent)]",
  locked: "text-white",
  institutional: "text-white",
  collection: "text-[color:var(--cair-premium)]"
};
const icons = {
  free: MdMenuBook,
  support: MdFavorite,
  locked: MdLock,
  institutional: MdAccountBalance,
  collection: MdLayers
};
const AccessTypeIcon = ({
  type,
  className
}) => {
  const Icon = icons[type];
  return /* @__PURE__ */ jsx("div", {
    className: badgeVariants({
      type,
      className
    }),
    children: /* @__PURE__ */ jsx(Icon, {
      size: 14,
      className: iconColors[type]
    })
  });
};

const VARIANT_CONFIG = {
  free: {
    statusTitle: "Free access",
    statusDescription: "This book is fully available to read at no cost."
  },
  support: {
    statusTitle: "Free with optional supportFree to read. You\u2019re welcome to support the platform",
    statusDescription: "Your contribution helps sustain access, expand shared knowledge, and bring more works into our Memory Project."
  },
  institutional: {
    statusTitle: "Access via institution",
    statusDescription: "You may have access through your institution using your email address."
  },
  collection: {
    statusTitle: "Included in collection",
    statusDescription: "Access this book with a subscription to the collection."
  },
  locked: {
    statusTitle: "Locked",
    statusDescription: "Get full access to this book with a one-time purchase."
  }
};
const BookDetailsPanel = ({
  image,
  title,
  author,
  publisher,
  year,
  language,
  accessType,
  collectionName,
  institutionName,
  hasAccess,
  onStartReading,
  onSupportDonate,
  onSubscribe,
  onUnlock,
  onReadSummary,
  onClose
}) => {
  const meta = [publisher, year, language].filter(Boolean);
  const variant = VARIANT_CONFIG[accessType];
  const statusTitle = accessType === "institutional" && institutionName ? `Access via ${institutionName}` : accessType === "collection" && collectionName ? variant.statusTitle : variant.statusTitle;
  const statusDescription = accessType === "collection" && collectionName ? `Access this book with a subscription to the ${collectionName}.` : accessType === "institutional" && institutionName ? `You may have access through ${institutionName} using your email address.` : variant.statusDescription;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col bg-[var(--cair-surface-elevated)] rounded-t-[var(--cair-radius-lg)] border-b border-[var(--cair-border-strong)]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full flex items-center justify-between px-[24px] pt-[16px] pb-[17px] border-b border-[var(--cair-border)]",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
        children: "Book details"
      }), /* @__PURE__ */ jsx("button", {
        onClick: onClose,
        className: "w-[20px] h-[20px] flex items-center justify-center text-[color:var(--cair-text-secondary)]",
        "aria-label": "Close",
        children: /* @__PURE__ */ jsx(MdClose, {
          size: 16
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex gap-[8px] items-start px-[24px] pt-[20px] pb-[17px] border-b border-[var(--cair-border-strong)] bg-[var(--cair-surface-elevated)]",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "relative shrink-0 w-[112px] self-stretch rounded-[var(--cair-radius-sm)] overflow-hidden bg-[var(--cair-text-secondary)]",
        children: [/* @__PURE__ */ jsx(BookCover, {
          image,
          width: 112,
          height: 112,
          radius: "sm"
        }), /* @__PURE__ */ jsx("div", {
          className: "absolute left-0 bottom-0 top-1/2 w-[4px] bg-[var(--cair-accent)]"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 min-w-0 flex flex-col gap-[4px]",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] font-semibold text-[color:var(--cair-accent)] leading-[1.5]",
          children: title
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
          children: author
        }), meta.length > 0 && /* @__PURE__ */ jsx("div", {
          className: "flex flex-wrap items-center gap-[8px]",
          children: meta.map((item, i) => /* @__PURE__ */ jsxs("span", {
            className: "text-[length:var(--cair-text-tiny)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.2] whitespace-nowrap",
            children: [i > 0 && /* @__PURE__ */ jsx("span", {
              className: "mr-[8px]",
              children: "\u2022"
            }), item]
          }, i))
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex items-start gap-[12px] px-[24px] pt-[16px] pb-[17px] border-b border-[var(--cair-border-strong)] bg-[var(--cair-surface)]",
      children: [/* @__PURE__ */ jsx(AccessTypeIcon, {
        type: accessType,
        className: "shrink-0 mt-[2px]"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 min-w-0 flex flex-col gap-[2px]",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text)] leading-[1.5]",
          children: statusTitle
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
          children: statusDescription
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex flex-col gap-[8px] px-[24px] py-[16px] bg-[var(--cair-surface-elevated)]",
      children: [accessType === "free" && onStartReading && /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        onClick: onStartReading,
        className: "w-full",
        children: "Start Reading"
      }), accessType === "support" && /* @__PURE__ */ jsxs(Fragment, {
        children: [onStartReading && /* @__PURE__ */ jsx(ActionButton, {
          intent: "cairPrimary",
          size: "md",
          rounded: "sm",
          onClick: onStartReading,
          children: "Start Reading"
        }), onSupportDonate && /* @__PURE__ */ jsx(ActionButton, {
          intent: "cairSubtle",
          size: "md",
          rounded: "sm",
          onClick: onSupportDonate,
          leftIcon: /* @__PURE__ */ jsx(SupportHeartIcon, {
            size: 24
          }),
          style: {
            backgroundColor: "#e8e9ec",
            borderColor: "#d9d9d9",
            color: "#1e2c44"
          },
          children: "Support with donation"
        })]
      }), accessType === "institutional" && onStartReading && /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        onClick: onStartReading,
        className: "w-full",
        children: "Start Reading"
      }), accessType === "collection" && /* @__PURE__ */ jsxs(Fragment, {
        children: [hasAccess ? onStartReading && /* @__PURE__ */ jsx(ActionButton, {
          intent: "cairPrimary",
          size: "md",
          rounded: "sm",
          onClick: onStartReading,
          className: "w-full",
          children: "Start Reading"
        }) : onSubscribe && /* @__PURE__ */ jsx(ActionButton, {
          intent: "cairPrimary",
          size: "md",
          rounded: "sm",
          onClick: onSubscribe,
          className: "w-full",
          leftIcon: /* @__PURE__ */ jsx(MdLayers, {
            size: 16
          }),
          children: collectionName ? `Subscribe to ${collectionName}` : "Subscribe"
        }), onReadSummary && /* @__PURE__ */ jsx("button", {
          onClick: onReadSummary,
          className: "w-full flex items-center justify-center text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75] underline",
          children: "Read Summary"
        })]
      }), accessType === "locked" && /* @__PURE__ */ jsxs(Fragment, {
        children: [hasAccess ? onStartReading && /* @__PURE__ */ jsx(ActionButton, {
          intent: "cairPrimary",
          size: "md",
          rounded: "sm",
          onClick: onStartReading,
          className: "w-full",
          children: "Start Reading"
        }) : onUnlock && /* @__PURE__ */ jsx(ActionButton, {
          intent: "cairPrimary",
          size: "md",
          rounded: "sm",
          onClick: onUnlock,
          className: "w-full",
          children: "Unlock this book"
        }), onReadSummary && /* @__PURE__ */ jsx("button", {
          onClick: onReadSummary,
          className: "w-full flex items-center justify-center text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75] underline",
          children: "Read Summary"
        })]
      })]
    })]
  });
};

const BookSummaryPanel = ({
  title,
  summary,
  language,
  onClose
}) => {
  const hasSummary = !!(summary && summary.trim());
  const dir = resolveTextDirection(language, summary, title);
  const isRtl = dir === "rtl";
  return /* @__PURE__ */ jsxs("div", {
    dir,
    className: "w-full flex flex-col bg-[var(--cair-surface-elevated)] rounded-t-[var(--cair-radius-lg)] border-b border-[var(--cair-border-strong)]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full flex items-center gap-[8px] px-[24px] pt-[16px] pb-[17px] border-b border-[var(--cair-border)]",
      children: [/* @__PURE__ */ jsx(MdMenuBook, {
        size: 20,
        className: "text-[color:var(--cair-accent)] shrink-0"
      }), /* @__PURE__ */ jsx("span", {
        className: "flex-1 text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
        children: isRtl ? "\u0627\u0644\u0645\u0644\u062E\u0635" : "Summary"
      }), /* @__PURE__ */ jsx("button", {
        onClick: onClose,
        className: "w-[20px] h-[20px] flex items-center justify-center text-[color:var(--cair-text-secondary)]",
        "aria-label": isRtl ? "\u0625\u063A\u0644\u0627\u0642" : "Close",
        children: /* @__PURE__ */ jsx(MdClose, {
          size: 16
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex flex-col gap-[12px] px-[24px] pt-[20px] pb-[24px] max-h-[60vh] overflow-y-auto",
      children: [title && /* @__PURE__ */ jsx("p", {
        dir: "auto",
        className: "text-[length:var(--cair-text-regular)] font-semibold text-[color:var(--cair-text)] leading-[1.5]",
        children: title
      }), hasSummary ? /* @__PURE__ */ jsx("p", {
        dir: "auto",
        className: "text-[length:var(--cair-text-regular)] font-normal text-[color:var(--cair-text)] leading-[1.75] whitespace-pre-wrap",
        children: summary
      }) : /* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-regular)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5] italic",
        children: isRtl ? "\u0644\u0627 \u064A\u0648\u062C\u062F \u0645\u0644\u062E\u0635 \u0644\u0647\u0630\u0627 \u0627\u0644\u0643\u062A\u0627\u0628." : "No summary available for this book."
      })]
    })]
  });
};

const SupportDonatePanel = ({
  onDonate,
  onContinueWithout,
  onClose
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col bg-[var(--cair-surface-elevated)] rounded-t-[var(--cair-radius-lg)] border-b border-[var(--cair-border-strong)]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full flex items-center gap-[8px] px-[24px] pt-[16px] pb-[17px] border-b border-[var(--cair-border)]",
      children: [/* @__PURE__ */ jsx(SupportHeartIcon, {
        size: 20,
        className: "text-[color:var(--cair-accent)] shrink-0"
      }), /* @__PURE__ */ jsx("span", {
        className: "flex-1 text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
        children: "Support this book"
      }), /* @__PURE__ */ jsx("button", {
        onClick: onClose,
        className: "w-[20px] h-[20px] flex items-center justify-center text-[color:var(--cair-text-secondary)]",
        "aria-label": "Close",
        children: /* @__PURE__ */ jsx(MdClose, {
          size: 16
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex flex-col gap-[16px] px-[24px] pt-[20px] pb-[17px] border-b border-[var(--cair-border-strong)] bg-[var(--cair-surface-elevated)]",
      style: {
        boxShadow: "0px 1px 2px rgba(0,0,0,0.05)"
      },
      children: [/* @__PURE__ */ jsx("div", {
        className: "pb-[20px]",
        children: /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] font-normal text-[color:var(--cair-text)] leading-[1.75]",
          children: "This book is free to read. You can support the platform if you'd like."
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "w-full h-[1px] bg-[var(--cair-divider)]"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[16px] pb-[20px]",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
          children: "Why donate?"
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] font-normal text-[color:var(--cair-text)] leading-[1.75]",
          children: "Your support helps cover hosting, development, and access to more books from publishers and archives."
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex flex-col gap-[8px] px-[24px] py-[16px] bg-[var(--cair-surface-elevated)]",
      children: [/* @__PURE__ */ jsx(ActionButton, {
        intent: "cairSubtle",
        size: "md",
        rounded: "sm",
        onClick: onContinueWithout,
        className: "w-full",
        children: "Continue without donating"
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        onClick: onDonate,
        className: "w-full",
        children: "Donate"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-tiny)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5] text-center",
        children: "Donations are optional and do not affect your access."
      })]
    })]
  });
};

const BookAccessGate = ({
  children,
  dialogPlacement = "bottom"
}) => {
  const {
    post
  } = useBookReader();
  const {
    rawAccessType,
    uiAccessType,
    isLocked,
    isSupportable,
    isReady,
    metadataTitle,
    metadataSummary,
    metadataAuthor,
    metadataLanguage,
    circleName,
    allowedDomains,
    donateDismissed,
    dismissDonate,
    navigateToPayment
  } = useBookAccess();
  const [unlockModalOpen, setUnlockModalOpen] = useState(false);
  const [donateModalOpen, setDonateModalOpen] = useState(false);
  const [summaryModalOpen, setSummaryModalOpen] = useState(false);
  useEffect(() => {
    if (isReady && isSupportable && !donateDismissed) {
      setDonateModalOpen(true);
    }
  }, [isReady, isSupportable, donateDismissed]);
  if (!isReady) {
    return /* @__PURE__ */ jsx("div", {
      className: "flex-1 bg-[var(--cair-surface-background)]"
    });
  }
  if (isLocked) {
    const handleUnlock = rawAccessType === "domain" ? () => window.location.reload() : () => setUnlockModalOpen(true);
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(BookLockedLanding, {
        title: metadataTitle,
        summary: metadataSummary,
        accessType: uiAccessType,
        rawAccessType,
        collectionName: circleName || void 0,
        allowedDomains,
        language: metadataLanguage,
        onUnlock: handleUnlock
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: unlockModalOpen,
        onClose: () => setUnlockModalOpen(false),
        placement: dialogPlacement,
        size: "sm",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(BookDetailsPanel, {
          title: metadataTitle,
          image: post && post.image,
          author: metadataAuthor,
          accessType: uiAccessType,
          collectionName: circleName || void 0,
          onUnlock: navigateToPayment,
          onSubscribe: navigateToPayment,
          onStartReading: () => setUnlockModalOpen(false),
          onSupportDonate: () => {
            setUnlockModalOpen(false);
            setDonateModalOpen(true);
          },
          onReadSummary: () => {
            setUnlockModalOpen(false);
            setSummaryModalOpen(true);
          },
          onClose: () => setUnlockModalOpen(false)
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: summaryModalOpen,
        onClose: () => setSummaryModalOpen(false),
        placement: dialogPlacement,
        size: "sm",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(BookSummaryPanel, {
          title: metadataTitle,
          summary: metadataSummary,
          language: metadataLanguage,
          onClose: () => setSummaryModalOpen(false)
        })
      })]
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [children, isSupportable && /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: donateModalOpen,
      onClose: () => setDonateModalOpen(false),
      placement: dialogPlacement,
      size: "sm",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(SupportDonatePanel, {
        onDonate: () => {
          dismissDonate();
          setDonateModalOpen(false);
          navigateToPayment();
        },
        onContinueWithout: () => {
          dismissDonate();
          setDonateModalOpen(false);
        },
        onClose: () => setDonateModalOpen(false)
      })
    })]
  });
};

const ReaderAskAiActionsContext = createContext(null);
const useReaderAskAiActions = () => {
  const ctx = useContext(ReaderAskAiActionsContext);
  if (!ctx) {
    throw new Error("useReaderAskAiActions must be used inside ReaderAskAiProvider");
  }
  return ctx;
};
const ReaderAskAiStateContext = createContext(null);
const useReaderAskAiState = () => {
  const ctx = useContext(ReaderAskAiStateContext);
  if (!ctx) {
    throw new Error("useReaderAskAiState must be used inside ReaderAskAiProvider");
  }
  return ctx;
};
const useReaderAskAi = () => {
  const actions = useReaderAskAiActions();
  const state = useReaderAskAiState();
  return {
    ...actions,
    ...state
  };
};

const ConnectedAskAiPanel = ({
  onClose,
  isVoice,
  onToggleVoice
}) => {
  const ai = useReaderAskAi();
  const handleRefClick = (ref) => {
    ai.handleRefClick(ref);
    onClose();
  };
  return /* @__PURE__ */ jsx(AskAiPanel, {
    query: ai.query,
    onQueryChange: ai.setQuery,
    onSubmit: ai.onSubmit,
    state: ai.state,
    isSubmitting: ai.isSubmitting,
    isVoice,
    onToggleVoice,
    onRefClick: handleRefClick,
    onClose
  });
};

const iqraIcon = "data:image/svg+xml;base64,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";

const ReaderAuthContext = React__default.createContext({
  isReadOnly: false,
  requireLogin: () => void 0
});
const useReaderAuth = () => useContext(ReaderAuthContext);
const isAuthError = (err) => !!err && (err.response === "authentication_required" || err.status === 401);
const ReaderAuthProvider = ({
  postId,
  children
}) => {
  const {
    profile
  } = useProfileContext();
  const {
    postError
  } = useBookReader();
  const [loginOpen, setLoginOpen] = useState(false);
  const isReadOnly = !profile;
  const requireLogin = useCallback(() => setLoginOpen(true), []);
  const value = useCreation(() => ({
    isReadOnly,
    requireLogin
  }), [isReadOnly, requireLogin]);
  if (isReadOnly && isAuthError(postError)) {
    return /* @__PURE__ */ jsx(BookAuthGate, {
      postId
    });
  }
  return /* @__PURE__ */ jsxs(ReaderAuthContext.Provider, {
    value,
    children: [children, loginOpen && /* @__PURE__ */ jsx(BookAuthGate, {
      postId,
      onClose: () => setLoginOpen(false)
    })]
  });
};

const AI_CHAT_ORIGIN_PARAM = "cair_origin";
const AI_CHAT_HOST_PARAM = "cair_host";
const isHttpUrl$1 = (value) => typeof value === "string" && /^https?:\/\//i.test(value);
const sessionGet = (key) => {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};
const sessionSet = (key, value) => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch {
  }
};
const readOrigin = () => {
  if (typeof window === "undefined")
    return { circleId: null, hostUrl: null };
  let circleId = null;
  let hostUrl = null;
  try {
    const params = new URLSearchParams(window.location.search);
    circleId = params.get(AI_CHAT_ORIGIN_PARAM);
    hostUrl = params.get(AI_CHAT_HOST_PARAM);
  } catch {
  }
  if (circleId)
    sessionSet(AI_CHAT_ORIGIN_PARAM, circleId);
  else
    circleId = sessionGet(AI_CHAT_ORIGIN_PARAM);
  if (hostUrl)
    sessionSet(AI_CHAT_HOST_PARAM, hostUrl);
  else
    hostUrl = sessionGet(AI_CHAT_HOST_PARAM);
  return { circleId: circleId || null, hostUrl: isHttpUrl$1(hostUrl) ? hostUrl : null };
};
const getAiChatReturnHref = (fallbackCircleId) => {
  const origin = readOrigin();
  if (origin.hostUrl)
    return origin.hostUrl;
  const cid = origin.circleId || fallbackCircleId;
  return cid ? `/trans/ai-chat/${cid}` : void 0;
};

const CairWelcomeBar = ({
  circleId,
  aiChatHref
}) => {
  const resolvedAiChatHref = aiChatHref || (circleId ? `/trans/ai-chat/${circleId}` : void 0);
  const {
    profile
  } = useProfileContext();
  const {
    requireLogin
  } = useReaderAuth();
  const isLoggedIn = !!profile;
  const fullName = profile ? getPersonName(profile) : "";
  const firstName = profile && (profile.firstname || profile.username) || "";
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-between h-[60px] md:h-[64px] py-1 md:py-1.5 px-2 md:px-4 shrink-0",
    style: {
      backgroundColor: "var(--cair-surface, #f2f2f2)",
      borderBottom: "1px solid var(--cair-border-strong, #b3b3b3)",
      boxShadow: "0px 1px 2px rgba(0,0,0,0.05)"
    },
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: [/* @__PURE__ */ jsx("img", {
        src: iqraIcon,
        alt: "",
        width: 20,
        height: 20
      }), /* @__PURE__ */ jsx("span", {
        className: "text-[16px] md:text-[18px] font-semibold tracking-wide",
        style: {
          color: "var(--cair-accent, #1e2c44)"
        },
        children: "CAIR"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 md:gap-3",
      children: [resolvedAiChatHref && /* @__PURE__ */ jsxs("a", {
        href: resolvedAiChatHref,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "hidden md:inline-flex items-center gap-1 text-[13px] font-semibold underline hover:opacity-80 transition-opacity",
        style: {
          color: "var(--cair-accent, #1e2c44)"
        },
        children: ["Go to AI Chat", /* @__PURE__ */ jsx("img", {
          src: "/static/images/chat-ai-logo.png",
          alt: "",
          width: 18,
          height: 18
        })]
      }), isLoggedIn ? /* @__PURE__ */ jsxs("a", {
        href: bookCairDashboardUrl(circleId),
        title: "Go to dashboard",
        className: "flex items-center gap-1.5 md:gap-2 px-1 py-0.5 rounded-md focus:outline-none focus:ring-2 focus:ring-[color:var(--cair-accent,#1e2c44)] hover:bg-black/5 transition-colors no-underline",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "hidden sm:flex flex-col items-end",
          children: [/* @__PURE__ */ jsxs("span", {
            className: "text-[12px] md:text-[13px] font-semibold leading-[1.2] truncate max-w-[200px]",
            style: {
              color: "var(--cair-text, #020203)"
            },
            children: ["Welcome back", fullName ? `, ${fullName}` : ""]
          }), /* @__PURE__ */ jsxs("span", {
            className: "inline-flex items-center gap-[3px] text-[10px] md:text-[11px] font-medium leading-[1.1] cursor-pointer hover:underline",
            style: {
              color: "var(--cair-accent, #1e2c44)"
            },
            title: "Profile settings",
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
              window.location.href = "/profile/public/_edit";
            },
            children: [/* @__PURE__ */ jsx(MdSettings, {
              size: 12,
              "aria-hidden": true
            }), "Profile Settings"]
          })]
        }), /* @__PURE__ */ jsx("span", {
          className: "sm:hidden text-[12px] font-semibold",
          style: {
            color: "var(--cair-text, #020203)"
          },
          children: firstName ? `Hi, ${firstName}` : "Hi"
        }), /* @__PURE__ */ jsx("div", {
          className: "w-[28px] h-[28px] md:w-[32px] md:h-[32px] rounded-full flex items-center justify-center overflow-hidden",
          style: {
            border: "1px solid #D9D9D9",
            backgroundColor: "white"
          },
          children: profile && profile.avatar ? /* @__PURE__ */ jsx(Avatar, {
            avatar: profile.avatar,
            size: 32,
            className: "w-full h-full"
          }) : /* @__PURE__ */ jsx("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            children: /* @__PURE__ */ jsx("path", {
              d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
              fill: "#4d4d4e"
            })
          })
        })]
      }) : /* @__PURE__ */ jsxs("button", {
        type: "button",
        onClick: () => requireLogin(),
        title: "Log in",
        className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[13px] font-semibold hover:opacity-90 transition-opacity",
        style: {
          backgroundColor: "var(--cair-accent, #1e2c44)",
          color: "white"
        },
        children: [/* @__PURE__ */ jsx(MdLogin, {
          size: 16,
          "aria-hidden": true
        }), "Log in"]
      })]
    })]
  });
};
const CairWelcomeBarConnected = () => {
  const {
    post
  } = useBookReader();
  const circleId = post ? postGroupId(post) : "";
  const aiChatHref = getAiChatReturnHref(circleId || void 0);
  return /* @__PURE__ */ jsx(CairWelcomeBar, {
    circleId: circleId || void 0,
    aiChatHref
  });
};

const noop$f = () => {
};
const useSSEConnection = (options, eventHandlers) => {
  const {
    url,
    enabled = true,
    withCredentials = true,
    reconnectDelay = 3e3,
    maxReconnectAttempts = 5,
    onOpen = noop$f,
    onError = noop$f,
    onClose = noop$f,
    dependencies = []
  } = options;
  const [isConnected, setIsConnected] = useState(false);
  const [error, setError] = useState(null);
  const [reconnectTrigger, setReconnectTrigger] = useState(0);
  const eventSourceRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);
  const reconnectTimeoutRef = useRef(null);
  const isMountedRef = useRef(true);
  const eventListenersRef = useRef(new Map());
  const handlersRef = useRef(eventHandlers);
  const onOpenRef = useRef(onOpen);
  const onErrorRef = useRef(onError);
  const onCloseRef = useRef(onClose);
  const closeEventSource = useCallback(() => {
    if (!eventSourceRef.current)
      return;
    const eventSource = eventSourceRef.current;
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }
    eventListenersRef.current.forEach((listener, eventName) => {
      eventSource.removeEventListener(eventName, listener);
    });
    eventListenersRef.current.clear();
    eventSource.onopen = null;
    eventSource.onerror = null;
    eventSource.close();
    eventSourceRef.current = null;
    setIsConnected(false);
    onCloseRef.current();
  }, []);
  useEffect(() => {
    handlersRef.current = eventHandlers;
  }, [eventHandlers]);
  useEffect(() => {
    onOpenRef.current = onOpen;
  }, [onOpen]);
  useEffect(() => {
    onErrorRef.current = onError;
  }, [onError]);
  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);
  useEffect(() => {
    if (!enabled || !url) {
      return;
    }
    isMountedRef.current = true;
    const connect = () => {
      if (!isMountedRef.current)
        return;
      if (eventSourceRef.current) {
        closeEventSource();
      }
      const eventSource = new EventSource(url, { withCredentials });
      eventSourceRef.current = eventSource;
      eventSource.onopen = () => {
        if (!isMountedRef.current)
          return;
        setIsConnected(true);
        setError(null);
        reconnectAttemptsRef.current = 0;
        onOpenRef.current();
      };
      eventSource.onerror = (err) => {
        if (!isMountedRef.current)
          return;
        if (!eventSourceRef.current)
          return;
        setIsConnected(false);
        onErrorRef.current(err);
        if (eventSource.readyState === EventSource.CLOSED) {
          setError(new Error("SSE connection closed by server"));
          if (reconnectAttemptsRef.current < maxReconnectAttempts) {
            reconnectAttemptsRef.current += 1;
            reconnectTimeoutRef.current = setTimeout(() => {
              if (isMountedRef.current) {
                connect();
              }
            }, reconnectDelay);
          } else {
            setError(new Error("SSE max reconnection attempts reached"));
          }
        } else {
          closeEventSource();
        }
      };
      handlersRef.current.forEach(({ event, handler, parseJSON = true }) => {
        const listener = (e) => {
          if (!isMountedRef.current)
            return;
          const messageEvent = e;
          try {
            const data = parseJSON && typeof messageEvent.data === "string" ? JSON.parse(messageEvent.data) : messageEvent.data;
            handler(data, messageEvent.data);
          } catch (err) {
            console.error(`Error handling SSE event '${event}':`, err);
          }
        };
        eventListenersRef.current.set(event, listener);
        eventSource.addEventListener(event, listener);
      });
    };
    connect();
    return () => {
      isMountedRef.current = false;
      closeEventSource();
    };
  }, [url, enabled, withCredentials, reconnectDelay, maxReconnectAttempts, reconnectTrigger, ...dependencies]);
  const disconnect = useMemoizedFn(() => {
    closeEventSource();
  });
  const reconnect = useMemoizedFn(() => {
    if (!enabled || !url) {
      return;
    }
    setReconnectTrigger((prev) => prev + 1);
  });
  return {
    isConnected,
    error,
    reconnectAttempts: reconnectAttemptsRef.current,
    disconnect,
    reconnect
  };
};

const useBookToc = (postId, lang) => {
  const api = useApi();
  const jwt = useJwt();
  const isMountedRef = useRef(true);
  const [headings, setHeadings] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  useEffect(() => {
    setIsComplete(false);
    setHeadings([]);
    setError(null);
  }, [lang]);
  const url = useMemo(() => {
    if (!postId || !jwt)
      return "";
    const params = { postId, token: jwt };
    if (lang)
      params.lang = lang;
    return api.buildUrl("/book-cair/sse/toc", params);
  }, [api, postId, jwt, lang]);
  const handlePage = useMemoizedFn((data) => {
    if (!isMountedRef.current)
      return;
    if (data.headings && data.headings.length > 0) {
      setHeadings((prev) => [...prev, ...data.headings]);
    }
  });
  const handleComplete = useMemoizedFn((data) => {
    if (!isMountedRef.current)
      return;
    setHeadings(data.items || []);
    setIsComplete(true);
  });
  const handleFailed = useMemoizedFn((data) => {
    if (!isMountedRef.current)
      return;
    setError(new Error(data && data.message || "toc_failed"));
  });
  useSSEConnection({
    url,
    enabled: !!url && !isComplete && !error,
    maxReconnectAttempts: 0,
    onOpen: useMemoizedFn(() => {
      if (!isMountedRef.current)
        return;
      setHeadings([]);
      setError(null);
    })
  }, [
    { event: "page", handler: handlePage },
    { event: "complete", handler: handleComplete },
    { event: "failed", handler: handleFailed }
  ]);
  return {
    headings,
    isLoading: !!url && !isComplete && !error,
    isComplete,
    error
  };
};

const groupHeadings = (headings, totalPages) => {
  const groups = [];
  let current = null;
  for (const h of headings) {
    if (h.level === 1) {
      current = { heading: h, sections: [], pages: 0 };
      groups.push(current);
    } else {
      if (current) {
        current.sections.push(h);
      } else {
        current = { heading: h, sections: [], pages: 0 };
        groups.push(current);
      }
    }
  }
  groups.forEach((g, i) => {
    const nextPageIndex = i + 1 < groups.length ? groups[i + 1].heading.pageIndex : totalPages;
    g.pages = Math.max(0, nextPageIndex - g.heading.pageIndex);
  });
  return groups;
};
const isPageInChapter = (pageIndex, chapterPageIndex, pages) => pageIndex >= chapterPageIndex && pageIndex < chapterPageIndex + pages;
const tocItemPageId = (item) => item.pageId || item.id;
const headingsToTocItems = (headings, totalPages, options = {}) => {
  if (!headings.length)
    return [];
  const { currentPageIndex = -1, expandedChapterId } = options;
  const groups = groupHeadings(headings, totalPages);
  return groups.map((g) => {
    const isActive = currentPageIndex >= 0 && isPageInChapter(currentPageIndex, g.heading.pageIndex, g.pages);
    const sections = g.sections.map((s, si) => ({
      id: `${s.pageId}-${si}`,
      title: s.text,
      pageId: s.pageId
    }));
    const item = {
      id: g.heading.pageId,
      title: g.heading.text,
      pages: g.pages,
      sections,
      isActive
    };
    if (expandedChapterId !== void 0) {
      item.isExpanded = expandedChapterId === g.heading.pageId;
    }
    return item;
  });
};

Array.from({ length: 80 }, (_, i) => ({
  level: i % 5 === 0 ? 1 : 2,
  text: `Chapter ${i + 1}: Sample heading for scroll testing`,
  pageId: `mock-page-${i}`,
  pageIndex: i
}));
const useBookTocItems = ({
  postId,
  totalPages,
  readingPercent,
  expandedChapterId
}) => {
  const { language } = useLanguageSelectionContext();
  const { pageIds } = useBookReader();
  const { headings: realHeadings } = useBookToc(postId, language);
  const headings = realHeadings;
  const currentPageIndex = totalPages > 0 ? Math.round(readingPercent / 100 * (totalPages - 1)) : -1;
  return useMemo(() => {
    const sorted = pageIds.flatMap((id) => headings.filter((h) => h.pageId === id)).map((h) => ({ ...h, pageIndex: pageIds.indexOf(h.pageId) }));
    return headingsToTocItems(sorted, totalPages, { currentPageIndex, expandedChapterId });
  }, [headings, pageIds, totalPages, currentPageIndex, expandedChapterId]);
};

const navigateToTocItem = (item, history) => {
  history.replace({ hash: `?chunk=${tocItemPageId(item)}` });
};

const useBookTextSearch = (postId) => {
  const api = useApi();
  const [query, setQuery] = useState("");
  const [submittedQuery, setSubmittedQuery] = useState("");
  const [results, setResults] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const onSubmit = useMemoizedFn(async () => {
    const q = query.trim();
    if (!q || !postId)
      return;
    setIsSubmitting(true);
    try {
      const res = await api.get({
        path: `/book-cair/${postId}/text-search` + buildQueryString({ q })
      });
      setResults(res && res.results || []);
    } catch (e) {
      setResults([]);
    } finally {
      setSubmittedQuery(q);
      setIsSubmitting(false);
    }
  });
  const onClear = useMemoizedFn(() => {
    setQuery("");
    setSubmittedQuery("");
    setResults([]);
  });
  return { query, setQuery, onSubmit, onClear, results, submittedQuery, isSubmitting };
};

const ReaderSearchProvider = ({
  children
}) => {
  const {
    post,
    getPageIndex
  } = useBookReader();
  const tokenRef = useRef(0);
  const postId = post && post._id ? String(post._id) : "";
  const {
    query,
    setQuery,
    onSubmit,
    onClear,
    results: rawResults,
    submittedQuery,
    isSubmitting
  } = useBookTextSearch(postId);
  const results = rawResults.map((r) => {
    const idx = getPageIndex(r.pageId);
    return {
      id: r.id,
      excerpt: r.snippet,
      location: idx >= 0 ? "p." + (idx + 1) : ""
    };
  });
  const [activeHighlight, setActiveHighlight] = useState(null);
  const handleSelectResult = useMemoizedFn((result) => {
    const raw = rawResults.find((r) => r.id === result.id);
    if (!raw)
      return;
    tokenRef.current += 1;
    setActiveHighlight({
      pageId: raw.pageId,
      query: submittedQuery,
      occurrence: raw.occurrenceInPage,
      token: tokenRef.current
    });
  });
  return /* @__PURE__ */ jsx(ReaderSearchContext.Provider, {
    value: {
      query,
      setQuery,
      onSubmit,
      onClear,
      results,
      isSubmitting,
      activeHighlight,
      handleSelectResult
    },
    children
  });
};

const useSSELogs = (options) => {
  const { maxLogs = 100, onLog } = options || {};
  const [logs, setLogs] = useState([]);
  const reset = useMemoizedFn(() => setLogs([]));
  const handler = {
    event: "log",
    handler: (data) => {
      setLogs((prev) => [...prev, data].slice(-maxLogs));
      if (onLog) {
        onLog(data);
      }
    }
  };
  return { logs, reset, handler };
};

function createError(message) {
    var err = new Error(message);
    err.source = "ulid";
    return err;
}
// These values should NEVER change. If
// they do, we're no longer making ulids!
var ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32
var ENCODING_LEN = ENCODING.length;
var TIME_MAX = Math.pow(2, 48) - 1;
var TIME_LEN = 10;
var RANDOM_LEN = 16;
function randomChar(prng) {
    var rand = Math.floor(prng() * ENCODING_LEN);
    if (rand === ENCODING_LEN) {
        rand = ENCODING_LEN - 1;
    }
    return ENCODING.charAt(rand);
}
function encodeTime(now, len) {
    if (isNaN(now)) {
        throw new Error(now + " must be a number");
    }
    if (now > TIME_MAX) {
        throw createError("cannot encode time greater than " + TIME_MAX);
    }
    if (now < 0) {
        throw createError("time must be positive");
    }
    if (Number.isInteger(now) === false) {
        throw createError("time must be an integer");
    }
    var mod = void 0;
    var str = "";
    for (; len > 0; len--) {
        mod = now % ENCODING_LEN;
        str = ENCODING.charAt(mod) + str;
        now = (now - mod) / ENCODING_LEN;
    }
    return str;
}
function encodeRandom(len, prng) {
    var str = "";
    for (; len > 0; len--) {
        str = randomChar(prng) + str;
    }
    return str;
}
function detectPrng() {
    var allowInsecure = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var root = arguments[1];

    if (!root) {
        root = typeof window !== "undefined" ? window : null;
    }
    var browserCrypto = root && (root.crypto || root.msCrypto);
    if (browserCrypto) {
        return function () {
            var buffer = new Uint8Array(1);
            browserCrypto.getRandomValues(buffer);
            return buffer[0] / 0xff;
        };
    } else {
        try {
            var nodeCrypto = require("crypto");
            return function () {
                return nodeCrypto.randomBytes(1).readUInt8() / 0xff;
            };
        } catch (e) {}
    }
    if (allowInsecure) {
        try {
            console.error("secure crypto unusable, falling back to insecure Math.random()!");
        } catch (e) {}
        return function () {
            return Math.random();
        };
    }
    throw createError("secure crypto unusable, insecure Math.random not allowed");
}
function factory(currPrng) {
    if (!currPrng) {
        currPrng = detectPrng();
    }
    return function ulid(seedTime) {
        if (isNaN(seedTime)) {
            seedTime = Date.now();
        }
        return encodeTime(seedTime, TIME_LEN) + encodeRandom(RANDOM_LEN, currPrng);
    };
}
var ulid = factory();

const MAX_MESSAGES$8 = 200;
const useCircleSearchSSE = ({
  enabled,
  path = "/group/sse/search"
} = {}) => {
  const [params, setParams] = useState({});
  const [counter, setCounter] = useState(0);
  const {
    circleId,
    question,
    language = "en",
    analyze = false,
    postId,
    prompt,
    trace = false,
    chaos,
    requestId: providedRequestId,
    alpha,
    searchFilters
  } = params;
  const api = useApi();
  const jwt = useJwt();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState(null);
  const [analyses, setAnalyses] = useState("");
  const [isComplete, setIsComplete] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  const [failure, setFailure] = useState(null);
  const {
    qwen
  } = useQueryStringParams();
  const [messages, setMessages] = useState([]);
  const pushMessage = (event, eventData) => {
    setMessages((prev) => {
      const next = {
        id: Date.now().toString() + Math.random(),
        event,
        timestamp: new Date(),
        data: eventData
      };
      return [...prev, next].slice(-MAX_MESSAGES$8);
    });
  };
  const {
    logs,
    reset: resetLogs,
    handler: logHandler
  } = useSSELogs({
    onLog: (logEvent) => pushMessage("log", logEvent)
  });
  const requestId = useMemo(() => {
    return providedRequestId || ulid();
  }, [providedRequestId, counter]);
  const url = useMemo(() => {
    if (!counter || !jwt) {
      return null;
    }
    const params2 = {
      token: jwt,
      circleId,
      question,
      lang: language,
      analyze,
      prompt,
      requestId
    };
    if (typeof alpha !== "undefined")
      params2.alpha = String(alpha);
    if (trace) {
      params2.trace = true;
    }
    if (qwen) {
      params2.qwen = true;
    }
    if (chaos && chaos.enabled) {
      params2.chaos = true;
      if (chaos.probability !== void 0) {
        params2.chaosProbability = String(chaos.probability);
      }
      if (chaos.checkpoints) {
        params2.chaosCheckpoints = chaos.checkpoints;
      }
    }
    if (postId)
      params2.postId = postId;
    if (searchFilters && Object.keys(searchFilters).length) {
      params2.searchFilters = JSON.stringify(searchFilters);
    }
    return api.buildUrl(path, params2);
  }, [counter, api, jwt, question, circleId, language, analyze, postId, searchFilters, prompt, trace, chaos, requestId, qwen]);
  const {
    isConnected,
    disconnect,
    error: sseError,
    reconnect
  } = useSSEConnection({
    url: url || "",
    enabled: counter > 0 && !!url && enabled,
    dependencies: [counter],
    onOpen: () => {
      setStatus(null);
      setIsComplete(false);
      setConnectionError(null);
      setFailure(null);
      setAnalyses("");
      resetLogs();
      setMessages([]);
    },
    onError: (err) => {
      console.error("SSE connection error:", err);
      setConnectionError(new Error("Connection error"));
    },
    onClose: () => {
      setStatus(null);
    }
  }, [{
    event: "status",
    handler: (data2) => {
      setStatus(data2.message);
      pushMessage("status", data2);
    }
  }, {
    event: "results",
    handler: (results) => {
      setData(results);
      pushMessage("results", results);
    }
  }, {
    event: "chunk",
    handler: (data2) => {
      setAnalyses((prev) => prev + data2.chunk);
    }
  }, {
    event: "analyses",
    handler: (data2) => {
      setAnalyses(data2.text);
      pushMessage("analyses", data2);
    }
  }, logHandler, {
    event: "complete",
    handler: (completeData) => {
      setStatus(completeData.message);
      setIsComplete(true);
      pushMessage("complete", completeData);
      setTimeout(() => disconnect(), 100);
    }
  }, {
    event: "failed",
    handler: (data2) => {
      const message = data2 && (data2.message || data2.error) || "Search failed";
      setStatus(null);
      setFailure(new Error(message));
      setIsComplete(true);
      pushMessage("failed", data2);
      setTimeout(() => disconnect(), 100);
    }
  }]);
  useEffect(() => {
    if (sseError) {
      setConnectionError(sseError);
    }
  }, [sseError]);
  const mutate = useMemoizedFn(() => {
    reconnect();
  });
  const search = useMemoizedFn((searchParams) => {
    setParams(searchParams);
    setCounter((c) => c + 1);
  });
  return {
    failure,
    search,
    counter,
    data,
    status,
    analyses,
    isComplete,
    error: connectionError,
    isValidating: isConnected,
    mutate,
    disconnect,
    isConnected,
    logs,
    messages,
    requestId
  };
};

const EXCERPT_MAX = 160;
const truncate = (text) => {
  if (text.length <= EXCERPT_MAX)
    return text;
  return text.slice(0, EXCERPT_MAX) + "\u2026";
};
const toAiAnswerRefs = ({ found, chunkTranslations }) => {
  const pageIndexMap = new Map();
  return found.map((item) => {
    const { text, metadata } = item;
    const { postId, chunkId } = metadata;
    const translation = chunkTranslations[postId];
    const excerpt = truncate(translation && translation.text || text);
    if (!pageIndexMap.has(postId)) {
      pageIndexMap.set(postId, pageIndexMap.size + 1);
    }
    const pageIndex = pageIndexMap.get(postId);
    const location = chunkId !== void 0 ? "p." + pageIndex + " \xB7 \xA7" + chunkId : "p." + pageIndex;
    return {
      id: postId + "_" + chunkId,
      excerpt,
      location,
      pageId: postId,
      chunkId: chunkId !== void 0 ? String(chunkId) : void 0
    };
  });
};

const INITIAL_STATE$3 = { answer: "", refs: [] };
const toAskAiState = (s) => {
  if (s.refs.length > 0)
    return { phase: "answer-ref", answer: s.answer, refs: s.refs };
  if (s.answer)
    return { phase: "answer", answer: s.answer };
  return { phase: "idle" };
};
const useBookAskAi = ({
  circleId,
  postId,
  language = ""
}) => {
  const [query, setQuery] = useState("");
  const [internal, setInternal] = useState(INITIAL_STATE$3);
  const {
    search,
    analyses,
    data,
    isConnected,
    isComplete,
    disconnect
  } = useCircleSearchSSE({ path: "/book-cair/sse/search" });
  useEffect(() => {
    const found = data && data.found || [];
    data && data.postsById || {};
    const chunkTranslations = data && data.chunkTranslations || {};
    if (found.length > 0) {
      setInternal((prev) => ({ ...prev, refs: toAiAnswerRefs({ found, chunkTranslations }) }));
    }
  }, [data && data.found]);
  useEffect(() => {
    if (!analyses)
      return;
    setInternal((prev) => ({ ...prev, answer: analyses }));
  }, [analyses]);
  useEffect(() => {
    if (!isComplete)
      return;
    const finalText = analyses || data && data.aiResponse || "";
    if (finalText) {
      setInternal((prev) => ({ ...prev, answer: finalText }));
    }
  }, [isComplete]);
  const onSubmit = useMemoizedFn(() => {
    if (!query.trim() || !circleId)
      return;
    setInternal(INITIAL_STATE$3);
    search({
      circleId,
      postId,
      question: query,
      language,
      analyze: true
    });
  });
  const onClear = useMemoizedFn(() => {
    disconnect();
    setQuery("");
    setInternal(INITIAL_STATE$3);
  });
  const isSubmitting = isConnected && !isComplete;
  return { query, setQuery, onSubmit, onClear, state: toAskAiState(internal), isSubmitting };
};

const toChunkParam = (ref) => ref.chunkId ? ref.pageId + "-" + ref.chunkId : ref.pageId;
const fixRefLocations = (state, getPageIndex) => {
  if (state.phase !== "answer-ref")
    return state;
  return {
    ...state,
    refs: state.refs.map((ref) => {
      if (!ref.pageId)
        return ref;
      const idx = getPageIndex(ref.pageId);
      if (idx < 0)
        return ref;
      const location = ref.chunkId ? "p." + (idx + 1) + " \xB7 \xA7" + ref.chunkId : "p." + (idx + 1);
      return {
        ...ref,
        location
      };
    })
  };
};
const ReaderAskAiProvider = ({
  children
}) => {
  const {
    post,
    getPageIndex
  } = useBookReader();
  const history = useHistory();
  const {
    language
  } = useLanguageSelectionContext();
  const circleId = circleIdForPost(post) || "";
  const postId = post && post._id ? String(post._id) : "";
  const {
    query,
    setQuery,
    onSubmit,
    onClear,
    state,
    isSubmitting
  } = useBookAskAi({
    circleId,
    postId,
    language
  });
  const fixedState = fixRefLocations(state, getPageIndex);
  const handleRefClick = useMemoizedFn((ref) => {
    if (!ref.pageId)
      return;
    history.push({
      hash: "?chunk=" + toChunkParam(ref)
    });
  });
  const actionsValue = useCreation(() => ({
    setQuery,
    onSubmit,
    onClear,
    handleRefClick
  }), []);
  return /* @__PURE__ */ jsx(ReaderAskAiActionsContext.Provider, {
    value: actionsValue,
    children: /* @__PURE__ */ jsx(ReaderAskAiStateContext.Provider, {
      value: {
        query,
        state: fixedState,
        isSubmitting
      },
      children
    })
  });
};

const findPageId = (node) => {
  let el = node;
  while (el) {
    if (el.nodeType === Node.ELEMENT_NODE) {
      const id = el.getAttribute("data-page-id");
      if (id)
        return id;
    }
    el = el.parentNode;
  }
  return "";
};
const getCharOffset = (root, targetNode, targetOffset) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let total = 0;
  let node = walker.nextNode();
  while (node) {
    if (node === targetNode)
      return total + targetOffset;
    total += node.textContent ? node.textContent.length : 0;
    node = walker.nextNode();
  }
  return total;
};
const useTextSelection = () => {
  const [selectionPos, setSelectionPos] = useState(null);
  const [selectionContext, setSelectionContext] = useState(null);
  const langCtx = useContext(LanguageSelectionContext);
  const activeLanguage = langCtx && langCtx.language || "";
  const handleTextSelect = useMemoizedFn((e) => {
    const container = e.currentTarget;
    requestAnimationFrame(() => {
      const selection = window.getSelection();
      if (!selection || selection.isCollapsed || !selection.toString().trim()) {
        setSelectionPos(null);
        setSelectionContext(null);
        return;
      }
      const range = selection.getRangeAt(0);
      const rect = range.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      setSelectionPos({
        top: rect.top - containerRect.top + container.scrollTop - 48,
        left: rect.left - containerRect.left + rect.width / 2
      });
      const selectedText = selection.toString();
      const pageId = findPageId(selection.anchorNode);
      let startOffset = 0;
      let endOffset = 0;
      if (pageId) {
        const pageEl = document.querySelector(`[data-page-id="${pageId}"]`);
        if (pageEl) {
          startOffset = getCharOffset(pageEl, range.startContainer, range.startOffset);
          endOffset = getCharOffset(pageEl, range.endContainer, range.endOffset);
        }
      }
      if (selectedText && pageId) {
        setSelectionContext({ selectedText, pageId, startOffset, endOffset, language: activeLanguage });
      } else {
        setSelectionContext(null);
      }
    });
  });
  const clearSelection = useMemoizedFn(() => {
    setSelectionPos(null);
    setSelectionContext(null);
    const selection = window.getSelection();
    if (selection)
      selection.removeAllRanges();
  });
  return { selectionPos, selectionContext, handleTextSelect, clearSelection };
};

const ReaderTextSelectionContext = createContext(null);
const useReaderTextSelection = () => {
  const ctx = useContext(ReaderTextSelectionContext);
  if (!ctx) {
    throw new Error("useReaderTextSelection must be used inside ReaderTextSelectionProvider");
  }
  return ctx;
};

const ReaderTextSelectionProvider = ({
  children
}) => {
  const {
    selectionPos,
    selectionContext,
    handleTextSelect,
    clearSelection
  } = useTextSelection();
  return /* @__PURE__ */ jsx(ReaderTextSelectionContext.Provider, {
    value: {
      selectionPos,
      selectionContext,
      handleTextSelect,
      clearSelection
    },
    children
  });
};

const SocialItem = ({
  label,
  children
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col items-center gap-[6px]",
  children: [children, /* @__PURE__ */ jsx("span", {
    className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)]",
    children: label
  })]
});
const ShareSocialButtons = ({
  url,
  title,
  tags
}) => {
  if (isMobileWrapper())
    return null;
  const firstTag = tags && tags.length > 0 ? tags[0] : void 0;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-center gap-[20px] px-[16px] pt-[24px] pb-[16px]",
    children: [/* @__PURE__ */ jsx(SocialItem, {
      label: "Facebook",
      children: /* @__PURE__ */ jsx(FacebookShareButton, {
        url,
        hashtag: firstTag ? `#${firstTag}` : void 0,
        children: /* @__PURE__ */ jsx(FacebookIcon, {
          size: 48,
          round: true
        })
      })
    }), /* @__PURE__ */ jsx(SocialItem, {
      label: "X / Twitter",
      children: /* @__PURE__ */ jsx(TwitterShareButton, {
        url,
        title,
        hashtags: tags,
        children: /* @__PURE__ */ jsx(TwitterIcon, {
          size: 48,
          round: true
        })
      })
    }), /* @__PURE__ */ jsx(SocialItem, {
      label: "WhatsApp",
      children: /* @__PURE__ */ jsx(WhatsappShareButton, {
        url,
        title,
        children: /* @__PURE__ */ jsx(WhatsappIcon, {
          size: 48,
          round: true
        })
      })
    })]
  });
};

const SharePanel = ({
  url,
  title,
  tags,
  onClose
}) => {
  const [copied, setCopied] = useState(false);
  if (!url.startsWith("http")) {
    url = `${window.location.origin}${url}`;
  }
  const handleCopy = useMemoizedFn(() => {
    const onSuccess = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2e3);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(onSuccess);
      return;
    }
    const textarea = document.createElement("textarea");
    textarea.value = url;
    textarea.style.cssText = "position:fixed;opacity:0;top:0;left:0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    try {
      document.execCommand("copy");
      onSuccess();
    } catch (_) {
    }
    document.body.removeChild(textarea);
  });
  return /* @__PURE__ */ jsxs(PanelShell, {
    icon: /* @__PURE__ */ jsx(MdShare, {
      size: 20,
      className: "text-[color:var(--cair-accent)]"
    }),
    title: "Share",
    onClose,
    children: [/* @__PURE__ */ jsx(ShareSocialButtons, {
      url,
      title,
      tags
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[8px] px-[16px] pb-[24px]",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-tiny)] font-medium text-[color:var(--cair-text-secondary)]",
        children: "Copy link"
      }), /* @__PURE__ */ jsxs("div", {
        className: ["flex items-center gap-[8px]", "bg-[var(--cair-surface)] border border-[var(--cair-border)]", "rounded-[var(--cair-radius-sm)] px-[12px] py-[10px]"].join(" "),
        children: [/* @__PURE__ */ jsx("span", {
          className: "flex-1 min-w-0 text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text)] truncate",
          children: url
        }), /* @__PURE__ */ jsxs("button", {
          onClick: handleCopy,
          "aria-label": copied ? "Link copied" : "Copy link",
          className: ["shrink-0 flex items-center gap-[4px]", "text-[length:var(--cair-text-tiny)] font-semibold transition-colors duration-150", copied ? "text-[color:var(--cair-success-darker)]" : "text-[color:var(--cair-accent)]"].join(" "),
          children: [copied ? /* @__PURE__ */ jsx(MdCheck, {
            size: 16
          }) : /* @__PURE__ */ jsx(MdContentCopy, {
            size: 16
          }), /* @__PURE__ */ jsx("span", {
            children: copied ? "Copied!" : "Copy"
          })]
        })]
      })]
    })]
  });
};

const LoadingOverlay = ({
  isOpen,
  message = "Loading...",
  spinnerSize = "xl"
}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  if (!isOpen || !mounted) {
    return null;
  }
  return createPortal(/* @__PURE__ */ jsxs("div", {
    className: "fixed inset-0 z-[9999] flex items-center justify-center",
    children: [/* @__PURE__ */ jsx("div", {
      className: "absolute inset-0 bg-black/20 backdrop-blur-sm"
    }), /* @__PURE__ */ jsxs("div", {
      className: "relative bg-white rounded-lg shadow-xl p-8 flex flex-col items-center gap-4 min-w-[200px]",
      children: [/* @__PURE__ */ jsx(Spinner, {
        size: spinnerSize,
        colorScheme: "blue"
      }), message && /* @__PURE__ */ jsx("span", {
        className: "text-gray-700 text-sm font-medium",
        children: message
      })]
    })]
  }), document.body);
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));
/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));
/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */

/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && isWhiteSpace(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}

/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(TokenKind || (TokenKind = {}));
/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new Token(TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === TokenKind.BANG ||
    kind === TokenKind.DOLLAR ||
    kind === TokenKind.AMP ||
    kind === TokenKind.PAREN_L ||
    kind === TokenKind.PAREN_R ||
    kind === TokenKind.SPREAD ||
    kind === TokenKind.COLON ||
    kind === TokenKind.EQUALS ||
    kind === TokenKind.AT ||
    kind === TokenKind.BRACKET_L ||
    kind === TokenKind.BRACKET_R ||
    kind === TokenKind.BRACE_L ||
    kind === TokenKind.PIPE ||
    kind === TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new Token(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if (isDigit(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if (isNameStart(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if (isDigit(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || isNameStart(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? TokenKind.FLOAT : TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while (isDigit(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        dedentBlockStringLines(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if (isNameContinue(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}

/* c8 ignore next 3 */

const isProduction =
  globalThis.process && // eslint-disable-next-line no-undef
  "production" === 'production';
/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  isProduction
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = inspect(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      devAssert(false, `Body must be a string. Received: ${inspect(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      devAssert(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      devAssert(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}

/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  const document = parser.parseDocument();
  Object.defineProperty(document, 'tokenCount', {
    enumerable: false,
    value: parser.tokenCount,
  });
  return document;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }

  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(TokenKind.NAME);
    return this.node(token, {
      kind: Kind.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Kind.DOCUMENT,
      definitions: this.many(
        TokenKind.SOF,
        this.parseDefinition,
        TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: Kind.OPERATION_DEFINITION,
        operation: OperationTypeNode.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: Kind.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return OperationTypeNode.QUERY;

      case 'mutation':
        return OperationTypeNode.MUTATION;

      case 'subscription':
        return OperationTypeNode.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseVariableDefinition,
      TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Kind.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.DOLLAR);
    return this.node(start, {
      kind: Kind.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Kind.SELECTION_SET,
      selections: this.many(
        TokenKind.BRACE_L,
        this.parseSelection,
        TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: Kind.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(TokenKind.PAREN_L, item, TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(TokenKind.NAME)) {
      return this.node(start, {
        kind: Kind.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: Kind.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: Kind.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: Kind.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.INT,
          value: token.value,
        });

      case TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: Kind.FLOAT,
          value: token.value,
        });

      case TokenKind.STRING:
      case TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: Kind.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: Kind.NULL,
            });

          default:
            return this.node(token, {
              kind: Kind.ENUM,
              value: token.value,
            });
        }

      case TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(TokenKind.DOLLAR);

          if (this._lexer.token.kind === TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: Kind.STRING,
      value: token.value,
      block: token.kind === TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.LIST,
      values: this.any(TokenKind.BRACKET_L, item, TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: Kind.OBJECT,
      fields: this.any(TokenKind.BRACE_L, item, TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    return this.node(start, {
      kind: Kind.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(TokenKind.AT);
    return this.node(start, {
      kind: Kind.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: Kind.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(TokenKind.BANG)) {
      return this.node(start, {
        kind: Kind.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Kind.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(TokenKind.STRING) || this.peek(TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: Kind.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: Kind.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseFieldDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      TokenKind.PAREN_L,
      this.parseInputValueDef,
      TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: Kind.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(TokenKind.EQUALS)
      ? this.delimitedMany(TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: Kind.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: Kind.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      TokenKind.BRACE_L,
      this.parseInputValueDef,
      TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: Kind.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: Kind.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new Location(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (token.kind !== TokenKind.EOF) {
      ++this._tokenCounter;

      if (maxTokens !== undefined && this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return __assign(__assign({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
var gql$1 = gql;

gql$1`
  query BatchCircleOptions($input: BatchGetCircleOptionsInput!, $merged: Boolean) {
    batchCircleOptions(input: $input, merged: $merged) {
      circleId
      options {
        type
        options
      }
    }
  }
`;
const useCircleOptions = (variables, op) => {
  const graphQLClient = useGraphQLClientFn();
  const result = useSWR(variables.input.circleId ? [BatchCircleOptionsDocument, variables.input.circleId, (variables.input.types || []).join(",")] : null, async () => {
    const graphqlClient = await graphQLClient();
    const result2 = await graphqlClient.request(BatchCircleOptionsDocument, variables);
    return result2;
  }, {
    ...swrLoadOnce,
    ...op
  });
  return result;
};

const SEARCH_FILTERS_OPTION_TYPE = "search-filters";
const ENTITY_FILTER_KEYS = ["persons", "locations", "organizations", "categoryCodes", "authors", "tags", "sourceInstitutions"];
const CircleSearchSSEContext = React__default.createContext({
  counter: 0,
  analyses: void 0,
  chat: void 0,
  isAdvisorEnabled: false,
  hasEmbeddingsOrAdvisor: false,
  isAIMode: false,
  setIsAIMode: noop$u,
  isSearchMode: false,
  setIsSearchMode: noop$u,
  prompt: "",
  setPrompt: noop$u,
  found: [],
  postsById: {},
  circleId: void 0,
  selectedFilters: {},
  toggleFilter: noop$u,
  clearFilters: noop$u,
  onSearch: noop$u,
  searchLoading: false,
  error: null,
  aiResponse: null,
  aiSearch: false,
  chunkTranslations: {},
  setAISearch: noop$u,
  logs: [],
  messages: [],
  requestId: void 0
});
const useCircleSearchSSEContext = () => {
  return useContext(CircleSearchSSEContext);
};
const CircleSearchSSEContextProvider = ({
  children,
  inPost
}) => {
  const {
    circleId,
    circle,
    postId
  } = useCircle4Search({
    inPost
  });
  const {
    language
  } = useLanguageSelectionContext();
  const isInstanceAdmin = useIsInstanceAdmin();
  const [state, setState] = useState({
    chat: void 0,
    found: void 0,
    aiResponse: "",
    postsById: {},
    chunkTranslations: {}
  });
  const [isAIMode, setIsAIMode] = useState(false);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});
  const dimensions = useDimensionsState();
  const [aiSearch, setAISearch] = useState(false);
  const [isAdvisorEnabled, setIsAdvisorEnabled] = useState(false);
  const [hasEmbeddingsOrAdvisor, setHasEmbeddingsOrAdvisor] = useState(false);
  const {
    data,
    isValidating: searchLoading,
    search,
    analyses,
    counter,
    failure: error,
    logs,
    messages,
    requestId
  } = useCircleSearchSSE();
  const {
    data: optionsData
  } = useCircleOptions({
    input: {
      circleId,
      types: [SEARCH_FILTERS_OPTION_TYPE]
    }
  });
  const metadataFieldTypes = useMemo(() => {
    const map = {};
    const groups = optionsData && optionsData.batchCircleOptions && optionsData.batchCircleOptions.options;
    const entry = groups && groups.find((o) => o.type === SEARCH_FILTERS_OPTION_TYPE);
    const saved = entry && entry.options && entry.options.filters;
    if (Array.isArray(saved)) {
      for (const f of saved) {
        map[f.field] = f.type;
      }
    }
    return map;
  }, [optionsData]);
  useEffect(() => {
    if (!data) {
      return;
    }
    setState(data);
  }, [data]);
  useEffect(() => {
    if (!circle) {
      return;
    }
    circle.embeddings || circle.aiSearch;
    setHasEmbeddingsOrAdvisor(circle.embeddings || circle.aiSearch);
    setIsAdvisorEnabled(circle.aiSearch);
  }, [circle]);
  const doSearch = useMemoizedFn((filters) => {
    const searchFilters = {};
    const metadataFilters = [];
    for (const key of Object.keys(filters)) {
      const values = filters[key];
      if (!values || !values.length) {
        continue;
      }
      if (ENTITY_FILTER_KEYS.includes(key)) {
        searchFilters[key] = values;
      } else {
        metadataFilters.push({
          field: key,
          type: metadataFieldTypes[key] || "string",
          values
        });
      }
    }
    if (metadataFilters.length) {
      searchFilters.metadataFilters = metadataFilters;
    }
    search({
      ...dimensions,
      language,
      postId,
      circleId,
      question: prompt,
      analyze: isAIMode,
      trace: isInstanceAdmin,
      searchFilters: Object.keys(searchFilters).length ? searchFilters : void 0
    });
  });
  const onSearch = useMemoizedFn(() => {
    doSearch(selectedFilters);
  });
  const toggleFilter = useMemoizedFn((category, value) => {
    const current = selectedFilters[category] || [];
    const next = current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
    const updated = {
      ...selectedFilters,
      [category]: next
    };
    setSelectedFilters(updated);
    doSearch(updated);
  });
  const clearFilters = useMemoizedFn(() => {
    setSelectedFilters({});
    doSearch({});
  });
  const context = useMemo(() => {
    return {
      counter,
      analyses,
      isAIMode,
      setIsAIMode,
      isSearchMode,
      setIsSearchMode,
      prompt,
      setPrompt,
      circleId,
      selectedFilters,
      toggleFilter,
      clearFilters,
      ...state,
      onSearch,
      searchLoading,
      error,
      aiSearch,
      setAISearch,
      isAdvisorEnabled,
      hasEmbeddingsOrAdvisor,
      logs,
      messages,
      requestId
    };
  }, [counter, analyses, isAIMode, isSearchMode, prompt, searchLoading, error, aiSearch, state, isAdvisorEnabled, hasEmbeddingsOrAdvisor, circleId, selectedFilters, logs, messages, requestId]);
  return /* @__PURE__ */ jsx(CircleSearchSSEContext.Provider, {
    value: context,
    children
  });
};

const useOpenResponse = () => {
  const {
    openReply
  } = usePostUpdatesContext();
  const params = useQueryStringParams();
  const {
    info,
    response
  } = params;
  useEffect(() => {
    if (info || !response) {
      return;
    }
    openReply(response);
  }, [info, response]);
};

// THIS FILE IS AUTO GENERATED
function ImFileVideo (props) {
  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 16 16"},"child":[{"tag":"path","attr":{"d":"M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"},"child":[]},{"tag":"path","attr":{"d":"M4 8h5v5h-5v-5z"},"child":[]},{"tag":"path","attr":{"d":"M9 10l3-2v5l-3-2z"},"child":[]}]})(props);
}function ImListNumbered (props) {
  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 16 16"},"child":[{"tag":"path","attr":{"d":"M6 13h10v2h-10zM6 7h10v2h-10zM6 1h10v2h-10zM3 0v4h-1v-3h-1v-1zM2 8.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM4 11v5h-3v-1h2v-1h-2v-1h2v-1h-2v-1z"},"child":[]}]})(props);
}function ImTable2 (props) {
  return GenIcon({"tag":"svg","attr":{"version":"1.1","viewBox":"0 0 16 16"},"child":[{"tag":"path","attr":{"d":"M0 1v14h16v-14h-16zM6 10v-3h4v3h-4zM10 11v3h-4v-3h4zM10 3v3h-4v-3h4zM5 3v3h-4v-3h4zM1 7h4v3h-4v-3zM11 7h4v3h-4v-3zM11 6v-3h4v3h-4zM1 11h4v3h-4v-3zM11 14v-3h4v3h-4z"},"child":[]}]})(props);
}

const toggle = (v) => !v;
const ResponsesToolbar = () => {
  const {
    expanded,
    setExpanded,
    columnView,
    setColumnView,
    numbering,
    setNumbering,
    sortAscending,
    setSortAscending
  } = useResponsesContext();
  const onExpand = () => {
    setExpanded(toggle);
  };
  return /* @__PURE__ */ jsxs(Toolbar, {
    children: [/* @__PURE__ */ jsx(Tooltip$2, {
      title: "Sort threads",
      children: /* @__PURE__ */ jsx(IconButton$5, {
        onClick: () => setSortAscending(toggle),
        children: sortAscending ? /* @__PURE__ */ jsx(BsSortNumericDown, {}) : /* @__PURE__ */ jsx(BsSortNumericDownAlt, {})
      })
    }), /* @__PURE__ */ jsx(Tooltip$2, {
      title: "Collapse/expend",
      children: /* @__PURE__ */ jsx(IconButton$5, {
        onClick: onExpand,
        children: expanded ? /* @__PURE__ */ jsx(BsArrowsCollapse, {}) : /* @__PURE__ */ jsx(BsChevronExpand, {})
      })
    }), /* @__PURE__ */ jsx(Tooltip$2, {
      title: "Replies numbering",
      children: /* @__PURE__ */ jsx(ToggleButton$1, {
        value: "numbering",
        selected: numbering,
        onChange: () => setNumbering(toggle),
        children: /* @__PURE__ */ jsx(ImListNumbered, {})
      })
    }), /* @__PURE__ */ jsx(Tooltip$2, {
      title: "Columns layout",
      children: /* @__PURE__ */ jsx(ToggleButton$1, {
        value: "columnView",
        selected: columnView,
        onChange: () => setColumnView(toggle),
        children: /* @__PURE__ */ jsx(ImTable2, {})
      })
    })]
  });
};

const canEditPost = (post, profile, membership) => {
  if (!profile) {
    return false;
  }
  const author = typeof post.author === "string" ? post.author : post.author && post.author._id;
  if (profile._id === author) {
    return true;
  }
  if (!membership) {
    return false;
  }
  return membership.role === "ADMIN";
};

const saveTags = async (api, postId, tags) => {
  return api.makeRequest({
    path: `/tagged-posts/update/${postId}`,
    method: "POST",
    body: {
      tags
    }
  });
};
const PickerAutocomplete = styled(Autocomplete$1)`
  && button.MuiAutocomplete-clearIndicator {
    padding: 0;
  }
`;
const ResponseTagsPicker = ({
  response
}) => {
  const {
    run
  } = useRequest(saveTags, {
    manual: true,
    retryCount: -1
  });
  const tags = response.tags;
  const [options, setOptions] = useState([]);
  const api = useApi();
  const {
    membership,
    profile
  } = usePostInfoContext();
  const canEdit = canEditPost(response, profile, membership);
  if (!canEdit) {
    return /* @__PURE__ */ jsx(TagsLine, {
      tags
    });
  }
  return /* @__PURE__ */ jsx(TagsWrapper, {
    children: /* @__PURE__ */ jsx(PickerAutocomplete, {
      multiple: true,
      id: "tags-filled",
      options,
      defaultValue: tags,
      freeSolo: true,
      renderTags: (value, getTagProps) => value.map((option, index) => /* @__PURE__ */ jsx(Tag, {
        label: option,
        ...getTagProps({
          index
        })
      }, option)),
      renderInput: (params) => /* @__PURE__ */ jsx(TextField$1, {
        ...params,
        placeholder: "Add Tags"
      }),
      onChange: (event, newValue) => {
        run(api, response._id, newValue);
      },
      onInputChange: async (_event, newInputValue) => {
        const result = await api.suggestTags({
          filter: newInputValue,
          range: {
            start: 1,
            end: 10
          }
        });
        const tags2 = (result.values || []).map((v) => v.tag);
        setOptions(tags2);
      }
    })
  });
};

function showDesktopNotifications(v) {
  const old = !localStorage.noDesktopNotifications;
  if (arguments.length) {
    if (v) {
      delete localStorage.noDesktopNotifications;
    } else {
      localStorage.noDesktopNotifications = 1;
    }
  }
  return old;
}

function showToastsConfig(v) {
  const old = localStorage.showToasts;
  if (arguments.length) {
    if (!v) {
      delete localStorage.showToasts;
    } else {
      localStorage.showToasts = 1;
    }
  }
  return old;
}

const content_image = "_content_image_1cj3s_1";
const placeholder = "_placeholder_1cj3s_6";
const placeholder_box = "_placeholder_box_1cj3s_12";
const picture = "_picture_1cj3s_22";
var styles$b = {
	content_image: content_image,
	placeholder: placeholder,
	placeholder_box: placeholder_box,
	picture: picture
};

const DEFAULT_SIZES = {
  "(min-width: 2560px)": 2560,
  "(min-width: 1920px)": 1920,
  "(min-width: 1440px)": 1440,
  "(min-width: 1280px)": 1280,
  "(min-width: 940px)": 940,
  "(min-width: 768px)": 768,
  "(min-width: 640px)": 640,
  "(min-width: 512px)": 512,
  "(min-width: 320px)": 320,
  "(max-width: 240px)": 240
};
class ImageInner extends Component {
  constructor(props) {
    super(props);
    this.onLoaded = this.onLoaded.bind(this);
    this.onLayout = this.onLayout.bind(this);
    this.state = {};
  }
  onLoaded() {
    this.setState({
      loaded: true
    });
  }
  onLayout(el) {
    if (el) {
      let {
        data
      } = this.props;
      const {
        w,
        h
      } = imageDimensions(data && data.dimensions, el);
      this.setState({
        w,
        h
      });
    }
  }
  render() {
    let {
      instanceName,
      data,
      sizes = DEFAULT_SIZES,
      cdnRoot
    } = this.props;
    if (!data) {
      return null;
    }
    const {
      uuid,
      dimensions: {
        width,
        height
      } = {}
    } = data;
    let {
      loaded,
      w,
      h
    } = this.state;
    let style = width ? {
      width: "100%",
      maxWidth: `${width}px`,
      marginLeft: "auto",
      marginRight: "auto"
    } : {};
    let sharedProps = {
      src: `${cdnRoot}${instanceName}/${uuid}`,
      fit: "clip",
      faces: false
    };
    return /* @__PURE__ */ jsxs("div", {
      className: styles$b.content_image,
      ref: this.onLayout,
      children: [loaded ? null : /* @__PURE__ */ jsx("div", {
        className: styles$b.placeholder,
        style: {
          height: h
        },
        children: /* @__PURE__ */ jsx("div", {
          className: styles$b.placeholder_box,
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "general.loading"
          })
        })
      }), /* @__PURE__ */ jsx(Imgix, {
        imgProps: {
          style,
          onLoad: this.onLoaded
        },
        className: styles$b.picture,
        ...sharedProps,
        type: "picture",
        children: Object.getOwnPropertyNames(sizes).map((media) => /* @__PURE__ */ jsx(Imgix, {
          ...sharedProps,
          width: sizes[media],
          type: "source",
          imgProps: {
            media
          }
        }, media))
      })]
    });
  }
}
const Image = (props) => {
  const {
    instance
  } = useProfileContext();
  const {
    cdnRoot
  } = useCDNImageContext();
  return /* @__PURE__ */ jsx(ImageInner, {
    instanceName: instance && instance.instanceName,
    ...props,
    cdnRoot
  });
};

const main_article = "_main_article_1ihak_1";
const article = "_article_1ihak_11";
const bold = "_bold_1ihak_52";
const underline = "_underline_1ihak_56";
const italic = "_italic_1ihak_60";
const mention = "_mention_1ihak_74";
const link = "_link_1ihak_79";
const superscript = "_superscript_1ihak_84";
const icon = "_icon_1ihak_91";
const header = "_header_1ihak_97";
var styles$a = {
	main_article: main_article,
	article: article,
	bold: bold,
	underline: underline,
	italic: italic,
	mention: mention,
	link: link,
	superscript: superscript,
	icon: icon,
	header: header
};

const Wrapper$F = styled.span`
  .article .mention {
    color: #999999;
    background-color: #dceddd;
  }
`;
const Mention = ({
  data,
  children
}) => {
  return /* @__PURE__ */ jsx(Wrapper$F, {
    children
  });
};

const CONTAINER_TYPES = ["ul", "ol", "h1", "h2", "h3"];
const getDirection = (type, dir) => {
  if (CONTAINER_TYPES.includes(type)) {
    return dir;
  } else {
    return "auto";
  }
};
const convertClassNames = ({
  props,
  type
}, dir) => {
  if (props && props.className) {
    return {
      ...props,
      dir: getDirection(type, dir),
      className: styles$a[props.className]
    };
  } else {
    return {
      ...props,
      dir: getDirection(type, dir)
    };
  }
};
const convertContent = (blockContent, index) => {
  return blockContent.map((data, idx) => {
    if (typeof data === "string") {
      return data;
    } else {
      return /* @__PURE__ */ jsx(Block, {
        data
      }, `${index}_${idx}`);
    }
  });
};
const Empty = () => null;
const Block = ({
  data,
  dir,
  index
}) => {
  const {
    Link
  } = useAppComponents();
  const COMPONENTS = {
    Link: Link || Empty,
    Mention,
    Image
  };
  const getComponentOrElement = (type) => {
    return COMPONENTS[type] || type;
  };
  if (data.type === "span" && data.content.length === 1 && data.content[0].type === "span") {
    let d = data.content[0];
    return React__default.createElement(getComponentOrElement(d.type), convertClassNames(d, dir), convertContent(d.content, index));
  } else {
    return React__default.createElement(getComponentOrElement(data.type), convertClassNames(data, dir), convertContent(data.content, index));
  }
};
const ContentContext = React__default.createContext({
  fontSize: 14
});
const useContentContext = () => {
  return useContext(ContentContext);
};
const ContentContextProvider = ({
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsx(ContentContext.Provider, {
    value: props,
    children
  });
};
const Content$3 = ({
  data,
  dir,
  title
}) => {
  const {
    fontSize
  } = useContentContext();
  let blocks;
  if (!data) {
    blocks = null;
  } else if ("nsHtml" in data) {
    blocks = /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(TinyContentStyles, {}), /* @__PURE__ */ jsx(HtmlContent, {
        html: data.nsHtml,
        className: "mce-content-body",
        style: fontSize ? {
          fontSize
        } : void 0
      })]
    });
  } else {
    blocks = data.map((block, idx) => /* @__PURE__ */ jsx(Block, {
      data: block,
      dir,
      index: idx
    }, `_${idx}`));
  }
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    storageKey: "cfg:post-content",
    children: /* @__PURE__ */ jsxs("article", {
      className: `${styles$a.article} bg-[var(--cair-surface-background)] text-[color:var(--cair-text)] overflow-hidden`,
      dir,
      children: [title && /* @__PURE__ */ jsxs("h2", {
        style: {
          marginRight: "auto",
          textAlign: "left"
        },
        children: [" ", /* @__PURE__ */ jsx(FormattedMessage, {
          id: title
        }), " "]
      }), blocks]
    })
  });
};

// THIS FILE IS AUTO GENERATED
function TiArrowBack (props) {
  return GenIcon({"tag":"svg","attr":{"version":"1.2","baseProfile":"tiny","viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M12 9.059v-2.559c0-.256-.098-.512-.293-.708-.195-.195-.451-.292-.707-.292s-.512.097-.707.292l-6.293 6.208 6.293 6.207c.195.195.451.293.707.293s.512-.098.707-.293.293-.452.293-.707v-2.489c2.75.068 5.755.566 8 3.989v-1c0-4.633-3.5-8.443-8-8.941z"},"child":[]}]})(props);
}function TiClipboard (props) {
  return GenIcon({"tag":"svg","attr":{"version":"1.2","baseProfile":"tiny","viewBox":"0 0 24 24"},"child":[{"tag":"g","attr":{},"child":[{"tag":"path","attr":{"d":"M17 3h-10c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3zm-8 2h6v1c0 .551-.449 1-1 1h-4c-.551 0-1-.449-1-1v-1zm9 13c0 .551-.449 1-1 1h-10c-.551 0-1-.449-1-1v-12c0-.551.449-1 1-1h1v1c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-1h1c.551 0 1 .449 1 1v12zM16 17h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 14h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 11h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5z"},"child":[]}]}]})(props);
}

const PostCompleted = () => {
  const {
    post,
    loadPost
  } = usePostInfoContext();
  if (!post || !post.completed) {
    return null;
  }
  const onReopened = (updatedPost) => {
    return loadPost(updatedPost);
  };
  return /* @__PURE__ */ jsx(CompletedInfoBox, {
    post,
    onReopened
  });
};
const ThreadCompleted = ({
  buttons
}) => {
  const {
    loadResponses
  } = usePostInfoContext();
  const {
    post
  } = usePostContext();
  if (!post || !post.completed) {
    return null;
  }
  const onReopened = (_updatedPost) => {
    return loadResponses();
  };
  return /* @__PURE__ */ jsx(CompletedInfoBox, {
    post,
    onReopened,
    buttons
  });
};
const CompletedInfoBox = ({
  post,
  onReopened,
  buttons
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col w-full p-2",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex w-full",
      children: [/* @__PURE__ */ jsx(TiClipboard, {
        size: 30
      }), /* @__PURE__ */ jsx(ReopenButton, {
        post,
        onReopened,
        className: "ml-auto"
      }), buttons]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex text-base pb-2",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "outcome"
      })
    }), /* @__PURE__ */ jsx(Conclusion, {
      post
    })]
  });
};
const ReopenButton = ({
  post,
  onReopened,
  ...other
}) => {
  const {
    membership
  } = usePostInfoContext();
  const api = useApi();
  if (!isAdmin(membership)) {
    return null;
  }
  const reopenDiscussion = errorsReported(async () => {
    const concludingPost = {
      post: post._id,
      conclusion: false,
      concludingPost: ""
    };
    await api.concludePost(concludingPost);
    await onReopened();
  });
  return /* @__PURE__ */ jsx(BigStyledButton, {
    fitContent: true,
    onClick: reopenDiscussion,
    ...other,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "reopen"
    })
  });
};
const Conclusion = ({
  post
}) => {
  const str = post.conclusion;
  let parsed;
  try {
    parsed = JSON.parse(str);
  } catch (e) {
  }
  if (!parsed) {
    return /* @__PURE__ */ jsx("h1", {
      children: str
    });
  }
  return /* @__PURE__ */ jsx(ConclusionContentCard, {
    language: post.language,
    post: parsed
  });
};
const ConclusionContentCard = ({
  post,
  language
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: "text-blue-400 w-full border-l-2 border-blue-400 p-4",
    children: /* @__PURE__ */ jsx(Content$3, {
      data: post,
      dir: getDirection$1(language)
    })
  });
};

const PostHeader = () => {
  const {
    circle,
    post
  } = usePostInfoContext();
  if (!circle || !post || post.type !== "event" && post.type !== "asset") {
    return null;
  }
  const {
    header_url
  } = circle;
  if (!header_url) {
    return null;
  }
  return /* @__PURE__ */ jsx("img", {
    src: header_url
  });
};
const PostFooter = () => {
  const {
    circle,
    post
  } = usePostInfoContext();
  if (!circle || !post || post.type !== "event" && post.type !== "asset") {
    return null;
  }
  const {
    footer_url
  } = circle;
  if (!footer_url) {
    return null;
  }
  return /* @__PURE__ */ jsx("img", {
    src: footer_url
  });
};
const MapFooter = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  const {
    map_footer_url,
    mobile_map_footer_url
  } = circle;
  if (!map_footer_url && !mobile_map_footer_url) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [map_footer_url && /* @__PURE__ */ jsx("img", {
      src: map_footer_url,
      className: "hidden sm:block"
    }), mobile_map_footer_url && /* @__PURE__ */ jsx("img", {
      src: mobile_map_footer_url,
      className: "sm:hidden"
    })]
  });
};

const Content$2 = styled.div`
  padding: 1rem;
  &>* {
    padding: 0.5rem;
  }
`;
const FlaggedMessage = () => {
  const {
    post
  } = usePostContext();
  const {
    onClick,
    disabled,
    loading
  } = useUnFlagPost(post && post.thread.length && post);
  if (!post || !post.flagged || post.unpublished) {
    return null;
  }
  return /* @__PURE__ */ jsx(InfoBox, {
    title: "Message was reported",
    component: Content$2,
    style: {
      margin: 10
    },
    children: /* @__PURE__ */ jsx(LoadingButton, {
      disabled,
      onClick,
      loading,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "post.unflag"
      })
    })
  });
};

const useAssetViewData = () => {
  const {
    post
  } = useContext(PostInfoContext);
  return post && post.form && post.form.data;
};

const findHeadingElements = (el) => {
  for (let i = 1; i < 7; i++) {
    const h = el.getElementsByTagName("h" + i);
    if (h.length) {
      return {
        h: htmlElementText(h[0]),
        el: h[0]
      };
    }
  }
};
const headingElement = (el) => {
  for (let i = 1; i < 7; i++) {
    const h = el.getElementsByTagName("h" + i);
    if (h.length)
      return h[0];
  }
};
const extractImage2 = (el) => {
  const images = el.getElementsByTagName("img");
  const length = images.length;
  for (let i = 0; i < length; i++) {
    const image = images[i];
    const url = image.src;
    const parts = url.split("/");
    const domain = parts[2];
    if (domain !== "s3.eu-west-2.amazonaws.com" && !/^newssocial.*\.imgix\.net$/.test(domain)) {
      continue;
    }
    const uuid = parts.slice(4).join("/");
    const name = parts[parts.length - 1];
    const nameParts = name.split(".");
    const type = nameParts[nameParts.length - 1];
    const info = {
      uuid,
      originalFileName: name,
      contentType: "image/" + type,
      originalFileSize: 0
    };
    return { info, image };
  }
  return { info: null, image: null };
};
const extractImage = (el) => extractImage2(el).info;
const extractTitle2 = (el) => {
  const heading = findHeadingElements(el);
  if (heading)
    return heading;
  const children = el.children;
  const length = children.length;
  for (let i = 0; i < length; i++) {
    const h = htmlElementText(children[i]);
    if (h.length)
      return { h, el: children[i] };
  }
};
const extractTitle = (el) => {
  const title = extractTitle2(el);
  if (title && title.h)
    return title.h.slice(0, 255);
};
const replaceTitle = (el, title, old) => {
  const heading = findHeadingElements(el);
  if (heading) {
    const h = headingElement(el);
    if (htmlElementText(h) === old) {
      h.innerText = title;
      return;
    }
  }
  const children = el.children;
  const length = children.length;
  for (let i = 0; i < length; i++) {
    const h = htmlElementText(children[i]);
    if (h === old) {
      children[i].innerText = title;
      return;
    }
  }
};
const extractSummary = (content) => {
  const el = document.createElement("div");
  el.innerHTML = content;
  replaceTitle(el, "");
  const children = el.children;
  let text = "";
  const length = children.length;
  let first = true;
  for (let i = 0; i < length; i++) {
    const h = htmlElementText(children[i]);
    if (!h)
      continue;
    if (first) {
      first = false;
    } else {
      text += "\n";
    }
    text += h;
    if (text.length > 300)
      break;
  }
  return text.slice(0, 700);
};
const contentInfoFromDiv = (el) => ({
  nsText: htmlElementText(el),
  nsHtml: el.innerHTML.trim(),
  nsTitle: extractTitle(el),
  nsImage: extractImage(el)
});
const getContentInfo = (content) => {
  const el = document.implementation.createHTMLDocument("").createElement("div");
  el.innerHTML = content;
  return contentInfoFromDiv(el);
};
const extractBodyHtml = (html) => {
  const doc = document.createElement("div");
  doc.innerHTML = html;
  const body = doc.querySelector("body");
  const root = body || doc;
  root.querySelectorAll('style, link[rel="stylesheet"]').forEach((el) => el.remove());
  return (body ? body.innerHTML : doc.innerHTML).trim();
};

var contentExtract = /*#__PURE__*/Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: 'Module',
  headingElement: headingElement,
  extractImage2: extractImage2,
  extractImage: extractImage,
  extractTitle2: extractTitle2,
  extractTitle: extractTitle,
  replaceTitle: replaceTitle,
  extractSummary: extractSummary,
  contentInfoFromDiv: contentInfoFromDiv,
  getContentInfo: getContentInfo,
  extractBodyHtml: extractBodyHtml
});

const PostEditorContext = React__default.createContext({
  isHtml: false,
  attachments: [],
  setAttachments: () => null,
  draft: void 0,
  content: void 0,
  editor: void 0,
  setEditor: () => null,
  setDraft: () => null,
  save: () => null
});
const isNsContent = (content) => content && "nsHtml" in content;
const usePostEditorContext = () => useContext(PostEditorContext);
const PostEditorContextProvider = ({
  children,
  draft: input,
  onSave = () => null
}) => {
  const [editor, setEditor] = useState();
  const [isHtml, setIsHtml] = useState(false);
  const [content, setContent] = useState(void 0);
  const [attachments, setAttachments] = useState(void 0);
  const [draft, setDraft] = useState();
  const update = useUpdateEditedDraftFn();
  useEffect(() => {
    if (!draft) {
      setContent(void 0);
      setAttachments([]);
      setIsHtml(false);
      return;
    }
    const {
      nsHtml
    } = draft.content || {};
    if (isNsContent(draft.content)) {
      setIsHtml(true);
    }
    setContent(nsHtml || "");
    setAttachments(draft.attachments || []);
  }, [draft && draft._id]);
  const last = useRef();
  const save = useMemoizedFn(async (data) => {
    if (!isHtml || !draft)
      return;
    const {
      getContentInfo: getContentInfo2
    } = await Promise.resolve().then(function () { return contentExtract; });
    const html = editor ? editor.getContent() : draft.content.nsHtml;
    if (last.current === html && !data)
      return;
    last.current = html;
    const hasAttachment = data && data.attachments;
    if (hasAttachment)
      setAttachments(data.attachments);
    const contentUpdate = getContentInfo2(html);
    const updated = await update({
      ...draft,
      content: contentUpdate,
      image: contentUpdate.nsImage,
      attachments,
      ...data
    });
    onSave(updated);
    return updated;
  });
  useInterval(save, editor && 30 * 1e3);
  useEffect(() => {
    setDraft(input);
  }, [input]);
  const context = useMemo(() => ({
    editor,
    setEditor,
    content,
    setDraft,
    draft,
    save,
    attachments,
    setAttachments,
    isHtml
  }), [editor, content, draft, attachments, isHtml]);
  return /* @__PURE__ */ jsx(PostEditorContext.Provider, {
    value: context,
    children
  });
};

const PostTinyEditor = () => {
  const {
    setEditor,
    content
  } = usePostEditorContext();
  const images_upload_handler = null;
  const wasCreated = useRef(null);
  if (wasCreated.current) {
    return wasCreated.current;
  }
  if (typeof content === "string") {
    const settings = {
      images_upload_handler,
      menubar: false
    };
    wasCreated.current = /* @__PURE__ */ jsx(TinyEditor, {
      setEditor,
      content,
      settings
    });
  }
  return wasCreated.current;
};

const AttachmentDataContext = React__default.createContext({
  data: void 0,
  closed: false,
  setClosed: () => null
});
const useAttachmentData = () => {
  return useContext(AttachmentDataContext);
};

const AttachmentProvider$1 = ({
  children,
  data,
  override
}) => {
  const [closed, setClosed] = useState(false);
  if (!data) {
    return null;
  }
  const context = {
    data,
    closed,
    setClosed
  };
  if (!override) {
    return /* @__PURE__ */ jsx(AttachmentDataContext.Provider, {
      value: context,
      children
    });
  }
  return /* @__PURE__ */ jsx(AttachmentDataContext.Provider, {
    value: context,
    children: /* @__PURE__ */ jsx(CardThemeProvider, {
      cardShadow: true,
      ...override,
      children
    })
  });
};

// THIS FILE IS AUTO GENERATED
function GrDocumentCsv (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"fill":"none","strokeWidth":"2","d":"M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M7,13 C7,13 6.00000004,13 5,13 C3.99999996,13 3,13.5 3,14.5 L3,16 C3,16 3.00000001,16.5 3,17.5 C2.99999999,18.5 4,19 5,19 L7,19 M13.25,13 C13.25,13 12.25,13 10.75,13 C9.25,13 8.75,13.5 8.75,14.5 C8.75,15.5 9.25,16 10.75,16 C12.25,16 12.75,16.5 12.75,17.5 C12.75,18.5 12.25,19 10.75,19 C9.25,19 8.25,19 8.25,19 M20.5,12 C20.5,12 20.5,12 20.5,12.5 C20.5,13 18,19 18,19 L17.5,19 C17.5,19 15,13 15,12.5 L15,12"},"child":[]}]})(props);
}function GrDocumentZip (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"fill":"none","strokeWidth":"2","d":"M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L4,23 M18,1 L18,6 L23,6 M2,13 L7,13 L7,14 L3,18 L3,19 L8,19 M11,12 L11,20 L11,12 Z M15,13 L15,20 L15,13 Z M20,15 C20,13.895 19.105,13 18,13 L15,13 L15,17 L18,17 C19.105,17 20,16.105 20,15 Z"},"child":[]}]})(props);
}

const fileTypeIcon = (mimeType) => {
  if (!mimeType) {
    return /* @__PURE__ */ jsx(BsFile, {});
  }
  if (mimeType.includes("document")) {
    return /* @__PURE__ */ jsx(BsFileWord, {});
  }
  if (mimeType.includes("spreadsheet")) {
    return /* @__PURE__ */ jsx(BsFileExcel, {});
  }
  if (mimeType.includes("image")) {
    return /* @__PURE__ */ jsx(BsFileImage, {});
  }
  if (mimeType.includes("pdf")) {
    return /* @__PURE__ */ jsx(BsFilePdf, {});
  }
  if (mimeType.includes("video")) {
    return /* @__PURE__ */ jsx(ImFileVideo, {});
  }
  if (mimeType.includes("audio")) {
    return /* @__PURE__ */ jsx(FaRegFileAudio, {});
  }
  if (mimeType.includes("csv")) {
    return /* @__PURE__ */ jsx(GrDocumentCsv, {});
  }
  if (mimeType.includes("zip")) {
    return /* @__PURE__ */ jsx(GrDocumentZip, {});
  }
  return /* @__PURE__ */ jsx(BsFile, {});
};

const AttachmentCard = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(AttachmentProvider$1, {
    data,
    override,
    children: /* @__PURE__ */ jsx(AttachmentCardImp, {
      ...props
    })
  });
};
const ContentOuter = styled.div`
    display: flex;
    align-items: center;
`;
const ContentBodyWrapper = styled.div`
    flex: 1;
    flex: auto;
    flex-direction: column;
    & > * {
        width: 100%;
    }
`;
const AttachmentTitle = ({
  underline = "always",
  ...other
}) => {
  const {
    data
  } = useAttachmentData();
  const {
    originalFileName,
    originalFileSize
  } = data;
  return /* @__PURE__ */ jsx(Title, {
    ...other,
    children: `${originalFileName} (${humanFileSize(originalFileSize)})`
  });
};
const AttachmentContentBody = () => {
  const {
    data
  } = useAttachmentData();
  const {
    description
  } = data;
  const {
    attachments,
    setAttachments
  } = usePostEditorContext();
  const handlePostChange = (e) => {
    const description2 = e.target.value;
    const updated = attachments.map((a) => {
      if (a.uuid !== data.uuid) {
        return a;
      }
      return {
        ...a,
        description: description2
      };
    });
    setAttachments(updated);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(AttachmentTitle, {}), /* @__PURE__ */ jsx(TextField$1, {
      label: "description",
      value: description || "",
      onChange: handlePostChange
    }), /* @__PURE__ */ jsx(SubText, {})]
  });
};
const AttachmentContentWrapper = ({
  children
}) => {
  return /* @__PURE__ */ jsx(ContentOuter, {
    children
  });
};
const ImageWrapper$1 = styled.div`
    padding: 10px;
`;
const RemoveAttachmentButton = () => {
  const {
    data
  } = useAttachmentData();
  const {
    save,
    attachments
  } = usePostEditorContext();
  const onClick = () => {
    save({
      attachments: attachments.filter((a) => a !== data)
    });
  };
  return /* @__PURE__ */ jsx(IconContext.Provider, {
    value: {
      size: "1.5rem"
    },
    children: /* @__PURE__ */ jsx(ImageWrapper$1, {
      children: /* @__PURE__ */ jsx(IconButton$5, {
        onClick,
        children: /* @__PURE__ */ jsx(BsTrash, {})
      })
    })
  });
};
const AttachmentCardImp = (props) => {
  const {
    data
  } = useAttachmentData();
  const {
    contentType
  } = data;
  return /* @__PURE__ */ jsx(CardOuter, {
    children: /* @__PURE__ */ jsxs(AttachmentContentWrapper, {
      ...props,
      children: [/* @__PURE__ */ jsx(IconContext.Provider, {
        value: {
          size: "3rem"
        },
        children: /* @__PURE__ */ jsx(ImageWrapper$1, {
          children: fileTypeIcon(contentType)
        })
      }), /* @__PURE__ */ jsx(ContentBodyWrapper, {
        children: /* @__PURE__ */ jsx(AttachmentContentBody, {})
      }), /* @__PURE__ */ jsx(RemoveAttachmentButton, {})]
    })
  });
};

const AttachmentsList = () => {
  const {
    attachments,
    isHtml
  } = usePostEditorContext();
  if (!isHtml || !attachments) {
    return null;
  }
  if (!attachments) {
    return /* @__PURE__ */ jsx("div", {
      children: "No attachments yet"
    });
  }
  return /* @__PURE__ */ jsx(CardThemeProvider, {
    cardShadow: true,
    children: attachments.map((g, i) => /* @__PURE__ */ jsx(AttachmentCard, {
      showImage: true,
      data: g
    }, g.uuid))
  });
};

const CircularProgressWithLabel = (props) => {
  const {
    value
  } = props;
  const indeterminate = typeof value === "undefined";
  return /* @__PURE__ */ jsxs(Box, {
    position: "relative",
    display: "inline-flex",
    children: [/* @__PURE__ */ jsx(CircularProgress, {
      variant: indeterminate ? "indeterminate" : "determinate",
      ...props
    }), /* @__PURE__ */ jsx(Box, {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      children: !indeterminate && /* @__PURE__ */ jsx(Typography, {
        variant: "caption",
        component: "div",
        color: "textSecondary",
        children: `${Math.round(value)}%`
      })
    })]
  });
};

const UploadButton = () => {
  const {
    save,
    attachments,
    isHtml
  } = usePostEditorContext();
  const api = useApi();
  const [dialogOpen, setDialogOpen] = useState(false);
  const onClick = () => {
    setDialogOpen(true);
  };
  const onFiles = useMemoizedFn(async (acceptedFiles, onProgress) => {
    const all = [...attachments, ...acceptedFiles];
    const saved = await errorsReported(async () => {
      const saved2 = await uploadFiles(api, all, onProgress);
      return saved2;
    }, {
      message: "Failed to upload files."
    })();
    onProgress(void 0);
    await save({
      attachments: saved
    });
  });
  if (!isHtml) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      onClick,
      color: "secondary",
      children: /* @__PURE__ */ jsx(Badge$2, {
        color: "secondary",
        badgeContent: attachments && attachments.length,
        invisible: !attachments || !attachments.length,
        children: /* @__PURE__ */ jsx(MdAttachFile, {})
      })
    }), /* @__PURE__ */ jsx(UploadFileDialog, {
      open: dialogOpen,
      onClose: () => setDialogOpen(false),
      onFiles
    })]
  });
};
const Dialog$2 = styled(Dialog$6)`
    & .MuiDialogContent-root {
        padding: 5px 24px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    & .MuiList-root {
        overflow-y: auto;
    }

    & .MuiDialog-paperScrollPaper {
        width: calc(100% - 64px);
        max-width: calc(100% - 64px);
    }

    & .DropZone-section {
        flex: 1;
        min-height: 200px;
    }
`;
const AlertTitle = styled(AlertTitle$2)`
    display: flex;
    align-items: center;
`;
const TitleWrapper = styled.span`
        margin: 0 10px;
`;
const Alert = styled(Alert$2)`
    margin: 5px;
`;
const UploadFileDialog = (props) => {
  const {
    open,
    onClose
  } = props;
  const [uploading, setUploading] = useState(false);
  const [percentage, setPercentage] = useState(void 0);
  const {
    onFiles,
    title,
    dropzone: dropzoneOptions,
    ...other
  } = props;
  const onProgress = useMemoizedFn((percentage2) => {
    setPercentage(percentage2 < 100 ? percentage2 : void 0);
  });
  const onDrop = useCallback(async (acceptedFiles) => {
    console.log("files", acceptedFiles);
    try {
      setUploading(true);
      setPercentage(0);
      await onFiles(acceptedFiles, onProgress);
    } finally {
      setUploading(false);
      setPercentage(void 0);
    }
  }, []);
  const dropzone = useDropzone({
    onDrop,
    ...dropzoneOptions
  });
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$2, {
    fullScreen: true,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    ...other,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: title || "Manage attachments"
    }), /* @__PURE__ */ jsx(AttachmentsList, {}), uploading && /* @__PURE__ */ jsx(Alert, {
      severity: "info",
      variant: "outlined",
      children: /* @__PURE__ */ jsxs(AlertTitle, {
        children: [/* @__PURE__ */ jsx(TitleWrapper, {
          children: "Uploading file..."
        }), /* @__PURE__ */ jsx(CircularProgressWithLabel, {
          value: percentage
        })]
      })
    }), /* @__PURE__ */ jsx(DropZone$1, {
      ...dropzone
    })]
  });
};

const useGetJwtTokenFn = () => {
  const api = useApi();
  return () => api.loadJwt();
};

const openBrowserAsync = (url) => execute("openBrowserAsync", {
  url,
  __noExecutionTimeout: true
});

const OpenBrowser = ({
  children
}) => {
  const history = useHistory();
  const getJwtToken = useGetJwtTokenFn();
  const close = () => {
    history.goBack();
  };
  useAsyncEffect(async () => {
    const token = await getJwtToken();
    await openBrowserAsync(`${location.origin}/${location.pathname.slice(1)}?token=${token}`);
    close();
  }, []);
  return /* @__PURE__ */ jsxs("div", {
    children: [children, /* @__PURE__ */ jsx(Button, {
      onClick: close,
      children: "<<"
    })]
  });
};

const normalizeFormData = (data, post) => {
  if (!data) {
    return null;
  }
  const updated = {
    ...data
  };
  if (updated["pictures"]) {
    updated.files = updated["pictures"];
    delete updated["pictures"];
  }
  if (updated["link_description"]) {
    updated.shortDescription = updated["link_description"];
    delete updated["link_description"];
  }
  if (updated["contact"]) {
    updated.email = updated["contact"];
    delete updated["contact"];
  }
  if (post && (!updated.tags || !updated.tags.length) && post.tags && post.tags.length) {
    updated.tags = [...post.tags];
  }
  return updated;
};

const Div$1 = (props) => /* @__PURE__ */ jsx("div", {
  ...props
});

const TranslatingSpinner = () => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      className: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
      children: /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      })
    })
  });
};
const MAX_TEXT_SIZE = 300;
const PostContent = ({
  setTitle
}) => {
  const {
    post
  } = usePostInfoContext();
  const [full, setFull] = useState(false);
  const {
    language: userLanguage
  } = useLanguageSelectionContext();
  const requiresTranslation = userLanguage && post && post.translate && !postITooBigToTranslate(post);
  const {
    html: translated
  } = useTranslatePost(requiresTranslation, post, userLanguage);
  if (!post || !post.content || !post.content.nsHtml) {
    return null;
  }
  const content = requiresTranslation && translated ? translated : post.content.nsHtml;
  const tempDivElement = document.createElement("div");
  tempDivElement.innerHTML = content;
  const {
    image
  } = extractImage2(tempDivElement);
  if (image) {
    image.remove();
  }
  const title = extractTitle2(tempDivElement);
  if (title) {
    title.el.remove();
    setTitle(title.h);
  }
  const text = tempDivElement.innerText.replace(/\s\s+/g, " ");
  const isBig = text.length > MAX_TEXT_SIZE;
  const isEmpty = isBig ? false : text.trim().length === 0;
  if (isEmpty) {
    return null;
  }
  let waitingSpinner = null;
  const showWaitTranslation = requiresTranslation && !translated;
  if (showWaitTranslation) {
    waitingSpinner = /* @__PURE__ */ jsx(TranslatingSpinner, {});
  }
  if (isBig && !full) {
    const short = text.slice(0, MAX_TEXT_SIZE);
    const split = short.split(" ");
    split.pop();
    return /* @__PURE__ */ jsxs("div", {
      dir: "auto",
      className: "bg-[#00A5B6] p-2 rounded-lg text-white cursor-pointer relative",
      onClick: () => setFull((v) => !v),
      children: [waitingSpinner, /* @__PURE__ */ jsx("span", {
        dangerouslySetInnerHTML: {
          __html: split.join(" ")
        }
      }), /* @__PURE__ */ jsxs("span", {
        className: "underline",
        children: ["\xA0...\xA0", /* @__PURE__ */ jsx("span", {
          className: "font-semibold",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.show_more"
          })
        })]
      })]
    });
  }
  const html = tempDivElement.innerHTML;
  return /* @__PURE__ */ jsxs("div", {
    className: "relative",
    children: [/* @__PURE__ */ jsx("div", {
      dir: "auto",
      className: "bg-[#00A5B6] p-2 rounded-lg text-white cursor-pointer",
      dangerouslySetInnerHTML: {
        __html: html
      },
      onClick: () => setFull((v) => !v)
    }), waitingSpinner]
  });
};

const loadedHrefs = new Set();
const loadStylesheet = (href) => {
  if (loadedHrefs.has(href))
    return Promise.resolve();
  return new Promise((resolve) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.onload = () => {
      loadedHrefs.add(href);
      resolve();
    };
    document.head.appendChild(link);
  });
};

const SWIPER_VERSION = "10.3.1";
const SWIPER_BASE = `https://cdn.jsdelivr.net/npm/swiper@${SWIPER_VERSION}`;
const SWIPER_JS_URL = `${SWIPER_BASE}/swiper-bundle.min.js`;
const SWIPER_CSS_URL = `${SWIPER_BASE}/swiper-bundle.min.css`;
const loadSwiper = () => Promise.all([
  loadStylesheet(SWIPER_CSS_URL),
  loadJsLibs([SWIPER_JS_URL])
]).then(() => void 0);

const imageHeight = 350;
const PhotoSwiper = styled.div`
  height: ${imageHeight}px;
  width: 100%;


  & .swiper-slide {
    display: flex;
  }
`;
const getMapZoomToPostUrl = (circle, post) => {
  if (!circle) {
    return "";
  }
  return circleUrl(circle) + `#?tab=map&zoom_to=${post._id}`;
};
const AssetFile = ({
  file,
  maxWidth
}) => {
  const url = useImageUrl(file);
  const {
    uuid,
    dimensions,
    originalFileSize,
    contentType,
    originalFileName
  } = file;
  const {
    height,
    width
  } = dimensions || {};
  if (contentType && contentType.startsWith("image/")) {
    const aspect = width && height ? width / height : 1;
    const calculatedWidth = imageHeight * aspect;
    const scaledImageWidth = calculatedWidth < maxWidth ? calculatedWidth : maxWidth;
    return /* @__PURE__ */ jsx(ScaledImageProxy, {
      h: imageHeight,
      w: scaledImageWidth,
      uuid,
      crop: true
    });
  }
  const image = contentType ? fileTypeIcon(contentType) : null;
  return /* @__PURE__ */ jsx(Link$1, {
    href: url,
    download: true,
    target: "_blank",
    underline: "always",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex gap-1 items-center max-w-full",
      children: [/* @__PURE__ */ jsx(IconContext$1.Provider, {
        value: {
          size: "20px"
        },
        children: image
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col overflow-hidden grow",
        children: [/* @__PURE__ */ jsx("div", {
          className: "text-ellipsis overflow-hidden max-w-xs whitespace-nowrap",
          children: originalFileName
        }), /* @__PURE__ */ jsx("div", {
          children: humanFileSize(originalFileSize)
        })]
      })]
    })
  });
};
const windowWidth = () => {
  if (typeof window === "undefined") {
    return imageHeight;
  }
  var win = window, doc = document, docElem = doc.documentElement, body = doc.getElementsByTagName("body")[0];
  return win.innerWidth || docElem.clientWidth || body.clientWidth;
};
const PostViewAssetContent = forwardRef((_, ref) => {
  const data = normalizeFormData(useAssetViewData());
  const {
    dialog
  } = usePostUIContext();
  const {
    post,
    circle
  } = usePostInfoContext();
  const {
    language: userLanguage
  } = useLanguageSelectionContext();
  const requiresTranslation = userLanguage && post && post.translate;
  const {
    html: translated
  } = useTranslatePost(requiresTranslation, post, userLanguage);
  const {
    name,
    address,
    shortDescription,
    phone,
    charges,
    openingTimes,
    email,
    url,
    status,
    files,
    category,
    type,
    subType,
    activity,
    subActivity
  } = {
    ...data,
    ...translated
  };
  const wasValidated = status === "Validated";
  const showOnMapLink = true;
  const maxWidth = windowWidth();
  const hasImages = files && files.length > 0;
  const subActivities = (subActivity && Array.isArray(subActivity) ? subActivity : [subActivity]) || [];
  const showOnMap = (ev) => {
    {
      if (!dialog) {
        return;
      }
      setQueryStringParams({
        tab: "map",
        zoom_to: post._id
      });
    }
    ev.stopPropagation();
    ev.preventDefault();
  };
  const swiperContainerRef = useRef(null);
  const swiperInstanceRef = useRef(null);
  useEffect(() => {
    if (!hasImages || !swiperContainerRef.current) {
      return;
    }
    let cancelled = false;
    loadSwiper().then(() => {
      if (cancelled || !swiperContainerRef.current) {
        return;
      }
      swiperInstanceRef.current = new window.Swiper(swiperContainerRef.current, {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      });
    });
    return () => {
      cancelled = true;
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy(true, true);
        swiperInstanceRef.current = null;
      }
    };
  }, [hasImages]);
  useEffect(() => {
    if (swiperInstanceRef.current) {
      swiperInstanceRef.current.update();
    }
  }, [files]);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col items-stretch gap-2 text-sm",
    ref,
    children: [hasImages && /* @__PURE__ */ jsxs(PhotoSwiper, {
      ref: swiperContainerRef,
      className: "swiper",
      dir: getDirectionality(),
      children: [/* @__PURE__ */ jsx("div", {
        className: "swiper-wrapper",
        children: files.map((f) => /* @__PURE__ */ jsx("div", {
          className: "swiper-slide flex items-center justify-center",
          children: /* @__PURE__ */ jsx(AssetFile, {
            file: f,
            maxWidth: maxWidth - 20
          })
        }, f.uuid))
      }), /* @__PURE__ */ jsx("div", {
        className: "swiper-button-prev"
      }), /* @__PURE__ */ jsx("div", {
        className: "swiper-button-next"
      }), /* @__PURE__ */ jsx("div", {
        className: "swiper-pagination"
      })]
    }), !hasImages && circle && circle.image && /* @__PURE__ */ jsx("div", {
      className: "relative w-full h-[200px]",
      "data-testid": "circle-image",
      children: /* @__PURE__ */ jsx(CircleHeaderImageInnerV2, {
        image: circle.image
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex bg-[#4A90CE] p-2 text-white text-lg rounded-md items-center relative",
      children: [name, " ", requiresTranslation && !translated && /* @__PURE__ */ jsx(TranslatingSpinner, {})]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex items-stretch",
      children: /* @__PURE__ */ jsxs("p", {
        className: "mx-auto max-w-[90%] min-w-[50%] bg-[#FFECEC] -mt-2 overflow-hidden text-ellipsis whitespace-nowrap text-center p-2 rounded-b-lg",
        children: [/* @__PURE__ */ jsx(MdLocationPin, {
          className: "inline align-middle"
        }), "\xA0", /* @__PURE__ */ jsx("span", {
          className: "inline align-middle",
          children: address
        })]
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 flex-nowrap flex-col sm:flex-row",
      children: [/* @__PURE__ */ jsx("div", {
        className: "bg-[#F5F5F5] p-2",
        children: /* @__PURE__ */ jsx(HTMLView, {
          html: shortDescription
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2 items-stretch",
        children: [/* @__PURE__ */ jsxs("div", {
          className: clsx("p-1 flex gap-1 rounded-md text-xs items-center", wasValidated ? " bg-green-400" : " bg-[#FFC100]"),
          children: [/* @__PURE__ */ jsx("span", {
            className: clsx("grow", wasValidated && "text-white"),
            children: wasValidated ? "VERIFIED" : "AWAITING VERIFICATION"
          }), " ", wasValidated ? /* @__PURE__ */ jsx(MdCheck, {
            color: "white"
          }) : /* @__PURE__ */ jsx(AiOutlineClockCircle, {})]
        }), /* @__PURE__ */ jsx(Link$1, {
          href: getMapZoomToPostUrl(circle, post) ,
          target: "_blank" ,
          onClick: showOnMap,
          underline: "always",
          children: /* @__PURE__ */ jsxs("div", {
            className: clsx("p-1 flex gap-1 rounded-md  text-xs  items-center", "bg-[#F9E2AF]" , !showOnMapLink ),
            children: [/* @__PURE__ */ jsx("span", {
              className: "grow",
              children: "SHOW ON MAP"
            }), /* @__PURE__ */ jsx(LiaMapMarkedAltSolid, {})]
          })
        })]
      })]
    }), /* @__PURE__ */ jsx(Tags$1, {
      tags: post.tags,
      tagClassName: "text-2xs",
      chipInner: Div$1,
      showAll: true
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col bg-[#F1F6F9] gap-2 items-stretch p-2",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-sm font-semibold",
        children: "MORE INFO"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center p-0 flex-wrap",
        children: [phone && /* @__PURE__ */ jsxs("div", {
          className: "flex bg-white items-center gap-1 p-1 flex-wrap max-w-full overflow-hidden text-ellipsis rounded-md",
          children: [/* @__PURE__ */ jsx(MdPhone, {}), phone]
        }), openingTimes && /* @__PURE__ */ jsxs("div", {
          className: "flex bg-white items-center gap-1 p-1 flex-wrap max-w-full overflow-hidden text-ellipsis rounded-md",
          children: [/* @__PURE__ */ jsx(AiOutlineClockCircle, {}), /* @__PURE__ */ jsx("span", {
            children: "Timing:"
          }), /* @__PURE__ */ jsx("span", {
            children: openingTimes || "-"
          })]
        }), charges && /* @__PURE__ */ jsxs("div", {
          className: "flex bg-white items-center gap-1 p-1 flex-wrap max-w-full overflow-hidden text-ellipsis rounded-md",
          children: [/* @__PURE__ */ jsx(HiOutlineCurrencyDollar, {}), /* @__PURE__ */ jsx("span", {
            children: "Cost:"
          }), /* @__PURE__ */ jsx("span", {
            children: charges || "-"
          })]
        }), email && /* @__PURE__ */ jsxs("div", {
          className: "flex bg-white items-center gap-1 p-1 flex-wrap max-w-full overflow-hidden text-ellipsis rounded-md",
          children: [/* @__PURE__ */ jsx(MdOutlineMail, {}), /* @__PURE__ */ jsx("span", {
            children: email || "-"
          })]
        }), url && /* @__PURE__ */ jsxs("div", {
          className: "flex bg-white items-center gap-1 p-1 max-w-full overflow-hidden text-ellipsis rounded-md flex-wrap",
          children: [/* @__PURE__ */ jsx(TbWorld, {}), /* @__PURE__ */ jsx(Link$1, {
            href: url,
            underline: "always",
            target: "_blank",
            children: url || "-"
          })]
        }), (type || subType) && /* @__PURE__ */ jsxs("div", {
          className: "flex bg-white items-center gap-1 p-1 max-w-full overflow-hidden text-ellipsis rounded-md flex-wrap",
          children: [/* @__PURE__ */ jsx(LuFolderTree, {}), /* @__PURE__ */ jsx("span", {
            children: subType || type || "-"
          })]
        }), (activity || subActivity) && /* @__PURE__ */ jsx("div", {
          className: "flex bg-white items-center gap-1 p-1 max-w-full overflow-hidden text-ellipsis rounded-md flex-wrap",
          children: /* @__PURE__ */ jsx("span", {
            children: subActivities.length && subActivities.filter((v) => v).join(", ") || activity || "-"
          })
        })]
      })]
    })]
  });
});

const useSelectChunk = (post) => {
  const [el, setEl] = useState();
  const {
    post: rootPost
  } = usePostContext();
  const {
    chunk,
    page: scrollToPostId
  } = useQueryStringParams();
  const [postId, chunkId] = rootPost && chunk && chunk.split("-") || [];
  const groupId = chunkId && postGroupId(rootPost);
  const {
    data
  } = useVectorSearchOptions(groupId || "wait");
  const size = data && data.options && (data.options.chunkSize || 1);
  const root = el && el.querySelector(".mce-content-body");
  const thisPost = postId === post._id || scrollToPostId === post._id;
  useEffect(() => {
    if (!thisPost || chunkId) {
      return;
    }
    if (!root) {
      return;
    }
    keepElementInViewWithObserver(root, {
      scrollOptions: {
        behavior: "instant"
      }
    });
  }, [root, chunkId, thisPost]);
  useEffect(() => {
    if (!thisPost) {
      return;
    }
    if (!size || !root) {
      return;
    }
    const chunks = splitHtmlIntoChunks(root, size * 1e3);
    const id = parseInt(chunkId);
    const chunk2 = chunks[id];
    if (!chunk2) {
      return;
    }
    unwrapTextNodes(root);
    const first = wrapAndGetFirstTextNode(chunk2);
    keepElementInViewWithObserver(first, {
      scrollOptions: {
        behavior: "instant"
      }
    });
  }, [root, size, chunkId, thisPost]);
  return {
    htmlRef: setEl
  };
};

const LANDING_TAG = "_landing";
const BLOCK = /<(p|div|h[1-6])\b[^>]*>([\s\S]*?)<\/\1\s*>/gi;
const MARKER_TEXT = /^<\s*section\s*>[\s\S]*?<\s*\/\s*section\s*>$/i;
const toText = (inner) => inner.replace(/<[^>]*>/g, "").replace(/&nbsp;|&#160;|&#xa0;/gi, " ").replace(/&lt;|&#60;|&#x3c;/gi, "<").replace(/&gt;|&#62;|&#x3e;/gi, ">").replace(/&amp;|&#38;|&#x26;/gi, "&").replace(/\u00a0/g, " ").trim();
const conceal = (block) => `<div hidden style="display:none">${block}</div>`;
const hideLandingMarkers = (html) => html ? html.replace(BLOCK, (block, _tag, inner) => MARKER_TEXT.test(toText(inner)) ? conceal(block) : block) : html;
const hasLandingMarkers = (tags) => !!tags && tags.includes(LANDING_TAG);

const findTitleCached = (content) => {
  if (content.hasOwnProperty("__title")) {
    return content.__title;
  }
  return content.__title = content.find((it) => it.type === "h2") || false;
};
const isTitle = (content, item) => {
  const title = findTitleCached(content);
  if (title) {
    return title === item;
  }
  return item.content && item.content.length && (item.type === "span" || item.type === "h2");
};
const filterTitle = (content) => {
  const index = content.findIndex((item) => {
    if (isTitle(content, item)) {
      return true;
    }
  });
  if (index === -1) {
    return content;
  }
  const copied = [...content];
  copied.splice(index, 1);
  return copied;
};
const videoIndex = (content) => {
  const index = embeddedVideoIndex(content);
  if (index !== -1) {
    return index;
  }
  const yIndex = youTubeIndex(content);
  if (yIndex === -1) {
    return -1;
  }
  return yIndex + 1;
};
const youTubeIndex = (content) => {
  const index = content.findIndex((item) => {
    if (item && item.content && item.content.length && item.content[0] && item.content[0].trim && item.content[0].trim().toLowerCase().startsWith("youtube:")) {
      return true;
    }
  });
  const link = content[index + 1] && content[index + 1].content;
  if (index === -1 || !link || !link[0] || !link[0].props || !link[0].props.data) {
    return -1;
  }
  return index;
};
const embeddedVideoIndex = (content) => {
  let index = -1, title;
  for (index = 0; index < content.length; index++) {
    const item = content[index];
    const type = item.type;
    if ((type === "span" || type === "h2") && !(item.content && item.content.length)) {
      continue;
    }
    if (item.type === "span" && item.content.length === 1 && typeof item.content[0] === "object" && item.content[0].props && item.content[0].props.data) {
      return index;
    }
    if (!title && isTitle(content, item)) {
      title = true;
      continue;
    }
    if (item.type === "Image") {
      continue;
    }
    return -1;
  }
  return -1;
};
const filterEmbeddedVideo = (content) => {
  const index = embeddedVideoIndex(content);
  if (index === -1) {
    return content;
  }
  const copied = [...content];
  copied.splice(index, 1);
  return copied;
};
const filterYouTube = (content) => {
  const index = youTubeIndex(content);
  if (index === -1) {
    return content;
  }
  const copied = [...content];
  copied.splice(index, 2);
  return copied;
};
const filterImage = (content) => {
  const index = content.findIndex((item) => {
    if (item.type === "Image") {
      return true;
    }
  });
  if (index === -1) {
    return content;
  }
  const copied = [...content];
  copied.splice(index, 1);
  return copied;
};
const filterContent = (post) => {
  if (!post) {
    return void 0;
  }
  if (!post.event) {
    return post.content;
  }
  const content = post.content;
  if (!content || !content.length) {
    return content;
  }
  switch (post.type) {
    case "event":
    case "discussion":
      return filterImage(filterYouTube(filterTitle(filterEmbeddedVideo(content))));
    default:
      return filterTitle(content);
  }
};
const ContentCard = forwardRef((props, ref) => {
  const {
    type
  } = props.post;
  if (type === "asset") {
    return /* @__PURE__ */ jsx(PostViewAssetContent, {
      ref
    });
  }
  return /* @__PURE__ */ jsx(ContentCardInner, {
    ref,
    ...props
  });
});
const ContentCardInner = forwardRef(({
  post,
  eventFilters
}, ref) => {
  const {
    content,
    language
  } = post;
  const {
    language: userLanguage
  } = useLanguageSelectionContext();
  const {
    htmlRef
  } = useSelectChunk(post);
  const isNSContent = isNsContent(post && post.content);
  const isFiltered = eventFilters && !isNSContent;
  const requiresTranslation = userLanguage && post.translate && !isFiltered && !postITooBigToTranslate(post);
  const filtered = isFiltered ? filterContent(post) : content;
  const {
    html
  } = useTranslatePost(requiresTranslation, post, userLanguage);
  const translated = requiresTranslation && html && {
    nsHtml: html
  };
  const showWaitTranslation = requiresTranslation && !translated;
  const untouched = translated || filtered;
  if (!untouched || !untouched.nsHtml) {
    return null;
  }
  const data = hasLandingMarkers(post.tags) ? {
    ...untouched,
    nsHtml: hideLandingMarkers(untouched.nsHtml)
  } : untouched;
  return /* @__PURE__ */ jsxs(Card, {
    ref: (node) => {
      htmlRef(node);
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    className: clsx(styles$a.main_article, "relative overflow-y-hidden"),
    children: [showWaitTranslation && /* @__PURE__ */ jsx(TranslationWaiter, {}), /* @__PURE__ */ jsx(Content$3, {
      data,
      dir: "auto"
    })]
  });
});

// THIS FILE IS AUTO GENERATED
function GoCommentDiscussion (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M1.75 1h12.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 14.25 14H8.061l-2.574 2.573A1.458 1.458 0 0 1 3 15.543V14H1.75A1.75 1.75 0 0 1 0 12.25v-9.5C0 1.784.784 1 1.75 1ZM1.5 2.75v9.5c0 .138.112.25.25.25h2a.75.75 0 0 1 .75.75v2.19l2.72-2.72a.749.749 0 0 1 .53-.22h6.5a.25.25 0 0 0 .25-.25v-9.5a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25Z"},"child":[]},{"tag":"path","attr":{"d":"M22.5 8.75a.25.25 0 0 0-.25-.25h-3.5a.75.75 0 0 1 0-1.5h3.5c.966 0 1.75.784 1.75 1.75v9.5A1.75 1.75 0 0 1 22.25 20H21v1.543a1.457 1.457 0 0 1-2.487 1.03L15.939 20H10.75A1.75 1.75 0 0 1 9 18.25v-1.465a.75.75 0 0 1 1.5 0v1.465c0 .138.112.25.25.25h5.5a.75.75 0 0 1 .53.22l2.72 2.72v-2.19a.75.75 0 0 1 .75-.75h2a.25.25 0 0 0 .25-.25v-9.5Z"},"child":[]}]})(props);
}

const isModerator = (profile, post) => {
  const participants = post && post.participants;
  if (!participants || !participants.length || !profile) {
    return false;
  }
  const found = participants.find(({
    _id
  }) => _id === profile._id);
  if (!found) {
    return false;
  }
  return found.role === "moderator";
};
const useIsDiscussionModeratorOrAdmin = () => {
  const {
    post,
    profile,
    membership
  } = usePostInfoContext();
  if (!post || !profile) {
    return false;
  }
  if (post.type !== "discussion") {
    return isAdmin(membership);
  }
  return isModerator(profile, post);
};
const useCanStartNewThread = () => {
  const {
    profile,
    post
  } = usePostInfoContext();
  if (!post) {
    return false;
  }
  if (post.type !== "discussion") {
    return !!profile;
  }
  return isModerator(profile, post);
};

const IconButton$4 = styled(IconButton$5)`
    & .MuiBadge-anchorOriginTopRightRectangle {
        top: -3px;
        right: -13px;
    }
`;
const useUserPostVoteButton = () => {
  const {
    post
  } = usePostContext();
  const ratingFormatted = useRating();
  const [closed, setClosed] = React__default.useState(true);
  const postId = post._id;
  usePostEmitterSubscription(OPEN_VOTE_EVENT, ({
    postId: requestPostId
  }) => {
    if (postId != requestPostId) {
      return;
    }
    setClosed(false);
  }, [postId]);
  if (!ratingFormatted) {
    return {};
  }
  return {
    setClosed,
    open: !closed,
    ratingFormatted,
    votingStarted: true
  };
};
styled.div`
    & .MuiBadge-anchorOriginTopRightRectangle {
        top: -3px;
        right: -13px;
    }

    & button {
        display: inline-flex;
        align-items: center;
        font-size: 1.5rem;
    }
`;
const UserPostVoteButton = () => {
  const {
    post,
    userVote
  } = usePostContext();
  const {
    membership
  } = usePostInfoContext();
  const {
    setClosed,
    open,
    ratingFormatted,
    votingStarted
  } = useUserPostVoteButton();
  if (!post || post.unpublished || !membership) {
    return null;
  }
  if (!votingStarted) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Tooltip$2, {
      title: "Test for consent",
      "aria-label": "Vote",
      children: /* @__PURE__ */ jsx(IconButton$4, {
        "aria-label": "user vote",
        color: "inherit",
        onClick: () => setClosed(false),
        children: /* @__PURE__ */ jsx(Badge$2, {
          badgeContent: ratingFormatted || void 0,
          color: userVote ? "secondary" : "error",
          children: /* @__PURE__ */ jsx(VoteIcon, {
            ...commonIconProps
          })
        })
      })
    }), /* @__PURE__ */ jsx(UsersVoteDialog, {
      open,
      setClosed
    })]
  });
};
const PostVoteButton = () => {
  const {
    isAdmin
  } = useAccessContext();
  if (!isAdmin) {
    return /* @__PURE__ */ jsx(UserPostVoteButton, {});
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Divider$1, {
      orientation: "vertical",
      flexItem: true
    }), /* @__PURE__ */ jsx(UserPostVoteButton, {}), /* @__PURE__ */ jsx(AdminVoteButton, {}), /* @__PURE__ */ jsx(Divider$1, {
      orientation: "vertical",
      flexItem: true
    })]
  });
};

const IconButton$3 = styled(IconButton$5)`
    & .MuiBadge-anchorOriginTopRightRectangle {
        top: -3px;
        right: -13px;
    }
`;
const AdminVoteButton = () => {
  const {
    post,
    profile
  } = usePostInfoContext();
  const {
    isAdmin
  } = useAccessContext();
  const {
    post: response
  } = usePostContext();
  if (post.completed || response.unpublished) {
    return null;
  }
  const [open, setOpen] = React__default.useState(false);
  if (!isAdmin || !isAuthor(response, profile)) {
    return null;
  }
  const handleClose = (open2) => {
    setOpen(!open2);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Tooltip$2, {
      title: "Test for consent (admin)",
      "aria-label": "Vote (admin)",
      children: /* @__PURE__ */ jsx(IconButton$3, {
        "aria-label": "show members",
        color: "inherit",
        onClick: () => handleClose(false),
        children: /* @__PURE__ */ jsx(RiScales3Fill, {
          color: "#4A90CE",
          className: "stroke-0 w-[28px] h-[28px]"
        })
      })
    }), /* @__PURE__ */ jsx(ConfigVoteDialog, {
      open,
      handleClose
    })]
  });
};

const usePostReady = () => {
  const {
    profileError,
    postError,
    postCircleError,
    post,
    circle,
    profile,
    membership
  } = usePostInfoContext();
  if (postCircleError) {
    return {
      error: postCircleError
    };
  }
  if (!circle) {
    return {
      wait: true
    };
  }
  if (profileError) {
    if (profileError.code === 401 || profileError.message === "authentication_required") {
      if (postError) {
        if (postError.code === 403) {
          return {
            registration: true
          };
        }
        return {
          error: postError
        };
      }
      if (!post) {
        return {
          wait: true
        };
      }
      return {
        ok: true
      };
    }
    return {
      error: profileError
    };
  }
  if (!profile) {
    return {
      wait: true
    };
  }
  if (!membership) {
    if (circle.privacy === "PUBLIC") {
      return {
        ok: true
      };
    }
    return {
      access: true
    };
  }
  return {
    ok: true
  };
};

const UserItem$1 = ({
  user
}) => {
  return /* @__PURE__ */ jsx(ListItem, {
    children: /* @__PURE__ */ jsx(Badge$1, {
      user
    })
  });
};
const ParticipantsForRole = ({
  participants,
  role
}) => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(List, {
      subheader: /* @__PURE__ */ jsx(ListSubheader, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "compose.event.roles." + role
        })
      }),
      children: participants.filter((p) => p.role === role).map((user) => {
        return /* @__PURE__ */ jsx(UserItem$1, {
          user
        }, user._id);
      })
    })
  });
};
const useAttendees = () => {
  const context = usePostInfoContext();
  const {
    post,
    membership,
    profile
  } = context;
  return {
    ...context,
    showAttendees: post && profile && post.rsvp && (isAdmin(membership) || profile._id === post.author._id || new EventData(post).endTime > Date.now())
  };
};
const Attendees = ({
  post
}) => {
  return /* @__PURE__ */ jsx(EventAttendees, {
    post
  });
};
const EventParticipantsList = ({
  post
}) => {
  if (!(post && post.participants && post.participants.length)) {
    return null;
  }
  const roles = Object.keys(Object.values(post.participants).reduce((roles2, p) => {
    roles2[p.role] = true;
    return roles2;
  }, {}));
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Divider$1, {}), roles.map((role) => {
      return /* @__PURE__ */ jsx(ParticipantsForRole, {
        role,
        participants: post.participants
      }, role);
    }), /* @__PURE__ */ jsx(Divider$1, {})]
  });
};
const AttendeesPopup = ({
  post
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "attendees-popover" : void 0;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("a", {
      href: "#",
      onClick: handleClick,
      className: "underline",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "event.respondents"
      })
    }), /* @__PURE__ */ jsx(Popover, {
      id,
      open,
      anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      children: open && /* @__PURE__ */ jsx(Attendees, {
        post
      })
    })]
  });
};
const EventParticipantsList2 = () => {
  const {
    post,
    showAttendees
  } = useAttendees();
  const showParticipants = post && post.participants && post.participants.length;
  if (!showParticipants && !showAttendees) {
    return null;
  }
  const roles = !showParticipants ? [] : Object.keys(Object.values(post.participants).reduce((roles2, p) => {
    roles2[p.role] = true;
    return roles2;
  }, {}));
  return /* @__PURE__ */ jsxs("div", {
    className: "text-black",
    children: [/* @__PURE__ */ jsx(Divider$1, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 flex-wrap",
      children: [roles.map((role) => {
        return /* @__PURE__ */ jsx(ParticipantsForRole, {
          role,
          participants: post.participants
        }, role);
      }), /* @__PURE__ */ jsx("div", {
        children: showAttendees && /* @__PURE__ */ jsx("div", {
          style: {
            marginLeft: 16,
            marginTop: 16
          },
          children: /* @__PURE__ */ jsx(AttendeesPopup, {
            post
          })
        })
      })]
    }), /* @__PURE__ */ jsx(Divider$1, {})]
  });
};

const useTinyEditorSetup$1 = () => {
  const [editor, setEditor] = useState();
  const images_upload_handler = null;
  return {
    editor,
    setEditor,
    images_upload_handler,
    setup_callback: null
  };
};

const useThread = () => {
  const {
    responses,
    order
  } = useResponsesDataContext();
  const open = order.filter((id) => !responses[id].completed);
  return responses[open[open.length - 1]];
};
const Assistant = ({
  assistant,
  selected,
  ...other
}) => {
  return /* @__PURE__ */ jsx("div", {
    ...other,
    className: clsx(selected && "outline", "border-0 rounded-full outline-green-500 flex items-center justify-center"),
    children: /* @__PURE__ */ jsx(Avatar, {
      avatar: assistant && assistant.avatar,
      size: 40
    })
  });
};
const EDITOR_MENU = "editor.menu";
const TinyResponseEditor = () => {
  const [selectedAssistant, setSelectedAssistantRaw] = useState(0);
  const thread = useThread();
  const scrollToPost = useScrollToPostFn();
  const [opened, setOpened] = useState(false);
  const {
    order
  } = useResponsesDataContext();
  const elementRef = useRef();
  const {
    post: rootPost,
    loadResponses,
    event$
  } = usePostInfoContext();
  const [postRef, setPostRef] = useState();
  const [edited, setEdited] = useState(false);
  const canStartNewThread = useCanStartNewThread();
  const api = useApi();
  const {
    profile,
    membership,
    circle
  } = usePostInfoContext();
  const setSelectedAssistant = (id) => {
    if (loadingAssistant) {
      return;
    }
    setSelectedAssistantRaw(id);
    onAssistant(id);
  };
  const {
    editor,
    setEditor,
    images_upload_handler
  } = useTinyEditorSetup$1();
  const {
    data: assistantsData,
    mutate
  } = useAssistants(circle && circle._id);
  const [assistants, setAssistants] = useState([]);
  useEffect(() => {
    if (!assistantsData) {
      return;
    }
    const {
      assistants: assistants2
    } = assistantsData;
    setAssistants(assistants2);
  }, [assistantsData]);
  useEffect(() => {
    if (!editor || !edited) {
      return;
    }
    if (edited && !postRef) {
      return;
    }
    const content = postRef.content;
    if (!content.nsHtml) {
      errorToast({
        error: "Can't extract messages in old draft.js format, you you will need to re-enter the complete message manually!"
      });
      editor.setContent("");
      return;
    }
    editor.setContent(content.nsHtml);
  }, [edited, postRef, editor]);
  event$.useSubscription((ev) => {
    switch (ev.type) {
      case REPLY_POST_EVENT:
        setPostRef(ev.post);
        setOpened(true);
        if (editor) {
          editor.focus(false);
        }
        intoView.schedule();
        break;
      case EDIT_POST_EVENT:
        setPostRef(ev.post);
        setEdited(true);
        editor.focus(false);
        intoView.schedule();
        break;
    }
  });
  const clear = () => {
    setPostRef(void 0);
    if (editor) {
      editor.setContent("");
    }
    setEdited(false);
  };
  const cancel = () => {
    if (loading) {
      return;
    }
    clear();
  };
  const intoView = useVisibilityController(elementRef);
  const onVisible = useMemoizedFn(() => {
    if (!editor) {
      return;
    }
    editor.focus(false);
  });
  const VisibilitySensor = useVisibilitySensor(intoView, onVisible);
  const {
    onClick,
    loading
  } = useLoading(async () => {
    await onSend();
  });
  const {
    onClick: onAssistant,
    loading: loadingAssistant
  } = useLoading(async (selectedAssistant2) => {
    const {
      prompt,
      assistant: assistant2
    } = editorsAssistants[selectedAssistant2];
    const content = `<p>question asked by user: ${getPersonName(profile)}</p>, the question:` + editor.getContent();
    const produceContent = prompt.position.includes(".content");
    const {
      post: published,
      content: html
    } = await api.post({
      path: `/ai/add-comment`,
      body: {
        circleId: circle._id,
        root: rootPost && rootPost._id,
        prompt: prompt && prompt.prompt,
        assistant: assistant2._id,
        thread: post._id,
        responseTo: post._id,
        first: post.thread && (post.thread.length > 1 ? post.thread[1] : post._id === rootPost._id ? void 0 : post._id),
        content,
        htmlPrefix: aiAnswerIntro({
          content,
          profile
        }),
        produceContent
      }
    });
    editor.setContent("");
    if (produceContent) {
      editor.setContent(html || "");
      return;
    }
    await loadResponses();
    scrollToPost(published._id);
  });
  if (!rootPost || !profile || rootPost.completed) {
    return null;
  }
  if (!order || !order.length && !opened) {
    return null;
  }
  if (!membership) {
    return null;
  }
  const onSend = async () => {
    const content = editor.getContent();
    if (!post) {
      errorToast({
        error: "No discussion threads was opened!"
      });
      return;
    }
    if (!content.trim()) {
      errorToast({
        error: "Message should not be empty!"
      });
      return;
    }
    const group = post.group;
    const contentUpdate = getContentInfo(content);
    const update = edited ? {
      _id: postRef.draft
    } : {
      attachments: [],
      responseTo: post._id,
      tags: [],
      type: "article",
      group: {
        privacy: group.privacy,
        group: group.group._id
      }
    };
    const draft = await api.upsertDraft({
      content: contentUpdate,
      image: contentUpdate.nsImage,
      ...update
    });
    const published = await api.publish(draft);
    editor.setContent("");
    await loadResponses();
    scrollToPost(published._id);
    clear();
  };
  const post = postRef || thread || (canStartNewThread ? rootPost : void 0);
  const level = post && post.thread.length;
  const colorBlue = level === 0 || level % 2 === 1;
  assistants.find((a) => a.prompts && a.prompts.find((p) => p.position === EDITOR_MENU));
  const editorsAssistants = assistants.filter((assistant2) => assistant2.prompts && assistant2.prompts.length).flatMap((assistant2) => {
    return assistant2.prompts.filter((p) => p.position && p.position.startsWith("editor.")).map((prompt, id) => {
      return {
        assistant: assistant2,
        prompt
      };
    });
  });
  const canAsk = !!editorsAssistants.length;
  return /* @__PURE__ */ jsx(VisibilitySensor, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "w-full flex flex-col",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "w-full flex items-center gap-3 flex-wrap",
        children: [post && order.length > 1 && post.type === "discussion" ? /* @__PURE__ */ jsxs("div", {
          className: "w-full flex items-stretch gap-3 overflow-hidden",
          children: [/* @__PURE__ */ jsx("div", {
            className: clsx("rounded-lg p-3 flex flex-col flex-grow-0 flex-shrink ", colorBlue ? "bg-[#4a90ce26]" : "bg-[#fe975d21]"),
            children: edited && "Edit message:" || level === 1 && /* @__PURE__ */ jsx(FormattedMessage, {
              id: "post.respond2Thread"
            }) || level === 0 && "Start new thread" || "Reply to:"
          }), level !== 0 && /* @__PURE__ */ jsx("div", {
            className: clsx("rounded-lg flex flex-col flex-grow flex-shrink max-h-40 overflow-hidden  p-3", colorBlue ? "bg-[#4a90ce26]" : "bg-[#fe975d21]"),
            children: /* @__PURE__ */ jsx("button", {
              className: "underline",
              onClick: () => {
                scrollToPost(post._id);
              },
              children: post.title
            })
          })]
        }) : null, /* @__PURE__ */ jsxs("div", {
          className: "w-full flex items-center gap-4 flex-wrap",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-1",
            children: [/* @__PURE__ */ jsx(Avatar, {
              avatar: profile && profile.avatar,
              size: 24
            }), /* @__PURE__ */ jsx("div", {
              className: "flex text-2xs font-medium",
              children: getPersonName(profile)
            })]
          }), canAsk && editorsAssistants.map(({
            assistant: assistant2,
            prompt
          }, id) => {
            return /* @__PURE__ */ jsxs("div", {
              className: clsx("flex items-center cursor-pointer"),
              onClick: () => setSelectedAssistant(id),
              children: [loadingAssistant && id === selectedAssistant && /* @__PURE__ */ jsx(CgSpinner, {
                size: 20,
                className: "animate-spin"
              }), /* @__PURE__ */ jsx(Assistant, {
                assistant: assistant2
              }), /* @__PURE__ */ jsx("div", {
                children: prompt.name
              })]
            }, id);
          })]
        })]
      }), /* @__PURE__ */ jsx("div", {
        ref: elementRef,
        children: /* @__PURE__ */ jsx(TinyEditor, {
          free: true,
          content: "",
          setEditor,
          settings: {
            height: 230,
            auto_focus: "none",
            menubar: false,
            images_upload_handler
          }
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-full flex justify-center p-2",
        children: [/* @__PURE__ */ jsx(BigStyledButton, {
          className: "mx-1",
          bg: loading ? "bg-gray-500" : "bg-black",
          fitContent: true,
          onClick: cancel,
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "post.cancel"
          })
        }), /* @__PURE__ */ jsx(BigStyledButton, {
          className: "mx-1",
          fitContent: true,
          icon: loading && (() => /* @__PURE__ */ jsx(CgSpinner, {
            size: 20,
            className: "animate-spin"
          })),
          onClick,
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "post.publish"
          })
        })]
      })]
    })
  });
};

const PeopleIcon = ({
  size,
  ...props
}) => {
  return /* @__PURE__ */ jsx("svg", {
    width: size,
    height: size,
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M46.9999 30.1911C46.9999 27.4409 46.1763 24.7853 44.618 22.5114C43.4971 20.8758 42.0537 19.5176 40.3811 18.5083C42.3504 16.6434 43.5825 14.0075 43.5825 11.0875C43.5825 5.44928 38.9954 0.862122 33.3573 0.862122C30.014 0.862122 26.8822 2.51559 24.9799 5.22985C24.4965 5.15944 24.0026 5.12146 23.4999 5.12146C22.9972 5.12146 22.5035 5.15957 22.0201 5.22985C20.1177 2.51559 16.9859 0.862122 13.6427 0.862122C8.0045 0.862122 3.41734 5.44928 3.41734 11.0875C3.41734 14.0075 4.64949 16.6434 6.61891 18.5083C4.94614 19.5175 3.50276 20.8758 2.38203 22.5112C0.823705 24.7853 0 27.4409 0 30.1911V35.8787H9.85733V40.1379H37.1428V35.8787H47V30.1911H46.9999ZM33.3573 3.38585C37.604 3.38585 41.0589 6.84079 41.0589 11.0876C41.0589 15.3345 37.604 18.7894 33.3573 18.7894C33.2812 18.7894 33.2051 18.7883 33.1289 18.786C33.1347 18.7699 33.1395 18.7533 33.1452 18.7372C33.2766 18.3645 33.3863 17.9816 33.4742 17.5906C33.4804 17.5628 33.4875 17.5353 33.4934 17.5074C33.5163 17.402 33.5363 17.2955 33.5559 17.1887C33.5651 17.1382 33.5746 17.0879 33.583 17.0373C33.5989 16.942 33.6133 16.8464 33.6265 16.7504C33.6357 16.6836 33.6441 16.6169 33.652 16.55C33.662 16.4652 33.6717 16.3803 33.6797 16.2948C33.6877 16.2077 33.6938 16.1203 33.6996 16.0329C33.7041 15.964 33.7098 15.8954 33.713 15.8261C33.7199 15.6776 33.7238 15.5288 33.7243 15.3799C33.7243 15.3689 33.7252 15.3582 33.7252 15.3471C33.7252 15.3412 33.7247 15.3352 33.7247 15.3293C33.7244 15.1773 33.72 15.0261 33.7132 14.8754C33.7112 14.8317 33.7086 14.788 33.706 14.7443C33.6986 14.6163 33.6889 14.4888 33.6769 14.362C33.6741 14.3333 33.6718 14.3045 33.6689 14.2758C33.2876 10.5902 30.9592 7.43561 27.6003 5.97646C29.0477 4.35037 31.1413 3.38585 33.3573 3.38585ZM20.8351 8.12039C20.8597 8.11143 20.8846 8.10298 20.9092 8.09414C20.9858 8.06676 21.063 8.04077 21.1406 8.01566C21.1994 7.99686 21.2586 7.97869 21.3182 7.96128C21.3614 7.94853 21.4048 7.93629 21.4484 7.92418C21.5261 7.90285 21.6042 7.88203 21.6831 7.86298C22.266 7.72141 22.874 7.64456 23.4997 7.64456C24.1259 7.64507 24.7341 7.72204 25.3172 7.86361C25.3955 7.88254 25.4731 7.90323 25.5505 7.92443C25.5947 7.93667 25.6388 7.94904 25.6826 7.96203C25.7414 7.97932 25.8 7.99724 25.8581 8.01579C25.9367 8.04115 26.0148 8.06739 26.0923 8.09515C26.1162 8.10361 26.14 8.11168 26.1637 8.12039C28.7394 9.07292 30.6706 11.3652 31.1077 14.1471C31.1111 14.1693 31.1144 14.1917 31.1177 14.214C31.1317 14.3083 31.1434 14.4033 31.1539 14.4985C31.1577 14.5336 31.1617 14.5686 31.1651 14.6038C31.1735 14.6907 31.1796 14.7783 31.1852 14.8661C31.1875 14.9037 31.1906 14.9412 31.1924 14.9789C31.1977 15.0911 31.2006 15.2039 31.201 15.3173C31.201 15.3272 31.2016 15.3368 31.2016 15.3466C31.2016 15.3511 31.2014 15.3558 31.2014 15.3604C31.2011 15.4701 31.1978 15.5792 31.193 15.6878C31.1915 15.722 31.19 15.7562 31.188 15.7903C31.182 15.8952 31.1742 15.9997 31.1641 16.1034C31.1602 16.1436 31.1549 16.1836 31.1504 16.2236C31.1427 16.2907 31.1341 16.3577 31.1248 16.4243C31.1174 16.4762 31.1101 16.5282 31.1018 16.5798C31.0891 16.6584 31.0749 16.7365 31.0598 16.8143C31.0463 16.8836 31.0315 16.9526 31.0161 17.0215C31.0069 17.063 30.9973 17.1045 30.9873 17.1458C30.9627 17.2481 30.9357 17.3498 30.907 17.4512C30.8955 17.4914 30.8848 17.5319 30.8727 17.5718C30.8551 17.6298 30.8362 17.6874 30.8174 17.7449C30.8022 17.791 30.7867 17.8368 30.7707 17.8825C30.7525 17.9343 30.7346 17.9863 30.7154 18.0378C30.6828 18.1252 30.6484 18.2119 30.6127 18.2978C30.5968 18.3362 30.5799 18.3742 30.5634 18.4124C30.5322 18.484 30.5002 18.5551 30.4669 18.6255C30.4629 18.6339 30.459 18.6422 30.4551 18.6505C30.4431 18.6755 30.4313 18.7006 30.419 18.7256C30.3817 18.8018 30.3428 18.8771 30.3029 18.9518C30.2874 18.9809 30.2724 19.0103 30.2565 19.0391C30.2555 19.041 30.2545 19.0428 30.2535 19.0446C30.2098 19.1241 30.1643 19.2023 30.118 19.28C30.0995 19.3108 30.0814 19.3417 30.0626 19.3721C30.0121 19.454 29.9602 19.535 29.9069 19.6148C29.8737 19.6644 29.839 19.7129 29.8047 19.7618C29.7755 19.8032 29.7465 19.8447 29.7166 19.8854C29.6779 19.9382 29.6384 19.9903 29.5982 20.0422C29.571 20.0774 29.5435 20.1123 29.5157 20.1471C29.4733 20.2001 29.4305 20.2529 29.3869 20.3047C29.3597 20.3369 29.3319 20.3685 29.3042 20.4001C29.2588 20.4522 29.2135 20.5045 29.1668 20.5553C29.1391 20.5855 29.1103 20.6145 29.082 20.6443C29.0061 20.7244 28.9283 20.8028 28.8491 20.8796C28.802 20.9252 28.7552 20.9708 28.707 21.0151C28.6737 21.0458 28.6395 21.0756 28.6056 21.1057C28.5503 21.1548 28.4947 21.2034 28.438 21.2508C28.4092 21.2749 28.3802 21.2988 28.3511 21.3225C28.2825 21.3783 28.2132 21.4329 28.1426 21.4864C28.1234 21.5009 28.1045 21.5157 28.0852 21.5301C26.8032 22.4831 25.2164 23.048 23.4998 23.048C21.7831 23.048 20.196 22.483 18.914 21.5297C18.8951 21.5156 18.8766 21.501 18.8578 21.4868C18.787 21.4332 18.7172 21.3781 18.6484 21.3221C18.6195 21.2985 18.5906 21.2749 18.5621 21.251C18.5052 21.2033 18.4494 21.1544 18.3939 21.1052C18.3602 21.0752 18.3262 21.0457 18.293 21.0151C18.2447 20.9707 18.1977 20.9249 18.1505 20.8794C18.0709 20.8023 17.9931 20.7237 17.9168 20.6433C17.889 20.6139 17.8604 20.5852 17.8331 20.5555C17.7862 20.5045 17.7409 20.4521 17.6955 20.4C17.6679 20.3683 17.6401 20.3369 17.613 20.3047C17.5692 20.2529 17.5266 20.2001 17.4842 20.1473C17.4564 20.1124 17.4288 20.0775 17.4015 20.0422C17.3615 19.9904 17.322 19.9383 17.2833 19.8856C17.2534 19.8447 17.2242 19.803 17.1951 19.7615C17.1608 19.7128 17.1262 19.6644 17.0931 19.6149C17.0395 19.5348 16.9874 19.4535 16.9368 19.3714C16.9182 19.3412 16.9003 19.3108 16.8822 19.2804C16.8351 19.2015 16.789 19.1223 16.7448 19.0417C16.7285 19.012 16.7131 18.9819 16.6971 18.9521C16.6572 18.8771 16.6182 18.8015 16.5807 18.7252C16.5673 18.6981 16.5543 18.6707 16.5413 18.6434C16.5393 18.6393 16.5374 18.6351 16.5355 18.631C16.5006 18.5573 16.4672 18.4828 16.4345 18.4077C16.419 18.372 16.4032 18.3364 16.3883 18.3006C16.3517 18.2128 16.3167 18.1242 16.2833 18.0349C16.2653 17.9867 16.2486 17.938 16.2316 17.8894C16.214 17.8396 16.1971 17.7893 16.1806 17.739C16.1628 17.6845 16.1449 17.63 16.1282 17.5752C16.1034 17.4933 16.0799 17.4109 16.0578 17.328C16.0423 17.2698 16.0283 17.2112 16.014 17.1526C16.0029 17.1066 15.9922 17.0605 15.982 17.0142C15.9694 16.9574 15.9566 16.9008 15.9453 16.8437C15.9277 16.7549 15.9117 16.6656 15.8973 16.5757C15.8895 16.5273 15.8827 16.4787 15.8757 16.4302C15.8655 16.3584 15.8563 16.2863 15.8481 16.2138C15.8441 16.1781 15.8394 16.1424 15.8357 16.1067C15.8253 16.0003 15.8173 15.8932 15.8113 15.7857C15.8095 15.7548 15.8081 15.7239 15.8067 15.693C15.8016 15.578 15.7979 15.4627 15.7979 15.3466C15.7979 15.2222 15.8014 15.0987 15.8074 14.9756C15.809 14.9422 15.8118 14.909 15.8137 14.8757C15.8192 14.7833 15.8259 14.6912 15.8347 14.5996C15.8378 14.5677 15.8414 14.5359 15.8448 14.5041C15.8557 14.4049 15.8679 14.3063 15.8826 14.2082C15.8853 14.1892 15.8881 14.17 15.8911 14.1509C16.3268 11.3674 18.2584 9.07355 20.8351 8.12039ZM5.94095 11.0876C5.94095 6.84092 9.39589 3.38585 13.6427 3.38585C15.8588 3.38585 17.9523 4.3505 19.3997 5.97621C16.0397 7.43586 13.7107 10.592 13.3306 14.2791C13.3279 14.3041 13.326 14.3292 13.3236 14.3543C13.311 14.4857 13.301 14.6175 13.2935 14.7502C13.2912 14.7905 13.2887 14.8308 13.2868 14.8713C13.2796 15.0291 13.2747 15.1875 13.2747 15.347C13.2747 15.508 13.2793 15.6686 13.2869 15.8291C13.2899 15.8937 13.2952 15.9577 13.2994 16.0219C13.3056 16.1143 13.3119 16.2067 13.3205 16.2988C13.328 16.3807 13.3374 16.462 13.347 16.5434C13.3553 16.6143 13.3641 16.685 13.374 16.7557C13.3868 16.8484 13.4007 16.9408 13.416 17.0328C13.4252 17.0874 13.4353 17.1419 13.4453 17.1964C13.4642 17.2994 13.4835 17.4021 13.5055 17.5039C13.5128 17.5375 13.5211 17.5708 13.5287 17.6042C13.6143 17.9831 13.7207 18.3541 13.8474 18.7159C13.8555 18.7392 13.8625 18.7628 13.8707 18.786C13.7947 18.7883 13.7184 18.7894 13.6425 18.7894C9.39589 18.7893 5.94095 15.3344 5.94095 11.0876ZM11.973 27.1758C11.9452 27.2195 11.9187 27.2641 11.8915 27.3081C11.8338 27.4012 11.7767 27.4946 11.7214 27.5889C11.6905 27.6415 11.6607 27.6945 11.6307 27.7475C11.581 27.8349 11.5319 27.9226 11.4842 28.0111C11.4541 28.0667 11.4246 28.1226 11.3953 28.1785C11.3494 28.2665 11.3046 28.3549 11.2607 28.4436C11.2331 28.4994 11.2056 28.555 11.1788 28.6111C11.1341 28.7046 11.0911 28.7988 11.0486 28.8932C11.0255 28.9445 11.0018 28.9955 10.9794 29.0471C10.9302 29.1602 10.8833 29.2741 10.8372 29.3884C10.8237 29.4219 10.8094 29.4549 10.7962 29.4884C10.7378 29.6369 10.6819 29.7864 10.6289 29.9367C10.6168 29.9711 10.606 30.006 10.594 30.0404C10.5541 30.1563 10.5152 30.2725 10.4785 30.3892C10.4617 30.4428 10.4462 30.4967 10.4301 30.5504C10.4004 30.6494 10.3713 30.7484 10.3439 30.8481C10.3276 30.9074 10.3121 30.9668 10.2966 31.0264C10.2716 31.122 10.2476 31.2179 10.2249 31.3142C10.2104 31.3752 10.1962 31.4361 10.1827 31.4972C10.161 31.5947 10.1407 31.6926 10.1212 31.7907C10.1094 31.8496 10.0973 31.9085 10.0863 31.9677C10.0665 32.0744 10.0487 32.1817 10.0315 32.2891C10.0234 32.3396 10.0144 32.3898 10.0069 32.4402C9.98338 32.598 9.96206 32.7561 9.94414 32.9149C9.94389 32.9168 9.94376 32.9187 9.94364 32.9206C9.92736 33.0651 9.91335 33.2098 9.90162 33.3551H2.52361V30.1911C2.52361 25.8684 5.0086 21.9877 8.90176 20.1432C10.32 20.8887 11.9322 21.313 13.6426 21.313C14.1372 21.313 14.6334 21.2764 15.1257 21.204C15.2025 21.3134 15.2804 21.4217 15.3612 21.5279C15.3884 21.5636 15.4167 21.5985 15.4445 21.6338C15.5242 21.7357 15.6051 21.8366 15.6886 21.9354C15.7228 21.9759 15.7579 22.0155 15.7927 22.0555C15.871 22.1453 15.9504 22.234 16.0317 22.321C16.0744 22.3668 16.1178 22.4118 16.1612 22.4569C16.2355 22.5335 16.3108 22.6089 16.3874 22.6832C16.4162 22.7111 16.4433 22.7406 16.4723 22.7683C16.3627 22.8345 16.254 22.9024 16.1464 22.9717C16.1289 22.9829 16.1117 22.9948 16.0943 23.0061C15.9867 23.076 15.8802 23.1474 15.7747 23.2203C15.7382 23.2455 15.7019 23.271 15.6655 23.2965C15.5715 23.3627 15.4785 23.4301 15.3863 23.4986C15.3571 23.5203 15.3276 23.5415 15.2987 23.5635C15.1814 23.6522 15.0654 23.7425 14.951 23.8349C14.926 23.8551 14.9015 23.8759 14.8765 23.8963C14.7854 23.9709 14.6952 24.0467 14.6061 24.1237C14.5715 24.1535 14.5372 24.1835 14.5029 24.2137C14.4137 24.2923 14.3256 24.372 14.2384 24.4529C14.2157 24.474 14.1925 24.4947 14.1699 24.516C14.0629 24.6167 13.9576 24.7193 13.8537 24.8236C13.8267 24.8508 13.8003 24.8784 13.7736 24.9056C13.6941 24.9868 13.6155 25.0688 13.5379 25.1519C13.5071 25.185 13.4763 25.2181 13.4458 25.2515C13.3585 25.3469 13.2724 25.4436 13.1877 25.5416C13.1745 25.557 13.1607 25.5719 13.1475 25.5874C13.051 25.7001 12.9566 25.8149 12.8634 25.9309C12.8375 25.9632 12.8121 25.996 12.7865 26.0286C12.7164 26.1176 12.6474 26.2074 12.5795 26.2982C12.5533 26.3332 12.5269 26.3681 12.5011 26.4034C12.4122 26.5245 12.3245 26.6467 12.2394 26.771C12.1479 26.9045 12.0593 27.0396 11.973 27.1758ZM12.3809 37.6144V35.8788V34.4504C12.3809 34.3104 12.3836 34.1708 12.3888 34.0316C12.3904 33.9858 12.3941 33.9404 12.3963 33.8947C12.4009 33.8019 12.4052 33.7089 12.412 33.6164C12.4161 33.5602 12.4224 33.5046 12.4275 33.4486C12.4348 33.367 12.4414 33.2854 12.4505 33.2044C12.4571 33.1451 12.4659 33.0862 12.4734 33.027C12.4833 32.9499 12.4925 32.8727 12.5038 32.7959C12.513 32.7349 12.5241 32.6743 12.5342 32.6135C12.5466 32.5396 12.5581 32.4654 12.572 32.3918C12.5837 32.3296 12.5973 32.268 12.6101 32.2061C12.6247 32.1346 12.6387 32.063 12.6547 31.9921C12.6689 31.9295 12.685 31.8675 12.7002 31.8052C12.7172 31.7358 12.7335 31.666 12.7518 31.597C12.7684 31.5343 12.7869 31.4722 12.8045 31.41C12.8237 31.3422 12.8424 31.2743 12.8628 31.2071C12.8819 31.1445 12.9028 31.0824 12.9229 31.0202C12.9443 30.9542 12.9651 30.8881 12.9877 30.8226C13.0092 30.7607 13.0323 30.6992 13.0547 30.6378C13.0785 30.5729 13.1017 30.5078 13.1265 30.4434C13.1503 30.3822 13.1755 30.3218 13.2001 30.261C13.226 30.1975 13.2515 30.1337 13.2785 30.0707C13.3046 30.01 13.3321 29.95 13.3592 29.8899C13.3871 29.8279 13.4147 29.7657 13.4437 29.7044C13.4721 29.6445 13.5019 29.5853 13.5313 29.5259C13.5613 29.4653 13.591 29.4046 13.622 29.3447C13.6527 29.2856 13.6846 29.2273 13.7163 29.1689C13.7483 29.1097 13.78 29.0505 13.8131 28.992C13.8459 28.934 13.88 28.8768 13.9136 28.8194C13.9477 28.7616 13.9815 28.7037 14.0167 28.6464C14.0517 28.5895 14.0878 28.5335 14.1237 28.4772C14.1598 28.4208 14.1957 28.3644 14.2328 28.3086C14.2699 28.2528 14.308 28.1978 14.3461 28.1428C14.384 28.0879 14.4219 28.033 14.4608 27.9788C14.4999 27.9243 14.5401 27.8705 14.5804 27.8166C14.6203 27.7632 14.66 27.7099 14.7008 27.6573C14.7419 27.6041 14.784 27.5518 14.8262 27.4993C14.8679 27.4473 14.9098 27.3954 14.9525 27.3442C14.9955 27.2927 15.0394 27.2419 15.0833 27.1911C15.1271 27.1405 15.171 27.09 15.2158 27.04C15.2606 26.99 15.3064 26.9408 15.3521 26.8916C15.3978 26.8425 15.4435 26.7937 15.49 26.7455C15.5367 26.697 15.5843 26.6493 15.632 26.6018C15.6795 26.5542 15.7274 26.5069 15.7758 26.4601C15.8241 26.4135 15.8732 26.3676 15.9226 26.3218C15.972 26.2758 16.0217 26.23 16.0721 26.1849C16.1223 26.1399 16.173 26.0956 16.2241 26.0516C16.2754 26.0073 16.327 25.9633 16.3791 25.9199C16.4309 25.8767 16.4833 25.8342 16.536 25.7919C16.5892 25.7493 16.6427 25.707 16.6967 25.6652C16.7501 25.6241 16.8039 25.5835 16.8581 25.5431C16.9131 25.5021 16.9685 25.4616 17.0245 25.4216C17.0793 25.3824 17.1345 25.3437 17.1902 25.3054C17.2472 25.2661 17.3045 25.2274 17.3623 25.1892C17.4184 25.1521 17.4751 25.1154 17.532 25.0791C17.5909 25.0417 17.6502 25.0047 17.7099 24.9684C17.7674 24.9333 17.8254 24.8986 17.8837 24.8645C17.9442 24.8291 18.0053 24.7941 18.0667 24.7597C18.1257 24.7266 18.185 24.6939 18.2447 24.6619C18.3071 24.6283 18.3701 24.5954 18.4334 24.5628C18.4935 24.5319 18.5538 24.5015 18.6146 24.4716C18.6624 24.4481 18.7108 24.4254 18.7591 24.4026C20.1772 25.148 21.7897 25.5723 23.4999 25.5723C25.2103 25.5723 26.8226 25.148 28.2408 24.4026C28.2887 24.4253 28.3367 24.4479 28.3841 24.4711C28.4457 24.5014 28.5066 24.5322 28.5675 24.5633C28.63 24.5955 28.6924 24.628 28.7542 24.6612C28.8145 24.6937 28.8745 24.7267 28.934 24.7602C28.9947 24.7942 29.055 24.8287 29.1148 24.8638C29.174 24.8983 29.2327 24.9335 29.291 24.9691C29.3499 25.0051 29.4083 25.0414 29.4664 25.0784C29.5242 25.1151 29.5814 25.1522 29.6384 25.1899C29.6955 25.2277 29.7522 25.266 29.8084 25.3048C29.8646 25.3435 29.9205 25.3825 29.9759 25.4221C30.0313 25.4617 30.086 25.5018 30.1406 25.5425C30.1953 25.5831 30.2497 25.6241 30.3036 25.6658C30.3571 25.7071 30.4101 25.749 30.4628 25.7913C30.5158 25.8338 30.5686 25.8766 30.6208 25.92C30.6727 25.9632 30.7239 26.0069 30.7749 26.051C30.8262 26.0953 30.8773 26.1398 30.9278 26.1851C30.9778 26.2299 31.0271 26.2753 31.0762 26.3209C31.1259 26.3671 31.1755 26.4135 31.2243 26.4606C31.2724 26.5069 31.3197 26.5538 31.3668 26.6009C31.4147 26.6488 31.4627 26.6969 31.5097 26.7456C31.5559 26.7936 31.6015 26.842 31.6468 26.8907C31.6929 26.9403 31.739 26.99 31.7842 27.0404C31.8286 27.0898 31.8721 27.1399 31.9155 27.1901C31.9598 27.2412 32.0041 27.2925 32.0474 27.3445C32.0899 27.3953 32.1314 27.4469 32.1729 27.4985C32.2153 27.5513 32.2577 27.6039 32.2991 27.6574C32.3397 27.7097 32.3792 27.7629 32.4189 27.816C32.4592 27.87 32.4996 27.9241 32.539 27.9789C32.5777 28.0328 32.6155 28.0875 32.6532 28.1422C32.6914 28.1974 32.7298 28.2527 32.767 28.3087C32.8038 28.3641 32.8394 28.4201 32.8753 28.4762C32.9115 28.5328 32.9478 28.5893 32.983 28.6466C33.0178 28.7033 33.0514 28.7608 33.0852 28.8181C33.1193 28.8759 33.1536 28.9336 33.1865 28.992C33.2195 29.0503 33.251 29.1093 33.2829 29.1681C33.3147 29.2268 33.3468 29.2854 33.3775 29.3445C33.4085 29.4043 33.438 29.465 33.4681 29.5255C33.4975 29.5849 33.5274 29.6442 33.5557 29.7043C33.5848 29.7656 33.6123 29.8276 33.64 29.8894C33.6673 29.9498 33.6949 30.0099 33.721 30.0708C33.7479 30.1333 33.773 30.1965 33.7988 30.2596C33.8238 30.3209 33.8492 30.382 33.8731 30.4438C33.8978 30.5078 33.9209 30.5725 33.9445 30.6371C33.9671 30.6988 33.9902 30.7603 34.0116 30.8225C34.0344 30.8882 34.0553 30.9547 34.0767 31.021C34.0968 31.0829 34.1176 31.1446 34.1366 31.2071C34.1571 31.2743 34.1757 31.3424 34.195 31.4101C34.2126 31.4723 34.2311 31.5343 34.2477 31.597C34.266 31.666 34.2823 31.7357 34.2993 31.8052C34.3146 31.8674 34.3306 31.9295 34.3448 31.9921C34.3608 32.063 34.3747 32.1345 34.3894 32.2058C34.4022 32.2678 34.4158 32.3295 34.4275 32.3918C34.4413 32.4647 34.4526 32.5383 34.465 32.6117C34.4752 32.6732 34.4866 32.7342 34.4958 32.7961C34.5071 32.8722 34.5162 32.9489 34.5261 33.0253C34.5338 33.085 34.5426 33.1443 34.5493 33.2043C34.5584 33.2853 34.5649 33.3669 34.5723 33.4484C34.5773 33.5044 34.5836 33.5601 34.5878 33.6162C34.5947 33.7087 34.5989 33.8019 34.6034 33.8949C34.6057 33.9404 34.6094 33.9858 34.611 34.0315C34.6162 34.1707 34.6188 34.3102 34.6188 34.4503V35.8785V37.6144H12.3809ZM37.0989 33.3551C37.0742 33.0477 37.0386 32.7422 36.9934 32.4386C36.9862 32.3905 36.9776 32.3428 36.9699 32.2949C36.9524 32.185 36.9341 32.0753 36.9138 31.9661C36.9031 31.9085 36.8913 31.8512 36.8798 31.7938C36.86 31.694 36.8393 31.5945 36.8173 31.4953C36.8039 31.4355 36.79 31.3757 36.7759 31.3161C36.7528 31.2187 36.7285 31.1217 36.7033 31.0249C36.688 30.9662 36.6728 30.9077 36.6566 30.8491C36.629 30.7484 36.5995 30.6482 36.5694 30.5482C36.5535 30.4954 36.5384 30.4426 36.5219 30.3899C36.4846 30.2715 36.4453 30.1536 36.4048 30.036C36.3934 30.0032 36.3831 29.97 36.3715 29.9372C36.3182 29.7864 36.2623 29.6365 36.2036 29.4875C36.191 29.4556 36.1773 29.424 36.1644 29.3921C36.1178 29.2764 36.0701 29.1609 36.0203 29.0464C35.9982 28.9955 35.9749 28.9453 35.9522 28.8947C35.9093 28.7993 35.8659 28.7043 35.8207 28.6099C35.7943 28.5547 35.7671 28.4998 35.7399 28.4449C35.6956 28.3553 35.6503 28.2661 35.604 28.1774C35.575 28.1219 35.5459 28.0666 35.5161 28.0114C35.4681 27.9227 35.4189 27.8347 35.369 27.7468C35.3389 27.6941 35.3093 27.6414 35.2786 27.589C35.2231 27.4942 35.1657 27.4005 35.1076 27.3069C35.0806 27.2632 35.0544 27.2192 35.0269 27.1759C34.9404 27.0397 34.8519 26.9046 34.7603 26.771C34.675 26.6466 34.5873 26.5244 34.4984 26.4033C34.4727 26.3682 34.4465 26.3335 34.4205 26.2987C34.3522 26.2074 34.2829 26.1174 34.2126 26.028C34.1873 25.9958 34.1622 25.9633 34.1364 25.9314C34.0432 25.815 33.9484 25.6999 33.8516 25.587C33.839 25.5724 33.826 25.5581 33.8134 25.5435C33.7281 25.4447 33.6413 25.3473 33.5533 25.2511C33.5231 25.2181 33.4927 25.1854 33.4621 25.1526C33.3841 25.0689 33.305 24.9863 33.225 24.9048C33.1987 24.8779 33.1728 24.8508 33.1462 24.8241C33.0421 24.7197 32.9363 24.6167 32.8291 24.5157C32.807 24.4949 32.7843 24.4747 32.7621 24.454C32.6744 24.3727 32.5858 24.2925 32.4962 24.2135C32.4621 24.1835 32.4278 24.1537 32.3935 24.124C32.3042 24.0469 32.2139 23.971 32.1227 23.8963C32.0979 23.876 32.0735 23.8552 32.0485 23.835C31.9342 23.7426 31.8182 23.6523 31.701 23.5637C31.6717 23.5416 31.642 23.5202 31.6126 23.4984C31.5207 23.4302 31.4282 23.3631 31.3346 23.2972C31.2979 23.2714 31.2612 23.2456 31.2243 23.2201C31.1198 23.1481 31.0145 23.0774 30.908 23.0083C30.8893 22.9962 30.871 22.9835 30.8523 22.9716C30.7448 22.9025 30.6366 22.8348 30.527 22.7687C30.5553 22.7418 30.5818 22.7131 30.6097 22.6859C30.6879 22.6102 30.7648 22.5332 30.8405 22.455C30.8827 22.4113 30.9248 22.3675 30.9662 22.3231C31.0488 22.2348 31.1293 22.1447 31.2088 22.0535C31.2426 22.0147 31.2766 21.9762 31.3097 21.9369C31.3944 21.8367 31.4767 21.7344 31.5576 21.6308C31.5841 21.5969 31.6112 21.5636 31.6372 21.5294C31.7183 21.4228 31.7967 21.314 31.8738 21.2043C32.3661 21.2766 32.8623 21.3132 33.3569 21.3132C35.0673 21.3132 36.6796 20.8889 38.0977 20.1433C41.991 21.9879 44.4759 25.8685 44.4759 30.1912V33.3551H37.0989Z",
      fill: "#4A90CE"
    })
  });
};

const UsersOnlineButton = () => {
  const {
    profile: user
  } = useProfileContext();
  const {
    users
  } = usePostVisitorContext();
  const [open, setOpen] = useState(false);
  const handleClose = (open2) => {
    if (!user) {
      errorToast({
        error: "You must be registered, to see users online!"
      });
      return;
    }
    setOpen(!open2);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Tooltip$2, {
      title: "Online Post Readers",
      children: /* @__PURE__ */ jsx(Badge$2, {
        badgeContent: users.length || 1,
        color: "secondary",
        children: /* @__PURE__ */ jsx(StyledButton, {
          className: "group relative",
          onClick: () => handleClose(false),
          icon: PeopleIcon
        })
      })
    }), /* @__PURE__ */ jsx(PostOnlineUsersDialog, {
      open,
      handleClose,
      user
    })]
  });
};

const UnpublishedPost = () => {
  return /* @__PURE__ */ jsx("div", {
    className: "p-2 rounded-lg bg-red-500 text-white",
    children: "Post was unpublished"
  });
};

const EventLabel = ({
  eventData
}) => {
  const {
    label,
    url,
    label2,
    url2
  } = eventData;
  if (!label) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 grow",
    children: [/* @__PURE__ */ jsx("div", {
      dir: "auto",
      className: clsx("bg-[#2698CC] p-2 rounded-lg", label2 && "w-1/2", !label2 && "grow"),
      children: /* @__PURE__ */ jsx("a", {
        href: url || "#",
        target: "_blank",
        children: label
      })
    }), label2 && /* @__PURE__ */ jsx("div", {
      className: clsx("bg-[#2698CC] p-2 rounded-lg", label2 && "w-1/2"),
      dir: "auto",
      children: /* @__PURE__ */ jsx("a", {
        href: url2 || "#",
        target: "_blank",
        children: label2
      })
    })]
  });
};
const EventPanel = () => {
  const {
    dialog
  } = usePostUIContext();
  const {
    post,
    circle
  } = usePostInfoContext();
  const api = useApi();
  const {
    order
  } = useResponsesDataContext();
  const [title, setTitleState] = useState(post && post.title);
  const setTitle = (v) => {
    if (v === title) {
      return;
    }
    setTitleState(v);
  };
  useEffect(() => {
    setTitle(post && post.title);
  }, [post && post.title]);
  if (!post || post.type !== "event") {
    return null;
  }
  if (post.unpublished) {
    return /* @__PURE__ */ jsx(UnpublishedPost, {
      post
    });
  }
  const event = new EventData(post);
  const eventData = post.event || {};
  const {
    address,
    sponsor,
    sponsorId
  } = eventData;
  const onSponsor = async () => {
    const post2 = await api.loadPostById({
      _id: sponsorId
    });
    window.location.href = url4post(post2);
  };
  const {
    image: postImage
  } = post;
  const {
    image: circleImage
  } = circle || {};
  const image = postImage || circleImage;
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col text-white gap-2 items-stretch",
      children: [/* @__PURE__ */ jsx("div", {
        className: "bg-[#00A5B6] p-2 rounded-lg font-semibold",
        dir: "auto",
        children: title
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-stretch gap-2",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "bg-[#a76f00] p-2 rounded-lg ",
          children: [/* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.start"
          }), ":\xA0", /* @__PURE__ */ jsx(FormattedDate, {
            value: event.localStartTime,
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "bg-[#a76f00] p-2 rounded-lg",
          children: [/* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.end"
          }), ":\xA0", /* @__PURE__ */ jsx(FormattedDate, {
            value: event.localEndTime,
            year: "numeric",
            month: "long",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
          })]
        })]
      }), address && /* @__PURE__ */ jsxs("div", {
        className: "bg-[#453202] p-2 rounded-lg",
        children: [/* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.address"
        }), ": ", /* @__PURE__ */ jsx("a", {
          href: getMapZoomToPostUrl(circle, post),
          target: "_blank",
          className: "underline",
          children: address
        })]
      }), sponsor && /* @__PURE__ */ jsxs("div", {
        className: "bg-[#453202] p-2 rounded-lg",
        children: [/* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.organizer"
        }), ": ", /* @__PURE__ */ jsx("span", {
          className: "underline cursor-pointer",
          onClick: onSponsor,
          children: sponsor
        })]
      }), /* @__PURE__ */ jsx(EventLabel, {
        eventData
      }), /* @__PURE__ */ jsx(EventImage2, {
        image
      }), /* @__PURE__ */ jsx(PostContent, {
        setTitle
      }), /* @__PURE__ */ jsx(Tags$1, {
        tags: post.tags,
        tagClassName: "text-2xs",
        chipInner: Div$1,
        className: "text-black",
        limit: 3
      }), /* @__PURE__ */ jsx(EventParticipantsList2, {}), /* @__PURE__ */ jsx(Going, {
        image: /* @__PURE__ */ jsx(FaRegCalendarCheck, {})
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col text-black gap-2 items-stretch p-0 m-0",
        children: [!dialog && /* @__PURE__ */ jsx(StartNewDiscussionThreadButton, {}), order && order.length ? /* @__PURE__ */ jsx("div", {
          className: "flex w-full bg-[#fe975d2b]",
          children: /* @__PURE__ */ jsxs("div", {
            className: "flex ml-auto mx-2 gap-4 items-center",
            children: [/* @__PURE__ */ jsx(UsersOnlineButton, {}), /* @__PURE__ */ jsx(ColumnButton, {}), /* @__PURE__ */ jsx(SortResponsesButton, {})]
          })
        }) : null, /* @__PURE__ */ jsx(AllResponses, {}), !dialog && /* @__PURE__ */ jsx(TinyResponseEditor, {}), dialog && /* @__PURE__ */ jsx(OpenFullPostViewLink, {})]
      }), /* @__PURE__ */ jsx(PostFooter, {})]
    })
  });
};
const MAX_WIDTH = 400;
const EventImage2 = ({
  image
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "image-popover" : void 0;
  const {
    baseUrl
  } = useCDNImageContext();
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const updateWidth = () => {
    if (containerRef.current) {
      const width2 = containerRef.current.clientWidth;
      setContainerWidth(width2);
    }
  };
  useEffect(() => {
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);
  if (!image) {
    return null;
  }
  const {
    dimensions,
    uuid
  } = image || {};
  const {
    height,
    width
  } = dimensions || {};
  const aspect = width && height ? width / height : 1;
  const imageWidth = containerWidth >= MAX_WIDTH ? MAX_WIDTH : containerWidth;
  const scaledImageHeight = imageWidth / aspect;
  const url = baseUrl() + `/${uuid}`;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex items-center justify-center cursor-pointer",
    ref: containerRef,
    children: [/* @__PURE__ */ jsx(ScaledImageProxy, {
      h: scaledImageHeight,
      w: imageWidth,
      uuid,
      crop: true,
      onClick: handleClick
    }), /* @__PURE__ */ jsx(Popover, {
      id,
      open,
      anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      children: open && /* @__PURE__ */ jsx("div", {
        className: "p-2",
        children: /* @__PURE__ */ jsx("img", {
          src: url,
          onClick: handleClose,
          className: "cursor-pointer"
        })
      })
    })]
  });
};

const chevronVariants = cva("relative float-left text-white no-underline flex items-center text-xs sm:text-sm h-6 sm:h-8", {
  variants: {
    variant: {
      blue: "bg-[#0077b6]",
      green: "bg-[#43aa8b]",
      orange: "bg-[#f94144]"
    },
    position: {
      first: "px-2 sm:px-3",
      middle: "pl-3 sm:pl-5 pr-2 sm:pr-3",
      last: "pl-3 sm:pl-5 px-2 sm:px-3"
    }
  },
  defaultVariants: {
    variant: "blue",
    position: "middle"
  }
});
const ChevronSegment = ({
  children,
  href,
  variant,
  position,
  isLast = false,
  isSquare = false
}) => {
  const className = chevronVariants({
    variant,
    position
  });
  const content = /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("span", {
      className: "relative z-[1]",
      "data-last-square": `${isLast}=${isSquare}`,
      children
    }), !isLast && !isSquare && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("span", {
        className: "sm:hidden absolute top-1/2 -translate-y-1/2 -right-[8px] w-0 h-0 z-[2]",
        style: {
          borderTopWidth: "12px",
          borderBottomWidth: "12px",
          borderLeftWidth: "8px",
          borderTopColor: "transparent",
          borderBottomColor: "transparent",
          borderLeftColor: variant === "green" ? "#43aa8b" : variant === "orange" ? "#f94144" : "#0077b6"
        }
      }), /* @__PURE__ */ jsx("span", {
        className: "hidden sm:block absolute top-0 -right-[10px] w-0 h-0 z-[2]",
        style: {
          borderTop: "16px solid transparent",
          borderBottom: "16px solid transparent",
          borderLeft: `10px solid ${variant === "green" ? "#43aa8b" : variant === "orange" ? "#f94144" : "#0077b6"}`
        }
      })]
    })]
  });
  if (href) {
    return /* @__PURE__ */ jsx(Link$2, {
      to: href,
      className,
      children: content
    });
  }
  return /* @__PURE__ */ jsx("span", {
    className,
    children: content
  });
};

const PostViewChevronBreadcrumbs = () => {
  const {
    circle
  } = usePostInfoContext();
  const dashboardUrl = useDashboardLink();
  return /* @__PURE__ */ jsxs("nav", {
    className: "flex font-sans text-sm m-0 p-0 list-none overflow-hidden flex-wrap",
    children: [/* @__PURE__ */ jsx(ChevronSegment, {
      href: dashboardUrl,
      variant: "blue",
      position: "first",
      isSquare: true,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.breadcrumb"
      })
    }), /* @__PURE__ */ jsx("span", {
      className: "px-0 sm:px-2 leading-6 sm:leading-8 text-gray-400 flex items-center",
      children: "|"
    }), /* @__PURE__ */ jsx(ChevronSegment, {
      href: myCirclesUrl(),
      variant: "blue",
      position: "middle",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.circles"
      })
    }), circle && /* @__PURE__ */ jsx(ChevronSegment, {
      href: circleUrl(circle),
      variant: "green",
      position: "middle",
      children: circle.name
    })]
  });
};

const usePostViewGate = () => {
  const history = useHistory();
  const { post, membership, profile } = usePostInfoContext();
  const canManage = post && (isAuthor(post, profile) || isAdmin(membership));
  const isMultiPage = post && post.pages && post.pages.length > 1;
  useEffect(() => {
    if (isMultiPage && !canManage) {
      history.replace(bookCairReaderUrl(post._id));
    }
  }, [isMultiPage, canManage, post, history]);
  return canManage;
};

const CloseWithConclusionMenuItem = ({
  response
}) => {
  const {
    post,
    loadPost
  } = usePostInfoContext();
  const api = useApi();
  if (!useIsDiscussionModeratorOrAdmin()) {
    return null;
  }
  const concludeDiscussion = errorsReported(async () => {
    const {
      content,
      _id
    } = response;
    const conclusion = Array.isArray(content) ? content : {
      nsId: _id,
      ...content
    };
    const concludingPost = {
      post: post._id,
      conclusion: true,
      concludingPost: JSON.stringify(conclusion)
    };
    const updatedPost = await api.concludePost(concludingPost);
    loadPost(updatedPost);
  });
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: concludeDiscussion,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "CloseDiscussion"
    })
  });
};
const ShowTagsMenuItem = ({
  setShowTags
}) => {
  const onClick = () => {
    setShowTags(true);
  };
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: "Add tags"
  });
};
const EditMenuItem = ({
  response
}) => {
  const {
    profile,
    event$
  } = usePostInfoContext();
  const {
    post
  } = usePostContext();
  if (!isAuthor(response, profile)) {
    return null;
  }
  const onClick = () => {
    event$.emit({
      type: EDIT_POST_EVENT,
      post
    });
  };
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "posts.edit"
    })
  });
};
const CloseThreadMenuItem = ({
  response
}) => {
  const {
    loadResponses
  } = usePostInfoContext();
  const {
    responses
  } = useResponsesDataContext();
  const api = useApi();
  if (!useIsDiscussionModeratorOrAdmin()) {
    return null;
  }
  if (response.thread.length < 2) {
    return null;
  }
  const concludeDiscussion = errorsReported(async () => {
    const {
      content,
      _id
    } = response;
    const post = responses[response.thread[1]];
    const conclusion = Array.isArray(content) ? content : {
      nsId: _id,
      ...content
    };
    const concludingPost = {
      post: post._id,
      conclusion: true,
      concludingPost: JSON.stringify(conclusion)
    };
    await api.concludePost(concludingPost);
    await loadResponses();
  });
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: concludeDiscussion,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "post.closeDiscussionThread"
    })
  });
};
const UnPublishMenuItem = ({
  response
}) => {
  const {
    loadResponses,
    profile
  } = usePostInfoContext();
  const api = useApi();
  const notAuthor = !isAuthor(response, profile);
  if (!useIsDiscussionModeratorOrAdmin() && notAuthor) {
    return null;
  }
  const unPublish = errorsReported(async () => {
    await api.unpublishPost({
      _id: response._id,
      as_admin: notAuthor
    });
    await loadResponses();
  });
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: unPublish,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "posts.unpublish"
    })
  });
};
const RepublishMenuItem = ({
  response
}) => {
  const {
    membership,
    loadResponses,
    profile
  } = usePostInfoContext();
  const api = useApi();
  const notAuthor = !isAuthor(response, profile);
  if (!isAdmin(membership) && notAuthor) {
    return null;
  }
  const rePublish = errorsReported(async () => {
    await api.get({
      path: `posts/${response._id}/republish`
    });
    await loadResponses();
  });
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick: rePublish,
    children: "Republish"
  });
};
const UnpublishedResponse = ({
  response
}) => {
  const unpublished = response.unpublished;
  if (!unpublished) {
    return null;
  }
  const user = response.unpublishedBy;
  const to = memberProfileUrl(user);
  return /* @__PURE__ */ jsxs("p", {
    children: [/* @__PURE__ */ jsx(FormattedMessage, {
      id: "post.response_removed_by"
    }), /* @__PURE__ */ jsx("span", {
      children: "\xA0"
    }), /* @__PURE__ */ jsx(Link$2, {
      to,
      className: "underline",
      children: getPersonName(user)
    })]
  });
};
const ReplyButton = ({
  response
}) => {
  const [login, setLogin] = useState(false);
  const [join, setJoin] = useState(false);
  const level = response.thread.length - 1;
  const {
    post,
    event$,
    profile,
    membership
  } = usePostInfoContext();
  const {
    isClosed
  } = usePostContext();
  const unpublished = response.unpublished;
  if (!post || unpublished || post.completed || isClosed) {
    return null;
  }
  const onClick = () => {
    if (!profile) {
      setLogin(true);
      return;
    }
    if (!membership) {
      setJoin(true);
      return;
    }
    event$.emit({
      type: REPLY_POST_EVENT,
      post: response
    });
  };
  let replyButton;
  if (!level) {
    replyButton = /* @__PURE__ */ jsx("button", {
      className: "flex items-center gap-3 py-2 px-3  bg-black rounded-md text-white font-medium w-fit",
      onClick,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "post.respond2Thread"
      })
    });
  } else {
    const user = response.author;
    replyButton = /* @__PURE__ */ jsxs("button", {
      className: "flex flex-col text-sm",
      onClick,
      children: [/* @__PURE__ */ jsx(TiArrowBack, {
        size: 24
      }), "Reply to ", getPersonName(user)]
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [login && /* @__PURE__ */ jsx(ConfirmLogin, {
      onClose: () => setLogin(false)
    }), join && /* @__PURE__ */ jsx(JoinDialog, {
      onClose: () => setJoin(false)
    }), replyButton]
  });
};
const ConfirmLogin = ({
  onClose
}) => {
  return /* @__PURE__ */ jsx(AuthDialog, {
    open: true,
    onClose
  });
};
const usePostJoinCircleFn = () => {
  const {
    circle
  } = usePostInfoContext();
  const api = useApi();
  return async (notReload) => {
    await api.joinGroup(circle);
    if (!notReload) {
      location.reload();
    }
  };
};
const JoinDialog = ({
  onClose
}) => {
  const join = usePostJoinCircleFn();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    await join();
  });
  return /* @__PURE__ */ jsx(ConfirmDialog, {
    title: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "post.proceed_join"
    }),
    open: true,
    content: /* @__PURE__ */ jsx("span", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "post.join2respond"
      })
    }),
    onClose,
    children: /* @__PURE__ */ jsx(LoadingButton, {
      onClick,
      loading,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "post.join"
      })
    })
  });
};
const AIMenuThread = (props) => {
  const {
    root,
    profile,
    post
  } = props;
  if (!root || root.type !== "discussion" || !isModerator(profile, root) || !post || post.unpublished) {
    return null;
  }
  return /* @__PURE__ */ jsx(AIMenuThreadInner, {
    ...props
  });
};
const AIMenuThreadInner = ({
  post
}) => {
  const {
    circle,
    loadResponses,
    post: root
  } = usePostInfoContext();
  const {
    data: assistantsData,
    mutate
  } = useAssistants(circle && circle._id);
  const [assistants, setAssistants] = useState([]);
  const scrollToPost = useScrollToPostFn();
  const api = useApi();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    if (!assistantsData) {
      return;
    }
    const {
      assistants: assistants2
    } = assistantsData;
    setAssistants(assistants2);
  }, [assistantsData]);
  const {
    onClick: onAssistant,
    loading: loadingAssistant
  } = useLoading(async (prompt) => {
    handleClose();
    if (loadingAssistant) {
      return;
    }
    const {
      post: published
    } = await api.post({
      path: `/ai/add-comment`,
      body: {
        first: post.thread && (post.thread.length > 1 ? post.thread[1] : post._id),
        circleId: circle._id,
        root: root && root._id,
        prompt: prompt.prompt,
        assistant: assistant._id,
        responseTo: post._id,
        thread: post._id
      }
    });
    await loadResponses();
    scrollToPost(published._id);
  });
  const COMMENTS_MENU = "comment.menu";
  const assistant = assistants.find((a) => a.prompts && a.prompts.find((a2) => a2.position === COMMENTS_MENU));
  if (!assistant) {
    return null;
  }
  const {
    name
  } = assistant;
  const comments = (assistant.prompts || []).filter((a) => a.position === COMMENTS_MENU);
  return /* @__PURE__ */ jsxs("div", {
    className: "AIMenuThread flex items-center",
    children: [/* @__PURE__ */ jsxs("div", {
      className: clsx(loadingAssistant && "outline", "border-0 rounded-full outline-green-500 flex items-center justify-center relative"),
      children: [/* @__PURE__ */ jsx(IconButton$5, {
        "aria-label": "ai menu",
        color: "inherit",
        disabled: loadingAssistant,
        onClick: handleClick,
        children: /* @__PURE__ */ jsx(Avatar, {
          avatar: assistant && assistant.avatar,
          size: 40
        })
      }), loadingAssistant && /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      })]
    }), name, /* @__PURE__ */ jsx(Menu$1, {
      id: "simple-menu",
      anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose,
      children: comments.map((prompt) => {
        const {
          name: name2
        } = prompt;
        return /* @__PURE__ */ jsx(MenuItem, {
          onClick: () => onAssistant(prompt),
          children: name2
        });
      })
    })]
  });
};
const Response = ({
  response,
  className
}) => {
  const level = response.thread.length - 1;
  const [showTags, setShowTags] = useState(false);
  const [lastRequested, setLastRequested] = useState(false);
  const [threadIsOpen, setThreadIsOpen] = useState(false);
  const {
    isClosed,
    hidden
  } = usePostContext();
  const {
    author,
    created,
    responses
  } = response;
  const {
    avatar
  } = author;
  const unpublished = response.unpublished;
  const {
    event$,
    membership,
    post: root,
    profile
  } = usePostInfoContext();
  const isFocusedRef = useRef(false);
  const scrollIntoView = useMemoizedFn(() => {
    if (!hidden) {
      intoView.schedule();
      return;
    }
    isFocusedRef.current = true;
    const opened = {};
    response.thread.forEach((id) => opened[id] = true);
    event$.emit({
      type: SHOW_POST_EVENT,
      opened
    });
  });
  useEffect(() => {
    if (hidden || !isFocusedRef.current) {
      return;
    }
    isFocusedRef.current = false;
    intoView.schedule();
  }, [hidden]);
  const {
    columnView
  } = useResponsesContext();
  event$.useSubscription((ev) => {
    switch (ev.type) {
      case REQUEST_POST_EVENT:
        if (response._id !== ev.postId) {
          setLastRequested(false);
          return;
        }
        setLastRequested(true);
        ev.found = true;
        ev.scrollIntoView = scrollIntoView;
        break;
      case SHOW_POST_EVENT:
        if (ev.opened[response._id]) {
          setThreadIsOpen(true);
        }
        break;
    }
  });
  const {
    updated,
    wasSeen
  } = usePostUpdatesContext();
  const isNew = updated[response._id] ? updated[response._id].isNew : false;
  const visibleRef = useRef(false);
  const elementRef = useRef();
  const intoView = useVisibilityController(elementRef);
  const delayedWasSeen = () => {
    setTimeout(() => {
      if (!visibleRef.current) {
        return;
      }
      wasSeen(response._id);
    }, 3e3);
  };
  const onVisible = useMemoizedFn(() => {
    if (!isNew) {
      return;
    }
    visibleRef.current = true;
    delayedWasSeen();
  });
  useEffect(() => {
    if (!isNew || !visibleRef.current) {
      return;
    }
    delayedWasSeen();
  }, [isNew]);
  const onHidden = () => {
    visibleRef.current = false;
  };
  const VisibilitySensor = useVisibilitySensor(intoView, onVisible, onHidden);
  const userAvatar = /* @__PURE__ */ jsx("div", {
    className: "z-10",
    children: /* @__PURE__ */ jsx(Avatar, {
      avatar,
      size: 60
    })
  });
  const header = /* @__PURE__ */ jsxs("div", {
    className: clsx("flex items-center flex-wrap overflow-hidden", !columnView && "mt-[18px] min-h-[24px]"),
    children: [columnView && userAvatar, /* @__PURE__ */ jsx("div", {
      className: "text-base font-medium ml-1 w-56 pr-2 text-ellipsis overflow-hidden whitespace-nowrap flex-shrink min-w-0",
      children: getPersonName(author)
    }), /* @__PURE__ */ jsx(RelativeTime, {
      value: created,
      className: "rounded-full border-[#4A90CE] border text-sm px-2"
    })]
  });
  return /* @__PURE__ */ jsx(VisibilitySensor, {
    children: /* @__PURE__ */ jsxs("div", {
      ref: elementRef,
      className: clsx("flex w-full items-stretch relative", className),
      children: [!columnView && userAvatar, /* @__PURE__ */ jsx("div", {
        className: clsx(!columnView && "w-[30px] absolute border-r-[3px] h-full", level % 2 === 0 ? "border-[#4A90CE]" : "border-[#FF7354]")
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col flex-grow min-w-0 w-full",
        children: [!columnView && header, /* @__PURE__ */ jsxs("div", {
          className: clsx("relative rounded-lg p-5 flex flex-col overflow-hidden min-w-0", isNew ? "bg-green-100" : level % 2 === 0 ? "bg-[#4a90ce26]" : "bg-[#fe975d21]", lastRequested && "outline-1 outline-red-800 outline -outline-offset-1", columnView && "mb-2"),
          children: [/* @__PURE__ */ jsx(FlaggedMessage, {}), /* @__PURE__ */ jsx(UnpublishedResponse, {
            response
          }), columnView && header, !unpublished && /* @__PURE__ */ jsx(ContentCard, {
            post: response
          }), (response.tags.length > 0 || showTags) && /* @__PURE__ */ jsx(ResponseTagsPicker, {
            response
          }), /* @__PURE__ */ jsxs("div", {
            className: "w-full flex flex-wrap items-center",
            children: [/* @__PURE__ */ jsx(ReplyButton, {
              response
            }), /* @__PURE__ */ jsxs("div", {
              className: "ml-auto -mr-3 flex items-center",
              children: [/* @__PURE__ */ jsx(AIMenuThread, {
                post: response,
                root,
                profile
              }), /* @__PURE__ */ jsx(UserPostVoteButton, {}), /* @__PURE__ */ jsx(AdminVoteButton, {})]
            })]
          }), /* @__PURE__ */ jsx("div", {
            className: "bg-[#fe975d21]",
            children: /* @__PURE__ */ jsx(ThreadCompleted, {
              buttons: /* @__PURE__ */ jsx(BigStyledButton, {
                className: "ml-2",
                fitContent: true,
                onClick: () => setThreadIsOpen((v) => !v),
                children: threadIsOpen ? "Minimize" : "Show thread"
              })
            })
          }), /* @__PURE__ */ jsx(OverflowMenu, {
            className: "absolute ltr:right-1 top-2 rtl:left-1",
            hidden: !membership || isClosed,
            contentComponent: ({
              onClick
            }) => /* @__PURE__ */ jsxs("div", {
              onClick,
              className: "p-2",
              children: [!response.unpublished && /* @__PURE__ */ jsxs(Fragment, {
                children: [/* @__PURE__ */ jsx(ShowTagsMenuItem, {
                  setShowTags
                }), /* @__PURE__ */ jsx(EditMenuItem, {
                  response
                }), /* @__PURE__ */ jsx(CloseThreadMenuItem, {
                  response
                }), /* @__PURE__ */ jsx(FlagPostMenuItem, {
                  response
                }), /* @__PURE__ */ jsx(UnFlagPostMenuItem, {
                  response
                }), /* @__PURE__ */ jsx(CloseWithConclusionMenuItem, {
                  response
                }), /* @__PURE__ */ jsx(UnPublishMenuItem, {
                  response
                }), /* @__PURE__ */ jsx(ShareMenuItem, {
                  response
                })]
              }), response.unpublished && /* @__PURE__ */ jsx(RepublishMenuItem, {
                response
              })]
            }),
            "data-testid": "response-overflow"
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: clsx("overflow-hidden min-w-0", isClosed && !threadIsOpen && "hidden", !columnView && "-ml-6"),
          children: /* @__PURE__ */ jsx(Responses, {
            responses,
            level: level + 1,
            hidden: isClosed && !threadIsOpen
          })
        })]
      })]
    })
  });
};
const AllResponses = () => {
  const {
    responses,
    order
  } = useResponsesDataContext();
  const {
    sortAscending,
    columnView
  } = useResponsesContext();
  const sorted = useMemo(() => {
    if (!order || !order.length) {
      return [];
    }
    if (!sortAscending) {
      return [...order].reverse();
    }
    return order;
  }, [order, sortAscending]);
  const all = sorted.map((id) => responses[id]);
  return /* @__PURE__ */ jsx(Responses, {
    responses: all,
    columnView,
    hidden: false,
    level: 0
  });
};
const Responses = ({
  responses,
  level = 0,
  columnView,
  hidden
}) => {
  if (!responses || !responses.length) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className: clsx("flex w-full p-0", columnView ? "gap-2 overflow-x-scroll" : "flex-col gap-0", level === 0 && "responses-container"),
    "data-testid": "responses-wrapper",
    children: responses.map((response) => {
      const key = response._id;
      return /* @__PURE__ */ jsx(PostContextProvider, {
        post: response,
        hidden,
        children: /* @__PURE__ */ jsx(Response, {
          response,
          className: clsx(level === 0 && "responses-thread")
        })
      }, key);
    })
  });
};
const StartNewDiscussionThreadButton = () => {
  const {
    event$,
    post
  } = usePostInfoContext();
  const canStartNewThread = useCanStartNewThread();
  if (!canStartNewThread || !post) {
    return null;
  }
  const onClick = () => {
    event$.emit({
      type: REPLY_POST_EVENT,
      post
    });
  };
  return /* @__PURE__ */ jsx(BigStyledButton, {
    fitContent: true,
    icon: GoCommentDiscussion,
    text: /* @__PURE__ */ jsx(FormattedMessage, {
      id: post.type === "discussion" ? "post.startNewDiscussionThread" : "post.respond",
      values: {
        name: getPersonName(post.author)
      }
    }),
    onClick
  });
};
const OpenFullPostViewLink = () => {
  const {
    post
  } = usePostInfoContext();
  if (!post) {
    return null;
  }
  return /* @__PURE__ */ jsx(Link$2, {
    to: url4post(post),
    className: "underline",
    target: "_blank",
    children: "Please open in full view to comment"
  });
};
const SortResponsesButton = () => {
  const {
    sortAscending,
    setSortAscending
  } = useResponsesContext();
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Sort threads",
    children: /* @__PURE__ */ jsx(ToolbarIconButton, {
      onClick: () => setSortAscending((v) => !v),
      children: sortAscending ? /* @__PURE__ */ jsx(BsSortNumericDown, {
        color: "#4A90CE",
        size: 28
      }) : /* @__PURE__ */ jsx(BsSortNumericDownAlt, {
        color: "#4A90CE",
        size: 28
      })
    })
  });
};
const ToolbarIconButton = styled(IconButton$5)`
    &.MuiIconButton-root {
        padding: 4px;
    }
`;
const ColumnButton = () => {
  const {
    columnView,
    setColumnView
  } = useResponsesContext();
  return /* @__PURE__ */ jsx(Tooltip$2, {
    title: "Columns layout",
    children: /* @__PURE__ */ jsx(ToolbarIconButton, {
      onClick: () => setColumnView((v) => !v),
      children: /* @__PURE__ */ jsx(PiColumns, {
        ...commonIconProps
      })
    })
  });
};
const PostViewPageInner2 = ({
  children,
  className,
  dialog
}) => {
  const join = usePostJoinCircleFn();
  const {
    profile,
    post
  } = usePostInfoContext();
  usePostViewGate();
  useSetOnLoginUrl();
  useSetOnLoginAction(!profile && (() => join(true)));
  const {
    ok,
    registration,
    access,
    error
  } = usePostReady();
  const isInterview = post && isMediaPost(post);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: clsx("ns sm:px-[54px] overflow-hidden text-base w-full pb-4", className, !dialog && "min-h-screen"),
      "data-testid": "PostViewPage",
      children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full flex-col gap-1 p-2",
        children: [/* @__PURE__ */ jsx(PostHeader, {}), /* @__PURE__ */ jsx(PostViewNavigation, {}), !dialog && /* @__PURE__ */ jsx(PostViewChevronBreadcrumbs, {}), children, ok && post && isInterview && /* @__PURE__ */ jsx(InterviewPostBody, {}), ok && post && !isInterview && post.type !== "event" && /* @__PURE__ */ jsx(PostBody, {}), ok && post && !isInterview && post.type === "event" && /* @__PURE__ */ jsx(EventPanel, {})]
      }), registration && /* @__PURE__ */ jsx(RequiresRegistration, {}), access && /* @__PURE__ */ jsx(AccessDeniedPostView, {}), error && /* @__PURE__ */ jsx(ErrorPanelPostView, {
        error
      })]
    }), /* @__PURE__ */ jsx(SharePostDialog, {})]
  });
};
const PostViewPageInner = (props) => {
  const {
    postId,
    response,
    dialog
  } = props;
  return /* @__PURE__ */ jsx(LoadPostViewData, {
    dialog,
    postId,
    response,
    children: /* @__PURE__ */ jsx(CircleSearchSSEContextProvider, {
      inPost: true,
      children: /* @__PURE__ */ jsx(PostViewPageInner2, {
        ...props
      })
    })
  }, postId);
};
const PostViewPage = (props) => {
  const {
    postId
  } = props;
  return /* @__PURE__ */ jsx(PostViewPageInner, {
    ...props
  }, postId);
};

const useScrollToPost = () => {
  const location = useLocation();
  const scrollTo = useScrollToPostFn();
  const {
    post
  } = usePostInfoContext();
  useEffect(() => {
    if (!post) {
      return;
    }
    const pathname = location.pathname;
    const parts = pathname.split("/");
    const id = parts[parts.length - 1];
    if (id === "post" || id === "post-view" || id === post._id) {
      return;
    }
    scrollTo(id);
  }, [post && post._id]);
};

const useLoadPages = () => {
  const {
    post
  } = usePostInfoContext();
  return useCreation(() => {
    if (!post || !post.pages || !post.pages.length) {
      return {
        pageIds: [],
        totalPages: 0,
        hasPages: false,
        getPageId: () => null,
        getPageIndex: () => -1
      };
    }
    return {
      pageIds: post.pages,
      totalPages: post.pages.length,
      initialPage: post.pagePost || null,
      hasPages: true,
      getPageId: (index) => {
        if (index < 0 || index >= post.pages.length) {
          return null;
        }
        return post.pages[index];
      },
      getPageIndex: (id) => {
        return post.pages.indexOf(id);
      }
    };
  }, [post]);
};

const useLoadPage = (id) => {
  const api = useApi();
  const {
    language
  } = useLanguageSelectionContext();
  const {
    getPageId,
    initialPage
  } = useLoadPages();
  const pageId = getPageId(id);
  const {
    data,
    error,
    isValidating: isLoading,
    mutate
  } = useSWR(pageId ? [`/post-view/${pageId}`, language] : null, async () => {
    if (initialPage && initialPage._id === pageId) {
      return initialPage;
    }
    return loadPage(api, pageId, {
      language
    });
  }, {
    ...swrLoadOnce,
    fallbackData: initialPage && initialPage._id === pageId ? initialPage : void 0
  });
  const reload = useMemoizedFn(async () => {
    await mutate();
  });
  return {
    pageId,
    page: data || null,
    isLoading,
    error,
    reload
  };
};

const PageContainer = ({
  pageIndex,
  estimatedHeight,
  onHeightChange,
  shouldPreload,
  isTargetPage
}) => {
  const {
    getPageId
  } = useLoadPages();
  const pageId = getPageId(pageIndex);
  const {
    page: scrollToPageId
  } = useQueryStringParams();
  const shouldScrollTo = scrollToPageId === pageId;
  const scrollRef = useRef(null);
  const {
    ref: visibilityRef,
    shouldLoad
  } = usePageVisibility();
  const {
    page
  } = useLoadPage(shouldLoad || shouldPreload || shouldScrollTo || isTargetPage ? pageIndex : null);
  const {
    ref: heightRef
  } = usePageHeight({
    defaultHeight: estimatedHeight,
    onHeightChange: useMemoizedFn((height) => {
      if (page) {
        onHeightChange(page._id, height);
      }
    })
  });
  useEffect(() => {
    if (isTargetPage && page && scrollRef.current) {
      const timer = setTimeout(() => {
        if (scrollRef.current) {
          scrollRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isTargetPage, page]);
  if (!shouldLoad && !shouldPreload && !shouldScrollTo && !isTargetPage) {
    return /* @__PURE__ */ jsx(PagePlaceholder, {
      ref: visibilityRef,
      height: estimatedHeight,
      pageNumber: pageIndex + 1
    });
  }
  if (!page) {
    return /* @__PURE__ */ jsx(PagePlaceholder, {
      ref: heightRef,
      height: estimatedHeight,
      pageNumber: pageIndex + 1
    });
  }
  return /* @__PURE__ */ jsx("div", {
    ref: (node) => {
      heightRef.current = node;
      scrollRef.current = node;
    },
    className: "border-b-8 border-gray-200 last:border-b-0",
    "data-page-id": pageId,
    children: /* @__PURE__ */ jsx(ContentCard, {
      post: page
    })
  });
};
const Pages = () => {
  const {
    totalPages,
    getPageId,
    getPageIndex
  } = useLoadPages();
  const {
    updatePageHeight,
    averageHeight
  } = usePagesHeights();
  const {
    pageId: targetPageId
  } = useChunkNavigation();
  if (!totalPages) {
    return null;
  }
  const targetPageIndex = targetPageId ? getPageIndex(targetPageId) : -1;
  return /* @__PURE__ */ jsx("div", {
    className: "space-y-4",
    children: Array.from({
      length: totalPages
    }, (_, index) => {
      const pageId = getPageId(index);
      const isTargetPage = targetPageId && pageId === targetPageId;
      const shouldPreload = targetPageIndex >= 0 && index <= targetPageIndex;
      return /* @__PURE__ */ jsx(PageContainer, {
        pageIndex: index,
        estimatedHeight: averageHeight,
        onHeightChange: updatePageHeight,
        shouldPreload,
        isTargetPage
      }, index);
    })
  });
};

const PostBody = () => {
  useOpenResponse();
  const {
    post
  } = usePostInfoContext();
  const {
    order
  } = useResponsesDataContext();
  const {
    dialog
  } = usePostUIContext();
  useScrollToPost();
  if (!post) {
    return null;
  }
  if (post.unpublished) {
    return /* @__PURE__ */ jsx(UnpublishedPost, {
      post
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(InfoMessage, {}), /* @__PURE__ */ jsx(FlaggedMessage, {}), /* @__PURE__ */ jsx(ContentCard, {
      post,
      eventFilters: true
    }), /* @__PURE__ */ jsx(Pages, {}), /* @__PURE__ */ jsx(EventControls, {}), /* @__PURE__ */ jsx(EventParticipantsList, {
      post
    }), /* @__PURE__ */ jsx(ReferencesCard, {
      post
    }), /* @__PURE__ */ jsx(PostCompleted, {}), !dialog && /* @__PURE__ */ jsx(StartNewDiscussionThreadButton, {}), order && order.length ? /* @__PURE__ */ jsx("div", {
      className: "flex w-full bg-[#fe975d2b]",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex ml-auto mx-2 gap-4 items-center",
        children: [/* @__PURE__ */ jsx(UsersOnlineButton, {}), /* @__PURE__ */ jsx(ColumnButton, {}), /* @__PURE__ */ jsx(SortResponsesButton, {})]
      })
    }) : null, /* @__PURE__ */ jsx(AllResponses, {}), !dialog && /* @__PURE__ */ jsx(TinyResponseEditor, {}), dialog && /* @__PURE__ */ jsx(OpenFullPostViewLink, {}), /* @__PURE__ */ jsx(PostFooter, {})]
  });
};

const NarratorBioPanel = ({
  metadata,
  imageUrl,
  title
}) => {
  const intl = useIntl();
  const formatDate = (raw) => intl.formatDate(raw, {
    year: "numeric",
    month: "long",
    day: "2-digit"
  });
  const {
    narratorName,
    birthYear,
    fieldResearcher,
    recordingDate
  } = metadata;
  const subtitleParts = [];
  if (birthYear)
    subtitleParts.push(intl.formatMessage({
      id: "interview.bornYear"
    }, {
      year: birthYear
    }));
  if (fieldResearcher)
    subtitleParts.push(intl.formatMessage({
      id: "interview.fieldResearcher"
    }, {
      name: String(fieldResearcher)
    }));
  const subtitle = subtitleParts.join(" \xB7 ");
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full rounded-t-lg bg-blue-500 px-5 py-4 flex flex-wrap items-center gap-x-4 gap-y-2",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-4 min-w-0",
      children: [imageUrl ? /* @__PURE__ */ jsx("img", {
        src: imageUrl,
        alt: narratorName || intl.formatMessage({
          id: "interview.narrator"
        }),
        className: "h-16 w-16 shrink-0 rounded-full object-cover border-2 border-white border-opacity-40"
      }) : /* @__PURE__ */ jsx("div", {
        className: "h-16 w-16 shrink-0 rounded-full bg-blue-400 flex items-center justify-center",
        children: /* @__PURE__ */ jsx(MdPerson, {
          size: 32,
          className: "text-white"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-0.5 min-w-0",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-xs font-medium uppercase tracking-widest text-blue-100",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "interview.narrator"
          })
        }), narratorName && /* @__PURE__ */ jsx("p", {
          className: "text-xl font-semibold text-white leading-snug truncate",
          children: narratorName
        }), subtitle && /* @__PURE__ */ jsx("p", {
          className: "text-sm text-blue-100 truncate",
          children: subtitle
        }), recordingDate && /* @__PURE__ */ jsxs("p", {
          className: "text-sm text-blue-100 flex items-center gap-1 mt-0.5",
          children: [/* @__PURE__ */ jsx(MdCalendarToday, {
            size: 14,
            className: "shrink-0"
          }), intl.formatMessage({
            id: "interview.recordingDate"
          }, {
            date: formatDate(String(recordingDate))
          })]
        })]
      })]
    }), title && /* @__PURE__ */ jsx("p", {
      className: "text-sm font-medium text-white basis-full sm:basis-auto sm:ms-auto sm:max-w-[45%] min-w-0 text-end",
      dir: "auto",
      children: title
    })]
  });
};

const PLYR_JS_URL$2 = "https://cdn.jsdelivr.net/npm/plyr@3/dist/plyr.min.js";
const PLYR_CSS_URL$2 = "https://cdn.jsdelivr.net/npm/plyr@3/dist/plyr.css";
const MediaAudioPlayer = ({
  src,
  contentType = "audio/mpeg",
  title
}) => {
  const audioRef = useRef(null);
  const playerRef = useRef(null);
  const [loadState, setLoadState] = useState("loading");
  const [loadError, setLoadError] = useState("");
  const initPlayer = useMemoizedFn(async () => {
    loadStylesheet(PLYR_CSS_URL$2);
    try {
      await loadJsLibs([PLYR_JS_URL$2]);
    } catch (err) {
      const msg = err && err.message ? err.message : "Failed to load player";
      setLoadError(msg);
      setLoadState("error");
      return;
    }
    if (!audioRef.current || !window.Plyr)
      return;
    playerRef.current = new window.Plyr(audioRef.current, {
      controls: ["play", "progress", "current-time", "duration", "mute", "volume", "speed"],
      speed: {
        selected: 1,
        options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]
      }
    });
    setLoadState("ready");
  });
  useEffect(() => {
    setLoadState("loading");
    setLoadError("");
    initPlayer();
    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [src]);
  if (loadState === "error") {
    return /* @__PURE__ */ jsxs("p", {
      className: "py-3 text-sm text-red-500",
      children: ["Player failed to load \u2014 ", loadError, ".", " ", /* @__PURE__ */ jsx("a", {
        href: src,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "underline",
        children: "Download to listen"
      })]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "relative w-full",
    children: [loadState === "loading" && /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 py-4 text-sm text-gray-400",
      children: [/* @__PURE__ */ jsx(Spinner, {
        size: "sm"
      }), /* @__PURE__ */ jsx("span", {
        children: "Loading player\u2026"
      })]
    }), /* @__PURE__ */ jsxs("audio", {
      ref: audioRef,
      controls: true,
      title: title || void 0,
      className: loadState === "loading" ? "opacity-0 absolute" : "w-full",
      children: [/* @__PURE__ */ jsx("source", {
        src,
        type: contentType
      }), "Your browser does not support the audio element."]
    })]
  });
};

const PLYR_JS_URL$1 = "https://cdn.jsdelivr.net/npm/plyr@3/dist/plyr.min.js";
const PLYR_CSS_URL$1 = "https://cdn.jsdelivr.net/npm/plyr@3/dist/plyr.css";
const MediaVideoPlayer = ({
  src,
  contentType = "video/mp4",
  title,
  poster,
  maxHeight
}) => {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const [loadState, setLoadState] = useState("loading");
  const [loadError, setLoadError] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const initPlayer = useMemoizedFn(async () => {
    loadStylesheet(PLYR_CSS_URL$1);
    try {
      await loadJsLibs([PLYR_JS_URL$1]);
    } catch (err) {
      const msg = err && err.message ? err.message : "Failed to load player";
      setLoadError(msg);
      setLoadState("error");
      return;
    }
    if (!videoRef.current || !window.Plyr)
      return;
    const player = new window.Plyr(videoRef.current, {
      controls: ["play-large", "play", "progress", "current-time", "duration", "mute", "volume", "fullscreen"]
    });
    player.on("enterfullscreen", () => setIsFullscreen(true));
    player.on("exitfullscreen", () => setIsFullscreen(false));
    playerRef.current = player;
    setLoadState("ready");
  });
  useEffect(() => {
    setLoadState("loading");
    setLoadError("");
    setIsFullscreen(false);
    initPlayer();
    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [src]);
  if (loadState === "error") {
    return /* @__PURE__ */ jsxs("p", {
      className: "py-3 text-sm text-red-500",
      children: ["Player failed to load \u2014 ", loadError, ".", " ", /* @__PURE__ */ jsx("a", {
        href: src,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "underline",
        children: "Download to view"
      })]
    });
  }
  const heightStyle = maxHeight && !isFullscreen ? {
    maxHeight
  } : void 0;
  return /* @__PURE__ */ jsxs("div", {
    className: "relative w-full",
    style: heightStyle,
    children: [loadState === "loading" && /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 py-4 text-sm text-gray-400",
      children: [/* @__PURE__ */ jsx(Spinner, {
        size: "sm"
      }), /* @__PURE__ */ jsx("span", {
        children: "Loading player\u2026"
      })]
    }), /* @__PURE__ */ jsxs("video", {
      ref: videoRef,
      controls: true,
      playsInline: true,
      poster: poster || void 0,
      title: title || void 0,
      style: heightStyle,
      className: loadState === "loading" ? "opacity-0 absolute" : "w-full",
      children: [/* @__PURE__ */ jsx("source", {
        src,
        type: contentType
      }), "Your browser does not support the video element."]
    })]
  });
};

const HLS_JS_URL = "https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js";
const PLYR_JS_URL = "https://cdn.jsdelivr.net/npm/plyr@3/dist/plyr.min.js";
const PLYR_CSS_URL = "https://cdn.jsdelivr.net/npm/plyr@3/dist/plyr.css";
const MediaHlsPlayer = ({
  src,
  title,
  poster,
  maxHeight
}) => {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);
  const playerRef = useRef(null);
  const [loadState, setLoadState] = useState("loading");
  const [loadError, setLoadError] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const initPlayer = useMemoizedFn(async () => {
    loadStylesheet(PLYR_CSS_URL);
    try {
      await loadJsLibs([HLS_JS_URL, PLYR_JS_URL]);
    } catch (err) {
      const msg = err && err.message ? err.message : "Failed to load player";
      setLoadError(msg);
      setLoadState("error");
      return;
    }
    const video = videoRef.current;
    if (!video || !window.Hls || !window.Plyr)
      return;
    if (window.Hls.isSupported()) {
      const hls = new window.Hls();
      hlsRef.current = hls;
      hls.loadSource(src);
      hls.attachMedia(video);
      hls.on("hlsError", (_event, data) => {
        if (data && data.fatal) {
          const msg = data.details ? String(data.details) : "HLS error";
          setLoadError(msg);
          setLoadState("error");
        }
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = src;
    } else {
      setLoadError("HLS playback is not supported in this browser");
      setLoadState("error");
      return;
    }
    const player = new window.Plyr(video, {
      controls: ["play-large", "play", "progress", "current-time", "duration", "mute", "volume", "fullscreen"]
    });
    player.on("enterfullscreen", () => setIsFullscreen(true));
    player.on("exitfullscreen", () => setIsFullscreen(false));
    playerRef.current = player;
    setLoadState("ready");
  });
  useEffect(() => {
    setLoadState("loading");
    setLoadError("");
    setIsFullscreen(false);
    initPlayer();
    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
        hlsRef.current = null;
      }
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [src]);
  if (loadState === "error") {
    return /* @__PURE__ */ jsxs("p", {
      className: "py-3 text-sm text-red-500",
      children: ["Player failed to load \u2014 ", loadError, "."]
    });
  }
  const heightStyle = maxHeight && !isFullscreen ? {
    maxHeight
  } : void 0;
  return /* @__PURE__ */ jsxs("div", {
    className: "relative w-full min-h-[48px]",
    style: heightStyle,
    children: [loadState === "loading" && /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 py-4 text-sm text-gray-400",
      children: [/* @__PURE__ */ jsx(Spinner, {
        size: "sm"
      }), /* @__PURE__ */ jsx("span", {
        children: "Loading player\u2026"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: loadState === "loading" ? "hidden" : "",
      children: /* @__PURE__ */ jsx("video", {
        ref: videoRef,
        controls: true,
        playsInline: true,
        poster: poster || void 0,
        title: title || void 0,
        style: heightStyle,
        className: "w-full"
      })
    })]
  });
};

const SLIDE_HEIGHT_PX$1 = 400;
const buildImgixUrl = (baseUrl) => `${baseUrl}?h=${SLIDE_HEIGHT_PX$1}&fit=clip&auto=format&q=80`;
const CarouselImageSlide = ({
  item
}) => {
  const [loadError, setLoadError] = useState(false);
  const intl = useIntl();
  const handleError = useMemoizedFn(() => setLoadError(true));
  const imgixUrl = buildImgixUrl(item.url);
  const alt = item.label || "";
  if (loadError) {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-center px-4 py-8 text-sm text-gray-400",
      children: [/* @__PURE__ */ jsx(FormattedMessage, {
        id: "interview.previewUnavailable"
      }), " ", /* @__PURE__ */ jsx("a", {
        href: item.url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "ml-1 underline",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "interview.openFile"
        })
      })]
    });
  }
  return /* @__PURE__ */ jsxs("a", {
    href: item.url,
    target: "_blank",
    rel: "noopener noreferrer",
    title: intl.formatMessage({
      id: "interview.openFullSize"
    }),
    className: "group relative flex justify-center items-center bg-gray-50 overflow-hidden w-full",
    style: {
      maxHeight: SLIDE_HEIGHT_PX$1
    },
    children: [/* @__PURE__ */ jsx("img", {
      src: imgixUrl,
      alt,
      onError: handleError,
      className: "w-auto max-w-full h-auto block",
      style: {
        maxHeight: SLIDE_HEIGHT_PX$1
      }
    }), /* @__PURE__ */ jsx("span", {
      className: ["absolute inset-0 flex items-center justify-center", "bg-black bg-opacity-0 group-hover:bg-opacity-20", "transition-colors duration-150"].join(" "),
      children: /* @__PURE__ */ jsx(MdOpenInNew, {
        size: 24,
        className: "text-white opacity-0 group-hover:opacity-100 transition-opacity duration-150"
      })
    })]
  });
};

const isAudio = (ct) => ct.startsWith("audio/");
const isVideo = (ct) => ct.startsWith("video/");
const isImage = (ct) => ct.startsWith("image/");
const kindOf = (ct) => {
  if (isAudio(ct))
    return "audio";
  if (isVideo(ct))
    return "video";
  if (isImage(ct))
    return "image";
  return "unknown";
};
const SLIDE_HEIGHT_PX = 400;
const kindIconMap = {
  audio: MdAudiotrack,
  video: MdVideocam,
  image: MdImage,
  unknown: MdAudiotrack
};
const kindBgMap = {
  audio: "bg-teal-50 text-teal-700",
  video: "bg-blue-50 text-blue-700",
  image: "bg-amber-50 text-amber-700",
  unknown: "bg-gray-100 text-gray-500"
};
const SlideHeader = ({
  kind,
  typeLabel,
  title
}) => {
  const Icon = kindIconMap[kind];
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-3 px-4 pt-4 pb-2",
    children: [/* @__PURE__ */ jsx("div", {
      className: `flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${kindBgMap[kind]}`,
      children: /* @__PURE__ */ jsx(Icon, {
        size: 20
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex-1 min-w-0",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-xs font-medium text-gray-400 uppercase tracking-wide mb-0.5",
        children: typeLabel
      }), /* @__PURE__ */ jsx("p", {
        className: "text-sm font-medium text-gray-900 truncate",
        children: title
      })]
    })]
  });
};
const SlideNote = ({
  note
}) => /* @__PURE__ */ jsx("p", {
  className: "px-4 pb-4 pt-2 text-xs text-gray-400 leading-relaxed border-t border-gray-100",
  children: note
});
const CarouselSlide = ({
  item
}) => {
  const ct = item.contentType || "";
  const kind = kindOf(ct);
  const intl = useIntl();
  const typeLabel = (() => {
    if (isAudio(ct))
      return intl.formatMessage({
        id: "interview.audio"
      });
    if (isVideo(ct))
      return intl.formatMessage({
        id: "interview.video"
      });
    if (isImage(ct))
      return intl.formatMessage({
        id: "interview.image"
      });
    return "";
  })();
  return /* @__PURE__ */ jsxs("div", {
    style: {
      minHeight: SLIDE_HEIGHT_PX
    },
    children: [/* @__PURE__ */ jsx(SlideHeader, {
      kind,
      typeLabel,
      title: item.label || ""
    }), isAudio(ct) && /* @__PURE__ */ jsx("div", {
      className: "flex flex-col items-center justify-center px-4 bg-gray-50",
      style: {
        height: SLIDE_HEIGHT_PX
      },
      children: item.url ? /* @__PURE__ */ jsx("div", {
        className: "w-full",
        children: /* @__PURE__ */ jsx(MediaAudioPlayer, {
          src: item.url,
          contentType: ct,
          title: item.label
        })
      }) : /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-400 text-center",
        children: item.note
      })
    }), isVideo(ct) && (item.hlsUrl ? /* @__PURE__ */ jsx(MediaHlsPlayer, {
      src: item.hlsUrl,
      title: item.label,
      maxHeight: SLIDE_HEIGHT_PX,
      poster: item.posterUrl
    }) : /* @__PURE__ */ jsx(MediaVideoPlayer, {
      src: item.url,
      contentType: ct,
      title: item.label,
      maxHeight: SLIDE_HEIGHT_PX,
      poster: item.posterUrl
    })), isImage(ct) && /* @__PURE__ */ jsx(CarouselImageSlide, {
      item
    }), item.note && /* @__PURE__ */ jsx(SlideNote, {
      note: item.note
    })]
  });
};
const NavButton = ({
  onClick,
  disabled,
  label,
  children
}) => /* @__PURE__ */ jsx("button", {
  onClick,
  disabled,
  "aria-label": label,
  className: ["flex-shrink-0 w-11 h-11 rounded-full", "flex items-center justify-center", "transition-colors shadow-sm", disabled ? "bg-gray-100 text-gray-300 cursor-default" : "bg-gray-900 text-white hover:bg-gray-700"].join(" "),
  children
});
const DotPagination = ({
  count,
  active,
  onSelect
}) => {
  const intl = useIntl();
  return /* @__PURE__ */ jsx("div", {
    className: "flex items-center gap-1.5",
    role: "tablist",
    "aria-label": "Media items",
    children: Array.from({
      length: count
    }).map((_, i) => /* @__PURE__ */ jsx("button", {
      role: "tab",
      "aria-selected": i === active,
      "aria-label": intl.formatMessage({
        id: "interview.mediaItem"
      }, {
        index: i + 1
      }),
      onClick: () => onSelect(i),
      className: ["rounded-full transition-all duration-150", i === active ? "w-4 h-1.5 bg-blue-500" : "w-1.5 h-1.5 bg-gray-300 hover:bg-gray-400"].join(" ")
    }, i))
  });
};
const InterviewMediaCarousel = ({
  items,
  isRtl
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const intl = useIntl();
  const containerRef = useRef(null);
  const swiperInstanceRef = useRef(null);
  useEffect(() => {
    if (!containerRef.current) {
      return;
    }
    let cancelled = false;
    loadSwiper().then(() => {
      if (cancelled || !containerRef.current) {
        return;
      }
      swiperInstanceRef.current = new window.Swiper(containerRef.current, {
        on: {
          slideChange: (swiper) => setActiveIndex(swiper.activeIndex)
        }
      });
    });
    return () => {
      cancelled = true;
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy(true, true);
        swiperInstanceRef.current = null;
      }
    };
  }, [items.length]);
  const goTo = useMemoizedFn((i) => {
    if (swiperInstanceRef.current) {
      swiperInstanceRef.current.slideTo(i);
    }
  });
  const goPrev = useMemoizedFn(() => {
    if (swiperInstanceRef.current) {
      swiperInstanceRef.current.slidePrev();
    }
  });
  const goNext = useMemoizedFn(() => {
    if (swiperInstanceRef.current) {
      swiperInstanceRef.current.slideNext();
    }
  });
  const onLeftArrow = isRtl ? goNext : goPrev;
  const onRightArrow = isRtl ? goPrev : goNext;
  const single = items.length === 1;
  if (items.length === 0)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full rounded-b-lg border border-gray-200 bg-white overflow-hidden",
    children: [/* @__PURE__ */ jsx("div", {
      className: "swiper",
      ref: containerRef,
      dir: isRtl ? "rtl" : "ltr",
      children: /* @__PURE__ */ jsx("div", {
        className: "swiper-wrapper",
        children: items.map((item, index) => /* @__PURE__ */ jsx("div", {
          className: "swiper-slide",
          children: index === activeIndex ? /* @__PURE__ */ jsx(CarouselSlide, {
            item
          }) : /* @__PURE__ */ jsx("div", {
            style: {
              height: SLIDE_HEIGHT_PX
            }
          })
        }, item.url || index))
      })
    }), !single && /* @__PURE__ */ jsxs("div", {
      dir: "ltr",
      className: "flex items-center gap-3 px-4 py-3 border-t border-gray-100",
      children: [/* @__PURE__ */ jsx(NavButton, {
        onClick: onLeftArrow,
        disabled: false,
        label: intl.formatMessage({
          id: isRtl ? "interview.nextSlide" : "interview.prevSlide"
        }),
        children: /* @__PURE__ */ jsx(MdChevronLeft, {
          size: 24
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "flex-1 flex justify-center",
        children: /* @__PURE__ */ jsx(DotPagination, {
          count: items.length,
          active: activeIndex,
          onSelect: goTo
        })
      }), /* @__PURE__ */ jsx("span", {
        className: "text-xs text-gray-400 whitespace-nowrap tabular-nums",
        children: isRtl ? `${items.length} / ${activeIndex + 1}` : `${activeIndex + 1} / ${items.length}`
      }), /* @__PURE__ */ jsx(NavButton, {
        onClick: onRightArrow,
        disabled: false,
        label: intl.formatMessage({
          id: isRtl ? "interview.prevSlide" : "interview.nextSlide"
        }),
        children: /* @__PURE__ */ jsx(MdChevronRight, {
          size: 24
        })
      })]
    })]
  });
};

const DetailChip = ({
  icon,
  label,
  value
}) => /* @__PURE__ */ jsxs("div", {
  className: "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-gray-200 bg-gray-50 text-sm",
  children: [/* @__PURE__ */ jsx("span", {
    className: "shrink-0 text-gray-400",
    children: icon
  }), /* @__PURE__ */ jsxs("span", {
    className: "text-gray-500",
    children: [label, ":"]
  }), /* @__PURE__ */ jsx("span", {
    className: "font-medium text-gray-900",
    children: value
  })]
});
const InterviewDetailsPanel = ({
  metadata,
  tags
}) => {
  const intl = useIntl();
  const {
    birthPlace,
    originalTownDistrict,
    addressLocation,
    recordingPlace,
    recordingDate,
    recordingDurationMinutes,
    fieldResearcher,
    supervisingOrganization,
    supervisingResearcher
  } = metadata;
  const formatDate = (raw) => intl.formatDate(raw, {
    year: "numeric",
    month: "long",
    day: "2-digit"
  });
  const chips = [];
  if (birthPlace)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdLocationOn, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.birthPlace"
      }),
      value: String(birthPlace)
    });
  if (originalTownDistrict)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdLocationOn, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.placeOfOrigin"
      }),
      value: String(originalTownDistrict)
    });
  if (addressLocation)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdHome, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.currentAddress"
      }),
      value: String(addressLocation)
    });
  if (recordingPlace)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdMic, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.recordingPlace"
      }),
      value: String(recordingPlace)
    });
  if (recordingDate)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdCalendarToday, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.recordingDateLabel"
      }),
      value: formatDate(String(recordingDate))
    });
  if (recordingDurationMinutes)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdTimer, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.duration"
      }),
      value: intl.formatMessage({
        id: "interview.durationMin"
      }, {
        min: recordingDurationMinutes
      })
    });
  if (fieldResearcher)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdPerson, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.fieldResearcherLabel"
      }),
      value: String(fieldResearcher)
    });
  if (supervisingOrganization)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdGroup, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.organization"
      }),
      value: String(supervisingOrganization)
    });
  if (supervisingResearcher)
    chips.push({
      icon: /* @__PURE__ */ jsx(MdPerson, {
        size: 15
      }),
      label: intl.formatMessage({
        id: "interview.supervisingResearcher"
      }),
      value: String(supervisingResearcher)
    });
  const hasTags = tags && tags.length > 0;
  if (chips.length === 0 && !hasTags)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-3",
    children: [chips.length > 0 && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-xs font-medium uppercase tracking-wide text-gray-400 mb-2",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "interview.details"
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-wrap gap-2",
        children: chips.map((chip, i) => /* @__PURE__ */ jsx(DetailChip, {
          icon: chip.icon,
          label: chip.label,
          value: chip.value
        }, i))
      })]
    }), hasTags && /* @__PURE__ */ jsx("div", {
      className: "flex flex-wrap gap-1.5",
      children: tags.map((tag, i) => /* @__PURE__ */ jsx("span", {
        className: "inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-600 border border-blue-100",
        children: tag
      }, i))
    })]
  });
};

const InterviewSummaryBlock = ({
  summary
}) => {
  const trimmed = summary && summary.trim();
  if (!trimmed)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full",
    children: [/* @__PURE__ */ jsx("p", {
      className: "text-xs font-medium uppercase tracking-wide text-gray-400 mb-2",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "interview.summary"
      })
    }), /* @__PURE__ */ jsx("p", {
      className: "text-sm text-gray-600 leading-relaxed",
      dir: "auto",
      children: trimmed
    })]
  });
};

const findHlsVariant = (att) => {
  if (!att.variants)
    return null;
  for (var i = 0; i < att.variants.length; i++) {
    const v = att.variants[i];
    if (v.variantType === "hls" && v.status === "ready")
      return v;
  }
  return null;
};
const buildHlsPlaylistUrl = (postId, attachmentUuid, buildUrl, jwt) => buildUrl(`interviews/${postId}/attachments/${encodeURIComponent(attachmentUuid)}/hls/playlist.m3u8`, { token: jwt });
const isWmaSource$1 = (att) => {
  const name = att.originalFileName;
  const ct = att.contentType;
  if (name && /\.wma$/i.test(name))
    return true;
  if (ct && ct.indexOf("x-ms-wma") !== -1)
    return true;
  return false;
};
const findReadyMp3Variant$1 = (att) => {
  if (!att.variants)
    return null;
  for (let i = 0; i < att.variants.length; i++) {
    const v = att.variants[i];
    if (v.variantType === "mp3" && v.status === "ready")
      return v;
  }
  return null;
};
const findReadyPosterVariant = (att) => {
  if (!att.variants)
    return null;
  for (let i = 0; i < att.variants.length; i++) {
    const v = att.variants[i];
    if (v.variantType === "poster" && v.status === "ready")
      return v;
  }
  return null;
};

const InterviewPostBody = () => {
  const {
    post
  } = usePostInfoContext();
  const imageUrlFn = useImageUrlFn();
  const api = useApi();
  const jwt = useJwt();
  const isRtl = useDirectionality() === "rtl";
  if (!post)
    return null;
  const metadata = post.metadata ? post.metadata : {};
  const narratorAttachment = post.attachments ? post.attachments.find((att) => att.label === "narrator" && att.contentType && att.contentType.startsWith("image/")) : void 0;
  const narratorMeta = metadata.narratorImage;
  const narratorBase = narratorMeta ? imageUrlFn(narratorMeta) : narratorAttachment ? imageUrlFn(narratorAttachment) : post.image && post.image.uuid ? imageUrlFn(post.image) : void 0;
  const imageUrl = narratorBase ? buildNarratorImageUrl(narratorBase) : void 0;
  const mediaItems = post.attachments ? post.attachments.filter((att) => {
    const ct = att.contentType || "";
    return ct.startsWith("audio/") || ct.startsWith("video/") || ct.startsWith("image/");
  }).map((att) => {
    const ct = att.contentType || "";
    const isVideoAtt = ct.startsWith("video/");
    const isImageAtt = ct.startsWith("image/");
    if (isWmaSource$1(att)) {
      const mp3 = findReadyMp3Variant$1(att);
      if (!mp3)
        return {
          url: null,
          contentType: "audio/mpeg",
          label: att.label || att.originalFileName,
          note: "This recording is being prepared for playback."
        };
      return {
        url: imageUrlFn(mp3),
        contentType: "audio/mpeg",
        label: att.label || att.originalFileName,
        note: att.description
      };
    }
    const hlsVariant = isVideoAtt ? findHlsVariant(att) : null;
    const hlsUrl = hlsVariant && jwt ? buildHlsPlaylistUrl(post._id, att.uuid, api.buildUrl.bind(api), jwt) : void 0;
    const posterVariant = isVideoAtt ? findReadyPosterVariant(att) : null;
    const posterUrl = posterVariant ? imageUrlFn(posterVariant) : void 0;
    return {
      url: imageUrlFn(att),
      contentType: att.contentType,
      label: att.label || att.originalFileName,
      note: att.description,
      hlsUrl,
      posterUrl,
      imageUrl: isImageAtt ? imageUrlFn(att) : void 0,
      dimensions: att.dimensions
    };
  }) : [];
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-6 w-full max-w-3xl mx-auto",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col w-full",
      children: [/* @__PURE__ */ jsx(NarratorBioPanel, {
        metadata,
        imageUrl,
        title: post.title
      }), mediaItems.length > 0 && /* @__PURE__ */ jsx(InterviewMediaCarousel, {
        items: mediaItems,
        isRtl
      })]
    }), /* @__PURE__ */ jsx(InterviewDetailsPanel, {
      metadata,
      tags: post.tags
    }), /* @__PURE__ */ jsx(InterviewSummaryBlock, {
      summary: post.metadata && String(post.metadata.summary || "")
    }), /* @__PURE__ */ jsx(PostBody, {})]
  });
};
const buildNarratorImageUrl = (baseUrl) => `${baseUrl}?w=128&h=128&fit=facearea&facepad=2&auto=format&q=80`;

const ReaderTopBar = ({
  bookTitle,
  chapterTitle,
  onExit,
  onShare,
  locked,
  onViewDetails,
  aiChatHref,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `
            w-full sticky top-0 z-[2]
            bg-[var(--cair-surface)] border-b border-[var(--cair-border-strong)]
            px-[24px] pt-[20px] pb-[17px]
            flex flex-col gap-[8px]
            ${className || ""}
        `,
  style: {
    boxShadow: "var(--cair-shadow-sm)"
  },
  children: [/* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-between w-full",
    children: [/* @__PURE__ */ jsx(ActionButton, {
      intent: "cairSubtle",
      size: "xs",
      rounded: "sm",
      onClick: onExit,
      leftIcon: /* @__PURE__ */ jsx(MdOutlineBackspace, {
        size: 16
      }),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "br.exit"
      })
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "cairDefault",
      size: "xs",
      rounded: "sm",
      onClick: onShare,
      leftIcon: /* @__PURE__ */ jsx(MdShare, {
        size: 16
      }),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "br.share"
      })
    })]
  }), /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col items-start w-full gap-[4px]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-[8px] w-full overflow-hidden",
      children: [locked && /* @__PURE__ */ jsx("div", {
        className: "bg-[var(--cair-accent)] border border-[#182336] p-[4px] rounded-[var(--cair-radius-xl)] shrink-0",
        children: /* @__PURE__ */ jsx(MdLock, {
          size: 14,
          className: "text-white"
        })
      }), /* @__PURE__ */ jsx("p", {
        className: "flex-1 text-[length:var(--cair-text-small)] text-[color:var(--cair-accent)] font-semibold leading-[1.75] truncate",
        children: bookTitle
      })]
    }), /* @__PURE__ */ jsx("p", {
      className: "w-full text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.2] truncate",
      children: chapterTitle
    })]
  }), onViewDetails && /* @__PURE__ */ jsx("button", {
    onClick: onViewDetails,
    className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] underline leading-[1.5] text-left",
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "br.viewDetails"
    })
  }), aiChatHref && /* @__PURE__ */ jsxs("a", {
    href: aiChatHref,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "inline-flex items-center gap-1 text-[length:var(--cair-text-tiny)] font-semibold underline leading-[1.5] self-start",
    style: {
      color: "var(--cair-accent)"
    },
    children: ["Go to AI Chat", /* @__PURE__ */ jsx("img", {
      src: "/static/images/chat-ai-logo.png",
      alt: "",
      width: 18,
      height: 18
    })]
  })]
});

const BookCairMediaPostViewInner = ({
  source
}) => {
  const {
    post
  } = usePostInfoContext();
  const history = useHistory();
  const [shareOpen, setShareOpen] = useState(false);
  if (source !== "mobile" || !post) {
    return /* @__PURE__ */ jsx(InterviewPostBody, {});
  }
  const circleId = postGroupId(post);
  const onExit = () => history.push(circleUrl(circleId));
  const aiChatHref = getAiChatReturnHref(circleId || void 0);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(ReaderTopBar, {
      bookTitle: post.title || "",
      chapterTitle: "",
      onExit,
      onShare: () => setShareOpen(true),
      aiChatHref
    }), /* @__PURE__ */ jsx("div", {
      className: "px-1",
      children: /* @__PURE__ */ jsx(InterviewPostBody, {})
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: shareOpen,
      onClose: () => setShareOpen(false),
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(SharePanel, {
        url: url4post(post),
        title: post.title,
        tags: post.tags,
        onClose: () => setShareOpen(false)
      })
    })]
  });
};
const BookCairMediaPostView = ({
  postId,
  source = "desktop"
}) => {
  useReaderLayoutMode(source);
  return /* @__PURE__ */ jsx(LoadPostViewData, {
    dialog: false,
    postId,
    children: /* @__PURE__ */ jsx(CircleSearchSSEContextProvider, {
      inPost: true,
      children: /* @__PURE__ */ jsx(BookCairMediaPostViewInner, {
        source
      })
    })
  }, postId);
};

const findVisiblePageId$1 = (container) => {
  const pages = Array.from(container.querySelectorAll("[data-page-id]"));
  if (!pages.length)
    return null;
  const containerRect = container.getBoundingClientRect();
  const mid = containerRect.top + containerRect.height / 2;
  for (let i = 0; i < pages.length; i++) {
    const rect = pages[i].getBoundingClientRect();
    if (rect.bottom >= mid) {
      return pages[i].getAttribute("data-page-id") || null;
    }
  }
  return pages[pages.length - 1].getAttribute("data-page-id") || null;
};
const BookCairDesktopLayoutInner = () => {
  const {
    post
  } = useBookReader();
  const postId = post && post._id ? String(post._id) : "";
  if (post && isMediaPost(post)) {
    return /* @__PURE__ */ jsx(BookCairMediaPostView, {
      postId
    });
  }
  return /* @__PURE__ */ jsx(ReaderTextSelectionProvider, {
    children: /* @__PURE__ */ jsx(ReaderAnnotationProvider, {
      postId,
      children: /* @__PURE__ */ jsx(ReaderSearchProvider, {
        children: /* @__PURE__ */ jsx(ReaderAskAiProvider, {
          children: /* @__PURE__ */ jsx(BookCairDesktopLayoutContent, {})
        })
      })
    })
  });
};
const BookCairDesktopLayoutContent = () => {
  const history = useHistory();
  const {
    post,
    totalPages,
    getPageIndex,
    getPageId
  } = useBookReader();
  const postId = post && post._id;
  const [shareOpen, setShareOpen] = useState(false);
  const shareUrl = bookCairReaderUrl(postId);
  const postIdStr = postId ? String(postId) : "";
  const layoutMode = useReaderLayoutMode("desktop");
  const isTablet = layoutMode === "tablet";
  const [expandedChapterId, setExpandedChapterId] = useState(null);
  const [rightPanelMode, setRightPanelMode] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [readingPercent, setReadingPercent] = useState(0);
  const {
    uiAccessType,
    isLocked,
    metadataTitle,
    metadataAuthor,
    metadataLanguage,
    metadataSummary,
    navigateToPayment
  } = useBookAccess();
  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const [summaryOpen, setSummaryOpen] = useState(false);
  const {
    bookmarks,
    notes,
    addBookmark,
    addNote,
    remove,
    scrollToAnnotation,
    activeAnnotation,
    setActiveAnnotation,
    clearAnnotationScroll
  } = useReaderAnnotation();
  const [pendingContext, setPendingContext] = useState(null);
  useEffect(() => {
    if (activeAnnotation) {
      setRightPanelMode(activeAnnotation.type === "note" ? "note" : "bookmark");
    }
  }, [activeAnnotation]);
  const {
    selectionPos,
    selectionContext,
    handleTextSelect,
    clearSelection
  } = useReaderTextSelection();
  const {
    setQuery: prefillSearch
  } = useReaderSearch();
  const {
    setQuery: prefillAskAi
  } = useReaderAskAiActions();
  const {
    isReadOnly,
    requireLogin
  } = useReaderAuth();
  const scrollContainerRef = useRef(null);
  const {
    resumePageId
  } = useReadPosition(isReadOnly || isLocked ? null : postId, scrollContainerRef);
  const [visiblePageId, setVisiblePageId] = useState(null);
  const audioPageId = visiblePageId || (totalPages > 0 ? getPageId(0) : null);
  const currentPage = visiblePageId ? getPageIndex(visiblePageId) + 1 : 1;
  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el)
      return;
    let cancelled = false;
    const tick = () => {
      if (cancelled)
        return;
      const pid = findVisiblePageId$1(el);
      if (pid) {
        setVisiblePageId(pid);
        return;
      }
      setTimeout(tick, 200);
    };
    tick();
    return () => {
      cancelled = true;
    };
  }, []);
  const audioCircleId = post ? postGroupId(post) : "";
  const nextAudioPageId = useMemo(() => {
    if (!audioPageId)
      return null;
    return getPageId(getPageIndex(audioPageId) + 1) || null;
  }, [audioPageId, getPageIndex, getPageId]);
  useBookPageAudio(nextAudioPageId, audioCircleId);
  const handleAdvance = useMemoizedFn((currentPageId) => {
    const nextIndex = getPageIndex(currentPageId) + 1;
    const nextId = getPageId(nextIndex);
    if (!nextId)
      return null;
    history.replace({
      hash: `?chunk=${nextId}`
    });
    return nextId;
  });
  const [bookmarkName, setBookmarkName] = useState("");
  const [noteText, setNoteText] = useState("");
  const snackbar = useCairSnackbar();
  const tocChapters = useBookTocItems({
    postId: postIdStr,
    totalPages,
    readingPercent,
    expandedChapterId
  });
  const handleOpenPanel = useMemoizedFn((panel) => {
    if (isReadOnly && (panel === "bookmark" || panel === "note" || panel === "ask-ai" || panel === "language" || panel === "search")) {
      requireLogin();
      return;
    }
    if (selectionContext && (panel === "bookmark" || panel === "note")) {
      setPendingContext(selectionContext);
    }
    if (selectionContext && panel === "search") {
      prefillSearch(selectionContext.selectedText);
    }
    if (selectionContext && panel === "ask-ai") {
      prefillAskAi(selectionContext.selectedText);
    }
    setRightPanelMode(panel);
    setActiveAnnotation(null);
    clearSelection();
  });
  const handleClosePanel = useMemoizedFn(() => {
    setRightPanelMode(null);
    setActiveAnnotation(null);
    setPendingContext(null);
    setBookmarkName("");
    setNoteText("");
  });
  const handleTtsToggle = useMemoizedFn(() => null);
  const handleTocNavigate = useMemoizedFn((item) => {
    clearAnnotationScroll();
    navigateToTocItem(item, history);
    setExpandedChapterId(item.id);
  });
  const handleScroll = useMemoizedFn((e) => {
    const el = e.currentTarget;
    if (!el)
      return;
    const scrollable = el.scrollHeight - el.clientHeight;
    if (scrollable > 0) {
      setReadingPercent(Math.round(el.scrollTop / scrollable * 100));
    }
    const pid = findVisiblePageId$1(el);
    if (pid)
      setVisiblePageId((prev) => prev === pid ? prev : pid);
  });
  const handleBookmarkSave = useMemoizedFn(() => {
    if (!bookmarkName.trim() || !pendingContext)
      return;
    addBookmark({
      name: bookmarkName.trim(),
      selectedText: pendingContext.selectedText,
      pageId: pendingContext.pageId,
      startOffset: pendingContext.startOffset,
      endOffset: pendingContext.endOffset,
      language: pendingContext.language
    });
    snackbar.show("success", "Bookmark added");
    handleClosePanel();
  });
  const handleNoteSave = useMemoizedFn(() => {
    if (!noteText.trim() || !pendingContext)
      return;
    addNote({
      name: noteText.trim(),
      selectedText: pendingContext.selectedText,
      pageId: pendingContext.pageId,
      startOffset: pendingContext.startOffset,
      endOffset: pendingContext.endOffset,
      language: pendingContext.language
    });
    snackbar.show("success", "Note saved");
    handleClosePanel();
  });
  const handleQuickNote = useMemoizedFn(() => {
    if (!selectionContext)
      return;
    addNote({
      selectedText: selectionContext.selectedText,
      pageId: selectionContext.pageId,
      startOffset: selectionContext.startOffset,
      endOffset: selectionContext.endOffset,
      language: selectionContext.language
    });
    clearSelection();
  });
  const handleSidebarBookmarkClick = useMemoizedFn((id) => {
    scrollToAnnotation(id);
    handleClosePanel();
  });
  const tocBookmarks = useMemo(() => bookmarks.map((b) => ({
    id: b.id,
    name: b.name,
    chapterLabel: `p.${getPageIndex(b.pageId) + 1}`
  })), [bookmarks, getPageIndex]);
  const tocNotes = useMemo(() => notes.map((n) => ({
    id: n.id,
    name: displayLabel(n),
    chapterLabel: `p.${getPageIndex(n.pageId) + 1}`
  })), [notes, getPageIndex]);
  const sidebarAccessType = uiAccessType === "collection" ? "included" : isLocked ? "locked" : "free";
  const bookMeta = useMemo(() => ({
    title: post && post.title || metadataTitle || "",
    subtitle: "",
    author: metadataAuthor || "",
    accessType: sidebarAccessType,
    image: post && post.image,
    contentLanguage: post && post.language || metadataLanguage || "en"
  }), [post, metadataTitle, metadataAuthor, metadataLanguage, sidebarAccessType]);
  const isRtl = post && post.language === "ar" || metadataLanguage === "ar";
  const protoRightPanelMode = rightPanelMode === "language" || rightPanelMode === "bookmark" || rightPanelMode === "note" || rightPanelMode === "ask-ai" ? null : rightPanelMode;
  const languagePanelOpen = rightPanelMode === "language";
  const sidebar = /* @__PURE__ */ jsx(BookCairDesktopSidebar, {
    book: bookMeta,
    toc: tocChapters,
    onTocNavigate: handleTocNavigate,
    bookmarks: tocBookmarks,
    notes: tocNotes,
    onBack: () => {
      const cid = post ? postGroupId(post) : "";
      window.location.href = bookCairDashboardUrl(cid || void 0);
    },
    onShare: () => setShareOpen(true),
    onBookmarkClick: handleSidebarBookmarkClick,
    onNoteClick: handleSidebarBookmarkClick,
    onViewDetails: () => setViewDetailsOpen(true)
  });
  return /* @__PURE__ */ jsxs("div", {
    dir: "ltr",
    className: "flex h-full overflow-hidden bg-[var(--cair-surface-background)]",
    children: [isTablet ? /* @__PURE__ */ jsxs(Fragment, {
      children: [sidebarOpen && /* @__PURE__ */ jsx("div", {
        className: "fixed inset-0 bg-black/30 z-[39]",
        onClick: () => setSidebarOpen(false)
      }), /* @__PURE__ */ jsx("div", {
        className: "absolute left-0 top-0 h-full z-[40] transition-transform duration-200" + (sidebarOpen ? "" : " -translate-x-full"),
        children: sidebar
      })]
    }) : sidebar, /* @__PURE__ */ jsxs("div", {
      className: "relative flex flex-col flex-1 min-w-0",
      children: [/* @__PURE__ */ jsx(BookCairDesktopReadingHeader, {
        chapterIndex: 1,
        chapterTotal: totalPages,
        progressPercent: readingPercent,
        currentPage,
        pageTotal: totalPages,
        toolbarExpanded: true,
        rightPanelMode,
        onOpenPanel: handleOpenPanel,
        isTablet,
        onToggleSidebar: () => setSidebarOpen((v) => !v)
      }), /* @__PURE__ */ jsxs(BookAccessGate, {
        dialogPlacement: isTablet ? "bottom" : "center",
        children: [/* @__PURE__ */ jsxs("div", {
          ref: scrollContainerRef,
          className: ["flex-1 overflow-y-auto relative bg-[var(--cair-surface-background)]", "transition-[padding] duration-200", !isTablet && rightPanelMode !== null ? "pr-[320px]" : ""].join(" "),
          dir: isRtl ? "rtl" : "ltr",
          onScroll: handleScroll,
          onMouseUp: handleTextSelect,
          onTouchEnd: handleTextSelect,
          children: [/* @__PURE__ */ jsx("div", {
            className: "max-w-[768px] mx-auto py-[32px]",
            children: /* @__PURE__ */ jsx(BookReaderPages, {
              resumePageId
            })
          }), selectionPos && /* @__PURE__ */ jsx("div", {
            "data-selection-menu": true,
            className: "absolute z-20",
            style: {
              top: selectionPos.top,
              left: (() => {
                const MENU_W = 134;
                const GAP = 8;
                const w = scrollContainerRef.current && scrollContainerRef.current.clientWidth || 0;
                const contentW = Math.min(768, w);
                const margin = (w - contentW) / 2;
                const menuLeft = margin - GAP - MENU_W;
                return Math.max(8, menuLeft);
              })()
            },
            onMouseUp: (e) => e.stopPropagation(),
            children: /* @__PURE__ */ jsx(SelectionMenu, {
              onAskAi: () => handleOpenPanel("ask-ai"),
              onBookmark: () => handleOpenPanel("bookmark"),
              onNote: handleQuickNote
            })
          })]
        }), /* @__PURE__ */ jsx(BookCairDesktopAudioPlayer, {
          visible: true,
          chapterTitle: post && post.title || "",
          pageId: audioPageId,
          circleId: audioCircleId,
          onAdvance: handleAdvance
        }), /* @__PURE__ */ jsx("div", {
          className: "absolute right-[12px] bottom-[96px] z-10",
          children: /* @__PURE__ */ jsx(SpeakButton, {
            onClick: () => handleOpenPanel("ask-ai")
          })
        }), /* @__PURE__ */ jsx("div", {
          className: ["absolute top-0 right-0 h-full w-[320px] z-[50]", "bg-[var(--cair-surface-elevated)] border-l border-[var(--cair-divider)]", "overflow-y-auto transition-transform duration-200", rightPanelMode === "bookmark" ? "translate-x-0" : "translate-x-full"].join(" "),
          children: activeAnnotation && activeAnnotation.type === "bookmark" ? /* @__PURE__ */ jsx(AddBookmarkPanel, {
            mode: "view",
            entry: activeAnnotation,
            onRemove: remove,
            onClose: handleClosePanel
          }) : /* @__PURE__ */ jsx(AddBookmarkPanel, {
            name: bookmarkName,
            onChange: setBookmarkName,
            selectedText: pendingContext ? pendingContext.selectedText : void 0,
            onSave: handleBookmarkSave,
            onClose: handleClosePanel
          })
        }), /* @__PURE__ */ jsx("div", {
          className: ["absolute top-0 right-0 h-full w-[320px] z-[50]", "bg-[var(--cair-surface-elevated)] border-l border-[var(--cair-divider)]", "overflow-y-auto transition-transform duration-200", rightPanelMode === "note" ? "translate-x-0" : "translate-x-full"].join(" "),
          children: activeAnnotation && activeAnnotation.type === "note" ? /* @__PURE__ */ jsx(AddNotePanel, {
            mode: "view",
            entry: activeAnnotation,
            onRemove: remove,
            onClose: handleClosePanel
          }) : /* @__PURE__ */ jsx(AddNotePanel, {
            text: noteText,
            onChange: setNoteText,
            selectedText: pendingContext ? pendingContext.selectedText : void 0,
            onSave: handleNoteSave,
            onClose: handleClosePanel
          })
        }), /* @__PURE__ */ jsx(BookCairDesktopRightPanel, {
          mode: protoRightPanelMode,
          onClose: handleClosePanel,
          onTtsToggle: handleTtsToggle
        }), /* @__PURE__ */ jsx("div", {
          className: ["absolute top-0 right-0 h-full w-[320px] z-[50]", "bg-[var(--cair-surface-elevated)] border-l border-[var(--cair-divider)]", "flex flex-col transition-transform duration-200", languagePanelOpen ? "translate-x-0" : "translate-x-full"].join(" "),
          children: /* @__PURE__ */ jsx(ConnectedLanguageTranslationPanel, {
            onClose: handleClosePanel
          })
        }), /* @__PURE__ */ jsx("div", {
          className: ["absolute top-0 right-0 h-full w-[320px] z-[50]", "bg-[var(--cair-surface-elevated)] border-l border-[var(--cair-divider)]", "overflow-y-auto transition-transform duration-200", rightPanelMode === "ask-ai" ? "translate-x-0" : "translate-x-full"].join(" "),
          children: /* @__PURE__ */ jsx(ConnectedAskAiPanel, {
            onClose: handleClosePanel,
            onToggleVoice: handleTtsToggle
          })
        })]
      })]
    }), /* @__PURE__ */ jsx(CairSnackbar, {
      ...snackbar.props
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: shareOpen,
      onClose: () => setShareOpen(false),
      size: "sm",
      placement: "center",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(SharePanel, {
        url: shareUrl,
        title: post ? post.title : void 0,
        tags: post && post.tags ? post.tags : void 0,
        onClose: () => setShareOpen(false)
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: viewDetailsOpen,
      onClose: () => setViewDetailsOpen(false),
      placement: isTablet ? "bottom" : "center",
      size: "sm",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(BookDetailsPanel, {
        title: metadataTitle || (post ? post.title : ""),
        image: post && post.image,
        author: metadataAuthor,
        language: metadataLanguage,
        accessType: uiAccessType,
        hasAccess: !isLocked,
        onUnlock: navigateToPayment,
        onSubscribe: navigateToPayment,
        onStartReading: () => setViewDetailsOpen(false),
        onSupportDonate: () => setViewDetailsOpen(false),
        onReadSummary: () => {
          setViewDetailsOpen(false);
          setSummaryOpen(true);
        },
        onClose: () => setViewDetailsOpen(false)
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: summaryOpen,
      onClose: () => setSummaryOpen(false),
      placement: isTablet ? "bottom" : "center",
      size: "sm",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(BookSummaryPanel, {
        title: metadataTitle || (post ? post.title : ""),
        summary: metadataSummary,
        language: metadataLanguage,
        onClose: () => setSummaryOpen(false)
      })
    })]
  });
};
const BookCairDesktopLayout$1 = ({
  postId,
  showWelcomeBar
}) => {
  const {
    profile,
    authenticationRequired
  } = useProfileContext();
  if (!profile && !authenticationRequired)
    return /* @__PURE__ */ jsx(LoadingOverlay, {
      isOpen: true
    });
  return /* @__PURE__ */ jsx(LanguageSelectionContextProvider, {
    children: /* @__PURE__ */ jsx(CairTokensProvider, {
      children: /* @__PURE__ */ jsx(BookReaderProvider, {
        postId,
        children: /* @__PURE__ */ jsx(ReaderAuthProvider, {
          postId,
          children: showWelcomeBar ? /* @__PURE__ */ jsxs("div", {
            dir: "ltr",
            className: "flex flex-col h-full",
            children: [/* @__PURE__ */ jsx(CairWelcomeBarConnected, {}), /* @__PURE__ */ jsx("div", {
              className: "flex-1 min-h-0",
              children: /* @__PURE__ */ jsx(BookCairDesktopLayoutInner, {})
            })]
          }) : /* @__PURE__ */ jsx(BookCairDesktopLayoutInner, {})
        })
      })
    })
  });
};

const Inner$2 = ({
  postId
}) => {
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(FullViewportCssOverrides, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns h-full",
      children: postId ? /* @__PURE__ */ jsx(BookCairDesktopLayout$1, {
        postId,
        showWelcomeBar: true
      }) : /* @__PURE__ */ jsxs("div", {
        className: "p-4 text-sm text-gray-500",
        children: ["No postId \u2014 append /", /* @__PURE__ */ jsx("span", {
          className: "font-mono",
          children: "{postId}"
        }), " to the URL."]
      })
    })]
  });
};
const BookCairDesktopLive = (props) => /* @__PURE__ */ jsx(ReaderTokenGate, {
  children: /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(ProfileCDNImageContextProvider, {
      children: /* @__PURE__ */ jsx(Inner$2, {
        ...props
      })
    })
  })
});

const ReturningBanner = ({
  userName,
  bookTitle,
  chapterTitle,
  lastReadLabel,
  onBackToLibrary,
  onStartFromBeginning,
  onPickUpWhereLeftOff
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col gap-[20px] w-full",
  children: [/* @__PURE__ */ jsxs("button", {
    onClick: onBackToLibrary,
    className: " w-full flex items-center gap-[16px] bg-[var(--cair-surface-elevated)] border-b border-[var(--cair-border-strong)] rounded-[var(--cair-radius-lg)] px-[16px] py-[12px] shadow-[var(--cair-shadow-sm)] ",
    children: [/* @__PURE__ */ jsx(MdChevronLeft, {
      size: 24,
      className: "shrink-0 text-[color:var(--cair-text)]"
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-1 min-w-0 border-l border-[var(--cair-border)] pl-[24px]",
      children: /* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-medium,18px)] font-normal text-[color:var(--cair-text)] leading-[1.75]",
        children: "Back to your library"
      })
    })]
  }), /* @__PURE__ */ jsxs("div", {
    className: " w-full flex flex-col gap-[16px] items-center bg-[var(--cair-surface-elevated)] border-b border-[var(--cair-border-strong)] rounded-[var(--cair-radius-lg)] px-[24px] pt-[20px] pb-[17px] shadow-[var(--cair-shadow-sm)] ",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full flex flex-col gap-[8px]",
      children: [/* @__PURE__ */ jsxs("p", {
        className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text)] leading-[1.5]",
        children: ["Welcome back ", userName, ","]
      }), /* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-medium,18px)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
        children: bookTitle
      }), /* @__PURE__ */ jsx("div", {
        className: "w-full h-px bg-[var(--cair-divider)]"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
          children: "You were reading:"
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
          children: chapterTitle
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-[8px] px-[10px] py-[4px] bg-[#e6f7ff] border border-[#69c0ff] rounded-[4px] self-start",
        children: [/* @__PURE__ */ jsx(MdOutlineWatchLater, {
          size: 16,
          className: "shrink-0 text-[#096dd9]"
        }), /* @__PURE__ */ jsx("span", {
          className: "text-[length:var(--cair-text-tiny)] font-semibold text-[#096dd9] leading-[1.5] whitespace-nowrap",
          children: lastReadLabel
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "w-full h-px bg-[var(--cair-divider)]"
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex flex-col gap-[12px] items-center",
      children: [/* @__PURE__ */ jsx(ActionButton, {
        intent: "cairDefault",
        size: "md",
        rounded: "sm",
        onClick: onStartFromBeginning,
        className: "w-full",
        children: "Start from beginning"
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        onClick: onPickUpWhereLeftOff,
        className: "w-full",
        children: "Pick up where you left off"
      })]
    })]
  })]
});

const tocNavigateNoop = (_item) => void 0;

const AccordionRow = ({
  label,
  expanded,
  onToggle,
  surface = "default"
}) => /* @__PURE__ */ jsxs("button", {
  onClick: onToggle,
  className: `
      w-full flex items-center justify-between px-[24px] py-[12px]
      border-b border-[var(--cair-border-strong)]
      ${surface === "elevated" ? "bg-[var(--cair-surface-elevated)]" : "bg-[var(--cair-surface)]"}
    `,
  children: [/* @__PURE__ */ jsx("span", {
    className: "text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
    children: label
  }), expanded ? /* @__PURE__ */ jsx(MdExpandLess, {
    size: 20,
    className: "text-[color:var(--cair-text-secondary)] shrink-0"
  }) : /* @__PURE__ */ jsx(MdExpandMore, {
    size: 20,
    className: "text-[color:var(--cair-text-secondary)] shrink-0"
  })]
});
const InteractionItem = ({
  icon,
  name,
  chapterLabel,
  highlighted,
  onClick
}) => /* @__PURE__ */ jsxs("button", {
  onClick,
  className: `
      w-full flex items-center gap-[8px] p-[8px] rounded-[var(--cair-radius-md)]
      ${highlighted ? "bg-[var(--cair-selection)]" : ""}
    `,
  children: [/* @__PURE__ */ jsx("span", {
    className: "shrink-0 w-[16px] h-[16px] flex items-center justify-center text-[color:var(--cair-text)]",
    children: icon
  }), /* @__PURE__ */ jsx("span", {
    className: "flex-1 text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text)] font-normal leading-[1.2] text-left truncate",
    children: name
  }), /* @__PURE__ */ jsx("span", {
    className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.2] shrink-0",
    children: chapterLabel
  })]
});
const Footer = ({
  onContinueReading,
  onSearch
}) => {
  const intl = useIntl();
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex items-center gap-[8px] px-[16px] pt-[17px] pb-[16px] border-t border-[var(--cair-border)] bg-[var(--cair-surface)]",
    children: [/* @__PURE__ */ jsx(ActionButton, {
      intent: "cairPrimary",
      size: "md",
      rounded: "sm",
      onClick: onContinueReading,
      className: "flex-1",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "br.content.continue"
      })
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "cairDefault",
      size: "md",
      rounded: "sm",
      onClick: onSearch,
      leftIcon: /* @__PURE__ */ jsx(MdSearch, {
        size: 20
      }),
      children: intl.formatMessage({
        id: "br.content.search"
      })
    })]
  });
};
const ContentPanel = ({
  chapters,
  bookmarks,
  notes,
  initialSection = "toc",
  onTocNavigate = tocNavigateNoop,
  onBookmarkSelect,
  onNoteSelect,
  onContinueReading,
  onSearch,
  onClose
}) => {
  const intl = useIntl();
  const [openSection, setOpenSection] = useState(initialSection || "toc");
  const toggle = (section) => setOpenSection((prev) => prev === section ? null : section);
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col bg-[var(--cair-surface-elevated)] rounded-t-[var(--cair-radius-lg)] border-b border-[var(--cair-border-strong)]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full flex items-center justify-between px-[24px] pt-[16px] pb-[17px] border-b border-[var(--cair-border)]",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-[8px]",
        children: [/* @__PURE__ */ jsx(MdMenuBook, {
          size: 20,
          className: "text-[color:var(--cair-accent)]"
        }), /* @__PURE__ */ jsx("span", {
          className: "text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "br.content.title"
          })
        })]
      }), /* @__PURE__ */ jsx("button", {
        onClick: onClose,
        className: "w-[20px] h-[20px] flex items-center justify-center text-[color:var(--cair-text-secondary)]",
        "aria-label": intl.formatMessage({
          id: "br.content.close"
        }),
        children: /* @__PURE__ */ jsx(MdClose, {
          size: 16
        })
      })]
    }), /* @__PURE__ */ jsx(AccordionRow, {
      label: intl.formatMessage({
        id: "br.content.toc"
      }),
      expanded: openSection === "toc",
      onToggle: () => toggle("toc"),
      surface: "elevated"
    }), openSection === "toc" && /* @__PURE__ */ jsx("div", {
      className: "w-full bg-[var(--cair-surface)] max-h-[40vh] overflow-y-auto",
      children: chapters.map((ch) => /* @__PURE__ */ jsx(ChapterRow, {
        chapter: ch,
        onTocNavigate
      }, ch.id))
    }), /* @__PURE__ */ jsx(AccordionRow, {
      label: intl.formatMessage({
        id: "br.content.bookmarks"
      }),
      expanded: openSection === "bookmarks",
      onToggle: () => toggle("bookmarks"),
      surface: "elevated"
    }), openSection === "bookmarks" && /* @__PURE__ */ jsx("div", {
      className: "w-full px-[24px] py-[12px] bg-[var(--cair-surface-elevated)] flex flex-col max-h-[40vh] overflow-y-auto",
      children: bookmarks.length > 0 ? bookmarks.map((bm, i) => /* @__PURE__ */ jsx(InteractionItem, {
        icon: /* @__PURE__ */ jsx(MdBookmark, {
          size: 14
        }),
        name: bm.name,
        chapterLabel: bm.chapterLabel,
        highlighted: i === 0,
        onClick: () => onBookmarkSelect && onBookmarkSelect(bm.id)
      }, bm.id)) : /* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] py-[8px]",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.content.noBm"
        })
      })
    }), /* @__PURE__ */ jsx(AccordionRow, {
      label: intl.formatMessage({
        id: "br.content.notes"
      }),
      expanded: openSection === "notes",
      onToggle: () => toggle("notes"),
      surface: "elevated"
    }), openSection === "notes" && /* @__PURE__ */ jsx("div", {
      className: "w-full px-[24px] py-[12px] bg-[var(--cair-surface-elevated)] flex flex-col max-h-[40vh] overflow-y-auto",
      children: notes.length > 0 ? notes.map((note, i) => /* @__PURE__ */ jsx(InteractionItem, {
        icon: /* @__PURE__ */ jsx(MdNotes, {
          size: 14
        }),
        name: note.name,
        chapterLabel: note.chapterLabel,
        highlighted: i === 0,
        onClick: () => onNoteSelect && onNoteSelect(note.id)
      }, note.id)) : /* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] py-[8px]",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "br.content.noNotes"
        })
      })
    }), /* @__PURE__ */ jsx(Footer, {
      onContinueReading,
      onSearch
    })]
  });
};

const MobileReaderPanels = ({
  panels,
  post,
  metadataTitle,
  metadataAuthor,
  metadataSummary,
  metadataLanguage,
  uiAccessType,
  hasAccess,
  navigateToPayment,
  tocChapters,
  onTocNavigate
}) => {
  const {
    activePanel,
    openPanel,
    closePanel
  } = panels;
  const noop = () => void 0;
  const postId = post && post._id ? String(post._id) : "";
  const shareUrl = bookCairReaderUrl(postId);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "share",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(SharePanel, {
        url: shareUrl,
        title: post ? post.title : void 0,
        tags: post && post.tags ? post.tags : void 0,
        onClose: closePanel
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "returning",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(ReturningBanner, {
        userName: "",
        bookTitle: post ? post.title : "",
        chapterTitle: "",
        lastReadLabel: "",
        onBackToLibrary: closePanel,
        onStartFromBeginning: closePanel,
        onPickUpWhereLeftOff: closePanel
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "toc",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(ContentPanel, {
        chapters: tocChapters,
        bookmarks: panels.tocBookmarks,
        notes: panels.tocNotes,
        onContinueReading: closePanel,
        onSearch: () => panels.openPanel("search"),
        onClose: closePanel,
        onTocNavigate,
        onBookmarkSelect: panels.handleSidebarEntryClick,
        onNoteSelect: panels.handleSidebarEntryClick
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "search",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(ConnectedSearchPanel, {
        onClose: closePanel
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "askAi",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(ConnectedAskAiPanel, {
        onClose: closePanel,
        onToggleVoice: noop
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "settings",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(ReaderPreferencesPanel, {
        onClose: closePanel
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "translate",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(ConnectedLanguageTranslationPanel, {
        onClose: closePanel
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "bookmark",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: panels.activeAnnotation && panels.activeAnnotation.type === "bookmark" ? /* @__PURE__ */ jsx(AddBookmarkPanel, {
        mode: "view",
        entry: panels.activeAnnotation,
        onRemove: panels.remove,
        onClose: closePanel
      }) : /* @__PURE__ */ jsx(AddBookmarkPanel, {
        name: panels.bookmarkName,
        onChange: panels.setBookmarkName,
        selectedText: panels.pendingContext ? panels.pendingContext.selectedText : void 0,
        onSave: panels.handleBookmarkSave,
        onClose: closePanel
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "note",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: panels.activeAnnotation && panels.activeAnnotation.type === "note" ? /* @__PURE__ */ jsx(AddNotePanel, {
        mode: "view",
        entry: panels.activeAnnotation,
        onRemove: panels.remove,
        onClose: closePanel
      }) : /* @__PURE__ */ jsx(AddNotePanel, {
        text: panels.noteText,
        onChange: panels.setNoteText,
        selectedText: panels.pendingContext ? panels.pendingContext.selectedText : void 0,
        onSave: panels.handleNoteSave,
        onClose: closePanel
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "details",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(BookDetailsPanel, {
        title: metadataTitle || (post ? post.title : ""),
        image: post && post.image,
        author: metadataAuthor,
        accessType: uiAccessType,
        hasAccess,
        onUnlock: navigateToPayment,
        onSubscribe: navigateToPayment,
        onStartReading: closePanel,
        onSupportDonate: navigateToPayment,
        onReadSummary: () => openPanel("summary"),
        onClose: closePanel
      })
    }), /* @__PURE__ */ jsx(Dialog$3, {
      isOpen: activePanel === "summary",
      onClose: closePanel,
      placement: "bottom",
      showCloseButton: false,
      children: /* @__PURE__ */ jsx(BookSummaryPanel, {
        title: metadataTitle || (post ? post.title : ""),
        summary: metadataSummary,
        language: metadataLanguage,
        onClose: closePanel
      })
    })]
  });
};

const useMobileReaderPanels = () => {
  const { getPageIndex } = useBookReader();
  const { isReadOnly, requireLogin } = useReaderAuth();
  const { selectionPos, selectionContext, handleTextSelect, clearSelection } = useReaderTextSelection();
  const { setQuery: prefillSearch } = useReaderSearch();
  const { setQuery: prefillAskAi } = useReaderAskAiActions();
  const {
    bookmarks,
    notes,
    addBookmark,
    addNote,
    remove,
    scrollToAnnotation,
    activeAnnotation,
    setActiveAnnotation
  } = useReaderAnnotation();
  const snackbar = useCairSnackbar();
  const intl = useIntl();
  const [activePanel, setActivePanel] = useState("returning");
  const [dialOpen, setDialOpen] = useState(false);
  const [pendingContext, setPendingContext] = useState(null);
  useEffect(() => {
    if (activeAnnotation) {
      setActivePanel(activeAnnotation.type === "note" ? "note" : "bookmark");
    }
  }, [activeAnnotation]);
  const openPanel = useMemoizedFn((panel) => {
    if (isReadOnly && (panel === "askAi" || panel === "bookmark" || panel === "note" || panel === "translate" || panel === "search")) {
      requireLogin();
      return;
    }
    if (selectionContext && (panel === "bookmark" || panel === "note")) {
      setPendingContext(selectionContext);
    }
    if (selectionContext && panel === "search") {
      prefillSearch(selectionContext.selectedText);
    }
    if (selectionContext && panel === "askAi") {
      prefillAskAi(selectionContext.selectedText);
    }
    setActivePanel(panel);
    setDialOpen(false);
    clearSelection();
  });
  const closePanel = useMemoizedFn(() => {
    setActivePanel(null);
    setActiveAnnotation(null);
    setPendingContext(null);
    setBookmarkName("");
    setNoteText("");
  });
  const [bookmarkName, setBookmarkName] = useState("");
  const [noteText, setNoteText] = useState("");
  const [aiQuery, setAiQuery] = useState("");
  const [aiState, setAiState] = useState({ phase: "idle" });
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults] = useState([]);
  const handleBookmarkSave = useMemoizedFn(() => {
    if (!bookmarkName.trim() || !pendingContext)
      return;
    addBookmark({
      name: bookmarkName.trim(),
      selectedText: pendingContext.selectedText,
      pageId: pendingContext.pageId,
      startOffset: pendingContext.startOffset,
      endOffset: pendingContext.endOffset,
      language: pendingContext.language
    });
    snackbar.show("success", intl.formatMessage({ id: "br.snack.bmAdded" }));
    closePanel();
  });
  const handleNoteSave = useMemoizedFn(() => {
    if (!noteText.trim() || !pendingContext)
      return;
    addNote({
      name: noteText.trim(),
      selectedText: pendingContext.selectedText,
      pageId: pendingContext.pageId,
      startOffset: pendingContext.startOffset,
      endOffset: pendingContext.endOffset,
      language: pendingContext.language
    });
    snackbar.show("success", intl.formatMessage({ id: "br.snack.noteSaved" }));
    closePanel();
  });
  const handleQuickNote = useMemoizedFn(() => {
    if (!selectionContext)
      return;
    addNote({
      selectedText: selectionContext.selectedText,
      pageId: selectionContext.pageId,
      startOffset: selectionContext.startOffset,
      endOffset: selectionContext.endOffset,
      language: selectionContext.language
    });
    snackbar.show("success", intl.formatMessage({ id: "br.snack.noteSaved" }));
    clearSelection();
  });
  const handleAiSubmit = useMemoizedFn(() => {
    if (!aiQuery.trim())
      return;
    setAiState({ phase: "answer-ref", answer: "AI responses are scoped to this document only.", refs: [] });
  });
  const handleAiClose = useMemoizedFn(() => {
    setAiQuery("");
    setAiState({ phase: "idle" });
    closePanel();
  });
  const handleSidebarEntryClick = useMemoizedFn((id) => {
    scrollToAnnotation(id);
    closePanel();
  });
  const tocBookmarks = useMemo(() => bookmarks.map((b) => ({ id: b.id, name: b.name, chapterLabel: `p.${getPageIndex(b.pageId) + 1}` })), [bookmarks, getPageIndex]);
  const tocNotes = useMemo(() => notes.map((n) => ({ id: n.id, name: n.name, chapterLabel: `p.${getPageIndex(n.pageId) + 1}` })), [notes, getPageIndex]);
  const toggleDial = useMemoizedFn(() => setDialOpen((v) => !v));
  return {
    activePanel,
    dialOpen,
    openPanel,
    closePanel,
    selectionPos,
    handleTextSelect,
    snackbarProps: snackbar.props,
    bookmarkName,
    setBookmarkName,
    noteText,
    setNoteText,
    aiQuery,
    setAiQuery,
    aiState,
    searchQuery,
    setSearchQuery,
    searchResults,
    handleBookmarkSave,
    handleNoteSave,
    handleAiSubmit,
    handleAiClose,
    handleQuickNote,
    handleSidebarEntryClick,
    pendingContext,
    activeAnnotation,
    remove,
    tocBookmarks,
    tocNotes,
    toggleDial
  };
};

const dialButtonClass = ["flex items-center justify-center", "w-[40px] h-[40px] rounded-full shrink-0", "bg-[var(--cair-surface-elevated)]", "border border-[var(--cair-border)]", "shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.1),0px_4px_6px_-4px_rgba(0,0,0,0.1)]", "cursor-pointer", "transition-opacity duration-150"].join(" ");
const FloatingActionsDial = ({
  open,
  onToggle,
  actions,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: ["flex flex-col items-start gap-[8px] w-[40px]", className || ""].join(" "),
  children: [/* @__PURE__ */ jsx("button", {
    className: dialButtonClass,
    onClick: onToggle,
    "aria-label": open ? "Close actions menu" : "Open actions menu",
    "aria-expanded": open,
    children: open ? /* @__PURE__ */ jsx(MdClose, {
      size: 20,
      className: "text-[color:var(--cair-text)]"
    }) : /* @__PURE__ */ jsx(MdMenu, {
      size: 20,
      className: "text-[color:var(--cair-text)]"
    })
  }), open && actions.map((action) => /* @__PURE__ */ jsx("button", {
    className: [dialButtonClass, action.disabled ? "opacity-40 cursor-not-allowed" : ""].join(" "),
    onClick: action.disabled ? void 0 : action.onClick,
    "aria-label": action.label,
    disabled: action.disabled,
    children: /* @__PURE__ */ jsx("span", {
      className: "flex items-center justify-center w-[20px] h-[20px] text-[color:var(--cair-text)]",
      children: action.icon
    })
  }, action.key))]
});

const buildActions = (props, labels) => {
  const {
    tier,
    onSearch,
    onAskAi,
    onSettings,
    onTranslate,
    onToc,
    onSave
  } = props;
  const paid = tier === "paid";
  const actions = [];
  if (paid) {
    actions.push({
      key: "search",
      icon: /* @__PURE__ */ jsx(MdSearch, {
        size: 20
      }),
      label: labels.search,
      onClick: onSearch || (() => void 0),
      disabled: !onSearch
    });
    actions.push({
      key: "ask-ai",
      icon: /* @__PURE__ */ jsx(MdAutoAwesome, {
        size: 20
      }),
      label: labels.askAi,
      onClick: onAskAi || (() => void 0),
      disabled: !onAskAi
    });
  }
  actions.push({
    key: "settings",
    icon: /* @__PURE__ */ jsx(MdSettings, {
      size: 20
    }),
    label: labels.settings,
    onClick: onSettings
  });
  actions.push({
    key: "translate",
    icon: /* @__PURE__ */ jsx(MdTranslate, {
      size: 20
    }),
    label: labels.translate,
    onClick: onTranslate
  });
  if (paid) {
    actions.push({
      key: "toc",
      icon: /* @__PURE__ */ jsx(MdMenuBook, {
        size: 20
      }),
      label: labels.toc,
      onClick: onToc || (() => void 0),
      disabled: !onToc
    });
    actions.push({
      key: "save",
      icon: /* @__PURE__ */ jsx(MdBookmark, {
        size: 20
      }),
      label: labels.save,
      onClick: onSave || (() => void 0),
      disabled: !onSave
    });
  }
  return actions;
};
const ReaderActionsDial = (props) => {
  const intl = useIntl();
  const labels = {
    search: intl.formatMessage({
      id: "br.dial.search"
    }),
    askAi: intl.formatMessage({
      id: "br.dial.askAi"
    }),
    settings: intl.formatMessage({
      id: "br.dial.settings"
    }),
    translate: intl.formatMessage({
      id: "br.dial.translate"
    }),
    toc: intl.formatMessage({
      id: "br.dial.toc"
    }),
    save: intl.formatMessage({
      id: "br.dial.save"
    })
  };
  return /* @__PURE__ */ jsx(FloatingActionsDial, {
    open: props.open,
    onToggle: props.onToggle,
    actions: buildActions(props, labels),
    className: props.className
  });
};

const findVisiblePageId = (container) => {
  const pages = Array.from(container.querySelectorAll("[data-page-id]"));
  if (!pages.length)
    return null;
  const containerRect = container.getBoundingClientRect();
  const mid = containerRect.top + containerRect.height / 2;
  for (let i = 0; i < pages.length; i++) {
    const rect = pages[i].getBoundingClientRect();
    if (rect.bottom >= mid) {
      return pages[i].getAttribute("data-page-id") || null;
    }
  }
  return pages[pages.length - 1].getAttribute("data-page-id") || null;
};
const BookCairReaderScreenInner = () => {
  const {
    post
  } = useBookReader();
  const postId = post && post._id ? String(post._id) : "";
  if (!post) {
    return null;
  }
  if (post && isMediaPost(post)) {
    return /* @__PURE__ */ jsx(BookCairMediaPostView, {
      postId,
      source: "mobile"
    });
  }
  return /* @__PURE__ */ jsx(ReaderTextSelectionProvider, {
    children: /* @__PURE__ */ jsx(ReaderAnnotationProvider, {
      postId,
      children: /* @__PURE__ */ jsx(ReaderSearchProvider, {
        children: /* @__PURE__ */ jsx(ReaderAskAiProvider, {
          children: /* @__PURE__ */ jsx(BookCairReaderScreenContent, {})
        })
      })
    })
  });
};
const BookCairReaderScreenContent = () => {
  useReaderLayoutMode("mobile");
  const history = useHistory();
  const {
    post,
    totalPages,
    getPageId,
    getPageIndex
  } = useBookReader();
  const {
    isLocked,
    uiAccessType,
    metadataTitle,
    metadataAuthor,
    metadataSummary,
    metadataLanguage,
    navigateToPayment
  } = useBookAccess();
  const {
    isReadOnly
  } = useReaderAuth();
  const scrollContainerRef = useRef(null);
  const postId = post && post._id ? String(post._id) : "";
  const {
    resumePageId
  } = useReadPosition(isReadOnly || isLocked ? null : postId, scrollContainerRef);
  const [readingPercent, setReadingPercent] = useState(0);
  const [visiblePageId, setVisiblePageId] = useState(null);
  const audioPageId = visiblePageId || (totalPages > 0 ? getPageId(0) : null);
  const audioCircleId = post ? postGroupId(post) : "";
  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el)
      return;
    let cancelled = false;
    const tick = () => {
      if (cancelled)
        return;
      const pid = findVisiblePageId(el);
      if (pid) {
        setVisiblePageId(pid);
        return;
      }
      setTimeout(tick, 200);
    };
    tick();
    return () => {
      cancelled = true;
    };
  }, []);
  const nextAudioPageId = useMemo(() => {
    if (!audioPageId)
      return null;
    return getPageId(getPageIndex(audioPageId) + 1) || null;
  }, [audioPageId, getPageIndex, getPageId]);
  useBookPageAudio(nextAudioPageId, audioCircleId);
  const handleAdvance = useMemoizedFn((currentPageId) => {
    const nextIndex = getPageIndex(currentPageId) + 1;
    const nextId = getPageId(nextIndex);
    if (!nextId)
      return null;
    history.replace({
      hash: `?chunk=${nextId}`
    });
    return nextId;
  });
  const panels = useMobileReaderPanels();
  const {
    clearAnnotationScroll
  } = useReaderAnnotation();
  const tocChapters = useBookTocItems({
    postId,
    totalPages,
    readingPercent
  });
  const handleTocNavigate = useMemoizedFn((item) => {
    clearAnnotationScroll();
    navigateToTocItem(item, history);
    panels.closePanel();
  });
  const handleScroll = useMemoizedFn((e) => {
    const el = e.currentTarget;
    const percent = el.scrollHeight > el.clientHeight ? Math.round(el.scrollTop / (el.scrollHeight - el.clientHeight) * 100) : 0;
    setReadingPercent(percent);
    const pid = findVisiblePageId(el);
    if (pid && pid !== visiblePageId)
      setVisiblePageId(pid);
  });
  return /* @__PURE__ */ jsxs("div", {
    dir: "ltr",
    className: "relative flex flex-col h-full overflow-hidden bg-[var(--cair-surface)]",
    children: [/* @__PURE__ */ jsx("div", {
      className: "absolute top-0 left-0 right-0 z-30 pointer-events-none",
      children: /* @__PURE__ */ jsx(ReadingProgressBar, {
        variant: "premium",
        percent: readingPercent
      })
    }), /* @__PURE__ */ jsx(ReaderTopBar, {
      bookTitle: post ? post.title : metadataTitle || "",
      chapterTitle: "",
      locked: isLocked,
      onExit: () => {
        const cid = post ? postGroupId(post) : "";
        window.location.href = bookCairDashboardUrl(cid || void 0);
      },
      onShare: () => panels.openPanel("share"),
      onViewDetails: () => panels.openPanel("details"),
      aiChatHref: getAiChatReturnHref(post ? postGroupId(post) : void 0)
    }), /* @__PURE__ */ jsx(BookAccessGate, {
      dialogPlacement: "bottom",
      children: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsxs("div", {
          ref: scrollContainerRef,
          className: "flex-1 overflow-y-auto relative",
          onScroll: handleScroll,
          onMouseUp: panels.handleTextSelect,
          onTouchEnd: panels.handleTextSelect,
          children: [panels.selectionPos && /* @__PURE__ */ jsx("div", {
            "data-selection-menu": true,
            className: "absolute z-20",
            style: {
              top: panels.selectionPos.top,
              left: panels.selectionPos.left
            },
            onMouseUp: (e) => e.stopPropagation(),
            children: /* @__PURE__ */ jsx(SelectionMenu, {
              onAskAi: () => panels.openPanel("askAi"),
              onBookmark: () => panels.openPanel("bookmark"),
              onNote: panels.handleQuickNote
            })
          }), /* @__PURE__ */ jsx(BookReaderPages, {
            resumePageId
          }), /* @__PURE__ */ jsx("div", {
            className: "h-[140px]"
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "absolute right-[12px] top-[128px] z-10",
          children: /* @__PURE__ */ jsx(ReaderActionsDial, {
            tier: "paid",
            open: panels.dialOpen,
            onToggle: panels.toggleDial,
            onSettings: () => panels.openPanel("settings"),
            onTranslate: () => panels.openPanel("translate"),
            onSearch: () => panels.openPanel("search"),
            onAskAi: () => panels.openPanel("askAi"),
            onToc: () => panels.openPanel("toc"),
            onSave: () => panels.openPanel("bookmark")
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "absolute right-[12px] bottom-[96px] z-10",
          children: /* @__PURE__ */ jsx(SpeakButton, {
            onClick: () => panels.openPanel("askAi")
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "absolute bottom-[90px] left-0 right-0 z-10 flex justify-center pointer-events-none",
          children: /* @__PURE__ */ jsx(CairSnackbar, {
            ...panels.snackbarProps
          })
        })]
      })
    }), /* @__PURE__ */ jsx(MobileReaderPanels, {
      panels,
      post,
      metadataTitle,
      metadataAuthor,
      metadataSummary,
      metadataLanguage,
      uiAccessType,
      hasAccess: !isLocked,
      navigateToPayment,
      tocChapters,
      onTocNavigate: handleTocNavigate
    }), !isLocked && /* @__PURE__ */ jsx(BookCairDesktopAudioPlayer, {
      visible: true,
      chapterTitle: post && post.title || "",
      pageId: audioPageId,
      circleId: audioCircleId,
      onAdvance: handleAdvance
    })]
  });
};
const BookCairMobileLiveScreen = ({
  postId,
  showWelcomeBar
}) => {
  const {
    profile,
    authenticationRequired
  } = useProfileContext();
  if (!profile && !authenticationRequired)
    return /* @__PURE__ */ jsx(LoadingOverlay, {
      isOpen: true
    });
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    children: /* @__PURE__ */ jsx(LanguageSelectionContextProvider, {
      children: /* @__PURE__ */ jsx(BookReaderProvider, {
        postId,
        children: /* @__PURE__ */ jsx(ReaderAuthProvider, {
          postId,
          children: showWelcomeBar ? /* @__PURE__ */ jsxs("div", {
            dir: "ltr",
            className: "flex flex-col h-full",
            children: [/* @__PURE__ */ jsx(CairWelcomeBarConnected, {}), /* @__PURE__ */ jsx("div", {
              className: "flex-1 min-h-0",
              children: /* @__PURE__ */ jsx(BookCairReaderScreenInner, {})
            })]
          }) : /* @__PURE__ */ jsx(BookCairReaderScreenInner, {})
        })
      })
    })
  });
};

const Inner$1 = ({
  postId
}) => {
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(FullViewportCssOverrides, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns h-full",
      children: postId ? /* @__PURE__ */ jsx(BookCairMobileLiveScreen, {
        postId
      }) : /* @__PURE__ */ jsxs("div", {
        className: "p-4 text-sm text-gray-500",
        children: ["No postId \u2014 append /", /* @__PURE__ */ jsx("span", {
          className: "font-mono",
          children: "{postId}"
        }), " to the URL."]
      })
    })]
  });
};
const BookCairMobileLive = (props) => /* @__PURE__ */ jsx(ReaderTokenGate, {
  children: /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(ProfileCDNImageContextProvider, {
      children: /* @__PURE__ */ jsx(Inner$1, {
        ...props
      })
    })
  })
});

const Inner = ({
  children,
  circleId,
  showWelcomeBar = true
}) => {
  const {
    profile
  } = useProfileContext();
  if (!profile)
    return null;
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(FullViewportCssOverrides, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns h-full flex flex-col",
      children: [showWelcomeBar && /* @__PURE__ */ jsx(CairWelcomeBar, {
        circleId
      }), /* @__PURE__ */ jsx("div", {
        className: "flex-1 min-h-0 overflow-auto",
        children
      })]
    })]
  });
};
const BookCairLivePage = (props) => /* @__PURE__ */ jsx(SWRProfileContextProvider, {
  children: /* @__PURE__ */ jsx(ProfileCDNImageContextProvider, {
    children: /* @__PURE__ */ jsx(Inner, {
      ...props
    })
  })
});

var GlobeBookIcon = function(props) {
  var s = props.size || 14;
  return /* @__PURE__ */ jsx("svg", {
    width: s,
    height: s,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: props.style,
    children: /* @__PURE__ */ jsx("path", {
      d: "M6.99735 1.6593C7.73906 1.6593 8.43109 1.79658 9.07344 2.07113C9.71588 2.34569 10.2788 2.72233 10.7622 3.20105C10.9994 3.44362 11.2149 3.70559 11.4085 3.98695C11.6021 4.26831 11.7679 4.56537 11.906 4.87813C12.0712 5.25225 12.1825 5.63802 12.2396 6.03547C12.2968 6.43291 12.3168 6.84625 12.2997 7.27549C12.2923 7.41802 12.2396 7.53886 12.1416 7.63803C12.0437 7.73729 11.9195 7.78693 11.769 7.78693C11.6353 7.78693 11.5241 7.73661 11.4352 7.63599C11.3464 7.53546 11.3058 7.41875 11.3131 7.28584C11.3326 7.10394 11.3374 6.93045 11.3276 6.76536C11.3178 6.60018 11.3004 6.43374 11.2755 6.26603H9.27046C9.28757 6.43685 9.29855 6.60519 9.30342 6.77105C9.30828 6.93701 9.30701 7.11352 9.29962 7.30057C9.2899 7.44086 9.23969 7.55699 9.14898 7.64897C9.05837 7.74094 8.9434 7.78693 8.80408 7.78693C8.67458 7.78693 8.56326 7.73851 8.47013 7.64168C8.37708 7.54484 8.33056 7.43143 8.33056 7.30145C8.33056 7.11381 8.33115 6.93701 8.33231 6.77105C8.33348 6.60519 8.32546 6.43685 8.30825 6.26603H5.70367C5.68646 6.43685 5.67542 6.60519 5.67056 6.77105C5.6657 6.93701 5.66327 7.11381 5.66327 7.30145C5.66327 7.43143 5.61724 7.54484 5.52517 7.64168C5.433 7.73851 5.32299 7.78693 5.19515 7.78693C5.05476 7.78693 4.93916 7.74094 4.84835 7.64897C4.75765 7.55699 4.70743 7.44115 4.69771 7.30145C4.68799 7.11381 4.68556 6.93701 4.69042 6.77105C4.69528 6.60519 4.70626 6.43685 4.72338 6.26603H2.73902C2.71297 6.43374 2.69488 6.60018 2.68477 6.76536C2.67466 6.93045 2.67933 7.10511 2.69877 7.28934C2.70616 7.42225 2.66547 7.53838 2.57671 7.63774C2.48785 7.7372 2.37658 7.78693 2.2429 7.78693C2.0924 7.78693 1.96819 7.73919 1.87029 7.64372C1.77229 7.54834 1.7196 7.43046 1.71221 7.29007C1.6951 6.86084 1.71513 6.44506 1.77229 6.04276C1.82946 5.64045 1.94185 5.25225 2.10946 4.87813C2.24557 4.56469 2.41017 4.26758 2.60325 3.9868C2.79633 3.70602 3.01183 3.44411 3.24973 3.20105C3.73312 2.72233 4.2937 2.34569 4.93148 2.07113C5.56935 1.79658 6.25798 1.6593 6.99735 1.6593ZM3.01844 5.32482H4.8364C4.9166 4.83472 5.02924 4.39771 5.17429 4.01378C5.31944 3.62985 5.5186 3.24694 5.77177 2.86505C5.13817 3.04005 4.58114 3.34207 4.10067 3.77111C3.62029 4.20016 3.25955 4.71806 3.01844 5.32482ZM5.82033 5.32482H8.1805C8.10272 4.82354 7.95747 4.34711 7.74475 3.89551C7.53203 3.44391 7.28333 3.01006 6.99867 2.59395C6.71167 3.00772 6.46239 3.44075 6.25083 3.89303C6.03928 4.34531 5.89578 4.82257 5.82033 5.32482ZM9.15773 5.32482H10.997C10.7559 4.72272 10.3921 4.20657 9.90571 3.77636C9.41921 3.34616 8.85916 3.04238 8.22556 2.86505C8.48106 3.24694 8.6808 3.63043 8.82479 4.01553C8.96868 4.40063 9.07966 4.83706 9.15773 5.32482ZM6.99837 12.3372C6.85594 12.3372 6.73758 12.2901 6.64327 12.1958C6.54896 12.1016 6.50181 11.9831 6.50181 11.8404C6.50181 11.1431 6.31694 10.5948 5.94721 10.1954C5.57747 9.79588 5.12121 9.59613 4.57842 9.59613H1.57148C1.42876 9.59613 1.31088 9.54903 1.21783 9.45482C1.12469 9.36052 1.07812 9.24215 1.07812 9.09972C1.07812 8.95719 1.12528 8.83872 1.21958 8.74432C1.31379 8.64982 1.43226 8.60257 1.57498 8.60257H4.57842C5.06686 8.60257 5.52128 8.71204 5.94167 8.93099C6.36206 9.14993 6.71439 9.45273 6.99867 9.83938C7.28294 9.45273 7.63285 9.14993 8.04837 8.93099C8.4639 8.71204 8.91589 8.60257 9.40433 8.60257H12.4259C12.5683 8.60257 12.6867 8.64972 12.7811 8.74403C12.8755 8.83824 12.9227 8.95729 12.9227 9.10118C12.9227 9.24497 12.8755 9.36343 12.7811 9.45657C12.6867 9.54961 12.5683 9.59613 12.4259 9.59613H9.40433C8.87224 9.59613 8.42108 9.79884 8.05085 10.2043C7.68063 10.6098 7.49552 11.1563 7.49552 11.8439C7.49552 11.9866 7.44827 12.1045 7.35377 12.1975C7.25927 12.2906 7.14081 12.3372 6.99837 12.3372Z",
      fill: "currentColor"
    })
  });
};
const configs = {
  collection: {
    icon: MdLayers,
    label: "Included",
    bg: "#F9F4EB",
    border: "#E8DDCC",
    textColor: "#8B6914",
    iconColor: "#8B6914"
  },
  free: {
    icon: GlobeBookIcon,
    label: "Free",
    bg: "#FFFFFF",
    border: "#E8E9EC",
    textColor: "#000000",
    iconColor: "#000000"
  },
  locked: {
    icon: MdLock,
    label: "Locked",
    bg: "#1E2C44",
    border: "#1E2C44",
    textColor: "#FFFFFF",
    iconColor: "#FFFFFF"
  }
};
const AccessTypeBadge = ({
  type,
  className
}) => {
  const cfg = configs[type];
  var Icon = cfg.icon;
  return /* @__PURE__ */ jsxs("div", {
    className: "inline-flex items-center gap-[4px] pl-[4px] pr-[6px] py-[4px] rounded-[16px] shrink-0 " + (className || ""),
    style: {
      backgroundColor: cfg.bg,
      border: "1px solid " + cfg.border
    },
    children: [/* @__PURE__ */ jsx(Icon, {
      size: 14,
      style: {
        color: cfg.iconColor
      }
    }), /* @__PURE__ */ jsx("span", {
      className: "text-[length:var(--cair-text-tiny)] font-normal leading-[1.2]",
      style: {
        color: cfg.textColor
      },
      children: cfg.label
    })]
  });
};

const RTL_CHARS$1 = /[؀-ۿ]/;
const dirOf$1 = (text) => text && RTL_CHARS$1.test(text) ? "rtl" : "ltr";
const BookCard$1 = ({
  image,
  title,
  author,
  publisher,
  description,
  accessType,
  progress,
  onClick,
  className
}) => {
  var hasProgress = progress != null && progress > 0;
  var progressPercent = hasProgress ? Math.min(Math.max(progress, 0), 1) * 100 : 0;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col bg-[var(--cair-surface-elevated)] rounded-[12px] overflow-hidden cursor-pointer " + (className || ""),
    style: {
      border: "1px solid var(--cair-border)"
    },
    onClick,
    children: [/* @__PURE__ */ jsx("div", {
      className: "relative w-full flex justify-center py-[16px] bg-[var(--cair-surface)]",
      style: {
        borderBottom: "1px solid var(--cair-border)"
      },
      children: /* @__PURE__ */ jsxs("div", {
        className: "relative",
        children: [/* @__PURE__ */ jsx(BookCover, {
          image,
          width: 132,
          height: 192,
          radius: "md"
        }), /* @__PURE__ */ jsx("div", {
          className: "absolute top-[8px] left-[8px]",
          children: /* @__PURE__ */ jsx(AccessTypeBadge, {
            type: accessType
          })
        })]
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col p-[16px]",
      children: [publisher && /* @__PURE__ */ jsx("div", {
        className: "pb-[4px]",
        children: /* @__PURE__ */ jsx("p", {
          dir: dirOf$1(publisher),
          className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
          children: publisher
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "pb-[4px]",
        children: /* @__PURE__ */ jsx("p", {
          dir: dirOf$1(title),
          className: "text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
          children: title
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "pb-[12px]",
        children: /* @__PURE__ */ jsx("p", {
          dir: dirOf$1(author),
          className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
          children: author
        })
      }), description && /* @__PURE__ */ jsx("div", {
        className: "pb-[16px]",
        children: /* @__PURE__ */ jsx("p", {
          dir: dirOf$1(description),
          className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5] line-clamp-2",
          children: description
        })
      }), hasProgress && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between pt-[13px]",
        style: {
          borderTop: "1px solid var(--cair-border)"
        },
        children: [/* @__PURE__ */ jsx("div", {
          className: "flex-1 pr-[16px]",
          style: {
            height: 6
          },
          children: /* @__PURE__ */ jsx("div", {
            className: "w-full h-full rounded-[9999px]",
            style: {
              backgroundColor: "var(--cair-surface)"
            },
            children: /* @__PURE__ */ jsx("div", {
              className: "h-full rounded-[9999px]",
              style: {
                width: progressPercent + "%",
                backgroundColor: "var(--cair-accent)"
              }
            })
          })
        }), /* @__PURE__ */ jsxs("span", {
          className: "text-[length:12px] font-normal text-[color:var(--cair-text-tertiary)] leading-[16px] shrink-0",
          children: [Math.round(progressPercent), "% read"]
        })]
      })]
    })]
  });
};

const mapBook = (b) => ({
  id: b.id,
  title: b.title,
  author: b.author,
  publisher: b.publisher || "",
  description: b.description || "",
  image: b.image || void 0,
  accessType: toBadgeAccessType(parseAccessType(b.accessType)),
  subject: b.subject || "",
  tags: b.tags || [],
  pageCount: b.pageCount || 0,
  progress: b.progress
});
const buildQuery$1 = (f, skip) => {
  const parts = [];
  parts.push("skip=" + skip);
  parts.push("limit=" + f.pageSize);
  if (f.search)
    parts.push("search=" + encodeURIComponent(f.search));
  f.subjects.forEach((s) => parts.push("subject=" + encodeURIComponent(s)));
  f.publishers.forEach((p) => parts.push("publisher=" + encodeURIComponent(p)));
  if (f.accessType !== "all")
    parts.push("accessType=" + f.accessType);
  if (f.sort !== "upload_date")
    parts.push("sort=" + f.sort);
  return parts.join("&");
};
const filtersKey = (f) => [f.search, f.accessType, f.sort, f.subjects.join(","), f.publishers.join(",")].join("|");
const useBrowseBooks = (circleId, filters) => {
  const api = useApi();
  const [books, setBooks] = useState([]);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [serverFilters, setServerFilters] = useState({ subjects: [], publishers: [] });
  const [skip, setSkip] = useState(0);
  const [isInitialLoading, setInitialLoading] = useState(false);
  const [isLoadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const fKey = filtersKey(filters);
  const lastKeyRef = useRef("");
  const reqSeqRef = useRef(0);
  useEffect(() => {
    if (lastKeyRef.current !== fKey + "|" + (circleId || "")) {
      lastKeyRef.current = fKey + "|" + (circleId || "");
      setSkip(0);
      setBooks([]);
      setTotal(0);
      setHasMore(false);
    }
  }, [fKey, circleId]);
  useEffect(() => {
    if (!circleId) {
      setBooks([]);
      setTotal(0);
      setHasMore(false);
      setError(null);
      return;
    }
    const isFirst = skip === 0;
    if (isFirst)
      setInitialLoading(true);
    else
      setLoadingMore(true);
    setError(null);
    const seq = ++reqSeqRef.current;
    const query = buildQuery$1(filters, skip);
    api.get({ path: `book-cair/circle/${circleId}/books?${query}` }).then((res) => {
      if (seq !== reqSeqRef.current)
        return;
      const nextBooks = (res.books || []).map(mapBook);
      setBooks((prev) => isFirst ? nextBooks : prev.concat(nextBooks));
      setTotal(res.total || 0);
      setHasMore(!!res.hasMore);
      setServerFilters({
        subjects: res.filters && res.filters.subjects || [],
        publishers: res.filters && res.filters.publishers || []
      });
    }).catch((e) => {
      if (seq !== reqSeqRef.current)
        return;
      setError(e);
    }).finally(() => {
      if (seq !== reqSeqRef.current)
        return;
      setInitialLoading(false);
      setLoadingMore(false);
    });
  }, [circleId, fKey, skip]);
  const loadMore = useMemoizedFn(() => {
    if (isLoadingMore || isInitialLoading || !hasMore)
      return;
    setSkip(books.length);
  });
  const reload = useMemoizedFn(() => {
    setSkip(0);
    setBooks([]);
    lastKeyRef.current = "";
  });
  return {
    books,
    total,
    hasMore,
    filters: serverFilters,
    isInitialLoading,
    isLoadingMore,
    error,
    loadMore,
    reload
  };
};

var SORT_OPTIONS = [{
  value: "upload_date",
  label: "Upload Date"
}, {
  value: "alphabetical",
  label: "Alphabetical"
}];
var ACCESS_OPTIONS = [{
  value: "all",
  label: "All"
}, {
  value: "free",
  label: "Free"
}, {
  value: "collection",
  label: "Collection"
}, {
  value: "locked",
  label: "Locked"
}];
var PAGE_SIZE$1 = 12;
var DEFAULT_FILTERS = {
  sortBy: "upload_date",
  subjects: [],
  publishers: [],
  accessType: "all"
};
var CheckboxItem = function(_ref) {
  var label = _ref.label;
  var checked = _ref.checked;
  var onChange = _ref.onChange;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-[8px] items-center cursor-pointer",
    onClick: function(e) {
      e.stopPropagation();
      onChange(!checked);
    },
    role: "checkbox",
    "aria-checked": checked,
    children: [/* @__PURE__ */ jsx("div", {
      className: "w-[18px] h-[18px] rounded-[2px] flex items-center justify-center shrink-0",
      style: {
        border: checked ? "none" : "1px solid #D9D9D9",
        backgroundColor: checked ? "var(--cair-accent)" : "transparent"
      },
      children: checked && /* @__PURE__ */ jsx(MdCheck, {
        size: 14,
        color: "white"
      })
    }), /* @__PURE__ */ jsx("span", {
      className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-accent)] leading-[1.5]",
      children: label
    })]
  });
};
var FilterContent = function(_ref) {
  var filters = _ref.filters;
  var onFilterChange = _ref.onFilterChange;
  var subjectOptions = _ref.subjectOptions;
  var publisherOptions = _ref.publisherOptions;
  var toggleArray = function(arr, value) {
    var idx = arr.indexOf(value);
    if (idx === -1)
      return arr.concat([value]);
    return arr.filter(function(v) {
      return v !== value;
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-[16px]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[12px]",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
        children: "Sort by"
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-[8px]",
        children: SORT_OPTIONS.map(function(opt) {
          return /* @__PURE__ */ jsx(CheckboxItem, {
            label: opt.label,
            checked: filters.sortBy === opt.value,
            onChange: function() {
              onFilterChange(Object.assign({}, filters, {
                sortBy: opt.value
              }));
            }
          }, opt.value);
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "w-full",
      style: {
        height: 1,
        backgroundColor: "var(--cair-divider, #f2f2f2)"
      }
    }), subjectOptions.length > 0 && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[12px]",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
        children: "Subject / Topic"
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-[8px]",
        children: subjectOptions.map(function(subject) {
          return /* @__PURE__ */ jsx(CheckboxItem, {
            label: subject,
            checked: filters.subjects.indexOf(subject) !== -1,
            onChange: function() {
              onFilterChange(Object.assign({}, filters, {
                subjects: toggleArray(filters.subjects, subject)
              }));
            }
          }, subject);
        })
      })]
    }), subjectOptions.length > 0 && /* @__PURE__ */ jsx("div", {
      className: "w-full",
      style: {
        height: 1,
        backgroundColor: "var(--cair-divider, #f2f2f2)"
      }
    }), publisherOptions.length > 0 && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[12px]",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
        children: "Publisher / Collection"
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-[8px]",
        children: publisherOptions.map(function(pub) {
          return /* @__PURE__ */ jsx(CheckboxItem, {
            label: pub,
            checked: filters.publishers.indexOf(pub) !== -1,
            onChange: function() {
              onFilterChange(Object.assign({}, filters, {
                publishers: toggleArray(filters.publishers, pub)
              }));
            }
          }, pub);
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "w-full",
      style: {
        height: 1,
        backgroundColor: "var(--cair-divider, #f2f2f2)"
      }
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[12px]",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
        children: "Access Type"
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-wrap gap-[8px]",
        children: ACCESS_OPTIONS.map(function(opt) {
          var isSelected = filters.accessType === opt.value;
          return /* @__PURE__ */ jsx("button", {
            className: "px-[12px] py-[6px] rounded-[4px] text-[length:var(--cair-text-small)] font-normal leading-[1.5]",
            style: {
              border: isSelected ? "1px solid rgba(2,2,3,0.15)" : "1px solid #D9D9D9",
              backgroundColor: isSelected ? "var(--cair-accent)" : "transparent",
              color: isSelected ? "white" : "var(--cair-accent)"
            },
            onClick: function() {
              onFilterChange(Object.assign({}, filters, {
                accessType: opt.value
              }));
            },
            children: opt.label
          }, opt.value);
        })
      })]
    })]
  });
};
const BrowseBooksPage = ({
  circleId
}) => {
  var [searchInput, setSearchInput] = useState("");
  var [searchQuery, setSearchQuery] = useState("");
  var [filters, setFilters] = useState(DEFAULT_FILTERS);
  var [showFilterSheet, setShowFilterSheet] = useState(false);
  var [showDesktopFilter, setShowDesktopFilter] = useState(false);
  useEffect(function() {
    var t = setTimeout(function() {
      setSearchQuery(searchInput.trim());
    }, 300);
    return function() {
      clearTimeout(t);
    };
  }, [searchInput]);
  var {
    books,
    total,
    hasMore,
    filters: serverFilterOpts,
    isInitialLoading,
    isLoadingMore,
    error,
    loadMore
  } = useBrowseBooks(circleId, {
    pageSize: PAGE_SIZE$1,
    search: searchQuery,
    subjects: filters.subjects,
    publishers: filters.publishers,
    accessType: filters.accessType,
    sort: filters.sortBy
  });
  var subjectOptions = serverFilterOpts.subjects;
  var publisherOptions = serverFilterOpts.publishers;
  var navigateToBook = useMemoizedFn(function(bookId) {
    window.location.href = bookCairReaderUrl(bookId);
  });
  var handleClearFilters = useMemoizedFn(function() {
    setFilters(DEFAULT_FILTERS);
  });
  var toggleFilter = useMemoizedFn(function() {
    if (window.innerWidth >= 768) {
      setShowDesktopFilter(function(v) {
        return !v;
      });
    } else {
      setShowFilterSheet(true);
    }
  });
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "w-full h-full bg-white flex flex-col relative",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "md:hidden w-full flex flex-col gap-[8px] px-[24px] pt-[16px] pb-[17px] bg-[var(--cair-surface)]",
        style: {
          borderBottom: "1px solid var(--cair-border-strong, #b3b3b3)",
          boxShadow: "0px 1px 2px rgba(0,0,0,0.05)"
        },
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center justify-between",
          children: [/* @__PURE__ */ jsx("button", {
            className: "w-[24px] h-[24px] flex items-center justify-center text-[color:var(--cair-text-secondary)]",
            onClick: function() {
              window.location.href = bookCairDashboardUrl(circleId);
            },
            children: /* @__PURE__ */ jsx(MdArrowBack, {
              size: 24
            })
          }), /* @__PURE__ */ jsx("div", {
            className: "flex-1 flex flex-col items-center pr-[24px]",
            children: /* @__PURE__ */ jsx("p", {
              className: "text-[length:var(--cair-text-small)] font-semibold text-[color:var(--cair-text)] leading-[1.75] cursor-pointer",
              onClick: function() {
                window.location.href = bookCairDashboardUrl(circleId);
              },
              children: "Dashboard"
            })
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "flex flex-col items-center",
          children: /* @__PURE__ */ jsx("p", {
            className: "text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
            children: "Browse books"
          })
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "hidden md:flex w-full flex-col gap-[8px] px-[200px] pt-[48px]",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex gap-[12px] items-center",
          children: [/* @__PURE__ */ jsxs("button", {
            className: "flex gap-[12px] items-center cursor-pointer",
            onClick: function() {
              window.location.href = bookCairDashboardUrl(circleId);
            },
            children: [/* @__PURE__ */ jsx(MdArrowBack, {
              size: 24,
              style: {
                color: "var(--cair-text-tertiary)"
              }
            }), /* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-medium)] font-medium text-[color:var(--cair-text-tertiary)] leading-[1.75]",
              children: "Dashboard"
            })]
          }), /* @__PURE__ */ jsx(MdChevronRight, {
            size: 24,
            style: {
              color: "var(--cair-text-tertiary)"
            }
          }), /* @__PURE__ */ jsx("span", {
            className: "text-[length:var(--cair-text-medium)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
            children: "Browse books"
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "w-full",
          style: {
            height: 1,
            backgroundColor: "var(--cair-divider, #f2f2f2)"
          }
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 flex min-h-0 relative",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex-1 flex flex-col min-h-0 overflow-auto items-center",
          children: [/* @__PURE__ */ jsx("div", {
            className: "w-full max-w-[768px]",
            style: {
              backdropFilter: "blur(2px)",
              backgroundColor: "rgba(255,255,255,0.95)",
              borderBottom: "1px solid #d0d0d0"
            },
            children: /* @__PURE__ */ jsxs("div", {
              className: "p-[16px] flex flex-col gap-[12px]",
              children: [/* @__PURE__ */ jsxs("div", {
                className: "flex gap-[8px] items-center px-[16px] rounded-[var(--cair-radius-md)]",
                style: {
                  border: "1px solid var(--cair-border)",
                  backgroundColor: "var(--cair-surface)",
                  height: 48
                },
                children: [/* @__PURE__ */ jsx(MdSearch, {
                  size: 20,
                  style: {
                    color: "var(--cair-text-tertiary)"
                  },
                  className: "shrink-0"
                }), /* @__PURE__ */ jsx("input", {
                  type: "text",
                  placeholder: "Search books, topics, or authors...",
                  value: searchInput,
                  onChange: function(e) {
                    setSearchInput(e.target.value);
                  },
                  className: "flex-1 bg-transparent text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] outline-none border-none",
                  style: {
                    color: "var(--cair-text)"
                  }
                }), searchInput && /* @__PURE__ */ jsx("button", {
                  onClick: function() {
                    setSearchInput("");
                  },
                  className: "shrink-0",
                  children: /* @__PURE__ */ jsx(MdClose, {
                    size: 16,
                    style: {
                      color: "var(--cair-text-tertiary)"
                    }
                  })
                })]
              }), /* @__PURE__ */ jsx("div", {
                className: "flex gap-[8px] items-start",
                children: /* @__PURE__ */ jsxs("button", {
                  className: "flex gap-[8px] items-center justify-center px-[12px] rounded-[var(--cair-radius-md)]",
                  style: {
                    border: "1px solid var(--cair-border)",
                    backgroundColor: "white",
                    height: 40
                  },
                  onClick: toggleFilter,
                  children: [/* @__PURE__ */ jsx(MdFilterList, {
                    size: 24,
                    style: {
                      color: "var(--cair-accent)"
                    }
                  }), /* @__PURE__ */ jsx("span", {
                    className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
                    children: "Filter"
                  })]
                })
              })]
            })
          }), /* @__PURE__ */ jsxs("div", {
            className: "w-full max-w-[1280px] px-[16px] pt-[24px] pb-[96px] flex flex-col gap-[24px]",
            children: [!circleId && /* @__PURE__ */ jsxs("p", {
              className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
              children: ["No circle selected \u2014 append /", "{circleId}", " to URL."]
            }), isInitialLoading && books.length === 0 && circleId && /* @__PURE__ */ jsx("div", {
              className: "flex items-center justify-center py-[80px]",
              children: /* @__PURE__ */ jsx(Spinner, {
                size: "xl",
                colorScheme: "gray"
              })
            }), error && books.length === 0 && !isInitialLoading && /* @__PURE__ */ jsx("div", {
              className: "flex items-center justify-center py-[40px]",
              children: /* @__PURE__ */ jsx("p", {
                className: "text-[length:var(--cair-text-regular)] text-red-500 leading-[1.5]",
                children: "Failed to load books."
              })
            }), circleId && !error && books.length > 0 && /* @__PURE__ */ jsxs("p", {
              className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
              children: ["Showing ", books.length, " of ", total, " result", total !== 1 ? "s" : ""]
            }), books.length > 0 && /* @__PURE__ */ jsx("div", {
              className: "flex flex-col md:flex-row md:flex-wrap gap-[16px]",
              children: books.map(function(book) {
                return /* @__PURE__ */ jsx("div", {
                  className: "w-full md:w-[calc(33.333%-11px)]",
                  children: /* @__PURE__ */ jsx(BookCard$1, {
                    image: book.image,
                    title: book.title,
                    author: book.author,
                    publisher: book.publisher,
                    description: book.description,
                    accessType: book.accessType,
                    progress: book.progress,
                    onClick: function() {
                      navigateToBook(book.id);
                    }
                  })
                }, book.id);
              })
            }), books.length === 0 && !isInitialLoading && circleId && !error && /* @__PURE__ */ jsx("div", {
              className: "py-[40px] text-center",
              children: /* @__PURE__ */ jsx("p", {
                className: "text-[length:var(--cair-text-regular)] text-[color:var(--cair-text-secondary)]",
                children: "No books found"
              })
            }), isLoadingMore && /* @__PURE__ */ jsx("div", {
              className: "flex items-center justify-center py-[16px]",
              children: /* @__PURE__ */ jsx(Spinner, {
                size: "lg",
                colorScheme: "gray"
              })
            }), hasMore && !isLoadingMore && /* @__PURE__ */ jsx("div", {
              className: "flex justify-center pt-[16px]",
              children: /* @__PURE__ */ jsx("button", {
                className: "px-[16px] flex items-center justify-center text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
                style: {
                  height: 44,
                  border: "1px solid var(--cair-border)",
                  backgroundColor: "var(--cair-accent-subtle)",
                  borderRadius: "var(--cair-radius-md)"
                },
                onClick: loadMore,
                children: "Load more results"
              })
            })]
          })]
        }), showDesktopFilter && /* @__PURE__ */ jsxs("div", {
          className: "hidden md:flex flex-col shrink-0 overflow-auto",
          style: {
            width: 320,
            borderLeft: "1px solid var(--cair-border-strong, #b3b3b3)",
            backgroundColor: "var(--cair-surface-elevated)",
            boxShadow: "0px 1px 2px rgba(0,0,0,0.05)"
          },
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex items-center justify-between px-[24px] pt-[16px] pb-[17px]",
            style: {
              borderBottom: "1px solid var(--cair-border)"
            },
            children: [/* @__PURE__ */ jsxs("div", {
              className: "flex gap-[8px] items-center",
              children: [/* @__PURE__ */ jsx(MdFilterList, {
                size: 20,
                style: {
                  color: "var(--cair-accent)"
                }
              }), /* @__PURE__ */ jsx("span", {
                className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
                children: "Filters"
              })]
            }), /* @__PURE__ */ jsx("button", {
              onClick: function() {
                setShowDesktopFilter(false);
              },
              className: "w-[20px] h-[20px] flex items-center justify-center",
              children: /* @__PURE__ */ jsx(MdClose, {
                size: 16,
                style: {
                  color: "var(--cair-text-secondary)"
                }
              })
            })]
          }), /* @__PURE__ */ jsx("div", {
            className: "flex-1 overflow-auto px-[24px] pt-[20px] pb-[17px]",
            style: {
              borderBottom: "1px solid var(--cair-border-strong, #b3b3b3)"
            },
            children: /* @__PURE__ */ jsx(FilterContent, {
              filters,
              onFilterChange: setFilters,
              subjectOptions,
              publisherOptions
            })
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex gap-[8px] px-[24px] py-[16px]",
            style: {
              boxShadow: "0px 1px 2px rgba(0,0,0,0.05)"
            },
            children: [/* @__PURE__ */ jsx("button", {
              className: "px-[16px] flex items-center justify-center text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75] shrink-0",
              style: {
                height: 46,
                border: "1px solid var(--cair-border)",
                backgroundColor: "var(--cair-accent-subtle)",
                borderRadius: "var(--cair-radius-md)"
              },
              onClick: handleClearFilters,
              children: "Clear"
            }), /* @__PURE__ */ jsx("button", {
              className: "flex-1 flex items-center justify-center text-[length:var(--cair-text-regular)] font-medium leading-[1.75]",
              style: {
                height: 46,
                border: "1px solid var(--cair-accent)",
                backgroundColor: "var(--cair-accent)",
                color: "white",
                borderRadius: "var(--cair-radius-md)"
              },
              onClick: function() {
                setShowDesktopFilter(false);
              },
              children: "Apply Filters"
            })]
          })]
        })]
      }), showFilterSheet && /* @__PURE__ */ jsxs("div", {
        className: "fixed inset-0 z-50 flex items-end justify-center md:hidden",
        children: [/* @__PURE__ */ jsx("div", {
          className: "absolute inset-0 bg-black/40",
          onClick: function() {
            setShowFilterSheet(false);
          }
        }), /* @__PURE__ */ jsxs("div", {
          className: "relative w-full bg-[var(--cair-surface-elevated)] rounded-t-[var(--cair-radius-lg)] flex flex-col",
          style: {
            maxHeight: "85vh",
            borderBottom: "1px solid var(--cair-border-strong, #b3b3b3)",
            boxShadow: "0px 1px 2px rgba(0,0,0,0.05)"
          },
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex items-center justify-between px-[24px] pt-[16px] pb-[17px]",
            style: {
              borderBottom: "1px solid var(--cair-border)"
            },
            children: [/* @__PURE__ */ jsxs("div", {
              className: "flex gap-[8px] items-center",
              children: [/* @__PURE__ */ jsx(MdFilterList, {
                size: 20,
                style: {
                  color: "var(--cair-accent)"
                }
              }), /* @__PURE__ */ jsx("span", {
                className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
                children: "Filters"
              })]
            }), /* @__PURE__ */ jsx("button", {
              onClick: function() {
                setShowFilterSheet(false);
              },
              className: "w-[20px] h-[20px] flex items-center justify-center",
              children: /* @__PURE__ */ jsx(MdClose, {
                size: 16,
                style: {
                  color: "var(--cair-text-secondary)"
                }
              })
            })]
          }), /* @__PURE__ */ jsx("div", {
            className: "flex-1 overflow-auto px-[24px] pt-[20px] pb-[17px]",
            style: {
              borderBottom: "1px solid var(--cair-border-strong, #b3b3b3)"
            },
            children: /* @__PURE__ */ jsx(FilterContent, {
              filters,
              onFilterChange: setFilters,
              subjectOptions,
              publisherOptions
            })
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex gap-[8px] px-[24px] py-[16px]",
            style: {
              boxShadow: "0px 1px 2px rgba(0,0,0,0.05)"
            },
            children: [/* @__PURE__ */ jsx("button", {
              className: "px-[16px] flex items-center justify-center text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75] shrink-0",
              style: {
                height: 46,
                border: "1px solid var(--cair-border)",
                backgroundColor: "var(--cair-accent-subtle)",
                borderRadius: "var(--cair-radius-md)"
              },
              onClick: function() {
                handleClearFilters();
                setShowFilterSheet(false);
              },
              children: "Clear"
            }), /* @__PURE__ */ jsx("button", {
              className: "flex-1 flex items-center justify-center text-[length:var(--cair-text-regular)] font-medium leading-[1.75]",
              style: {
                height: 46,
                border: "1px solid var(--cair-accent)",
                backgroundColor: "var(--cair-accent)",
                color: "white",
                borderRadius: "var(--cair-radius-md)"
              },
              onClick: function() {
                setShowFilterSheet(false);
              },
              children: "Apply Filters"
            })]
          })]
        })]
      })]
    })
  });
};

const BrowseBooksPageLive = ({
  circleId
}) => /* @__PURE__ */ jsx(BookCairLivePage, {
  circleId,
  children: /* @__PURE__ */ jsx(BrowseBooksPage, {
    circleId
  })
});

const RTL_CHARS = /[؀-ۿ]/;
const dirOf = (text) => text && RTL_CHARS.test(text) ? "rtl" : "ltr";
const LibraryBookItem = ({
  image,
  title,
  author,
  purchaseDate,
  price,
  progress,
  onClick,
  className
}) => {
  var hasProgress = progress != null && progress > 0;
  var progressPercent = hasProgress ? Math.min(Math.max(progress, 0), 1) * 100 : 0;
  return /* @__PURE__ */ jsxs("div", {
    className: "relative flex flex-col overflow-hidden cursor-pointer " + (className || ""),
    style: {
      border: "1px solid #D9D9D9",
      borderRadius: 8,
      backgroundColor: "white",
      boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
      padding: 13
    },
    onClick,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-[16px] items-start",
      children: [/* @__PURE__ */ jsx("div", {
        className: "shrink-0",
        children: /* @__PURE__ */ jsx(BookCover, {
          image,
          height: 140,
          width: 120,
          radius: "sm"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 min-w-0 flex flex-col gap-[4px]",
        children: [/* @__PURE__ */ jsx("p", {
          dir: dirOf(title),
          className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
          children: title
        }), /* @__PURE__ */ jsx("p", {
          dir: dirOf(author),
          className: "text-[length:var(--cair-text-tiny)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.2]",
          children: author
        }), purchaseDate && /* @__PURE__ */ jsxs("p", {
          className: "text-[length:var(--cair-text-tiny)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.2]",
          children: ["Purchased: ", purchaseDate]
        }), price && /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-tiny)] font-normal leading-[1.2]",
          style: {
            color: "#666"
          },
          children: price
        })]
      })]
    }), hasProgress && /* @__PURE__ */ jsx("div", {
      className: "absolute left-0 right-0",
      style: {
        bottom: -1,
        height: 4,
        backgroundColor: "#e5e7eb"
      },
      children: /* @__PURE__ */ jsx("div", {
        className: "h-full",
        style: {
          width: progressPercent + "%",
          backgroundColor: "#2a2b5f"
        }
      })
    })]
  });
};

const DEFAULT_LIBRARY_QUERY = {
  pageSize: 20,
  filter: { kind: "all" },
  search: ""
};
const mapItem = (b) => {
  const raw = parseAccessType(b.accessType);
  return {
    id: b.id,
    title: b.title,
    author: b.author,
    image: b.image || void 0,
    progress: typeof b.progress === "number" ? b.progress : 0,
    accessType: raw,
    allowedDomains: Array.isArray(b.allowedDomains) ? b.allowedDomains : [],
    collectionName: b.collectionName || "",
    circleId: b.circleId || ""
  };
};
const buildQuery = (q, skip) => {
  const parts = [];
  parts.push("skip=" + skip);
  parts.push("limit=" + q.pageSize);
  if (q.search)
    parts.push("search=" + encodeURIComponent(q.search));
  if (q.filter.kind !== "all") {
    parts.push("filter=" + q.filter.kind);
    if (q.filter.kind === "circle")
      parts.push("circleId=" + encodeURIComponent(q.filter.circleId));
    if (q.filter.kind === "domain")
      parts.push("domain=" + encodeURIComponent(q.filter.domain));
  }
  return parts.join("&");
};
const queryKey = (q) => {
  const f = q.filter;
  const fk = f.kind === "all" ? "all" : f.kind === "purchase" ? "purchase" : f.kind === "circle" ? "circle:" + f.circleId : "domain:" + f.domain;
  return fk + "|" + q.search;
};
const useMyLibrary = (query = DEFAULT_LIBRARY_QUERY) => {
  const api = useApi();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pills, setPills] = useState({ hasPurchase: false, circles: [], domains: [] });
  const [skip, setSkip] = useState(0);
  const [isInitialLoading, setInitialLoading] = useState(false);
  const [isLoadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const qKey = queryKey(query);
  const lastKeyRef = useRef("");
  const reqSeqRef = useRef(0);
  useEffect(() => {
    if (lastKeyRef.current !== qKey) {
      lastKeyRef.current = qKey;
      setSkip(0);
      setItems([]);
      setTotal(0);
      setHasMore(false);
    }
  }, [qKey]);
  useEffect(() => {
    const isFirst = skip === 0;
    if (isFirst)
      setInitialLoading(true);
    else
      setLoadingMore(true);
    setError(null);
    const seq = ++reqSeqRef.current;
    const qs = buildQuery(query, skip);
    api.get({ path: "book-cair/user/library?" + qs }).then((res) => {
      if (seq !== reqSeqRef.current)
        return;
      const next = (res.books || []).map(mapItem);
      setItems((prev) => isFirst ? next : prev.concat(next));
      setTotal(res.total || 0);
      setHasMore(!!res.hasMore);
      setPills({
        hasPurchase: !!(res.pills && res.pills.hasPurchase),
        circles: res.pills && res.pills.circles || [],
        domains: res.pills && res.pills.domains || []
      });
    }).catch((e) => {
      if (seq !== reqSeqRef.current)
        return;
      setError(e);
    }).finally(() => {
      if (seq !== reqSeqRef.current)
        return;
      setInitialLoading(false);
      setLoadingMore(false);
    });
  }, [qKey, skip]);
  const loadMore = useMemoizedFn(() => {
    if (isLoadingMore || isInitialLoading || !hasMore)
      return;
    setSkip(items.length);
  });
  const reload = useMemoizedFn(() => {
    setSkip(0);
    setItems([]);
    lastKeyRef.current = "";
  });
  return {
    items,
    total,
    hasMore,
    pills,
    isInitialLoading,
    isLoadingMore,
    error,
    loadMore,
    reload
  };
};

const PAGE_SIZE = 20;
const MyLibraryPage = () => {
  var [activePill, setActivePill] = useState("all");
  var apiFilter = useMemo(function() {
    if (activePill === "all")
      return {
        kind: "all"
      };
    if (activePill === "purchase")
      return {
        kind: "purchase"
      };
    if (activePill.indexOf("circle:") === 0) {
      return {
        kind: "circle",
        circleId: activePill.slice("circle:".length),
        name: ""
      };
    }
    if (activePill.indexOf("domain:") === 0) {
      return {
        kind: "domain",
        domain: activePill.slice("domain:".length)
      };
    }
    return {
      kind: "all"
    };
  }, [activePill]);
  var {
    items,
    total,
    hasMore,
    pills,
    isInitialLoading,
    isLoadingMore,
    error,
    loadMore
  } = useMyLibrary({
    pageSize: PAGE_SIZE,
    filter: apiFilter,
    search: ""
  });
  var navigateToBook = useMemoizedFn(function(bookId) {
    window.location.href = bookCairReaderUrl(bookId);
  });
  var filterPills = useMemo(function() {
    var list = [{
      value: "all",
      label: "View all"
    }];
    if (pills.hasPurchase) {
      list.push({
        value: "purchase",
        label: "Single Purchases"
      });
    }
    pills.circles.forEach(function(c) {
      list.push({
        value: "circle:" + c.id,
        label: c.name
      });
    });
    pills.domains.forEach(function(d) {
      list.push({
        value: "domain:" + d,
        label: "Domain @" + d
      });
    });
    return list;
  }, [pills]);
  var renderFilterPills = function() {
    return filterPills.map(function(pill) {
      var isActive = activePill === pill.value;
      return /* @__PURE__ */ jsx("button", {
        className: "px-[12px] py-[6px] rounded-[4px] text-[length:var(--cair-text-small)] font-normal leading-[1.5] whitespace-nowrap shrink-0",
        style: {
          border: isActive ? "1px solid rgba(2,2,3,0.15)" : "1px solid #D9D9D9",
          backgroundColor: isActive ? "#1E2C44" : "transparent",
          color: isActive ? "#FFFFFF" : "#1E2C44"
        },
        onClick: function() {
          setActivePill(pill.value);
        },
        children: pill.label
      }, pill.value);
    });
  };
  var renderBookList = function(cardClassName) {
    if (isInitialLoading && items.length === 0) {
      return /* @__PURE__ */ jsx("div", {
        className: "w-full flex items-center justify-center py-[80px]",
        children: /* @__PURE__ */ jsx(Spinner, {
          size: "xl",
          colorScheme: "gray"
        })
      });
    }
    if (error && items.length === 0) {
      return /* @__PURE__ */ jsx("div", {
        className: "w-full flex items-center justify-center py-[40px]",
        children: /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] text-red-500 leading-[1.5]",
          children: "Failed to load library."
        })
      });
    }
    if (items.length === 0) {
      return /* @__PURE__ */ jsx("div", {
        className: "w-full py-[40px] text-center",
        children: /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] text-[color:var(--cair-text-secondary)]",
          children: "No books in your library yet"
        })
      });
    }
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [items.map(function(item) {
        return /* @__PURE__ */ jsx(LibraryBookItem, {
          image: item.image,
          title: item.title,
          author: item.author,
          progress: item.progress,
          className: cardClassName,
          onClick: function() {
            navigateToBook(item.id);
          }
        }, item.id);
      }), isLoadingMore && /* @__PURE__ */ jsx("div", {
        className: "w-full flex items-center justify-center py-[16px]",
        children: /* @__PURE__ */ jsx(Spinner, {
          size: "lg",
          colorScheme: "gray"
        })
      }), hasMore && !isLoadingMore && /* @__PURE__ */ jsx("div", {
        className: "w-full flex justify-center py-[16px]",
        children: /* @__PURE__ */ jsxs("button", {
          className: "px-[16px] flex items-center justify-center text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-accent)] leading-[1.75]",
          style: {
            height: 44,
            border: "1px solid var(--cair-border)",
            backgroundColor: "var(--cair-accent-subtle)",
            borderRadius: "var(--cair-radius-md)"
          },
          onClick: loadMore,
          children: ["Load more (", total - items.length, " remaining)"]
        })
      })]
    });
  };
  return /* @__PURE__ */ jsxs(CairTokensProvider, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full md:hidden max-w-[480px] mx-auto min-h-full bg-[var(--cair-surface)] flex flex-col",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "w-full flex flex-col px-[24px] pt-[16px] pb-[12px] bg-[var(--cair-surface-elevated)]",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-[8px] mb-[4px]",
          children: [/* @__PURE__ */ jsx("button", {
            className: "w-[32px] h-[32px] flex items-center justify-center text-[color:var(--cair-text-secondary)]",
            onClick: function() {
              window.history.back();
            },
            children: /* @__PURE__ */ jsx(MdArrowBack, {
              size: 20
            })
          }), /* @__PURE__ */ jsx("span", {
            className: "text-[length:var(--cair-text-tiny)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
            children: "Your Profile"
          })]
        }), /* @__PURE__ */ jsx("h1", {
          className: "text-[length:var(--cair-text-large)] font-semibold text-[color:var(--cair-text)] leading-[1.4] ml-[40px]",
          children: "My Library"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "w-full flex gap-[8px] px-[24px] py-[12px] bg-[var(--cair-surface-elevated)] overflow-x-auto",
        style: {
          borderBottom: "1px solid var(--cair-border)"
        },
        children: renderFilterPills()
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-[12px] px-[24px] py-[20px]",
        children: renderBookList()
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "hidden md:flex w-full min-h-full bg-[var(--cair-surface-background,white)] flex-col",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[8px] px-[200px] pt-[48px]",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-[12px]",
          children: [/* @__PURE__ */ jsx("button", {
            className: "w-[24px] h-[24px] flex items-center justify-center",
            onClick: function() {
              window.history.back();
            },
            children: /* @__PURE__ */ jsx(MdChevronRight, {
              size: 20,
              style: {
                color: "var(--cair-text-tertiary, #808081)",
                transform: "rotate(180deg)"
              }
            })
          }), /* @__PURE__ */ jsx("span", {
            className: "text-[18px] font-medium leading-[1.75] cursor-pointer",
            style: {
              color: "var(--cair-text-tertiary, #808081)"
            },
            onClick: function() {
              window.history.back();
            },
            children: "Dashboard"
          }), /* @__PURE__ */ jsx(MdChevronRight, {
            size: 20,
            style: {
              color: "var(--cair-text-tertiary, #808081)",
              transform: "rotate(180deg)"
            }
          }), /* @__PURE__ */ jsx("span", {
            className: "text-[18px] font-medium leading-[1.75]",
            style: {
              color: "var(--cair-accent, #1e2c44)"
            },
            children: "My Library"
          })]
        }), /* @__PURE__ */ jsx("div", {
          style: {
            height: 1,
            backgroundColor: "var(--cair-divider, #f2f2f2)"
          }
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "w-full flex justify-center gap-[8px] py-[16px]",
        children: renderFilterPills()
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-wrap content-start items-start gap-[12px] px-[80px]",
        children: renderBookList("w-[418px]")
      })]
    })]
  });
};

const MyLibraryPageLive = () => /* @__PURE__ */ jsx(BookCairLivePage, {
  children: /* @__PURE__ */ jsx(MyLibraryPage, {})
});

const ContinueReadingCard = ({
  title,
  author,
  chapterTitle,
  image,
  progressPercent,
  onContinue
}) => /* @__PURE__ */ jsx("div", {
  className: "w-full bg-[var(--cair-surface-elevated)] border border-[var(--cair-border)] rounded-[var(--cair-radius-md)] p-[13px]",
  style: {
    boxShadow: "var(--cair-shadow-sm)"
  },
  children: /* @__PURE__ */ jsxs("div", {
    className: "flex gap-[16px] items-start",
    children: [/* @__PURE__ */ jsx(BookCover, {
      image,
      alt: title,
      height: 151,
      width: 120,
      radius: "sm"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col flex-1 gap-[16px] min-w-0 self-stretch",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[4px]",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-small)] text-[color:var(--cair-text)] font-medium leading-[1.75] truncate",
          children: title
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] leading-[1.5]",
          children: author
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] leading-[1.5]",
          children: chapterTitle
        }), /* @__PURE__ */ jsx(ReadingProgressBar, {
          percent: progressPercent,
          variant: "premium",
          height: 8,
          label: "Progress",
          showPercent: true
        })]
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "xs",
        rounded: "sm",
        onClick: onContinue,
        className: "self-start",
        children: "Continue \u2192"
      })]
    })]
  })
});

const BookCard = ({
  title,
  author,
  image,
  progressPercent,
  onClick,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `flex flex-col gap-[8px] items-start w-[140px] shrink-0 ${onClick ? "cursor-pointer" : ""} ${className || ""}`,
  onClick,
  children: [/* @__PURE__ */ jsx(BookCover, {
    image,
    alt: title,
    height: 160,
    radius: "sm"
  }), /* @__PURE__ */ jsx("p", {
    className: "w-full text-[length:var(--cair-text-small)] text-[color:var(--cair-text)] font-normal leading-[1.75] overflow-hidden line-clamp-2",
    children: title
  }), /* @__PURE__ */ jsx("p", {
    className: "w-full text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.5]",
    children: author
  }), progressPercent !== void 0 && /* @__PURE__ */ jsx(ReadingProgressBar, {
    percent: progressPercent,
    variant: "accent",
    height: 4
  })]
});

const AchievementBadge = ({
  icon,
  title,
  description,
  unlocked = true,
  className
}) => {
  const cardBg = unlocked ? "bg-[var(--cair-surface-elevated)]" : "bg-[var(--cair-surface)]";
  const iconBg = unlocked ? "bg-[var(--cair-premium-subtle)]" : "bg-[var(--cair-border)]";
  const titleColor = unlocked ? "text-[color:var(--cair-text)]" : "text-[color:var(--cair-text-secondary)]";
  return /* @__PURE__ */ jsxs("div", {
    className: `
        flex flex-col items-center gap-[6px]
        w-[160px] h-[150px] shrink-0
        p-[17px]
        ${cardBg}
        border border-[var(--cair-border)]
        rounded-[var(--cair-radius-lg)]
        ${className || ""}
      `,
    style: {
      boxShadow: unlocked ? "var(--cair-shadow-sm)" : void 0
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: `
          shrink-0 w-[48px] h-[48px] rounded-full
          flex items-center justify-center
          ${iconBg}
        `,
      children: /* @__PURE__ */ jsx("span", {
        className: "w-[24px] h-[24px] flex items-center justify-center",
        children: icon
      })
    }), /* @__PURE__ */ jsx("p", {
      className: `
          text-[length:var(--cair-text-small)] font-normal leading-[1.75]
          text-center whitespace-nowrap
          ${titleColor}
        `,
      children: title
    }), /* @__PURE__ */ jsx("p", {
      className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.5] text-center",
      children: description
    })]
  });
};

const DEFAULT_DAYS = [{
  label: "S",
  completed: false
}, {
  label: "M",
  completed: false
}, {
  label: "T",
  completed: false
}, {
  label: "W",
  completed: false
}, {
  label: "T",
  completed: false
}, {
  label: "F",
  completed: false
}, {
  label: "S",
  completed: false
}];
const WeekStreakBar = ({
  days = DEFAULT_DAYS,
  label = "This Week",
  summary,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `flex flex-col gap-[8px] w-full pt-[8px] ${className || ""}`,
  children: [/* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-between w-full",
    children: [/* @__PURE__ */ jsx("span", {
      className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.5]",
      children: label
    }), summary && /* @__PURE__ */ jsx("span", {
      className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.5]",
      children: summary
    })]
  }), /* @__PURE__ */ jsx("div", {
    className: "flex items-center justify-between w-full",
    children: days.map((day, i) => /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col flex-1 items-center gap-[6px] min-w-0",
      children: [/* @__PURE__ */ jsx("div", {
        className: `h-[6px] w-full rounded-full ${day.completed ? "bg-[var(--cair-accent)]" : "bg-[var(--cair-surface)]"}`
      }), /* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.5] h-[16px] flex items-center",
        children: day.label
      })]
    }, i))
  })]
});

const SectionHeader$1 = ({
  title,
  action,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `flex items-center justify-between w-full ${className || ""}`,
  children: [/* @__PURE__ */ jsx("p", {
    className: "text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] font-medium leading-[1.75] whitespace-nowrap",
    children: title
  }), action && /* @__PURE__ */ jsxs("button", {
    onClick: action.onClick,
    className: "flex items-center gap-[4px] shrink-0",
    children: [/* @__PURE__ */ jsx("span", {
      className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.5]",
      children: action.label
    }), /* @__PURE__ */ jsx(MdChevronRight, {
      className: "w-[16px] h-[16px] text-[color:var(--cair-text-secondary)]"
    })]
  })]
});

const MOCK_STREAK_DAYS = [
  { label: "S", completed: true },
  { label: "M", completed: true },
  { label: "T", completed: true },
  { label: "W", completed: true },
  { label: "T", completed: true },
  { label: "F", completed: false },
  { label: "S", completed: false }
];
const MOCK_STREAK_COUNT = 5;
const MOCK_ACHIEVEMENTS = [
  { id: "ach-1", title: "First Book", description: "Finished your first book", unlocked: true },
  { id: "ach-2", title: "7 Day Streak", description: "Read for a week straight", unlocked: true },
  { id: "ach-3", title: "Curious Mind", description: "Asked 10 questions", unlocked: true },
  { id: "ach-4", title: "Night Owl", description: "Read after midnight", unlocked: true },
  { id: "ach-5", title: "Marathon", description: "Read for 5 hours in a day", unlocked: false },
  { id: "ach-6", title: "Scholar", description: "Complete 10 books", unlocked: false }
];

const readerMock = {
  bookTitle: "Advanced Research Methods",
  chapterTitle: "Chapter 3: Methodological Frameworks",
  progressPercent: 23,
  ttsCurrentTime: "12:34",
  ttsDuration: "45:22",
  ttsProgress: 28,
  pages: [
    {
      heading: "Chapter 3: Methodological Frameworks in Academic Research",
      paragraphs: [
        "The foundation of rigorous academic research lies in the careful selection and application of appropriate methodological frameworks. These frameworks serve as the structural backbone that guides researchers through the complex process of inquiry, data collection, analysis, and interpretation.",
        "In contemporary academic discourse, methodological frameworks have evolved beyond traditional quantitative and qualitative distinctions to encompass mixed-method approaches that leverage the strengths of multiple research paradigms.",
        "The selection of an appropriate methodological framework depends on several critical factors: the nature of the research question, the available resources, the target population, and the epistemological stance of the researcher.",
        "Positivist frameworks emphasize objectivity, measurability, and the pursuit of universal truths through systematic observation and experimentation.",
        "In contrast, interpretivist frameworks prioritize understanding the subjective experiences and meanings that individuals attach to their social realities.",
        "The emergence of pragmatic research philosophies has further enriched the methodological landscape by emphasizing the practical utility of research outcomes.",
        "Mixed-method research designs exemplify this pragmatic approach by integrating quantitative and qualitative methods within a single study."
      ]
    },
    {
      heading: "3.1 Quantitative Research Frameworks",
      paragraphs: [
        "Quantitative research frameworks are characterized by their emphasis on numerical data, statistical analysis, and the testing of predetermined hypotheses.",
        "The strength of quantitative frameworks lies in their ability to handle large datasets, identify patterns and relationships across variables, and provide statistically robust evidence.",
        "Experimental designs represent the gold standard of quantitative research, offering the highest level of control over confounding variables."
      ]
    }
  ]
};

const ComingSoonPill = () => /* @__PURE__ */ jsx("span", {
  className: "text-[10px] font-medium px-[8px] py-[2px] rounded-full",
  style: {
    backgroundColor: "var(--cair-premium-subtle, #f9f4eb)",
    color: "var(--cair-premium, #c7933f)",
    border: "1px solid var(--cair-premium, #c7933f)"
  },
  children: "Coming soon"
});
const StreakBanner = () => /* @__PURE__ */ jsxs("section", {
  className: "w-full flex flex-col gap-[8px]",
  children: [/* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-[8px]",
    children: [/* @__PURE__ */ jsx("span", {
      role: "img",
      "aria-label": "fire",
      children: "\u{1F525}"
    }), /* @__PURE__ */ jsxs("span", {
      className: "text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-text)]",
      children: [MOCK_STREAK_COUNT, " day reading streak"]
    }), /* @__PURE__ */ jsx(ComingSoonPill, {})]
  }), /* @__PURE__ */ jsx("p", {
    className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)]",
    children: "Keep it up, you're on a roll!"
  }), /* @__PURE__ */ jsx(WeekStreakBar, {
    days: MOCK_STREAK_DAYS,
    label: "This Week",
    summary: `${MOCK_STREAK_COUNT} of 7 days`
  })]
});
const ContinueReadingSection = ({
  book
}) => {
  if (!book)
    return null;
  return /* @__PURE__ */ jsxs("section", {
    className: "w-full flex flex-col gap-[16px]",
    children: [/* @__PURE__ */ jsx(SectionHeader$1, {
      title: "Continue Reading"
    }), /* @__PURE__ */ jsx(ContinueReadingCard, {
      title: book.title,
      author: book.author,
      chapterTitle: "",
      image: book.image,
      progressPercent: book.progress,
      onContinue: () => {
        window.location.href = bookCairReaderUrl(book.id);
      }
    })]
  });
};
const FindBooksSection = ({
  circleId
}) => {
  if (!circleId)
    return null;
  const onBrowse = () => {
    window.location.href = bookCairBrowseUrl(circleId);
  };
  return /* @__PURE__ */ jsxs("section", {
    className: "w-full flex flex-col gap-[16px]",
    children: [/* @__PURE__ */ jsx(SectionHeader$1, {
      title: "Find books"
    }), /* @__PURE__ */ jsx("p", {
      className: "text-[length:var(--cair-text-small)] text-[color:var(--cair-text)]",
      children: "Browse to find books and documents."
    }), /* @__PURE__ */ jsx("div", {
      className: "flex gap-[18px] items-stretch",
      children: /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        onClick: onBrowse,
        className: "flex-1",
        children: "Browse books"
      })
    })]
  });
};
const LibrarySection = ({
  books,
  isLoading,
  layout
}) => {
  const openBook = (id) => {
    window.location.href = bookCairReaderUrl(id);
  };
  const seeAll = () => {
    window.location.href = bookCairLibraryUrl();
  };
  const body = isLoading && books.length === 0 ? /* @__PURE__ */ jsx("div", {
    className: "w-full py-[20px] flex justify-center",
    children: /* @__PURE__ */ jsx(Spinner, {
      size: "md",
      colorScheme: "gray"
    })
  }) : books.length === 0 ? /* @__PURE__ */ jsx("p", {
    className: "text-[length:var(--cair-text-small)] text-[color:var(--cair-text-secondary)] py-[20px] text-center",
    children: "No books in your library yet"
  }) : layout === "grid" ? /* @__PURE__ */ jsx("div", {
    className: "grid grid-cols-3 gap-x-[12px] gap-y-[20px]",
    children: books.map((b) => /* @__PURE__ */ jsx(BookCard, {
      title: b.title,
      author: b.author,
      image: b.image,
      progressPercent: b.progress,
      onClick: () => openBook(b.id),
      className: "w-full"
    }, b.id))
  }) : /* @__PURE__ */ jsx("div", {
    className: "flex flex-row gap-[12px] overflow-x-auto pb-[4px]",
    children: books.map((b) => /* @__PURE__ */ jsx(BookCard, {
      title: b.title,
      author: b.author,
      image: b.image,
      progressPercent: b.progress,
      onClick: () => openBook(b.id)
    }, b.id))
  });
  return /* @__PURE__ */ jsxs("section", {
    className: "w-full flex flex-col gap-[16px] overflow-hidden",
    children: [/* @__PURE__ */ jsx(SectionHeader$1, {
      title: "My Library",
      action: {
        label: "See all",
        onClick: seeAll
      }
    }), body]
  });
};
const AchievementsSection = ({
  layout
}) => {
  const header = /* @__PURE__ */ jsx("div", {
    className: "flex items-center justify-between w-full",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-[8px]",
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-[length:var(--cair-text-regular)] font-medium text-[color:var(--cair-text)] leading-[1.75]",
        children: "Achievements"
      }), /* @__PURE__ */ jsx(ComingSoonPill, {})]
    })
  });
  if (layout === "grid") {
    return /* @__PURE__ */ jsxs("section", {
      className: "w-full flex flex-col gap-[16px] overflow-hidden",
      children: [header, /* @__PURE__ */ jsx("div", {
        className: "grid grid-cols-3 gap-[12px]",
        children: MOCK_ACHIEVEMENTS.map((a) => /* @__PURE__ */ jsx(AchievementBadge, {
          icon: /* @__PURE__ */ jsx("span", {
            role: "img",
            "aria-label": a.title,
            children: "\u{1F3C6}"
          }),
          title: a.title,
          description: a.description,
          unlocked: a.unlocked,
          className: "w-full h-auto"
        }, a.id))
      })]
    });
  }
  return /* @__PURE__ */ jsxs("section", {
    className: "w-full flex flex-col gap-[16px] overflow-hidden",
    children: [header, /* @__PURE__ */ jsx("div", {
      className: "flex flex-row gap-[12px] overflow-x-auto pb-[4px]",
      children: MOCK_ACHIEVEMENTS.map((a) => /* @__PURE__ */ jsx(AchievementBadge, {
        icon: /* @__PURE__ */ jsx("span", {
          role: "img",
          "aria-label": a.title,
          children: "\u{1F3C6}"
        }),
        title: a.title,
        description: a.description,
        unlocked: a.unlocked
      }, a.id))
    })]
  });
};
const BookCairDashboardScreen = ({
  circleId
}) => {
  const {
    items,
    isInitialLoading
  } = useMyLibrary({
    pageSize: 6,
    filter: {
      kind: "all"
    },
    search: ""
  });
  const continueBook = useMemo(() => {
    const first = items[0];
    if (!first)
      return null;
    return {
      id: first.id,
      title: first.title,
      author: first.author,
      image: first.image,
      progress: first.progress
    };
  }, [items]);
  const libraryBooks = items.slice(0, 6).map((b) => ({
    id: b.id,
    title: b.title,
    author: b.author,
    image: b.image,
    progress: b.progress
  }));
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "w-full min-h-full bg-[var(--cair-surface)]",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "md:hidden flex flex-col",
        children: [/* @__PURE__ */ jsx("div", {
          className: "px-[16px] py-[20px]",
          children: /* @__PURE__ */ jsx(StreakBanner, {})
        }), /* @__PURE__ */ jsx("div", {
          className: "px-[16px] py-[21px] bg-[var(--cair-surface)] border-t border-b border-[var(--cair-border)]",
          children: /* @__PURE__ */ jsx(ContinueReadingSection, {
            book: continueBook
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "px-[16px] py-[21px] border-b border-[var(--cair-border)]",
          children: /* @__PURE__ */ jsx(FindBooksSection, {
            circleId
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "px-[16px] py-[24px] bg-[var(--cair-surface)] border-t border-b border-[var(--cair-border)]",
          children: /* @__PURE__ */ jsx(LibrarySection, {
            books: libraryBooks,
            isLoading: isInitialLoading,
            layout: "scroll"
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "px-[16px] pt-[20px] pb-[21px] border-b border-[var(--cair-border)]",
          children: /* @__PURE__ */ jsx(AchievementsSection, {
            layout: "scroll"
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "h-[40px]"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "hidden md:flex w-full bg-[var(--cair-surface-background,white)] pt-[48px]",
        children: /* @__PURE__ */ jsxs("div", {
          className: "flex w-full",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex-1 min-w-0 pl-[200px] pr-[24px] py-[20px] flex flex-col gap-[16px]",
            children: [/* @__PURE__ */ jsx("div", {
              className: "max-w-[672px] w-full flex flex-col gap-[16px]",
              children: /* @__PURE__ */ jsx(StreakBanner, {})
            }), /* @__PURE__ */ jsx("div", {
              className: "max-w-[672px] w-full flex flex-col gap-[16px]",
              children: /* @__PURE__ */ jsx(AchievementsSection, {
                layout: "grid"
              })
            }), /* @__PURE__ */ jsx("div", {
              className: "max-w-[672px] w-full flex flex-col gap-[16px]",
              children: /* @__PURE__ */ jsx(FindBooksSection, {
                circleId
              })
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex-1 min-w-0 pl-[24px] pr-[200px] py-[20px] flex flex-col gap-[16px]",
            children: [/* @__PURE__ */ jsx("div", {
              className: "max-w-[672px] w-full flex flex-col gap-[16px]",
              children: /* @__PURE__ */ jsx(ContinueReadingSection, {
                book: continueBook
              })
            }), /* @__PURE__ */ jsx("div", {
              className: "max-w-[672px] w-full flex flex-col gap-[16px]",
              children: /* @__PURE__ */ jsx(LibrarySection, {
                books: libraryBooks,
                isLoading: isInitialLoading,
                layout: "grid"
              })
            })]
          })]
        })
      })]
    })
  });
};

const BookCairDashboardPageLive = ({
  circleId
}) => /* @__PURE__ */ jsx(BookCairLivePage, {
  circleId,
  children: /* @__PURE__ */ jsx(BookCairDashboardScreen, {
    circleId
  })
});

const PurchaseRow = ({
  iconType,
  name,
  price,
  priceInterval,
  className
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex items-center gap-[12px] px-[16px] py-[12px] rounded-[8px] " + (className || ""),
    style: {
      backgroundColor: "#f2f2f2",
      border: "1px solid #D9D9D9"
    },
    children: [/* @__PURE__ */ jsx(AccessTypeIcon, {
      type: iconType
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-1 min-w-0",
      children: /* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-text)] leading-[1.75] truncate",
        children: name
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "shrink-0 flex items-center gap-[4px]",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-large)] font-semibold leading-[1.75]",
        style: {
          color: "#1E2C44"
        },
        children: price
      }), priceInterval && /* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-tiny)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.2]",
        children: priceInterval
      })]
    })]
  });
};

const CURRENCY_SYMBOL = {
  usd: "$",
  eur: "\u20AC",
  gbp: "\xA3"
};
const formatMoney = (amount, currency) => {
  if (typeof amount !== "number")
    return "\u2014";
  const sym = CURRENCY_SYMBOL[(currency || "usd").toLowerCase()] || "";
  return sym + (amount / 100).toFixed(2);
};
const intervalSuffix = (interval) => interval === "yearly" ? "/ year" : "/ month";
const PurchasesPage = () => {
  var api = useApi();
  var [isLoadingPortal, setIsLoadingPortal] = useState(false);
  var {
    data: subscriptions,
    isValidating: isLoadingSubs
  } = useSWR(api ? "/ua/payments/my-subscriptions" : null, function() {
    return api.get({
      path: "ua/payments/my-subscriptions"
    });
  }, swrLoadOnce);
  var {
    data: purchases,
    isValidating: isLoadingPurchases
  } = useSWR(api ? "/ua/payments/my-purchases" : null, function() {
    return api.get({
      path: "ua/payments/my-purchases"
    });
  }, swrLoadOnce);
  var subList = subscriptions || [];
  var purList = purchases || [];
  var handleManageSubscriptions = useMemoizedFn(function() {
    if (!api)
      return;
    setIsLoadingPortal(true);
    api.post({
      path: "ua/payments/portal-session",
      body: {
        returnUrl: window.location.href
      }
    }).then(function(res) {
      if (res && res.data && res.data.url) {
        window.location.href = res.data.url;
      }
    }).catch(function(err) {
      console.error("Portal session error:", err);
    }).finally(function() {
      setIsLoadingPortal(false);
    });
  });
  var renderSubscriptions = function() {
    if (isLoadingSubs && subList.length === 0) {
      return /* @__PURE__ */ jsx("div", {
        className: "py-[20px] flex justify-center",
        children: /* @__PURE__ */ jsx(Spinner, {
          size: "md",
          colorScheme: "gray"
        })
      });
    }
    if (subList.length === 0) {
      return /* @__PURE__ */ jsx("div", {
        className: "py-[20px] text-center",
        children: /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] text-[color:var(--cair-text-secondary)]",
          children: "No active subscriptions"
        })
      });
    }
    return subList.map(function(sub) {
      return /* @__PURE__ */ jsx(PurchaseRow, {
        iconType: "collection",
        name: sub.circleName || "Collection",
        price: formatMoney(sub.amount, sub.currency),
        priceInterval: intervalSuffix(sub.interval)
      }, sub.subscriptionId);
    });
  };
  var renderManageButton = function() {
    return /* @__PURE__ */ jsx("button", {
      className: "w-full flex items-center justify-center px-[16px] py-[6px] rounded-[8px] text-[length:var(--cair-text-regular)] font-medium leading-[1.75]",
      style: {
        height: 44,
        backgroundColor: "#1E2C44",
        border: "1px solid #1E2C44",
        color: "white",
        opacity: isLoadingPortal ? 0.7 : 1,
        cursor: isLoadingPortal ? "not-allowed" : "pointer"
      },
      onClick: handleManageSubscriptions,
      disabled: isLoadingPortal,
      children: isLoadingPortal ? "Loading..." : "Manage Subscriptions"
    });
  };
  var renderDivider = function() {
    return /* @__PURE__ */ jsx("div", {
      className: "w-full",
      style: {
        height: 1,
        backgroundColor: "#f2f2f2"
      }
    });
  };
  var renderPurchases = function() {
    if (isLoadingPurchases && purList.length === 0) {
      return /* @__PURE__ */ jsx("div", {
        className: "py-[20px] flex justify-center",
        children: /* @__PURE__ */ jsx(Spinner, {
          size: "md",
          colorScheme: "gray"
        })
      });
    }
    if (purList.length === 0) {
      return /* @__PURE__ */ jsx("div", {
        className: "py-[40px] text-center",
        children: /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] text-[color:var(--cair-text-secondary)]",
          children: "No purchases yet"
        })
      });
    }
    return purList.map(function(pur) {
      return /* @__PURE__ */ jsx(PurchaseRow, {
        iconType: "locked",
        name: pur.bookTitle || "Book",
        price: formatMoney(pur.amount, pur.currency)
      }, pur.purchaseId);
    });
  };
  var sectionTitle = function(text) {
    return /* @__PURE__ */ jsx("p", {
      className: "text-[length:var(--cair-text-small)] font-semibold leading-[1.75]",
      style: {
        color: "var(--cair-text, #020203)"
      },
      children: text
    });
  };
  return /* @__PURE__ */ jsxs(CairTokensProvider, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "w-full md:hidden max-w-[480px] mx-auto min-h-full bg-white flex flex-col",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "w-full flex flex-col gap-[8px] px-[24px] pt-[16px] pb-[17px] sticky top-0 z-[2]",
        style: {
          backgroundColor: "#f2f2f2",
          borderBottom: "1px solid #b3b3b3",
          boxShadow: "0px 1px 2px rgba(0,0,0,0.05)"
        },
        children: [/* @__PURE__ */ jsxs("div", {
          className: "w-full flex items-center relative",
          children: [/* @__PURE__ */ jsx("button", {
            className: "shrink-0 w-[24px] h-[24px] flex items-center justify-center text-[color:var(--cair-text)]",
            onClick: function() {
              window.history.back();
            },
            children: /* @__PURE__ */ jsx(MdArrowBack, {
              size: 20
            })
          }), /* @__PURE__ */ jsx("div", {
            className: "flex-1 flex flex-col items-center pr-[24px]",
            children: /* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-small)] font-semibold text-[color:var(--cair-text)] leading-[1.75]",
              children: "Your Profile"
            })
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "w-full flex justify-center",
          children: /* @__PURE__ */ jsx("span", {
            className: "text-[length:var(--cair-text-regular)] font-medium leading-[1.75]",
            style: {
              color: "#1E2C44"
            },
            children: "Subscriptions & Purchases"
          })
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[12px] px-[24px] py-[20px]",
        children: [renderSubscriptions(), subList.length > 0 && /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-[16px]",
          children: [renderManageButton(), renderDivider()]
        }), renderPurchases()]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "hidden md:flex w-full min-h-full bg-white flex-col",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[8px] px-[200px] pt-[48px]",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-[12px]",
          children: [/* @__PURE__ */ jsx("button", {
            className: "w-[24px] h-[24px] flex items-center justify-center",
            onClick: function() {
              window.history.back();
            },
            children: /* @__PURE__ */ jsx(MdChevronRight, {
              size: 20,
              style: {
                color: "var(--cair-text-tertiary, #808081)",
                transform: "rotate(180deg)"
              }
            })
          }), /* @__PURE__ */ jsx("span", {
            className: "text-[18px] font-medium leading-[1.75] cursor-pointer",
            style: {
              color: "var(--cair-text-tertiary, #808081)"
            },
            onClick: function() {
              window.history.back();
            },
            children: "Profile"
          }), /* @__PURE__ */ jsx(MdChevronRight, {
            size: 20,
            style: {
              color: "var(--cair-text-tertiary, #808081)",
              transform: "rotate(180deg)"
            }
          }), /* @__PURE__ */ jsx("span", {
            className: "text-[18px] font-medium leading-[1.75]",
            style: {
              color: "var(--cair-accent, #1e2c44)"
            },
            children: "Subscriptions & Purchases"
          })]
        }), /* @__PURE__ */ jsx("div", {
          style: {
            height: 1,
            backgroundColor: "var(--cair-divider, #f2f2f2)"
          }
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-full max-w-[960px] mx-auto grid grid-cols-2 gap-[24px] px-[24px] py-[24px]",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-[12px]",
          children: [sectionTitle("Subscriptions"), renderSubscriptions(), subList.length > 0 && renderManageButton()]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-[12px]",
          children: [sectionTitle("Single Purchases"), renderPurchases()]
        })]
      })]
    })]
  });
};

const PurchasesPageLive = () => /* @__PURE__ */ jsx(BookCairLivePage, {
  children: /* @__PURE__ */ jsx(PurchasesPage, {})
});

const PaymentOptionCard = function PaymentOptionCard2({
  title,
  price,
  priceInterval,
  description,
  selected,
  onSelect,
  tag,
  className
}) {
  return /* @__PURE__ */ jsxs("button", {
    type: "button",
    onClick: onSelect,
    className: ["relative w-full flex items-start gap-[16px] p-[16px] rounded-[8px] transition-colors text-left", className].filter(Boolean).join(" "),
    style: {
      border: selected ? "1px solid var(--cair-accent)" : "1px solid #D9D9D9",
      backgroundColor: selected ? "var(--cair-accent-subtle)" : "#FFFFFF"
    },
    children: [tag && /* @__PURE__ */ jsx("span", {
      className: "absolute -top-[13px] left-[16px] px-[8px] py-[4px] text-[12px] font-semibold rounded-[4px]",
      style: {
        color: "var(--cair-tag-text, #9F7532)",
        backgroundColor: "var(--cair-tag-bg, #F9F4EB)"
      },
      children: tag
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex-1 min-w-0 flex flex-col gap-[4px]",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-[14px] font-medium text-[color:var(--cair-text)] leading-[1.75]",
        children: title
      }), /* @__PURE__ */ jsxs("p", {
        className: "leading-[1.75]",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-[18px] font-semibold text-[color:var(--cair-accent)]",
          children: price
        }), priceInterval && /* @__PURE__ */ jsx("span", {
          className: "text-[12px] font-normal text-[color:var(--cair-text-secondary)] ml-[2px]",
          children: priceInterval
        })]
      }), /* @__PURE__ */ jsx("p", {
        className: "text-[12px] font-normal text-[color:var(--cair-text-secondary)] leading-[1.2]",
        children: description
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "shrink-0 w-[18px] h-[18px] rounded-full flex items-center justify-center transition-colors",
      style: {
        border: selected ? "1px solid var(--cair-accent)" : "1px solid var(--cair-border-strong)",
        backgroundColor: selected ? "var(--cair-accent)" : "transparent"
      },
      children: selected && /* @__PURE__ */ jsx(MdCheck, {
        size: 12,
        className: "text-white"
      })
    })]
  });
};

const MOCK_BOOK_PAYMENT = {
  id: "post-001",
  title: "Deep Work",
  author: "Cal Newport",
  publisher: "Oxford University Press",
  year: "2023",
  language: "English",
  coverUrl: "",
  accessType: "purchase",
  paymentType: "both",
  price: 299,
  currency: "USD",
  circleId: "circle-001",
  collection: {
    name: "Productivity Masters",
    monthlyPrice: 899,
    books: [
      { title: "The Lean Startup", author: "Eric Ries" },
      { title: "Atomic Habits", author: "James Clear" },
      { title: "Deep Work", author: "Cal Newport" }
    ]
  },
  institutionName: "Cairo University"
};

const TITLES = {
  one_time: "Purchase",
  collection: "Subscribe",
  both: "Purchase or Subscribe",
  donation: "Donate"
};
const FEATURES = [{
  icon: MdAutoAwesome,
  label: "AI-powered reading assistant"
}, {
  icon: MdHeadphones,
  label: "Audio reading for every book"
}];
function formatPrice(cents, currency) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD"
  }).format(cents / 100);
}
function getAuthorName(author) {
  const parts = [author.firstname, author.lastname].filter(Boolean);
  if (parts.length > 0)
    return parts.join(" ");
  return author.username || "Unknown author";
}
const CairPaymentPage = () => {
  const api = useApi();
  const urlParams = useMemo(function() {
    return new URLSearchParams(window.location.search);
  }, []);
  const documentId = urlParams.get("documentId") || MOCK_BOOK_PAYMENT.id;
  const urlCircleId = urlParams.get("circleId") || MOCK_BOOK_PAYMENT.circleId;
  const urlPaymentType = urlParams.get("type");
  const sourceParam = urlParams.get("source") || "";
  const {
    data: postData,
    isValidating: isFetchingBook
  } = usePostMetadata({
    postId: documentId
  });
  const post = postData && postData.post;
  const bookTitle = post && post.title || MOCK_BOOK_PAYMENT.title;
  const bookAuthor = post ? getAuthorName(post.author) : MOCK_BOOK_PAYMENT.author;
  const bookPrice = post && post.price != null ? post.price : MOCK_BOOK_PAYMENT.price;
  const bookAccessType = post && post.accessType || MOCK_BOOK_PAYMENT.accessType;
  const image = post && post.image ? {
    uuid: post.image.uuid
  } : void 0;
  const bookPublisher = post && post.metadata && post.metadata.publisher || MOCK_BOOK_PAYMENT.publisher;
  const bookYear = post && post.metadata && post.metadata.year || MOCK_BOOK_PAYMENT.year;
  const bookLanguage = post && post.metadata && post.metadata.language || MOCK_BOOK_PAYMENT.language;
  const circleId = post && post.group && post.group.group && post.group.group._id || urlCircleId;
  const circleName = post && post.group && post.group.group && post.group.group.name;
  const subscriptionMonthlyPrice = post && post.group && post.group.group && post.group.group.subscriptionMonthlyPrice;
  const subscriptionYearlyPrice = post && post.group && post.group.group && post.group.group.subscriptionYearlyPrice;
  const hasCollection = !!subscriptionMonthlyPrice || !!subscriptionYearlyPrice;
  const paymentType = urlPaymentType || derivePaymentType(bookAccessType) || "one_time";
  const pageTitle = TITLES[paymentType];
  const meta = [bookPublisher, bookYear, bookLanguage].filter(Boolean);
  const hasMonthly = !!subscriptionMonthlyPrice;
  const hasYearly = !!subscriptionYearlyPrice;
  const hasBothIntervals = hasMonthly && hasYearly;
  const [selectedInterval, setSelectedInterval] = useState(!hasMonthly && hasYearly ? "yearly" : "monthly");
  const [selectedOption, setSelectedOption] = useState(paymentType === "collection" ? "subscription" : "purchase");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  var DONATION_PRESETS = [500, 1e3, 2500, 5e3];
  var [donationAmountCents, setDonationAmountCents] = useState(500);
  var [customAmountInput, setCustomAmountInput] = useState("");
  var [isCustomAmount, setIsCustomAmount] = useState(false);
  const handleBack = useMemoizedFn(function() {
    window.history.back();
  });
  const resultBase = window.location.origin + bookCairPaymentResultUrl();
  var resultSearchParams = new URLSearchParams({
    documentId,
    type: paymentType
  });
  if (circleId)
    resultSearchParams.set("circleId", circleId);
  if (sourceParam)
    resultSearchParams.set("source", sourceParam);
  var successUrl = resultBase + "?status=success&" + resultSearchParams.toString();
  var cancelUrl = resultBase + "?status=failure&" + resultSearchParams.toString();
  const handleContinueToPayment = useMemoizedFn(async function() {
    setIsLoading(true);
    setError(null);
    try {
      var isPurchase = selectedOption === "purchase" || paymentType === "one_time";
      if (paymentType === "donation" && isCustomAmount) {
        var parsed = parseFloat(customAmountInput);
        if (isNaN(parsed) || parsed < 1) {
          setError("Please enter a donation amount of at least $1.00");
          setIsLoading(false);
          return;
        }
      }
      var body;
      if (paymentType === "donation") {
        body = {
          type: "purchase",
          documentId,
          donationAmountCents,
          successUrl,
          cancelUrl
        };
      } else if (isPurchase) {
        body = {
          type: "purchase",
          documentId,
          successUrl,
          cancelUrl
        };
      } else {
        body = {
          type: "subscription",
          circleId,
          interval: selectedInterval,
          successUrl,
          cancelUrl
        };
      }
      var response = await api.post({
        path: "payments/checkout-session",
        body
      });
      if (response && response.url) {
        window.location.href = response.url;
      }
    } catch (err) {
      console.error("Checkout error:", err);
      setError(err && err.message || "Failed to start checkout. Please try again.");
      setIsLoading(false);
    }
  });
  const handleReadSummary = useMemoizedFn(function() {
    window.history.back();
  });
  var isDonation = paymentType === "donation";
  var purchaseCard = bookPrice != null && bookPrice > 0 ? {
    title: "Get the book",
    price: formatPrice(bookPrice),
    description: "Best if you only need this book."
  } : null;
  var subscriptionCard = hasCollection ? {
    title: "Access via " + (circleName || "Collection"),
    price: formatPrice(selectedInterval === "yearly" && subscriptionYearlyPrice ? subscriptionYearlyPrice : subscriptionMonthlyPrice || 0),
    priceInterval: selectedInterval === "yearly" ? "/ year" : "/ month",
    description: selectedInterval === "yearly" && subscriptionMonthlyPrice && subscriptionYearlyPrice ? "Save " + formatPrice(subscriptionMonthlyPrice * 12 - subscriptionYearlyPrice) + " per year" : "Full access to the collection. Cancel anytime."
  } : null;
  if (isFetchingBook && !post) {
    return /* @__PURE__ */ jsx(CairTokensProvider, {
      children: /* @__PURE__ */ jsx("div", {
        className: "flex items-center justify-center h-full bg-[var(--cair-surface-background)]",
        children: /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-regular)] text-[color:var(--cair-text-secondary)]",
          children: "Loading book details\u2026"
        })
      })
    });
  }
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col h-full bg-[var(--cair-surface-background)]",
      children: [/* @__PURE__ */ jsx("div", {
        className: "hidden lg:flex items-center h-[65px] px-[24px] border-b border-[var(--cair-divider)] bg-[var(--cair-surface)]",
        children: /* @__PURE__ */ jsx("span", {
          className: "text-[18px] font-medium text-[color:var(--cair-accent)]",
          children: "CAIR"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-[4px] px-[16px] lg:px-[200px] pt-[20px] pb-[12px] border-b border-[var(--cair-divider)] bg-[var(--cair-surface)]",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-[8px]",
          children: [/* @__PURE__ */ jsx("button", {
            onClick: handleBack,
            className: "w-[24px] h-[24px] flex items-center justify-center text-[color:var(--cair-text)] hover:opacity-70",
            "aria-label": "Back",
            children: /* @__PURE__ */ jsx(MdArrowBack, {
              size: 20
            })
          }), /* @__PURE__ */ jsx("p", {
            className: "text-[14px] font-semibold text-[color:var(--cair-text)] leading-[1.5]",
            children: pageTitle
          })]
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[18px] font-medium text-[color:var(--cair-text)] leading-[1.5]",
          children: bookTitle
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex-1 overflow-y-auto",
        children: /* @__PURE__ */ jsxs("div", {
          className: "px-[16px] lg:px-[200px] py-[32px]",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex flex-col lg:flex-row gap-[48px]",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "flex-1 min-w-0 flex flex-col gap-[24px]",
              children: [/* @__PURE__ */ jsxs("div", {
                className: "flex gap-[12px] items-start",
                children: [/* @__PURE__ */ jsx(BookCover, {
                  image: image || void 0,
                  alt: bookTitle,
                  width: 80,
                  height: 110,
                  radius: "sm"
                }), /* @__PURE__ */ jsxs("div", {
                  className: "flex-1 min-w-0 flex flex-col gap-[2px]",
                  children: [/* @__PURE__ */ jsx("p", {
                    className: "text-[16px] font-semibold text-[color:var(--cair-text)] leading-[1.5]",
                    children: bookTitle
                  }), /* @__PURE__ */ jsx("p", {
                    className: "text-[14px] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
                    children: bookAuthor
                  }), meta.length > 0 && /* @__PURE__ */ jsx("div", {
                    className: "flex flex-wrap items-center gap-[4px] mt-[2px]",
                    children: meta.map(function(item, i) {
                      return /* @__PURE__ */ jsxs("span", {
                        className: "text-[12px] font-normal text-[color:var(--cair-text-secondary)] leading-[1.2]",
                        children: [i > 0 && /* @__PURE__ */ jsx("span", {
                          className: "mx-[4px]",
                          children: "\u2022"
                        }), item]
                      }, i);
                    })
                  })]
                })]
              }), isDonation && /* @__PURE__ */ jsxs("div", {
                className: "flex flex-col gap-[12px]",
                children: [/* @__PURE__ */ jsx("p", {
                  className: "text-[16px] font-medium text-[color:var(--cair-text)] leading-[1.5]",
                  children: "Support this book"
                }), /* @__PURE__ */ jsx("p", {
                  className: "text-[12px] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
                  children: "This book is free to read. Your donation helps cover hosting, development, and access to more books from publishers and archives."
                }), /* @__PURE__ */ jsxs("div", {
                  className: "flex flex-wrap gap-[8px] mt-[8px]",
                  children: [DONATION_PRESETS.map(function(amount) {
                    var isSelected = !isCustomAmount && donationAmountCents === amount;
                    return /* @__PURE__ */ jsx("button", {
                      type: "button",
                      onClick: function() {
                        setDonationAmountCents(amount);
                        setIsCustomAmount(false);
                        setError(null);
                      },
                      className: "px-[16px] py-[10px] rounded-[8px] text-[14px] font-medium",
                      style: {
                        border: isSelected ? "2px solid var(--cair-accent)" : "1px solid #D9D9D9",
                        backgroundColor: isSelected ? "var(--cair-accent-subtle)" : "#FFFFFF",
                        color: isSelected ? "var(--cair-accent)" : "var(--cair-text)"
                      },
                      children: formatPrice(amount)
                    }, amount);
                  }), /* @__PURE__ */ jsx("button", {
                    type: "button",
                    onClick: function() {
                      setIsCustomAmount(true);
                      setError(null);
                    },
                    className: "px-[16px] py-[10px] rounded-[8px] text-[14px] font-medium",
                    style: {
                      border: isCustomAmount ? "2px solid var(--cair-accent)" : "1px solid #D9D9D9",
                      backgroundColor: isCustomAmount ? "var(--cair-accent-subtle)" : "#FFFFFF",
                      color: isCustomAmount ? "var(--cair-accent)" : "var(--cair-text)"
                    },
                    children: "Other"
                  })]
                }), isCustomAmount && /* @__PURE__ */ jsxs("div", {
                  className: "flex items-center gap-[8px] mt-[4px]",
                  children: [/* @__PURE__ */ jsx("span", {
                    className: "text-[16px] font-medium text-[color:var(--cair-text)]",
                    children: "$"
                  }), /* @__PURE__ */ jsx("input", {
                    type: "number",
                    min: "1",
                    step: "0.01",
                    placeholder: "Enter amount",
                    value: customAmountInput,
                    onChange: function(e) {
                      setCustomAmountInput(e.target.value);
                      var val = parseFloat(e.target.value);
                      if (!isNaN(val) && val >= 1) {
                        setDonationAmountCents(Math.round(val * 100));
                        setError(null);
                      }
                    },
                    className: "flex-1 h-[40px] px-[12px] rounded-[8px] text-[14px] text-[color:var(--cair-text)] bg-white outline-none",
                    style: {
                      border: "1px solid #D9D9D9"
                    }
                  })]
                }), isCustomAmount && customAmountInput !== "" && (isNaN(parseFloat(customAmountInput)) || parseFloat(customAmountInput) < 1) && /* @__PURE__ */ jsx("p", {
                  className: "text-[12px] text-red-500",
                  children: "Minimum donation is $1.00"
                })]
              }), !isDonation && /* @__PURE__ */ jsxs(Fragment, {
                children: [/* @__PURE__ */ jsx("p", {
                  className: "text-[16px] font-medium text-[color:var(--cair-text)] leading-[1.5]",
                  children: "Choose your access"
                }), (paymentType === "collection" || paymentType === "both") && hasBothIntervals && /* @__PURE__ */ jsxs("div", {
                  className: "flex rounded-[8px] overflow-hidden",
                  style: {
                    border: "1px solid #D9D9D9"
                  },
                  children: [/* @__PURE__ */ jsx("button", {
                    type: "button",
                    onClick: function() {
                      setSelectedInterval("monthly");
                    },
                    className: "flex-1 px-[16px] py-[8px] text-[14px] font-medium",
                    style: {
                      backgroundColor: selectedInterval === "monthly" ? "var(--cair-accent)" : "#FFFFFF",
                      color: selectedInterval === "monthly" ? "#FFFFFF" : "var(--cair-text)"
                    },
                    children: "Monthly"
                  }), /* @__PURE__ */ jsx("button", {
                    type: "button",
                    onClick: function() {
                      setSelectedInterval("yearly");
                    },
                    className: "flex-1 px-[16px] py-[8px] text-[14px] font-medium",
                    style: {
                      backgroundColor: selectedInterval === "yearly" ? "var(--cair-accent)" : "#FFFFFF",
                      color: selectedInterval === "yearly" ? "#FFFFFF" : "var(--cair-text)"
                    },
                    children: "Yearly"
                  })]
                }), /* @__PURE__ */ jsxs("div", {
                  className: "flex flex-col gap-[12px]",
                  children: [(paymentType === "one_time" || paymentType === "both") && purchaseCard && /* @__PURE__ */ jsx(PaymentOptionCard, {
                    title: purchaseCard.title,
                    price: purchaseCard.price,
                    description: purchaseCard.description,
                    selected: selectedOption === "purchase",
                    onSelect: function() {
                      setSelectedOption("purchase");
                    }
                  }), (paymentType === "collection" || paymentType === "both") && subscriptionCard && /* @__PURE__ */ jsx(PaymentOptionCard, {
                    title: subscriptionCard.title,
                    price: subscriptionCard.price,
                    priceInterval: subscriptionCard.priceInterval,
                    description: subscriptionCard.description,
                    selected: selectedOption === "subscription",
                    onSelect: function() {
                      setSelectedOption("subscription");
                    },
                    tag: paymentType === "both" ? "Best Value" : void 0
                  })]
                })]
              })]
            }), /* @__PURE__ */ jsx("div", {
              className: "hidden lg:flex w-[360px] shrink-0 flex-col gap-[20px]",
              children: isDonation ? /* @__PURE__ */ jsxs(Fragment, {
                children: [/* @__PURE__ */ jsx("p", {
                  className: "text-[16px] font-medium text-[color:var(--cair-text)] leading-[1.5]",
                  children: "Why donate?"
                }), /* @__PURE__ */ jsx("p", {
                  className: "text-[12px] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
                  children: "Your support helps cover hosting, development, and access to more books from publishers and archives."
                })]
              }) : /* @__PURE__ */ jsxs(Fragment, {
                children: [/* @__PURE__ */ jsx("p", {
                  className: "text-[16px] font-medium text-[color:var(--cair-text)] leading-[1.5]",
                  children: "What's included"
                }), /* @__PURE__ */ jsx("div", {
                  className: "flex flex-col gap-[16px]",
                  children: FEATURES.map(function(feat) {
                    var Icon = feat.icon;
                    return /* @__PURE__ */ jsxs("div", {
                      className: "flex items-center gap-[12px]",
                      children: [/* @__PURE__ */ jsx(Icon, {
                        size: 20,
                        className: "text-[color:var(--cair-text-secondary)] shrink-0"
                      }), /* @__PURE__ */ jsx("span", {
                        className: "text-[12px] font-normal text-[color:var(--cair-text)] leading-[1.5]",
                        children: feat.label
                      })]
                    }, feat.label);
                  })
                }), /* @__PURE__ */ jsxs("div", {
                  className: "mt-[8px] flex flex-col gap-[8px]",
                  children: [/* @__PURE__ */ jsx("p", {
                    className: "text-[12px] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
                    children: "Not sure yet? You can read a free summary now."
                  }), /* @__PURE__ */ jsx("button", {
                    onClick: handleReadSummary,
                    className: "text-[14px] font-medium text-[color:var(--cair-accent)] underline text-left",
                    children: "Continue reading summary"
                  })]
                })]
              })
            })]
          }), !isDonation && /* @__PURE__ */ jsxs("div", {
            className: "flex lg:hidden flex-col gap-[16px] mt-[32px]",
            children: [/* @__PURE__ */ jsx("p", {
              className: "text-[16px] font-medium text-[color:var(--cair-text)] leading-[1.5]",
              children: "What's included"
            }), /* @__PURE__ */ jsx("div", {
              className: "flex flex-col gap-[16px]",
              children: FEATURES.map(function(feat) {
                var Icon = feat.icon;
                return /* @__PURE__ */ jsxs("div", {
                  className: "flex items-center gap-[12px]",
                  children: [/* @__PURE__ */ jsx(Icon, {
                    size: 20,
                    className: "text-[color:var(--cair-text-secondary)] shrink-0"
                  }), /* @__PURE__ */ jsx("span", {
                    className: "text-[12px] font-normal text-[color:var(--cair-text)] leading-[1.5]",
                    children: feat.label
                  })]
                }, feat.label);
              })
            }), /* @__PURE__ */ jsxs("div", {
              className: "flex flex-col gap-[8px] mt-[8px]",
              children: [/* @__PURE__ */ jsx("p", {
                className: "text-[12px] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
                children: "Not sure yet? You can read a free summary now."
              }), /* @__PURE__ */ jsx("button", {
                onClick: handleReadSummary,
                className: "text-[14px] font-medium text-[color:var(--cair-accent)] underline text-left",
                children: "Continue reading summary"
              })]
            })]
          })]
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "shrink-0 px-[16px] lg:px-[200px] py-[16px] border-t border-[var(--cair-divider)] bg-[var(--cair-surface)]",
        children: [error && /* @__PURE__ */ jsx("p", {
          className: "text-[12px] text-red-500 mb-[8px] text-center",
          children: error
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col lg:flex-row items-center gap-[12px]",
          children: [/* @__PURE__ */ jsx(ActionButton, {
            intent: "cairPrimary",
            size: "md",
            rounded: "sm",
            onClick: handleContinueToPayment,
            isLoading,
            loadingText: "Redirecting to Stripe\u2026",
            className: "w-full lg:w-auto lg:px-[32px]",
            children: isDonation ? "Continue to donate " + formatPrice(donationAmountCents) : "Continue to payment"
          }), !isDonation && /* @__PURE__ */ jsx(ActionButton, {
            intent: "cairDefault",
            size: "md",
            rounded: "sm",
            onClick: handleReadSummary,
            className: "w-full lg:w-auto lg:px-[32px]",
            children: "Read free summary"
          }), /* @__PURE__ */ jsx("span", {
            className: "text-[12px] font-normal text-[color:var(--cair-text-secondary)]",
            children: isDonation ? "Secure payment" : "Secure payment \u2022 Cancel anytime"
          })]
        })]
      })]
    })
  });
};

const CairPaymentPageLive = () => /* @__PURE__ */ jsx(BookCairLivePage, {
  children: /* @__PURE__ */ jsx(CairPaymentPage, {})
});

const PaymentResultPage = () => {
  const api = useApi();
  const urlParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const status = urlParams.get("status") === "success" ? "success" : "failure";
  const documentId = urlParams.get("documentId") || "";
  const circleId = urlParams.get("circleId") || "";
  const paymentType = urlParams.get("type") || "one_time";
  const source = urlParams.get("source") === "mobile" ? "mobile" : "desktop";
  const isSuccess = status === "success";
  const isSubscription = paymentType === "collection";
  const [portalLoading, setPortalLoading] = useState(false);
  const [portalError, setPortalError] = useState(null);
  const handleContinueReading = useMemoizedFn(() => {
    if (!documentId)
      return;
    window.location.href = source === "mobile" ? bookCairMobileUrl(documentId) : bookCairDesktopUrl(documentId);
  });
  const handleRetryPayment = useMemoizedFn(() => {
    const retryParams = new URLSearchParams({
      type: paymentType,
      ...documentId ? {
        documentId
      } : {},
      ...circleId ? {
        circleId
      } : {},
      ...source ? {
        source
      } : {}
    });
    window.location.href = bookCairPaymentUrl(`?${retryParams}`);
  });
  const handlePrimary = useMemoizedFn(() => {
    if (isSuccess) {
      handleContinueReading();
    } else {
      handleRetryPayment();
    }
  });
  const handleSecondary = useMemoizedFn(() => {
    if (isSuccess) {
      window.location.href = bookCairLibraryUrl();
    } else {
      handleContinueReading();
    }
  });
  const handleManageSubscription = useMemoizedFn(async () => {
    setPortalLoading(true);
    setPortalError(null);
    try {
      const returnUrl = window.location.href;
      const response = await api.post({
        path: "payments/portal-session",
        body: {
          returnUrl
        }
      });
      if (response && response.url) {
        window.location.href = response.url;
      }
    } catch (err) {
      console.error("Portal session error:", err);
      setPortalError(err && err.message || "Could not open subscription portal. Please try again.");
      setPortalLoading(false);
    }
  });
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    children: /* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-center h-full bg-[var(--cair-surface-background)]",
      children: /* @__PURE__ */ jsxs("div", {
        className: "w-full max-w-[400px] mx-auto px-[16px] flex flex-col items-center gap-[24px] text-center",
        children: [/* @__PURE__ */ jsx("div", {
          className: "w-[80px] h-[80px] rounded-full flex items-center justify-center",
          style: {
            backgroundColor: isSuccess ? "var(--cair-accent-subtle)" : "var(--cair-surface)"
          },
          children: isSuccess ? /* @__PURE__ */ jsx(MdCheckCircle, {
            size: 40,
            className: "text-[color:var(--cair-accent)]"
          }) : /* @__PURE__ */ jsx(MdSentimentDissatisfied, {
            size: 40,
            className: "text-[color:var(--cair-text-secondary)]"
          })
        }), /* @__PURE__ */ jsx("h1", {
          className: "text-[24px] font-medium text-[color:var(--cair-accent)] leading-[1.3]",
          children: isSuccess ? "Payment successful" : "We couldn't complete your payment"
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-small)] font-normal text-[color:var(--cair-text-secondary)] leading-[1.5]",
          children: isSuccess ? isSubscription ? "Your subscription is now active. You have full access to all books in this collection." : "Thank you for your support. You now have full access to this book." : "No charge was made. You can try again or return to the book."
        }), /* @__PURE__ */ jsxs("div", {
          className: "w-full flex flex-col gap-[8px]",
          children: [/* @__PURE__ */ jsx(ActionButton, {
            intent: "cairPrimary",
            size: "md",
            rounded: "sm",
            onClick: handlePrimary,
            className: "w-full",
            children: isSuccess ? "Continue reading" : "Retry payment"
          }), isSuccess && isSubscription && /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx(ActionButton, {
              intent: "cairDefault",
              size: "md",
              rounded: "sm",
              onClick: handleManageSubscription,
              isLoading: portalLoading,
              loadingText: "Opening portal\u2026",
              className: "w-full",
              children: "Manage subscription"
            }), portalError && /* @__PURE__ */ jsx("p", {
              className: "text-[length:var(--cair-text-tiny)] text-red-500",
              children: portalError
            })]
          }), /* @__PURE__ */ jsx(ActionButton, {
            intent: "cairSubtle",
            size: "md",
            rounded: "sm",
            onClick: handleSecondary,
            className: "w-full",
            children: isSuccess ? "Browse more books" : "Return to book"
          })]
        }), documentId && /* @__PURE__ */ jsxs("p", {
          className: "text-[length:var(--cair-text-tiny)] font-normal text-[color:var(--cair-text-secondary)]",
          children: ["Book ID: ", documentId]
        })]
      })
    })
  });
};

const PaymentResultPageLive = () => /* @__PURE__ */ jsx(BookCairLivePage, {
  children: /* @__PURE__ */ jsx(PaymentResultPage, {})
});

const PageHeader = ({
  title,
  subtitle,
  onBack,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `
      w-full sticky top-0 z-[2]
      bg-[var(--cair-surface)] border-b border-[var(--cair-border-strong)]
      px-[24px] pt-[16px] pb-[17px] flex flex-col gap-[8px]
      ${className || ""}
    `,
  style: {
    boxShadow: "var(--cair-shadow-sm)"
  },
  children: [/* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-between w-full",
    children: [onBack ? /* @__PURE__ */ jsx("button", {
      onClick: onBack,
      className: "shrink-0 w-[24px] h-[24px] flex items-center justify-center",
      "aria-label": "Go back",
      children: /* @__PURE__ */ jsx(MdChevronLeft, {
        className: "w-[24px] h-[24px] text-[color:var(--cair-text)]"
      })
    }) : /* @__PURE__ */ jsx("div", {
      className: "w-[24px] shrink-0"
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-1 flex flex-col items-center px-[16px]",
      children: /* @__PURE__ */ jsx("p", {
        className: "text-[length:var(--cair-text-small)] text-[color:var(--cair-text)] font-semibold leading-[1.75] text-center",
        children: title
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "w-[24px] shrink-0"
    })]
  }), subtitle && /* @__PURE__ */ jsx("p", {
    className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] font-normal leading-[1.5] text-center w-full",
    children: subtitle
  })]
});

const SettingsMenuItem = ({
  icon,
  label,
  onClick,
  divider = true,
  className
}) => /* @__PURE__ */ jsx("div", {
  className: `
      w-full
      ${divider ? "border-b border-[var(--cair-divider)]" : ""}
      ${className || ""}
    `,
  children: /* @__PURE__ */ jsxs("button", {
    onClick,
    className: "w-full flex items-center justify-between py-[16px]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-[8px] flex-1 min-w-0",
      children: [/* @__PURE__ */ jsx("span", {
        className: "shrink-0 w-[24px] h-[24px] flex items-center justify-center text-[color:var(--cair-text)]",
        children: icon
      }), /* @__PURE__ */ jsx("span", {
        className: "text-[length:var(--cair-text-regular)] text-[color:var(--cair-text)] font-medium leading-[1.75] text-left truncate",
        children: label
      })]
    }), /* @__PURE__ */ jsx(MdChevronRight, {
      className: "shrink-0 w-[20px] h-[20px] text-[color:var(--cair-text-secondary)]"
    })]
  })
});

const BookCairProfileScreen = ({
  onBack,
  onAccountSettings,
  onReadingPreferences,
  onSubscriptions,
  onPrivacy
}) => /* @__PURE__ */ jsxs("div", {
  className: "relative flex flex-col w-full h-full bg-[var(--cair-background)]",
  children: [/* @__PURE__ */ jsx(PageHeader, {
    title: "Your Profile",
    onBack
  }), /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col px-[16px] py-[20px]",
    children: [/* @__PURE__ */ jsx(SettingsMenuItem, {
      icon: /* @__PURE__ */ jsx(MdPersonOutline, {
        size: 24
      }),
      label: "Account Settings",
      onClick: onAccountSettings
    }), /* @__PURE__ */ jsx(SettingsMenuItem, {
      icon: /* @__PURE__ */ jsx(MdAutoStories, {
        size: 24
      }),
      label: "Reading Preferences",
      onClick: onReadingPreferences
    }), /* @__PURE__ */ jsx(SettingsMenuItem, {
      icon: /* @__PURE__ */ jsx(MdCardMembership, {
        size: 24
      }),
      label: "Subscriptions & Purchases",
      onClick: onSubscriptions
    }), /* @__PURE__ */ jsx(SettingsMenuItem, {
      icon: /* @__PURE__ */ jsx(MdPrivacyTip, {
        size: 24
      }),
      label: "Privacy & Data",
      onClick: onPrivacy,
      divider: false
    })]
  })]
});

const noop$e = () => void 0;
const BookCairProfilePageLive = () => {
  const navigateToSubscriptions = useMemoizedFn(() => {
    window.location.href = bookCairPurchasesUrl();
  });
  return /* @__PURE__ */ jsx(BookCairLivePage, {
    children: /* @__PURE__ */ jsx(BookCairProfileScreen, {
      onBack: noop$e,
      onAccountSettings: noop$e,
      onReadingPreferences: noop$e,
      onSubscriptions: navigateToSubscriptions,
      onPrivacy: noop$e
    })
  });
};

class PostViewDataHelper {
  constructor(api) {
    this.api = api;
    this.updated = {};
    this.rating = {};
    this.userVote = {};
    this.notesInfo = {};
    this.refreshResponses = async () => {
      if (!this.post) {
        return;
      }
      const result = await loadResponses(this.api, this.post._id, this.language);
      this.setResponsesResult(result);
      this.triggerUpdate();
    };
    this.wasSeen = async (id, force = false) => {
      const old = this.updated[id];
      if (!old) {
        return;
      }
      if (!old.isNew && !force) {
        return;
      }
      const nextUpdated = {
        ...this.updated
      };
      await nextUpdated[id].wasSeen();
      this.updated = nextUpdated;
      this.triggerUpdate();
    };
  }
  setResponsesResult(responsesRequestResult) {
    if (!responsesRequestResult) {
      return;
    }
    const {
      id,
      responses,
      authors,
      timestamp
    } = responsesRequestResult;
    if (timestamp < this.timestamp) {
      return;
    }
    this.responsesRequestResult = responsesRequestResult;
    this.timestamp = timestamp;
    this.setResponses(id, responses, authors);
  }
  setResponses(id, responses, authors) {
    if (!this.profile) {
      return;
    }
    if (!responses || responses === this.oldResponses) {
      return;
    }
    if (!this.post || this.post.thread.length || this.post._id !== id) {
      return;
    }
    const array = Object.values(responses);
    if (!array.length) {
      return;
    }
    const first = array[0];
    if (first.responseTo !== id && !first.thread.includes(id)) {
      return;
    }
    this.authors = authors;
    this.regularUpdate(!this.oldResponses, responses, authors);
  }
  onPost(post) {
    const id = post._id;
    this.rating[id] = post.rating;
    this.userVote[id] = post.userVote;
    this.notesInfo[id] = post.notesInfo;
  }
  noteAdded(id, notesInfo) {
    this.notesInfo = {
      ...this.notesInfo,
      [id]: notesInfo
    };
    this.triggerUpdate();
  }
  userVoted(id, rating, userVote) {
    this.rating = {
      ...this.rating,
      [id]: rating
    };
    this.userVote = {
      ...this.userVote,
      [id]: userVote
    };
    this.triggerUpdate();
  }
  ratingCreated(id, rating) {
    this.rating = {
      ...this.rating,
      [id]: rating
    };
    this.userVote = {
      ...this.userVote
    };
    delete this.userVote[id];
    this.triggerUpdate();
  }
  setMainPost(loaded) {
    if (!loaded || loaded === this.post) {
      return;
    }
    this.post = loaded;
    this.onPost(loaded);
    this.afterAllPosts();
  }
  afterAllPosts() {
    this.rating = {
      ...this.rating
    };
    this.userVote = {
      ...this.userVote
    };
    this.notesInfo = {
      ...this.notesInfo
    };
  }
  regularUpdate(first, responses, authors) {
    const flattenedResponses = flattenResponses(responses);
    const nextUpdated = {
      ...this.updated
    };
    Object.values(flattenedResponses).forEach((r) => {
      const postId = r._id;
      const author = authors[r.author];
      if (!author) {
        return;
      }
      if (!nextUpdated[postId]) {
        nextUpdated[postId] = new UpdateInfo(this.profile, this.api, author);
      }
      nextUpdated[postId].setPost(r);
      this.onPost(r);
    });
    this.afterAllPosts();
    this.updated = nextUpdated;
    this.oldResponses = responses;
  }
  updateNotifications(updates) {
    this.notifications = updates;
  }
  triggerUpdate() {
    if (!this.setCounter) {
      return;
    }
    this.setCounter((v) => v + 1);
  }
}
class UpdateInfo {
  constructor(user, api, author) {
    this.user = user;
    this.api = api;
    this.author = author;
    this.isNew = true;
  }
  setPost(r) {
    this.current = r;
    if (!this.user) {
      this.isNew = false;
      return;
    }
    this.isNew = !(r.visited >= r.modified) && this.author._id !== this.user._id;
  }
  async wasSeen() {
    if (!this.user) {
      return;
    }
    const current = this.current;
    const postId = current._id;
    await wasSeen(this.api, postId, current.modified);
    this.isNew = false;
  }
}
const usePostViewDataHelper = () => {
  const api = useApi();
  const ref = useRef();
  const {
    language
  } = useLanguageSelectionContext();
  if (!ref.current) {
    ref.current = new PostViewDataHelper(api);
  }
  ref.current.language = language;
  return ref.current;
};

const useLoadPost = (postId, op) => {
  const api = useApi();
  const [data, setData] = useState({});
  const helper = usePostViewDataHelper();
  const {
    profile,
    error: profileError
  } = useProfileContext();
  const {
    language
  } = useLanguageSelectionContext();
  useEffect(() => {
    helper.triggerUpdate();
  }, [data]);
  const {
    data: post,
    error: postError
  } = useSWR(postId ? [`/post-view/${postId}`, language] : null, async () => loadPost(api, postId, {
    language
  }), {
    ...swrLoadOnce,
    ...op
  });
  const {
    data: responsesData
  } = useLoadResponses(postId, op);
  const {
    data: groupData,
    error: postCircleError
  } = usePostGroupData(postId, op);
  useEffect(() => {
    setData({
      responsesRequestResult: responsesData,
      ...groupData,
      profile,
      post
    });
  }, [responsesData, groupData, profile, post]);
  const updateOrLoadPost = useMemoizedFn(async (post2) => {
    if (post2) {
      setData((current) => ({
        ...current,
        post: post2
      }));
      return post2;
    }
    const loadedPost = await loadPost(api, postId, {
      language
    });
    setData((current) => ({
      ...current,
      post: loadedPost
    }));
    return loadedPost;
  });
  const loadAndUpdateResponses = useMemoizedFn(async () => {
    const rootPostId = data && data.post && data.post._id;
    if (!rootPostId)
      return;
    const responsesRequestResult = await loadResponses(api, rootPostId, language);
    setData((current) => ({
      ...current,
      responsesRequestResult
    }));
  });
  return {
    data,
    helper,
    loadPost: updateOrLoadPost,
    loadResponses: loadAndUpdateResponses,
    postCircleError,
    postError,
    profileError
  };
};

const LoadPostViewData = ({
  postId,
  children,
  response,
  dialog
}) => {
  const {
    data,
    helper,
    loadPost,
    loadResponses,
    postCircleError,
    postError,
    profileError
  } = useLoadPost(postId);
  const {
    profile,
    post,
    responsesRequestResult,
    group,
    membership,
    invitation
  } = data;
  return /* @__PURE__ */ jsx(PostViewDataContextCoreProvider, {
    dialog,
    loadPost,
    loadResponses,
    circle: group,
    membership,
    invitation,
    helper,
    profile,
    post,
    responsesRequestResult,
    response,
    postCircleError,
    postError,
    profileError,
    children
  });
};

const GoingPopupButton$1 = () => {
  const {
    post,
    membership
  } = usePostInfoContext();
  return /* @__PURE__ */ jsx(GoingPopupButton2, {
    post,
    membership
  });
};
const GoingPopupButton2 = ({
  post,
  isNotPost,
  onPostUpdated,
  size,
  className,
  membership
}) => {
  const loginState = useLoginPopup();
  const [anchorEl, setAnchorEl] = useState(null);
  if (!post || post.type !== "event") {
    return null;
  }
  const handleClick = (event) => {
    if (!membership) {
      loginState.handleClick(event);
      return;
    }
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "going-popover" : void 0;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [new EventData(post).endTime > Date.now() && /* @__PURE__ */ jsxs(Button, {
      startIcon: /* @__PURE__ */ jsx(FaRegCalendarCheck, {}),
      className,
      onClick: handleClick,
      size: size || "medium",
      children: [/* @__PURE__ */ jsx(FormattedMessage, {
        id: "event.going"
      }), "?"]
    }), /* @__PURE__ */ jsxs(Popover, {
      id,
      open,
      anchorEl,
      onClose: handleClose,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      children: [isNotPost && open && /* @__PURE__ */ jsx(LoadPostViewData, {
        postId: post._id,
        children: /* @__PURE__ */ jsx(Going, {
          onPostUpdated
        })
      }), !isNotPost && open && /* @__PURE__ */ jsx(Going, {
        onPostUpdated
      })]
    }), /* @__PURE__ */ jsx(LoginPopup, {
      state: loginState
    })]
  });
};
const noop$d = () => null;
const EventAttendees = ({
  post
}) => {
  const {
    rsvp
  } = post;
  if (!rsvp) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-2 items-start p-2",
    children: Object.values(rsvp).map(({
      name,
      going
    }) => {
      return /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center",
        children: [/* @__PURE__ */ jsx("div", {
          children: name
        }), /* @__PURE__ */ jsx("div", {
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event." + going
          })
        })]
      });
    })
  });
};
const Going = (props) => {
  const {
    post,
    membership,
    loadPost
  } = usePostInfoContext();
  return /* @__PURE__ */ jsx(Going2, {
    post,
    membership,
    loadPost,
    ...props
  });
};
const Going2 = ({
  image,
  onPostUpdated = noop$d,
  loadPost = noop$d,
  post,
  membership
}) => {
  const api = useApi();
  const [anchorEl, setAnchorEl] = useState(null);
  if (!post || !membership || post.type !== "event" || new EventData(post).endTime < Date.now()) {
    return null;
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (name) => async () => {
    setAnchorEl(null);
    if (!name) {
      return;
    }
    await api.post({
      "path": `/posts/${post._id}/rsvp`,
      body: {
        going: name
      }
    });
    const updated = await loadPost();
    onPostUpdated(updated);
  };
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col p-2 gap-2 rounded-lg bg-[#00A5B6]",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [image, /* @__PURE__ */ jsxs("div", {
        className: "text-white",
        children: [/* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.going"
        }), "?"]
      }), /* @__PURE__ */ jsx(Button, {
        variant: "outlined",
        size: "small",
        onClick: handleClick,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.yes1"
        })
      }), /* @__PURE__ */ jsxs(Menu$1, {
        id: "simple-menu",
        anchorEl,
        open: Boolean(anchorEl),
        onClose: handleClose(),
        children: [/* @__PURE__ */ jsx(MenuItem, {
          onClick: handleClose("yes"),
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.yes"
          })
        }), /* @__PURE__ */ jsx(MenuItem, {
          onClick: handleClose("yes_v"),
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.yes_v"
          })
        })]
      }), /* @__PURE__ */ jsx(Button, {
        variant: "outlined",
        size: "small",
        onClick: handleClose("no"),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.no"
        })
      }), /* @__PURE__ */ jsx(Button, {
        variant: "outlined",
        size: "small",
        onClick: handleClose("maybe"),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.maybe"
        })
      })]
    })
  });
};

const GoingPopupButton = styled(GoingPopupButton2)`
  & .MuiButton-startIcon {
    margin-top: -5px;
    margin-right: 3px;
  }
`;
const EventDate = ({
  post,
  ...props
}) => {
  if (post.type !== "event") {
    return null;
  }
  const event = new EventData(post);
  return /* @__PURE__ */ jsx("div", {
    ...props,
    children: /* @__PURE__ */ jsx(FormattedDate, {
      value: event.localStartTime,
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    })
  });
};
const RsvpListItem = ({
  post,
  membership,
  ...props
}) => {
  const {
    updatePost
  } = useCirclePostsContext();
  if (!post || post.type !== "event") {
    return null;
  }
  const count = post.rsvp ? Object.keys(post.rsvp).length : 0;
  const onPostUpdated = useMemoizedFn((post2) => {
    updatePost(post2);
  });
  return /* @__PURE__ */ jsxs("div", {
    ...props,
    children: [count > 0 && /* @__PURE__ */ jsxs("span", {
      children: [count, " ", /* @__PURE__ */ jsx(FormattedMessage, {
        id: "event.responded"
      }), " \xA0"]
    }), /* @__PURE__ */ jsx(GoingPopupButton, {
      post,
      isNotPost: true,
      onPostUpdated,
      size: "small",
      membership
    })]
  });
};

const noop$c = () => null;
const PostsFiltersContext = createContext({
  type: null,
  setType: noop$c
});
const usePostsFiltersContext = () => {
  return useContext(PostsFiltersContext);
};
const PostsFiltersContextProvider = ({
  children
}) => {
  const [type, setType] = useState("");
  const context = useMemo(() => {
    return {
      type,
      setType
    };
  }, [type]);
  return /* @__PURE__ */ jsx(PostsFiltersContext.Provider, {
    value: context,
    children
  });
};

const usePostPromptExecution = (postId, isPrompt, options) => {
  const api = useApi();
  const result = useSWR(postId ? `/posts/${postId}/prompt-execution?prompt=${isPrompt}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const PostPromptExecution = (props) => {
  const {
    showPromptExecution
  } = useCircleModalDialogsContext();
  if (!showPromptExecution) {
    return null;
  }
  return /* @__PURE__ */ jsx(PostPromptExecutionInner, {
    ...props
  });
};
const PostPromptExecutionInner = ({
  postId,
  isPrompt
}) => {
  const {
    data,
    mutate
  } = usePostPromptExecution(postId, isPrompt);
  if (!data) {
    return null;
  }
  if (!data.source && !data.result && !isPrompt) {
    return null;
  }
  const {
    executing = []
  } = data;
  const onRefresh = () => {
    mutate();
  };
  const Source = () => {
    const {
      postProcessed,
      started,
      post,
      prompt,
      pages,
      pagesProcessed,
      errors,
      status,
      time
    } = data.source;
    const [showErrors, setShowErrors] = useState(false);
    const errorStatus = errors && errors.length > 0;
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "w-full justify-stretch flex gap-2 items-center",
        children: [/* @__PURE__ */ jsx("span", {
          children: "Last prompt execution (source)"
        }), time && /* @__PURE__ */ jsxs("span", {
          children: ["in ", time, " sec"]
        }), /* @__PURE__ */ jsx("a", {
          href: url4post(prompt),
          target: "_blank",
          children: /* @__PURE__ */ jsx(MdOutlineOpenInNew, {})
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-full justify-stretch flex gap-2 items-center",
        children: [!errorStatus && status === "finished" && /* @__PURE__ */ jsx(Chip$1, {
          label: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.success"
          }),
          size: "small"
        }), /* @__PURE__ */ jsx(Chip$1, {
          label: status,
          size: "small"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-full justify-stretch flex gap-2 items-center",
        children: [/* @__PURE__ */ jsx(RelativeTime, {
          value: started
        }), /* @__PURE__ */ jsx("a", {
          href: url4post(post),
          target: "_blank",
          children: /* @__PURE__ */ jsx(MdOutlineOpenInNew, {})
        }), pages && /* @__PURE__ */ jsx(Chip$1, {
          label: /* @__PURE__ */ jsx("div", {
            children: /* @__PURE__ */ jsxs("span", {
              children: ["pages ", pagesProcessed, "/", pages]
            })
          })
        })]
      }), showErrors && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col justify-stretch px-2",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "cursor-pointer underline",
          onClick: () => setShowErrors((e) => !e),
          children: [errors.length + " errors", ":"]
        }), errors.map((error, i) => /* @__PURE__ */ jsxs("div", {
          className: "p-2",
          children: [i + 1, ". ", error]
        }, error))]
      })]
    });
  };
  const Result = () => {
    const {
      postProcessed,
      started,
      post,
      prompt,
      pages,
      pagesProcessed,
      status,
      errors,
      time
    } = data.result;
    const [showErrors, setShowErrors] = useState(false);
    const errorStatus = errors && errors.length > 0;
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "w-full justify-stretch flex gap-2 items-center",
        children: [/* @__PURE__ */ jsx("span", {
          children: "Last prompt execution (result)"
        }), time && /* @__PURE__ */ jsxs("span", {
          children: ["in ", time, " sec"]
        }), /* @__PURE__ */ jsx("a", {
          href: url4post(prompt),
          target: "_blank",
          children: /* @__PURE__ */ jsx(MdOutlineOpenInNew, {})
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-full justify-stretch flex gap-2 items-center",
        children: [!errorStatus && status === "finished" && /* @__PURE__ */ jsx(Chip$1, {
          label: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.success"
          }),
          size: "small"
        }), /* @__PURE__ */ jsx(Chip$1, {
          label: status,
          size: "small"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-full justify-stretch flex gap-2 items-center",
        children: [/* @__PURE__ */ jsx(RelativeTime, {
          value: started
        }), /* @__PURE__ */ jsx("a", {
          href: url4post(postProcessed),
          target: "_blank",
          children: /* @__PURE__ */ jsx(MdOutlineOpenInNew, {})
        }), pages && /* @__PURE__ */ jsx(Chip$1, {
          label: /* @__PURE__ */ jsx("div", {
            children: /* @__PURE__ */ jsxs("span", {
              children: ["pages ", pagesProcessed, "/", pages]
            })
          })
        })]
      }), showErrors && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col justify-stretch px-2",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "cursor-pointer underline",
          onClick: () => setShowErrors((e) => !e),
          children: [errors.length + " errors", ":"]
        }), errors.map((error, i) => /* @__PURE__ */ jsxs("div", {
          className: "p-2",
          children: [i + 1, ". ", error]
        }, error))]
      })]
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2 relative",
    children: [/* @__PURE__ */ jsx("div", {
      className: "absolute right-0 top-0",
      children: /* @__PURE__ */ jsx(IconButton$5, {
        onClick: onRefresh,
        children: /* @__PURE__ */ jsx(BiRefresh, {})
      })
    }), data.source && /* @__PURE__ */ jsx(Source, {}), data.result && /* @__PURE__ */ jsx(Result, {}), isPrompt && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex items-center gap-2",
        children: /* @__PURE__ */ jsxs("span", {
          children: ["Currently executing (", executing.length, " found)"]
        })
      }), executing.map((one) => {
        const {
          started,
          postProcessed
        } = one;
        return /* @__PURE__ */ jsxs("div", {
          className: "flex gap-2 items-center",
          children: [/* @__PURE__ */ jsx(RelativeTime, {
            value: started
          }), /* @__PURE__ */ jsx("a", {
            href: url4post(postProcessed),
            target: "_blank",
            children: /* @__PURE__ */ jsx(MdOutlineOpenInNew, {})
          })]
        });
      })]
    })]
  });
};

const MAX_INLINE_FIELDS = 2;
const allFields = [...metadataFields, ...interviewFields];
const PostMetadataFields = ({
  post
}) => {
  const [visible] = useVisibleMetadataFields();
  if (!visible || visible.length === 0 || !post.metadata) {
    return null;
  }
  const populated = allFields.filter((field) => visible.includes(field.shortName) && post.metadata[field.shortName]).slice(0, MAX_INLINE_FIELDS);
  if (populated.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className: "flex gap-3 items-center flex-wrap",
    children: populated.map((field) => /* @__PURE__ */ jsxs("p", {
      className: "text-2xs opacity-70",
      children: [field.name, ": ", String(post.metadata[field.shortName])]
    }, field.shortName))
  });
};

const errorPanelVariants = cva("rounded-lg border transition-all duration-200", {
  variants: {
    variant: {
      compact: "p-3",
      detailed: "p-4"
    },
    severity: {
      error: "bg-red-50 border-red-200 text-red-800",
      warning: "bg-amber-50 border-amber-200 text-amber-800"
    }
  },
  defaultVariants: {
    variant: "detailed",
    severity: "error"
  }
});
const isApiError = (error) => {
  return error && typeof error === "object" && error.type && error.status !== void 0;
};
const getErrorSeverity = (error) => {
  if (isApiError(error)) {
    if (error.type === "timeout" || error.type === "network")
      return "warning";
    if (error.status === 429)
      return "warning";
  }
  return "error";
};
const getRetryHint = (error) => {
  switch (error.type) {
    case "network":
      return "Check your internet connection and try again";
    case "timeout":
      return "The request took too long - please try again";
    case "server":
      if (error.status && error.status >= 500) {
        return "Server issue - please try again in a few moments";
      }
      if (error.status === 429) {
        return "Too many requests - please wait a moment before trying again";
      }
      break;
  }
  return null;
};
const ErrorPanel$1 = ({
  error,
  variant,
  onDismiss,
  className
}) => {
  const [showDetails, setShowDetails] = useState(false);
  if (!error)
    return null;
  const errorMessage = typeof error === "string" ? error : error.message;
  const apiError = isApiError(error) ? error : null;
  const severity = getErrorSeverity(error);
  const retryHint = apiError ? getRetryHint(apiError) : null;
  const hasDetails = apiError && (apiError.status || apiError.response || apiError.errors);
  return /* @__PURE__ */ jsx("div", {
    className: errorPanelVariants({
      variant,
      severity,
      className
    }),
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex items-start gap-3",
      children: [/* @__PURE__ */ jsx(MdError, {
        className: "w-5 h-5 flex-shrink-0 mt-0.5"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 min-w-0",
        children: [/* @__PURE__ */ jsx("div", {
          className: "font-medium text-sm",
          children: errorMessage
        }), retryHint && /* @__PURE__ */ jsx("div", {
          className: "text-xs mt-1 opacity-80",
          children: retryHint
        }), hasDetails && /* @__PURE__ */ jsxs("button", {
          onClick: () => setShowDetails(!showDetails),
          className: "flex items-center gap-1 text-xs mt-2 underline hover:no-underline focus:outline-none",
          children: [/* @__PURE__ */ jsx(MdExpandMore, {
            className: `w-4 h-4 transition-transform ${showDetails ? "rotate-180" : ""}`
          }), showDetails ? "Hide details" : "Show details"]
        }), showDetails && apiError && /* @__PURE__ */ jsx("div", {
          className: "mt-3 pt-3 border-t border-current/20",
          children: /* @__PURE__ */ jsxs("div", {
            className: "space-y-2 text-xs",
            children: [apiError.status && /* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "font-medium",
                children: "Status:"
              }), " ", apiError.status, apiError.statusText && ` (${apiError.statusText})`]
            }), apiError.type && /* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "font-medium",
                children: "Type:"
              }), " ", apiError.type]
            }), apiError.response && /* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "font-medium",
                children: "Server Response:"
              }), /* @__PURE__ */ jsx("pre", {
                className: "mt-1 p-2 bg-black/5 rounded text-xs font-mono overflow-auto max-h-32",
                children: typeof apiError.response === "string" ? apiError.response : JSON.stringify(apiError.response, null, 2)
              })]
            }), apiError.errors && /* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "font-medium",
                children: "Error Details:"
              }), /* @__PURE__ */ jsx("pre", {
                className: "mt-1 p-2 bg-black/5 rounded text-xs font-mono overflow-auto max-h-32",
                children: typeof apiError.errors === "string" ? apiError.errors : JSON.stringify(apiError.errors, null, 2)
              })]
            })]
          })
        })]
      }), onDismiss && /* @__PURE__ */ jsx("button", {
        onClick: onDismiss,
        className: "flex-shrink-0 p-1 hover:bg-black/10 rounded transition-colors focus:outline-none focus:ring-2 focus:ring-current/20",
        "aria-label": "Dismiss error",
        children: /* @__PURE__ */ jsx(MdClose, {
          className: "w-4 h-4"
        })
      })]
    })
  });
};

const toggleButtonVariants = cva("inline-flex items-center justify-center rounded transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1", {
  variants: {
    variant: {
      default: "hover:bg-gray-100 text-gray-600",
      subtle: "hover:bg-gray-50 text-gray-500",
      primary: "hover:bg-blue-50 text-blue-600",
      ghost: "hover:bg-transparent text-gray-400 hover:text-gray-600"
    },
    size: {
      xs: "p-0.5",
      sm: "p-1",
      md: "p-1.5",
      lg: "p-2",
      xl: "p-3"
    },
    disabled: {
      true: "opacity-50 pointer-events-none",
      false: ""
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md",
    disabled: false
  }
});
const iconVariants = cva("transition-transform duration-200", {
  variants: {
    size: {
      xs: "w-3 h-3",
      sm: "w-4 h-4",
      md: "w-5 h-5",
      lg: "w-6 h-6",
      xl: "w-7 h-7"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const ToggleButton = ({
  expanded,
  onToggle,
  variant,
  size,
  disabled,
  iconSize,
  children,
  className,
  title,
  ...props
}) => {
  const effectiveIconSize = iconSize || size;
  return /* @__PURE__ */ jsx("button", {
    onClick: onToggle,
    className: toggleButtonVariants({
      variant,
      size,
      disabled,
      className
    }),
    title: title || (expanded ? "Collapse" : "Expand"),
    type: "button",
    disabled,
    ...props,
    children: children || (expanded ? /* @__PURE__ */ jsx(MdExpandMore, {
      className: iconVariants({
        size: effectiveIconSize
      })
    }) : /* @__PURE__ */ jsx(MdChevronRight, {
      className: iconVariants({
        size: effectiveIconSize
      })
    }))
  });
};

const collapsibleSectionVariants = cva("overflow-hidden rounded-lg", {
  variants: {
    variant: {
      default: "border border-gray-200",
      outlined: "border border-gray-300",
      elevated: "border border-gray-100 shadow-sm",
      minimal: "border-0",
      card: "border border-gray-200 bg-white shadow-sm"
    },
    spacing: {
      none: "",
      sm: "m-1",
      md: "m-2",
      lg: "m-4"
    }
  },
  defaultVariants: {
    variant: "default",
    spacing: "none"
  }
});
const headerVariants$1 = cva("flex items-center gap-3", {
  variants: {
    variant: {
      default: "p-4 bg-white",
      subtle: "p-4 bg-gray-50",
      primary: "p-4 bg-blue-50",
      minimal: "p-2",
      card: "p-4 bg-white"
    },
    size: {
      sm: "p-2",
      md: "p-4",
      lg: "p-6"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
});
const contentVariants$1 = cva("border-t", {
  variants: {
    variant: {
      default: "border-gray-200 bg-gray-50 p-4",
      subtle: "border-gray-100 bg-white p-4",
      primary: "border-blue-200 bg-blue-50/30 p-4",
      minimal: "border-gray-200 p-2",
      card: "border-gray-200 bg-gray-50 p-4"
    },
    size: {
      sm: "p-2",
      md: "p-4",
      lg: "p-6"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
});
const titleVariants = cva("font-medium", {
  variants: {
    size: {
      sm: "text-sm text-gray-600",
      md: "text-md text-gray-700",
      lg: "text-lg text-gray-800"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const CollapsibleSection = ({
  title,
  children,
  defaultCollapsed = false,
  variant,
  spacing,
  headerVariant,
  contentVariant,
  headerSize,
  contentSize,
  titleSize,
  toggleVariant = "default",
  toggleSize = "md",
  className,
  renderHeader,
  keepMounted
}) => {
  const [expanded, setExpanded] = useState(!defaultCollapsed);
  const handleToggle = () => {
    setExpanded(!expanded);
  };
  const effectiveHeaderVariant = headerVariant || (variant === "minimal" ? "minimal" : variant === "card" ? "card" : "default");
  const effectiveContentVariant = contentVariant || (variant === "minimal" ? "minimal" : variant === "card" ? "card" : "default");
  return /* @__PURE__ */ jsxs("div", {
    className: collapsibleSectionVariants({
      variant,
      spacing,
      className
    }),
    children: [/* @__PURE__ */ jsx("div", {
      className: headerVariants$1({
        variant: effectiveHeaderVariant,
        size: headerSize
      }),
      children: renderHeader ? renderHeader(expanded, handleToggle) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(ToggleButton, {
          expanded,
          onToggle: handleToggle,
          variant: toggleVariant,
          size: toggleSize
        }), /* @__PURE__ */ jsx("h3", {
          className: titleVariants({
            size: titleSize
          }),
          children: title
        })]
      })
    }), (expanded || keepMounted) && /* @__PURE__ */ jsx("div", {
      className: [contentVariants$1({
        variant: effectiveContentVariant,
        size: contentSize
      }), expanded ? "" : "hidden"].join(" "),
      children
    })]
  });
};

const FAMILY_FIELDS = ["privacy", "type", "circleId", "rootPostId"];
const familyFieldDrift = (chunks) => {
  if (chunks.length === 0) {
    return [];
  }
  const reference = chunks[0];
  return FAMILY_FIELDS.filter((field) => chunks.some((c) => c[field] !== reference[field]));
};
const METADATA_KEYS_TO_IGNORE = ["creationDate"];
const metadataMatchesExpected = (chunkMetadata, expected) => {
  if (!expected) {
    return true;
  }
  if (!chunkMetadata) {
    return false;
  }
  return Object.keys(expected).filter((key) => METADATA_KEYS_TO_IGNORE.indexOf(key) === -1).every((key) => JSON.stringify(chunkMetadata[key]) === JSON.stringify(expected[key]));
};
const metadataMismatchChunkIds = (chunks, expected) => chunks.filter((c) => !metadataMatchesExpected(c.metadata, expected)).map((c) => c._id);
const maxIso = (values) => {
  if (values.length === 0) {
    return null;
  }
  return values.reduce((a, b) => a > b ? a : b);
};
const outOfSyncChunkIds = (openaiChunks, qwenChunks) => {
  const qwenById = new Map();
  qwenChunks.forEach((c) => qwenById.set(c._id, c));
  const outOfSync = [];
  openaiChunks.forEach((oa) => {
    const qw = qwenById.get(oa._id);
    if (qw !== void 0 && qw.modified !== oa.modified) {
      outOfSync.push(oa._id);
    }
  });
  return outOfSync;
};
const summarizePostEsEntry = (data) => {
  const indices = data.indices;
  const openaiChunks = indices && indices.openai ? indices.openai.chunks : [];
  const qwenChunks = indices && indices.qwen ? indices.qwen.chunks : [];
  const expected = data.expectedMetadata;
  return {
    totalChunks: openaiChunks.length > 0 ? openaiChunks.length : qwenChunks.length,
    openaiCount: openaiChunks.length,
    openaiFamilyDrift: familyFieldDrift(openaiChunks),
    openaiMetadataMismatchChunkIds: metadataMismatchChunkIds(openaiChunks, expected),
    qwenCount: qwenChunks.length,
    qwenMissing: qwenChunks.length === 0,
    qwenFamilyDrift: familyFieldDrift(qwenChunks),
    qwenMetadataMismatchChunkIds: metadataMismatchChunkIds(qwenChunks, expected),
    latestModified: maxIso(openaiChunks.map((c) => c.modified)),
    outOfSyncChunkIds: outOfSyncChunkIds(openaiChunks, qwenChunks)
  };
};

const FIELDS_TO_COMPARE = [
  "title",
  "authors",
  "metadataText",
  "type",
  "isTopLevel"
];
const staleFields = (doc, expected) => {
  if (!doc || !expected) {
    return [];
  }
  return FIELDS_TO_COMPARE.filter((field) => JSON.stringify(doc[field]) !== JSON.stringify(expected[field]));
};
const summarizePostCircleSearchEntry = (data) => {
  return {
    found: data.found,
    staleFields: staleFields(data.doc, data.expected),
    modified: data.doc ? data.doc.modified : null
  };
};

const PostCircleSearchSubpanel = ({
  postId,
  open
}) => {
  const [copied, setCopied] = useState(false);
  const api = useApi();
  const {
    data,
    isLoading,
    error,
    execute
  } = useAsyncOperation(async () => {
    return await api.get({
      path: `/circle-search/post/${postId}/entry`
    });
  });
  useEffect(() => {
    if (open && !data && !isLoading) {
      execute();
    }
  }, [open]);
  const onCopyJson = useMemoizedFn(async () => {
    if (!navigator.clipboard || !data) {
      return;
    }
    try {
      await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
    }
  });
  if (!open) {
    return null;
  }
  const summary = data ? summarizePostCircleSearchEntry(data) : null;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-1",
    children: [isLoading && /* @__PURE__ */ jsx(Spinner, {
      size: "xs"
    }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error,
      variant: "compact"
    }), data && summary && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-wrap items-center gap-1.5 text-xs",
        children: [/* @__PURE__ */ jsx("span", {
          className: "px-1.5 py-0.5 rounded bg-gray-100 text-gray-700 font-medium",
          children: "circle-search"
        }), /* @__PURE__ */ jsx("span", {
          className: summary.found === false ? "px-1.5 py-0.5 rounded bg-gray-100 text-gray-500" : summary.staleFields.length === 0 ? "px-1.5 py-0.5 rounded bg-blue-50 text-blue-700" : "px-1.5 py-0.5 rounded bg-red-50 text-red-700",
          children: summary.found === false ? "not indexed" : summary.staleFields.length === 0 ? "indexed \u2713" : "\u26A0 stale " + summary.staleFields.join(", ")
        }), data.isTopLevel === false && /* @__PURE__ */ jsx("span", {
          className: "text-gray-400",
          children: "page \u2192 root entry"
        }), summary.modified && /* @__PURE__ */ jsxs("span", {
          className: "text-gray-400",
          children: ["modified ", /* @__PURE__ */ jsx(RelativeTime, {
            value: summary.modified
          })]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex justify-end",
        children: /* @__PURE__ */ jsx("button", {
          onClick: onCopyJson,
          className: "text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100",
          children: copied ? "Copied!" : "Copy JSON"
        })
      }), /* @__PURE__ */ jsx(CollapsibleSection, {
        title: "Raw JSON",
        defaultCollapsed: true,
        variant: "minimal",
        titleSize: "sm",
        toggleSize: "sm",
        children: /* @__PURE__ */ jsx("pre", {
          className: "text-[10px] bg-gray-50 border border-gray-200 rounded p-2 overflow-x-auto max-h-64 overflow-y-auto whitespace-pre-wrap",
          children: JSON.stringify(data, null, 2)
        })
      })]
    })]
  });
};

const PostDeveloperPanel = ({
  postId,
  className
}) => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const api = useApi();
  const {
    data,
    isLoading,
    error,
    execute
  } = useAsyncOperation(async () => {
    return await api.get({
      path: `/rag/post/${postId}/es-entry`
    });
  });
  const onToggle = useMemoizedFn(() => {
    const next = !open;
    setOpen(next);
    if (next && !data && !isLoading) {
      execute();
    }
  });
  const onCopyJson = useMemoizedFn(async () => {
    if (!navigator.clipboard || !data) {
      return;
    }
    try {
      await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
    }
  });
  const summary = data ? summarizePostEsEntry(data) : null;
  const describeIssues = (familyDrift, metadataMismatchCount) => {
    const issues = [];
    if (familyDrift.length > 0) {
      issues.push(familyDrift.join(", "));
    }
    if (metadataMismatchCount > 0) {
      issues.push("metadata (" + metadataMismatchCount + ")");
    }
    return issues;
  };
  return /* @__PURE__ */ jsxs("div", {
    className,
    children: [/* @__PURE__ */ jsx("button", {
      onClick: onToggle,
      className: "text-xs text-gray-500 hover:text-gray-700",
      children: open ? "Hide dev info" : "Dev info"
    }), open && /* @__PURE__ */ jsxs("div", {
      className: "mt-1 flex flex-col gap-1",
      children: [isLoading && /* @__PURE__ */ jsx(Spinner, {
        size: "xs"
      }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error,
        variant: "compact"
      }), data && summary && (() => {
        const openaiIssues = describeIssues(summary.openaiFamilyDrift, summary.openaiMetadataMismatchChunkIds.length);
        const qwenIssues = describeIssues(summary.qwenFamilyDrift, summary.qwenMetadataMismatchChunkIds.length);
        return /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex flex-wrap items-center gap-1.5 text-xs",
            children: [/* @__PURE__ */ jsxs("span", {
              className: "px-1.5 py-0.5 rounded bg-gray-100 text-gray-700 font-medium",
              children: [summary.totalChunks, " chunks"]
            }), /* @__PURE__ */ jsxs("span", {
              className: summary.openaiCount === 0 ? "px-1.5 py-0.5 rounded bg-gray-100 text-gray-500" : openaiIssues.length === 0 ? "px-1.5 py-0.5 rounded bg-blue-50 text-blue-700" : "px-1.5 py-0.5 rounded bg-red-50 text-red-700",
              children: ["openai ", summary.openaiCount, summary.openaiCount > 0 && (openaiIssues.length === 0 ? " \u2713" : " \u26A0 " + openaiIssues.join("; "))]
            }), /* @__PURE__ */ jsxs("span", {
              className: summary.qwenMissing ? "px-1.5 py-0.5 rounded bg-gray-100 text-gray-500" : qwenIssues.length === 0 ? "px-1.5 py-0.5 rounded bg-blue-50 text-blue-700" : "px-1.5 py-0.5 rounded bg-red-50 text-red-700",
              children: ["qwen ", summary.qwenCount, !summary.qwenMissing && (qwenIssues.length === 0 ? " \u2713" : " \u26A0 " + qwenIssues.join("; "))]
            }), summary.outOfSyncChunkIds.length > 0 && /* @__PURE__ */ jsxs("span", {
              className: "px-1.5 py-0.5 rounded bg-amber-50 text-amber-700",
              children: ["qwen embeddings stale (", summary.outOfSyncChunkIds.length, ")"]
            }), summary.latestModified && /* @__PURE__ */ jsxs("span", {
              className: "text-gray-400",
              children: ["modified ", /* @__PURE__ */ jsx(RelativeTime, {
                value: summary.latestModified
              })]
            })]
          }), /* @__PURE__ */ jsx("div", {
            className: "flex justify-end",
            children: /* @__PURE__ */ jsx("button", {
              onClick: onCopyJson,
              className: "text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100",
              children: copied ? "Copied!" : "Copy JSON"
            })
          }), /* @__PURE__ */ jsx(CollapsibleSection, {
            title: "Raw JSON",
            defaultCollapsed: true,
            variant: "minimal",
            titleSize: "sm",
            toggleSize: "sm",
            children: /* @__PURE__ */ jsx("pre", {
              className: "text-[10px] bg-gray-50 border border-gray-200 rounded p-2 overflow-x-auto max-h-64 overflow-y-auto whitespace-pre-wrap",
              children: JSON.stringify(data, null, 2)
            })
          })]
        });
      })(), /* @__PURE__ */ jsx(PostCircleSearchSubpanel, {
        postId,
        open
      }), "   "]
    })]
  });
};

const PostMenu$1 = ({
  post,
  className
}) => {
  const {
    render
  } = useCirclePostItems();
  const {
    profile,
    membership,
    circle
  } = useCircleContext();
  const hasOverflowMenu = (target) => {
    return isAuthor(target, profile) || isAdmin(membership) && circle && !circle.closed;
  };
  if (!hasOverflowMenu(post)) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className,
    children: /* @__PURE__ */ jsx("div", {
      className: "relative inline-block",
      children: /* @__PURE__ */ jsx(OverflowMenu, {
        fn: render,
        target: post,
        button: StyledMenuButton$1
      })
    })
  });
};
const postType = (post) => {
  const type = post.type;
  if (type === "event") {
    return "event";
  }
  return type;
};
const PostCardWrapper$1 = styled.div`
  & .ns-post-tag {
    margin-top: 0;
    margin-bottom: 0;
  }
  line-height: 1.2;
`;
const Div = (props) => /* @__PURE__ */ jsx("div", {
  ...props
});
const PROMPT_TAG = "_prompt";
const isPromptPost = (post) => {
  return !(!post || !post.tags || post.tags.indexOf(PROMPT_TAG) === -1);
};
const ExecutePromptButton = ({
  post
}) => {
  const {
    onClick,
    loading
  } = useExecutePrompt(post && post._id);
  const canExecutePrompt = useCanExecutePrompt();
  if (!isPromptPost(post) || !canExecutePrompt) {
    return null;
  }
  return /* @__PURE__ */ jsx(LoadingButton, {
    variant: "outlined",
    size: "small",
    onClick,
    loading,
    children: "Execute"
  });
};
const TestPromptButton = ({
  post
}) => {
  const {
    onClick,
    loading
  } = useTestPrompt(post && post._id);
  const canExecutePrompt = useCanExecutePrompt();
  if (!isPromptPost(post) || !canExecutePrompt) {
    return null;
  }
  return /* @__PURE__ */ jsx(LoadingButton, {
    variant: "outlined",
    size: "small",
    onClick,
    loading,
    children: "Test"
  });
};
const LikeButton = (props) => {
  const {
    post
  } = props;
  if (!post) {
    return null;
  }
  return /* @__PURE__ */ jsx(LikeButtonInner, {
    ...props
  });
};
const LikeButtonInner = ({
  post,
  variant = "list",
  membership
}) => {
  const loginState = useLoginPopup();
  const {
    handleClick
  } = loginState;
  const postLikes = post.likes || 0;
  const [likes, setLikes] = useState(postLikes);
  const [me, setMe] = useState(post.myLike);
  useEffect(() => {
    if (postLikes === likes) {
      return;
    }
    setLikes(postLikes);
  }, [postLikes]);
  useEffect(() => {
    if (post.myLike === me) {
      return;
    }
    setMe(post.myLike);
  }, [post.myLike]);
  const api = useApi();
  const onLike = async (event) => {
    if (!membership) {
      handleClick(event);
      return;
    }
    const result = await api.post({
      path: `/posts/${post._id}/like`,
      body: {
        like: me ? 0 : 1,
        circle: post.group.group
      }
    });
    setMe(result.me);
    setLikes(result.likes);
  };
  const isList = variant === "list";
  const iconSize = isList ? 16 : 24;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(IconButton$5, {
      size: "small",
      onClick: onLike,
      children: [me ? /* @__PURE__ */ jsx(IoIosHeart, {
        size: iconSize
      }) : /* @__PURE__ */ jsx(IoIosHeartEmpty, {
        size: iconSize
      }), /* @__PURE__ */ jsx("div", {
        className: isList ? "text-2xs" : "text-sm",
        children: likes
      })]
    }), /* @__PURE__ */ jsx(LoginPopup, {
      state: loginState
    })]
  });
};
const POST_CARD_HEIGHT = 157;
const PostCard = ({
  post,
  selected,
  style,
  ...props
}) => {
  const {
    membership
  } = useCircleContext();
  const {
    setType
  } = usePostsFiltersContext();
  const isDeveloper = useIsDeveloper();
  const url = url4post(post);
  const {
    type,
    tags
  } = post;
  const isPrompt = tags && tags.includes("_prompt");
  const TypeIcon = getPostTypeIcon(post);
  const onType = () => setType((t) => t ? null : type);
  return /* @__PURE__ */ jsxs(PostCardWrapper$1, {
    "data-testid": "PostCard",
    style,
    className: clsx("justify-start items-start relative gap-3 p-3 bg-white flex w-full card-shadow overflow-hidden leading-3 text-black", selected && "outline-yellow-200 outline"),
    ...props,
    children: [/* @__PURE__ */ jsx(PostMenu$1, {
      post,
      className: "absolute ltr:right-0 rtl:left-0 top-0 mt-0 mr-0 z-10"
    }), /* @__PURE__ */ jsx(Link$2, {
      to: url,
      children: /* @__PURE__ */ jsx(PostImage, {
        post,
        width: 60,
        height: 60,
        className: "flex"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-between items-start  gap-1.5",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col justify-start items-start relative",
        children: [/* @__PURE__ */ jsxs("a", {
          className: "hidden sm:flex gap-2 items-center opacity-70 text-2xs font-medium",
          onClick: onType,
          children: [/* @__PURE__ */ jsx(TypeIcon, {
            className: "min-w-[16px] min-h-[16px]",
            size: 16
          }), /* @__PURE__ */ jsx("p", {
            className: "underline",
            children: postType(post)
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "inline-block self-stretch relative",
          children: [/* @__PURE__ */ jsx(TypeIcon, {
            className: "sm:hidden min-w-[16px] min-h-[16px] inline mr-1 mt-1",
            size: 12,
            onClick: onType
          }), /* @__PURE__ */ jsxs(Link$2, {
            to: url,
            children: [/* @__PURE__ */ jsx("p", {
              className: "inline text-sm font-semibold break-words",
              children: post.title
            }), post.translate && /* @__PURE__ */ jsx(CgSpinner, {
              size: 20,
              className: "animate-spin inline"
            })]
          })]
        })]
      }), /* @__PURE__ */ jsxs(PostAuthor$1, {
        post,
        children: [/* @__PURE__ */ jsx(ExecutePromptButton, {
          post
        }), /* @__PURE__ */ jsx(TestPromptButton, {
          post
        })]
      }), /* @__PURE__ */ jsx(Tags$1, {
        tags: post.tags,
        tagClassName: "text-2xs",
        chipInner: Div
      }), /* @__PURE__ */ jsx("div", {
        className: "flex justify-between items-end self-stretch",
        children: /* @__PURE__ */ jsxs("div", {
          className: "flex gap-9 items-center",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex gap-3 items-center",
            children: [/* @__PURE__ */ jsx(TimeIcon, {
              className: "hidden sm:block flex-grow-0 flex-shrink-0 w-4 h-4"
            }), /* @__PURE__ */ jsx("p", {
              className: "text-2xs w-full",
              children: /* @__PURE__ */ jsx(RelativeTime, {
                value: post.created
              })
            })]
          }), /* @__PURE__ */ jsx(LikeButton, {
            post,
            membership
          }), type !== "event" && /* @__PURE__ */ jsxs("div", {
            className: "lg:flex gap-3 items-center hidden",
            children: [/* @__PURE__ */ jsx(ReadTimeIcon, {
              className: "hidden sm:block flex-grow-0 flex-shrink-0 w-4 h-4"
            }), /* @__PURE__ */ jsx("p", {
              className: "text-2xs",
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "posts.n_minute_read",
                values: {
                  value: post.readTime
                }
              })
            })]
          }), type !== "event" && /* @__PURE__ */ jsxs("div", {
            className: "flex gap-3 items-center",
            children: [/* @__PURE__ */ jsx(ResponsesIcon, {
              className: "hidden sm:block flex-grow-0 flex-shrink-0 w-4 h-4"
            }), /* @__PURE__ */ jsxs("p", {
              className: "text-2xs",
              children: [post.responseCount, " ", isBook(post) ? /* @__PURE__ */ jsx(FormattedMessage, {
                id: "group.pages"
              }) : /* @__PURE__ */ jsx(FormattedMessage, {
                id: "group.totalResponses"
              })]
            })]
          }), /* @__PURE__ */ jsx(RsvpListItem, {
            post,
            className: "text-2xs flex items-center",
            membership
          }), post.attachments && post.attachments.length > 0 && /* @__PURE__ */ jsx("div", {
            className: "flex gap-3 items-center",
            children: /* @__PURE__ */ jsx(MdAttachFile, {
              className: "block flex-grow-0 flex-shrink-0 w-4 h-4"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(EventDate, {
        post,
        className: "text-2xs"
      }), /* @__PURE__ */ jsx(PostPromptExecution, {
        postId: post && post._id,
        isPrompt
      }), /* @__PURE__ */ jsx(PostMetadataFields, {
        post
      }), isDeveloper && /* @__PURE__ */ jsx(PostDeveloperPanel, {
        postId: post._id,
        className: "mt-1"
      })]
    })]
  });
};

const useTranslateCirclePostsFn = () => {
  const api = useApi();
  return async (circleId, language, posts) => {
    const array = await api.post({
      path: `/translate-circle`,
      body: {
        language,
        ids: posts.map((p) => p._id),
        circle: circleId,
        titles: posts.map((p) => p.title),
        modified: posts.map((p) => p.modified)
      }
    });
    return array;
  };
};

const useCirclePostsData = ({
  events,
  chat
}) => {
  const {
    initialPosts: initial,
    id: circleId
  } = useCircleContext();
  const [filter, setFilter] = useState("");
  const {
    filter$
  } = useSearchContext();
  filter$.useSubscription(({
    filter: filter2
  }) => {
    setFilter(filter2);
    setLoading(true);
  });
  const {
    data,
    error,
    mutate
  } = useCirclePosts(circleId, {
    fallbackData: initial,
    onSuccess() {
      setLoading(false);
    }
  }, filter, {
    events,
    chat
  });
  const {
    activities$
  } = useActivityContext();
  const {
    run
  } = useThrottleFn(() => {
    mutate();
  }, {
    wait: 5e3
  });
  activities$.useSubscription(({
    type
  }) => {
    if (type !== "post") {
      return;
    }
    run();
  });
  const {
    event$
  } = useCircleContext();
  event$.useSubscription((event) => {
    switch (event.type) {
      case CIRCLE_EVENT_REFRESH_POSTS: {
        setLoading(true);
        mutate();
        break;
      }
    }
  });
  const [loading, setLoading] = useState(!initial);
  return {
    data,
    loading,
    error,
    mutate
  };
};
const useTranslatedCirclePosts = (posts) => {
  const [translated, setTranslated] = useState(posts);
  const translateCirclePosts = useTranslateCirclePostsFn();
  const {
    id
  } = useCircleContext();
  const {
    language
  } = useLanguageSelectionContext();
  useEffect(() => {
    if (translated === posts) {
      return;
    }
    setTranslated(posts);
  }, [posts]);
  useAsyncEffect(async () => {
    if (!posts || !posts.length) {
      return;
    }
    const notTranslated = posts.filter((p) => p.translate);
    if (!notTranslated.length) {
      return;
    }
    const translated2 = await translateCirclePosts(id, language, posts);
    updateTranslated(translated2);
  }, [posts]);
  const updateTranslated = useMemoizedFn((translated2) => {
    if (!translated2.length) {
      return;
    }
    const updated = {};
    translated2.forEach((t) => {
      updated[t.id] = t;
    });
    const updatedPosts = posts.map((post) => {
      const update = updated[post._id];
      if (!update) {
        return post;
      }
      return {
        ...post,
        title: update.title,
        translate: false
      };
    });
    setTranslated(updatedPosts);
  });
  return translated;
};
const LoadCirclePosts = (props) => {
  const {
    children
  } = props;
  const {
    data,
    error,
    loading,
    mutate
  } = useCirclePostsData(props);
  return /* @__PURE__ */ jsx(CirclePostsContextProvider, {
    ...data || {},
    error,
    loading,
    mutate,
    children
  });
};

const ArticlesArea = () => {
  return /* @__PURE__ */ jsx(LoadCirclePosts, {
    children: /* @__PURE__ */ jsx(ArticlesAreaInner, {})
  });
};
const ArticlesAreaInner = () => {
  const {
    posts
  } = useCirclePostsContext();
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-wrap gap-4 justify-items-center",
    children: posts.list.filter((p) => p.type === "article").map((article) => /* @__PURE__ */ jsx(PostCard, {
      post: article
    }))
  });
};

const DiscussionCard = ({
  discussion
}) => {
  const event = new EventData(discussion);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col justify-start items-start w-[370px] relative rounded-[10px] bg-white shadow-md shadow-slate-300 text-white min-h-[130px]",
    children: [/* @__PURE__ */ jsx(PostImage, {
      post: discussion,
      width: 370,
      height: 194,
      className: "rounded-tl-[10px] rounded-tr-[10px]"
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col justify-start items-start relative gap-[13px] ml-1",
      children: /* @__PURE__ */ jsx("p", {
        className: "break-words  text-base/5 font-bold text-left text-black",
        children: discussion.title
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex justify-end  w-full p-2 mt-auto mb-1 ",
      children: /* @__PURE__ */ jsx("div", {
        className: "flex items-end relative rounded-[10px] bg-blue-500 text-sm px-2",
        children: /* @__PURE__ */ jsx(Link$2, {
          to: url4post(discussion),
          children: "Join to Discuss"
        })
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: `
flex flex-col justify-start items-center w-fit px-2 py-1
absolute top-2 right-0
rounded-tl-[20px] rounded-br-[20px]
text-xs font-semibold bg-green-500
shadow-md shadow-slate-300
`,
      children: [/* @__PURE__ */ jsx("p", {
        children: /* @__PURE__ */ jsx(FormattedDate, {
          value: event.localStartTime,
          year: "numeric",
          month: "long",
          day: "2-digit"
        })
      }), /* @__PURE__ */ jsx("p", {
        className: "text-[10px]",
        children: "TO"
      }), /* @__PURE__ */ jsx("p", {
        children: /* @__PURE__ */ jsx(FormattedDate, {
          value: event.localEndTime,
          year: "numeric",
          month: "long",
          day: "2-digit"
        })
      })]
    })]
  });
};

const DiscussionsArea = () => {
  return /* @__PURE__ */ jsx(LoadCirclePosts, {
    children: /* @__PURE__ */ jsx(DiscussionsAreaInner, {})
  });
};
const DiscussionsAreaInner = () => {
  const {
    posts
  } = useCirclePostsContext();
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col md:flex-row flex-wrap gap-2 justify-items-center items-center md:items-stretch",
    children: posts.list.filter((p) => p.type === "discussion").map((discussion) => /* @__PURE__ */ jsx(DiscussionCard, {
      discussion
    }))
  });
};

const LockIcon$1 = (props) => {
  return /* @__PURE__ */ jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M8 11V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7M12 15V17M6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V13C20 12.4696 19.7893 11.9609 19.4142 11.5858C19.0391 11.2107 18.5304 11 18 11H6C5.46957 11 4.96086 11.2107 4.58579 11.5858C4.21071 11.9609 4 12.4696 4 13V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21Z",
      stroke: "#4A90CE",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const PostsIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M4 16L8.586 11.414C8.96106 11.0391 9.46967 10.8284 10 10.8284C10.5303 10.8284 11.0389 11.0391 11.414 11.414L16 16M14 14L15.586 12.414C15.9611 12.0391 16.4697 11.8284 17 11.8284C17.5303 11.8284 18.0389 12.0391 18.414 12.414L20 14M14 8H14.01M6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20Z",
      stroke: "#4A90CE",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const MembersIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", {
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M12 5.32397C12.5374 4.71467 13.2477 4.28348 14.0362 4.08776C14.8247 3.89205 15.6542 3.94109 16.4142 4.22837C17.1741 4.51565 17.8286 5.02754 18.2905 5.69593C18.7524 6.36432 18.9998 7.15751 18.9998 7.96997C18.9998 8.78243 18.7524 9.57562 18.2905 10.244C17.8286 10.9124 17.1741 11.4243 16.4142 11.7116C15.6542 11.9988 14.8247 12.0479 14.0362 11.8522C13.2477 11.6565 12.5374 11.2253 12 10.616M15 21.97H3V20.97C3 19.3787 3.63214 17.8525 4.75736 16.7273C5.88258 15.6021 7.4087 14.97 9 14.97C10.5913 14.97 12.1174 15.6021 13.2426 16.7273C14.3679 17.8525 15 19.3787 15 20.97V21.97ZM15 21.97H21V20.97C21.0001 19.9167 20.723 18.8819 20.1965 17.9697C19.6699 17.0574 18.9125 16.2999 18.0004 15.7732C17.0882 15.2465 16.0535 14.9692 15.0002 14.9691C13.9469 14.9691 12.9122 15.2463 12 15.773M13 7.96997C13 9.03084 12.5786 10.0483 11.8284 10.7984C11.0783 11.5485 10.0609 11.97 9 11.97C7.93913 11.97 6.92172 11.5485 6.17157 10.7984C5.42143 10.0483 5 9.03084 5 7.96997C5 6.90911 5.42143 5.89169 6.17157 5.14154C6.92172 4.3914 7.93913 3.96997 9 3.96997C10.0609 3.96997 11.0783 4.3914 11.8284 5.14154C12.5786 5.89169 13 6.90911 13 7.96997Z",
      stroke: "#4A90CE",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
const CircleCard = ({
  circle
}) => {
  useState(true);
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex justify-start items-center self-stretch relative",
      children: [/* @__PURE__ */ jsx("svg", {
        width: "104",
        height: "4",
        viewBox: "0 0 104 4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "hidden md:block",
        preserveAspectRatio: "none",
        children: /* @__PURE__ */ jsx("path", {
          d: "M0 2H104",
          stroke: "#FF7354",
          strokeWidth: "3"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex justify-start items-start flex-grow w-full px-3 bg-white shadow-md py-2 relative overflow-hidden",
        children: [/* @__PURE__ */ jsx("div", {
          className: "flex self-center items-start relative gap-2.5 p-2.5",
          children: /* @__PURE__ */ jsxs(Link$2, {
            to: circleUrl(circle),
            children: [/* @__PURE__ */ jsx(Image$1, {
              size: 75,
              image: circle.image,
              className: "sm:hidden"
            }), /* @__PURE__ */ jsx(Image$1, {
              size: 85,
              image: circle.image,
              className: "hidden sm:block"
            })]
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col justify-start items-start flex-grow gap-4",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex flex-col justify-start items-start relative",
            children: [/* @__PURE__ */ jsx(Link$2, {
              to: circleUrl(circle),
              children: /* @__PURE__ */ jsx("p", {
                className: " text-base font-semibold text-black",
                children: circle.name
              })
            }), /* @__PURE__ */ jsx("div", {
              className: "flex flex-col justify-start items-start gap-1",
              children: /* @__PURE__ */ jsx("div", {
                className: "flex justify-start items-center relative gap-2",
                children: (circle.tags || []).map((tag) => /* @__PURE__ */ jsxs("p", {
                  className: "text-xs font-light text-left text-black",
                  children: ["#", tag]
                }, tag))
              })
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex justify-start items-start gap-7",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "flex flex-col justify-start items-center relative gap-1.5",
              children: [/* @__PURE__ */ jsx(LockIcon$1, {
                alt: "Public"
              }), /* @__PURE__ */ jsx("p", {
                className: " text-sm text-left text-black",
                children: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: `group.summary.privacy.${circle && circle.privacy}`
                })
              })]
            }), /* @__PURE__ */ jsxs("div", {
              className: "flex flex-col justify-start items-center relative gap-1.5",
              children: [/* @__PURE__ */ jsx(PostsIcon, {
                alt: "POsts"
              }), /* @__PURE__ */ jsxs("p", {
                className: " text-sm text-left text-black",
                children: [circle.stats.postCount, " Posts"]
              })]
            }), /* @__PURE__ */ jsxs("div", {
              className: "flex flex-col justify-start items-center relative gap-1.5",
              children: [/* @__PURE__ */ jsx(MembersIcon, {
                alt: "Members"
              }), /* @__PURE__ */ jsxs("p", {
                className: " text-sm text-left text-black",
                children: [circle.stats.memberCount, " Members"]
              })]
            })]
          })]
        })]
      })]
    })
  });
};

const CirclesArea = () => {
  const {
    id,
    profile
  } = useCircleContext();
  const {
    data
  } = useSubCircles(id);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex w-full",
    children: [/* @__PURE__ */ jsx("div", {
      className: "hidden md:block w-2 min-h-12 border-2 flex-grow flex-1 border-[#FF7354]"
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col w-full gap-4",
      children: data && data.map((circle) => {
        if (circle.chat) {
          return null;
        }
        if (circle.administrators[0] !== profile._id && circle.privacy === "PERSONAL") {
          return null;
        }
        console.log(circle);
        return /* @__PURE__ */ jsx(CircleCard, {
          circle
        });
      })
    })]
  });
};

const RenderCirclePosts = ({
  children,
  error,
  data
}) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [!data && error && /* @__PURE__ */ jsx(ErrorPanelCircle, {
      error
    }), !data && !error && /* @__PURE__ */ jsx(PleaseWaitDelayed, {}), data && data.length === 0 && /* @__PURE__ */ jsx(EmptyList$1, {}), data && data.map(children)]
  });
};

var index = '';

var App = '';

createLogger("info:ui");
const Content$1 = styled(DialogContent)`
    display: flex;
    flex-direction: column;

`;
const ConfigureCircleDialog = (props) => {
  const {
    open
  } = props;
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsx(ConfigureCircleDialogInner, {
    ...props
  });
};
const ConfigureCircleDialogInner = ({
  open,
  setOpen
}) => {
  const {
    circle
  } = useCircleContext();
  const api = useApi();
  const {
    onClick,
    loading
  } = useLoading(async () => {
    testError();
    await api.makeRequest({
      path: `/groups/${circle._id}/_help-config`,
      method: "POST",
      body: {
        helpPost: helpPost.trim(),
        defaultHelpPost: defaultHelpPost.trim(),
        welcomeNewUsers
      }
    });
    setOpen(false);
  });
  const {
    data: configData,
    error
  } = useRequest(async () => {
    testError();
    const config = await api.makeRequest({
      path: `/groups/${circle._id}/_help-config?edit=1`,
      method: "GET"
    });
    const {
      helpPost: helpPost2,
      welcomeNewUsers: welcomeNewUsers2
    } = config.main;
    setPostId(helpPost2 || "");
    setDefPostId(config.defaults.helpPost || "");
    setWelcomeNewUsers(!!welcomeNewUsers2);
    return true;
  }, {
    ready: !!circle,
    retryCount: -1
  });
  const [helpPost, setPostId] = useState("");
  const [defaultHelpPost, setDefPostId] = useState("");
  const [welcomeNewUsers, setWelcomeNewUsers] = useState(false);
  if (!circle) {
    return null;
  }
  const onPostId = (e) => {
    setPostId(e.target.value);
  };
  const onDefPostId = (e) => {
    setDefPostId(e.target.value);
  };
  return /* @__PURE__ */ jsxs(Dialog$6, {
    onClose: () => setOpen(false),
    "aria-labelledby": "customized-dialog-title",
    open,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose: () => setOpen(false),
      icon: /* @__PURE__ */ jsx(DialogIcon, {
        children: /* @__PURE__ */ jsx(BsGear, {})
      }),
      children: /* @__PURE__ */ jsxs("div", {
        "data-id": "welcome-dialog",
        children: [/* @__PURE__ */ jsx(FormattedMessage, {
          id: `post_dialog.circle.title`
        }), " ", /* @__PURE__ */ jsxs("span", {
          className: "custom_text",
          children: [" `", circle.name, "`"]
        })]
      })
    }), /* @__PURE__ */ jsxs(Content$1, {
      dividers: true,
      children: [/* @__PURE__ */ jsx(ErrorAlert, {
        error
      }), !configData && /* @__PURE__ */ jsx(CircularProgress, {
        color: "secondary"
      }), configData && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(TextField$1, {
          label: "Post Id of help for this circle",
          value: helpPost,
          onChange: onPostId
        }), /* @__PURE__ */ jsx(TextField$1, {
          label: "Post Id of default help",
          value: defaultHelpPost,
          onChange: onDefPostId
        }), /* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Checkbox$1, {
            checked: welcomeNewUsers,
            onChange: (event) => setWelcomeNewUsers(event.target.checked)
          }),
          label: "Show to new users"
        })]
      })]
    }), /* @__PURE__ */ jsx(DialogActions, {
      children: /* @__PURE__ */ jsx(LoadingButton, {
        loading,
        onClick,
        disabled: !configData,
        children: "Save"
      })
    })]
  });
};

const ConfigureCircleButton = ({
  onConfigChange = () => null
}) => {
  const [open, setOpenState] = React__default.useState(false);
  const {
    profile
  } = useCircleContext();
  if (!profile || profile.role !== "ADMIN") {
    return null;
  }
  const setOpen = (v) => {
    setOpenState(v);
    if (!v) {
      onConfigChange();
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      "aria-label": "welcome to circle dialog",
      color: "inherit",
      onClick: () => setOpen(true),
      children: /* @__PURE__ */ jsx(BsGear, {})
    }), /* @__PURE__ */ jsx(ConfigureCircleDialog, {
      open,
      setOpen
    })]
  });
};

createLogger("info:ui");
const WelcomeToCircleDialog = (props) => {
  const {
    open
  } = props;
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsx(WelcomeToCircleDialogInner, {
    ...props
  });
};
const WaitingWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 10px;
`;
const WelcomeMessage = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Typography, {
      gutterBottom: true,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: `post_dialog.circle.line_1`
      })
    }), /* @__PURE__ */ jsx(Typography, {
      gutterBottom: true,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: `post_dialog.circle.line_2`
      })
    })]
  });
};
const WelcomeToCircleDialogInner = ({
  open,
  setOpen
}) => {
  const [fullScreen, setFullScreen] = useState(false);
  const {
    circle
  } = useCircleContext();
  const api = useApi();
  const {
    data: configData,
    error,
    run
  } = useRequest(async () => {
    testError();
    const config = await api.makeRequest({
      path: `/groups/${circle._id}/_help-config`,
      method: "GET"
    });
    return config;
  }, {
    ready: !!circle,
    retryCount: -1
  });
  if (!circle) {
    return null;
  }
  const onConfigChange = () => {
    run();
  };
  const {
    html,
    groupSpecific
  } = configData || {};
  return /* @__PURE__ */ jsxs(Dialog$6, {
    fullScreen,
    onClose: () => setOpen(false),
    "aria-labelledby": "circle-help-dialog-title",
    open,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [!configData && /* @__PURE__ */ jsx(WaitingWrapper, {
      children: /* @__PURE__ */ jsx(CircularProgress, {
        color: "secondary"
      })
    }), configData && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(DialogTitle, {
        onClose: () => setOpen(false),
        icon: /* @__PURE__ */ jsx(DialogIcon, {
          children: /* @__PURE__ */ jsx(AssistantIcon, {})
        }),
        noTitle: groupSpecific,
        children: /* @__PURE__ */ jsxs("div", {
          "data-id": "welcome-dialog",
          children: [/* @__PURE__ */ jsx(FormattedMessage, {
            id: `post_dialog.circle.title`
          }), " ", /* @__PURE__ */ jsxs("span", {
            className: "custom_text",
            children: [" `", circle.name, "`"]
          })]
        })
      }), /* @__PURE__ */ jsxs(DialogContent, {
        dividers: !groupSpecific,
        children: [/* @__PURE__ */ jsx(ErrorAlert, {
          error
        }), !html && /* @__PURE__ */ jsx(WelcomeMessage, {}), !!html && /* @__PURE__ */ jsx(TinyContent, {
          dangerouslySetInnerHTML: {
            __html: html
          },
          className: "mce-content-body"
        })]
      })]
    }), /* @__PURE__ */ jsxs(DialogActions, {
      children: [/* @__PURE__ */ jsx(ConfigureCircleButton, {
        onConfigChange
      }), /* @__PURE__ */ jsx(IconButton$5, {
        onClick: () => setFullScreen(!fullScreen),
        children: fullScreen ? /* @__PURE__ */ jsx(FiMinimize2, {}) : /* @__PURE__ */ jsx(FiMaximize2, {})
      })]
    })]
  });
};

const useWelcomeToCircle = () => {
  const {
    circle
  } = useCircleContext();
  const [open, setOpenState] = React__default.useState(false);
  useEffect(() => {
    if (!circle || !circle.config || !circle.config.welcomeNewUsers) {
      return;
    }
    if (localStorage["welcomeCircleVisited" + circle._id]) {
      return;
    }
    setOpenState(true);
  }, [circle]);
  const setOpen = (open2) => {
    setOpenState(open2);
    if (!circle || !circle.config) {
      return;
    }
    localStorage["welcomeCircleVisited" + circle._id] = true;
  };
  return [() => setOpen(true), !open ? null : /* @__PURE__ */ jsx(WelcomeToCircleDialog, {
    open,
    setOpen
  })];
};
const WelcomeToCircleButton = () => {
  const [onClick, dialog] = useWelcomeToCircle();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      "aria-label": "welcome to circle dialog",
      color: "inherit",
      onClick,
      children: /* @__PURE__ */ jsx(AssistantIcon, {
        blackAndWite: true
      })
    }), dialog]
  });
};

var CairIcon$1 = "data:image/svg+xml;base64,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";

const options = LANGUAGE_OPTIONS.map((v) => ({
  ...v,
  name: v.label
}));
const ITEM_HEIGHT = 48;
const LanguageSelectionMenu = () => {
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const open = Boolean(anchorEl);
  const {
    language,
    setLanguage
  } = useLanguageSelectionContext();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (value) => {
    setAnchorEl(null);
    setLanguage(value);
  };
  const backdropClick = () => {
    setAnchorEl(null);
  };
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx(StyledButton, {
      icon: MdLanguage,
      className: "group relative",
      "aria-label": "languages-menu",
      "aria-controls": "languages-menu",
      "aria-haspopup": "true",
      onClick: handleClick,
      children: /* @__PURE__ */ jsx(Tooltip, {
        children: "Translate"
      })
    }), /* @__PURE__ */ jsx(Menu$1, {
      id: "long-menu",
      anchorEl,
      keepMounted: true,
      open,
      onClose: backdropClick,
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5,
          width: "20ch"
        }
      },
      children: options.map(({
        value,
        name
      }) => {
        return /* @__PURE__ */ jsx(MenuItem, {
          selected: value === language,
          onClick: () => handleClose(value),
          children: name
        }, value || "def");
      })
    })]
  });
};

const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(typeof window === "undefined" ? true : window.innerWidth < breakpoint);
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const handleResize = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoint]);
  return isMobile;
};

const AssistantNavigation = ({
  assistant,
  edit
}) => {
  const {
    circle
  } = useCircleContext();
  const canExecute = useCanExecutePrompt();
  const onEdit = () => {
    window.location.href = editCircleAssistantUrl(assistant);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 sm:justify-start items-center w-full  bg-white shadow-lg relative px-1",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: "hidden lg:block",
      children: /* @__PURE__ */ jsx(HamburgerMenu, {})
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-end items-center relative gap-4  ltr:ml-auto rtl:mr-auto",
      children: [edit && canExecute && /* @__PURE__ */ jsx(StyledButton, {
        icon: MdEdit,
        className: "group relative",
        onClick: onEdit,
        children: /* @__PURE__ */ jsx(Tooltip, {
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.edit"
          })
        })
      }), /* @__PURE__ */ jsx(Link$2, {
        to: "/notifications",
        children: /* @__PURE__ */ jsxs(StyledButton, {
          icon: FaRegBell,
          className: "group relative",
          children: [/* @__PURE__ */ jsx(NotificationsBadge, {}), /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.notifications"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circle) + "/membership",
        children: /* @__PURE__ */ jsxs(StyledButton, {
          icon: FaRegUserCircle,
          className: "group relative",
          children: [/* @__PURE__ */ jsx(CircleUsersBadge, {}), /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.members"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(OpenHelpButton$4, {}), /* @__PURE__ */ jsx(ProfileIcon, {})]
    })]
  });
};
const SearchInput = ({
  noSimpleSearch
}) => {
  const {
    filter,
    setFilter
  } = useSearchContext2();
  const [focused, setFocused] = useState(true);
  const inputRef = useRef();
  const isMobile = useIsMobile();
  const divRef = useRef(null);
  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setFocused(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const intl = useIntl();
  const {
    hasEmbeddingsOrAdvisor,
    isAdvisorEnabled,
    isAIMode,
    setIsAIMode,
    isSearchMode,
    setIsSearchMode,
    prompt,
    setPrompt,
    onSearch,
    searchLoading,
    aiSearch,
    setAISearch
  } = useCircleSearchSSEContext();
  const onAIMode = (aiMode, aiSearch2 = true) => {
    setIsAIMode(aiMode);
    setIsSearchMode(true);
    setAISearch(aiSearch2);
    setFocused(true);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const handleSearchFocus = () => {
    setFocused(true);
    setIsSearchMode(true);
  };
  const handleSearchCancel = () => {
    setIsSearchMode(false);
    setIsAIMode(isAdvisorEnabled);
    setFilter("");
    setPrompt("");
  };
  const toggleAIMode = () => {
    onAIMode(isAdvisorEnabled ? !isAIMode : false);
    setFilter("");
  };
  const simpleSearch = () => {
    onAIMode(false, false);
  };
  const handleChange = useMemoizedFn((e) => {
    const value2 = e.target.value;
    if (aiSearch) {
      setPrompt(value2);
    } else {
      setFilter(value2);
    }
  });
  const handleKeyDown = useMemoizedFn((event) => {
    if (event.key === "Enter") {
      onSearch();
    }
  });
  if (!hasEmbeddingsOrAdvisor && noSimpleSearch) {
    return null;
  }
  const value = aiSearch ? prompt : filter;
  return /* @__PURE__ */ jsx("div", {
    className: `bg-white flex-grow flex justify-center items-center ${isSearchMode && isMobile && focused ? "inset-0 absolute z-50" : ""}`,
    children: /* @__PURE__ */ jsxs("div", {
      ref: divRef,
      className: "flex justify-end items-center px-2 rounded-full border border-black/30 w-full gap-2",
      children: [!noSimpleSearch && /* @__PURE__ */ jsx("div", {
        className: clsx("cursor-pointer", aiSearch && "opacity-50"),
        onClick: simpleSearch,
        children: /* @__PURE__ */ jsx(AiOutlineSearch, {
          size: 24
        })
      }), hasEmbeddingsOrAdvisor && /* @__PURE__ */ jsx("div", {
        className: clsx("cursor-pointer", !aiSearch && "opacity-50"),
        onClick: toggleAIMode,
        children: /* @__PURE__ */ jsx("img", {
          src: CairIcon$1,
          className: "h-6 w-6 min-w-[24px]"
        })
      }), /* @__PURE__ */ jsx("input", {
        ref: inputRef,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onFocus: handleSearchFocus,
        placeholder: (isAIMode ? "AI analyses" : intl.formatMessage({
          id: "group.searchHere"
        })) + "...",
        type: "text",
        value,
        className: "outline-none w-full h-6 text-xl text-black ltr:text-left rtl:text-right "
      }), aiSearch && isSearchMode && /* @__PURE__ */ jsxs(BigStyledButton, {
        bg: "bg-[#00A5B6]",
        className: "mx-1",
        fitContent: true,
        icon: searchLoading && (() => /* @__PURE__ */ jsx(CgSpinner, {
          size: 20,
          className: "animate-spin"
        })),
        onClick: onSearch,
        children: [isAIMode && /* @__PURE__ */ jsx("span", {
          children: "AI\xA0Analyses"
        }), !isAIMode && /* @__PURE__ */ jsx("span", {
          children: "AI\xA0Search"
        })]
      }), isSearchMode && /* @__PURE__ */ jsx("div", {
        className: "cursor-pointer",
        onClick: handleSearchCancel,
        children: /* @__PURE__ */ jsx(AiOutlineClose, {
          size: 24
        })
      })]
    })
  });
};
const CircleNavigation = () => {
  const {
    circle
  } = useCircleContext();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 sm:justify-start items-center w-full bg-white shadow-lg relative px-1",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: "hidden lg:block",
      children: /* @__PURE__ */ jsx(HamburgerMenu, {})
    }), /* @__PURE__ */ jsx(SearchInput, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-end items-center relative gap-4 ltr:ml-auto rtl:mr-auto",
      children: [/* @__PURE__ */ jsx(LanguageSelectionMenu, {}), /* @__PURE__ */ jsx(Link$2, {
        to: "/notifications",
        children: /* @__PURE__ */ jsxs(StyledButton, {
          icon: FaRegBell,
          className: "group relative",
          children: [/* @__PURE__ */ jsx(NotificationsBadge, {}), /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.notifications"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circle) + "/membership",
        children: /* @__PURE__ */ jsxs(StyledButton, {
          icon: FaRegUserCircle,
          className: "group relative",
          children: [/* @__PURE__ */ jsx(CircleUsersBadge, {}), /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.members"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(OpenHelpButton$4, {}), /* @__PURE__ */ jsx(ProfileIcon, {})]
    })]
  });
};
const OpenHelpButton$4 = () => {
  const [onClick, dialog] = useWelcomeToCircle();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(StyledButton, {
      icon: IoMdHelpCircleOutline,
      onClick,
      className: "group relative",
      children: /* @__PURE__ */ jsx(Tooltip, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.tooltips.help"
        })
      })
    }), dialog]
  });
};
const CircleUsersBadge = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle || !circle.stats) {
    return null;
  }
  const count = circle.stats.memberCount > 0 ? circle.stats.memberCount : 0;
  return /* @__PURE__ */ jsx("div", {
    className: "absolute -right-2 -top-0.5 rounded-full bg-primary text-white text-xs",
    children: /* @__PURE__ */ jsx("div", {
      className: "p-0 min-w-[25px]",
      children: count
    })
  });
};

const InviteButton = ({
  className
}) => {
  const buttonProps = useGuestWithJoinOptionV2();
  if (!buttonProps) {
    return null;
  }
  const {
    Icon,
    onClick,
    Text,
    className: dynamicClassName,
    Dialogs = () => null
  } = buttonProps;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Dialogs, {}), /* @__PURE__ */ jsxs("button", {
      className: clsx(className, dynamicClassName),
      style: {
        boxShadow: " 0px 7px 15px 0 rgba(255,255,255,0.25)"
      },
      onClick,
      children: [/* @__PURE__ */ jsx(Icon, {
        className: "w-6 h-6"
      }), /* @__PURE__ */ jsx("p", {
        className: "font-medium",
        children: /* @__PURE__ */ jsx(Text, {})
      })]
    })]
  });
};
const CreateButton = ({
  className
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    className: redButton
  } = useGuestWithJoinOptionV2() || {};
  const buttons = useCreatePostButtonsDescription();
  const {
    circle
  } = useCircleContext();
  if (redButton) {
    return /* @__PURE__ */ jsx(InviteButton, {
      className
    });
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const defaultPostType = circle && circle.defaultPostType;
  const postType = defaultPostType && buttons.find((b) => b.id === defaultPostType);
  const messageId = postType ? postType.title : "group.createPost";
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("button", {
      className,
      style: {
        boxShadow: " 0px 7px 15px 0 rgba(255,255,255,0.25)"
      },
      onClick: handleClick,
      children: [/* @__PURE__ */ jsx("p", {
        className: "font-medium",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: messageId
        })
      }), /* @__PURE__ */ jsx(ArrowDownIcon, {})]
    }), /* @__PURE__ */ jsx(Menu$1, {
      id: "simple-menu",
      anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose,
      children: /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-4 p-4 rounded",
        children: /* @__PURE__ */ jsx(CreateButtons, {})
      })
    })]
  });
};
const CircleHeaderMenu = () => {
  return /* @__PURE__ */ jsx(CircleMenu, {
    button: StyledMenuButton$1
  });
};
const ArrowDownIcon = (props) => {
  return /* @__PURE__ */ jsx("svg", {
    width: "11",
    height: "7",
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ...props,
    children: /* @__PURE__ */ jsx("path", {
      d: "M4.97324 6.50779L0.723242 2.25779C0.429492 1.96404 0.429492 1.48904 0.723242 1.19841L1.42949 0.492163C1.72324 0.198413 2.19824 0.198413 2.48887 0.492163L5.50137 3.50466L8.51387 0.492163C8.80762 0.198413 9.28262 0.198413 9.57324 0.492163L10.2795 1.19841C10.5732 1.49216 10.5732 1.96716 10.2795 2.25779L6.02949 6.50779C5.74199 6.80154 5.26699 6.80154 4.97324 6.50779Z",
      fill: "white"
    })
  });
};
const ContentHero = () => {
  const {
    circle: circleData
  } = useCircleContext();
  const circle = circleData ? circleData : {
    stats: {},
    name: ""
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col w-full relative p-1 text-white bg-[#999999] max-h-[250px] overflow-hidden",
    "data-testid": "ContentHero",
    children: [/* @__PURE__ */ jsx(CircleHeaderImageV2, {}), /* @__PURE__ */ jsx("h1", {
      className: "text-2xl font-bold z-10",
      children: circle.name
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex mb-1 z-10 justify-between align-bottom",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-sm sm:text-base",
        children: /* @__PURE__ */ jsx(CircleAccessV2, {})
      }), /* @__PURE__ */ jsx(CreateButton, {
        className: "flex flex-wrap sm:hidden sm:absolute relative justify-start items-center overflow-hidden gap-[9px] px-[11px] py-[5px] rounded-[5px] bg-primary m-1 w-fit lg:hidden mt-3 mr-0",
        "data-testid": "create-post"
      })]
    }), /* @__PURE__ */ jsx(InviteButton, {
      className: "hidden lg:flex absolute justify-start items-center overflow-hidden ltr:right-2 rtl:left-2 bottom-2 gap-[9px] px-[11px] py-[3px] rounded-[5px] bg-primary m-1 w-fit",
      "data-testid": "invite-button"
    }), /* @__PURE__ */ jsx(CreateButton, {
      className: "hidden sm:flex sm:absolute relative justify-start items-center overflow-hidden ltr:right-2 rtl:left-2 bottom-2 gap-[9px] px-[11px] py-[3px] rounded-[5px] bg-primary m-1 w-fit lg:hidden",
      "data-testid": "create-post"
    }), /* @__PURE__ */ jsx("div", {
      className: "absolute ltr:right-0 top-0 mt-0 mr-0 rtl:left-0 z-20",
      "data-testid": "circle-menu",
      children: /* @__PURE__ */ jsx(CircleHeaderMenu, {})
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-between items-baseline w-full gap-4 sm:w-fit sm:gap-3 text-2xs",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col justify-start items-center  relative",
        children: [/* @__PURE__ */ jsxs("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          className: "w-4 h-4",
          preserveAspectRatio: "none",
          children: [/* @__PURE__ */ jsx("path", {
            d: "M9.305 9.92447C9.08444 9.70377 8.82256 9.52869 8.53431 9.40924C8.24606 9.28979 7.9371 9.22831 7.62508 9.22831C7.31307 9.22831 7.00411 9.28979 6.71586 9.40924C6.42761 9.52869 6.16573 9.70377 5.94517 9.92447L0.530168 15.3395C0.603366 16.3323 1.04864 17.2609 1.77694 17.9396C2.50525 18.6183 3.4629 18.997 4.45842 19.0001H15.5417C16.3174 19 17.0756 18.7706 17.7212 18.3407L9.305 9.92447Z",
            fill: "white"
          }), /* @__PURE__ */ jsx("path", {
            d: "M14.7499 6.33357C15.6243 6.33357 16.3332 5.62469 16.3332 4.75024C16.3332 3.87579 15.6243 3.16691 14.7499 3.16691C13.8754 3.16691 13.1666 3.87579 13.1666 4.75024C13.1666 5.62469 13.8754 6.33357 14.7499 6.33357Z",
            fill: "#488ECE"
          }), /* @__PURE__ */ jsx("path", {
            d: "M15.5417 0H4.45833C3.4089 0.00125705 2.40282 0.418698 1.66076 1.16076C0.918698 1.90282 0.501257 2.9089 0.5 3.95833V13.1306L4.82567 8.80492C5.19325 8.43724 5.62966 8.14558 6.10997 7.94659C6.59029 7.7476 7.1051 7.64518 7.625 7.64518C8.1449 7.64518 8.65971 7.7476 9.14003 7.94659C9.62035 8.14558 10.0568 8.43724 10.4243 8.80492L18.8405 17.2211C19.2704 16.5755 19.4998 15.8173 19.5 15.0417V3.95833C19.4987 2.9089 19.0813 1.90282 18.3392 1.16076C17.5972 0.418698 16.5911 0.00125705 15.5417 0ZM14.75 7.91667C14.1237 7.91667 13.5115 7.73095 12.9907 7.38299C12.4699 7.03503 12.0641 6.54046 11.8244 5.96183C11.5847 5.3832 11.522 4.74649 11.6442 4.13221C11.7664 3.51794 12.068 2.9537 12.5108 2.51083C12.9537 2.06796 13.5179 1.76637 14.1322 1.64418C14.7465 1.52199 15.3832 1.5847 15.9618 1.82438C16.5405 2.06406 17.035 2.46994 17.383 2.99069C17.7309 3.51145 17.9167 4.12369 17.9167 4.75C17.9167 5.58985 17.583 6.39531 16.9892 6.98917C16.3953 7.58304 15.5899 7.91667 14.75 7.91667Z",
            fill: "white"
          })]
        }), /* @__PURE__ */ jsxs("p", {
          children: [circlePostsCounter(circle), " Posts"]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col justify-start items-center relative",
        children: [/* @__PURE__ */ jsx("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          className: "w-4 h-4",
          preserveAspectRatio: "none",
          children: /* @__PURE__ */ jsx("path", {
            d: "M19.8401 14.364C19.9389 14.9326 19.9122 15.5159 19.7618 16.0731C19.6114 16.6302 19.341 17.1478 18.9696 17.5895C18.5981 18.0311 18.1346 18.3862 17.6115 18.6299C17.0883 18.8736 16.5182 18.9999 15.9411 19H13.5661C13.3562 19 13.1548 18.9166 13.0063 18.7682C12.8579 18.6197 12.7745 18.4183 12.7745 18.2084V16.1579C12.019 16.4608 11.2134 16.6193 10.3995 16.625C9.58504 16.6167 8.77943 16.4555 8.02446 16.15V18.2084C8.02446 18.4183 7.94105 18.6197 7.79258 18.7682C7.64412 18.9166 7.44275 19 7.23279 19H4.85779C4.28069 18.9999 3.71059 18.8736 3.18745 18.6299C2.66431 18.3862 2.20078 18.0311 1.82933 17.5895C1.45788 17.1478 1.18749 16.6302 1.03712 16.0731C0.886752 15.5159 0.860031 14.9326 0.95883 14.364L1.19633 12.9865C1.27531 12.5284 1.48972 12.1044 1.81192 11.7693C2.13412 11.4341 2.54933 11.2032 3.00401 11.1062C3.45869 11.0093 3.93199 11.0507 4.36287 11.2253C4.79376 11.3999 5.16247 11.6995 5.42146 12.0856C6.42212 13.5565 8.34825 15.0417 10.3995 15.0417C12.8774 15.0417 15.3189 12.8416 16.044 10.7857C16.1022 10.6311 16.206 10.4979 16.3415 10.4036C16.4771 10.3093 16.6381 10.2584 16.8032 10.2576L17.1452 10.2632C17.2985 10.2651 17.4507 10.2365 17.5928 10.179C17.7349 10.1216 17.8642 10.0365 17.9732 9.92867C18.0821 9.82082 18.1686 9.6924 18.2274 9.55086C18.2863 9.40932 18.3165 9.25749 18.3161 9.10419C18.3158 8.82653 18.2183 8.55774 18.0404 8.34455C17.8625 8.13136 17.6155 7.98725 17.3424 7.93727C17.1739 7.90672 17.0199 7.82239 16.9035 7.69693C16.787 7.57147 16.7143 7.41164 16.6964 7.2414C16.5913 6.24041 16.2481 5.27913 15.6954 4.43799C15.1427 3.59686 14.3965 2.90033 13.5194 2.40669C13.2955 3.10748 12.9964 3.78195 12.6272 4.41831C11.5996 5.87511 10.259 7.08344 8.70371 7.95469C8.94079 8.0129 9.15417 8.14276 9.3148 8.3266C9.47543 8.51044 9.57549 8.73931 9.60137 8.98206C9.62725 9.22481 9.57768 9.46964 9.45942 9.68321C9.34116 9.89677 9.15994 10.0687 8.94046 10.1756C8.72097 10.2825 8.47388 10.3191 8.23282 10.2805C7.99177 10.2419 7.76847 10.13 7.59332 9.9599C7.41818 9.78983 7.2997 9.56992 7.25403 9.3301C7.20836 9.09029 7.23771 8.84222 7.33808 8.61969C5.51789 9.35672 3.5498 9.65504 1.59296 9.49052C1.42985 9.46866 1.27761 9.39652 1.15741 9.28412C1.03721 9.17172 0.955023 9.02466 0.92228 8.86339C0.889538 8.70211 0.907867 8.53464 0.974719 8.38427C1.04157 8.23389 1.15362 8.10809 1.29529 8.02435C1.77388 7.48136 2.13001 6.84172 2.3395 6.1489C3.37262 3.70027 4.93695 2.21724e-05 10.3995 2.21724e-05C12.2633 -0.00439333 14.0687 0.65081 15.4958 1.84964C16.923 3.04848 17.88 4.71361 18.1974 6.55027C18.7012 6.76089 19.1315 7.11566 19.4343 7.57004C19.7371 8.02442 19.899 8.55815 19.8995 9.10419C19.8981 9.76204 19.6579 10.397 19.2234 10.891C19.2289 10.9116 19.2432 10.9282 19.2471 10.9504L19.8401 14.364ZM13.5661 9.10419C13.5661 8.86932 13.4965 8.63973 13.366 8.44445C13.2355 8.24917 13.05 8.09696 12.8331 8.00708C12.6161 7.9172 12.3773 7.89369 12.147 7.93951C11.9166 7.98533 11.705 8.09842 11.5389 8.2645C11.3729 8.43057 11.2598 8.64217 11.2139 8.87252C11.1681 9.10287 11.1916 9.34164 11.2815 9.55863C11.3714 9.77561 11.5236 9.96108 11.7189 10.0916C11.9142 10.222 12.1438 10.2917 12.3786 10.2917C12.6936 10.2917 12.9956 10.1666 13.2183 9.94388C13.441 9.72118 13.5661 9.41913 13.5661 9.10419Z",
            fill: "white"
          })
        }), /* @__PURE__ */ jsxs("p", {
          children: [circle.stats.memberCount || "0", " Members"]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col justify-start items-center relative",
        children: [/* @__PURE__ */ jsx("svg", {
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          className: "w-4 h-4",
          preserveAspectRatio: "none",
          children: /* @__PURE__ */ jsx("path", {
            d: "M18.8498 10.2857H16.9498V12.5714H17.6148C17.7721 12.5714 17.8998 12.7 17.8998 12.8571V13.4286C17.8998 13.5857 17.7721 13.7143 17.6148 13.7143H2.9848C2.82746 13.7143 2.6998 13.5857 2.6998 13.4286V12.8571C2.6998 12.7 2.82746 12.5714 2.9848 12.5714H3.6498V10.2857H1.7498C1.22434 10.2857 0.799805 10.7964 0.799805 11.4286V14.8571C0.799805 15.4893 1.22434 16 1.7498 16H18.8498C19.3753 16 19.7998 15.4893 19.7998 14.8571V11.4286C19.7998 10.7964 19.3753 10.2857 18.8498 10.2857ZM15.9998 12.5714V1.15357C15.9998 0.514286 15.5693 0 15.0409 0H5.56168C5.03027 0 4.5998 0.517857 4.5998 1.15357V12.5714H15.9998ZM7.0698 6.07143L7.82684 5.16786C7.95152 5.01786 8.1534 5.01786 8.27809 5.17143L9.50418 6.65714L12.3304 3.28571C12.4551 3.13571 12.657 3.13571 12.7817 3.28929L13.5328 4.2C13.6575 4.35 13.6575 4.59286 13.5298 4.74286L9.7209 9.28572C9.59621 9.43572 9.39434 9.43571 9.26965 9.28214L7.0698 6.61429C6.94215 6.46429 6.94512 6.22143 7.0698 6.07143Z",
            fill: "white"
          })
        }), /* @__PURE__ */ jsxs("p", {
          children: [circle.stats.votesCount || "0", " Votes"]
        })]
      })]
    })]
  });
};

const ConfirmationOverlay = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmIntent = "danger",
  isLoading = false,
  error = null
}) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  if (!isOpen || !mounted) {
    return null;
  }
  return createPortal(/* @__PURE__ */ jsxs("div", {
    className: "fixed inset-0 z-[9999] flex items-center justify-center ns",
    children: [/* @__PURE__ */ jsx("div", {
      className: "absolute inset-0 bg-black/20 backdrop-blur-sm",
      onClick: isLoading ? void 0 : onCancel
    }), /* @__PURE__ */ jsxs("div", {
      className: "relative bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4",
      children: [title && /* @__PURE__ */ jsx("h3", {
        className: "text-lg font-semibold text-gray-900 mb-2",
        children: title
      }), /* @__PURE__ */ jsx("div", {
        className: "text-gray-600 text-sm mb-6",
        children: message
      }), error && /* @__PURE__ */ jsx("div", {
        className: "mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm",
        children: error
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex justify-end gap-2",
        children: [/* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          size: "sm",
          onClick: onCancel,
          disabled: isLoading,
          children: cancelText
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: confirmIntent,
          size: "sm",
          onClick: onConfirm,
          disabled: isLoading,
          className: "min-w-[80px]",
          children: isLoading ? /* @__PURE__ */ jsx(Spinner, {
            size: "xs",
            colorScheme: "white"
          }) : error ? "Retry" : confirmText
        })]
      })]
    })]
  }), document.body);
};

const trackVariants = cva("relative inline-flex shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-blue-500", {
  variants: {
    size: {
      sm: "w-8 h-4",
      md: "w-10 h-5",
      lg: "w-12 h-6"
    },
    checked: {
      true: "bg-blue-600",
      false: "bg-gray-300"
    },
    disabled: {
      true: "opacity-50 pointer-events-none",
      false: ""
    }
  },
  defaultVariants: {
    size: "md",
    checked: false,
    disabled: false
  }
});
const Switch = ({
  checked,
  onChange,
  size,
  disabled,
  label,
  helperText
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col gap-1",
  children: [/* @__PURE__ */ jsxs("label", {
    className: "flex items-center gap-2 cursor-pointer",
    children: [/* @__PURE__ */ jsx("button", {
      type: "button",
      role: "switch",
      "aria-checked": checked,
      disabled: disabled || false,
      onClick: () => onChange(!checked),
      className: trackVariants({
        size,
        checked,
        disabled
      }),
      children: /* @__PURE__ */ jsx("span", {
        className: `inline-block w-3.5 h-3.5 rounded-full bg-white transition-transform ${checked ? "translate-x-5" : "translate-x-1"}`
      })
    }), label && /* @__PURE__ */ jsx("span", {
      className: "text-sm font-medium text-gray-700",
      children: label
    })]
  }), helperText && /* @__PURE__ */ jsx("span", {
    className: "text-xs text-gray-500 ml-12",
    children: helperText
  })]
});

const useSelectInteractions = ({
  isOpen,
  setIsOpen,
  triggerRef,
  floatingRef,
  disabled = false,
  onClose
}) => {
  useEffect(() => {
    if (!isOpen)
      return;
    const handleClickOutside = (event) => {
      const target = event.target;
      if (triggerRef.current && floatingRef.current && !triggerRef.current.contains(target) && !floatingRef.current.contains(target)) {
        setIsOpen(false);
        if (onClose)
          onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, setIsOpen, triggerRef, floatingRef, onClose]);
  useEffect(() => {
    if (!isOpen)
      return;
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
        if (onClose)
          onClose();
        if (triggerRef.current) {
          triggerRef.current.focus();
        }
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, setIsOpen, triggerRef, onClose]);
  const handleTriggerClick = useCallback(() => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  }, [disabled, isOpen, setIsOpen]);
  const handleTriggerKeyDown = useCallback((event) => {
    if (disabled)
      return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setIsOpen(!isOpen);
    } else if (event.key === "ArrowDown" && !isOpen) {
      event.preventDefault();
      setIsOpen(true);
    }
  }, [disabled, isOpen, setIsOpen]);
  return {
    handleTriggerClick,
    handleTriggerKeyDown
  };
};

const useListNavigation = ({
  items,
  isOpen,
  onSelect,
  isItemDisabled = () => false,
  loop = true
}) => {
  const [activeIndex, setActiveIndex] = useState(null);
  useEffect(() => {
    if (!isOpen) {
      setActiveIndex(null);
    }
  }, [isOpen]);
  const findNextIndex = useCallback((currentIndex, direction) => {
    const itemCount = items.length;
    let nextIndex = currentIndex;
    for (let i = 0; i < itemCount; i++) {
      nextIndex = nextIndex + direction;
      if (loop) {
        nextIndex = (nextIndex + itemCount) % itemCount;
      } else {
        if (nextIndex < 0 || nextIndex >= itemCount) {
          return currentIndex;
        }
      }
      if (!isItemDisabled(items[nextIndex])) {
        return nextIndex;
      }
    }
    return currentIndex;
  }, [items, isItemDisabled, loop]);
  const handleKeyDown = useCallback((event) => {
    if (!isOpen)
      return;
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        setActiveIndex((current) => {
          const startIndex = current !== null ? current : -1;
          return findNextIndex(startIndex, 1);
        });
        break;
      case "ArrowUp":
        event.preventDefault();
        setActiveIndex((current) => {
          const startIndex = current !== null ? current : items.length;
          return findNextIndex(startIndex, -1);
        });
        break;
      case "Home":
        event.preventDefault();
        for (let i = 0; i < items.length; i++) {
          if (!isItemDisabled(items[i])) {
            setActiveIndex(i);
            break;
          }
        }
        break;
      case "End":
        event.preventDefault();
        for (let i = items.length - 1; i >= 0; i--) {
          if (!isItemDisabled(items[i])) {
            setActiveIndex(i);
            break;
          }
        }
        break;
      case "Enter":
      case " ":
        event.preventDefault();
        if (activeIndex !== null && onSelect) {
          const item = items[activeIndex];
          if (!isItemDisabled(item)) {
            onSelect(item, activeIndex);
          }
        }
        break;
    }
  }, [isOpen, items, activeIndex, onSelect, isItemDisabled, findNextIndex]);
  const handleItemMouseEnter = useCallback((index) => {
    if (!isItemDisabled(items[index])) {
      setActiveIndex(index);
    }
  }, [items, isItemDisabled]);
  return {
    activeIndex,
    setActiveIndex,
    handleKeyDown,
    handleItemMouseEnter
  };
};

const selectTriggerVariants = cva("w-full px-3 py-2 border rounded-md text-sm transition-colors focus:outline-none focus:ring-2 focus:border-transparent flex items-center justify-between cursor-pointer", {
  variants: {
    variant: {
      default: "border-gray-300 focus:ring-blue-500 bg-white hover:bg-gray-50",
      error: "border-red-300 focus:ring-red-500 bg-red-50",
      success: "border-green-300 focus:ring-green-500 bg-green-50"
    },
    size: {
      sm: "px-2 py-1 text-xs",
      md: "px-3 py-2 text-sm",
      lg: "px-4 py-3 text-base"
    },
    disabled: {
      true: "opacity-50 cursor-not-allowed hover:bg-white",
      false: ""
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md",
    disabled: false
  }
});
const selectMenuVariants = cva("bg-white rounded-md shadow-lg border border-gray-200 py-1 z-50 overflow-auto", {
  variants: {
    size: {
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
const selectItemVariants = cva("px-3 py-2 cursor-pointer transition-colors flex items-center justify-between", {
  variants: {
    size: {
      sm: "px-2 py-1 text-xs",
      md: "px-3 py-2 text-sm",
      lg: "px-4 py-3 text-base"
    },
    selected: {
      true: "bg-blue-50 text-blue-700",
      false: "hover:bg-gray-100"
    },
    focused: {
      true: "bg-gray-100",
      false: ""
    },
    disabled: {
      true: "opacity-50 cursor-not-allowed hover:bg-transparent",
      false: ""
    }
  },
  defaultVariants: {
    size: "md",
    selected: false,
    focused: false,
    disabled: false
  }
});
const Select = forwardRef(({
  value,
  onChange,
  options,
  placeholder = "Select an option",
  label,
  helperText,
  error,
  disabled = false,
  variant,
  size: size$1,
  className,
  name,
  ...props
}, ref) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectVariant = error ? "error" : variant;
  const selectedOption = options.find((opt) => opt.value === value);
  const {
    x,
    y,
    strategy,
    refs,
    middlewareData
  } = useFloating({
    placement: "bottom-start",
    middleware: [offset(4), flip({
      padding: 8
    }), shift({
      padding: 8
    }), size({
      apply({
        rects,
        elements,
        availableHeight
      }) {
        Object.assign(elements.floating.style, {
          maxHeight: `${Math.min(240, availableHeight)}px`,
          minWidth: `${rects.reference.width}px`
        });
      },
      padding: 8
    })],
    whileElementsMounted: isOpen ? autoUpdate : void 0
  });
  const {
    handleTriggerClick,
    handleTriggerKeyDown
  } = useSelectInteractions({
    isOpen,
    setIsOpen,
    triggerRef: refs.reference,
    floatingRef: refs.floating,
    disabled,
    onClose: () => {
      const triggerEl = refs.reference.current;
      if (triggerEl) {
        triggerEl.focus();
      }
    }
  });
  const {
    activeIndex,
    handleKeyDown: handleListKeyDown,
    handleItemMouseEnter
  } = useListNavigation({
    items: options,
    isOpen,
    onSelect: (option) => {
      if (onChange) {
        onChange(option.value);
      }
      setIsOpen(false);
      const triggerEl = refs.reference.current;
      if (triggerEl) {
        triggerEl.focus();
      }
    },
    isItemDisabled: (option) => option.disabled || false
  });
  const handleSelect = (option) => {
    if (option.disabled)
      return;
    if (onChange) {
      onChange(option.value);
    }
    setIsOpen(false);
    const triggerEl = refs.reference.current;
    if (triggerEl) {
      triggerEl.focus();
    }
  };
  const handleKeyDown = (event) => {
    handleTriggerKeyDown(event);
    handleListKeyDown(event);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-1",
    ref,
    children: [label && /* @__PURE__ */ jsx("label", {
      className: "text-sm font-medium text-gray-700",
      children: label
    }), /* @__PURE__ */ jsxs("div", {
      ref: refs.setReference,
      className: selectTriggerVariants({
        variant: selectVariant,
        size: size$1,
        disabled,
        className
      }),
      onClick: handleTriggerClick,
      onKeyDown: handleKeyDown,
      tabIndex: disabled ? -1 : 0,
      role: "button",
      "aria-expanded": isOpen,
      "aria-haspopup": "listbox",
      "aria-disabled": disabled,
      "aria-label": label || "Select",
      children: [/* @__PURE__ */ jsx("span", {
        className: selectedOption ? "" : "text-gray-400",
        children: selectedOption ? selectedOption.label : placeholder
      }), /* @__PURE__ */ jsx(MdExpandMore, {
        className: `h-4 w-4 text-gray-400 transition-transform ${isOpen ? "rotate-180" : ""}`
      })]
    }), (helperText || error) && /* @__PURE__ */ jsx("span", {
      className: `text-xs ${error ? "text-red-500" : "text-gray-500"}`,
      children: error || helperText
    }), isOpen && /* @__PURE__ */ jsx(FloatingPortal, {
      children: /* @__PURE__ */ jsx("div", {
        ref: refs.setFloating,
        style: {
          position: strategy,
          top: y || 0,
          left: x || 0,
          width: "max-content",
          pointerEvents: "auto",
          zIndex: 9999
        },
        className: selectMenuVariants({
          size: size$1
        }),
        children: /* @__PURE__ */ jsx("div", {
          role: "listbox",
          "aria-label": label || "Select options",
          children: options.map((option, index) => /* @__PURE__ */ jsxs("div", {
            role: "option",
            "aria-selected": option.value === value,
            "aria-disabled": option.disabled,
            className: selectItemVariants({
              size: size$1,
              selected: option.value === value,
              focused: activeIndex === index,
              disabled: option.disabled
            }),
            onClick: () => handleSelect(option),
            onMouseEnter: () => handleItemMouseEnter(index),
            children: [/* @__PURE__ */ jsx("span", {
              children: option.label
            }), option.value === value && /* @__PURE__ */ jsx(MdCheck, {
              className: "h-4 w-4 text-blue-600"
            })]
          }, option.value))
        })
      })
    })]
  });
});
Select.displayName = "Select";

const useMyCircles = ({ idle } = {}) => {
  const api = useApi();
  return useSWR(idle ? null : ["my-circles"], async () => {
    const result = await api.makeRequest({
      method: "GET",
      path: "/groups/my"
    });
    return result.values.filter((v) => v.group).map((v) => ({
      _id: v.group._id,
      name: v.group.name,
      privacy: v.group.privacy
    }));
  }, { ...swrLoadOnce });
};

const CircleSelect = ({
  value,
  onChange,
  label = "Save to",
  placeholder = "Select circle",
  disabled = false,
  className,
  idle
}) => {
  const {
    data,
    isValidating: isLoading
  } = useMyCircles({
    idle
  });
  const options = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.slice().sort((a, b) => a.name.localeCompare(b.name)).map((circle) => ({
      value: circle._id,
      label: `${circle.name} (${circle.privacy})`
    }));
  }, [data]);
  const handleChange = (id) => {
    const circle = data && data.find((c) => c._id === id);
    onChange(id, circle || void 0);
  };
  return /* @__PURE__ */ jsx(Select, {
    value: value || "",
    onChange: handleChange,
    options,
    label,
    placeholder,
    disabled: disabled || isLoading,
    className
  });
};

const MAX_MESSAGES$7 = 30;
const useSSEOperation = () => {
  const api = useApi();
  const jwt = useJwt();
  const isMountedRef = useRef(true);
  const isCompleteRef = useRef(false);
  const [complete, setComplete] = useState();
  const [progress, setProgress] = useState();
  const [current, setCurrent] = useState();
  const [params, setParams] = useState({});
  const [counter, setCounter] = useState(0);
  const { requestId: providedRequestId, url: baseUrl, trace = false } = params;
  const [messages, setMessages] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const requestId = useMemo(() => {
    return providedRequestId || ulid();
  }, [providedRequestId, counter]);
  const url = useMemo(() => {
    if (!counter || !jwt) {
      return null;
    }
    const queryParams = {
      token: jwt,
      trace,
      requestId,
      ...params.body
    };
    return api.buildUrl(baseUrl, queryParams);
  }, [counter, api, jwt, requestId, params]);
  const addMessage = useMemoizedFn((event, data) => {
    if (!isMountedRef.current)
      return;
    const newMessage = {
      id: Date.now().toString() + Math.random(),
      event,
      timestamp: new Date(),
      data
    };
    setMessages((prev) => {
      const updated = [newMessage, ...prev];
      return updated.slice(0, MAX_MESSAGES$7);
    });
  });
  const { logs, reset: resetLogs, handler: logHandler } = useSSELogs({
    onLog: (logEvent) => addMessage("log", logEvent)
  });
  const {
    isConnected,
    error: sseError,
    disconnect,
    reconnect
  } = useSSEConnection({
    url: url || "",
    enabled: counter > 0 && !!url,
    dependencies: [counter],
    onOpen: () => {
      if (!isMountedRef.current)
        return;
      isCompleteRef.current = false;
      setIsComplete(false);
      setConnectionError(null);
      setMessages([]);
      resetLogs();
      setComplete(void 0);
      setProgress(void 0);
      setCurrent(void 0);
    },
    onError: (err) => {
      if (!isMountedRef.current)
        return;
      console.error("SSE connection error:", err);
    },
    onClose: () => {
    }
  }, [
    {
      event: "started",
      handler: (data) => {
        addMessage("started", data);
        setCurrent(data);
      }
    },
    {
      event: "progress",
      handler: (data) => {
        addMessage("progress", data);
        setProgress(data);
        setCurrent(void 0);
      }
    },
    {
      event: "retry",
      handler: (data) => {
        addMessage("retry", data);
      }
    },
    {
      event: "complete",
      handler: (data) => {
        addMessage("complete", data);
        if (!isMountedRef.current)
          return;
        setIsComplete(true);
        isCompleteRef.current = true;
        setTimeout(() => {
          if (isMountedRef.current) {
            disconnect();
          }
        }, 100);
        setComplete(data);
      }
    },
    {
      event: "failed",
      handler: (data) => {
        const errorData = data || {};
        const errorMessage = errorData.message || errorData.error || String(data) || "Unknown error";
        addMessage("failed", { message: errorMessage, ...errorData });
        if (!isMountedRef.current)
          return;
        setConnectionError(new Error(errorMessage));
        setTimeout(() => {
          if (isMountedRef.current) {
            disconnect();
          }
        }, 100);
      }
    },
    logHandler
  ]);
  useEffect(() => {
    if (!isMountedRef.current)
      return;
    if (isCompleteRef.current)
      return;
    if (sseError) {
      setConnectionError(sseError);
    }
  }, [sseError]);
  const mutate = useMemoizedFn(() => {
    reconnect();
  });
  const start = useMemoizedFn((startParams) => {
    setParams(startParams);
    setCounter((c) => c + 1);
    setConnectionError(null);
  });
  const clear = useMemoizedFn(() => {
    setConnectionError(null);
    setMessages([]);
    resetLogs();
    setComplete(void 0);
    setProgress(void 0);
    setCurrent(void 0);
  });
  return {
    complete,
    progress,
    current,
    messages,
    logs,
    isConnected,
    isComplete,
    error: connectionError,
    setError: setConnectionError,
    isValidating: isConnected,
    requestId,
    start,
    clear,
    disconnect,
    mutate
  };
};

const useTaskOperation = (params) => {
  const api = useApi();
  const sseOperation = useSSEOperation();
  const [taskExecutionId, setTaskExecutionId] = useState(null);
  const [isCreatingTask, setIsCreatingTask] = useState(false);
  const startTask = useMemoizedFn(async (request) => {
    setIsCreatingTask(true);
    try {
      const response = await withRetry(() => api.post({
        path: "/tasks/create",
        body: request
      }));
      const { executionId } = response;
      setTaskExecutionId(executionId);
      sseOperation.start({
        url: params.executeEndpoint,
        trace: true,
        body: {
          executionId
        }
      });
    } catch (error) {
      sseOperation.setError(error);
    } finally {
      setIsCreatingTask(false);
    }
  });
  return {
    ...sseOperation,
    taskExecutionId,
    isCreatingTask,
    startTask
  };
};

const extractProgressFromLog = (logData) => {
  const { message, data } = logData;
  if (message === "Translating page" && data) {
    const { pageIndex, totalPages, postTitle } = data;
    return {
      current: pageIndex,
      total: totalPages,
      operation: "Translating page",
      parent: {
        context: postTitle
      },
      details: data
    };
  }
  if (message === "Processing post pages" && data) {
    const { title, totalPages } = data;
    return {
      total: totalPages,
      operation: `Processing "${title}"`,
      details: data
    };
  }
  if (data && data.current !== void 0 && data.total !== void 0) {
    return {
      current: data.current,
      total: data.total,
      operation: message,
      details: data
    };
  }
  return null;
};
const formatProgress = (progress) => {
  const parts = [];
  if (progress.parent && progress.parent.current !== void 0 && progress.parent.total !== void 0) {
    const label = progress.parent.label || "item";
    parts.push(`${label.charAt(0).toUpperCase() + label.slice(1)} ${progress.parent.current}/${progress.parent.total}`);
  }
  if (progress.parent && progress.parent.context) {
    parts.push(progress.parent.context);
  }
  if (progress.current !== void 0 && progress.total !== void 0) {
    parts.push(`${progress.current}/${progress.total}`);
  } else if (progress.percentage !== void 0) {
    parts.push(`${progress.percentage}%`);
  }
  if (progress.operation) {
    parts.push(progress.operation);
  } else if (progress.message) {
    parts.push(progress.message);
  }
  return parts.filter(Boolean).join(" - ");
};
const calculateProgressPercentage = (progress) => {
  if (progress.percentage !== void 0) {
    return progress.percentage;
  }
  if (progress.parent && progress.parent.current !== void 0 && progress.parent.total !== void 0 && progress.parent.total > 0 && progress.current !== void 0 && progress.total !== void 0 && progress.total > 0) {
    const completedPosts = progress.parent.current - 1;
    const currentPostProgress = progress.current / progress.total;
    const totalProgress = (completedPosts + currentPostProgress) / progress.parent.total;
    return Math.round(totalProgress * 100);
  }
  if (progress.current !== void 0 && progress.total !== void 0 && progress.total > 0) {
    return Math.round(progress.current / progress.total * 100);
  }
  if (progress.parent && progress.parent.current !== void 0 && progress.parent.total !== void 0 && progress.parent.total > 0) {
    return Math.round(progress.parent.current / progress.parent.total * 100);
  }
  return 0;
};
const getLatestProgress = (messages) => {
  const progressMsg = messages.find((m) => m.event === "progress");
  if (progressMsg) {
    return progressMsg.data;
  }
  for (const message of messages) {
    if (message.event === "log") {
      const progress = extractProgressFromLog(message.data);
      if (progress) {
        return progress;
      }
    }
  }
  return null;
};
const getLatestCompletion = (messages) => {
  const completeMsg = messages.find((m) => m.event === "complete");
  return completeMsg ? completeMsg.data : null;
};

const SSEProgressPanel = ({
  messages,
  isConnected,
  isComplete,
  error,
  variant = "default"
}) => {
  const latestProgress = getLatestProgress(messages);
  const completion = isComplete ? getLatestCompletion(messages) : null;
  if (!isConnected && !isComplete && !error && !latestProgress) {
    return null;
  }
  const getStatusInfo = () => {
    if (error) {
      return {
        label: "Error",
        color: "red",
        bgColor: "bg-red-50",
        textColor: "text-red-700",
        borderColor: "border-red-200"
      };
    }
    if (isComplete) {
      return {
        label: "Completed",
        color: "green",
        bgColor: "bg-green-50",
        textColor: "text-green-700",
        borderColor: "border-green-200"
      };
    }
    if (isConnected) {
      return {
        label: "Running",
        color: "blue",
        bgColor: "bg-blue-50",
        textColor: "text-blue-700",
        borderColor: "border-blue-200"
      };
    }
    return {
      label: "Idle",
      color: "gray",
      bgColor: "bg-gray-50",
      textColor: "text-gray-700",
      borderColor: "border-gray-200"
    };
  };
  const statusInfo = getStatusInfo();
  const percentage = latestProgress ? calculateProgressPercentage(latestProgress) : 0;
  const renderProgressInfo = (progress) => {
    const parts = [];
    if (progress.parent && progress.parent.current !== void 0 && progress.parent.total !== void 0) {
      const label = progress.parent.label || "item";
      parts.push(/* @__PURE__ */ jsxs("span", {
        className: "font-medium",
        children: [label.charAt(0).toUpperCase() + label.slice(1), " ", progress.parent.current, "/", progress.parent.total]
      }, "parent"));
    }
    if (progress.parent && progress.parent.context) {
      parts.push(/* @__PURE__ */ jsxs("span", {
        className: "text-gray-600",
        children: ['"', progress.parent.context, '"']
      }, "context"));
    }
    if (progress.current !== void 0 && progress.total !== void 0) {
      parts.push(/* @__PURE__ */ jsxs("span", {
        children: [progress.current, "/", progress.total, " ", progress.operation || ""]
      }, "child"));
    } else if (progress.operation) {
      parts.push(/* @__PURE__ */ jsx("span", {
        children: progress.operation
      }, "operation"));
    }
    return /* @__PURE__ */ jsx("div", {
      className: "flex items-center gap-2 flex-wrap",
      children: parts.map((part, idx) => /* @__PURE__ */ jsxs(React__default.Fragment, {
        children: [idx > 0 && /* @__PURE__ */ jsx("span", {
          className: "text-gray-400",
          children: "\u2022"
        }), part]
      }, idx))
    });
  };
  const renderCompletionInfo = () => {
    if (!completion)
      return null;
    const parts = [];
    if (completion.processed !== void 0)
      parts.push(`Processed: ${completion.processed}`);
    if (completion.created !== void 0)
      parts.push(`Created: ${completion.created}`);
    if (completion.failed !== void 0 && completion.failed > 0)
      parts.push(`Failed: ${completion.failed}`);
    if (completion.processingTimeMs) {
      const seconds = (completion.processingTimeMs / 1e3).toFixed(1);
      parts.push(`${seconds}s`);
    }
    return parts.length > 0 ? parts.join(" \u2022 ") : null;
  };
  if (variant === "minimal") {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-3 px-3 py-2 bg-gray-50 rounded-md",
      children: [/* @__PURE__ */ jsx("div", {
        className: `w-2 h-2 rounded-full ${statusInfo.color === "blue" ? "bg-blue-500 animate-pulse" : statusInfo.color === "green" ? "bg-green-500" : statusInfo.color === "red" ? "bg-red-500" : "bg-gray-400"}`
      }), /* @__PURE__ */ jsx("span", {
        className: "text-sm text-gray-700",
        children: isComplete && completion ? renderCompletionInfo() : latestProgress ? renderProgressInfo(latestProgress) : statusInfo.label
      }), !isComplete && percentage > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-xs text-gray-500 font-mono ml-auto",
        children: [percentage, "%"]
      })]
    });
  }
  if (variant === "compact") {
    return /* @__PURE__ */ jsxs("div", {
      className: `flex items-center gap-3 px-3 py-2 rounded-md border ${statusInfo.bgColor} ${statusInfo.borderColor}`,
      children: [/* @__PURE__ */ jsx("span", {
        className: `text-xs font-medium uppercase ${statusInfo.textColor}`,
        children: statusInfo.label
      }), isComplete && completion ? /* @__PURE__ */ jsx("span", {
        className: "text-sm text-gray-700",
        children: renderCompletionInfo()
      }) : latestProgress ? /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-gray-300",
          children: "\u2022"
        }), /* @__PURE__ */ jsx("div", {
          className: "text-sm text-gray-700",
          children: renderProgressInfo(latestProgress)
        })]
      }) : null, !isComplete && percentage > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-xs text-gray-600 font-mono ml-auto",
        children: [percentage, "%"]
      })]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: `flex flex-col gap-3 p-4 rounded-lg border ${statusInfo.bgColor} ${statusInfo.borderColor}`,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-3",
        children: [/* @__PURE__ */ jsx("span", {
          className: `px-2 py-1 rounded text-xs font-medium uppercase ${statusInfo.bgColor} ${statusInfo.textColor} border ${statusInfo.borderColor}`,
          children: statusInfo.label
        }), isComplete && completion ? /* @__PURE__ */ jsx("span", {
          className: "text-sm text-gray-700",
          children: renderCompletionInfo()
        }) : latestProgress ? /* @__PURE__ */ jsx("div", {
          className: "text-sm",
          children: renderProgressInfo(latestProgress)
        }) : null]
      }), !isComplete && percentage > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-sm text-gray-600 font-mono",
        children: [percentage, "%"]
      })]
    }), !isComplete && percentage > 0 && /* @__PURE__ */ jsx("div", {
      className: "w-full h-2 bg-gray-200 rounded-full overflow-hidden",
      children: /* @__PURE__ */ jsx("div", {
        className: `h-full transition-all duration-300 ${statusInfo.color === "blue" ? "bg-blue-500" : statusInfo.color === "green" ? "bg-green-500" : statusInfo.color === "red" ? "bg-red-500" : "bg-gray-400"}`,
        style: {
          width: `${percentage}%`
        }
      })
    })]
  });
};

const DuplicatePostDialog = () => {
  const {
    duplicated
  } = useCircleModalDialogsContext();
  const {
    circle
  } = useCircleContext();
  if (!circle || !duplicated) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(DuplicatePostDialogInner, {})]
  });
};
const DuplicatePostDialogInner = () => {
  const {
    duplicated,
    setDuplicated
  } = useCircleModalDialogsContext();
  const {
    circle,
    refresh
  } = useCircleContext();
  const [title, setTitle] = useState("Copy of " + duplicated.title);
  const [groupId, setGroupId] = useState(circle._id);
  const [unpublishSourceAfter, setUnpublishSourceAfter] = useState(false);
  const taskOperation = useTaskOperation({
    executeEndpoint: "/posts/actions/duplicate"
  });
  const isRunning = taskOperation.isCreatingTask || taskOperation.isValidating;
  const isDone = taskOperation.isComplete;
  useEffect(() => {
    if (!isDone)
      return;
    refresh();
    setDuplicated(null);
  }, [isDone]);
  const handleConfirm = () => {
    taskOperation.startTask({
      input: {
        postId: [duplicated._id],
        targetCircleId: groupId,
        titles: [title],
        ...unpublishSourceAfter ? {
          unpublishSourceAfter: true
        } : {}
      }
    });
  };
  const handleChange = (e) => {
    setTitle(e.target.value);
  };
  const message = /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-3",
    children: [/* @__PURE__ */ jsx(TextInput, {
      value: title,
      label: "Post title",
      onChange: handleChange,
      dir: "auto"
    }), /* @__PURE__ */ jsx(CircleSelect, {
      value: groupId,
      onChange: (id) => setGroupId(id),
      label: "Destination circle"
    }), /* @__PURE__ */ jsx(Switch, {
      checked: unpublishSourceAfter,
      onChange: setUnpublishSourceAfter,
      label: "Remove original after duplicating",
      helperText: "Moves the post instead of copying it \u2014 the original is unpublished and redirects here."
    }), /* @__PURE__ */ jsx(SSEProgressPanel, {
      messages: taskOperation.messages,
      isConnected: taskOperation.isValidating,
      isComplete: isDone,
      variant: "compact"
    })]
  });
  return /* @__PURE__ */ jsx(ConfirmationOverlay, {
    isOpen: !!duplicated,
    title: "Duplicate post",
    message,
    confirmText: "Duplicate",
    confirmIntent: "primary",
    isLoading: isRunning,
    error: taskOperation.error && taskOperation.error.message,
    onConfirm: handleConfirm,
    onCancel: () => setDuplicated(null)
  });
};

const SectionHeader = styled.h2`
    padding: 10px;
    font-weight: bold;
    font-size: 24px;
    text-decoration: underline;
`;
const SectionHeader2 = styled.h3`
    padding: 5px;
    margin: 5px;
    font-weight: bold;
    font-size: 16px;
    text-decoration: underline;
`;
const Section = styled.div`
    padding: 10px;
    border-bottom: 2px solid #592727;
`;
const PlaygroundActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    & .MuiButtonBase-root {
        margin: 10px;
        text-transform: none;
    }

    && .MuiButton-root {
        text-transform: none;
    }
`;
const PlaygroundTextField = styled(TextField$1)`
    width: 100%;
    && {
        margin: 5px;
    }
`;
const ResultWrapper = styled.div`
    padding: 10px;
`;
const Result = ({
  children: result,
  label = "Last Request: "
}) => {
  return /* @__PURE__ */ jsxs(ResultWrapper, {
    children: [label, /* @__PURE__ */ jsx("div", {
      dangerouslySetInnerHTML: {
        __html: result ? JSON.stringify(result, null, 4) : "-"
      }
    })]
  });
};
const LevelUp = () => {
  return /* @__PURE__ */ jsx("div", {
    children: /* @__PURE__ */ jsx("a", {
      href: "./..",
      children: "Level Up"
    })
  });
};

const placeDetails = (place) => {
  const data = {};
  data.address = "";
  data.postcode = "";
  for (const component of place.address_components) {
    const componentType = component.types[0];
    switch (componentType) {
      case "street_number": {
        data.streetNumber = component.long_name;
        break;
      }
      case "postal_code": {
        data.postcode = `${component.long_name}${data.postcode}`;
        break;
      }
      case "postal_code_prefix": {
        data.postcode = `${component.long_name}${data.postcode}`;
        break;
      }
      case "postal_code_suffix": {
        data.postcode = `${data.postcode}${component.long_name}`;
        break;
      }
      case "locality":
        data.locality = component.long_name;
        break;
      case "administrative_area_level_1": {
        data.state = component.short_name;
        break;
      }
      case "country":
        data.country = component.long_name;
        break;
    }
  }
  data.address = place.formatted_address;
  data.location = place.geometry.location && {
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng()
  };
  data.placeId = place.place_id;
  data.name = place.name || data.address;
  return data;
};

let loaded = false;
if (typeof window !== "undefined") {
  window["initMap"] = () => {
    console.log("Google maps loaded", google.maps);
    loaded = true;
  };
}
const initGoogleMaps = async () => {
  if (loaded) {
    return;
  }
  await loadJsLibs([`https://maps.googleapis.com/maps/api/js?key=AIzaSyCK8h9y8cT3J3vhjh0fxRNWMOxxgG2XV6E&libraries=places&callback=initMap`]);
};
const GoogleApiTest = () => {
  const postIdDefault = isLocalhost() ? "645a79ab864598fbc2ef70e5" : "6460ae96956bfa5e9bc058cf";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  path[3] === "post-view" && path[4] ? path[4] : postIdDefault;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
      children: /* @__PURE__ */ jsxs("div", {
        className: "ns overflow-auto text-base w-full pb-4 min-h-screen",
        "data-testid": "GoogleAPITest",
        children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(TestPanel$4, {})]
      })
    })]
  });
};
const GoogleAutoComplete = (props) => {
  const [place, setPlace] = useState(null);
  const [details, setDetails] = useState(null);
  const [ward, setWard] = useState("");
  const inputRef = useRef();
  const divRef = useRef();
  const initGoogleMaps2 = useInitGoogleMapsFn();
  const [autocomplete, setAutocomplete] = useState();
  useEffect(() => {
    if (!autocomplete) {
      return;
    }
    const handle = autocomplete.addListener("place_changed", () => {
      const place2 = autocomplete.getPlace();
      console.log("place:", place2);
      setPlace(placeDetails(place2));
    });
    return () => {
      if (!autocomplete) {
        return;
      }
      google.maps.event.removeListener(handle);
    };
  }, [autocomplete]);
  useAsyncEffect(async () => {
    if (!await initGoogleMaps2()) {
      return;
    }
    const autocomplete2 = new google.maps.places.Autocomplete(inputRef.current);
    setAutocomplete(autocomplete2);
  }, []);
  const getDeyails = () => {
    const service = new google.maps.places.PlacesService(divRef.current);
    service.getDetails({
      placeId: place.placeId
    }, (place2, status) => {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        setDetails(place2);
      }
      console.log("Details", details);
    });
  };
  const getWard = async () => {
    const response = await fetch("https://api.postcodes.io/postcodes?q=" + place.postcode);
    const result = await response.json();
    setWard(result.result[0].admin_ward);
    console.log("result:", result);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("input", {
      ref: inputRef,
      ...props,
      className: "border border-black border-solid p-2 w-full"
    }), /* @__PURE__ */ jsx("div", {
      ref: divRef
    }), /* @__PURE__ */ jsx(Button, {
      onClick: getWard,
      variant: "outlined",
      children: "getWard"
    }), /* @__PURE__ */ jsx(Result, {
      label: "ward",
      children: ward
    }), /* @__PURE__ */ jsx(Result, {
      label: "details",
      children: place
    }), /* @__PURE__ */ jsx(Result, {
      label: "place",
      children: details
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col",
      children: details && details.photos && details.photos.map((photo, id) => {
        return /* @__PURE__ */ jsx("img", {
          src: photo.getUrl(),
          height: photo.height,
          width: photo.width
        }, id);
      })
    }), /* @__PURE__ */ jsx(Button, {
      onClick: getDeyails,
      variant: "outlined",
      children: "Get Details"
    })]
  });
};
const TestPanel$4 = () => {
  const [result, setResult] = useState(null);
  const initGoogleMaps2 = useInitGoogleMapsFn();
  useApi();
  const onLoadGooglePlaces = async () => {
    setResult("wait...");
    await initGoogleMaps2();
    setResult("ok");
  };
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx(Result, {
      children: result
    }), /* @__PURE__ */ jsx(Button, {
      onClick: onLoadGooglePlaces,
      variant: "outlined",
      children: "Load Google Places API"
    }), /* @__PURE__ */ jsx(GoogleAutoComplete, {
      className: "w-full"
    })]
  });
};

const useInitGoogleMapsFn = () => {
  const unmountedRef = useUnmountedRef();
  return async () => {
    await initGoogleMaps();
    return new Promise((resolve) => {
      const check = () => {
        if (unmountedRef.current) {
          resolve(false);
          return;
        }
        if (loaded) {
          resolve(true);
          return;
        }
        setTimeout(check, 50);
      };
      check();
    });
  };
};

const OpenHelpButton$3 = () => {
  const {
    data: profile
  } = useProfile();
  const page = "asset";
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(HelpContextProvider, {
      page,
      profile,
      children: /* @__PURE__ */ jsx(WelcomeToPageButton, {
        button: (props) => /* @__PURE__ */ jsx(StyledButton, {
          className: "group relative",
          icon: IoMdHelpCircleOutline,
          ...props,
          children: /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.help"
            })
          })
        })
      })
    })
  });
};

const PostNavigation = ({
  panel
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-6 sm:justify-start items-center w-full bg-white shadow-lg px-[9px] relative ",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: "block",
      children: /* @__PURE__ */ jsx(HamburgerMenu, {})
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-end items-center relative gap-4  ltr:ml-auto rtl:mr-auto",
      children: [panel, /* @__PURE__ */ jsx(PostVotingIcon, {}), /* @__PURE__ */ jsx(OpenHelpButton$3, {}), /* @__PURE__ */ jsx(ProfileIcon, {})]
    })]
  });
};

const PostTextBreadCrumbs = ({
  panel
}) => {
  const {
    post
  } = usePostInfoContext();
  const parent = post && post.group.group.parent;
  const onCircle = () => {
    if (window.location.pathname === postCircleUrl(post)) {
      window.location.reload();
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), parent && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(parent),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: "..."
        })
      })]
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: postCircleUrl(post),
      onClick: onCircle,
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: post && post.group.group.name
      })
    }), /* @__PURE__ */ jsx(Next, {}), panel]
  });
};

const getDraftUrl = (draftId) => `/drafts/${draftId}`;
const useDraft = (draftId, op) => {
  const api = useApi();
  return useSWR(draftId ? getDraftUrl(draftId) : null, () => api.loadDraft({
    _id: draftId
  }), {
    ...swrLoadOnce,
    ...op
  });
};
const updateDraftCache = (draft) => mutate(getDraftUrl(draft._id), draft);

const useLightTheme = () => {
  const direction = useDirectionality();
  const primaryMainColor = "#6D78FF";
  const secondaryMainColor = "#6D78FF";
  const theme = createMuiTheme$1({
    direction,
    palette: {
      primary: {
        main: primaryMainColor
      },
      secondary: {
        main: secondaryMainColor
      }
    },
    appDrawer: {
      width: 225
    },
    iconSize: 35,
    bottomNavSize: 56,
    leftNavSize: 100
  });
  return theme;
};
const MuiLightProvider = ({
  children
}) => {
  const theme = useLightTheme();
  return /* @__PURE__ */ jsx(MuiThemeProvider, {
    theme,
    children
  });
};

const additionalFieldNames = ["url", "phone", "email", "shortDescription", "openingTimes", "charges"];
const hasAdditionalFields = (assetData) => {
  for (const name of additionalFieldNames) {
    if (assetData[name]) {
      return true;
    }
  }
  return false;
};

const ThankYouDialog = (props) => {
  if (!props.open) {
    return null;
  }
  return /* @__PURE__ */ jsx(ThankYouDialogInner, {
    ...props
  });
};
const ThankYouDialogInner = ({
  open,
  setOpen,
  onThankYouOk
}) => {
  const assetData = useAssetData();
  return /* @__PURE__ */ jsx(Dialog$6, {
    onClose: () => setOpen(false),
    "aria-labelledby": "customized-dialog-title",
    open,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: /* @__PURE__ */ jsxs("div", {
      className: "p-2 flex flex-col items-center justify-center rounded-2xl gap-2",
      children: [/* @__PURE__ */ jsx("img", {
        src: "/static/images/dancing.png"
      }), /* @__PURE__ */ jsx("div", {
        className: "text-sm",
        children: "Thank you for submitting this record which has earned you"
      }), /* @__PURE__ */ jsxs("div", {
        className: "text-base text-[#7B61FF]",
        children: [hasAdditionalFields(assetData) ? 7 : 5, " points"]
      }), /* @__PURE__ */ jsx("div", {
        className: "text-sm",
        children: "Your submitted record will be verified and linked to YourMap"
      }), /* @__PURE__ */ jsx(MuiLightProvider, {
        children: /* @__PURE__ */ jsx(Button, {
          className: "w-full ",
          color: "primary",
          variant: "contained",
          onClick: onThankYouOk,
          children: "OK"
        })
      })]
    })
  });
};

let defaultAssetType;
const getAssetTypeIcon = (type) => {
  const selected = assetTypesAndSubtypes[type] || assetTypesAndSubtypes[defaultAssetType];
  return selected.icon;
};
const getEventIcon = (eventType) => {
  const type = eventType.toLowerCase().replaceAll(" ", "_");
  if (eventIcons.indexOf(type) > -1) {
    return type;
  }
  return eventIcons[0];
};
const eventIcons = ["announce_event", "culture", "information", "meeting", "music", "sport", "training"];
const assetTypesAndSubtypes = {
  "Facilities": {
    icon: "Facilities",
    subtypes: ["Buildings", "Recreational Facilities", "Businesses", "Transportation", "Arts Venues", "Cultural Festivals", "Museums", "Traditions"]
  },
  "Individuals": {
    icon: "Individual",
    subtypes: ["Community Leaders", "Volunteers", "Local Experts", "Educators", "Skill-Sharing and Knowledge Cooperatives"]
  },
  [defaultAssetType = "Activities"]: {
    icon: "Activities",
    subtypes: ["Trade union Community Engagement and Support", "Community Groups", "Housing Cooperatives", "Worker Cooperatives", "Networks", "Families and Individuals", "Religious and Spiritual Groups"]
  },
  "Beauty Spots": {
    icon: "Beauty",
    subtypes: ["Parks and Green Spaces", "Water Bodies", "Wildlife Areas", "Walking Trails"]
  },
  "Groups": {
    icon: "Groups",
    subtypes: ["Trade unions", "Educational Institutions", "Health Facilities", "Government Offices", "Non-profits and NGOs", "Local business"]
  }
};
const mainAssetTypes = Object.keys(assetTypesAndSubtypes);
const assetActivitiesAndSubActivities = {
  "Social": ["Community Meetings", "Trade union events", "Social Events", "Networking Events", "Support Groups"],
  "Cultural": ["Cultural Celebrations", "Artistic Performances", "Workshops and Classes"],
  "Institutional": ["Educational Seminars and Talks", "Public Forums", "Health and Wellness Programs "],
  "Volunteering ": [],
  "Environmental Initiatives": [],
  "Youth and Children\u2019s Activities": []
};
const noop$b = () => null;
const EditAssetContext = React__default.createContext({
  draft: void 0,
  update: noop$b,
  updatePost: noop$b,
  publish: noop$b
});
const useEditAssetContext = () => {
  return React__default.useContext(EditAssetContext);
};
const useAssetData = () => {
  const {
    draft
  } = useEditAssetContext();
  return draft && draft.form && draft.form.data || {};
};
const updateImage = (updated) => {
  const image = (updated.form.data.files || []).find((p) => {
    const {
      contentType
    } = p;
    return contentType && contentType.startsWith("image/");
  });
  updated.image = image;
  return updated;
};
const useUpsertDraftFn$1 = () => {
  const api = useApi();
  const create = async (update) => {
    const {
      title = "New post",
      content,
      tags: allTags,
      ...other
    } = update;
    const system = systemTags(update);
    const form = update.form && update.form.data || {};
    const {
      tags = []
    } = form;
    const draft = await api.upsertDraft({
      attachments: [],
      tags: [...system, ...tags],
      title,
      content: {
        nsTitle: title,
        nsHtml: ""
      },
      ...other
    });
    return draft;
  };
  return create;
};
const EditAssetContextProvider = ({
  children,
  draftId
}) => {
  const [draft, setDraft] = useState();
  const {
    data: data1
  } = useDraft(draftId);
  const data = useCreation(() => {
    if (!data1) {
      return data1;
    }
    return {
      ...data1,
      form: {
        data: {
          ...data1.form && normalizeFormData(data1.form.data, data1)
        }
      }
    };
  }, [data1]);
  const {
    data: circleData
  } = useCircle(postGroupId(draft));
  const api = useApi();
  const updateDraft = useUpsertDraftFn$1();
  const {
    run: updateRequest
  } = useThrottleFn((updated) => {
    updateDraft(updated);
  });
  const publish = useMemoizedFn(async (u) => {
    const request = {
      ...draft,
      form: {
        data: {
          ...draft.form.data,
          ...u
        }
      }
    };
    updateImage(request);
    const updated = await updateDraft(request);
    const result = await api.publish(updated);
    updateDraftCache(updated);
    setDraft(request);
    return result;
  });
  const updatePost = useMemoizedFn(async (u) => {
    const updated = {
      ...draft,
      ...u
    };
    updateRequest(updated);
    setDraft(updated);
  });
  const update = useMemoizedFn(async (u) => {
    const title = "name" in u ? u.name : draft.title;
    const updated = {
      ...draft,
      title,
      form: {
        data: {
          ...draft.form.data,
          ...u
        }
      }
    };
    updateImage(updated);
    updateRequest(updated);
    setDraft(updated);
  });
  useEffect(() => {
    if (!data) {
      return;
    }
    if (data.form) {
      setDraft(data);
      return;
    }
    setDraft({
      ...data,
      form: {
        data: {}
      }
    });
  }, [data]);
  const context = useMemo(() => {
    return {
      draft,
      update,
      updatePost,
      publish
    };
  }, [draft, update, updatePost, publish, circleData]);
  const circleContext = useMemo(() => {
    return {
      circle: draft && draft.group.group,
      membership: circleData && circleData.membership
    };
  }, [draft, circleData]);
  const event$ = useEventEmitter();
  return /* @__PURE__ */ jsx(PostInfoContext.Provider, {
    value: {
      post: draft,
      event$
    },
    children: /* @__PURE__ */ jsx(EditAssetContext.Provider, {
      value: context,
      children: /* @__PURE__ */ jsx(CircleContext.Provider, {
        value: circleContext,
        children: draft && children
      })
    })
  });
};
const getDetails = async (placeId, divRef) => {
  const service = new google.maps.places.PlacesService(divRef.current);
  return new Promise((resolve) => {
    service.getDetails({
      placeId
    }, (place, status) => {
      if (status == google.maps.places.PlacesServiceStatus.OK) {
        resolve(place);
      }
    });
  });
};
const getWard = async (postcode) => {
  const response = await fetch("https://api.postcodes.io/postcodes?q=" + postcode);
  const result = await response.json();
  return result.result[0].admin_ward;
};
const useGetUpdatedGooglePhotosFn = () => {
  useAssetData();
  return (details) => {
    if (!details.photos) {
      return [];
    }
    const updatedPhotos = [];
    for (const photo of details.photos) {
      const url = photo.getUrl();
      updatedPhotos.push({
        ...photo,
        url
      });
    }
    return updatedPhotos;
  };
};
const SuggestedPhotos = (props) => {
  const {
    googlePhotos = [],
    files = []
  } = useAssetData();
  const filesById = useCreation(() => {
    const map = {};
    files.forEach((file) => {
      map[file.uuid] = file;
    });
    return map;
  }, [files]);
  if (!googlePhotos || !googlePhotos.length) {
    return null;
  }
  const notSuggested = googlePhotos.filter((photo) => !filesById[photo.uuid]);
  if (!notSuggested.length) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    ...props,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-base font-semibold",
        children: "Retrieved images"
      }), /* @__PURE__ */ jsx("div", {
        className: "text-xs sm:hidden",
        children: "To optionally use an Image: Press on to download then upload with the button above"
      }), /* @__PURE__ */ jsx("div", {
        className: "text-xs hidden sm:block",
        children: "To optionally use an Image: right-click to download then upload with the button above"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "w-full flex items-start overflow-auto gap-2 p-2",
      children: notSuggested.map((photo) => /* @__PURE__ */ jsx(SuggestedPhoto, {
        photo
      }, photo.url))
    })]
  });
};
const SuggestedPhoto = ({
  photo
}) => {
  const PHOTO_HEIGHT = 100;
  const {
    url,
    height,
    width
  } = photo;
  const photoWidth = width / height * PHOTO_HEIGHT;
  return /* @__PURE__ */ jsx(ImageWrapper, {
    className: "relative cursor-pointer",
    children: /* @__PURE__ */ jsx("img", {
      src: url,
      height: PHOTO_HEIGHT,
      width: photoWidth,
      style: {
        height: PHOTO_HEIGHT,
        minHeight: PHOTO_HEIGHT,
        width: photoWidth,
        minWidth: photoWidth
      }
    })
  });
};
const ImageWrapper = styled.div`
  & .MuiCircularProgress-root {
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -12px;
    margin-left: -12px;    
  }

  & .MuiCircularProgress-svg {
    stroke: white;
  }
`;
const getActivities = (subActivity) => (subActivity && Array.isArray(subActivity) ? subActivity : [subActivity]) || [];
const EditAssetPageInner = ({
  children,
  className
}) => {
  const history = useHistory();
  const [openThankYou, setOpenThankYou] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const assetNameRef = useRef();
  const addressRef = useRef();
  const attrRef = useRef();
  const api = useApi();
  const urlParams = useQueryStringParams();
  const {
    editor,
    setEditor,
    images_upload_handler
  } = useTinyEditorSetup$1();
  const getUpdatedGooglePhotos = useGetUpdatedGooglePhotosFn();
  const [autocomplete, setAutocomplete] = useState();
  const [autocompleteAddress, setAutocompleteAddress] = useState();
  const initGoogleMaps = useInitGoogleMapsFn();
  const {
    data: profile,
    isValidating
  } = useProfile();
  const {
    update,
    draft,
    publish
  } = useEditAssetContext();
  const {
    membership
  } = useCircleContext();
  const assetData = useAssetData();
  const {
    name,
    address,
    ward,
    category,
    status,
    files = [],
    url,
    phone,
    email,
    shortDescription,
    openingTimes,
    charges,
    type,
    subType,
    activity,
    subActivity,
    tags = []
  } = assetData;
  const handleChange = (name2) => async (e) => {
    let value = e.target.value;
    if (name2 === "subActivity") {
      value = value.filter((v) => v);
    }
    const request = {
      [name2]: value
    };
    if (name2 === "type") {
      request["subType"] = "";
    }
    if (name2 === "activity") {
      request["subActivity"] = "";
    }
    await update(request);
  };
  const onDetails = useMemoizedFn((details) => {
    const phoneUpdated = phone ? phone : details.formatted_phone_number || "";
    const urlUpdated = url ? url : details.website;
    const googlePhotos = getUpdatedGooglePhotos(details);
    console.log("googlePhotos!!!!!!!", googlePhotos);
    const request = {
      phone: phoneUpdated,
      url: urlUpdated,
      openingTimes: details.opening_hours && details.opening_hours.weekday_text.join(", "),
      googlePhotos
    };
    if (hasAdditionalFields(request)) {
      setExpanded(true);
    }
    update(request);
  });
  const setupAutocomplete = (autocomplete2, isAddress) => {
    const handle = autocomplete2.addListener("place_changed", async () => {
      const place = autocomplete2.getPlace();
      console.log("place:", place);
      const json = placeDetails(place);
      const request = {
        ...json
      };
      if (isAddress) {
        delete request["name"];
      }
      update(request);
      getWard(json.postcode).then((ward2) => {
        update({
          ward: ward2
        });
      });
      const details = await getDetails(json.placeId, attrRef);
      console.log("details", details);
      onDetails(details);
    });
    return () => {
      if (!autocomplete2) {
        return;
      }
      google.maps.event.removeListener(handle);
    };
  };
  useEffect(() => {
    if (!autocomplete) {
      return;
    }
    setupAutocomplete(autocomplete);
  }, [autocomplete]);
  useEffect(() => {
    if (!autocompleteAddress) {
      return;
    }
    setupAutocomplete(autocompleteAddress, true);
  }, [autocompleteAddress]);
  useAsyncEffect(async () => {
    if (!await initGoogleMaps()) {
      return;
    }
    const autocomplete2 = new google.maps.places.Autocomplete(assetNameRef.current);
    setAutocomplete(autocomplete2);
    const autocompleteAddress2 = new google.maps.places.Autocomplete(addressRef.current);
    setAutocompleteAddress(autocompleteAddress2);
  }, []);
  const onFilesChanged = async (acceptedFiles) => {
    const files2 = await uploadFiles(api, acceptedFiles);
    update({
      files: files2
    });
  };
  const {
    onClick: onSave,
    loading
  } = useLoading(async () => {
    const result = await publish({
      shortDescription: editor.getContent()
    });
    if (profile._id === postAuthorId(draft) && result.modified === result.created) {
      setOpenThankYou(true);
    } else {
      onThankYouOk();
    }
  });
  const onThankYouOk = () => {
    if (urlParams.close) {
      window.close();
      return;
    }
    history.replace(circleUrl(draft.group.group));
  };
  const onCancel = () => {
    onThankYouOk();
  };
  const isEditedByAdmin = isAdmin(membership);
  const subActivities = getActivities(subActivity);
  if (assetNameRef.current) {
    assetNameRef.current.value = name || "";
  }
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("ns sm:px-[54px] text-base w-full pb-4 min-h-screen", className),
    "data-testid": "EditAssetPage",
    children: [/* @__PURE__ */ jsx(ThankYouDialog, {
      open: openThankYou,
      setOpen: setOpenThankYou,
      onThankYouOk
    }), /* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex w-full flex-col gap-2 p-2",
      children: [/* @__PURE__ */ jsx(PostNavigation, {}), /* @__PURE__ */ jsx(PostTextBreadCrumbs, {}), /* @__PURE__ */ jsxs("div", {
        className: "relative w-full h-[200px]",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "absolute w-full bottom-0 text-white flex flex-col items-center z-10 bg-black bg-opacity-25",
          children: [/* @__PURE__ */ jsx("span", {
            className: "font-semibold",
            children: "Celebrate Your Community"
          }), /* @__PURE__ */ jsx("span", {
            children: "Each asset you share illuminates our collective wealth. Together, we are building a vibrant, connected City. Your contribution matters!"
          })]
        }), /* @__PURE__ */ jsx(CircleHeaderImageV2, {})]
      }), /* @__PURE__ */ jsx("h1", {
        className: "bg-[#ECF2FF] text-center p-2 text-base -mt-2",
        children: "ASSET RECORD FORM"
      }), /* @__PURE__ */ jsx(TextField$1, {
        inputRef: assetNameRef,
        defaultValue: name || "",
        onChange: handleChange("name"),
        label: "Asset name",
        placeholder: "Enter name",
        variant: "outlined"
      }), /* @__PURE__ */ jsx(TextField$1, {
        value: address || "",
        inputRef: addressRef,
        label: "Address",
        onChange: handleChange("address"),
        variant: "outlined"
      }), /* @__PURE__ */ jsx(TextField$1, {
        value: ward || "",
        label: "Name of Ward",
        onChange: handleChange("ward"),
        variant: "outlined"
      }), /* @__PURE__ */ jsxs(FormControl$1, {
        className: "w-full",
        children: [/* @__PURE__ */ jsx(InputLabel, {
          id: "asset-type-label",
          children: "Select type"
        }), /* @__PURE__ */ jsxs(Select$1, {
          labelId: "asset-type-label",
          value: type || "",
          variant: "outlined",
          onChange: handleChange("type"),
          children: [/* @__PURE__ */ jsx(MenuItem, {
            value: "",
            children: "-"
          }), Object.keys(assetTypesAndSubtypes).map((type2) => /* @__PURE__ */ jsx(MenuItem, {
            value: type2,
            children: type2
          }, type2))]
        })]
      }), /* @__PURE__ */ jsxs(FormControl$1, {
        className: "w-full",
        children: [/* @__PURE__ */ jsx(InputLabel, {
          id: "asset-activity-type-label",
          children: "Select activity type"
        }), /* @__PURE__ */ jsxs(Select$1, {
          labelId: "asset-activity-type-label",
          value: activity || "",
          variant: "outlined",
          onChange: handleChange("activity"),
          children: [/* @__PURE__ */ jsx(MenuItem, {
            value: "",
            children: "-"
          }), Object.keys(assetActivitiesAndSubActivities).map((type2) => /* @__PURE__ */ jsx(MenuItem, {
            value: type2,
            children: type2
          }, type2))]
        })]
      }), isEditedByAdmin && /* @__PURE__ */ jsxs(FormControl$1, {
        className: "w-full",
        children: [/* @__PURE__ */ jsx(InputLabel, {
          id: "asset-status-label",
          children: "Status"
        }), /* @__PURE__ */ jsxs(Select$1, {
          labelId: "asset-status-label",
          value: status || "Entry",
          variant: "outlined",
          onChange: handleChange("status"),
          children: [/* @__PURE__ */ jsx(MenuItem, {
            value: "Entry",
            children: "Entry"
          }), /* @__PURE__ */ jsx(MenuItem, {
            value: "Validated",
            children: "Validated"
          })]
        })]
      }), /* @__PURE__ */ jsx(TagsPicker$1, {}), /* @__PURE__ */ jsx("h2", {
        className: "text-base",
        children: "Upload Media"
      }), /* @__PURE__ */ jsx(UploadButton$1, {
        value: files || [],
        onFilesChanged
      }), /* @__PURE__ */ jsx(SuggestedPhotos, {}), /* @__PURE__ */ jsx(SaveTo, {
        className: "w-full"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex  flex-col gap-2 p-2 bg-[#F5F5F5] -ml-2 -mr-2",
        children: [/* @__PURE__ */ jsxs("h2", {
          className: "flex items-center text-base",
          children: [/* @__PURE__ */ jsx("span", {
            children: "For More Rewards\xA0"
          }), /* @__PURE__ */ jsx(Trophey, {})]
        }), /* @__PURE__ */ jsx("div", {
          className: "w-full flex items-center",
          children: /* @__PURE__ */ jsxs(DetailsButton, {
            variant: "outlined",
            onClick: () => setExpanded((v) => !v),
            children: [expanded && /* @__PURE__ */ jsx("div", {
              className: "flex-grow",
              children: "Collapse form"
            }), !expanded && /* @__PURE__ */ jsx("div", {
              className: "flex-grow",
              children: "Add more info /Extend Form"
            })]
          })
        }), /* @__PURE__ */ jsx(Collapse, {
          in: expanded,
          timeout: "auto",
          children: /* @__PURE__ */ jsxs("div", {
            className: "flex w-full flex-col gap-2",
            children: [/* @__PURE__ */ jsxs(FormControl$1, {
              className: "w-full",
              children: [/* @__PURE__ */ jsx(InputLabel, {
                id: "asset-subtype-label",
                children: "Sub-type"
              }), /* @__PURE__ */ jsxs(Select$1, {
                labelId: "asset-subtype-label",
                value: subType || "",
                variant: "outlined",
                onChange: handleChange("subType"),
                disabled: !assetTypesAndSubtypes[type] || !assetTypesAndSubtypes[type].subtypes.length,
                children: [/* @__PURE__ */ jsx(MenuItem, {
                  value: "",
                  children: "-"
                }), (assetTypesAndSubtypes[type] && assetTypesAndSubtypes[type].subtypes || []).map((type2) => /* @__PURE__ */ jsx(MenuItem, {
                  value: type2,
                  children: type2
                }, type2))]
              })]
            }), /* @__PURE__ */ jsxs(FormControl$1, {
              className: "w-full",
              children: [/* @__PURE__ */ jsx(InputLabel, {
                id: "asset-activity-label",
                children: "Select activity"
              }), /* @__PURE__ */ jsx(Select$1, {
                labelId: "asset-activity-label",
                value: subActivities,
                multiple: true,
                variant: "outlined",
                onChange: handleChange("subActivity"),
                input: /* @__PURE__ */ jsx(Input, {}),
                renderValue: (selected) => selected.filter((v) => !!v).join(", "),
                disabled: !assetActivitiesAndSubActivities[activity] || !assetActivitiesAndSubActivities[activity].length,
                children: (assetActivitiesAndSubActivities[activity] || []).map((type2) => {
                  return /* @__PURE__ */ jsxs(MenuItem, {
                    value: type2,
                    children: [/* @__PURE__ */ jsx(Checkbox$1, {
                      checked: subActivities.indexOf(type2) > -1
                    }), type2]
                  }, type2);
                })
              })]
            }), /* @__PURE__ */ jsx(TextField$1, {
              value: url || "",
              label: "Web Address",
              onChange: handleChange("url"),
              variant: "outlined"
            }), /* @__PURE__ */ jsx(TextField$1, {
              value: phone || "",
              label: "Phone number",
              onChange: handleChange("phone"),
              variant: "outlined"
            }), /* @__PURE__ */ jsx(TextField$1, {
              value: email || "",
              label: "Email",
              onChange: handleChange("email"),
              variant: "outlined"
            }), /* @__PURE__ */ jsx("div", {
              className: "text-xs text-gray-400 px-1",
              children: "Description"
            }), /* @__PURE__ */ jsx(TinyEditor, {
              free: true,
              content: shortDescription || "",
              setEditor,
              settings: {
                height: 230,
                auto_focus: "none",
                menubar: false,
                toolbar: "ltr rtl | bold italic underline | link"
              }
            }), /* @__PURE__ */ jsx(TextField$1, {
              value: openingTimes || "",
              label: "Opening Times",
              onChange: handleChange("openingTimes"),
              variant: "outlined"
            }), /* @__PURE__ */ jsx(TextField$1, {
              value: charges || "",
              label: "Charges if any",
              onChange: handleChange("charges"),
              variant: "outlined"
            })]
          })
        })]
      }), children, /* @__PURE__ */ jsxs("div", {
        className: "w-full flex gap-2",
        children: [/* @__PURE__ */ jsx(LoadingButton, {
          onClick: onCancel,
          children: "Cancel"
        }), /* @__PURE__ */ jsxs(LoadingButton, {
          onClick: onSave,
          loading,
          children: ["Save to ", draft.group.group.name]
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      ref: attrRef
    })]
  });
};
const DetailsButton = styled(Button)`
    &.MuiButtonBase-root {
        text-transform: none;
        width: 100%;
    }
`;
const Trophey = () => {
  return /* @__PURE__ */ jsx("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx("path", {
      d: "M9 8C9.55 8 10.021 7.804 10.413 7.412C10.805 7.02 11.0007 6.54934 11 6C11 5.45 10.804 4.979 10.412 4.587C10.02 4.195 9.54933 3.99934 9 4C8.45 4 7.979 4.196 7.587 4.588C7.195 4.98 6.99933 5.45067 7 6C7 6.55 7.196 7.021 7.588 7.413C7.98 7.805 8.45067 8.00067 9 8ZM4 7.8V4H2V5C2 5.63334 2.18333 6.20434 2.55 6.713C2.91667 7.22167 3.4 7.584 4 7.8ZM14 7.8C14.6 7.58334 15.0833 7.22067 15.45 6.712C15.8167 6.20334 16 5.63267 16 5V4H14V7.8ZM8 16V12.9C7.18333 12.7167 6.454 12.3707 5.812 11.862C5.17 11.3533 4.69933 10.716 4.4 9.95C3.15 9.8 2.104 9.25434 1.262 8.313C0.420001 7.37167 -0.000665876 6.26734 7.91139e-07 5V4C7.91139e-07 3.45 0.196001 2.979 0.588001 2.587C0.980001 2.195 1.45067 1.99934 2 2H4C4 1.45 4.196 0.979002 4.588 0.587002C4.98 0.195002 5.45067 -0.000664969 6 1.69779e-06H12C12.55 1.69779e-06 13.021 0.196002 13.413 0.588002C13.805 0.980002 14.0007 1.45067 14 2H16C16.55 2 17.021 2.196 17.413 2.588C17.805 2.98 18.0007 3.45067 18 4V5C18 6.26667 17.579 7.371 16.737 8.313C15.895 9.255 14.8493 9.80067 13.6 9.95C13.3 10.7167 12.829 11.3543 12.187 11.863C11.545 12.3717 10.816 12.7173 10 12.9V16H13C13.2833 16 13.521 16.096 13.713 16.288C13.905 16.48 14.0007 16.7173 14 17C14 17.2833 13.904 17.521 13.712 17.713C13.52 17.905 13.2827 18.0007 13 18H5C4.71667 18 4.479 17.904 4.287 17.712C4.095 17.52 3.99933 17.2827 4 17C4 16.7167 4.096 16.479 4.288 16.287C4.48 16.095 4.71733 15.9993 5 16H8Z",
      fill: "black"
    })
  });
};
const SaveTo = (props) => {
  const {
    draft
  } = useEditAssetContext();
  if (!draft) {
    return null;
  }
  return /* @__PURE__ */ jsx(SaveTo1, {
    ...props
  });
};
const SaveTo1 = (props) => {
  const {
    draft,
    updatePost,
    update
  } = useEditAssetContext();
  const {
    ward
  } = useAssetData();
  const group = draft.group.group;
  const groupId = group._id;
  const id = group.parent || groupId;
  const {
    data
  } = useSubCircles(id);
  const changeGroup = async (id2) => {
    if (groupId === id2) {
      return;
    }
    const updatedGroup = data.find((g) => g._id === id2);
    const group2 = {
      ...draft.group,
      group: updatedGroup
    };
    await updatePost({
      group: group2
    });
    if (!ward) {
      const wardFromCircle = updatedGroup.name;
      update({
        ward: wardFromCircle
      });
    }
  };
  useEffect(() => {
    if (!data || !ward) {
      return;
    }
    const wardLowcase = ward.toLocaleLowerCase();
    const group2 = data.find((g) => g.name.toLocaleLowerCase() === wardLowcase);
    if (!group2 || group2._id === groupId) {
      return;
    }
    changeGroup(group2._id);
  }, [ward]);
  const handleChange = async (e) => {
    const id2 = e.target.value;
    changeGroup(id2);
  };
  return /* @__PURE__ */ jsxs(FormControl$1, {
    ...props,
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: "asset-circle-label",
      children: "Save to"
    }), /* @__PURE__ */ jsx(Select$1, {
      labelId: "asset-circle-label",
      value: groupId || "",
      variant: "outlined",
      onChange: handleChange,
      children: data && data.map((circle) => {
        return /* @__PURE__ */ jsx(MenuItem, {
          value: circle._id,
          children: circle.name
        }, circle._id);
      })
    })]
  });
};
const systemTags = (draft) => {
  if (!draft || !draft.form) {
    return [];
  }
  const form = draft.form.data;
  const tags = ["Asset Record", form.status || "Entry"];
  if (form.ward) {
    tags.push(form.ward);
  }
  if (form.type) {
    tags.push(form.type);
  }
  if (form.subType) {
    tags.push(form.subType);
  }
  if (form.activity) {
    tags.push(form.activity);
  }
  if (form.subActivity) {
    tags.push(...getActivities(form.subActivity));
  }
  return tags.filter((v) => v).map((t) => t.toLowerCase().replace(/\s+/g, " "));
};
const TagsPicker$1 = (props) => {
  const [options, setOptions] = useState([]);
  const api = useApi();
  const [tags, setTags] = useState([]);
  const {
    update,
    draft
  } = useEditAssetContext();
  const {
    tags: userTags = []
  } = useAssetData();
  const system = systemTags(draft);
  const renderTags = useMemoizedFn((value, getTagProps) => {
    return value.map((option, index) => {
      const props2 = getTagProps({
        index
      });
      if (index < system.length) {
        props2.onDelete = null;
      }
      return /* @__PURE__ */ jsx(Tag, {
        label: option,
        ...props2
      }, option);
    });
  });
  const onChange = useMemoizedFn((event, newValue) => {
    console.log("newValue", newValue);
    update({
      tags: newValue.slice(system.length).map((t) => t.toLowerCase().replace(/\s+/g, " "))
    });
  });
  useDeepCompareEffect(() => {
    setTags([...system, ...userTags].map((t) => t.toLowerCase().replace(/\s+/g, " ")));
  }, [system, userTags]);
  console.log("tags:", tags);
  return /* @__PURE__ */ jsx(TagsWrapper, {
    ...props,
    children: /* @__PURE__ */ jsx(Autocomplete$1, {
      multiple: true,
      id: "tags-filled",
      options,
      value: tags,
      freeSolo: true,
      renderTags,
      renderInput: (params) => /* @__PURE__ */ jsx(TextField$1, {
        ...params,
        placeholder: "Add Tags"
      }),
      onChange,
      onInputChange: async (_event, newInputValue) => {
        const result = await api.suggestTags({
          filter: newInputValue,
          range: {
            start: 1,
            end: 10
          }
        });
        const tags2 = (result.values || []).map((v) => v.tag);
        setOptions(tags2);
      }
    })
  });
};
const EditAssetPageInner1 = (props) => {
  const {
    draft
  } = useEditAssetContext();
  if (!draft) {
    return null;
  }
  return /* @__PURE__ */ jsx(EditAssetPageInner, {
    ...props
  });
};
const EditAssetPage = (props) => {
  const location = useLocation();
  const {
    draftId: paramDraftId,
    ...other
  } = props;
  let all;
  const draftId = paramDraftId || (all = location.pathname.split("/").filter((v) => v)) && all[all.length - 1];
  return /* @__PURE__ */ jsxs(EditAssetContextProvider, {
    draftId,
    children: [/* @__PURE__ */ jsx(GoogleFixCss$1, {}), /* @__PURE__ */ jsx(EditAssetPageInner1, {
      ...other
    }, draftId)]
  });
};
const GoogleFixCss$1 = createGlobalStyle`
    .pac-container {
        z-index: 10000 !important;
    }

`;

function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

const drawPolyline = (map, bounds, array) => {
  const coordinates = array.map((v) => {
    return {
      lat: v[1],
      lng: v[0]
    };
  });
  const path = new google.maps.Polyline({
    path: coordinates,
    geodesic: true,
    strokeColor: "#C71585",
    strokeOpacity: 1,
    strokeWeight: 2
  });
  path.setMap(map);
  coordinates.forEach((c) => bounds.extend(c));
};
const drawSinglePolygon = (map, bounds, coordinates, onError) => {
  if (!Array.isArray(coordinates) || !Array.isArray(coordinates[0]) || !Array.isArray(coordinates[0][0])) {
    onError({
      error: "Feature should have geometry.coordinates[0] array of arrays [ [lng, lat], [lng, lat], ... ] for polyline"
    });
    return;
  }
  drawPolyline(map, bounds, coordinates[0]);
};
const drawMultiPolygon = (map, bounds, coordinates, onError) => {
  coordinates.forEach((one) => {
    drawSinglePolygon(map, bounds, one, onError);
  });
};
const drawPolygon = (map, bounds, json, onError) => {
  if (!json.geometry || !Array.isArray(json.geometry.coordinates)) {
    onError({
      error: "Feature should have geometry.coordinates[0] array of arrays [ [lng, lat], [lng, lat], ... ] for polyline"
    });
    return;
  }
  if (!json.geometry.type || json.geometry.type === "Polygon") {
    drawSinglePolygon(map, bounds, json.geometry.coordinates, onError);
  } else if (json.geometry.type === "MultiPolygon") {
    drawMultiPolygon(map, bounds, json.geometry.coordinates, onError);
  }
};
const displayGeoJsonFeatureCore = (map, value, onSuccess, onError) => {
  if (!value) {
    return;
  }
  try {
    const trimmed = prepareJsonString(value);
    const json = JSON.parse(trimmed);
    const bounds = new google.maps.LatLngBounds();
    drawPolygon(map, bounds, json, onError);
    onSuccess({
      bounds
    });
  } catch (error) {
    onError({
      error
    });
  }
};
const displayGeoJsonFeature = (map, value) => {
  displayGeoJsonFeatureCore(map, value, ({
    bounds
  }) => {
    map.fitBounds(bounds);
  }, ({
    error
  }) => {
    errorToast({
      error
    });
  });
};
const displayGeoJsonFeatureSilent = (map, value) => {
  displayGeoJsonFeatureCore(map, value, () => {
  }, ({
    error
  }) => {
    console.error(error);
  });
};
const prepareJsonString = (v) => v.trim().replace(/,\s*$/, "");
const GoogleMapImport = () => {
  const [value, setValue] = useState("");
  const {
    id: circleId
  } = useCircleContext();
  const {
    ref,
    map,
    fragment
  } = useCircleGoogleMap();
  const handleChange = (e) => {
    setValue(e.target.value);
  };
  const onImport = () => {
    displayGeoJsonFeature(map, value);
  };
  const api = useApi();
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    await api.post({
      path: `/groups/${circleId}/geo`,
      body: {
        json: prepareJsonString(value)
      }
    });
  });
  const {
    onClick: onDelete,
    loading: deleteLoading
  } = useLoading(async () => {
    await api.delete({
      path: `/groups/${circleId}/geo`
    });
  });
  const {
    onClick: onCurrent,
    loading: currentLoading
  } = useLoading(async () => {
    const {
      geo
    } = await api.get({
      path: `/groups/${circleId}/geo`
    });
    geo.forEach(({
      json
    }) => {
      displayGeoJsonFeature(map, json);
    });
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "ns w-full p-2 flex flex-col gap-2 text-sm",
    children: [/* @__PURE__ */ jsx("h1", {
      className: "font-semibold text-base p-1",
      children: "Defining the boundary of your Circle-Map"
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "Paste the json file for the boundary, click on Import, then Click on Save",
      placeholder: "Paste the json file for the boundary, click on Import, then Click on Save",
      value,
      onChange: handleChange,
      className: "w-full"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-1",
      children: [/* @__PURE__ */ jsx(LoadingButton, {
        onClick: onImport,
        children: "Import"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onSave,
        loading: saveLoading,
        children: "Save"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onDelete,
        loading: deleteLoading,
        children: "Delete"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onCurrent,
        loading: currentLoading,
        children: "Show current"
      })]
    }), /* @__PURE__ */ jsx("div", {
      ref,
      className: "w-full h-96"
    }), fragment]
  });
};
const CircleMapConfigPage = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[1] === "circle-google-map" && path[2] ? path[2] : circleIdDefault;
  return /* @__PURE__ */ jsxs(LoadCircleData, {
    circleId,
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(GoogleMapImport, {})]
  });
};

const DEFAULT_CLUSTER_RADIUS = 20;
const ConfigureClusteringPanel = () => {
  const api = useApi();
  const [zoom, setZoom] = useState(0);
  const {
    id: circleId
  } = useCircleContext();
  const {
    algorithm,
    setAlgorithm,
    options,
    setOptions,
    map
  } = useMarkerClustering();
  const handleChange = async (e) => {
    const value = e.target.value;
    setAlgorithm(value);
  };
  const algorithmNames = clusterAlgorithmNames();
  const {
    radius = DEFAULT_CLUSTER_RADIUS,
    minPoints = 2,
    minZoom = 0,
    maxZoom = 16
  } = options;
  const optionsChange = (name) => (e) => {
    setOptions({
      ...options,
      [name]: parseInt(e.target.value)
    });
  };
  useEffect(() => {
    if (!map) {
      return;
    }
    const onZoom = () => {
      const currentZoom = map.getZoom();
      setZoom(currentZoom);
    };
    const zoomListener = google.maps.event.addListener(map, "zoom_changed", onZoom);
    onZoom();
    return () => {
      google.maps.event.removeListener(zoomListener);
    };
  }, [map]);
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    await api.post({
      path: `/groups/${circleId}/_partial`,
      body: {
        cluster: {
          options,
          algorithm
        }
      }
    });
    onCancel();
  });
  const onCancel = (cancel = false) => {
    if (!cancel && isLocalhost()) {
      return;
    }
    window.location.href = circleUrl(circleId);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 p-2",
    children: [zoom > 0 && /* @__PURE__ */ jsxs("div", {
      className: "flex",
      children: ["Zoom level: ", zoom]
    }), /* @__PURE__ */ jsx(Result, {
      label: "Options:",
      children: options
    }), /* @__PURE__ */ jsxs(FormControl$1, {
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "algorithm-label",
        children: "Algorithm"
      }), /* @__PURE__ */ jsx(Select$1, {
        labelId: "algorithm-label",
        value: algorithm || "",
        variant: "outlined",
        onChange: handleChange,
        children: algorithmNames.map((name) => /* @__PURE__ */ jsx(MenuItem, {
          value: name,
          children: name
        }, name))
      })]
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "Minimum zoom level at which clusters are generated",
      value: minZoom,
      onChange: optionsChange("minZoom"),
      className: "w-full"
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "Maximum zoom level at which clusters are generated",
      value: maxZoom,
      onChange: optionsChange("maxZoom"),
      className: "w-full"
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "Cluster radius, in pixels",
      value: radius,
      onChange: optionsChange("radius"),
      className: "w-full"
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "Minimum number of points to form a cluster",
      value: minPoints,
      onChange: optionsChange("minPoints"),
      className: "w-full"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-1",
      children: [/* @__PURE__ */ jsx(LoadingButton, {
        onClick: () => onCancel(true),
        variant: "outlined",
        size: "small",
        children: "Cancel"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onSave,
        loading: saveLoading,
        children: "Save"
      })]
    })]
  });
};

const CategoriesFilter = ({
  categories,
  categoryFilter,
  setCategoryFilter,
  name,
  disabled
}) => {
  const allRef = useRef(true);
  const handleChange = async (e) => {
    let value = e.target.value;
    const hasAll = value.indexOf("all") !== -1;
    if (hasAll && allRef.current && value.length > 0) {
      value = value.filter((v) => v !== "all");
      allRef.current = true;
    } else {
      if (hasAll) {
        value = ["all"];
      }
      allRef.current = hasAll;
    }
    setCategoryFilter(value);
  };
  return /* @__PURE__ */ jsxs(FormControl$1, {
    className: "w-full",
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: "asset-category-label",
      children: name || "Select type"
    }), /* @__PURE__ */ jsx(Select$1, {
      labelId: "asset-category-label",
      value: categoryFilter,
      multiple: true,
      variant: "outlined",
      onChange: handleChange,
      disabled,
      renderValue: (selected) => {
        if (selected.length === mainAssetTypes.length) {
          return "all";
        }
        return selected.join(", ");
      },
      children: ["all", ...categories].map((category) => {
        return /* @__PURE__ */ jsxs(MenuItem, {
          value: category,
          children: [/* @__PURE__ */ jsx(Checkbox$1, {
            checked: categoryFilter.indexOf(category) > -1
          }), /* @__PURE__ */ jsx(ListItemText, {
            primary: category
          })]
        }, category);
      })
    })]
  });
};

const QuickViewDialog = () => {
  const {
    post,
    setPostUrl
  } = useTabUrl();
  const [postId, setPostId] = useState("");
  useEffect(() => {
    setPostId(post);
  }, [post]);
  if (!postId) {
    return null;
  }
  const onClose = () => {
    setPostUrl(void 0);
  };
  return /* @__PURE__ */ jsx(StyledMuiDialog, {
    open: true,
    onClose,
    children: /* @__PURE__ */ jsx(PostViewPage, {
      postId,
      className: "overflow-y-auto",
      dialog: true
    })
  });
};

const CirclePageTest$2 = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[3] === "google-map" && path[4] ? path[4] : circleIdDefault;
  return /* @__PURE__ */ jsx(CirclePage, {
    circleId,
    children: /* @__PURE__ */ jsx(DuplicatePostTestPanel, {})
  });
};
const StyledMuiDialog = styled(Dialog$6)`
    & .MuiDialog-paper {
        overflow-y: hidden;
    }
`;
const DuplicatePostTestPanel = () => {
  const [result, setResult] = useState();
  useState("");
  useCircleContext();
  const {
    ref,
    categories,
    categoryFilter,
    setCategoryFilter,
    activities,
    activityFilter,
    setActivityFilter,
    fragment
  } = useCircleGoogleMap();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("h1", {
      children: "=Google Map="
    }), /* @__PURE__ */ jsx("h1", {
      children: "=Import="
    }), /* @__PURE__ */ jsx(GoogleMapImport, {}), /* @__PURE__ */ jsx("h1", {
      children: "=Import="
    }), /* @__PURE__ */ jsx("button", {
      className: "border rounded-full border-blue-500 w-3 h-3 border-solid"
    }), /* @__PURE__ */ jsx(Result, {
      children: result
    }), /* @__PURE__ */ jsx("a", {
      href: "#64c9274f4284f2fc7c6f667f",
      children: "Open Asset"
    }), /* @__PURE__ */ jsx(QuickViewDialog, {}), /* @__PURE__ */ jsx(CategoriesFilter, {
      categories,
      categoryFilter,
      setCategoryFilter
    }), /* @__PURE__ */ jsx(CategoriesFilter, {
      name: "Select activity",
      categories: activities,
      categoryFilter: activityFilter,
      setCategoryFilter: setActivityFilter
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("div", {
        ref,
        className: "w-full h-96"
      }), fragment]
    }), /* @__PURE__ */ jsx("h1", {
      children: "=Google Map="
    })]
  });
};
const CircleGoogleMapTest = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
      children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
        children: /* @__PURE__ */ jsx(ActivityContextProvider, {
          children: /* @__PURE__ */ jsx("div", {
            className: "absolute h-full w-full",
            children: /* @__PURE__ */ jsx(CirclePageTest$2, {})
          })
        })
      })
    })]
  });
};

const PostSelectorDialog = ({
  nearby,
  onClose
}) => {
  const dialogInfo = React__default.useRef({
    dialogRoot: null,
    originalParent: null,
    originalNextSibling: null
  });
  const handleClose = () => {
    const {
      dialogRoot,
      originalParent,
      originalNextSibling
    } = dialogInfo.current;
    if (dialogRoot && originalParent) {
      if (originalNextSibling) {
        originalParent.insertBefore(dialogRoot, originalNextSibling);
      } else {
        originalParent.appendChild(dialogRoot);
      }
      dialogInfo.current = {
        dialogRoot: null,
        originalParent: null,
        originalNextSibling: null
      };
    }
    onClose();
  };
  useEffect(() => {
    const moveDialogToFullscreen = () => {
      const fullscreenElement = document.fullscreenElement;
      setTimeout(() => {
        const dialogRoot = document.querySelector(".MuiDialog-root");
        if (!dialogRoot)
          return;
        if (fullscreenElement) {
          if (dialogRoot.parentElement !== fullscreenElement) {
            dialogInfo.current = {
              dialogRoot,
              originalParent: dialogRoot.parentElement,
              originalNextSibling: dialogRoot.nextSibling
            };
            fullscreenElement.appendChild(dialogRoot);
          }
        } else if (dialogInfo.current.dialogRoot && dialogInfo.current.originalParent) {
          const {
            dialogRoot: dialogRoot2,
            originalParent,
            originalNextSibling
          } = dialogInfo.current;
          if (originalNextSibling) {
            originalParent.insertBefore(dialogRoot2, originalNextSibling);
          } else {
            originalParent.appendChild(dialogRoot2);
          }
        }
      }, 50);
    };
    moveDialogToFullscreen();
    document.addEventListener("fullscreenchange", moveDialogToFullscreen);
    return () => {
      document.removeEventListener("fullscreenchange", moveDialogToFullscreen);
      const {
        dialogRoot,
        originalParent,
        originalNextSibling
      } = dialogInfo.current;
      if (dialogRoot && originalParent) {
        if (originalNextSibling) {
          originalParent.insertBefore(dialogRoot, originalNextSibling);
        } else {
          originalParent.appendChild(dialogRoot);
        }
      }
    };
  }, []);
  return /* @__PURE__ */ jsx(StyledMuiDialog, {
    open: true,
    onClose: handleClose,
    children: /* @__PURE__ */ jsxs("div", {
      className: "overflow-y-auto flex flex-col gap-2 p-2 rounded-lg",
      children: [nearby.assets.map((a) => {
        const {
          _id
        } = a;
        const {
          type
        } = assetData(a);
        const markerUrl = postEventIconUrl(type) + "?" + _id;
        return /* @__PURE__ */ jsx(SelectorItem, {
          post: a,
          markerUrl,
          handleClose
        }, _id);
      }), nearby.events.map((a) => {
        const {
          eventType
        } = a;
        const _id = a.post._id;
        const markerUrl = postEventIconUrl("", eventType) + "?" + _id;
        return /* @__PURE__ */ jsx(SelectorItem, {
          post: a.post,
          markerUrl,
          handleClose
        }, _id);
      })]
    })
  });
};
const SelectorItem = ({
  post,
  markerUrl,
  handleClose
}) => {
  const setPostUrl = useSetPostViewUrlFn();
  const {
    title,
    _id
  } = post;
  const onOpen = () => {
    if (document.fullscreenElement && document.exitFullscreen) {
      document.exitFullscreen();
    }
    setPostUrl(_id);
    handleClose();
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 underline cursor-pointer items-center",
    onClick: onOpen,
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex justify-center items-center",
      style: {
        minWidth: 36,
        minHeight: 36
      },
      children: /* @__PURE__ */ jsx("img", {
        src: markerUrl
      })
    }), /* @__PURE__ */ jsx("div", {
      children: title
    })]
  });
};

const OVERLAPPING_DISTANCE = 5;
const noop$a = () => null;
const MarkerClustering = React__default.createContext({
  algorithm: "SuperClusterAlgorithm",
  setAlgorithm: noop$a,
  options: {},
  setOptions: noop$a,
  map: null,
  setMap: noop$a
});
const algorithmMap = {
  NoopAlgorithm,
  SuperClusterAlgorithm
};
const clusterAlgorithmNames = () => {
  return Object.keys(algorithmMap);
};
const createAlgorithm = (options) => {
  return new algorithmMap[options.algorithm](options.options || {
    radius: DEFAULT_CLUSTER_RADIUS
  });
};
const useMarkerClustering = () => {
  return useContext(MarkerClustering);
};
const CircleMarkerClusteringProvider = ({
  children
}) => {
  const {
    circle
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsx(MarkerClusteringProvider, {
    circle,
    children
  });
};
const MarkerClusteringProvider = ({
  children,
  circle
}) => {
  const [algorithm, setAlgorithm] = useState(circle && circle.cluster && circle.cluster.algorithm || "SuperClusterAlgorithm");
  const [options, setOptions] = useSetState(circle && circle.cluster && circle.cluster.options || {});
  const [map, setMap] = useState();
  const context = useCreation(() => {
    return {
      algorithm,
      setAlgorithm,
      options,
      setOptions,
      map,
      setMap
    };
  }, [algorithm, options, map]);
  return /* @__PURE__ */ jsx(MarkerClustering.Provider, {
    value: context,
    children
  });
};
const useAssets = (circleId, options) => {
  const {
    filter$,
    currentFilterRef
  } = useSearchContext();
  const [filter, setFilter] = useState(currentFilterRef.current);
  filter$.useSubscription(({
    filter: filter2
  }) => {
    setFilter(filter2);
  });
  const api = useApi();
  const result = useSWR(circleId ? `/groups/${circleId}/assets/${filter || "_ALL"}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result,
    filter
  };
};
const useCircleGeo = (circleId, options) => {
  const api = useApi();
  const result = useSWR(circleId ? `/groups/${circleId}/geo` : null, async (path) => {
    const {
      geo
    } = await api.get({
      path: `/groups/${circleId}/geo`
    });
    return geo;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const handleLocationError = (map, browserHasGeolocation, infoWindow, pos, error) => {
  infoWindow.setPosition(pos);
  infoWindow.setContent(browserHasGeolocation ? "Error: The Geolocation service failed. " + (error ? error.message : "") : "Error: Your browser doesn't support geolocation.");
  infoWindow.open(map);
};
const createImg = () => {
  const img = document.createElement("img");
  img.src = window.location.origin + "/static/images/location-button.png";
  img.className = "border-0";
  return img;
};
const createLocationControl = (map) => {
  const controlButton = document.createElement("button");
  controlButton.style.backgroundColor = "#fff";
  controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
  controlButton.style.color = "rgb(25,25,25)";
  controlButton.style.cursor = "pointer";
  controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
  controlButton.style.margin = "0px 9px";
  controlButton.style.padding = "7px";
  controlButton.type = "button";
  controlButton.className = "border-0";
  controlButton.appendChild(createImg());
  const infoWindow = new google.maps.InfoWindow();
  const marker = new google.maps.Marker({
    title: "your location",
    icon: window.location.origin + "/static/images/position_small.png"
  });
  controlButton.addEventListener("click", () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        map.setCenter(pos);
        marker.setPosition(pos);
        marker.setMap(map);
      }, (error) => {
        handleLocationError(map, true, infoWindow, map.getCenter(), error);
      }, {
        maximumAge: 6e4,
        timeout: 5e3,
        enableHighAccuracy: true
      });
    } else {
      handleLocationError(map, false, infoWindow, map.getCenter());
    }
  });
  return controlButton;
};
const MARKER_URL = "http://www.google.com/mapfiles/marker.png";
const MarkerAnimations = createGlobalStyle`
    @keyframes bounce {
        0% {
            transform: scale(1.0);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1.0);
        }
    }
`;
const MarkerAnimation = createGlobalStyle`
    img[src^='${(props) => props.url || MARKER_URL}']{
        animation: bounce 1s ease-in-out infinite;
    }   
`;
const postEventIconUrl = (type, eventType) => {
  const icon = eventType ? `2d-${getEventIcon(eventType)}-32_32` : getAssetTypeIcon(type);
  return window.location.origin + "/static/images/" + icon + ".png";
};
const assetData = (asset, def = null) => asset && asset.form && asset.form.data || def;
const zoomToMarker = (map, marker, zoomLevel = 21) => {
  const markerPosition = marker.getPosition();
  if (!markerPosition)
    return;
  map.setZoom(zoomLevel);
  map.panTo(markerPosition);
};
const categoryFilterDefault = ["all"];
const useCircleGoogleMap = () => {
  const [seq, setSeq] = useState(0);
  const [showPostSelector, setShowPostSelector] = useState();
  const clusteringOptions = useMarkerClustering();
  const {
    algorithm,
    options
  } = clusteringOptions;
  const [booleanFilters, setBooleanFilters] = useState({
    showEvents: true,
    showAssets: true
  });
  const pageParams = useQueryStringParams();
  const {
    zoom_to
  } = pageParams;
  const [idle, setIdle] = useState(false);
  const handleChangeBooleanFilters = (event) => {
    setBooleanFilters({
      ...booleanFilters,
      [event.target.name]: event.target.checked
    });
  };
  useThrottleEffect(() => {
    if (!seq) {
      return;
    }
    const selected = markerPostsRef.current[zoom_to];
    if (!selected) {
      return;
    }
    zoomToMarker(map, selected.marker);
    const {
      zoom_to: _,
      ...otherParams
    } = pageParams;
    if (idle) {
      setQueryStringParams(otherParams);
    }
  }, [seq, zoom_to, idle], {
    wait: 10,
    leading: false
  });
  const setPostViewUrl = useSetPostViewUrlFn();
  const [categoryFilter1, setCategoryFilter] = useState(["all"]);
  const [activityFilter1, setActivityFilter] = useState("all");
  const {
    id
  } = useCircleContext();
  const initGoogleMaps = useInitGoogleMapsFn();
  const markersRef = useRef([]);
  const markerPostsRef = useRef({});
  const [categories, setCategories] = useState([]);
  const [activities, setActivities] = useState([]);
  const ref = useRef();
  const [map, setMap] = useState();
  const {
    data,
    filter
  } = useAssets(id);
  const {
    data: geo
  } = useCircleGeo(id);
  const cssRef = useRef(null);
  useEffect(() => {
    if (!map || !geo) {
      return;
    }
    geo.forEach(({
      json
    }) => {
      displayGeoJsonFeatureSilent(map, json);
    });
  }, [geo, map]);
  const categoryFilter = !filter ? categoryFilter1 : categoryFilterDefault;
  const activityFilter = !filter ? activityFilter1 : "all";
  const disableCategoryFilters = !!filter;
  useAsyncEffect(async () => {
    if (!await initGoogleMaps()) {
      return;
    }
    const map2 = new google.maps.Map(ref.current, {
      styles: [
        {
          featureType: "poi.business",
          stylers: [{
            visibility: "off"
          }]
        },
        {
          featureType: "poi.attraction",
          stylers: [{
            visibility: "off"
          }]
        },
        {
          featureType: "poi.medical",
          stylers: [{
            visibility: "off"
          }]
        },
        {
          featureType: "poi.government",
          stylers: [{
            visibility: "off"
          }]
        },
        {
          featureType: "poi.sports_complex",
          stylers: [{
            visibility: "off"
          }]
        },
        {
          featureType: "poi.place_of_worship",
          stylers: [{
            visibility: "off"
          }]
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{
            visibility: "off"
          }]
        }
      ]
    });
    google.maps.event.addListenerOnce(map2, "idle", () => {
      setIdle(true);
    });
    const locationControl = createLocationControl(map2);
    map2.controls[google.maps.ControlPosition.RIGHT_TOP].push(locationControl);
    setMap(map2);
    clusteringOptions.setMap(map2);
  }, []);
  useEffect(() => {
    if (!data || !map) {
      return;
    }
    const {
      assets,
      connections = [],
      events = []
    } = data;
    const bounds = new google.maps.LatLngBounds();
    const markerPosts = {};
    const markers = [];
    const types = [];
    const activities2 = [];
    const posts4asset = {};
    const css = cssRef.current = [];
    const connectionsByPost = {};
    connections.forEach((c) => {
      posts4asset[c.asset] = c.post;
      connectionsByPost[c.post._id] = c;
    });
    const {
      showAssets,
      showEvents
    } = booleanFilters;
    const addOneAsset = (asset) => {
      const data2 = assetData(asset);
      if (!data2) {
        return;
      }
      const {
        location,
        type,
        activity
      } = data2;
      asset.location = null;
      if (!location) {
        return;
      }
      if (type) {
        types.push(type);
      }
      if (activity) {
        activities2.push(activity);
      }
      const {
        title,
        _id
      } = asset;
      if (categoryFilter.indexOf("all") === -1 && categoryFilter.indexOf(type) === -1) {
        return;
      }
      if (activityFilter !== "all" && activity !== activityFilter) {
        return;
      }
      const markerUrl = postEventIconUrl(type) + "?" + _id;
      const icon = {
        url: markerUrl
      };
      asset.location = location;
      const marker = new google.maps.Marker({
        position: location,
        title,
        map,
        icon,
        optimized: false
      });
      markerPosts[_id] = {
        post: asset,
        marker
      };
      markers.push(marker);
      marker.addListener("click", () => {
        onMarkerClick(asset, _id);
      });
      bounds.extend(location);
    };
    const addOneEvent = (event2) => {
      const {
        location,
        post,
        priority,
        eventType
      } = event2;
      const {
        title,
        _id
      } = post;
      const markerUrl = postEventIconUrl("", eventType) + "?" + _id;
      const icon = {
        url: markerUrl
      };
      if (priority === "promote") {
        icon.scaledSize = new google.maps.Size(42, 42);
        icon.size = new google.maps.Size(42, 42);
      }
      const marker = new google.maps.Marker({
        position: location,
        map,
        title,
        icon,
        optimized: false
      });
      css.push(/* @__PURE__ */ jsx(MarkerAnimation, {
        url: markerUrl
      }, _id));
      markerPosts[_id] = {
        post,
        marker
      };
      markers.push(marker);
      marker.addListener("click", () => {
        onMarkerClick(event2, _id);
      });
      bounds.extend(location);
    };
    const onMarkerClick = (event, _id) => {
      const near = eventsAndAssetsNearby(event);
      if (near.length < 2) {
        if (document.fullscreenElement && document.exitFullscreen) {
          document.exitFullscreen();
        }
        setPostViewUrl(_id);
        return;
      }
      setShowPostSelector(near);
    };
    const eventsAndAssetsNearby = (event) => {
      const diff = pixelsDiff(map, event.location, OVERLAPPING_DISTANCE);
      const rt = {
        assets: showAssets ? nearby(event.location, assets, diff) : [],
        events: showEvents ? nearby(event.location, events, diff) : [],
        length: 0
      };
      rt.length = rt.assets.length + rt.events.length;
      return rt;
    };
    if (showAssets) {
      assets.forEach((asset) => {
        try {
          addOneAsset(asset);
        } catch (e) {
          console.error("error adding asset:", asset, e);
          checkDevConsoleAlert();
        }
      });
    }
    if (showEvents) {
      events.forEach((event) => {
        try {
          addOneEvent(event);
        } catch (e) {
          console.error("error adding event:", event, e);
          checkDevConsoleAlert();
        }
      });
    }
    map.fitBounds(bounds);
    markersRef.current = markers;
    markerPostsRef.current = markerPosts;
    setCategories(types.filter(onlyUnique));
    setActivities(activities2.filter(onlyUnique));
    let cluster;
    try {
      cluster = new MarkerClusterer({
        map,
        markers,
        algorithm: createAlgorithm(clusteringOptions)
      });
    } catch (e) {
      console.error(e);
    }
    setSeq((v) => v + 1);
    return () => {
      markers.forEach((marker) => {
        marker.setMap(null);
      });
      markersRef.current = [];
      try {
        cluster.clearMarkers();
      } catch (e) {
        console.error(e);
      }
    };
  }, [map, data, categoryFilter, activityFilter, booleanFilters, algorithm, options]);
  return {
    ref,
    map,
    categories: mainAssetTypes,
    categoryFilter,
    setCategoryFilter,
    activityFilter,
    setActivityFilter,
    activities,
    disableCategoryFilters,
    handleChangeBooleanFilters,
    booleanFilters,
    fragment: /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(MarkerAnimations, {}), showPostSelector && /* @__PURE__ */ jsx(PostSelectorDialog, {
        nearby: showPostSelector,
        onClose: () => setShowPostSelector(null)
      }), cssRef.current]
    })
  };
};
const pixelToLatLng = (map, pixel) => {
  var projection = map.getProjection();
  var point = new google.maps.Point(pixel.x / Math.pow(2, map.getZoom()), pixel.y / Math.pow(2, map.getZoom()));
  return projection.fromPointToLatLng(point);
};
const latLngToPixel = (map, latLng) => {
  var projection = map.getProjection();
  var point = projection.fromLatLngToPoint(latLng);
  return new google.maps.Point(point.x * Math.pow(2, map.getZoom()), point.y * Math.pow(2, map.getZoom()));
};
const pixelsDiff = (map, startLatLng, distanceInPixels) => {
  var startPixel = latLngToPixel(map, startLatLng);
  var targetPixel = {
    x: startPixel.x + distanceInPixels,
    y: startPixel.y + distanceInPixels
  };
  var targetLatLng = pixelToLatLng(map, targetPixel);
  return {
    lat: Math.abs(startLatLng.lat - targetLatLng.lat()),
    lng: Math.abs(startLatLng.lng - targetLatLng.lng())
  };
};
const nearby = (startLatLng, all, diff) => {
  return all.filter((one) => {
    if (!one.location) {
      return false;
    }
    return Math.abs(one.location.lat - startLatLng.lat) <= diff.lat && Math.abs(one.location.lng - startLatLng.lng) <= diff.lng;
  });
};

const encodeHTML = (originalString) => {
  const el = document.createElement("div");
  el.innerText = originalString;
  return el.innerHTML;
};

const text2Html = (str) => {
  if (!str) {
    return "";
  }
  if (typeof str === "string") {
    return encodeHTML(str).split("\n").join("<br>");
  }
  return text2Html(JSON.stringify(str, null, 2));
};
const CircleTestPromptDialog = () => {
  const {
    testPromptDialogOpen,
    setTestPromptDialogOpen
  } = useCircleContext();
  if (!testPromptDialogOpen) {
    return null;
  }
  return /* @__PURE__ */ jsx(TestPromptDialog, {
    open: !!testPromptDialogOpen,
    result: testPromptDialogOpen,
    onClose: () => {
      setTestPromptDialogOpen(false);
    }
  });
};
const TestPromptDialog = (props) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const {
    open,
    onClose,
    result
  } = props;
  if (!open) {
    return null;
  }
  const {
    prompt,
    help,
    error,
    context,
    html
  } = result;
  const details = /* @__PURE__ */ jsxs(Fragment, {
    children: [error && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h1", {
        className: "font-semibold m-4 underline",
        children: "Error"
      }), /* @__PURE__ */ jsx("p", {
        dangerouslySetInnerHTML: {
          __html: text2Html(error)
        }
      })]
    }), context && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h1", {
        className: "font-semibold m-4 underline",
        children: "Prompt Context"
      }), /* @__PURE__ */ jsx("p", {
        dangerouslySetInnerHTML: {
          __html: text2Html(context)
        }
      })]
    }), prompt && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h1", {
        className: "font-semibold m-4 underline",
        children: "Full Prompt"
      }), /* @__PURE__ */ jsx("p", {
        dangerouslySetInnerHTML: {
          __html: text2Html(prompt)
        }
      })]
    }), help && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h1", {
        className: "font-semibold m-4 underline",
        children: "Prompts commands help screen"
      }), /* @__PURE__ */ jsx("p", {
        dangerouslySetInnerHTML: {
          __html: text2Html(help)
        }
      })]
    })]
  });
  return /* @__PURE__ */ jsxs(ConfirmDialog, {
    title: "Test Prompt Results",
    open: true,
    content: /* @__PURE__ */ jsxs("div", {
      className: "ns",
      children: [!showPrompt && details, showPrompt && /* @__PURE__ */ jsx(Content$3, {
        data: {
          nsHtml: html || ""
        },
        dir: "auto"
      })]
    }),
    onClose,
    children: [/* @__PURE__ */ jsx(Button, {
      onClick: () => setShowPrompt((v) => !v),
      children: "Full prompt"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: () => onClose(null, null),
      children: "Close"
    })]
  });
};

const ChevronBreadcrumb = ({
  current
}) => {
  const {
    circle
  } = useCircleContext();
  const dashboardUrl = useDashboardLink();
  return /* @__PURE__ */ jsxs("nav", {
    className: "flex font-sans text-sm m-0 p-0 list-none overflow-hidden flex-wrap",
    children: [/* @__PURE__ */ jsx(ChevronSegment, {
      href: dashboardUrl,
      variant: "blue",
      position: "first",
      isSquare: true,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.breadcrumb"
      })
    }), /* @__PURE__ */ jsx("span", {
      className: "px-0 sm:px-2 leading-6 sm:leading-8 text-gray-400 flex items-center",
      children: "|"
    }), /* @__PURE__ */ jsx(ChevronSegment, {
      href: myCirclesUrl(),
      variant: "blue",
      position: "middle",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "dashboard.circles"
      })
    }), circle && circle.parent && /* @__PURE__ */ jsx(ChevronSegment, {
      href: circleUrl(circle.parent),
      variant: "orange",
      position: "middle",
      children: "..."
    }), circle && /* @__PURE__ */ jsx(ChevronSegment, {
      href: circleUrl(circle._id),
      variant: "green",
      position: current ? "middle" : "last",
      children: circle.name
    }), current && /* @__PURE__ */ jsx(ChevronSegment, {
      variant: "orange",
      position: "last",
      isLast: true,
      children: current
    })]
  });
};

const AuthModal = () => {
  const {
    open,
    setOpen
  } = useAuthContext();
  return /* @__PURE__ */ jsx(AuthDialog, {
    open,
    onClose: () => setOpen(false)
  });
};

const FORMAT_OPTIONS = [{
  value: "docx",
  label: "Word Document (.docx)"
}, {
  value: "epub",
  label: "E-Book (.epub)"
}, {
  value: "odt",
  label: "OpenDocument (.odt)"
}, {
  value: "markdown",
  label: "Markdown (.md)"
}, {
  value: "txt",
  label: "Plain Text (.txt)"
}];
const ExportPostDialog = () => {
  const {
    exported
  } = useCircleModalDialogsContext();
  const {
    circle
  } = useCircleContext();
  if (!circle || !exported) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(ExportPostDialogInner, {})]
  });
};
const ExportPostDialogInner = () => {
  const {
    exported,
    setExported
  } = useCircleModalDialogsContext();
  const [format, setFormat] = useState("docx");
  const taskOperation = useTaskOperation({
    executeEndpoint: "/download/post/sse"
  });
  const isRunning = taskOperation.isCreatingTask || taskOperation.isValidating;
  const isDone = taskOperation.isComplete;
  const completeData = taskOperation.complete;
  const downloadUrl = isDone && completeData && completeData.result ? completeData.result.url : null;
  const downloadFilename = isDone && completeData && completeData.result ? completeData.result.filename : null;
  const handleExport = () => {
    taskOperation.startTask({
      input: {
        postId: exported._id,
        format
      }
    });
  };
  const message = /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-3",
    children: [/* @__PURE__ */ jsx(Select, {
      value: format,
      onChange: (v) => setFormat(v),
      options: FORMAT_OPTIONS,
      label: "Export format",
      disabled: isRunning || isDone
    }), /* @__PURE__ */ jsx(SSEProgressPanel, {
      messages: taskOperation.messages,
      isConnected: taskOperation.isValidating,
      isComplete: isDone,
      variant: "compact"
    }), downloadUrl && downloadFilename && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-1 p-3 bg-green-50 border border-green-200 rounded",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-xs font-medium text-green-700",
        children: "Export ready \u2014 link valid for 1 hour"
      }), /* @__PURE__ */ jsx("a", {
        href: downloadUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-sm text-blue-600 underline break-all hover:text-blue-800",
        children: downloadFilename
      })]
    })]
  });
  return /* @__PURE__ */ jsx(ConfirmationOverlay, {
    isOpen: !!exported,
    title: "Export post",
    message,
    confirmText: isDone ? "Export again" : "Export",
    cancelText: isDone ? "Close" : "Cancel",
    confirmIntent: "primary",
    isLoading: isRunning,
    error: taskOperation.error && taskOperation.error.message,
    onConfirm: handleExport,
    onCancel: () => setExported(null)
  });
};

const CircleApiNoop = ({
  children
}) => {
  return /* @__PURE__ */ jsx(Fragment, {
    children
  });
};
const CirclePageWrapper = styled.div`
    line-height: 1.2;
`;
const CirclePageProviders = ({
  circleId,
  initial,
  initialPosts,
  children
}) => {
  useSetOnLoginUrl();
  const components = useAppComponents();
  const CircleApi = components["CircleApi"] || CircleApiNoop;
  return /* @__PURE__ */ jsx(LoadCircleData, {
    circleId,
    initial,
    initialPosts,
    children: /* @__PURE__ */ jsx(CircleModalDialogsContextProvider, {
      children: /* @__PURE__ */ jsx(CircleApi, {
        children: /* @__PURE__ */ jsx(PostsFiltersContextProvider, {
          children
        })
      })
    })
  });
};
const CirclePageImpl = ({
  children
}) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [children, /* @__PURE__ */ jsx(ChangeCirclePrivacyDialog, {}), /* @__PURE__ */ jsx(DuplicatePostDialog, {}), /* @__PURE__ */ jsx(ExportPostDialog, {}), /* @__PURE__ */ jsx(ConfirmDeleteCircle, {}), /* @__PURE__ */ jsxs(CirclePageWrapper, {
      className: "ns _app sm:px-[54px] overflow-x-hidden text-base/3 w-full",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex w-full flex-col gap-1 p-1",
        children: [/* @__PURE__ */ jsx(CircleNavigation, {}), /* @__PURE__ */ jsx(ChevronBreadcrumb, {})]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-col  lg:grid grid-cols-4 gap-8 w-full",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex flex-col w-full lg:col-span-3",
          children: [/* @__PURE__ */ jsx(ContentHero, {}), /* @__PURE__ */ jsx(Tabs$1, {})]
        }), /* @__PURE__ */ jsx(RightSection, {})]
      })]
    })]
  });
};
const CirclePage = ({
  children,
  ...props
}) => {
  const {
    circleId
  } = props;
  return /* @__PURE__ */ jsxs(AuthProvider, {
    children: [/* @__PURE__ */ jsx(AuthModal, {
      circleId
    }), /* @__PURE__ */ jsx(CirclePageProviders, {
      ...props,
      children: /* @__PURE__ */ jsx(CircleMarkerClusteringProvider, {
        children: /* @__PURE__ */ jsxs(CircleSearchSSEContextProvider, {
          children: [/* @__PURE__ */ jsx(CircleTestPromptDialog, {}), /* @__PURE__ */ jsx(CirclePageImpl, {
            children
          })]
        })
      })
    })]
  });
};

const LoginTesterButton = ({
  setResult
}) => {
  const api = useApi();
  const loginTester = async () => {
    setResult({
      wait: true
    });
    try {
      const result = await api.loginWithEmail({
        email: "eugeny.galchenko@newssocial.co.uk",
        password: "1234567a"
      });
      console.log("login", result);
      setResult(result);
    } catch (error) {
      setResult({
        error: error.message
      });
    }
  };
  return /* @__PURE__ */ jsx(Button, {
    variant: "contained",
    color: "primary",
    onClick: loginTester,
    children: "loginTester"
  });
};

var styles$9 = '';

const PaginationTestInner$1 = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[3] === "test-pagination-2" && path[4] ? path[4] : circleIdDefault;
  return /* @__PURE__ */ jsx(CirclePageProviders, {
    circleId,
    children: /* @__PURE__ */ jsx(PostsFiltersContextProvider, {
      children: /* @__PURE__ */ jsx(CirclePostsPanelTest$1, {
        circleId
      })
    })
  });
};
const CirclePostsCore$1 = ({
  state,
  children
}) => {
  const {
    type,
    setType
  } = usePostsFiltersContext();
  const {
    postsLoaded,
    moreLoading,
    loadMore,
    intro,
    all
  } = state;
  const filtered = type ? all.filter((p) => p.type === type) : all;
  useEffect(() => {
    if (filtered.length) {
      return;
    }
    setType(null);
  }, [filtered.length]);
  if (!postsLoaded) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "grow flex flex-col p-2 paginatedCircleList gap-2",
    children: [children, type && /* @__PURE__ */ jsxs("div", {
      className: "flex text-sm",
      children: ["filter:\xA0", /* @__PURE__ */ jsxs("a", {
        className: "flex items-center",
        onClick: () => setType(null),
        children: [/* @__PURE__ */ jsxs("div", {
          className: "underline",
          children: [type, " "]
        }), /* @__PURE__ */ jsx(IoIosClose, {}), " "]
      })]
    }), filtered.map((post) => {
      return /* @__PURE__ */ jsx(PostCard, {
        post,
        selected: intro === post._id
      }, post._id);
    }), /* @__PURE__ */ jsx(LoadingButton, {
      loading: moreLoading,
      onClick: loadMore,
      children: "Load more..."
    })]
  });
};
const CirclePostsPanelTest$1 = ({
  circleId
}) => {
  const state = useCirclePostsState$2(circleId);
  const {
    circle,
    state: dataState,
    firstLoaded
  } = state;
  const {
    activities$
  } = useActivityContext();
  const onUpdate = () => {
  };
  const onRefresh = () => {
    activities$.emit({
      type: "post"
    });
  };
  const onClearRefresh = async () => {
    await delay$1();
    activities$.emit({
      type: "post"
    });
  };
  return /* @__PURE__ */ jsxs(CirclePostsCore$1, {
    circleId,
    state,
    children: [/* @__PURE__ */ jsx(Result, {
      children: circle && circle.stats
    }), /* @__PURE__ */ jsx(Result, {
      children: {
        ...dataState,
        firstLoaded
      }
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex gap-2",
      children: [/* @__PURE__ */ jsx(Button, {
        onClick: onUpdate,
        variant: "outlined",
        children: "Update"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: onRefresh,
        variant: "outlined",
        children: "Refresh"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: onClearRefresh,
        variant: "outlined",
        children: "Clear Refresh"
      })]
    })]
  });
};
const PaginationTest2 = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
      children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
        children: /* @__PURE__ */ jsx(ActivityContextProvider, {
          children: /* @__PURE__ */ jsxs("div", {
            className: "absolute h-full w-full flex flex-col",
            children: [/* @__PURE__ */ jsx(LoginTesterButton, {
              setResult: () => null
            }), /* @__PURE__ */ jsx(PaginationTestInner$1, {})]
          })
        })
      })
    })]
  });
};

const CirclePostsPanel2 = ({
  circleId
}) => {
  const state = useCirclePostsState$2(circleId);
  const translated = useTranslatedCirclePosts(state.all);
  const translatedState = {
    ...state,
    all: translated
  };
  return /* @__PURE__ */ jsx(CirclePostsCore$1, {
    circleId,
    state: translatedState
  });
};

const userDraftsKey = (circleId) => ["drafts", circleId];
const useUserDrafts = (circleId) => {
  const api = useApi();
  const { data, error, mutate } = useSWR(circleId ? userDraftsKey(circleId) : null, () => api.get({ path: `/v2/drafts/${circleId}` }), swrLoadOnce);
  return {
    drafts: data && data.drafts || [],
    count: data && data.count || 0,
    loading: !data && !error,
    mutate
  };
};

const iconButtonVariants = cva("relative overflow-hidden inline-flex items-center justify-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 disabled:opacity-50 disabled:pointer-events-none", {
  variants: {
    variant: {
      default: "text-gray-600 hover:bg-gray-100",
      subtle: "text-gray-500 hover:bg-gray-50",
      primary: "text-blue-600 hover:bg-blue-50",
      ghost: "text-gray-400 hover:text-gray-600",
      contrast: "text-white hover:bg-white/15"
    },
    size: {
      xs: "w-6 h-6 text-base",
      sm: "w-8 h-8 text-lg",
      md: "w-10 h-10 text-xl",
      lg: "w-12 h-12 text-2xl"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
});
const IconButton$2 = forwardRef(({
  className,
  variant,
  size,
  children,
  onClick,
  type = "button",
  ...props
}, ref) => {
  const {
    ripples,
    createRipple,
    removeRipple
  } = useRipple();
  const handleClick = useMemoizedFn((e) => {
    createRipple(e);
    if (onClick) {
      onClick(e);
    }
  });
  return /* @__PURE__ */ jsxs("button", {
    ref,
    type,
    className: iconButtonVariants({
      variant,
      size,
      className
    }),
    onClick: handleClick,
    ...props,
    children: [ripples.map((ripple) => /* @__PURE__ */ jsx("span", {
      className: "absolute rounded-full bg-current opacity-20 animate-ripple pointer-events-none",
      style: {
        left: ripple.x,
        top: ripple.y,
        width: ripple.size,
        height: ripple.size
      },
      onAnimationEnd: () => removeRipple(ripple.key)
    }, ripple.key)), children]
  });
});
IconButton$2.displayName = "IconButton";

const useConfirmation = ({
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  confirmIntent
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const open = useMemoizedFn(() => {
    setIsOpen(true);
    setError(null);
  });
  const close = useMemoizedFn(() => {
    setIsOpen(false);
    setIsLoading(false);
    setError(null);
  });
  const handleConfirm = useMemoizedFn(async () => {
    setIsLoading(true);
    setError(null);
    try {
      await onConfirm();
      close();
    } catch (e) {
      setError(e.message || "An error occurred");
      setIsLoading(false);
    }
  });
  const confirmationProps = {
    isOpen,
    onConfirm: handleConfirm,
    onCancel: close,
    title,
    message,
    confirmText,
    cancelText,
    confirmIntent,
    isLoading,
    error
  };
  return {
    open,
    close,
    confirmationProps
  };
};

const DraftRow = ({
  draft,
  onRefresh
}) => {
  const api = useApi();
  const {
    execute: doDelete,
    isLoading
  } = useAsyncOperation(async () => {
    await api.unpublishPost({
      _id: draft._id
    });
    onRefresh();
  });
  const {
    open,
    confirmationProps
  } = useConfirmation({
    onConfirm: () => doDelete(),
    title: "Delete draft",
    message: "Are you sure you want to delete this draft? This action cannot be undone.",
    confirmText: "Delete",
    cancelText: "Cancel",
    confirmIntent: "danger"
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-1",
    children: [/* @__PURE__ */ jsx(Link$2, {
      to: createInterviewUrl(draft),
      className: "flex-1 text-left text-sm truncate underline",
      children: draft.title || draft.name
    }), /* @__PURE__ */ jsx(IconButton$2, {
      variant: "ghost",
      size: "xs",
      onClick: open,
      disabled: isLoading,
      title: "Delete draft",
      "aria-label": "Delete draft",
      children: /* @__PURE__ */ jsx(MdDelete, {})
    }), /* @__PURE__ */ jsx(ConfirmationOverlay, {
      ...confirmationProps
    })]
  });
};
const DraftsIndicator = ({
  circleId
}) => {
  const {
    drafts,
    count,
    loading,
    mutate
  } = useUserDrafts(circleId);
  const [expanded, setExpanded] = useState(false);
  if (loading || count === 0) {
    return null;
  }
  const handleRefresh = () => {
    if (mutate) {
      mutate();
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-1 px-2",
    children: [/* @__PURE__ */ jsx("button", {
      className: "text-sm text-blue-600 self-start",
      onClick: () => setExpanded((e) => !e),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "drafts.count",
        values: {
          count
        }
      })
    }), expanded && /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-1 pl-2",
      children: drafts.map((draft) => /* @__PURE__ */ jsx(DraftRow, {
        draft,
        onRefresh: handleRefresh
      }, draft._id))
    })]
  });
};

const PostsArea = () => {
  const filter = useSearchFilter$1();
  const {
    id: circleId
  } = useCircleContext();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(DraftsIndicator, {
      circleId
    }), !filter ? /* @__PURE__ */ jsx(CirclePostsPanel2, {
      circleId
    }) : /* @__PURE__ */ jsx(LoadCirclePosts, {
      children: /* @__PURE__ */ jsx(PostsAreaInner$1, {})
    })]
  });
};
const NO_POSTS = [];
const useCircleContextPosts = () => {
  const {
    id,
    circle,
    error: circleError
  } = useCircleContext();
  const {
    order,
    content,
    error: postsError
  } = useCirclePostsContext();
  const notLoadedResult = useCreation(() => {
    if (!circle || !order) {
      return {
        id,
        posts: NO_POSTS,
        circleError,
        postsError,
        introId: null
      };
    }
  }, [circle, order]);
  const introId = circle && circle.intro;
  return useCreation(() => {
    if (notLoadedResult) {
      return notLoadedResult;
    }
    const intro = introId && content && content[introId];
    const posts = order && content && [intro, ...order.filter((id2) => id2 !== introId).map((id2) => content[id2])].filter((p) => p);
    return {
      id,
      posts,
      circleError,
      postsError,
      introId
    };
  }, [notLoadedResult, introId, content, order]);
};
const PostsAreaInner$1 = () => {
  const {
    posts,
    circleError,
    postsError,
    introId
  } = useCircleContextPosts();
  const translated = useTranslatedCirclePosts(posts);
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-2 items-center w-full",
    children: /* @__PURE__ */ jsx(RenderCirclePosts, {
      data: translated,
      error: circleError || postsError,
      children: (post) => /* @__PURE__ */ jsx(PostCard, {
        post,
        selected: post._id === introId
      }, post._id)
    })
  });
};

var calendar = "data:image/png;base64,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";

const getEventStatusId = (event) => {
  const {
    outOfHours,
    future,
    isFinished,
    aboutToStart,
    inProgress
  } = getEventStatusInfo(event);
  if (outOfHours && future) {
    return "event.comeLater";
  }
  if (outOfHours && isFinished) {
    return "event.reportAvailable";
  }
  if (aboutToStart) {
    return "event.aboutToStart";
  }
  if (inProgress) {
    return "event.joinMeeting";
  }
};
const EventCard = ({
  event
}) => {
  const url = url4post(event);
  const downloadCalendarUrl = eventCalendarLink(event);
  const dates = new EventData(event);
  const statusId = getEventStatusId(dates);
  const {
    dialog,
    createEvent
  } = useCalendar();
  const onCalendar = (e) => {
    if (!isExpoWrapper()) {
      return;
    }
    e.stopPropagation();
    e.preventDefault();
    const eventData = {
      title: event.title,
      startDate: dates.localStartTime,
      alarms: [{
        relativeOffset: -10
      }],
      endDate: dates.localEndTime
    };
    createEvent(eventData);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col justify-start items-center w-[370px] relative gap-2 rounded-[10px] bg-white shadow-md shadow-slate-300",
    "data-testid": "event-card",
    children: [/* @__PURE__ */ jsx(Link$2, {
      to: url,
      className: "min-h-[90px]",
      children: /* @__PURE__ */ jsx(PostImage, {
        post: event,
        width: 370,
        height: 194,
        className: "rounded-tl-[10px] rounded-tr-[10px]"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col sm:flex-row items-end sm:items-start gap-5 py-3 w-full",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex flex-col justify-start items-start gap-1 flex-grow w-full",
        children: /* @__PURE__ */ jsx(Link$2, {
          to: url,
          children: /* @__PURE__ */ jsx("p", {
            className: "text-base/5 break-words font-semibold  text-black ltr:text-left rtl:text-right",
            children: event.title
          })
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex sm:flex-col justify-between sm:justify-start items-end gap-5 px-2 w-full sm:w-auto",
        children: [/* @__PURE__ */ jsxs("a", {
          className: "flex flex-col justify-center items-center relative w-max px-2.5 py-0.5 rounded-[10px] bg-primary",
          href: downloadCalendarUrl,
          onClick: onCalendar,
          children: [/* @__PURE__ */ jsx("img", {
            src: calendar
          }), /* @__PURE__ */ jsx("p", {
            className: "w-full text-xs font-medium text-white",
            children: "Add to my Calendar"
          }), dialog]
        }), /* @__PURE__ */ jsx(MeetingButton, {
          event: dates
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: `
        flex flex-col justify-start items-center w-fit px-2 py-1
        absolute top-2 right-0
        rounded-tl-[20px] rounded-br-[20px]
        text-xs font-semibold bg-green-500 text-white
        shadow-md shadow-slate-300
        `,
      children: [/* @__PURE__ */ jsx("p", {
        children: /* @__PURE__ */ jsx(FormattedDate, {
          value: dates.localStartTime,
          year: "numeric",
          month: "long",
          day: "2-digit"
        })
      }), /* @__PURE__ */ jsxs("p", {
        children: [time24hoursFormat(dates.localStartTime), "-", time24hoursFormat(dates.localEndTime)]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex justify-start items-center w-[80px] absolute left-0 top-9 p-1 rounded-tr-[20px] rounded-br-[20px] bg-[#ff4236]",
      children: /* @__PURE__ */ jsx("p", {
        className: "text-sm font-semibold text-white",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "statusShort." + statusId
        })
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "absolute right-0 top-36 p-0",
      children: /* @__PURE__ */ jsx(GoingPanel, {
        post: event
      })
    })]
  });
};
const GoingPanel = ({
  post
}) => {
  const {
    membership
  } = useCircleContext();
  return /* @__PURE__ */ jsx(Going2, {
    post,
    membership
  });
};
const MeetingButton = ({
  event
}) => {
  const {
    label,
    url: meetingUrl
  } = event;
  const {
    isFinished
  } = getEventStatusInfo(event);
  if (!meetingUrl) {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: meetingUrl,
    target: "_blank",
    children: /* @__PURE__ */ jsx("button", {
      className: "flex justify-start items-center relative w-max p-1 rounded-[10px] bg-black",
      children: /* @__PURE__ */ jsx("p", {
        className: "text-sm text-left text-white",
        children: label ? label : isFinished ? "View Meeting" : "Click to Join"
      })
    })
  });
};
const time24hoursFormat = (date) => {
  if (!date) {
    return "";
  }
  let hours = date.getHours();
  if (hours < 10)
    hours = "0" + hours;
  let minutes = date.getMinutes();
  if (minutes < 10)
    minutes = "0" + minutes;
  return hours + ":" + minutes;
};

const CircleEventsCalendarPanel = () => {
  return /* @__PURE__ */ jsx(LoadCirclePosts, {
    events: true,
    children: /* @__PURE__ */ jsx(CircleEventsCalendarPanelInner, {})
  });
};
const CircleEventsCalendarPanelInner = () => {
  const {
    posts
  } = useCirclePostsContext();
  const events = posts.list.filter((p) => p.type === "event").map((event) => {
    const {
      title
    } = event;
    const date = new EventData(event);
    return {
      title,
      start: date.localStartTime.toISOString(),
      end: date.localEndTime.toISOString(),
      extendedProps: {
        post: event
      }
    };
  });
  return /* @__PURE__ */ jsx("div", {
    children: /* @__PURE__ */ jsx(FullCalendar, {
      plugins: [dayGridPlugin],
      initialView: "dayGridMonth",
      events,
      eventContent: renderEventContent2
    })
  });
};
const renderEventContent2 = (eventInfo) => {
  return /* @__PURE__ */ jsx(EventInfo, {
    eventInfo
  });
};
const EventInfo = ({
  eventInfo
}) => {
  const setPostUrl = useSetPostViewUrlFn();
  const post = eventInfo.event.extendedProps.post;
  const dates = new EventData(post);
  const title = eventInfo.event.title;
  const tooltip = /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-2",
    children: [/* @__PURE__ */ jsx(FormattedDate, {
      value: dates.localStartTime,
      year: "numeric",
      month: "long",
      day: "2-digit"
    }), /* @__PURE__ */ jsxs("span", {
      children: [time24hoursFormat(dates.localStartTime), "-", time24hoursFormat(dates.localEndTime)]
    }), /* @__PURE__ */ jsx("span", {
      children: title
    })]
  });
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setTooltipOpen(false);
    setPostUrl(post._id);
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(Tooltip$2, {
      title: tooltip,
      open: tooltipOpen,
      onClose: () => setTooltipOpen(false),
      onOpen: () => setTooltipOpen(true),
      children: /* @__PURE__ */ jsx("a", {
        href: "#",
        className: "flex items-center overflow-hidden",
        onClick: handleClick,
        children: /* @__PURE__ */ jsx("i", {
          className: "text-ellipsis overflow-hidden whitespace-nowrap",
          children: title
        })
      })
    })
  });
};

const EventsArea = () => {
  const [mode, setMode] = useState("cards");
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 m-2",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-semibold",
        children: "Switch to view:"
      }), /* @__PURE__ */ jsx(Link$1, {
        underline: mode === "cards" ? "always" : "hover",
        onClick: () => setMode("cards"),
        className: "cursor-pointer",
        children: "cards"
      }), /* @__PURE__ */ jsx(Link$1, {
        underline: mode === "calendar" ? "always" : "hover",
        onClick: () => setMode("calendar"),
        className: "cursor-pointer",
        children: "calendar"
      })]
    }), /* @__PURE__ */ jsx(QuickViewDialog, {}), mode === "calendar" && /* @__PURE__ */ jsx(CircleEventsCalendarPanel, {}), mode === "cards" && /* @__PURE__ */ jsx(CircleEventsPanel, {})]
  });
};
const CircleEventsPanel = () => {
  return /* @__PURE__ */ jsx(LoadCirclePosts, {
    events: true,
    children: /* @__PURE__ */ jsx(CircleEventsPanelInner, {})
  });
};
const CircleEventsPanelInner = () => {
  const {
    posts
  } = useCirclePostsContext();
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col md:flex-row flex-wrap gap-2 justify-items-center items-center md:items-stretch",
    children: posts.list.filter((p) => p.type === "event").map((event) => /* @__PURE__ */ jsx(EventCard, {
      event
    }))
  });
};

var allPosts = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAzMEwxNi4wOTg4IDIxLjQwMTJDMTYuODAyIDIwLjY5ODIgMTcuNzU1NiAyMC4zMDMzIDE4Ljc1IDIwLjMwMzNDMTkuNzQ0NCAyMC4zMDMzIDIwLjY5OCAyMC42OTgyIDIxLjQwMTIgMjEuNDAxMkwzMCAzME0yNi4yNSAyNi4yNUwyOS4yMjM4IDIzLjI3NjJDMjkuOTI3IDIyLjU3MzIgMzAuODgwNiAyMi4xNzgzIDMxLjg3NSAyMi4xNzgzQzMyLjg2OTQgMjIuMTc4MyAzMy44MjMgMjIuNTczMiAzNC41MjYyIDIzLjI3NjJMMzcuNSAyNi4yNU0yNi4yNSAxNUgyNi4yNjg4TTExLjI1IDM3LjVIMzMuNzVDMzQuNzQ0NiAzNy41IDM1LjY5ODQgMzcuMTA0OSAzNi40MDE2IDM2LjQwMTZDMzcuMTA0OSAzNS42OTg0IDM3LjUgMzQuNzQ0NiAzNy41IDMzLjc1VjExLjI1QzM3LjUgMTAuMjU1NCAzNy4xMDQ5IDkuMzAxNjEgMzYuNDAxNiA4LjU5ODM1QzM1LjY5ODQgNy44OTUwOSAzNC43NDQ2IDcuNSAzMy43NSA3LjVIMTEuMjVDMTAuMjU1NCA3LjUgOS4zMDE2MSA3Ljg5NTA5IDguNTk4MzUgOC41OTgzNUM3Ljg5NTA5IDkuMzAxNjEgNy41IDEwLjI1NTQgNy41IDExLjI1VjMzLjc1QzcuNSAzNC43NDQ2IDcuODk1MDkgMzUuNjk4NCA4LjU5ODM1IDM2LjQwMTZDOS4zMDE2MSAzNy4xMDQ5IDEwLjI1NTQgMzcuNSAxMS4yNSAzNy41WiIgc3Ryb2tlPSIjNEE5MENFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";

var Article = "data:image/svg+xml;base64,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";

var References = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI2LjI1IDIyLjk2ODhDMjQuODU5MyAyMi45Njg4IDIzLjQ5OTkgMjIuNTU2NCAyMi4zNDM2IDIxLjc4MzhDMjEuMTg3MyAyMS4wMTEzIDIwLjI4NjEgMTkuOTEzMSAxOS43NTQgMTguNjI4MkMxOS4yMjE3IDE3LjM0MzUgMTkuMDgyNiAxNS45Mjk3IDE5LjM1MzkgMTQuNTY1OEMxOS42MjUyIDEzLjIwMTggMjAuMjk0OCAxMS45NDkgMjEuMjc4MiAxMC45NjU3QzIyLjI2MTUgOS45ODIzMSAyMy41MTQzIDkuMzEyNjYgMjQuODc4MiA5LjA0MTM2QzI2LjI0MjEgOC43NzAwNSAyNy42NTU4IDguOTA5MjkgMjguOTQwOCA5LjQ0MTQ3QzMwLjIyNTUgOS45NzM2NSAzMS4zMjM3IDEwLjg3NDkgMzIuMDk2MiAxMi4wMzExQzMyLjg2ODkgMTMuMTg3NCAzMy4yODEyIDE0LjU0NjkgMzMuMjgxMiAxNS45Mzc1QzMzLjI4MTIgMTcuODAyMyAzMi41NDA0IDE5LjU5MDggMzEuMjIxOSAyMC45MDk0QzI5LjkwMzIgMjIuMjI3OSAyOC4xMTQ4IDIyLjk2ODggMjYuMjUgMjIuOTY4OFpNMjYuMjUgMTEuNzE4OEMyNS40MTU2IDExLjcxODggMjQuNiAxMS45NjYyIDIzLjkwNjIgMTIuNDI5N0MyMy4yMTI1IDEyLjg5MzMgMjIuNjcxNyAxMy41NTIyIDIyLjM1MjQgMTQuMzIzMUMyMi4wMzMxIDE1LjA5MzkgMjEuOTQ5NSAxNS45NDIyIDIyLjExMjIgMTYuNzYwNUMyMi4yNzUxIDE3LjU3ODkgMjIuNjc2OCAxOC4zMzA2IDIzLjI2NjggMTguOTIwNkMyMy44NTY5IDE5LjUxMDcgMjQuNjA4NiAxOS45MTI1IDI1LjQyNjggMjAuMDc1M0MyNi4yNDUzIDIwLjIzOCAyNy4wOTM1IDIwLjE1NDQgMjcuODY0MyAxOS44MzUxQzI4LjYzNTMgMTkuNTE1OCAyOS4yOTQyIDE4Ljk3NSAyOS43NTc3IDE4LjI4MTNDMzAuMjIxMiAxNy41ODc1IDMwLjQ2ODcgMTYuNzcxOSAzMC40Njg3IDE1LjkzNzVDMzAuNDY4NyAxNC44MTg2IDMwLjAyNDEgMTMuNzQ1NiAyOS4yMzMxIDEyLjk1NDRDMjguNDQxOCAxMi4xNjMyIDI3LjM2ODggMTEuNzE4OCAyNi4yNSAxMS43MTg4WiIgZmlsbD0iIzRBOTBDRSIvPgo8cGF0aCBkPSJNMzkuMzc1IDM2LjA5MzhDMzkuMDAzNiAzNi4wODg5IDM4LjY0ODYgMzUuOTM5MiAzOC4zODU5IDM1LjY3NjZDMzguMTIzMiAzNS40MTM5IDM3Ljk3MzYgMzUuMDU4OSAzNy45Njg3IDM0LjY4NzVDMzcuOTY4NyAzMS4wMzEyIDM1Ljk4MTIgMjguNTkzOCAyNi4yNSAyOC41OTM4QzE2LjUxODcgMjguNTkzOCAxNC41MzEyIDMxLjAzMTIgMTQuNTMxMiAzNC42ODc1QzE0LjUzMTIgMzUuMDYwNCAxNC4zODMxIDM1LjQxODIgMTQuMTE5NCAzNS42ODE4QzEzLjg1NTYgMzUuOTQ1NiAxMy40OTggMzYuMDkzOCAxMy4xMjUgMzYuMDkzOEMxMi43NTIgMzYuMDkzOCAxMi4zOTQzIDM1Ljk0NTYgMTIuMTMwNiAzNS42ODE4QzExLjg2NjkgMzUuNDE4MiAxMS43MTg4IDM1LjA2MDQgMTEuNzE4OCAzNC42ODc1QzExLjcxODggMjUuNzgxMiAyMS45IDI1Ljc4MTIgMjYuMjUgMjUuNzgxMkMzMC42IDI1Ljc4MTIgNDAuNzgxMiAyNS43ODEyIDQwLjc4MTIgMzQuNjg3NUM0MC43NzY0IDM1LjA1ODkgNDAuNjI2NyAzNS40MTM5IDQwLjM2NDEgMzUuNjc2NkM0MC4xMDE0IDM1LjkzOTIgMzkuNzQ2NCAzNi4wODg5IDM5LjM3NSAzNi4wOTM4WiIgZmlsbD0iIzRBOTBDRSIvPgo8cGF0aCBkPSJNMTUuNjAwMSAyNC40ODcySDE1LjAwMDFDMTMuNTA4MiAyNC4zNDMgMTIuMTM0OCAyMy42MTIxIDExLjE4MTkgMjIuNDU1MkMxMC4yMjg5IDIxLjI5ODMgOS43NzQ2MSAxOS44MTAzIDkuOTE4ODEgMTguMzE4NEMxMC4wNjMgMTYuODI2NiAxMC43OTQgMTUuNDUzMSAxMS45NTA4IDE0LjUwMDJDMTMuMTA3NyAxMy41NDczIDE0LjU5NTcgMTMuMDkzIDE2LjA4NzYgMTMuMjM3MkMxNi4yNzg5IDEzLjI0NTQgMTYuNDY2NCAxMy4yOTI2IDE2LjYzODkgMTMuMzc1OUMxNi44MTEzIDEzLjQ1OTIgMTYuOTY0OCAxMy41NzY4IDE3LjA5MDIgMTMuNzIxNUMxNy4yMTU1IDEzLjg2NjIgMTcuMzEgMTQuMDM1IDE3LjM2NzggMTQuMjE3NkMxNy40MjU2IDE0LjQwMDEgMTcuNDQ1NiAxNC41OTI1IDE3LjQyNjQgMTQuNzgzQzE3LjQwNzIgMTQuOTczNSAxNy4zNDkzIDE1LjE1ODEgMTcuMjU2MyAxNS4zMjU0QzE3LjE2MzMgMTUuNDkyOCAxNy4wMzcgMTUuNjM5MyAxNi44ODU0IDE1Ljc1NjJDMTYuNzMzNyAxNS44NzMgMTYuNTU5NyAxNS45NTc2IDE2LjM3NDIgMTYuMDA0OUMxNi4xODg2IDE2LjA1MjEgMTUuOTk1NCAxNi4wNjEgMTUuODA2MyAxNi4wMzA5QzE1LjQ0MDMgMTUuOTk0NCAxNS4wNzA3IDE2LjAzMjEgMTQuNzE5NSAxNi4xNDE2QzE0LjM2ODQgMTYuMjUxMSAxNC4wNDI5IDE2LjQzMDMgMTMuNzYyNiAxNi42Njg0QzEzLjQ3NzggMTYuODk4MSAxMy4yNDE2IDE3LjE4MjIgMTMuMDY3OCAxNy41MDQxQzEyLjg5NCAxNy44MjYgMTIuNzg2IDE4LjE3OTMgMTIuNzUwMSAxOC41NDM0QzEyLjcxMTMgMTguOTEyIDEyLjc0NjMgMTkuMjg0OCAxMi44NTMgMTkuNjM5N0MxMi45NTk3IDE5Ljk5NDggMTMuMTM2IDIwLjMyNSAxMy4zNzE1IDIwLjYxMTJDMTMuNjA3MSAyMC44OTc1IDEzLjg5NzMgMjEuMTMzOSAxNC4yMjUyIDIxLjMwNjhDMTQuNTUzMSAyMS40Nzk3IDE0LjkxMjEgMjEuNTg1NiAxNS4yODEzIDIxLjYxODRDMTUuODkxNyAyMS42NzA3IDE2LjUwMjggMjEuNTI2MiAxNy4wMjUxIDIxLjIwNTlDMTcuMzQzMyAyMS4wMDk2IDE3LjcyNjYgMjAuOTQ3NSAxOC4wOTA1IDIxLjAzMzhDMTguNDU0NSAyMS4xMTk4IDE4Ljc2OTIgMjEuMzQ3MSAxOC45NjU3IDIxLjY2NTNDMTkuMTYyMiAyMS45ODM3IDE5LjIyNDEgMjIuMzY2OSAxOS4xMzggMjIuNzMwOEMxOS4wNTE4IDIzLjA5NDggMTguODI0NSAyMy40MDk2IDE4LjUwNjMgMjMuNjA1OUMxNy42MzY3IDI0LjE2MDUgMTYuNjMxMyAyNC40NjU0IDE1LjYwMDEgMjQuNDg3MloiIGZpbGw9IiM0QTkwQ0UiLz4KPHBhdGggZD0iTTUuNjI1IDM0LjY4NzVDNS4yNTM1NCAzNC42ODI2IDQuODk4NjggMzQuNTMzIDQuNjM1OTkgMzQuMjcwM0M0LjM3MzMyIDM0LjAwNzYgNC4yMjM2MSAzMy42NTI3IDQuMjE4NzUgMzMuMjgxMkM0LjIxODc1IDI4LjIxODggNS41Njg3NSAyNC44NDM4IDEyLjE4NzUgMjQuODQzOEMxMi41NjA1IDI0Ljg0MzggMTIuOTE4MSAyNC45OTE5IDEzLjE4MTkgMjUuMjU1N0MxMy40NDU2IDI1LjUxOTMgMTMuNTkzNyAyNS44NzcxIDEzLjU5MzcgMjYuMjVDMTMuNTkzNyAyNi42MjI5IDEzLjQ0NTYgMjYuOTgwNyAxMy4xODE5IDI3LjI0NDNDMTIuOTE4MSAyNy41MDgxIDEyLjU2MDUgMjcuNjU2MiAxMi4xODc1IDI3LjY1NjJDNy43ODEyNSAyNy42NTYyIDcuMDMxMjUgMjkuMDYyNSA3LjAzMTI1IDMzLjI4MTJDNy4wMjYzOSAzMy42NTI3IDYuODc2NjcgMzQuMDA3NiA2LjYxNDAxIDM0LjI3MDNDNi4zNTEzMiAzNC41MzMgNS45OTY0NiAzNC42ODI2IDUuNjI1IDM0LjY4NzVaIiBmaWxsPSIjNEE5MENFIi8+Cjwvc3ZnPgo=";

var CairIcon = "data:image/svg+xml;base64,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";

const ReferencesArea = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsx(PostsAreaInner, {});
};
const PostsAreaInner = () => {
  const {
    filter$,
    currentFilterRef
  } = useSearchContext();
  const [filter, setFilter] = useState(currentFilterRef.current);
  filter$.useSubscription(({
    filter: filter2
  }) => {
    setFilter(filter2);
  });
  const {
    id
  } = useCircleContext();
  const {
    data,
    error
  } = useCircleReferences(id, {}, filter);
  const filtered = !data ? null : data.order.map((id2) => data.content[id2]);
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-6 items-center w-full",
    children: /* @__PURE__ */ jsx(RenderCirclePosts, {
      data: filtered,
      error,
      children: (post) => /* @__PURE__ */ jsx(PostCard, {
        post
      })
    })
  });
};

const ActivitiesArea = (props) => {
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-2",
    children: /* @__PURE__ */ jsx(Activities, {})
  });
};

const GoogleMapArea = ({
  className,
  fullHeight
}) => {
  const {
    ref,
    categories,
    categoryFilter,
    setCategoryFilter,
    activities,
    activityFilter,
    setActivityFilter,
    disableCategoryFilters,
    fragment,
    booleanFilters,
    handleChangeBooleanFilters
  } = useCircleGoogleMap();
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("flex flex-col gap-2", className),
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-1",
      children: [/* @__PURE__ */ jsx(CategoriesFilter, {
        categories,
        categoryFilter,
        setCategoryFilter,
        disabled: disableCategoryFilters
      }), /* @__PURE__ */ jsx(FormControlLabel, {
        control: /* @__PURE__ */ jsx(Switch$1, {
          checked: booleanFilters["showEvents"],
          onChange: handleChangeBooleanFilters,
          name: "showEvents",
          color: "primary"
        }),
        label: "Events"
      }), /* @__PURE__ */ jsx(FormControlLabel, {
        control: /* @__PURE__ */ jsx(Switch$1, {
          checked: booleanFilters["showAssets"],
          onChange: handleChangeBooleanFilters,
          name: "showAssets",
          color: "primary"
        }),
        label: "Assets"
      })]
    }), /* @__PURE__ */ jsx("div", {
      ref,
      className: clsx("w-full", fullHeight ? "h-full" : "h-96")
    }), /* @__PURE__ */ jsx(MapFooter, {}), fragment, /* @__PURE__ */ jsx(QuickViewDialog, {})]
  });
};
const CircleMapPage = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[1] === "circle-map" && path[2];
  const context = {
    id: circleId
  };
  return /* @__PURE__ */ jsxs(CircleContext.Provider, {
    value: context,
    children: [/* @__PURE__ */ jsx(QuickViewDialog, {}), /* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(GoogleMapArea, {
      className: "ns w-full h-full",
      fullHeight: true
    })]
  });
};

const chipVariants = cva("inline-flex items-center justify-center font-medium rounded-full transition-colors", {
  variants: {
    variant: {
      default: "bg-gray-100 text-gray-700 hover:bg-gray-200",
      primary: "bg-blue-100 text-blue-700 hover:bg-blue-200",
      success: "bg-green-100 text-green-700 hover:bg-green-200",
      warning: "bg-yellow-100 text-yellow-700 hover:bg-yellow-200",
      error: "bg-red-100 text-red-700 hover:bg-red-200",
      info: "bg-cyan-100 text-cyan-700 hover:bg-cyan-200",
      green: "bg-green-100 text-green-700 hover:bg-green-200",
      blue: "bg-blue-100 text-blue-700 hover:bg-blue-200",
      gray: "bg-gray-100 text-gray-700 hover:bg-gray-200",
      red: "bg-red-100 text-red-700 hover:bg-red-200"
    },
    size: {
      sm: "px-2 py-0.5 text-xs",
      md: "px-2.5 py-1 text-sm",
      lg: "px-3 py-1.5 text-base"
    },
    clickable: {
      true: "cursor-pointer",
      false: "cursor-default"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md",
    clickable: false
  }
});
const Chip = ({
  children,
  className,
  variant,
  size,
  onClick,
  onDelete,
  icon,
  ...props
}) => {
  const isClickable = Boolean(onClick || onDelete);
  return /* @__PURE__ */ jsxs("span", {
    className: chipVariants({
      variant,
      size,
      clickable: isClickable,
      className
    }),
    onClick,
    ...props,
    children: [icon && /* @__PURE__ */ jsx("span", {
      className: "mr-1",
      children: icon
    }), children, onDelete && /* @__PURE__ */ jsx("button", {
      onClick: (e) => {
        e.stopPropagation();
        onDelete();
      },
      className: "ml-1 -mr-1 hover:bg-black hover:bg-opacity-10 rounded-full p-0.5",
      "aria-label": "Delete",
      children: /* @__PURE__ */ jsx("svg", {
        className: "w-3 h-3",
        fill: "currentColor",
        viewBox: "0 0 20 20",
        children: /* @__PURE__ */ jsx("path", {
          fillRule: "evenodd",
          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
          clipRule: "evenodd"
        })
      })
    })]
  });
};

const useFilterSuggestions = ({
  circleId,
  trigger
}) => {
  const api = useApi();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const reload = useMemoizedFn(async () => {
    if (!circleId) {
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await api.post({
        path: "/groups/elastic/filter-suggestions",
        body: {
          circleId,
          maxBuckets: 50
        }
      });
      setData(result);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  });
  useEffect(() => {
    reload();
  }, [circleId, trigger]);
  return {
    data,
    loading,
    error,
    reload
  };
};

const noop$9 = () => {
};
const FilterOptionsContext = React__default.createContext({
  filters: {},
  totalOptions: 0,
  loading: false,
  addFilterOption: noop$9
});
const useFilterOptionsContext = () => useContext(FilterOptionsContext);
const FilterOptionsProvider = ({
  children
}) => {
  const {
    circleId,
    counter
  } = useCircleSearchSSEContext();
  const {
    data,
    loading
  } = useFilterSuggestions({
    circleId,
    trigger: counter
  });
  const [extra, setExtra] = useState({});
  useEffect(() => {
    if (!data) {
      return;
    }
    setExtra((prev) => {
      let changed = false;
      const next = {};
      for (const category of Object.keys(prev)) {
        const stillMissing = prev[category].filter((opt) => !(data.filters[category] || []).some((o) => o.value === opt.value));
        if (stillMissing.length !== prev[category].length) {
          changed = true;
        }
        if (stillMissing.length) {
          next[category] = stillMissing;
        }
      }
      return changed ? next : prev;
    });
  }, [data]);
  const addFilterOption = useMemoizedFn((category, option) => {
    setExtra((prev) => {
      const baseline = data && data.filters[category] || [];
      const already = baseline.some((o) => o.value === option.value) || (prev[category] || []).some((o) => o.value === option.value);
      if (already) {
        return prev;
      }
      return {
        ...prev,
        [category]: [...prev[category] || [], option]
      };
    });
  });
  const filters = useMemo(() => {
    const merged = {};
    const categories = new Set([...data ? Object.keys(data.filters) : [], ...Object.keys(extra)]);
    for (const category of categories) {
      merged[category] = [...data && data.filters[category] || [], ...extra[category] || []];
    }
    return merged;
  }, [data, extra]);
  const totalOptions = useMemo(() => Object.values(filters).reduce((sum, options) => sum + options.length, 0), [filters]);
  const context = useMemo(() => ({
    filters,
    totalOptions,
    loading,
    addFilterOption
  }), [filters, totalOptions, loading, addFilterOption]);
  return /* @__PURE__ */ jsx(FilterOptionsContext.Provider, {
    value: context,
    children
  });
};

const ClassificationSchemaContext = createContext(null);
const useClassificationSchema$1 = () => {
  const context = useContext(ClassificationSchemaContext);
  if (!context) {
    throw new Error("useClassificationSchema must be used within ClassificationSchemaProvider");
  }
  return context;
};
const useSchema = () => {
  const {
    schema
  } = useClassificationSchema$1();
  return schema;
};

const findCategoryByCode = (schema, code) => {
  return schema.classifications[code] || null;
};
const getChildren = (schema, parentCode) => {
  const children = [];
  for (const entry of Object.values(schema.classifications)) {
    if (entry.parentCode === parentCode) {
      children.push(entry);
    }
  }
  return children.sort((a, b) => a.code.localeCompare(b.code, void 0, { numeric: true }));
};

const isValidDeweyCode$1 = (code) => {
  return /^\d{3}(\.\d+)?$/.test(code);
};
const hasValidName = (entry) => {
  return typeof entry.name === "string" && entry.name.trim().length > 0;
};
const getEntryName = (entry, language = "en") => {
  if (language === "ar" && entry.nameAr) {
    return entry.nameAr;
  }
  return entry.name;
};

const getCategoryLabel = (schema, code, lang = "en") => {
  const entry = schema ? findCategoryByCode(schema, code) : null;
  const name = entry ? getEntryName(entry, lang) : code;
  return name === code ? code : `${name} (${code})`;
};

const humanizeField = (field) => {
  const spaced = field.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").trim();
  if (!spaced) {
    return field;
  }
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
};

const FilterChipRow = ({
  label,
  chips,
  isSelected,
  onToggle
}) => {
  if (!chips.length) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-wrap items-center gap-2",
    dir: "auto",
    children: [/* @__PURE__ */ jsx("span", {
      className: "text-xs text-gray-500 me-1",
      children: label
    }), chips.map((chip) => {
      const selected = isSelected(chip.category, chip.value);
      return /* @__PURE__ */ jsxs("button", {
        type: "button",
        dir: "auto",
        onClick: () => onToggle(chip.category, chip.value),
        "aria-pressed": selected,
        className: selected ? "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm border transition-colors bg-[#00A5B6] text-white border-[#00A5B6]" : "inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm border transition-colors bg-white text-gray-700 border-gray-300 hover:bg-gray-50",
        children: [chip.fieldLabel && /* @__PURE__ */ jsxs("span", {
          className: selected ? "text-white/70" : "text-gray-400",
          children: [chip.fieldLabel, ":"]
        }), /* @__PURE__ */ jsx("span", {
          className: "break-words",
          children: chip.display || chip.value
        }), /* @__PURE__ */ jsx("span", {
          className: selected ? "text-white/80" : "text-gray-400",
          children: chip.count
        }), selected && /* @__PURE__ */ jsx("span", {
          "aria-hidden": "true",
          children: "\xD7"
        })]
      }, `${chip.category}:${chip.value}`);
    })]
  });
};

const EMPTY_DATA = {
  results: [],
  totalOptions: 0
};
const DEFAULT_FIELDS = ["persons", "organizations", "locations", "authors", "tags", "sourceInstitutions"];
const useEntityValueSearch = ({
  circleId,
  query,
  fields = DEFAULT_FIELDS,
  limit = 20,
  debounceWait = 250
}) => {
  const api = useApi();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const requestId = useRef(0);
  const search = useMemoizedFn(async () => {
    if (!circleId || !query.trim()) {
      setData(EMPTY_DATA);
      setLoading(false);
      setError(null);
      return;
    }
    const thisRequestId = requestId.current + 1;
    requestId.current = thisRequestId;
    setLoading(true);
    setError(null);
    try {
      const result = await api.post({
        path: "/groups/elastic/entity-values/search",
        body: {
          circleId,
          query,
          fields,
          limit
        }
      });
      if (requestId.current === thisRequestId) {
        setData(result);
      }
    } catch (e) {
      if (requestId.current === thisRequestId) {
        setError(e);
      }
    } finally {
      if (requestId.current === thisRequestId) {
        setLoading(false);
      }
    }
  });
  const {
    run: debouncedSearch
  } = useDebounceFn(search, {
    wait: debounceWait
  });
  useEffect(() => {
    debouncedSearch();
  }, [circleId, query, debouncedSearch]);
  return {
    data,
    loading,
    error,
    reload: search
  };
};

const FIELD_KEY_LABELS = {
  persons: "People",
  organizations: "Organizations",
  locations: "Places",
  authors: "Authors",
  tags: "Tags",
  sourceInstitutions: "Institutions"
};
const detectRTL$1 = (text) => /[\u0600-\u06FF]/.test(text);
const EntityGlossarySearch = ({
  placeholder = "Search people, places, organizations\u2026",
  fields
}) => {
  const {
    circleId,
    selectedFilters,
    toggleFilter
  } = useCircleSearchSSEContext();
  const {
    addFilterOption
  } = useFilterOptionsContext();
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const containerRef = useRef(null);
  const listRef = useRef(null);
  const {
    data,
    loading
  } = useEntityValueSearch({
    circleId,
    query,
    fields
  });
  const {
    refs,
    floatingStyles
  } = useFloating({
    placement: "bottom-start",
    middleware: [offset(4), flip({
      padding: 8
    }), shift({
      padding: 8
    }), size({
      apply({
        rects,
        elements,
        availableHeight
      }) {
        Object.assign(elements.floating.style, {
          maxHeight: `${Math.min(320, availableHeight)}px`,
          minWidth: `${rects.reference.width}px`
        });
      },
      padding: 8
    })],
    whileElementsMounted: open ? autoUpdate : void 0
  });
  useClickAway(() => {
    setOpen(false);
  }, [containerRef, refs.floating]);
  const results = data ? data.results : [];
  useEffect(() => {
    setHighlightedIndex(results.length > 0 ? 0 : -1);
  }, [data]);
  const groups = [];
  for (const result of results) {
    let group = groups.find((g) => g.fieldKey === result.fieldKey);
    if (!group) {
      group = {
        fieldKey: result.fieldKey,
        label: FIELD_KEY_LABELS[result.fieldKey] || result.fieldKey,
        items: []
      };
      groups.push(group);
    }
    group.items.push(result);
  }
  const handleInputChange = useMemoizedFn((e) => {
    setQuery(e.target.value);
    if (!open) {
      setOpen(true);
    }
  });
  const handleSelect = useMemoizedFn((result) => {
    if (!result.fieldKey) {
      return;
    }
    toggleFilter(result.fieldKey, result.value);
    addFilterOption(result.fieldKey, result);
    setQuery("");
    setOpen(false);
  });
  const scrollHighlightedIntoView = useMemoizedFn((index) => {
    const list = listRef.current;
    const el = list ? list.querySelector(`[data-index="${index}"]`) : null;
    if (el) {
      el.scrollIntoView({
        block: "nearest"
      });
    }
  });
  const handleKeyDown = useMemoizedFn((e) => {
    if (e.key === "Escape") {
      setOpen(false);
      return;
    }
    if (!open || results.length === 0) {
      return;
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const next = highlightedIndex < results.length - 1 ? highlightedIndex + 1 : 0;
      setHighlightedIndex(next);
      scrollHighlightedIntoView(next);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const next = highlightedIndex > 0 ? highlightedIndex - 1 : results.length - 1;
      setHighlightedIndex(next);
      scrollHighlightedIntoView(next);
    } else if (e.key === "Enter") {
      e.preventDefault();
      const result = results[highlightedIndex];
      if (result) {
        handleSelect(result);
      }
    }
  });
  const showDropdown = open && query.trim().length > 0;
  let flatIndex = -1;
  return /* @__PURE__ */ jsxs("div", {
    ref: containerRef,
    className: "relative",
    children: [/* @__PURE__ */ jsxs("div", {
      ref: refs.setReference,
      className: "relative",
      children: [/* @__PURE__ */ jsx(MdSearch, {
        size: 16,
        className: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
      }), /* @__PURE__ */ jsx("input", {
        type: "text",
        value: query,
        onChange: handleInputChange,
        onFocus: () => setOpen(true),
        onKeyDown: handleKeyDown,
        placeholder,
        dir: detectRTL$1(query) ? "rtl" : "ltr",
        className: "w-full pl-9 pr-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-500 text-sm",
        role: "combobox",
        "aria-expanded": showDropdown,
        "aria-autocomplete": "list",
        "aria-activedescendant": showDropdown && highlightedIndex >= 0 ? `entity-glossary-option-${highlightedIndex}` : void 0
      })]
    }), showDropdown && /* @__PURE__ */ jsx(FloatingPortal, {
      children: /* @__PURE__ */ jsx("div", {
        ref: refs.setFloating,
        style: {
          ...floatingStyles,
          pointerEvents: "auto"
        },
        className: "bg-white rounded-lg shadow-lg border border-gray-200 overflow-auto z-50",
        children: /* @__PURE__ */ jsxs("div", {
          ref: listRef,
          role: "listbox",
          children: [loading && !results.length && /* @__PURE__ */ jsx("div", {
            className: "px-3 py-4 text-center text-gray-500 text-sm",
            children: "Searching\u2026"
          }), !loading && !results.length && /* @__PURE__ */ jsx("div", {
            className: "px-3 py-4 text-center text-gray-500 text-sm",
            children: "No matches"
          }), groups.map((group) => /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("div", {
              className: "px-3 py-1.5 text-xs text-gray-500 bg-gray-50",
              children: group.label
            }), group.items.map((item) => {
              flatIndex += 1;
              const index = flatIndex;
              const isSelected = (selectedFilters[item.fieldKey] || []).includes(item.value);
              const isHighlighted = index === highlightedIndex;
              return /* @__PURE__ */ jsxs("button", {
                type: "button",
                id: `entity-glossary-option-${index}`,
                role: "option",
                "aria-selected": isHighlighted,
                "data-index": index,
                onClick: () => handleSelect(item),
                onMouseEnter: () => setHighlightedIndex(index),
                dir: detectRTL$1(item.value) ? "rtl" : "ltr",
                className: ["w-full flex items-center gap-2 px-3 py-2 text-sm text-left transition-colors", isHighlighted ? "bg-blue-50 text-blue-700" : isSelected ? "text-blue-700" : "hover:bg-gray-50 text-gray-900"].join(" "),
                children: [/* @__PURE__ */ jsx("span", {
                  className: "flex-1 truncate",
                  children: item.value
                }), /* @__PURE__ */ jsx("span", {
                  className: "text-xs text-gray-400",
                  children: item.count
                })]
              }, `${item.fieldKey}-${item.value}`);
            })]
          }, group.fieldKey))]
        })
      })
    })]
  });
};

const RAIL_CATEGORIES = [{
  key: "authors",
  label: "Authors"
}, {
  key: "persons",
  label: "People"
}, {
  key: "locations",
  label: "Places"
}, {
  key: "organizations",
  label: "Organizations"
}, {
  key: "tags",
  label: "Tags"
}, {
  key: "sourceInstitutions",
  label: "Institutions"
}];
const CATEGORY_KEY = "categoryCodes";
const PER_CATEGORY = 4;
const MAX_ENTITY_CHIPS = 12;
const MAX_METADATA_CHIPS = 16;
const MAX_CATEGORY_CHIPS = 12;
const VectorSearchFilterRail = () => {
  const {
    selectedFilters,
    toggleFilter
  } = useCircleSearchSSEContext();
  const {
    filters
  } = useFilterOptionsContext();
  const schemaCtx = useContext(ClassificationSchemaContext);
  const schema = schemaCtx && schemaCtx.schema;
  if (!Object.keys(filters).length) {
    return null;
  }
  const buildCategoryChips = (key) => {
    const options = filters[key] || [];
    const topChips = options.slice(0, PER_CATEGORY).map((option) => ({
      category: key,
      value: option.label,
      count: option.count
    }));
    const selectedValues = selectedFilters[key] || [];
    const extraSelectedChips = selectedValues.filter((value) => !topChips.some((c) => c.value === value)).map((value) => {
      const match = options.find((o) => o.label === value);
      return {
        category: key,
        value,
        count: match ? match.count : 0
      };
    });
    return [...topChips, ...extraSelectedChips];
  };
  let entityChips = [];
  for (const {
    key
  } of RAIL_CATEGORIES) {
    entityChips.push(...buildCategoryChips(key));
  }
  const isChipSelected = (chip) => (selectedFilters[chip.category] || []).includes(chip.value);
  const selectedEntityChips = entityChips.filter(isChipSelected);
  const unselectedEntityChips = entityChips.filter((chip) => !isChipSelected(chip));
  entityChips = [...selectedEntityChips, ...unselectedEntityChips.slice(0, Math.max(0, MAX_ENTITY_CHIPS - selectedEntityChips.length))];
  const metadataChips = [];
  for (const key of Object.keys(filters)) {
    const options = filters[key] || [];
    const isMetadata = options.length > 0 && options[0].kind === "metadata";
    if (!isMetadata) {
      continue;
    }
    const fieldLabel = humanizeField(key);
    for (const option of options.slice(0, PER_CATEGORY)) {
      metadataChips.push({
        category: key,
        value: option.label,
        count: option.count,
        fieldLabel
      });
    }
  }
  const categoryChips = [];
  {
    const options = filters[CATEGORY_KEY] || [];
    for (const option of options.slice(0, MAX_CATEGORY_CHIPS)) {
      const code = option.label;
      categoryChips.push({
        category: CATEGORY_KEY,
        value: code,
        count: option.count,
        display: getCategoryLabel(schema, code)
      });
    }
  }
  const narrowChips = [...entityChips, ...metadataChips.slice(0, MAX_METADATA_CHIPS)];
  if (!narrowChips.length && !categoryChips.length) {
    return null;
  }
  const isSelected = (category, value) => {
    const current = selectedFilters[category] || [];
    return current.includes(value);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsx(EntityGlossarySearch, {}), /* @__PURE__ */ jsx(FilterChipRow, {
      label: "Categories",
      chips: categoryChips,
      isSelected,
      onToggle: toggleFilter
    }), /* @__PURE__ */ jsx(FilterChipRow, {
      label: "Narrow by",
      chips: narrowChips,
      isSelected,
      onToggle: toggleFilter
    })]
  });
};

const externalPostUrl = (post) => {
  return post && post.form && post.form.external && post.form.external.url;
};

const getChunkText = (post, text) => {
  if (!post) {
    return text;
  }
  if (post.type !== "asset") {
    return text;
  }
  const parts = text.split("===");
  if (parts.length === 1) {
    return text;
  }
  return parts.slice(1).join("===").trim();
};

const getPostAssetFields = (post, defaultValue) => post && post.form && post.form.data || defaultValue;
const getEventData = (post, defaultValue) => post && post.event || defaultValue;

const CategoryChip = ({
  code,
  lang = "en",
  className
}) => {
  const ctx = useContext(ClassificationSchemaContext);
  const schema = ctx && ctx.schema;
  const text = getCategoryLabel(schema, code, lang);
  return /* @__PURE__ */ jsx("span", {
    dir: "auto",
    title: text,
    className: ["inline-flex items-center px-2 py-0.5 rounded text-xs bg-gray-100 text-gray-700", className || ""].join(" "),
    children: text
  });
};

const convertSchema = (source, sourceFormat) => {
  const classifications = {};
  const traverse = (node, code, level, ancestors, pathSegments) => {
    if (!node)
      return;
    const name = typeof node === "string" ? node : node.name || "-";
    const entry = {
      code,
      name,
      level,
      ancestorCodes: ancestors,
      fullPath: [...pathSegments, name],
      keywords: extractKeywords(name),
      isLeaf: !node.divisions || Object.keys(node.divisions).length === 0,
      divisions: {}
    };
    if (node.nameAr) {
      entry.nameAr = node.nameAr;
      entry.fullPathAr = [...pathSegments, node.nameAr];
      entry.keywordsAr = extractKeywords(node.nameAr);
    }
    classifications[code] = entry;
    if (node.divisions) {
      for (const [subCode, subNode] of Object.entries(node.divisions)) {
        if (!isValidDeweyCode(subCode)) {
          console.warn(`Invalid Dewey code: ${subCode}`);
          continue;
        }
        traverse(subNode, subCode, level + 1, [...ancestors, code], [...pathSegments, name]);
      }
    }
  };
  if (Array.isArray(source)) {
    source = source[0];
  }
  for (const [rootCode, rootNode] of Object.entries(source)) {
    traverse(rootNode, rootCode, 0, [], []);
  }
  return {
    version: "1.0",
    language: "bilingual",
    standard: "hybrid",
    classifications
  };
};
const isValidDeweyCode = (code) => {
  return /^\d{3}(\.\d+)?$/.test(code);
};
const extractKeywords = (name) => {
  return name.toLowerCase().replace(/[^\w\s]/g, " ").split(/\s+/).filter((word) => word.length > 2);
};

const isValidEntry = (entry) => {
  const errors = [];
  if (!entry.code || !isValidDeweyCode$1(entry.code)) {
    errors.push("Invalid or missing code");
  }
  if (!hasValidName(entry)) {
    errors.push("Invalid or missing name");
  }
  if (typeof entry.level !== "number" || entry.level < 0) {
    errors.push("Invalid or missing level");
  }
  if (!Array.isArray(entry.ancestorCodes)) {
    errors.push("Missing ancestorCodes array");
  }
  if (!Array.isArray(entry.fullPath)) {
    errors.push("Missing fullPath array");
  }
  if (!Array.isArray(entry.keywords)) {
    errors.push("Missing keywords array");
  }
  if (typeof entry.isLeaf !== "boolean") {
    errors.push("Missing isLeaf boolean");
  }
  if (entry.ancestorCodes && entry.level !== entry.ancestorCodes.length) {
    errors.push(`Level ${entry.level} doesn't match ancestor count ${entry.ancestorCodes.length}`);
  }
  return {
    valid: errors.length === 0,
    errors
  };
};
const hasValidAncestors = (entry, schema) => {
  const missingCodes = [];
  for (const ancestorCode of entry.ancestorCodes) {
    if (!schema.classifications[ancestorCode]) {
      missingCodes.push(ancestorCode);
    }
  }
  return {
    valid: missingCodes.length === 0,
    missingCodes
  };
};
const hasValidParent = (entry, schema) => {
  if (!entry.parentCode) {
    return { valid: true };
  }
  if (!schema.classifications[entry.parentCode]) {
    return {
      valid: false,
      error: `Parent code ${entry.parentCode} not found in schema`
    };
  }
  if (entry.ancestorCodes.length > 0) {
    const lastAncestor = entry.ancestorCodes[entry.ancestorCodes.length - 1];
    if (entry.parentCode !== lastAncestor) {
      return {
        valid: false,
        error: `Parent code ${entry.parentCode} doesn't match last ancestor ${lastAncestor}`
      };
    }
  }
  return { valid: true };
};
const hasValidRelatedCodes = (entry, schema) => {
  if (!entry.relatedCodes || entry.relatedCodes.length === 0) {
    return { valid: true, missingCodes: [] };
  }
  const missingCodes = [];
  for (const relatedCode of entry.relatedCodes) {
    if (!schema.classifications[relatedCode]) {
      missingCodes.push(relatedCode);
    }
  }
  return {
    valid: missingCodes.length === 0,
    missingCodes
  };
};
const hasValidBroaderCodes = (entry, schema) => {
  if (!entry.broaderCodes || entry.broaderCodes.length === 0) {
    return { valid: true, missingCodes: [] };
  }
  const missingCodes = [];
  for (const broaderCode of entry.broaderCodes) {
    if (!schema.classifications[broaderCode]) {
      missingCodes.push(broaderCode);
    }
  }
  return {
    valid: missingCodes.length === 0,
    missingCodes
  };
};
const validateEntry = (entry, schema) => {
  const structure = isValidEntry(entry);
  const ancestors = hasValidAncestors(entry, schema);
  const parent = hasValidParent(entry, schema);
  const relatedCodes = hasValidRelatedCodes(entry, schema);
  const broaderCodes = hasValidBroaderCodes(entry, schema);
  const valid = structure.valid && ancestors.valid && parent.valid && relatedCodes.valid && broaderCodes.valid;
  return {
    valid,
    structure,
    ancestors,
    parent,
    relatedCodes,
    broaderCodes
  };
};
const validateCompleteSchema = (schema) => {
  const errors = [];
  let totalEntries = 0;
  let validEntries = 0;
  for (const [code, entry] of Object.entries(schema.classifications)) {
    totalEntries++;
    const validation = validateEntry(entry, schema);
    if (!validation.valid) {
      const entryErrors = [];
      if (!validation.structure.valid) {
        entryErrors.push(...validation.structure.errors);
      }
      if (!validation.ancestors.valid) {
        entryErrors.push(`Missing ancestors: ${validation.ancestors.missingCodes.join(", ")}`);
      }
      if (!validation.parent.valid && validation.parent.error) {
        entryErrors.push(validation.parent.error);
      }
      if (!validation.relatedCodes.valid) {
        entryErrors.push(`Missing related codes: ${validation.relatedCodes.missingCodes.join(", ")}`);
      }
      if (!validation.broaderCodes.valid) {
        entryErrors.push(`Missing broader codes: ${validation.broaderCodes.missingCodes.join(", ")}`);
      }
      errors.push({ code, errors: entryErrors });
    } else {
      validEntries++;
    }
  }
  return {
    valid: errors.length === 0,
    totalEntries,
    validEntries,
    errors
  };
};
const isMinimallyValidSchema = (schema) => {
  if (!schema || typeof schema !== "object") {
    return false;
  }
  const s = schema;
  if (!s.version || !s.language || !s.standard) {
    return false;
  }
  if (!s.classifications || typeof s.classifications !== "object") {
    return false;
  }
  if (Object.keys(s.classifications).length === 0) {
    return false;
  }
  return true;
};
const validateSchema = (data) => {
  if (!isMinimallyValidSchema(data)) {
    return {
      valid: false,
      errors: ["Invalid schema structure: missing required fields"],
      categoryCount: 0,
      maxDepth: 0,
      hasMultilingual: false
    };
  }
  const validation = validateCompleteSchema(data);
  const entries = Object.values(data.classifications);
  const maxDepth = Math.max(...entries.map((e) => e.level));
  const hasArabic = entries.some((e) => e.nameAr);
  let language = "en";
  if (hasArabic) {
    const hasEnglish = entries.some((e) => e.name);
    language = hasEnglish ? "bilingual" : "ar";
  }
  return {
    valid: validation.valid,
    errors: validation.errors.flatMap((e) => e.errors),
    categoryCount: validation.totalEntries,
    maxDepth,
    hasMultilingual: hasArabic,
    language
  };
};

const isOldFormat = (data) => {
  if (Array.isArray(data)) {
    return true;
  }
  if (!data || typeof data !== "object")
    return false;
  if (data.classifications && typeof data.classifications === "object") {
    return false;
  }
  const keys = Object.keys(data).filter((k) => k !== "name" && k !== "version");
  if (keys.length === 0)
    return false;
  const firstEntry = data[keys[0]];
  return firstEntry && typeof firstEntry === "object" && (firstEntry.divisions !== void 0 || firstEntry.subcategories !== void 0);
};
const processClassificationSchema = (schemaData) => {
  try {
    let finalSchema;
    if (isOldFormat(schemaData)) {
      console.log("Converting schema from old to new format");
      finalSchema = convertSchema(schemaData, "dewey-json");
    } else {
      finalSchema = schemaData;
    }
    const validationResult = validateSchema(finalSchema);
    if (!validationResult.valid) {
      return {
        success: false,
        schema: null,
        validation: null,
        error: validationResult.errors.join(", ")
      };
    }
    return {
      success: true,
      schema: finalSchema,
      validation: validationResult,
      error: null
    };
  } catch (err) {
    return {
      success: false,
      schema: null,
      validation: null,
      error: `Failed to process schema: ${err.message}`
    };
  }
};

const CLASSIFICATION_OPTIONS$1 = "classification";
const useCircleClassificationOptions = (circleId) => {
  const { data: optionsData, mutate: refreshOptions, isValidating, error } = useCircleOptions({
    input: { circleId, types: [CLASSIFICATION_OPTIONS$1] }
  });
  const schemaConfig = optionsData && optionsData.batchCircleOptions && optionsData.batchCircleOptions.options[0] ? optionsData.batchCircleOptions.options[0].options : null;
  const schema = schemaConfig && schemaConfig.json || null;
  const schemaName = schemaConfig && schemaConfig.name || "";
  const schemaVersion = schemaConfig && schemaConfig.version || "";
  return {
    schema,
    schemaName,
    schemaVersion,
    isLoading: isValidating,
    error,
    refreshOptions,
    hasSchema: !!schema,
    optionsData
  };
};

const useClassificationSchema = (circleId) => {
  const [schema, setSchema] = useState(null);
  const [fileName, setFileName] = useState("");
  const [validation, setValidation] = useState(null);
  const [parseError, setParseError] = useState(null);
  const circleOptions = useCircleClassificationOptions(circleId);
  const applySchemaResult = useCallback((result, name) => {
    if (result.success) {
      setSchema(result.schema);
      setFileName(name);
      setValidation(result.validation);
      setParseError(null);
    } else {
      setParseError(result.error);
      setSchema(null);
      setValidation(null);
    }
  }, []);
  useEffect(() => {
    if (circleOptions.schema) {
      const result = processClassificationSchema(circleOptions.schema);
      applySchemaResult(result, circleOptions.schemaName || "Loaded schema");
    }
  }, [circleOptions.schema, circleOptions.schemaName, applySchemaResult]);
  const handleFileUpload = useCallback((file) => {
    setParseError(null);
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target && e.target.result;
      if (typeof content !== "string")
        return;
      try {
        const parsed = JSON.parse(content);
        const result = processClassificationSchema(parsed);
        const name = parsed.name && typeof parsed.name === "string" ? parsed.name : file.name;
        applySchemaResult(result, name);
      } catch (err) {
        setParseError(`Invalid JSON format: ${err.message}`);
        setSchema(null);
        setValidation(null);
      }
    };
    reader.readAsText(file);
  }, [applySchemaResult]);
  const clearSchema = useCallback(() => {
    setSchema(null);
    setFileName("");
    setValidation(null);
    setParseError(null);
  }, []);
  const loadSchemaFromJson = useCallback((schemaJson, name) => {
    const result = processClassificationSchema(schemaJson);
    applySchemaResult(result, name || "Loaded schema");
  }, [applySchemaResult]);
  return {
    schema,
    fileName,
    validation,
    parseError,
    handleFileUpload,
    loadSchemaFromJson,
    clearSchema,
    hasSchema: !!schema,
    schemaInfo: schema ? {
      version: schema.version,
      language: schema.language,
      standard: schema.standard,
      entryCount: Object.keys(schema.classifications).length
    } : null
  };
};

const ClassificationSchemaProvider = ({
  schemaHook,
  children
}) => {
  const value = {
    schema: schemaHook.schema,
    validation: schemaHook.validation,
    hasSchema: schemaHook.hasSchema
  };
  return /* @__PURE__ */ jsx(ClassificationSchemaContext.Provider, {
    value,
    children
  });
};

const Field = ({
  label,
  value,
  href
}) => /* @__PURE__ */ jsxs("a", {
  href,
  className: "no-underline flex items-center gap-2 text-sm",
  children: [/* @__PURE__ */ jsx("span", {
    className: "text-xs font-medium uppercase tracking-wide text-gray-400 shrink-0",
    children: label
  }), /* @__PURE__ */ jsx("span", {
    className: "text-gray-700 break-words",
    children: value
  })]
});
const extractQueryTranslations = (logs) => {
  for (let i = logs.length - 1; i >= 0; i--) {
    if (logs[i].message === "translateQueryForSearch: variants" && logs[i].data && logs[i].data.variants) {
      return logs[i].data.variants;
    }
  }
  return null;
};
const VectorSearchResultsList = () => {
  const {
    circleId,
    found,
    postsById,
    chat,
    isAIMode,
    chunkTranslations = {},
    prompt,
    logs,
    messages,
    requestId
  } = useCircleSearchSSEContext();
  const {
    id
  } = useCircleContext();
  const [expanded, setExpanded] = useState(false);
  const [copied, setCopied] = useState(false);
  const isInstanceAdmin = useIsInstanceAdmin();
  const queryTranslations = isInstanceAdmin ? extractQueryTranslations(logs) : null;
  const onCopyTrace = async () => {
    if (!navigator.clipboard) {
      return;
    }
    const traceData = {
      circleId,
      question: prompt,
      requestId,
      messages
    };
    try {
      await navigator.clipboard.writeText(JSON.stringify(traceData, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
    }
  };
  const minimizeSearchResult = isAIMode && !expanded;
  const schemaHook = useClassificationSchema(circleId);
  return /* @__PURE__ */ jsx(ClassificationSchemaProvider, {
    schemaHook,
    children: /* @__PURE__ */ jsx(FilterOptionsProvider, {
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-3",
        children: [isInstanceAdmin && messages.length > 0 && /* @__PURE__ */ jsx("div", {
          className: "flex justify-end",
          children: /* @__PURE__ */ jsx("button", {
            onClick: onCopyTrace,
            className: "text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded hover:bg-gray-100",
            children: copied ? "Copied!" : "Copy trace"
          })
        }), found && found.length === 0 && /* @__PURE__ */ jsx("div", {
          className: "text-sm text-gray-500 p-2",
          children: "No results found"
        }), found && found.length > 0 && /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2 bg-[#00A5B6] text-white font-semibold rounded-lg px-3 py-2",
          dir: "auto",
          children: [/* @__PURE__ */ jsxs("span", {
            children: ["Search results (", found.length, ")"]
          }), isAIMode && /* @__PURE__ */ jsx(IconButton$2, {
            variant: "contrast",
            size: "sm",
            onClick: () => setExpanded((v) => !v),
            "aria-label": expanded ? "Collapse results" : "Expand results",
            children: !expanded ? /* @__PURE__ */ jsx(BsArrowsCollapse, {}) : /* @__PURE__ */ jsx(BsChevronExpand, {})
          })]
        }), isInstanceAdmin && queryTranslations && queryTranslations.length > 1 && /* @__PURE__ */ jsxs("div", {
          className: "border rounded p-3 bg-amber-50 border-amber-200",
          children: [/* @__PURE__ */ jsx("h3", {
            className: "text-sm font-semibold text-amber-800 mb-2",
            children: "Query translations"
          }), /* @__PURE__ */ jsx("div", {
            className: "flex flex-col gap-1",
            children: queryTranslations.map((v) => /* @__PURE__ */ jsxs("div", {
              className: "flex gap-2 text-sm items-center",
              children: [/* @__PURE__ */ jsx("span", {
                className: "w-10 flex-shrink-0 font-mono text-xs text-amber-700 uppercase",
                children: v.lang
              }), v.isOriginal && /* @__PURE__ */ jsx("span", {
                className: "text-[10px] px-1.5 py-0.5 bg-amber-100 text-amber-700 rounded-full",
                children: "original"
              }), /* @__PURE__ */ jsx("span", {
                dir: "auto",
                className: "flex-1",
                children: v.text
              })]
            }, v.lang))
          })]
        }), /* @__PURE__ */ jsx(VectorSearchFilterRail, {}), minimizeSearchResult && found && found.length > 0 && /* @__PURE__ */ jsx("div", {
          className: "w-full h-20"
        }), !minimizeSearchResult && found && found.map((one, i) => {
          const {
            text,
            score,
            metadata
          } = one;
          const {
            postId,
            persons,
            locations,
            organizations,
            circleId: circleId2,
            chunkId,
            type,
            categories
          } = metadata || {};
          const post = postsById[postId];
          const translation = chunkTranslations[postId] || {};
          const isChat = circleId2 === chat;
          const externalUrl = externalPostUrl(post);
          const isInternal = !externalUrl && !isChat && post;
          const url = isChat ? `/trans/circle-chat/${id}` : externalUrl || (isInternal ? url4post(post) : url4post(post));
          const getChunkUrl = () => {
            const threadLength = post && post.thread && post.thread.length;
            const shouldUseChunkHash = !isChat && type !== "asset" && typeof chunkId === "number" && (!threadLength || isPage(post)) && !externalUrl;
            if (!shouldUseChunkHash) {
              return url;
            }
            if (isInternal) {
              return `${url}#?chunk=${postId}-${chunkId}`;
            }
            if (isPage(post)) {
              return `${url}&chunk=${postId}-${chunkId}`;
            }
            return `${url}#?chunk=${postId}-${chunkId}`;
          };
          const chunkUrl = getChunkUrl();
          const description = getChunkText(post, translation.text || text);
          const {
            email,
            address,
            phone,
            url: assetUrl
          } = getPostAssetFields(post, {});
          const {
            address: eventAddress
          } = getEventData(post, {});
          const title = translation.title || (post ? post.title : "open");
          const entityGroups = [{
            label: "People",
            values: persons,
            variant: "blue"
          }, {
            label: "Places",
            values: locations,
            variant: "green"
          }, {
            label: "Organizations",
            values: organizations,
            variant: "gray"
          }];
          return /* @__PURE__ */ jsxs("div", {
            dir: "auto",
            className: "flex flex-col gap-2 p-4 bg-white rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow w-full text-black",
            children: [/* @__PURE__ */ jsx("a", {
              href: url,
              className: "no-underline",
              children: /* @__PURE__ */ jsx("span", {
                className: "text-base font-semibold text-gray-900 hover:text-[#00A5B6] transition-colors break-words",
                children: title
              })
            }), /* @__PURE__ */ jsx("a", {
              href: chunkUrl,
              className: "no-underline",
              children: /* @__PURE__ */ jsx("p", {
                className: "text-sm text-gray-700 leading-relaxed",
                "data-testid": "description",
                children: description
              })
            }), (address || eventAddress) && /* @__PURE__ */ jsx(Field, {
              label: "Address",
              value: address || eventAddress,
              href: chunkUrl
            }), phone && /* @__PURE__ */ jsx(Field, {
              label: "Phone",
              value: phone,
              href: chunkUrl
            }), email && /* @__PURE__ */ jsx(Field, {
              label: "Email",
              value: email,
              href: chunkUrl
            }), assetUrl && /* @__PURE__ */ jsx(Field, {
              label: "Web",
              value: assetUrl,
              href: chunkUrl
            }), entityGroups.map((group) => group.values && group.values.length > 0 && /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2 flex-wrap",
              children: [/* @__PURE__ */ jsx("span", {
                className: "text-xs font-medium uppercase tracking-wide text-gray-400",
                children: group.label
              }), group.values.map((value) => /* @__PURE__ */ jsx(Chip, {
                variant: group.variant,
                size: "sm",
                children: value
              }, value))]
            }, group.label)), categories && categories.length > 0 && /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2 flex-wrap",
              children: [/* @__PURE__ */ jsx("span", {
                className: "text-xs font-medium uppercase tracking-wide text-gray-400",
                children: "Categories"
              }), categories.map((value) => /* @__PURE__ */ jsx(CategoryChip, {
                code: value
              }, value))]
            }), /* @__PURE__ */ jsx("div", {
              className: "pt-1",
              children: /* @__PURE__ */ jsxs("span", {
                className: "inline-flex items-center rounded-full bg-gray-100 text-gray-500 text-xs px-2 py-0.5",
                children: ["Similarity ", Math.round(score * 100) / 100]
              })
            })]
          }, i);
        })]
      })
    })
  });
};

const DEFAULT_MODEL_OPTIONS = [
  {
    label: "GPT-4o mini (default)",
    value: "gpt-4o-mini"
  },
  {
    label: "GPT-5.6 Terra",
    value: "gpt-5.6-terra"
  },
  {
    label: "Claude Sonnet",
    value: "claude-3-5-sonnet-latest"
  },
  {
    label: "Gemini 3.6 Flash",
    value: "gemini-3.6-flash"
  },
  {
    label: "DeepSeek Chat",
    value: "deepseek-chat"
  }
];
const TRANSCRIPTION_MODEL_OPTIONS$1 = [{
  label: "Gemini 3.1 Pro (default)",
  value: "gemini-3.1-pro-preview"
}, {
  label: "Gemini 3.6 Flash",
  value: "gemini-3.6-flash"
}];
const ModelSelector = ({
  value,
  onChange,
  options = DEFAULT_MODEL_OPTIONS,
  listId,
  placeholder,
  className
}) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("input", {
      type: "text",
      list: listId,
      value,
      onChange: (e) => onChange(e.target.value),
      placeholder: placeholder || "Model name",
      title: "Pick a preset or type any model name",
      className: className || "text-xs border border-gray-300 rounded px-1.5 py-0.5 w-40"
    }), /* @__PURE__ */ jsx("datalist", {
      id: listId,
      children: options.map((opt) => /* @__PURE__ */ jsx("option", {
        value: opt.value,
        children: opt.label
      }, opt.value))
    })]
  });
};

const useAgenticSearchSSE = ({
  enabled,
  path = "/search-agent/sse/search"
} = {}) => {
  const [params, setParams] = useState({});
  const [counter, setCounter] = useState(0);
  const {
    circleId,
    question,
    language = "en",
    requestId: providedRequestId,
    itemCount,
    minRounds,
    model,
    verbose
  } = params;
  const api = useApi();
  const jwt = useJwt();
  const [status, setStatus] = useState(null);
  const [rounds, setRounds] = useState([]);
  const [aiResponse, setAiResponse] = useState("");
  const [isComplete, setIsComplete] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  const [failure, setFailure] = useState(null);
  const {
    logs,
    reset: resetLogs,
    handler: logHandler
  } = useSSELogs();
  const requestId = useMemo(() => {
    return providedRequestId || ulid();
  }, [providedRequestId, counter]);
  const url = useMemo(() => {
    if (!counter || !jwt) {
      return null;
    }
    const queryParams = {
      token: jwt,
      circleId,
      question,
      lang: language,
      requestId
    };
    if (itemCount) {
      queryParams.itemCount = String(itemCount);
    }
    if (minRounds) {
      queryParams.minRounds = String(minRounds);
    }
    if (model) {
      queryParams.model = model;
    }
    if (verbose) {
      queryParams.verbose = true;
    }
    return api.buildUrl(path, queryParams);
  }, [counter, api, jwt, question, circleId, language, requestId, itemCount, minRounds, model, verbose]);
  const {
    isConnected,
    disconnect,
    error: sseError,
    reconnect
  } = useSSEConnection({
    url: url || "",
    enabled: counter > 0 && !!url && enabled,
    dependencies: [counter],
    onOpen: () => {
      setStatus(null);
      setIsComplete(false);
      setConnectionError(null);
      setFailure(null);
      setRounds([]);
      setAiResponse("");
      resetLogs();
    },
    onError: (err) => {
      console.error("Agentic search SSE error:", err);
      setConnectionError(new Error("Connection error"));
    },
    onClose: () => {
      setStatus(null);
    }
  }, [{
    event: "status",
    handler: (data) => {
      setStatus(data.message);
    }
  }, {
    event: "meta",
    handler: (data) => {
      setRounds((prev) => {
        const idx = prev.findIndex((r) => r.round === data.round);
        const entry = {
          round: data.round,
          header: data.header,
          final: data.final,
          modelUsed: data.modelUsed,
          chunkContent: data.chunkContent,
          bodyMarkdown: data.bodyMarkdown,
          fullPrompt: data.fullPrompt
        };
        if (idx === -1) {
          return [...prev, entry];
        }
        const next = [...prev];
        next[idx] = entry;
        return next;
      });
    }
  }, {
    event: "delta",
    handler: (data) => {
      setAiResponse((prev) => prev + data.chunk);
    }
  }, {
    event: "complete",
    handler: (data) => {
      setStatus(data.message);
      setIsComplete(true);
      if (data.aiResponse) {
        setAiResponse(data.aiResponse);
      }
      setTimeout(() => disconnect(), 100);
    }
  }, logHandler, {
    event: "failed",
    handler: (data) => {
      setFailure(new Error(data.message || data.error || "Agentic search failed"));
      setIsComplete(true);
    }
  }]);
  const search = useMemoizedFn((next) => {
    setParams(next);
    setCounter((c) => c + 1);
  });
  const searchLoading = isConnected && !isComplete;
  return {
    search,
    disconnect,
    reconnect,
    isConnected,
    isComplete,
    searchLoading,
    status,
    rounds,
    aiResponse,
    logs,
    connectionError: connectionError || sseError,
    failure
  };
};

const containerVariants$1 = cva("overflow-hidden rounded-md", {
  variants: {
    variant: {
      default: "border border-gray-200",
      bordered: "border border-gray-300",
      minimal: "border-0"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const headerVariants = cva("flex items-center justify-between cursor-pointer transition-colors", {
  variants: {
    variant: {
      default: "p-3 bg-white hover:bg-gray-50",
      bordered: "p-3 bg-white hover:bg-gray-100",
      minimal: "p-2 hover:bg-gray-50"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const contentVariants = cva("border-t", {
  variants: {
    variant: {
      default: "p-3 bg-gray-50 border-gray-200",
      bordered: "p-3 bg-gray-50 border-gray-300",
      minimal: "p-2 bg-white border-gray-200"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const CollapsibleListItem = ({
  header,
  children,
  defaultExpanded = false,
  variant,
  className,
  headerClassName,
  contentClassName,
  onToggle,
  icon = "chevron"
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const handleToggle = useMemoizedFn(() => {
    const newExpanded = !expanded;
    setExpanded(newExpanded);
    if (onToggle) {
      onToggle(newExpanded);
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    className: containerVariants$1({
      variant,
      className
    }),
    children: [/* @__PURE__ */ jsxs("div", {
      onClick: handleToggle,
      className: headerVariants({
        variant,
        className: headerClassName
      }),
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex-1 min-w-0",
        children: header
      }), icon === "chevron" && /* @__PURE__ */ jsx("svg", {
        className: `w-5 h-5 text-gray-400 transition-transform flex-shrink-0 ${expanded ? "rotate-180" : ""}`,
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        children: /* @__PURE__ */ jsx("path", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M19 9l-7 7-7-7"
        })
      })]
    }), expanded && /* @__PURE__ */ jsx("div", {
      className: contentVariants({
        variant,
        className: contentClassName
      }),
      children
    })]
  });
};

const EntityList = ({
  label,
  values
}) => {
  if (!values || values.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "mb-3",
    children: [/* @__PURE__ */ jsx("div", {
      className: "text-xs font-medium text-gray-500 mb-1",
      children: label
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-wrap gap-1",
      children: values.map((v) => /* @__PURE__ */ jsx("span", {
        className: "text-xs px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full",
        children: v
      }, v))
    })]
  });
};
const CHUNK_CONTENT_FOLD_LENGTH = 200;
const ChunkContentRow = ({
  text
}) => {
  const [expanded, setExpanded] = useState(false);
  const long = text.length > CHUNK_CONTENT_FOLD_LENGTH;
  const displayText = expanded || !long ? text : text.slice(0, CHUNK_CONTENT_FOLD_LENGTH) + "\u2026";
  return /* @__PURE__ */ jsx("tr", {
    className: "border-t border-gray-50",
    children: /* @__PURE__ */ jsxs("td", {
      colSpan: 3,
      className: "pb-2 pt-1 text-xs text-gray-500 whitespace-pre-wrap",
      dir: "auto",
      children: [displayText, long && /* @__PURE__ */ jsx("button", {
        onClick: () => setExpanded(!expanded),
        className: "ml-1 text-blue-600 hover:text-blue-700 underline",
        children: expanded ? "show less" : "show more"
      })]
    })
  });
};
const truncateId = (id) => id && id.length > 10 ? id.slice(0, 10) + "\u2026" : id || "\u2014";
const ChunkRefCell = ({
  chunkRef,
  content
}) => {
  const [expanded, setExpanded] = useState(false);
  if (!content) {
    return /* @__PURE__ */ jsx("span", {
      className: "font-mono",
      children: chunkRef
    });
  }
  const {
    postId,
    chunkId,
    rootPostId
  } = content;
  const hasRoot = rootPostId && rootPostId !== postId;
  return /* @__PURE__ */ jsxs("button", {
    type: "button",
    onClick: () => setExpanded(!expanded),
    className: "font-mono text-left hover:underline",
    children: [/* @__PURE__ */ jsxs("div", {
      children: [truncateId(postId), typeof chunkId === "number" && /* @__PURE__ */ jsxs("span", {
        className: "text-gray-400",
        children: [" \xA7", chunkId]
      })]
    }), expanded && /* @__PURE__ */ jsxs("div", {
      className: "mt-1 font-normal text-gray-400 space-y-0.5",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["ref: ", chunkRef]
      }), /* @__PURE__ */ jsxs("div", {
        children: ["page: ", postId]
      }), hasRoot && /* @__PURE__ */ jsxs("div", {
        children: ["root: ", rootPostId]
      })]
    })]
  });
};
const AgentRoundDetailsDialog = ({
  round,
  onClose
}) => {
  const header = round && round.header;
  const title = round ? "Round " + (round.round + 1) + " details" : "";
  return /* @__PURE__ */ jsxs(Dialog$3, {
    isOpen: !!round,
    onClose,
    title,
    size: "md",
    children: [!header && /* @__PURE__ */ jsx("div", {
      className: "p-4 text-sm text-gray-500",
      children: "No structured header for this round \u2014 the model's output didn't parse as valid JSON (see headerParseError server-side)."
    }), header && /* @__PURE__ */ jsxs("div", {
      className: "p-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "mb-3",
        children: [/* @__PURE__ */ jsx("div", {
          className: "text-xs font-medium text-gray-500 mb-1",
          children: "Intent"
        }), /* @__PURE__ */ jsxs("div", {
          className: "text-sm text-gray-800",
          children: [header.intent, " \u2014 ", header.intentSummary]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "mb-3",
        children: [/* @__PURE__ */ jsx("div", {
          className: "text-xs font-medium text-gray-500 mb-1",
          children: "Sufficiency"
        }), /* @__PURE__ */ jsxs("div", {
          className: "text-sm text-gray-800",
          children: [header.sufficiency, header.sufficiency === "search_more" && header.followupQueries.length > 0 && /* @__PURE__ */ jsxs("span", {
            className: "text-gray-500",
            children: [" ", "\u2192 next: ", header.followupQueries.join(", ")]
          })]
        }), header.sufficiency === "search_more" && header.rephrasedQuestion && /* @__PURE__ */ jsxs("div", {
          className: "text-sm text-gray-800 mt-1",
          children: [/* @__PURE__ */ jsx("span", {
            className: "text-gray-500",
            children: "rephrased as: "
          }), header.rephrasedQuestion]
        })]
      }), /* @__PURE__ */ jsx(EntityList, {
        label: "Persons",
        values: header.persons
      }), /* @__PURE__ */ jsx(EntityList, {
        label: "Locations",
        values: header.locations
      }), /* @__PURE__ */ jsx(EntityList, {
        label: "Organizations",
        values: header.organizations
      }), /* @__PURE__ */ jsx(EntityList, {
        label: "Categories",
        values: header.categoryCodes
      }), header.dateRange && (header.dateRange.from || header.dateRange.to) && /* @__PURE__ */ jsxs("div", {
        className: "mb-3",
        children: [/* @__PURE__ */ jsx("div", {
          className: "text-xs font-medium text-gray-500 mb-1",
          children: "Date range"
        }), /* @__PURE__ */ jsxs("div", {
          className: "text-sm text-gray-800",
          children: [header.dateRange.from || "\u2026", " to ", header.dateRange.to || "\u2026"]
        })]
      }), header.chunkScores.length > 0 && /* @__PURE__ */ jsxs("div", {
        className: "mb-3",
        children: [/* @__PURE__ */ jsx("div", {
          className: "text-xs font-medium text-gray-500 mb-1",
          children: "Chunk scores"
        }), /* @__PURE__ */ jsxs("table", {
          className: "w-full text-xs",
          children: [/* @__PURE__ */ jsx("thead", {
            children: /* @__PURE__ */ jsxs("tr", {
              className: "text-left text-gray-400",
              children: [/* @__PURE__ */ jsx("th", {
                className: "pr-2 py-1",
                children: "Ref"
              }), /* @__PURE__ */ jsx("th", {
                className: "pr-2 py-1",
                children: "Score"
              }), /* @__PURE__ */ jsx("th", {
                className: "py-1",
                children: "Reason"
              })]
            })
          }), /* @__PURE__ */ jsx("tbody", {
            children: header.chunkScores.map((cs) => {
              const content = round.chunkContent && round.chunkContent[cs.ref];
              return /* @__PURE__ */ jsxs(Fragment$1, {
                children: [/* @__PURE__ */ jsxs("tr", {
                  className: "border-t border-gray-100",
                  children: [/* @__PURE__ */ jsx("td", {
                    className: "pr-2 py-1 align-top",
                    children: /* @__PURE__ */ jsx(ChunkRefCell, {
                      chunkRef: cs.ref,
                      content
                    })
                  }), /* @__PURE__ */ jsx("td", {
                    className: "pr-2 py-1",
                    children: cs.score.toFixed(2)
                  }), /* @__PURE__ */ jsx("td", {
                    className: "py-1 text-gray-600",
                    children: cs.reason || "\u2014"
                  })]
                }), content && /* @__PURE__ */ jsx(ChunkContentRow, {
                  text: content.text
                })]
              }, cs.ref);
            })
          })]
        })]
      }), round.bodyMarkdown && /* @__PURE__ */ jsxs("div", {
        className: "mb-3",
        children: [/* @__PURE__ */ jsx("div", {
          className: "text-xs font-medium text-gray-500 mb-1",
          children: "Answer"
        }), /* @__PURE__ */ jsx("div", {
          className: "text-sm text-gray-800",
          dir: "auto",
          dangerouslySetInnerHTML: {
            __html: round.bodyMarkdown
          }
        })]
      }), round.fullPrompt && /* @__PURE__ */ jsx(CollapsibleListItem, {
        header: /* @__PURE__ */ jsx("span", {
          className: "text-xs font-medium text-gray-500",
          children: "Full LLM prompt"
        }),
        children: /* @__PURE__ */ jsx("pre", {
          className: "text-xs whitespace-pre-wrap break-words",
          dir: "auto",
          children: round.fullPrompt
        })
      })]
    })]
  });
};

const sufficiencyBadge = (round) => {
  if (!round.header) {
    return {
      label: "no header",
      className: "bg-gray-100 text-gray-500"
    };
  }
  return round.header.sufficiency === "answer" ? {
    label: "answered",
    className: "bg-green-100 text-green-700"
  } : {
    label: "searching more",
    className: "bg-amber-100 text-amber-700"
  };
};
const logLevelBadgeClass = (level) => {
  switch (level) {
    case "error":
      return "bg-red-100 text-red-700";
    case "warn":
      return "bg-amber-100 text-amber-700";
    case "debug":
      return "bg-gray-100 text-gray-500";
    default:
      return "bg-blue-100 text-blue-700";
  }
};
const buildInvestigationTrace = (params) => {
  const {
    circleId,
    question,
    itemCount,
    minRounds,
    model,
    isComplete,
    aiResponse,
    failure,
    rounds,
    logs
  } = params;
  const parsedItemCount = parseInt(itemCount, 10);
  const parsedMinRounds = parseInt(minRounds, 10);
  return {
    circleId,
    question,
    itemCountOverride: parsedItemCount > 0 ? parsedItemCount : void 0,
    minRoundsOverride: parsedMinRounds > 0 ? parsedMinRounds : void 0,
    modelOverride: model || void 0,
    isComplete,
    failure: failure ? failure.message : void 0,
    aiResponse,
    rounds,
    logs
  };
};
const AgentInvestigationPanel = ({
  circleId,
  question
}) => {
  const isInstanceAdmin = useIsInstanceAdmin();
  const [selectedRound, setSelectedRound] = useState(null);
  const [itemCount, setItemCount] = useState("5");
  const [minRounds, setMinRounds] = useState("2");
  const [model, setModel] = useState("");
  const [copied, setCopied] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const {
    search,
    rounds,
    isComplete,
    aiResponse,
    failure,
    searchLoading,
    logs
  } = useAgenticSearchSSE();
  if (!isInstanceAdmin) {
    return null;
  }
  const onInvestigate = () => {
    if (!question || !question.trim() || !circleId) {
      return;
    }
    const parsedItemCount = parseInt(itemCount, 10);
    const parsedMinRounds = parseInt(minRounds, 10);
    search({
      circleId,
      question,
      itemCount: parsedItemCount > 0 ? parsedItemCount : void 0,
      minRounds: parsedMinRounds > 0 ? parsedMinRounds : void 0,
      model: model.trim() ? model.trim() : void 0,
      verbose: true
    });
  };
  const onCopyTrace = async () => {
    if (!navigator.clipboard) {
      return;
    }
    const trace = buildInvestigationTrace({
      circleId,
      question,
      itemCount,
      minRounds,
      model,
      isComplete,
      aiResponse,
      failure,
      rounds,
      logs
    });
    try {
      await navigator.clipboard.writeText(JSON.stringify(trace, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
    }
  };
  const errorLog = [...logs].reverse().find((log) => log.level === "error");
  return /* @__PURE__ */ jsxs("div", {
    className: "mt-4 border border-dashed border-gray-300 rounded-md p-3 bg-gray-50",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between mb-2",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-xs font-medium text-gray-500 uppercase tracking-wide",
        children: "Agent investigation (instance admin only)"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx(ModelSelector, {
          value: model,
          onChange: setModel,
          listId: "agent-investigation-model-options",
          placeholder: "model (default)",
          className: "w-32 text-xs border border-gray-300 rounded px-1.5 py-0.5"
        }), /* @__PURE__ */ jsx("input", {
          type: "number",
          min: 1,
          value: itemCount,
          onChange: (e) => setItemCount(e.target.value),
          placeholder: "items/round",
          title: "Override items retrieved per round (blank = circle default)",
          className: "w-20 text-xs border border-gray-300 rounded px-1.5 py-0.5"
        }), /* @__PURE__ */ jsx("input", {
          type: "number",
          min: 1,
          value: minRounds,
          onChange: (e) => setMinRounds(e.target.value),
          placeholder: "min rounds",
          title: "Override guaranteed minimum rounds before stopping (blank = server default)",
          className: "w-20 text-xs border border-gray-300 rounded px-1.5 py-0.5"
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          size: "sm",
          onClick: onInvestigate,
          disabled: searchLoading,
          children: searchLoading ? /* @__PURE__ */ jsx(Spinner, {
            size: "xs"
          }) : "Investigate with agent"
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          size: "sm",
          onClick: onCopyTrace,
          disabled: rounds.length === 0 && !failure,
          children: copied ? "Copied!" : "Copy trace"
        })]
      })]
    }), failure && /* @__PURE__ */ jsxs("div", {
      className: "mb-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "text-xs text-red-600",
        children: failure.message
      }), errorLog && errorLog.data && errorLog.data.details && /* @__PURE__ */ jsx("pre", {
        className: "mt-1 text-[10px] text-red-700 bg-red-50 border border-red-200 rounded p-2 overflow-x-auto whitespace-pre-wrap",
        children: errorLog.data.details.join("\n")
      })]
    }), rounds.length > 0 && /* @__PURE__ */ jsx("ul", {
      className: "flex flex-col gap-1",
      children: rounds.map((round) => {
        const badge = sufficiencyBadge(round);
        const followupQueries = round.header ? round.header.followupQueries : [];
        const rephrasedQuestion = round.header ? round.header.rephrasedQuestion : null;
        const nextRoundQueries = rephrasedQuestion ? [...followupQueries, rephrasedQuestion] : followupQueries;
        return /* @__PURE__ */ jsxs("li", {
          children: [/* @__PURE__ */ jsxs("button", {
            onClick: () => setSelectedRound(round),
            className: "w-full flex items-center justify-between gap-2 px-2 py-1.5 bg-white border border-gray-200 rounded text-left hover:bg-gray-50 transition-colors",
            children: [/* @__PURE__ */ jsxs("span", {
              className: "text-xs text-gray-700 truncate",
              children: ["Round ", round.round + 1, round.header ? ": " + round.header.intentSummary : ""]
            }), round.modelUsed && /* @__PURE__ */ jsx("span", {
              className: "text-[10px] text-gray-400 shrink-0",
              children: round.modelUsed
            }), /* @__PURE__ */ jsx("span", {
              className: "text-[10px] px-1.5 py-0.5 rounded shrink-0 " + badge.className,
              children: badge.label
            })]
          }), nextRoundQueries.length > 0 && /* @__PURE__ */ jsxs("div", {
            className: "flex flex-wrap items-center gap-1 mt-1 px-2",
            children: [/* @__PURE__ */ jsx("span", {
              className: "text-[10px] text-gray-400",
              children: "next \u2192"
            }), followupQueries.map((q) => /* @__PURE__ */ jsx("span", {
              className: "text-[10px] px-1.5 py-0.5 bg-amber-50 text-amber-700 rounded-full",
              children: q
            }, q)), rephrasedQuestion && /* @__PURE__ */ jsxs("span", {
              className: "text-[10px] px-1.5 py-0.5 bg-blue-50 text-blue-700 rounded-full",
              children: ["rephrased: ", rephrasedQuestion]
            }, rephrasedQuestion)]
          })]
        }, round.round);
      })
    }), isComplete && rounds.length === 0 && !failure && /* @__PURE__ */ jsx("div", {
      className: "text-xs text-gray-400",
      children: "No rounds recorded."
    }), logs.length > 0 && /* @__PURE__ */ jsxs("div", {
      className: "mt-2",
      children: [/* @__PURE__ */ jsxs("button", {
        onClick: () => setShowLogs((v) => !v),
        className: "text-[10px] text-gray-500 hover:text-gray-700 underline",
        children: [showLogs ? "Hide" : "Show", " logs (", logs.length, ")"]
      }), showLogs && /* @__PURE__ */ jsx("ul", {
        className: "mt-1 flex flex-col gap-0.5 max-h-64 overflow-y-auto border border-gray-200 rounded bg-white p-1.5",
        children: logs.map((log, i) => /* @__PURE__ */ jsxs("li", {
          className: "text-[10px] font-mono flex items-start gap-1.5",
          children: [/* @__PURE__ */ jsx("span", {
            className: "text-gray-400 shrink-0",
            children: new Date(log.timestamp).toLocaleTimeString()
          }), /* @__PURE__ */ jsx("span", {
            className: "px-1 rounded shrink-0 " + logLevelBadgeClass(log.level),
            children: log.level
          }), /* @__PURE__ */ jsx("span", {
            className: "text-gray-600 break-all",
            children: log.message
          })]
        }, i))
      })]
    }), /* @__PURE__ */ jsx(AgentRoundDetailsDialog, {
      round: selectedRound,
      onClose: () => setSelectedRound(null)
    })]
  });
};

const SearchHelp$1 = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("li", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "chat.search1"
      })
    }), /* @__PURE__ */ jsx("li", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "chat.search2"
      })
    }), /* @__PURE__ */ jsx("li", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "chat.search3"
      })
    })]
  });
};
const VectorSearchSSEResultsPanel = () => {
  const {
    found,
    prompt,
    aiResponse,
    circleId,
    isAIMode,
    isSearchMode,
    searchLoading,
    analyses: analysesMarked,
    error
  } = useCircleSearchSSEContext();
  const {
    parse
  } = useMarked();
  const analyses = useMemo(() => parse && analysesMarked ? parse(analysesMarked) : "", [parse, analysesMarked]);
  const ref = useRef(null);
  useEffect(() => {
    if (!found || !isSearchMode) {
      return;
    }
    ref.current.scrollIntoView({
      behavior: "smooth"
    });
  }, [isSearchMode, found]);
  return /* @__PURE__ */ jsxs("div", {
    className: "text-sm sm:text-base flex flex-col gap-2 w-full",
    ref,
    children: [!prompt && /* @__PURE__ */ jsx("p", {
      className: "p-2",
      children: /* @__PURE__ */ jsx(SearchHelp$1, {})
    }), aiResponse && isAIMode && /* @__PURE__ */ jsx("div", {
      className: "bg-[#00A5B6] p-2 rounded-lg font-semibold text-white m-1",
      dir: "auto",
      children: "AI analysis of the Search results"
    }), analyses && isAIMode && /* @__PURE__ */ jsx(TinyContent, {
      className: "bg-white p-4 rounded border border-indigo-200 overflow-auto markdown-content mce-content-body",
      dir: "auto",
      dangerouslySetInnerHTML: {
        __html: analyses
      }
    }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error
    }), searchLoading && /* @__PURE__ */ jsx("div", {
      className: "relative h-5",
      children: /* @__PURE__ */ jsx(MuiSpinner, {
        timeout: 0
      })
    }), /* @__PURE__ */ jsx(VectorSearchResultsList, {}), /* @__PURE__ */ jsx(AgentInvestigationPanel, {
      circleId,
      question: prompt
    })]
  });
};

const AIArea = () => {
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-2 items-center w-full",
    "data-testid": "AIArea",
    children: /* @__PURE__ */ jsx(VectorSearchSSEResultsPanel, {})
  });
};

const useTabs = () => {
  const {
    isSearchMode,
    aiSearch
  } = useCircleSearchSSEContext();
  const tabs = useCreation(() => {
    const tabs2 = [isSearchMode && aiSearch && {
      title: "AI",
      icon: CairIcon,
      component: AIArea,
      id: "ai"
    }, {
      title: "AI Chat",
      icon: CairIcon,
      url: (circleId) => `/trans/ai-chat/${circleId}`,
      id: "ai-chat",
      hidden: true
    }, {
      title: "Chat",
      iconComponent: BsChatDots,
      url: (circleId) => `/trans/circle-chat/${circleId}`,
      id: "chat",
      hidden: true
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.tabs.all"
      }),
      icon: allPosts,
      component: PostsArea,
      id: "all"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.tabs.discussions"
      }),
      icon: Discussions,
      component: DiscussionsArea,
      id: "discussions"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.tabs.meetings"
      }),
      icon: Events,
      component: EventsArea,
      id: "meetings"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.tabs.articles"
      }),
      icon: Article,
      component: ArticlesArea,
      id: "articles"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.tabs.references"
      }),
      icon: References,
      component: ReferencesArea,
      id: "references"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.tabs.subCircles"
      }),
      icon: Subcircles,
      component: CirclesArea,
      id: "subCircles"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "navigation.home/activity"
      }),
      iconComponent: FaRegBell,
      className: "lg:hidden",
      component: ActivitiesArea,
      id: "activity"
    }, {
      title: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "group.tabs.map"
      }),
      iconComponent: LiaMapMarkedAltSolid,
      component: GoogleMapArea,
      id: "map"
    }].filter((v) => v);
    tabs2.forEach((tab, order) => {
      tab.order = order;
    });
    return tabs2;
  }, [isSearchMode && aiSearch]);
  return {
    tabs
  };
};
const Tabs$1 = () => {
  const {
    circle
  } = useCircleContext();
  const [tabs] = useConfiguredTabs();
  if (!circle || !tabs) {
    return null;
  }
  return /* @__PURE__ */ jsx(TabsInner, {
    tabs
  });
};
const useSetPostViewUrlFn = () => {
  const params = useQueryStringParams();
  return useMemoizedFn((postId) => {
    setQueryStringParams({
      ...params,
      map_post: postId
    });
  });
};
const useTabUrl = () => {
  const params = useQueryStringParams();
  const setTabUrl = useMemoizedFn((name) => {
    setQueryStringParams({
      ...params,
      tab: name
    });
  });
  const setPostUrl = useSetPostViewUrlFn();
  return {
    post: params.map_post,
    tab: params.tab,
    setTabUrl,
    setPostUrl
  };
};
const TabsInner = ({
  tabs
}) => {
  const {
    isSearchMode,
    aiSearch,
    counter
  } = useCircleSearchSSEContext();
  const {
    tab: tabIdFromUrl,
    setTabUrl
  } = useTabUrl();
  const tabBeforeAIRef = useRef();
  const history = useHistory();
  useEffect(() => {
    if (counter) {
      tabBeforeAIRef.current = selectedTabId;
      setTabUrl("ai");
    } else {
      setTabUrl(defaultTabId());
    }
  }, [counter]);
  useEffect(() => {
    if (isSearchMode && aiSearch) {
      tabBeforeAIRef.current = selectedTabId;
      setTabUrl("ai");
    } else {
      setTabUrl(tabBeforeAIRef.current || defaultTabId());
    }
  }, [isSearchMode && aiSearch]);
  const {
    currentFilterRef,
    filter$
  } = useSearchContext();
  filter$.useSubscription(() => {
    if (currentFilterRef.current && selectedTabId === "subCircles") {
      setTabUrl("all");
    }
  });
  const defaultTabId = useMemoizedFn(() => {
    const found = tabs.find((t) => t.defaultActive);
    return !found ? "all" : found.id;
  });
  const idFromUrlOrDefault = useMemoizedFn(() => {
    if (tabIdFromUrl) {
      return tabIdFromUrl;
    }
    return defaultTabId();
  });
  const [selectedTabId, setSelectedTabId] = useState(() => {
    return idFromUrlOrDefault();
  });
  const {
    id
  } = useCircleContext();
  useEffect(() => {
    setSelectedTabId(idFromUrlOrDefault());
  }, [id, tabIdFromUrl, tabs]);
  const renderContentArea = () => {
    const found = tabs.find((v) => v.id === selectedTabId) || tabs.find((v) => v.id === "all");
    const Component = found.component;
    if (found.url) {
      return /* @__PURE__ */ jsx("div", {
        children: "Chat could not be the default page!!!!!!!!!"
      });
    }
    return /* @__PURE__ */ jsx(Component, {});
  };
  const toggleTab = (index, tab) => {
    if (tab.url) {
      history.push(tab.url(id));
      return;
    }
    setTabUrl(index);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "lg:px-2 flex max-w-full overflow-x-scroll gap-2 sm:gap-4 w-full pr-6 items-center justify-between border-b-2 border-gray-300 scrollbar-hide p-1 self-stretch",
      children: tabs.map((tab, index) => {
        if (tab.hidden) {
          return null;
        }
        return /* @__PURE__ */ jsx(TabItem, {
          title: tab.title,
          icon: tab.icon,
          iconComponent: tab.iconComponent,
          active: selectedTabId === tab.id,
          className: tab.className,
          onClick: () => {
            toggleTab(tab.id, tab);
          }
        }, index);
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "pb-4",
      children: renderContentArea()
    })]
  });
};

const canUserEditPostMetadata = (profile, post, membership) => {
  if (!post || !profile || !membership) {
    return false;
  }
  if (isAuthor(post, profile)) {
    return true;
  }
  if (!isAdmin(membership)) {
    return false;
  }
  return true;
};
const canUserEditPost = (profile, post, membership) => {
  if (!post || !profile || !membership) {
    return false;
  }
  if (isAuthor(post, profile)) {
    return true;
  }
  if (!isAdmin(membership)) {
    return false;
  }
  return post.authorGroupRole === "ADMIN" || post.type === "asset";
};
const canUserAnnounceEvent = (profile, post, membership) => {
  if (!post || !profile || !membership) {
    return false;
  }
  if (isAuthor(post, profile)) {
    return true;
  }
  if (isAdmin(membership)) {
    return true;
  }
  return false;
};
const PostViewNavigation = () => {
  const {
    dialog
  } = usePostUIContext();
  if (dialog) {
    return /* @__PURE__ */ jsx(PostViewNavigationDialog, {});
  }
  return /* @__PURE__ */ jsx(PostViewNavigationInner, {});
};
const PostViewNavigationDialog = () => {
  const {
    post,
    membership,
    profile
  } = usePostInfoContext();
  const {
    onEditClick
  } = useOnEditClickFn();
  const canEdit = canUserEditPost(profile, post, membership);
  const {
    setPostUrl
  } = useTabUrl();
  const closeDialog = () => {
    setPostUrl(void 0);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-1 sm:gap-6 sm:justify-start items-center w-full bg-white shadow-lg px-[9px] relative ",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      onClick: closeDialog,
      children: /* @__PURE__ */ jsx(MdClose, {})
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-grow"
    }), /* @__PURE__ */ jsx(ShareIconButton, {
      response: post
    }), canEdit && /* @__PURE__ */ jsx(IconButton$5, {
      onClick: () => onEditClick(post),
      children: /* @__PURE__ */ jsx(MdEdit, {})
    }), /* @__PURE__ */ jsx(PostVotingIcon, {}), /* @__PURE__ */ jsx(OpenHelpButton$2, {}), /* @__PURE__ */ jsx(ProfileIcon, {}), /* @__PURE__ */ jsx(PostsOverflow, {})]
  });
};
const PostViewNavigationInner = () => {
  const history = useHistory();
  const {
    post,
    membership,
    profile
  } = usePostInfoContext();
  const {
    onEditClick
  } = useOnEditClickFn();
  const canEdit = canUserEditPost(profile, post, membership);
  const canEditMetadata = canUserEditPostMetadata(profile, post, membership);
  const {
    isSearchMode
  } = useCircleSearchSSEContext();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex  gap-1 sm:gap-6 sm:justify-start items-center w-full bg-white shadow-lg px-[9px] relative ",
      style: {
        boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
      },
      "data-testid": "PostViewNavigation",
      children: [/* @__PURE__ */ jsx("div", {
        className: "block",
        children: /* @__PURE__ */ jsx(HamburgerMenu, {})
      }), /* @__PURE__ */ jsx(SearchInput, {
        noSimpleSearch: true
      }), /* @__PURE__ */ jsx(GoingPopupButton$1, {}), /* @__PURE__ */ jsx("div", {
        className: "flex-grow"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex justify-end items-center relative  gap-1 sm:gap-6",
        children: [/* @__PURE__ */ jsx(LanguageSelectionMenu, {}), /* @__PURE__ */ jsx(LikeButton, {
          post,
          variant: "post",
          membership
        }), /* @__PURE__ */ jsx(ShareIconButton, {
          response: post
        }), canEditMetadata && /* @__PURE__ */ jsx(IconButton$5, {
          onClick: () => history.push(editMetadataUrl(post)),
          children: /* @__PURE__ */ jsx(HiTag, {})
        }), canEdit && /* @__PURE__ */ jsx(IconButton$5, {
          onClick: () => onEditClick(post),
          children: /* @__PURE__ */ jsx(MdEdit, {})
        }), /* @__PURE__ */ jsx(PostVotingIcon, {}), /* @__PURE__ */ jsx(OpenHelpButton$2, {}), /* @__PURE__ */ jsx(ProfileIcon, {}), /* @__PURE__ */ jsx(PostsOverflow, {})]
      })]
    }), isSearchMode && /* @__PURE__ */ jsx(VectorSearchSSEResultsPanel, {})]
  });
};
const OpenHelpButton$2 = () => {
  const {
    data: profile
  } = useProfile();
  const {
    post
  } = usePostInfoContext();
  const page = post ? post.type : "post";
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(HelpContextProvider, {
      page,
      profile,
      children: /* @__PURE__ */ jsx(WelcomeToPageButton, {
        button: (props) => /* @__PURE__ */ jsx(StyledButton, {
          className: "group relative",
          icon: IoMdHelpCircleOutline,
          ...props,
          children: /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.help"
            })
          })
        })
      })
    })
  });
};

const useCirclePostItems = () => {
  const history = useHistory();
  const {
    onClick: sendReminder
  } = useSendInvitation();
  const {
    circle: group,
    profile,
    membership
  } = useCircleContext();
  const {
    onMove,
    setOutcome,
    onEditClick,
    setDuplicated,
    setExported
  } = useCircleModalDialogsContext();
  const api = useApi();
  const onShowCloseDialog = (target) => {
    setOutcome(target);
  };
  const handleUnpublishAsAdmin = (target) => {
    handleUnpublish({
      ...target,
      as_admin: true
    });
  };
  const handleUnpublish = errorsReported(async (target) => {
    await api.unpublishPost(target);
    window.location.reload();
  });
  const handlePinIntro = errorsReported(async (target) => {
    await api.pinIntroToGroup({
      group: group._id,
      post: target._id
    });
    window.location.reload();
  });
  const renderOverflowMenu = (target) => {
    if (!group) {
      return null;
    }
    const items = [];
    const forTarget = (f) => () => {
      f(target);
    };
    if (membership && target.type === "article") {
      items.push(/* @__PURE__ */ jsx(MenuItem, {
        onClick: forTarget(setExported),
        children: "Export"
      }, "export"));
    }
    if (canUserEditPost(profile, target, membership)) {
      items.push(/* @__PURE__ */ jsx(MenuItem, {
        onClick: forTarget(onEditClick),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "posts.edit"
        })
      }, "edit"));
    }
    if (canUserEditPostMetadata(profile, target, membership)) {
      items.push(/* @__PURE__ */ jsx(MenuItem, {
        onClick: forTarget((post) => history.push(editMetadataUrl(post))),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "posts.edit_metadata"
        })
      }, "edit"));
      items.push(/* @__PURE__ */ jsx(MenuItem, {
        onClick: forTarget((post) => history.push("/trans/admin/translate-post/" + post._id)),
        children: "Translate"
      }, "edit"));
    }
    if (isAuthor(target, profile)) {
      items.push(/* @__PURE__ */ jsx(MenuItem, {
        onClick: forTarget(handleUnpublish),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "posts.unpublish"
        })
      }, "unpublish"));
    }
    if (isAdmin(membership) && !group.closed) {
      items.push(/* @__PURE__ */ jsx(MenuItem, {
        onClick: forTarget(onShowCloseDialog),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "posts.pin_and_close_group"
        })
      }, "close"));
      items.push(/* @__PURE__ */ jsx(MenuItem, {
        onClick: forTarget(handlePinIntro),
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "posts.pin_as_group_intro"
        })
      }, "intro"));
      if (!isAuthor(target, profile)) {
        items.push(/* @__PURE__ */ jsx(MenuItem, {
          onClick: forTarget(handleUnpublishAsAdmin),
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "posts.unpublish"
          })
        }, "unpublish"));
      }
      if (target.type === "discussion" || target.type === "event") {
        const template = target.type === "discussion" ? "discussion-reminder" : "events-reminder";
        items.push(/* @__PURE__ */ jsx(MenuItem, {
          onClick: () => sendReminder({
            template,
            post: target
          }),
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "posts.send_reminder"
          })
        }, "close"));
      }
      if (target.type === "asset") {
        items.push(/* @__PURE__ */ jsx(MenuItem, {
          onClick: forTarget(onMove),
          children: "Move the asset.."
        }, "move"));
      }
      if (isAuthor(target, profile) || isAdmin(membership) && !group.closed) {
        items.push(/* @__PURE__ */ jsx(MenuItem, {
          onClick: forTarget(setDuplicated),
          children: "Duplicate Post"
        }, "duplicate"));
      }
    }
    return /* @__PURE__ */ jsx(Fragment, {
      children: items
    });
  };
  return {
    render: renderOverflowMenu
  };
};
const OpenStartNewEventMenuItem = ({
  post,
  profile,
  membership,
  circle
}) => {
  const postId = post._id;
  const canEdit = canUserAnnounceEvent(profile, post, membership) && (!circle || !circle.closed);
  if (!canEdit || post.type === "asset") {
    return null;
  }
  return /* @__PURE__ */ jsx("a", {
    href: "/trans/post-connect-asset/" + postId,
    target: "_blank",
    children: /* @__PURE__ */ jsx(MenuItem, {
      children: "Announce Event for this Post"
    }, "connect asset")
  });
};

const DownloadCalendarMenuItem = ({
  createEvent
}) => {
  const {
    post
  } = usePostContext();
  if (!post || post.type !== "event") {
    return null;
  }
  const onCalendar = (e) => {
    if (!isExpoWrapper()) {
      return;
    }
    e.preventDefault();
    const event = new EventData(post);
    const eventData = {
      title: post.title,
      startDate: event.localStartTime,
      alarms: [{
        relativeOffset: -10
      }],
      endDate: event.localEndTime
    };
    createEvent(eventData);
  };
  return /* @__PURE__ */ jsxs(MenuItem, {
    component: "a",
    href: postCalendarLink(post),
    target: "_blank",
    onClick: onCalendar,
    children: [/* @__PURE__ */ jsx(ListItemIcon, {
      children: /* @__PURE__ */ jsx(IconButton$5, {
        "aria-label": "download calendar file",
        color: "inherit",
        children: /* @__PURE__ */ jsx(CalendarIcon, {})
      })
    }), "Add to my calendar"]
  });
};
const FlagPostMenuItem = ({
  response
}) => {
  const api = useApi();
  const {
    loadResponses,
    profile,
    loadPost,
    post: rootPost
  } = usePostInfoContext();
  const post = response || rootPost;
  if (!post || post.flagged || isAuthor(post, profile)) {
    return null;
  }
  const flagPost = errorsReported(async () => {
    await api.makeRequest({
      path: `/posts/${post._id}/flag`,
      method: "POST"
    });
    const reload = response ? loadResponses : loadPost;
    await reload();
  });
  return /* @__PURE__ */ jsxs(MenuItem, {
    onClick: flagPost,
    children: [/* @__PURE__ */ jsx(ListItemIcon, {
      children: /* @__PURE__ */ jsx(IconButton$5, {
        "aria-label": "report inappropriate content",
        color: "inherit",
        children: /* @__PURE__ */ jsx(MdOutlineReport, {})
      })
    }), /* @__PURE__ */ jsx(FormattedMessage, {
      id: `toolbars.report`
    })]
  });
};
const useUnFlagPost = (response) => {
  const {
    membership,
    loadResponses,
    post: rootPost,
    loadPost
  } = usePostInfoContext();
  const post = response || rootPost;
  const api = useApi();
  const {
    onClick,
    loading
  } = useLoading(errorsReported(async () => {
    await api.makeRequest({
      path: `/posts/${post._id}/remove-flag`,
      method: "POST"
    });
    const reload = response ? loadResponses : loadPost;
    await reload();
  }));
  return {
    onClick,
    disabled: !isAdmin(membership),
    loading,
    flagged: post && post.flagged
  };
};
const UnFlagPostMenuItem = ({
  response
}) => {
  const {
    onClick,
    disabled,
    flagged
  } = useUnFlagPost(response);
  if (!flagged) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    disabled,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "post.unflag"
    })
  });
};
const MenuContent = ({
  onClick,
  createEvent
}) => {
  return /* @__PURE__ */ jsx(Paper, {
    onClick,
    children: /* @__PURE__ */ jsxs(MenuList, {
      children: [/* @__PURE__ */ jsx(DownloadCalendarMenuItem, {
        createEvent
      }), /* @__PURE__ */ jsx(FlagPostMenuItem, {
        response: void 0
      }), /* @__PURE__ */ jsx(UnFlagPostMenuItem, {
        response: void 0
      })]
    })
  });
};
const PostsOverflow = () => {
  const {
    dialog,
    createEvent
  } = useCalendar();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [dialog, /* @__PURE__ */ jsx(OverflowMenu, {
      contentComponent: (props) => /* @__PURE__ */ jsx(MenuContent, {
        ...props,
        createEvent
      })
    })]
  });
};

const NOTE_ADDED_EVENT = "post-notes";
const RATING_CREATED_EVENT = "post-rating";
const USER_VOTED_EVENT = "post-vote";
const POST_UPDATE_EVENT = "post-update";
const OPEN_ADD_NOTE_EVENT = "open-add-note";
const OPEN_VOTE_EVENT = "open-vote";
const postEmitter = new Emitter();
const dispatchPostEvent = (type, event) => {
  return postEmitter.dispatchEvent(type, event);
};
const usePostEmitterSubscription = emitterSubscription(postEmitter);

const AccessContext = React__default.createContext({
  isAdmin: false,
  showAdminTools: false,
  setShowAdminTools: () => null
});
const useAccessContext = () => {
  return useContext(AccessContext);
};
const AccessContextProvider = ({
  children
}) => {
  const [showAdminTools, setShowAdminTools] = useState();
  const {
    membership
  } = usePostInfoContext();
  const isAdmin = membership && membership.role === "ADMIN";
  const context = useMemo(() => ({
    isAdmin,
    showAdminTools,
    setShowAdminTools
  }), [isAdmin, showAdminTools]);
  return /* @__PURE__ */ jsx(AccessContext.Provider, {
    value: context,
    children
  });
};

const thread_card = "_thread_card_1jxne_1";
const thread = "_thread_1jxne_1";
const responding = "_responding_1jxne_11";
const summary = "_summary_1jxne_15";
const entity_name = "_entity_name_1jxne_43";
const info$2 = "_info_1jxne_51";
const information = "_information_1jxne_52";
const meta = "_meta_1jxne_66";
const children = "_children_1jxne_75";
const thread_indicator = "_thread_indicator_1jxne_79";
const thread_indicator_icon = "_thread_indicator_icon_1jxne_87";
const badge = "_badge_1jxne_92";
const main_post = "_main_post_1jxne_129";
const parent = "_parent_1jxne_135";
const parent_summary = "_parent_summary_1jxne_144";
const parent_title = "_parent_title_1jxne_148";
const seperator = "_seperator_1jxne_152";
const post_wrapper = "_post_wrapper_1jxne_157";
const thread_Card = "_thread_Card_1jxne_163";
const thread_summary = "_thread_summary_1jxne_163";
const thread_main_post = "_thread_main_post_1jxne_167";
var styles$8 = {
	thread_card: thread_card,
	thread: thread,
	responding: responding,
	summary: summary,
	entity_name: entity_name,
	info: info$2,
	information: information,
	meta: meta,
	children: children,
	thread_indicator: thread_indicator,
	thread_indicator_icon: thread_indicator_icon,
	badge: badge,
	main_post: main_post,
	parent: parent,
	parent_summary: parent_summary,
	parent_title: parent_title,
	seperator: seperator,
	post_wrapper: post_wrapper,
	thread_Card: thread_Card,
	thread_summary: thread_summary,
	thread_main_post: thread_main_post
};

const ThreadIndicator = ({
  length
}) => {
  if (length > 0) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsxs("span", {
        className: styles$8.thread_indicator,
        children: [/* @__PURE__ */ jsx(OverflowIcon$2, {
          className: styles$8.thread_indicator_icon
        }), /* @__PURE__ */ jsx(FormattedMessage, {
          id: "post.n_other_posts",
          values: {
            length
          }
        }), /* @__PURE__ */ jsx(OverflowIcon$2, {
          className: styles$8.thread_indicator_icon
        })]
      })
    });
  }
  return /* @__PURE__ */ jsx(OverflowIcon$2, {
    className: styles$8.thread_indicator_icon
  });
};
const Summary = ({
  post
}) => {
  const {
    title,
    author,
    modified
  } = post;
  return /* @__PURE__ */ jsxs(Link$2, {
    to: url4post(post),
    className: styles$8.summary,
    children: [/* @__PURE__ */ jsx(Badge$1, {
      user: author,
      children: /* @__PURE__ */ jsx(RelativeTime, {
        value: modified,
        className: styles$8.meta
      })
    }), /* @__PURE__ */ jsx("h3", {
      children: title
    })]
  });
};
const ThreadCard = ({
  post: {
    thread: ids,
    extra: {
      thread
    }
  }
}) => {
  if (!ids || !ids.length) {
    return null;
  }
  if (!thread) {
    thread = {};
  }
  let top = thread[ids[0]];
  let parent = thread[ids[ids.length - 1]];
  const [expanded, setExpanded] = React__default.useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return /* @__PURE__ */ jsxs(Card, {
    className: styles$8.thread_card,
    children: [/* @__PURE__ */ jsx(Card, {
      className: styles$8.thread_main_post,
      children: /* @__PURE__ */ jsxs(Accordion, {
        className: styles$8.parent,
        expanded: expanded === "panel1",
        onChange: handleChange("panel1"),
        style: {
          margin: "0 0.25em 0 0"
        },
        children: [/* @__PURE__ */ jsx(AccordionSummary$1, {
          "aria-controls": "panel1d-content",
          id: "panel1d-header",
          className: styles$8.parent_summary,
          expandIcon: /* @__PURE__ */ jsx(ExpandMore$1, {}),
          children: /* @__PURE__ */ jsx(Typography, {
            className: styles$8.parent_title,
            children: /* @__PURE__ */ jsx("span", {
              className: styles$8.responding,
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "post.main_post"
              })
            })
          })
        }), /* @__PURE__ */ jsx(AccordionDetails, {
          className: styles$8.parent_body,
          children: /* @__PURE__ */ jsxs(Card, {
            className: styles$8.main_post,
            children: [/* @__PURE__ */ jsxs("span", {
              className: styles$8.information,
              children: [" ", /* @__PURE__ */ jsx(FormattedMessage, {
                id: "post.go_back_to_main_post"
              })]
            }), /* @__PURE__ */ jsx(Summary, {
              post: top
            })]
          })
        })]
      })
    }), /* @__PURE__ */ jsx(Card, {
      className: styles$8.main_post,
      children: parent && parent._id !== top._id && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(ThreadIndicator, {
          length: ids.length - 2
        }, "indicator"), /* @__PURE__ */ jsxs("div", {
          className: styles$8.post_wrapper,
          children: [/* @__PURE__ */ jsx("span", {
            className: styles$8.parent_title,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "post.owner_thread"
            })
          }), /* @__PURE__ */ jsxs("span", {
            className: styles$8.info,
            children: [" ", /* @__PURE__ */ jsx(FormattedMessage, {
              id: "post.go_to_owner_thread"
            })]
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: styles$8.thread_summary,
          children: /* @__PURE__ */ jsx(Summary, {
            post: parent
          }, "parent")
        })]
      })
    }), /* @__PURE__ */ jsx(Divider$1, {
      className: styles$8.seperator
    }), /* @__PURE__ */ jsx(Typography, {
      className: styles$8.parent_title,
      children: /* @__PURE__ */ jsx("span", {
        className: styles$8.responding,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "post.current_thread"
        })
      })
    })]
  });
};

var common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var pink$1 = pink;

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var indigo$1 = indigo;

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var grey$1 = grey;

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _typeof$2(o) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$2(o);
}

function isPlainObject(item) {
  return item && _typeof$2(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  factoryWithThrowingShims();
}

function toPrimitive(t, r) {
  if ("object" != _typeof$2(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$2(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var reactIs$1 = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

{
  reactIs$1.exports = reactIs_production_min;
}

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(formatMuiErrorMessage(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return _extends({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: Theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return _extends({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty({}, breakpoints.up('sm'), _extends({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: grey$1[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey$1[800],
    default: '#303030'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo$1[300],
    main: indigo$1[500],
    dark: indigo$1[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink$1.A200,
    main: pink$1.A400,
    dark: pink$1.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red$1[300],
    main: red$1[500],
    dark: red$1[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange$1[300],
    main: orange$1[500],
    dark: orange$1[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue$1[300],
    main: blue$1[500],
    dark: blue$1[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green$1[300],
    main: green$1[500],
    dark: green$1[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(formatMuiErrorMessage(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  var paletteOutput = deepmerge(_extends({
    // A collection of common colors.
    common: common$1,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;

var shape = {
  borderRadius: 4
};
var shape$1 = shape;

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  return function () {
    return undefined;
  };
}

function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay;
        _objectWithoutProperties(options, ["duration", "easing", "delay"]);

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows$1,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape$1,
    transitions: transitions,
    zIndex: zIndex$1
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  return muiTheme;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var functions = functionPlugin;

var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp$1 = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        container.addRule(selector, style[prop], _extends({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache$2[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof$1(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$1(document)) === 'object' && document.nodeType === 9;

// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix$1 = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix$1.js === 'ms') return key;
  return "@" + prefix$1.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix$1.js === 'ms') return "-webkit-" + prop;
    return prefix$1.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix$1.js === 'Webkit') return prefix$1.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix$1.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix$1.js + pascalize(longhand) in style) {
        return prefix$1.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix$1.vendor === 'apple' && !prefix$1.isTouch) {
      return prefix$1.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix$1.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix$1.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix$1.js === 'Webkit' || prefix$1.js === 'ms' && prefix$1.browser !== 'edge') {
      return prefix$1.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix$1.js === 'Moz' || prefix$1.js === 'ms' || prefix$1.vendor === 'apple') {
      return prefix$1.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix$1.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix$1.css + "column-" + prop : false;
    }

    if (prefix$1.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix$1.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix$1.js + pascalize(newProp) in style ? prefix$1.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix$1.js + pascalized in style) return prefix$1.css + prop; // Try webkit fallback.

    if (prefix$1.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix$1.js === 'ms') {
      return "" + prefix$1.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix$1.js === 'ms') {
      return prefix$1.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix$1.js + pascalize(newProp) in style ? prefix$1.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix$1.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix$1.js + pascalize(newProp) in style ? prefix$1.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix$1.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (isBrowser) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix$1.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functions(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses;
      options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends({}, baseClasses);

  Object.keys(newClasses).forEach(function (key) {

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var multiKeyStore$1 = multiKeyStore;

var ThemeContext = React__default.createContext(null);

var ThemeContext$1 = ThemeContext;

function useTheme() {
  var theme = React__default.useContext(ThemeContext$1);

  return theme;
}

var jss = create(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions);

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
var noopTheme$1 = noopTheme;

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends({}, styles);

      Object.keys(overrides).forEach(function (key) {

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme() || defaultTheme;

    var stylesOptions = _extends({}, React__default.useContext(StylesContext), stylesOptions2);

    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    return classes;
  };

  return useStyles;
}

var reactIs = reactIs$1.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);

    var classNamePrefix = name;

    var useStyles = makeStyles(stylesOrCreator, _extends({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__default.forwardRef(function WithStyles(props, ref) {
      props.classes;
          var innerRef = props.innerRef,
          other = _objectWithoutProperties(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React__default.createElement(Component, _extends({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });

    hoistNonReactStatics_cjs(WithStyles, Component);

    return WithStyles;
  };
};

var withStylesWithoutDefault = withStyles$1;

var defaultTheme = createMuiTheme();
var defaultTheme$1 = defaultTheme;

function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends({
    defaultTheme: defaultTheme$1
  }, options));
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

var styles$7 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/React$2.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/React$2.createElement(Component, _extends({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], fontSize !== 'default' && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/React$2.createElement("title", null, titleAccess) : null);
});
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles(styles$7, {
  name: 'MuiSvgIcon'
})(SvgIcon);

/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon$1(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/React__default.createElement(SvgIcon$1, _extends({
      ref: ref
    }, props), path);
  };

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React__default.memo( /*#__PURE__*/React__default.forwardRef(Component));
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

function deprecatedPropType(validator, reason) {
  {
    return function () {
      return null;
    };
  }
}

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/React$2.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}

function requirePropFactory(componentNameInError) {
  {
    return function () {
      return null;
    };
  }
}

// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  {
    return null;
  }
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default;
      _ref.name;
      _ref.state;

  var _React$useRef = React$2.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = React$2.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  var setValueIfUncontrolled = React$2.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

var useEnhancedEffect$1 = typeof window !== 'undefined' ? React$2.useLayoutEffect : React$2.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = React$2.useRef(fn);
  useEnhancedEffect$1(function () {
    ref.current = fn;
  });
  return React$2.useCallback(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return React$2.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = React$2.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  React$2.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {// browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  } // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = React$2.useCallback(function (instance) {
    var node = ReactDOM.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: 'Module',
  capitalize: capitalize,
  createChainedFunction: createChainedFunction,
  createSvgIcon: createSvgIcon$1,
  debounce: debounce,
  deprecatedPropType: deprecatedPropType,
  isMuiElement: isMuiElement,
  ownerDocument: ownerDocument,
  ownerWindow: ownerWindow,
  requirePropFactory: requirePropFactory,
  setRef: setRef,
  unsupportedProp: unsupportedProp,
  useControlled: useControlled,
  useEventCallback: useEventCallback,
  useForkRef: useForkRef,
  unstable_useId: useId,
  useIsFocusVisible: useIsFocusVisible
});

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

var TransitionGroupContext = React__default.createContext(null);

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
var TransitionGroup$1 = TransitionGroup;

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = /*#__PURE__*/React$2.createContext({});

var AccordionContext$1 = AccordionContext;

var useEnhancedEffect = typeof window === 'undefined' ? React$2.useEffect : React$2.useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = React$2.useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = clsx(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = useEventCallback(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/React$2.createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/React$2.createElement("span", {
    className: childClassName
  }));
}

var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles$6 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/React$2.forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties(props, ["center", "classes", "className"]);

  var _React$useState = React$2.useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = React$2.useRef(0);
  var rippleCallback = React$2.useRef(null);
  React$2.useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = React$2.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = React$2.useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = React$2.useRef(null);
  var container = React$2.useRef(null);
  React$2.useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = React$2.useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(_toConsumableArray(oldRipples), [/*#__PURE__*/React$2.createElement(Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = React$2.useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = React$2.useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = React$2.useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  React$2.useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/React$2.createElement("span", _extends({
    className: clsx(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/React$2.createElement(TransitionGroup$1, {
    component: null,
    exit: true
  }, ripples));
});
var TouchRipple$1 = withStyles(styles$6, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/React$2.memo(TouchRipple));

var styles$5 = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/React$2.forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = _objectWithoutProperties(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = React$2.useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return ReactDOM.findDOMNode(buttonRef.current);
  }

  var rippleRef = React$2.useRef(null);

  var _React$useState = React$2.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  React$2.useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  React$2.useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return useEventCallback(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = useEventCallback(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = React$2.useRef(false);
  var handleKeyDown = useEventCallback(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = useEventCallback(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = useForkRef(buttonRefProp, ref);
  var handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  var handleRef = useForkRef(handleUserRef, handleOwnRef);

  var _React$useState2 = React$2.useState(false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  React$2.useEffect(function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  return /*#__PURE__*/React$2.createElement(ComponentProp, _extends({
    className: clsx(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  React$2.createElement(TouchRipple$1, _extends({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
var ButtonBase$1 = withStyles(styles$5, {
  name: 'MuiButtonBase'
})(ButtonBase);

var styles$4 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: fade(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/React$2.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/React$2.createElement(ButtonBase$1, _extends({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], disabled && classes.disabled, size === "small" && classes["size".concat(capitalize(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/React$2.createElement("span", {
    className: classes.label
  }, children));
});
var IconButton$1 = withStyles(styles$4, {
  name: 'MuiIconButton'
})(IconButton);

var styles$3 = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var AccordionSummary = /*#__PURE__*/React$2.forwardRef(function AccordionSummary(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = React$2.useState(false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = React$2.useContext(AccordionContext$1),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/React$2.createElement(ButtonBase$1, _extends({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: clsx(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/React$2.createElement("div", {
    className: clsx(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/React$2.createElement(IconButton$1, _extends({
    className: clsx(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
var MuiAccordionSummary = withStyles(styles$3, {
  name: 'MuiAccordionSummary'
})(AccordionSummary);

const NsAccordionSummary = styled(MuiAccordionSummary)`
    & > .MuiAccordionSummary-content {
        display: flex;
        align-items: center;        
    }

    & > .MuiAccordionSummary-content > :first-child {
        margin-right: 5px;
    }
`;

const PostPageList = styled(List).attrs({
  dense: true,
  disablePadding: true
})`
    & .MuiListItemAvatar-root,  & .MuiListItemIcon-root{
        min-width: 30px
    }
`;

styled.div`
  padding: 1rem;
  &>* {
    padding: 0.5rem;
  }
`;
styled.div`
    display: flex;
    line-height: 1.3em;
    overflow-y: auto;
    max-height: 6.4em;
    overflow: hidden;
    align-items: center;
`;
const AVATAR_SIZE = 32;
styled.div`
  float: left;
  display: block;
  overflow: hidden;
  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  min-width: ${AVATAR_SIZE}px;
  margin: 0.25rem;
  border-radius: 9999px;
  background-color: #ccc;
`;
styled.div`
  font-size: 1.25em;
`;
const VotingInfo = ({
  response
}) => {
  const {
    responsesById
  } = useResponsesDataContext();
  if (!responsesById) {
    return null;
  }
  const post = responsesById[response];
  const info = usePostInfoContext();
  const poll = info.rating[response]; info.userVote[response];
  const {
    description
  } = poll;
  if (!post) {
    return null;
  }
  const postId = post._id;
  return /* @__PURE__ */ jsx(PostContextProvider, {
    post,
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex overflow-hidden items-center bg-[#4a90ce26] p-2",
      children: [/* @__PURE__ */ jsx("p", {
        className: "font-semibold",
        children: "Testing for consent started..."
      }), /* @__PURE__ */ jsx(UserPostVoteButton, {}), /* @__PURE__ */ jsx(PostLink, {
        postId,
        children: description || post.title
      })]
    })
  });
};
const InfoMessage = () => {
  const params = useQueryStringParams();
  const {
    info,
    response
  } = params;
  if (info === "vote" && response) {
    return /* @__PURE__ */ jsx(NoSsr, {
      children: /* @__PURE__ */ jsx(VotingInfo, {
        response
      })
    });
  }
  return null;
};

const getResponseTitle = (post) => {
  return post.title;
};

const PostNotificationMessage = ({
  post
}) => {
  const title = getResponseTitle(post);
  const onClick = (event) => {
    dispatchResponseEvent(SCROLL_TO_EVENT, {
      postId: post._id
    });
  };
  return /* @__PURE__ */ jsx(Link$1, {
    underline: "always",
    onClick,
    children: /* @__PURE__ */ jsx(LineWrapper, {
      children: title
    })
  });
};

const ConfigureNotificationsDialog = ({
  open,
  handleClose
}) => {
  const [showToasts, setShowToasts] = useState(() => showToastsConfig());
  const [showNotifications, setShowNotifications] = useState(() => showDesktopNotifications());
  const setup = () => {
    handleClose();
  };
  const changeShowToasts = (event) => {
    const show = event.target.checked;
    showToastsConfig(show);
    setShowToasts(show);
  };
  const changeShowDesktopNotifications = (event) => {
    const show = event.target.checked;
    setShowNotifications(show);
    showDesktopNotifications(show);
  };
  const notificationsNotSupported = !("Notification" in window);
  return /* @__PURE__ */ jsxs(Dialog$6, {
    open,
    onClose: handleClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    children: [/* @__PURE__ */ jsx(DialogTitle$1, {
      id: "alert-dialog-title",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: `dialogs.configure_notifications`
      })
    }), /* @__PURE__ */ jsx(DialogContent, {
      children: /* @__PURE__ */ jsx(DialogContentText, {
        id: "alert-dialog-description",
        children: /* @__PURE__ */ jsxs(FormGroup, {
          children: [/* @__PURE__ */ jsx(FormControlLabel, {
            control: /* @__PURE__ */ jsx(Checkbox$1, {
              checked: showToasts,
              onChange: changeShowToasts
            }),
            label: /* @__PURE__ */ jsx(FormattedMessage, {
              id: `dialogs.show_toasts`
            })
          }), /* @__PURE__ */ jsx(FormControlLabel, {
            disabled: notificationsNotSupported,
            control: /* @__PURE__ */ jsx(Checkbox$1, {
              checked: showNotifications,
              onChange: changeShowDesktopNotifications
            }),
            label: /* @__PURE__ */ jsx(FormattedMessage, {
              id: `dialogs.show_notifications`
            }) + (notificationsNotSupported ? " (not supported)" : "")
          })]
        })
      })
    }), /* @__PURE__ */ jsxs(DialogActions, {
      children: [/* @__PURE__ */ jsx(Button, {
        onClick: handleClose,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: `buttons.cancel`
        })
      }), /* @__PURE__ */ jsx(Button, {
        onClick: setup,
        color: "primary",
        autoFocus: true,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: `buttons.ok`
        })
      })]
    })]
  });
};

const NotificationsTitle = () => {
  const [open, setOpen] = React__default.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const onClick = () => {
    setOpen(true);
  };
  return /* @__PURE__ */ jsxs(Toolbar, {
    children: [/* @__PURE__ */ jsx(ConfigureNotificationsDialog, {
      open,
      handleClose
    }), /* @__PURE__ */ jsx(Typography, {
      variant: "h6",
      component: "h6",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: `toolbars.notifications`
      })
    }), /* @__PURE__ */ jsx(IconButton$5, {
      onClick,
      children: /* @__PURE__ */ jsx(BsGear, {})
    })]
  });
};

const postModified = (p) => {
  return (p.modified || "").toString();
};

const Wrapper$E = styled.div`
    & .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover {
        background-color: ${({
  theme
}) => theme.palette.primary.light}; 
    }
    & .MuiToggleButton-root {
        background-color: ${({
  theme
}) => theme.palette.primary.main}; 
    }
`;
const ListItemStyled = styled(ListItem)`
    & .MuiListItemIcon-root {
        min-width: 30px;
    }
`;
const NotificationsListItem = ({
  update
}) => {
  const current = update.current;
  const modified = current.modified !== current.created;
  const icon = modified ? /* @__PURE__ */ jsx(AiOutlineEdit, {}) : /* @__PURE__ */ jsx(RiPlayListAddLine, {});
  const messageInner = /* @__PURE__ */ jsx(PostNotificationMessage, {
    post: current
  });
  const message = update.isNew && /* @__PURE__ */ jsx(Badge$2, {
    color: "error",
    variant: "dot",
    children: messageInner
  }) || messageInner;
  const username = getPersonName(update.author);
  return /* @__PURE__ */ jsxs(ListItemStyled, {
    children: [/* @__PURE__ */ jsx(ListItemIcon, {
      children: icon
    }), /* @__PURE__ */ jsx(ListItemText, {
      primary: message,
      secondary: /* @__PURE__ */ jsx(LineWrapper, {
        children: username
      })
    })]
  }, update.current._id);
};
const RightSidePanelWidth = "300px";
const NotificationsPanel = styled.div`
    overflow: auto;
    padding: 5px;
    min-width: ${RightSidePanelWidth};
    width: ${RightSidePanelWidth};
    display: flex;
    flex-direction: column;
`;
const NotificationsPanelFixed = styled(NotificationsPanel)`
    position: fixed;
    top: 70px;
    height: calc(100vh - 70px);
`;
const NotificationsList = ({
  fixed,
  ...other
}) => {
  const {
    updated
  } = usePostUpdatesContext();
  const all = Object.values(updated).filter((u) => u.isNew).sort((a, b) => postModified(a.current).localeCompare(postModified(b.current)));
  const Panel = fixed ? NotificationsPanelFixed : NotificationsPanel;
  return /* @__PURE__ */ jsxs(Panel, {
    ...other,
    children: [/* @__PURE__ */ jsx(ResponsesToolbar, {}), /* @__PURE__ */ jsx(LastNotesAccordion, {}), /* @__PURE__ */ jsx(LastVotedAccordion, {}), /* @__PURE__ */ jsx(NotificationsTitle, {}), /* @__PURE__ */ jsx(List, {
      children: all.map((update) => /* @__PURE__ */ jsx(NotificationsListItem, {
        update
      }, update.current._id))
    })]
  });
};
const RightSidePanel = styled.div`
    min-width: ${RightSidePanelWidth};
    width: ${RightSidePanelWidth};
    padding-bottom: 15em;
    border-left: 0.05em solid #777777;
`;
const ShowNotificationsPanel = () => {
  const {
    open,
    drawer
  } = usePostUIContext();
  if (!open || drawer) {
    return null;
  }
  return /* @__PURE__ */ jsx(RightSidePanel, {
    children: /* @__PURE__ */ jsx(NotificationsList, {
      fixed: true
    })
  });
};
const Content = ({
  open,
  count
}) => {
  if (count) {
    return /* @__PURE__ */ jsx(Badge$2, {
      badgeContent: count,
      color: "secondary",
      children: /* @__PURE__ */ jsx(BsFileText, {
        color: open ? "white" : "#B3B3B3",
        size: 30
      })
    });
  }
  return /* @__PURE__ */ jsx(BsFileText, {
    color: open ? "white" : "#B3B3B3",
    size: 30
  });
};
const Drawer = styled(Drawer$1)`
    & .MuiDrawer-paper {
        max-width: calc(100% - 64px);
        overflow-x: auto;
    }
`;
const NotificationsDrawer = () => {
  const {
    open,
    setOpen,
    drawer
  } = usePostUIContext();
  if (!drawer) {
    return null;
  }
  return /* @__PURE__ */ jsx(Drawer, {
    anchor: "right",
    open,
    onClose: () => setOpen(false),
    children: /* @__PURE__ */ jsx(NotificationsList, {})
  });
};
const NotificationsButton = () => {
  const {
    open,
    setOpen
  } = usePostUIContext();
  const {
    updated
  } = usePostUpdatesContext();
  const updates = Object.values(updated);
  const count = updates.reduce((count2, update) => {
    if (update.isNew) {
      return count2 + 1;
    }
    return count2;
  }, 0);
  const toggleShowNotes = () => {
    setOpen(!open);
  };
  return /* @__PURE__ */ jsxs(Wrapper$E, {
    children: [/* @__PURE__ */ jsx(NotificationsDrawer, {}), /* @__PURE__ */ jsx(Tooltip$2, {
      title: "Customize and View Post Activities",
      "aria-label": "Customize and View Post Activities",
      children: /* @__PURE__ */ jsx(ToggleButton$1, {
        value: "left",
        selected: open,
        "aria-label": "show notes list",
        color: "primary",
        onChange: toggleShowNotes,
        "data-intro": "notifications",
        children: /* @__PURE__ */ jsx(Content, {
          open,
          count
        })
      })
    })]
  });
};

const references_card = "_references_card_fbphc_1";
const description = "_description_fbphc_11";
const filename = "_filename_fbphc_15";
var styles$2 = {
	references_card: references_card,
	description: description,
	filename: filename
};

const getLinks = (content) => {
  return Array.isArray(content) && content.reduce((r, b) => {
    if (typeof b === "string") ; else if (b.type === "Link") {
      r.push(b);
    } else {
      r = r.concat(getLinks(b.content));
    }
    return r;
  }, []) || [];
};
const getReferences = ({
  content,
  attachments
}) => {
  if (content.nsHtml) {
    return attachments;
  }
  const links = getLinks(content);
  return links.concat(attachments || []);
};
const Reference = ({
  description,
  name,
  contentType
}) => {
  const image = contentType ? fileTypeIcon(contentType) : null;
  return /* @__PURE__ */ jsxs("span", {
    children: [image, /* @__PURE__ */ jsx("span", {
      className: styles$2.description,
      children: name
    })]
  });
};
const LinkRef = ({
  data: {
    description,
    url
  }
}) => {
  if (isValidTag(url)) {
    const match = url.replace(/'/g, '"').match(/src\s*=\s*"(.+?)"/);
    if (match && match[1]) {
      url = match[1];
    } else {
      return /* @__PURE__ */ jsx("div", {
        children: url
      });
    }
  }
  const u = url.split("//")[1];
  return /* @__PURE__ */ jsx("a", {
    href: url,
    target: "_blank",
    children: /* @__PURE__ */ jsx(Reference, {
      description,
      name: u
    })
  });
};
const AttachmentRef = ({
  data
}) => {
  const {
    description,
    uuid,
    originalFileName,
    contentType
  } = data;
  const {
    instance
  } = useProfileContext();
  const instanceName = instance && instance.instanceName;
  const url = uuid && uuid.startsWith("obs/") ? `https://obs.${instanceName}/${uuid}` : `${FILE_CDN_ROOT}/${instanceName}/${uuid}`;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-2",
    children: [/* @__PURE__ */ jsx("a", {
      href: url,
      children: /* @__PURE__ */ jsx(Reference, {
        description,
        name: originalFileName,
        contentType
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-grow"
    })]
  });
};
const ReferencesList = styled.ol`
  margin-top: 0;
  margin-bottom: 0;
  & > li {
    max-width: 300px;
    max-width: 90vw;
    overflow-wrap: anywhere;
  }
`;
const ReferencesCard = ({
  post
}) => {
  if (!post || !post.content) {
    return null;
  }
  const refs = getReferences(post);
  if (refs && refs.length) {
    return /* @__PURE__ */ jsx(CardWithHeader, {
      title: "post.references",
      icon: MdAttachFile,
      className: styles$2.references_card,
      children: /* @__PURE__ */ jsx(ReferencesList, {
        children: refs.map((r) => {
          if (r.type === "Link") {
            let data = r.props.data;
            return /* @__PURE__ */ jsx("li", {
              children: /* @__PURE__ */ jsx(LinkRef, {
                data
              })
            }, data.duid);
          } else {
            return /* @__PURE__ */ jsx("li", {
              children: /* @__PURE__ */ jsx(AttachmentRef, {
                data: r
              })
            }, r.uuid);
          }
        })
      })
    });
  } else {
    return null;
  }
};

const info$1 = createLogger("info:ui");
const defaultContext = {
  users: [],
  published: []
};
const PostVisitorContext = React__default.createContext(defaultContext);
const usePostVisitorContext = () => {
  return useContext(PostVisitorContext);
};
const PostPageVisitor = ({
  children
}) => {
  const pollingControlsRef = useRef();
  const lastInfoRef = useRef();
  const infoContext = usePostInfoContext();
  const {
    post: loaded,
    loadPost: refreshPost,
    loadResponses: refreshResponses
  } = infoContext;
  const postId = loaded && loaded._id;
  const post = loaded && loaded._id === postId && loaded;
  const {
    profile: user
  } = useProfileContext();
  const [context, setContext] = useState();
  const [lastPostUpdate, setLastPostUpdate] = useState("");
  const subscriptionRequest = getSubscriptionData({
    user,
    post,
    postId
  });
  const onWebsocketsState = (state) => {
    setContext(() => {
      return {
        ...state
      };
    });
  };
  useEffect(() => {
    return () => {
      if (pollingControlsRef.current && pollingControlsRef.current.polling) {
        clearInterval(pollingControlsRef.current.polling);
      }
    };
  }, []);
  if (typeof window !== "undefined") {
    window["post"] = {
      refreshResponses,
      refreshPost
    };
  }
  const doRefresh = async (lastPostUpdate2, lastInfo) => {
    dispatchPostEvent(POST_UPDATE_EVENT, {
      postId
    });
    await refreshPost();
    await refreshResponses();
    if (lastPostUpdate2) {
      setLastPostUpdate(lastPostUpdate2);
    }
    if (lastInfo) {
      lastInfoRef.current = lastInfo;
    }
  };
  const {
    activities$
  } = useActivityContext();
  const {
    run: refresh
  } = useThrottleFn(() => {
    doRefresh();
  }, {
    wait: 5e3
  });
  activities$.useSubscription(({
    type,
    rootPost
  }) => {
    console.log("!!!!!!!!!!!!!", rootPost);
    if (type !== "post") {
      return;
    }
    if (rootPost !== postId) {
      return;
    }
    refresh();
  });
  const disconnected = () => {
    info$1("post visitor while disconnected");
    pollingControlsRef.current = {
      first: true,
      polling: setInterval(() => refresh(), 5 * 60 * 1e3)
    };
  };
  if (!pollingControlsRef.current && postId) {
    disconnected();
  }
  useWebsocketSubscription((data) => {
    info$1("subscription: %o", data);
    const lastUpdate = data.published.length && data.published[data.published.length - 1].uuid;
    const current = pollingControlsRef.current;
    const first = current.first;
    const lastInfo = data.info && data.info.uuid;
    if (first) {
      info$1("post visitor connected");
      current.first = false;
      refresh(lastUpdate, lastInfo);
    } else if (lastUpdate !== lastPostUpdate) {
      refresh(lastUpdate, lastInfo);
    } else if (lastInfoRef.current !== lastInfo) {
      refresh(lastUpdate, lastInfo);
    }
    onWebsocketsState(data);
  }, {
    type: "post-visitor",
    data: subscriptionRequest,
    disconnected
  }, [!subscriptionRequest, postId, user && user._id]);
  return /* @__PURE__ */ jsx(PostVisitorContext.Provider, {
    value: context || defaultContext,
    children
  });
};
function getSubscriptionData({
  user,
  post,
  postId
}) {
  if (!user || !post || post.thread.length) {
    return null;
  }
  return {
    id: `post-visitor:${postId}`,
    postId,
    user: {
      userId: user._id,
      username: getPersonName(user)
    }
  };
}

createLogger("info:ui");
const PostOnlineUsersDialog = ({
  open,
  handleClose,
  user
}) => {
  const {
    users
  } = usePostVisitorContext();
  if (!user || !open) {
    return null;
  }
  const all = users.length ? users : [{
    username: getPersonName(user),
    userId: user._id
  }];
  return /* @__PURE__ */ jsxs(Dialog$6, {
    onClose: () => handleClose(true),
    "aria-labelledby": "customized-dialog-title",
    open,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      "data-testid": "customized-dialog-title",
      onClose: () => handleClose(true),
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: `dialogs.online`
      })
    }), /* @__PURE__ */ jsx(DialogContent, {
      dividers: true,
      children: /* @__PURE__ */ jsx(List, {
        children: all.map((user2) => {
          return /* @__PURE__ */ jsxs(ListItem, {
            children: [/* @__PURE__ */ jsx(ListItemAvatar, {
              children: /* @__PURE__ */ jsx(Avatar$1, {
                children: /* @__PURE__ */ jsx(BsImageAlt, {})
              })
            }), /* @__PURE__ */ jsx(ListItemText, {
              primary: user2.username
            })]
          }, `${user2.userId}:${user2.username}`);
        })
      })
    })]
  });
};

const SharePublishedPost = ({
  post
}) => {
  return /* @__PURE__ */ jsxs(CardWithHeader, {
    title: "compose.share.title",
    icon: BsShare,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col p-4 bg-white self-center rounded-lg m-8",
      children: [/* @__PURE__ */ jsx(ImportantMessage, {
        i18nKey: "compose.share.published_successfully"
      }), /* @__PURE__ */ jsx(ShareSection, {
        post
      })]
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(ResponsiveImageProxy, {
        data: post.image,
        sizes: {
          "(min-width: 768px)": {
            width: 245,
            height: 196
          },
          "(min-width: 640px)": {
            width: 308,
            height: 246
          },
          "(min-width: 512px)": {
            width: 244,
            height: 195
          },
          "(min-width: 320px)": {
            width: 148,
            height: 118
          },
          "(max-width: 240px)": {
            width: 224,
            height: 179
          }
        }
      })
    })]
  });
};

let AudioContext = typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext);

let createWorker = fn => {
  let js = fn
    .toString()
    .replace(/^(\(\)\s*=>|function\s*\(\))\s*{/, '')
    .replace(/}$/, '');
  let blob = new Blob([js]);
  return new Worker(URL.createObjectURL(blob))
};

let error = method => {
  let event = new Event('error');
  event.data = new Error('Wrong state for ' + method);
  return event
};

let context;

/**
 * Audio Recorder with MediaRecorder API.
 *
 * @example
 * navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
 *   let recorder = new MediaRecorder(stream)
 * })
 */
class MediaRecorder$1 {
  /**
   * @param {MediaStream} stream The audio stream to record.
   */
  constructor (stream, config = null) {
    /**
     * The `MediaStream` passed into the constructor.
     * @type {MediaStream}
     */
    this.stream = stream;
    this.config = config;
    /**
     * The current state of recording process.
     * @type {"inactive"|"recording"|"paused"}
     */
    this.state = 'inactive';

    this.em = document.createDocumentFragment();
    this.encoder = createWorker(MediaRecorder$1.encoder);

    let recorder = this;
    this.encoder.addEventListener('message', e => {
      let event = new Event('dataavailable');
      event.data = new Blob([e.data], { type: recorder.mimeType });
      recorder.em.dispatchEvent(event);
      if (recorder.state === 'inactive') {
        recorder.em.dispatchEvent(new Event('stop'));
      }
    });
  }

  /**
   * Begins recording media.
   *
   * @param {number} [timeslice] The milliseconds to record into each `Blob`.
   *                             If this parameter isn’t included, single `Blob`
   *                             will be recorded.
   *
   * @return {undefined}
   *
   * @example
   * recordButton.addEventListener('click', () => {
   *   recorder.start()
   * })
   */
  start (timeslice) {
    if (this.state !== 'inactive') {
      return this.em.dispatchEvent(error('start'))
    }

    this.state = 'recording';

    if (!context) {
      context = new AudioContext(this.config);
    }
    this.clone = this.stream.clone();
    this.input = context.createMediaStreamSource(this.clone);
    this.processor = context.createScriptProcessor(2048, 1, 1);

    this.encoder.postMessage(['init', context.sampleRate]);

    this.processor.onaudioprocess = e => {
      if (this.state === 'recording') {
        this.encoder.postMessage(['encode', e.inputBuffer.getChannelData(0)]);
      }
    };

    this.input.connect(this.processor);
    this.processor.connect(context.destination);

    this.em.dispatchEvent(new Event('start'));

    if (timeslice) {
      this.slicing = setInterval(() => {
        if (this.state === 'recording') this.requestData();
      }, timeslice);
    }

    return undefined
  }

  /**
   * Stop media capture and raise `dataavailable` event with recorded data.
   *
   * @return {undefined}
   *
   * @example
   * finishButton.addEventListener('click', () => {
   *   recorder.stop()
   * })
   */
  stop () {
    if (this.state === 'inactive') {
      return this.em.dispatchEvent(error('stop'))
    }

    this.requestData();
    this.state = 'inactive';
    this.clone.getTracks().forEach(track => {
      track.stop();
    });
    this.processor.disconnect();
    this.input.disconnect();
    return clearInterval(this.slicing)
  }

  /**
   * Pauses recording of media streams.
   *
   * @return {undefined}
   *
   * @example
   * pauseButton.addEventListener('click', () => {
   *   recorder.pause()
   * })
   */
  pause () {
    if (this.state !== 'recording') {
      return this.em.dispatchEvent(error('pause'))
    }

    this.state = 'paused';
    return this.em.dispatchEvent(new Event('pause'))
  }

  /**
   * Resumes media recording when it has been previously paused.
   *
   * @return {undefined}
   *
   * @example
   * resumeButton.addEventListener('click', () => {
   *   recorder.resume()
   * })
   */
  resume () {
    if (this.state !== 'paused') {
      return this.em.dispatchEvent(error('resume'))
    }

    this.state = 'recording';
    return this.em.dispatchEvent(new Event('resume'))
  }

  /**
   * Raise a `dataavailable` event containing the captured media.
   *
   * @return {undefined}
   *
   * @example
   * this.on('nextData', () => {
   *   recorder.requestData()
   * })
   */
  requestData () {
    if (this.state === 'inactive') {
      return this.em.dispatchEvent(error('requestData'))
    }

    return this.encoder.postMessage(['dump', context.sampleRate])
  }

  /**
   * Add listener for specified event type.
   *
   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
   * type Event type.
   * @param {function} listener The listener function.
   *
   * @return {undefined}
   *
   * @example
   * recorder.addEventListener('dataavailable', e => {
   *   audio.src = URL.createObjectURL(e.data)
   * })
   */
  addEventListener (...args) {
    this.em.addEventListener(...args);
  }

  /**
   * Remove event listener.
   *
   * @param {"start"|"stop"|"pause"|"resume"|"dataavailable"|"error"}
   * type Event type.
   * @param {function} listener The same function used in `addEventListener`.
   *
   * @return {undefined}
   */
  removeEventListener (...args) {
    this.em.removeEventListener(...args);
  }

  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {Event} event The event object.
   *
   * @return {boolean} Is event was no canceled by any listener.
   */
  dispatchEvent (...args) {
    this.em.dispatchEvent(...args);
  }
}

/**
 * The MIME type that is being used for recording.
 * @type {string}
 */
MediaRecorder$1.prototype.mimeType = 'audio/wav';

/**
 * Returns `true` if the MIME type specified is one the polyfill can record.
 *
 * This polyfill supports `audio/wav` and `audio/mpeg`.
 *
 * @param {string} mimeType The mimeType to check.
 *
 * @return {boolean} `true` on `audio/wav` and `audio/mpeg` MIME type.
 */
MediaRecorder$1.isTypeSupported = mimeType => {
  return MediaRecorder$1.prototype.mimeType === mimeType
};

/**
 * `true` if MediaRecorder can not be polyfilled in the current browser.
 * @type {boolean}
 *
 * @example
 * if (MediaRecorder.notSupported) {
 *   showWarning('Audio recording is not supported in this browser')
 * }
 */
MediaRecorder$1.notSupported = typeof navigator !== "undefined" && (!navigator.mediaDevices || !AudioContext);

var mpegEncoder = () => {
    importScripts(
      'https://cdnjs.cloudflare.com/ajax/libs/lamejs/1.2.0/lame.min.js'
    );
  
    let CHANNELS = 1;
    let KBPS = 128;
    let DEFAULT_SAMPLE_RATE = 44100;
  
    let encoder;
    let recorded = new Int8Array();
  
    function concat (a, b) {
      if (b.length === 0) {
        return a
      }
      let c = new Int8Array(a.length + b.length);
      c.set(a);
      c.set(b, a.length);
      return c
    }
  
    function init (sampleRate) {
      encoder = new lamejs.Mp3Encoder(
        CHANNELS,
        sampleRate || DEFAULT_SAMPLE_RATE,
        KBPS
      );
    }
  
    function encode (buffer) {
      for (let i = 0; i < buffer.length; i++) {
        buffer[i] = buffer[i] * 32767.5;
      }
  
      let buf = encoder.encodeBuffer(buffer);
      recorded = concat(recorded, buf);
    }
  
    function dump () {
      let buf = encoder.flush();
      recorded = concat(recorded, buf);
      let buffer = recorded.buffer;
      recorded = new Int8Array();
      postMessage(buffer, [buffer]);
    }
  
    onmessage = e => {
      if (e.data[0] === 'init') {
        init(e.data[1]);
      } else if (e.data[0] === 'encode') {
        encode(e.data[1]);
      } else {
        dump(e.data[1]);
      }
    };
  };

const info = createLogger("info:ui");
const installMediaRecorder = async () => {
  if (typeof window === "undefined") {
    return;
  }
  MediaRecorder$1.encoder = mpegEncoder;
  MediaRecorder$1.prototype.mimeType = "audio/mpeg";
  window.MediaRecorder = MediaRecorder$1;
};
class SimpleRecorder {
  constructor() {
    this.onData = (ev) => {
      this.data = ev.data;
      info("recorder data: %o", this.data);
    };
  }
  async start() {
    this.stream = await navigator.mediaDevices.getUserMedia({
      audio: true
    });
    this.recorder = new MediaRecorder(this.stream);
    this.recorder.addEventListener("dataavailable", this.onData);
    this.recorder.start();
  }
  stop() {
    this.recorder.stop();
    this.recorder.stream.getTracks().forEach((i) => i.stop());
  }
}
const SimpleRecorderContext = React__default.createContext({
  recorder: new SimpleRecorder(),
  toggle: () => null,
  save: () => null,
  recording: false,
  audio: null
});
const useSimpleRecorderContext = () => {
  return useContext(SimpleRecorderContext);
};
const useSimpleRecorder = () => {
  const api = useApi();
  const recorderRef = useRef();
  if (!recorderRef.current) {
    recorderRef.current = new SimpleRecorder();
  }
  const recorder = recorderRef.current;
  const [recording, setRecording] = useState(false);
  const toggle = useCallback(() => {
    setRecording((v) => {
      if (v) {
        recorder.stop();
      } else {
        recorder.start();
      }
      return !v;
    });
  }, []);
  const save = useCallback(async (postId) => {
    const audio = recorder.data;
    if (!audio) {
      return;
    }
    return await savePostAudio({
      api,
      postId,
      audio
    });
  }, []);
  return {
    recorder,
    toggle,
    recording,
    audio: recorder && recorder.data,
    save
  };
};
const SimpleRecorderContextProviderInner = ({
  children
}) => {
  const context = useSimpleRecorder();
  return /* @__PURE__ */ jsx(SimpleRecorderContext.Provider, {
    value: context,
    children
  });
};
const SimpleRecorderContextProvider = ({
  children
}) => {
  const [installed, setInstalled] = useState(false);
  useEffect(() => {
    installMediaRecorder().then(() => {
      setInstalled(true);
    });
  }, []);
  if (!installed) {
    return /* @__PURE__ */ jsx(Fragment, {
      children
    });
  }
  return /* @__PURE__ */ jsx(SimpleRecorderContextProviderInner, {
    children
  });
};
const savePostAudio = async ({
  api,
  postId,
  audio
}) => {
  const {
    url
  } = await api.makeRequest({
    method: "POST",
    path: `/posts/${postId}/file`
  });
  info("s3 url: %s", url);
  const options = {
    method: "PUT",
    body: audio
  };
  const response = await fetch(url, options);
  info("s3 upload: %o", response);
  return response;
};

const SimplePlayer = ({
  bucket,
  path
}) => {
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef();
  const toggle = async () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(`https://s3.eu-west-2.amazonaws.com/${bucket}/${path}`);
    }
    const audio = audioRef.current;
    if (playing) {
      audio.pause();
      audio.currentTime = 0;
      setPlaying(false);
      return;
    }
    audio.play();
    setPlaying(true);
    audio.addEventListener("ended", function() {
      audioRef.current.currentTime = 0;
      setPlaying(false);
    });
  };
  return /* @__PURE__ */ jsx(IconButton$5, {
    onClick: toggle,
    children: playing ? /* @__PURE__ */ jsx(AiOutlineSound, {}) : /* @__PURE__ */ jsx(BsHeadphones, {})
  });
};

const GPopup = () => {
  if (typeof window !== "undefined") {
    localStorage.setItem("__goo", window.location.href);
    localStorage.removeItem("__goo");
  }
  return /* @__PURE__ */ jsx("div", {
    children: "Return URL for Google Auth"
  });
};

const Wrapper$D = styled.div`
  && > * {
    margin: 10px;
  } 
`;
const PostsElasticTest = () => {
  const [operation, setOperation] = useState({});
  const [text, setText] = useState("");
  const [found, setFound] = useState({});
  const api = useApi();
  const onIndexLast = async () => {
    setOperation({});
    const result = await api.makeRequest({
      path: "/elastic/posts/reindex"
    });
    console.log("onIndexLast", result);
    setOperation(result);
  };
  const onIndexTags = async () => {
    setOperation({});
    const result = await api.makeRequest({
      path: "/elastic/tags/indexed"
    });
    console.log("onIndex", result);
    setOperation(result);
  };
  const onIndexGroups = async () => {
    setOperation({});
    const result = await api.makeRequest({
      path: "/elastic/groups/indexed"
    });
    console.log("onIndex", result);
    setOperation(result);
  };
  const onSearch = async () => {
    const result = await api.makeRequest({
      path: "/elastic/posts/search?query=" + encodeURIComponent(text)
    });
    console.log("onSearch", result);
    setFound(result);
  };
  const onSearchTags = async () => {
    const result = await api.makeRequest({
      path: "/elastic/tags/search?query=" + encodeURIComponent(text)
    });
    console.log("onSearchTags", result.tags);
    setFound(result);
  };
  const onSearchGroups = async () => {
    const result = await api.makeRequest({
      path: "/elastic/groups/search?query=" + encodeURIComponent(text)
    });
    console.log("onSearchGroups", result.name);
    setFound(result);
  };
  const handleChange = (e) => {
    setText(e.target.value);
  };
  const showFound = () => {
    if (found.posts) {
      return found.posts.map((p, i) => {
        return /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("span", {
            children: p.title
          }), /* @__PURE__ */ jsx("span", {
            children: p.content
          })]
        }, i);
      });
    }
    if (found.tags) {
      return found.tags.map((t, i) => {
        return /* @__PURE__ */ jsx("div", {
          children: /* @__PURE__ */ jsx("span", {
            children: t
          })
        }, i);
      });
    }
    if (found.names) {
      return found.names.map((t, i) => {
        return /* @__PURE__ */ jsx("div", {
          children: /* @__PURE__ */ jsx("span", {
            children: t
          })
        }, i);
      });
    }
    return [];
  };
  const list = showFound();
  return /* @__PURE__ */ jsxs(Wrapper$D, {
    children: [/* @__PURE__ */ jsx(OutlinedInput, {
      autoFocus: true,
      placeholder: "Query",
      value: text,
      onChange: handleChange
    }), /* @__PURE__ */ jsx(Button, {
      onClick: onIndexLast,
      variant: "contained",
      color: "primary",
      children: "Reindex posts"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: onIndexTags,
      variant: "contained",
      color: "primary",
      children: "Index tags"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: onIndexGroups,
      variant: "contained",
      color: "primary",
      children: "Index groups"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: onSearch,
      variant: "contained",
      color: "primary",
      children: "Search"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: onSearchTags,
      variant: "contained",
      color: "primary",
      children: "Search Tags"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: onSearchGroups,
      variant: "contained",
      color: "primary",
      children: "Search Groups"
    }), /* @__PURE__ */ jsx("div", {
      children: `Operation: ${JSON.stringify(operation)}, found (${list.length}):`
    }), list, /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("h3", {
        children: "Suggestions"
      })
    })]
  });
};

var landing = '';

const CssOverrides$1 = createGlobalStyle`
  #body {
    overflow-y: scroll;
  }
`;
const LandingPage = () => {
  return /* @__PURE__ */ jsxs(Fragment$1, {
    children: [/* @__PURE__ */ jsx(CssOverrides$1, {}), /* @__PURE__ */ jsx(CssLink, {
      href: "/static/core.css"
    }), /* @__PURE__ */ jsx("div", {
      className: "bg-white",
      children: /* @__PURE__ */ jsx("div", {
        className: "max-w-7xl mx-auto relative ",
        children: /* @__PURE__ */ jsx("div", {
          className: "",
          children: /* @__PURE__ */ jsxs("dl", {
            className: "md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "relative title-block en lg:max-w-lg pl-4 pr-4 sm:pl-6 lg:pl-8 pt-4 sm:pr-6 sm:pt-6 sm:pb-10 lg:pt-1 lg:h-screen",
              children: [/* @__PURE__ */ jsxs("h1", {
                className: "mt-5 text-3xl tracking-tight font-bold sm:text-3xl md:text-3xl lg:text-4xl text-font-base landing-title",
                children: [/* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.title`
                }), " ", /* @__PURE__ */ jsx("span", {
                  className: "inline-block text-primary-color",
                  children: /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.circles`
                  })
                })]
              }), /* @__PURE__ */ jsxs("p", {
                className: "mt-3 text-base text-font-sub pb-[20px] sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0",
                children: [/* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.pre_desc`
                }), " ", /* @__PURE__ */ jsxs("span", {
                  className: "inline-block text-primary-color",
                  children: ["'", /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.circles`
                  }), "'"]
                }), " ", /* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.post_desc`
                })]
              }), /* @__PURE__ */ jsx("div", {
                className: "img-container",
                children: /* @__PURE__ */ jsxs("a", {
                  href: "/",
                  children: [" ", /* @__PURE__ */ jsx("span", {
                    className: "sr-only",
                    children: "NewsSocial"
                  }), /* @__PURE__ */ jsx("div", {
                    className: "img-banner sm:mt:10"
                  })]
                })
              })]
            }), /* @__PURE__ */ jsxs("div", {
              className: "relative title-block ar mt-5 lg:max-w-lg pl-4 pr-4 sm:pl-6 lg:pl-8 pt-4 sm:pr-6 sm:pt-6 sm:pb-10 lg:pt-1 lg:h-screen",
              children: [/* @__PURE__ */ jsxs("div", {
                className: "mt-5",
                children: [/* @__PURE__ */ jsx("span", {
                  className: "text-3xl tracking-tight font-bold sm:text-3xl md:text-3xl lg:text-4xl text-font-base landing-title",
                  children: /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.title_ar`
                  })
                }), "\xA0\xA0", /* @__PURE__ */ jsx("span", {
                  className: "text-primary-color text-3xl tracking-tight font-bold sm:text-3xl md:text-3xl lg:text-4x landing-title",
                  children: /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.circles_ar`
                  })
                })]
              }), /* @__PURE__ */ jsxs("p", {
                className: "mt-3 text-base text-font-sub pb-[20px] sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0",
                children: [/* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.pre_desc_ar`
                }), " ", /* @__PURE__ */ jsxs("span", {
                  className: "inline-block text-primary-color",
                  children: ["'", /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.circles_ar`
                  }), "'"]
                }), " ", /* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.post_desc_ar`
                })]
              }), /* @__PURE__ */ jsx("div", {
                className: "img-container",
                children: /* @__PURE__ */ jsxs("a", {
                  href: "/",
                  children: [" ", /* @__PURE__ */ jsx("span", {
                    className: "sr-only",
                    children: "NewsSocial"
                  }), /* @__PURE__ */ jsx("div", {
                    className: "img-banner sm:mt:10"
                  })]
                })
              })]
            }), /* @__PURE__ */ jsx("div", {
              className: "relative bg-primary-shade bg-opacity-25 sm:pr-6 sm:pl-8 sm:pb-10 md:pr-8 md:pl-8 md:pt-8 lg:pr-8 lg:pl-8 lg:pt-8 lg:h-screen",
              children: /* @__PURE__ */ jsx("div", {
                className: "",
                children: /* @__PURE__ */ jsx("div", {
                  className: "feature-list-right feature-block lg:pt-10 sm:pt-[5px] feature-block lg:max-w-lg",
                  children: /* @__PURE__ */ jsxs("dl", {
                    className: "space-y-5 md:space-y-10 lg:space-y-10 md:gap-x-8 md:gap-y-10",
                    children: [/* @__PURE__ */ jsx("a", {
                      className: "feature-item relative",
                      href: "/groups",
                      children: /* @__PURE__ */ jsxs("div", {
                        className: "mt-[10px] md:mt-[5px] lg:mt-[10px] hover:shadow-lg p-[10px] hover:bg-white hover:rounded-md hover:bg-opacity-80 ",
                        children: [" ", /* @__PURE__ */ jsxs("dt", {
                          children: [/* @__PURE__ */ jsx("div", {
                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-ns-red ",
                            children: /* @__PURE__ */ jsx(BiMessageRoundedAdd, {
                              className: "h-6 w-6 text-white"
                            })
                          }), /* @__PURE__ */ jsx("p", {
                            className: "text-lg leading-6 font-bold text-gray-900",
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_one`
                            })
                          })]
                        }), /* @__PURE__ */ jsx("dd", {
                          className: "mt-2 text-base text-gray-500",
                          children: /* @__PURE__ */ jsx("p", {
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_one_desc`
                            })
                          })
                        })]
                      })
                    }), /* @__PURE__ */ jsx("a", {
                      className: "feature-item relative",
                      href: "/",
                      children: /* @__PURE__ */ jsxs("div", {
                        className: "lg:mt-[10px] hover:shadow-lg p-[10px] hover:bg-white hover:rounded-md hover:bg-opacity-80 ",
                        children: [" ", /* @__PURE__ */ jsxs("dt", {
                          children: [/* @__PURE__ */ jsx("div", {
                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-ns-orange ",
                            children: /* @__PURE__ */ jsx(BiSearchAlt, {
                              className: "h-6 w-6 text-white"
                            })
                          }), /* @__PURE__ */ jsx("p", {
                            className: "text-lg leading-6 font-bold text-gray-900",
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_two`
                            })
                          })]
                        }), /* @__PURE__ */ jsx("dd", {
                          className: "mt-2 text-base text-gray-500",
                          children: /* @__PURE__ */ jsx("p", {
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_two_desc`
                            })
                          })
                        })]
                      })
                    }), /* @__PURE__ */ jsx("a", {
                      className: "feature-item relative ",
                      href: "/profile",
                      children: /* @__PURE__ */ jsxs("div", {
                        className: "lg:mt-[10px] hover:shadow-lg p-[10px] hover:bg-white hover:rounded-md hover:bg-opacity-80 ",
                        children: [" ", /* @__PURE__ */ jsxs("dt", {
                          children: [/* @__PURE__ */ jsx("div", {
                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-ns-purple",
                            children: /* @__PURE__ */ jsx(FaUserEdit, {
                              className: "h-6 w-6 text-white"
                            })
                          }), /* @__PURE__ */ jsx("p", {
                            className: "text-lg leading-6 font-bold text-gray-900",
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_three`
                            })
                          })]
                        }), /* @__PURE__ */ jsx("dd", {
                          className: "mt-2 text-base text-gray-500",
                          children: /* @__PURE__ */ jsx("p", {
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_three_desc`
                            })
                          })
                        }), " "]
                      })
                    })]
                  })
                })
              })
            })]
          })
        })
      })
    })]
  });
};

var newcustomlanding = '';

const NewCustomLanding = (props) => {
  const [value, setValue] = React__default.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return /* @__PURE__ */ jsxs(Fragment$1, {
    children: [/* @__PURE__ */ jsx(CssLink, {
      href: "/static/core.css"
    }), /* @__PURE__ */ jsx(Tabs$4, {
      value,
      onChange: handleChange,
      "aria-label": "icon label tabs example"
    })]
  });
};

var customlanding = '';

const CustomLanding = (props) => {
  return /* @__PURE__ */ jsx(Fragment$1, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "p-[10px] pb-6 bg-white mb-12",
      children: [/* @__PURE__ */ jsx("div", {
        className: "relative px-4 sm:px-6 lg:px-8",
        children: /* @__PURE__ */ jsx("nav", {
          className: "relative flex items-center justify-between sm:h-10 lg:justify-start",
          "aria-label": "Global",
          children: /* @__PURE__ */ jsx("div", {
            className: "flex items-center flex-grow flex-shrink-0 lg:flex-grow-0",
            children: /* @__PURE__ */ jsx("div", {
              className: "flex items-center justify-between w-full md:w-auto",
              children: /* @__PURE__ */ jsxs("a", {
                href: "#",
                children: [" ", /* @__PURE__ */ jsx("span", {
                  className: "sr-only",
                  children: "Workflow"
                }), " ", /* @__PURE__ */ jsx("img", {
                  className: "h-8 w-auto sm:h-10",
                  src: "/static/images/logo-extra-large.png"
                }), " "]
              })
            })
          })
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
        children: /* @__PURE__ */ jsx("div", {
          className: "hero-banner bg-primary-color rounded-3xl p-8 mt-8 mb-8 ",
          children: /* @__PURE__ */ jsxs("div", {
            className: "space-y-10 md:space-y-0",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "banner-text relative sm:text-center lg:max-w-lg mt-5 ",
              children: [/* @__PURE__ */ jsxs("h1", {
                className: "text-4xl tracking-tight font-extrabold sm:text-5xl md:text-6xl",
                children: [/* @__PURE__ */ jsx("span", {
                  className: "text-white ",
                  children: " Do ideas matter?"
                }), /* @__PURE__ */ jsx("br", {}), /* @__PURE__ */ jsx("span", {
                  className: "block text-font-base  xl:inline ",
                  children: "Make them happen"
                })]
              }), /* @__PURE__ */ jsxs("p", {
                className: "text-white  mt-3 text-base sm:mt-5 sm:text-lg sm:max-w-sm sm:mx-auto md:mt-5 md:text-xl lg:mx-0",
                children: ["Moderated discussions in ", /* @__PURE__ */ jsx("span", {
                  className: "font-bold",
                  children: "'Circles'"
                }), " lead to positive outcomes and inter-cooperation."]
              }), " ", /* @__PURE__ */ jsx("img", {
                className: "landing-sm-bg-mobile h-8 w-auto sm:h-10",
                src: "/static/images/dotted-line-arrow.png"
              }), " "]
            }), " ", /* @__PURE__ */ jsx("img", {
              className: "img-banner-bg",
              src: "/static/images/circle_with_bg.png"
            }), " ", /* @__PURE__ */ jsx("img", {
              className: "img-annouonce",
              src: "/static/images/announce.png"
            }), " "]
          })
        })
      }), /* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx("div", {
          children: /* @__PURE__ */ jsx("div", {
            className: "pl-8 pr-8",
            children: /* @__PURE__ */ jsx("div", {
              className: "",
              children: /* @__PURE__ */ jsxs("div", {
                className: "space-y-10 md:space-y-0 flex items-stretch flex-col md:flex-row",
                children: [/* @__PURE__ */ jsx("div", {
                  className: "flex-1 bg-lum-blue rounded-md p-4 mr-2 ",
                  children: /* @__PURE__ */ jsxs("a", {
                    className: "feature-item relative h-full",
                    href: "#",
                    children: [/* @__PURE__ */ jsxs("div", {
                      className: "flex items-center justify-center h-12 w-12 rounded-md bg-primary-shade bg-opacity- text-white",
                      children: [/* @__PURE__ */ jsx(BiMessageRoundedAdd, {
                        className: "h-6 w-6"
                      }), " "]
                    }), /* @__PURE__ */ jsx("p", {
                      className: "mt-2 mb-2 text-lg leading-6 font-medium text-gray-900 text-left",
                      children: "Join Circle"
                    }), /* @__PURE__ */ jsx("p", {
                      children: "Click here to join ideation Circle or create a Circle for your community"
                    })]
                  })
                }), /* @__PURE__ */ jsx("div", {
                  className: "flex-1 bg-lum-yellow rounded-md p-4 mr-2 bg-opacity-50",
                  children: /* @__PURE__ */ jsxs("a", {
                    className: "feature-item relative h-full",
                    href: "#",
                    children: [/* @__PURE__ */ jsxs("div", {
                      className: "flex items-center justify-center h-12 w-12 rounded-md bg-primary-shade bg-opacity- text-white",
                      children: [/* @__PURE__ */ jsx(BiMessageRoundedAdd, {
                        className: "h-6 w-6"
                      }), " "]
                    }), /* @__PURE__ */ jsx("p", {
                      className: "mt-2 mb-2 text-lg leading-6 font-medium text-gray-900 text-left",
                      children: "Browse posts and events"
                    }), /* @__PURE__ */ jsx("p", {
                      children: "Click to browse posts and events agregated from all Circles, tag surf and discover content to follow and Circles to join"
                    })]
                  })
                }), /* @__PURE__ */ jsx("div", {
                  className: "flex-1 bg-lum-blue rounded-md p-4 mr-2 ",
                  children: /* @__PURE__ */ jsxs("a", {
                    className: "feature-item relative h-full",
                    href: "#",
                    children: [/* @__PURE__ */ jsxs("div", {
                      className: "flex items-center justify-center h-12 w-12 rounded-md bg-primary-shade bg-opacity- text-white",
                      children: [/* @__PURE__ */ jsx(GiDiscussion, {
                        className: "h-6 w-6"
                      }), " "]
                    }), /* @__PURE__ */ jsx("p", {
                      className: "mt-2 mb-2 text-lg leading-6 font-medium text-gray-900 text-left",
                      children: "Start discussing"
                    }), /* @__PURE__ */ jsx("p", {
                      children: "Click to author your own article or start a discussion"
                    })]
                  })
                }), /* @__PURE__ */ jsx("div", {
                  className: "flex-1 bg-lum-purple rounded-md p-4 bg-opacity-50",
                  children: /* @__PURE__ */ jsxs("a", {
                    className: "feature-item relative h-full",
                    href: "#",
                    children: [/* @__PURE__ */ jsxs("div", {
                      className: "flex items-center justify-center h-12 w-12 rounded-md bg-primary-shade bg-opacity- text-white",
                      children: [/* @__PURE__ */ jsx(BiMessageRoundedAdd, {
                        className: "h-6 w-6"
                      }), " "]
                    }), /* @__PURE__ */ jsx("p", {
                      className: "mt-2 mb-2 text-lg leading-6 font-medium text-gray-900 text-left",
                      children: "Customise Profile"
                    }), /* @__PURE__ */ jsx("p", {
                      children: "Click here to join ideation Circle or create a Circle for your community"
                    })]
                  })
                })]
              })
            })
          })
        })
      })]
    })
  });
};

const CssOverrides = createGlobalStyle`
  #body {
    overflow-y: scroll;
  }
`;
const LandingPagesTest = ({
  prefix = ""
}) => {
  const location = useLocation();
  const pathname = location.pathname;
  let component = null;
  if (pathname.startsWith(prefix + "/landing/custom")) {
    component = /* @__PURE__ */ jsx(CustomLanding, {});
  }
  if (pathname.startsWith(prefix + "/landing/new")) {
    component = /* @__PURE__ */ jsx(NewCustomLanding, {});
  }
  if (pathname.startsWith(prefix + "/landing/simple")) {
    component = /* @__PURE__ */ jsx(LandingPage, {});
  }
  if (component) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(CssOverrides, {}), /* @__PURE__ */ jsx(CssLink, {
        href: "/static/core.css"
      }), component]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col",
    children: [/* @__PURE__ */ jsx(CssLink, {
      href: "/static/core.css"
    }), /* @__PURE__ */ jsx("a", {
      className: "link link-secondary",
      href: prefix + "/landing/simple",
      children: "Landing Page"
    }), /* @__PURE__ */ jsx("a", {
      className: "link link-secondary",
      href: prefix + "/landing/custom",
      children: "Landing Page Custom"
    }), /* @__PURE__ */ jsx("a", {
      className: "link link-secondary",
      href: prefix + "/landing/new",
      children: "Landing Page Blue"
    })]
  });
};

const CreateAssetDialog = (props) => {
  const {
    open,
    onClose
  } = props;
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$6, {
    fullScreen: true,
    ...props,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: "Add asset"
    }), /* @__PURE__ */ jsx(FillForm, {
      onCreated: () => onClose(new Event("created"), "backdropClick")
    })]
  });
};
const CreateAssetDialogV2 = (props) => {
  const {
    open,
    onClose,
    draftId
  } = props;
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsx(Dialog$6, {
    fullScreen: true,
    ...props,
    children: /* @__PURE__ */ jsx(EditAssetPage, {
      draftId,
      className: "overflow-y-scroll",
      onCancel: () => onClose(new Event("created"), "backdropClick")
    })
  });
};

const Wrapper$C = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
`;
const FormTest = () => {
  const api = useApi();
  const [view, setView] = useState(null);
  const [circleId, setCircleId] = useState("63347f1c71697d10f868dea8");
  const [postId, setPostId] = useState("6357b745af149f10303ed8c1");
  const [openCreateDialog, setOpenCreate] = useState(false);
  const [openEditDialog, setOpenEdit] = useState(false);
  const [openMoveDialog, setOpenMove] = useState(false);
  const handleCircleChange = (e) => {
    setCircleId(e.target.value);
  };
  const handlePostChange = (e) => {
    setPostId(e.target.value);
  };
  const onViewForm = async () => {
    setView(null);
    const post = await api.loadPostById({
      _id: postId
    });
    setView(post);
  };
  const afterCreateEdit = () => {
    setOpenCreate(false);
    setOpenEdit(false);
    setOpenMove(false);
    setView(null);
  };
  return /* @__PURE__ */ jsx(FormDataContextProvider, {
    circleId,
    old: openEditDialog && view.form.data || void 0,
    draftId: view && view.draft,
    tags: view && view.tags || void 0,
    children: /* @__PURE__ */ jsxs(Wrapper$C, {
      children: [/* @__PURE__ */ jsxs(Section, {
        children: [/* @__PURE__ */ jsx(SectionHeader, {
          children: "Create, view, edit (to save provide circle ID)"
        }), /* @__PURE__ */ jsx(PlaygroundTextField, {
          autoFocus: true,
          label: "Circle ID (to save)",
          placeholder: "Circle ID (to save)",
          value: circleId,
          onChange: handleCircleChange
        }), /* @__PURE__ */ jsx(PlaygroundTextField, {
          autoFocus: true,
          label: "Post Id",
          placeholder: "Post Id",
          value: postId,
          onChange: handlePostChange
        }), /* @__PURE__ */ jsxs(PlaygroundActions, {
          children: [/* @__PURE__ */ jsx(Button, {
            variant: "contained",
            color: "primary",
            onClick: () => setOpenCreate(true),
            children: "Create Asset Dialog"
          }), /* @__PURE__ */ jsx(Button, {
            disabled: !postId,
            variant: "contained",
            color: "primary",
            onClick: onViewForm,
            children: "View Asset"
          }), /* @__PURE__ */ jsx(Button, {
            disabled: !view,
            variant: "contained",
            color: "primary",
            onClick: () => setOpenMove(true),
            children: "Open Move Dialog"
          }), /* @__PURE__ */ jsx(Button, {
            variant: "contained",
            color: "primary",
            onClick: () => setOpenEdit(true),
            disabled: !view,
            children: "Open Edit Dialog"
          })]
        })]
      }), /* @__PURE__ */ jsx(CreateAssetDialog, {
        open: openCreateDialog,
        onClose: afterCreateEdit
      }), /* @__PURE__ */ jsx(CreateAssetDialog, {
        open: openEditDialog,
        onClose: afterCreateEdit
      }), /* @__PURE__ */ jsx(MoveAssetDialog, {
        open: openMoveDialog,
        onClose: afterCreateEdit,
        post: view
      }), view && /* @__PURE__ */ jsx(FormView, {
        value: view.form && view.form.data,
        tags: view.tags
      })]
    })
  });
};

const ActivityDashboard = (props) => {
  return /* @__PURE__ */ jsxs(Fragment$1, {
    children: [/* @__PURE__ */ jsx(CssLink, {
      href: "/static/core.css"
    }), /* @__PURE__ */ jsx("div", {
      className: "bg-white",
      children: /* @__PURE__ */ jsx("div", {
        className: "max-w-7xl mx-auto relative ",
        children: /* @__PURE__ */ jsx("div", {
          className: "",
          children: /* @__PURE__ */ jsxs("dl", {
            className: "md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "relative title-block en lg:max-w-lg pl-4 pr-4 sm:pl-6 lg:pl-8 pt-4 sm:pr-6 sm:pt-6 sm:pb-10 lg:pt-1 lg:h-screen",
              children: [/* @__PURE__ */ jsxs("h1", {
                className: "mt-5 text-3xl tracking-tight font-bold sm:text-3xl md:text-3xl lg:text-4xl text-font-base landing-title",
                children: [/* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.title`
                }), " ", /* @__PURE__ */ jsx("span", {
                  className: "inline-block text-primary-color",
                  children: /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.circles`
                  })
                })]
              }), /* @__PURE__ */ jsxs("p", {
                className: "mt-3 text-base text-font-sub pb-[20px] sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0",
                children: [/* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.pre_desc`
                }), " ", /* @__PURE__ */ jsxs("span", {
                  className: "inline-block text-primary-color",
                  children: ["'", /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.circles`
                  }), "'"]
                }), " ", /* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.post_desc`
                })]
              }), /* @__PURE__ */ jsx("div", {
                className: "img-container",
                children: /* @__PURE__ */ jsxs("a", {
                  href: "/",
                  children: [" ", /* @__PURE__ */ jsx("span", {
                    className: "sr-only",
                    children: "NewsSocial"
                  }), /* @__PURE__ */ jsx("div", {
                    className: "img-banner sm:mt:10"
                  })]
                })
              })]
            }), /* @__PURE__ */ jsxs("div", {
              className: "relative title-block ar mt-5 lg:max-w-lg pl-4 pr-4 sm:pl-6 lg:pl-8 pt-4 sm:pr-6 sm:pt-6 sm:pb-10 lg:pt-1 lg:h-screen",
              children: [/* @__PURE__ */ jsxs("div", {
                className: "mt-5",
                children: [/* @__PURE__ */ jsx("span", {
                  className: "text-3xl tracking-tight font-bold sm:text-3xl md:text-3xl lg:text-4xl text-font-base landing-title",
                  children: /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.title_ar`
                  })
                }), "\xA0\xA0", /* @__PURE__ */ jsx("span", {
                  className: "text-primary-color text-3xl tracking-tight font-bold sm:text-3xl md:text-3xl lg:text-4x landing-title",
                  children: /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.circles_ar`
                  })
                })]
              }), /* @__PURE__ */ jsxs("p", {
                className: "mt-3 text-base text-font-sub pb-[20px] sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0",
                children: [/* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.pre_desc_ar`
                }), " ", /* @__PURE__ */ jsxs("span", {
                  className: "inline-block text-primary-color",
                  children: ["'", /* @__PURE__ */ jsx(FormattedMessage, {
                    id: `overview_page.circles_ar`
                  }), "'"]
                }), " ", /* @__PURE__ */ jsx(FormattedMessage, {
                  id: `overview_page.post_desc_ar`
                })]
              }), /* @__PURE__ */ jsx("div", {
                className: "img-container",
                children: /* @__PURE__ */ jsxs("a", {
                  href: "/",
                  children: [" ", /* @__PURE__ */ jsx("span", {
                    className: "sr-only",
                    children: "NewsSocial"
                  }), /* @__PURE__ */ jsx("div", {
                    className: "img-banner sm:mt:10"
                  })]
                })
              })]
            }), /* @__PURE__ */ jsx("div", {
              className: "relative bg-primary-shade bg-opacity-25 sm:pr-6 sm:pl-8 sm:pb-10 md:pr-8 md:pl-8 md:pt-8 lg:pr-8 lg:pl-8 lg:pt-8 lg:h-screen",
              children: /* @__PURE__ */ jsx("div", {
                className: "",
                children: /* @__PURE__ */ jsx("div", {
                  className: "feature-list-right feature-block lg:pt-10 sm:pt-[5px] feature-block lg:max-w-lg",
                  children: /* @__PURE__ */ jsxs("dl", {
                    className: "space-y-5 md:space-y-10 lg:space-y-10 md:gap-x-8 md:gap-y-10",
                    children: [/* @__PURE__ */ jsx("a", {
                      className: "feature-item relative",
                      href: "/groups",
                      children: /* @__PURE__ */ jsxs("div", {
                        className: "mt-[10px] md:mt-[5px] lg:mt-[10px] hover:shadow-lg p-[10px] hover:bg-white hover:rounded-md hover:bg-opacity-80 ",
                        children: [" ", /* @__PURE__ */ jsxs("dt", {
                          children: [/* @__PURE__ */ jsx("div", {
                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-ns-red ",
                            children: /* @__PURE__ */ jsx(BiMessageRoundedAdd, {
                              className: "h-6 w-6 text-white"
                            })
                          }), /* @__PURE__ */ jsx("p", {
                            className: "text-lg leading-6 font-bold text-gray-900",
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_one`
                            })
                          })]
                        }), /* @__PURE__ */ jsx("dd", {
                          className: "mt-2 text-base text-gray-500",
                          children: /* @__PURE__ */ jsx("p", {
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_one_desc`
                            })
                          })
                        })]
                      })
                    }), /* @__PURE__ */ jsx("a", {
                      className: "feature-item relative",
                      href: "/",
                      children: /* @__PURE__ */ jsxs("div", {
                        className: "lg:mt-[10px] hover:shadow-lg p-[10px] hover:bg-white hover:rounded-md hover:bg-opacity-80 ",
                        children: [" ", /* @__PURE__ */ jsxs("dt", {
                          children: [/* @__PURE__ */ jsx("div", {
                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-ns-orange ",
                            children: /* @__PURE__ */ jsx(BiSearchAlt, {
                              className: "h-6 w-6 text-white"
                            })
                          }), /* @__PURE__ */ jsx("p", {
                            className: "text-lg leading-6 font-bold text-gray-900",
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_two`
                            })
                          })]
                        }), /* @__PURE__ */ jsx("dd", {
                          className: "mt-2 text-base text-gray-500",
                          children: /* @__PURE__ */ jsx("p", {
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_two_desc`
                            })
                          })
                        })]
                      })
                    }), /* @__PURE__ */ jsx("a", {
                      className: "feature-item relative ",
                      href: "/profile",
                      children: /* @__PURE__ */ jsxs("div", {
                        className: "lg:mt-[10px] hover:shadow-lg p-[10px] hover:bg-white hover:rounded-md hover:bg-opacity-80 ",
                        children: [" ", /* @__PURE__ */ jsxs("dt", {
                          children: [/* @__PURE__ */ jsx("div", {
                            className: "absolute flex items-center justify-center h-12 w-12 rounded-md bg-ns-purple",
                            children: /* @__PURE__ */ jsx(FaUserEdit, {
                              className: "h-6 w-6 text-white"
                            })
                          }), /* @__PURE__ */ jsx("p", {
                            className: "text-lg leading-6 font-bold text-gray-900",
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_three`
                            })
                          })]
                        }), /* @__PURE__ */ jsx("dd", {
                          className: "mt-2 text-base text-gray-500",
                          children: /* @__PURE__ */ jsx("p", {
                            children: /* @__PURE__ */ jsx(FormattedMessage, {
                              id: `overview_page.feature_three_desc`
                            })
                          })
                        }), " "]
                      })
                    })]
                  })
                })
              })
            })]
          })
        })
      })
    })]
  });
};

const CDNImageContextProviderStaging = ({
  children
}) => {
  const instanceName = "newssocial.uk";
  return /* @__PURE__ */ jsx(CDNImageContext.Provider, {
    value: {
      cdnRoot: IMAGE_CDN_ROOT,
      instanceName,
      baseUrl(instanceNameOverride) {
        return `${IMAGE_CDN_ROOT}${instanceNameOverride || instanceName}`;
      }
    },
    children
  });
};

const COVER_WIDTH$2 = 1200;
const COVER_HEIGHT$2 = 900;
const testImage1$2 = {
  contentType: "image/png",
  dimensions: {
    width: 640,
    height: 480
  },
  originalFileName: "pencil.png",
  originalFileSize: 57758,
  uuid: "f4a84a08-ef2a-41ce-bfd1-da4c77e6ac0d/pencil.png",
  _id: "62d967c662baf600132a95c9"
};
const sampleCircleItemData$1 = {
  _id: 1,
  image: testImage1$2,
  name: "NEWSSOCIAL",
  privacy: "PUBLIC",
  stats: {
    memberCount: 5,
    postCount: 30
  },
  tags: ["#newssocial", "#cooperate", "#test", "#newssocial"],
  subcircles: [{
    _id: 2,
    image: testImage1$2,
    name: "Preston",
    privacy: "REGISTERED",
    stats: {
      memberCount: 3,
      postCount: 11
    },
    tags: ["#newssocial", "#cooperate", "#test", "#newssocial", "#sustainable development"],
    subcircles: [{
      _id: 3,
      image: testImage1$2,
      name: "Social Business Value Approach",
      privacy: "PRIVATE",
      stats: {
        memberCount: 7,
        postCount: 14
      },
      tags: ["#cornet", "#cooperate", "#test", "#newssocial", "#sustainable development"],
      subcircles: [{
        _id: 4,
        image: testImage1$2,
        name: "Social Value Business Approach",
        privacy: "PRIVATE",
        stats: {
          memberCount: 7,
          postCount: 14
        },
        tags: ["#cornet", "#cooperate", "#test", "#newssocial", "#sustainable development"],
        subcircles: []
      }]
    }]
  }]
};
const useStyles$2 = makeStyles$1((theme) => createStyles({
  root: {
    width: "100%",
    overflow: "hidden",
    position: "relative",
    boxShadow: "0px 4px 8px rgb(0 0 0 / 12%)",
    minHeight: "194px",
    borderRadius: "8px",
    margin: "0.5em",
    backgroundColor: "#fff",
    cursor: "pointer",
    display: "flex",
    flexWrap: "wrap"
  },
  avatar: {
    border: "2px solid #ddd",
    backgroundColor: "#ddd",
    marginRight: "10px",
    height: "90px",
    width: "90px",
    minWidth: "90px",
    borderRadius: "50%",
    "& img": {
      borderRadius: "50%",
      width: "90px",
      height: "90px",
      position: "absolute",
      left: "-9px",
      top: "0"
    }
  },
  accordion: {
    margin: "5px",
    boxShadow: "none",
    paddingLeft: "8px",
    "& .Mui-expanded": {
      marginBottom: "0",
      marginTop: "1px"
    },
    "& .MuiAccordion-root.Mui-expanded": {
      margin: "0"
    }
  },
  button: {
    height: "10px",
    minWidth: "5px",
    cursor: "pointer",
    backgroundColor: "transparent",
    padding: "0",
    marginTop: "10px",
    "z-index": "9999"
  },
  title: {
    fontWeight: "bold",
    color: "rgba(0, 0, 0, 0.87) !important",
    textTransform: "capitalize",
    lineHeight: "22px",
    fontSize: "16px",
    [theme.breakpoints.down("xs")]: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      width: "240px"
    },
    "& li": {
      padding: "0"
    }
  },
  circleItem: {
    position: "relative",
    padding: "0",
    marginLeft: "10px"
  },
  accordionSummary: {
    borderRadius: "3px",
    paddingTop: "0",
    paddingBottom: "0",
    margin: "1px 0 !important"
  },
  accordionSummaryContent: {
    margin: "15px 0 0",
    width: "100%"
  },
  subText: {
    fontSize: "0.75em",
    color: "#999",
    paddingTop: "0",
    display: "block",
    marginTop: "3px",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },
    "& li": {
      padding: "0",
      [theme.breakpoints.down("xs")]: {
        width: "auto",
        flex: "none"
      },
      "& div": {
        padding: "0 1px"
      },
      "& p": {
        fontSize: "11px"
      },
      "& .MuiListItemText-root": {
        width: "auto",
        [theme.breakpoints.down("xs")]: {
          width: "auto",
          flex: "none"
        }
      }
    }
  },
  "& <div>": {
    border: "0",
    boxShadow: "none",
    margin: "0"
  },
  accordionDetails: {
    padding: "0 0 8px",
    width: "100%",
    flexDirection: "column"
  },
  section: {
    width: "100%"
  },
  tag: {
    [theme.breakpoints.down("xs")]: {
      display: "block",
      width: "100%",
      float: "left"
    }
  },
  tagSingle: {
    display: "inline-flex",
    lineHeight: "13px",
    borderRadius: "0.7em",
    padding: "0 5px 0 0 !important",
    pointerEvents: "none",
    cursor: "none"
  },
  post: {
    paddingRight: "10px",
    display: "inline-block",
    float: "left",
    marginTop: "3px"
  },
  member: {
    paddingRight: "10px",
    display: "inline-block",
    float: "left",
    marginTop: "3px"
  },
  colContainer: {
    display: "flex",
    width: "100%"
  },
  circleDetails: {
    width: "100%"
  },
  arrowDown: {
    width: "0",
    height: "0",
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: "6px solid #000",
    marginTop: "5px"
  },
  arrowRight: {
    width: "0",
    height: "0",
    borderTop: "6px solid transparent",
    borderBottom: "6px solid transparent",
    borderLeft: "6px solid #000",
    marginTop: "5px"
  },
  privacy: {
    margin: "0",
    "& span": {
      textTransform: "capitalize",
      fontSize: "0.75em",
      color: "#999"
    }
  }
}));
const CircleItemImage$1 = ({
  image
}) => {
  if (!image) {
    return null;
  }
  return /* @__PURE__ */ jsx(ScaledImageProxy, {
    uuid: image && image.uuid,
    w: COVER_WIDTH$2,
    h: COVER_HEIGHT$2,
    crop: false
  });
};
const CircleItem = ({
  data
}) => {
  const {
    name,
    stats: {
      postCount,
      memberCount
    },
    tags,
    subcircles,
    image,
    _id,
    privacy
  } = data;
  const classes = useStyles$2();
  const subCircleItem = subcircles.map((c) => /* @__PURE__ */ jsx(CircleItem, {
    data: c
  }));
  const [expanded, setExpanded] = React__default.useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return /* @__PURE__ */ jsxs(Accordion, {
    className: classes.accordion,
    expanded: expanded === "panel1",
    onChange: handleChange("panel1"),
    style: {
      margin: "0"
    },
    children: [/* @__PURE__ */ jsxs(AccordionSummary$1, {
      "aria-controls": "panel1a-content",
      id: "panel1a-header",
      className: classes.accordionSummary,
      children: [subCircleItem.length > 0 ? /* @__PURE__ */ jsx(Link$1, {
        className: classes.button,
        children: expanded ? /* @__PURE__ */ jsx(Tooltip$2, {
          title: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "circle_listing.collapse"
          }),
          "aria-label": "Collapse sub circles",
          children: /* @__PURE__ */ jsx("div", {
            className: classes.arrowDown
          })
        }) : /* @__PURE__ */ jsx(Tooltip$2, {
          title: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "circle_listing.expand"
          }),
          "aria-label": "Expand sub circles",
          children: /* @__PURE__ */ jsx("div", {
            className: classes.arrowRight
          })
        })
      }) : null, /* @__PURE__ */ jsx(Link$1, {
        className: classes.accordionSummaryContent,
        onClick: (e) => {
          e.stopPropagation();
        },
        component: Link$2,
        to: `/groups/${_id}`,
        underline: "none",
        children: /* @__PURE__ */ jsx(ListItem, {
          className: classes.circleItem,
          children: /* @__PURE__ */ jsxs("ul", {
            className: classes.colContainer,
            style: {
              listStyle: "none",
              marginLeft: "-10px"
            },
            children: [/* @__PURE__ */ jsx("li", {
              children: /* @__PURE__ */ jsx(Tooltip$2, {
                title: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: "circle_listing.go_to_circle"
                }),
                "aria-label": "Click to go to circle",
                children: /* @__PURE__ */ jsx(ListItemAvatar, {
                  className: classes.avatar,
                  children: /* @__PURE__ */ jsx(CircleItemImage$1, {
                    image
                  })
                })
              })
            }), /* @__PURE__ */ jsxs("li", {
              className: classes.circleDetails,
              children: [/* @__PURE__ */ jsx(Tooltip$2, {
                title: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: "circle_listing.go_to_circle"
                }),
                "aria-label": "Click to go to circle",
                children: /* @__PURE__ */ jsx("div", {
                  className: classes.title,
                  children: name
                })
              }), /* @__PURE__ */ jsx("div", {
                className: classes.subText,
                children: /* @__PURE__ */ jsx("div", {
                  className: classes.privacy,
                  children: /* @__PURE__ */ jsx("span", {
                    children: privacy
                  })
                })
              }), /* @__PURE__ */ jsx("div", {
                className: classes.subText,
                children: /* @__PURE__ */ jsx("div", {
                  className: classes.tag,
                  children: /* @__PURE__ */ jsx("ul", {
                    style: {
                      listStyle: "none"
                    },
                    children: tags.map((tag) => /* @__PURE__ */ jsxs("li", {
                      className: classes.tagSingle,
                      children: ["#", tag]
                    }))
                  })
                })
              }), /* @__PURE__ */ jsxs("div", {
                className: classes.subText,
                children: [/* @__PURE__ */ jsxs("div", {
                  className: classes.post,
                  children: [/* @__PURE__ */ jsx("span", {
                    children: postCount
                  }), /* @__PURE__ */ jsxs("span", {
                    children: ["\xA0", /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "circle_listing.c_posts"
                    }), "\xA0\xA0\u2022"]
                  })]
                }), /* @__PURE__ */ jsxs("div", {
                  className: classes.member,
                  children: [/* @__PURE__ */ jsx("span", {
                    children: memberCount
                  }), /* @__PURE__ */ jsxs("span", {
                    children: ["\xA0", /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "circle_listing.c_members"
                    })]
                  })]
                })]
              })]
            })]
          })
        })
      })]
    }), /* @__PURE__ */ jsx(AccordionDetails, {
      className: classes.accordionDetails,
      children: subcircles.map((c) => /* @__PURE__ */ jsx(CircleItem, {
        data: c
      }))
    })]
  });
};
const CircleItemTest = () => {
  useStyles$2();
  return /* @__PURE__ */ jsx(CDNImageContextProviderStaging, {
    children: /* @__PURE__ */ jsxs(List, {
      style: {
        padding: "0"
      },
      children: [/* @__PURE__ */ jsx(CircleItem, {
        data: sampleCircleItemData$1
      }), /* @__PURE__ */ jsx(CircleItem, {
        data: sampleCircleItemData$1
      }), /* @__PURE__ */ jsx(CircleItem, {
        data: sampleCircleItemData$1
      })]
    })
  });
};

new API({
  root: "newssocial.uk/ua"
});
const COVER_WIDTH$1 = 1200;
const COVER_HEIGHT$1 = 900;
const testImage1$1 = {
  contentType: "image/png",
  dimensions: {
    width: 640,
    height: 480
  },
  originalFileName: "pencil.png",
  originalFileSize: 57758,
  uuid: "f4a84a08-ef2a-41ce-bfd1-da4c77e6ac0d/pencil.png",
  _id: "62d967c662baf600132a95c9"
};
const sampleDiscoverCircleItemData = {
  _id: 1,
  image: testImage1$1,
  name: "NEWSSOCIAL",
  privacy: "PUBLIC",
  stats: {
    memberCount: 5,
    postCount: 30
  },
  tags: ["#newssocial", "#cooperate", "#test", "#newssocial"],
  subcircles: [{
    _id: 2,
    image: testImage1$1,
    name: "Preston",
    privacy: "REGISTERED",
    stats: {
      memberCount: 3,
      postCount: 11
    },
    tags: ["#newssocial", "#cooperate", "#test", "#newssocial", "#sustainable development"],
    subcircles: [{
      _id: 3,
      image: testImage1$1,
      name: "Social Business Value Approach",
      privacy: "PRIVATE",
      stats: {
        memberCount: 7,
        postCount: 14
      },
      tags: ["#cornet", "#cooperate", "#test", "#newssocial", "#sustainable development"],
      subcircles: [{
        _id: 4,
        image: testImage1$1,
        name: "Social Value Business Approach",
        privacy: "PRIVATE",
        stats: {
          memberCount: 7,
          postCount: 14
        },
        tags: ["#cornet", "#cooperate", "#test", "#newssocial", "#sustainable development"],
        subcircles: []
      }]
    }]
  }]
};
const useStyles$1 = makeStyles$1((theme) => createStyles({
  root: {
    width: "100%",
    overflow: "hidden",
    position: "relative",
    boxShadow: "0px 4px 8px rgb(0 0 0 / 12%)",
    minHeight: "194px",
    borderRadius: "8px",
    margin: "0.5em",
    backgroundColor: "#fff",
    cursor: "pointer",
    display: "flex",
    flexWrap: "wrap"
  },
  avatar: {
    border: "2px solid #ddd",
    backgroundColor: "#ddd",
    marginRight: "10px",
    height: "50px",
    width: "50px",
    minWidth: "50px",
    borderRadius: "50%",
    "& img": {
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      position: "absolute",
      left: "0",
      top: "0"
    }
  },
  accordion: {
    margin: "5px",
    boxShadow: "none",
    "& .MuiCollapse-container MuiCollapse-entered": {
      backgroundColor: "#f2f2f5"
    },
    "& .Mui-expanded": {
      backgroundColor: "#f2f2f5",
      marginBottom: "0",
      paddingLeft: "8px",
      marginTop: "2px"
    },
    "& .MuiAccordion-root.Mui-expanded": {
      margin: "0"
    }
  },
  button: {
    height: "10px",
    minWidth: "5px",
    position: "absolute",
    left: "9px",
    top: "22px",
    fontSize: "10px",
    textTransform: "capitalize",
    textDecoration: "underline",
    cursor: "pointer",
    backgroundColor: "transparent",
    padding: "0"
  },
  title: {
    fontWeight: "bold",
    color: "#000",
    textTransform: "capitalize",
    lineHeight: "17px",
    marginTop: "5px",
    [theme.breakpoints.down("xs")]: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      width: "240px"
    },
    "& li": {
      padding: "0"
    }
  },
  circleItem: {
    position: "relative",
    padding: "0",
    marginLeft: "10px"
  },
  accordionSummary: {
    borderRadius: "3px",
    paddingTop: "0",
    paddingBottom: "0",
    backgroundColor: "#f2f2f5",
    margin: "1px 0"
  },
  accordionSummaryContent: {
    margin: "15px 0 0",
    width: "100%"
  },
  subText: {
    fontSize: "10px",
    paddingTop: "0",
    display: "block",
    marginTop: "3px",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },
    "& li": {
      padding: "0",
      [theme.breakpoints.down("xs")]: {
        width: "auto",
        flex: "none"
      },
      "& div": {
        padding: "0 1px"
      },
      "& p": {
        fontSize: "11px"
      },
      "& .MuiListItemText-root": {
        width: "auto",
        [theme.breakpoints.down("xs")]: {
          width: "auto",
          flex: "none"
        }
      }
    }
  },
  "& <div>": {
    border: "0",
    boxShadow: "none",
    margin: "0"
  },
  accordionDetails: {
    padding: "0 0 8px",
    width: "100%",
    backgroundColor: "#f2f2f5",
    flexDirection: "column"
  },
  section: {
    width: "100%"
  },
  tag: {
    [theme.breakpoints.down("xs")]: {
      display: "block",
      width: "100%",
      float: "left"
    }
  },
  tagSingle: {
    display: "inline-flex",
    lineHeight: "13px",
    color: "#636972",
    borderRadius: "0.7em",
    padding: "0 5px 0 0 !important",
    pointerEvents: "none",
    cursor: "none"
  },
  post: {
    paddingRight: "10px",
    display: "inline-block",
    float: "left"
  },
  member: {
    paddingRight: "10px",
    display: "inline-block",
    float: "left"
  },
  colContainer: {
    display: "flex",
    width: "100%"
  },
  circleDetails: {
    width: "100%"
  },
  arrowDown: {
    width: "0",
    height: "0",
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: "6px solid #000"
  },
  arrowRight: {
    width: "0",
    height: "0",
    borderTop: "6px solid transparent",
    borderBottom: "6px solid transparent",
    borderLeft: "6px solid #000",
    marginTop: "7px"
  },
  privacy: {
    margin: "10px 0 8px",
    "& span": {
      padding: "3px 8px",
      border: "1px solid #ddd",
      borderRadius: "20px",
      backgroundColor: "#E1E4E9",
      textTransform: "uppercase"
    }
  }
}));
const DiscoverCircleItemImage = ({
  image
}) => {
  if (!image) {
    return null;
  }
  return /* @__PURE__ */ jsx(ScaledImageProxy, {
    uuid: image && image.uuid,
    w: COVER_WIDTH$1,
    h: COVER_HEIGHT$1,
    crop: false
  });
};
const DiscoverCircleItem = ({
  data
}) => {
  const {
    name,
    stats: {
      postCount,
      memberCount
    },
    tags,
    subcircles,
    image,
    _id,
    privacy
  } = data;
  const classes = useStyles$1();
  const [expanded, setExpanded] = React__default.useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return /* @__PURE__ */ jsxs(Accordion, {
    className: classes.accordion,
    expanded: expanded === "panel1",
    onChange: handleChange("panel1"),
    style: {
      margin: "0"
    },
    children: [/* @__PURE__ */ jsx(AccordionSummary$1, {
      "aria-controls": "panel1a-content",
      id: "panel1a-header",
      className: classes.accordionSummary,
      children: /* @__PURE__ */ jsx(Link$1, {
        className: classes.accordionSummaryContent,
        onClick: (e) => {
          e.stopPropagation();
        },
        component: Link$2,
        to: `/groups/${_id}`,
        underline: "none",
        children: /* @__PURE__ */ jsx(ListItem, {
          className: classes.circleItem,
          children: /* @__PURE__ */ jsxs("ul", {
            className: classes.colContainer,
            style: {
              listStyle: "none"
            },
            children: [/* @__PURE__ */ jsx("li", {
              children: /* @__PURE__ */ jsx(Tooltip$2, {
                title: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: "circle_listing.go_to_circle"
                }),
                "aria-label": "Click to go to circle",
                children: /* @__PURE__ */ jsx(ListItemAvatar, {
                  className: classes.avatar,
                  children: /* @__PURE__ */ jsx(DiscoverCircleItemImage, {
                    image
                  })
                })
              })
            }), /* @__PURE__ */ jsxs("li", {
              className: classes.circleDetails,
              children: [/* @__PURE__ */ jsx(Tooltip$2, {
                title: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: "circle_listing.go_to_circle"
                }),
                "aria-label": "Click to go to circle",
                children: /* @__PURE__ */ jsx("div", {
                  className: classes.title,
                  children: name
                })
              }), /* @__PURE__ */ jsx("div", {
                className: classes.subText,
                children: /* @__PURE__ */ jsx("div", {
                  className: classes.privacy,
                  children: /* @__PURE__ */ jsx("span", {
                    children: privacy
                  })
                })
              }), /* @__PURE__ */ jsx("div", {
                className: classes.subText,
                children: /* @__PURE__ */ jsx("div", {
                  className: classes.tag,
                  children: /* @__PURE__ */ jsx("ul", {
                    style: {
                      listStyle: "none"
                    },
                    children: tags.map((tag) => /* @__PURE__ */ jsxs("li", {
                      className: classes.tagSingle,
                      children: ["#", tag]
                    }))
                  })
                })
              }), /* @__PURE__ */ jsxs("div", {
                className: classes.subText,
                children: [/* @__PURE__ */ jsxs("div", {
                  className: classes.post,
                  children: [/* @__PURE__ */ jsx("span", {
                    children: postCount
                  }), /* @__PURE__ */ jsxs("span", {
                    children: ["\xA0", /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "circle_listing.c_posts"
                    }), "\xA0\xA0\u2022"]
                  })]
                }), /* @__PURE__ */ jsxs("div", {
                  className: classes.member,
                  children: [/* @__PURE__ */ jsx("span", {
                    children: memberCount
                  }), /* @__PURE__ */ jsxs("span", {
                    children: ["\xA0", /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "circle_listing.c_members"
                    })]
                  })]
                })]
              })]
            })]
          })
        })
      })
    }), subcircles && (subcircles.length || null) && /* @__PURE__ */ jsxs(AccordionDetails, {
      className: classes.accordionDetails,
      children: [/* @__PURE__ */ jsx(Link$1, {
        className: classes.button,
        children: expanded ? /* @__PURE__ */ jsx(Tooltip$2, {
          title: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "circle_listing.collapse"
          }),
          "aria-label": "Collapse sub circles",
          children: /* @__PURE__ */ jsx("div", {
            className: classes.arrowDown
          })
        }) : /* @__PURE__ */ jsx(Tooltip$2, {
          title: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "circle_listing.expand"
          }),
          "aria-label": "Expand sub circles",
          children: /* @__PURE__ */ jsx("div", {
            className: classes.arrowRight
          })
        })
      }), subcircles.map((c) => /* @__PURE__ */ jsx(DiscoverCircleItem, {
        data: c
      }))]
    })]
  });
};
const DiscoverCircles = () => {
  useStyles$1();
  return /* @__PURE__ */ jsx(CDNImageContextProviderStaging, {
    children: /* @__PURE__ */ jsx(List, {
      style: {
        padding: "0"
      },
      children: /* @__PURE__ */ jsx(DiscoverCircleItem, {
        data: sampleDiscoverCircleItemData
      })
    })
  });
};

const COVER_WIDTH = 1200;
const COVER_HEIGHT = 900;
const useStyles = makeStyles$1((theme) => createStyles({
  root: {
    width: "100%",
    overflow: "hidden",
    position: "relative",
    boxShadow: "0px 4px 8px rgb(0 0 0 / 12%)",
    minHeight: "194px",
    borderRadius: "8px",
    margin: "0.5em",
    backgroundColor: "#fff",
    cursor: "pointer",
    display: "flex",
    flexWrap: "wrap"
  },
  avatar: {
    border: "2px solid #ddd",
    backgroundColor: "#ddd",
    marginRight: "10px",
    height: "50px",
    width: "50px",
    minWidth: "50px",
    borderRadius: "50%",
    "& img": {
      borderRadius: "50%",
      width: "50px",
      height: "50px",
      position: "absolute",
      left: "0",
      top: "0"
    }
  },
  accordion: {
    margin: "5px",
    boxShadow: "none",
    "& .MuiCollapse-container MuiCollapse-entered": {
      backgroundColor: "#f2f2f5"
    },
    "& .Mui-expanded": {
      backgroundColor: "#f2f2f5",
      marginBottom: "0",
      paddingLeft: "8px",
      marginTop: "2px"
    },
    "& .MuiAccordion-root.Mui-expanded": {
      margin: "0"
    }
  },
  button: {
    height: "10px",
    minWidth: "5px",
    position: "absolute",
    left: "9px",
    top: "22px",
    fontSize: "10px",
    textTransform: "capitalize",
    textDecoration: "underline",
    cursor: "pointer",
    backgroundColor: "transparent",
    padding: "0"
  },
  title: {
    fontWeight: "bold",
    color: "#000",
    textTransform: "capitalize",
    lineHeight: "17px",
    marginTop: "5px",
    [theme.breakpoints.down("xs")]: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      width: "240px"
    },
    "& li": {
      padding: "0"
    }
  },
  circleItem: {
    position: "relative",
    padding: "0",
    marginLeft: "10px"
  },
  accordionSummary: {
    borderRadius: "3px",
    paddingTop: "0",
    paddingBottom: "0",
    backgroundColor: "#f2f2f5",
    margin: "1px 0"
  },
  accordionSummaryContent: {
    margin: "15px 0 0",
    width: "100%"
  },
  subText: {
    fontSize: "10px",
    paddingTop: "0",
    display: "block",
    marginTop: "3px",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },
    "& li": {
      padding: "0",
      [theme.breakpoints.down("xs")]: {
        width: "auto",
        flex: "none"
      },
      "& div": {
        padding: "0 1px"
      },
      "& p": {
        fontSize: "11px"
      },
      "& .MuiListItemText-root": {
        width: "auto",
        [theme.breakpoints.down("xs")]: {
          width: "auto",
          flex: "none"
        }
      }
    }
  },
  "& <div>": {
    border: "0",
    boxShadow: "none",
    margin: "0"
  },
  accordionDetails: {
    padding: "0 0 8px",
    width: "100%",
    backgroundColor: "#f2f2f5",
    flexDirection: "column"
  },
  section: {
    width: "100%"
  },
  tag: {
    [theme.breakpoints.down("xs")]: {
      display: "block",
      width: "100%",
      float: "left"
    }
  },
  tagSingle: {
    display: "inline-flex",
    lineHeight: "13px",
    color: "#636972",
    borderRadius: "0.7em",
    padding: "0 5px 0 0 !important",
    pointerEvents: "none",
    cursor: "none"
  },
  post: {
    paddingRight: "10px",
    display: "inline-block",
    float: "left"
  },
  member: {
    paddingRight: "10px",
    display: "inline-block",
    float: "left"
  },
  colContainer: {
    display: "flex",
    width: "100%"
  },
  circleDetails: {
    width: "100%"
  },
  arrowDown: {
    width: "0",
    height: "0",
    borderLeft: "6px solid transparent",
    borderRight: "6px solid transparent",
    borderTop: "6px solid #000"
  },
  arrowRight: {
    width: "0",
    height: "0",
    borderTop: "6px solid transparent",
    borderBottom: "6px solid transparent",
    borderLeft: "6px solid #000",
    marginTop: "5px"
  }
}));
const CircleItemImage = ({
  image
}) => {
  if (!image) {
    return null;
  }
  return /* @__PURE__ */ jsx(ScaledImageProxy, {
    uuid: image && image.uuid,
    w: COVER_WIDTH,
    h: COVER_HEIGHT,
    crop: false
  });
};
const CircleItemDepricated = ({
  data
}) => {
  const {
    name,
    stats: {
      postCount,
      memberCount
    },
    tags,
    subcircles,
    image,
    _id
  } = data;
  const classes = useStyles();
  const subCircleItem = subcircles.map((c) => /* @__PURE__ */ jsx(CircleItemDepricated, {
    data: c
  }));
  const [expanded, setExpanded] = React__default.useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return /* @__PURE__ */ jsxs(Accordion, {
    className: classes.accordion,
    expanded: expanded === "panel1",
    onChange: handleChange("panel1"),
    style: {
      margin: "0"
    },
    children: [/* @__PURE__ */ jsxs(AccordionSummary$1, {
      "aria-controls": "panel1a-content",
      id: "panel1a-header",
      className: classes.accordionSummary,
      children: [subCircleItem.length > 0 ? /* @__PURE__ */ jsx(Link$1, {
        className: classes.button,
        children: expanded ? /* @__PURE__ */ jsx(Tooltip$2, {
          title: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "circle_listing.collapse"
          }),
          "aria-label": "Collapse sub circles",
          children: /* @__PURE__ */ jsx("img", {
            className: classes.arrowDown,
            src: "../static/images/up.png"
          })
        }) : /* @__PURE__ */ jsx(Tooltip$2, {
          title: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "circle_listing.expand"
          }),
          "aria-label": "Expand sub circles",
          children: /* @__PURE__ */ jsx("img", {
            className: classes.arrowRight,
            src: "/static/images/up.png"
          })
        })
      }) : null, /* @__PURE__ */ jsx(Link$1, {
        className: classes.accordionSummaryContent,
        onClick: (e) => {
          e.stopPropagation();
        },
        component: Link$2,
        to: `/groups/${_id}`,
        underline: "none",
        children: /* @__PURE__ */ jsx(ListItem, {
          className: classes.circleItem,
          children: /* @__PURE__ */ jsxs("ul", {
            className: classes.colContainer,
            style: {
              listStyle: "none"
            },
            children: [/* @__PURE__ */ jsx("li", {
              children: /* @__PURE__ */ jsx(Tooltip$2, {
                title: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: "circle_listing.go_to_circle"
                }),
                "aria-label": "Click to go to circle",
                children: /* @__PURE__ */ jsx(ListItemAvatar, {
                  className: classes.avatar,
                  children: /* @__PURE__ */ jsx(CircleItemImage, {
                    image
                  })
                })
              })
            }), /* @__PURE__ */ jsxs("li", {
              className: classes.circleDetails,
              children: [/* @__PURE__ */ jsx(Tooltip$2, {
                title: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: "circle_listing.go_to_circle"
                }),
                "aria-label": "Click to go to circle",
                children: /* @__PURE__ */ jsx("div", {
                  className: classes.title,
                  children: name
                })
              }), /* @__PURE__ */ jsx("div", {
                className: classes.subText,
                children: /* @__PURE__ */ jsx("div", {
                  className: classes.tag,
                  children: /* @__PURE__ */ jsx("ul", {
                    style: {
                      listStyle: "none"
                    },
                    children: tags.map((tag) => /* @__PURE__ */ jsxs("li", {
                      className: classes.tagSingle,
                      children: ["#", tag]
                    }))
                  })
                })
              }), /* @__PURE__ */ jsxs("div", {
                className: classes.subText,
                children: [/* @__PURE__ */ jsxs("div", {
                  className: classes.post,
                  children: [/* @__PURE__ */ jsx("span", {
                    children: postCount
                  }), /* @__PURE__ */ jsxs("span", {
                    children: ["\xA0", /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "circle_listing.c_posts"
                    }), "\xA0\xA0\u2022"]
                  })]
                }), /* @__PURE__ */ jsxs("div", {
                  className: classes.member,
                  children: [/* @__PURE__ */ jsx("span", {
                    children: memberCount
                  }), /* @__PURE__ */ jsxs("span", {
                    children: ["\xA0", /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "circle_listing.c_members"
                    })]
                  })]
                })]
              })]
            })]
          })
        })
      })]
    }), /* @__PURE__ */ jsx(AccordionDetails, {
      className: classes.accordionDetails,
      children: subcircles.map((c) => /* @__PURE__ */ jsx(CircleItemDepricated, {
        data: c
      }))
    })]
  });
};

const SampleNotification = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      children: /* @__PURE__ */ jsx(Badge$2, {
        badgeContent: "5",
        color: "secondary",
        children: /* @__PURE__ */ jsx(RiScales3Fill, {})
      })
    }), /* @__PURE__ */ jsx(IconButton$5, {
      children: /* @__PURE__ */ jsx(Badge$2, {
        badgeContent: "1",
        color: "secondary",
        children: /* @__PURE__ */ jsx(BiEdit, {})
      })
    }), /* @__PURE__ */ jsx(IconButton$5, {
      children: /* @__PURE__ */ jsx(Badge$2, {
        badgeContent: "2",
        color: "secondary",
        children: /* @__PURE__ */ jsx(MdEvent, {})
      })
    }), /* @__PURE__ */ jsx(IconButton$5, {
      children: /* @__PURE__ */ jsx(Badge$2, {
        color: "secondary",
        badgeContent: "10",
        children: /* @__PURE__ */ jsx(GiDiscussion, {})
      })
    })]
  });
};

const testImage1 = {
  contentType: "image/png",
  dimensions: {
    width: 640,
    height: 480
  },
  originalFileName: "pencil.png",
  originalFileSize: 57758,
  uuid: "f4a84a08-ef2a-41ce-bfd1-da4c77e6ac0d/pencil.png",
  _id: "62d967c662baf600132a95c9"
};
const testImage2 = {
  "dimensions": {
    "width": 3e3,
    "height": 2e3
  },
  "uuid": "2cb35dd0-75bf-4ac6-8c79-7d8b2ea5691e/people.jpg",
  "originalFileName": "people.jpg",
  "originalFileSize": 395495,
  "contentType": "image/jpeg",
  "_id": "632876376e0d43384c9029f2"
};

const sampleCircleItemData = {
  _id: "1",
  image: testImage1,
  name: "NEWSSOCIAL",
  privacy: "PUBLIC",
  stats: {
    memberCount: 5,
    postCount: 30
  },
  tags: ["#newssocial", "#cooperate", "#test", "#newssocial"],
  subcircles: void 0
};
const sampleCircleWithSubCirclesData = {
  _id: "1",
  image: testImage1,
  name: "NEWSSOCIAL",
  privacy: "PUBLIC",
  stats: {
    memberCount: 5,
    postCount: 30
  },
  tags: ["#newssocial", "#cooperate", "#test", "#newssocial"],
  subcircles: [{
    _id: "2",
    image: testImage1,
    name: "Preston",
    privacy: "REGISTERED",
    stats: {
      memberCount: 3,
      postCount: 11
    },
    tags: ["#newssocial", "#cooperate", "#test", "#newssocial", "#sustainable development"],
    subcircles: [{
      _id: "3",
      image: testImage1,
      name: "Social Business Value Approach",
      privacy: "PRIVATE",
      stats: {
        memberCount: 7,
        postCount: 14
      },
      tags: ["#cornet", "#cooperate", "#test", "#newssocial", "#sustainable development"],
      subcircles: [{
        _id: "4",
        image: testImage1,
        name: "Social Value Business Approach",
        privacy: "PRIVATE",
        stats: {
          memberCount: 7,
          postCount: 14
        },
        tags: ["#cornet", "#cooperate", "#test", "#newssocial", "#sustainable development"],
        subcircles: []
      }]
    }]
  }]
};

const PlaygroundSearchInput = () => {
  const {
    filter$
  } = useSearchContext();
  const [filter, setFilter] = useState();
  const handleChange = (e) => {
    const filter2 = e.target.value;
    setFilter(filter2);
    filter$.emit({
      filter: filter2
    });
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(PlaygroundTextField, {
      autoFocus: true,
      label: "Filter",
      placeholder: "Filter",
      value: filter,
      onChange: handleChange
    })
  });
};

const CicrleListItemComponentsInner = () => {
  const {
    data
  } = useMyCirclesWithFilter();
  return /* @__PURE__ */ jsx(CardThemeProvider, {
    children: /* @__PURE__ */ jsx(CDNImageContextProviderStaging, {
      children: /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Line of text"
          }), /* @__PURE__ */ jsx(SubText, {
            children: "line of text"
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Privacy badges"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Public"
          }), /* @__PURE__ */ jsx(CardChip$1, {
            children: "public"
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Tags"
          }), /* @__PURE__ */ jsx(Tags, {
            tags: ["tag1", "tag2", "tag3"]
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Big list of long random char sequences (faker.js)"
          }), /* @__PURE__ */ jsx(Tags, {
            tags: Array.from({
              length: 40
            }, () => "tag " + Math.random())
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Counters"
          }), /* @__PURE__ */ jsx(Counter, {
            value: 125,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "circle_listing.c_posts"
            })
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Undefined value"
          }), /* @__PURE__ */ jsx(Counter, {
            value: void 0,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "circle_listing.c_posts"
            })
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Title"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: 'Title "my title"'
          }), /* @__PURE__ */ jsx(Title, {
            children: "my title"
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Image"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Normal"
          }), /* @__PURE__ */ jsx(Image$1, {
            image: sampleCircleItemData.image
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Small"
          }), /* @__PURE__ */ jsx(Image$1, {
            image: sampleCircleItemData.image,
            size: "small"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Big"
          }), /* @__PURE__ */ jsx(Image$1, {
            image: sampleCircleItemData.image,
            size: "big"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Square"
          }), /* @__PURE__ */ jsx(Image$1, {
            image: sampleCircleItemData.image,
            square: true
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Big Square"
          }), /* @__PURE__ */ jsx(Image$1, {
            image: sampleCircleItemData.image,
            square: true,
            size: "big"
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Cards"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Simple"
          }), /* @__PURE__ */ jsx(CircleCard$1, {
            data: sampleCircleItemData
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Simple grey"
          }), /* @__PURE__ */ jsx(CircleCard$1, {
            data: sampleCircleItemData,
            bg: "grey"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Gray with image"
          }), /* @__PURE__ */ jsx(CircleCard$1, {
            data: sampleCircleItemData,
            bg: "grey",
            showImage: true
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "White square with image"
          }), /* @__PURE__ */ jsx(CardThemeProvider, {
            cardImage: false,
            children: /* @__PURE__ */ jsx(CircleCard$1, {
              data: sampleCircleItemData,
              showImage: true
            })
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Cards with subcircles"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "With notifications"
          }), /* @__PURE__ */ jsx(CircleCard$1, {
            data: sampleCircleWithSubCirclesData,
            showImage: true,
            sw: false,
            menu: /* @__PURE__ */ jsx(OverflowMenu, {
              contentComponent: () => /* @__PURE__ */ jsxs(Paper, {
                children: [/* @__PURE__ */ jsx(MenuItem, {
                  children: "acttion 1"
                }), /* @__PURE__ */ jsx(MenuItem, {
                  children: "acttion 2"
                })]
              })
            }),
            notifications: /* @__PURE__ */ jsx(SampleNotification, {})
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "With links"
          }), /* @__PURE__ */ jsx(CircleCard$1, {
            data: sampleCircleWithSubCirclesData,
            showImage: true,
            sw: false,
            link: true
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "With links and open/close"
          }), /* @__PURE__ */ jsxs("div", {
            style: {
              backgroundColor: "#F0F2F5"
            },
            children: [/* @__PURE__ */ jsx(CircleCard$1, {
              data: sampleCircleWithSubCirclesData,
              showImage: true,
              sw: false,
              link: true,
              closer: true
            }), /* @__PURE__ */ jsx(CircleCard$1, {
              data: sampleCircleWithSubCirclesData,
              showImage: true,
              sw: false,
              link: true,
              closer: true
            }), /* @__PURE__ */ jsx(CircleCard$1, {
              data: sampleCircleWithSubCirclesData,
              showImage: true,
              sw: false,
              link: true,
              closer: true
            }), /* @__PURE__ */ jsx(CircleCard$1, {
              data: sampleCircleWithSubCirclesData,
              showImage: true,
              sw: false,
              link: true,
              closer: true
            })]
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Server Data"
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "My circles"
          }), /* @__PURE__ */ jsx(PlaygroundSearchInput, {}), data && data.map((g) => /* @__PURE__ */ jsx(CircleCard$1, {
            showImage: true,
            sw: false,
            link: true,
            closer: true,
            data: g
          }, g._id))]
        }), /* @__PURE__ */ jsx(CircleItemDepricated, {
          data: sampleCircleWithSubCirclesData
        })]
      })
    })
  });
};
const CicrleListItemComponentsTest = () => {
  return /* @__PURE__ */ jsx(SearchContextProvider, {
    children: /* @__PURE__ */ jsx(CicrleListItemComponentsInner, {})
  });
};

var ExpandMore = {};

var interopRequireDefault = {exports: {}};

(function (module) {
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(interopRequireDefault));

var interopRequireWildcard = {exports: {}};

var _typeof = {exports: {}};

(function (module) {
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_typeof));

(function (module) {
var _typeof$1 = _typeof.exports["default"];
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        "default": e
      };
    if (null === e || "object" != _typeof$1(e) && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(interopRequireWildcard));

var createSvgIcon = {};

var require$$0 = /*@__PURE__*/getAugmentedNamespace(utils);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
});

var _utils = require$$0;
}(createSvgIcon));

var _interopRequireDefault$1 = interopRequireDefault.exports;

var _interopRequireWildcard$1 = interopRequireWildcard.exports;

Object.defineProperty(ExpandMore, "__esModule", {
  value: true
});
var default_1$1 = ExpandMore.default = void 0;

var React$1 = _interopRequireWildcard$1(React__default);

var _createSvgIcon$1 = _interopRequireDefault$1(createSvgIcon);

var _default$1 = (0, _createSvgIcon$1.default)( /*#__PURE__*/React$1.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

default_1$1 = ExpandMore.default = _default$1;

var ChevronRight = {};

var _interopRequireDefault = interopRequireDefault.exports;

var _interopRequireWildcard = interopRequireWildcard.exports;

Object.defineProperty(ChevronRight, "__esModule", {
  value: true
});
var default_1 = ChevronRight.default = void 0;

var React = _interopRequireWildcard(React__default);

var _createSvgIcon = _interopRequireDefault(createSvgIcon);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

default_1 = ChevronRight.default = _default;

function CircleListing() {
  const [expanded, setExpanded] = React$2.useState([]);
  const [selected, setSelected] = React$2.useState([]);
  const handleExpandClick = () => {
    setExpanded((oldExpanded) => oldExpanded.length === 0 ? ["1", "5", "6", "7"] : []);
  };
  const handleSelectClick = () => {
    setSelected((oldSelected) => oldSelected.length === 0 ? ["1", "2", "3", "4", "5", "6", "7", "8", "9"] : []);
  };
  return /* @__PURE__ */ jsxs(Box, {
    children: [/* @__PURE__ */ jsxs(Box, {
      children: [/* @__PURE__ */ jsx(Button, {
        onClick: handleExpandClick,
        children: expanded.length === 0 ? "Expand all" : "Collapse all"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: handleSelectClick,
        children: selected.length === 0 ? "Select all" : "Unselect all"
      })]
    }), /* @__PURE__ */ jsxs(TreeView, {
      "aria-label": "controlled",
      defaultCollapseIcon: /* @__PURE__ */ jsx(default_1$1, {}),
      defaultExpandIcon: /* @__PURE__ */ jsx(default_1, {}),
      expanded,
      selected,
      multiSelect: true,
      children: [/* @__PURE__ */ jsxs(TreeItem, {
        nodeId: "1",
        label: "Applications",
        children: [/* @__PURE__ */ jsx(TreeItem, {
          nodeId: "2",
          label: "Calendar"
        }), /* @__PURE__ */ jsx(TreeItem, {
          nodeId: "3",
          label: "Chrome"
        }), /* @__PURE__ */ jsx(TreeItem, {
          nodeId: "4",
          label: "Webstorm"
        })]
      }), /* @__PURE__ */ jsx(TreeItem, {
        nodeId: "5",
        label: "Documents",
        children: /* @__PURE__ */ jsx(TreeItem, {
          nodeId: "6",
          label: "MUI",
          children: /* @__PURE__ */ jsxs(TreeItem, {
            nodeId: "7",
            label: "src",
            children: [/* @__PURE__ */ jsx(TreeItem, {
              nodeId: "8",
              label: "index.js"
            }), /* @__PURE__ */ jsx(TreeItem, {
              nodeId: "9",
              label: "tree-view.js"
            })]
          })
        })
      })]
    })]
  });
}

let generatedId = 0;
let items = {};
const generateCircleData = (options = {
  level: 0,
  maxDepth: 0
}) => {
  const {
    level,
    maxDepth
  } = options;
  generatedId++;
  const subcircles = level >= maxDepth ? [] : [];
  const item = {
    _id: generatedId + "",
    image: testImage1,
    name: "NEWSSOCIAL",
    privacy: "PUBLIC",
    stats: {
      memberCount: 5,
      postCount: 30
    },
    tags: ["#newssocial", "#cooperate", "#test", "#newssocial"],
    subcircles
  };
  items[item._id] = item;
  return item;
};
const CirclesTreePlayground = () => {
  return /* @__PURE__ */ jsx(CardThemeProvider, {
    children: /* @__PURE__ */ jsx(CDNImageContextProviderStaging, {
      children: /* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader2, {
            children: "With links and open/close"
          }), /* @__PURE__ */ jsx("div", {
            style: {
              backgroundColor: "#F0F2F5"
            },
            children: /* @__PURE__ */ jsx(CircleCard$1, {
              data: generateCircleData(),
              showImage: true,
              sw: false,
              link: true,
              closer: true
            })
          })]
        })
      })
    })
  });
};

const circleWillBeApproved = (circle) => {
  if (circle.status) {
    toast("Thank you for creating this Circle, which will become active once approved by an Instance Admin.");
  }
};

const useApproveCircle = (circleId) => {
  const api = useApi();
  return useSWR(circleId ? `/groups/${circleId}/approve` : null, () => approveCircle(api, circleId), swrLoadOnce);
};
const approveCircle = (api, circleId) => {
  return api.makeRequest({
    path: `/groups/${circleId}/approve`,
    method: "GET"
  });
};
const CircleApprovalResult = ({
  circleId
}) => {
  const {
    data,
    error
  } = useApproveCircle(circleId);
  if (error) {
    return /* @__PURE__ */ jsxs("div", {
      children: ["There was error: ", error.message]
    });
  }
  if (!data) {
    return /* @__PURE__ */ jsx("div", {
      children: "waiting..."
    });
  }
  const {
    error: errorMessage
  } = data;
  if (errorMessage) {
    const {
      email,
      role
    } = data;
    return /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsxs("span", {
        children: ["There was error: ", errorMessage, ".\xA0"]
      }), email && /* @__PURE__ */ jsxs("span", {
        children: ['User: "', email, '".\xA0']
      }), role && /* @__PURE__ */ jsxs("span", {
        children: ['Role: "', role, '".\xA0']
      })]
    });
  }
  return /* @__PURE__ */ jsx("div", {
    children: "Circle approved"
  });
};
const CircleApprovalPanel = ({
  circleId,
  approve = true
}) => {
  const {
    data: circleData
  } = useCircle(circleId);
  if (!circleData) {
    return null;
  }
  const {
    group
  } = circleData;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("h1", {
      children: ["Circle approval `", group.name, "`"]
    }), approve && /* @__PURE__ */ jsx(CircleApprovalResult, {
      circleId
    })]
  });
};

const Wrapper$B = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const deleteCircleApi = (api, id) => {
  return api.makeRequest({
    path: `/playground/group/delete/${id}`
  });
};
let counter$4 = 0;
let lastCircle$1;
const CircleCreationInner = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("");
  const [circleIdToApprove, setCircleIdToApprove] = useState("");
  const handleCircleIdChange = (e) => {
    setCircleId(e.target.value);
  };
  const handleCircleIdToApproveChange = (e) => {
    setCircleIdToApprove(e.target.value);
  };
  const createCircle = async () => {
    setResult(null);
    const circle = await api.upsertGroup({
      "privacy": "PUBLIC",
      "min_privacy": "PUBLIC",
      "name": "public " + counter$4++,
      "tags": ["s"]
    });
    circleWillBeApproved(circle);
    lastCircle$1 = circle;
    setResult(circle);
  };
  const deleteCircle = async () => {
    const circle = lastCircle$1 || result;
    setResult(null);
    const rt = await deleteCircleApi(api, circle._id);
    setResult(rt);
  };
  const deleteCircleById = async () => {
    setResult(null);
    const rt = await deleteCircleApi(api, circleId);
    setResult(rt);
  };
  const makeAdmin = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "ADMIN"
      }
    });
    setResult(rt);
  };
  const makeUser = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "USER"
      }
    });
    setResult(rt);
  };
  const approve = async () => {
    setResult(null);
    const rt = await approveCircle(api, circleId);
    setResult(rt);
  };
  const sendApprovalEmail = async () => {
    circleId || lastCircle$1._id;
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/approval-email/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  const sendApprovalEmailAll = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/approval-email-all/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  const sendApproved = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/approved-email/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  const sendApprovedAll = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/approved-email-all/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  const sendStatusApproval = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/set-status-approval/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  return /* @__PURE__ */ jsxs(Wrapper$B, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Circles Create"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: createCircle,
          children: "Create Circle"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: deleteCircle,
          children: "Delete Circle"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: makeAdmin,
          children: "Make Instance Admin"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: makeUser,
          children: "Make Instance User"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Delete Circles"
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        label: "circleId",
        placeholder: "circleId",
        value: circleId,
        onChange: handleCircleIdChange
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: deleteCircleById,
          children: "Delete Circle By ID"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendApprovalEmail,
          children: "Send Approval Email"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendApproved,
          children: "Send Email Approved"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendApprovalEmailAll,
          children: "Send Approval Email All"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendApprovedAll,
          children: "Send Email Approved All"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendStatusApproval,
          children: "Set Status Approval"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: approve,
          children: "Approve"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Circle Approval"
      }), /* @__PURE__ */ jsx(CircleApprovalPanel, {
        circleId,
        approve: false
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Execute Circle Approval"
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        label: "circleId",
        placeholder: "circleId",
        value: circleIdToApprove,
        onChange: handleCircleIdToApproveChange
      }), /* @__PURE__ */ jsx(CircleApprovalPanel, {
        circleId: circleIdToApprove
      })]
    })]
  });
};
const CreateCircleTest = () => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(CircleCreationInner, {})
  });
};

const usePdfFileHandler = (options = {}) => {
  const { maxSize, onFileSelect, extensions = [".pdf"] } = options;
  const [file, setFileState] = useState();
  const fileInfo = file ? {
    name: file.name,
    sizeMB: file.size / (1024 * 1024),
    sizeBytes: file.size
  } : void 0;
  const handleFileDrop = useCallback((acceptedFiles) => {
    const pdfFile = acceptedFiles[0];
    if (!pdfFile)
      return;
    if (maxSize && pdfFile.size > maxSize) {
      console.warn(`File ${pdfFile.name} exceeds max size of ${maxSize} bytes`);
      return;
    }
    setFileState(pdfFile);
    if (onFileSelect) {
      onFileSelect(pdfFile);
    }
  }, [maxSize, onFileSelect]);
  const dropzone = useDropzone({
    onDrop: handleFileDrop,
    accept: extensions,
    maxFiles: 1,
    maxSize
  });
  const clearFile = useCallback(() => {
    setFileState(void 0);
  }, []);
  const setFile = useCallback((newFile) => {
    setFileState(newFile);
    if (onFileSelect) {
      onFileSelect(newFile);
    }
  }, [onFileSelect]);
  return {
    file,
    fileInfo,
    dropzone,
    clearFile,
    setFile
  };
};

const usePdfSplitWorker = () => {
  const workerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(null);
  const [error, setError] = useState(null);
  const createWorker = useCallback(() => {
    const workerScript = `
      importScripts('https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js');
      
      const splitPDFInWorker = async (pdfBuffer, fileName, options = {}) => {
        const {
          maxPagesPerFile = 15,
          maxSizePerFile = 19 * 1024 * 1024
        } = options;

        const pdfBytes = new Uint8Array(pdfBuffer);
        const pdfDoc = await PDFLib.PDFDocument.load(pdfBytes);
        const totalPages = pdfDoc.getPageCount();
        const splitFiles = [];
        
        let currentPageIndex = 0;
        let fileIndex = 0;
        
        while (currentPageIndex < totalPages) {
          self.postMessage({
            type: 'SPLIT_PDF_PROGRESS',
            payload: {
              currentPage: currentPageIndex + 1,
              totalPages,
              filesCreated: fileIndex
            }
          });

          const newPdfDoc = await PDFLib.PDFDocument.create();
          let pagesInCurrentFile = 0;
          let previousPdfBytes = null;
          let pdfBytes = null;
          const startPage = currentPageIndex;
          
          while (
            currentPageIndex < totalPages && 
            pagesInCurrentFile < maxPagesPerFile
          ) {
            const [copiedPage] = await newPdfDoc.copyPages(pdfDoc, [currentPageIndex]);
            newPdfDoc.addPage(copiedPage);
            
            pagesInCurrentFile++;
            currentPageIndex++;
            
            pdfBytes = await newPdfDoc.save();
            if (pdfBytes.length > maxSizePerFile) {
              if(pagesInCurrentFile > 1) {
                pdfBytes = previousPdfBytes;
                currentPageIndex--;
                pagesInCurrentFile--;
              }
              break;
            }
            previousPdfBytes = pdfBytes;
          }
          
          
          // Convert to base64 in chunks to avoid call stack overflow
          const uint8Array = new Uint8Array(pdfBytes);
          let binaryString = '';
          const chunkSize = 8192; // Process in 8KB chunks
          
          for (let i = 0; i < uint8Array.length; i += chunkSize) {
            const chunk = uint8Array.slice(i, i + chunkSize);
            binaryString += String.fromCharCode.apply(null, Array.from(chunk));
          }
          
          const base64Data = btoa(binaryString);
          
          splitFiles.push({
            fileName: \`split_\${String(fileIndex + 1).padStart(3, '0')}.pdf\`,
            pageRange: { 
              start: startPage + 1, 
              end: currentPageIndex 
            },
            pageCount: pagesInCurrentFile,
            sizeBytes: pdfBytes.length,
            base64Data,
            mimeType: 'application/pdf'
          });
          
          fileIndex++;
        }
        
        // Convert to server format before returning
        const serverFormat = {
          summary: {
            originalFile: fileName,
            totalPages: totalPages,
            totalSplitFiles: splitFiles.length,
            splitDetails: splitFiles.map(file => ({
              fileName: file.fileName,
              pages: \`\${file.pageRange.start}-\${file.pageRange.end}\`,
              sizeMB: (file.sizeBytes / (1024 * 1024)).toFixed(2)
            }))
          },
          files: splitFiles.map(file => ({
            base64Data: file.base64Data
          }))
        };
        
        return serverFormat;
      };

      self.addEventListener('message', async (event) => {
        const { type, payload } = event.data;

        if (type === 'SPLIT_PDF') {
          try {
            const { pdfBuffer, fileName, options } = payload;
            const result = await splitPDFInWorker(pdfBuffer, fileName, options);
            
            self.postMessage({
              type: 'SPLIT_PDF_SUCCESS',
              payload: result
            });
          } catch (error) {
            self.postMessage({
              type: 'SPLIT_PDF_ERROR',
              payload: {
                message: error.message || 'Unknown error',
                stack: error.stack
              }
            });
          }
        }
      });
    `;
    const blob = new Blob([workerScript], { type: "application/javascript" });
    const workerUrl = URL.createObjectURL(blob);
    return new Worker(workerUrl);
  }, []);
  const splitPdf = useCallback(async (file, options = {}) => {
    return new Promise((resolve, reject) => {
      setIsLoading(true);
      setError(null);
      setProgress(null);
      if (workerRef.current) {
        workerRef.current.terminate();
      }
      const worker = createWorker();
      workerRef.current = worker;
      const handleMessage = (event) => {
        const { type, payload } = event.data;
        switch (type) {
          case "SPLIT_PDF_SUCCESS":
            setIsLoading(false);
            setProgress(null);
            worker.terminate();
            workerRef.current = null;
            resolve(payload);
            break;
          case "SPLIT_PDF_ERROR":
            setIsLoading(false);
            setProgress(null);
            setError(payload.message);
            worker.terminate();
            workerRef.current = null;
            reject(new Error(payload.message));
            break;
          case "SPLIT_PDF_PROGRESS":
            setProgress(payload);
            break;
        }
      };
      worker.addEventListener("message", handleMessage);
      file.arrayBuffer().then((buffer) => {
        const message = {
          type: "SPLIT_PDF",
          payload: {
            pdfBuffer: buffer,
            fileName: file.name,
            options
          }
        };
        worker.postMessage(message);
      }).catch((error2) => {
        setIsLoading(false);
        setError(error2.message);
        worker.terminate();
        workerRef.current = null;
        reject(error2);
      });
    });
  }, [createWorker]);
  const cancelSplit = useCallback(() => {
    if (workerRef.current) {
      workerRef.current.terminate();
      workerRef.current = null;
      setIsLoading(false);
      setProgress(null);
    }
  }, []);
  return {
    splitPdf,
    isLoading,
    progress,
    error,
    cancelSplit
  };
};

const PdfProcessingContext = createContext(null);
const usePdfProcessing = () => {
  const context = useContext(PdfProcessingContext);
  if (!context) {
    throw new Error("usePdfProcessing must be used within PdfProcessingProvider");
  }
  return context;
};
const PdfProcessingProvider = ({
  children
}) => {
  const [state, setState] = useControllableValue({
    defaultValue: {
      stage: "idle",
      autoMode: false,
      splitData: null,
      error: null,
      execution: null
    }
  });
  const actions = {
    startAutoSplitAndUpload: useMemoizedFn(() => {
      setState((prev) => ({
        ...prev,
        stage: "splitting",
        autoMode: true,
        splitData: null,
        error: null
      }));
    }),
    setSplitComplete: useMemoizedFn((data) => {
      setState((prev) => ({
        ...prev,
        stage: "split-complete",
        splitData: data
      }));
    }),
    setUploadStarted: useMemoizedFn(() => {
      setState((prev) => ({
        ...prev,
        stage: "uploading"
      }));
    }),
    setUploadComplete: useMemoizedFn((execution) => {
      setState((prev) => ({
        ...prev,
        execution,
        stage: "upload-complete"
      }));
    }),
    setProcessingStarted: useMemoizedFn(() => {
      setState((prev) => ({
        ...prev,
        stage: "processing"
      }));
    }),
    setProcessingComplete: useMemoizedFn(() => {
      setState((prev) => ({
        ...prev,
        stage: "idle",
        autoMode: false,
        execution: null
      }));
    }),
    setExecution(execution) {
      setState((prev) => ({
        ...prev,
        execution
      }));
    },
    setError: useMemoizedFn((error) => {
      setState((prev) => ({
        ...prev,
        error,
        autoMode: false
      }));
    }),
    reset: useMemoizedFn(() => {
      setState({
        stage: "idle",
        autoMode: false,
        splitData: null,
        error: null,
        execution: null
      });
    })
  };
  return /* @__PURE__ */ jsx(PdfProcessingContext.Provider, {
    value: {
      state,
      actions
    },
    children
  });
};

const useWorkerSplit = (options) => {
  const {
    file,
    defaultOptions: overrides,
    onSuccess,
    onError,
    onProgress
  } = options;
  const defaultOptions = {
    maxPagesPerFile: 15,
    maxSizePerFile: 19 * 1024 * 1024,
    ...overrides
  };
  const [data, setData] = useState(null);
  const { state, actions } = usePdfProcessing();
  const {
    splitPdf,
    isLoading: isWorkerLoading,
    progress,
    error: workerError,
    cancelSplit
  } = usePdfSplitWorker();
  useEffect(() => {
    if (state.stage === "splitting" && state.autoMode && file) {
      operation.execute();
    }
  }, [state.stage, state.autoMode, file]);
  if (progress && onProgress) {
    onProgress(progress);
  }
  const operation = useAsyncOperation(async (splitOptions) => {
    if (!file)
      throw new Error("No file selected");
    try {
      const result = await splitPdf(file, {
        ...defaultOptions,
        ...splitOptions
      });
      setData(result);
      actions.setSplitComplete(result);
      if (onSuccess) {
        onSuccess(result);
      }
      return result;
    } catch (err) {
      const error = err;
      actions.setError(error.message);
      if (onError) {
        onError(error);
      }
      throw error;
    }
  });
  const reset = useCallback(() => {
    setData(null);
    cancelSplit();
    operation.reset();
  }, [cancelSplit]);
  return {
    execute: operation.execute,
    isLoading: isWorkerLoading || operation.isLoading,
    error: workerError ? new Error(workerError) : operation.error,
    data,
    progress,
    reset,
    cancel: cancelSplit
  };
};

const useExecutions = ({ id, size = 50 }, options) => {
  const api = useApi();
  const result = useSWR(id ? [`/uploads/import-pdf-batches/${id}`, size] : null, async (path) => {
    const data = await api.get({
      path: `/uploads/import-pdf-batches?id=${id}&size=${size}`
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result,
    executions: result.data && result.data.executions || [],
    setExecutions: (executions) => {
      if (typeof executions === "function") {
        result.mutate((current) => ({
          executions: executions(current && current.executions || [])
        }), false);
      } else {
        result.mutate({ executions }, false);
      }
    }
  };
};

const DropZone = (props) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    className,
    children
  } = props;
  const getBorderColor = () => {
    if (isDragAccept)
      return "border-green-400";
    if (isDragReject)
      return "border-red-400";
    if (isDragActive)
      return "border-blue-400";
    return "border-gray-300";
  };
  return /* @__PURE__ */ jsxs("section", {
    className: clsx("flex flex-col font-sans relative", className),
    children: [children, /* @__PURE__ */ jsxs("div", {
      ...getRootProps({
        isDragActive,
        isDragAccept,
        isDragReject
      }),
      className: clsx("flex-1 flex flex-col items-center p-5", "border-2 border-dashed rounded", "bg-gray-50 text-gray-400", "outline-none transition-colors duration-200 ease-in-out", "cursor-pointer", getBorderColor()),
      children: [/* @__PURE__ */ jsx("input", {
        ...getInputProps()
      }), /* @__PURE__ */ jsx("p", {
        className: "text-base mb-2.5",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "attachments.drop_here"
        })
      })]
    })]
  });
};

const PdfFileSelector = ({
  dropzone,
  file,
  fileInfo,
  isProcessing = false,
  progressInfo,
  className = ""
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: `flex flex-col gap-4 ${className}`,
    children: [/* @__PURE__ */ jsx(DropZone, {
      ...dropzone,
      children: isProcessing && /* @__PURE__ */ jsx("div", {
        className: "absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10",
        children: /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col items-center gap-2",
          children: [/* @__PURE__ */ jsx(Spinner, {
            size: "lg"
          }), progressInfo && /* @__PURE__ */ jsxs("div", {
            className: "text-sm text-center text-gray-600",
            children: [/* @__PURE__ */ jsxs("div", {
              children: ["Processing page ", progressInfo.currentPage, " of ", progressInfo.totalPages]
            }), /* @__PURE__ */ jsxs("div", {
              children: ["Files created: ", progressInfo.filesCreated]
            })]
          })]
        })
      })
    }), file && fileInfo && /* @__PURE__ */ jsx("div", {
      className: "p-3 bg-green-50 border border-green-200 rounded",
      children: /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-green-700",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Selected file:"
        }), " ", fileInfo.name, /* @__PURE__ */ jsxs("span", {
          className: "ml-2",
          children: ["(", fileInfo.sizeMB.toFixed(2), " MB)"]
        })]
      })
    })]
  });
};

const formSectionVariants = cva("rounded-lg", {
  variants: {
    variant: {
      default: "bg-gray-50",
      outlined: "border border-gray-200",
      elevated: "bg-white shadow-sm border border-gray-100"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const FormSection = ({
  children,
  title,
  variant,
  className
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: formSectionVariants({
      variant,
      className
    }),
    children: [title && /* @__PURE__ */ jsx("div", {
      className: "px-4 py-3 border-b border-gray-200",
      children: /* @__PURE__ */ jsx("h3", {
        className: "text-sm font-semibold text-gray-900",
        children: title
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-3 p-4",
      children
    })]
  });
};

const inputVariants = cva("w-full px-3 py-2 rounded-lg border focus:outline-none focus:ring-2 transition-colors", {
  variants: {
    variant: {
      default: "border-gray-300 focus:border-blue-500 focus:ring-blue-200",
      outlined: "border-2 border-gray-400 focus:border-blue-600 focus:ring-blue-300"
    },
    disabled: {
      true: "bg-gray-100 cursor-not-allowed opacity-60",
      false: "bg-white"
    },
    hasValue: {
      true: "pr-10",
      false: ""
    }
  },
  defaultVariants: {
    variant: "default",
    disabled: false
  }
});
const dropdownVariants = cva("bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 overflow-auto z-50", {
  variants: {
    open: {
      true: "visible opacity-100",
      false: "invisible opacity-0"
    }
  }
});
const optionVariants = cva("px-3 py-2 cursor-pointer transition-colors", {
  variants: {
    highlighted: {
      true: "bg-blue-50 text-blue-700",
      false: "text-gray-900 hover:bg-gray-50"
    },
    disabled: {
      true: "opacity-50 cursor-not-allowed",
      false: ""
    }
  }
});
const detectRTL = (text) => {
  return /[\u0600-\u06FF]/.test(text);
};
const Autocomplete = ({
  value,
  onChange,
  onInputChange,
  options,
  placeholder = "Search...",
  disabled = false,
  className = "",
  variant = "default",
  minSearchLength = 0,
  debounceMs = 300,
  "aria-label": ariaLabel
}) => {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [showLoading, setShowLoading] = useState(false);
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const listRef = useRef(null);
  const loadingTimeoutRef = useRef(null);
  const searchAbortRef = useRef(null);
  const {
    refs,
    floatingStyles
  } = useFloating({
    placement: "bottom-start",
    middleware: [offset(4), flip(), shift({
      padding: 8
    })],
    whileElementsMounted: autoUpdate
  });
  const selectedOption = value !== void 0 ? options.find((opt) => opt.value === value) : null;
  const displayValue = open ? searchValue : selectedOption ? selectedOption.label : "";
  const isRTL = detectRTL(displayValue);
  useEffect(() => {
    return () => {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
      }
    };
  }, []);
  useEffect(() => {
    if (highlightedIndex >= options.length) {
      setHighlightedIndex(Math.max(0, options.length - 1));
    }
  }, [options.length, highlightedIndex]);
  const handleSearch = useCallback(async (searchValue2) => {
    if (searchAbortRef.current) {
      searchAbortRef.current();
    }
    if (minSearchLength > 0 && searchValue2.length < minSearchLength) {
      return;
    }
    if (!onInputChange) {
      return;
    }
    let cancelled = false;
    searchAbortRef.current = () => {
      cancelled = true;
    };
    loadingTimeoutRef.current = setTimeout(() => {
      if (!cancelled) {
        setShowLoading(true);
      }
    }, 500);
    try {
      await onInputChange(searchValue2);
    } finally {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
        loadingTimeoutRef.current = null;
      }
      if (!cancelled) {
        setShowLoading(false);
      }
    }
  }, [onInputChange, minSearchLength]);
  const {
    run: debouncedSearch,
    cancel: cancelDebounce
  } = useDebounceFn(handleSearch, {
    wait: debounceMs
  });
  useEffect(() => {
    return () => {
      cancelDebounce();
      if (searchAbortRef.current) {
        searchAbortRef.current();
      }
    };
  }, [cancelDebounce]);
  const handleInputChange = useCallback((e) => {
    const newValue = e.target.value;
    setSearchValue(newValue);
    setHighlightedIndex(0);
    if (!open) {
      setOpen(true);
    }
    debouncedSearch(newValue);
  }, [open, debouncedSearch]);
  const handleOptionSelect = useCallback((option) => {
    if (option.disabled)
      return;
    if (onChange) {
      onChange(option.value, option);
    }
    setOpen(false);
    setSearchValue("");
    setHighlightedIndex(0);
    if (inputRef.current) {
      inputRef.current.blur();
    }
  }, [onChange]);
  const handleClear = useCallback((e) => {
    e.stopPropagation();
    if (onChange) {
      onChange(void 0, null);
    }
    setSearchValue("");
    setOpen(true);
    if (inputRef.current) {
      inputRef.current.focus();
    }
    handleSearch("");
  }, [onChange, handleSearch]);
  const handleInputFocus = useCallback(() => {
    setOpen(true);
    if (onInputChange) {
      handleSearch(searchValue);
    }
  }, [onInputChange, handleSearch, searchValue]);
  const handleKeyDown = useCallback((e) => {
    if (disabled)
      return;
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        if (!open) {
          setOpen(true);
        } else if (options.length > 0) {
          setHighlightedIndex((prev) => prev < options.length - 1 ? prev + 1 : prev);
        }
        break;
      case "ArrowUp":
        e.preventDefault();
        if (open && options.length > 0) {
          setHighlightedIndex((prev) => prev > 0 ? prev - 1 : 0);
        }
        break;
      case "Enter":
        e.preventDefault();
        if (open && options.length > 0 && options[highlightedIndex]) {
          const option = options[highlightedIndex];
          if (!option.disabled) {
            handleOptionSelect(option);
          }
        }
        break;
      case "Escape":
        e.preventDefault();
        setOpen(false);
        setSearchValue("");
        if (inputRef.current) {
          inputRef.current.blur();
        }
        break;
      case "Tab":
        setOpen(false);
        setSearchValue("");
        break;
    }
  }, [disabled, open, options, highlightedIndex, handleOptionSelect]);
  useEffect(() => {
    if (open && listRef.current && options.length > 0) {
      const highlightedElement = listRef.current.children[highlightedIndex];
      if (highlightedElement) {
        highlightedElement.scrollIntoView({
          block: "nearest"
        });
      }
    }
  }, [highlightedIndex, open, options.length]);
  useClickAway(() => {
    if (open) {
      setOpen(false);
      setSearchValue("");
    }
  }, containerRef);
  const showClearButton = selectedOption && !disabled && !open && !showLoading;
  const referenceWidth = refs.reference.current ? refs.reference.current.offsetWidth : void 0;
  return /* @__PURE__ */ jsxs("div", {
    ref: containerRef,
    className: `relative ${className}`,
    children: [/* @__PURE__ */ jsxs("div", {
      ref: refs.setReference,
      children: [/* @__PURE__ */ jsx("input", {
        ref: inputRef,
        type: "text",
        value: displayValue,
        onChange: handleInputChange,
        onFocus: handleInputFocus,
        onKeyDown: handleKeyDown,
        placeholder,
        disabled,
        dir: isRTL ? "rtl" : "ltr",
        className: inputVariants({
          variant,
          disabled,
          hasValue: !!selectedOption
        }),
        role: "combobox",
        "aria-label": ariaLabel || placeholder,
        "aria-expanded": open,
        "aria-controls": "autocomplete-listbox",
        "aria-autocomplete": "list",
        "aria-activedescendant": open ? `option-${highlightedIndex}` : void 0
      }), showClearButton && /* @__PURE__ */ jsx("button", {
        type: "button",
        onClick: handleClear,
        className: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors",
        "aria-label": "Clear selection",
        children: /* @__PURE__ */ jsx("svg", {
          className: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: /* @__PURE__ */ jsx("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M6 18L18 6M6 6l12 12"
          })
        })
      }), showLoading && /* @__PURE__ */ jsx("div", {
        className: "absolute right-3 top-1/2 -translate-y-1/2",
        children: /* @__PURE__ */ jsxs("svg", {
          className: "animate-spin h-4 w-4 text-blue-500",
          fill: "none",
          viewBox: "0 0 24 24",
          children: [/* @__PURE__ */ jsx("circle", {
            className: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "4"
          }), /* @__PURE__ */ jsx("path", {
            className: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          })]
        })
      })]
    }), /* @__PURE__ */ jsx(FloatingPortal, {
      children: /* @__PURE__ */ jsx("div", {
        ref: refs.setFloating,
        style: {
          ...floatingStyles,
          minWidth: referenceWidth
        },
        className: dropdownVariants({
          open
        }),
        children: open && /* @__PURE__ */ jsx("ul", {
          ref: listRef,
          id: "autocomplete-listbox",
          role: "listbox",
          "aria-label": "Search results",
          className: "py-1",
          children: options.length === 0 ? /* @__PURE__ */ jsx("li", {
            className: "px-3 py-4 text-center text-gray-500 text-sm",
            children: searchValue.length < minSearchLength ? `Type at least ${minSearchLength} characters to search` : searchValue ? "No results found" : "Start typing to search..."
          }) : options.map((option, index) => {
            const optionRTL = detectRTL(option.label);
            return /* @__PURE__ */ jsx("li", {
              id: `option-${index}`,
              role: "option",
              "aria-selected": index === highlightedIndex,
              "aria-disabled": option.disabled || void 0,
              className: optionVariants({
                highlighted: index === highlightedIndex,
                disabled: option.disabled
              }),
              onClick: () => handleOptionSelect(option),
              onMouseEnter: () => setHighlightedIndex(index),
              dir: optionRTL ? "rtl" : "ltr",
              children: option.label
            }, `${option.value}-${index}`);
          })
        })
      })
    })]
  });
};

const PromptPostSelector = ({
  prompts,
  value,
  onChange,
  onInputChange,
  placeholder = "Select prompt...",
  label
}) => {
  const options = useMemo(() => prompts.map((p) => ({
    value: p._id,
    label: p.title
  })), [prompts]);
  const handleInputChange = useMemoizedFn((search) => {
    if (onInputChange) {
      onInputChange(search);
    }
  });
  const promptHref = value ? url4post(value) : void 0;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-1",
    children: [label && /* @__PURE__ */ jsx("label", {
      className: "text-sm font-medium",
      children: label
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex-1",
        children: /* @__PURE__ */ jsx(Autocomplete, {
          value,
          onChange,
          options,
          placeholder,
          onInputChange: handleInputChange
        })
      }), promptHref && /* @__PURE__ */ jsx("a", {
        href: promptHref,
        target: "_blank",
        rel: "noopener noreferrer",
        title: "Open prompt in new tab",
        className: "shrink-0 text-blue-600 hover:text-blue-700",
        children: /* @__PURE__ */ jsx(MdOpenInNew, {
          size: 18
        })
      })]
    })]
  });
};

const usePromptPostSearch = () => {
  const api = useApi();
  const [prompts, setPrompts] = useState([]);
  const search = useMemoizedFn(async (value) => {
    try {
      const { sponsors } = await api.get({
        path: `/group-assistant/prompts/${value || "_ALL"}`
      });
      setPrompts(sponsors.map((s) => ({ _id: s._id, title: s.title })));
    } catch (err) {
      console.error("usePromptPostSearch: fetch failed", err);
    }
  });
  useEffect(() => {
    search("");
  }, []);
  return { prompts, search };
};

const ConnectedPromptPostSelector = ({
  value,
  onChange,
  label,
  placeholder
}) => {
  const {
    prompts,
    search
  } = usePromptPostSearch();
  return /* @__PURE__ */ jsx(PromptPostSelector, {
    prompts,
    value,
    onChange,
    onInputChange: search,
    label,
    placeholder
  });
};

const isVMProcessor = (processor) => {
  return processor.startsWith("ocr-");
};

const processorOptions$1 = [{
  value: "--",
  label: "Straight recognition with page images"
}, {
  value: "layout",
  label: "Layout recognition with no page images"
}, {
  value: "hawashi-extractor",
  label: "hawashi-extractor"
}, {
  value: "ocr-3",
  label: "OCR 3"
}, {
  value: "ocr-4",
  label: "OCR 4"
}, {
  value: "ocr-4l",
  label: "OCR 4L"
}, {
  value: "ocr-5",
  label: "OCR 5"
}, {
  value: "ocr-6",
  label: "OCR 6"
}, {
  value: "ocr-7",
  label: "OCR 7"
}];
const PdfProcessingOptions = ({
  processor,
  onProcessorChange,
  width,
  onWidthChange,
  pageNo,
  onPageNoChange,
  addPrompt,
  onAddPromptChange,
  promptPostId,
  onPromptPostIdChange,
  includePageThumbnails,
  onIncludePageThumbnailsChange,
  variant = "outlined",
  isCircleAdmin,
  className = ""
}) => {
  const isAdmin = useIsInstanceAdmin() || isCircleAdmin;
  const handleProcessorChange = (value) => {
    const actualValue = value === "--" ? "" : value;
    onProcessorChange(actualValue);
    if (isVMProcessor(actualValue)) {
      onPageNoChange("1");
    } else if (isVMProcessor(processor)) {
      onPageNoChange("15");
    }
  };
  const isOcr = isVMProcessor(processor);
  return /* @__PURE__ */ jsxs(FormSection, {
    variant,
    className,
    children: [/* @__PURE__ */ jsx(Select, {
      label: "Process Type",
      value: processor || "--",
      onChange: handleProcessorChange,
      options: isAdmin ? processorOptions$1 : processorOptions$1.filter((v) => v.value !== "ocr-3"),
      helperText: "Choose how the PDF should be processed"
    }), isOcr && onAddPromptChange && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Switch, {
        checked: addPrompt || false,
        onChange: onAddPromptChange,
        label: "Add custom prompt"
      }), addPrompt && onPromptPostIdChange && /* @__PURE__ */ jsx(ConnectedPromptPostSelector, {
        label: "Select Custom Prompt",
        value: promptPostId,
        onChange: onPromptPostIdChange,
        placeholder: "Select a saved prompt..."
      })]
    }), processor !== "layout" && onIncludePageThumbnailsChange && /* @__PURE__ */ jsx(Switch, {
      checked: includePageThumbnails !== false,
      onChange: onIncludePageThumbnailsChange,
      label: "Include page thumbnails"
    }), includePageThumbnails !== false && /* @__PURE__ */ jsx(TextInput, {
      label: "Page Image Width",
      value: width,
      onChange: (e) => onWidthChange(e.target.value),
      placeholder: "600",
      helperText: "Width in pixels for page images (0 for no images)",
      type: "number",
      disabled: true
    }), /* @__PURE__ */ jsx(TextInput, {
      label: "Number of pages in chunk",
      value: isOcr ? "1" : pageNo,
      onChange: (e) => onPageNoChange(e.target.value),
      placeholder: "15",
      helperText: "Documents are split and processed in multi-page chunks",
      type: "number",
      disabled: isOcr
    })]
  });
};

const checkStale = (started) => {
  const now = Date.now();
  const MINUTES_30 = 3 * 30 * 60 * 1e3;
  started = new Date(started);
  return now - started.getTime() > MINUTES_30;
};

const toBatchStub = (index) => ({
  fileIndex: index,
  fileName: `Missing batch ${index}`,
  batchId: `missing-${index}`,
  status: "error",
  error: "Batch record missing (data corruption)",
  gcsOutputPath: ""
});
const sanitizeBatches = (batches) => {
  if (!batches || !batches.some((b) => !b))
    return batches;
  return batches.map((b, i) => b ? b : toBatchStub(i));
};
const convertToBatchFormat = (execution) => {
  const batches = sanitizeBatches(execution.data.batches);
  if (batches && batches.length > 0) {
    if (batches === execution.data.batches)
      return execution;
    return { ...execution, data: { ...execution.data, batches } };
  }
  const { operationName, batchId, gcsOutputPath, processorId, width } = execution.data;
  return {
    ...execution,
    data: {
      ...execution.data,
      originalFileName: execution.title || "Untitled",
      totalFiles: 1,
      batches: [{
        fileIndex: 0,
        fileName: execution.title || "document.pdf",
        operationName: operationName || "",
        batchId: batchId || "",
        gcsOutputPath: gcsOutputPath || "",
        status: execution.status === "finished" ? "finished" : execution.status === "error" ? "error" : "processing"
      }]
    }
  };
};
const calculateBatchSummary = (batches) => {
  const summary = {
    total: batches.length,
    queued: 0,
    processing: 0,
    finished: 0,
    failed: 0
  };
  batches.forEach((batch) => {
    const status = batch.status || "queued";
    switch (status) {
      case "queued":
        summary.queued++;
        break;
      case "processing":
        summary.processing++;
        break;
      case "finished":
        summary.finished++;
        break;
      case "error":
        summary.failed++;
        break;
    }
  });
  return summary;
};
const getStatusColor = (status) => {
  switch (status) {
    case "finished":
      return "green";
    case "processing":
      return "blue";
    case "error":
      return "red";
    case "queued":
    default:
      return "gray";
  }
};
const isExecutionComplete = (execution) => {
  if (!execution.data.batches || execution.data.batches.length === 0) {
    return execution.status === "finished";
  }
  return execution.data.batches.every((batch) => batch.status === "finished" || batch.status === "error");
};
const hasExecutionErrors = (execution) => {
  if (!execution.data.batches || execution.data.batches.length === 0) {
    return execution.status === "error";
  }
  return execution.data.batches.some((batch) => batch.status === "error");
};
const getProcessingPhase = (data) => {
  if (data.totalFiles !== data.batches.length) {
    return "uploading";
  }
  const hasQueued = data.batches.some((batch) => batch.status === "queued");
  if (hasQueued) {
    return "ready";
  }
  const hasProcessing = data.batches.some((batch) => batch.status === "processing" || !batch.status && batch.operationName);
  if (hasProcessing) {
    return "processing";
  }
  return "complete";
};
const shouldScheduleBatches = (data) => {
  return getProcessingPhase(data) === "ready";
};
const shouldMonitorStatus = (data) => {
  return getProcessingPhase(data) === "processing";
};
const hasQueuedBatches = (data) => {
  return data.batches.some((batch) => batch.status === "queued");
};

const ExecutionSummary = ({
  execution,
  summary
}) => {
  const getOverallStatus = () => {
    if (summary.failed === summary.total)
      return "error";
    if (summary.finished === summary.total)
      return "finished";
    if (summary.processing > 0 || summary.queued > 0)
      return "processing";
    return "unknown";
  };
  const overallStatus = getOverallStatus();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-4 flex-1",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: execution.title
        }), summary.total > 1 && /* @__PURE__ */ jsxs("span", {
          className: "text-sm text-gray-500",
          children: ["(", summary.total, " files)"]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 text-xs text-gray-500",
        children: [/* @__PURE__ */ jsx(RelativeTime, {
          value: execution.started
        }), execution.data.processorId && /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx("span", {
            children: "\u2022"
          }), /* @__PURE__ */ jsxs("span", {
            children: ["Processor: ", getProcessorName(execution.data.processorId)]
          })]
        }), execution.data.width && /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx("span", {
            children: "\u2022"
          }), /* @__PURE__ */ jsxs("span", {
            children: ["Width: ", execution.data.width, "px"]
          })]
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [summary.finished > 0 && /* @__PURE__ */ jsxs(Chip, {
        size: "sm",
        variant: "green",
        children: [summary.finished, " finished"]
      }), summary.processing > 0 && /* @__PURE__ */ jsxs(Chip, {
        size: "sm",
        variant: "blue",
        children: [summary.processing, " processing"]
      }), summary.queued > 0 && /* @__PURE__ */ jsxs(Chip, {
        size: "sm",
        variant: "gray",
        children: [summary.queued, " queued"]
      }), summary.failed > 0 && /* @__PURE__ */ jsxs(Chip, {
        size: "sm",
        variant: "red",
        children: [summary.failed, " failed"]
      })]
    }), summary.total > 1 && overallStatus === "processing" && /* @__PURE__ */ jsx("div", {
      className: "flex-1 max-w-xs",
      children: /* @__PURE__ */ jsx("div", {
        className: "w-full bg-gray-200 rounded-full h-2",
        children: /* @__PURE__ */ jsx("div", {
          className: "bg-blue-500 h-2 rounded-full transition-all duration-300",
          style: {
            width: `${(summary.finished + summary.failed) / summary.total * 100}%`
          }
        })
      })
    })]
  });
};
const getProcessorName = (processorId) => {
  const processorMap = {
    "f305c44078d0e21a": "OCR",
    "b2149b1ef9096d84": "Layout",
    "fce7e238f8f5ba07": "Forms",
    "2c34ec878aa59b43": "hawashi-extractor",
    "ocr-3": "OCR 3",
    "ocr-4": "OCR 4",
    "ocr-4l": "OCR 4L",
    "ocr-5": "OCR 5",
    "ocr-6": "OCR 6",
    "ocr-7": "OCR 7"
  };
  return processorMap[processorId] || processorId;
};

const isUrlContaining = (keyword) => {
  if (typeof window === "undefined") {
    return false;
  }
  const currentUrl = window.location.href.toLowerCase();
  const currentPath = window.location.pathname.toLowerCase();
  const lowerKeyword = keyword.toLowerCase();
  return currentUrl.includes(lowerKeyword) || currentPath.includes(lowerKeyword);
};
const isPlaygroundUrl = () => {
  return isUrlContaining("playground");
};

const TEST_MODE_KEY = "global-test-mode";
const useTestMode = () => {
  const [isUrlPlayground, setIsUrlPlayground] = useState(false);
  const { data: override } = useSWR(TEST_MODE_KEY, () => null, {
    fallbackData: null,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateOnMount: false,
    revalidateIfStale: false
  });
  useEffect(() => {
    const checkUrl = () => setIsUrlPlayground(isPlaygroundUrl());
    checkUrl();
    return () => {
    };
  }, []);
  return override !== null ? override : isUrlPlayground;
};
const useTestModeControls = () => {
  const isTestMode = useTestMode();
  const { mutate } = useSWR(TEST_MODE_KEY);
  const toggleTestMode = () => {
    mutate(!isTestMode, false);
  };
  return { isTestMode, toggleTestMode };
};

const ImportExecutionContext = createContext(void 0);
const ImportExecutionProvider = ({
  execution,
  onExecutionUpdate,
  stale,
  onDelete,
  children
}) => {
  const {
    addToast
  } = useToast();
  const api = useApi();
  const [isCreatingPost, setIsCreatingPost] = useState(false);
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);
  const {
    actions
  } = usePdfProcessing();
  const updateExecution = useMemoizedFn((updatedExecution) => {
    onExecutionUpdate(updatedExecution);
  });
  const updateExecutionPartial = useMemoizedFn((updates) => {
    const updatedExecution = {
      ...execution,
      ...updates
    };
    onExecutionUpdate(updatedExecution);
  });
  const createPost = useMemoizedFn(async () => {
    setIsCreatingPost(true);
    try {
      await withRetry(async () => {
        let response = null;
        const executionId = execution._id;
        while (true) {
          response = await api.get({
            path: "/playground/import-pdf-batch-html?id=" + executionId
          });
          const {
            execution: execution2
          } = response;
          updateExecution(execution2);
          if (!execution2.data.postCreationState) {
            break;
          }
        }
        return response;
      }, {
        onFinalFailure(error) {
          actions.setError(error);
        }
      });
      addToast({
        type: "success",
        message: `New post created!`
      });
    } finally {
      setIsCreatingPost(false);
    }
  });
  const scheduleBatchProcessing = useMemoizedFn(async () => {
    const {
      execution: updated
    } = await api.post({
      path: "/uploads/schedule-batch-processing",
      body: {
        executionId: execution._id
      }
    });
    updateExecution(updated);
  });
  const checkStatus = useMemoizedFn(async () => {
    setIsCheckingStatus(true);
    try {
      const response = await api.get({
        path: `/uploads/import-pdf-batch-status?id=${execution._id}&force=true`
      });
      if (response && response.execution) {
        updateExecution(response.execution);
      }
    } finally {
      setIsCheckingStatus(false);
    }
  });
  const contextValue = {
    execution,
    updateExecution,
    updateExecutionPartial,
    createPost,
    checkStatus,
    scheduleBatchProcessing,
    isCreatingPost,
    isCheckingStatus,
    stale,
    onDelete
  };
  return /* @__PURE__ */ jsx(ImportExecutionContext.Provider, {
    value: contextValue,
    children
  });
};
const useImportExecution = () => {
  const context = useContext(ImportExecutionContext);
  if (!context) {
    throw new Error("useImportExecution must be used within ImportExecutionProvider");
  }
  return context;
};

const useBatchPostCreator = ({
  onSuccess,
  onError
} = {}) => {
  const api = useApi();
  const { addToast } = useToast();
  const { execution, updateExecution } = useImportExecution();
  const operation = useAsyncOperation(async (options) => {
    const { batchIndex, batch } = options;
    console.log(`Creating post for batch ${batchIndex} in execution ${execution._id}`);
    try {
      const response = await api.post({
        path: `/uploads/create-batch-post`,
        body: {
          executionId: execution._id,
          batchIndex,
          batchId: batch.batchId,
          fileName: batch.fileName,
          postId: batch.postId
        }
      });
      if (response && response.execution) {
        updateExecution(response.execution);
      }
      addToast({
        type: "success",
        message: `Post created successfully for ${batch.fileName}`,
        title: "Batch Post Created"
      });
      if (onSuccess) {
        onSuccess(response, options);
      }
      if (response.post && response.post._id) {
      }
      return response;
    } catch (error) {
      console.error(`Failed to create post for batch ${batchIndex}:`, error);
      const errorMessage = error instanceof Error ? error.message : "Unknown error occurred";
      addToast({
        type: "error",
        message: `Failed to create post for ${batch.fileName}: ${errorMessage}`,
        title: "Post Creation Failed"
      });
      if (onError) {
        onError(error, options);
      }
      throw error;
    }
  });
  const createPost = useCallback(async (options) => {
    return await operation.execute(options);
  }, [operation]);
  const reset = useCallback(() => {
    operation.reset();
  }, [operation]);
  return {
    createPost,
    isLoading: operation.isLoading,
    error: operation.error,
    data: operation.data,
    reset
  };
};

const BatchItemDisplay = ({
  batch,
  index
}) => {
  const [showError, setShowError] = useState(false);
  const isTestMode = useTestMode();
  const statusColor = getStatusColor(batch.status);
  const {
    createPost,
    isLoading: isCreatingPost
  } = useBatchPostCreator({
    onSuccess: (response, options) => {
      console.log(`Post created for batch ${options.batchIndex}:`, response.post);
    },
    onError: (error, options) => {
      console.error(`Failed to create post for batch ${options.batchIndex}:`, error);
    }
  });
  const getIcon = () => {
    switch (batch.status) {
      case "finished":
        return /* @__PURE__ */ jsx(MdCheckCircle, {
          className: "text-green-500 w-5 h-5"
        });
      case "processing":
        return /* @__PURE__ */ jsx(CgSpinner, {
          className: "animate-spin text-blue-500 w-5 h-5"
        });
      case "error":
        return /* @__PURE__ */ jsx(MdError, {
          className: "text-red-500 w-5 h-5"
        });
      case "queued":
      default:
        return /* @__PURE__ */ jsx(MdSchedule, {
          className: "text-gray-400 w-5 h-5"
        });
    }
  };
  const formatPageRange = () => {
    if (batch.startPage && batch.endPage) {
      return `Pages ${batch.startPage}-${batch.endPage}`;
    }
    if (batch.pageCount) {
      return `${batch.pageCount} pages`;
    }
    return null;
  };
  const handleCreatePost = () => {
    createPost({
      batchIndex: index,
      batch
    });
  };
  const canCreatePost = isTestMode && batch.status === "finished";
  const pageInfo = formatPageRange();
  const hasSubmissionError = batch.submissionError;
  const isQuotaError = hasSubmissionError && hasSubmissionError.type === "quota_exceeded";
  return /* @__PURE__ */ jsxs("div", {
    className: "relative",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex items-center justify-center w-8 h-8",
        children: getIcon()
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 min-w-0",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2",
          children: [/* @__PURE__ */ jsxs("span", {
            className: "text-xs text-gray-500",
            children: ["#", index + 1]
          }), /* @__PURE__ */ jsx("span", {
            className: "font-medium text-sm truncate",
            children: batch.fileName
          })]
        }), pageInfo && /* @__PURE__ */ jsx("div", {
          className: "text-xs text-gray-600 mt-0.5",
          children: pageInfo
        }), isQuotaError && /* @__PURE__ */ jsx("div", {
          className: "text-xs text-amber-600 mt-1",
          children: "Queued - quota limit reached"
        }), batch.progress !== void 0 && batch.status === "processing" && /* @__PURE__ */ jsx("div", {
          className: "mt-1",
          children: /* @__PURE__ */ jsx("div", {
            className: "w-full bg-gray-200 rounded-full h-1.5",
            children: /* @__PURE__ */ jsx("div", {
              className: "bg-blue-500 h-1.5 rounded-full transition-all duration-300",
              style: {
                width: `${batch.progress}%`
              }
            })
          })
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx(Chip, {
          size: "sm",
          variant: statusColor,
          children: batch.status || "queued"
        }), (batch.error || hasSubmissionError) && /* @__PURE__ */ jsx("button", {
          onClick: () => setShowError(!showError),
          className: `${isQuotaError ? "text-amber-600 hover:text-amber-700" : "text-red-500 hover:text-red-700"} text-sm underline`,
          children: isQuotaError ? "Details" : "Error"
        }), batch.postId && batch.postId.map((postId, postIndex) => {
          const pageNumber = batch.startPage ? batch.startPage + postIndex : postIndex + 1;
          return /* @__PURE__ */ jsxs("a", {
            href: `/trans/post-view/${postId}`,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "flex items-center gap-1 text-blue-500 hover:text-blue-700 transition-colors",
            title: `View page ${pageNumber}`,
            children: [/* @__PURE__ */ jsx(MdOpenInNew, {
              className: "w-3 h-3"
            }), /* @__PURE__ */ jsx("span", {
              className: "text-xs",
              children: pageNumber
            })]
          }, postId);
        }), canCreatePost && /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: isCreatingPost,
          onClick: handleCreatePost,
          background: "blue",
          size: "sm",
          leftIcon: /* @__PURE__ */ jsx(MdPostAdd, {
            className: "w-4 h-4"
          }),
          children: "Create Post"
        })]
      })]
    }), showError && (batch.error || hasSubmissionError) && /* @__PURE__ */ jsxs("div", {
      className: `mt-2 p-3 ${isQuotaError ? "bg-amber-50 border-amber-200" : "bg-red-50 border-red-200"} border rounded text-sm`,
      children: [/* @__PURE__ */ jsx("div", {
        className: `font-medium mb-1 ${isQuotaError ? "text-amber-700" : "text-red-700"}`,
        children: isQuotaError ? "Quota Information:" : "Error Details:"
      }), /* @__PURE__ */ jsx("div", {
        className: `text-xs ${isQuotaError ? "text-amber-600" : "text-red-600"}`,
        children: hasSubmissionError ? hasSubmissionError.message : batch.error
      }), hasSubmissionError && hasSubmissionError.isTransient && /* @__PURE__ */ jsx("div", {
        className: "text-xs text-gray-600 mt-2 italic",
        children: "This batch will be automatically retried when resources become available."
      }), batch.retryCount && batch.retryCount > 0 && /* @__PURE__ */ jsxs("div", {
        className: "text-xs text-gray-500 mt-1",
        children: ["Retry attempts: ", batch.retryCount, batch.lastRetryAt && ` (last attempt: ${new Date(batch.lastRetryAt).toLocaleTimeString()})`]
      })]
    })]
  });
};

const useExecutionProcessor = (paused = false) => {
  const { execution, checkStatus, scheduleBatchProcessing } = useImportExecution();
  const [isScheduling, setIsScheduling] = useState(false);
  const phase = getProcessingPhase(execution.data);
  const scheduleBatches = useMemoizedFn(async () => {
    if (!hasQueuedBatches(execution.data) || isScheduling)
      return;
    setIsScheduling(true);
    try {
      await scheduleBatchProcessing();
    } finally {
      setIsScheduling(false);
    }
  });
  const monitorStatus = useMemoizedFn(async () => {
    if (shouldMonitorStatus(execution.data)) {
      await checkStatus();
    }
  });
  useInterval(() => {
    if (shouldScheduleBatches(execution.data)) {
      scheduleBatches();
    }
  }, !paused && shouldScheduleBatches(execution.data) ? 5e3 : null, { immediate: true });
  useInterval(() => {
    if (shouldMonitorStatus(execution.data)) {
      monitorStatus();
    }
  }, !paused && shouldMonitorStatus(execution.data) ? 3e4 : null, { immediate: true });
  return {
    phase,
    isScheduling,
    scheduleBatches,
    monitorStatus
  };
};

const highlightContainer = cva("transition-all duration-300 ease-out", {
  variants: {
    highlight: {
      none: "",
      selected: "ring-2 ring-blue-400/30 ring-offset-1 bg-blue-50/15",
      "selected-strong": "ring-2 ring-blue-500/40 ring-offset-1 bg-blue-50/25 border-blue-300",
      "selected-minimal": "border-l-4 border-blue-400 bg-blue-50/10",
      processing: "ring-4 ring-blue-500/50 ring-offset-2 bg-blue-50/30 scale-[1.01] shadow-lg",
      success: "ring-4 ring-green-500/50 ring-offset-2 bg-green-50/30",
      error: "ring-4 ring-red-500/50 ring-offset-2 bg-red-50/30"
    },
    animation: {
      none: "",
      pulse: "animate-pulse",
      bounce: "animate-bounce"
    }
  },
  defaultVariants: {
    highlight: "none",
    animation: "none"
  }
});
const HighlightContainer = forwardRef(({
  children,
  highlight,
  animation,
  className,
  ...props
}, ref) => {
  return /* @__PURE__ */ jsx("div", {
    ref,
    className: highlightContainer({
      highlight,
      animation,
      className
    }),
    ...props,
    children
  });
});

const useComponentHighlight = () => {
  const elementRef = useRef(null);
  const [highlightState, setHighlightState] = useState("none");
  const scrollToPerfectCenter = useCallback(() => {
    const element = elementRef.current;
    if (!element)
      return;
    requestAnimationFrame(() => {
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;
      const currentScrollY = window.scrollY;
      const currentScrollX = window.scrollX;
      const elementTop = rect.top + currentScrollY;
      const elementLeft = rect.left + currentScrollX;
      const targetScrollY = elementTop - viewportHeight / 2 + rect.height / 2;
      const targetScrollX = elementLeft - viewportWidth / 2 + rect.width / 2;
      const maxScrollY = Math.max(0, document.documentElement.scrollHeight - viewportHeight);
      const maxScrollX = Math.max(0, document.documentElement.scrollWidth - viewportWidth);
      window.scrollTo({
        top: Math.max(0, Math.min(targetScrollY, maxScrollY)),
        left: Math.max(0, Math.min(targetScrollX, maxScrollX)),
        behavior: "smooth"
      });
    });
  }, []);
  const highlightComponent = useCallback(() => {
    scrollToPerfectCenter();
    setTimeout(() => {
      setHighlightState("processing");
    }, 200);
    setTimeout(() => {
      setHighlightState("selected");
    }, 3200);
  }, [scrollToPerfectCenter]);
  return { elementRef, highlightComponent, highlightState };
};

const PostCreationProgress = ({
  execution
}) => {
  const totalBatches = execution.data.batches.length;
  const postCreationState = execution.data.postCreationState;
  if (totalBatches <= 1 || !postCreationState) {
    return null;
  }
  const currentBatchIndex = postCreationState && postCreationState.currentBatchIndex || 0;
  const progress = Math.round(currentBatchIndex / totalBatches * 100);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-3 px-3 py-2 bg-blue-50 rounded-lg border border-blue-200",
    children: [/* @__PURE__ */ jsx(Spinner, {
      size: "sm"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex-1",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between mb-1",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-sm font-medium text-blue-900",
          children: "Creating post from batches"
        }), /* @__PURE__ */ jsxs("span", {
          className: "text-sm text-blue-700",
          children: [currentBatchIndex, "/", totalBatches]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "w-full bg-blue-200 rounded-full h-2",
        children: /* @__PURE__ */ jsx("div", {
          className: "bg-blue-600 h-2 rounded-full transition-all duration-300",
          style: {
            width: `${progress}%`
          }
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "text-xs text-blue-600 mt-1",
        children: ["Processing batch ", currentBatchIndex + 1, "..."]
      })]
    })]
  });
};

const BatchExecutionDisplay = () => {
  const {
    execution,
    createPost,
    updateExecution,
    checkStatus,
    isCreatingPost,
    isCheckingStatus,
    scheduleBatchProcessing: scheduleBatchProcessingFn,
    stale,
    onDelete
  } = useImportExecution();
  const isTestMode = useTestMode();
  const {
    elementRef,
    highlightState,
    highlightComponent
  } = useComponentHighlight();
  const api = useApi();
  const [paused, setPaused] = useState(false);
  const {
    phase
  } = useExecutionProcessor(paused);
  const {
    state,
    actions
  } = usePdfProcessing();
  const isProcessed = state.execution && execution._id === state.execution._id;
  useEffect(() => {
    if (state.stage === "upload-complete" && state.autoMode && isProcessed) {
      actions.setProcessingStarted();
      highlightComponent();
    }
  }, [state.stage, isProcessed, state.autoMode]);
  useEffect(() => {
    if (phase === "complete" && state.autoMode && isProcessed) {
      actions.setProcessingComplete();
    }
  }, [phase, isProcessed, state.autoMode]);
  const [expanded, setExpanded] = useState(false);
  const {
    addToast
  } = useToast();
  const {
    batches,
    processorId
  } = execution.data;
  const summary = calculateBatchSummary(batches);
  const isComplete = isExecutionComplete(execution);
  const hasErrors = hasExecutionErrors(execution);
  const isExpanded = expanded;
  const postId = execution.post && objectId(execution.post);
  useEffect(() => {
    if (isComplete && !hasErrors && !postId && !isCreatingPost && processorId && !isVMProcessor(processorId)) {
      createPost();
    }
  }, [isComplete]);
  const isActive = !stale && !paused && (phase === "ready" || phase === "processing");
  const scheduleBatchProcessing = useAsyncOperation(async () => {
    await scheduleBatchProcessingFn();
    addToast({
      type: "success",
      message: "Batch processing scheduled successfully"
    });
  });
  const retryFailedBatches = useAsyncOperation(async () => {
    const response = await api.post({
      path: "/uploads/retry-ocr-batches",
      body: {
        executionId: execution._id
      }
    });
    if (response.execution) {
      updateExecution(response.execution);
    }
    const {
      requeued,
      errors
    } = response.summary;
    addToast({
      type: requeued > 0 ? "success" : "warning",
      message: requeued > 0 ? `Requeued ${requeued} batch${requeued === 1 ? "" : "es"} for reprocessing` : `No batches requeued${errors > 0 ? ` (${errors} retry error${errors === 1 ? "" : "s"})` : ""}`
    });
  });
  const deleteImport = useAsyncOperation(async () => {
    await api.post({
      path: "/uploads/delete-import",
      body: {
        executionId: execution._id
      }
    });
    onDelete();
  });
  const hasFinishedBatches = summary.finished > 0;
  const canForceCreatePost = hasFinishedBatches;
  return /* @__PURE__ */ jsx(HighlightContainer, {
    ref: elementRef,
    highlight: highlightState,
    animation: highlightState === "processing" ? "pulse" : "none",
    children: /* @__PURE__ */ jsxs("div", {
      className: "border border-gray-200 rounded-lg overflow-hidden",
      children: [/* @__PURE__ */ jsx("div", {
        className: "p-4 bg-white",
        children: /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-3",
          children: [/* @__PURE__ */ jsx(ToggleButton, {
            expanded: isExpanded,
            onToggle: () => setExpanded(!expanded),
            title: isExpanded ? "Collapse" : "Expand"
          }), /* @__PURE__ */ jsx(ExecutionSummary, {
            execution,
            summary
          }), postId && /* @__PURE__ */ jsx("a", {
            href: "/trans/post-view/" + postId,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "p-1 hover:bg-gray-100 rounded transition-colors",
            title: "View post",
            children: /* @__PURE__ */ jsx(MdOpenInNew, {
              className: "w-4 h-4 text-blue-600"
            })
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-2",
            children: [isActive && /* @__PURE__ */ jsx(Spinner, {}), (phase === "ready" || phase === "processing") && !stale && /* @__PURE__ */ jsx(LoadingButtonTW, {
              onClick: () => setPaused((p) => !p),
              background: paused ? "blue" : "gray",
              size: "sm",
              leftIcon: paused ? /* @__PURE__ */ jsx(MdPlayArrow, {
                className: "w-4 h-4"
              }) : /* @__PURE__ */ jsx(MdPause, {
                className: "w-4 h-4"
              }),
              children: paused ? "Resume" : "Pause"
            }), (summary.failed > 0 || summary.processing > 0 && (paused || stale)) && /* @__PURE__ */ jsxs(LoadingButtonTW, {
              loading: retryFailedBatches.isLoading,
              onClick: retryFailedBatches.execute,
              background: "red",
              size: "sm",
              leftIcon: /* @__PURE__ */ jsx(MdReplay, {
                className: "w-4 h-4"
              }),
              children: ["Retry (", summary.failed + (paused || stale ? summary.processing : 0), ")"]
            }), isTestMode && /* @__PURE__ */ jsxs(Fragment, {
              children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
                loading: isCheckingStatus,
                onClick: checkStatus,
                background: "gray",
                size: "sm",
                leftIcon: /* @__PURE__ */ jsx(MdRefresh, {
                  className: "w-4 h-4"
                }),
                children: "Check Status"
              }), /* @__PURE__ */ jsx(LoadingButtonTW, {
                loading: scheduleBatchProcessing.isLoading,
                onClick: scheduleBatchProcessing.execute,
                background: "blue",
                size: "sm",
                leftIcon: /* @__PURE__ */ jsx(MdScheduleSend, {
                  className: "w-4 h-4"
                }),
                children: "Schedule processing"
              })]
            }), isComplete && !hasErrors && /* @__PURE__ */ jsxs(Fragment, {
              children: [isCreatingPost && /* @__PURE__ */ jsx(PostCreationProgress, {
                execution
              }), /* @__PURE__ */ jsx(LoadingButtonTW, {
                loading: isCreatingPost,
                onClick: createPost,
                background: "blue",
                size: "sm",
                leftIcon: /* @__PURE__ */ jsx(MdPostAdd, {
                  className: "w-4 h-4"
                }),
                children: "Create Post"
              })]
            })]
          })]
        })
      }), isExpanded && /* @__PURE__ */ jsxs("div", {
        className: "border-t border-gray-200 bg-gray-50 p-4",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "space-y-2",
          children: [batches.length > 1 && /* @__PURE__ */ jsxs("div", {
            className: "text-sm font-medium text-gray-700 mb-3",
            children: ["Batch Files (", batches.length, ")"]
          }), batches.map((batch, index) => /* @__PURE__ */ jsx(BatchItemDisplay, {
            batch,
            index
          }, `${batch.batchId}-${index}`))]
        }), /* @__PURE__ */ jsx("div", {
          className: "mt-4",
          children: /* @__PURE__ */ jsx(CollapsibleSection, {
            title: "Danger zone",
            defaultCollapsed: true,
            variant: "minimal",
            titleSize: "sm",
            toggleSize: "xs",
            children: /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-3 pt-2",
              children: [canForceCreatePost && /* @__PURE__ */ jsxs(Fragment, {
                children: [isCreatingPost && /* @__PURE__ */ jsx(PostCreationProgress, {
                  execution
                }), /* @__PURE__ */ jsx(LoadingButtonTW, {
                  loading: isCreatingPost,
                  onClick: createPost,
                  background: "gray",
                  size: "sm",
                  leftIcon: /* @__PURE__ */ jsx(MdPostAdd, {
                    className: "w-4 h-4"
                  }),
                  children: "Create post from available pages"
                })]
              }), /* @__PURE__ */ jsx(LoadingButtonTW, {
                loading: deleteImport.isLoading,
                onClick: deleteImport.execute,
                background: "red",
                size: "sm",
                leftIcon: /* @__PURE__ */ jsx(MdDeleteOutline, {
                  className: "w-4 h-4"
                }),
                children: "Delete import"
              }), /* @__PURE__ */ jsx("span", {
                className: "text-xs text-gray-500",
                children: "Cancels any running jobs and removes this import record."
              })]
            })
          })
        })]
      })]
    })
  });
};

const makeId = () => `${Date.now()}-${Math.random().toString(36).slice(2)}`;
const MultiFileQueueContext = createContext(null);
const useMultiFileQueue = () => {
  const ctx = useContext(MultiFileQueueContext);
  if (!ctx)
    throw new Error("useMultiFileQueue must be used within MultiFileQueueProvider");
  return ctx;
};
const computeSummary = (items) => {
  const summary = {
    total: items.length,
    pending: 0,
    active: 0,
    processing: 0,
    done: 0,
    error: 0
  };
  for (let i = 0; i < items.length; i++) {
    const s = items[i].status;
    if (s === "pending")
      summary.pending++;
    else if (s === "splitting" || s === "uploading")
      summary.active++;
    else if (s === "processing")
      summary.processing++;
    else if (s === "done")
      summary.done++;
    else if (s === "error")
      summary.error++;
  }
  return summary;
};
const MultiFileQueueProvider = ({
  children
}) => {
  const [state, setState] = useState({
    items: [],
    running: false
  });
  const setFiles = useMemoizedFn((files) => {
    const items = files.map((file) => ({
      id: makeId(),
      file,
      status: "pending"
    }));
    setState({
      items,
      running: false
    });
  });
  const addFiles = useMemoizedFn((files) => {
    const newItems = files.map((file) => ({
      id: makeId(),
      file,
      status: "pending"
    }));
    setState((prev) => ({
      ...prev,
      items: [...prev.items, ...newItems]
    }));
  });
  const updateItem = useMemoizedFn((id, patch) => {
    setState((prev) => ({
      ...prev,
      items: prev.items.map((item) => item.id === id ? {
        ...item,
        ...patch
      } : item)
    }));
  });
  const setRunning = useMemoizedFn((running) => {
    setState((prev) => ({
      ...prev,
      running
    }));
  });
  const reset = useMemoizedFn(() => {
    setState({
      items: [],
      running: false
    });
  });
  const removeByExecutionId = useMemoizedFn((executionId) => {
    setState((prev) => ({
      ...prev,
      items: prev.items.filter((item) => item.execution._id !== executionId)
    }));
  });
  const summary = computeSummary(state.items);
  return /* @__PURE__ */ jsx(MultiFileQueueContext.Provider, {
    value: {
      state,
      actions: {
        setFiles,
        addFiles,
        updateItem,
        setRunning,
        reset,
        removeByExecutionId
      },
      summary
    },
    children
  });
};

const ImportExecution = ({
  execution,
  setExecutions
}) => {
  const {
    actions
  } = useMultiFileQueue();
  const {
    _id,
    started,
    status
  } = execution;
  const stale = status !== "finished" && checkStale(new Date(started));
  const batchExecution = convertToBatchFormat(execution);
  const handleExecutionUpdate = (updatedExecution) => {
    setExecutions((executions) => executions.map((e) => e._id === updatedExecution._id ? updatedExecution : e));
  };
  const handleDelete = () => {
    setExecutions((executions) => executions.filter((e) => e._id !== _id));
    actions.removeByExecutionId(_id);
  };
  return /* @__PURE__ */ jsx(ImportExecutionProvider, {
    execution: batchExecution,
    onExecutionUpdate: handleExecutionUpdate,
    onDelete: handleDelete,
    stale,
    children: /* @__PURE__ */ jsx(ImportExecutionInner, {})
  });
};
const ImportExecutionInner = () => {
  return /* @__PURE__ */ jsx(BatchExecutionDisplay, {});
};

const horizontalRulerVariants = cva("border-t w-full", {
  variants: {
    variant: {
      default: "border-gray-200",
      light: "border-gray-100",
      dark: "border-gray-400",
      subtle: "border-gray-200/50",
      dashed: "border-gray-300 border-dashed",
      dotted: "border-gray-300 border-dotted"
    },
    spacing: {
      none: "",
      sm: "my-2",
      md: "my-4",
      lg: "my-6",
      xl: "my-8"
    },
    thickness: {
      thin: "border-t",
      medium: "border-t-2",
      thick: "border-t-4"
    }
  },
  defaultVariants: {
    variant: "default",
    spacing: "none",
    thickness: "thin"
  }
});
const HorizontalRuler$2 = ({
  className,
  variant,
  spacing,
  thickness,
  ...props
}) => {
  return /* @__PURE__ */ jsx("hr", {
    className: horizontalRulerVariants({
      variant,
      spacing,
      thickness,
      className
    }),
    ...props
  });
};

const useUploadSplitBatch = ({
  onSuccess,
  onError,
  onStart
}) => {
  const api = useApi();
  const { actions } = usePdfProcessing();
  const uploadOperation = useAsyncOperation(async () => {
    const {
      splitData,
      file,
      options = {}
    } = onStart();
    actions.setUploadStarted();
    const processor = options.processor || "";
    const width = options.width !== void 0 ? String(options.width) : "600";
    const circleId = options.circleId || "";
    const includePageThumbnails = options.includePageThumbnails !== false;
    if (!circleId) {
      throw new Error("Circle ID required");
    }
    if (!splitData || !splitData.files || !file) {
      throw new Error("No split data or file available");
    }
    let execution = null;
    for (let i = 0; i < splitData.files.length; i++) {
      const splitFile = splitData.files[i];
      const splitDetail = splitData.summary.splitDetails[i];
      const base64Data = splitFile.base64Data;
      const binaryString = atob(base64Data);
      const bytes = new Uint8Array(binaryString.length);
      for (let j = 0; j < binaryString.length; j++) {
        bytes[j] = binaryString.charCodeAt(j);
      }
      const blob = new Blob([bytes], { type: "application/pdf" });
      const pageRange = splitDetail.pages;
      const [startPage, endPage] = pageRange.split("-").map(Number);
      const fileName = `${file.name.replace(".pdf", "")}_pages_${startPage}-${endPage}.pdf`;
      const chunkFile = new File([blob], fileName, { type: "application/pdf" });
      const uploadData = {
        0: chunkFile,
        executionId: execution && execution._id || "",
        chunkIndex: String(i),
        totalChunks: String(splitData.files.length),
        originalFileName: splitData.summary.originalFile || file.name,
        processor,
        width,
        circleId,
        startPage: String(startPage),
        endPage: String(endPage),
        pageCount: String(endPage - startPage + 1),
        includePageThumbnails: String(includePageThumbnails)
      };
      try {
        const maxRetries = 3;
        const response = await withRetry(() => api.upload({
          ...uploadData,
          path: "/uploads/upload-pdf-chunk"
        }), {
          maxRetries,
          onRetry: (attempt, error) => {
            console.log(`Retry ${attempt}/${maxRetries} for chunk ${i}:`, error.message);
          },
          onSuccess: (result, totalAttempts) => {
            if (totalAttempts > 1) {
              console.log(`Chunk ${i} succeeded after ${totalAttempts} attempts`);
            }
          },
          onFinalFailure: (error, attempts) => {
            console.error(`Failed to upload chunk ${i} after ${attempts} attempts`);
          }
        });
        execution = response.execution;
        if (onSuccess && execution) {
          const progressResponse = {
            execution
          };
          onSuccess(progressResponse);
        }
        console.log(`Chunk ${i + 1}/${splitData.files.length} uploaded: ${fileName}`);
      } catch (error) {
        actions.setError(error);
        if (onError) {
          onError(error);
          return;
        }
        throw error;
      }
    }
    actions.setUploadComplete(execution);
    return true;
  });
  const uploadBatch = useCallback(async () => {
    await uploadOperation.execute();
  }, [uploadOperation, onError]);
  return {
    uploadBatch,
    isLoading: uploadOperation.isLoading,
    error: uploadOperation.error,
    data: uploadOperation.data,
    reset: uploadOperation.reset
  };
};

const PdfBatchUploadSection = ({
  filesCount,
  file,
  circleId,
  width,
  processor,
  executions,
  setExecutions,
  className
}) => {
  const {
    addToast
  } = useToast();
  const [uploadProgress, setUploadProgress] = useState(null);
  const {
    state
  } = usePdfProcessing();
  const isTestMode = useTestMode();
  const {
    splitData
  } = state;
  const uploadBatch = useUploadSplitBatch({
    onSuccess: ({
      execution
    }) => {
      if (execution) {
        const totalFiles = execution.data.totalFiles;
        const uploadedFiles = execution.data.batches.length;
        setUploadProgress({
          currentFile: uploadedFiles,
          totalFiles
        });
        setExecutions([execution, ...executions.filter((e) => e._id !== execution._id)]);
        if (uploadedFiles === totalFiles) {
          addToast({
            type: "info",
            message: "Files queued for processing"
          });
        }
      }
    },
    onError: (error) => {
      addToast({
        type: "error",
        message: `Upload failed: ${errorMessage(error)}`
      });
    },
    onStart() {
      setUploadProgress(null);
      return {
        splitData,
        file,
        options: {
          circleId,
          width,
          processor
        }
      };
    }
  });
  useEffect(() => {
    if (state.stage === "split-complete" && state.autoMode && splitData) {
      uploadBatch.uploadBatch();
    }
  }, [state.stage, state.autoMode, splitData]);
  const handleUpload = () => {
    uploadBatch.uploadBatch();
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `mt-4 pt-4 border-t border-gray-200 relative ${className || ""}`,
    children: [uploadBatch.isLoading && uploadProgress && /* @__PURE__ */ jsx("div", {
      className: "absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10 rounded",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col items-center gap-2",
        children: [/* @__PURE__ */ jsx(Spinner, {
          size: "lg"
        }), /* @__PURE__ */ jsx("div", {
          className: "text-sm text-center text-gray-600",
          children: /* @__PURE__ */ jsxs("div", {
            children: ["Uploading file ", uploadProgress.currentFile, " of ", uploadProgress.totalFiles]
          })
        })]
      })
    }), isTestMode && /* @__PURE__ */ jsx("div", {
      className: "flex gap-3 w-full",
      children: /* @__PURE__ */ jsxs(LoadingButtonTW, {
        onClick: handleUpload,
        loading: uploadBatch.isLoading,
        background: "gray",
        className: "w-full",
        children: ["Upload ", filesCount, " Split Files for Batch Processing"]
      })
    }), uploadBatch.error && /* @__PURE__ */ jsxs("div", {
      className: "mt-2 p-3 bg-red-50 border border-red-200 rounded text-sm text-red-700",
      children: [/* @__PURE__ */ jsx("strong", {
        children: "Upload Error:"
      }), " ", uploadBatch.error.message]
    }), uploadBatch.data && !uploadBatch.isLoading && /* @__PURE__ */ jsxs("div", {
      className: `mt-2 p-3 bg-green-50 border-green-200 border rounded text-sm`,
      children: [/* @__PURE__ */ jsx("strong", {
        className: "text-green-700",
        children: "Success:"
      }), /* @__PURE__ */ jsx("span", {
        className: "text-green-600",
        children: "Files uploaded for batch processing"
      })]
    })]
  });
};

const PDFSplitSummary = ({
  data,
  variant = "server",
  className = ""
}) => {
  if (!data)
    return null;
  const {
    summary,
    files
  } = data;
  const isWorker = variant === "worker";
  const titlePrefix = isWorker ? "Worker " : "";
  const summaryBgColor = isWorker ? "bg-blue-50" : "bg-gray-50";
  const iconColor = isWorker ? "text-blue-500" : "text-gray-500";
  const downloadPdf = (file, fileName) => {
    const byteCharacters = atob(file.base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/pdf"
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `p-4 bg-white rounded-lg shadow ${className}`,
    children: [/* @__PURE__ */ jsxs("h3", {
      className: "text-lg font-semibold mb-4",
      children: [titlePrefix, "Split Summary"]
    }), /* @__PURE__ */ jsxs("div", {
      className: `mb-4 p-3 ${summaryBgColor} rounded`,
      children: [/* @__PURE__ */ jsxs("p", {
        children: [/* @__PURE__ */ jsx("strong", {
          children: "Original:"
        }), " ", summary.originalFile]
      }), /* @__PURE__ */ jsxs("p", {
        children: [/* @__PURE__ */ jsx("strong", {
          children: "Total Pages:"
        }), " ", summary.totalPages]
      }), /* @__PURE__ */ jsxs("p", {
        children: [/* @__PURE__ */ jsx("strong", {
          children: "Split Files:"
        }), " ", summary.totalSplitFiles]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "space-y-2",
      children: summary.splitDetails.map((detail, index) => /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between p-3 border rounded hover:bg-gray-50",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center",
          children: [/* @__PURE__ */ jsx(FiFileText, {
            className: `h-4 w-4 mr-2 ${iconColor}`
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("span", {
              className: "font-medium",
              children: detail.fileName
            }), /* @__PURE__ */ jsxs("span", {
              className: "ml-2 text-sm text-gray-600",
              children: ["Pages ", detail.pages, " \u2022 ", detail.sizeMB, " MB"]
            })]
          })]
        }), /* @__PURE__ */ jsxs("button", {
          onClick: () => downloadPdf(files[index], detail.fileName),
          className: "flex items-center px-3 py-1 text-sm bg-blue-600 text-white rounded hover:bg-blue-700",
          children: [/* @__PURE__ */ jsx(FiDownload, {
            className: "h-3 w-3 mr-1"
          }), "Download"]
        })]
      }, index))
    })]
  });
};

const PdfProcessingResults = ({
  file,
  circleId,
  width,
  processor,
  executions,
  setExecutions
}) => {
  const {
    state
  } = usePdfProcessing();
  const workerSplitData = state.splitData;
  if (!workerSplitData) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsx("h2", {
      className: "text-lg font-semibold",
      children: "4. Last file upload"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx(CollapsibleSection, {
        title: "Split files",
        defaultCollapsed: true,
        variant: "elevated",
        headerVariant: "primary",
        contentVariant: "primary",
        toggleVariant: "primary",
        children: /* @__PURE__ */ jsx(PDFSplitSummary, {
          data: workerSplitData,
          variant: "worker"
        })
      }), workerSplitData.files && workerSplitData.files.length > 0 && /* @__PURE__ */ jsx(PdfBatchUploadSection, {
        filesCount: workerSplitData.files.length,
        file,
        circleId,
        width,
        processor,
        executions,
        setExecutions
      })]
    })]
  });
};

const TestModeToggle = () => {
  if (!isPlaygroundUrl()) {
    return null;
  }
  const {
    isTestMode,
    toggleTestMode
  } = useTestModeControls();
  return /* @__PURE__ */ jsx("div", {
    className: "fixed top-4 right-4 z-50",
    children: /* @__PURE__ */ jsxs("button", {
      onClick: toggleTestMode,
      className: `px-4 py-2 rounded-lg font-medium transition-colors ${isTestMode ? "bg-red-500 hover:bg-red-600 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`,
      children: ["Test Mode: ", isTestMode ? "ON" : "OFF"]
    })
  });
};

const panelVariants = cva("border rounded-lg p-6 text-center bg-gray-50", {
  variants: {
    variant: {
      default: "border-gray-200",
      card: "border-gray-200 bg-white shadow-sm",
      inline: "border-blue-200 bg-blue-50"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const CircleMembershipRequiredPanel = ({
  circle,
  variant
}) => {
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: panelVariants({
      variant
    }),
    children: [/* @__PURE__ */ jsxs("h3", {
      className: "text-lg font-medium text-gray-900 mb-2",
      children: ["Join ", circle.name, " to see this content"]
    }), /* @__PURE__ */ jsx("p", {
      className: "text-gray-600 mb-4",
      children: "You need to be a member of this circle to view this page."
    }), /* @__PURE__ */ jsx("a", {
      href: circleUrl(circle),
      className: "bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors",
      children: "View Circle"
    })]
  });
};

const PdfImportPanel = ({
  circleId
}) => {
  const [processor, setProcessor] = useState("");
  const [width, setWidth] = useState("600");
  const [pageNo, setPageNo] = useState("15");
  const {
    data: circleData = {}
  } = useCircle(circleId);
  const {
    group: circle,
    membership
  } = circleData;
  const {
    addToast
  } = useToast();
  const isTestMode = useTestMode();
  const {
    state,
    actions
  } = usePdfProcessing();
  const {
    executions,
    setExecutions
  } = useExecutions({
    id: circleId
  });
  const {
    file,
    fileInfo,
    dropzone,
    clearFile
  } = usePdfFileHandler({
    onFileSelect: (selectedFile) => {
      console.log("File selected:", selectedFile.name);
      workerSplit.reset();
    }
  });
  const maxPagesPerFile = parseInt(pageNo);
  const workerSplit = useWorkerSplit({
    file,
    onSuccess: (data) => {
      addToast({
        type: "success",
        message: `Worker split completed: ${data.summary.totalSplitFiles} files created`
      });
    },
    onError: (error) => {
      addToast({
        type: "error",
        message: `Worker split failed: ${error.message}`
      });
    },
    defaultOptions: {
      maxPagesPerFile: maxPagesPerFile < 1 ? 1 : !maxPagesPerFile ? 1 : maxPagesPerFile
    }
  });
  if (!membership) {
    return /* @__PURE__ */ jsx(CircleMembershipRequiredPanel, {
      circle
    });
  }
  const isProcessing = workerSplit.isLoading;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 flex flex-col gap-6",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2 relative",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex items-start justify-between",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/* @__PURE__ */ jsx("h1", {
            className: "text-2xl font-semibold",
            children: "Process your documents with DAIR"
          }), isTestMode && /* @__PURE__ */ jsxs("div", {
            className: "inline-flex items-center gap-2 px-3 py-1 bg-red-50 border border-red-200 rounded-md text-sm text-red-700",
            children: [/* @__PURE__ */ jsx("div", {
              className: "w-2 h-2 bg-red-500 rounded-full animate-pulse"
            }), "Test Mode Active"]
          })]
        }), /* @__PURE__ */ jsx(TestModeToggle, {})]
      })
    }), circle && /* @__PURE__ */ jsxs("p", {
      className: "text-gray-600 font-semibold",
      children: ["For circle:", /* @__PURE__ */ jsx("a", {
        href: circleUrl(circleId),
        className: "text-blue-600",
        children: /* @__PURE__ */ jsx("span", {
          className: "underline mx-2",
          children: circle.name
        })
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "1. Processing Options"
      }), /* @__PURE__ */ jsx(PdfProcessingOptions, {
        processor,
        onProcessorChange: setProcessor,
        width,
        onWidthChange: setWidth,
        pageNo,
        onPageNoChange: setPageNo,
        isCircleAdmin: membership.role === "ADMIN"
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "2. Select PDF Document"
      }), /* @__PURE__ */ jsx(PdfFileSelector, {
        dropzone,
        file,
        fileInfo,
        isProcessing,
        progressInfo: workerSplit.progress
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-2",
        children: /* @__PURE__ */ jsx("h2", {
          className: "text-lg font-semibold",
          children: "3. Process Document"
        })
      }), /* @__PURE__ */ jsx(LoadingButtonTW, {
        onClick: () => actions.startAutoSplitAndUpload(),
        loading: state.autoMode,
        disabled: !file,
        background: "red",
        children: "Upload"
      }), isTestMode && /* @__PURE__ */ jsx(LoadingButtonTW, {
        onClick: () => workerSplit.execute(),
        loading: workerSplit.isLoading,
        disabled: !file,
        background: "gray",
        children: "Split in Worker"
      }), state.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: state.error,
        variant: "detailed",
        onDismiss: () => actions.setError(null)
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(PdfProcessingResults, {
      file,
      circleId,
      width,
      processor,
      executions,
      setExecutions
    }), executions.length > 0 && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-4",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/* @__PURE__ */ jsx("h2", {
            className: "text-lg font-semibold",
            children: "5. Processing Status"
          }), /* @__PURE__ */ jsx("p", {
            className: "text-sm text-gray-600",
            children: 'Background processing tasks. Click "Create Post" when processing is finished'
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "flex flex-col gap-3 p-4 bg-gray-50 rounded-lg",
          children: executions.map((execution) => /* @__PURE__ */ jsx(ImportExecution, {
            execution,
            setExecutions
          }, execution._id))
        })]
      })]
    })]
  });
};

const PdfSimple = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(PdfSimpleInner, {})
  });
};
const PdfSimpleInner = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  const circleId = parts[parts.findIndex((v) => v === "pdf-simple") + 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(PdfProcessingProvider, {
        children: /* @__PURE__ */ jsx(PdfImportPanel, {
          circleId
        })
      })
    })]
  });
};

const FilterSuggestionsPanel = ({
  data,
  loading,
  error,
  state
}) => {
  const {
    filters: {
      selectedFilters,
      setSelectedFilters
    }
  } = state;
  const handleFilterToggle = (category, value) => {
    setSelectedFilters((prev) => {
      const current = prev[category] || [];
      const updated = current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
      return {
        ...prev,
        [category]: updated
      };
    });
  };
  if (!data && !loading && !error)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full border-t pt-6",
    children: [/* @__PURE__ */ jsx("h2", {
      className: "text-lg font-semibold mb-4",
      children: "Filter Suggestions"
    }), loading && /* @__PURE__ */ jsx("div", {
      className: "flex justify-center py-8",
      children: /* @__PURE__ */ jsx(Spinner, {})
    }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error
    }), data && /* @__PURE__ */ jsx("div", {
      className: "space-y-4",
      children: Object.entries(data.filters).map(([category, options]) => {
        if (!options || options.length === 0)
          return null;
        return /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/* @__PURE__ */ jsx("h3", {
            className: "font-medium text-sm text-gray-700",
            children: formatCategoryName(category)
          }), /* @__PURE__ */ jsx("div", {
            className: "flex flex-wrap gap-2",
            children: options.map((option) => /* @__PURE__ */ jsxs("button", {
              onClick: () => handleFilterToggle(category, option.value),
              className: `
                                                px-3 py-1 rounded-full text-sm border transition-colors
                                                ${selectedFilters[category] && selectedFilters[category].includes && selectedFilters[category].includes(option.value) ? "bg-blue-100 border-blue-300 text-blue-700" : "bg-gray-50 border-gray-300 text-gray-700 hover:bg-gray-100"}
                                            `,
              children: [option.displayLabel || option.label, /* @__PURE__ */ jsxs("span", {
                className: "ml-1 text-xs text-gray-500",
                children: ["(", option.count, ")"]
              })]
            }, option.value))
          })]
        }, category);
      })
    })]
  });
};
const formatCategoryName = (category) => {
  const names = {
    documentTypes: "Document Types",
    categoryCodes: "Categories",
    tags: "Tags",
    persons: "Persons",
    organizations: "Organizations",
    locations: "Locations",
    authors: "Authors",
    sourceInstitutions: "Source Institutions",
    languages: "Languages",
    privacy: "Privacy"
  };
  return names[category] || category;
};

const SearchResults = ({
  results,
  searchOperation
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsxs("h2", {
      className: "text-lg font-semibold",
      children: ["4. Search Results ", results.length > 0 && `(${results.length})`]
    }), results.length > 0 ? /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-3",
      children: results.map((result, index) => {
        const {
          text,
          postId
        } = result;
        return /* @__PURE__ */ jsxs("div", {
          className: "p-4 border border-gray-200 rounded-lg hover:bg-gray-50",
          children: [/* @__PURE__ */ jsx("div", {
            className: "flex justify-between items-start mb-2",
            children: /* @__PURE__ */ jsxs("span", {
              className: "text-sm font-medium text-blue-600",
              children: ["Score: ", result.score.toFixed(4)]
            })
          }), /* @__PURE__ */ jsx("div", {
            className: "text-gray-700",
            children: text
          }), /* @__PURE__ */ jsx("div", {
            className: "mt-2 text-xs text-gray-500 underline",
            children: /* @__PURE__ */ jsxs("a", {
              href: "/trans/post-view/" + postId,
              children: ["Post ID: ", postId]
            })
          })]
        }, index);
      })
    }) : searchOperation.data && /* @__PURE__ */ jsx("div", {
      className: "text-gray-500 italic",
      children: "No results found for your query."
    })]
  });
};

const useSuggestionsState = () => {
  const [selectedFilters, setSelectedFilters] = useState({});
  return useMemo(() => {
    return {
      filters: {
        selectedFilters,
        setSelectedFilters
      }
    };
  }, [selectedFilters]);
};

const QueryEnhancementPanel = ({
  data,
  loading,
  error
}) => {
  if (!data && !loading && !error)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full border-t pt-6",
    children: [/* @__PURE__ */ jsx("h2", {
      className: "text-lg font-semibold mb-4",
      children: "LLM Query Enhancement"
    }), loading && /* @__PURE__ */ jsx("div", {
      className: "flex justify-center py-8",
      children: /* @__PURE__ */ jsx(Spinner, {})
    }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error
    }), data && data.queryEnhancement && /* @__PURE__ */ jsxs("div", {
      className: "space-y-4",
      children: [data.queryEnhancement.searchIntent && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "font-medium text-sm text-gray-700",
          children: "Search Intent"
        }), /* @__PURE__ */ jsx("span", {
          className: `
                                inline-flex self-start px-3 py-1 rounded-full text-sm font-medium
                                ${data.queryEnhancement.searchIntent === "semantic" ? "bg-purple-100 text-purple-700" : data.queryEnhancement.searchIntent === "exact" ? "bg-green-100 text-green-700" : "bg-blue-100 text-blue-700"}
                            `,
          children: data.queryEnhancement.searchIntent
        })]
      }), data.queryEnhancement.enhancedQuery && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "font-medium text-sm text-gray-700",
          children: "Enhanced Query (for vectors)"
        }), /* @__PURE__ */ jsx("div", {
          className: "bg-purple-50 border border-purple-200 rounded-lg p-3",
          children: /* @__PURE__ */ jsx("p", {
            className: "text-sm text-gray-800 whitespace-pre-wrap",
            dir: "auto",
            children: data.queryEnhancement.enhancedQuery
          })
        })]
      }), data.queryEnhancement.textQuery && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "font-medium text-sm text-gray-700",
          children: "Text Query (for exact matching)"
        }), /* @__PURE__ */ jsx("div", {
          className: "bg-green-50 border border-green-200 rounded-lg p-3",
          children: /* @__PURE__ */ jsx("p", {
            className: "text-sm text-gray-800 whitespace-pre-wrap",
            dir: "auto",
            children: data.queryEnhancement.textQuery
          })
        })]
      }), data.queryEnhancement.reasoning && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "font-medium text-sm text-gray-700",
          children: "LLM Reasoning"
        }), /* @__PURE__ */ jsx("div", {
          className: "bg-gray-50 border border-gray-200 rounded-lg p-3",
          children: /* @__PURE__ */ jsx("p", {
            className: "text-sm text-gray-600 italic",
            dir: "auto",
            children: data.queryEnhancement.reasoning
          })
        })]
      }), data.queryEnhancement.suggestedFilters && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "font-medium text-sm text-gray-700",
          children: "Suggested Filters"
        }), /* @__PURE__ */ jsxs("div", {
          className: "space-y-3",
          children: [renderFilterSection("Language", data.queryEnhancement.suggestedFilters.language ? [data.queryEnhancement.suggestedFilters.language] : []), renderFilterSection("Categories", data.queryEnhancement.suggestedFilters.categories), renderFilterSection("Authors", data.queryEnhancement.suggestedFilters.authors), renderFilterSection("People", data.queryEnhancement.suggestedFilters.people), renderFilterSection("Locations", data.queryEnhancement.suggestedFilters.locations), renderFilterSection("Organizations", data.queryEnhancement.suggestedFilters.organizations), renderFilterSection("Tags", data.queryEnhancement.suggestedFilters.tags), renderFilterSection("Document Types", data.queryEnhancement.suggestedFilters.documentTypes)]
        })]
      }), data.queryEnhancement.clarifyingQuestions && data.queryEnhancement.clarifyingQuestions.length > 0 && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "font-medium text-sm text-gray-700",
          children: "Clarifying Questions"
        }), /* @__PURE__ */ jsx("div", {
          className: "bg-yellow-50 border border-yellow-200 rounded-lg p-3",
          children: /* @__PURE__ */ jsx("ul", {
            className: "list-disc list-inside space-y-1",
            children: data.queryEnhancement.clarifyingQuestions.map((question, idx) => /* @__PURE__ */ jsx("li", {
              className: "text-sm text-gray-700",
              dir: "auto",
              children: question
            }, idx))
          })
        })]
      })]
    })]
  });
};
const renderFilterSection = (title, items) => {
  if (!items || items.length === 0)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-1",
    children: [/* @__PURE__ */ jsxs("span", {
      className: "text-xs font-medium text-gray-600",
      children: [title, ":"]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-wrap gap-1",
      children: items.map((item, idx) => /* @__PURE__ */ jsx("span", {
        className: "px-2 py-0.5 bg-blue-50 border border-blue-200 text-blue-700 text-xs rounded",
        dir: "auto",
        children: item
      }, idx))
    })]
  });
};

const llmModelOptions = [
  {
    value: "gpt-5-nano",
    label: "GPT-5 Nano (Fastest, Recommended)"
  },
  {
    value: "gpt-5-mini",
    label: "GPT-5 Mini (Fast)"
  },
  {
    value: "openai/gpt-4.1-mini-2025-04-14",
    label: "GPT-4.1 Mini (Fast)"
  },
  {
    value: "gpt-4o-mini",
    label: "GPT-4o Mini (Fast)"
  },
  {
    value: "gpt-5",
    label: "GPT-5 (Balanced)"
  },
  {
    value: "openai/gpt-4.1-2025-04-14",
    label: "GPT-4.1 (Balanced)"
  },
  {
    value: "gpt-4o",
    label: "GPT-4o (Balanced)"
  },
  {
    value: "gemini-2.5-flash-lite",
    label: "Gemini 2.5 Flash Lite (Fast)"
  },
  {
    value: "gemini-2.5-flash",
    label: "Gemini 2.5 Flash (Fast)"
  },
  {
    value: "claude-3-5-haiku",
    label: "Claude 3.5 Haiku (Fast)"
  },
  {
    value: "gemini-2.5-pro",
    label: "Gemini 2.5 Pro (Premium)"
  },
  {
    value: "claude-3-5-sonnet",
    label: "Claude 3.5 Sonnet (Premium)"
  },
  {
    value: "claude-4-1-opus",
    label: "Claude 4.1 Opus (Best Quality)"
  },
  {
    value: "deepseek-v3.1",
    label: "DeepSeek V3.1"
  },
  {
    value: "deepseek-r1",
    label: "DeepSeek R1 (Reasoning)"
  }
];
const HybridSearchPanel = ({
  circleId
}) => {
  const [queryEnhancementData, setQueryEnhancementData] = useState(null);
  const [llmModel, setLlmModel] = useState(llmModelOptions[0].value);
  const suggestionsState = useSuggestionsState();
  const [query, setQuery] = useState("");
  const [filterSuggestionsData, setFilterSuggestionsData] = useState(null);
  const [searchType, setSearchType] = useState("hybrid");
  const [resultLimit, setResultLimit] = useState("10");
  const [vectorWeight, setVectorWeight] = useState("0.5");
  const [results, setResults] = useState([]);
  const {
    data: circleData = {}
  } = useCircle(circleId);
  const {
    group: circle,
    membership
  } = circleData;
  const api = useApi();
  const ensureRagIndex = useAsyncOperation(async () => {
    await api.post({
      path: "/groups/elastic/ensure-rag-index",
      body: {
        circleId
      }
    });
    return;
  });
  const dropRagIndex = useAsyncOperation(async () => {
    await api.post({
      path: "/groups/elastic/drop-rag-index",
      body: {
        circleId
      }
    });
    return;
  });
  const indexChunks = useAsyncOperation(async () => {
    await api.post({
      path: "/groups/elastic/index-chunks",
      body: {
        circleId
      }
    });
    return;
  });
  const filterSuggestionsOperation = useAsyncOperation(async () => {
    const response = await api.post({
      path: "/groups/elastic/filter-suggestions",
      body: {
        circleId,
        searchQuery: query,
        maxBuckets: 50
      }
    });
    setFilterSuggestionsData(response);
    return response;
  });
  const llmQuerySuggestionsOperation = useAsyncOperation(async () => {
    const response = await api.post({
      path: "/groups/elastic/llm-query-suggestions",
      body: {
        circleId,
        searchQuery: query,
        modelName: llmModel
      }
    });
    setQueryEnhancementData(response);
    return response;
  });
  const searchOperation = useAsyncOperation(async () => {
    const {
      filters: {
        selectedFilters
      }
    } = suggestionsState;
    const response = await api.post({
      path: "/groups/elastic/search-chunks",
      body: {
        query,
        circleId,
        searchType: searchType === "keyword" ? "text" : searchType,
        k: parseInt(resultLimit),
        vectorWeight: parseFloat(vectorWeight),
        textWeight: searchType === "hybrid" ? 1 - parseFloat(vectorWeight) : 1,
        filters: selectedFilters
      }
    });
    setResults(response.results);
    return response.results;
  });
  if (!membership) {
    return /* @__PURE__ */ jsx(CircleMembershipRequiredPanel, {
      circle
    });
  }
  const handleSearch = async () => {
    if (!query.trim())
      return;
    await searchOperation.execute();
  };
  const isSearching = searchOperation.isLoading;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("h1", {
        className: "text-2xl font-semibold",
        children: "Hybrid Search Test"
      }), circle && /* @__PURE__ */ jsxs("p", {
        className: "text-gray-600",
        children: ["Testing search in circle:", /* @__PURE__ */ jsx("a", {
          href: circleUrl(circleId),
          className: "text-blue-600",
          children: /* @__PURE__ */ jsx("span", {
            className: "underline mx-2",
            children: circle.name
          })
        })]
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "1. Search Configuration"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-3",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/* @__PURE__ */ jsx("label", {
            className: "text-sm font-medium text-gray-700",
            children: "Search Mode"
          }), /* @__PURE__ */ jsx(Select, {
            value: searchType,
            onChange: (value) => setSearchType(value),
            options: [{
              value: "hybrid",
              label: "Hybrid Search"
            }, {
              value: "vector",
              label: "Vector Search"
            }, {
              value: "keyword",
              label: "Keyword Search"
            }],
            placeholder: "Select search type"
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex gap-4",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-2 flex-1",
            children: [/* @__PURE__ */ jsx("label", {
              className: "text-sm font-medium text-gray-700",
              children: "Result Limit"
            }), /* @__PURE__ */ jsx(TextInput, {
              type: "number",
              value: resultLimit,
              onChange: (e) => setResultLimit(e.target.value),
              min: "1",
              max: "50",
              className: "max-w-xs"
            })]
          }), searchType === "hybrid" && /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-2 flex-1",
            children: [/* @__PURE__ */ jsx("label", {
              className: "text-sm font-medium text-gray-700",
              children: "Vector Weight (0-1)"
            }), /* @__PURE__ */ jsx(TextInput, {
              type: "number",
              value: vectorWeight,
              onChange: (e) => setVectorWeight(e.target.value),
              min: "0",
              max: "1",
              step: "0.1",
              className: "max-w-xs"
            })]
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/* @__PURE__ */ jsx("label", {
            className: "text-sm font-medium text-gray-700",
            children: "LLM Model for Query Suggestions"
          }), /* @__PURE__ */ jsx(Select, {
            value: llmModel,
            onChange: (value) => setLlmModel(value),
            options: llmModelOptions,
            placeholder: "Select LLM model"
          })]
        })]
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "2. Ensure Elastic Index"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-3",
        children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: dropRagIndex.isLoading,
          onClick: () => dropRagIndex.execute(),
          background: "blue",
          children: "Drop RAG Index"
        }), /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: ensureRagIndex.isLoading,
          onClick: () => ensureRagIndex.execute(),
          background: "blue",
          children: "Ensure RAG Index"
        }), /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: indexChunks.isLoading,
          onClick: () => indexChunks.execute(),
          background: "blue",
          children: "Index chunks"
        })]
      }), indexChunks.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: indexChunks.error
      }), dropRagIndex.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: dropRagIndex.error
      }), ensureRagIndex.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: ensureRagIndex.error
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "3. Enter Search Query"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-3",
        children: [/* @__PURE__ */ jsx(TextInput, {
          value: query,
          onChange: (e) => setQuery(e.target.value),
          placeholder: "Enter your search query (supports Arabic and English)...",
          onKeyPress: (e) => {
            if (e.key === "Enter" && !isSearching) {
              handleSearch();
            }
          },
          className: "w-full"
        }), /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: isSearching,
          onClick: handleSearch,
          disabled: !query.trim(),
          background: "blue",
          children: "Search"
        }), /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: filterSuggestionsOperation.isLoading,
          onClick: () => filterSuggestionsOperation.execute(),
          background: "gray",
          children: "Filter Suggestions"
        }), /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: llmQuerySuggestionsOperation.isLoading,
          onClick: () => llmQuerySuggestionsOperation.execute(),
          background: "gray",
          children: "LLM query Suggestions"
        })]
      }), llmQuerySuggestionsOperation.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: llmQuerySuggestionsOperation.error
      }), filterSuggestionsOperation.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: filterSuggestionsOperation.error
      }), searchOperation.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: searchOperation.error
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(SearchResults, {
      results,
      searchOperation
    }), /* @__PURE__ */ jsx(FilterSuggestionsPanel, {
      state: suggestionsState,
      data: filterSuggestionsData,
      loading: filterSuggestionsOperation.isLoading,
      error: filterSuggestionsOperation.error
    }), /* @__PURE__ */ jsx(QueryEnhancementPanel, {
      data: queryEnhancementData,
      loading: llmQuerySuggestionsOperation.isLoading,
      error: llmQuerySuggestionsOperation.error
    })]
  });
};

const HybridSearchTest = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(HybridSearchTestInner, {})
  });
};
const HybridSearchTestInner = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  const circleId = parts[parts.findIndex((v) => v === "rag") + 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(HybridSearchPanel, {
        circleId
      })
    })]
  });
};

const VectorResultDisplay = ({
  result
}) => {
  const [expanded, setExpanded] = useState(false);
  const [displayMode, setDisplayMode] = useState("text");
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-3",
    children: [/* @__PURE__ */ jsx("h2", {
      className: "text-lg font-semibold",
      children: "Combined Result"
    }), /* @__PURE__ */ jsxs("div", {
      className: "border rounded-lg overflow-hidden",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between p-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors",
        onClick: () => setExpanded(!expanded),
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "View Full Result"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2",
          children: [expanded && /* @__PURE__ */ jsxs("div", {
            className: "flex gap-1",
            children: [/* @__PURE__ */ jsx("button", {
              onClick: (e) => {
                e.stopPropagation();
                setDisplayMode("text");
              },
              className: `px-2 py-1 text-xs rounded transition-colors ${displayMode === "text" ? "bg-blue-500 text-white" : "bg-white text-gray-700 hover:bg-gray-100"}`,
              children: "Text"
            }), /* @__PURE__ */ jsx("button", {
              onClick: (e) => {
                e.stopPropagation();
                setDisplayMode("html");
              },
              className: `px-2 py-1 text-xs rounded transition-colors ${displayMode === "html" ? "bg-blue-500 text-white" : "bg-white text-gray-700 hover:bg-gray-100"}`,
              children: "HTML"
            })]
          }), expanded ? /* @__PURE__ */ jsx(MdExpandLess, {
            size: 20
          }) : /* @__PURE__ */ jsx(MdExpandMore, {
            size: 20
          })]
        })]
      }), expanded && /* @__PURE__ */ jsx("div", {
        className: "p-4 border-t",
        children: displayMode === "text" ? /* @__PURE__ */ jsx("pre", {
          className: "whitespace-pre-wrap text-sm bg-gray-50 p-4 rounded overflow-auto max-h-96 font-mono",
          dir: "auto",
          children: result
        }) : /* @__PURE__ */ jsx("div", {
          className: "prose max-w-none",
          dir: "auto",
          dangerouslySetInnerHTML: {
            __html: result
          }
        })
      })]
    })]
  });
};

const SearchResultItem = ({
  index,
  chunkText,
  searchResult
}) => {
  const [expanded, setExpanded] = useState(false);
  const [displayMode, setDisplayMode] = useState("text");
  const {
    score,
    metadata: chunk
  } = searchResult;
  const {
    postId,
    title
  } = chunk;
  return /* @__PURE__ */ jsxs("div", {
    className: "border rounded-lg overflow-hidden",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between p-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors",
      onClick: () => setExpanded(!expanded),
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-3 flex-1 min-w-0",
        children: [/* @__PURE__ */ jsxs("span", {
          className: "text-sm font-medium text-gray-500 flex-shrink-0",
          children: ["#", index + 1]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col min-w-0 flex-1",
          children: [/* @__PURE__ */ jsx("a", {
            href: `/trans/post-view/${postId}`,
            className: "text-blue-600 hover:underline font-medium truncate",
            onClick: (e) => e.stopPropagation(),
            dir: "auto",
            children: title || `Post ${postId}`
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-3 text-xs text-gray-500",
            children: [/* @__PURE__ */ jsxs("span", {
              className: "font-semibold",
              children: ["Score: ", score.toFixed(4)]
            }), /* @__PURE__ */ jsx("span", {
              children: "\u2022"
            }), /* @__PURE__ */ jsxs("span", {
              className: "truncate",
              children: ["Post ID: ", postId]
            })]
          })]
        })]
      }), expanded ? /* @__PURE__ */ jsx(MdExpandLess, {
        size: 20
      }) : /* @__PURE__ */ jsx(MdExpandMore, {
        size: 20
      })]
    }), expanded && /* @__PURE__ */ jsxs("div", {
      className: "p-4 border-t",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex gap-1 mb-3",
        children: [/* @__PURE__ */ jsx("button", {
          onClick: () => setDisplayMode("text"),
          className: `px-3 py-1 text-sm rounded transition-colors ${displayMode === "text" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`,
          children: "Text"
        }), /* @__PURE__ */ jsx("button", {
          onClick: () => setDisplayMode("html"),
          className: `px-3 py-1 text-sm rounded transition-colors ${displayMode === "html" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`,
          children: "HTML"
        }), /* @__PURE__ */ jsx("button", {
          onClick: () => setDisplayMode("json"),
          className: `px-3 py-1 text-sm rounded transition-colors ${displayMode === "json" ? "bg-blue-500 text-white" : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`,
          children: "JSON (IChunk)"
        })]
      }), displayMode === "text" && /* @__PURE__ */ jsx("pre", {
        className: "whitespace-pre-wrap text-sm bg-gray-50 p-4 rounded overflow-auto max-h-96 font-mono",
        dir: "auto",
        children: chunkText
      }), displayMode === "html" && /* @__PURE__ */ jsx("div", {
        className: "prose max-w-none",
        dir: "auto",
        dangerouslySetInnerHTML: {
          __html: chunkText
        }
      }), displayMode === "json" && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("div", {
          className: "text-xs text-gray-500 font-medium",
          children: "IChunk Metadata:"
        }), /* @__PURE__ */ jsx("pre", {
          className: "whitespace-pre-wrap text-xs bg-gray-50 p-4 rounded overflow-auto max-h-96 font-mono",
          children: JSON.stringify(chunk, null, 2)
        })]
      })]
    })]
  });
};

const VectorCommandPanel = ({
  circleId,
  post
}) => {
  const [query, setQuery] = useState("");
  const [response, setResponse] = useState(null);
  const {
    data: circleData = {}
  } = useCircle(circleId);
  const {
    group: circle,
    membership
  } = circleData;
  const api = useApi();
  const vectorSearch = useAsyncOperation(async () => {
    const data = await withRetry(() => api.get({
      path: "/ai/group/vector?circle=" + circleId + "&query=" + encodeURIComponent(query)
    }));
    setResponse(data);
  });
  if (!membership) {
    return /* @__PURE__ */ jsx(CircleMembershipRequiredPanel, {
      circle
    });
  }
  const handleSearch = async () => {
    if (!query.trim())
      return;
    vectorSearch.execute();
  };
  const isSearching = vectorSearch.isLoading;
  const searchResults = response ? response.found.map((item, index) => ({
    index,
    chunkText: response.chunks[index] || "",
    searchResult: item
  })) : [];
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 flex flex-col gap-6",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2",
      children: /* @__PURE__ */ jsx("h1", {
        className: "text-2xl font-semibold",
        children: "Vector Command"
      })
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "Search Configuration"
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-3",
        children: /* @__PURE__ */ jsx("div", {
          className: "flex gap-4",
          children: /* @__PURE__ */ jsx("div", {
            className: "flex flex-col gap-2 flex-1",
            children: /* @__PURE__ */ jsx(TextInput, {
              value: query,
              onChange: (e) => setQuery(e.target.value),
              placeholder: "Enter your vector command (e.g., vector -q 'your question' -s 10)",
              onKeyPress: (e) => {
                if (e.key === "Enter" && !isSearching) {
                  handleSearch();
                }
              },
              className: "w-full"
            })
          })
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-3",
        children: /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: vectorSearch.isLoading,
          onClick: () => vectorSearch.execute(),
          background: "blue",
          children: "Execute Vector Command"
        })
      }), vectorSearch.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: vectorSearch.error
      })]
    }), response && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(VectorResultDisplay, {
        result: response.result
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-3",
        children: [/* @__PURE__ */ jsxs("h2", {
          className: "text-lg font-semibold",
          children: ["Search Results (", searchResults.length, " items)"]
        }), /* @__PURE__ */ jsx("div", {
          className: "flex flex-col gap-2",
          children: searchResults.map((item) => /* @__PURE__ */ jsx(SearchResultItem, {
            index: item.index,
            chunkText: item.chunkText,
            searchResult: item.searchResult
          }, item.index))
        })]
      })]
    })]
  });
};

const VectorCommandTest = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(VectorCommandTestInner, {})
  });
};
const VectorCommandTestInner = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const postId = parts[parts.findIndex((v) => v === "vector") + 1];
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(VectorCommandPanel, {
        circleId: postId
      })
    })]
  });
};

const MAX_MESSAGES$6 = 10;
const WebSocketMessagesMonitor = () => {
  const [messages, setMessages] = useState([]);
  const {
    activities$
  } = useActivityContext();
  const api = useApi();
  activities$.useSubscription((msg) => {
    const message = msg;
    const newMessage = {
      id: Date.now().toString() + Math.random(),
      type: message.type || "unknown",
      timestamp: new Date(),
      data: message
    };
    setMessages((prev) => {
      const updated = [newMessage, ...prev];
      return updated.slice(0, MAX_MESSAGES$6);
    });
  });
  const sendTestMessage = useAsyncOperation(async () => {
    await api.get({
      path: "/playground/websockets/test-bullmq"
    });
  }, {
    showSuccessToast: "Test message sent successfully",
    showErrorToast: true
  });
  const handleClear = () => {
    setMessages([]);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "WebSocket Messages"
      }), /* @__PURE__ */ jsx(LoadingButtonTW, {
        loading: sendTestMessage.isLoading,
        onClick: () => sendTestMessage.execute(),
        background: "blue",
        children: "Send Test Message"
      }), messages.length > 0 && /* @__PURE__ */ jsx("button", {
        onClick: handleClear,
        className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
        children: "Clear"
      })]
    }), sendTestMessage.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: sendTestMessage.error
    }), /* @__PURE__ */ jsxs("div", {
      className: "text-sm text-gray-600",
      children: ["Latest ", MAX_MESSAGES$6, " messages (newest first)"]
    }), messages.length === 0 ? /* @__PURE__ */ jsx("div", {
      className: "p-8 text-center text-gray-500 bg-gray-50 rounded-md",
      children: "No messages received yet. Waiting for WebSocket events..."
    }) : /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2",
      children: messages.map((message) => /* @__PURE__ */ jsx(WebSocketMessageItem, {
        message
      }, message.id))
    })]
  });
};
const WebSocketMessageItem = ({
  message
}) => {
  const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });
  };
  const getTypeColor = (type) => {
    const colors = {
      vote: "bg-blue-100 text-blue-800",
      post: "bg-green-100 text-green-800",
      chat: "bg-purple-100 text-purple-800",
      "search-result": "bg-amber-100 text-amber-800",
      "ai-chat": "bg-pink-100 text-pink-800",
      started: "bg-gray-100 text-gray-800"
    };
    return colors[type] || "bg-gray-100 text-gray-800";
  };
  const header = /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-3",
    children: [/* @__PURE__ */ jsx("span", {
      className: `px-2 py-1 rounded text-xs font-medium ${getTypeColor(message.type)}`,
      children: message.type
    }), /* @__PURE__ */ jsx("span", {
      className: "text-sm text-gray-600 font-mono",
      children: formatTime(message.timestamp)
    })]
  });
  return /* @__PURE__ */ jsx(CollapsibleListItem, {
    header,
    variant: "default",
    children: /* @__PURE__ */ jsx("pre", {
      className: "text-xs text-gray-700 overflow-x-auto font-mono",
      children: JSON.stringify(message.data, null, 2)
    })
  });
};

const MAX_MESSAGES$5 = 20;
const SSEMessagesMonitor = () => {
  const [messages, setMessages] = useState([]);
  const [testStatus, setTestStatus] = useState({
    status: "idle",
    messagesReceived: 0,
    lastUpdate: null
  });
  const [connectionEnabled, setConnectionEnabled] = useState(false);
  const api = useApi();
  const addMessage = (event, data) => {
    const newMessage = {
      id: Date.now().toString() + Math.random(),
      event,
      timestamp: new Date(),
      data
    };
    setMessages((prev) => {
      const updated = [newMessage, ...prev];
      return updated.slice(0, MAX_MESSAGES$5);
    });
    setTestStatus((prev) => ({
      ...prev,
      messagesReceived: prev.messagesReceived + 1,
      lastUpdate: new Date()
    }));
  };
  const {
    isConnected,
    error: connectionError,
    disconnect
  } = useSSEConnection({
    url: api.buildUrl("/playground/sse/test"),
    enabled: connectionEnabled,
    onOpen: () => {
      setTestStatus({
        status: "active",
        messagesReceived: 0,
        lastUpdate: new Date()
      });
    },
    onError: (error) => {
      console.error("SSE connection error:", error);
      setTestStatus((prev) => ({
        ...prev,
        status: "error"
      }));
    },
    onClose: () => {
      if (testStatus.status === "completed") {
        return;
      }
      setTestStatus((prev) => ({
        ...prev,
        status: "idle"
      }));
    }
  }, [{
    event: "message",
    handler: (data) => {
      addMessage("message", data);
    }
  }, {
    event: "tick",
    handler: (data) => {
      addMessage("tick", data);
    }
  }, {
    event: "complete",
    handler: (data) => {
      addMessage("complete", data);
      setTestStatus((prev) => ({
        ...prev,
        status: "completed"
      }));
      setTimeout(() => {
        disconnect();
        setConnectionEnabled(false);
      }, 100);
    }
  }]);
  const handleStartTest = () => {
    setMessages([]);
    setTestStatus({
      status: "connecting",
      messagesReceived: 0,
      lastUpdate: null
    });
    setConnectionEnabled(true);
  };
  const handleStopTest = () => {
    disconnect();
    setConnectionEnabled(false);
    setTestStatus((prev) => ({
      ...prev,
      status: "idle"
    }));
  };
  const handleClear = () => {
    setMessages([]);
    setTestStatus({
      status: "idle",
      messagesReceived: 0,
      lastUpdate: null
    });
  };
  const getStatusBadge = () => {
    const statusColors = {
      idle: "bg-gray-200 text-gray-700",
      connecting: "bg-blue-200 text-blue-700",
      active: "bg-green-200 text-green-700",
      completed: "bg-purple-200 text-purple-700",
      error: "bg-red-200 text-red-700"
    };
    const statusLabels = {
      idle: "Idle",
      connecting: "Connecting...",
      active: "Active",
      completed: "Completed \u2713",
      error: "Error"
    };
    return /* @__PURE__ */ jsx("span", {
      className: `px-3 py-1 rounded-full text-sm font-medium ${statusColors[testStatus.status]}`,
      children: statusLabels[testStatus.status]
    });
  };
  const isActive = testStatus.status === "active" || testStatus.status === "connecting";
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "SSE Connection Test"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-3",
        children: [getStatusBadge(), isActive ? /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: false,
          onClick: handleStopTest,
          background: "red",
          children: "Stop Test"
        }) : /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: false,
          onClick: handleStartTest,
          background: "blue",
          disabled: connectionEnabled,
          children: "Start SSE Test"
        }), messages.length > 0 && /* @__PURE__ */ jsx("button", {
          onClick: handleClear,
          className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
          children: "Clear"
        })]
      })]
    }), connectionError && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: connectionError
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-4 text-sm",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Connected:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: isConnected ? "text-green-600" : "text-gray-400",
          children: isConnected ? "Yes" : "No"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Messages:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-blue-600",
          children: testStatus.messagesReceived
        })]
      }), testStatus.lastUpdate && /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Last Update:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-gray-600",
          children: testStatus.lastUpdate.toLocaleTimeString()
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "text-sm text-gray-600",
      children: ["Latest ", MAX_MESSAGES$5, " messages (newest first)"]
    }), messages.length === 0 ? /* @__PURE__ */ jsx("div", {
      className: "p-8 text-center text-gray-500 bg-gray-50 rounded-md",
      children: 'No messages received yet. Click "Start SSE Test" to begin.'
    }) : /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2",
      children: messages.map((msg) => /* @__PURE__ */ jsx(CollapsibleListItem, {
        header: /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2",
          children: [/* @__PURE__ */ jsx("span", {
            className: `
                                        px-2 py-0.5 rounded text-xs font-medium
                                        ${msg.event === "complete" ? "bg-purple-100 text-purple-700" : msg.event === "tick" ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-700"}
                                    `,
            children: msg.event
          }), /* @__PURE__ */ jsx("span", {
            className: "text-sm text-gray-600",
            children: msg.timestamp.toLocaleTimeString()
          }), msg.event === "tick" && msg.data.counter && /* @__PURE__ */ jsxs("span", {
            className: "text-sm font-medium",
            children: ["#", msg.data.counter]
          }), msg.event === "message" && msg.data.text && /* @__PURE__ */ jsx("span", {
            className: "text-sm",
            children: msg.data.text
          }), msg.event === "complete" && /* @__PURE__ */ jsx("span", {
            className: "text-sm font-medium text-purple-600",
            children: msg.data.message
          })]
        }),
        defaultExpanded: false,
        children: /* @__PURE__ */ jsx("pre", {
          className: "text-xs bg-gray-50 p-3 rounded overflow-auto",
          children: JSON.stringify(msg.data, null, 2)
        })
      }, msg.id))
    }), testStatus.status === "completed" && /* @__PURE__ */ jsx("div", {
      className: "p-4 bg-green-50 border border-green-200 rounded-md",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-green-600 text-lg",
          children: "\u2713"
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("div", {
            className: "font-medium text-green-900",
            children: "Test Completed Successfully"
          }), /* @__PURE__ */ jsxs("div", {
            className: "text-sm text-green-700",
            children: ["Received ", testStatus.messagesReceived, " messages. Connection closed automatically."]
          })]
        })]
      })
    })]
  });
};

const ResultHeader = ({
  index,
  scoreDisplay,
  post,
  postTitle,
  postIdShort
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-2 flex-wrap",
    children: [/* @__PURE__ */ jsxs("span", {
      className: "px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-700",
      children: ["#", index + 1]
    }), /* @__PURE__ */ jsxs("span", {
      className: "px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700",
      children: ["Score: ", scoreDisplay]
    }), post && /* @__PURE__ */ jsx("span", {
      className: "text-sm font-medium truncate max-w-md",
      children: postTitle
    }), /* @__PURE__ */ jsxs("span", {
      className: "text-xs text-gray-500 font-mono",
      children: [postIdShort, "..."]
    })]
  });
};

const PostDetailsSection = ({
  post
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "border-t pt-3",
    children: [/* @__PURE__ */ jsx("div", {
      className: "text-xs font-medium text-gray-600 mb-2",
      children: "Post Details:"
    }), /* @__PURE__ */ jsx("pre", {
      className: "text-xs bg-white p-3 rounded overflow-auto border",
      children: JSON.stringify({
        _id: post._id,
        title: post.title,
        author: post.author,
        tags: post.tags,
        created: post.created
      }, null, 2)
    })]
  });
};

const FullResultData = ({
  result
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "border-t pt-3",
    children: [/* @__PURE__ */ jsx("div", {
      className: "text-xs font-medium text-gray-600 mb-2",
      children: "Full Result Data:"
    }), /* @__PURE__ */ jsx("pre", {
      className: "text-xs bg-gray-50 p-3 rounded overflow-auto",
      children: JSON.stringify(result, null, 2)
    })]
  });
};

const ResultDetails = ({
  text,
  language,
  post,
  result
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-3",
    children: [text && /* @__PURE__ */ jsxs("div", {
      className: "bg-gray-50 p-3 rounded",
      children: [/* @__PURE__ */ jsx("div", {
        className: "text-xs font-medium text-gray-600 mb-1",
        children: "Matched Text:"
      }), /* @__PURE__ */ jsx("div", {
        className: "text-sm",
        dir: language === "ar" ? "rtl" : "ltr",
        children: text
      })]
    }), post && /* @__PURE__ */ jsx(PostDetailsSection, {
      post
    }), /* @__PURE__ */ jsx(FullResultData, {
      result
    })]
  });
};

const SearchResultsList = ({
  results,
  postsById,
  language,
  maxResults = 20,
  query
}) => {
  if (!query && results.length === 0) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-8 text-center text-gray-500 bg-gray-50 rounded-md",
      children: 'Enter a query and click "Search" to see results'
    });
  }
  if (results.length === 0) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-8 text-center text-gray-500 bg-gray-50 rounded-md",
      children: "No results found"
    });
  }
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-2",
    children: results.slice(0, maxResults).map((result, index) => {
      const {
        metadata,
        text
      } = result;
      const {
        chunkId,
        postId
      } = metadata;
      const post = postsById[postId];
      const scoreDisplay = result.score && result.score.toFixed(4);
      const postTitle = post && post.title;
      const postIdShort = postId;
      return /* @__PURE__ */ jsx(CollapsibleListItem, {
        header: /* @__PURE__ */ jsx(ResultHeader, {
          index,
          scoreDisplay,
          post,
          postTitle,
          postIdShort
        }),
        defaultExpanded: false,
        children: /* @__PURE__ */ jsx(ResultDetails, {
          text,
          language,
          post,
          result
        })
      }, chunkId);
    })
  });
};

const MAX_RESULTS$1 = 20;
const CircleSearchResultsMonitor = ({
  circleId
}) => {
  const [query, setQuery] = useState("");
  const [counter, setCounter] = useState(0);
  const [language, setLanguage] = useState("en");
  const [analyze, setAnalyze] = useState(false);
  const {
    data,
    isValidating: isLoading,
    error
  } = useCircleSearch({
    circleId,
    question: query,
    language,
    analyze,
    postId: null,
    selectedPersons: void 0,
    selectedLocations: void 0,
    selectedOrganizations: void 0,
    counter
  });
  const handleSearch = () => {
    if (!query.trim())
      return;
    setCounter((v) => v + 1);
  };
  const handleClear = () => {
    setQuery("");
    setCounter(0);
  };
  const results = data && data.found || [];
  const postsById = data && data.postsById || {};
  const aiResponse = data && data.aiResponse;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-xl font-semibold",
        children: "Circle Search Results Monitor"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-600",
        children: "Test vector search with AI analysis for circle content"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-3",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex gap-2",
        children: [/* @__PURE__ */ jsx(TextInput, {
          value: query,
          onChange: (e) => setQuery(e.target.value),
          placeholder: "Enter search query...",
          className: "flex-grow",
          onKeyDown: (e) => {
            if (e.key === "Enter")
              handleSearch();
          }
        }), /* @__PURE__ */ jsxs("select", {
          value: language,
          onChange: (e) => setLanguage(e.target.value),
          className: "px-3 py-2 border rounded",
          children: [/* @__PURE__ */ jsx("option", {
            value: "en",
            children: "English"
          }), /* @__PURE__ */ jsx("option", {
            value: "ar",
            children: "Arabic"
          })]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center",
        children: [/* @__PURE__ */ jsxs("label", {
          className: "flex items-center gap-2 text-sm",
          children: [/* @__PURE__ */ jsx("input", {
            type: "checkbox",
            checked: analyze,
            onChange: (e) => setAnalyze(e.target.checked)
          }), "Enable AI Analysis"]
        }), /* @__PURE__ */ jsx("div", {
          className: "flex-grow"
        }), /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: isLoading,
          onClick: handleSearch,
          background: "blue",
          disabled: !query.trim() || isLoading,
          children: "Search"
        }), counter > 0 && /* @__PURE__ */ jsx("button", {
          onClick: handleClear,
          className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
          children: "Clear"
        })]
      })]
    }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error
    }), data && /* @__PURE__ */ jsxs("div", {
      className: "flex gap-4 text-sm",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Results:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-blue-600",
          children: results.length
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Posts:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-blue-600",
          children: Object.keys(postsById).length
        })]
      }), data.asyncId && /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Async ID:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-gray-600 font-mono text-xs",
          children: data.asyncId
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Loading:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: isLoading ? "text-yellow-600" : "text-green-600",
          children: isLoading ? "Yes" : "No"
        })]
      })]
    }), aiResponse && /* @__PURE__ */ jsxs("div", {
      className: "border border-purple-200 bg-purple-50 rounded-md p-4",
      children: [/* @__PURE__ */ jsx("div", {
        className: "font-medium text-purple-900 mb-2",
        children: "AI Analysis:"
      }), /* @__PURE__ */ jsx("div", {
        className: "prose prose-sm max-w-none",
        dangerouslySetInnerHTML: {
          __html: aiResponse
        }
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "text-sm text-gray-600",
      children: results.length > 0 ? `Showing ${Math.min(results.length, MAX_RESULTS$1)} results` : "No results yet"
    }), /* @__PURE__ */ jsx(SearchResultsList, {
      results,
      postsById,
      language,
      maxResults: MAX_RESULTS$1,
      query
    })]
  });
};

const getLogLevelColor = (level) => {
  const colors = {
    info: "text-blue-600",
    error: "text-red-600",
    warn: "text-yellow-600",
    debug: "text-gray-600"
  };
  return colors[level] || "text-gray-600";
};
const getLogLevelBg = (level) => {
  const colors = {
    info: "bg-blue-50",
    error: "bg-red-50",
    warn: "bg-yellow-50",
    debug: "bg-gray-50"
  };
  return colors[level] || "bg-gray-50";
};
const ServerLogsPanel = ({
  logs: incomingLogs,
  maxHeight = "max-h-96",
  title = "Server Logs"
}) => {
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    setLogs(incomingLogs);
  }, [incomingLogs]);
  if (logs.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "border rounded p-4 bg-gray-50",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-between mb-3",
      children: /* @__PURE__ */ jsxs("h3", {
        className: "text-sm font-semibold",
        children: [title, " (", logs.length, ")"]
      })
    }), /* @__PURE__ */ jsx("div", {
      className: `space-y-1 ${maxHeight} overflow-auto`,
      children: logs.map((log, idx) => /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col",
        children: [/* @__PURE__ */ jsxs("div", {
          className: `flex gap-2 p-2 ${getLogLevelBg(log.level)} rounded hover:opacity-80 transition-opacity`,
          children: [/* @__PURE__ */ jsx("span", {
            className: "text-gray-400 w-20 flex-shrink-0 font-mono text-xs",
            children: new Date(log.timestamp).toLocaleTimeString()
          }), /* @__PURE__ */ jsxs("span", {
            className: `font-semibold w-16 flex-shrink-0 font-mono text-xs ${getLogLevelColor(log.level)}`,
            children: ["[", log.level.toUpperCase(), "]"]
          }), /* @__PURE__ */ jsx("span", {
            className: "flex-1 text-sm",
            children: log.message
          })]
        }, idx), log.data && /* @__PURE__ */ jsxs("details", {
          className: "text-gray-500 text-xs",
          children: [/* @__PURE__ */ jsx("summary", {
            className: "cursor-pointer hover:text-gray-700",
            children: "data"
          }), /* @__PURE__ */ jsx("pre", {
            className: "mt-1 p-2 bg-white rounded border text-xs overflow-auto w-full max-w-full",
            children: JSON.stringify(log.data, null, 2)
          })]
        })]
      }))
    })]
  });
};

const MAX_RESULTS = 20;
const CircleSearchSSEMonitor = ({
  circleId
}) => {
  const api = useApi();
  const [query, setQuery] = useState("");
  const [language, setLanguage] = useState("en");
  const [analyze, setAnalyze] = useState(true);
  const [selectedPrompt, setSelectedPrompt] = useState();
  const [promptOptions, setPromptOptions] = useState([]);
  const [trace, setTrace] = useState(false);
  const [chaosEnabled, setChaosEnabled] = useState(false);
  const [chaosProbability, setChaosProbability] = useState(1);
  const [chaosCheckpoints, setChaosCheckpoints] = useState("");
  const [showLogs, setShowLogs] = useState(false);
  const chaosOptions = chaosEnabled ? {
    enabled: true,
    probability: chaosProbability,
    checkpoints: chaosCheckpoints || void 0
  } : void 0;
  const {
    data,
    status,
    analyses,
    error,
    isComplete,
    isConnected,
    disconnect,
    logs,
    requestId,
    search
  } = useCircleSearchSSE();
  const [searchResultsAnalyses, setSearchResultsAnalyses] = useState("");
  useEffect(() => {
    setSearchResultsAnalyses(analyses);
  }, [analyses]);
  const fetchPrompts = useMemoizedFn(async (searchValue) => {
    try {
      const {
        sponsors
      } = await api.get({
        path: `/group-assistant/prompts/${searchValue || "_ALL"}`
      });
      setPromptOptions(sponsors.map((s) => ({
        value: s._id,
        label: s.title
      })));
    } catch (err) {
      console.error("Failed to fetch prompts:", err);
    }
  });
  useEffect(() => {
    fetchPrompts("");
  }, []);
  const handleSearch = useMemoizedFn(() => {
    search({
      analyze,
      circleId,
      question: query,
      language,
      prompt: selectedPrompt,
      trace,
      chaos: chaosOptions
    });
  });
  const handleStop = () => {
    disconnect();
  };
  const handleClear = () => {
    setSearchResultsAnalyses("");
    setResults([]);
    disconnect();
  };
  const [results, setResults] = useState([]);
  useEffect(() => {
    setResults(data && data.found || []);
  }, [data && data.found]);
  const postsById = data && data.postsById || {};
  const isSearching = isConnected && !isComplete;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-xl font-semibold",
        children: "Circle Search SSE Monitor"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-600",
        children: "Test SSE-based vector search with real-time streaming"
      })]
    }), requestId && /* @__PURE__ */ jsxs("div", {
      className: "px-3 py-2 bg-gray-50 rounded text-sm font-mono",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-semibold",
        children: "Request ID:"
      }), " ", requestId]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-3",
      children: [/* @__PURE__ */ jsx(TextInput, {
        value: query,
        onChange: (e) => setQuery(e.target.value),
        placeholder: "Enter search query...",
        onKeyPress: (e) => {
          if (e.key === "Enter" && !isSearching) {
            handleSearch();
          }
        }
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-3 p-4 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "text-sm font-semibold",
          children: "Advanced Options"
        }), /* @__PURE__ */ jsx("div", {
          className: "flex gap-4 flex-wrap",
          children: /* @__PURE__ */ jsx(Checkbox, {
            checked: trace,
            onChange: (e) => setTrace(e.target.checked),
            label: "Enable Trace Mode (debug logs)"
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-2 p-3 border border-red-200 bg-red-50 rounded",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-2",
            children: [/* @__PURE__ */ jsx(Checkbox, {
              checked: chaosEnabled,
              onChange: (e) => setChaosEnabled(e.target.checked),
              label: "Enable Chaos Testing"
            }), /* @__PURE__ */ jsx("span", {
              className: "text-xs text-red-600",
              children: "(Random failures for testing)"
            })]
          }), chaosEnabled && /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-2 ml-6",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2",
              children: [/* @__PURE__ */ jsx("label", {
                className: "text-sm font-medium w-32",
                children: "Probability:"
              }), /* @__PURE__ */ jsx("input", {
                type: "range",
                min: "0",
                max: "1",
                step: "0.1",
                value: chaosProbability,
                onChange: (e) => setChaosProbability(parseFloat(e.target.value)),
                className: "flex-1"
              }), /* @__PURE__ */ jsxs("span", {
                className: "text-sm w-12 text-right",
                children: [(chaosProbability * 100).toFixed(0), "%"]
              })]
            }), /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2",
              children: [/* @__PURE__ */ jsx("label", {
                className: "text-sm font-medium w-32",
                children: "Checkpoints:"
              }), /* @__PURE__ */ jsx(TextInput, {
                value: chaosCheckpoints,
                onChange: (e) => setChaosCheckpoints(e.target.value),
                placeholder: "e.g., authentication,validation",
                className: "flex-1"
              })]
            }), /* @__PURE__ */ jsx("p", {
              className: "text-xs text-gray-600 ml-32",
              children: "Leave empty for all checkpoints, or comma-separated list"
            })]
          })]
        }), /* @__PURE__ */ jsx(Checkbox, {
          checked: analyze,
          onChange: (e) => setAnalyze(e.target.checked),
          label: "Enable AI analyses"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex gap-4 items-center",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex-1",
            children: [/* @__PURE__ */ jsx("label", {
              className: "text-sm font-medium",
              children: "Language"
            }), /* @__PURE__ */ jsxs("select", {
              value: language,
              onChange: (e) => setLanguage(e.target.value),
              className: "w-full px-3 py-2 border rounded",
              children: [/* @__PURE__ */ jsx("option", {
                value: "en",
                children: "English"
              }), /* @__PURE__ */ jsx("option", {
                value: "ar",
                children: "Arabic"
              })]
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex-1",
            children: [/* @__PURE__ */ jsx("label", {
              className: "text-sm font-medium",
              children: "Prompt Template"
            }), /* @__PURE__ */ jsx(Autocomplete, {
              value: selectedPrompt,
              onChange: setSelectedPrompt,
              options: promptOptions,
              placeholder: "Select prompt...",
              onInputChange: fetchPrompts
            })]
          })]
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2",
        children: [isSearching ? /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: false,
          onClick: handleStop,
          background: "red",
          children: "Stop Search"
        }) : /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: false,
          onClick: handleSearch,
          background: "blue",
          children: "Start Search"
        }), (results.length > 0 || logs.length > 0) && /* @__PURE__ */ jsx("button", {
          onClick: handleClear,
          className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
          children: "Clear"
        }), logs.length > 0 && /* @__PURE__ */ jsxs("button", {
          onClick: () => setShowLogs(!showLogs),
          className: "text-sm text-blue-600 hover:text-blue-900 px-3 py-1 rounded hover:bg-blue-100",
          children: [showLogs ? "Hide" : "Show", " Logs (", logs.length, ")"]
        })]
      })]
    }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-4 text-sm flex-wrap",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Connected:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: isConnected ? "text-green-600" : "text-gray-400",
          children: isConnected ? "Yes" : "No"
        })]
      }), status && /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-blue-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Status:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-blue-700",
          children: status
        })]
      }), selectedPrompt && promptOptions.length > 0 && /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-purple-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Prompt:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-purple-700",
          children: (promptOptions.find((p) => p.value === selectedPrompt) || {}).label || "Selected"
        })]
      }), isComplete && /* @__PURE__ */ jsx("div", {
        className: "px-3 py-2 bg-green-50 rounded",
        children: /* @__PURE__ */ jsx("span", {
          className: "font-medium text-green-700",
          children: "\u2713 Complete"
        })
      })]
    }), showLogs && /* @__PURE__ */ jsx(ServerLogsPanel, {
      logs,
      title: "Server Logs"
    }), searchResultsAnalyses && /* @__PURE__ */ jsxs("div", {
      className: "border rounded p-4 bg-gradient-to-br from-blue-50 to-indigo-50",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 mb-3",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-sm font-semibold text-indigo-700",
          children: "\u{1F916} AI Analysis"
        }), !isComplete && isConnected && /* @__PURE__ */ jsxs("span", {
          className: "text-xs text-gray-500 animate-pulse",
          children: ["Streaming... (", searchResultsAnalyses.length, " chars)"]
        }), isComplete && /* @__PURE__ */ jsxs("span", {
          className: "text-xs text-green-600",
          children: ["Complete (", searchResultsAnalyses.length, " chars)"]
        })]
      }), /* @__PURE__ */ jsx("pre", {
        className: "whitespace-pre-wrap bg-white p-4 rounded text-sm border border-indigo-200 overflow-auto max-h-96",
        dir: "auto",
        children: searchResultsAnalyses
      })]
    }), /* @__PURE__ */ jsx(SearchResultsList, {
      results,
      postsById,
      language,
      maxResults: MAX_RESULTS,
      query
    })]
  });
};

const WebSocketsPanel = ({
  circleId,
  post
}) => {
  const {
    data: circleData = {}
  } = useCircle(circleId);
  const {
    group: circle,
    membership
  } = circleData;
  if (!membership) {
    return /* @__PURE__ */ jsx(CircleMembershipRequiredPanel, {
      circle
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 flex flex-col gap-6",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2",
      children: /* @__PURE__ */ jsx("h1", {
        className: "text-2xl font-semibold",
        children: "WebSockets tests"
      })
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(WebSocketMessagesMonitor, {}), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(SSEMessagesMonitor, {}), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(CircleSearchResultsMonitor, {
      circleId
    }), /* @__PURE__ */ jsx(CircleSearchSSEMonitor, {
      circleId
    })]
  });
};

const WebSocketsTest = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(WebSocketsTestInner, {})
  });
};
const WebSocketsTestInner = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const circleId = parts[parts.findIndex((v) => v === "websockets") + 1];
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  return /* @__PURE__ */ jsx(WebsocketsContextProvider, {
    children: /* @__PURE__ */ jsx(ActivityContextProvider, {
      children: /* @__PURE__ */ jsxs(ToastProvider, {
        children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
          className: "ns p-2 h-full flex flex-col",
          children: /* @__PURE__ */ jsx(WebSocketsPanel, {
            circleId
          })
        })]
      })
    })
  });
};

const useUploadOcrImage = ({
  onSuccess,
  onError
}) => {
  const api = useApi();
  const uploadOperation = useAsyncOperation(async ({ file, options }) => {
    if (!file) {
      throw new Error("No file provided");
    }
    const { circleId, processor = "", width = "600", includePageThumbnails = true } = options;
    if (!circleId) {
      throw new Error("Circle ID is required");
    }
    console.log(`Uploading OCR image: ${file.name} (${(file.size / 1024).toFixed(2)} KB)`);
    try {
      const response = await withRetry(() => api.upload({
        0: file,
        circleId,
        processor,
        width: String(width),
        originalFileName: file.name,
        includePageThumbnails: String(includePageThumbnails),
        path: "/uploads/ocr-image"
      }), {
        maxRetries: 1,
        onRetry: (attempt, error) => {
          console.log(`Retry ${attempt}/3 for OCR image upload:`, errorMessage(error));
        },
        onSuccess: (result, totalAttempts) => {
          if (totalAttempts > 1) {
            console.log(`OCR image upload succeeded after ${totalAttempts} attempts`);
          }
        }
      });
      console.log("OCR image upload response:", response);
      if (onSuccess) {
        onSuccess(response);
      }
      return response;
    } catch (error) {
      const err = error;
      console.error("OCR image upload failed:", errorMessage(err));
      if (onError) {
        onError(err);
      }
      throw err;
    }
  });
  return {
    upload: uploadOperation.execute,
    isLoading: uploadOperation.isLoading,
    error: uploadOperation.error,
    data: uploadOperation.data,
    reset: uploadOperation.reset
  };
};

const PostCreatedSuccessPanel = ({
  post
}) => {
  if (!post) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-3 p-4 bg-green-50 border border-green-200 rounded-lg",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 text-green-700 font-semibold",
      children: [/* @__PURE__ */ jsx(MdCheckCircle, {
        className: "w-5 h-5"
      }), /* @__PURE__ */ jsx("span", {
        children: "Post Created Successfully"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("a", {
        href: `/trans/post-view/${post._id}`,
        className: "flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium group",
        target: "_blank",
        rel: "noopener noreferrer",
        children: [/* @__PURE__ */ jsx("span", {
          className: "underline",
          children: post.title
        }), /* @__PURE__ */ jsx(MdOpenInNew, {
          className: "w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 text-sm text-gray-600",
        children: [/* @__PURE__ */ jsx("span", {
          children: "Created"
        }), /* @__PURE__ */ jsx(RelativeTime, {
          value: post.created
        })]
      })]
    })]
  });
};

const processorOptions = [
  {
    value: "straight",
    label: "Straight recognition with page images"
  },
  {
    value: "layout",
    label: "Layout recognition with no page images"
  },
  {
    value: "vl-gemini-3.1-pro-preview",
    label: "VL LLM image OCR 3"
  },
  {
    value: "vl-gemini-3-flash-preview",
    label: "VL LLM image OCR 4"
  },
  {
    value: "vl-hf-Qwen/Qwen3.5-397B-A17B:together",
    label: "VL LLM image OCR 5"
  },
  {
    value: "vl-ali-qwen3.6-plus",
    label: "VL LLM image OCR 5"
  }
];
const OCRSinglePanel = ({
  circleId
}) => {
  const {
    data: circleData = {}
  } = useCircle(circleId);
  const [post, setPost] = useState();
  const {
    group: circle,
    membership
  } = circleData;
  const [processor, setProcessor] = useState("vl-gemini-3.1-pro-preview");
  const [includePageThumbnails, setIncludePageThumbnails] = useState(true);
  const {
    addToast
  } = useToast();
  const isTestMode = useTestMode();
  const {
    file,
    fileInfo,
    dropzone,
    clearFile
  } = usePdfFileHandler({
    onFileSelect: (selectedFile) => {
      console.log("File selected:", selectedFile.name);
      ocrUpload.reset();
    },
    extensions: [".jpg", ".gif", ".png", ".pdf", ".tiff"]
  });
  const ocrUpload = useUploadOcrImage({
    onSuccess: (response) => {
      addToast({
        type: "success",
        message: `Image uploaded successfully: ${response.message || "Processing started"}`
      });
    }
  });
  const handleUpload = async () => {
    if (!file) {
      addToast({
        type: "error",
        message: "Please select a file first"
      });
      return;
    }
    const {
      post: post2
    } = await ocrUpload.upload({
      file,
      options: {
        circleId,
        processor,
        width: "600",
        includePageThumbnails
      }
    });
    setPost(post2);
  };
  if (!membership) {
    return /* @__PURE__ */ jsx(CircleMembershipRequiredPanel, {
      circle
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 flex flex-col gap-6",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2 relative",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex items-start justify-between",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/* @__PURE__ */ jsx("h1", {
            className: "text-2xl font-semibold",
            children: "Process your images with OCR"
          }), isTestMode && /* @__PURE__ */ jsxs("div", {
            className: "inline-flex items-center gap-2 px-3 py-1 bg-red-50 border border-red-200 rounded-md text-sm text-red-700",
            children: [/* @__PURE__ */ jsx("div", {
              className: "w-2 h-2 bg-red-500 rounded-full animate-pulse"
            }), "Test Mode Active"]
          })]
        }), /* @__PURE__ */ jsx(TestModeToggle, {})]
      })
    }), circle && /* @__PURE__ */ jsxs("p", {
      className: "text-gray-600 font-semibold",
      children: ["For circle:", /* @__PURE__ */ jsx("a", {
        href: circleUrl(circleId),
        className: "text-blue-600",
        children: /* @__PURE__ */ jsx("span", {
          className: "underline mx-2",
          children: circle.name
        })
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "1. Select Image"
      }), /* @__PURE__ */ jsx(PdfFileSelector, {
        dropzone,
        file,
        fileInfo,
        isProcessing: ocrUpload.isLoading
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("h2", {
          className: "text-lg font-semibold",
          children: "2. Upload for OCR Processing"
        }), /* @__PURE__ */ jsx("p", {
          className: "text-sm text-gray-600",
          children: "Upload your image to extract text using OCR technology"
        })]
      }), /* @__PURE__ */ jsxs(FormSection, {
        variant: "outlined",
        children: [/* @__PURE__ */ jsx(Select, {
          label: "Process Type",
          value: processor || "--",
          onChange: setProcessor,
          options: processorOptions,
          helperText: "Choose how the file should be processed"
        }), /* @__PURE__ */ jsx(Switch, {
          checked: includePageThumbnails,
          onChange: setIncludePageThumbnails,
          label: "Include page thumbnails"
        })]
      }), /* @__PURE__ */ jsx(LoadingButtonTW, {
        onClick: handleUpload,
        loading: ocrUpload.isLoading,
        disabled: !file,
        background: "red",
        children: "Upload for OCR"
      }), ocrUpload.data && !ocrUpload.isLoading && /* @__PURE__ */ jsxs("div", {
        className: "p-3 bg-green-50 border border-green-200 rounded text-sm",
        children: [/* @__PURE__ */ jsx("strong", {
          className: "text-green-700",
          children: "Success: "
        }), /* @__PURE__ */ jsx("span", {
          className: "text-green-600",
          children: ocrUpload.data.message || "Image uploaded successfully"
        })]
      }), ocrUpload.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: ocrUpload.error,
        variant: "detailed",
        onDismiss: () => ocrUpload.reset()
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(PostCreatedSuccessPanel, {
      post
    })]
  });
};

const OCRSinglePage = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(OCRSinglePageInner, {})
  });
};
const OCRSinglePageInner = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  const circleId = parts[parts.findIndex((v) => v === "ocr") + 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(OCRSinglePanel, {
        circleId
      })
    })]
  });
};

const usePostWithChunks = (circleId) => {
  const api = useApi();
  const [postId, setPostId] = useLocalStorageState$1(`categories-test-postId-${circleId}`, { defaultValue: "" });
  useEffect(() => {
    if (postId && postId.trim() && !postData) {
      loadOperation.execute();
    }
  }, []);
  const [postData, setPostData] = useState(null);
  const [selectedChunkIds, setSelectedChunkIds] = useState(new Set());
  const loadOperation = useAsyncOperation(async () => {
    if (!postId.trim()) {
      throw new Error("Post ID is required");
    }
    const response = await api.get({
      path: api.buildUrl(`/groups/categories/load-post`, {
        postId: postId.trim(),
        circleId
      })
    });
    setPostData({
      post: response.post,
      pages: response.pages,
      totalChunks: response.totalChunks
    });
    setSelectedChunkIds(new Set());
    return response;
  });
  const toggleChunkSelection = (chunkId) => {
    setSelectedChunkIds((prev) => {
      const next = new Set(prev);
      if (next.has(chunkId)) {
        next.delete(chunkId);
      } else {
        next.add(chunkId);
      }
      return next;
    });
  };
  const selectAllChunks = () => {
    if (!postData)
      return;
    const allChunkIds = postData.pages.flatMap((page) => page.chunks.map((chunk) => chunk._id));
    setSelectedChunkIds(new Set(allChunkIds));
  };
  const clearSelection = () => {
    setSelectedChunkIds(new Set());
  };
  const selectPageChunks = (pageId) => {
    if (!postData)
      return;
    const page = postData.pages.find((p) => p._id === pageId);
    if (!page)
      return;
    setSelectedChunkIds((prev) => {
      const next = new Set(prev);
      page.chunks.forEach((chunk) => next.add(chunk._id));
      return next;
    });
  };
  const clearPageChunks = (pageId) => {
    if (!postData)
      return;
    const page = postData.pages.find((p) => p._id === pageId);
    if (!page)
      return;
    setSelectedChunkIds((prev) => {
      const next = new Set(prev);
      page.chunks.forEach((chunk) => next.delete(chunk._id));
      return next;
    });
  };
  return {
    postId,
    setPostId,
    postData,
    isLoading: loadOperation.isLoading,
    error: loadOperation.error,
    loadPost: loadOperation.execute,
    selectedChunkIds,
    toggleChunkSelection,
    selectAllChunks,
    clearSelection,
    selectPageChunks,
    clearPageChunks
  };
};

const suggestSimilarCategories = (schema, invalidCode, maxSuggestions = 5) => {
  const suggestions = [];
  suggestions.push(...findByPrefixMatch(schema, invalidCode));
  suggestions.push(...findByNumericProximity(schema, invalidCode));
  suggestions.push(...findByFuzzyCodeMatch(schema, invalidCode));
  const uniqueSuggestions = deduplicateSuggestions(suggestions);
  return uniqueSuggestions.sort((a, b) => b.similarity - a.similarity).slice(0, maxSuggestions);
};
const findByPrefixMatch = (schema, code) => {
  const suggestions = [];
  const parts = code.split(".");
  const mainCode = parts[0];
  const decimals = parts[1] || "";
  const prefixes = [];
  if (decimals.length > 0) {
    for (let i = decimals.length - 1; i > 0; i--) {
      prefixes.push(`${mainCode}.${decimals.substring(0, i)}`);
    }
  }
  prefixes.push(mainCode);
  for (const prefix of prefixes) {
    const entry = findCategoryByCode(schema, prefix);
    if (entry) {
      suggestions.push({
        code: prefix,
        entry,
        reason: "parent",
        similarity: 0.9 - prefixes.indexOf(prefix) * 0.1
      });
    }
  }
  const closestValidPrefix = prefixes.find((p) => findCategoryByCode(schema, p));
  if (closestValidPrefix) {
    const children = getChildren(schema, closestValidPrefix);
    for (const child of children.slice(0, 3)) {
      suggestions.push({
        code: child.code,
        entry: child,
        reason: "sibling",
        similarity: 0.7
      });
    }
  }
  return suggestions;
};
const findByNumericProximity = (schema, code) => {
  const suggestions = [];
  const numericValue = parseFloat(code);
  if (isNaN(numericValue))
    return suggestions;
  const allCodes = Object.keys(schema.classifications).map((c) => ({ code: c, num: parseFloat(c) })).filter((c) => !isNaN(c.num)).sort((a, b) => Math.abs(a.num - numericValue) - Math.abs(b.num - numericValue));
  for (const { code: nearbyCode } of allCodes.slice(0, 5)) {
    const entry = schema.classifications[nearbyCode];
    const distance = Math.abs(parseFloat(nearbyCode) - numericValue);
    const similarity = Math.max(0, 1 - distance / 100);
    suggestions.push({
      code: nearbyCode,
      entry,
      reason: "prefix",
      similarity
    });
  }
  return suggestions;
};
const findByFuzzyCodeMatch = (schema, code) => {
  const suggestions = [];
  const codeMatches = Object.entries(schema.classifications).map(([schemaCode, entry]) => ({
    code: schemaCode,
    entry,
    similarity: calculateCodeSimilarity(code, schemaCode)
  })).filter((match) => match.similarity > 0.5).sort((a, b) => b.similarity - a.similarity).slice(0, 5);
  for (const match of codeMatches) {
    suggestions.push({
      code: match.code,
      entry: match.entry,
      reason: "fuzzy",
      similarity: match.similarity * 0.6
    });
  }
  return suggestions;
};
const calculateCodeSimilarity = (code1, code2) => {
  if (code1 === code2)
    return 1;
  let commonPrefixLength = 0;
  const minLength = Math.min(code1.length, code2.length);
  for (let i = 0; i < minLength; i++) {
    if (code1[i] === code2[i]) {
      commonPrefixLength++;
    } else {
      break;
    }
  }
  const maxLength = Math.max(code1.length, code2.length);
  const prefixSimilarity = commonPrefixLength / maxLength;
  const sameMainClass = code1.substring(0, 3) === code2.substring(0, 3);
  const boost = sameMainClass ? 0.2 : 0;
  return Math.min(1, prefixSimilarity + boost);
};
const deduplicateSuggestions = (suggestions) => {
  const seen = new Map();
  for (const suggestion of suggestions) {
    const existing = seen.get(suggestion.code);
    if (!existing || suggestion.similarity > existing.similarity) {
      seen.set(suggestion.code, suggestion);
    }
  }
  return Array.from(seen.values());
};

const validateCategoryWithSuggestions = (schema, code) => {
  if (!schema) {
    return { exists: false, entry: null, suggestions: [] };
  }
  const entry = findCategoryByCode(schema, code);
  if (entry) {
    return { exists: true, entry, suggestions: [] };
  }
  const suggestions = suggestSimilarCategories(schema, code);
  return { exists: false, entry: null, suggestions };
};

const CategorySuggestionsTooltip = ({
  invalidCode,
  suggestions,
  onSuggestionClick
}) => {
  if (suggestions.length === 0)
    return null;
  const reasonLabels = {
    parent: "Parent",
    sibling: "Similar",
    child: "Child",
    prefix: "Nearby",
    fuzzy: "Similar"
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "absolute z-50 top-full left-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg p-3 min-w-[300px]",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "text-xs font-semibold text-red-700 mb-2",
      children: ['Code "', invalidCode, '" not found. Suggestions:']
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-1",
      children: suggestions.map((suggestion, index) => /* @__PURE__ */ jsx("button", {
        type: "button",
        onClick: () => onSuggestionClick && onSuggestionClick(suggestion.code),
        className: "text-left text-xs p-2 rounded hover:bg-gray-100 transition-colors",
        children: /* @__PURE__ */ jsxs("div", {
          className: "flex items-center justify-between",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex-1",
            children: [/* @__PURE__ */ jsx("span", {
              className: "font-mono font-medium text-blue-700",
              children: suggestion.code
            }), /* @__PURE__ */ jsx("span", {
              className: "mx-1 text-gray-400",
              children: "\u2022"
            }), /* @__PURE__ */ jsx("span", {
              className: "text-gray-700",
              children: suggestion.entry.name
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-2 ml-2",
            children: [/* @__PURE__ */ jsx("span", {
              className: "text-gray-500 text-[10px]",
              children: reasonLabels[suggestion.reason]
            }), /* @__PURE__ */ jsxs("span", {
              className: "text-gray-400 text-[10px]",
              children: [(suggestion.similarity * 100).toFixed(0), "%"]
            })]
          })]
        })
      }, index))
    })]
  });
};

const CategoryBadge = ({
  category,
  onClick,
  onRemove,
  className,
  showValidation = true
}) => {
  const schema = useSchema();
  const [showSuggestions, setShowSuggestions] = useState(false);
  const validation = schema && showValidation ? validateCategoryWithSuggestions(schema, category.full_code) : null;
  const isValid = !showValidation || !schema || validation && validation.exists;
  const hasSuggestions = validation && !validation.exists && validation.suggestions.length > 0;
  const handleClick = (e) => {
    if (onClick) {
      onClick(category);
    }
  };
  const handleRemove = (e) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove(category);
    }
  };
  const baseClassName = "text-xs px-2 py-0.5 rounded inline-flex items-center gap-1 transition-colors";
  const colorClassName = isValid ? "bg-green-100 text-green-700 hover:bg-green-200" : "bg-red-100 text-red-700 hover:bg-red-200";
  const interactiveClassName = onClick ? "cursor-pointer" : "";
  const finalClassName = `${baseClassName} ${colorClassName} ${interactiveClassName} ${className || ""}`;
  const buildTooltip = () => {
    const parts = [];
    parts.push(`Code: ${category.full_code}`);
    if (validation && validation.entry) {
      parts.push(`Path: ${validation.entry.fullPath.join(" > ")}`);
    }
    if (category.confidence_score) {
      parts.push(`Confidence: ${(category.confidence_score * 100).toFixed(0)}%`);
    }
    if (!isValid) {
      parts.push("\u26A0\uFE0F Code not found in schema");
    }
    return parts.join("\n");
  };
  return /* @__PURE__ */ jsxs("span", {
    className: "relative inline-block",
    children: [/* @__PURE__ */ jsxs("span", {
      className: finalClassName,
      onClick: onClick ? handleClick : void 0,
      onMouseEnter: () => setShowSuggestions(true),
      onMouseLeave: () => setShowSuggestions(false),
      title: buildTooltip(),
      children: [showValidation && schema && /* @__PURE__ */ jsx("span", {
        className: `w-1.5 h-1.5 rounded-full ${isValid ? "bg-green-600" : "bg-red-600"}`
      }), /* @__PURE__ */ jsxs("span", {
        className: "font-medium",
        children: ["(", category.full_code, ")"]
      }), /* @__PURE__ */ jsx("span", {
        className: "font-medium",
        children: category.specific_label
      }), category.confidence_score && /* @__PURE__ */ jsxs("span", {
        className: `${isValid ? "text-green-600" : "text-red-600"} opacity-70`,
        children: [(category.confidence_score * 100).toFixed(0), "%"]
      }), onRemove && /* @__PURE__ */ jsx("button", {
        type: "button",
        onClick: handleRemove,
        className: `ml-0.5 transition-colors ${isValid ? "hover:text-green-900" : "hover:text-red-900"}`,
        "aria-label": "Remove category",
        children: /* @__PURE__ */ jsx("svg", {
          className: "w-3 h-3",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: /* @__PURE__ */ jsx("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M6 18L18 6M6 6l12 12"
          })
        })
      })]
    }), hasSuggestions && showSuggestions && validation && /* @__PURE__ */ jsx(CategorySuggestionsTooltip, {
      invalidCode: category.full_code,
      suggestions: validation.suggestions,
      onSuggestionClick: (code) => {
        console.log("Suggested code:", code);
      }
    })]
  });
};

const CategoryBadgeList = ({
  categories,
  onCategoryClick,
  onCategoryRemove,
  className = "",
  emptyMessage
}) => {
  if (!categories || categories.length === 0) {
    if (emptyMessage) {
      return /* @__PURE__ */ jsx("div", {
        className: `text-xs text-gray-500 italic ${className}`,
        children: emptyMessage
      });
    }
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className: `flex flex-wrap gap-1 ${className}`,
    children: categories.map((category) => /* @__PURE__ */ jsx(CategoryBadge, {
      category,
      onClick: onCategoryClick,
      onRemove: onCategoryRemove
    }, category.full_code))
  });
};

const ChunkItem = ({
  chunk,
  isSelected,
  onToggle
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldTruncate = chunk.text.length > 200;
  const displayText = isExpanded || !shouldTruncate ? chunk.text : chunk.text.slice(0, 200) + "...";
  return /* @__PURE__ */ jsx("div", {
    className: "border border-gray-200 rounded-lg p-3 hover:bg-gray-50 transition-colors",
    children: /* @__PURE__ */ jsxs("label", {
      className: "flex items-start gap-3 cursor-pointer",
      children: [/* @__PURE__ */ jsx("input", {
        type: "checkbox",
        checked: isSelected,
        onChange: onToggle,
        className: "mt-1 h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 min-w-0",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "text-xs text-gray-500 mb-1",
          children: ["Chunk #", chunk._id]
        }), /* @__PURE__ */ jsx("div", {
          className: "text-sm text-gray-700 whitespace-pre-wrap break-words",
          children: displayText
        }), shouldTruncate && /* @__PURE__ */ jsx("button", {
          onClick: (e) => {
            e.preventDefault();
            setIsExpanded(!isExpanded);
          },
          className: "text-xs text-blue-600 hover:text-blue-700 underline mt-1",
          children: isExpanded ? "Show less" : "Show more"
        }), /* @__PURE__ */ jsx(CategoryBadgeList, {
          categories: chunk.categories,
          className: "mt-2"
        }), chunk.categoriesExtractedAt && /* @__PURE__ */ jsxs("div", {
          className: "mt-1 text-xs text-gray-500",
          children: ["Extracted: ", new Date(chunk.categoriesExtractedAt).toLocaleString()]
        }), chunk.categoriesExtractionError && /* @__PURE__ */ jsxs("div", {
          className: "mt-2 bg-red-50 border border-red-200 rounded p-2",
          children: [/* @__PURE__ */ jsx("div", {
            className: "text-xs font-semibold text-red-700 mb-1",
            children: "\u26A0\uFE0F Extraction Error"
          }), /* @__PURE__ */ jsx("div", {
            className: "text-xs text-red-600",
            children: chunk.categoriesExtractionError
          })]
        })]
      })]
    })
  });
};

const PageCollapsible = ({
  page,
  postHook
}) => {
  const {
    selectedChunkIds,
    selectPageChunks,
    clearPageChunks
  } = postHook;
  const selectedCount = page.chunks.filter((chunk) => selectedChunkIds.has(chunk._id)).length;
  const allSelected = selectedCount === page.chunks.length && page.chunks.length > 0;
  const handleToggleAll = () => {
    if (allSelected) {
      clearPageChunks(page._id);
    } else {
      selectPageChunks(page._id);
    }
  };
  return /* @__PURE__ */ jsxs(CollapsibleSection, {
    title: /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between flex-1",
      children: [/* @__PURE__ */ jsxs("span", {
        children: ["Page ", page.pageIndex + 1, ": ", page.title]
      }), /* @__PURE__ */ jsxs("span", {
        className: "text-sm text-gray-500 mr-2",
        children: [selectedCount, "/", page.chunks.length, " chunks selected"]
      })]
    }),
    children: [page.chunks.length > 0 && /* @__PURE__ */ jsx("div", {
      className: "flex gap-2 items-center text-sm mb-3 pb-2 border-b border-gray-200",
      children: /* @__PURE__ */ jsx("button", {
        onClick: handleToggleAll,
        className: "text-blue-600 hover:text-blue-700 underline",
        children: allSelected ? "Deselect All" : "Select All"
      })
    }), page.chunks.length === 0 ? /* @__PURE__ */ jsx("div", {
      className: "text-sm text-gray-500 italic",
      children: "No chunks found for this page"
    }) : /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2",
      children: page.chunks.map((chunk) => /* @__PURE__ */ jsx(ChunkItem, {
        chunk,
        isSelected: selectedChunkIds.has(chunk._id),
        onToggle: () => postHook.toggleChunkSelection(chunk._id)
      }, chunk._id))
    })]
  });
};

const PostInfoSection = ({
  postHook
}) => {
  const {
    postId,
    setPostId,
    postData,
    isLoading,
    error,
    loadPost,
    selectedChunkIds,
    selectAllChunks,
    clearSelection
  } = postHook;
  useState(true);
  const handleLoadClick = async () => {
    await loadPost();
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !isLoading) {
      handleLoadClick();
    }
  };
  return /* @__PURE__ */ jsxs(CollapsibleSection, {
    title: "1. Post Info",
    defaultCollapsed: false,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-4 mb-4 items-center",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex-1",
        children: /* @__PURE__ */ jsx(TextInput, {
          value: postId,
          onChange: (e) => setPostId(e.target.value),
          onKeyPress: handleKeyPress,
          placeholder: "Enter Post ID (e.g., 507f1f77bcf86cd799439011)",
          label: "Post ID",
          disabled: isLoading
        })
      }), /* @__PURE__ */ jsx(LoadingButtonTW, {
        loading: isLoading,
        onClick: handleLoadClick,
        disabled: !postId.trim(),
        background: "blue",
        children: "Load Post"
      })]
    }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error
    }), postData && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "bg-gray-50 border border-gray-200 rounded-lg p-4",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "text-lg font-semibold mb-2",
          children: postData.post.title
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-wrap gap-4 text-sm text-gray-600",
          children: [/* @__PURE__ */ jsx("span", {
            children: postData.post.isBook ? "\u{1F4DA} Multipage Book" : "\u{1F4C4} Single Page"
          }), /* @__PURE__ */ jsxs("span", {
            children: [postData.pages.length, " page", postData.pages.length !== 1 ? "s" : ""]
          }), /* @__PURE__ */ jsxs("span", {
            children: [postData.totalChunks, " chunk", postData.totalChunks !== 1 ? "s" : ""]
          }), postData.post.author && /* @__PURE__ */ jsxs("span", {
            children: ["\u{1F464} ", postData.post.author.firstname, " ", postData.post.author.lastname]
          })]
        }), postData.post.tags.length > 0 && /* @__PURE__ */ jsx("div", {
          className: "flex flex-wrap gap-2 mt-2",
          children: postData.post.tags.map((tag) => /* @__PURE__ */ jsx("span", {
            className: "text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded",
            children: tag
          }, tag))
        })]
      }), postData.totalChunks > 0 && /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center text-sm",
        children: [/* @__PURE__ */ jsxs("span", {
          className: "text-gray-600",
          children: [selectedChunkIds.size, " of ", postData.totalChunks, " chunks selected"]
        }), /* @__PURE__ */ jsx("button", {
          onClick: selectAllChunks,
          className: "text-blue-600 hover:text-blue-700 underline",
          children: "Select All"
        }), selectedChunkIds.size > 0 && /* @__PURE__ */ jsx("button", {
          onClick: clearSelection,
          className: "text-gray-600 hover:text-gray-700 underline",
          children: "Clear"
        })]
      }), postData.totalChunks === 0 ? /* @__PURE__ */ jsx("div", {
        className: "bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-sm text-yellow-800",
        children: "\u26A0\uFE0F This post has no chunks yet. Chunks are created when the post is indexed."
      }) : /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-3",
        children: postData.pages.map((page) => /* @__PURE__ */ jsx(PageCollapsible, {
          page,
          postHook
        }, page._id))
      })]
    })]
  });
};

const SelectedChunksSection = ({
  postHook
}) => {
  const {
    postData,
    selectedChunkIds,
    toggleChunkSelection,
    clearSelection
  } = postHook;
  if (selectedChunkIds.size === 0) {
    return null;
  }
  const selectedChunks = [];
  if (postData && postData.pages) {
    postData.pages.forEach((page) => {
      page.chunks.forEach((chunk) => {
        if (selectedChunkIds.has(chunk._id)) {
          selectedChunks.push(chunk);
        }
      });
    });
  }
  return /* @__PURE__ */ jsxs(CollapsibleSection, {
    title: /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between flex-1",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-semibold",
        children: "Selected Chunks for Testing"
      }), /* @__PURE__ */ jsxs("span", {
        className: "text-sm text-gray-500 m-2",
        children: [selectedChunkIds.size, " chunk(s) selected"]
      })]
    }),
    defaultCollapsed: true,
    variant: "default",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex gap-2 items-center text-sm mb-3 pb-2 border-b border-gray-200",
      children: /* @__PURE__ */ jsx("button", {
        onClick: clearSelection,
        className: "text-red-600 hover:text-red-700 underline",
        children: "Clear All Selections"
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2",
      children: selectedChunks.map((chunk) => /* @__PURE__ */ jsx(ChunkItem, {
        chunk,
        isSelected: true,
        onToggle: () => toggleChunkSelection(chunk._id)
      }, chunk._id))
    })]
  });
};

const CollapsibleTree = ({
  nodes,
  defaultExpandedIds = new Set(),
  onNodeClick,
  renderNode,
  indent = 16
}) => {
  const [expandedIds, setExpandedIds] = useState(defaultExpandedIds);
  const toggleExpanded = (id) => {
    setExpandedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };
  const renderTreeNode = (node, depth = 0) => {
    const hasChildren = node.children && node.children.length > 0;
    const isExpanded = expandedIds.has(node.id);
    const handleClick = () => {
      if (hasChildren) {
        toggleExpanded(node.id);
      }
      if (onNodeClick) {
        onNodeClick(node.id);
      }
    };
    return /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col",
      children: [renderNode ? renderNode(node, isExpanded) : /* @__PURE__ */ jsxs("div", {
        className: `flex items-center gap-2 py-1 rounded transition-colors ${hasChildren ? "cursor-pointer hover:bg-gray-50" : ""}`,
        style: {
          paddingLeft: `${depth * indent}px`
        },
        onClick: handleClick,
        children: [hasChildren && /* @__PURE__ */ jsx("span", {
          className: `text-gray-400 transition-transform ${isExpanded ? "rotate-90" : ""}`,
          children: "\u25B6"
        }), !hasChildren && /* @__PURE__ */ jsx("span", {
          className: "w-4"
        }), node.badge && /* @__PURE__ */ jsx("span", {
          className: "text-xs font-mono text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded",
          children: node.badge
        }), /* @__PURE__ */ jsx("span", {
          className: "text-sm text-gray-700",
          children: node.label
        }), node.metadata && /* @__PURE__ */ jsx("div", {
          className: "ml-auto",
          children: node.metadata
        })]
      }), hasChildren && isExpanded && node.children && /* @__PURE__ */ jsx("div", {
        children: node.children.map((child) => renderTreeNode(child, depth + 1))
      })]
    }, node.id);
  };
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col",
    children: nodes.map((node) => renderTreeNode(node))
  });
};

const SchemaPreview = ({
  schema,
  preferredLanguage = "en"
}) => {
  const treeNodes = useMemo(() => {
    if (!schema.classifications)
      return [];
    const childrenMap = new Map();
    const rootEntries = [];
    for (const [code, entry] of Object.entries(schema.classifications)) {
      if (entry.level === 0) {
        rootEntries.push(entry);
      } else {
        const parentCode = entry.ancestorCodes[entry.ancestorCodes.length - 1];
        if (!childrenMap.has(parentCode)) {
          childrenMap.set(parentCode, []);
        }
        childrenMap.get(parentCode).push(entry);
      }
    }
    const sortByCode = (a, b) => {
      return a.code.localeCompare(b.code, void 0, {
        numeric: true
      });
    };
    const entryToTreeNode = (entry) => {
      const children = childrenMap.get(entry.code) || [];
      const hasChildren = children.length > 0;
      let labelText = entry.name;
      if (preferredLanguage === "ar" && entry.nameAr) {
        labelText = entry.nameAr;
      } else if (preferredLanguage === "both" && entry.nameAr) {
        labelText = `${entry.name} | ${entry.nameAr}`;
      }
      const inlineMetadata = [];
      inlineMetadata.push(`L${entry.level}`);
      if (entry.relatedCodes && entry.relatedCodes.length > 0) {
        inlineMetadata.push(`\u{1F517} ${entry.relatedCodes.length}`);
      }
      const label = /* @__PURE__ */ jsxs("span", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx("span", {
          children: labelText
        }), /* @__PURE__ */ jsx("span", {
          className: "text-xs text-gray-400",
          children: inlineMetadata.join(" \u2022 ")
        })]
      });
      return {
        id: entry.code,
        label,
        badge: entry.code,
        children: hasChildren ? children.sort(sortByCode).map(entryToTreeNode) : void 0
      };
    };
    return rootEntries.sort(sortByCode).map(entryToTreeNode);
  }, [schema.classifications, preferredLanguage]);
  const stats = useMemo(() => {
    if (!schema.classifications)
      return null;
    const entries = Object.values(schema.classifications);
    return {
      total: entries.length,
      maxLevel: Math.max(...entries.map((e) => e.level), 0),
      withArabic: entries.filter((e) => e.nameAr).length,
      withRelations: entries.filter((e) => e.relatedCodes && e.relatedCodes.length > 0).length
    };
  }, [schema.classifications]);
  return /* @__PURE__ */ jsxs("div", {
    className: "border border-gray-200 rounded-lg",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "bg-gray-50 px-3 py-2 border-b border-gray-200",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between mb-2",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-sm font-medium text-gray-700",
          children: "Schema Preview"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-3 text-xs",
          children: [schema.version && /* @__PURE__ */ jsxs("span", {
            className: "text-gray-500",
            children: ["v", schema.version]
          }), schema.standard && /* @__PURE__ */ jsx("span", {
            className: "text-blue-600 bg-blue-50 px-2 py-0.5 rounded",
            children: schema.standard
          }), schema.language && /* @__PURE__ */ jsx("span", {
            className: "text-purple-600 bg-purple-50 px-2 py-0.5 rounded",
            children: schema.language
          })]
        })]
      }), stats && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-600",
        children: [/* @__PURE__ */ jsxs("span", {
          children: [/* @__PURE__ */ jsx("strong", {
            children: stats.total
          }), " categories"]
        }), /* @__PURE__ */ jsx("span", {
          children: "\u2022"
        }), /* @__PURE__ */ jsxs("span", {
          children: [/* @__PURE__ */ jsx("strong", {
            children: stats.maxLevel + 1
          }), " levels deep"]
        }), stats.withArabic > 0 && /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx("span", {
            children: "\u2022"
          }), /* @__PURE__ */ jsxs("span", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: stats.withArabic
            }), " with Arabic"]
          })]
        }), stats.withRelations > 0 && /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx("span", {
            children: "\u2022"
          }), /* @__PURE__ */ jsxs("span", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: stats.withRelations
            }), " with relations"]
          })]
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "p-3 max-h-96 overflow-y-auto",
      children: treeNodes.length === 0 ? /* @__PURE__ */ jsx("div", {
        className: "text-sm text-gray-500 text-center py-4",
        children: "No categories found"
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx("div", {
          className: "mb-3 pb-2 border-b border-gray-200",
          children: /* @__PURE__ */ jsxs("div", {
            className: "text-xs text-gray-500 flex flex-wrap gap-x-4 gap-y-1",
            children: [/* @__PURE__ */ jsxs("span", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "font-mono text-blue-600",
                children: "Code"
              }), " = Dewey code"]
            }), /* @__PURE__ */ jsxs("span", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "text-gray-400",
                children: "L#"
              }), " = Level depth"]
            }), /* @__PURE__ */ jsx("span", {
              children: "\u{1F517} = Related categories count"
            })]
          })
        }), /* @__PURE__ */ jsx(CollapsibleTree, {
          nodes: treeNodes
        })]
      })
    })]
  });
};

const SchemaSectionTitle = ({
  fileName,
  validation,
  parseError,
  hasSchema
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-between flex-1",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-medium",
        children: "2. Classification Schema"
      }), fileName && /* @__PURE__ */ jsx("span", {
        className: "text-sm text-gray-500 font-mono bg-gray-100 px-2 py-0.5 rounded",
        children: fileName
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex items-center gap-3 mr-2",
      children: parseError ? /* @__PURE__ */ jsx(StatusIndicator, {
        variant: "error",
        label: "Parse Error"
      }) : validation ? validation.valid ? /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(StatusIndicator, {
          variant: "success",
          label: "Valid"
        }), /* @__PURE__ */ jsx(StatsBadges, {
          validation
        })]
      }) : /* @__PURE__ */ jsx(StatusIndicator, {
        variant: "warning",
        label: "Invalid"
      }) : hasSchema ? /* @__PURE__ */ jsx(StatusIndicator, {
        variant: "info",
        label: "Loaded"
      }) : null
    })]
  });
};
const StatusIndicator = ({
  variant,
  label
}) => {
  const config = {
    success: {
      color: "text-green-600",
      icon: /* @__PURE__ */ jsx("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 13l4 4L19 7"
      })
    },
    error: {
      color: "text-red-600",
      icon: /* @__PURE__ */ jsx("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6 18L18 6M6 6l12 12"
      })
    },
    warning: {
      color: "text-orange-600",
      icon: /* @__PURE__ */ jsx("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      })
    },
    info: {
      color: "text-gray-500",
      icon: /* @__PURE__ */ jsx("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      })
    }
  }[variant];
  return /* @__PURE__ */ jsxs("div", {
    className: `flex items-center gap-1 ${config.color}`,
    children: [/* @__PURE__ */ jsx("svg", {
      className: "w-4 h-4",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      children: config.icon
    }), /* @__PURE__ */ jsx("span", {
      className: "text-xs font-medium",
      children: label
    })]
  });
};
const StatsBadges = ({
  validation
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-2 text-xs",
    children: [/* @__PURE__ */ jsxs("span", {
      className: "bg-blue-100 text-blue-700 px-2 py-0.5 rounded",
      children: [validation.categoryCount, " ", validation.categoryCount === 1 ? "cat" : "cats"]
    }), /* @__PURE__ */ jsxs("span", {
      className: "bg-purple-100 text-purple-700 px-2 py-0.5 rounded",
      children: [validation.maxDepth, "L"]
    })]
  });
};

const ClassificationSchemaSection = ({
  schemaHook
}) => {
  const {
    schema,
    fileName,
    validation,
    parseError,
    handleFileUpload,
    clearSchema
  } = schemaHook;
  const dropzone = useDropzone({
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        handleFileUpload(file);
      }
    },
    accept: [".json"],
    maxFiles: 1,
    multiple: false
  });
  return /* @__PURE__ */ jsx(CollapsibleSection, {
    title: /* @__PURE__ */ jsx(SchemaSectionTitle, {
      fileName,
      validation,
      parseError,
      hasSchema: !!schema
    }),
    defaultCollapsed: true,
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-600",
        children: "Upload a JSON file containing the category classification schema. Drag and drop a file or click to browse."
      }), !schema && /* @__PURE__ */ jsx(DropZone, {
        ...dropzone,
        className: "min-h-32",
        children: /* @__PURE__ */ jsx("div", {
          className: "absolute inset-0 flex items-center justify-center pointer-events-none",
          children: /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col items-center gap-2",
            children: [/* @__PURE__ */ jsx("svg", {
              className: "w-12 h-12 text-gray-400",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: /* @__PURE__ */ jsx("path", {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              })
            }), /* @__PURE__ */ jsxs("p", {
              className: "text-sm text-gray-600",
              children: [/* @__PURE__ */ jsx("span", {
                className: "text-blue-600 font-medium",
                children: "Click to upload"
              }), " ", "or drag and drop"]
            })]
          })
        })
      }), schema && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between p-3 bg-blue-50 border border-blue-200 rounded-lg",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2",
          children: [/* @__PURE__ */ jsx("svg", {
            className: "w-5 h-5 text-blue-600 flex-shrink-0",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })
          }), /* @__PURE__ */ jsx("span", {
            className: "text-sm font-medium text-blue-900",
            children: fileName
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "flex items-center gap-2",
          children: /* @__PURE__ */ jsx("button", {
            onClick: clearSchema,
            className: "text-sm text-red-600 hover:text-red-700 px-3 py-1 rounded hover:bg-red-50 transition-colors disabled:opacity-50",
            children: "Remove"
          })
        })]
      }), parseError && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: parseError
      }), validation && validation.valid && /* @__PURE__ */ jsx("div", {
        className: "bg-green-50 border border-green-200 rounded-lg p-3",
        children: /* @__PURE__ */ jsxs("div", {
          className: "flex items-start gap-2",
          children: [/* @__PURE__ */ jsx("svg", {
            className: "w-5 h-5 text-green-600 flex-shrink-0 mt-0.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            })
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex-1",
            children: [/* @__PURE__ */ jsx("p", {
              className: "text-sm font-medium text-green-800",
              children: "Valid schema"
            }), /* @__PURE__ */ jsxs("div", {
              className: "flex flex-wrap gap-3 mt-1 text-xs text-green-700",
              children: [/* @__PURE__ */ jsxs("span", {
                children: [validation.categoryCount, " ", validation.categoryCount === 1 ? "category" : "categories"]
              }), /* @__PURE__ */ jsx("span", {
                children: "\u2022"
              }), /* @__PURE__ */ jsxs("span", {
                children: [validation.maxDepth, " ", validation.maxDepth === 1 ? "level" : "levels", " deep"]
              })]
            })]
          })]
        })
      }), schema && /* @__PURE__ */ jsx(SchemaPreview, {
        schema
      })]
    })
  });
};

const useExtractionTest = (circleId) => {
  const api = useApi();
  const [results, setResults] = useState([]);
  const asyncExtract = useAsyncOperation(async (params) => {
    const newResults = [];
    const { schema } = params;
    const chunkId = params.chunkIds[0];
    const response = await api.post({
      path: "/groups/categories/extract-categories",
      body: {
        schema,
        chunkId,
        circleId,
        modelName: params.modelName,
        maxCategories: params.maxCategories
      }
    });
    newResults.push({
      chunkId,
      categories: response.categories || [],
      modelUsed: response.modelUsed || params.modelName
    });
    setResults(newResults);
  });
  const extractCategories = asyncExtract.execute;
  const clearResults = useCallback(() => {
    setResults([]);
  }, []);
  return {
    isExtracting: asyncExtract.isLoading,
    results,
    error: asyncExtract.error,
    extractCategories,
    clearResults
  };
};

const ExtractionTestSection = ({
  postHook,
  schemaHook,
  circleId
}) => {
  const [modelName, setModelName] = useState("gpt-4o");
  const [maxCategories, setMaxCategories] = useState(5);
  const extractionHook = useExtractionTest(circleId);
  const selectedCount = postHook.selectedChunkIds.size;
  const hasSchema = schemaHook.schema !== null;
  if (selectedCount === 0) {
    return null;
  }
  const handleExtract = async () => {
    const chunkIds = Array.from(postHook.selectedChunkIds);
    await extractionHook.extractCategories({
      chunkIds,
      modelName,
      maxCategories,
      schema: schemaHook.schema
    });
  };
  const canExtract = selectedCount > 0 && hasSchema && modelName.trim().length > 0;
  return /* @__PURE__ */ jsx(CollapsibleSection, {
    title: /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between flex-1",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-semibold",
        children: "Test Extraction"
      }), /* @__PURE__ */ jsxs("span", {
        className: "text-sm text-gray-500 mr-2",
        children: [selectedCount, " chunk", selectedCount !== 1 ? "s" : "", " selected"]
      })]
    }),
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "grid grid-cols-2 gap-4",
        children: [/* @__PURE__ */ jsx(TextInput, {
          value: modelName,
          onChange: (e) => setModelName(e.target.value),
          label: "Model Name",
          placeholder: "e.g., gpt-4o, claude-3-sonnet",
          helperText: "AI model to use for extraction"
        }), /* @__PURE__ */ jsx(TextInput, {
          type: "number",
          value: maxCategories.toString(),
          onChange: (e) => setMaxCategories(parseInt(e.target.value) || 5),
          label: "Max Categories",
          placeholder: "5",
          helperText: "Maximum categories per chunk"
        })]
      }), !hasSchema && /* @__PURE__ */ jsx("div", {
        className: "bg-orange-50 border border-orange-200 rounded-lg p-3",
        children: /* @__PURE__ */ jsx("div", {
          className: "text-sm text-orange-800",
          children: "\u26A0\uFE0F Please load a classification schema first"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-3",
        children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
          onClick: handleExtract,
          loading: extractionHook.isExtracting,
          disabled: !canExtract,
          className: "bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
          children: "Extract Categories"
        }), extractionHook.results.length > 0 && /* @__PURE__ */ jsx("button", {
          onClick: extractionHook.clearResults,
          className: "text-sm text-gray-600 hover:text-gray-800 underline",
          children: "Clear Results"
        })]
      }), extractionHook.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: extractionHook.error
      }), extractionHook.results.length > 0 && /* @__PURE__ */ jsxs("div", {
        className: "mt-4",
        children: [/* @__PURE__ */ jsxs("h3", {
          className: "text-sm font-semibold mb-3",
          children: ["Extraction Results (", extractionHook.results.length, ")"]
        }), /* @__PURE__ */ jsx("div", {
          className: "flex flex-col gap-3",
          children: extractionHook.results.map((result) => /* @__PURE__ */ jsx(ExtractionResultItem, {
            result,
            postHook
          }, result.chunkId))
        })]
      })]
    })
  });
};
const ExtractionResultItem = ({
  result,
  postHook
}) => {
  const chunk = postHook.postData && postHook.postData.pages.flatMap((p) => p.chunks).find((c) => c._id === result.chunkId);
  return /* @__PURE__ */ jsxs("div", {
    className: "border border-gray-200 rounded-lg p-3 bg-gray-50",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-start justify-between mb-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "text-xs text-gray-600",
        children: [/* @__PURE__ */ jsxs("span", {
          className: "font-medium",
          children: ["Chunk #", result.chunkId]
        }), chunk && /* @__PURE__ */ jsxs("span", {
          className: "ml-2",
          children: [chunk.text.slice(0, 60), "..."]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "text-xs text-gray-500",
        children: result.modelUsed
      })]
    }), result.error ? /* @__PURE__ */ jsxs("div", {
      className: "bg-red-50 border border-red-200 rounded p-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "text-xs font-semibold text-red-700 mb-1",
        children: "\u26A0\uFE0F Extraction Error"
      }), /* @__PURE__ */ jsx("div", {
        className: "text-xs text-red-600",
        children: result.error
      })]
    }) : /* @__PURE__ */ jsx(CategoryBadgeList, {
      categories: result.categories,
      className: "mt-2"
    })]
  });
};

const CategoriesPanel = ({
  circleId
}) => {
  const {
    data: circleData = {}
  } = useCircle(circleId);
  const {
    group: circle,
    membership
  } = circleData;
  const postHook = usePostWithChunks(circleId);
  const schemaHook = useClassificationSchema(circleId);
  if (!membership) {
    return /* @__PURE__ */ jsx(CircleMembershipRequiredPanel, {
      circle
    });
  }
  return /* @__PURE__ */ jsx(ClassificationSchemaProvider, {
    schemaHook,
    children: /* @__PURE__ */ jsxs("div", {
      className: "w-full p-4 flex flex-col gap-6",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx("h1", {
          className: "text-2xl font-semibold",
          children: "Categories Extraction Test"
        }), circle && /* @__PURE__ */ jsxs("p", {
          className: "text-gray-600",
          children: ["Testing category extraction in circle:", /* @__PURE__ */ jsx("a", {
            href: circleUrl(circleId),
            className: "text-blue-600",
            children: /* @__PURE__ */ jsx("span", {
              className: "underline mx-2",
              children: circle.name
            })
          })]
        })]
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(PostInfoSection, {
        postHook
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(ClassificationSchemaSection, {
        schemaHook
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(SelectedChunksSection, {
        postHook
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(ExtractionTestSection, {
        postHook,
        schemaHook,
        circleId
      })]
    })
  });
};

const CategoriesTest = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(CategoriesTestInner, {})
  });
};
const CategoriesTestInner = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  const circleId = parts[parts.findIndex((v) => v === "categories") + 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(CategoriesPanel, {
        circleId
      })
    })]
  });
};

const formatSize = (sizeMB) => {
  if (sizeMB < 1)
    return `${(sizeMB * 1024).toFixed(0)} KB`;
  return `${sizeMB.toFixed(1)} MB`;
};
const FileRow = ({
  info,
  index,
  onRemove,
  disabled
}) => {
  const handleRemove = useCallback(() => {
    onRemove(index);
  }, [index, onRemove]);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-between gap-2 py-1.5 px-2 rounded hover:bg-gray-50 group",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 min-w-0",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-xs text-gray-400 w-5 shrink-0 text-right",
        children: index + 1
      }), /* @__PURE__ */ jsx("span", {
        className: "text-sm text-gray-700 truncate",
        title: info.path,
        children: info.name
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 shrink-0",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-xs text-gray-400",
        children: formatSize(info.sizeMB)
      }), !disabled && /* @__PURE__ */ jsx("button", {
        onClick: handleRemove,
        className: "text-gray-300 hover:text-red-500 transition-colors opacity-0 group-hover:opacity-100",
        title: "Remove file",
        children: /* @__PURE__ */ jsx(MdOutlineClose, {
          size: 16
        })
      })]
    })]
  });
};
const MultiFileSelector = ({
  handler,
  isProcessing = false,
  className
}) => {
  const {
    files,
    filesInfo,
    dropzone,
    addFiles,
    removeFile,
    clearFiles
  } = handler;
  const dirInputRef = useRef(null);
  useEffect(() => {
    if (dirInputRef.current) {
      dirInputRef.current.setAttribute("webkitdirectory", "");
      dirInputRef.current.setAttribute("multiple", "");
    }
  }, []);
  const handleDirChange = useCallback((e) => {
    const fileList = e.target.files;
    if (!fileList || fileList.length === 0)
      return;
    const pdfs = [];
    for (let i = 0; i < fileList.length; i++) {
      const f = fileList[i];
      if (f.name.toLowerCase().endsWith(".pdf")) {
        pdfs.push(f);
      }
    }
    addFiles(pdfs);
    e.target.value = "";
  }, [addFiles]);
  const handleFolderClick = useCallback(() => {
    if (dirInputRef.current) {
      dirInputRef.current.click();
    }
  }, []);
  const hasFiles = files.length > 0;
  return /* @__PURE__ */ jsxs("div", {
    className: `flex flex-col gap-3 ${className || ""}`,
    children: [/* @__PURE__ */ jsx(DropZone, {
      ...dropzone
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-3",
      children: [/* @__PURE__ */ jsx("input", {
        ref: dirInputRef,
        type: "file",
        accept: ".pdf",
        onChange: handleDirChange,
        className: "hidden"
      }), /* @__PURE__ */ jsxs("button", {
        onClick: handleFolderClick,
        disabled: isProcessing,
        className: "inline-flex items-center gap-2 px-3 py-1.5 text-sm border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
        children: [/* @__PURE__ */ jsx(MdFolderOpen, {
          size: 16,
          className: "text-gray-500"
        }), "Select folder"]
      }), hasFiles && /* @__PURE__ */ jsxs("span", {
        className: "text-sm text-gray-500",
        children: [files.length, " ", files.length === 1 ? "file" : "files", " selected"]
      }), hasFiles && !isProcessing && /* @__PURE__ */ jsxs("button", {
        onClick: clearFiles,
        className: "inline-flex items-center gap-1 text-xs text-gray-400 hover:text-red-500 transition-colors ml-auto",
        children: [/* @__PURE__ */ jsx(MdOutlineClear, {
          size: 14
        }), "Clear all"]
      })]
    }), hasFiles && /* @__PURE__ */ jsx("div", {
      className: "border border-gray-200 rounded max-h-64 overflow-y-auto",
      children: /* @__PURE__ */ jsx("div", {
        className: "divide-y divide-gray-100",
        children: filesInfo.map((info, index) => /* @__PURE__ */ jsx(FileRow, {
          info,
          index,
          onRemove: removeFile,
          disabled: isProcessing
        }, info.path + info.sizeBytes))
      })
    })]
  });
};

const FileQueueProgress = ({
  summary,
  className
}) => {
  const {
    total,
    pending,
    active,
    processing,
    done,
    error
  } = summary;
  if (total === 0)
    return null;
  const completed = done + error;
  const pct = Math.round(completed / total * 100);
  const filledPct = Math.round((done + processing) / total * 100);
  return /* @__PURE__ */ jsxs("div", {
    className: `flex flex-col gap-2 ${className || ""}`,
    children: [/* @__PURE__ */ jsx("div", {
      className: "w-full h-2 bg-gray-100 rounded-full overflow-hidden",
      children: /* @__PURE__ */ jsx("div", {
        className: "h-full bg-green-500 rounded-full transition-all duration-300",
        style: {
          width: `${filledPct}%`
        }
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-4 text-xs text-gray-500 flex-wrap",
      children: [/* @__PURE__ */ jsxs("span", {
        className: "font-medium text-gray-700",
        children: [completed, " / ", total, " files"]
      }), pending > 0 && /* @__PURE__ */ jsxs("span", {
        children: [pending, " pending"]
      }), active > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-blue-600 font-medium",
        children: [active, " uploading"]
      }), processing > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-amber-600",
        children: [processing, " processing"]
      }), done > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-green-600",
        children: [done, " done"]
      }), error > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-red-600 font-medium",
        children: [error, " failed"]
      }), total > 0 && completed === total && /* @__PURE__ */ jsxs("span", {
        className: "text-gray-400",
        children: ["(", pct, "%)"]
      })]
    })]
  });
};

const toFileInfo = (f) => ({
  name: f.name,
  sizeMB: f.size / (1024 * 1024),
  sizeBytes: f.size,
  path: f.webkitRelativePath || f.name
});
const dedup = (existing, incoming) => {
  const keys = new Set(existing.map((f) => f.name + f.size));
  return [...existing, ...incoming.filter((f) => !keys.has(f.name + f.size))];
};
const useMultiFileHandler = (options = {}) => {
  const {
    extensions = [".pdf"],
    maxSize,
    maxFiles,
    onFilesAdded,
    onFileRemoved
  } = options;
  const [files, setFilesState] = useState([]);
  const filesRef = useRef([]);
  const setFiles = useCallback((next) => {
    filesRef.current = next;
    setFilesState(next);
  }, []);
  const filesInfo = files.map(toFileInfo);
  const applyIncoming = useCallback((incoming, current) => {
    const sizeFiltered = maxSize ? incoming.filter((f) => {
      const ok = f.size <= maxSize;
      if (!ok)
        console.warn(`Skipped "${f.name}" \u2014 exceeds ${maxSize} bytes`);
      return ok;
    }) : incoming;
    const merged = dedup(current, sizeFiltered);
    if (maxFiles && merged.length > maxFiles) {
      console.warn(`File cap of ${maxFiles} reached \u2014 some files were not added`);
      return merged.slice(0, maxFiles);
    }
    return merged;
  }, [maxSize, maxFiles]);
  const handleDrop = useCallback((accepted) => {
    if (accepted.length === 0)
      return;
    const next = applyIncoming(accepted, filesRef.current);
    const added = next.filter((f) => !filesRef.current.includes(f));
    setFiles(next);
    if (onFilesAdded && added.length > 0)
      onFilesAdded(added, next);
  }, [applyIncoming, setFiles, onFilesAdded]);
  const dropzone = useDropzone({
    onDrop: handleDrop,
    accept: extensions,
    multiple: true,
    maxFiles,
    maxSize
  });
  const addFiles = useCallback((incoming) => {
    const next = applyIncoming(incoming, filesRef.current);
    const added = next.filter((f) => !filesRef.current.includes(f));
    setFiles(next);
    if (onFilesAdded && added.length > 0)
      onFilesAdded(added, next);
  }, [applyIncoming, setFiles, onFilesAdded]);
  const removeFile = useCallback((index) => {
    const next = filesRef.current.filter((_, i) => i !== index);
    setFiles(next);
    if (onFileRemoved)
      onFileRemoved(index, next);
  }, [setFiles, onFileRemoved]);
  const clearFiles = useCallback(() => {
    setFiles([]);
  }, [setFiles]);
  return {
    files,
    filesInfo,
    dropzone,
    addFiles,
    removeFile,
    clearFiles
  };
};

const uploadChunks = async (api, splitData, file, options, onChunkUploaded) => {
  if (!options.circleId)
    throw new Error("circleId is required");
  if (!splitData || !splitData.files || splitData.files.length === 0) {
    throw new Error("No split data available");
  }
  let execution = null;
  const total = splitData.files.length;
  for (let i = 0; i < total; i++) {
    const splitFile = splitData.files[i];
    const splitDetail = splitData.summary.splitDetails[i];
    const binaryString = atob(splitFile.base64Data);
    const bytes = new Uint8Array(binaryString.length);
    for (let j = 0; j < binaryString.length; j++) {
      bytes[j] = binaryString.charCodeAt(j);
    }
    const blob = new Blob([bytes], { type: "application/pdf" });
    const [startPage, endPage] = splitDetail.pages.split("-").map(Number);
    const baseName = file.name.replace(/\.pdf$/i, "");
    const chunkFile = new File([blob], `${baseName}_pages_${startPage}-${endPage}.pdf`, { type: "application/pdf" });
    const uploadData = {
      0: chunkFile,
      executionId: execution && execution._id || "",
      chunkIndex: String(i),
      totalChunks: String(total),
      originalFileName: splitData.summary.originalFile || file.name,
      processor: options.processor,
      width: options.width,
      circleId: options.circleId,
      startPage: String(startPage),
      endPage: String(endPage),
      pageCount: String(endPage - startPage + 1),
      promptPostId: options.promptPostId || "",
      includePageThumbnails: String(options.includePageThumbnails !== false),
      path: "/uploads/upload-pdf-chunk"
    };
    const response = await withRetry(() => api.upload(uploadData), {
      maxRetries: 3,
      onRetry: (attempt, error) => {
        console.log(`uploadChunks: retry ${attempt}/3 for chunk ${i}:`, error.message);
      }
    });
    splitData.files[i] = { base64Data: null };
    if (response.execution) {
      execution = response.execution;
    }
    if (onChunkUploaded) {
      onChunkUploaded(i + 1, total);
    }
  }
  if (!execution) {
    throw new Error("Upload completed but server returned no execution");
  }
  return execution;
};

const useFileQueueProcessor = () => {
  const api = useApi();
  const { splitPdf } = usePdfSplitWorker();
  const { state, actions } = useMultiFileQueue();
  const processingRef = useRef(false);
  const optionsRef = useRef(null);
  const [tick, setTick] = useState(0);
  const processItem = useMemoizedFn(async (id, file) => {
    const options = optionsRef.current;
    if (!options)
      return;
    try {
      actions.updateItem(id, { status: "splitting" });
      const splitResult = await splitPdf(file, {
        maxPagesPerFile: options.maxPagesPerFile,
        maxSizePerFile: 19 * 1024 * 1024
      });
      const splitDetails = splitResult.summary.splitDetails.map((d, i) => ({
        ...d
      }));
      actions.updateItem(id, {
        status: "uploading",
        splitDetails
      });
      const execution = await uploadChunks(api, splitResult, file, options, (uploaded, total) => {
        actions.updateItem(id, { chunkProgress: { uploaded, total } });
      });
      actions.updateItem(id, { status: "processing", execution });
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      console.error(`useFileQueueProcessor: error processing "${file.name}":`, message);
      actions.updateItem(id, { status: "error", error: message });
    } finally {
      processingRef.current = false;
      setTick((t) => t + 1);
    }
  });
  useEffect(() => {
    if (!state.running || processingRef.current)
      return;
    const next = state.items.find((item) => item.status === "pending");
    if (!next) {
      actions.setRunning(false);
      return;
    }
    processingRef.current = true;
    processItem(next.id, next.file);
  }, [state.running, tick]);
  const start = useMemoizedFn((options) => {
    optionsRef.current = options;
    state.items.forEach((item) => {
      if (item.status === "error") {
        actions.updateItem(item.id, { status: "pending", error: void 0 });
      }
    });
    actions.setRunning(true);
  });
  const pause = useMemoizedFn(() => {
    actions.setRunning(false);
  });
  const resume = useMemoizedFn(() => {
    actions.setRunning(true);
  });
  return { start, pause, resume };
};

const SCHEDULE_INTERVAL = 5e3;
const STATUS_INTERVAL = 3e4;
const isTerminal = (execution) => execution.status === "finished" || execution.status === "error";
const useQueueExecutionPoller = (executions = [], setExecutions) => {
  const api = useApi();
  const schedulingRef = useRef(new Set());
  const checkingRef = useRef(new Set());
  const scheduleExecution = useMemoizedFn(async (execution) => {
    if (schedulingRef.current.has(execution._id))
      return;
    schedulingRef.current.add(execution._id);
    try {
      const { execution: updated } = await api.post({
        path: "/uploads/schedule-batch-processing",
        body: { executionId: execution._id }
      });
      if (setExecutions) {
        setExecutions((prev) => prev.map((e) => e._id === updated._id ? updated : e));
      }
    } catch (err) {
      console.error("useQueueExecutionPoller: schedule failed for", execution._id, err);
    } finally {
      schedulingRef.current.delete(execution._id);
    }
  });
  const checkExecution = useMemoizedFn(async (execution) => {
    if (checkingRef.current.has(execution._id))
      return;
    checkingRef.current.add(execution._id);
    try {
      const { execution: updated } = await api.get({
        path: `/uploads/import-pdf-batch-status?id=${execution._id}&force=true`
      });
      if (setExecutions) {
        setExecutions((prev) => prev.map((e) => e._id === updated._id ? updated : e));
      }
    } catch (err) {
      console.error("useQueueExecutionPoller: status check failed for", execution._id, err);
    } finally {
      checkingRef.current.delete(execution._id);
    }
  });
  useInterval(() => {
    for (const execution of executions) {
      if (isTerminal(execution))
        continue;
      if (shouldScheduleBatches(execution.data)) {
        scheduleExecution(execution);
      }
    }
  }, SCHEDULE_INTERVAL, { immediate: true });
  useInterval(() => {
    for (const execution of executions) {
      if (isTerminal(execution))
        continue;
      if (shouldMonitorStatus(execution.data)) {
        checkExecution(execution);
      }
    }
  }, STATUS_INTERVAL, { immediate: true });
};

const MultiImportBreadcrumb = ({
  circle,
  circleId
}) => {
  const parent = circle && circle.parent;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), parent && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(parent),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: "..."
        })
      })]
    }), circle && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circleId),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: circle.name
        })
      })]
    })]
  });
};

const MultiImportPanel = ({
  circleId
}) => {
  const [processor, setProcessor] = useState("ocr-5");
  const [width, setWidth] = useState("600");
  const [pageNo, setPageNo] = useState("1");
  const [addPrompt, setAddPrompt] = useState(false);
  const [promptPostId, setPromptPostId] = useState("");
  const [includePageThumbnails, setIncludePageThumbnails] = useState(true);
  const {
    data: circleData = {}
  } = useCircle(circleId);
  const {
    group: circle,
    membership
  } = circleData;
  const {
    addToast
  } = useToast();
  const handler = useMultiFileHandler({
    onFilesAdded: (added, all) => {
      addToast({
        type: "success",
        message: `Added ${added.length} file${added.length === 1 ? "" : "s"} \u2014 ${all.length} total`
      });
    }
  });
  const {
    state: queueState,
    actions: queueActions,
    summary
  } = useMultiFileQueue();
  const processor_ = useFileQueueProcessor();
  const {
    executions,
    setExecutions
  } = useExecutions({
    id: circleId
  });
  useEffect(() => {
    const promotable = queueState.items.filter((item) => item.execution && !executions.find((e) => e._id === item.execution._id));
    if (promotable.length === 0)
      return;
    setExecutions((prev) => [...promotable.map((item) => item.execution), ...prev]);
  }, [queueState.items]);
  useQueueExecutionPoller(executions, setExecutions);
  const uploadingItems = queueState.items.filter((i) => !i.execution);
  const isRunning = queueState.running;
  const hasFiles = handler.files.length > 0;
  const hasQueueItems = queueState.items.length > 0;
  const handleStart = () => {
    const existingKeys = new Set(queueState.items.filter((i) => i.status === "pending" || i.status === "splitting" || i.status === "uploading").map((i) => i.file.name + i.file.size));
    const newFiles = handler.files.filter((f) => !existingKeys.has(f.name + f.size));
    if (newFiles.length > 0) {
      queueActions.addFiles(newFiles);
    }
    const maxPagesPerFile = parseInt(pageNo);
    processor_.start({
      circleId,
      processor,
      width,
      maxPagesPerFile: maxPagesPerFile > 0 ? maxPagesPerFile : 15,
      promptPostId: addPrompt && promptPostId ? promptPostId : void 0,
      includePageThumbnails
    });
  };
  if (!membership) {
    return /* @__PURE__ */ jsx(CircleMembershipRequiredPanel, {
      circle
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 flex flex-col gap-6",
    children: [/* @__PURE__ */ jsx(MultiImportBreadcrumb, {
      circle,
      circleId
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("h1", {
        className: "text-2xl font-semibold",
        children: "Import multiple PDFs"
      }), circle && /* @__PURE__ */ jsxs("p", {
        className: "text-gray-600 font-semibold",
        children: ["For circle:", /* @__PURE__ */ jsx("a", {
          href: circleUrl(circleId),
          className: "text-blue-600",
          children: /* @__PURE__ */ jsx("span", {
            className: "underline mx-2",
            children: circle.name
          })
        })]
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "1. Select Import Options"
      }), /* @__PURE__ */ jsx(PdfProcessingOptions, {
        processor,
        onProcessorChange: setProcessor,
        width,
        onWidthChange: setWidth,
        pageNo,
        onPageNoChange: setPageNo,
        addPrompt,
        onAddPromptChange: setAddPrompt,
        promptPostId,
        onPromptPostIdChange: setPromptPostId,
        includePageThumbnails,
        onIncludePageThumbnailsChange: setIncludePageThumbnails,
        isCircleAdmin: membership.role === "ADMIN"
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "2. Select PDF Documents"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-500",
        children: 'Drag and drop files, click the drop zone to browse, or use "Select folder" to pick an entire directory.'
      }), /* @__PURE__ */ jsx(MultiFileSelector, {
        handler,
        isProcessing: isRunning
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "3. Process Documents"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-3",
        children: [!isRunning ? /* @__PURE__ */ jsx(LoadingButtonTW, {
          onClick: handleStart,
          disabled: !hasFiles,
          background: "red",
          children: hasFiles ? `Upload ${handler.files.length} files` : "Upload"
        }) : /* @__PURE__ */ jsx(LoadingButtonTW, {
          onClick: () => processor_.pause(),
          background: "gray",
          children: "Pause"
        }), !isRunning && summary.pending > 0 && hasQueueItems && /* @__PURE__ */ jsxs(LoadingButtonTW, {
          onClick: () => processor_.resume(),
          background: "blue",
          children: ["Resume (", summary.pending, " remaining)"]
        })]
      })]
    }), uploadingItems.length > 0 && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-4",
        children: [/* @__PURE__ */ jsx("h2", {
          className: "text-lg font-semibold",
          children: "4. Processing Status"
        }), isRunning && /* @__PURE__ */ jsx(FileQueueProgress, {
          summary
        }), /* @__PURE__ */ jsx("div", {
          className: "flex flex-col gap-1",
          children: uploadingItems.map((item, idx) => /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-3 px-3 py-2 bg-gray-50 rounded text-sm",
            children: [/* @__PURE__ */ jsx("span", {
              className: "text-gray-400 w-5 text-right shrink-0",
              children: idx + 1
            }), /* @__PURE__ */ jsx("span", {
              className: "flex-1 truncate text-gray-700",
              title: item.file.name,
              children: item.file.name
            }), /* @__PURE__ */ jsx("span", {
              className: `text-xs px-2 py-0.5 rounded shrink-0 ${item.status === "splitting" ? "bg-blue-100 text-blue-700 animate-pulse" : item.status === "uploading" ? "bg-amber-100 text-amber-700 animate-pulse" : item.status === "error" ? "bg-red-100 text-red-700" : "bg-gray-100 text-gray-500"}`,
              children: item.status === "splitting" ? "Splitting\u2026" : item.status === "uploading" ? `Uploading\u2026${item.chunkProgress ? ` (${item.chunkProgress.uploaded}/${item.chunkProgress.total})` : ""}` : item.status === "error" ? item.error || "Failed" : "Pending"
            })]
          }, item.id))
        })]
      })]
    }), executions.length > 0 && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(CollapsibleSection, {
        title: `Imports (${executions.length})`,
        defaultCollapsed: false,
        children: /* @__PURE__ */ jsx("div", {
          className: "flex flex-col gap-3 pt-2",
          children: executions.map((execution) => /* @__PURE__ */ jsx(ImportExecution, {
            execution,
            setExecutions
          }, execution._id))
        })
      })]
    })]
  });
};

const MultiImportPage = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(MultiImportPageInner, {})
  });
};
const MultiImportPageInner = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  const circleId = parts[parts.findIndex((v) => v === "pdf-multi" || v === "pdf-import") + 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(MultiFileQueueProvider, {
        children: /* @__PURE__ */ jsx(PdfProcessingProvider, {
          children: /* @__PURE__ */ jsx(MultiImportPanel, {
            circleId
          })
        })
      })
    })]
  });
};

const Wrapper$A = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const CirclesPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/circles";
  if (pathname.startsWith(prefix + "/simple-tree")) {
    return /* @__PURE__ */ jsx(CircleListing, {});
  }
  if (pathname.startsWith(prefix + "/circles-tree")) {
    return /* @__PURE__ */ jsx(CirclesTreePlayground, {});
  }
  if (pathname.startsWith(prefix + "/creation")) {
    return /* @__PURE__ */ jsx(CreateCircleTest, {});
  }
  if (pathname.startsWith(prefix + "/pdf-simple")) {
    return /* @__PURE__ */ jsx(PdfSimple, {});
  }
  if (pathname.startsWith(prefix + "/pdf-multi")) {
    return /* @__PURE__ */ jsx(MultiImportPage, {});
  }
  if (pathname.startsWith(prefix + "/ocr")) {
    return /* @__PURE__ */ jsx(OCRSinglePage, {});
  }
  if (pathname.startsWith(prefix + "/categories")) {
    return /* @__PURE__ */ jsx(CategoriesTest, {});
  }
  if (pathname.startsWith(prefix + "/rag")) {
    return /* @__PURE__ */ jsx(HybridSearchTest, {});
  }
  if (pathname.startsWith(prefix + "/vector")) {
    return /* @__PURE__ */ jsx(VectorCommandTest, {});
  }
  if (pathname.startsWith(prefix + "/websockets")) {
    return /* @__PURE__ */ jsx(WebSocketsTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$A, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/simple-tree/",
        children: "Simple Tree"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/creation/",
        children: "Circles Creation"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/circles-tree/",
        children: "Circles Tree"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/pdf-simple/",
        children: "Pdf Import Test"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/rag/",
        children: "Vector search tests"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/vector/",
        children: "Vector command test"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/websockets/",
        children: "Websockets test"
      })
    })]
  });
};

const VotingIcon = () => {
  const [open, setOpen] = useState(false);
  const {
    data
  } = useVotesActivity();
  if (!data) {
    return null;
  }
  const {
    history
  } = data;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(IconButton$5, {
      onClick: () => setOpen(true),
      children: /* @__PURE__ */ jsx(Badge$2, {
        ...votingBadgeProps(history),
        children: /* @__PURE__ */ jsx(RiScales3Fill, {})
      })
    }), /* @__PURE__ */ jsx(VotesListDialog, {
      open,
      onClose: () => setOpen(false),
      data,
      title: "All votes"
    })]
  });
};

const Wrapper$z = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const RecentCircleVotesInner = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("631240bffa1bdef56b4538ab");
  const {
    data,
    mutate
  } = useCircleVotesActivity(circleId);
  const {
    data: allVotes,
    mutate: mutateAll
  } = useVotesActivity();
  const getCircleVotes = async () => {
    mutate();
    mutateAll();
  };
  const handleCircleChange = (e) => {
    setCircleId(e.target.value);
  };
  const lastVotingPolls = async () => {
    setResult({
      waiting: true
    });
    const result2 = await api.activityRequest({
      path: "/activities-votes/last-votes/"
    });
    setResult(result2);
  };
  const clearUserVotingHistory = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/user-votes/",
      method: "DELETE"
    });
    setResult(result2);
  };
  return /* @__PURE__ */ jsxs(Wrapper$z, {
    children: [/* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Vote activities actions"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: getCircleVotes,
          children: "Get Recent Votes"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: lastVotingPolls,
          children: "Reprocess Last Voting Polls"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: clearUserVotingHistory,
          children: "Clear User Voting History"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Notifications"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Red dot"
      }), /* @__PURE__ */ jsx(Badge$2, {
        ...useCheckActivityBadge(),
        children: /* @__PURE__ */ jsx(MdNotifications, {})
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Votes in circles"
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        autoFocus: true,
        label: "Circle ID",
        placeholder: "Circle ID",
        value: circleId,
        onChange: handleCircleChange
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["Icon to show votes in circle #", circleId]
      }), /* @__PURE__ */ jsx(CircleVotingIcon, {
        circleId
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["Icons for posts in circle #", circleId]
      }), /* @__PURE__ */ jsx("div", {
        children: data && Object.values(data.history.map((p) => p.root._id).reduce((all, id) => {
          all[id] = id;
          return all;
        }, {})).map((postId, i) => {
          return /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx("span", {
              style: {
                marginRight: 20
              },
              children: i !== 0 ? ";" : ""
            }), /* @__PURE__ */ jsx(CirclePostVotingIcon, {
              circleId,
              postId
            })]
          });
        })
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["Voting icons on post view in circle #", circleId]
      }), /* @__PURE__ */ jsx("div", {
        children: data && Object.values(data.history.map((p) => p.root._id).reduce((all, id) => {
          all[id] = id;
          return all;
        }, {})).map((postId, i) => {
          const post = data.history.find((h) => h.root._id === postId).root;
          return /* @__PURE__ */ jsxs(PostContextProvider, {
            post,
            children: [/* @__PURE__ */ jsxs("span", {
              style: {
                marginRight: 20
              },
              children: [i !== 0 ? ";" : "", postId, "-"]
            }), /* @__PURE__ */ jsx(PostVotingIcon, {
              color: "blue"
            })]
          });
        })
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["List of votes in circle #", circleId]
      }), /* @__PURE__ */ jsx(CardThemeProvider, {
        cardImage: true,
        children: data && data.history.map((d) => {
          return /* @__PURE__ */ jsx(VoteActivityCard$1, {
            data: d
          }, d._id);
        })
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "All Votes"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Icon to show all votes"
      }), /* @__PURE__ */ jsx(VotingIcon, {}), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "List of all votes"
      }), /* @__PURE__ */ jsx(CardThemeProvider, {
        cardImage: true,
        children: allVotes && allVotes.history.map((d) => {
          return /* @__PURE__ */ jsx(VoteActivityCard$1, {
            data: d
          }, d._id);
        })
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "My Circles"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "With notifications"
      }), /* @__PURE__ */ jsxs(SearchContextProvider, {
        children: [/* @__PURE__ */ jsx(PlaygroundSearchInput, {}), /* @__PURE__ */ jsx(MyCirclesList, {
          empty: "No data"
        })]
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Only circles with activity"
      }), /* @__PURE__ */ jsx(MyCirclesWithActivity, {})]
    })]
  });
};
const RecentCircleVotesTest = () => {
  return /* @__PURE__ */ jsx(Staging, {
    children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
      children: /* @__PURE__ */ jsx(ActivityContextProvider, {
        children: /* @__PURE__ */ jsx(RecentCircleVotesInner, {})
      })
    })
  });
};

const Wrapper$y = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    & .MuiButtonBase-root {
        margin: 10px;
    }
`;
const VotingBasicActivityTest = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const roundsSub = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/rounds-sub/"
    });
    setResult(result2);
  };
  const restartSub = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/restart-sub/"
    });
    setResult(result2);
  };
  const roundsAddModified = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/rounds-add-modified/"
    });
    setResult(result2);
  };
  const getDomain = async () => {
    const result2 = await api.activityRequest({
      path: "/instance/"
    });
    setResult(result2);
  };
  const activitiesMe = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/me/"
    });
    setResult(result2);
  };
  const lastPost = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/changes-last/"
    });
    setResult(result2);
  };
  const lastVotingPolls = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/last-votes/"
    });
    setResult(result2);
  };
  const clearUserVotingHistory = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/user-votes/",
      method: "DELETE"
    });
    setResult(result2);
  };
  const allUserVotes = async () => {
    const result2 = await api.makeRequest({
      path: "/activities/user-votes/"
    });
    setResult(result2);
  };
  const activitiesUsers = async () => {
    const result2 = await api.activityRequest({
      path: "/activities-votes/users/"
    });
    setResult(result2);
  };
  const getUser = async () => {
    const result2 = await api.loadProfile();
    setResult(result2);
  };
  const getJwt = async () => {
    const token = await api.loadJwt();
    const parsed = api.parseJwt(token);
    const d = new Date(0);
    d.setUTCSeconds(parsed.exp);
    console.log("Expires:", d);
    setResult(parsed);
  };
  return /* @__PURE__ */ jsxs(Wrapper$y, {
    children: [/* @__PURE__ */ jsxs("div", {
      children: ["Last Request: ", /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: result ? JSON.stringify(result) : "-"
        }
      })]
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: restartSub,
      children: "Reatsrt Subscription"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: roundsSub,
      children: "Rounds Subscription"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: roundsAddModified,
      children: "Rounds Add Modified"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: getDomain,
      children: "Get Instance"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: getUser,
      children: "Get User"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: getJwt,
      children: "Get Jwt"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: activitiesMe,
      children: "Activities Me"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: activitiesUsers,
      children: "Users"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: lastPost,
      children: "Last Post Change and cursor"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: lastVotingPolls,
      children: "Replay Last Voting Polls"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: clearUserVotingHistory,
      children: "Clear User Voting History"
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: allUserVotes,
      children: "User votes"
    })]
  });
};

const Wrapper$x = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;
    & > div {
        width: 100%;
    }
`;
const NotificationsPageTestInner = () => {
  return /* @__PURE__ */ jsxs(Wrapper$x, {
    children: [/* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Notifications"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Red dot"
      }), /* @__PURE__ */ jsx(Badge$2, {
        ...useCheckActivityBadge(),
        children: /* @__PURE__ */ jsx(MdNotifications, {})
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Notifications Action Item"
      }), /* @__PURE__ */ jsx(NotificationsActionItem, {}), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Notifications Selected"
      }), /* @__PURE__ */ jsx(NotificationsActionItem, {
        selected: true,
        selectedColor: "blue"
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Notifications"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Only circles with activity"
      }), /* @__PURE__ */ jsx(NotificationsList$1, {})]
    })]
  });
};
const NotificationsPageTest$1 = () => {
  return /* @__PURE__ */ jsx(Staging, {
    children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
      children: /* @__PURE__ */ jsx(ActivityContextProvider, {
        children: /* @__PURE__ */ jsx(NotificationsPageTestInner, {})
      })
    })
  });
};

const Wrapper$w = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
    & .MuiButtonBase-root {
        margin: 10px;
    }
`;
const PostsBasicActivityTest = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const lastVotingPolls = async () => {
    setResult(null);
    const result2 = await api.activityRequest({
      path: "/activities-posts/replay-posts/"
    });
    setResult(result2);
  };
  const clearUserVotingHistory = async () => {
    setResult(null);
    const result2 = await api.activityRequest({
      path: "/activities-posts/clear-user-posts/",
      method: "DELETE"
    });
    setResult(result2);
  };
  return /* @__PURE__ */ jsx(Wrapper$w, {
    children: /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Posts activity actions"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: lastVotingPolls,
          children: "Replay Posts"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: clearUserVotingHistory,
          children: "Clear User Posts History"
        })]
      })]
    })
  });
};

const Wrapper$v = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const PostsHistoryTestInner = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("633d83279c457b6481a87670");
  const {
    data
  } = useCirclePostsActivity(circleId);
  const handleCircleChange = (e) => {
    setCircleId(e.target.value);
  };
  const lastVotingPolls = async () => {
    setResult(null);
    const result2 = await api.activityRequest({
      path: "/activities-posts/replay-posts/"
    });
    setResult(result2);
  };
  const clearUserVotingHistory = async () => {
    setResult(null);
    const result2 = await api.activityRequest({
      path: "/activities-posts/clear-user-posts/",
      method: "DELETE"
    });
    setResult(result2);
  };
  return /* @__PURE__ */ jsxs(Wrapper$v, {
    children: [/* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Posts activities actions"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: lastVotingPolls,
          children: "Replay Posts"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: clearUserVotingHistory,
          children: "Clear User Posts History"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Posts in circles"
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        autoFocus: true,
        label: "Circle ID",
        placeholder: "Circle ID",
        value: circleId,
        onChange: handleCircleChange
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["Icon to show posts in circle #", circleId]
      }), /* @__PURE__ */ jsx(CirclePostsIcon, {
        circleId
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["Icons for posts in circle #", circleId]
      }), /* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx(CircleContext.Provider, {
          value: {
            showNotifications: true
          },
          children: data && Object.values(data.history.reduce((all, p) => {
            const rootPost = p.rootPost;
            const id = rootPost._id;
            all[id] = {
              id,
              rootPost
            };
            return all;
          }, {})).map(({
            id: postId,
            rootPost
          }, i) => {
            return /* @__PURE__ */ jsxs(Fragment, {
              children: [/* @__PURE__ */ jsx("span", {
                style: {
                  marginRight: 20
                },
                children: i !== 0 ? ";" : ""
              }), /* @__PURE__ */ jsx("span", {
                children: postId
              }), /* @__PURE__ */ jsx(CirclePostRepliesIcon, {
                circleId,
                postId
              }), " \xB7", /* @__PURE__ */ jsx(PostIcons, {
                post: rootPost
              })]
            });
          })
        })
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["Badges for posts in circle #", circleId]
      }), /* @__PURE__ */ jsx("div", {
        children: data && data.history.filter((p) => !p.post.thread.length).map(({
          post
        }) => {
          return /* @__PURE__ */ jsx("span", {
            style: {
              marginRight: 20
            },
            children: post.title
          });
        })
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["List of posts in circle #", circleId]
      }), /* @__PURE__ */ jsx(CardThemeProvider, {
        cardImage: true,
        children: data && data.history.map((d) => {
          return /* @__PURE__ */ jsx(PostActivityCard$1, {
            data: d
          }, d._id);
        })
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "My Circles"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "With notifications"
      }), /* @__PURE__ */ jsx(MyCirclesList, {})]
    })]
  });
};
const PostsHistoryTest = () => {
  return /* @__PURE__ */ jsx(Staging, {
    children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
      children: /* @__PURE__ */ jsx(ActivityContextProvider, {
        children: /* @__PURE__ */ jsx(PostsHistoryTestInner, {})
      })
    })
  });
};

const Wrapper$u = styled.div`
  && > * {
    margin: 10px;
  } 
`;
const Tools = ({
  setResult = () => null
}) => {
  const refreshResponses = usePostRefreshResponses();
  const api = useApi();
  const onDelete = async (postId2) => {
    await api.makeRequest({
      path: `/visits/posts/${postId2}/seen`,
      method: "DELETE"
    });
  };
  const onTouch = async (postId2) => {
    const data = await api.makeRequest({
      path: `/visits/posts/${postId2}/seen`,
      method: "POST",
      body: {
        modified: new Date()
      }
    });
    console.log("visit:", data);
  };
  const onUpdateHistory = async (postId2) => {
    const data = await api.activityRequest({
      path: `/activities-posts/update-post/${postId2}/`
    });
    setResult(data);
    console.log("visit:", data);
  };
  const onGetPostVisit = async (postId2) => {
    const data = await api.makeRequest({
      path: `/visits/posts/${postId2}`
    });
    console.log("get visit:", data);
    setResult(data);
  };
  const {
    updated,
    wasSeen
  } = usePostUpdatesContext();
  const {
    post: reply
  } = usePostContext();
  const postId = reply._id;
  const response = reply;
  const post = response;
  const update = updated[postId];
  const {
    isNew
  } = update;
  return /* @__PURE__ */ jsxs(ToolsWrapper, {
    children: [/* @__PURE__ */ jsx("span", {
      children: post.title
    }), /* @__PURE__ */ jsxs(ToolsFields, {
      children: [/* @__PURE__ */ jsx(Badge$2, {
        badgeContent: "new",
        invisible: !isNew,
        color: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        children: /* @__PURE__ */ jsx(TextField$1, {
          label: "Was seen",
          InputProps: {
            readOnly: true
          },
          variant: "outlined",
          value: isNew ? "NO" : "YES"
        })
      }), /* @__PURE__ */ jsx(TextField$1, {
        label: "Modified",
        InputProps: {
          readOnly: true
        },
        variant: "outlined",
        value: post.modified
      }), /* @__PURE__ */ jsx(TextField$1, {
        label: "Visited",
        InputProps: {
          readOnly: true
        },
        variant: "outlined",
        value: post.visited || "n/a"
      })]
    }), /* @__PURE__ */ jsxs(PlaygroundActions, {
      children: [/* @__PURE__ */ jsx(Button, {
        onClick: () => wasSeen(postId),
        variant: "contained",
        color: "primary",
        children: "Was seen"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => wasSeen(postId, true),
        variant: "contained",
        color: "primary",
        children: "Force was seen"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => onDelete(postId),
        variant: "contained",
        color: "primary",
        children: "Delete"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => onTouch(postId),
        variant: "contained",
        color: "primary",
        children: "Touch"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => onUpdateHistory(postId),
        variant: "contained",
        color: "primary",
        children: "Update History"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => onGetPostVisit(postId),
        variant: "contained",
        color: "primary",
        children: "Get Visit"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: refreshResponses,
        variant: "contained",
        color: "primary",
        children: "Refresh Responses"
      })]
    })]
  });
};
const ToolsFields = styled.div`
  display: flex;
  && > * {
    margin: 5px;
    padding: 0;
    width: 230px;
  }
`;
const ToolsWrapper = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  & > * {
    margin: 5px;
    padding: 0;
  }
`;
const Root$1 = () => {
  const data = useResponsesDataContext();
  return /* @__PURE__ */ jsx("div", {
    children: /* @__PURE__ */ jsx(ResponsesRoot, {
      ...data
    })
  });
};
const ResponseWithTools$1 = ({
  response,
  setResult
}) => {
  return /* @__PURE__ */ jsx(PostContextProvider, {
    post: response,
    children: /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsxs(ResponseHeader, {
        children: [/* @__PURE__ */ jsxs(NumberingAndAuthor, {
          children: [/* @__PURE__ */ jsx(Numbering, {}), /* @__PURE__ */ jsx(AuthorAndMeta, {
            author: response.author,
            created: response.created,
            readTime: response.readTime
          })]
        }), /* @__PURE__ */ jsx(ResponseTitle, {})]
      }), /* @__PURE__ */ jsx(Tools, {
        setResult
      })]
    })
  });
};
const UserVisitsTest = () => {
  const api = useApi();
  const [data, setData] = useState({});
  const {
    profile
  } = useProfileContext();
  const [result, setResult] = useState({});
  const [postId, setPostId] = useState("63408e9deee555a579ce769a");
  const helper = usePostViewDataHelper();
  const onProfile = async () => {
    const result2 = await api.loadProfile();
    console.log("onProfile", result2);
    setResult(result2);
  };
  const loadResponses = async () => {
    const post2 = await loadPost(api, postId);
    const data2 = await loadPostViewData(api, postId);
    setData({
      ...data2,
      profile,
      post: post2
    });
    helper.triggerUpdate();
  };
  const handlePostChange = (e) => {
    setPostId(e.target.value);
  };
  const {
    post,
    responsesRequestResult
  } = data;
  console.log("111111111111111111111", profile, post);
  return /* @__PURE__ */ jsxs(Wrapper$u, {
    children: [/* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Posts activities actions"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        autoFocus: true,
        label: "Post ID",
        placeholder: "Post ID",
        value: postId,
        onChange: handlePostChange
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          onClick: onProfile,
          variant: "contained",
          color: "primary",
          children: "Profile"
        }), /* @__PURE__ */ jsx(Button, {
          onClick: loadResponses,
          variant: "contained",
          color: "primary",
          children: "Load responses"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsxs(SectionHeader, {
        children: ["replys on post #", postId]
      }), /* @__PURE__ */ jsxs(PostViewDataContextCoreProvider, {
        helper,
        profile,
        post,
        responsesRequestResult,
        response: {
          response: (props) => /* @__PURE__ */ jsx(ResponseWithTools$1, {
            ...props,
            setResult
          })
        },
        postCircleError: null,
        postError: null,
        profileError: null,
        children: [/* @__PURE__ */ jsx(Root$1, {}), /* @__PURE__ */ jsx(Logging$1, {})]
      })]
    })]
  });
};
const Logging$1 = () => {
  console.log("logging!!!!!!!!!!!!!!");
  return null;
};

const LoadPostViewTest = ({
  children,
  defaultPostId = "63408e9deee555a579ce769a",
  response
}) => {
  const [postId, setPostId] = useState(defaultPostId);
  const handlePostChange = (e) => {
    setPostId(e.target.value);
  };
  return /* @__PURE__ */ jsxs(LoadPostViewData, {
    postId,
    response,
    children: [/* @__PURE__ */ jsx(PlaygroundTextField, {
      autoFocus: true,
      label: "Post ID",
      placeholder: "Post ID",
      value: postId,
      onChange: handlePostChange
    }), children]
  });
};

const Wrapper$t = styled.div`
  && > * {
    margin: 10px;
  } 
`;
const Root = () => {
  const data = useResponsesDataContext();
  return /* @__PURE__ */ jsx("div", {
    children: /* @__PURE__ */ jsx(ResponsesRoot, {
      ...data
    })
  });
};
const ResponseWithTools = ({
  response,
  setResult
}) => {
  return /* @__PURE__ */ jsx(PostContextProvider, {
    post: response,
    children: /* @__PURE__ */ jsx(ResponseOuterDiv, {
      children: /* @__PURE__ */ jsxs(PostWrapper, {
        post: response,
        children: [/* @__PURE__ */ jsxs(ResponseHeader, {
          children: [/* @__PURE__ */ jsxs(NumberingAndAuthor, {
            children: [/* @__PURE__ */ jsx(Numbering, {}), /* @__PURE__ */ jsx(AuthorAndMeta, {
              author: response.author,
              created: response.created,
              readTime: response.readTime
            })]
          }), response.title]
        }), getResponseUrl(response), /* @__PURE__ */ jsx(ResponseTagsPicker, {
          response
        })]
      })
    })
  });
};
const OpenReplyTest = () => {
  const [result, setResult] = useState({});
  return /* @__PURE__ */ jsx(Wrapper$t, {
    children: /* @__PURE__ */ jsxs(LoadPostViewTest, {
      defaultPostId: "63408e9deee555a579ce769a",
      response: {
        response: (props) => /* @__PURE__ */ jsx(ResponseWithTools, {
          ...props,
          setResult
        })
      },
      children: [/* @__PURE__ */ jsxs(Section, {
        children: [/* @__PURE__ */ jsx(SectionHeader, {
          children: "Posts activities actions"
        }), /* @__PURE__ */ jsx(Result, {
          children: result
        })]
      }), /* @__PURE__ */ jsxs(Section, {
        children: [/* @__PURE__ */ jsx(SectionHeader, {
          children: "replies on post"
        }), /* @__PURE__ */ jsx(ResponsesToolbar, {}), /* @__PURE__ */ jsx(OpenReply, {}), /* @__PURE__ */ jsx(Root, {}), /* @__PURE__ */ jsx(Logging, {})]
      })]
    })
  });
};
const OpenReply = () => {
  useOpenResponse();
  const {
    updated,
    openReply
  } = usePostUpdatesContext();
  return /* @__PURE__ */ jsx(PlaygroundActions, {
    children: Object.values(updated).map(({
      current: response
    }) => {
      const id = response._id;
      return /* @__PURE__ */ jsx(Button, {
        variant: "contained",
        color: "primary",
        onClick: () => openReply(id),
        children: response.title
      }, id);
    })
  });
};
const Logging = () => {
  console.log("logging!!!!!!!!!!!!!!");
  return null;
};

const Wrapper$s = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const ActivityPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/activity";
  if (pathname.startsWith(prefix + "/user-votes")) {
    return /* @__PURE__ */ jsx(RecentCircleVotesTest, {});
  }
  if (pathname.startsWith(prefix + "/user-posts")) {
    return /* @__PURE__ */ jsx(PostsHistoryTest, {});
  }
  if (pathname.startsWith(prefix + "/user-visits")) {
    return /* @__PURE__ */ jsx(UserVisitsTest, {});
  }
  if (pathname.startsWith(prefix + "/open-reply")) {
    return /* @__PURE__ */ jsx(OpenReplyTest, {});
  }
  if (pathname.startsWith(prefix + "/basic-posts-activity")) {
    return /* @__PURE__ */ jsx(PostsBasicActivityTest, {});
  }
  if (pathname.startsWith(prefix + "/basic-voting-activity")) {
    return /* @__PURE__ */ jsx(VotingBasicActivityTest, {});
  }
  if (pathname.startsWith(prefix + "/notifications-page")) {
    return /* @__PURE__ */ jsx(NotificationsPageTest$1, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$s, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/user-votes",
        children: "User votes"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/user-posts",
        children: "User posts"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/open-reply",
        children: "Open reply"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/user-visits",
        children: "User visits"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/basic-posts-activity",
        children: "Basic Posts Activity"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/basic-voting-activity",
        children: "Basic Voting Activity"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/notifications-page",
        children: "Notifications page"
      })
    })]
  });
};

const ImageComponentsTest = () => {
  return /* @__PURE__ */ jsx(CDNImageContextProviderStaging, {
    children: /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsxs(Section, {
        children: [/* @__PURE__ */ jsx(SectionHeader, {
          children: "Images"
        }), /* @__PURE__ */ jsx(SectionHeader2, {
          children: "Responsive"
        }), /* @__PURE__ */ jsx(ResponsiveImageProxy, {
          data: testImage2
        })]
      })
    })
  });
};

const Wrapper$r = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const CoreLibComponentsPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/core";
  if (pathname.startsWith(prefix + "/image")) {
    return /* @__PURE__ */ jsx(ImageComponentsTest, {});
  }
  return /* @__PURE__ */ jsx(Wrapper$r, {
    children: /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/image",
        children: "Images"
      })
    })
  });
};

const Wrapper$q = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;
    & .MuiButtonBase-root {
        margin: 10px;
    }
    & > div {
        width: 100%;
    }
`;
const InvitesTestInner = () => {
  useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("64370230a961a77ffb941cc2");
  const {
    data: profile
  } = useProfile();
  const handleCircleChange = (e) => {
    setCircleId(e.target.value);
  };
  return /* @__PURE__ */ jsxs(Wrapper$q, {
    children: [/* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Vote activities actions"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Invites in circles"
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        autoFocus: true,
        label: "Circle ID",
        placeholder: "Circle ID",
        value: circleId,
        onChange: handleCircleChange
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["Invites in circle #", circleId]
      }), /* @__PURE__ */ jsx(InvitesList, {
        circleId,
        profile
      })]
    })]
  });
};
const InvitesTest = () => {
  return /* @__PURE__ */ jsx(InvitesTestInner, {});
};

const Wrapper$p = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
let counter$3 = 0;
let lastCircle;
const CircleMenuTestInner = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("");
  const handleCircleIdChange = (e) => {
    setCircleId(e.target.value);
  };
  const createCircle = async () => {
    setResult(null);
    const circle = await api.upsertGroup({
      "privacy": "PUBLIC",
      "min_privacy": "PUBLIC",
      "name": "public " + counter$3++,
      "tags": ["s"]
    });
    lastCircle = circle;
    setResult(circle);
  };
  const deleteCircle = async () => {
    const circle = lastCircle || result;
    setResult(null);
    const rt = await deleteCircleApi$1(api, circle._id);
    setResult(rt);
  };
  const deleteCircleById = async () => {
    setResult(null);
    const rt = await deleteCircleApi$1(api, circleId);
    setResult(rt);
  };
  const makeAdmin = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "ADMIN"
      }
    });
    setResult(rt);
  };
  const makeUser = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "USER"
      }
    });
    setResult(rt);
  };
  const approve = async () => {
    setResult(null);
    const rt = await approveCircle(api, circleId);
    setResult(rt);
  };
  const sendDeleteEmail = async () => {
    circleId || lastCircle._id;
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/deleted-email/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  const sendDeleteEmailAll = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/deleted-email-all/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  const sendChangePrivacyEmail = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/change-privacy-email/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  const sendChangePrivacyEmailAll = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/group/change-privacy-email-all/${circleId}`,
      method: "GET"
    });
    setResult(rt);
  };
  return /* @__PURE__ */ jsx(LoadCircleData, {
    circleId,
    children: /* @__PURE__ */ jsx(CircleModalDialogsContextProvider, {
      children: /* @__PURE__ */ jsxs(Wrapper$p, {
        children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Circles Create"
          }), /* @__PURE__ */ jsx(Result, {
            children: result
          }), /* @__PURE__ */ jsxs(PlaygroundActions, {
            children: [/* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: createCircle,
              children: "Create Circle"
            }), /* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: deleteCircle,
              children: "Delete Circle"
            }), /* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: makeAdmin,
              children: "Make Instance Admin"
            }), /* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: makeUser,
              children: "Make Instance User"
            })]
          })]
        }), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Delete Circles"
          }), /* @__PURE__ */ jsx(PlaygroundTextField, {
            label: "circleId",
            placeholder: "circleId",
            value: circleId,
            onChange: handleCircleIdChange
          }), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Delete Menu Item"
          }), /* @__PURE__ */ jsx(ConfirmDeleteCircle, {}), /* @__PURE__ */ jsx(DeleteCircleMenuItem, {}), /* @__PURE__ */ jsx(SectionHeader2, {
            children: "Delete group API"
          }), /* @__PURE__ */ jsx(Result, {
            children: result
          }), /* @__PURE__ */ jsxs(PlaygroundActions, {
            children: [/* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: deleteCircleById,
              children: "Delete Circle By ID"
            }), /* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: sendDeleteEmail,
              children: "Send Delete Email"
            }), /* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: sendDeleteEmailAll,
              children: "Send Delete Email All"
            }), /* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: approve,
              children: "Approve"
            })]
          }), /* @__PURE__ */ jsxs(Section, {
            children: [/* @__PURE__ */ jsx(SectionHeader, {
              children: "Change Privacy Circles"
            }), /* @__PURE__ */ jsx(SectionHeader2, {
              children: "Change Privacy Menu Item"
            }), /* @__PURE__ */ jsx(ChangeCirclePrivacyDialog, {}), /* @__PURE__ */ jsx(ChangeCirclePrivacyMenuItem, {}), /* @__PURE__ */ jsx(SectionHeader2, {
              children: "Change privacy group API"
            }), /* @__PURE__ */ jsx(Result, {
              children: result
            }), /* @__PURE__ */ jsxs(PlaygroundActions, {
              children: [/* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: sendChangePrivacyEmail,
                children: "Send Change Privacy Email"
              }), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: sendChangePrivacyEmailAll,
                children: "Send Change Privacy Email All"
              })]
            })]
          })]
        })]
      })
    })
  });
};
const CircleMenuTest = () => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(CircleMenuTestInner, {})
  });
};

const Wrapper$o = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const CircleWelcomeTestInner$1 = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("63347f1c71697d10f868dea8");
  const {
    data: profile
  } = useProfile();
  const handleCircleIdChange = (e) => {
    setCircleId(e.target.value);
  };
  const makeAdmin = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "ADMIN"
      }
    });
    setResult(rt);
  };
  const makeUser = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "USER"
      }
    });
    setResult(rt);
  };
  return /* @__PURE__ */ jsx(HelpContextProvider, {
    profile,
    page: "main",
    children: /* @__PURE__ */ jsx(LoadCircleData, {
      circleId,
      children: /* @__PURE__ */ jsx(CircleModalDialogsContextProvider, {
        children: /* @__PURE__ */ jsxs(Wrapper$o, {
          children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsxs(Section, {
            children: [/* @__PURE__ */ jsx(SectionHeader, {
              children: "Circles Welcome Dialog"
            }), /* @__PURE__ */ jsx(PlaygroundTextField, {
              label: "circleId",
              placeholder: "circleId",
              value: circleId,
              onChange: handleCircleIdChange
            }), /* @__PURE__ */ jsx(Result, {
              children: result
            }), /* @__PURE__ */ jsxs(PlaygroundActions, {
              children: [/* @__PURE__ */ jsx(ConfigureCircleButton, {}), /* @__PURE__ */ jsx(WelcomeToCircleButton, {}), /* @__PURE__ */ jsx(GirlIcon, {}), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: makeAdmin,
                children: "Make Instance Admin"
              }), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: makeUser,
                children: "Make Instance User"
              })]
            })]
          }), /* @__PURE__ */ jsxs(Section, {
            children: [/* @__PURE__ */ jsx(SectionHeader, {
              children: "Welcome Dialogs"
            }), /* @__PURE__ */ jsxs(PlaygroundActions, {
              children: [/* @__PURE__ */ jsx(ConfigureHelpButton, {}), /* @__PURE__ */ jsx(WelcomeToPageButton, {})]
            })]
          })]
        })
      })
    })
  });
};
const CircleWelcomeTest = () => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(CircleWelcomeTestInner$1, {})
  });
};

const Wrapper$n = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const CircleStatsTestInner$1 = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("63347f1c71697d10f868dea8");
  const {
    data: profile
  } = useProfile();
  const handleCircleIdChange = (e) => {
    setCircleId(e.target.value);
  };
  const calculateMembership = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/groups/${circleId}/stats/group`,
      method: "POST",
      body: {}
    });
    setResult(rt);
  };
  const calculateMembershipAll = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/stats/all`,
      method: "POST",
      body: {}
    });
    setResult(rt);
  };
  const calculateMembershipAllNext = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/stats/all`,
      method: "POST",
      body: {
        keep: true
      }
    });
    setResult(rt);
  };
  const makeAdmin = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "ADMIN"
      }
    });
    setResult(rt);
  };
  const makeUser = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "USER"
      }
    });
    setResult(rt);
  };
  return /* @__PURE__ */ jsx(HelpContextProvider, {
    profile,
    page: "main",
    children: /* @__PURE__ */ jsx(LoadCircleData, {
      circleId,
      children: /* @__PURE__ */ jsx(CircleModalDialogsContextProvider, {
        children: /* @__PURE__ */ jsxs(Wrapper$n, {
          children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsxs(Section, {
            children: [/* @__PURE__ */ jsx(SectionHeader, {
              children: "Circles Statistics"
            }), /* @__PURE__ */ jsx(PlaygroundTextField, {
              label: "circleId",
              placeholder: "circleId",
              value: circleId,
              onChange: handleCircleIdChange
            }), /* @__PURE__ */ jsx(Result, {
              children: result
            }), /* @__PURE__ */ jsxs(PlaygroundActions, {
              children: [/* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: calculateMembership,
                children: "Recalculate Group Membership"
              }), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: calculateMembershipAll,
                children: "Recalculate Membership All"
              }), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: calculateMembershipAllNext,
                children: "Membership All Next"
              }), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: makeAdmin,
                children: "Make Instance Admin"
              }), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: makeUser,
                children: "Make Instance User"
              })]
            })]
          }), /* @__PURE__ */ jsx(Section, {
            children: /* @__PURE__ */ jsx(SectionHeader, {
              children: "Circles Statistics Panel"
            })
          })]
        })
      })
    })
  });
};
const CircleStatsTest = () => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(CircleStatsTestInner$1, {})
  });
};

const TRANSLATION_MODEL_OPTIONS = [{
  value: "Google",
  label: "Google",
  thinkingLevel: void 0
}, {
  value: "ali-qwen3.5-flash",
  label: "ali-qwen3.5-flash (thinking off)",
  thinkingLevel: "off"
}, {
  value: "maas-deepseek-v4-flash",
  label: "maas-deepseek-v4-flash (thinking off)",
  thinkingLevel: "off"
}, {
  value: "gemini-3.1-flash-lite",
  label: "gemini-3.1-flash-lite (minimal thinking)",
  thinkingLevel: "minimal"
}, {
  value: "gemini-3.6-flash",
  label: "gemini-3.6-flash (low thinking)",
  thinkingLevel: "low"
}, {
  value: "gpt-5.6-luna",
  label: "gpt-5.6-luna (low thinking)",
  thinkingLevel: "low"
}, {
  value: "gpt-5.6-terra",
  label: "gpt-5.6-terra (low thinking)",
  thinkingLevel: "low"
}];
const ConfigureTranslation = () => {
  const {
    circle: circle4post
  } = usePostInfoContext();
  const {
    circle: circle4desktop
  } = useCircleContext();
  const circle = circle4desktop || circle4post;
  if (!circle) {
    return null;
  }
  return /* @__PURE__ */ jsx(ConfigureTranslateInner, {
    circle
  });
};
const ConfigureTranslateInner = ({
  circle
}) => {
  const api = useApi();
  const [model, setModel] = useState(circle.translator_options ? circle.translator_options.modelName : "Google");
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    const selected = TRANSLATION_MODEL_OPTIONS.find((o) => o.value === model);
    await api.post({
      path: `/groups/${circle._id}/_partial`,
      body: {
        translator_options: {
          modelName: model,
          thinkingLevel: selected && selected.thinkingLevel
        }
      }
    });
    if (!isLocalhost()) {
      window.location.href = circleUrl(circle);
    }
  });
  const handlePostChange = (e) => {
    setModel(e.target.value);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 flex-col",
    children: [/* @__PURE__ */ jsxs(FormControl$1, {
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "algorithm-label",
        children: "Algorithm"
      }), /* @__PURE__ */ jsx(Select$1, {
        labelId: "algorithm-label",
        value: model || "Google",
        variant: "outlined",
        onChange: handlePostChange,
        children: TRANSLATION_MODEL_OPTIONS.map(({
          value,
          label
        }) => /* @__PURE__ */ jsx(MenuItem, {
          value,
          children: label
        }, value))
      })]
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSave,
      className: "w-52",
      loading: saveLoading,
      children: "Save Options"
    })]
  });
};
const ConfigureTranslationPage = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  if (!isInstanceAdmin) {
    return /* @__PURE__ */ jsx("div", {
      children: "Only instance admin can configure circle translation"
    });
  }
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[2] ? path[2] : circleIdDefault;
  return /* @__PURE__ */ jsxs(LoadCircleData, {
    circleId,
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx("div", {
      className: "p-2",
      children: /* @__PURE__ */ jsx(ConfigureTranslation, {})
    })]
  });
};

const CirclePageTest$1 = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[3] === "design" && path[4] ? path[4] : circleIdDefault;
  return /* @__PURE__ */ jsx(CirclePage, {
    circleId
  });
};
const CircleDesignTest = () => {
  return /* @__PURE__ */ jsx(LanguageSelectionContextProvider, {
    children: /* @__PURE__ */ jsxs(SearchContextProvider, {
      children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
        children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
          children: /* @__PURE__ */ jsx(ActivityContextProvider, {
            children: /* @__PURE__ */ jsxs("div", {
              className: "absolute inset-0 w-full",
              children: [/* @__PURE__ */ jsx(LoginTesterButton, {
                setResult: () => null
              }), /* @__PURE__ */ jsx(CirclePageTest$1, {})]
            })
          })
        })
      })]
    })
  });
};

const Wrapper$m = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const CircleStatsTestInner = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("64370230a961a77ffb941cc2");
  const handleCircleIdChange = (e) => {
    setCircleId(e.target.value);
  };
  const makeAdmin = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "ADMIN"
      }
    });
    setResult(rt);
  };
  const makeUser = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "USER"
      }
    });
    setResult(rt);
  };
  return /* @__PURE__ */ jsx(LoadCircleData, {
    circleId,
    children: /* @__PURE__ */ jsx(CircleModalDialogsContextProvider, {
      children: /* @__PURE__ */ jsxs(Wrapper$m, {
        children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsxs(Section, {
          children: [/* @__PURE__ */ jsx(SectionHeader, {
            children: "Circles Data"
          }), /* @__PURE__ */ jsx(PlaygroundTextField, {
            label: "circleId",
            placeholder: "circleId",
            value: circleId,
            onChange: handleCircleIdChange
          }), /* @__PURE__ */ jsx(Result, {
            children: result
          }), /* @__PURE__ */ jsxs(PlaygroundActions, {
            children: [/* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: makeAdmin,
              children: "Make Instance Admin"
            }), /* @__PURE__ */ jsx(Button, {
              variant: "contained",
              color: "primary",
              onClick: makeUser,
              children: "Make Instance User"
            })]
          })]
        }), /* @__PURE__ */ jsx(Section, {
          children: /* @__PURE__ */ jsx(SectionHeader, {
            children: "Circles Statistics Panel"
          })
        })]
      })
    })
  });
};
const CircleDataTest = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(CssLink, {
      href: "/static/core.css"
    }), /* @__PURE__ */ jsx(CircleStatsTestInner, {})]
  });
};

const Wrapper$l = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const CirclePostsTestInner = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("64370230a961a77ffb941cc2");
  const handleCircleIdChange = (e) => {
    setCircleId(e.target.value);
  };
  const makeAdmin = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "ADMIN"
      }
    });
    setResult(rt);
  };
  const makeUser = async () => {
    setResult(null);
    const rt = await api.makeRequest({
      path: `/playground/user/role`,
      method: "POST",
      body: {
        role: "USER"
      }
    });
    setResult(rt);
  };
  const onLoadPosts = async () => {
    const result2 = await loadCirclePosts(api, circleId);
    setResult(result2);
  };
  return /* @__PURE__ */ jsx(LoadCircleData, {
    circleId,
    children: /* @__PURE__ */ jsx(LoadCirclePosts, {
      circleId,
      children: /* @__PURE__ */ jsx(CircleModalDialogsContextProvider, {
        children: /* @__PURE__ */ jsxs(Wrapper$l, {
          children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsxs(Section, {
            children: [/* @__PURE__ */ jsx(SectionHeader, {
              children: "Circle Posts API"
            }), /* @__PURE__ */ jsx(PlaygroundTextField, {
              label: "circleId",
              placeholder: "circleId",
              value: circleId,
              onChange: handleCircleIdChange
            }), /* @__PURE__ */ jsx(Result, {
              children: result
            }), /* @__PURE__ */ jsxs(PlaygroundActions, {
              children: [/* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: onLoadPosts,
                children: "Load Posts"
              }), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: makeAdmin,
                children: "Make Instance Admin"
              }), /* @__PURE__ */ jsx(Button, {
                variant: "contained",
                color: "primary",
                onClick: makeUser,
                children: "Make Instance User"
              })]
            })]
          }), /* @__PURE__ */ jsxs(Section, {
            children: [/* @__PURE__ */ jsx(SectionHeader, {
              children: "Circle Header"
            }), /* @__PURE__ */ jsx(CircleTitle, {})]
          }), /* @__PURE__ */ jsxs(Section, {
            children: [/* @__PURE__ */ jsx(SectionHeader, {
              children: "Circle Posts"
            }), /* @__PURE__ */ jsx(CirclePosts$2, {})]
          })]
        })
      })
    })
  });
};
const CircleTitle = () => {
  const {
    circle
  } = useCircleContext();
  if (!circle) {
    return null;
  }
  const {
    name
  } = circle;
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("span", {
      children: "Circle Name:"
    }), "\xA0", /* @__PURE__ */ jsx("span", {
      children: /* @__PURE__ */ jsxs("b", {
        children: ["`", name, "`"]
      })
    })]
  });
};
const CirclePosts$2 = () => {
  const {
    posts
  } = useCirclePostsContext();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsxs("div", {
      children: ["total: ", posts.list.length]
    }), /* @__PURE__ */ jsx("div", {
      children: posts.list.map((post, i) => {
        const {
          _id,
          title
        } = post;
        return /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsxs("span", {
            children: [i, ". "]
          }), /* @__PURE__ */ jsx("span", {
            children: "title:\xA0"
          }), /* @__PURE__ */ jsx("span", {
            children: title
          })]
        }, _id);
      })
    })]
  });
};
const CirclePostsTest$1 = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(CssLink, {
      href: "/static/core.css"
    }), /* @__PURE__ */ jsx(CirclePostsTestInner, {})]
  });
};

const TestPageCssOverrides$3 = createGlobalStyle`
  #root, #root>* {
    min-width: 100%;
  }
`;
const DashboardPageTest = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$3, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
      children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
        children: /* @__PURE__ */ jsx(ActivityContextProvider, {
          children: /* @__PURE__ */ jsx(DashboardPage, {
            ignoreProfile: true
          })
        })
      })
    })]
  });
};

const MyCirclesNavigation = ({
  initial = {}
}) => {
  const {
    filter$,
    currentFilterRef
  } = useSearchContext();
  const [filter, setFilter] = useState(currentFilterRef.current || "");
  const {
    run: emitFilter
  } = useThrottleFn((filter2) => {
    filter$.emit({
      filter: filter2
    });
  }, {
    wait: 500
  });
  const handleChange = (e) => {
    const filter2 = e.target.value;
    emitFilter(filter2);
    setFilter(filter2);
  };
  const intl = useIntl();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-6 sm:justify-start items-center w-full p-4 bg-white shadow-lg px-[9px] py-[7px] relative ",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: "hidden sm:block",
      children: /* @__PURE__ */ jsx(HamburgerMenu, {})
    }), /* @__PURE__ */ jsxs("div", {
      className: "hidden sm:flex justify-end items-center gap-2.5 px-6 py-2 rounded-full border-2 border-black/30 w-full max-w-2xl",
      children: [/* @__PURE__ */ jsx("img", {
        src: Search,
        className: "hidden sm:block w-8 h-8 object-cover"
      }), /* @__PURE__ */ jsx("input", {
        value: filter,
        onChange: handleChange,
        placeholder: intl.formatMessage({
          id: "group.searchHere"
        }) + "...",
        type: "text",
        className: "outline-none w-full h-6 opacity-50 text-xl text-black  ltr:text-left rtl:text-right"
      })]
    }), /* @__PURE__ */ jsx("input", {
      value: filter,
      onChange: handleChange,
      placeholder: intl.formatMessage({
        id: "group.searchHere"
      }) + "...",
      type: "text",
      className: "rounded-full border-2 border-black/30 outline-none text-xl ltr:text-left rtl:text-right text-black sm:hidden bg-white z-10 inset-0 w-full px-1 focus:absolute focus:border-0 focus:px-4"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-end items-center relative gap-4  ltr:ml-auto rtl:mr-auto",
      children: [/* @__PURE__ */ jsx(Link$2, {
        to: "/notifications",
        children: /* @__PURE__ */ jsxs(StyledButton, {
          icon: FaRegBell,
          className: "group relative",
          children: [/* @__PURE__ */ jsx(NotificationsBadge, {}), /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.notifications"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(OpenHelpButton$1, {}), /* @__PURE__ */ jsx(ProfileIcon, {})]
    })]
  });
};
const OpenHelpButton$1 = () => {
  const {
    data: profile
  } = useProfile();
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(HelpContextProvider, {
      page: "groups",
      profile,
      children: /* @__PURE__ */ jsx(WelcomeToPageButton, {
        button: (props) => /* @__PURE__ */ jsx(StyledButton, {
          className: "group relative",
          icon: IoMdHelpCircleOutline,
          ...props,
          children: /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.help"
            })
          })
        })
      })
    })
  });
};

const MyCirclesBreadCrumbs = () => {
  const {
    CreateCircleComponent = () => null
  } = useAppComponents();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(Link$2, {
      to: "/",
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: "Dashboard"
      })
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-grow"
    }), /* @__PURE__ */ jsx(Link$2, {
      to: "/groups/discover",
      className: "mx-1 sm:mx-2",
      children: /* @__PURE__ */ jsx("div", {
        className: "text-primary font-semibold text-xs sm:text-xl p-1",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.discover"
        })
      })
    }), /* @__PURE__ */ jsx(CreateCircleComponent, {})]
  });
};

const groups_list = "_groups_list_6pagm_1";
const nothing_to_show = "_nothing_to_show_6pagm_12";
var styles$1 = {
	groups_list: groups_list,
	nothing_to_show: nothing_to_show
};

const LoadingPlaceholder = () => /* @__PURE__ */ jsx(PleaseWait, {
  i18nKey: "general.loading"
});
const ErrorPanel = ({
  error
}) => {
  const msg = error.message || error;
  switch (msg) {
    case "authentication_required":
      return /* @__PURE__ */ jsx(RequiresRegistration, {});
    case "access_denied":
      return /* @__PURE__ */ jsx(AccessDenied, {});
  }
  return /* @__PURE__ */ jsx(ErrorPlaceholder, {
    error: msg
  });
};
const NothingToShow = () => /* @__PURE__ */ jsx("div", {
  className: styles$1.groups_list,
  children: /* @__PURE__ */ jsx(Card, {
    className: styles$1.nothing_to_show,
    children: /* @__PURE__ */ jsxs("ul", {
      children: [/* @__PURE__ */ jsx("li", {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.discover_some_groups"
        })
      }), /* @__PURE__ */ jsxs("li", {
        children: [/* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.tap_add"
        }), /* @__PURE__ */ jsx(BiPlusCircle, {}), /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.create_your_own_groups"
        })]
      })]
    })
  })
});
const MyCirclesPage = (props) => {
  if (!props.waiting) {
    props = {
      ...props,
      waiting: /* @__PURE__ */ jsx(LoadingPlaceholder, {})
    };
  }
  if (!props.error) {
    props = {
      ...props,
      error: ErrorPanel
    };
  }
  if (!props.empty) {
    props = {
      ...props,
      empty: /* @__PURE__ */ jsx(NothingToShow, {})
    };
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "ns sm:px-[54px] overflow-x-hidden text-base/3 w-full",
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex w-full flex-col gap-2 p-2",
      children: [/* @__PURE__ */ jsx(MyCirclesNavigation, {}), /* @__PURE__ */ jsx(MyCirclesBreadCrumbs, {})]
    }), /* @__PURE__ */ jsx(MyCirclesList, {
      ...props
    })]
  });
};

const TestPageCssOverrides$2 = createGlobalStyle`
  #root, #root>* {
    min-width: 100%;
  }
`;
const MyCirclesPageTest = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$2, {}), /* @__PURE__ */ jsx(MyCirclesPage, {})]
  });
};

const DiscoverBreadCrumbs = () => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(Link$2, {
      to: "/",
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: "Dashboard"
      })
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: "/groups/discover",
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.discover"
        })
      })
    })]
  });
};

const DiscoverTabs = () => {
  const {
    active,
    setActive
  } = useDiscoverPageContext();
  const tabs = useCreation(() => {
    return [
      {
        title: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.discover.suggestions"
        }),
        name: "suggestions"
      },
      {
        title: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "group.discover.invitations"
        }),
        name: "invitations"
      }
    ];
  }, []);
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx("div", {
      className: "flex max-w-full overflow-x-scroll gap-2 sm:gap-4 w-full pr-6 items-center justify-start border-b-2 border-gray-300 scrollbar-hide pt-2",
      children: tabs.map((tab, index) => {
        return /* @__PURE__ */ jsx(TabItem, {
          title: tab.title,
          icon: tab.icon,
          iconComponent: tab.iconComponent,
          active: active === tab.name,
          onClick: () => {
            setActive(tab.name);
          }
        }, index);
      })
    })
  });
};

const noop$8 = () => null;
const DiscoverPageContext = React__default.createContext({
  active: "suggestions",
  setActive: noop$8
});
const useDiscoverPageContext = () => {
  return useContext(DiscoverPageContext);
};
const DiscoverPageContextProvider = ({
  children
}) => {
  const [active, setActive] = useState("suggestions");
  const context = useMemo(() => {
    return {
      active,
      setActive
    };
  }, [active]);
  return /* @__PURE__ */ jsx(DiscoverPageContext.Provider, {
    value: context,
    children
  });
};
const Suggestion = ({
  value
}) => /* @__PURE__ */ jsx(CircleCard$1, {
  showImage: true,
  sw: false,
  link: true,
  closer: true,
  data: value
});
const SuggestSection = ({
  suggestions
}) => {
  const {
    active
  } = useDiscoverPageContext();
  if (active !== "suggestions") {
    return null;
  }
  if (!suggestions || !suggestions.length) {
    return /* @__PURE__ */ jsx(PleaseWait, {
      i18nKey: "group.discover.nothing_to_see"
    }, "nothing");
  }
  return /* @__PURE__ */ jsx("section", {
    "data-testid": "suggestions",
    className: "overflow-hidden mb-40",
    children: suggestions.map((suggestion) => /* @__PURE__ */ jsx(Suggestion, {
      value: suggestion
    }, suggestion._id))
  });
};
const InvitationsSection = ({
  invitations,
  invitationList: List = (props) => /* @__PURE__ */ jsx("div", {
    children: "Invitations List"
  })
}) => {
  const {
    active
  } = useDiscoverPageContext();
  if (active !== "invitations") {
    return null;
  }
  if (!invitations || !invitations.length) {
    return /* @__PURE__ */ jsx(PleaseWait, {
      i18nKey: "group.discover.nothing_to_see"
    }, "nothing");
  }
  return /* @__PURE__ */ jsx(List, {
    invitations
  });
};
const DiscoverPage = ({
  invitationList
}) => {
  const {
    data
  } = useDiscover();
  const {
    data: profile,
    isValidating
  } = useProfile();
  const isNotLoggedIn = !profile && !isValidating;
  return /* @__PURE__ */ jsx(DiscoverPageContextProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "ns sm:px-[54px] overflow-hidden text-base/3 w-full",
      children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full flex-col gap-2 p-2",
        children: [/* @__PURE__ */ jsx(MyCirclesNavigation, {}), /* @__PURE__ */ jsx(DiscoverBreadCrumbs, {})]
      }), /* @__PURE__ */ jsx(DiscoverTabs, {}), !isNotLoggedIn && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(SuggestSection, {
          suggestions: data && data.suggestions
        }), /* @__PURE__ */ jsx(InvitationsSection, {
          invitations: data && data.invitations,
          invitationList
        })]
      }), isNotLoggedIn && /* @__PURE__ */ jsx(RequiresRegistration, {})]
    })
  });
};

const TestPageCssOverrides$1 = createGlobalStyle`
  #root, #root>* {
    min-width: 100%;
  }
`;
const DiscoverPageTest = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$1, {}), /* @__PURE__ */ jsx(DiscoverPage, {})]
  });
};

const TestPageCssOverrides = createGlobalStyle`
  #root, #root>* {
    min-width: 100%;
  }
`;
const TestPanel$3 = () => {
  const settings = useUserPage("notify");
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2 p-2",
    children: [/* @__PURE__ */ jsx("h1", {
      children: "==========================Notify test panel================================"
    }), /* @__PURE__ */ jsx(Result, {
      children: settings
    }), /* @__PURE__ */ jsx("h1", {
      children: "==========================Notify test panel================================"
    })]
  });
};
const NotificationsPageTest = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
      children: /* @__PURE__ */ jsxs(SearchContextProvider, {
        children: [/* @__PURE__ */ jsx(TestPageCssOverrides, {}), /* @__PURE__ */ jsx(NotificationsPage, {
          children: /* @__PURE__ */ jsx(TestPanel$3, {})
        })]
      })
    })
  });
};

const useTimePanelState = () => {
  const [date1, setDate1] = useState(() => {
    const next = new Date();
    next.setHours(0, 0, 0, 0);
    return next;
  });
  const [date2, setDate2] = useState(() => {
    const next = new Date();
    next.setHours(0, 0, 0, 0);
    return next;
  });
  const [time1, setTime1] = useState(0);
  const [time2, setTime2] = useState(0);
  const [timezone, setTimezone] = useState("");
  const [tzOffset, setTzOffset] = useState(0);
  return {
    date1,
    setDate1,
    date2,
    setDate2,
    time1,
    setTime1,
    time2,
    setTime2,
    timezone,
    setTimezone,
    tzOffset,
    setTzOffset
  };
};

const TimePanel = ({
  state,
  noValidation
}) => {
  const intl = useIntl();
  const {
    date1,
    setDate1,
    time1,
    setTime1,
    date2,
    setDate2,
    time2,
    setTime2,
    timezone,
    setTimezone,
    tzOffset,
    setTzOffset
  } = state;
  const isTimeError = noValidation ? false : date1.getTime() === date2.getTime() && time2 <= time1;
  return /* @__PURE__ */ jsxs(MuiPickersUtilsProvider, {
    locale: getBrowserLanguage(),
    utils: MomentUtils,
    children: [/* @__PURE__ */ jsxs(FormControl$1, {
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "timezone-label",
        disableAnimation: true,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "compose.event.timezone"
        })
      }), /* @__PURE__ */ jsx(SelectTimezone, {
        timezone,
        tzOffset,
        onChangeTimezone: setTimezone,
        labelId: "timezone-label",
        id: "timezone-select",
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "compose.event.timezone"
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 flex-wrap",
      children: [/* @__PURE__ */ jsx(FormDatePicker, {
        date: date1,
        onChangeDate: setDate1
      }), /* @__PURE__ */ jsx(FormDatePicker, {
        date: date2,
        onChangeDate: setDate2,
        label: intl.formatMessage({
          id: "compose.new.end_date"
        }),
        minDate: date1
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 flex-wrap",
      children: [/* @__PURE__ */ jsx(TimeFormSelectorStateless, {
        time: time1,
        onChangeTime: setTime1
      }), /* @__PURE__ */ jsx(TimeFormSelectorStateless, {
        time: time2,
        onChangeTime: setTime2,
        label: intl.formatMessage({
          id: "compose.new.end_time"
        }),
        isTimeError
      })]
    })]
  });
};

let translateText;
const isWithinDoNotTranslate = (node) => {
  while (node) {
    if (node instanceof Element && node.classList.contains("do-not-translate")) {
      return true;
    }
    node = node.parentElement;
  }
  return false;
};
const getTextNodes = (node) => {
  const textNodes = [];
  const traverse = (node2) => {
    if (node2.nodeType === Node.TEXT_NODE) {
      const tn = node2;
      if (tn.textContent && tn.textContent.trim && tn.textContent.trim()) {
        textNodes.push(node2);
      }
    } else {
      node2.childNodes.forEach((child) => traverse(child));
    }
  };
  traverse(node);
  return textNodes;
};
const translateTextNode = async (textNode) => {
  try {
    const translatedText = await translateText(textNode.textContent || "");
    textNode.textContent = translatedText;
  } catch (error) {
    console.error("Translation error:", error);
  }
};
const translateInitialTextNodes = async (el) => {
  const textNodes = getTextNodes(el || document.body);
  for (const textNode of textNodes) {
    if (!isWithinDoNotTranslate(textNode)) {
      translateTextNode(textNode);
    }
  }
};
const pages = {};
const getTranslationState = (page, language) => {
  const key = `${page}:${language}`;
  if (!pages[key]) {
    pages[key] = {
      translated: {}
    };
  }
  return pages[key];
};
const useUITranslation = (page, language) => {
  const state = getTranslationState(page, language);
  const translateAll = useMemoizedFn(() => {
    Object.entries(state.translated).filter(([text, translation]) => {
      if (translation.v) {
        return;
      }
    });
  });
  const { run: translate } = useThrottleFn(translateAll, {
    wait: 100,
    leading: false
  });
  translateText = async (text) => {
    if (!text) {
      return "";
    }
    if (!state.translated[text]) {
      state.translated[text] = { t: Date.now(), f: [] };
    }
    const translated = state.translated[text];
    if (translated.v) {
      return translated.v;
    }
    const rt = new Promise((resolve2) => {
      translated.f.push(resolve2);
    });
    translate();
    return rt;
  };
  const translatePage = () => {
    translateInitialTextNodes();
  };
  return {
    state,
    translatePage
  };
};

const PostViewPageTest = () => {
  const postIdDefault = isLocalhost() ? "645a79ab864598fbc2ef70e5" : "6460ae96956bfa5e9bc058cf";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const postId = path[3] === "post-view" && path[4] ? path[4] : postIdDefault;
  return /* @__PURE__ */ jsx(LanguageSelectionContextProvider, {
    children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
      children: /* @__PURE__ */ jsx(SearchContextProvider, {
        children: /* @__PURE__ */ jsxs(ActivityContextProvider, {
          children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
            children: /* @__PURE__ */ jsx(PostViewPage, {
              postId,
              children: /* @__PURE__ */ jsx(TestAll, {})
            })
          })]
        })
      })
    })
  });
};
const TranslateTest = () => {
  const [html, setHtml] = useState();
  const [language, setLanguage] = useState("ru");
  const {
    state,
    translatePage
  } = useUITranslation("post", language);
  const update = useUpdate();
  const api = useApi();
  const {
    post
  } = usePostInfoContext();
  const {
    onClick: onTranslate,
    loading: loadingTranslate
  } = useLoading(async () => {
    const {
      html: html2
    } = await api.post({
      path: `/post-view/${post._id}/translate`,
      body: {
        language
      }
    });
    setHtml(html2);
  });
  const {
    onClick: onTranslateClear,
    loading: loadingClear
  } = useLoading(async () => {
    const {
      html: html2
    } = await api.post({
      path: `/post-view/${post._id}/translate-clear`,
      body: {}
    });
    setHtml(html2);
  });
  const {
    onClick: onTranslateUi,
    loading: loadingTranslateUi
  } = useLoading(async () => {
    translatePage();
    update();
  });
  const handlePostChange = (e) => {
    setLanguage(e.target.value);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 flex-col do-not-translate",
    children: [/* @__PURE__ */ jsx(PlaygroundTextField, {
      autoFocus: true,
      label: "2 char language (en, ar, etc)",
      placeholder: "Language",
      value: language,
      onChange: handlePostChange
    }), /* @__PURE__ */ jsx(ConfigureTranslation, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2",
      children: [/* @__PURE__ */ jsx(LoadingButton, {
        onClick: onTranslateUi,
        loading: loadingTranslateUi,
        className: "w-32",
        children: "Translate UI"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onTranslate,
        loading: loadingTranslate,
        className: "w-32",
        children: "Translate"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onTranslateClear,
        loading: loadingClear,
        variant: "contained",
        className: "w-52",
        children: "Translate clear"
      })]
    }), /* @__PURE__ */ jsx(LanguageSelectionMenu, {}), /* @__PURE__ */ jsx("div", {
      dangerouslySetInnerHTML: {
        __html: html
      }
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-1",
      children: Object.entries(state.translated).map(([text, translation]) => {
        return /* @__PURE__ */ jsxs("div", {
          className: "flex gap-2",
          children: [/* @__PURE__ */ jsx("div", {
            children: text
          }), /* @__PURE__ */ jsx("div", {
            children: translation.v || ""
          })]
        }, text);
      })
    })]
  });
};
const TestAll = () => {
  const {
    circle,
    post
  } = usePostInfoContext();
  circle && circle._id;
  post && post._id;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsx("h1", {
      children: "=Test Post View Panel="
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/* @__PURE__ */ jsx("div", {
        children: "language:"
      }), /* @__PURE__ */ jsx("div", {
        children: post && post.language || ""
      }), /* @__PURE__ */ jsx("div", {
        children: "pages:"
      }), /* @__PURE__ */ jsx("div", {
        children: post && post.pages && post.pages.join(";") || ""
      }), /* @__PURE__ */ jsx("div", {
        children: "features:"
      }), /* @__PURE__ */ jsx("div", {
        children: post && post.features || ""
      })]
    }), /* @__PURE__ */ jsx(TranslateTest, {}), /* @__PURE__ */ jsx("h1", {
      children: "=Test Post View Panel="
    })]
  });
};

const LoginPageTest = () => {
  return /* @__PURE__ */ jsxs("div", {
    className: "ns sm:px-[54px] overflow-hidden text-base w-full pb-4 min-h-screen",
    "data-testid": "LoginPage",
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(TestPanel$2, {})]
  });
};
const TestPanel$2 = () => {
  const onSuccess = useOnLoginSuccess();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("h1", {
      children: "============================Test panel================================"
    }), /* @__PURE__ */ jsx(Result, {
      label: "getLoginUrl",
      children: getLoginUrl()
    }), /* @__PURE__ */ jsx(LoginTextField, {
      type: "password",
      label: "login.password"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: () => onSuccess(),
      children: "After Login"
    }), /* @__PURE__ */ jsx("h1", {
      children: "============================Test panel end================================"
    })]
  });
};

const landing_page = "_landing_page_1sbco_1";
const links = "_links_1sbco_7";
const login_header = "_login_header_1sbco_11";
const content = "_content_1sbco_19";
const button = "_button_1sbco_49";
const strap_line = "_strap_line_1sbco_54";
const register_or_login = "_register_or_login_1sbco_61";
const login = "_login_1sbco_11";
const root = "_root_1sbco_75";
const guest = "_guest_1sbco_75";
const desktop_large_logo = "_desktop_large_logo_1sbco_112";
const mobile_large_logo = "_mobile_large_logo_1sbco_116";
var styles = {
	landing_page: landing_page,
	links: links,
	login_header: login_header,
	content: content,
	button: button,
	strap_line: strap_line,
	register_or_login: register_or_login,
	login: login,
	root: root,
	guest: guest,
	desktop_large_logo: desktop_large_logo,
	mobile_large_logo: mobile_large_logo
};

const usePrivacyPolicy = () => {
  const [showing_privacy_policy, set_showing_privacy_policy] = useState(false);
  const [showing_terms_and_conditions, set_showing_terms_and_conditions] = useState(false);
  const togglePrivacyPolicy = (e) => {
    set_showing_privacy_policy((v) => !v);
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  const toggleTermsAndConditions = (e) => {
    set_showing_terms_and_conditions((v) => !v);
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  return {
    togglePrivacyPolicy,
    toggleTermsAndConditions,
    showing_privacy_policy,
    showing_terms_and_conditions
  };
};

const WelcomePage = () => {
  const {
    data: configData,
    error,
    loading
  } = usePageHTML("welcome");
  const html = configData && configData.html || "";
  const {
    buttonsBlock,
    ref
  } = useLoginButtons();
  if (!html) {
    if (loading) {
      return null;
    }
    return /* @__PURE__ */ jsx(WelcomePageDefault, {});
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "ns px-[5px] sm:px-[54px] text-base w-full pb-4 min-h-screen configuration-page",
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(WelcomeHtml, {
      html,
      ref
    }), buttonsBlock]
  });
};
const WelcomePageDefault = () => {
  const {
    togglePrivacyPolicy,
    toggleTermsAndConditions,
    showing_privacy_policy,
    showing_terms_and_conditions
  } = usePrivacyPolicy();
  const {
    instance
  } = useProfileContext();
  const largeLogo = instance && instance.largeLogo;
  return /* @__PURE__ */ jsxs("div", {
    className: styles.landing_page,
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles.content,
      children: [/* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsxs("header", {
          children: [/* @__PURE__ */ jsx("h1", {
            children: instance && instance.strapLine ? instance.strapLine : /* @__PURE__ */ jsx(FormattedMessage, {
              id: "landing.line_1"
            })
          }), largeLogo ? /* @__PURE__ */ jsx("div", {
            className: styles.mobile_large_logo,
            children: /* @__PURE__ */ jsx(ScaledImageProxy, {
              instanceNameOverride: instance.instanceName,
              uuid: instance.largeLogo.uuid,
              w: 240,
              h: 240
            })
          }) : null, /* @__PURE__ */ jsx("h3", {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "landing.line_2"
            })
          })]
        }), /* @__PURE__ */ jsx(SignUpOrLoginPanel, {})]
      }), largeLogo ? /* @__PURE__ */ jsx("div", {
        className: styles.desktop_large_logo,
        children: /* @__PURE__ */ jsx(ResponsiveImageProxy, {
          instanceNameOverride: instance.instanceName,
          data: instance.largeLogo,
          sizes: {
            "(min-width: 2200px)": {
              width: 1440,
              height: 1440
            },
            "(min-width: 1920px)": {
              width: 1280,
              height: 1280
            },
            "(min-width: 1440px)": {
              width: 1024,
              height: 1024
            },
            "(min-width: 1280px)": {
              width: 768,
              height: 768
            },
            "(min-width: 1024px)": {
              width: 640,
              height: 640
            },
            "(min-width: 768px)": {
              width: 512,
              height: 512
            },
            "(min-width: 640px)": {
              width: 320,
              height: 320
            },
            "(max-width: 512px)": {
              width: 240,
              height: 240
            }
          }
        })
      }) : null]
    }), /* @__PURE__ */ jsx("footer", {
      children: /* @__PURE__ */ jsxs("ul", {
        children: [/* @__PURE__ */ jsx("li", {
          children: /* @__PURE__ */ jsx(PCLink, {
            onClick: togglePrivacyPolicy,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "registration.privacy_policy"
            })
          })
        }), /* @__PURE__ */ jsx("li", {
          children: /* @__PURE__ */ jsx(PCLink, {
            onClick: toggleTermsAndConditions,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "registration.terms"
            })
          })
        }), /* @__PURE__ */ jsx(PlaygroundLink, {})]
      })
    }), showing_privacy_policy && /* @__PURE__ */ jsx(PrivacyPolicyDialog, {
      onClose: togglePrivacyPolicy
    }), showing_terms_and_conditions && /* @__PURE__ */ jsx(TermsAndConditionsDialog, {
      onClose: toggleTermsAndConditions
    })]
  });
};
const PCLink = (props) => {
  return /* @__PURE__ */ jsx("span", {
    ...props,
    className: styles.links
  });
};

const WelcomePageOuter = ({
  page
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "ns sm:px-[54px] overflow-hidden text-base w-full pb-4 min-h-screen configuration-page",
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(WelcomePage, {})]
  });
};
const WelcomePageTest = () => {
  return /* @__PURE__ */ jsxs(SWRProfileContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(WelcomePageOuter, {})]
  });
};

const EditEventPageTest = () => {
  const draftIdDefault = isLocalhost() ? "64c9274e4284f2fc7c6f6672" : "64c950ed6325ac7544448da0";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  path[3] === "edit" && path[4] ? path[4] : draftIdDefault;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(LoginTesterButton, {
      setResult: () => null
    }), /* @__PURE__ */ jsx(EventTestPanel, {})]
  });
};
const EventTestPanel = () => {
  const {
    draft
  } = useEditAssetContext();
  const onClose = (asset) => {
    console.log("Asset editor dialog was close!!!!!!!!!!!!!", asset);
  };
  const {
    editAsset,
    editDialog
  } = useAssetEditor(onClose);
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2",
    children: [editDialog, /* @__PURE__ */ jsx("h1", {
      children: "==========================Event test panel================================"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: () => editAsset(draft, true),
      children: "Open"
    }), /* @__PURE__ */ jsx("h1", {
      children: "==========================Event test panel================================"
    })]
  });
};

const PaginationTestInner = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[3] === "pagination" && path[4] ? path[4] : circleIdDefault;
  return /* @__PURE__ */ jsx(CirclePageProviders, {
    circleId,
    children: /* @__PURE__ */ jsx(CirclePostsPanelTest, {
      circleId
    })
  });
};
const list = [];
const useCirclePostsState$1 = (circleId) => {
  const update = useUpdate();
  const [position, setPosition] = useState({
    overscanStartIndex: 0,
    overscanStopIndex: 0,
    startIndex: 0,
    stopIndex: 0
  });
  const {
    circle
  } = useCircleContext();
  const api = useApi();
  useCreation(() => {
    list.length = 0;
  }, []);
  const updateCache = (data, {
    startIndex,
    stopIndex
  }) => {
    const {
      content,
      order
    } = data;
    for (let i = startIndex; i <= stopIndex; i++) {
      list[i] = content[order[i - startIndex]];
    }
  };
  const loadMore = async ({
    startIndex,
    stopIndex
  }) => {
    const data = await loadCirclePosts(api, circleId, "", {
      range: {
        start: startIndex + 1,
        end: stopIndex + 1
      }
    });
    return data;
  };
  const {
    run: loadMoreRows
  } = useRequest(async (v) => {
    const data = await loadMore(v);
    updateCache(data, v);
    update();
  }, {
    manual: true,
    retryCount: -1
  });
  const remoteRowCount = circle && circle.stats.postCount || 100;
  const {
    activities$
  } = useActivityContext();
  const {
    run
  } = useThrottleFn(async () => {
    const {
      startIndex,
      stopIndex
    } = position;
    const data = await loadMore({
      startIndex,
      stopIndex
    });
    list.length = 0;
    updateCache(data, {
      startIndex,
      stopIndex
    });
    update();
  }, {
    wait: 5e3
  });
  activities$.useSubscription(({
    type
  }) => {
    if (type !== "post") {
      return;
    }
    console.log("22222222222222222222222222222222222222222222222222222-activities$");
    run();
  });
  const isRowLoaded = ({
    index
  }) => {
    return !!list[index];
  };
  const rowRenderer = ({
    key,
    index,
    style
  }) => {
    console.log("111111111111111111111111111111111-rowRenderer", index);
    const post = list[index];
    if (!post) {
      return /* @__PURE__ */ jsx("div", {
        style: {
          height: POST_CARD_HEIGHT,
          maxHeight: POST_CARD_HEIGHT,
          ...style
        },
        children: "Wait..."
      }, key);
    }
    return /* @__PURE__ */ jsx(PostCard, {
      post,
      style: {
        height: POST_CARD_HEIGHT,
        maxHeight: POST_CARD_HEIGHT,
        ...style
      }
    }, key);
  };
  return {
    update,
    rowRenderer,
    circle,
    position,
    remoteRowCount,
    setPosition,
    isRowLoaded,
    loadMoreRows
  };
};
const CirclePostsCore = ({
  circleId,
  state,
  children
}) => {
  const {
    update,
    rowRenderer,
    circle,
    position,
    remoteRowCount,
    setPosition,
    isRowLoaded,
    loadMoreRows
  } = state;
  return /* @__PURE__ */ jsxs("div", {
    className: "grow flex flex-col p-2 paginatedCircleList",
    style: {
      minHeight: POST_CARD_HEIGHT * 5
    },
    children: [children, /* @__PURE__ */ jsx("div", {
      className: "grow",
      children: /* @__PURE__ */ jsx(AutoSizer, {
        children: ({
          height,
          width
        }) => /* @__PURE__ */ jsx(InfiniteLoader, {
          isRowLoaded,
          loadMoreRows,
          rowCount: remoteRowCount,
          children: ({
            onRowsRendered,
            registerChild
          }) => /* @__PURE__ */ jsx(List$1, {
            height,
            onRowsRendered: (v) => {
              onRowsRendered(v);
              setPosition(v);
            },
            ref: registerChild,
            rowCount: remoteRowCount,
            rowHeight: POST_CARD_HEIGHT,
            rowRenderer,
            width
          })
        })
      })
    })]
  });
};
const CirclePostsPanelTest = ({
  circleId
}) => {
  const state = useCirclePostsState$1(circleId);
  const {
    update,
    circle,
    position
  } = state;
  const {
    activities$
  } = useActivityContext();
  const onUpdate = () => {
    update();
  };
  const onRefresh = () => {
    activities$.emit({
      type: "post"
    });
  };
  const onClearRefresh = async () => {
    list.length = 0;
    update();
    await delay$1();
    activities$.emit({
      type: "post"
    });
  };
  return /* @__PURE__ */ jsxs(CirclePostsCore, {
    circleId,
    state,
    children: [/* @__PURE__ */ jsx(Result, {
      children: circle && circle.stats
    }), /* @__PURE__ */ jsx(Result, {
      label: "list position",
      children: position
    }), /* @__PURE__ */ jsxs("div", {
      className: "w-full flex gap-2",
      children: [/* @__PURE__ */ jsx(Button, {
        onClick: onUpdate,
        variant: "outlined",
        children: "Update"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: onRefresh,
        variant: "outlined",
        children: "Refresh"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: onClearRefresh,
        variant: "outlined",
        children: "Clear Refresh"
      })]
    })]
  });
};
const PaginationTest = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
      children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
        children: /* @__PURE__ */ jsx(ActivityContextProvider, {
          children: /* @__PURE__ */ jsxs("div", {
            className: "absolute h-full w-full flex flex-col",
            children: [/* @__PURE__ */ jsx(LoginTesterButton, {
              setResult: () => null
            }), /* @__PURE__ */ jsx(PaginationTestInner, {})]
          })
        })
      })
    })]
  });
};

const PaginationTestInner1 = () => {
  return /* @__PURE__ */ jsx(CirclePostsTestPanel1, {});
};
const useRemoteData = () => {
  const [remotePosts, setRemotePosts] = useState([]);
  return {
    remoteRowCount: remotePosts.length,
    remotePosts,
    setRemotePosts
  };
};
const useLocalData = () => {
  const [position, setPosition] = useState({
    overscanStartIndex: 0,
    overscanStopIndex: 0,
    startIndex: 0,
    stopIndex: 0
  });
  const [postsById, setPostsById] = useState({});
  const [remoteRowCount, setRemoteRowCount] = useState(0);
  const [list, setList] = useState([]);
  const getUpdateRequest = useMemoizedFn((start, end) => {
    const request = {
      start,
      end
    };
    if (list.length && list[0]._id) {
      request.fromId = list[0]._id;
      request.fromModified = list[0].modified;
    }
    return request;
  });
  return {
    remoteRowCount,
    setRemoteRowCount,
    list,
    setList,
    postsById,
    setPostsById,
    position,
    setPosition,
    getUpdateRequest
  };
};
const addRemote = (remote, num = 10) => {
  const {
    remoteRowCount,
    remotePosts,
    setRemotePosts
  } = remote;
  const posts = [...remotePosts];
  for (let i = 0; i < num; i++) {
    const _id = remoteRowCount + i;
    posts.unshift({
      _id,
      title: "post #" + _id,
      modified: new Date().toISOString()
    });
  }
  setRemotePosts(posts);
};
const fetchRemoteTestFn = (remote) => async ({
  start,
  end,
  fromModified,
  fromId
}) => {
  const {
    remoteRowCount,
    remotePosts
  } = remote;
  const posts = [];
  const updated = [];
  let i = 0;
  if (fromModified) {
    for (; i < remotePosts.length; i++) {
      const post = remotePosts[i];
      if (post.modified > fromModified) {
        updated.push(post);
        continue;
      }
      if (post.modified === fromModified && post._id > fromId) {
        updated.push(post);
        continue;
      }
      break;
    }
  }
  i += start;
  for (; i < remotePosts.length; i++) {
    const post = remotePosts[i];
    posts.push(post);
    if (posts.length > end - start) {
      break;
    }
  }
  return {
    startIndex: start,
    stopIndex: end,
    count: remoteRowCount,
    posts,
    updated
  };
};
const onUpdateFn = (local, result) => {
  const {
    count,
    posts,
    startIndex,
    updated
  } = result;
  const {
    list,
    setList,
    setRemoteRowCount,
    setPostsById
  } = local;
  const updatedById = {};
  updated.forEach((u) => {
    updatedById[u._id] = u;
  });
  const notTooMany = updated.length <= 10;
  const updatedList = notTooMany ? list.filter((p) => !updatedById[p._id]) : [];
  if (!notTooMany) {
    updated.reverse().forEach((u) => {
      updatedList.unshift(u);
    });
  }
  for (let i = 0; i < posts.length; i++) {
    const post = posts[i];
    updatedList[i + startIndex] = post;
  }
  if (notTooMany) {
    updated.reverse().forEach((u) => {
      updatedList.unshift(u);
    });
  }
  const postsById = {};
  updatedList.forEach((u) => {
    postsById[u._id] = u;
  });
  setRemoteRowCount(count);
  setList([...updatedList]);
  setPostsById(postsById);
};
const CirclePostsTestPanel1 = () => {
  const remote = useRemoteData();
  const fetchRemote = fetchRemoteTestFn(remote);
  const {
    runAsync
  } = useRequest(fetchRemote, {
    manual: true,
    retryCount: -1
  });
  const local = useLocalData();
  const onUpdate = useMemoizedFn((result) => {
    onUpdateFn(local, result);
  });
  useCreation(async () => {
    const result = await runAsync({
      start: 0,
      end: 10
    });
    onUpdate(result);
  }, []);
  const {
    list,
    setPosition,
    getUpdateRequest,
    remoteRowCount
  } = local;
  const handleRowsRendered = (value) => {
    setPosition(value);
  };
  function isRowLoaded({
    index
  }) {
    return !!list[index];
  }
  const loadMoreRows = async ({
    startIndex,
    stopIndex
  }) => {
    console.log("1111111111111111111111111111-startIndex", startIndex, stopIndex);
    const request = getUpdateRequest(startIndex, stopIndex);
    const result = await runAsync(request);
    onUpdate(result);
  };
  const rowRenderer = ({
    key,
    index,
    style
  }) => {
    const post = list[index];
    if (!post) {
      return null;
    }
    return /* @__PURE__ */ jsx("div", {
      style,
      children: post.title
    }, key);
  };
  const onUpdateFirstTest = async () => {
    const request = getUpdateRequest(0, 9);
    const result = await runAsync(request);
    onUpdate(result);
  };
  const onUpdateVisibleTest = async () => {
    const {
      position: {
        startIndex,
        stopIndex
      }
    } = local;
    const request = getUpdateRequest(startIndex, stopIndex);
    const result = await runAsync(request);
    onUpdate(result);
  };
  const {
    postsById,
    ...otherLocal
  } = local;
  return /* @__PURE__ */ jsxs("div", {
    className: "grow flex flex-col",
    children: [/* @__PURE__ */ jsx(Result, {
      label: "remote",
      children: remote
    }), /* @__PURE__ */ jsx(Result, {
      label: "local",
      children: otherLocal
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2",
      children: [/* @__PURE__ */ jsx(Button, {
        onClick: () => addRemote(remote),
        children: "Add 10 remote posts"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: onUpdateFirstTest,
        children: "Update first"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: onUpdateVisibleTest,
        children: "Update visible"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "grow m-1",
      children: /* @__PURE__ */ jsx(AutoSizer, {
        children: ({
          height,
          width
        }) => /* @__PURE__ */ jsx(InfiniteLoader, {
          isRowLoaded,
          loadMoreRows,
          rowCount: remoteRowCount,
          children: ({
            onRowsRendered,
            registerChild
          }) => /* @__PURE__ */ jsx(List$1, {
            height,
            onRowsRendered: (v) => {
              onRowsRendered(v);
              handleRowsRendered(v);
            },
            ref: registerChild,
            rowCount: remoteRowCount,
            rowHeight: 200,
            rowRenderer,
            width
          })
        })
      })
    })]
  });
};
const PaginationTest1 = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
      children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
        children: /* @__PURE__ */ jsx(ActivityContextProvider, {
          children: /* @__PURE__ */ jsx("div", {
            className: "absolute h-full w-full flex flex-col",
            children: /* @__PURE__ */ jsx(PaginationTestInner1, {})
          })
        })
      })
    })]
  });
};

const EventsCalendarTestInner = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[3] === "calendar-events" && path[4] ? path[4] : circleIdDefault;
  return /* @__PURE__ */ jsx(CirclePageProviders, {
    circleId,
    children: /* @__PURE__ */ jsx(CircleEventsCalendarPanel, {})
  });
};
const EventsCalendarTest = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
      children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
        children: /* @__PURE__ */ jsx(ActivityContextProvider, {
          children: /* @__PURE__ */ jsx("div", {
            className: "absolute h-full w-full flex flex-col",
            children: /* @__PURE__ */ jsx(EventsCalendarTestInner, {})
          })
        })
      })
    })]
  });
};

const HorizontalRuler$1 = () => /* @__PURE__ */ jsx("hr", {
  className: "border-t border-gray-200",
  style: {
    borderColor: "#F5F5F5"
  }
});
const SessionAPITestPage = () => {
  useApi();
  const [file, setFile] = useState();
  useState("");
  useState(600);
  const location = useLocation();
  const [totalPages, setTotalPages] = useState(0);
  const path = location.pathname.split("/").filter((p) => p);
  console.log("111111111111111111111111111111111111", path);
  const circleId = path[5];
  const {
    data: circleData
  } = useCircle(circleId);
  circleData && circleData.group;
  useLoading(async (accepted) => {
    setTotalPages(-1);
    setFile(accepted[0]);
  });
  useLoading(async () => {
  });
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsxs(LoadCircleData, {
      circleId,
      children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
        className: "ns w-full p-2 flex flex-col gap-4 text-sm h-full overflow-auto relative",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "font-semibold text-lg m-auto",
          children: [/* @__PURE__ */ jsx("span", {
            children: "API for sessions test page"
          }), /* @__PURE__ */ jsx(CircleInfo, {})]
        }), /* @__PURE__ */ jsx(SubCircles, {
          circleId
        }), /* @__PURE__ */ jsx(UserInfo, {}), /* @__PURE__ */ jsx(CirclePosts$1, {
          circleId
        })]
      })]
    })
  });
};
let counter$2 = 0;
const CircleInfo = () => {
  const {
    circle
  } = useCircleContext();
  return /* @__PURE__ */ jsx(Fragment, {
    children: circle && /* @__PURE__ */ jsx("a", {
      href: circleUrl(circle._id),
      children: /* @__PURE__ */ jsxs("span", {
        className: "underline",
        children: [" for the circle ", circle.name]
      })
    })
  });
};
const SubCircles = ({
  circleId
}) => {
  const {
    id
  } = useCircleContext();
  const api = useApi();
  const {
    data,
    mutate
  } = useSubCircles(circleId);
  if (!data) {
    return null;
  }
  const {
    onClick: onSave,
    loading: loadingSave
  } = useLoading(async () => {
    const circle = await api.upsertGroup({
      parent: id,
      "privacy": "PUBLIC",
      "min_privacy": "PUBLIC",
      "name": "public " + counter$2++,
      "tags": ["s"]
    });
    console.log("2222222222222222222222", circle);
    mutate();
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(HorizontalRuler$1, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["SubCircles: (", data.length, ")"]
      }), data.map((circle) => {
        const {
          name,
          _id
        } = circle;
        return /* @__PURE__ */ jsx("div", {
          children: name
        }, _id);
      }), /* @__PURE__ */ jsx(LoadingButton, {
        loading: loadingSave,
        onClick: onSave,
        background: "blue",
        children: "Create Sub Circle"
      })]
    })]
  });
};
const CirclePosts$1 = ({
  circleId
}) => {
  const api = useApi();
  const {
    id
  } = useCircleContext();
  const state = useCirclePostsState$2(circleId, {
    limit: 30
  });
  const {
    firstLoaded,
    all,
    updatePost,
    moreLoading,
    loadMore,
    state: {
      pinned
    }
  } = state;
  const {
    onClick: onSave,
    loading: loadingSave
  } = useLoading(async () => {
    const title = `title #${counter$2++}`;
    const draft = await api.upsertDraft({
      attachments: [],
      tags: [],
      title,
      group: {
        group: id
      },
      type: "article",
      content: {
        nsTitle: title,
        nsHtml: `<p>${title}</p>`
      }
    });
    const post = await api.publish(draft);
    updatePost(post);
  });
  if (!all) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler$1, {}), /* @__PURE__ */ jsx("div", {
        children: "Posts: no data"
      })]
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(HorizontalRuler$1, {}), /* @__PURE__ */ jsx(LoadingButton, {
      loading: loadingSave,
      onClick: onSave,
      background: "blue",
      children: "Create Post"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["Circle posts: (", all.length, ")"]
      }), all.map((post) => {
        const {
          title,
          _id
        } = post;
        return /* @__PURE__ */ jsx("div", {
          children: title
        }, _id);
      })]
    })]
  });
};
const UserInfo = () => {
  const {
    profile,
    authenticationRequired
  } = useProfileContext();
  if (authenticationRequired) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler$1, {}), /* @__PURE__ */ jsx("div", {
        children: "User info: authentication required"
      })]
    });
  }
  if (!profile) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(HorizontalRuler$1, {}), /* @__PURE__ */ jsx("div", {
      children: getPersonName(profile)
    })]
  });
};

const Wrapper$k = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const SessionPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/single-circle/sessions";
  if (pathname.startsWith(prefix + "/api")) {
    return /* @__PURE__ */ jsx(SessionAPITestPage, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$k, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/api/",
        children: "API"
      })
    })]
  });
};

function fetchJson(url) {
  return fetch(url).then((res) => res.json()).then((res) => {
    return res;
  });
}
const HorizontalRuler = () => /* @__PURE__ */ jsx("hr", {
  className: "border-t border-gray-200",
  style: {
    borderColor: "#F5F5F5"
  }
});
const WebExtractionTestPage = () => {
  useApi();
  const [file, setFile] = useState();
  useState("");
  useState(600);
  const location = useLocation();
  const [totalPages, setTotalPages] = useState(0);
  const path = location.pathname.split("/").filter((p) => p);
  console.log("111111111111111111111111111111111111", path);
  const circleId = path[5];
  const {
    data: circleData
  } = useCircle(circleId);
  const circle = circleData && circleData.group;
  useLoading(async (accepted) => {
    setTotalPages(-1);
    setFile(accepted[0]);
  });
  useLoading(async () => {
  });
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsxs(LoadCircleData, {
      circleId,
      children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
        className: "ns w-full p-2 flex flex-col gap-4 text-sm h-full overflow-auto relative",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "font-semibold text-lg m-auto",
          children: [/* @__PURE__ */ jsx("span", {
            children: "API for sessions test page"
          }), circle && /* @__PURE__ */ jsx("a", {
            href: circleUrl(circleId),
            children: /* @__PURE__ */ jsxs("span", {
              className: "underline",
              children: [" for the circle ", circle.name]
            })
          })]
        }), /* @__PURE__ */ jsx(CirclePosts, {
          circleId
        })]
      })]
    })
  });
};
const CirclePosts = ({
  circleId
}) => {
  const api = useApi();
  const {
    id
  } = useCircleContext();
  const state = useCirclePostsState$2(circleId, {
    limit: 30
  });
  const {
    firstLoaded,
    all,
    updatePost,
    moreLoading,
    loadMore,
    state: {
      pinned
    }
  } = state;
  const {
    onClick: onSave,
    loading: loadingSave
  } = useLoading(async () => {
    const json_data = await fetchJson("https://180post.com/wp-json/wp/v2/posts?_embed");
    json_data.forEach(async function(item) {
      const title = item.title.rendered;
      const content = item.content.rendered;
      const date = item.date;
      const wordpress_author = item._embedded.author[0].name;
      const tags_raw = item._embedded["wp:term"][1];
      const tags = [];
      tags_raw.forEach(async function(item_inner) {
        tags.push(item_inner.name);
      });
      const draft = await api.upsertDraft({
        attachments: [],
        tags,
        title,
        group: {
          group: id
        },
        type: "article",
        content: {
          nsTitle: title + " - " + wordpress_author,
          nsHtml: `<h1>${title}</h1>
                    <br>
                    <h2>Author: ${wordpress_author}</h2>
                    <br>
                    <h3>Date of Publication: ${date}</h3>
                    <br>
                    ${content}`
        }
      });
      const post = await api.publish(draft);
      updatePost(post);
      console.log(json_data);
    });
  });
  if (!all) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler, {}), /* @__PURE__ */ jsx("div", {
        children: "Posts: no data"
      })]
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(HorizontalRuler, {}), /* @__PURE__ */ jsx(LoadingButton, {
      loading: loadingSave,
      onClick: onSave,
      background: "blue",
      children: "Parse Posts"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["Circle posts: (", all.length, ")"]
      }), all.map((post) => {
        const {
          title,
          _id
        } = post;
        return /* @__PURE__ */ jsx("a", {
          href: circleUrl(circleId) + `/posts/post/${_id}`,
          children: /* @__PURE__ */ jsxs(LoadingButton, {
            background: "blue",
            children: [_id, " - ", title]
          })
        }, _id);
      })]
    })]
  });
};

const Wrapper$j = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const WebExtractionTest = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/single-circle/web-extraction-test";
  if (pathname.startsWith(prefix + "/api")) {
    return /* @__PURE__ */ jsx(WebExtractionTestPage, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$j, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/api/",
        children: "API"
      })
    })]
  });
};

const LanguageSelect = ({
  value,
  onChange,
  label = "Language",
  placeholder = "Select language",
  disabled = false,
  className,
  variant,
  size = "md"
}) => {
  return /* @__PURE__ */ jsx(Select, {
    value,
    onChange,
    options: LANGUAGE_OPTIONS,
    label,
    placeholder,
    disabled,
    className,
    variant,
    size
  });
};

const GraphStateForm = ({
  state,
  onUpdate,
  disabled = false
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "grid grid-cols-1 md:grid-cols-2 gap-4",
      children: [/* @__PURE__ */ jsx(LanguageSelect, {
        label: "Source Language",
        value: state.sourceLang || "",
        onChange: (value) => onUpdate({
          sourceLang: value
        }),
        disabled
      }), /* @__PURE__ */ jsx(LanguageSelect, {
        label: "Target Language",
        value: state.targetLang || "",
        onChange: (value) => onUpdate({
          targetLang: value
        }),
        disabled
      })]
    }), /* @__PURE__ */ jsx(TextInput, {
      label: "Domain",
      value: state.domain || "",
      onChange: (e) => onUpdate({
        domain: e.target.value
      }),
      disabled,
      placeholder: "e.g., technology, medicine, legal"
    })]
  });
};

const useGraphTask = () => {
  const taskOp = useTaskOperation({
    executeEndpoint: "/admin/translate/post"
  });
  const startGraph = useMemoizedFn(async ({
    input,
    data
  }) => {
    await taskOp.startTask({
      input,
      data
    });
  });
  return {
    ...taskOp,
    startGraph
  };
};

const formatTime = (date) => {
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });
};
const getEventColor = (message) => {
  const {
    event,
    data
  } = message;
  if (event === "log" && data.level) {
    const levelColors = {
      debug: "bg-gray-100 text-gray-600",
      info: "bg-blue-100 text-blue-800",
      warn: "bg-yellow-100 text-yellow-800",
      error: "bg-red-100 text-red-800"
    };
    return levelColors[data.level] || "bg-gray-100 text-gray-800";
  }
  const colors = {
    progress: "bg-blue-100 text-blue-800",
    complete: "bg-green-100 text-green-800",
    error: "bg-red-100 text-red-800",
    log: "bg-gray-100 text-gray-800"
  };
  return colors[event] || "bg-gray-100 text-gray-800";
};
const getEventLabel = (message) => {
  const {
    event,
    data
  } = message;
  if (event === "log" && data.level) {
    return data.level;
  }
  return event;
};
const SSEMessageItem = ({
  message
}) => {
  const renderProgressSummary = () => {
    const {
      data,
      event
    } = message;
    if (!data) {
      return /* @__PURE__ */ jsx("span", {
        className: "text-sm text-gray-500",
        children: "No data"
      });
    }
    if (event === "progress") {
      const {
        processed = 0,
        total = 0,
        current
      } = data;
      return /* @__PURE__ */ jsxs("span", {
        className: "text-sm text-gray-700",
        children: [processed, "/", total, current ? ` - ${current}` : ""]
      });
    }
    if (event === "complete") {
      const {
        created,
        deleted,
        skipped,
        failed
      } = data;
      const parts = [];
      if (created !== void 0)
        parts.push(`Created: ${created}`);
      if (deleted !== void 0)
        parts.push(`Deleted: ${deleted}`);
      if (skipped !== void 0)
        parts.push(`Skipped: ${skipped}`);
      if (failed !== void 0)
        parts.push(`Failed: ${failed}`);
      return /* @__PURE__ */ jsx("span", {
        className: "text-sm text-green-700 font-medium",
        children: parts.join(" | ") || "Completed"
      });
    }
    if (event === "failed") {
      const errorMessage = data.message || data.error || String(data) || "Unknown error";
      return /* @__PURE__ */ jsx("span", {
        className: "text-sm text-red-700 font-medium",
        children: errorMessage
      });
    }
    if (event === "log") {
      const logMessage = data.message || String(data);
      return /* @__PURE__ */ jsx("span", {
        className: "text-sm text-gray-600",
        children: logMessage
      });
    }
    return null;
  };
  const header = /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-3",
    children: [/* @__PURE__ */ jsx("span", {
      className: `px-2 py-1 rounded text-xs font-medium uppercase ${getEventColor(message)}`,
      children: getEventLabel(message)
    }), /* @__PURE__ */ jsx("span", {
      className: "text-sm text-gray-600 font-mono",
      children: formatTime(message.timestamp)
    }), renderProgressSummary()]
  });
  const renderContent = () => {
    const {
      data
    } = message;
    if (!data) {
      return /* @__PURE__ */ jsx("div", {
        className: "text-xs text-gray-500 p-3",
        children: "No data available"
      });
    }
    try {
      return /* @__PURE__ */ jsx("pre", {
        className: "text-xs text-gray-700 overflow-x-auto font-mono bg-gray-50 p-3 rounded",
        children: JSON.stringify(data, null, 2)
      });
    } catch (error) {
      return /* @__PURE__ */ jsxs("div", {
        className: "text-xs text-red-600 p-3",
        children: ["Error displaying data: ", String(error)]
      });
    }
  };
  return /* @__PURE__ */ jsx(CollapsibleListItem, {
    header,
    variant: "default",
    defaultExpanded: message.event === "failed",
    children: renderContent()
  });
};

const SSEMessagesList = ({
  messages,
  emptyMessage = "No messages yet",
  maxMessages = 30
}) => {
  if (messages.length === 0) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-8 text-center text-gray-500 bg-gray-50 rounded-md",
      children: emptyMessage
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "text-sm text-gray-600",
      children: ["Latest ", maxMessages, " messages (newest first)"]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2",
      children: messages.map((message) => /* @__PURE__ */ jsx(SSEMessageItem, {
        message
      }, message.id))
    })]
  });
};

const TranslationProgressSection = ({
  messages,
  isComplete,
  onClear
}) => {
  if (messages.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(CollapsibleSection, {
    title: "Translation Progress",
    defaultCollapsed: false,
    variant: "card",
    renderHeader: (expanded, onToggle) => /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between w-full",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-3",
        children: [/* @__PURE__ */ jsx(ToggleButton, {
          expanded,
          onToggle,
          variant: "default",
          size: "md"
        }), /* @__PURE__ */ jsxs("h2", {
          className: "text-lg font-semibold",
          children: ["Translation Progress", isComplete && /* @__PURE__ */ jsx("span", {
            className: "ml-2 text-sm text-green-600",
            children: "(Completed)"
          })]
        })]
      }), /* @__PURE__ */ jsx("button", {
        onClick: (e) => {
          e.stopPropagation();
          onClear();
        },
        className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
        children: "Clear"
      })]
    }),
    children: /* @__PURE__ */ jsx(SSEMessagesList, {
      messages,
      emptyMessage: "No translation messages yet"
    })
  });
};

const FinalTranslationSection$1 = ({
  finalTranslation
}) => {
  if (!finalTranslation) {
    return null;
  }
  return /* @__PURE__ */ jsx(CollapsibleSection, {
    title: "Final Translation",
    defaultCollapsed: false,
    variant: "elevated",
    headerVariant: "primary",
    contentVariant: "subtle",
    children: /* @__PURE__ */ jsx("div", {
      className: "prose max-w-none",
      children: /* @__PURE__ */ jsx("div", {
        className: "bg-white p-4 rounded border border-gray-200",
        children: /* @__PURE__ */ jsx("pre", {
          className: "whitespace-pre-wrap text-sm font-sans text-gray-800",
          children: finalTranslation
        })
      })
    })
  });
};

const useGraphInitialState = (postId) => {
  const [state, setState] = useState({
    postId,
    sourceLang: "en",
    targetLang: "ar",
    domain: "technology"
  });
  const updateState = useMemoizedFn((updates) => {
    setState((prev) => ({ ...prev, ...updates }));
  });
  return {
    state,
    updateState
  };
};

const PostInfoHeader$1 = ({
  post
}) => {
  if (!post) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className: "bg-gray-50 border border-gray-200 rounded-lg p-4",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex-1",
        children: [/* @__PURE__ */ jsxs("a", {
          href: `/trans/post-view/${post._id}`,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "text-lg font-semibold text-blue-600 hover:text-blue-800 underline inline-flex items-center gap-2 group",
          children: [/* @__PURE__ */ jsx("span", {
            children: post.title || "Untitled Post"
          }), /* @__PURE__ */ jsx(MdOpenInNew, {
            className: "w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity"
          })]
        }), post.author && /* @__PURE__ */ jsxs("div", {
          className: "text-sm text-gray-600 mt-1",
          children: ["by ", getPersonName(post.author)]
        })]
      }), post.tags && post.tags.length > 0 && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-wrap gap-1 ml-4",
        children: [post.tags.slice(0, 3).map((tag) => /* @__PURE__ */ jsx("span", {
          className: "text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded",
          children: tag
        }, tag)), post.tags.length > 3 && /* @__PURE__ */ jsxs("span", {
          className: "text-xs text-gray-500",
          children: ["+", post.tags.length - 3, " more"]
        })]
      })]
    })
  });
};

const extractVariablesFromPrompt = (prompt) => {
  if (!prompt)
    return [];
  const matches = prompt.matchAll(/\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g);
  const variables = [...matches].map((m) => m[1]);
  return [...new Set(variables)];
};
const extractAllPromptVariables = (systemPrompt, userPrompt) => {
  const systemVars = extractVariablesFromPrompt(systemPrompt);
  const userVars = extractVariablesFromPrompt(userPrompt);
  return [...new Set([...systemVars, ...userVars])];
};

const inferOutputVariables = (sampleJson) => {
  if (!sampleJson || !sampleJson.trim()) {
    return [];
  }
  try {
    const parsed = JSON.parse(sampleJson);
    if (typeof parsed !== "object" || parsed === null) {
      return [];
    }
    return Object.keys(parsed);
  } catch (error) {
    return [];
  }
};
const validateJSON = (jsonString) => {
  if (!jsonString || !jsonString.trim()) {
    return { valid: true, error: null };
  }
  try {
    JSON.parse(jsonString);
    return { valid: true, error: null };
  } catch (error) {
    return {
      valid: false,
      error: error instanceof Error ? error.message : "Invalid JSON"
    };
  }
};

const extractFunctionVariables = (block, functionDefinitions) => {
  const requiredVars = [];
  const providedVars = [];
  const allFunctions = [...block.preFunctions || [], ...block.postFunctions || []];
  for (const fnConfig of allFunctions) {
    if (!fnConfig.enabled)
      continue;
    const definition = functionDefinitions.find((d) => d.id === fnConfig.functionId);
    if (!definition)
      continue;
    requiredVars.push(...definition.requiredFields);
    providedVars.push(...definition.providedFields);
  }
  return {
    requiredVars: [...new Set(requiredVars)],
    providedVars: [...new Set(providedVars)]
  };
};
const calculateBlockMetadata = (blocks, functionDefinitions = []) => {
  const metadata = new Map();
  for (const block of blocks) {
    const requiredVars = [];
    const providedVars = [];
    if (block.llm) {
      const promptVars = extractAllPromptVariables(block.llm.systemPrompt, block.llm.userPrompt);
      requiredVars.push(...promptVars);
      const outputVars = inferOutputVariables(block.llm.sampleOutput);
      providedVars.push(...outputVars);
    }
    const functionVars = extractFunctionVariables(block, functionDefinitions);
    requiredVars.push(...functionVars.requiredVars);
    providedVars.push(...functionVars.providedVars);
    metadata.set(block.id, {
      requiredVars: [...new Set(requiredVars)],
      providedVars: [...new Set(providedVars)]
    });
  }
  return metadata;
};
const findReachableFrom = (startBlockId, blocks) => {
  const reachable = new Set();
  const queue = [startBlockId];
  while (queue.length > 0) {
    const currentId = queue.shift();
    if (!currentId || reachable.has(currentId))
      continue;
    reachable.add(currentId);
    const block = blocks.find((b) => b.id === currentId);
    if (!block)
      continue;
    for (const condition of block.routing.conditions) {
      if (condition.targetNode && !reachable.has(condition.targetNode)) {
        queue.push(condition.targetNode);
      }
    }
    if (block.routing.defaultNode && !reachable.has(block.routing.defaultNode)) {
      queue.push(block.routing.defaultNode);
    }
  }
  return reachable;
};
const validateGraphConfig = (config, functionDefinitions = []) => {
  const warnings = [];
  const blockIds = new Set(config.blocks.map((b) => b.id));
  const metadata = calculateBlockMetadata(config.blocks, functionDefinitions);
  const idCounts = new Map();
  for (const block of config.blocks) {
    idCounts.set(block.id, (idCounts.get(block.id) || 0) + 1);
  }
  for (const [id, count] of idCounts.entries()) {
    if (count > 1) {
      warnings.push({
        blockId: id,
        type: "error",
        message: `Duplicate block ID: "${id}"`
      });
    }
  }
  if (!config.entryPoint) {
    warnings.push({
      blockId: "_graph",
      type: "error",
      message: 'No entry point set. Right-click a block and select "Set as Entry Point"'
    });
  } else if (!blockIds.has(config.entryPoint)) {
    warnings.push({
      blockId: "_graph",
      type: "error",
      message: `Entry point "${config.entryPoint}" does not exist`
    });
  }
  for (const block of config.blocks) {
    const blockMeta = metadata.get(block.id);
    const hasLLM = !!block.llm;
    const hasFunctions = (block.preFunctions && block.preFunctions.length || 0) + (block.postFunctions && block.postFunctions.length || 0) > 0;
    if (!hasLLM && !hasFunctions) {
      warnings.push({
        blockId: block.id,
        type: "warning",
        message: "Block has no LLM configuration and no functions (will pass through state unchanged)"
      });
    }
    if (block.llm) {
      if (!block.llm.userPrompt.trim()) {
        warnings.push({
          blockId: block.id,
          type: "error",
          message: "User prompt is empty"
        });
      }
      if (block.llm.sampleOutput) {
        const { valid, error } = validateJSON(block.llm.sampleOutput);
        if (!valid) {
          warnings.push({
            blockId: block.id,
            type: "error",
            message: `Invalid sample JSON: ${error}`
          });
        }
      }
    }
    const allFunctions = [...block.preFunctions || [], ...block.postFunctions || []];
    for (const fnConfig of allFunctions) {
      if (!fnConfig.enabled)
        continue;
      const definition = functionDefinitions.find((d) => d.id === fnConfig.functionId);
      if (!definition) {
        warnings.push({
          blockId: block.id,
          type: "error",
          message: `Function "${fnConfig.functionId}" not found in available functions`
        });
      }
      if (fnConfig.config && fnConfig.config.trim()) {
        const { valid, error } = validateJSON(fnConfig.config);
        if (!valid) {
          warnings.push({
            blockId: block.id,
            type: "error",
            message: `Invalid function config JSON for "${fnConfig.functionId}": ${error}`
          });
        }
      }
    }
    for (const condition of block.routing.conditions) {
      if (condition.targetNode && !blockIds.has(condition.targetNode)) {
        warnings.push({
          blockId: block.id,
          type: "error",
          message: `Condition target "${condition.targetNode}" does not exist`
        });
      }
      if (condition.field && blockMeta && !blockMeta.providedVars.includes(condition.field)) {
        warnings.push({
          blockId: block.id,
          type: "warning",
          message: `Condition field "${condition.field}" not in block output. Ensure it's provided by LLM or functions.`
        });
      }
    }
    if (block.routing.defaultNode && !blockIds.has(block.routing.defaultNode)) {
      warnings.push({
        blockId: block.id,
        type: "error",
        message: `Default target "${block.routing.defaultNode}" does not exist`
      });
    }
    if (block.routing.conditions.length === 0 && !block.routing.defaultNode) {
      warnings.push({
        blockId: block.id,
        type: "warning",
        message: "Block has no routing configured (will end execution)"
      });
    }
  }
  if (config.entryPoint && blockIds.has(config.entryPoint)) {
    const reachable = findReachableFrom(config.entryPoint, config.blocks);
    for (const block of config.blocks) {
      if (!reachable.has(block.id)) {
        warnings.push({
          blockId: block.id,
          type: "warning",
          message: "Block is unreachable from entry point"
        });
      }
    }
  }
  return warnings;
};

const DEFAULT_LLM = "gpt-5.5";

const defaultConfig = {
  blocks: [],
  entryPoint: null
};
const defaultLLMConfig = {
  model: DEFAULT_LLM,
  temperature: 0.3,
  maxTokens: 4096
};

const useExecuteGraphTask = () => {
  const taskOp = useTaskOperation({
    executeEndpoint: "/graphs/execute"
  });
  const executeGraph = useMemoizedFn(async ({
    input,
    graphConfig
  }) => {
    await taskOp.startTask({
      input,
      data: {
        graphConfig
      }
    });
  });
  return {
    ...taskOp,
    executeGraph
  };
};

const GraphBlockContext = createContext(null);
const useGraphBlockContext = () => {
  const context = useContext(GraphBlockContext);
  if (!context) {
    throw new Error("useGraphBlockContext must be used within GraphBlockProvider");
  }
  return context;
};
const createEmptyBlock = (defaultLLMConfig2) => ({
  id: `block_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`,
  preFunctions: [],
  postFunctions: [],
  llm: {
    model: defaultLLMConfig2.model || DEFAULT_LLM,
    temperature: defaultLLMConfig2.temperature || 0.3,
    maxTokens: defaultLLMConfig2.maxTokens || 4096,
    systemPrompt: defaultLLMConfig2.systemPrompt || "",
    userPrompt: defaultLLMConfig2.userPrompt || "",
    sampleOutput: defaultLLMConfig2.sampleOutput || ""
  },
  routing: {
    conditions: [],
    defaultNode: null
  }
});
const onBlockIdChanged = (updated, oldId, newId) => {
  if (updated.entryPoint === oldId) {
    updated.entryPoint = newId;
  }
  return updated;
};
const GraphBlockProvider = ({
  children,
  initialConfig
}) => {
  const [config, setConfig] = useState(initialConfig || defaultConfig);
  const [selectedBlockId, setSelectedBlockId] = useState(null);
  const [validationWarnings, setValidationWarnings] = useState([]);
  const [functionDefinitions, setFunctionDefinitions] = useState([]);
  const execution = useExecuteGraphTask();
  const blockMetadata = useMemo(() => calculateBlockMetadata(config.blocks), [config.blocks]);
  const addBlock = useMemoizedFn(() => {
    const newBlock = createEmptyBlock(defaultLLMConfig);
    setConfig((prev) => ({
      ...prev,
      blocks: [...prev.blocks, newBlock],
      entryPoint: prev.blocks.length === 0 ? newBlock.id : prev.entryPoint
    }));
    setSelectedBlockId(newBlock.id);
  });
  const updateBlock = useMemoizedFn((blockId, updates) => {
    let updated = {
      ...config
    };
    if (blockId !== updates.id && updates.id) {
      setSelectedBlockId(updates.id);
      onBlockIdChanged(updated, blockId, updates.id);
    }
    updated.blocks = updated.blocks.map((block) => block.id === blockId ? {
      ...block,
      ...updates
    } : block);
    setConfig(updated);
  });
  const deleteBlock = useMemoizedFn((blockId) => {
    setConfig((prev) => {
      const newBlocks = prev.blocks.filter((b) => b.id !== blockId);
      return {
        ...prev,
        blocks: newBlocks,
        entryPoint: prev.entryPoint === blockId ? null : prev.entryPoint
      };
    });
    if (selectedBlockId === blockId) {
      setSelectedBlockId(null);
    }
  });
  const selectBlock = useMemoizedFn((blockId) => {
    setSelectedBlockId(blockId);
  });
  const setEntryPoint = useMemoizedFn((blockId) => {
    setConfig((prev) => ({
      ...prev,
      entryPoint: blockId
    }));
  });
  const validate = useMemoizedFn(() => {
    const warnings = validateGraphConfig(config, functionDefinitions);
    setValidationWarnings(warnings);
  });
  const exportConfig = useMemoizedFn(() => {
    return config;
  });
  const importConfig = useMemoizedFn((newConfig) => {
    setConfig(newConfig);
    setSelectedBlockId(null);
    setValidationWarnings([]);
  });
  const value = {
    config,
    selectedBlockId,
    validationWarnings,
    blockMetadata,
    functionDefinitions,
    addBlock,
    updateBlock,
    deleteBlock,
    selectBlock,
    setEntryPoint,
    validate,
    exportConfig,
    importConfig,
    setFunctionDefinitions,
    execution
  };
  return /* @__PURE__ */ jsx(GraphBlockContext.Provider, {
    value,
    children
  });
};

const DEFAULT = [];
const useFunctions = (options) => {
  const api = useApi();
  const result = useSWR("/graphs/functions", async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result,
    functions: result.data && result.data.functions ? result.data.functions : DEFAULT,
    count: result.data && result.data.count ? result.data.count : 0
  };
};

class LocalStorageAdapter {
  constructor(configId) {
    this.key = `graph-config${configId ? `-${configId}` : ""}`;
  }
  async save(config) {
    if (typeof window === "undefined") {
      return;
    }
    try {
      const serialized = JSON.stringify(config);
      window.localStorage.setItem(this.key, serialized);
    } catch (error) {
      throw new Error(`Failed to save to localStorage: ${error.message || error}`);
    }
  }
  async load() {
    if (typeof window === "undefined") {
      return null;
    }
    try {
      const stored = window.localStorage.getItem(this.key);
      if (!stored) {
        return null;
      }
      const parsed = JSON.parse(stored);
      return parsed;
    } catch (error) {
      throw new Error(`Failed to load from localStorage: ${error.message}`);
    }
  }
  async clear() {
    if (typeof window === "undefined") {
      return;
    }
    try {
      window.localStorage.removeItem(this.key);
    } catch (error) {
      throw new Error(`Failed to clear localStorage: ${error.message}`);
    }
  }
}

const useConfigStorage = ({
  adapter,
  autoSave = true,
  autoLoad = true,
  debounceMs = 300
}) => {
  const { config, exportConfig, importConfig } = useGraphBlockContext();
  const isInitialLoad = useRef(true);
  const [saveError, setSaveError] = useState(null);
  const [loadError, setLoadError] = useState(null);
  const [clearError, setClearError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const save = useMemoizedFn(async () => {
    try {
      setSaveError(null);
      const configToSave = exportConfig();
      await adapter.save(configToSave);
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      setSaveError(err);
      console.error("Failed to save config:", err);
    }
  });
  const load = useMemoizedFn(async () => {
    try {
      setIsLoading(true);
      setLoadError(null);
      const loaded = await adapter.load();
      if (loaded) {
        importConfig(loaded);
      }
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      setLoadError(err);
      console.error("Failed to load config:", err);
    } finally {
      setIsLoading(false);
    }
  });
  const clear = useMemoizedFn(async () => {
    try {
      setClearError(null);
      await adapter.clear();
      const defaultConfig = { blocks: [], entryPoint: null };
      importConfig(defaultConfig);
    } catch (error) {
      const err = error instanceof Error ? error : new Error(String(error));
      setClearError(err);
      console.error("Failed to clear config:", err);
    }
  });
  useEffect(() => {
    if (autoLoad && isInitialLoad.current) {
      load();
      isInitialLoad.current = false;
    }
  }, []);
  useEffect(() => {
    if (!autoSave || isInitialLoad.current) {
      return;
    }
    const timer = setTimeout(async () => {
      try {
        setSaveError(null);
        const configToSave = exportConfig();
        await adapter.save(configToSave);
      } catch (error) {
        const err = error instanceof Error ? error : new Error(String(error));
        setSaveError(err);
        console.error("Failed to auto-save config:", err);
      }
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [config, autoSave, debounceMs, adapter, exportConfig]);
  return {
    save,
    load,
    clear,
    saveError,
    loadError,
    clearError,
    isLoading
  };
};

const PersistenceContext = createContext(null);
const useGraphConfigPersistence = () => {
  const context = useContext(PersistenceContext);
  if (!context) {
    throw new Error("useGraphConfigPersistence must be used within GraphConfigPersistenceProvider");
  }
  return context;
};
const GraphConfigPersistenceProvider = ({
  children,
  configId,
  autoSave = true,
  autoLoad = true
}) => {
  const adapter = useMemo(() => new LocalStorageAdapter(configId), [configId]);
  const storage = useConfigStorage({
    adapter,
    autoSave,
    autoLoad
  });
  const {
    setFunctionDefinitions
  } = useGraphBlockContext();
  const {
    functions,
    isValidating: functionsLoading,
    error: functionsError
  } = useFunctions();
  useEffect(() => {
    setFunctionDefinitions(functions || []);
  }, [functions, setFunctionDefinitions]);
  const value = {
    save: storage.save,
    load: storage.load,
    clear: storage.clear,
    autosaved: autoSave,
    saveError: storage.saveError,
    loadError: storage.loadError,
    clearError: storage.clearError,
    isLoading: storage.isLoading,
    functions,
    functionsLoading,
    functionsError
  };
  return /* @__PURE__ */ jsx(PersistenceContext.Provider, {
    value,
    children
  });
};

const BlockListItem = ({
  blockId
}) => {
  const {
    config,
    blockMetadata,
    validationWarnings,
    selectBlock,
    deleteBlock,
    setEntryPoint
  } = useGraphBlockContext();
  const block = config.blocks.find((b) => b.id === blockId);
  const metadata = blockMetadata.get(blockId);
  const warnings = validationWarnings.filter((w) => w.blockId === blockId);
  const isEntryPoint = config.entryPoint === blockId;
  const onSelect = () => selectBlock(block.id);
  const onDelete = () => {
    if (confirm(`Delete block "${block.id}"?`)) {
      deleteBlock(block.id);
    }
  };
  const onSetEntryPoint = () => setEntryPoint(block.id);
  const [expanded, setExpanded] = useState(false);
  const hasErrors = warnings.some((w) => w.type === "error");
  const hasWarnings = warnings.some((w) => w.type === "warning");
  return /* @__PURE__ */ jsxs("div", {
    className: "border border-gray-200 rounded-lg bg-white hover:shadow-md transition-shadow",
    children: [/* @__PURE__ */ jsx("div", {
      className: "p-4",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex items-start justify-between gap-4",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex-1 min-w-0",
          children: [/* @__PURE__ */ jsx("div", {
            className: "flex items-center gap-2 mb-2",
            children: /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-1.5 flex-shrink-0",
              children: [isEntryPoint && /* @__PURE__ */ jsx("span", {
                className: "px-2 py-0.5 text-xs bg-green-100 text-green-700 rounded-full font-medium",
                children: "\u{1F680} Entry"
              }), hasErrors && /* @__PURE__ */ jsx("span", {
                className: "px-2 py-0.5 text-xs bg-red-100 text-red-700 rounded-full font-medium",
                children: "\u274C Error"
              }), hasWarnings && !hasErrors && /* @__PURE__ */ jsx("span", {
                className: "px-2 py-0.5 text-xs bg-yellow-100 text-yellow-700 rounded-full font-medium",
                children: "\u26A0\uFE0F Warning"
              })]
            })
          }), /* @__PURE__ */ jsx("div", {
            className: "text-sm text-gray-500 font-mono mb-3",
            children: block.id
          }), metadata && /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-4 text-sm",
            children: [metadata.requiredVars.length > 0 && /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-1.5",
              children: [/* @__PURE__ */ jsx("span", {
                className: "text-gray-500",
                children: "\u{1F4E5}"
              }), /* @__PURE__ */ jsxs("span", {
                className: "text-gray-600",
                children: [metadata.requiredVars.length, " input", metadata.requiredVars.length !== 1 ? "s" : ""]
              })]
            }), metadata.providedVars.length > 0 && /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-1.5",
              children: [/* @__PURE__ */ jsx("span", {
                className: "text-gray-500",
                children: "\u{1F4E4}"
              }), /* @__PURE__ */ jsxs("span", {
                className: "text-gray-600",
                children: [metadata.providedVars.length, " output", metadata.providedVars.length !== 1 ? "s" : ""]
              })]
            }), block.routing.conditions.length > 0 && /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-1.5",
              children: [/* @__PURE__ */ jsx("span", {
                className: "text-gray-500",
                children: "\u{1F500}"
              }), /* @__PURE__ */ jsxs("span", {
                className: "text-gray-600",
                children: [block.routing.conditions.length, " route", block.routing.conditions.length !== 1 ? "s" : ""]
              })]
            })]
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex items-start gap-2 flex-shrink-0",
          children: [/* @__PURE__ */ jsx("button", {
            onClick: (e) => {
              e.stopPropagation();
              setExpanded(!expanded);
            },
            className: "px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded transition-colors",
            title: expanded ? "Collapse" : "Expand",
            children: expanded ? "\u25BC Less" : "\u25B6 More"
          }), /* @__PURE__ */ jsx("button", {
            onClick: (e) => {
              e.stopPropagation();
              onSelect();
            },
            className: "px-3 py-1.5 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors font-medium",
            children: "\u270F\uFE0F Edit"
          })]
        })]
      })
    }), expanded && /* @__PURE__ */ jsx("div", {
      className: "border-t border-gray-200 bg-gray-50",
      children: /* @__PURE__ */ jsxs("div", {
        className: "p-4 space-y-4",
        children: [metadata && metadata.requiredVars.length > 0 && /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("h4", {
            className: "text-sm font-semibold text-gray-700 mb-2",
            children: "\u{1F4E5} Input Variables"
          }), /* @__PURE__ */ jsx("div", {
            className: "flex flex-wrap gap-2",
            children: metadata.requiredVars.map((varName) => /* @__PURE__ */ jsx("span", {
              className: "px-2.5 py-1 bg-blue-100 text-blue-700 rounded text-sm font-mono",
              children: varName
            }, varName))
          })]
        }), metadata && metadata.providedVars.length > 0 && /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("h4", {
            className: "text-sm font-semibold text-gray-700 mb-2",
            children: "\u{1F4E4} Output Variables"
          }), /* @__PURE__ */ jsx("div", {
            className: "flex flex-wrap gap-2",
            children: metadata.providedVars.map((varName) => /* @__PURE__ */ jsx("span", {
              className: "px-2.5 py-1 bg-green-100 text-green-700 rounded text-sm font-mono",
              children: varName
            }, varName))
          })]
        }), (block.routing.conditions.length > 0 || block.routing.defaultNode) && /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("h4", {
            className: "text-sm font-semibold text-gray-700 mb-2",
            children: "\u{1F500} Routing"
          }), /* @__PURE__ */ jsxs("div", {
            className: "space-y-2",
            children: [block.routing.conditions.map((condition, idx) => /* @__PURE__ */ jsx("div", {
              className: "bg-white border border-gray-200 rounded p-2 text-sm",
              children: /* @__PURE__ */ jsxs("div", {
                className: "flex items-center gap-2",
                children: [/* @__PURE__ */ jsx("span", {
                  className: "text-gray-600",
                  children: "If"
                }), /* @__PURE__ */ jsx("span", {
                  className: "font-mono text-purple-700",
                  children: condition.field
                }), /* @__PURE__ */ jsx("span", {
                  className: "text-gray-600",
                  children: condition.operator
                }), /* @__PURE__ */ jsx("span", {
                  className: "font-mono text-purple-700",
                  children: condition.value
                }), /* @__PURE__ */ jsx("span", {
                  className: "text-gray-600",
                  children: "\u2192"
                }), /* @__PURE__ */ jsx("span", {
                  className: "font-medium text-blue-700",
                  children: condition.targetNode
                })]
              })
            }, idx)), block.routing.defaultNode && /* @__PURE__ */ jsx("div", {
              className: "bg-white border border-gray-200 rounded p-2 text-sm",
              children: /* @__PURE__ */ jsxs("div", {
                className: "flex items-center gap-2",
                children: [/* @__PURE__ */ jsx("span", {
                  className: "text-gray-600",
                  children: "Default \u2192"
                }), /* @__PURE__ */ jsx("span", {
                  className: "font-medium text-blue-700",
                  children: block.routing.defaultNode
                })]
              })
            })]
          })]
        }), warnings.length > 0 && /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("h4", {
            className: "text-sm font-semibold text-gray-700 mb-2",
            children: hasErrors ? "\u274C Errors" : "\u26A0\uFE0F Warnings"
          }), /* @__PURE__ */ jsx("div", {
            className: "space-y-1.5",
            children: warnings.map((warning, idx) => /* @__PURE__ */ jsx("div", {
              className: `text-sm p-2 rounded ${warning.type === "error" ? "bg-red-50 text-red-700 border border-red-200" : "bg-yellow-50 text-yellow-700 border border-yellow-200"}`,
              children: warning.message
            }, idx))
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2 pt-2",
          children: [!isEntryPoint && /* @__PURE__ */ jsx("button", {
            onClick: (e) => {
              e.stopPropagation();
              onSetEntryPoint();
            },
            className: "px-3 py-1.5 text-sm bg-green-600 text-white rounded hover:bg-green-700 transition-colors",
            children: "\u{1F680} Set as Entry Point"
          }), /* @__PURE__ */ jsx("button", {
            onClick: (e) => {
              e.stopPropagation();
              onDelete();
            },
            className: "px-3 py-1.5 text-sm bg-red-600 text-white rounded hover:bg-red-700 transition-colors ml-auto",
            children: "\u{1F5D1}\uFE0F Delete Block"
          })]
        })]
      })
    })]
  });
};

const EntryPointInfo = () => {
  const {
    config
  } = useGraphBlockContext();
  const entryPoint = config.entryPoint;
  return /* @__PURE__ */ jsxs("div", {
    className: "px-6 py-3 bg-gray-50 border-t flex items-center gap-2",
    children: [/* @__PURE__ */ jsx("span", {
      className: "text-sm text-gray-600 font-medium",
      children: "Entry Point:"
    }), entryPoint ? /* @__PURE__ */ jsx("div", {
      className: "flex items-center gap-2",
      children: /* @__PURE__ */ jsx("span", {
        className: "px-2 py-1 bg-green-100 text-green-700 rounded text-sm font-medium",
        children: entryPoint
      })
    }) : /* @__PURE__ */ jsx("span", {
      className: "text-sm text-gray-400 italic",
      children: "Not set (set via block menu)"
    })]
  });
};

const GraphBlockEmptyState = () => {
  return /* @__PURE__ */ jsx("div", {
    className: "flex items-center justify-center h-full text-gray-400",
    children: /* @__PURE__ */ jsxs("div", {
      className: "text-center",
      children: [/* @__PURE__ */ jsx("div", {
        className: "text-6xl mb-4",
        children: "\u{1F527}"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-lg mb-2",
        children: "No blocks yet"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-sm",
        children: 'Click "Add Block" to get started'
      })]
    })
  });
};

const menuTriggerVariants = cva("px-4 py-2 border rounded-lg font-medium flex items-center gap-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500", {
  variants: {
    variant: {
      default: "bg-white border-gray-300 text-gray-700 hover:bg-gray-50",
      primary: "bg-blue-600 border-blue-600 text-white hover:bg-blue-700",
      ghost: "bg-transparent border-transparent text-gray-700 hover:bg-gray-100"
    },
    size: {
      sm: "px-3 py-1.5 text-sm",
      md: "px-4 py-2 text-sm",
      lg: "px-5 py-2.5 text-base"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
});
const menuItemVariants = cva("w-full px-4 py-2 text-left transition-colors flex items-center gap-3 cursor-pointer", {
  variants: {
    variant: {
      default: "hover:bg-gray-50 text-gray-700",
      danger: "hover:bg-red-50 text-red-600"
    },
    disabled: {
      true: "opacity-50 cursor-not-allowed hover:bg-transparent",
      false: ""
    }
  },
  defaultVariants: {
    variant: "default",
    disabled: false
  }
});
const DropdownMenu = ({
  label,
  icon,
  groups,
  footer,
  disabled = false,
  variant,
  size,
  className,
  "aria-label": ariaLabel
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const {
    x,
    y,
    strategy,
    refs
  } = useFloating({
    placement: "bottom-end",
    middleware: [offset(8), flip(), shift({
      padding: 8
    })],
    whileElementsMounted: isOpen ? autoUpdate : void 0
  });
  useClickAway(() => {
    setIsOpen(false);
  }, [containerRef, refs.floating]);
  const handleItemClick = useMemoizedFn((item) => {
    if (item.disabled)
      return;
    item.onClick();
    setIsOpen(false);
  });
  return /* @__PURE__ */ jsxs("div", {
    ref: containerRef,
    children: [/* @__PURE__ */ jsxs("button", {
      ref: refs.setReference,
      onClick: () => !disabled && setIsOpen(!isOpen),
      disabled,
      "aria-label": label ? void 0 : ariaLabel,
      className: menuTriggerVariants({
        variant,
        size,
        className
      }),
      children: [icon, label, label && /* @__PURE__ */ jsx(MdExpandMore, {
        className: `h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`
      })]
    }), isOpen && /* @__PURE__ */ jsxs(FloatingPortal, {
      children: [/* @__PURE__ */ jsx("div", {
        className: "fixed inset-0 z-10",
        onClick: () => setIsOpen(false)
      }), /* @__PURE__ */ jsxs("div", {
        ref: refs.setFloating,
        style: {
          position: strategy,
          top: y || 0,
          left: x || 0,
          pointerEvents: "auto",
          zIndex: 9999
        },
        className: "bg-white border border-gray-200 rounded-lg shadow-lg py-1 min-w-48",
        children: [groups.map((group, groupIndex) => /* @__PURE__ */ jsxs("div", {
          children: [groupIndex > 0 && /* @__PURE__ */ jsx("div", {
            className: "border-t border-gray-200 my-1"
          }), group.items.map((item, itemIndex) => /* @__PURE__ */ jsxs("button", {
            onClick: () => handleItemClick(item),
            disabled: item.disabled,
            className: menuItemVariants({
              variant: item.variant,
              disabled: item.disabled
            }),
            children: [item.icon && /* @__PURE__ */ jsx("span", {
              className: "text-base",
              children: item.icon
            }), /* @__PURE__ */ jsx("span", {
              className: "text-sm",
              children: item.label
            })]
          }, itemIndex))]
        }, groupIndex)), footer && /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx("div", {
            className: "border-t border-gray-200 my-1"
          }), footer]
        })]
      })]
    })]
  });
};

const GraphConfigMenu = () => {
  const {
    exportConfig,
    importConfig
  } = useGraphBlockContext();
  const {
    load,
    clear,
    autosaved,
    loadError,
    clearError,
    saveError
  } = useGraphConfigPersistence();
  const fileInputRef = useRef(null);
  const handleExport = useMemoizedFn(() => {
    const configJson = JSON.stringify(exportConfig(), null, 2);
    const blob = new Blob([configJson], {
      type: "application/json"
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `graph-config-${Date.now()}.json`;
    a.click();
    URL.revokeObjectURL(url);
  });
  const handleImport = useMemoizedFn(() => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  });
  const handleFileChange = useMemoizedFn((e) => {
    const file = e.target.files && e.target.files[0];
    if (!file)
      return;
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const config = JSON.parse(event.target.result);
        importConfig(config);
      } catch (error) {
        alert("Invalid JSON file");
      }
    };
    reader.readAsText(file);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  });
  const handleReload = useMemoizedFn(async () => {
    if (confirm("Reload saved configuration? Any unsaved changes will be lost.")) {
      await load();
      if (loadError) {
        alert(`Failed to reload configuration: ${loadError.message}`);
      }
    }
  });
  const handleClear = useMemoizedFn(async () => {
    if (confirm("Clear saved configuration? This cannot be undone.")) {
      await clear();
      if (clearError) {
        alert(`Failed to clear configuration: ${clearError.message}`);
      }
    }
  });
  const groups = [{
    items: [{
      label: "Export to File",
      icon: "\u{1F4E5}",
      onClick: handleExport
    }, {
      label: "Import from File",
      icon: "\u{1F4E4}",
      onClick: handleImport
    }]
  }];
  groups.push({
    items: [{
      label: "Reload Saved",
      icon: "\u{1F504}",
      onClick: handleReload
    }, {
      label: "Clear Saved",
      icon: "\u{1F5D1}\uFE0F",
      onClick: handleClear,
      variant: "danger"
    }]
  });
  let footer = "";
  if (autosaved) {
    footer = "\u2713 Auto-save enabled";
  }
  if (saveError) {
    footer = footer + "\n\u26A0\uFE0F Save error: " + saveError.message;
  }
  if (loadError) {
    footer = footer + "\n\u26A0\uFE0F Load error: " + loadError.message;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(DropdownMenu, {
      label: "Config",
      icon: "\u{1F4BE}",
      groups,
      footer: footer || void 0
    }), /* @__PURE__ */ jsx("input", {
      ref: fileInputRef,
      type: "file",
      accept: ".json",
      style: {
        display: "none"
      },
      onChange: handleFileChange
    })]
  });
};

const MERMAID_CDN_URL = "https://cdn.jsdelivr.net/npm/mermaid@10/dist/mermaid.min.js";
const Mermaid = ({
  chart,
  className,
  onError
}) => {
  const containerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const renderIdRef = useRef(0);
  const renderChart = useMemoizedFn(async () => {
    if (!containerRef.current || !chart)
      return;
    try {
      setIsLoading(true);
      setError(null);
      if (!window.mermaid) {
        await loadJsLibs([MERMAID_CDN_URL]);
        window.mermaid.initialize({
          startOnLoad: false,
          theme: "default",
          securityLevel: "loose",
          flowchart: {
            useMaxWidth: true,
            htmlLabels: true,
            curve: "basis"
          }
        });
      }
      const renderId = `mermaid-${++renderIdRef.current}`;
      const {
        svg
      } = await window.mermaid.render(renderId, chart);
      if (containerRef.current) {
        containerRef.current.innerHTML = svg;
      }
      setIsLoading(false);
    } catch (err) {
      const error2 = err instanceof Error ? err : new Error(String(err));
      setError(error2);
      setIsLoading(false);
      if (onError) {
        onError(error2);
      }
    }
  });
  useEffect(() => {
    renderChart();
  }, [chart, renderChart]);
  if (error) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-4 bg-red-50 border border-red-200 rounded text-red-700",
      children: [/* @__PURE__ */ jsx("div", {
        className: "font-semibold",
        children: "Failed to render diagram"
      }), /* @__PURE__ */ jsx("div", {
        className: "text-sm mt-1",
        children: error.message
      })]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className,
    children: [isLoading && /* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-center p-8",
      children: /* @__PURE__ */ jsx("div", {
        className: "text-gray-500",
        children: "Loading diagram..."
      })
    }), /* @__PURE__ */ jsx("div", {
      ref: containerRef,
      className: isLoading ? "hidden" : ""
    })]
  });
};

const escapeLabel = (text) => {
  return text.replace(/"/g, "#quot;").replace(/\n/g, "<br/>");
};
const formatCondition = (condition) => {
  const { field, operator, value } = condition;
  return `${field} ${operator} ${JSON.stringify(value)}`;
};
const graphConfigToMermaid = (config) => {
  const lines = ["flowchart TD"];
  lines.push("  START([START])");
  lines.push("  START:::startNode");
  lines.push("  END([END])");
  lines.push("  END:::endNode");
  config.blocks.forEach((block) => {
    const hasLLM = block.llm !== void 0;
    const hasFunctions = block.preFunctions && block.preFunctions.length > 0 || block.postFunctions && block.postFunctions.length > 0;
    let label = block.id;
    if (hasLLM)
      label += "<br/>[LLM]";
    if (hasFunctions)
      label += "<br/>[Functions]";
    const nodeShape = hasLLM ? `["${escapeLabel(label)}"]` : `("${escapeLabel(label)}")`;
    lines.push(`  ${block.id}${nodeShape}`);
    if (hasLLM) {
      lines.push(`  ${block.id}:::llmNode`);
    } else if (hasFunctions) {
      lines.push(`  ${block.id}:::functionNode`);
    }
  });
  if (config.entryPoint) {
    lines.push(`  START --> ${config.entryPoint}`);
  }
  config.blocks.forEach((block) => {
    if (block.routing.conditions.length > 0) {
      block.routing.conditions.forEach((condition, idx) => {
        const label = escapeLabel(formatCondition(condition));
        lines.push(`  ${block.id} -->|"${label}"| ${condition.targetNode}`);
      });
      if (block.routing.defaultNode) {
        lines.push(`  ${block.id} -.->|default| ${block.routing.defaultNode}`);
      } else {
        lines.push(`  ${block.id} -.->|default| END`);
      }
    } else if (block.routing.defaultNode) {
      lines.push(`  ${block.id} --> ${block.routing.defaultNode}`);
    } else {
      lines.push(`  ${block.id} --> END`);
    }
  });
  lines.push("");
  lines.push("  classDef startNode fill:#e1f5e1,stroke:#4caf50,stroke-width:2px");
  lines.push("  classDef endNode fill:#ffebee,stroke:#f44336,stroke-width:2px");
  lines.push("  classDef llmNode fill:#e3f2fd,stroke:#2196f3,stroke-width:2px");
  lines.push("  classDef functionNode fill:#fff3e0,stroke:#ff9800,stroke-width:2px");
  return lines.join("\n");
};

const GraphVisualizer = ({
  config,
  className
}) => {
  const mermaidCode = useMemo(() => {
    return graphConfigToMermaid(config);
  }, [config]);
  return /* @__PURE__ */ jsx("div", {
    className,
    children: /* @__PURE__ */ jsx(Mermaid, {
      chart: mermaidCode,
      className: "w-full h-full flex items-center justify-center"
    })
  });
};

const GraphVisualizerDialog = ({
  isOpen,
  onClose,
  config
}) => {
  return /* @__PURE__ */ jsx(Dialog$3, {
    isOpen,
    onClose,
    title: "Graph Workflow Visualization",
    size: "full",
    footer: /* @__PURE__ */ jsx("div", {
      className: "flex justify-end gap-2",
      children: /* @__PURE__ */ jsx("button", {
        onClick: onClose,
        className: "px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors",
        children: "Close"
      })
    }),
    children: /* @__PURE__ */ jsx("div", {
      className: "p-6 h-full",
      children: config.blocks.length === 0 ? /* @__PURE__ */ jsx("div", {
        className: "flex items-center justify-center h-full text-gray-400",
        children: /* @__PURE__ */ jsxs("div", {
          className: "text-center",
          children: [/* @__PURE__ */ jsx("div", {
            className: "text-6xl mb-4",
            children: "\u{1F4CA}"
          }), /* @__PURE__ */ jsx("p", {
            className: "text-lg mb-2",
            children: "No blocks to visualize"
          }), /* @__PURE__ */ jsx("p", {
            className: "text-sm",
            children: "Add blocks to see the workflow diagram"
          })]
        })
      }) : /* @__PURE__ */ jsx(GraphVisualizer, {
        config,
        className: "h-full"
      })
    })
  });
};

const ExecuteGraphButton = () => {
  const {
    config,
    execution
  } = useGraphBlockContext();
  const handleExecute = useMemoizedFn(async () => {
    await execution.executeGraph({
      input: {},
      graphConfig: config
    });
  });
  const isDisabled = execution.isCreatingTask || execution.isConnected;
  return /* @__PURE__ */ jsx("button", {
    onClick: handleExecute,
    disabled: isDisabled,
    className: "px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
    children: execution.isCreatingTask ? "Creating..." : execution.isConnected ? "Running..." : "Execute"
  });
};

const GraphBlockToolbar = ({
  onValidate
}) => {
  const {
    config,
    addBlock
  } = useGraphBlockContext();
  const [isVisualizerOpen, setIsVisualizerOpen] = useState(false);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-3",
      children: [/* @__PURE__ */ jsx(GraphConfigMenu, {}), /* @__PURE__ */ jsx("button", {
        onClick: onValidate,
        className: "px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium",
        children: "\u{1F50D} Validate"
      }), /* @__PURE__ */ jsx("button", {
        onClick: () => setIsVisualizerOpen(true),
        className: "px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium",
        children: "\u{1F4CA} Visualize"
      }), /* @__PURE__ */ jsx("button", {
        onClick: addBlock,
        className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium",
        children: "\u2795 Add Block"
      }), /* @__PURE__ */ jsx(ExecuteGraphButton, {})]
    }), /* @__PURE__ */ jsx(GraphVisualizerDialog, {
      isOpen: isVisualizerOpen,
      onClose: () => setIsVisualizerOpen(false),
      config
    })]
  });
};

const ValidationPanel = ({
  validationState
}) => {
  const {
    showValidation,
    setShowValidation,
    validationCounts,
    validationSummary,
    handleValidate,
    hasErrors,
    hasWarnings
  } = validationState;
  const errorCount = validationCounts.errors;
  const warningCount = validationCounts.warnings;
  const onClose = () => setShowValidation(false);
  const onViewDetails = handleValidate;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [showValidation && /* @__PURE__ */ jsxs("div", {
      className: "px-6 py-3 border-t",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-start justify-between mb-2",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "font-medium text-gray-900",
          children: "Validation Results"
        }), /* @__PURE__ */ jsx("button", {
          onClick: onClose,
          className: "text-gray-400 hover:text-gray-600",
          children: "\u2715"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "bg-gray-50 rounded-lg p-3 text-sm whitespace-pre-line",
        children: validationSummary
      })]
    }), (hasErrors || hasWarnings) && /* @__PURE__ */ jsx("div", {
      className: `px-6 py-2 ${hasErrors ? "bg-red-50 border-t border-red-200" : "bg-yellow-50 border-t border-yellow-200"}`,
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 text-sm",
        children: [/* @__PURE__ */ jsx("span", {
          className: hasErrors ? "text-red-700" : "text-yellow-700",
          children: hasErrors ? "\u274C" : "\u26A0\uFE0F"
        }), /* @__PURE__ */ jsx("span", {
          className: hasErrors ? "text-red-700 font-medium" : "text-yellow-700 font-medium",
          children: hasErrors ? `${errorCount} error(s) found` : `${warningCount} warning(s) found`
        }), /* @__PURE__ */ jsx("button", {
          onClick: onViewDetails,
          className: `ml-auto text-xs underline ${hasErrors ? "text-red-600" : "text-yellow-600"}`,
          children: "View Details"
        })]
      })
    })]
  });
};

const useValidationPanelState = () => {
  const { validationWarnings, validate } = useGraphBlockContext();
  const [showValidation, setShowValidation] = useState(false);
  const validationCounts = useMemo(() => ({
    errors: validationWarnings.filter((w) => w.type === "error").length,
    warnings: validationWarnings.filter((w) => w.type === "warning").length,
    total: validationWarnings.length
  }), [validationWarnings]);
  const validationSummary = useMemo(() => {
    if (validationWarnings.length === 0) {
      return "\u2705 No issues found. Graph is valid.";
    }
    const lines = validationWarnings.map((w) => `${w.type === "error" ? "\u274C" : "\u26A0\uFE0F"} [${w.blockId}] ${w.message}`);
    return `Found ${validationCounts.errors} error(s) and ${validationCounts.warnings} warning(s):

${lines.join("\n")}`;
  }, [validationWarnings, validationCounts]);
  const handleValidate = () => {
    validate();
    setShowValidation(true);
  };
  return {
    showValidation,
    setShowValidation,
    validationCounts,
    validationSummary,
    handleValidate,
    hasErrors: validationCounts.errors > 0,
    hasWarnings: validationCounts.warnings > 0
  };
};

const ExecutionPanel = () => {
  const {
    execution
  } = useGraphBlockContext();
  const {
    messages,
    isComplete,
    error,
    clear
  } = execution;
  if (messages.length === 0 && !error) {
    return null;
  }
  return /* @__PURE__ */ jsx(CollapsibleSection, {
    title: "Graph Execution",
    defaultCollapsed: false,
    variant: "card",
    renderHeader: (expanded, onToggle) => /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between w-full",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-3",
        children: [/* @__PURE__ */ jsx(ToggleButton, {
          expanded,
          onToggle,
          variant: "default",
          size: "md"
        }), /* @__PURE__ */ jsxs("h2", {
          className: "text-lg font-semibold",
          children: ["Graph Execution", isComplete && /* @__PURE__ */ jsx("span", {
            className: "ml-2 text-sm text-green-600",
            children: "(Completed)"
          }), error && /* @__PURE__ */ jsx("span", {
            className: "ml-2 text-sm text-red-600",
            children: "(Error)"
          })]
        })]
      }), /* @__PURE__ */ jsx("button", {
        onClick: (e) => {
          e.stopPropagation();
          clear();
        },
        className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
        children: "Clear"
      })]
    }),
    children: /* @__PURE__ */ jsx(SSEMessagesList, {
      messages,
      emptyMessage: "No execution messages yet"
    })
  });
};

const GraphBlockList = () => {
  const validationState = useValidationPanelState();
  return /* @__PURE__ */ jsxs("div", {
    className: "h-full flex flex-col bg-white",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "border-b bg-white sticky top-0 z-10",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "px-6 py-4 flex items-center justify-between",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("h1", {
            className: "text-2xl font-semibold text-gray-900",
            children: "Graph Nodes"
          }), /* @__PURE__ */ jsx("p", {
            className: "text-sm text-gray-500 mt-1",
            children: "Configure your AI agent workflow nodes"
          })]
        }), /* @__PURE__ */ jsx(GraphBlockToolbar, {
          onValidate: validationState.handleValidate
        })]
      }), /* @__PURE__ */ jsx(EntryPointInfo, {}), /* @__PURE__ */ jsx(ExecutionPanel, {}), /* @__PURE__ */ jsx(ValidationPanel, {
        validationState
      })]
    }), /* @__PURE__ */ jsx(BlocksList, {})]
  });
};
const BlocksList = () => {
  const {
    config
  } = useGraphBlockContext();
  if (config.blocks.length === 0) {
    return /* @__PURE__ */ jsx(GraphBlockEmptyState, {});
  }
  return /* @__PURE__ */ jsx("div", {
    className: "max-w-7xl mx-auto px-6 py-4",
    children: /* @__PURE__ */ jsx("div", {
      className: "space-y-3",
      children: config.blocks.map((block) => /* @__PURE__ */ jsx(BlockListItem, {
        blockId: block.id
      }, block.id))
    })
  });
};

const RoutingEditor = ({
  block,
  availableTargets,
  onUpdate
}) => {
  const handleAddCondition = useMemoizedFn(() => {
    const newCondition = {
      field: "",
      operator: "==",
      value: "",
      targetNode: availableTargets[0] && availableTargets[0].id || ""
    };
    onUpdate({
      routing: {
        ...block.routing,
        conditions: [...block.routing.conditions, newCondition]
      }
    });
  });
  const handleUpdateCondition = useMemoizedFn((index, updates) => {
    const conditions = [...block.routing.conditions];
    conditions[index] = {
      ...conditions[index],
      ...updates
    };
    onUpdate({
      routing: {
        ...block.routing,
        conditions
      }
    });
  });
  const handleRemoveCondition = useMemoizedFn((index) => {
    const conditions = block.routing.conditions.filter((_, i) => i !== index);
    onUpdate({
      routing: {
        ...block.routing,
        conditions
      }
    });
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "space-y-4",
    children: [/* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between mb-2",
        children: [/* @__PURE__ */ jsx("label", {
          className: "text-sm font-medium text-gray-700",
          children: "Conditional Routes"
        }), /* @__PURE__ */ jsx("button", {
          onClick: handleAddCondition,
          className: "text-xs text-blue-500 hover:text-blue-700",
          children: "+ Add Condition"
        })]
      }), block.routing.conditions.length === 0 ? /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-400 italic",
        children: "No conditions"
      }) : /* @__PURE__ */ jsx("div", {
        className: "space-y-2",
        children: block.routing.conditions.map((condition, index) => /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2 p-3 bg-gray-50 rounded",
          children: [/* @__PURE__ */ jsx("input", {
            type: "text",
            value: condition.field,
            onChange: (e) => handleUpdateCondition(index, {
              field: e.target.value
            }),
            placeholder: "field",
            className: "flex-1 px-2 py-1 border rounded text-sm"
          }), /* @__PURE__ */ jsxs("select", {
            value: condition.operator,
            onChange: (e) => handleUpdateCondition(index, {
              operator: e.target.value
            }),
            className: "px-2 py-1 border rounded text-sm",
            children: [/* @__PURE__ */ jsx("option", {
              value: "==",
              children: "=="
            }), /* @__PURE__ */ jsx("option", {
              value: "!=",
              children: "!="
            }), /* @__PURE__ */ jsx("option", {
              value: ">",
              children: ">"
            }), /* @__PURE__ */ jsx("option", {
              value: "<",
              children: "<"
            }), /* @__PURE__ */ jsx("option", {
              value: ">=",
              children: ">="
            }), /* @__PURE__ */ jsx("option", {
              value: "<=",
              children: "<="
            }), /* @__PURE__ */ jsx("option", {
              value: "contains",
              children: "contains"
            }), /* @__PURE__ */ jsx("option", {
              value: "exists",
              children: "exists"
            })]
          }), /* @__PURE__ */ jsx("input", {
            type: "text",
            value: condition.value !== null ? String(condition.value) : "",
            onChange: (e) => {
              let value = e.target.value;
              if (value === "true")
                value = true;
              else if (value === "false")
                value = false;
              else if (!isNaN(Number(value)) && value !== "")
                value = Number(value);
              handleUpdateCondition(index, {
                value
              });
            },
            placeholder: "value",
            className: "w-24 px-2 py-1 border rounded text-sm"
          }), /* @__PURE__ */ jsx("span", {
            className: "text-gray-400",
            children: "\u2192"
          }), /* @__PURE__ */ jsxs("select", {
            value: condition.targetNode,
            onChange: (e) => handleUpdateCondition(index, {
              targetNode: e.target.value
            }),
            className: "flex-1 px-2 py-1 border rounded text-sm",
            children: [/* @__PURE__ */ jsx("option", {
              value: "",
              children: "Select target..."
            }), availableTargets.map((target) => /* @__PURE__ */ jsx("option", {
              value: target.id,
              children: target.id
            }, target.id))]
          }), /* @__PURE__ */ jsx("button", {
            onClick: () => handleRemoveCondition(index),
            className: "text-gray-400 hover:text-red-600",
            title: "Remove condition",
            children: "\u2715"
          })]
        }, index))
      })]
    }), /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("label", {
        className: "block text-sm font-medium text-gray-700 mb-2",
        children: "Default Route"
      }), /* @__PURE__ */ jsxs("select", {
        value: block.routing.defaultNode || "",
        onChange: (e) => onUpdate({
          routing: {
            ...block.routing,
            defaultNode: e.target.value || null
          }
        }),
        className: "w-full px-3 py-2 border rounded text-sm",
        children: [/* @__PURE__ */ jsx("option", {
          value: "",
          children: "End execution"
        }), availableTargets.map((target) => /* @__PURE__ */ jsx("option", {
          value: target.id,
          children: target.id
        }, target.id))]
      })]
    })]
  });
};

const FunctionEditor = ({
  functions,
  availableFunctions,
  onChange
}) => {
  const addFunction = () => {
    const newFunction = {
      functionId: availableFunctions[0] && availableFunctions[0].id || "",
      enabled: true,
      config: availableFunctions[0] && availableFunctions[0].config && availableFunctions[0].config.exampleJson || "{}"
    };
    onChange([...functions, newFunction]);
  };
  const updateFunction = (index, updates) => {
    const updated = functions.map((fn, i) => i === index ? {
      ...fn,
      ...updates
    } : fn);
    onChange(updated);
  };
  const removeFunction = (index) => {
    onChange(functions.filter((_, i) => i !== index));
  };
  if (availableFunctions.length === 0) {
    return /* @__PURE__ */ jsx("div", {
      className: "text-sm text-gray-400 italic",
      children: "No functions available (will be loaded from server)"
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "space-y-2",
    children: [functions.map((fn, index) => {
      const definition = availableFunctions.find((d) => d.id === fn.functionId);
      return /* @__PURE__ */ jsx("div", {
        className: "border rounded p-3 bg-gray-50",
        children: /* @__PURE__ */ jsxs("div", {
          className: "flex items-start gap-2",
          children: [/* @__PURE__ */ jsx("input", {
            type: "checkbox",
            checked: fn.enabled,
            onChange: (e) => updateFunction(index, {
              enabled: e.target.checked
            }),
            className: "mt-1"
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex-1",
            children: [/* @__PURE__ */ jsx("select", {
              value: fn.functionId,
              onChange: (e) => updateFunction(index, {
                functionId: e.target.value
              }),
              className: "w-full px-2 py-1 border rounded text-sm mb-2",
              children: availableFunctions.map((def) => /* @__PURE__ */ jsx("option", {
                value: def.id,
                children: def.id
              }, def.id))
            }), definition && /* @__PURE__ */ jsx("div", {
              className: "text-xs text-gray-600 mb-2",
              children: definition.description
            }), /* @__PURE__ */ jsx("textarea", {
              value: fn.config,
              onChange: (e) => updateFunction(index, {
                config: e.target.value
              }),
              placeholder: "Function config (JSON)",
              className: "w-full px-2 py-1 border rounded text-xs font-mono",
              rows: 3
            }), definition && definition.config && /* @__PURE__ */ jsxs("details", {
              className: "mt-2",
              children: [/* @__PURE__ */ jsx("summary", {
                className: "text-xs text-blue-600 cursor-pointer",
                children: "Show example config"
              }), /* @__PURE__ */ jsx("pre", {
                className: "text-xs bg-white p-2 rounded mt-1 overflow-auto",
                children: definition.config.exampleJson
              })]
            })]
          }), /* @__PURE__ */ jsx("button", {
            onClick: () => removeFunction(index),
            className: "text-red-500 hover:text-red-700 text-sm",
            children: "\u2715"
          })]
        })
      }, index);
    }), /* @__PURE__ */ jsx("button", {
      onClick: addFunction,
      className: "text-sm text-blue-500 hover:text-blue-700",
      children: "+ Add Function"
    })]
  });
};

const FunctionsSection = ({
  title,
  description,
  type,
  functions,
  availableFunctions,
  onChange
}) => {
  const providedFields = functions.filter((fn) => fn.enabled).flatMap((fn) => {
    const def = availableFunctions.find((d) => d.id === fn.functionId);
    return def && def.providedFields || [];
  });
  const requiredFields = functions.filter((fn) => fn.enabled).flatMap((fn) => {
    const def = availableFunctions.find((d) => d.id === fn.functionId);
    return def && def.requiredFields || [];
  });
  const colors = type === "pre" ? {
    bg: "bg-purple-50",
    text: "text-purple-900",
    badge: "bg-purple-100 text-purple-800"
  } : {
    bg: "bg-orange-50",
    text: "text-orange-900",
    badge: "bg-orange-100 text-orange-800"
  };
  return /* @__PURE__ */ jsxs("section", {
    children: [/* @__PURE__ */ jsx("h3", {
      className: "text-sm font-semibold mb-3",
      children: title
    }), /* @__PURE__ */ jsx("p", {
      className: "text-xs text-gray-500 mb-3",
      children: description
    }), /* @__PURE__ */ jsx(FunctionEditor, {
      functions,
      availableFunctions,
      onChange
    }), functions.length > 0 && functions.some((fn) => fn.enabled) && /* @__PURE__ */ jsxs("div", {
      className: `mt-3 p-3 ${colors.bg} rounded text-sm space-y-2`,
      children: [requiredFields.length > 0 && /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("div", {
          className: `font-medium ${colors.text} mb-1`,
          children: "Requires from state:"
        }), /* @__PURE__ */ jsx("div", {
          className: "flex flex-wrap gap-2",
          children: [...new Set(requiredFields)].map((field) => /* @__PURE__ */ jsx("code", {
            className: `px-2 py-0.5 ${colors.badge} rounded`,
            children: field
          }, field))
        })]
      }), providedFields.length > 0 && /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("div", {
          className: `font-medium ${colors.text} mb-1`,
          children: "Provides to state:"
        }), /* @__PURE__ */ jsx("div", {
          className: "flex flex-wrap gap-2",
          children: [...new Set(providedFields)].map((field) => /* @__PURE__ */ jsx("code", {
            className: `px-2 py-0.5 ${colors.badge} rounded`,
            children: field
          }, field))
        })]
      })]
    })]
  });
};

const LLMConfigSection = ({
  localBlock,
  metadata,
  handleUpdate
}) => {
  const jsonValidation = validateJSON(localBlock.llm.sampleOutput);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("section", {
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-sm font-semibold mb-3",
        children: "LLM Configuration"
      }), /* @__PURE__ */ jsxs("div", {
        className: "space-y-3",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("label", {
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: "Model"
          }), /* @__PURE__ */ jsx("input", {
            type: "text",
            value: localBlock.llm.model,
            onChange: (e) => handleUpdate({
              llm: {
                ...localBlock.llm,
                model: e.target.value
              }
            }),
            className: "w-full px-3 py-2 border rounded text-sm",
            placeholder: DEFAULT_LLM
          }), /* @__PURE__ */ jsxs("p", {
            className: "text-xs text-gray-500 mt-1",
            children: ["Default: ", DEFAULT_LLM]
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "grid grid-cols-2 gap-3",
          children: [/* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("label", {
              className: "block text-sm font-medium text-gray-700 mb-1",
              children: "Temperature"
            }), /* @__PURE__ */ jsx("input", {
              type: "number",
              value: localBlock.llm.temperature,
              onChange: (e) => handleUpdate({
                llm: {
                  ...localBlock.llm,
                  temperature: parseFloat(e.target.value)
                }
              }),
              min: "0",
              max: "2",
              step: "0.1",
              className: "w-full px-3 py-2 border rounded text-sm"
            })]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("label", {
              className: "block text-sm font-medium text-gray-700 mb-1",
              children: "Max Tokens"
            }), /* @__PURE__ */ jsx("input", {
              type: "number",
              value: localBlock.llm.maxTokens,
              onChange: (e) => handleUpdate({
                llm: {
                  ...localBlock.llm,
                  maxTokens: parseInt(e.target.value)
                }
              }),
              min: "256",
              max: "8192",
              step: "256",
              className: "w-full px-3 py-2 border rounded text-sm"
            })]
          })]
        })]
      })]
    }), /* @__PURE__ */ jsxs("section", {
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-sm font-semibold mb-3",
        children: "Prompts"
      }), /* @__PURE__ */ jsxs("div", {
        className: "space-y-3",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("label", {
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: "System Prompt"
          }), /* @__PURE__ */ jsx("textarea", {
            value: localBlock.llm.systemPrompt,
            onChange: (e) => handleUpdate({
              llm: {
                ...localBlock.llm,
                systemPrompt: e.target.value
              }
            }),
            rows: 4,
            className: "w-full px-3 py-2 border rounded text-sm font-mono",
            placeholder: "You are a helpful assistant..."
          })]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("label", {
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: "User Prompt"
          }), /* @__PURE__ */ jsx("textarea", {
            value: localBlock.llm.userPrompt,
            onChange: (e) => handleUpdate({
              llm: {
                ...localBlock.llm,
                userPrompt: e.target.value
              }
            }),
            rows: 6,
            className: "w-full px-3 py-2 border rounded text-sm font-mono",
            placeholder: "Analyze the following text: {text}"
          }), /* @__PURE__ */ jsxs("p", {
            className: "text-xs text-gray-500 mt-1",
            children: ["Use ", "{variable}", " syntax for state variables"]
          })]
        }), metadata && metadata.requiredVars.length > 0 && /* @__PURE__ */ jsxs("div", {
          className: "p-3 bg-blue-50 rounded text-sm",
          children: [/* @__PURE__ */ jsx("div", {
            className: "font-medium text-blue-900 mb-1",
            children: "Required State Variables:"
          }), /* @__PURE__ */ jsx("div", {
            className: "flex flex-wrap gap-2",
            children: metadata.requiredVars.map((varName) => /* @__PURE__ */ jsx("code", {
              className: "px-2 py-0.5 bg-blue-100 text-blue-800 rounded",
              children: varName
            }, varName))
          })]
        })]
      })]
    }), /* @__PURE__ */ jsxs("section", {
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-sm font-semibold mb-3",
        children: "Sample Output (JSON)"
      }), /* @__PURE__ */ jsxs("div", {
        className: "space-y-3",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("textarea", {
            value: localBlock.llm.sampleOutput,
            onChange: (e) => handleUpdate({
              llm: {
                ...localBlock.llm,
                sampleOutput: e.target.value
              }
            }),
            rows: 8,
            className: `w-full px-3 py-2 border rounded text-sm font-mono ${!jsonValidation.valid ? "border-red-300" : ""}`,
            placeholder: `{
  "entities": [
    { "name": "...", "type": "..." }
  ],
  "summary": "..."
}`
          }), !jsonValidation.valid && jsonValidation.error && /* @__PURE__ */ jsx("p", {
            className: "text-xs text-red-600 mt-1",
            children: jsonValidation.error
          })]
        }), metadata && metadata.providedVars.length > 0 && /* @__PURE__ */ jsxs("div", {
          className: "p-3 bg-green-50 rounded text-sm",
          children: [/* @__PURE__ */ jsx("div", {
            className: "font-medium text-green-900 mb-1",
            children: "Output State Variables:"
          }), /* @__PURE__ */ jsx("div", {
            className: "flex flex-wrap gap-2",
            children: metadata.providedVars.map((varName) => /* @__PURE__ */ jsx("code", {
              className: "px-2 py-0.5 bg-green-100 text-green-800 rounded",
              children: varName
            }, varName))
          })]
        })]
      })]
    })]
  });
};

const createDefaultLLMConfig = () => ({
  ...defaultLLMConfig,
  systemPrompt: "",
  userPrompt: "",
  sampleOutput: ""
});
const useLLMToggle = ({ block, onUpdate }) => {
  const [llmEnabled, setLlmEnabled] = useState(!!block.llm);
  useEffect(() => {
    setLlmEnabled(!!block.llm);
  }, [!block.llm]);
  const toggleLLM = useMemoizedFn((enabled) => {
    setLlmEnabled(enabled);
    if (enabled && !block.llm) {
      onUpdate({ llm: createDefaultLLMConfig() });
    } else if (!enabled && block.llm) {
      onUpdate({ llm: void 0 });
    }
  });
  return {
    llmEnabled,
    toggleLLM
  };
};

const LLMToggleControl = ({
  block,
  onUpdate
}) => {
  const {
    llmEnabled,
    toggleLLM
  } = useLLMToggle({
    block,
    onUpdate
  });
  return /* @__PURE__ */ jsx("section", {
    children: /* @__PURE__ */ jsx("div", {
      className: "p-3 bg-gray-50 rounded border border-gray-200",
      children: /* @__PURE__ */ jsx(Checkbox, {
        checked: llmEnabled,
        onChange: (e) => toggleLLM(e.target.checked),
        label: "Enable LLM",
        helperText: "Use Large Language Model for processing. Disable to run functions only."
      })
    })
  });
};

const BlockEditFormContent = ({
  block,
  allBlocks,
  blockMetadata,
  onUpdate,
  onClose
}) => {
  const [localBlock, setLocalBlock] = useState(block);
  const [isVisualizerOpen, setIsVisualizerOpen] = useState(false);
  const {
    config,
    functionDefinitions
  } = useGraphBlockContext();
  useEffect(() => {
    setLocalBlock(block);
  }, [block]);
  const handleUpdate = useMemoizedFn((updates) => {
    const updated = {
      ...localBlock,
      ...updates
    };
    setLocalBlock(updated);
    onUpdate(updates);
  });
  const metadata = blockMetadata.get(block.id);
  const availableTargets = allBlocks.filter((b) => b.id !== block.id);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col h-full",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between p-4 border-b",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 text-sm",
        children: [/* @__PURE__ */ jsx("button", {
          onClick: onClose,
          className: "text-blue-500 hover:text-blue-700",
          children: "\u2190 Blocks"
        }), /* @__PURE__ */ jsx("span", {
          className: "text-gray-400",
          children: "/"
        }), /* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: localBlock.id
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx("button", {
          onClick: () => setIsVisualizerOpen(true),
          className: "px-3 py-1.5 text-sm bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-50 transition-colors",
          children: "\u{1F4CA} Visualize"
        }), /* @__PURE__ */ jsx("button", {
          onClick: onClose,
          className: "text-gray-400 hover:text-gray-600",
          children: "\u2715"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex-1 overflow-y-auto p-4 space-y-6",
      children: [/* @__PURE__ */ jsxs("section", {
        children: [/* @__PURE__ */ jsx("h3", {
          className: "text-sm font-semibold mb-3",
          children: "Basic Information"
        }), /* @__PURE__ */ jsx("div", {
          className: "space-y-3",
          children: /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("label", {
              className: "block text-sm font-medium text-gray-700 mb-1",
              children: "Block ID"
            }), /* @__PURE__ */ jsx("input", {
              type: "text",
              value: localBlock.id,
              onChange: (e) => handleUpdate({
                id: e.target.value
              }),
              className: "w-full px-3 py-2 border rounded text-sm"
            })]
          })
        })]
      }), /* @__PURE__ */ jsx(LLMToggleControl, {
        block: localBlock,
        onUpdate: handleUpdate
      }), localBlock.llm && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(LLMConfigSection, {
          localBlock,
          metadata,
          handleUpdate
        }), /* @__PURE__ */ jsx(FunctionsSection, {
          title: "Pre-Functions",
          description: localBlock.llm ? "Execute before LLM call to enrich state with context" : "Execute before routing to enrich state with context",
          type: "pre",
          functions: localBlock.preFunctions || [],
          availableFunctions: functionDefinitions,
          onChange: (updated) => handleUpdate({
            preFunctions: updated
          })
        })]
      }), /* @__PURE__ */ jsx(FunctionsSection, {
        title: "Post-Functions",
        description: localBlock.llm ? "Execute after LLM call to process and validate output" : "Execute before routing to process and validate state",
        type: "post",
        functions: localBlock.postFunctions || [],
        availableFunctions: functionDefinitions,
        onChange: (updated) => handleUpdate({
          postFunctions: updated
        })
      }), /* @__PURE__ */ jsxs("section", {
        children: [/* @__PURE__ */ jsx("h3", {
          className: "text-sm font-semibold mb-3",
          children: "Routing"
        }), /* @__PURE__ */ jsx(RoutingEditor, {
          block: localBlock,
          availableTargets,
          onUpdate: handleUpdate
        })]
      })]
    }), /* @__PURE__ */ jsx(GraphVisualizerDialog, {
      isOpen: isVisualizerOpen,
      onClose: () => setIsVisualizerOpen(false),
      config
    })]
  });
};

const GraphBlockEditForm = () => {
  const {
    config,
    selectedBlockId,
    blockMetadata,
    updateBlock,
    selectBlock
  } = useGraphBlockContext();
  const [editingBlock, setEditingBlock] = useState(null);
  useEffect(() => {
    if (selectedBlockId) {
      const block = config.blocks.find((b) => b.id === selectedBlockId);
      if (block) {
        setEditingBlock({
          ...block
        });
      }
    } else {
      setEditingBlock(null);
    }
  }, [!!selectedBlockId]);
  const handleClose = () => {
    setEditingBlock(null);
    selectBlock(null);
  };
  const handleUpdate = (updates) => {
    if (!editingBlock)
      return;
    const updatedBlock = {
      ...editingBlock,
      ...updates
    };
    setEditingBlock(updatedBlock);
    updateBlock(editingBlock.id, updates);
  };
  if (!editingBlock) {
    return /* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-center h-full text-gray-400",
      children: /* @__PURE__ */ jsx("p", {
        children: "Select a block to edit"
      })
    });
  }
  return /* @__PURE__ */ jsx(BlockEditFormContent, {
    block: editingBlock,
    allBlocks: config.blocks,
    blockMetadata,
    onUpdate: handleUpdate,
    onClose: handleClose
  });
};

const GraphBlockEditor = ({
  configId
}) => {
  return /* @__PURE__ */ jsx(GraphBlockProvider, {
    children: /* @__PURE__ */ jsx(GraphConfigPersistenceProvider, {
      configId,
      children: /* @__PURE__ */ jsx(GraphBlockEditorContent, {})
    })
  });
};
const GraphBlockEditorContent = () => {
  const {
    selectedBlockId
  } = useGraphBlockContext();
  return /* @__PURE__ */ jsx("div", {
    className: "h-screen flex flex-col bg-gray-50",
    children: !selectedBlockId ? /* @__PURE__ */ jsx(GraphBlockList, {}) : /* @__PURE__ */ jsx(GraphBlockEditForm, {})
  });
};

const TranslationGraphPanel = ({
  postId
}) => {
  const translate = useGraphTask();
  const [graphConfig, setGraphConfig] = useState(null);
  const graphState = useGraphInitialState(postId);
  const {
    data: post,
    isValidating: isLoadingPost
  } = usePost(postId);
  const complete = translate.complete;
  const finalTranslation = complete && complete.finalTranslation;
  const isTranslating = translate.isCreatingTask || translate.isConnected;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("h1", {
        className: "text-2xl font-semibold",
        children: "Translate Post"
      }), /* @__PURE__ */ jsxs("p", {
        className: "text-gray-600",
        children: ["Post ID: ", postId]
      }), translate.taskExecutionId && /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-gray-500",
        children: ["Task ID: ", translate.taskExecutionId]
      })]
    }), isLoadingPost && /* @__PURE__ */ jsx("div", {
      className: "bg-gray-50 border border-gray-200 rounded-lg p-4",
      children: /* @__PURE__ */ jsx("div", {
        className: "text-gray-500",
        children: "Loading post information..."
      })
    }), post && /* @__PURE__ */ jsx(PostInfoHeader$1, {
      post
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(GraphBlockEditor, {
      configId: postId
    }), /* @__PURE__ */ jsx(GraphStateForm, {
      state: graphState.state,
      onUpdate: graphState.updateState,
      disabled: isTranslating
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(LoadingButtonTW, {
      loading: translate.isCreatingTask || translate.isConnected,
      onClick: () => translate.startGraph({
        input: {
          postId,
          sourceLang: "English",
          targetLang: "Russian",
          domain: "technology"
        },
        data: {
          graphConfig
        }
      }),
      disabled: translate.isCreatingTask || translate.isConnected,
      background: "blue",
      children: translate.isCreatingTask ? "Creating Task..." : "Translate Post"
    }), translate.error && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-sm font-medium text-red-700 mb-2",
        children: "Translation Error:"
      }), /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: translate.error
      })]
    }), /* @__PURE__ */ jsx(TranslationProgressSection, {
      messages: translate.messages,
      isComplete: translate.isComplete,
      onClear: translate.clear
    }), translate.isComplete && /* @__PURE__ */ jsx(FinalTranslationSection$1, {
      finalTranslation
    })]
  });
};

const ExecuteGraphPage = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(TranslationPageInner$1, {})
  });
};
const TranslationPageInner$1 = () => {
  const parts = location.pathname.split("/").filter((v) => v);
  const postId = parts[parts.findIndex((v) => v === "translate-post") + 1];
  const {
    profile
  } = useProfileContext();
  const isInstanceAdmin = useIsInstanceAdmin();
  if (!profile) {
    return null;
  }
  if (!isInstanceAdmin) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-4",
      children: /* @__PURE__ */ jsx("div", {
        className: "bg-yellow-50 border border-yellow-200 rounded-md p-4",
        children: /* @__PURE__ */ jsx("p", {
          className: "text-yellow-800",
          children: "Only instance administrators can manage Elasticsearch indices."
        })
      })
    });
  }
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-4 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(TranslationGraphPanel, {
        postId
      })
    })]
  });
};

const PrototypeInfoBar = ({
  routeSegment,
  routeParam
}) => {
  const {
    addToast
  } = useToast();
  const handleTestToast = () => {
    addToast({
      type: "success",
      title: "Toast works",
      message: `Route: ${routeSegment}${routeParam ? ` \xB7 param: ${routeParam}` : ""}`
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-3 px-3 py-1.5 rounded bg-gray-100 border border-gray-200 text-xs text-gray-500 shrink-0",
    children: [/* @__PURE__ */ jsx("span", {
      className: "font-medium text-gray-700",
      children: "PROTOTYPE"
    }), /* @__PURE__ */ jsx("span", {
      children: "\xB7"
    }), /* @__PURE__ */ jsxs("span", {
      children: ["route: ", /* @__PURE__ */ jsx("code", {
        className: "text-gray-800",
        children: routeSegment
      })]
    }), routeParam ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("span", {
        children: "\xB7"
      }), /* @__PURE__ */ jsxs("span", {
        children: ["param: ", /* @__PURE__ */ jsx("code", {
          className: "text-gray-800",
          children: routeParam
        })]
      })]
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("span", {
        children: "\xB7"
      }), /* @__PURE__ */ jsxs("span", {
        className: "italic text-gray-400",
        children: ["no param \u2014 append /", "{param}", " to URL"]
      })]
    }), /* @__PURE__ */ jsx("span", {
      className: "ml-auto",
      children: /* @__PURE__ */ jsx("button", {
        className: "px-2 py-0.5 rounded border border-gray-300 hover:bg-white transition-colors",
        onClick: handleTestToast,
        children: "test toast"
      })
    })]
  });
};

const BookCairPrototypePage = (props) => /* @__PURE__ */ jsx(SWRProfileContextProvider, {
  children: /* @__PURE__ */ jsx(ProfileCDNImageContextProvider, {
    children: /* @__PURE__ */ jsx(BookCairPrototypePageInner, {
      ...props
    })
  })
});
const BookCairPrototypePageInner = ({
  routeSegment,
  children
}) => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const segIdx = parts.findIndex((v) => v === routeSegment);
  const postId = segIdx !== -1 ? parts[segIdx + 1] : void 0;
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(FullViewportCssOverrides, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns p-2 h-full flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx(PrototypeInfoBar, {
        routeSegment,
        routeParam: postId
      }), /* @__PURE__ */ jsx("div", {
        className: "flex-1 min-h-0 overflow-auto",
        children: children(postId)
      })]
    })]
  });
};

const TooltipBubble = ({
  text,
  arrowOffset = 30,
  width = 240,
  className
}) => /* @__PURE__ */ jsxs("div", {
  className: `flex flex-col items-end ${className || ""}`,
  style: {
    width,
    filter: "drop-shadow(0px 4px 6px rgba(0,0,0,0.03)) drop-shadow(0px 12px 16px rgba(0,0,0,0.08))"
  },
  children: [/* @__PURE__ */ jsx("div", {
    className: "w-full bg-[var(--cair-surface-elevated)] rounded-[var(--cair-radius-md)] px-[12px] py-[8px]",
    children: /* @__PURE__ */ jsx("p", {
      className: "text-[length:var(--cair-text-small)] text-[color:var(--cair-text)] font-normal leading-[1.75]",
      children: text
    })
  }), /* @__PURE__ */ jsx("div", {
    style: {
      marginRight: arrowOffset,
      width: 0,
      height: 0,
      borderLeft: "6px solid transparent",
      borderRight: "6px solid transparent",
      borderTop: "6px solid var(--cair-surface-elevated)"
    }
  })]
});

const NewBookCard = ({
  book,
  onBack,
  onReadSummary,
  onContinueReading,
  isLoading
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col gap-[20px] items-start w-full",
  children: [/* @__PURE__ */ jsxs("div", {
    className: "bg-[var(--cair-surface-elevated)] border-b border-[var(--cair-border-strong)] flex gap-[16px] items-center pb-[13px] pl-[16px] pr-[24px] pt-[12px] rounded-[var(--cair-radius-lg)] shadow-[var(--cair-shadow-sm)] w-full",
    children: [/* @__PURE__ */ jsx("button", {
      onClick: onBack,
      className: "shrink-0 w-[24px] h-[24px] flex items-center justify-center",
      "aria-label": "Back",
      children: /* @__PURE__ */ jsx(MdChevronLeft, {
        size: 24,
        className: "text-[color:var(--cair-text)]"
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "border-l border-[var(--cair-border)] flex-1 min-w-0 pl-[24px]",
      children: /* @__PURE__ */ jsx("span", {
        className: "font-normal text-[length:var(--cair-text-large)] text-[color:var(--cair-text)] leading-[1.75]",
        children: "Back to Chat AI"
      })
    })]
  }), /* @__PURE__ */ jsxs("div", {
    className: "bg-[var(--cair-surface-elevated)] border-b border-[var(--cair-border-strong)] flex flex-col gap-[16px] items-center pb-[17px] pt-[20px] px-[24px] rounded-[var(--cair-radius-lg)] shadow-[var(--cair-shadow-sm)] w-full",
    children: [book.requiresPurchase && /* @__PURE__ */ jsx("div", {
      className: "bg-[#e6f7ff] border border-[#69c0ff] rounded-[4px]",
      children: /* @__PURE__ */ jsx("div", {
        className: "px-[10px] py-[4px]",
        children: /* @__PURE__ */ jsx("span", {
          className: "font-semibold text-[length:var(--cair-text-tiny)] text-[#096dd9] leading-[1.5] whitespace-nowrap",
          children: "Full access requires a purchase"
        })
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col items-start w-full",
      children: [/* @__PURE__ */ jsx("p", {
        className: "font-medium text-[length:var(--cair-text-large)] text-[color:var(--cair-accent)] leading-[1.75] text-center w-full",
        children: book.title
      }), book.subtitle && /* @__PURE__ */ jsx("p", {
        className: "font-normal text-[length:var(--cair-text-small)] text-[color:var(--cair-text-secondary)] leading-[1.5] text-center w-full",
        children: book.subtitle
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[12px] items-center w-full",
      children: [/* @__PURE__ */ jsx(ActionButton, {
        intent: "cairSubtle",
        size: "md",
        rounded: "sm",
        className: "w-full max-w-[303px] h-[40px]",
        onClick: onReadSummary,
        disabled: isLoading,
        children: "Read Free Summary"
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "md",
        rounded: "sm",
        className: "w-full max-w-[303px] h-[40px]",
        onClick: onContinueReading,
        isLoading,
        loadingText: "Opening\u2026",
        children: "Continue Reading"
      })]
    })]
  })]
});

const ShowcaseSection = ({
  title,
  children
}) => /* @__PURE__ */ jsxs("section", {
  className: "flex flex-col gap-[16px] py-[24px] border-b border-[var(--cair-border)]",
  children: [/* @__PURE__ */ jsx("h2", {
    className: "text-[length:var(--cair-text-small)] font-semibold text-[color:var(--cair-text-secondary)] uppercase tracking-widest px-[16px]",
    children: title
  }), /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-[16px] px-[16px]",
    children
  })]
});
const Row$1 = ({
  children
}) => /* @__PURE__ */ jsx("div", {
  className: "flex flex-row flex-wrap gap-[12px] items-start",
  children
});
const MOCK_SEARCH_RESULTS$1 = [{
  id: "1",
  title: "1.1  Research Frameworks",
  location: "L53"
}, {
  id: "2",
  title: "3.1 Quantitative Research Frameworks",
  location: "L82"
}, {
  id: "3",
  title: "3.2 Qualitative Research Frameworks",
  location: "L16"
}];
const MOCK_AI_REFS$1 = [{
  id: "1",
  excerpt: "The foundation of rigorous academic research lies in the careful selection of methodological frameworks.",
  location: "Chapter 3 \xB7 L12"
}, {
  id: "2",
  excerpt: "Mixed-method designs provide a more comprehensive understanding of complex phenomena.",
  location: "Chapter 3 \xB7 L82"
}];
const BookCairShowcase = () => {
  const [speaking, setSpeaking] = useState(false);
  const [freeDialOpen, setFreeDialOpen] = useState(true);
  const [paidDialOpen, setPaidDialOpen] = useState(false);
  const [audioPlaying, setAudioPlaying] = useState(false);
  const snackbar = useCairSnackbar();
  const [bookmarkName, setBookmarkName] = useState("");
  const [noteText, setNoteText] = useState("");
  const [langCode, setLangCode] = useState("en");
  useState(false);
  const [aiQuery, setAiQuery] = useState("");
  const [aiState, setAiState] = useState({
    phase: "idle"
  });
  const [searchQuery, setSearchQuery] = useState("Research");
  const handleAiSubmit = () => setAiState({
    phase: "answer-ref",
    answer: "Academic research frameworks guide inquiry, data collection, and interpretation. Mixed-method approaches integrate quantitative and qualitative methods to provide comprehensive insight.",
    refs: MOCK_AI_REFS$1
  });
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "min-h-screen bg-[var(--cair-surface)] flex flex-col",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "px-[16px] py-[20px] border-b border-[var(--cair-border-strong)]",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-large)] font-semibold text-[color:var(--cair-accent)]",
          children: "Book CAIR \u2014 Component Showcase"
        }), /* @__PURE__ */ jsx("p", {
          className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)] mt-[4px]",
          children: "Prototype only \u2014 not a production screen"
        })]
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Tokens \u2014 Colour Palette",
        children: /* @__PURE__ */ jsx(Row$1, {
          children: [["--cair-accent", "accent"], ["--cair-accent-subtle", "accent-subtle"], ["--cair-premium", "premium"], ["--cair-premium-subtle", "premium-subtle"], ["--cair-surface", "surface"], ["--cair-surface-elevated", "elevated"], ["--cair-border", "border"], ["--cair-border-strong", "border-strong"], ["--cair-text", "text"], ["--cair-text-secondary", "text-secondary"]].map(([token, label]) => /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-[4px] items-center",
            children: [/* @__PURE__ */ jsx("div", {
              className: "w-[48px] h-[48px] rounded-[var(--cair-radius-md)] border border-[var(--cair-border)]",
              style: {
                background: `var(${token})`
              }
            }), /* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)]",
              children: label
            })]
          }, token))
        })
      }), /* @__PURE__ */ jsxs(ShowcaseSection, {
        title: "Controls \u2014 ActionButton (CAIR variants)",
        children: [/* @__PURE__ */ jsxs(Row$1, {
          children: [/* @__PURE__ */ jsx(ActionButton, {
            intent: "cairPrimary",
            size: "md",
            rounded: "sm",
            children: "cairPrimary md"
          }), /* @__PURE__ */ jsx(ActionButton, {
            intent: "cairDefault",
            size: "md",
            rounded: "sm",
            children: "cairDefault md"
          }), /* @__PURE__ */ jsx(ActionButton, {
            intent: "cairSubtle",
            size: "md",
            rounded: "sm",
            children: "cairSubtle md"
          })]
        }), /* @__PURE__ */ jsxs(Row$1, {
          children: [/* @__PURE__ */ jsx(ActionButton, {
            intent: "cairPrimary",
            size: "xs",
            rounded: "sm",
            children: "cairPrimary xs"
          }), /* @__PURE__ */ jsx(ActionButton, {
            intent: "cairDefault",
            size: "xs",
            rounded: "sm",
            children: "cairDefault xs"
          }), /* @__PURE__ */ jsx(ActionButton, {
            intent: "cairSubtle",
            size: "xs",
            rounded: "sm",
            children: "cairSubtle xs"
          })]
        })]
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Controls \u2014 SpeakButton",
        children: /* @__PURE__ */ jsx(Row$1, {
          children: /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col items-center gap-[8px]",
            children: [/* @__PURE__ */ jsx(SpeakButton, {
              onClick: () => setSpeaking(true)
            }), /* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)]",
              children: "inactive"
            })]
          })
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Controls \u2014 SettingsMenuItem",
        children: /* @__PURE__ */ jsxs("div", {
          className: "border border-[var(--cair-border)] rounded-[var(--cair-radius-md)] overflow-hidden",
          children: [/* @__PURE__ */ jsx(SettingsMenuItem, {
            icon: /* @__PURE__ */ jsx(MdSettings, {
              size: 24
            }),
            label: "Reader Preferences",
            onClick: () => void 0
          }), /* @__PURE__ */ jsx(SettingsMenuItem, {
            icon: /* @__PURE__ */ jsx(MdTranslate, {
              size: 24
            }),
            label: "Language & Translation",
            onClick: () => void 0
          }), /* @__PURE__ */ jsx(SettingsMenuItem, {
            icon: /* @__PURE__ */ jsx(MdSearch, {
              size: 24
            }),
            label: "Search in Book",
            onClick: () => void 0,
            divider: false
          })]
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Controls \u2014 FloatingActionsDial (generic)",
        children: /* @__PURE__ */ jsx(Row$1, {
          children: /* @__PURE__ */ jsx(FloatingActionsDial, {
            open: false,
            onToggle: () => void 0,
            actions: [{
              key: "settings",
              icon: /* @__PURE__ */ jsx(MdSettings, {
                size: 20
              }),
              label: "Settings",
              onClick: () => void 0
            }, {
              key: "search",
              icon: /* @__PURE__ */ jsx(MdSearch, {
                size: 20
              }),
              label: "Search",
              onClick: () => void 0
            }, {
              key: "bookmark",
              icon: /* @__PURE__ */ jsx(MdBookmark, {
                size: 20
              }),
              label: "Bookmark",
              onClick: () => void 0
            }]
          })
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Controls \u2014 AccessTypeIcon",
        children: /* @__PURE__ */ jsx(Row$1, {
          children: ["free", "support", "locked", "institutional", "collection"].map((t) => /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col items-center gap-[6px]",
            children: [/* @__PURE__ */ jsx(AccessTypeIcon, {
              type: t
            }), /* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-tertiary)]",
              children: t
            })]
          }, t))
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Display \u2014 BookCover",
        children: /* @__PURE__ */ jsxs(Row$1, {
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-[4px] items-center",
            children: [/* @__PURE__ */ jsx(BookCover, {
              height: 120,
              width: 80,
              radius: "sm"
            }), /* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)]",
              children: "no image"
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-[4px] items-center",
            children: [/* @__PURE__ */ jsx(BookCover, {
              height: 160,
              width: 107,
              radius: "sm"
            }), /* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)]",
              children: "large"
            })]
          })]
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Display \u2014 BookCard",
        children: /* @__PURE__ */ jsxs(Row$1, {
          children: [/* @__PURE__ */ jsx(BookCard, {
            title: "Advanced Research Methods",
            author: "Dr. Sarah Mitchell",
            progressPercent: 42
          }), /* @__PURE__ */ jsx(BookCard, {
            title: "The Philosophy of Science",
            author: "Karl Popper",
            progressPercent: 0
          })]
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Display \u2014 ContinueReadingCard",
        children: /* @__PURE__ */ jsx(ContinueReadingCard, {
          title: "Advanced Research Methods",
          author: "Dr. Sarah Mitchell",
          chapterTitle: "Chapter 3: Methodological Frameworks",
          progressPercent: 42,
          onContinue: () => void 0
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Display \u2014 AchievementBadge",
        children: /* @__PURE__ */ jsxs(Row$1, {
          children: [MOCK_ACHIEVEMENTS.map((a) => /* @__PURE__ */ jsx(AchievementBadge, {
            icon: /* @__PURE__ */ jsx(MdMenuBook, {
              size: 24
            }),
            title: a.title,
            description: a.description,
            unlocked: a.unlocked
          }, a.id)), /* @__PURE__ */ jsx(AchievementBadge, {
            icon: /* @__PURE__ */ jsx(MdMenuBook, {
              size: 24
            }),
            title: "Scholar",
            description: "Complete 10 books",
            unlocked: false
          })]
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Display \u2014 WeekStreakBar",
        children: /* @__PURE__ */ jsx(WeekStreakBar, {
          days: MOCK_STREAK_DAYS,
          label: "This Week",
          summary: "5 of 7 days"
        })
      }), /* @__PURE__ */ jsxs(ShowcaseSection, {
        title: "Feedback \u2014 ReadingProgressBar",
        children: [/* @__PURE__ */ jsx(ReadingProgressBar, {
          percent: 68,
          variant: "accent",
          height: 4,
          label: "accent 4px",
          showPercent: true
        }), /* @__PURE__ */ jsx(ReadingProgressBar, {
          percent: 68,
          variant: "accent",
          height: 6,
          label: "accent 6px",
          showPercent: true
        }), /* @__PURE__ */ jsx(ReadingProgressBar, {
          percent: 68,
          variant: "premium",
          height: 8,
          label: "premium 8px",
          showPercent: true
        })]
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Feedback \u2014 TooltipBubble",
        children: /* @__PURE__ */ jsx(TooltipBubble, {
          text: "Tap to hear this chapter read aloud",
          arrowOffset: 30
        })
      }), /* @__PURE__ */ jsxs(ShowcaseSection, {
        title: "Feedback \u2014 CairSnackbar",
        children: [/* @__PURE__ */ jsx(Row$1, {
          children: ["success", "error", "info", "warning"].map((t) => /* @__PURE__ */ jsxs("button", {
            onClick: () => snackbar.show(t, `${t.charAt(0).toUpperCase() + t.slice(1)} message`),
            className: "px-[12px] h-[32px] bg-[var(--cair-accent-subtle)] border border-[var(--cair-border)] rounded-[var(--cair-radius-md)] text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-accent)]",
            children: ["Show ", t]
          }, t))
        }), /* @__PURE__ */ jsx("div", {
          className: "min-h-[40px] flex items-center",
          children: /* @__PURE__ */ jsx(CairSnackbar, {
            ...snackbar.props
          })
        })]
      }), /* @__PURE__ */ jsxs(ShowcaseSection, {
        title: "Layout \u2014 SectionHeader",
        children: [/* @__PURE__ */ jsx(SectionHeader$1, {
          title: "My Library",
          action: {
            label: "See all",
            onClick: () => void 0
          }
        }), /* @__PURE__ */ jsx(SectionHeader$1, {
          title: "Achievements"
        })]
      }), /* @__PURE__ */ jsxs(ShowcaseSection, {
        title: "Layout \u2014 PageHeader",
        children: [/* @__PURE__ */ jsx("div", {
          className: "border border-[var(--cair-border)] rounded-[var(--cair-radius-md)] overflow-hidden",
          children: /* @__PURE__ */ jsx(PageHeader, {
            title: "Account Settings",
            subtitle: "Manage your personal info",
            onBack: () => void 0
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "border border-[var(--cair-border)] rounded-[var(--cair-radius-md)] overflow-hidden",
          children: /* @__PURE__ */ jsx(PageHeader, {
            title: "My Library"
          })
        })]
      }), /* @__PURE__ */ jsxs(ShowcaseSection, {
        title: "Layout \u2014 ReaderTopBar",
        children: [/* @__PURE__ */ jsx("div", {
          className: "border border-[var(--cair-border)] rounded-[var(--cair-radius-md)] overflow-hidden",
          children: /* @__PURE__ */ jsx(ReaderTopBar, {
            bookTitle: "Advanced Research Methods",
            chapterTitle: "Chapter 3: Methodological Frameworks",
            onExit: () => void 0,
            onShare: () => void 0
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "border border-[var(--cair-border)] rounded-[var(--cair-radius-md)] overflow-hidden",
          children: /* @__PURE__ */ jsx(ReaderTopBar, {
            bookTitle: "Advanced Research Methods",
            chapterTitle: "Chapter 3: Methodological Frameworks",
            locked: true,
            onViewDetails: () => void 0,
            onExit: () => void 0,
            onShare: () => void 0
          })
        })]
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Layout \u2014 AudioPlayerDock",
        children: /* @__PURE__ */ jsx("div", {
          className: "border border-[var(--cair-border)] rounded-[var(--cair-radius-md)] overflow-hidden",
          children: /* @__PURE__ */ jsx(AudioPlayerDock, {
            title: "Chapter 3: Methodological Frameworks",
            currentTime: "12:34",
            duration: "45:22",
            progress: 28,
            playing: audioPlaying,
            onPlayPause: () => setAudioPlaying((v) => !v),
            onSkipBack: () => void 0,
            onSkipForward: () => void 0,
            onSpeedChange: () => void 0,
            onSeek: () => void 0
          })
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Layout \u2014 AddBookmarkPanel",
        children: /* @__PURE__ */ jsx(AddBookmarkPanel, {
          name: bookmarkName,
          onChange: setBookmarkName,
          onSave: () => snackbar.show("success", "Bookmark added"),
          onClose: () => void 0
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Layout \u2014 AddNotePanel",
        children: /* @__PURE__ */ jsx(AddNotePanel, {
          text: noteText,
          onChange: setNoteText,
          onSave: () => snackbar.show("success", "Note saved"),
          onClose: () => void 0
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Layout \u2014 ReaderPreferencesPanel",
        children: /* @__PURE__ */ jsx(ReaderPreferencesPanel, {
          onClose: () => void 0
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Layout \u2014 LanguageTranslationPanel",
        children: /* @__PURE__ */ jsx(LanguageTranslationPanel, {
          selectedCode: langCode,
          onSelectLanguage: setLangCode,
          onSave: () => snackbar.show("success", "Language saved"),
          onClose: () => void 0
        })
      }), /* @__PURE__ */ jsxs(ShowcaseSection, {
        title: "Layout \u2014 AskAiPanel",
        children: [/* @__PURE__ */ jsx(AskAiPanel, {
          query: aiQuery,
          onQueryChange: setAiQuery,
          onSubmit: handleAiSubmit,
          state: aiState,
          onToggleVoice: () => void 0,
          onClose: () => setAiState({
            phase: "idle"
          })
        }), aiState.phase !== "idle" && /* @__PURE__ */ jsx("button", {
          onClick: () => {
            setAiState({
              phase: "idle"
            });
            setAiQuery("");
          },
          className: "text-[length:var(--cair-text-small)] text-[color:var(--cair-text-secondary)] underline",
          children: "Reset to idle"
        })]
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Layout \u2014 SearchPanel",
        children: /* @__PURE__ */ jsx(SearchPanel, {
          query: searchQuery,
          onQueryChange: setSearchQuery,
          onSearch: () => void 0,
          results: searchQuery.trim().length > 0 ? MOCK_SEARCH_RESULTS$1 : [],
          onSelectResult: () => void 0,
          onClose: () => void 0
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Domain \u2014 ReaderActionsDial (free / paid)",
        children: /* @__PURE__ */ jsxs(Row$1, {
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-[8px] items-start",
            children: [/* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)]",
              children: "free tier"
            }), /* @__PURE__ */ jsx(ReaderActionsDial, {
              tier: "free",
              open: freeDialOpen,
              onToggle: () => setFreeDialOpen((v) => !v),
              onSettings: () => void 0,
              onTranslate: () => void 0
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-[8px] items-start",
            children: [/* @__PURE__ */ jsx("span", {
              className: "text-[length:var(--cair-text-tiny)] text-[color:var(--cair-text-secondary)]",
              children: "paid tier (interactive)"
            }), /* @__PURE__ */ jsx(ReaderActionsDial, {
              tier: "paid",
              open: paidDialOpen,
              onToggle: () => setPaidDialOpen((v) => !v),
              onSettings: () => void 0,
              onTranslate: () => void 0,
              onSearch: () => void 0,
              onAskAi: () => void 0,
              onToc: () => void 0,
              onSave: () => void 0
            })]
          })]
        })
      }), /* @__PURE__ */ jsx(ShowcaseSection, {
        title: "Domain \u2014 NewBookCard",
        children: /* @__PURE__ */ jsx(NewBookCard, {
          book: {
            title: "Advanced Research Methods",
            subtitle: "Chapter 3: Methodological Frameworks",
            requiresPurchase: true
          },
          onBack: () => void 0,
          onReadSummary: () => snackbar.show("info", "Opening summary\u2026"),
          onContinueReading: () => snackbar.show("info", "Opening reader\u2026")
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "h-[40px]"
      })]
    })
  });
};

const BookCairShowcasePage = () => {
  return /* @__PURE__ */ jsx(BookCairPrototypePage, {
    routeSegment: "book-cair-showcase",
    children: () => /* @__PURE__ */ jsx(BookCairShowcase, {})
  });
};

const BookCairDashboardPage = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-dashboard",
  children: (circleId) => /* @__PURE__ */ jsx(BookCairDashboardScreen, {
    circleId
  })
});

const MOCK_SEARCH_RESULTS = [{
  id: "1",
  title: "1.1  Research Frameworks",
  location: "L53"
}, {
  id: "2",
  title: "3.1 Quantitative Research Frameworks",
  location: "L82"
}, {
  id: "3",
  title: "3.2 Qualitative Research Frameworks",
  location: "L16"
}];
const MOCK_AI_REFS = [{
  id: "1",
  excerpt: "The foundation of rigorous academic research lies in the careful selection of appropriate methodological frameworks.",
  location: "Chapter 3 \xB7 L53"
}, {
  id: "2",
  excerpt: "Mixed-method approaches integrate quantitative and qualitative methods for comprehensive insight.",
  location: "Chapter 3 \xB7 L82"
}];
const MOCK_CHAPTERS = [{
  id: "ch1",
  title: "Chapter 1: Introduction to Research Methods",
  pages: 45,
  audioTime: "1h 15m",
  isRead: true
}, {
  id: "ch2",
  title: "Chapter 2: Literature Review",
  pages: 38,
  audioTime: "58m",
  isRead: true
}, {
  id: "ch3",
  title: "Chapter 3: Methodological Frameworks",
  pages: 52,
  audioTime: "1h 22m",
  isCurrent: true,
  sections: [{
    id: "s1",
    title: "3.1 Quantitative Research Frameworks"
  }, {
    id: "s2",
    title: "3.2 Qualitative Research Frameworks"
  }, {
    id: "s3",
    title: "3.3 Mixed-Method Approaches"
  }, {
    id: "s4",
    title: "3.4 Framework Selection Criteria"
  }]
}];
const MOCK_BOOKMARKS = [{
  id: "bm1",
  name: "Bookmark name here",
  chapterLabel: "Ch-2"
}, {
  id: "bm2",
  name: "Bookmark name here",
  chapterLabel: "Ch-3"
}, {
  id: "bm3",
  name: "Bookmark name here",
  chapterLabel: "Ch-1"
}];
const MOCK_NOTES = [{
  id: "n1",
  name: "Note name here",
  chapterLabel: "Ch-2"
}, {
  id: "n2",
  name: "Note name here",
  chapterLabel: "Ch-3"
}, {
  id: "n3",
  name: "Note name here",
  chapterLabel: "Ch-1"
}];
const BookCairReaderMobileScreen = (_props) => {
  useReaderLayoutMode("mobile");
  const noop = () => void 0;
  const [dialOpen, setDialOpen] = useState(false);
  const [ttsActive, setTtsActive] = useState(false);
  const [ttsPlaying, setTtsPlaying] = useState(false);
  const [activePanel, setActivePanel] = useState("returning");
  const openPanel = useMemoizedFn((panel) => {
    setDialOpen(false);
    setActivePanel(panel);
    clearSelection();
  });
  const closePanel = useMemoizedFn(() => setActivePanel(null));
  const {
    selectionPos,
    handleTextSelect,
    clearSelection
  } = useTextSelection();
  const snackbar = useCairSnackbar();
  const [searchQuery, setSearchQuery] = useState("");
  const [aiQuery, setAiQuery] = useState("");
  const [aiState, setAiState] = useState({
    phase: "idle"
  });
  const handleAiSubmit = useMemoizedFn(() => {
    if (!aiQuery.trim())
      return;
    setAiState({
      phase: "answer-ref",
      answer: "Academic research frameworks guide the process of inquiry, data collection, and interpretation. Mixed-method approaches integrate quantitative and qualitative methods for comprehensive insight.",
      refs: MOCK_AI_REFS
    });
  });
  const handleAiClose = useMemoizedFn(() => {
    setAiQuery("");
    setAiState({
      phase: "idle"
    });
    closePanel();
  });
  const [langCode, setLangCode] = useState("en");
  useState(false);
  const handleSaveLang = useMemoizedFn(() => {
    closePanel();
    snackbar.show("success", "Language saved");
  });
  const [bookmarkName, setBookmarkName] = useState("");
  const handleSaveBookmark = useMemoizedFn(() => {
    closePanel();
    setBookmarkName("");
    snackbar.show("success", "Bookmark added");
  });
  const [noteText, setNoteText] = useState("");
  const handleSaveNote = useMemoizedFn(() => {
    closePanel();
    setNoteText("");
    snackbar.show("success", "Note saved");
  });
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "relative flex flex-col h-full overflow-hidden bg-[var(--cair-surface)]",
      children: [/* @__PURE__ */ jsx("div", {
        className: "absolute top-0 left-0 right-0 z-30 pointer-events-none",
        children: /* @__PURE__ */ jsx(ReadingProgressBar, {
          variant: "premium",
          percent: readerMock.progressPercent
        })
      }), /* @__PURE__ */ jsx(ReaderTopBar, {
        bookTitle: readerMock.bookTitle,
        chapterTitle: readerMock.chapterTitle,
        locked: true,
        onExit: noop,
        onShare: noop,
        onViewDetails: () => openPanel("details")
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 overflow-y-auto relative",
        onMouseUp: handleTextSelect,
        onTouchEnd: handleTextSelect,
        children: [readerMock.pages.map((page, i) => /* @__PURE__ */ jsxs("div", {
          className: "px-[24px] py-[20px] border-b border-[var(--cair-border)]",
          children: [page.heading && /* @__PURE__ */ jsx("h2", {
            className: "font-semibold text-[length:var(--cair-text-regular)] text-[color:var(--cair-accent)] leading-[1.75] mb-[12px]",
            children: page.heading
          }), page.paragraphs.map((para, j) => /* @__PURE__ */ jsx("p", {
            className: "font-normal text-[length:var(--cair-text-small)] text-[color:var(--cair-text)] leading-[1.75] mb-[16px] last:mb-0",
            children: para
          }, j))]
        }, i)), /* @__PURE__ */ jsx("div", {
          className: "h-[140px]"
        }), selectionPos && /* @__PURE__ */ jsx("div", {
          "data-selection-menu": true,
          className: "absolute z-20",
          style: {
            top: selectionPos.top,
            left: selectionPos.left
          },
          onMouseUp: (e) => e.stopPropagation(),
          children: /* @__PURE__ */ jsx(SelectionMenu, {
            onAskAi: () => openPanel("askAi"),
            onBookmark: () => openPanel("bookmark"),
            onNote: () => openPanel("note")
          })
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "absolute right-[12px] top-[128px] z-10",
        children: /* @__PURE__ */ jsx(ReaderActionsDial, {
          tier: "paid",
          open: dialOpen,
          onToggle: () => setDialOpen((v) => !v),
          onSearch: () => openPanel("search"),
          onAskAi: () => openPanel("askAi"),
          onSettings: () => openPanel("settings"),
          onTranslate: () => openPanel("translate"),
          onToc: () => openPanel("toc"),
          onSave: () => openPanel("bookmark")
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "absolute right-[12px] bottom-[96px] z-10",
        children: /* @__PURE__ */ jsx(SpeakButton, {
          onClick: () => setTtsActive((v) => !v)
        })
      }), /* @__PURE__ */ jsx("div", {
        className: "absolute bottom-[90px] left-0 right-0 z-10 flex justify-center pointer-events-none",
        children: /* @__PURE__ */ jsx(CairSnackbar, {
          ...snackbar.props
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "returning",
        onClose: closePanel,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(ReturningBanner, {
          userName: "Ahmed",
          bookTitle: readerMock.bookTitle,
          chapterTitle: readerMock.chapterTitle,
          lastReadLabel: "3 days ago",
          onBackToLibrary: closePanel,
          onStartFromBeginning: closePanel,
          onPickUpWhereLeftOff: closePanel
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "details",
        onClose: closePanel,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(BookDetailsPanel, {
          title: readerMock.bookTitle,
          author: "Yuval Noah Harari",
          publisher: "Oxford University Press",
          year: "2023",
          language: "English",
          accessType: "locked",
          onUnlock: noop,
          onReadSummary: noop,
          onClose: closePanel
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "search",
        onClose: closePanel,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(SearchPanel, {
          query: searchQuery,
          onQueryChange: setSearchQuery,
          onSearch: noop,
          results: searchQuery.trim().length > 0 ? MOCK_SEARCH_RESULTS : [],
          onSelectResult: closePanel,
          onClose: closePanel
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "askAi",
        onClose: handleAiClose,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(AskAiPanel, {
          query: aiQuery,
          onQueryChange: setAiQuery,
          onSubmit: handleAiSubmit,
          state: aiState,
          onToggleVoice: () => setTtsActive((v) => !v),
          onClose: handleAiClose
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "settings",
        onClose: closePanel,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(ReaderPreferencesPanel, {
          onClose: closePanel
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "translate",
        onClose: closePanel,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(LanguageTranslationPanel, {
          selectedCode: langCode,
          onSelectLanguage: setLangCode,
          onSave: handleSaveLang,
          onClose: closePanel
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "toc",
        onClose: closePanel,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(ContentPanel, {
          chapters: MOCK_CHAPTERS,
          bookmarks: MOCK_BOOKMARKS,
          notes: MOCK_NOTES,
          onContinueReading: closePanel,
          onSearch: () => openPanel("search"),
          onClose: closePanel
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "bookmark",
        onClose: closePanel,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(AddBookmarkPanel, {
          name: bookmarkName,
          onChange: setBookmarkName,
          onSave: handleSaveBookmark,
          onClose: closePanel
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: activePanel === "note",
        onClose: closePanel,
        placement: "bottom",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(AddNotePanel, {
          text: noteText,
          onChange: setNoteText,
          onSave: handleSaveNote,
          onClose: closePanel
        })
      }), /* @__PURE__ */ jsx(AudioPlayerDock, {
        title: readerMock.chapterTitle,
        currentTime: readerMock.ttsCurrentTime,
        duration: readerMock.ttsDuration,
        progress: readerMock.ttsProgress,
        playing: ttsPlaying,
        onPlayPause: () => setTtsPlaying((v) => !v),
        onSkipBack: noop,
        onSkipForward: noop,
        onSpeedChange: noop,
        onSeek: noop
      })]
    })
  });
};

const BookCairReaderMobilePage = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-mobile",
  children: (circleId) => /* @__PURE__ */ jsx(BookCairReaderMobileScreen, {
    circleId
  })
});

const noop$7 = () => void 0;
function navigateToSubscriptions() {
  var pathname = window.location.pathname;
  var idx = pathname.indexOf("/book-cair-profile");
  var prefix = idx >= 0 ? pathname.substring(0, idx) : pathname;
  window.location.href = prefix + "/book-cair-purchases/";
}
const BookCairProfilePageInner = () => /* @__PURE__ */ jsx(BookCairProfileScreen, {
  onBack: noop$7,
  onAccountSettings: noop$7,
  onReadingPreferences: noop$7,
  onSubscriptions: navigateToSubscriptions,
  onPrivacy: noop$7
});
const BookCairProfilePage = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-profile",
  children: () => /* @__PURE__ */ jsx(BookCairProfilePageInner, {})
});

const SHARED_PARAS = [`The foundation of rigorous academic research lies in the careful selection
   and application of appropriate methodological frameworks. These frameworks
   provide researchers with a structured approach to inquiry, guiding decisions
   about research design, data collection, and analysis methods.`, `Quantitative research methods emphasise the collection and analysis of
   numerical data, enabling researchers to identify patterns, test hypotheses,
   and generalise findings across larger populations. Statistical rigour is
   central to this tradition.`, `Qualitative approaches prioritise depth of understanding over breadth,
   exploring meaning, context, and lived experience. Methods such as interviews,
   ethnography, and thematic analysis are hallmarks of this tradition.`, `Mixed-method designs integrate both paradigms, recognising that complex
   research questions often require multiple lenses. The sequencing and weighting
   of methods within a mixed design demands careful justification.`, `Framework selection is ultimately driven by the research question, the nature
   of the phenomenon under investigation, available resources, and the
   epistemological stance of the researcher. No single framework is universally
   superior.`];
const OBSERVER_OPTIONS = {
  rootMargin: "-5% 0px -70% 0px",
  threshold: 0
};
const BookCairDesktopReadingArea = ({
  contentLanguage,
  onFirstScroll,
  onChapterChange,
  onOpenPanel,
  isLocked,
  isSupportable,
  onUnlockBook
}) => {
  const {
    selectionPos,
    handleTextSelect,
    clearSelection
  } = useTextSelection();
  const scrollRef = useRef(null);
  const hasScrolled = useRef(false);
  useEffect(() => {
    const root = scrollRef.current;
    if (!root)
      return;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
      if (visible.length > 0) {
        const el = visible[0].target;
        const chapterId = el.dataset.chapterId;
        if (chapterId)
          onChapterChange(chapterId);
      }
    }, {
      ...OBSERVER_OPTIONS,
      root
    });
    const headings = root.querySelectorAll("[data-chapter-id]");
    headings.forEach((h) => observer.observe(h));
    return () => {
      observer.disconnect();
    };
  }, [onChapterChange]);
  const handleScroll = () => {
    if (!hasScrolled.current) {
      hasScrolled.current = true;
      onFirstScroll();
    }
  };
  const openPanel = (mode) => {
    clearSelection();
    onOpenPanel(mode);
  };
  const dir = contentLanguage === "ar" ? "rtl" : "ltr";
  return /* @__PURE__ */ jsxs("div", {
    ref: scrollRef,
    className: "flex-1 overflow-y-auto relative bg-[var(--cair-surface-background)]",
    dir,
    onMouseUp: handleTextSelect,
    onTouchEnd: handleTextSelect,
    onScroll: handleScroll,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "max-w-[768px] mx-auto px-[64px] py-[40px]",
      style: {
        fontFamily: "var(--cair-reader-font-family)",
        fontSize: "var(--cair-reader-font-size)",
        lineHeight: "var(--cair-reader-line-spacing)"
      },
      children: [/* @__PURE__ */ jsx("h2", {
        id: "ch3",
        "data-chapter-id": "ch3",
        className: "text-[20px] font-semibold text-[color:var(--cair-text)] mb-[16px]",
        children: "Chapter 3: Methodological Frameworks in Academic Research"
      }), /* @__PURE__ */ jsx("hr", {
        className: "border-[var(--cair-divider)] mb-[24px]"
      }), SHARED_PARAS.map((p, i) => /* @__PURE__ */ jsx("p", {
        className: "text-[color:var(--cair-text)] mb-[24px]",
        children: p
      }, "ch3-" + i)), /* @__PURE__ */ jsx("h3", {
        id: "s3-1",
        "data-chapter-id": "ch3",
        className: "text-[18px] font-semibold text-[color:var(--cair-text)] mt-[8px] mb-[16px]",
        children: "3.1 Quantitative Research Frameworks"
      }), /* @__PURE__ */ jsx("hr", {
        className: "border-[var(--cair-divider)] mb-[24px]"
      }), SHARED_PARAS.slice(0, 3).map((p, i) => /* @__PURE__ */ jsx("p", {
        className: "text-[color:var(--cair-text)] mb-[24px]",
        children: p
      }, "s31-" + i)), /* @__PURE__ */ jsx("h3", {
        id: "s3-2",
        "data-chapter-id": "ch3",
        className: "text-[18px] font-semibold text-[color:var(--cair-text)] mt-[8px] mb-[16px]",
        children: "3.2 Qualitative Research Methods"
      }), /* @__PURE__ */ jsx("hr", {
        className: "border-[var(--cair-divider)] mb-[24px]"
      }), SHARED_PARAS.slice(1, 4).map((p, i) => /* @__PURE__ */ jsx("p", {
        className: "text-[color:var(--cair-text)] mb-[24px]",
        children: p
      }, "s32-" + i)), /* @__PURE__ */ jsx("h2", {
        id: "ch4",
        "data-chapter-id": "ch4",
        className: "text-[20px] font-semibold text-[color:var(--cair-text)] mt-[48px] mb-[16px]",
        children: "Chapter 4: Data Collection Strategies"
      }), /* @__PURE__ */ jsx("hr", {
        className: "border-[var(--cair-divider)] mb-[24px]"
      }), SHARED_PARAS.map((p, i) => /* @__PURE__ */ jsx("p", {
        className: "text-[color:var(--cair-text)] mb-[24px]",
        children: p
      }, "ch4-" + i)), SHARED_PARAS.map((p, i) => /* @__PURE__ */ jsx("p", {
        className: "text-[color:var(--cair-text-secondary)] mb-[24px]",
        children: p
      }, "ch4b-" + i)), /* @__PURE__ */ jsxs("div", {
        className: "mt-[48px] pt-[24px] border-t border-[var(--cair-divider)] flex items-center justify-between",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-[13px] text-[color:var(--cair-text-secondary)]",
          children: "End of Chapter 4"
        }), /* @__PURE__ */ jsx("button", {
          className: "text-[13px] font-medium text-[color:var(--cair-accent)] hover:underline",
          children: "Next Chapter \u2192"
        })]
      }), isLocked && onUnlockBook && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx("hr", {
          className: "border-[var(--cair-divider)] my-[24px]"
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "cairPrimary",
          size: "md",
          rounded: "sm",
          onClick: onUnlockBook,
          className: "w-full",
          leftIcon: /* @__PURE__ */ jsx(MdLockOpen, {
            size: 16
          }),
          children: "Unlock this book"
        })]
      }), isSupportable && onUnlockBook && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx("hr", {
          className: "border-[var(--cair-divider)] my-[24px]"
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "cairSubtle",
          size: "md",
          rounded: "sm",
          onClick: onUnlockBook,
          className: "w-full",
          leftIcon: /* @__PURE__ */ jsx(SupportHeartIcon, {
            size: 24
          }),
          style: {
            backgroundColor: "#e8e9ec",
            borderColor: "#d9d9d9",
            color: "#1e2c44"
          },
          children: "Support with donation"
        })]
      })]
    }), selectionPos && /* @__PURE__ */ jsx("div", {
      "data-selection-menu": true,
      className: "absolute z-20",
      style: {
        top: selectionPos.top,
        left: selectionPos.left
      },
      onMouseUp: (e) => e.stopPropagation(),
      children: /* @__PURE__ */ jsx(SelectionMenu, {
        onAskAi: () => openPanel("ask-ai"),
        onBookmark: () => openPanel("bookmark"),
        onNote: () => openPanel("note")
      })
    })]
  });
};

const DESKTOP_MOCK = {
  book: {
    title: "Advanced Research Methods",
    subtitle: "A Comprehensive Guide to Academic Study",
    author: "Dr. Ahmed Al-Hassan",
    accessType: "included",
    contentLanguage: "en"
  },
  toc: [
    {
      id: "ch1",
      title: "Chapter 1: Introduction",
      pages: 45,
      audioDuration: "1h 15m",
      isActive: false,
      sections: []
    },
    {
      id: "ch2",
      title: "Chapter 2: Literature Review",
      pages: 38,
      audioDuration: "58m",
      isActive: false,
      sections: []
    },
    {
      id: "ch3",
      title: "Chapter 3: Methodological Frameworks",
      pages: 52,
      audioDuration: "1h 22m",
      isActive: true,
      sections: [
        { id: "s3-1", title: "3.1 Quantitative Research" },
        { id: "s3-2", title: "3.2 Qualitative Methods" },
        { id: "s3-3", title: "3.3 Mixed-Method Approaches" },
        { id: "s3-4", title: "3.4 Framework Selection" }
      ]
    },
    {
      id: "ch4",
      title: "Chapter 4: Data Collection",
      pages: 41,
      audioDuration: "1h 05m",
      isActive: false,
      sections: []
    },
    {
      id: "ch5",
      title: "Chapter 5: Analysis Techniques",
      pages: 60,
      audioDuration: "1h 40m",
      isActive: false,
      sections: []
    }
  ],
  currentChapter: { index: 3, total: 12, progressPercent: 23 },
  activeSection: "s3-1",
  bookmarks: [
    { id: "bm1", name: "Key methodology principle", chapterLabel: "Chapter 3 \xB7 L53" },
    { id: "bm2", name: "Mixed methods overview", chapterLabel: "Chapter 3 \xB7 L82" }
  ],
  notes: [
    { id: "n1", name: "Compare with Smith 2019", chapterLabel: "Chapter 2 \xB7 L14" }
  ]
};

const ALL_ACCESS_TYPES = ["free", "free_donation", "purchase", "subscription", "domain", "admin"];
const ACCESS_TYPE_LABELS$1 = {
  free: "Free",
  free_donation: "Free + Donation",
  purchase: "Purchase",
  subscription: "Subscription",
  domain: "Institutional",
  admin: "Admin Only"
};
const AccessTypeSwitcher = ({
  value,
  onChange
}) => /* @__PURE__ */ jsxs("div", {
  className: "absolute top-[8px] right-[8px] z-50 flex items-center gap-[6px] px-[10px] py-[6px] rounded-[8px] bg-black/70 backdrop-blur-sm",
  children: [/* @__PURE__ */ jsx("span", {
    className: "text-[11px] font-medium text-white/70 mr-[2px]",
    children: "Access:"
  }), ALL_ACCESS_TYPES.map((at) => /* @__PURE__ */ jsx("button", {
    onClick: () => onChange(at),
    className: ["px-[8px] py-[3px] rounded-[6px] text-[11px] font-medium transition-colors", at === value ? "bg-white text-black" : "text-white/70 hover:text-white hover:bg-white/20"].join(" "),
    children: ACCESS_TYPE_LABELS$1[at]
  }, at))]
});
const noop$6 = () => void 0;
const resolveChapterId = (chapterId) => {
  const direct = DESKTOP_MOCK.toc.find((ch) => ch.id === chapterId);
  if (direct)
    return direct.id;
  for (const ch of DESKTOP_MOCK.toc) {
    if (ch.sections.some((s) => s.id === chapterId))
      return ch.id;
  }
  return chapterId;
};
const BookCairDesktopLayout = () => {
  const layoutMode = useReaderLayoutMode("desktop");
  const [activeChapterId, setActiveChapterId] = useState("ch3");
  const [expandedChapterId, setExpandedChapterId] = useState("ch3");
  const [activeSection, setActiveSection] = useState(DESKTOP_MOCK.activeSection);
  const [rightPanelMode, setRightPanelMode] = useState(null);
  const [ttsActive, setTtsActive] = useState(false);
  const [toolbarExpanded, setToolbarExpanded] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [unlockModalOpen, setUnlockModalOpen] = useState(false);
  const [donateModalOpen, setDonateModalOpen] = useState(false);
  const [activeAccessType, setActiveAccessType] = useState(MOCK_BOOK_PAYMENT.accessType);
  const uiAccessType = toUiAccessType(activeAccessType);
  const paymentType = derivePaymentType(activeAccessType);
  const isLocked = uiAccessType === "locked" || uiAccessType === "collection" || uiAccessType === "institutional";
  const isSupportable = uiAccessType === "support";
  const toc = useMemo(() => DESKTOP_MOCK.toc.map((ch) => ({
    ...ch,
    isActive: ch.id === activeChapterId
  })), [activeChapterId]);
  const activeChapterTitle = useMemo(() => {
    const ch = toc.find((c) => c.id === activeChapterId);
    return ch ? ch.title : "";
  }, [toc, activeChapterId]);
  useMemoizedFn((id) => {
    setExpandedChapterId((prev) => prev === id ? null : id);
  });
  useMemoizedFn((sectionId) => {
    setActiveSection(sectionId);
    const el = document.getElementById(sectionId);
    if (el)
      el.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
  });
  const handleOpenPanel = useMemoizedFn((mode) => {
    setRightPanelMode((prev) => prev === mode ? null : mode);
    setToolbarExpanded(true);
  });
  const handleClosePanel = useMemoizedFn(() => {
    setRightPanelMode(null);
  });
  const handleFirstScroll = useMemoizedFn(() => {
    if (!toolbarExpanded)
      setToolbarExpanded(true);
  });
  const handleChapterChange = useMemoizedFn((chapterId) => {
    const resolved = resolveChapterId(chapterId);
    setActiveChapterId(resolved);
    setExpandedChapterId(resolved);
  });
  const handleTtsToggle = useMemoizedFn(() => {
    setTtsActive((v) => !v);
  });
  const handleUnlockBook = useMemoizedFn(() => {
    setUnlockModalOpen(true);
  });
  const handleCloseUnlockModal = useMemoizedFn(() => {
    setUnlockModalOpen(false);
  });
  const handleCloseDonateModal = useMemoizedFn(() => {
    setDonateModalOpen(false);
  });
  const navigateToPayment = useMemoizedFn(() => {
    setUnlockModalOpen(false);
    if (paymentType) {
      const params = new URLSearchParams({
        type: paymentType,
        accessType: activeAccessType,
        documentId: MOCK_BOOK_PAYMENT.id,
        ...{
          circleId: MOCK_BOOK_PAYMENT.circleId
        } 
      });
      window.location.href = window.location.pathname.replace(/\/book-cair-desktop.*/, `/book-cair-payment?${params}`);
    }
  });
  const handleStartReading = useMemoizedFn(() => {
    setUnlockModalOpen(false);
  });
  const handleSupportDonate = useMemoizedFn(() => {
    setUnlockModalOpen(false);
    setDonateModalOpen(true);
  });
  const handleDonate = useMemoizedFn(() => {
    setDonateModalOpen(false);
    const params = new URLSearchParams({
      type: "donation",
      accessType: activeAccessType,
      documentId: MOCK_BOOK_PAYMENT.id
    });
    window.location.href = window.location.pathname.replace(/\/book-cair-desktop.*/, `/book-cair-payment?${params}`);
  });
  const handleContinueWithout = useMemoizedFn(() => {
    setDonateModalOpen(false);
  });
  const handleReadSummary = useMemoizedFn(() => {
    setUnlockModalOpen(false);
  });
  const isTablet = layoutMode === "tablet";
  const sidebar = /* @__PURE__ */ jsx(BookCairDesktopSidebar, {
    book: DESKTOP_MOCK.book,
    toc,
    onTocNavigate: noop$6,
    bookmarks: DESKTOP_MOCK.bookmarks,
    notes: DESKTOP_MOCK.notes,
    onBack: () => {
      window.location.href = bookCairDashboardUrl();
    },
    onShare: noop$6
  });
  return /* @__PURE__ */ jsx(CairTokensProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "relative flex h-full overflow-hidden bg-[var(--cair-surface-background)]",
      children: [/* @__PURE__ */ jsx(AccessTypeSwitcher, {
        value: activeAccessType,
        onChange: setActiveAccessType
      }), isTablet && sidebarOpen && /* @__PURE__ */ jsx("div", {
        className: "absolute inset-0 bg-black bg-opacity-30 z-[39]",
        onClick: () => setSidebarOpen(false)
      }), isTablet ? /* @__PURE__ */ jsx("div", {
        className: "absolute left-0 top-0 h-full z-[40] transition-transform duration-200" + (sidebarOpen ? "" : " -translate-x-full"),
        children: sidebar
      }) : sidebar, /* @__PURE__ */ jsxs("div", {
        className: "relative flex flex-col flex-1 min-w-0",
        children: [/* @__PURE__ */ jsx(BookCairDesktopReadingHeader, {
          chapterIndex: DESKTOP_MOCK.currentChapter.index,
          chapterTotal: DESKTOP_MOCK.currentChapter.total,
          progressPercent: DESKTOP_MOCK.currentChapter.progressPercent,
          toolbarExpanded,
          rightPanelMode,
          onOpenPanel: handleOpenPanel,
          isTablet,
          onToggleSidebar: () => setSidebarOpen((v) => !v)
        }), /* @__PURE__ */ jsx(BookCairDesktopReadingArea, {
          contentLanguage: DESKTOP_MOCK.book.contentLanguage,
          onFirstScroll: handleFirstScroll,
          onChapterChange: handleChapterChange,
          onOpenPanel: handleOpenPanel,
          isLocked,
          isSupportable,
          onUnlockBook: handleUnlockBook
        }), /* @__PURE__ */ jsx("div", {
          className: "flex items-center justify-end h-[48px] px-[16px] flex-none border-t border-[var(--cair-divider)] bg-[var(--cair-surface)]",
          children: /* @__PURE__ */ jsx(SpeakButton, {
            onClick: handleTtsToggle
          })
        }), /* @__PURE__ */ jsx(BookCairDesktopAudioPlayer, {
          visible: ttsActive,
          chapterTitle: activeChapterTitle
        }), /* @__PURE__ */ jsx(BookCairDesktopRightPanel, {
          mode: rightPanelMode,
          onClose: handleClosePanel,
          onTtsToggle: handleTtsToggle
        })]
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: unlockModalOpen,
        onClose: handleCloseUnlockModal,
        placement: isTablet ? "bottom" : "center",
        size: "sm",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(BookDetailsPanel, {
          title: MOCK_BOOK_PAYMENT.title,
          author: MOCK_BOOK_PAYMENT.author,
          publisher: MOCK_BOOK_PAYMENT.publisher,
          year: MOCK_BOOK_PAYMENT.year,
          language: MOCK_BOOK_PAYMENT.language,
          accessType: uiAccessType,
          collectionName: MOCK_BOOK_PAYMENT.collection && MOCK_BOOK_PAYMENT.collection.name,
          institutionName: MOCK_BOOK_PAYMENT.institutionName,
          onStartReading: handleStartReading,
          onSupportDonate: handleSupportDonate,
          onSubscribe: navigateToPayment,
          onUnlock: navigateToPayment,
          onReadSummary: handleReadSummary,
          onClose: handleCloseUnlockModal
        })
      }), /* @__PURE__ */ jsx(Dialog$3, {
        isOpen: donateModalOpen,
        onClose: handleCloseDonateModal,
        placement: isTablet ? "bottom" : "center",
        size: "sm",
        showCloseButton: false,
        children: /* @__PURE__ */ jsx(SupportDonatePanel, {
          onDonate: handleDonate,
          onContinueWithout: handleContinueWithout,
          onClose: handleCloseDonateModal
        })
      })]
    })
  });
};

const BookCairDesktopPage = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-desktop",
  children: () => /* @__PURE__ */ jsx(BookCairDesktopLayout, {})
});

const BookCairReaderMobilePageLive = () => {
  return /* @__PURE__ */ jsx(BookCairPrototypePage, {
    routeSegment: "live-book-cair-mobile",
    children: (postId) => postId ? /* @__PURE__ */ jsx(BookCairMobileLiveScreen, {
      postId
    }) : /* @__PURE__ */ jsxs("div", {
      className: "p-4 text-sm text-gray-500",
      children: ["No postId \u2014 append /", /* @__PURE__ */ jsx("span", {
        className: "font-mono",
        children: "{postId}"
      }), " to the URL."]
    })
  });
};

const BookCairDesktopPageLive = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "live-book-cair-desktop",
  children: (postId) => postId ? /* @__PURE__ */ jsx(BookCairDesktopLayout$1, {
    postId
  }) : /* @__PURE__ */ jsxs("div", {
    className: "p-4 text-sm text-gray-500",
    children: ["No postId \u2014 append /", /* @__PURE__ */ jsx("span", {
      className: "font-mono",
      children: "{postId}"
    }), " to the URL."]
  })
});

const PaymentResultPageWrapper = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-payment-result",
  children: (circleId) => /* @__PURE__ */ jsx(PaymentResultPage, {
    circleId
  })
});

const CairPaymentPageWrapper = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-payment",
  children: (circleId) => /* @__PURE__ */ jsx(CairPaymentPage, {
    circleId
  })
});

const BrowseBooksPageWrapper = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-browse",
  children: (circleId) => /* @__PURE__ */ jsx(BrowseBooksPage, {
    circleId
  })
});

const MyLibraryPageWrapper = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-library",
  children: (circleId) => /* @__PURE__ */ jsx(MyLibraryPage, {
    circleId
  })
});

const PurchasesPageWrapper = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "book-cair-purchases",
  children: (circleId) => /* @__PURE__ */ jsx(PurchasesPage, {
    circleId
  })
});

const PostAttachmentsContext = createContext(null);
const usePostAttachmentsCtx = () => {
  const ctx = useContext(PostAttachmentsContext);
  if (!ctx) {
    throw new Error("usePostAttachmentsCtx must be called inside PostAttachmentsProvider");
  }
  return ctx;
};

const encodeUuid$3 = (uuid) => encodeURIComponent(uuid);
const listAttachments = async (api, postId) => {
  const result = await api.get({ path: `posts/${postId}/attachments` });
  return result && result.attachments ? result.attachments : [];
};
const deleteAttachment = async (api, postId, uuid) => {
  await api.delete({
    path: `posts/${postId}/attachments/${encodeUuid$3(uuid)}`
  });
};
const uploadViaServer = async (api, opts) => {
  const {
    postId,
    file,
    label,
    variantOf,
    variantType,
    onProgress,
    signalTaskId,
    signalId
  } = opts;
  const result = await api.upload({
    0: file,
    path: `posts/${postId}/attachments/upload`,
    label: label || void 0,
    variantOf,
    variantType,
    signalTaskId,
    signalId,
    onProgress
  });
  return result && result.attachment;
};
const initiateMultipart = async (api, postId, opts) => {
  const result = await api.post({
    path: `posts/${postId}/attachments/initiate-multipart`,
    body: opts
  });
  return result;
};
const signPart = async (api, postId, opts) => {
  const result = await api.post({
    path: `posts/${postId}/attachments/sign-part`,
    body: opts
  });
  return result;
};
const savePart = async (api, postId, opts) => {
  await api.post({
    path: `posts/${postId}/attachments/save-part`,
    body: opts
  });
};
const completeMultipart = async (api, postId, opts) => {
  await api.post({
    path: `posts/${postId}/attachments/complete-multipart`,
    body: opts
  });
};
const convertDocxToHtml = async (api, postId, uuid) => {
  const result = await api.post({
    path: `posts/${postId}/attachments/${encodeUuid$3(uuid)}/convert-to-html`
  });
  return result;
};
const createUploadBarrier = async (api, opts) => {
  const result = await api.post({
    path: `fair-scheduler/attachment-processing/tasks`,
    body: {
      circleId: opts.circleId,
      userId: opts.userId,
      postId: opts.postId,
      expectedIds: opts.expectedIds,
      lookupKey: `post-content:${opts.postId}`,
      payload: {
        kind: "post-content",
        postId: opts.postId,
        transcribeSignalId: opts.transcribeSignalId,
        promptPostId: opts.promptPostId,
        modelName: opts.modelName
      }
    }
  });
  return { taskId: result && result.task ? result.task._id : "" };
};

const usePostAttachments = (postId) => {
  const api = useApi();
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(void 0);
  const load = useMemoizedFn(async () => {
    if (!postId)
      return;
    setLoading(true);
    setError(void 0);
    try {
      const items = await listAttachments(api, postId);
      setAttachments(items);
    } catch (err) {
      const message = err && err.message ? err.message : "Failed to load attachments";
      setError(message);
    } finally {
      setLoading(false);
    }
  });
  useEffect(() => {
    load();
  }, [postId]);
  const remove = useMemoizedFn(async (uuid) => {
    await deleteAttachment(api, postId, uuid);
    await load();
  });
  return { attachments, loading, error, reload: load, remove };
};

const DIRECT_UPLOAD_THRESHOLD_BYTES = 10 * 1024 * 1024;
const PART_SIZE_BYTES = 10 * 1024 * 1024;

const remove_unsafe_chars = (str = "") => {
  return str.replace(/[\\\|\^\&\{\}\[\]\?\*\`\#\>\<\,\:\+\=\@\~\;\%\$]+/g, "-").trim();
};
const sanitizeFilename = (filename = "", len = 256) => {
  let f = filename;
  let i = f.lastIndexOf("/");
  if (i >= 0) {
    f = f.substring(f.lastIndexOf("/") + 1, f.length);
  }
  i = f.lastIndexOf("\\");
  if (i >= 0) {
    f = f.substring(f.lastIndexOf("\\") + 1, f.length);
  }
  let [n, e] = f.split(/(\.[^\.]*$)/);
  let name = remove_unsafe_chars(n);
  let ext = e ? remove_unsafe_chars(e) : "";
  return name.substring(0, Math.max(1, len - ext.length)) + ext;
};

const findResumableAttachment = (attachments, file) => {
  const sanitized = sanitizeFilename(file.name);
  for (let i = 0; i < attachments.length; i++) {
    const a = attachments[i];
    if (a.status === "pending" && a.originalFileName === sanitized && a.data && a.data.uploadId) {
      return a;
    }
  }
  return null;
};

class UploadCancelledError extends Error {
  constructor() {
    super("Upload cancelled");
    this.name = "UploadCancelledError";
  }
}
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const backoffDelay = (attempt) => Math.min(1e3 * 2 ** Math.min(attempt, 5), 3e4);
const uploadPartXhr = (partUrl, chunk, onChunkProgress) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", partUrl);
    xhr.upload.onprogress = (ev) => {
      if (ev.lengthComputable) {
        onChunkProgress(Math.round(ev.loaded / ev.total * 100));
      }
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        const raw = xhr.getResponseHeader("ETag") || "";
        resolve(raw.replace(/"/g, ""));
      } else {
        const err = new Error("Part upload failed: HTTP " + xhr.status);
        err.httpStatus = xhr.status;
        reject(err);
      }
    };
    xhr.onerror = () => reject(new Error("Network error during part upload"));
    xhr.ontimeout = () => reject(new Error("Part upload timed out"));
    xhr.send(chunk);
  });
};
const isPermanentPartError = (err) => {
  const status = err && err.httpStatus;
  if (!status)
    return false;
  return status >= 400 && status < 500 && status !== 403 && status !== 408 && status !== 429;
};
const uploadPartResilient = async (opts) => {
  const { signPartUrl, chunk, onChunkProgress, onTransientError, isCancelled } = opts;
  let attempt = 0;
  while (true) {
    if (isCancelled())
      throw new UploadCancelledError();
    try {
      const partUrl = await signPartUrl();
      return await uploadPartXhr(partUrl, chunk, onChunkProgress);
    } catch (err) {
      if (err instanceof UploadCancelledError)
        throw err;
      if (isPermanentPartError(err))
        throw err;
      attempt++;
      const message = err && err.message ? err.message : "Upload interrupted";
      onTransientError(message, attempt);
      await delay(backoffDelay(attempt));
    }
  }
};

const useAttachmentUpload = (postId, reload, attachments) => {
  const api = useApi();
  const [staged, setStaged] = useState([]);
  const [pending, setPending] = useState([]);
  const [transcribeTempId, setTranscribeTempId] = useState(null);
  const [transcribeAddPrompt, setTranscribeAddPrompt] = useState(false);
  const [transcribePromptPostId, setTranscribePromptPostId] = useState(void 0);
  const [transcribeModelName, setTranscribeModelName] = useState("");
  const attachmentsRef = useRef(attachments);
  attachmentsRef.current = attachments;
  const cancelledRef = useRef({});
  const stageFiles = useMemoizedFn((files) => {
    const next = Array.from(files).map((file) => {
      const isLarge = file.size > DIRECT_UPLOAD_THRESHOLD_BYTES;
      const resumable = isLarge ? findResumableAttachment(attachmentsRef.current, file) : null;
      return {
        tempId: ulid(),
        file,
        label: resumable && resumable.label || "",
        strategy: isLarge ? "direct" : "server",
        resumeFromKey: resumable ? resumable.uuid : void 0
      };
    });
    setStaged((prev) => [...prev, ...next]);
  });
  const removeStaged = useMemoizedFn((tempId) => {
    setStaged((prev) => prev.filter((s) => s.tempId !== tempId));
  });
  const clearStaged = useMemoizedFn(() => setStaged([]));
  const updateStagedLabel = useMemoizedFn((tempId, label) => {
    setStaged((prev) => prev.map((s) => s.tempId === tempId ? { ...s, label } : s));
  });
  const setTranscribeTarget = useMemoizedFn((tempId) => {
    setTranscribeTempId((prev) => {
      const next = prev === tempId ? null : tempId;
      if (next === null) {
        setTranscribeAddPrompt(false);
        setTranscribePromptPostId(void 0);
      }
      return next;
    });
  });
  const removePending = useMemoizedFn((tempId) => {
    delete cancelledRef.current[tempId];
    setPending((prev) => prev.filter((p) => p.tempId !== tempId));
  });
  const cancelUpload = useMemoizedFn((tempId) => {
    cancelledRef.current[tempId] = true;
  });
  const setPendingProgress = (tempId, progress) => {
    setPending((prev) => prev.map((p) => p.tempId === tempId ? { ...p, progress, error: void 0, notice: void 0 } : p));
  };
  const setPendingError = (tempId, error) => {
    setPending((prev) => prev.map((p) => p.tempId === tempId ? { ...p, error } : p));
  };
  const setPendingNotice = (tempId, notice) => {
    setPending((prev) => prev.map((p) => p.tempId === tempId ? { ...p, notice, error: void 0 } : p));
  };
  const retryApiCall = (tempId, label, fn) => withRetry(fn, {
    maxRetries: Infinity,
    isCancelled: () => cancelledRef.current[tempId] === true,
    onRetry: (attempt, error) => {
      const msg = error && error.message ? error.message : label;
      setPendingNotice(tempId, "Connection problem, retrying (attempt " + attempt + "): " + msg);
    }
  });
  const runServerUpload = async (sf) => {
    try {
      await uploadViaServer(api, {
        postId,
        file: sf.file,
        label: sf.label || void 0,
        signalTaskId: sf.signalTaskId || void 0,
        signalId: sf.signalId || void 0,
        onProgress: (pct) => setPendingProgress(sf.tempId, pct)
      });
      removePending(sf.tempId);
      reload();
    } catch (err) {
      const msg = err && err.message ? err.message : "Upload failed";
      setPendingError(sf.tempId, msg);
    }
  };
  const runMultipartUpload = async (sf) => {
    cancelledRef.current[sf.tempId] = false;
    const totalParts = Math.ceil(sf.file.size / PART_SIZE_BYTES);
    let key;
    let uploadId;
    let completedParts;
    let startFromPart;
    const existing = sf.resumeFromKey ? attachmentsRef.current.find((a) => a.uuid === sf.resumeFromKey) || null : findResumableAttachment(attachmentsRef.current, sf.file);
    if (existing && existing.data && existing.data.uploadId) {
      key = existing.uuid;
      uploadId = existing.data.uploadId;
      const saved = existing.data && existing.data.completedParts ? existing.data.completedParts : [];
      completedParts = saved.slice();
      startFromPart = completedParts.length + 1;
    } else {
      try {
        const info = await retryApiCall(sf.tempId, "Could not initiate upload", () => initiateMultipart(api, postId, {
          originalFileName: sf.file.name,
          contentType: sf.file.type || "application/octet-stream",
          label: sf.label || void 0,
          signal: sf.signalTaskId ? { taskId: sf.signalTaskId, id: sf.signalId || "" } : void 0
        }));
        key = info.key;
        uploadId = info.uploadId;
        completedParts = [];
        startFromPart = 1;
      } catch (err) {
        if (cancelledRef.current[sf.tempId]) {
          removePending(sf.tempId);
          reload();
          return;
        }
        const msg = err && err.message ? err.message : "Could not initiate upload";
        setPendingError(sf.tempId, msg);
        return;
      }
    }
    for (let partNumber = startFromPart; partNumber <= totalParts; partNumber++) {
      const start = (partNumber - 1) * PART_SIZE_BYTES;
      const chunk = sf.file.slice(start, start + PART_SIZE_BYTES);
      let etag;
      try {
        etag = await uploadPartResilient({
          signPartUrl: async () => {
            const signed = await signPart(api, postId, { key, uploadId, partNumber });
            return signed.partUrl;
          },
          chunk,
          onChunkProgress: (chunkPct) => {
            const overallPct = Math.round((partNumber - 1 + chunkPct / 100) / totalParts * 100);
            setPendingProgress(sf.tempId, overallPct);
          },
          onTransientError: (message, attempt) => {
            setPendingNotice(sf.tempId, "Connection problem, retrying (attempt " + attempt + "): " + message);
          },
          isCancelled: () => cancelledRef.current[sf.tempId] === true
        });
      } catch (err) {
        if (err instanceof UploadCancelledError) {
          removePending(sf.tempId);
          reload();
          return;
        }
        const msg = err && err.message ? err.message : "Part " + partNumber + " upload failed";
        setPendingError(sf.tempId, msg);
        return;
      }
      try {
        await savePart(api, postId, { key, partNumber, etag });
      } catch (err) {
        console.warn("savePart failed for part " + partNumber + ":", err);
      }
      completedParts.push({ partNumber, etag });
    }
    try {
      await retryApiCall(sf.tempId, "Failed to complete upload", () => completeMultipart(api, postId, {
        key,
        uploadId,
        parts: completedParts,
        originalFileSize: sf.file.size
      }));
      removePending(sf.tempId);
      reload();
    } catch (err) {
      if (cancelledRef.current[sf.tempId]) {
        removePending(sf.tempId);
        reload();
        return;
      }
      const msg = err && err.message ? err.message : "Failed to complete upload";
      setPendingError(sf.tempId, msg);
    }
  };
  const uploadAll = useMemoizedFn(() => {
    if (staged.length === 0)
      return;
    const toUpload = [...staged];
    const newPending = toUpload.map((sf) => ({
      tempId: sf.tempId,
      fileName: sf.file.name,
      progress: -1,
      error: void 0,
      notice: void 0
    }));
    setPending((prev) => [...prev, ...newPending]);
    setStaged([]);
    setTranscribeTempId(null);
    setTranscribeAddPrompt(false);
    setTranscribePromptPostId(void 0);
    toUpload.forEach((sf) => {
      if (sf.strategy === "direct") {
        runMultipartUpload(sf);
      } else {
        runServerUpload(sf);
      }
    });
  });
  return {
    staged,
    pending,
    stageFiles,
    removeStaged,
    clearStaged,
    updateStagedLabel,
    uploadAll,
    removePending,
    cancelUpload,
    transcribeTempId,
    setTranscribeTarget,
    transcribeAddPrompt,
    setTranscribeAddPrompt,
    transcribePromptPostId,
    setTranscribePromptPostId,
    transcribeModelName,
    setTranscribeModelName
  };
};

const ATTACHMENT_PROCESSING_TASK_TYPE$1 = "attachment-processing";
const collectTaskIds = (attachments) => {
  const ids = [];
  const walk = (a) => {
    const data = a.data;
    const taskId = data && data.processingTaskId ? data.processingTaskId : "";
    if (taskId)
      ids.push(taskId);
    if (a.variants && a.variants.length > 0)
      a.variants.forEach(walk);
  };
  attachments.forEach(walk);
  return ids;
};
const readPercent$1 = (value, prev) => {
  if (value && typeof value.percent === "number")
    return value.percent;
  return prev;
};
const useAttachmentProcessing = (attachments, reload) => {
  const api = useApi();
  const jwt = useJwt();
  const [map, setMap] = useState({});
  const taskIds = useMemo(() => collectTaskIds(attachments), [attachments]);
  const idsKey = taskIds.join(",");
  const url = idsKey !== "" && jwt ? api.buildUrl(`fair-scheduler/${ATTACHMENT_PROCESSING_TASK_TYPE$1}/tasks/progress`, { taskIds: idsKey, token: jwt }) : "";
  const onProgress = useMemoizedFn((data) => {
    if (!data || !data.taskId)
      return;
    const status = data.status;
    setMap((prev) => {
      const existing = prev[data.taskId];
      const prevPercent = existing ? existing.percent : 0;
      const next = status === "done" ? { phase: "done", percent: 100, phaseLabel: "Done" } : status === "failed" ? { phase: "error", percent: prevPercent, phaseLabel: data.phase || "" } : { phase: "processing", percent: readPercent$1(data.value, prevPercent), phaseLabel: data.phase || "" };
      return { ...prev, [data.taskId]: next };
    });
    if (status === "done")
      reload();
  });
  useSSEConnection({ url, enabled: url !== "", maxReconnectAttempts: 0 }, [
    { event: "progress", handler: onProgress }
  ]);
  return map;
};

const PostAttachmentsProvider = ({
  postId,
  children
}) => {
  const {
    attachments,
    loading,
    error: listError,
    reload,
    remove
  } = usePostAttachments(postId);
  const [selectedUuid, setSelectedUuid] = useState(null);
  const processing = useAttachmentProcessing(attachments, reload);
  const {
    staged,
    pending,
    stageFiles,
    removeStaged,
    clearStaged,
    updateStagedLabel,
    uploadAll,
    removePending,
    transcribeTempId,
    setTranscribeTarget,
    transcribeAddPrompt,
    setTranscribeAddPrompt,
    transcribePromptPostId,
    setTranscribePromptPostId,
    transcribeModelName,
    setTranscribeModelName
  } = useAttachmentUpload(postId, reload, attachments);
  return /* @__PURE__ */ jsx(PostAttachmentsContext.Provider, {
    value: {
      postId,
      attachments,
      loading,
      listError,
      reload,
      staged,
      pending,
      stageFiles,
      removeStaged,
      clearStaged,
      updateStagedLabel,
      uploadAll,
      removePending,
      remove,
      selectedUuid,
      selectAttachment: setSelectedUuid,
      processing,
      transcribeTempId,
      setTranscribeTarget,
      transcribeAddPrompt,
      setTranscribeAddPrompt,
      transcribePromptPostId,
      setTranscribePromptPostId,
      transcribeModelName,
      setTranscribeModelName
    },
    children
  });
};

const useDropZone = (options) => {
  const { onFiles, disabled } = options;
  const [isDragOver, setIsDragOver] = useState(false);
  const onDragOver = useMemoizedFn((e) => {
    e.preventDefault();
    if (!disabled)
      setIsDragOver(true);
  });
  const onDragLeave = useMemoizedFn((e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false);
    }
  });
  const onDrop = useMemoizedFn((e) => {
    e.preventDefault();
    setIsDragOver(false);
    if (disabled)
      return;
    const files = e.dataTransfer && e.dataTransfer.files;
    if (files)
      onFiles(files);
  });
  return { isDragOver, dragProps: { onDragOver, onDragLeave, onDrop } };
};

const detachFromFolder = (file) => {
  const path = file.webkitRelativePath || file.name;
  const name = path.replace(/^\/+/, "").replace(/[\\/]+/g, "_");
  return new File([file], name, { type: file.type, lastModified: file.lastModified });
};
const useFolderPicker = (options) => {
  const { onFiles, filter, disabled } = options;
  const inputRef = useRef(null);
  useEffect(() => {
    const el = inputRef.current;
    if (el) {
      el.setAttribute("webkitdirectory", "");
      el.setAttribute("multiple", "");
    }
  }, []);
  const open = useMemoizedFn(() => {
    if (disabled)
      return;
    if (inputRef.current)
      inputRef.current.click();
  });
  const onChange = useMemoizedFn((e) => {
    const list = e.target.files;
    if (list && list.length > 0) {
      const all = Array.from(list);
      const kept = filter ? all.filter(filter) : all;
      if (kept.length > 0)
        onFiles(kept.map(detachFromFolder));
    }
    e.target.value = "";
  });
  return {
    inputRef,
    open,
    onChange,
    inputProps: {
      ref: inputRef,
      type: "file",
      className: "hidden",
      onChange
    }
  };
};

const zoneVariants = cva(["flex flex-col items-center justify-center gap-2", "border-2 border-dashed rounded-lg", "py-8 px-4 text-center", "cursor-pointer transition-colors select-none"], {
  variants: {
    state: {
      idle: "border-gray-200 bg-white hover:border-blue-300 hover:bg-blue-50",
      dragover: "border-blue-400 bg-blue-50",
      disabled: "border-gray-100 bg-gray-50 cursor-not-allowed opacity-60"
    }
  },
  defaultVariants: {
    state: "idle"
  }
});
const UploadZone = ({
  disabled = false
}) => {
  const {
    stageFiles
  } = usePostAttachmentsCtx();
  const inputRef = useRef(null);
  const {
    isDragOver,
    dragProps
  } = useDropZone({
    onFiles: (files) => stageFiles(files),
    disabled
  });
  const folderPicker = useFolderPicker({
    onFiles: (files) => stageFiles(files),
    filter: (f) => !f.name.startsWith("."),
    disabled
  });
  const onClick = useMemoizedFn(() => {
    if (disabled)
      return;
    if (inputRef.current)
      inputRef.current.click();
  });
  const onInputChange = useMemoizedFn((e) => {
    if (!disabled && e.target.files && e.target.files.length > 0) {
      stageFiles(e.target.files);
    }
    if (inputRef.current)
      inputRef.current.value = "";
  });
  const onKeyDown = useMemoizedFn((e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  });
  const zoneState = disabled ? "disabled" : isDragOver ? "dragover" : "idle";
  const thresholdMb = DIRECT_UPLOAD_THRESHOLD_BYTES / (1024 * 1024);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsxs("div", {
      role: "button",
      tabIndex: disabled ? -1 : 0,
      "aria-label": "Upload files \u2014 click or drag and drop",
      "aria-disabled": disabled,
      className: zoneVariants({
        state: zoneState
      }),
      onClick,
      onKeyDown,
      ...dragProps,
      children: [/* @__PURE__ */ jsx(MdCloudUpload, {
        size: 32,
        className: isDragOver ? "text-blue-400" : "text-gray-300"
      }), /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-gray-600",
        children: ["Drop files here or", " ", /* @__PURE__ */ jsx("span", {
          className: "text-blue-500 font-medium",
          children: "browse"
        })]
      }), /* @__PURE__ */ jsxs("p", {
        className: "text-xs text-gray-400",
        children: ["ANY file size \xB7 Any format accepted \xB7 Files > ", thresholdMb, " MB upload directly to OBS"]
      }), /* @__PURE__ */ jsx("input", {
        ref: inputRef,
        type: "file",
        multiple: true,
        className: "hidden",
        tabIndex: -1,
        "aria-hidden": "true",
        onChange: onInputChange
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center",
      children: [/* @__PURE__ */ jsxs("button", {
        type: "button",
        onClick: folderPicker.open,
        disabled,
        className: "inline-flex items-center gap-1.5 px-2.5 py-1 text-xs border border-gray-300 rounded text-gray-600 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
        children: [/* @__PURE__ */ jsx(MdFolderOpen, {
          size: 14,
          className: "text-gray-400"
        }), "Select folder"]
      }), /* @__PURE__ */ jsx("input", {
        ...folderPicker.inputProps,
        tabIndex: -1,
        "aria-hidden": "true"
      })]
    })]
  });
};

const formatFileSize = (bytes) => {
  if (bytes === void 0 || bytes === null)
    return "\u2014";
  if (bytes === 0)
    return "0 B";
  if (bytes < 1024)
    return `${bytes} B`;
  if (bytes < 1024 * 1024)
    return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024)
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};
const STATUS_LABELS = {
  ready: "Ready",
  pending: "Pending upload",
  processing: "Processing",
  error: "Error"
};
const STATUS_CLASSES = {
  ready: "bg-green-100 text-green-700",
  pending: "bg-yellow-100 text-yellow-700",
  processing: "bg-blue-100 text-blue-700 animate-pulse",
  error: "bg-red-100 text-red-700"
};
const StatusBadge = ({
  status
}) => {
  const s = status || "ready";
  const cls = STATUS_CLASSES[s] || STATUS_CLASSES.ready;
  return /* @__PURE__ */ jsx("span", {
    className: `shrink-0 text-xs px-2 py-0.5 rounded font-medium ${cls}`,
    children: s
  });
};

const MEDIA_EXTENSIONS = /\.(mp3|wav|m4a|aac|ogg|flac|wma|mp4|mov|avi|mkv|webm)$/i;
const isTranscribableMedia = (file) => {
  if (file.type.indexOf("audio/") === 0)
    return true;
  if (file.type.indexOf("video/") === 0)
    return true;
  return MEDIA_EXTENSIONS.test(file.name);
};
const TranscribeCheckbox = ({
  item
}) => {
  const {
    transcribeTempId,
    setTranscribeTarget
  } = usePostAttachmentsCtx();
  const handleClick = useMemoizedFn(() => setTranscribeTarget(item.tempId));
  if (!isTranscribableMedia(item.file))
    return null;
  const checked = transcribeTempId === item.tempId;
  return /* @__PURE__ */ jsxs("label", {
    className: "shrink-0 flex items-center gap-1 cursor-pointer select-none",
    children: [/* @__PURE__ */ jsx("input", {
      type: "checkbox",
      checked,
      onChange: handleClick,
      className: "h-3.5 w-3.5 accent-red-600"
    }), /* @__PURE__ */ jsx("span", {
      className: "text-xs font-medium text-red-600",
      children: "Transcribe"
    })]
  });
};

const STRATEGY_CLASSES = {
  server: "bg-gray-100 text-gray-500",
  direct: "bg-blue-50 text-blue-600"
};
const STRATEGY_LABEL = {
  server: "server upload",
  direct: "direct \u2192 OBS"
};
const StagedRow = ({
  item
}) => {
  const {
    removeStaged,
    updateStagedLabel
  } = usePostAttachmentsCtx();
  const handleLabelChange = useMemoizedFn((e) => updateStagedLabel(item.tempId, e.target.value));
  const handleRemove = useMemoizedFn(() => removeStaged(item.tempId));
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-3 px-3 py-2 border-b border-gray-100 last:border-0",
    children: [/* @__PURE__ */ jsx(MdInsertDriveFile, {
      size: 16,
      className: "text-gray-400 shrink-0"
    }), /* @__PURE__ */ jsx("span", {
      className: "flex-1 text-sm text-gray-700 truncate min-w-0",
      title: item.file.name,
      children: item.file.name
    }), /* @__PURE__ */ jsx(TranscribeCheckbox, {
      item
    }), /* @__PURE__ */ jsx("span", {
      className: "text-xs text-gray-400 shrink-0 tabular-nums",
      children: formatFileSize(item.file.size)
    }), item.resumeFromKey ? /* @__PURE__ */ jsx("span", {
      className: "shrink-0 text-xs px-2 py-0.5 rounded font-medium bg-amber-50 text-amber-600",
      children: "resume"
    }) : /* @__PURE__ */ jsx("span", {
      className: `shrink-0 text-xs px-2 py-0.5 rounded font-medium ${STRATEGY_CLASSES[item.strategy]}`,
      children: STRATEGY_LABEL[item.strategy]
    }), /* @__PURE__ */ jsx("input", {
      type: "text",
      value: item.label,
      onChange: handleLabelChange,
      placeholder: "label (optional)",
      className: "shrink-0 w-36 text-xs border border-gray-200 rounded px-2 py-0.5 focus:outline-none focus:border-blue-300 placeholder:text-gray-300"
    }), /* @__PURE__ */ jsx("button", {
      onClick: handleRemove,
      className: "shrink-0 p-1 text-gray-400 hover:text-red-500 transition-colors rounded",
      title: "Remove from staging",
      children: /* @__PURE__ */ jsx(MdClose, {
        size: 14
      })
    })]
  });
};

const UploadProgressRow = ({
  item,
  onCancel
}) => {
  const hasError = !!item.error;
  const isIndeterminate = item.progress < 0;
  const pct = isIndeterminate ? 0 : item.progress;
  const handleCancel = () => onCancel(item.tempId);
  return /* @__PURE__ */ jsxs("div", {
    className: "px-3 py-2 border-b border-gray-100 last:border-0",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-3 mb-1.5",
      children: [hasError ? /* @__PURE__ */ jsx(MdErrorOutline, {
        size: 16,
        className: "text-red-400 shrink-0"
      }) : isIndeterminate ? /* @__PURE__ */ jsx(Spinner, {
        size: "xs"
      }) : /* @__PURE__ */ jsx(MdInsertDriveFile, {
        size: 16,
        className: "text-blue-400 shrink-0"
      }), /* @__PURE__ */ jsx("span", {
        className: "flex-1 text-sm text-gray-700 truncate min-w-0",
        title: item.fileName,
        children: item.fileName
      }), item.notice && !item.error ? /* @__PURE__ */ jsx("span", {
        className: "text-xs text-amber-600",
        children: item.notice
      }) : null, !hasError && !isIndeterminate && /* @__PURE__ */ jsxs("span", {
        className: "text-xs text-gray-400 shrink-0 tabular-nums",
        children: [pct, "%"]
      }), /* @__PURE__ */ jsx("button", {
        onClick: handleCancel,
        className: "shrink-0 p-1 text-gray-400 hover:text-gray-700 transition-colors rounded",
        title: hasError ? "Dismiss" : "Cancel upload",
        children: /* @__PURE__ */ jsx(MdClose, {
          size: 14
        })
      })]
    }), hasError && /* @__PURE__ */ jsx("p", {
      className: "text-xs text-red-500 mt-0.5 pl-7",
      children: item.error
    }), !hasError && !isIndeterminate && /* @__PURE__ */ jsx("div", {
      className: "h-1 bg-gray-100 rounded-full overflow-hidden ml-7",
      children: /* @__PURE__ */ jsx("div", {
        className: "h-full bg-blue-400 rounded-full transition-[width] duration-150",
        style: {
          width: `${pct}%`
        }
      })
    })]
  });
};

const interviewPostKey = (postId) => ["interview", postId];
const mutateInterviewPost = (postId, post) => mutate(interviewPostKey(postId), (current) => current ? { ...current, ...post } : current, false);
const useLoadInterview = (postId) => {
  const api = useApi();
  const { data, error, mutate: reload } = useSWR(postId ? interviewPostKey(postId) : null, () => loadInterviewPost(api, postId), swrLoadOnce);
  return {
    post: data || null,
    loading: !data && !error,
    error: error || null,
    reload
  };
};

const InterviewEditorContext = createContext(null);
const useInterviewEditor = () => {
  const ctx = useContext(InterviewEditorContext);
  if (!ctx)
    throw new Error("useInterviewEditor must be used inside InterviewEditorProvider");
  return ctx;
};
const InterviewEditorProvider = ({
  initialPost,
  children
}) => {
  const [isBusy, setIsBusy] = useState(false);
  const api = useApi();
  const [root, setRoot] = useState(initialPost);
  const [currentPageIndex, setCurrentPageIndex] = useState(null);
  const [lastPageIndex, setLastPageIndex] = useState(0);
  useEffect(() => {
    if (currentPageIndex !== null) {
      setLastPageIndex(currentPageIndex);
    }
  }, [currentPageIndex]);
  const pages = root.pages && root.pages.length > 0 ? root.pages : [];
  const pageCount = pages.length;
  const currentPostId = currentPageIndex === null ? root._id : pages[currentPageIndex] || root._id;
  const updateRoot = useMemoizedFn((updated) => {
    setRoot(updated);
  });
  const save = useMemoizedFn(async (postId, input) => {
    setIsBusy(true);
    try {
      const updated = await saveInterview(api, postId, input);
      if (postId === root._id) {
        setRoot(updated.post);
      }
      mutateInterviewPost(postId, updated.post);
      return updated;
    } finally {
      setIsBusy(false);
    }
  });
  const publish = useMemoizedFn(async () => {
    await publishInterviewPost(api, root._id);
  });
  const publishDraft = useMemoizedFn(async () => {
    const {
      post
    } = await publishInterviewDraft(api, root._id);
    return post;
  });
  const addPage = useMemoizedFn(async () => {
    setIsBusy(true);
    try {
      const {
        post: newPage
      } = await createInterviewPage(api, root, {});
      const insertAfter = currentPageIndex === null ? pages.length - 1 : currentPageIndex;
      const newPages = [...pages];
      newPages.splice(insertAfter + 1, 0, newPage._id);
      const updatedRoot = await saveInterview(api, root._id, {
        pages: newPages
      });
      setRoot(updatedRoot.post);
      setCurrentPageIndex(insertAfter + 1);
    } finally {
      setIsBusy(false);
    }
  });
  const removePage = useMemoizedFn(async (index) => {
    setIsBusy(true);
    try {
      const newPages = pages.filter((_, i) => i !== index);
      const updatedRoot = await saveInterview(api, root._id, {
        pages: newPages
      });
      setRoot(updatedRoot.post);
      if (newPages.length === 0) {
        setCurrentPageIndex(null);
      } else if (currentPageIndex !== null) {
        const next = currentPageIndex >= newPages.length ? newPages.length - 1 : currentPageIndex;
        setCurrentPageIndex(next);
      }
    } finally {
      setIsBusy(false);
    }
  });
  const movePage = useMemoizedFn(async (fromIndex, toIndex) => {
    if (fromIndex === toIndex) {
      return;
    }
    const newPages = [...root.pages];
    const [moved] = newPages.splice(fromIndex, 1);
    newPages.splice(toIndex, 0, moved);
    await save(root._id, {
      pages: newPages
    });
    setCurrentPageIndex(toIndex);
  });
  const [appendHtmlCommand, setAppendHtmlCommand] = useState(null);
  const setAppendHtml = useMemoizedFn((command) => {
    setAppendHtmlCommand(typeof command === "string" ? {
      html: command
    } : command);
  });
  const value = useMemo(() => ({
    root,
    currentPageIndex,
    currentPostId,
    pageCount,
    setCurrentPageIndex,
    save,
    addPage,
    removePage,
    movePage,
    updateRoot,
    lastPageIndex,
    publish,
    publishDraft,
    appendHtmlCommand,
    setAppendHtml
  }), [root, currentPageIndex, currentPostId, pageCount, lastPageIndex, appendHtmlCommand]);
  return /* @__PURE__ */ jsxs(InterviewEditorContext.Provider, {
    value,
    children: [/* @__PURE__ */ jsx(LoadingOverlay, {
      isOpen: isBusy,
      message: "Saving..."
    }), children]
  });
};

const useCreateUploadBarrier = () => {
  const api = useApi();
  const {
    postId,
    staged,
    transcribeTempId,
    transcribeAddPrompt,
    transcribePromptPostId,
    transcribeModelName
  } = usePostAttachmentsCtx();
  const { root } = useInterviewEditor();
  const circleId = circleIdForPost(root);
  const { profile } = useProfileContext();
  return useMemoizedFn(async () => {
    const userId = profile && profile._id ? profile._id : "";
    const expectedIds = staged.map((_, index) => String(index));
    const transcribeIndex = transcribeTempId ? staged.findIndex((sf) => sf.tempId === transcribeTempId) : -1;
    const transcribeSignalId = transcribeIndex >= 0 ? String(transcribeIndex) : void 0;
    const promptPostId = transcribeAddPrompt && transcribePromptPostId ? transcribePromptPostId : void 0;
    const modelName = transcribeModelName || void 0;
    const { taskId } = await createUploadBarrier(api, {
      circleId,
      userId,
      postId,
      expectedIds,
      transcribeSignalId,
      promptPostId,
      modelName
    });
    return taskId;
  });
};

const useUploadAllWithSignal = () => {
  const { staged, uploadAll } = usePostAttachmentsCtx();
  const uploadAllWithSignal = useMemoizedFn((barrierTaskId) => {
    if (staged.length === 0)
      return;
    staged.forEach((sf, index) => {
      sf.signalTaskId = barrierTaskId;
      sf.signalId = String(index);
    });
    uploadAll();
  });
  return { uploadAllWithSignal };
};

const DOCX_CONTENT_TYPE$2 = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
const isDocx$1 = (file) => {
  if (file.type === DOCX_CONTENT_TYPE$2)
    return true;
  const name = file.name ? file.name.toLowerCase() : "";
  return name.endsWith(".docx");
};
const UploadAndProcessButton = () => {
  const {
    staged,
    transcribeTempId
  } = usePostAttachmentsCtx();
  const createBarrier = useCreateUploadBarrier();
  const {
    uploadAllWithSignal
  } = useUploadAllWithSignal();
  const handleClick = useMemoizedFn(async () => {
    const taskId = await createBarrier();
    if (taskId)
      uploadAllWithSignal(taskId);
  });
  if (staged.length === 0)
    return null;
  const hasDocx = staged.some((sf) => isDocx$1(sf.file));
  const hasTranscribe = !!transcribeTempId;
  return /* @__PURE__ */ jsx(ActionButton, {
    intent: "primary",
    size: "sm",
    disabled: !hasDocx && !hasTranscribe,
    onClick: handleClick,
    leftIcon: /* @__PURE__ */ jsx(MdAutoAwesome, {
      size: 14
    }),
    children: "Upload and process"
  });
};

const TranscribePromptOptions = () => {
  const {
    transcribeTempId,
    transcribeAddPrompt,
    setTranscribeAddPrompt,
    transcribePromptPostId,
    setTranscribePromptPostId,
    transcribeModelName,
    setTranscribeModelName
  } = usePostAttachmentsCtx();
  if (!transcribeTempId)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "px-3 py-2 border-t border-dashed border-gray-200 flex flex-col gap-2",
    children: [/* @__PURE__ */ jsx(Switch, {
      checked: transcribeAddPrompt,
      onChange: setTranscribeAddPrompt,
      label: "Add custom prompt"
    }), transcribeAddPrompt && /* @__PURE__ */ jsx(ConnectedPromptPostSelector, {
      label: "Select Custom Prompt",
      value: transcribePromptPostId,
      onChange: setTranscribePromptPostId,
      placeholder: "Select a saved prompt..."
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 text-xs text-gray-500",
      children: [/* @__PURE__ */ jsx("span", {
        children: "Model"
      }), /* @__PURE__ */ jsx(ModelSelector, {
        value: transcribeModelName,
        onChange: setTranscribeModelName,
        options: TRANSCRIPTION_MODEL_OPTIONS$1,
        listId: "transcribe-staging-model",
        placeholder: "gemini-3.1-pro-preview (default)"
      })]
    })]
  });
};

const StagedPanel = () => {
  const {
    staged,
    pending,
    uploadAll,
    clearStaged,
    removePending
  } = usePostAttachmentsCtx();
  const handleCancel = useMemoizedFn((tempId) => removePending(tempId));
  if (staged.length === 0 && pending.length === 0)
    return null;
  const stagedCount = staged.length;
  const pendingCount = pending.length;
  const totalLabel = stagedCount > 0 && pendingCount > 0 ? `${stagedCount} staged \xB7 ${pendingCount} uploading` : stagedCount > 0 ? `${stagedCount} ${stagedCount === 1 ? "file" : "files"} ready` : `${pendingCount} uploading`;
  return /* @__PURE__ */ jsxs("div", {
    className: "border border-gray-200 rounded-lg overflow-hidden",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between gap-3 px-3 py-2 bg-gray-50 border-b border-gray-100",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-xs font-medium text-gray-500 uppercase tracking-wide",
        children: totalLabel
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [stagedCount > 0 && /* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          size: "sm",
          onClick: clearStaged,
          leftIcon: /* @__PURE__ */ jsx(MdClear, {
            size: 14
          }),
          children: "Clear all"
        }), stagedCount > 0 && /* @__PURE__ */ jsx(ActionButton, {
          intent: "primary",
          size: "sm",
          onClick: uploadAll,
          leftIcon: /* @__PURE__ */ jsx(MdUpload, {
            size: 14
          }),
          children: "Upload all"
        }), /* @__PURE__ */ jsx(UploadAndProcessButton, {})]
      })]
    }), staged.length > 0 && /* @__PURE__ */ jsx("div", {
      children: staged.map((item) => /* @__PURE__ */ jsx(StagedRow, {
        item
      }, item.tempId))
    }), /* @__PURE__ */ jsx(TranscribePromptOptions, {}), staged.length > 0 && pending.length > 0 && /* @__PURE__ */ jsx("div", {
      className: "border-t border-dashed border-gray-200 mx-3"
    }), pending.length > 0 && /* @__PURE__ */ jsx("div", {
      children: pending.map((item) => /* @__PURE__ */ jsx(UploadProgressRow, {
        item,
        onCancel: handleCancel
      }, item.tempId))
    })]
  });
};

const AttachmentContext = createContext(null);
const useAttachmentCtx = () => {
  const ctx = useContext(AttachmentContext);
  if (!ctx)
    throw new Error("useAttachmentCtx must be used inside AttachmentProvider");
  return ctx;
};

const findByUuid = (list, uuid) => {
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    if (item.uuid === uuid || item.uuid.indexOf(uuid) !== -1) {
      return item;
    }
    if (item.variants && item.variants.length > 0) {
      var found = findByUuid(item.variants, uuid);
      if (found)
        return found;
    }
  }
  return null;
};

const AttachmentProvider = ({
  uuid,
  children
}) => {
  const {
    postId,
    attachments,
    loading,
    listError
  } = usePostAttachmentsCtx();
  const attachment = findByUuid(attachments, uuid);
  return /* @__PURE__ */ jsx(AttachmentContext.Provider, {
    value: {
      postId,
      uuid,
      attachment,
      isLoading: loading,
      error: listError
    },
    children
  });
};

const VariantRow = () => {
  const {
    attachment: variant
  } = useAttachmentCtx();
  if (!variant)
    return null;
  const isReady = !variant.status || variant.status === "ready";
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-3 pl-10 pr-3 py-2 bg-gray-50 border-t border-gray-100",
    children: [/* @__PURE__ */ jsx(MdInsertDriveFile, {
      size: 14,
      className: "text-gray-400 shrink-0"
    }), /* @__PURE__ */ jsxs("span", {
      className: "flex-1 text-xs text-gray-600 min-w-0 truncate",
      children: [variant.originalFileName, variant.variantType && /* @__PURE__ */ jsx("span", {
        className: "ml-1.5 italic text-gray-400",
        children: variant.variantType
      })]
    }), /* @__PURE__ */ jsx("span", {
      className: "text-xs text-gray-400 shrink-0",
      children: formatFileSize(variant.originalFileSize)
    }), /* @__PURE__ */ jsx(StatusBadge, {
      status: variant.status
    }), isReady && variant.url ? /* @__PURE__ */ jsx(Tooltip$1, {
      content: "Download variant",
      placement: "top",
      children: /* @__PURE__ */ jsx("a", {
        href: variant.url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "p-1 text-gray-400 hover:text-gray-700 transition-colors rounded shrink-0",
        "aria-label": "Download variant",
        children: /* @__PURE__ */ jsx(MdDownload, {
          size: 14
        })
      })
    }) : /* @__PURE__ */ jsx("span", {
      className: "w-6 shrink-0"
    }), /* @__PURE__ */ jsx("span", {
      className: "w-7 shrink-0"
    })]
  });
};

const AttachmentRow = () => {
  const {
    remove,
    processing,
    selectAttachment
  } = usePostAttachmentsCtx();
  const {
    attachment
  } = useAttachmentCtx();
  if (!attachment)
    return null;
  const isReady = !attachment.status || attachment.status === "ready";
  const hasVariants = !!(attachment.variants && attachment.variants.length > 0);
  const data = attachment.data;
  const taskId = data && data.processingTaskId ? data.processingTaskId : "";
  const task = taskId && processing[taskId] ? processing[taskId] : void 0;
  const isProcessing = !!(task && task.phase === "processing");
  const isProcessingError = !!(task && task.phase === "error");
  const variantCount = hasVariants ? attachment.variants.length : 0;
  const confirmMessage = hasVariants ? `Remove "${attachment.originalFileName}" and ${variantCount} variant${variantCount > 1 ? "s" : ""}?` : `Remove "${attachment.originalFileName}"?`;
  const {
    open,
    confirmationProps
  } = useConfirmation({
    title: "Remove attachment",
    message: confirmMessage,
    confirmText: "Remove",
    confirmIntent: "danger",
    onConfirm: () => remove(attachment.uuid)
  });
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-3 px-3 py-2.5",
      children: [/* @__PURE__ */ jsx(MdInsertDriveFile, {
        size: 18,
        className: "text-gray-400 shrink-0"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1 min-w-0",
        children: [/* @__PURE__ */ jsx("button", {
          onClick: () => selectAttachment(attachment.uuid),
          className: "text-sm font-medium text-gray-900 underline decoration-gray-300 hover:decoration-gray-600 underline-offset-2 truncate block text-left",
          children: attachment.label || attachment.originalFileName
        }), attachment.label && /* @__PURE__ */ jsx("p", {
          className: "text-xs text-gray-500 truncate",
          children: attachment.label
        })]
      }), /* @__PURE__ */ jsx("span", {
        className: "text-xs text-gray-400 shrink-0",
        children: formatFileSize(attachment.originalFileSize)
      }), isProcessing ? /* @__PURE__ */ jsxs("span", {
        className: "shrink-0 flex items-center gap-1.5 text-xs px-2 py-0.5 rounded font-medium bg-blue-100 text-blue-700",
        children: [/* @__PURE__ */ jsx(Spinner, {
          size: "xs"
        }), task.percent, "%"]
      }) : isProcessingError ? /* @__PURE__ */ jsx("span", {
        className: "shrink-0 text-xs px-2 py-0.5 rounded font-medium bg-red-100 text-red-700",
        children: "Processing failed"
      }) : /* @__PURE__ */ jsx(StatusBadge, {
        status: attachment.status
      }), isReady && attachment.url ? /* @__PURE__ */ jsx("a", {
        href: attachment.url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "p-1.5 text-gray-400 hover:text-gray-700 transition-colors rounded shrink-0",
        title: "Download",
        children: /* @__PURE__ */ jsx(MdDownload, {
          size: 16
        })
      }) : /* @__PURE__ */ jsx("span", {
        className: "w-7 shrink-0"
      }), /* @__PURE__ */ jsx("button", {
        onClick: open,
        className: "p-1.5 text-gray-400 hover:text-red-500 transition-colors rounded shrink-0",
        title: "Remove attachment",
        children: /* @__PURE__ */ jsx(MdDeleteOutline, {
          size: 16
        })
      })]
    }), isProcessing && /* @__PURE__ */ jsxs("div", {
      className: "px-3 pb-2.5 -mt-1",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between text-xs text-gray-500 mb-1",
        children: [/* @__PURE__ */ jsx("span", {
          className: "truncate",
          children: task.phaseLabel || "Processing\u2026"
        }), /* @__PURE__ */ jsxs("span", {
          className: "shrink-0 ml-2",
          children: [task.percent, "%"]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "w-full h-1.5 bg-gray-100 rounded-full overflow-hidden",
        children: /* @__PURE__ */ jsx("div", {
          className: "h-full bg-blue-500 rounded-full transition-all duration-300",
          style: {
            width: task.percent + "%"
          }
        })
      })]
    }), hasVariants && attachment.variants.map((variant) => /* @__PURE__ */ jsx(AttachmentProvider, {
      uuid: variant.uuid,
      children: /* @__PURE__ */ jsx(VariantRow, {})
    }, variant.uuid)), /* @__PURE__ */ jsx(ConfirmationOverlay, {
      ...confirmationProps
    })]
  });
};

const AttachmentList = () => {
  const {
    attachments,
    loading,
    listError,
    reload
  } = usePostAttachmentsCtx();
  if (loading && attachments.length === 0) {
    return /* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-center py-12",
      children: /* @__PURE__ */ jsx(Spinner, {
        size: "md"
      })
    });
  }
  if (listError) {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx(ErrorPanel$1, {
        error: listError
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "sm",
        onClick: reload,
        leftIcon: /* @__PURE__ */ jsx(MdRefresh, {
          size: 16
        }),
        children: "Retry"
      })]
    });
  }
  if (attachments.length === 0) {
    return /* @__PURE__ */ jsx("div", {
      className: "border border-dashed border-gray-200 rounded-lg py-10 text-center",
      children: /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-400",
        children: "No attachments yet"
      })
    });
  }
  const count = attachments.length;
  return /* @__PURE__ */ jsxs("div", {
    className: "border border-gray-200 rounded-lg overflow-hidden",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "px-3 py-2 bg-gray-50 border-b border-gray-100 flex items-center justify-between",
      children: [/* @__PURE__ */ jsxs("span", {
        className: "text-xs font-medium text-gray-500 uppercase tracking-wide",
        children: ["Attachments \u2014 ", count, " ", count === 1 ? "file" : "files"]
      }), loading && /* @__PURE__ */ jsx(Spinner, {
        size: "xs"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "divide-y divide-gray-100",
      children: attachments.map((attachment) => /* @__PURE__ */ jsx(AttachmentProvider, {
        uuid: attachment.uuid,
        children: /* @__PURE__ */ jsx(AttachmentRow, {})
      }, attachment.uuid))
    })]
  });
};

const InfoRow = ({
  label,
  value
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex gap-2 py-1 border-b border-gray-100 last:border-0",
  children: [/* @__PURE__ */ jsx("span", {
    className: "w-36 shrink-0 text-sm text-gray-500",
    children: label
  }), /* @__PURE__ */ jsx("span", {
    className: "text-sm text-gray-900 break-all",
    children: value
  })]
});

const FileInfoCardHeader = ({
  title,
  status,
  statusColor,
  actions,
  expanded,
  onToggle
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex items-center gap-2 w-full min-w-0",
  children: [/* @__PURE__ */ jsx(ToggleButton, {
    expanded,
    onToggle,
    size: "sm",
    variant: "subtle"
  }), /* @__PURE__ */ jsx("h2", {
    className: "flex-1 min-w-0 text-sm font-semibold text-gray-900 truncate",
    children: title
  }), status && statusColor && /* @__PURE__ */ jsx("span", {
    className: `shrink-0 text-xs px-2 py-0.5 rounded-full font-medium ${statusColor}`,
    children: status
  }), actions && /* @__PURE__ */ jsx("div", {
    className: "shrink-0 flex items-center gap-1",
    onClick: (e) => e.stopPropagation(),
    children: actions
  })]
});
const FileInfoCard = ({
  title,
  status,
  statusColor,
  fields,
  actions,
  defaultCollapsed = true
}) => /* @__PURE__ */ jsx(CollapsibleSection, {
  title,
  variant: "card",
  defaultCollapsed,
  headerSize: "sm",
  contentSize: "sm",
  renderHeader: (expanded, onToggle) => /* @__PURE__ */ jsx(FileInfoCardHeader, {
    title,
    status,
    statusColor,
    actions,
    expanded,
    onToggle
  }),
  children: /* @__PURE__ */ jsx("div", {
    className: "flex flex-col",
    children: fields.map((f) => /* @__PURE__ */ jsx(InfoRow, {
      label: f.label,
      value: f.value
    }, f.label))
  })
});

const AttachmentInfoPanel = ({
  attachment
}) => {
  const status = attachment.status || "ready";
  const statusText = STATUS_LABELS[status] || status;
  const statusColor = STATUS_CLASSES[status] || STATUS_CLASSES.ready;
  const infoFields = [{
    label: "File name",
    value: attachment.originalFileName || "\u2014"
  }, {
    label: "Content type",
    value: attachment.contentType
  }, {
    label: "Size",
    value: formatFileSize(attachment.originalFileSize)
  }, {
    label: "Storage key",
    value: attachment.uuid
  }, ...attachment.error ? [{
    label: "Error",
    value: attachment.error
  }] : []];
  const downloadAction = attachment.url ? /* @__PURE__ */ jsx(Tooltip$1, {
    content: "Download original",
    placement: "top",
    children: /* @__PURE__ */ jsx("a", {
      href: attachment.url,
      target: "_blank",
      rel: "noreferrer",
      className: "flex items-center justify-center w-7 h-7 rounded hover:bg-gray-100 text-gray-500 hover:text-gray-800 transition-colors",
      "aria-label": "Download original",
      children: /* @__PURE__ */ jsx(MdFileDownload, {
        size: 18
      })
    })
  }) : void 0;
  return /* @__PURE__ */ jsx(FileInfoCard, {
    title: attachment.label || attachment.originalFileName,
    status: statusText,
    statusColor,
    fields: infoFields,
    actions: downloadAction
  });
};

const VariantsPanel = ({
  variants
}) => {
  if (!variants.length)
    return null;
  return /* @__PURE__ */ jsxs("div", {
    className: "bg-white rounded-lg border border-gray-200 p-4",
    children: [/* @__PURE__ */ jsxs("h2", {
      className: "text-sm font-semibold text-gray-700 mb-3",
      children: ["Attachments (", variants.length, ")"]
    }), /* @__PURE__ */ jsx("div", {
      children: variants.map((v) => /* @__PURE__ */ jsx(AttachmentProvider, {
        uuid: v.uuid,
        children: /* @__PURE__ */ jsx(VariantRow, {})
      }, v.uuid))
    })]
  });
};

const useRemoteText$1 = (url) => {
  const [state, setState] = useState({
    html: null,
    loading: false,
    error: null
  });
  const fetchText = useMemoizedFn(async (target) => {
    setState({
      html: null,
      loading: true,
      error: null
    });
    try {
      const res = await fetch(target);
      if (!res.ok) {
        setState({
          html: null,
          loading: false,
          error: `HTTP ${res.status}`
        });
        return;
      }
      const text = await res.text();
      setState({
        html: text,
        loading: false,
        error: null
      });
    } catch (err) {
      const msg = err && err.message ? err.message : "Fetch failed";
      setState({
        html: null,
        loading: false,
        error: msg
      });
    }
  });
  useEffect(() => {
    if (!url)
      return;
    fetchText(url);
  }, [url]);
  return state;
};
const isHtmlType = (contentType) => {
  if (!contentType)
    return false;
  return contentType === "text/html" || contentType.startsWith("text/html;");
};
const HtmlAttachmentViewer = ({
  attachment
}) => {
  if (!isHtmlType(attachment.contentType))
    return null;
  if (!attachment.url)
    return null;
  const interviewCtx = useContext(InterviewEditorContext);
  const {
    html,
    loading,
    error
  } = useRemoteText$1(attachment.url);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(CollapsibleSection, {
      title: "HTML Preview",
      defaultCollapsed: true,
      variant: "card",
      headerSize: "sm",
      contentSize: "sm",
      children: [loading && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 py-4 text-sm text-gray-400",
        children: [/* @__PURE__ */ jsx(Spinner, {
          size: "sm"
        }), /* @__PURE__ */ jsx("span", {
          children: "Loading preview\u2026"
        })]
      }), error && !loading && /* @__PURE__ */ jsxs("p", {
        className: "py-3 text-sm text-red-500",
        children: ["Preview unavailable \u2014 ", error, ".", " ", /* @__PURE__ */ jsx("a", {
          href: attachment.url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "underline",
          children: "Download to view"
        }), "."]
      }), html && !loading && /* @__PURE__ */ jsx("div", {
        className: "text-sm text-gray-800 leading-relaxed overflow-auto max-h-[480px]",
        children: /* @__PURE__ */ jsx(HtmlContent, {
          html: extractBodyHtml(html),
          dir: "auto"
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-row gap-2",
      children: html && !loading && interviewCtx && /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "sm",
        leftIcon: /* @__PURE__ */ jsx(MdOutlinePostAdd, {
          size: 16
        }),
        onClick: () => interviewCtx.setAppendHtml(extractBodyHtml(html)),
        children: "Append to editor"
      })
    })]
  });
};

const DOCX_CONTENT_TYPE$1 = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
const isDocxType = (contentType) => {
  if (!contentType)
    return false;
  return contentType === DOCX_CONTENT_TYPE$1;
};
const findHtmlVariant$1 = (attachment) => {
  if (!attachment.variants)
    return null;
  for (var i = 0; i < attachment.variants.length; i++) {
    var v = attachment.variants[i];
    if (v.variantType === "html" && v.status === "ready")
      return v;
  }
  return null;
};
const useRemoteHtml = (url) => {
  const [state, setState] = useState({
    html: null,
    loading: false,
    error: null
  });
  const fetchText = useMemoizedFn(async (target) => {
    setState({
      html: null,
      loading: true,
      error: null
    });
    try {
      const res = await fetch(target);
      if (!res.ok) {
        setState({
          html: null,
          loading: false,
          error: `HTTP ${res.status}`
        });
        return;
      }
      const text = await res.text();
      setState({
        html: text,
        loading: false,
        error: null
      });
    } catch (err) {
      const msg = err && err.message ? err.message : "Fetch failed";
      setState({
        html: null,
        loading: false,
        error: msg
      });
    }
  });
  useEffect(() => {
    if (!url)
      return;
    fetchText(url);
  }, [url]);
  return state;
};
const DocxAttachmentViewer = ({
  attachment
}) => {
  if (!isDocxType(attachment.contentType))
    return null;
  const interviewCtx = useContext(InterviewEditorContext);
  const api = useApi();
  const {
    postId,
    reload
  } = usePostAttachmentsCtx();
  const [converting, setConverting] = useState(false);
  const [convertError, setConvertError] = useState(null);
  const htmlVariant = findHtmlVariant$1(attachment);
  const htmlUrl = htmlVariant && htmlVariant.url ? htmlVariant.url : void 0;
  const {
    html,
    loading: htmlLoading,
    error: htmlError
  } = useRemoteHtml(htmlUrl);
  const handleConvert = useMemoizedFn(async () => {
    setConverting(true);
    setConvertError(null);
    try {
      await convertDocxToHtml(api, postId, attachment.uuid);
      await reload();
    } catch (err) {
      const msg = err && err.message ? err.message : "Conversion failed";
      setConvertError(msg);
    } finally {
      setConverting(false);
    }
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(CollapsibleSection, {
      title: "HTML Preview",
      defaultCollapsed: false,
      variant: "card",
      headerSize: "sm",
      contentSize: "sm",
      children: [!htmlVariant && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-3 py-3",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-sm text-gray-500",
          children: "Convert this document to HTML to preview it inline."
        }), convertError && /* @__PURE__ */ jsx("p", {
          className: "text-sm text-red-500",
          children: convertError
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "primary",
          size: "sm",
          onClick: handleConvert,
          disabled: converting,
          leftIcon: converting ? /* @__PURE__ */ jsx(Spinner, {
            size: "xs"
          }) : void 0,
          children: converting ? "Converting\u2026" : "Convert to HTML"
        })]
      }), htmlVariant && htmlLoading && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 py-4 text-sm text-gray-400",
        children: [/* @__PURE__ */ jsx(Spinner, {
          size: "sm"
        }), /* @__PURE__ */ jsx("span", {
          children: "Loading preview\u2026"
        })]
      }), htmlVariant && htmlError && !htmlLoading && /* @__PURE__ */ jsxs("p", {
        className: "py-3 text-sm text-red-500",
        children: ["Preview unavailable \u2014 ", htmlError, ".", " ", htmlVariant.url && /* @__PURE__ */ jsx("a", {
          href: htmlVariant.url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "underline",
          children: "Download to view"
        })]
      }), htmlVariant && html && !htmlLoading && /* @__PURE__ */ jsx("div", {
        className: "text-sm text-gray-800 leading-relaxed overflow-auto max-h-[480px]",
        children: /* @__PURE__ */ jsx(HtmlContent, {
          html: extractBodyHtml(html),
          dir: "auto"
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-row gap-2",
      children: htmlVariant && html && !htmlLoading && interviewCtx && /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "sm",
        leftIcon: /* @__PURE__ */ jsx(MdOutlinePostAdd, {
          size: 16
        }),
        onClick: () => interviewCtx.setAppendHtml(extractBodyHtml(html)),
        children: "Append to editor"
      })
    })]
  });
};

const isImageType = (contentType) => {
  if (!contentType)
    return false;
  return contentType.startsWith("image/");
};
const ImageAttachmentViewer = ({
  attachment
}) => {
  if (!isImageType(attachment.contentType))
    return null;
  if (!attachment.url)
    return null;
  const [loadError, setLoadError] = useState(false);
  const handleError = useMemoizedFn(() => setLoadError(true));
  const alt = attachment.label || attachment.originalFileName;
  return /* @__PURE__ */ jsxs(CollapsibleSection, {
    title: "Image Preview",
    defaultCollapsed: false,
    variant: "card",
    headerSize: "sm",
    contentSize: "sm",
    children: [loadError ? /* @__PURE__ */ jsxs("p", {
      className: "py-3 text-sm text-red-500",
      children: ["Preview unavailable.", " ", /* @__PURE__ */ jsx("a", {
        href: attachment.url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "underline",
        children: "Open file"
      })]
    }) : /* @__PURE__ */ jsx("a", {
      href: attachment.url,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "block",
      title: "Open full size",
      children: /* @__PURE__ */ jsx("img", {
        src: attachment.url,
        alt,
        onError: handleError,
        className: "max-h-[480px] w-auto max-w-full rounded object-contain"
      })
    }), attachment.dimensions && /* @__PURE__ */ jsxs("p", {
      className: "mt-2 text-xs text-gray-400",
      children: [attachment.dimensions.width, " \xD7 ", attachment.dimensions.height, " px"]
    })]
  });
};

const encodeUuid$2 = (uuid) => encodeURIComponent(uuid);
const INITIAL_STATE$2 = {
  phase: "idle",
  percent: 0,
  phaseLabel: "",
  segmentCount: null,
  transcoded: null,
  durationSeconds: null,
  error: null
};
const useHlsConversion = (postId, attachmentUuid) => {
  const api = useApi();
  const jwt = useJwt();
  const [state, setState] = useState(INITIAL_STATE$2);
  const [url, setUrl] = useState("");
  const start = useMemoizedFn(() => {
    setState({ ...INITIAL_STATE$2, phase: "converting", phaseLabel: "Starting\u2026" });
    setUrl(api.buildUrl(`interviews/${postId}/attachments/${encodeUuid$2(attachmentUuid)}/convert-to-hls`, { token: jwt }));
  });
  const cancel = useMemoizedFn(() => {
    setUrl("");
    setState(INITIAL_STATE$2);
  });
  useSSEConnection({
    url,
    enabled: url !== "",
    maxReconnectAttempts: 0
  }, [
    {
      event: "progress",
      handler: (data) => {
        setState((prev) => ({
          ...prev,
          percent: data && data.percent ? data.percent : prev.percent,
          phaseLabel: data && data.phase ? data.phase : prev.phaseLabel
        }));
      }
    },
    {
      event: "complete",
      handler: (data) => {
        setUrl("");
        setState({
          phase: "done",
          percent: 100,
          phaseLabel: "Done",
          segmentCount: data && data.segmentCount ? data.segmentCount : null,
          transcoded: data && data.transcoded != null ? data.transcoded : null,
          durationSeconds: data && data.durationSeconds ? data.durationSeconds : null,
          error: null
        });
      }
    },
    {
      event: "failed",
      handler: (data) => {
        setUrl("");
        setState((prev) => ({
          ...prev,
          phase: "error",
          error: data && data.error ? data.error : "Conversion failed"
        }));
      }
    }
  ]);
  return { ...state, start, cancel };
};

const encodeUuid$1 = (uuid) => encodeURIComponent(uuid);
const INITIAL_STATE$1 = {
  phase: "idle",
  percent: 0,
  phaseLabel: "",
  htmlVariant: null,
  audioVariant: null,
  transcriptLength: null,
  error: null
};
const useTranscription = (postId, attachmentUuid) => {
  const api = useApi();
  const jwt = useJwt();
  const [state, setState] = useState(INITIAL_STATE$1);
  const [url, setUrl] = useState("");
  const start = useMemoizedFn((opts = {}) => {
    setState({ ...INITIAL_STATE$1, phase: "transcribing", phaseLabel: "Starting\u2026" });
    setUrl(api.buildUrl(`interviews/${postId}/attachments/${encodeUuid$1(attachmentUuid)}/transcribe`, {
      token: jwt,
      ...opts.promptPostId ? { promptPostId: opts.promptPostId } : {},
      ...opts.modelName ? { modelName: opts.modelName } : {}
    }));
  });
  const cancel = useMemoizedFn(() => {
    setUrl("");
    setState(INITIAL_STATE$1);
  });
  useSSEConnection({
    url,
    enabled: url !== "",
    maxReconnectAttempts: 0
  }, [
    {
      event: "progress",
      handler: (data) => {
        setState((prev) => ({
          ...prev,
          percent: data && data.percent != null ? data.percent : prev.percent,
          phaseLabel: data && data.phase ? data.phase : prev.phaseLabel
        }));
      }
    },
    {
      event: "complete",
      handler: (data) => {
        setUrl("");
        setState({
          phase: "done",
          percent: 100,
          phaseLabel: "Done",
          htmlVariant: data && data.htmlVariant ? data.htmlVariant : null,
          audioVariant: data && data.audioVariant ? data.audioVariant : null,
          transcriptLength: data && data.transcriptLength != null ? data.transcriptLength : null,
          error: null
        });
      }
    },
    {
      event: "failed",
      handler: (data) => {
        setUrl("");
        setState((prev) => ({
          ...prev,
          phase: "error",
          error: data && data.error ? data.error : "Transcription failed"
        }));
      }
    }
  ]);
  return { ...state, start, cancel };
};

const findHtmlVariant = (attachment) => {
  if (!attachment.variants)
    return null;
  for (let i = 0; i < attachment.variants.length; i++) {
    const v = attachment.variants[i];
    if (v.variantType === "html" && v.status === "ready")
      return v;
  }
  return null;
};
const TRANSCRIPTION_MODEL_OPTIONS = [{
  label: "Gemini 3.1 Pro (default)",
  value: "gemini-3.1-pro-preview"
}, {
  label: "Gemini 3.6 Flash",
  value: "gemini-3.6-flash"
}];
const findExtractedAudioVariant = (attachment) => {
  if (!attachment.variants)
    return null;
  for (let i = 0; i < attachment.variants.length; i++) {
    const v = attachment.variants[i];
    if (v.variantType === "extracted-audio" && v.status === "ready")
      return v;
  }
  return null;
};
const isVideoType$1 = (contentType) => {
  if (!contentType)
    return false;
  return contentType.startsWith("video/");
};
const useRemoteText = (url) => {
  const [state, setState] = useState({
    html: null,
    loading: false,
    error: null
  });
  const fetchText = useMemoizedFn(async (target) => {
    setState({
      html: null,
      loading: true,
      error: null
    });
    try {
      const res = await fetch(target);
      if (!res.ok) {
        setState({
          html: null,
          loading: false,
          error: `HTTP ${res.status}`
        });
        return;
      }
      const text = await res.text();
      setState({
        html: text,
        loading: false,
        error: null
      });
    } catch (err) {
      const msg = err && err.message ? err.message : "Fetch failed";
      setState({
        html: null,
        loading: false,
        error: msg
      });
    }
  });
  useEffect(() => {
    if (!url)
      return;
    fetchText(url);
  }, [url]);
  return state;
};
const TranscriptionSection = ({
  attachment,
  postId,
  onDone
}) => {
  const {
    remove
  } = usePostAttachmentsCtx();
  const transcription = useTranscription(postId, attachment.uuid);
  const [addPrompt, setAddPrompt] = useState(false);
  const [promptPostId, setPromptPostId] = useState(void 0);
  const [modelName, setModelName] = useState("");
  const [deleting, setDeleting] = useState(null);
  const htmlVariant = findHtmlVariant(attachment);
  const audioVariant = findExtractedAudioVariant(attachment);
  const isVideo = isVideoType$1(attachment.contentType);
  const htmlUrl = htmlVariant && htmlVariant.url ? htmlVariant.url : void 0;
  const {
    html,
    loading: htmlLoading,
    error: htmlError
  } = useRemoteText(htmlUrl);
  useEffect(() => {
    if (transcription.phase === "done") {
      onDone();
    }
  }, [transcription.phase]);
  const handleTranscribe = useMemoizedFn(() => {
    transcription.start({
      promptPostId: addPrompt ? promptPostId : void 0,
      modelName: modelName || void 0
    });
  });
  const handleDeleteHtml = useMemoizedFn(async () => {
    if (!htmlVariant)
      return;
    setDeleting("html");
    try {
      await remove(htmlVariant.uuid);
      onDone();
    } finally {
      setDeleting(null);
    }
  });
  const handleDeleteAudio = useMemoizedFn(async () => {
    if (!audioVariant)
      return;
    setDeleting("audio");
    try {
      await remove(audioVariant.uuid);
      onDone();
    } finally {
      setDeleting(null);
    }
  });
  if (transcription.phase === "transcribing") {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between text-xs text-gray-500",
        children: [/* @__PURE__ */ jsxs("span", {
          className: "flex items-center gap-1.5",
          children: [/* @__PURE__ */ jsx(Spinner, {
            size: "xs"
          }), transcription.phaseLabel]
        }), /* @__PURE__ */ jsxs("span", {
          children: [transcription.percent, "%"]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "w-full h-1.5 bg-gray-100 rounded-full overflow-hidden",
        children: /* @__PURE__ */ jsx("div", {
          className: "h-full bg-blue-500 rounded-full transition-all duration-300",
          style: {
            width: transcription.percent + "%"
          }
        })
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "sm",
        onClick: transcription.cancel,
        children: "Cancel"
      })]
    });
  }
  if (htmlVariant) {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-3",
      children: [htmlLoading && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 py-4 text-sm text-gray-400",
        children: [/* @__PURE__ */ jsx(Spinner, {
          size: "sm"
        }), /* @__PURE__ */ jsx("span", {
          children: "Loading transcript\u2026"
        })]
      }), htmlError && !htmlLoading && /* @__PURE__ */ jsxs("p", {
        className: "py-3 text-sm text-red-500",
        children: ["Preview unavailable \u2014 ", htmlError, "."]
      }), html && !htmlLoading && /* @__PURE__ */ jsx("div", {
        className: "text-sm text-gray-800 leading-relaxed overflow-auto max-h-[480px]",
        children: /* @__PURE__ */ jsx(HtmlContent, {
          html: extractBodyHtml(html),
          dir: "auto"
        })
      }), /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-500",
        children: "Transcript ready. To retry with a different prompt, delete it first."
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "sm",
        onClick: handleDeleteHtml,
        disabled: deleting === "html",
        leftIcon: deleting === "html" ? /* @__PURE__ */ jsx(Spinner, {
          size: "xs"
        }) : void 0,
        children: deleting === "html" ? "Deleting\u2026" : "Delete HTML"
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "primary",
        size: "sm",
        onClick: handleTranscribe,
        disabled: true,
        children: "Transcribe"
      })]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-3",
    children: [isVideo && audioVariant && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-500",
        children: "Reusing previously extracted audio. To re-extract from the source video, delete it first."
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "sm",
        onClick: handleDeleteAudio,
        disabled: deleting === "audio",
        leftIcon: deleting === "audio" ? /* @__PURE__ */ jsx(Spinner, {
          size: "xs"
        }) : void 0,
        children: deleting === "audio" ? "Deleting\u2026" : "Delete audio"
      })]
    }), transcription.phase === "error" && transcription.error && /* @__PURE__ */ jsx("p", {
      className: "text-sm text-red-500",
      children: transcription.error
    }), /* @__PURE__ */ jsx(Switch, {
      checked: addPrompt,
      onChange: setAddPrompt,
      label: "Add custom prompt"
    }), addPrompt && /* @__PURE__ */ jsx(ConnectedPromptPostSelector, {
      label: "Select Custom Prompt",
      value: promptPostId,
      onChange: setPromptPostId,
      placeholder: "Select a saved prompt..."
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 text-xs text-gray-500",
      children: [/* @__PURE__ */ jsx("span", {
        children: "Model"
      }), /* @__PURE__ */ jsx(ModelSelector, {
        value: modelName,
        onChange: setModelName,
        options: TRANSCRIPTION_MODEL_OPTIONS,
        listId: "transcription-model",
        placeholder: "gemini-3.1-pro-preview (default)"
      })]
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "primary",
      size: "sm",
      onClick: handleTranscribe,
      children: transcription.phase === "error" ? "Retry" : "Transcribe"
    })]
  });
};

const isVideoType = (contentType) => {
  if (!contentType)
    return false;
  return contentType.startsWith("video/");
};
const encodeUuid = (uuid) => encodeURIComponent(uuid);
const formatDuration = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return m + ":" + (s < 10 ? "0" : "") + s;
};
const HlsSection = ({
  attachment,
  postId,
  onConversionDone
}) => {
  const api = useApi();
  const jwt = useJwt();
  const hlsVariant = findHlsVariant(attachment);
  const conversion = useHlsConversion(postId, attachment.uuid);
  useEffect(() => {
    if (conversion.phase === "done") {
      onConversionDone();
    }
  }, [conversion.phase]);
  const playlistUrl = useMemo(() => {
    if (!hlsVariant || !jwt)
      return "";
    return api.buildUrl(`interviews/${postId}/attachments/${encodeUuid(attachment.uuid)}/hls/playlist.m3u8`, {
      token: jwt
    });
  }, [hlsVariant, postId, attachment.uuid, jwt]);
  if (hlsVariant) {
    const data = hlsVariant.data;
    const segmentCount = data && data.segmentCount ? data.segmentCount : null;
    const durationSeconds = data && data.durationSeconds ? data.durationSeconds : null;
    const transcoded = data && data.transcoded != null ? data.transcoded : null;
    return /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 text-xs text-gray-500",
        children: [segmentCount && /* @__PURE__ */ jsxs("span", {
          children: [segmentCount, " segments"]
        }), durationSeconds && /* @__PURE__ */ jsx("span", {
          children: formatDuration(durationSeconds)
        }), transcoded != null && /* @__PURE__ */ jsx("span", {
          className: "px-1.5 py-0.5 rounded bg-gray-100",
          children: transcoded ? "transcoded" : "remuxed"
        })]
      }), /* @__PURE__ */ jsx(CollapsibleSection, {
        title: "Player",
        defaultCollapsed: true,
        variant: "card",
        headerSize: "sm",
        contentSize: "sm",
        children: /* @__PURE__ */ jsx(MediaHlsPlayer, {
          src: playlistUrl,
          title: attachment.label || attachment.originalFileName
        })
      })]
    });
  }
  if (conversion.phase === "converting") {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between text-xs text-gray-500",
        children: [/* @__PURE__ */ jsxs("span", {
          className: "flex items-center gap-1.5",
          children: [/* @__PURE__ */ jsx(Spinner, {
            size: "xs"
          }), conversion.phaseLabel]
        }), /* @__PURE__ */ jsxs("span", {
          children: [conversion.percent, "%"]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "w-full h-1.5 bg-gray-100 rounded-full overflow-hidden",
        children: /* @__PURE__ */ jsx("div", {
          className: "h-full bg-blue-500 rounded-full transition-all duration-300",
          style: {
            width: conversion.percent + "%"
          }
        })
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "sm",
        onClick: conversion.cancel,
        children: "Cancel"
      })]
    });
  }
  if (conversion.phase === "done") {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 text-sm text-gray-400",
      children: [/* @__PURE__ */ jsx(Spinner, {
        size: "xs"
      }), /* @__PURE__ */ jsx("span", {
        children: "Refreshing\u2026"
      })]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-3",
    children: [/* @__PURE__ */ jsx("p", {
      className: "text-sm text-gray-500",
      children: "Prepare this video for adaptive streaming (HLS). This may take a few minutes depending on file size."
    }), conversion.phase === "error" && conversion.error && /* @__PURE__ */ jsx("p", {
      className: "text-sm text-red-500",
      children: conversion.error
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "primary",
      size: "sm",
      onClick: conversion.start,
      children: conversion.phase === "error" ? "Retry" : "Prepare for streaming"
    })]
  });
};
const VideoAttachmentViewer = ({
  attachment
}) => {
  if (!isVideoType(attachment.contentType))
    return null;
  if (!attachment.url)
    return null;
  const {
    postId,
    reload
  } = usePostAttachmentsCtx();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(CollapsibleSection, {
      title: "Video",
      defaultCollapsed: true,
      variant: "card",
      headerSize: "sm",
      contentSize: "sm",
      children: /* @__PURE__ */ jsx(MediaVideoPlayer, {
        src: attachment.url,
        contentType: attachment.contentType,
        title: attachment.label || attachment.originalFileName
      })
    }), /* @__PURE__ */ jsx(CollapsibleSection, {
      title: "Streaming (HLS)",
      defaultCollapsed: false,
      variant: "card",
      headerSize: "sm",
      contentSize: "sm",
      children: /* @__PURE__ */ jsx(HlsSection, {
        attachment,
        postId,
        onConversionDone: reload
      })
    }), /* @__PURE__ */ jsx(CollapsibleSection, {
      title: "Transcript",
      defaultCollapsed: false,
      variant: "card",
      headerSize: "sm",
      contentSize: "sm",
      children: /* @__PURE__ */ jsx(TranscriptionSection, {
        attachment,
        postId,
        onDone: reload
      })
    })]
  });
};

const isAudioType = (contentType) => {
  if (!contentType)
    return false;
  return contentType.startsWith("audio/");
};
const isWmaSource = (attachment) => {
  const name = attachment.originalFileName;
  const ct = attachment.contentType;
  if (name && /\.wma$/i.test(name))
    return true;
  if (ct && ct.indexOf("x-ms-wma") !== -1)
    return true;
  return false;
};
const findReadyMp3Variant = (attachment) => {
  if (!attachment.variants)
    return null;
  for (let i = 0; i < attachment.variants.length; i++) {
    const v = attachment.variants[i];
    if (v.variantType === "mp3" && v.status === "ready")
      return v;
  }
  return null;
};
const AudioAttachmentViewer = ({
  attachment
}) => {
  const {
    postId,
    reload
  } = usePostAttachmentsCtx();
  const isWma = isWmaSource(attachment);
  if (!isAudioType(attachment.contentType) && !isWma)
    return null;
  if (isWma) {
    const mp3 = findReadyMp3Variant(attachment);
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(CollapsibleSection, {
        title: "Audio",
        defaultCollapsed: false,
        variant: "card",
        headerSize: "sm",
        contentSize: "sm",
        children: mp3 && mp3.url ? /* @__PURE__ */ jsx(MediaAudioPlayer, {
          src: mp3.url,
          contentType: "audio/mpeg",
          title: attachment.label || attachment.originalFileName
        }) : /* @__PURE__ */ jsx("p", {
          className: "py-3 text-sm text-gray-400",
          children: "Preparing an MP3 version for playback\u2026"
        })
      }), /* @__PURE__ */ jsx(CollapsibleSection, {
        title: "Transcript",
        defaultCollapsed: false,
        variant: "card",
        headerSize: "sm",
        contentSize: "sm",
        children: /* @__PURE__ */ jsx(TranscriptionSection, {
          attachment,
          postId,
          onDone: reload
        })
      })]
    });
  }
  if (!attachment.url)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(CollapsibleSection, {
      title: "Audio",
      defaultCollapsed: false,
      variant: "card",
      headerSize: "sm",
      contentSize: "sm",
      children: /* @__PURE__ */ jsx(MediaAudioPlayer, {
        src: attachment.url,
        contentType: attachment.contentType,
        title: attachment.label || attachment.originalFileName
      })
    }), /* @__PURE__ */ jsx(CollapsibleSection, {
      title: "Transcript",
      defaultCollapsed: false,
      variant: "card",
      headerSize: "sm",
      contentSize: "sm",
      children: /* @__PURE__ */ jsx(TranscriptionSection, {
        attachment,
        postId,
        onDone: reload
      })
    })]
  });
};

const AttachmentWorkspaceInner = () => {
  const {
    attachment,
    isLoading,
    error
  } = useAttachmentCtx();
  const attachmentsCtx = useContext(PostAttachmentsContext);
  const handleBack = attachmentsCtx ? () => attachmentsCtx.selectAttachment(null) : () => window.history.back();
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-8 text-sm text-gray-400",
      children: "Loading\u2026"
    });
  }
  if (error) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-8 text-sm text-red-500",
      children: ["Failed to load attachment: ", error]
    });
  }
  if (!attachment) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-8 text-sm text-gray-400",
      children: "Attachment not found."
    });
  }
  const variants = attachment.variants || [];
  return /* @__PURE__ */ jsxs("div", {
    className: "max-w-3xl mx-auto px-4 py-6 flex flex-col gap-6",
    children: [/* @__PURE__ */ jsx("button", {
      onClick: handleBack,
      className: "self-start flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800",
      children: "\u2190 Back"
    }), /* @__PURE__ */ jsx(AttachmentInfoPanel, {
      attachment
    }), /* @__PURE__ */ jsx(ImageAttachmentViewer, {
      attachment
    }), /* @__PURE__ */ jsx(VideoAttachmentViewer, {
      attachment
    }), /* @__PURE__ */ jsx(AudioAttachmentViewer, {
      attachment
    }), /* @__PURE__ */ jsx(HtmlAttachmentViewer, {
      attachment
    }), /* @__PURE__ */ jsx(DocxAttachmentViewer, {
      attachment
    }), /* @__PURE__ */ jsx(VariantsPanel, {
      variants
    })]
  });
};

const readPercent = (value, prev) => {
  if (value && typeof value.percent === "number")
    return value.percent;
  return prev;
};
const useTaskProgress = (taskType, taskId, onTerminal) => {
  const api = useApi();
  const jwt = useJwt();
  const [state, setState] = useState(void 0);
  const url = taskId && jwt ? api.buildUrl(`fair-scheduler/${taskType}/tasks/progress`, { taskIds: taskId, token: jwt }) : "";
  const onProgress = useMemoizedFn((data) => {
    if (!data || !data.taskId || data.taskId !== taskId)
      return;
    const status = data.status;
    setState((prev) => {
      const prevPercent = prev ? prev.percent : 0;
      if (status === "done") {
        return { phase: "done", percent: 100, phaseLabel: "Done" };
      }
      if (status === "failed") {
        return { phase: "error", percent: prevPercent, phaseLabel: data.phase || "" };
      }
      if (status === "waiting") {
        return { phase: "waiting", percent: 0, phaseLabel: data.phase || "Waiting" };
      }
      return {
        phase: "processing",
        percent: readPercent(data.value, prevPercent),
        phaseLabel: data.phase || ""
      };
    });
    if ((status === "done" || status === "failed") && onTerminal)
      onTerminal();
  });
  useSSEConnection({ url, enabled: url !== "", maxReconnectAttempts: 0 }, [
    { event: "progress", handler: onProgress }
  ]);
  return state;
};

const ATTACHMENT_PROCESSING_TASK_TYPE = "attachment-processing";
const useBarrierProgress = (barrierTaskId, onTerminal) => useTaskProgress(ATTACHMENT_PROCESSING_TASK_TYPE, barrierTaskId, onTerminal);

const DOCX_CONTENT_TYPE = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
const isDocx = (a) => {
  const ct = a && a.contentType ? a.contentType : "";
  const name = a && a.originalFileName ? a.originalFileName.toLowerCase() : "";
  return ct === DOCX_CONTENT_TYPE || name.endsWith(".docx");
};
const findBarrier = (attachments) => {
  let fallback = null;
  for (const a of attachments) {
    const data = a && a.data;
    const signal = data && data.signal;
    if (!signal || !signal.taskId)
      continue;
    const entry = {
      taskId: signal.taskId,
      name: a.label || a.originalFileName || ""
    };
    if (isDocx(a))
      return entry;
    if (!fallback)
      fallback = entry;
  }
  return fallback;
};
const BarrierProgressPanel = () => {
  const {
    attachments,
    reload
  } = usePostAttachmentsCtx();
  const {
    root
  } = useInterviewEditor();
  const barrier = findBarrier(attachments);
  const state = useBarrierProgress(barrier ? barrier.taskId : null, reload);
  if (!barrier || !state)
    return null;
  const isError = state.phase === "error";
  const isDone = state.phase === "done";
  const isWaiting = state.phase === "waiting";
  const barColor = isError ? "bg-red-500" : isDone ? "bg-green-500" : "bg-blue-500";
  const headline = isError ? "Publishing failed" : isDone ? "Published" : isWaiting ? "Waiting for uploads\u2026" : "Publishing\u2026";
  const postUrl = root ? url4post(root) : "";
  return /* @__PURE__ */ jsxs("div", {
    className: "border border-gray-200 rounded-lg overflow-hidden",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "px-3 py-2 bg-gray-50 border-b border-gray-100 flex items-center justify-between gap-2",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-xs font-medium text-gray-500 uppercase tracking-wide",
        children: headline
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [isDone && postUrl && /* @__PURE__ */ jsx("a", {
          href: postUrl,
          target: "_blank",
          rel: "noopener noreferrer",
          title: "Open post in new tab",
          className: "text-blue-600 hover:text-blue-700",
          children: /* @__PURE__ */ jsx(MdOpenInNew, {
            size: 16
          })
        }), !isDone && !isError && /* @__PURE__ */ jsx(Spinner, {
          size: "xs"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "px-3 py-3 flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between gap-3 text-sm",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-gray-700 truncate",
          children: barrier.name
        }), !isWaiting && /* @__PURE__ */ jsxs("span", {
          className: "text-xs text-gray-400 shrink-0",
          children: [state.percent, "%"]
        })]
      }), !isWaiting && /* @__PURE__ */ jsx("div", {
        className: "h-1.5 w-full bg-gray-100 rounded overflow-hidden",
        children: /* @__PURE__ */ jsx("div", {
          className: `h-full ${barColor} transition-all duration-300`,
          style: {
            width: `${state.percent}%`
          }
        })
      }), state.phaseLabel && !isDone && /* @__PURE__ */ jsx("span", {
        className: "text-xs text-gray-400 truncate",
        children: state.phaseLabel
      })]
    })]
  });
};

const containerVariants = cva("ns flex flex-col gap-4 w-full", {
  variants: {
    layout: {
      centered: "max-w-3xl mx-auto p-4",
      full: ""
    }
  },
  defaultVariants: {
    layout: "centered"
  }
});
const PostAttachmentsScreenInner = ({
  compact,
  layout
}) => {
  const {
    reload,
    loading,
    pending,
    selectedUuid
  } = usePostAttachmentsCtx();
  const isUploading = pending.some((p) => !p.error);
  const [openedUuids, setOpenedUuids] = useState([]);
  useEffect(() => {
    if (selectedUuid) {
      setOpenedUuids((prev) => prev.indexOf(selectedUuid) === -1 ? [...prev, selectedUuid] : prev);
    }
  }, [selectedUuid]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [openedUuids.map((uuid) => /* @__PURE__ */ jsx("div", {
      className: selectedUuid === uuid ? "" : "hidden",
      children: /* @__PURE__ */ jsx(AttachmentProvider, {
        uuid,
        children: /* @__PURE__ */ jsx(AttachmentWorkspaceInner, {})
      })
    }, uuid)), /* @__PURE__ */ jsxs("div", {
      className: containerVariants({
        layout
      }),
      children: [!compact && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between gap-3",
        children: [/* @__PURE__ */ jsx("div", {
          className: "flex items-center gap-2 min-w-0",
          children: /* @__PURE__ */ jsx("h1", {
            className: "text-base font-medium text-gray-900 shrink-0",
            children: "Post attachments"
          })
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          size: "sm",
          isLoading: loading,
          onClick: reload,
          leftIcon: /* @__PURE__ */ jsx(MdRefresh, {
            size: 16
          }),
          children: "Refresh"
        })]
      }), /* @__PURE__ */ jsx(UploadZone, {
        disabled: isUploading
      }), /* @__PURE__ */ jsx(StagedPanel, {}), /* @__PURE__ */ jsx(AttachmentList, {}), /* @__PURE__ */ jsx(BarrierProgressPanel, {})]
    })]
  });
};
const PostAttachmentsScreen = ({
  postId,
  compact,
  layout
}) => /* @__PURE__ */ jsx(PostAttachmentsProvider, {
  postId,
  children: /* @__PURE__ */ jsx(PostAttachmentsScreenInner, {
    compact,
    layout
  })
});

const PostAttachmentsPage = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "post-attachments",
  children: (postId) => postId ? /* @__PURE__ */ jsx(PostAttachmentsScreen, {
    postId
  }) : /* @__PURE__ */ jsxs("div", {
    className: "p-6 text-sm text-gray-500",
    children: ["No postId \u2014 append", " ", /* @__PURE__ */ jsxs("code", {
      className: "font-mono bg-gray-100 px-1 rounded",
      children: ["/", "{postId}"]
    }), " ", "to the URL."]
  })
});

const CirclePlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/single-circle";
  if (pathname.startsWith(prefix + "/translate-post")) {
    return /* @__PURE__ */ jsx(ExecuteGraphPage, {});
  }
  if (pathname.startsWith(prefix + "/invites")) {
    return /* @__PURE__ */ jsx(InvitesTest, {});
  }
  if (pathname.startsWith(prefix + "/menu")) {
    return /* @__PURE__ */ jsx(CircleMenuTest, {});
  }
  if (pathname.startsWith(prefix + "/sessions")) {
    return /* @__PURE__ */ jsx(SessionPlayground, {});
  }
  if (pathname.startsWith(prefix + "/web-extraction-test")) {
    return /* @__PURE__ */ jsx(WebExtractionTest, {});
  }
  if (pathname.startsWith(prefix + "/dialog-welcome-circle")) {
    return /* @__PURE__ */ jsx(CircleWelcomeTest, {});
  }
  if (pathname.startsWith(prefix + "/stats")) {
    return /* @__PURE__ */ jsx(CircleStatsTest, {});
  }
  if (pathname.startsWith(prefix + "/login")) {
    return /* @__PURE__ */ jsx(LoginPageTest, {});
  }
  if (pathname.startsWith(prefix + "/design")) {
    return /* @__PURE__ */ jsx(CircleDesignTest, {});
  }
  if (pathname.startsWith(prefix + "/pagination")) {
    return /* @__PURE__ */ jsx(PaginationTest, {});
  }
  if (pathname.startsWith(prefix + "/test-pagination-1")) {
    return /* @__PURE__ */ jsx(PaginationTest1, {});
  }
  if (pathname.startsWith(prefix + "/assistants")) {
    return /* @__PURE__ */ jsx(CircleAssistantsListTest, {});
  }
  if (pathname.startsWith(prefix + "/test-pagination-2")) {
    return /* @__PURE__ */ jsx(PaginationTest2, {});
  }
  if (pathname.startsWith(prefix + "/event")) {
    return /* @__PURE__ */ jsx(EditEventPageTest, {});
  }
  if (pathname.startsWith(prefix + "/google-map")) {
    return /* @__PURE__ */ jsx(CircleGoogleMapTest, {});
  }
  if (pathname.startsWith(prefix + "/welcome")) {
    return /* @__PURE__ */ jsx(WelcomePageTest, {});
  }
  if (pathname.startsWith(prefix + "/config")) {
    return /* @__PURE__ */ jsx(ConfigurablePageTest, {});
  }
  if (pathname.startsWith(prefix + "/dashboard")) {
    return /* @__PURE__ */ jsx(DashboardPageTest, {});
  }
  if (pathname.startsWith(prefix + "/discover")) {
    return /* @__PURE__ */ jsx(DiscoverPageTest, {});
  }
  if (pathname.startsWith(prefix + "/notify")) {
    return /* @__PURE__ */ jsx(NotificationsPageTest, {});
  }
  if (pathname.startsWith(prefix + "/post-view")) {
    return /* @__PURE__ */ jsx(PostViewPageTest, {});
  }
  if (pathname.startsWith(prefix + "/calendar-events")) {
    return /* @__PURE__ */ jsx(EventsCalendarTest, {});
  }
  if (pathname.startsWith(prefix + "/my-circles")) {
    return /* @__PURE__ */ jsx(MyCirclesPageTest, {});
  }
  if (pathname.startsWith(prefix + "/data")) {
    return /* @__PURE__ */ jsx(CircleDataTest, {});
  }
  if (pathname.startsWith(prefix + "/posts")) {
    return /* @__PURE__ */ jsx(CirclePostsTest$1, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-showcase")) {
    return /* @__PURE__ */ jsx(BookCairShowcasePage, {});
  }
  if (pathname.startsWith(prefix + "/post-attachments")) {
    return /* @__PURE__ */ jsx(PostAttachmentsPage, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-dashboard")) {
    return /* @__PURE__ */ jsx(BookCairDashboardPage, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-profile")) {
    return /* @__PURE__ */ jsx(BookCairProfilePage, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-mobile")) {
    return /* @__PURE__ */ jsx(BookCairReaderMobilePage, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-desktop")) {
    return /* @__PURE__ */ jsx(BookCairDesktopPage, {});
  }
  if (pathname.startsWith(prefix + "/live-book-cair-mobile")) {
    return /* @__PURE__ */ jsx(BookCairReaderMobilePageLive, {});
  }
  if (pathname.startsWith(prefix + "/live-book-cair-desktop")) {
    return /* @__PURE__ */ jsx(BookCairDesktopPageLive, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-browse")) {
    return /* @__PURE__ */ jsx(BrowseBooksPageWrapper, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-library")) {
    return /* @__PURE__ */ jsx(MyLibraryPageWrapper, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-purchases")) {
    return /* @__PURE__ */ jsx(PurchasesPageWrapper, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-payment-result")) {
    return /* @__PURE__ */ jsx(PaymentResultPageWrapper, {});
  }
  if (pathname.startsWith(prefix + "/book-cair-payment")) {
    return /* @__PURE__ */ jsx(CairPaymentPageWrapper, {});
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "ns p-2.5 overflow-auto h-full w-full min-w-[300px] mx-auto",
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/invites/",
        children: "Invites list"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/sessions",
        children: "Sessions"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/login/",
        children: "Login Test"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/welcome/",
        children: "WelcomePage test"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/menu/",
        children: "Circle Menu"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/google-map/",
        children: "Google Map"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/dialog-welcome-circle/",
        children: "Welcome Dialog"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/stats/",
        children: "Statistics"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/design/",
        children: "Design"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/pagination/",
        children: "Pagination"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/test-pagination-1/",
        children: "Pagination 1"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/test-pagination-2/",
        children: "Pagination 2"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/assistants/",
        children: "Assistant"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/event/",
        children: "Event"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/config/",
        children: "Configure Page"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/dashboard/",
        children: "Dashboard"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/discover/",
        children: "Discover"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/notify/",
        children: "Notifications"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/post-view/",
        children: "Post View"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/data/",
        children: "Data"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/posts/",
        children: "Posts"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/my-circles/",
        children: "My circles"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/web-extraction-test/",
        children: "Web Extraction Test"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/translate-post/",
        children: "Translate Post"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/post-attachments/",
        children: "Interview \u2014 Post attachments"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-showcase/",
        children: "Book CAIR \u2014 Showcase"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-dashboard/",
        children: "Book CAIR \u2014 Dashboard"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-profile/",
        children: "Book CAIR \u2014 Profile"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-mobile/",
        children: "Book CAIR \u2014 Mobile"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-desktop/",
        children: "Book CAIR \u2014 Desktop"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/live-book-cair-mobile/",
        children: "Book CAIR \u2014 Reader Mobile (live)"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/live-book-cair-desktop/",
        children: "Book CAIR \u2014 Reader Desktop (live)"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-payment/?type=both",
        children: "Book CAIR \u2014 Payment"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-payment-result/?status=success",
        children: "Book CAIR \u2014 Payment Result"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-browse/",
        children: "Book CAIR \u2014 Browse Books"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-library/",
        children: "Book CAIR \u2014 My Library"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/book-cair-purchases/",
        children: "Book CAIR \u2014 Purchases"
      })
    })]
  });
};

const Wrapper$i = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const useSearchFilter = () => {
  const [filter, setFilter] = useState("");
  const {
    filter$
  } = useSearchContext();
  filter$.useSubscription(({
    filter: filter2
  }) => {
    setFilter(filter2);
  });
  return filter;
};
const useHomePagePosts = (op) => {
  const api = useApi();
  const filter = useSearchFilter();
  const interestingResult = useSWR(filter ? null : `/interesting-posts`, async () => {
    const result2 = await api.loadInterestingPosts({});
    return result2.values;
  }, {
    ...swrLoadOnce,
    ...op,
    refreshInterval: activityRrefreshInterval
  });
  const loadSuggestedPostsRaw = async (filter2) => {
    const result2 = await api.suggestPosts({
      filter: filter2
    });
    return result2.values;
  };
  const {
    run: loadSuggestedPosts
  } = useThrottleFn(loadSuggestedPostsRaw);
  const suggestResult = useSWR(!filter ? null : `/suggest-posts/${filter}`, async () => {
    return loadSuggestedPosts(filter);
  }, {
    ...swrLoadOnce,
    ...op,
    refreshInterval: activityRrefreshInterval
  });
  const result = filter ? suggestResult : interestingResult;
  return result;
};
const renderOverflowMenu = ({
  target
}) => {
  return /* @__PURE__ */ jsxs(MenuList, {
    children: [/* @__PURE__ */ jsx(MenuItem, {
      children: "menu item 1"
    }), /* @__PURE__ */ jsx(MenuItem, {
      children: "menu item 2"
    })]
  });
};
const HomePostsInner = () => {
  const {
    data
  } = useHomePagePosts();
  const {
    data: profile
  } = useProfile();
  const [result, setResult] = useState(null);
  console.log("1111111111111111111", data);
  const getCircleVotes = async () => {
    setResult({
      waiting: true
    });
  };
  return /* @__PURE__ */ jsxs(Wrapper$i, {
    children: [/* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Home page actions"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(PlaygroundSearchInput, {}), /* @__PURE__ */ jsx(PlaygroundActions, {
        children: /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: getCircleVotes,
          children: "Dummy"
        })
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Posts On Home Page"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "New cards"
      }), data && profile && data.map((post, i) => {
        return /* @__PURE__ */ jsx(ArticleSummaryCore2, {
          selected: !i,
          onClick: (p) => console.log("1111111111111111:", p),
          article: post,
          membership: void 0,
          profile,
          overflowMenu: renderOverflowMenu
        }, post._id);
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Old cards"
      }), data && profile && data.map((post) => {
        return /* @__PURE__ */ jsx(ArticleSummaryCore, {
          article: post,
          membership: void 0,
          profile,
          overflowMenu: renderOverflowMenu
        }, post._id);
      })]
    })]
  });
};
const HomePostsTest = () => {
  return /* @__PURE__ */ jsx(Staging, {
    children: /* @__PURE__ */ jsx(SearchContextProvider, {
      children: /* @__PURE__ */ jsx(HomePostsInner, {})
    })
  });
};

const Wrapper$h = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const CirclePostsInner = () => {
  useApi();
  const [result, setResult] = useState(null);
  const [circleId, setCircleId] = useState("631240bffa1bdef56b4538ab");
  const getCircleVotes = async () => {
    setResult({
      waiting: true
    });
  };
  const handleCircleChange = (e) => {
    setCircleId(e.target.value);
  };
  return /* @__PURE__ */ jsxs(Wrapper$h, {
    children: [/* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Vote activities actions"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(PlaygroundActions, {
        children: /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: getCircleVotes,
          children: "Dummy"
        })
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Posts in circles"
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        autoFocus: true,
        label: "Circle ID",
        placeholder: "Circle ID",
        value: circleId,
        onChange: handleCircleChange
      }), /* @__PURE__ */ jsxs(SectionHeader2, {
        children: ["Posts in circle #", circleId]
      })]
    })]
  });
};
const CirclePostsTest = () => {
  return /* @__PURE__ */ jsx(Staging, {
    children: /* @__PURE__ */ jsx(CirclePostsInner, {})
  });
};

const Wrapper$g = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
let count$1 = 0;
const TinyEditorInner = () => {
  const [editor, setEditor] = useState();
  const [content, setContentState] = useState("");
  const [result, setResult] = useState(null);
  const initTiny = async () => {
    setResult({
      waiting: true
    });
    await loadJsLibs(["https://cdn.tiny.cloud/1/ntiy9m8xo0ylv0ncpf5dz2l2u5lrb7kk9fv2i8c44dw8us90/tinymce/6/tinymce.min.js"]);
    const tinymce = getTiny();
    tinymce.init({
      selector: "#tinymce",
      plugins: "anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount checklist mediaembed casechange export formatpainter pageembed linkchecker a11ychecker tinymcespellchecker permanentpen powerpaste advtable advcode editimage tinycomments tableofcontents footnotes mergetags autocorrect typography inlinecss",
      toolbar: "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat",
      tinycomments_mode: "embedded",
      tinycomments_author: "Author name",
      mergetags_list: [{
        value: "First.Name",
        title: "First Name"
      }, {
        value: "Email",
        title: "Email"
      }]
    });
    console.log("1111111111", tinymce.get("tinymce"));
  };
  const logContent = async () => {
    const editor2 = getTinyEditorById("tinymce");
    console.log("content:", editor2.getContent());
  };
  const setContent = async () => {
    editor.setContent(`<p><b>hello ${count$1++}</b> there</p>`);
  };
  const addEditor = () => {
    setContentState(`<p><b>hello ${count$1++}</b> there</p>`);
  };
  const removeEditor = () => {
    setContentState(void 0);
  };
  return /* @__PURE__ */ jsxs(Wrapper$g, {
    children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Add Tiny editor"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: initTiny,
          children: "Init"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: logContent,
          children: "Log content to console"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: setContent,
          children: "Set Editor content!"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: addEditor,
          children: "Editor component"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: removeEditor,
          children: "Remove component"
        })]
      })]
    }), /* @__PURE__ */ jsx("textarea", {
      id: "tinymce",
      defaultValue: " Welcome to TinyMCE!"
    }), content && /* @__PURE__ */ jsx(TinyEditor, {
      setEditor,
      content
    })]
  });
};
const TinyEditorTest = () => {
  return /* @__PURE__ */ jsx(Staging, {
    children: /* @__PURE__ */ jsx(TinyEditorInner, {})
  });
};

const Wrapper$f = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
let count = 0;
const BlocksTestInner = () => {
  const api = useApi();
  const {
    post
  } = usePostInfoContext();
  const [result, setResult] = useState(null);
  const loadDraftBlocks = async () => {
    const draft = await api.loadDraft({
      _id: post.draft
    });
    setResult(draft.contentBlocks);
  };
  const saveBlocksToDrafts = async () => {
    const result2 = await blocksApi(api, post.draft, {
      order: shuffleArray(["a", "b", "c"]),
      blocks: {
        a: {
          id: "a",
          value: 1 * count
        },
        b: {
          id: "b",
          value: 10 * count
        },
        c: {
          id: "c",
          value: 9 * count++
        }
      }
    });
    setResult(result2);
    loadDraftBlocks();
  };
  const saveOrderToDrafts = async () => {
    const result2 = await blocksApi(api, post.draft, {
      order: shuffleArray(["a", "b", "c"])
    });
    setResult(result2);
    loadDraftBlocks();
  };
  const updateOneBlock = async () => {
    const result2 = await blocksApi(api, post.draft, {
      block: {
        id: "b",
        value: count++
      }
    });
    setResult(result2);
    loadDraftBlocks();
  };
  const publishBlocks = async () => {
    const result2 = await publishBlocksApi(api, post.draft);
    setResult(result2);
    loadDraftBlocks();
  };
  const deleteBBlock = async () => {
    const result2 = await blocksApi(api, post.draft, {
      deleted: "b"
    });
    setResult(result2);
    loadDraftBlocks();
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(ResponsesToolbar, {}), /* @__PURE__ */ jsx(SectionHeader, {
        children: "Block API Test"
      }), /* @__PURE__ */ jsx(Result, {
        label: "post blocks",
        children: post && post.contentBlocks
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(EditPostToggleButton, {}), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: loadDraftBlocks,
          children: "Load draft blocks"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: saveBlocksToDrafts,
          children: "Save blocks to drafts"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: saveOrderToDrafts,
          children: "Save order to drafts"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: updateOneBlock,
          children: "Update B Block"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: deleteBBlock,
          children: "Delete B Block"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: publishBlocks,
          children: "Publish Blocks"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Attachments"
      }), /* @__PURE__ */ jsx(UploadButton$1, {
        defaultValue: [],
        onFilesChanged: () => null
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Blocks list"
      }), /* @__PURE__ */ jsx(PlaygroundActions, {}), /* @__PURE__ */ jsx(BlocksToolbar, {}), /* @__PURE__ */ jsx(BlocksList$1, {})]
    })]
  });
};
const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};
const BlocksTest = () => {
  return /* @__PURE__ */ jsx(Staging, {
    children: /* @__PURE__ */ jsxs(Wrapper$f, {
      children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsx(LoadPostViewTest, {
        defaultPostId: "63e40c228394babed67ca857",
        children: /* @__PURE__ */ jsx(BlocksTestInner, {})
      })]
    })
  });
};

const Wrapper$e = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const BlocksEditorTestInner = () => {
  const [postId, setPostId] = useState("63e40c228394babed67ca857");
  const [draft, setDraft] = useState();
  const [circleId, setCircleId] = useState("");
  const [profile, setProfile] = useState();
  const handlePostChange = (e) => {
    setPostId(e.target.value);
  };
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const api = useApi();
  const [result, setResult] = useState(null);
  const loadProfile = async () => {
    const profile2 = await api.loadProfile();
    setProfile(profile2);
  };
  const loadDraftBlocks = async () => {
    setResult("waiting");
    loadProfile();
    const opts = {
      _id: postId
    };
    const post = await api.loadPostById(opts);
    const draft2 = await api.loadDraft({
      _id: post.draft
    });
    setDraft(draft2);
    setResult("ok");
    console.log("contentBlocks", draft2.contentBlocks);
  };
  const publishBlocks = async () => {
    const result2 = await publishBlocksApi(api, draft._id);
    setResult(result2);
    loadDraftBlocks();
  };
  const onCreateHelp = async () => {
    const opts = {
      _id: postId
    };
    const post = await api.loadPostById(opts);
    setCircleId(post.group.group._id);
    setOpenEditDialog(true);
  };
  const onEditHelp = async () => {
    const opts = {
      _id: postId
    };
    const post = await api.loadPostById(opts);
    const draft2 = await api.loadDraft({
      _id: post.draft
    });
    setDraft(draft2);
    setOpenEditDialog(true);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(BlocksEditorDialog, {
      open: openEditDialog,
      circleId,
      onClose: () => setOpenEditDialog(false),
      draft
    }), /* @__PURE__ */ jsx(PlaygroundTextField, {
      autoFocus: true,
      label: "Post ID",
      placeholder: "Post ID",
      value: "63e40c228394babed67ca857",
      onChange: handlePostChange
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Load Draft Blocks Test"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: loadDraftBlocks,
          children: "Load draft blocks"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: publishBlocks,
          children: "Publish Blocks"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: onCreateHelp,
          children: "Create Help File"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: onEditHelp,
          children: "Edit Help File"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Blocks list"
      }), /* @__PURE__ */ jsx(PostInfoContextForDraft, {
        draft,
        profile,
        children: draft && /* @__PURE__ */ jsxs(BlocksContextProvider, {
          post: draft,
          edited: true,
          children: [/* @__PURE__ */ jsx(BlocksToolbar, {}), /* @__PURE__ */ jsx(BlocksList$1, {})]
        })
      })]
    })]
  });
};
const BlocksEditorTest = () => {
  return /* @__PURE__ */ jsx(Staging, {
    children: /* @__PURE__ */ jsxs(Wrapper$e, {
      children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsx(BlocksEditorTestInner, {})]
    })
  });
};

const Wrapper$d = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const EditorReplacementInner = ({
  draftId
}) => {
  const [openBrowser, setOpenBrowser] = useState(false);
  const [result, setResult] = useState(null);
  const createDraft = useCreateDraftToEditFn();
  const api = useApi();
  const {
    setDraft,
    save,
    editor
  } = usePostEditorContext();
  const loadDraft = async () => {
    setResult("waiting");
    const draft = await api.loadDraft({
      _id: draftId
    });
    setDraft(draft);
    setResult("ok");
  };
  const onSaveDraft = async () => {
    setResult("waiting");
    const draft = await save({});
    console.log(draft);
    setResult("ok");
  };
  const onCreateDraft = async () => {
    setResult("waiting");
    const draft = await createDraft({
      type: "article"
    });
    console.log(draft);
    setDraft(draft);
    setResult("ok");
  };
  const onRemoveEditor = async () => {
    setDraft(void 0);
  };
  const onLogContent = async () => {
    console.log("11111111111", editor.getContent());
  };
  const [showEditor, setShowEditor] = useState(false);
  const getJwtToken = useGetJwtTokenFn();
  const onJwtToken = async () => {
    const token = await getJwtToken();
    console.log("getJwtToken", token);
    setResult(token);
  };
  return /* @__PURE__ */ jsxs(Wrapper$d, {
    children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Add Tiny editor"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: loadDraft,
          children: "Load draft"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: onSaveDraft,
          children: "Save"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: onCreateDraft,
          children: "Create draft"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => setShowEditor((v) => !v),
          children: "Toggle Editor"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: onRemoveEditor,
          children: "Remove Editor"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: onLogContent,
          children: "Log content"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: onJwtToken,
          children: "Jwt Token"
        }), /* @__PURE__ */ jsx(LoginTesterButton, {
          setResult
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => setOpenBrowser(true),
          children: "Open Browser"
        }), /* @__PURE__ */ jsx("a", {
          href: "http://192.168.0.145:3000/groups/63da6ae6c1c148b84885a97d",
          children: "Go to test circle"
        }), /* @__PURE__ */ jsx(PlaygroundLink, {})]
      })]
    }), openBrowser && /* @__PURE__ */ jsx(OpenBrowser, {
      children: "Test open browser"
    }), /* @__PURE__ */ jsx(UploadButton, {}), /* @__PURE__ */ jsx(AttachmentsList, {}), showEditor && /* @__PURE__ */ jsx(PostTinyEditor, {})]
  });
};
const TinyEditorReplacementTest = () => {
  const [id, setId] = useState("63f7c2e8ffb139e965b8dde0");
  const handlePostChange = (e) => {
    setId(e.target.value);
  };
  return /* @__PURE__ */ jsxs(Staging, {
    children: [/* @__PURE__ */ jsx(PlaygroundTextField, {
      autoFocus: true,
      label: "Draft ID",
      placeholder: "Draft ID",
      defaultValue: id,
      onChange: handlePostChange
    }), /* @__PURE__ */ jsx(PostEditorContextProvider, {
      children: /* @__PURE__ */ jsx(EditorReplacementInner, {
        draftId: id
      })
    })]
  });
};

const Wrapper$c = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const PostsPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/posts";
  if (pathname.startsWith(prefix + "/home-posts")) {
    return /* @__PURE__ */ jsx(HomePostsTest, {});
  }
  if (pathname.startsWith(prefix + "/circle-posts")) {
    return /* @__PURE__ */ jsx(CirclePostsTest, {});
  }
  if (pathname.startsWith(prefix + "/tiny-editor")) {
    return /* @__PURE__ */ jsx(TinyEditorTest, {});
  }
  if (pathname.startsWith(prefix + "/blocks")) {
    return /* @__PURE__ */ jsx(BlocksTest, {});
  }
  if (pathname.startsWith(prefix + "/editor-blocks")) {
    return /* @__PURE__ */ jsx(BlocksEditorTest, {});
  }
  if (pathname.startsWith(prefix + "/editor-replacement")) {
    return /* @__PURE__ */ jsx(TinyEditorReplacementTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$c, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/home-posts/",
        children: "Home posts"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/circle-posts/",
        children: "Circle posts"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/tiny-editor/",
        children: "Tiny Editor"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/blocks/",
        children: "Blocks"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/editor-blocks/",
        children: "Blocks Editor"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/editor-replacement/",
        children: "Editor Replacement"
      })
    })]
  });
};

const noops = () => {
};
const NativeEventContext = React__default.createContext({
  event$: {
    emit: noops,
    useSubscription: noops
  }
});
const useNativeEventContext = () => {
  return useContext(NativeEventContext);
};
const NativeEventContextProvider = ({
  children
}) => {
  const event$ = useEventEmitter();
  const emitter = useCallback((ev) => {
    event$.emit(ev);
  }, []);
  if (typeof window !== "undefined") {
    window["ReactNativeWebViewEvents"] = emitter;
  }
  return /* @__PURE__ */ jsx(NativeEventContext.Provider, {
    value: {
      event$
    },
    children
  });
};

const useSetupPushNotifications = ({
  onOpen = () => null
} = {}) => {
  if (!isMobileWrapper()) {
    return;
  }
  const history = useHistory();
  const documentVisibility = useDocumentVisibility();
  const api = useApi();
  useEffect(() => {
    if (documentVisibility === "visible") {
      clearOneSignalNotifications();
    }
  }, [documentVisibility]);
  clearOneSignalNotifications();
  const {
    event$
  } = useNativeEventContext();
  event$.useSubscription(async (ev) => {
    if (ev.type === "setNotificationOpenedHandler") {
      const {
        postId,
        chat,
        url
      } = ev.additionalData || {};
      if (url) {
        history.push(url);
        onOpen(ev);
        return;
      }
      if (chat) {
        const url2 = `/trans/circle-chat/${chat}`;
        history.push(url2);
        onOpen(ev);
        return;
      }
      if (postId) {
        const post = await api.loadPostById({
          _id: postId
        });
        if (post) {
          const url2 = url4post(post);
          history.push(url2);
          onOpen(ev);
          return;
        }
      }
      history.push("/notifications");
      onOpen(ev);
    }
    if (ev.type === "setNotificationWillShowInForegroundHandler") {
      const {
        url
      } = ev.additionalData || {};
      if (url) {
        window.location.href = url;
        onOpen(ev);
        return;
      }
    }
  });
  setNotificationWillShowInForegroundHandler();
  setNotificationOpenedHandler();
};

const SetupPushNotifications = ({
  test,
  profile
}) => {
  const [openEvent, setOpenEvent] = useState(null);
  const {
    mutate: saveMobile,
    data: addMobile,
    error: addMobileError,
    isValidating: addMobileIsValidating
  } = useAddMobile({
    profile
  });
  useSetupPushNotifications({
    onOpen: (ev) => setOpenEvent(ev)
  });
  if (!test) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx(Result, {
      label: "add mobile:",
      children: {
        addMobileError,
        addMobile,
        addMobileIsValidating
      }
    }), /* @__PURE__ */ jsx(Result, {
      label: "Last Open Event:",
      children: openEvent
    }), /* @__PURE__ */ jsx(Button, {
      variant: "contained",
      color: "primary",
      onClick: () => saveMobile(),
      children: "saveMobile"
    })]
  });
};

const Wrapper$b = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
let counter$1 = 0;
const CommunicationInner = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [userId, setUserId] = useState("");
  const [appId, setAppId] = useState("");
  const [event, setEvent] = useState(null);
  const {
    event$
  } = useNativeEventContext();
  const [setup, setSetup] = useState(false);
  event$.useSubscription((ev) => {
    setEvent(ev);
  });
  const documentVisibility = useDocumentVisibility();
  useEffect(() => {
    setFocus((v) => v + 1);
  }, [documentVisibility]);
  const [focus, setFocus] = useState(0);
  const {
    mutate: saveMobile,
    data: addMobile,
    error: addMobileError,
    isValidating: addMobileIsValidating
  } = useAddMobile({
    profile: true
  });
  const onProfile = async () => {
    setResult({
      wait: true
    });
    try {
      const result2 = await api.loadProfile();
      console.log("onProfile", result2);
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    }
  };
  const handleUserIdChange = (e) => {
    setUserId(e.target.value);
  };
  const handleAppIdChange = (e) => {
    setAppId(e.target.value);
  };
  const sendCounter = async () => {
    setResult({
      waiting: true
    });
    const result2 = await execute("counter", {
      counter: counter$1++
    });
    setResult(result2);
  };
  const sendNoReply = async () => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await execute("noreply", {
        counter: counter$1++
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    }
  };
  const sendDummy = async () => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await execute("dummy", {
        counter: counter$1++
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    }
  };
  const invokeNativeTest = (f) => async (options) => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await f(options);
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    }
  };
  const getDeviceStateTest = invokeNativeTest(getDeviceState);
  const promptForPushNotificationsWithUserResponseTest = invokeNativeTest(promptForPushNotificationsWithUserResponse);
  const clearOneSignalNotificationsTest = invokeNativeTest(clearOneSignalNotifications);
  const setNotificationWillShowInForegroundHandlerTest = invokeNativeTest(setNotificationWillShowInForegroundHandler);
  const setNotificationOpenedHandlerTest = invokeNativeTest(setNotificationOpenedHandler);
  const sendTestEvent = async () => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await execute("sendTestEvent");
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    }
  };
  const sendTestPushNotofication = async () => {
    setResult({
      waiting: true
    });
    const {
      userId: userId2
    } = await getDeviceState();
    try {
      const other = {
        data: {
          counter: counter$1
        }
      };
      const result2 = await api.makeRequest({
        path: "/playground/one-signal/send-to-me",
        method: "POST",
        body: {
          playerIds: [userId2],
          content: "counter=" + counter$1,
          other
        }
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message,
        userId: userId2
      });
    } finally {
      counter$1++;
    }
  };
  const sendToMyMobiles = async () => {
    setResult({
      waiting: true
    });
    try {
      const other = {
        data: {
          counter: counter$1
        }
      };
      const result2 = await api.activityRequest({
        path: "/push-notifications/send-to-my-mobiles",
        method: "POST",
        body: {
          content: "counter=" + counter$1,
          other
        }
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message,
        userId
      });
    } finally {
      counter$1++;
    }
  };
  const sendToMe = async () => {
    setResult({
      waiting: true
    });
    const {
      userId: userId2
    } = await getDeviceState();
    try {
      const other = {
        data: {
          counter: counter$1
        }
      };
      const result2 = await api.activityRequest({
        path: "/push-notifications/send-to-me",
        method: "POST",
        body: {
          playerIds: [userId2],
          content: "counter=" + counter$1,
          other
        }
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message,
        userId: userId2
      });
    } finally {
      counter$1++;
    }
  };
  const getDeviceUserId = async () => {
    const {
      userId: userId2
    } = await getDeviceState();
    setUserId(userId2);
  };
  const sendToUserFromTextInput = async () => {
    setResult({
      waiting: true
    });
    try {
      const other = {
        data: {
          counter: counter$1
        }
      };
      const result2 = await api.makeRequest({
        path: "/playground/one-signal/send-to-me",
        method: "POST",
        body: {
          playerIds: [userId],
          content: "counter=" + counter$1,
          other
        }
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message,
        userId
      });
    } finally {
      counter$1++;
    }
  };
  const saveUserMobile = async () => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await api.makeRequest({
        path: "/playground/one-signal/save-one-mobile",
        method: "POST",
        body: {
          playerId: userId
        }
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message,
        userId
      });
    }
  };
  const addUserMobile = async () => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await api.makeRequest({
        path: "/users/mobile",
        method: "POST",
        body: {
          player: userId,
          token: "dummy_token" + ++counter$1,
          appId
        }
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message,
        userId
      });
    }
  };
  const openBrowserAsyncTest = invokeNativeTest(openBrowserAsync);
  return /* @__PURE__ */ jsxs(Wrapper$b, {
    className: "overflow-y-auto max-h-full",
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Login to NS"
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        className: "gap-2",
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: onProfile,
          children: "loadProfile"
        }), /* @__PURE__ */ jsx(LoginTesterButton, {
          setResult
        }), /* @__PURE__ */ jsx("a", {
          href: "/welcome/login/email",
          children: "login"
        }), /* @__PURE__ */ jsx("a", {
          href: "/playground/lib/single-circle/post-view/",
          children: "view post"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: `Communicate with React Native (is native = ${isMobileWrapper()}, platform = ${mobileAppOs()})`
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(Result, {
        label: "Last Native Event:",
        children: event
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Open Web Browser"
      }), /* @__PURE__ */ jsx(PlaygroundActions, {
        children: /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => openBrowserAsyncTest("https://www.youtube.com/"),
          children: "open youtube"
        })
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Setup Push Notifications"
      }), /* @__PURE__ */ jsx(Result, {
        label: "focus counter:",
        children: {
          focus
        }
      }), setup && /* @__PURE__ */ jsx(SetupPushNotifications, {
        test: true,
        profile: true
      }), /* @__PURE__ */ jsx(PlaygroundActions, {
        children: /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => setSetup(true),
          children: "addSetupPushComponent"
        })
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Ns Push Notifications"
      }), /* @__PURE__ */ jsx(PlaygroundActions, {
        children: /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendToMe,
          children: "sendToMe"
        })
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Push Notifications to yourself"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Save user data"
      }), /* @__PURE__ */ jsx(Result, {
        label: "add mobile:",
        children: {
          addMobileError,
          addMobile,
          addMobileIsValidating
        }
      }), /* @__PURE__ */ jsx(PlaygroundActions, {
        children: /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => saveMobile(),
          children: "saveMobile"
        })
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Send push notification"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        label: "userId",
        placeholder: "userId",
        value: userId,
        onChange: handleUserIdChange
      }), /* @__PURE__ */ jsx(PlaygroundTextField, {
        label: "appId",
        placeholder: "appId",
        value: appId,
        onChange: handleAppIdChange
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendToMyMobiles,
          children: "sendToMyMobiles"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: addUserMobile,
          children: "addUserMobile"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: saveUserMobile,
          children: "saveUserMobile"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: getDeviceUserId,
          children: "getDeviceUserId"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendToUserFromTextInput,
          children: "sendToUserFromTextInput"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendTestPushNotofication,
          children: "sendTestPushNotofication"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "One Signal Push Notifications"
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Subscribe to notifications"
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: clearOneSignalNotificationsTest,
          children: "clearOneSignalNotificationsTest"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: setNotificationWillShowInForegroundHandlerTest,
          children: "setNotificationWillShowInForegroundHandlerTest"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: setNotificationOpenedHandlerTest,
          children: "setNotificationOpenedHandlerTest"
        })]
      }), /* @__PURE__ */ jsx(SectionHeader2, {
        children: "Mobile State"
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: getDeviceStateTest,
          children: "getDeviceState"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: promptForPushNotificationsWithUserResponseTest,
          children: "promptForPushNotificationsWithUserResponse"
        })]
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Communicate with React Native"
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendCounter,
          children: "Send Counter"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendNoReply,
          children: "sendNoReply"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendDummy,
          children: "sendDummy"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendTestEvent,
          children: "sendTestEvent"
        })]
      })]
    })]
  });
};
const CommunicationTest = () => {
  return /* @__PURE__ */ jsxs(NativeEventContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(CommunicationInner, {})]
  });
};

const Wrapper$a = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const CalendarInner = () => {
  const [result, setResult] = useState(null);
  const {
    dialog: settingsTestDialog,
    setOpenSettingsDialog
  } = useOpenSettingsDialog();
  const {
    dialog,
    createEvent: createEventMobile
  } = useCalendar();
  const invokeNativeTest = (f) => async (options) => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await f(options);
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    }
  };
  const createEventNative = invokeNativeTest(createEvent);
  const openSettingsTest = invokeNativeTest(openSettings);
  const createEventTest = () => {
    const startDate = new Date(Date.now() + 1e3 * 60 * 60 * 2);
    const event = {
      title: "test event at " + startDate.toISOString(),
      startDate,
      endDate: startDate
    };
    createEventNative(event);
  };
  const createEventWithChecks = () => {
    const startDate = new Date(Date.now() + 1e3 * 60 * 60 * 2);
    const event = {
      title: "test event with checks " + startDate.toISOString(),
      startDate,
      endDate: startDate,
      alarms: [{
        relativeOffset: -10
      }]
    };
    createEventMobile(event);
  };
  return /* @__PURE__ */ jsxs(Wrapper$a, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(Link$1, {
        href: "./..",
        underline: "always",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: `Communicate with Mobile Calendar (is native = ${isMobileWrapper()})`
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      })]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Setup Push Notifications"
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: createEventTest,
          children: "Create EventTest"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: openSettingsTest,
          children: "Open Settings"
        }), settingsTestDialog, /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => setOpenSettingsDialog(true),
          children: "Open Settings Confirmation Dialog"
        }), dialog, /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: createEventWithChecks,
          children: "Create Event With Checks"
        })]
      })]
    })]
  });
};
const CalendarTest = () => {
  return /* @__PURE__ */ jsx(NativeEventContextProvider, {
    children: /* @__PURE__ */ jsx(CalendarInner, {})
  });
};

const NotificationDataContext = React__default.createContext({
  data: void 0
});
const useNotificationData = () => {
  return useContext(NotificationDataContext);
};
const NotificationProvider = ({
  children,
  data,
  override
}) => {
  const [closed, setClosed] = useState(false);
  if (!data) {
    return null;
  }
  const context = {
    data,
    closed,
    setClosed
  };
  if (!override) {
    return /* @__PURE__ */ jsx(NotificationDataContext.Provider, {
      value: context,
      children
    });
  }
  return /* @__PURE__ */ jsx(NotificationDataContext.Provider, {
    value: context,
    children: /* @__PURE__ */ jsx(CardThemeProvider, {
      ...override,
      children
    })
  });
};
const NotificationCard = (props) => {
  const {
    data
  } = props;
  const override = themeOverrides(props);
  return /* @__PURE__ */ jsx(NotificationProvider, {
    data,
    override,
    children: /* @__PURE__ */ jsx(NotificationCardImp, {
      ...props
    })
  });
};
const NotificationCardImp = (props) => {
  const {
    data: {
      notification: {
        content
      }
    }
  } = useNotificationData();
  return /* @__PURE__ */ jsx(CardOuter, {
    children: content
  });
};

const useMobilesCount = (opt) => {
  const api = useApi();
  const result = useSWR("/push-notifications/user-mobiles-count", async (path) => {
    return api.activityRequest({
      path,
      method: "GET"
    });
  }, {
    ...swrLoadOnce,
    ...opt
  });
  return result;
};

const useLastNotifications = (opt) => {
  const api = useApi();
  const result = useSWR(open ? "/push-notifications/user-notifications" : null, async (path) => {
    return api.activityRequest({
      path,
      method: "GET"
    });
  }, {
    ...swrLoadOnce,
    ...opt
  });
  return result;
};

const CardsList = styled.div`
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 10px;
 `;
const LastNotificationsDialog = (props) => {
  const {
    open,
    onClose,
    title
  } = props;
  const {
    data
  } = useLastNotifications();
  if (!open) {
    return null;
  }
  const records = data && data.notifications || [];
  const noData = data && !records.length;
  return /* @__PURE__ */ jsxs(Dialog$6, {
    fullScreen: true,
    ...props,
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      onClose,
      children: title
    }), /* @__PURE__ */ jsx(DialogContent, {
      dividers: true,
      children: /* @__PURE__ */ jsx(CardsList, {
        children: /* @__PURE__ */ jsxs(CardThemeProvider, {
          cardImage: true,
          startNewTheme: true,
          children: [noData && "No recent notifications", /* @__PURE__ */ jsx(CardThemeProvider, {
            children: records.map((record) => {
              return /* @__PURE__ */ jsx(NotificationCard, {
                data: record
              }, record._id);
            })
          })]
        })
      })
    })]
  });
};

const OpenLastMobilePushNotifications = () => {
  const [open, setOpen] = useState(false);
  const {
    data
  } = useMobilesCount();
  if (!data) {
    return null;
  }
  const {
    count
  } = data;
  if (!count) {
    return null;
  }
  const title = `Last mobile notifications (${count} mobiles) for posts`;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Link$1, {
      component: "button",
      underline: "always",
      onClick: () => {
        setOpen(true);
      },
      children: title
    }), open && /* @__PURE__ */ jsx(LastNotificationsDialog, {
      open,
      onClose: () => setOpen(false),
      title
    })]
  });
};

const Wrapper$9 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
let counter = 0;
const NotificationsInner = () => {
  const api = useApi();
  const [result, setResult] = useState(null);
  const [records, setRRecords] = useState([]);
  const userNotifications = async () => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await api.activityRequest({
        path: "/push-notifications/user-notifications",
        method: "GET"
      });
      setResult(result2);
      setRRecords(result2.notifications);
    } catch (error) {
      setResult({
        error: error.message
      });
    } finally {
      counter++;
    }
  };
  const userMobilesCount = async () => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await api.activityRequest({
        path: "/push-notifications/user-mobiles-count",
        method: "GET"
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    } finally {
      counter++;
    }
  };
  const lastPostNotifications = async (force = false) => {
    setResult({
      waiting: true
    });
    try {
      const result2 = await api.activityRequest({
        path: "/push-notifications/last-post-history-notifications",
        method: "POST",
        body: {
          force
        }
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    }
  };
  const sendToMyMobiles = async () => {
    setResult({
      waiting: true
    });
    try {
      const other = {
        data: {
          counter
        }
      };
      const result2 = await api.activityRequest({
        path: "/push-notifications/send-to-my-mobiles",
        method: "POST",
        body: {
          content: "counter=" + counter,
          other
        }
      });
      setResult(result2);
    } catch (error) {
      setResult({
        error: error.message
      });
    } finally {
      counter++;
    }
  };
  return /* @__PURE__ */ jsxs(Wrapper$9, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Last Mobile Push Notifications"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(OpenLastMobilePushNotifications, {}), /* @__PURE__ */ jsx(PlaygroundActions, {})]
    }), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Post Push Notifications"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(CardThemeProvider, {
        children: records.map((record) => {
          return /* @__PURE__ */ jsx(NotificationCard, {
            data: record
          }, record._id);
        })
      }), /* @__PURE__ */ jsxs(PlaygroundActions, {
        children: [/* @__PURE__ */ jsx(LoginTesterButton, {
          setResult
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: userMobilesCount,
          children: "user mobiles count"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: userNotifications,
          children: "get user notifications"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendToMyMobiles,
          children: "sendToMyMobiles"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => lastPostNotifications(),
          children: "lastPostNotifications"
        }), /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: () => lastPostNotifications(true),
          children: "lastPostNotifications force"
        })]
      })]
    })]
  });
};
const NotificationsTest = () => {
  return /* @__PURE__ */ jsx(NativeEventContextProvider, {
    children: /* @__PURE__ */ jsx(NotificationsInner, {})
  });
};

const Wrapper$8 = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const MobilePlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/mobile";
  if (pathname.startsWith(prefix + "/rpc")) {
    return /* @__PURE__ */ jsx(CommunicationTest, {});
  }
  if (pathname.startsWith(prefix + "/calendar")) {
    return /* @__PURE__ */ jsx(CalendarTest, {});
  }
  if (pathname.startsWith(prefix + "/notifications")) {
    return /* @__PURE__ */ jsx(NotificationsTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$8, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/rpc/",
        children: "Mobile/browser RPC"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/notifications/",
        children: "User Notifications"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/calendar/",
        children: "Calendar"
      })
    })]
  });
};

let gtag = () => null;
if (typeof window !== "undefined") {
  let gtag1 = function() {
    window["dataLayer"].push(arguments);
  };
  window["dataLayer"] = window["dataLayer"] || [];
  gtag = gtag1;
  window["gtag"] = gtag;
}
const useInitGTag = (measurementId) => {
  if (typeof window === "undefined") {
    return;
  }
  useRequest(async () => {
    await loadJsLibs(["https://www.googletagmanager.com/gtag/js?id=" + measurementId]);
  }, {
    retryCount: -1,
    ready: !!measurementId
  });
  useCreation(() => {
    if (!measurementId) {
      return;
    }
    gtag("js", new Date());
    gtag("config", measurementId, {
      send_page_view: false
    });
  }, [measurementId]);
};

const pageView = (options = {}) => {
  gtag("event", "page_view", {
    page_title: document.title,
    page_location: location.href,
    page_path: location.pathname,
    ...options
  });
};
const useGTagPageView = () => {
  const location2 = useLocation();
  useEffect(() => {
    pageView();
  }, [location2.pathname]);
};

const Wrapper$7 = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    word-wrap: break-word;

    & > div {
        width: 100%;
    }
`;
const measurementId = "G-TKH5M5GNVH";
const CircleWelcomeTestInner = () => {
  useInitGTag(measurementId);
  useGTagPageView();
  const [result, setResult] = useState(null);
  const sendPageView = () => {
    pageView();
  };
  return /* @__PURE__ */ jsxs(Wrapper$7, {
    children: [/* @__PURE__ */ jsx(LevelUp, {}), /* @__PURE__ */ jsxs(Section, {
      children: [/* @__PURE__ */ jsx(SectionHeader, {
        children: "Initialize GTags"
      }), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(PlaygroundActions, {
        children: /* @__PURE__ */ jsx(Button, {
          variant: "contained",
          color: "primary",
          onClick: sendPageView,
          children: "Send Page View"
        })
      })]
    })]
  });
};
const GTagTest = () => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(CircleWelcomeTestInner, {})
  });
};

const Wrapper$6 = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const GoogleAnalyticsPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/google-analytics";
  if (pathname.startsWith(prefix + "/init")) {
    return /* @__PURE__ */ jsx(GTagTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$6, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/init/",
        children: "Gtag initialization"
      })
    })]
  });
};

const EditAssetPageTest = () => {
  const draftIdDefault = isLocalhost() ? "64c9274e4284f2fc7c6f6672" : "64c950ed6325ac7544448da0";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const draftId = path[3] === "edit" && path[4] ? path[4] : draftIdDefault;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(LoginTesterButton, {
      setResult: () => null
    }), /* @__PURE__ */ jsxs(EditAssetPage, {
      draftId,
      children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(AssetTestPanel, {})]
    })]
  });
};
const AssetTestPanel = () => {
  const {
    draft
  } = useEditAssetContext();
  const onClose = (asset) => {
    console.log("Asset editor dialog was close!!!!!!!!!!!!!", asset);
  };
  const {
    editAsset,
    editDialog
  } = useAssetEditor(onClose);
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2",
    children: [editDialog, /* @__PURE__ */ jsx("h1", {
      children: "==========================Asset test panel================================"
    }), /* @__PURE__ */ jsx(Button, {
      onClick: () => editAsset(draft, true),
      children: "Open Dialog"
    }), /* @__PURE__ */ jsx("h1", {
      children: "==========================Asset test panel================================"
    })]
  });
};

const AssetViewPageTest = () => {
  const postIdDefault = isLocalhost() ? "64c9274f4284f2fc7c6f667f" : "64c950ed6325ac7544448dad";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const postId = path[3] === "view" && path[4] ? path[4] : postIdDefault;
  return /* @__PURE__ */ jsx(WebsocketsContextProvider, {
    children: /* @__PURE__ */ jsxs(ActivityContextProvider, {
      children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
        children: /* @__PURE__ */ jsx(PostViewPage, {
          postId,
          children: /* @__PURE__ */ jsx(TestPanel$1, {})
        })
      })]
    })
  });
};
const TestPanel$1 = () => {
  const {
    post
  } = usePostInfoContext();
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("h1", {
      children: "============================Test panel================================"
    }), /* @__PURE__ */ jsx(Result, {
      label: "Draft Id",
      children: post && post.draft
    }), /* @__PURE__ */ jsx(Result, {
      children: post && post.form && post.form.data
    }), /* @__PURE__ */ jsx("h1", {
      children: "============================Test panel end================================"
    })]
  });
};

const Wrapper$5 = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const AssetsPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/assets";
  if (pathname.startsWith(prefix + "/google-api")) {
    return /* @__PURE__ */ jsx(GoogleApiTest, {});
  }
  if (pathname.startsWith(prefix + "/edit")) {
    return /* @__PURE__ */ jsx(EditAssetPageTest, {});
  }
  if (pathname.startsWith(prefix + "/view")) {
    return /* @__PURE__ */ jsx(AssetViewPageTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$5, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/google-api/",
        children: "Google API test"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/edit/",
        children: "Edit asset"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/view/",
        children: "View asset"
      })
    })]
  });
};

const MAX_POSTS = 25;
const data2posts = (data) => {
  const {
    content,
    order
  } = data;
  const posts = [];
  for (let i = 0; i < order.length; i++) {
    posts[i] = content[order[i]];
  }
  return posts;
};
const mappedPinned = (data) => {
  const {
    pinned
  } = data;
  if (!pinned) {
    return {};
  }
  const result = {};
  for (const id of pinned) {
    result[id] = true;
  }
  return result;
};
const useCirclePostsState = (circleId, options) => {
  const {
    chat,
    chatId,
    limit
  } = options || {};
  const [state, setState] = useSetState({
    moreLoading: false,
    loadMoreIndex: -1,
    intro: null,
    pinned: {}
  });
  const maxPosts = typeof limit === "number" ? limit : MAX_POSTS;
  const {
    loadMoreIndex,
    moreLoading,
    intro
  } = state;
  const firstLoaded = loadMoreIndex >= maxPosts;
  const [posts, setPosts] = useState();
  const [more, setMore] = useState([]);
  const {
    circle
  } = useCircleContext();
  const {
    language
  } = useLanguageSelectionContext();
  const api = useApi();
  const deletePost = useMemoizedFn((post) => {
    const idPosts = posts.findIndex((p) => {
      return p._id === post._id;
    });
    const idMore = more.findIndex((p) => {
      return p._id === post._id;
    });
    const notFound = idPosts === -1 && idMore === -1;
    if (notFound) {
      return;
    }
    const all2 = idPosts !== -1 ? posts : more;
    const setAll = idPosts !== -1 ? setPosts : setMore;
    setAll(all2.filter((p) => {
      if (p._id === post._id) {
        return false;
      }
      return true;
    }));
  });
  const togglePin = useMemoizedFn(async (id) => {
    const pinned = {
      ...state.pinned
    };
    const alreadyPinned = !!pinned[id];
    await api.post({
      path: alreadyPinned ? "/posts/pin/remove" : "/posts/pin",
      body: {
        ids: [id],
        group: circleId
      }
    });
    if (pinned[id]) {
      delete pinned[id];
    } else {
      pinned[id] = true;
    }
    setState({
      ...state,
      pinned
    });
  });
  const updatePost = useMemoizedFn((post) => {
    const idPosts = posts.findIndex((p) => {
      return p._id === post._id;
    });
    const idMore = more.findIndex((p) => {
      return p._id === post._id;
    });
    const notFound = idPosts === -1 && idMore === -1;
    if (notFound) {
      setPosts([post, ...posts]);
      return;
    }
    const all2 = idPosts !== -1 ? posts : more;
    const setAll = idPosts !== -1 ? setPosts : setMore;
    setAll(all2.map((p) => {
      if (p._id === post._id) {
        return post;
      }
      return p;
    }));
  });
  const load = async ({
    startIndex,
    stopIndex,
    noIntro
  }) => {
    const data = await loadCirclePosts(api, circleId, "", {
      intro: !noIntro && circle && circle.intro,
      noIntro,
      language,
      range: {
        start: startIndex + 1,
        end: stopIndex + 1
      },
      chat
    });
    return data;
  };
  useUpdateEffect(() => {
    loadFirstRows();
  }, [language]);
  const {
    run: loadFirstRows
  } = useRequest(async () => {
    const range = {
      startIndex: 0,
      stopIndex: maxPosts - 1
    };
    const data = await load(range);
    const posts2 = data2posts(data);
    setState(({
      loadMoreIndex: loadMoreIndex2
    }) => {
      return {
        intro: data.intro && posts2[0] && posts2[0]._id,
        loadMoreIndex: Math.max(data.intro ? posts2.length - 1 : posts2.length, loadMoreIndex2),
        pinned: mappedPinned(data)
      };
    });
    setPosts(posts2);
  }, {
    manual: true,
    retryCount: -1
  });
  const {
    run: loadMore
  } = useRequest(async () => {
    if (!firstLoaded) {
      loadFirstRows();
      return;
    }
    setState({
      moreLoading: true
    });
    const range = {
      startIndex: loadMoreIndex,
      stopIndex: loadMoreIndex + maxPosts - 1,
      noIntro: circle && circle.intro
    };
    const data = await load(range);
    const posts2 = data2posts(data);
    setState(({
      loadMoreIndex: loadMoreIndex2
    }) => {
      return {
        moreLoading: false,
        loadMoreIndex: loadMoreIndex2 + posts2.length,
        pinned: mappedPinned(data)
      };
    });
    setMore((prev) => [...prev, ...posts2]);
  }, {
    manual: true,
    retryCount: -1
  });
  useCreation(() => {
    if (!circle) {
      return;
    }
    loadFirstRows();
  }, [!!circle, circleId]);
  const {
    activities$
  } = useActivityContext();
  const {
    run: loadFirstRowsThrottled
  } = useThrottleFn(async () => {
    loadFirstRows();
  }, {
    wait: 5e3
  });
  activities$.useSubscription((message) => {
    const {
      type,
      circleId: circleId2
    } = message;
    if (type === "post" && !chat) {
      loadFirstRowsThrottled();
      return;
    }
    if (!chat) {
      return;
    }
    if (type === "chat" && circleId2 === chatId) {
      loadFirstRowsThrottled();
    }
  });
  const all = useCreation(() => {
    if (!posts) {
      return [];
    }
    const ids = {};
    return [...posts, ...more].filter((p) => {
      const id = p._id;
      if (ids[id]) {
        return false;
      }
      ids[id] = true;
      return true;
    });
  }, [posts, more]);
  return {
    posts,
    postsLoaded: !!posts,
    updatePost,
    deletePost,
    circle,
    state,
    firstLoaded,
    moreLoading,
    loadMore,
    more,
    all,
    intro,
    togglePin
  };
};
const noop$5 = () => null;
const CirclePostsStateContext = React__default.createContext({
  posts: void 0,
  postsLoaded: false,
  updatePost: noop$5,
  circle: void 0,
  state: {},
  firstLoaded: false,
  moreLoading: false,
  loadMore: noop$5,
  deletePost: noop$5,
  more: [],
  all: [],
  intro: void 0,
  togglePin: noop$5
});
const useCirclePostsStateContext = () => {
  return useContext(CirclePostsStateContext);
};
const CirclePostsStateContextProvider = ({
  children,
  state
}) => {
  return /* @__PURE__ */ jsx(CirclePostsStateContext.Provider, {
    value: state,
    children
  });
};

const usePrompts = (op) => {
  const api = useApi();
  const result = useSWR("/playground/ai/prompts", (path) => {
    return api.get({
      path
    });
  }, {
    ...swrLoadOnce,
    ...op
  });
  return result;
};

const PromptSelector = ({
  setPrompt,
  prompt
}) => {
  const {
    data
  } = usePrompts();
  const handleChange = async (e) => {
    const id = e.target.value;
    setPrompt(id);
  };
  return /* @__PURE__ */ jsxs(FormControl$1, {
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: "prompts-label",
      children: "Your prompt"
    }), /* @__PURE__ */ jsxs(Select$1, {
      labelId: "prompts-label",
      value: prompt || "",
      variant: "outlined",
      onChange: handleChange,
      children: [/* @__PURE__ */ jsx(MenuItem, {
        value: "",
        children: "Select.."
      }), data && data.prompts.map((prompt2) => {
        return /* @__PURE__ */ jsx(MenuItem, {
          value: prompt2._id,
          children: prompt2.title
        }, prompt2._id);
      })]
    })]
  });
};

const SummarizeTest = () => {
  const postIdDefault = isLocalhost() ? "651db7decaa7332358202a53" : "6460ae96956bfa5e9bc058cf";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const postId = path[3] === "summarize" && path[4] ? path[4] : postIdDefault;
  return /* @__PURE__ */ jsx(WebsocketsContextProvider, {
    children: /* @__PURE__ */ jsxs(ActivityContextProvider, {
      children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(SWRProfileContextProvider, {
        children: /* @__PURE__ */ jsx(PostViewPage, {
          postId,
          children: /* @__PURE__ */ jsx(TestPanel, {})
        })
      })]
    })
  });
};
const TestPanel = () => {
  const {
    post,
    loadResponses
  } = usePostInfoContext();
  const api = useApi();
  const {
    onClick: onSummarize,
    loading
  } = useLoading(async () => {
    console.log("Summarize post!!!!!!!!!!!!!", post);
    await api.post({
      path: "/playground/ai/post/summarize",
      body: {
        promptId: prompt,
        postId: post._id
      }
    });
    toast("Sent to AI, response will be added as a post");
  });
  const [prompt, setPrompt] = useState("");
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2",
    children: [/* @__PURE__ */ jsx("h1", {
      children: "==========================AI test panel================================"
    }), /* @__PURE__ */ jsx(PromptSelector, {
      prompt,
      setPrompt
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSummarize,
      loading,
      disabled: !prompt,
      children: "Summarize"
    }), /* @__PURE__ */ jsx("h1", {
      children: "==========================AI test panel================================"
    })]
  });
};

const CirclePageTest = () => {
  const circleIdDefault = isLocalhost() ? "651d9f9756eb30f85b9a5936" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[3] === "circle-summarize" && path[4] ? path[4] : circleIdDefault;
  return /* @__PURE__ */ jsx(CirclePage, {
    circleId,
    children: /* @__PURE__ */ jsx(AITestPanel, {})
  });
};
const AITestPanel = () => {
  const api = useApi();
  const [prompt, setPrompt] = useState("");
  const {
    circle
  } = useCircleContext();
  const [mode, setMode] = useState("all");
  const [model, setModel] = useState("fast");
  const [filter, setFilter] = useState("");
  const [ignore, setIgnore] = useState("");
  const handleChange = (setter) => (e) => {
    const id = e.target.value;
    setter(id);
  };
  const eachPair = async () => {
    await api.post({
      path: "/playground/ai/circle/summarize-pairs",
      body: {
        promptId: prompt,
        circleId: circle._id,
        filter: filter ? filter.split(",").map((v) => v.trim()) : void 0,
        chat: model === "thorough"
      }
    });
  };
  const summarize = async () => {
    const body = {
      promptId: prompt,
      circleId: circle._id,
      ignore: ignore ? ignore.split(",").map((v) => v.trim()) : void 0,
      filter: filter ? filter.split(",").map((v) => v.trim()) : void 0,
      mode,
      chat: model === "thorough"
    };
    await api.post({
      path: "/playground/ai/circle/summarize",
      body
    });
  };
  const {
    onClick: onSummarize,
    loading
  } = useLoading(async () => {
    switch (mode) {
      case "each_pair":
        await eachPair();
        break;
      default:
        await summarize();
        break;
    }
    toast("Sent to AI, response will be added as a post");
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2 p-2",
    children: [/* @__PURE__ */ jsx("h1", {
      children: "==========================AI test panel================================"
    }), /* @__PURE__ */ jsx(PromptSelector, {
      prompt,
      setPrompt
    }), /* @__PURE__ */ jsxs(FormControl$1, {
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "execution-type",
        children: "Execute On"
      }), /* @__PURE__ */ jsxs(Select$1, {
        labelId: "execution-type",
        value: mode || "",
        variant: "outlined",
        onChange: handleChange(setMode),
        children: [/* @__PURE__ */ jsx(MenuItem, {
          value: "all",
          children: "all"
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "each_pair",
          children: "each pair"
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "subcircles",
          children: "subcirles"
        })]
      })]
    }), /* @__PURE__ */ jsxs(FormControl$1, {
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "model",
        children: "Model"
      }), /* @__PURE__ */ jsxs(Select$1, {
        labelId: "model",
        value: model || "",
        variant: "outlined",
        onChange: handleChange(setModel),
        children: [/* @__PURE__ */ jsx(MenuItem, {
          value: "fast",
          children: "fast"
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "thorough",
          children: "thorough"
        })]
      })]
    }), /* @__PURE__ */ jsx(TextField$1, {
      defaultValue: filter || "",
      onChange: handleChange(setFilter),
      label: "Include tags",
      variant: "outlined"
    }), /* @__PURE__ */ jsx(TextField$1, {
      defaultValue: ignore || "",
      onChange: handleChange(setIgnore),
      label: "Ignore tags",
      variant: "outlined"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSummarize,
      loading,
      disabled: !prompt,
      children: "Summarize"
    }), /* @__PURE__ */ jsx("h1", {
      children: "==========================AI test panel================================"
    })]
  });
};
const CircleSummarizeTest = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(WebsocketsContextProvider, {
      children: /* @__PURE__ */ jsx(ActivityContextProvider, {
        children: /* @__PURE__ */ jsx("div", {
          className: "absolute h-full w-full",
          children: /* @__PURE__ */ jsx(CirclePageTest, {})
        })
      })
    })]
  });
};

const Wrapper$4 = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const AIPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/ai";
  if (pathname.startsWith(prefix + "/summarize")) {
    return /* @__PURE__ */ jsx(SummarizeTest, {});
  }
  if (pathname.startsWith(prefix + "/circle-summarize")) {
    return /* @__PURE__ */ jsx(CircleSummarizeTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$4, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/summarize/",
        children: "summarize"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/circle-summarize/",
        children: "summarize circle"
      })
    })]
  });
};

const useIsDrafts = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const parts = pathname.split("/").filter((v) => v);
  const isDrafts = parts[parts.length - 1] === "drafts";
  return isDrafts;
};
const ProfileBreadCrumbs = ({
  isMine
}) => {
  const isDrafts = useIsDrafts();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(Link$2, {
      to: "/",
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: "Dashboard"
      })
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: "/profile",
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "profile.view"
        })
      })
    }), isDrafts && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: "/profile/drafts",
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "navigation.profile/drafts"
          })
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-grow"
    }), !isDrafts && isMine && /* @__PURE__ */ jsx(Link$2, {
      to: "/profile/drafts",
      className: "mx-1 sm:mx-2",
      children: /* @__PURE__ */ jsx("div", {
        className: "text-primary font-semibold text-xs sm:text-xl p-1",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "navigation.profile/drafts"
        })
      })
    })]
  });
};

const ProfilePageNavigation = ({
  onSearch,
  profile,
  isMine
}) => {
  const isDraft = useIsDrafts();
  const {
    run: emitFilter
  } = useThrottleFn((filter) => {
    if (!profile) {
      return;
    }
    onSearch({
      author: profile._id,
      filter
    });
  }, {
    wait: 500
  });
  const handleChange = (e) => {
    const filter = e.target.value;
    emitFilter(filter);
  };
  const intl = useIntl();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-6 sm:justify-start items-center w-full p-4 bg-white shadow-lg px-[9px] py-[7px] relative ",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: "hidden sm:block",
      children: /* @__PURE__ */ jsx(HamburgerMenu, {})
    }), !isDraft && isMine && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "hidden sm:flex justify-end items-center gap-2.5 px-6 py-2 rounded-full border-2 border-black/30 w-full max-w-2xl",
        children: [/* @__PURE__ */ jsx("img", {
          src: Search,
          className: "hidden sm:block w-8 h-8 object-cover"
        }), /* @__PURE__ */ jsx("input", {
          onChange: handleChange,
          placeholder: intl.formatMessage({
            id: "group.searchHere"
          }) + "...",
          type: "text",
          className: "outline-none w-full h-6 opacity-50 text-xl text-black  ltr:text-left rtl:text-right"
        })]
      }), /* @__PURE__ */ jsx("input", {
        onChange: handleChange,
        placeholder: intl.formatMessage({
          id: "group.searchHere"
        }) + "...",
        type: "text",
        className: "rounded-full border-2 border-black/30 outline-none text-xl ltr:text-left rtl:text-right text-black sm:hidden bg-white z-10 inset-0 w-full px-1 focus:absolute focus:border-0 focus:px-4"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-end items-center relative gap-4  ltr:ml-auto rtl:mr-auto",
      children: [/* @__PURE__ */ jsx(Link$2, {
        to: "/notifications",
        children: /* @__PURE__ */ jsxs(StyledButton, {
          icon: FaRegBell,
          className: "group relative",
          children: [/* @__PURE__ */ jsx(NotificationsBadge, {}), /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.notifications"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(OpenHelpButton, {}), /* @__PURE__ */ jsx(MyProfileIcon, {})]
    })]
  });
};
const OpenHelpButton = () => {
  const {
    profile
  } = useProfileContext();
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(HelpContextProvider, {
      page: "profile",
      profile,
      children: /* @__PURE__ */ jsx(WelcomeToPageButton, {
        button: (props) => /* @__PURE__ */ jsx(StyledButton, {
          className: "group relative",
          icon: IoMdHelpCircleOutline,
          ...props,
          children: /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.help"
            })
          })
        })
      })
    })
  });
};

const ProfilePageTest = () => {
  return /* @__PURE__ */ jsxs(SearchContextProvider, {
    children: [/* @__PURE__ */ jsx(TestPageCssOverrides$4, {}), /* @__PURE__ */ jsx(ProfilePageNavigation, {}), /* @__PURE__ */ jsx(ProfileBreadCrumbs, {})]
  });
};

const Wrapper$3 = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const ProfilePlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/profile";
  if (pathname.startsWith(prefix + "/main")) {
    return /* @__PURE__ */ jsx(ProfilePageTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$3, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/profile/",
        children: "main"
      })
    })]
  });
};

const noop$4 = () => null;
const EditCirclePostsContext = React__default.createContext({
  edited: null,
  setEdited: noop$4
});
const useEditCirclePostsContext = () => {
  return useContext(EditCirclePostsContext);
};
const EditCirclePostsContextProvider = ({
  children
}) => {
  const [edited, setEdited] = useState();
  const context = useMemo(() => {
    return {
      edited,
      setEdited
    };
  }, [edited]);
  return /* @__PURE__ */ jsx(EditCirclePostsContext.Provider, {
    value: context,
    children
  });
};

// THIS FILE IS AUTO GENERATED
function FcCancel (props) {
  return GenIcon({"tag":"svg","attr":{"version":"1","viewBox":"0 0 48 48","enableBackground":"new 0 0 48 48"},"child":[{"tag":"path","attr":{"fill":"#D50000","d":"M24,6C14.1,6,6,14.1,6,24s8.1,18,18,18s18-8.1,18-18S33.9,6,24,6z M24,10c3.1,0,6,1.1,8.4,2.8L12.8,32.4 C11.1,30,10,27.1,10,24C10,16.3,16.3,10,24,10z M24,38c-3.1,0-6-1.1-8.4-2.8l19.6-19.6C36.9,18,38,20.9,38,24C38,31.7,31.7,38,24,38 z"},"child":[]}]})(props);
}

// THIS FILE IS AUTO GENERATED
function FaRegPaperPlane (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376l0 103.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"},"child":[]}]})(props);
}

const useTinyEditorSetup = () => {
  const [editor, setEditor] = useState();
  useApi();
  useImageUrlFn();
  const images_upload_handler = null;
  return {
    editor,
    setEditor,
    images_upload_handler
  };
};
const AssistantAvatar = ({
  assistant,
  selected,
  ...other
}) => {
  return /* @__PURE__ */ jsx("div", {
    ...other,
    className: clsx(selected && "outline", "border-0 rounded-full outline-green-500 flex items-center justify-center"),
    children: /* @__PURE__ */ jsx(Avatar, {
      avatar: assistant && assistant.avatar,
      size: 24
    })
  });
};
const toolbar = "ltr rtl bold italic underline strikethrough link image media emoticons";
const TinyChatEditor = ({
  updatePost
}) => {
  const [minimized, setMinimized] = useState(true);
  const [selectedAssistant, setSelectedAssistantRaw] = useState(0);
  const {
    edited,
    setEdited
  } = useEditCirclePostsContext();
  const intl = useIntl();
  const onAssistantSelected = (id) => {
    if (loadingAssistant) {
      return;
    }
    setSelectedAssistantRaw(id);
    onAssistant(id);
  };
  const elementRef = useRef();
  const api = useApi();
  const {
    profile,
    membership,
    circle
  } = useCircleContext();
  const {
    editor,
    setEditor,
    images_upload_handler
  } = useTinyEditorSetup();
  useEffect(() => {
    if (!editor) {
      return;
    }
    if (!edited) {
      editor.setContent("");
      return;
    }
    editor.setContent(edited.content.nsHtml);
    editor.focus(false);
  }, [edited, editor]);
  const {
    data: assistantsData,
    mutate
  } = useAssistants(circle && circle.chat);
  const [assistants, setAssistants] = useState([]);
  useEffect(() => {
    if (!assistantsData) {
      return;
    }
    const {
      assistants: assistants2
    } = assistantsData;
    setAssistants(assistants2);
  }, [assistantsData]);
  const clear = () => {
    if (editor) {
      editor.setContent("");
    }
  };
  const cancel = () => {
    if (loading) {
      return;
    }
    clear();
    setMinimized(true);
  };
  const {
    onClick,
    loading
  } = useLoading(async () => {
    await onSend();
  });
  const {
    onClick: onAssistant,
    loading: loadingAssistant
  } = useLoading(async (selectedAssistant2) => {
    const {
      prompt,
      assistant
    } = editorsAssistants[selectedAssistant2];
    const content = `<p>question asked by user: ${getPersonName(profile)}</p>, the question:` + editor.getContent();
    const produceContent = prompt.position.includes(".content");
    const {
      post: published,
      content: html
    } = await api.post({
      path: `/ai/chat/add-message`,
      body: {
        circleId: circle._id,
        prompt: prompt && prompt.prompt,
        assistant: assistant._id,
        content,
        htmlPrefix: aiAnswerIntro({
          content,
          profile
        }),
        produceContent
      }
    });
    if (produceContent) {
      editor.setContent(html || "");
      return;
    }
    updatePost(published);
    clear();
  });
  const onSend = async () => {
    const content = editor.getContent();
    if (!content.trim()) {
      errorToast({
        error: "Message should not be empty!"
      });
      return;
    }
    const group = circle;
    const contentUpdate = getContentInfo(content);
    const old = edited ? await api.loadDraft({
      _id: edited.draft
    }) : null;
    const update = {
      attachments: [],
      tags: [],
      type: "article",
      group: {
        privacy: group.privacy,
        group: group._id
      },
      ...old
    };
    const draft = await api.upsertDraft({
      ...update,
      content: contentUpdate,
      image: contentUpdate.nsImage
    });
    const published = await api.publish(draft);
    editor.setContent("");
    if (edited) {
      published.author = edited.author;
      setEdited(void 0);
    } else {
      published.author = profile;
    }
    updatePost(published);
    clear();
  };
  const {
    editorsAssistants,
    groupedPrompts
  } = useCreation(() => {
    const editorsAssistants2 = assistants.filter((assistant) => assistant.prompts && assistant.prompts.length).flatMap((assistant) => {
      return assistant.prompts.filter((p) => p.position && p.position.startsWith("editor.")).map((prompt, id) => {
        return {
          assistant,
          prompt
        };
      });
    });
    const groupsMap = new Map();
    editorsAssistants2.forEach((item, index) => {
      if (!groupsMap.has(item.assistant._id)) {
        groupsMap.set(item.assistant._id, {
          ids: [index],
          assistant: item.assistant,
          prompts: [item.prompt]
        });
      } else {
        const grouped = groupsMap.get(item.assistant._id);
        grouped.prompts.push(item.prompt);
        grouped.ids.push(index);
      }
    });
    return {
      editorsAssistants: editorsAssistants2,
      groupedPrompts: Array.from(groupsMap.values())
    };
  }, [assistants]);
  const canAsk = !!editorsAssistants.length;
  const onCancelEdit = () => {
    setEdited(void 0);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: clsx("w-full flex-col", !minimized ? "hidden" : "flex"),
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex justify-end items-center px-2 rounded-full border border-black/30 w-full gap-2 cursor-pointer",
        onClick: async () => {
          setMinimized(false);
          await delay$1(40);
          editor.focus(false);
        },
        children: [/* @__PURE__ */ jsx(FaRegPaperPlane, {}), /* @__PURE__ */ jsx("div", {
          className: "outline-none w-full text-xs text-black ltr:text-left rtl:text-right opacity-60",
          children: intl.formatMessage({
            id: "compose.new.chat_placeholder"
          })
        })]
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: clsx("w-full flex-col", minimized ? "hidden" : "flex"),
      children: [edited && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsxs("div", {
          children: ["Editing post: ", edited.title.slice(0, 250)]
        }), /* @__PURE__ */ jsx(FcCancel, {
          onClick: onCancelEdit,
          className: "cursor-pointer"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-full flex items-center gap-4 flex-wrap",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-1",
          children: [/* @__PURE__ */ jsx(Avatar, {
            avatar: profile && profile.avatar,
            size: 24
          }), /* @__PURE__ */ jsx("div", {
            className: "flex text-2xs font-medium",
            children: getPersonName(profile)
          })]
        }), canAsk && groupedPrompts.map((grouped) => {
          return /* @__PURE__ */ jsx(AssistantPromptsMenu, {
            grouped,
            onAssistantSelected,
            loadingAssistant,
            selectedAssistant
          }, grouped.assistant._id);
        })]
      }), /* @__PURE__ */ jsx("div", {
        ref: elementRef,
        children: /* @__PURE__ */ jsx(TinyEditor, {
          free: true,
          content: "",
          autoresize: true,
          setEditor,
          settings: {
            plugins: "urlpreview",
            height: 100,
            toolbar,
            auto_focus: "none",
            menubar: false,
            statusbar: false,
            images_upload_handler,
            min_height: 100,
            ...{
              autoresize_bottom_margin: 50
            },
            max_height: 250
          }
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-full flex justify-center p-2",
        children: [/* @__PURE__ */ jsx(BigStyledButton, {
          className: "mx-1",
          bg: loading ? "bg-gray-500" : "bg-black",
          fitContent: true,
          onClick: cancel,
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "post.cancel"
          })
        }), /* @__PURE__ */ jsx(BigStyledButton, {
          className: "mx-1",
          fitContent: true,
          icon: loading && (() => /* @__PURE__ */ jsx(CgSpinner, {
            size: 20,
            className: "animate-spin"
          })),
          onClick,
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "post.publish"
          })
        })]
      })]
    })]
  });
};
const AssistantPromptsMenu = ({
  grouped,
  onAssistantSelected,
  loadingAssistant,
  selectedAssistant
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const {
    prompts,
    ids,
    assistant
  } = grouped;
  if (prompts.length === 1) {
    const prompt = prompts[0];
    const id = ids[0];
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center cursor-pointer",
      onClick: () => onAssistantSelected(id),
      children: [loadingAssistant && id === selectedAssistant && /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      }), /* @__PURE__ */ jsx(AssistantAvatar, {
        assistant
      }), /* @__PURE__ */ jsx("div", {
        children: prompt.name
      })]
    });
  }
  const onPromptSelected = (id) => {
    handleClose();
    onAssistantSelected(id);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center cursor-pointer",
      onClick: handleClick,
      children: [loadingAssistant && ids.includes(selectedAssistant) && /* @__PURE__ */ jsx(CgSpinner, {
        size: 20,
        className: "animate-spin"
      }), /* @__PURE__ */ jsx(AssistantAvatar, {
        assistant
      }), /* @__PURE__ */ jsx("div", {
        children: assistant.name
      })]
    }), /* @__PURE__ */ jsx(Menu$1, {
      id: "simple-menu",
      anchorEl,
      keepMounted: true,
      open: Boolean(anchorEl),
      onClose: handleClose,
      children: prompts.map((prompt, id) => {
        return /* @__PURE__ */ jsx(MenuItem, {
          onClick: () => onPromptSelected(ids[id]),
          children: prompt.name
        }, id);
      })
    })]
  });
};

const noop$3 = () => null;
const ChatContext = React__default.createContext({
  membership: null,
  circle: null,
  setMembership: noop$3,
  setCircle: noop$3,
  setAuthenticationRequired: noop$3
});
const useChatContext = () => {
  return useContext(ChatContext);
};
const ChatContextProvider = ({
  children
}) => {
  const [circle, setCircle] = useState();
  const [membership, setMembership] = useState();
  const [authenticationRequired, setAuthenticationRequired] = useState(false);
  const context = useMemo(() => {
    return {
      circle,
      membership,
      setMembership,
      setCircle,
      authenticationRequired,
      setAuthenticationRequired
    };
  }, [circle, membership]);
  return /* @__PURE__ */ jsx(ChatContext.Provider, {
    value: context,
    children
  });
};

const StyledMenuButton = (props) => {
  return /* @__PURE__ */ jsx("button", {
    className: "p-[3px] sm:p-[6px] w-max rounded-full flex justify-between items-center hover:bg-slate-200 active:scale-125 active:bg-slate-300",
    ...props,
    children: /* @__PURE__ */ jsx(BsThreeDotsVertical, {
      className: "w-[15px] h-[15px] sm:w-[20px] sm:h-[20px]"
    })
  });
};
const PostMenu = ({
  post,
  className
}) => {
  const {
    profile
  } = useProfileContext();
  const {
    membership,
    circle
  } = useChatContext();
  const hasOverflowMenu = (target) => {
    return isAuthor(target, profile) || isAdmin(membership) && circle && !circle.closed;
  };
  if (!hasOverflowMenu(post)) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className,
    children: /* @__PURE__ */ jsx("div", {
      className: "relative inline-block",
      children: /* @__PURE__ */ jsx(OverflowMenu, {
        button: StyledMenuButton,
        contentComponent: (props) => /* @__PURE__ */ jsxs(Paper, {
          ...props,
          children: [/* @__PURE__ */ jsx(DeleteChatMessageMenuItem, {
            post
          }), /* @__PURE__ */ jsx(EditChatMessageMenuItem, {
            post
          }), /* @__PURE__ */ jsx(PinMessageMenuItem, {
            post
          })]
        })
      })
    })
  });
};
const PinMessageMenuItem = ({
  post
}) => {
  const {
    membership
  } = useChatContext();
  const {
    state,
    togglePin
  } = useCirclePostsStateContext$1();
  const {
    pinned
  } = state;
  const {
    onClick
  } = useLoading(async () => {
    await togglePin(post._id);
  });
  if (!isAdmin(membership)) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: pinned[post._id] ? /* @__PURE__ */ jsx(FormattedMessage, {
      id: "chat.unpin"
    }) : /* @__PURE__ */ jsx(FormattedMessage, {
      id: "chat.pin"
    })
  });
};
const EditChatMessageMenuItem = ({
  post
}) => {
  const {
    setEdited
  } = useEditCirclePostsContext();
  const {
    profile
  } = useProfileContext();
  const {
    onClick
  } = useLoading(async () => {
    setEdited(post);
  });
  if (!isAuthor(post, profile)) {
    return null;
  }
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "chat.edit"
    })
  });
};
const DeleteChatMessageMenuItem = ({
  post
}) => {
  const {
    deletePost
  } = useCirclePostsStateContext$1();
  const api = useApi();
  const {
    membership
  } = useChatContext();
  const {
    onClick
  } = useLoading(async () => {
    await api.unpublishPost({
      _id: post._id,
      as_admin: isAdmin(membership)
    });
    deletePost(post);
  });
  return /* @__PURE__ */ jsx(MenuItem, {
    onClick,
    children: /* @__PURE__ */ jsx(FormattedMessage, {
      id: "ai.delete"
    })
  });
};
const PostCardWrapper = styled.div`
  line-height: 1.2;
  font-family: Helvetica, Arabic Droid Arabic Kufi;
`;
const ChatMessageCard = ({
  post,
  selected,
  style,
  ...props
}) => {
  const {
    profile
  } = useProfileContext();
  usePostsFiltersContext();
  getPostTypeIcon(post);
  const {
    author
  } = post;
  const displayName = getPersonName(author);
  const isAuthor2 = profile && author && author._id === profile._id;
  return /* @__PURE__ */ jsxs(PostCardWrapper, {
    "data-testid": "PostCard",
    style,
    className: clsx("justify-start items-start relative p-1 flex w-full leading-3 text-black min-w-0 max-w-full"),
    ...props,
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(Avatar, {
        avatar: author.avatar,
        size: 24,
        className: "mx-1"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: clsx("flex flex-col justify-start items-start rounded-lg relative p-1", isAuthor2 ? "bg-[#4a90ce26]" : "bg-[#fe975d21]", selected && "outline-blue-400 outline"),
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center",
        children: [/* @__PURE__ */ jsx("p", {
          className: "text-black text-2xs",
          children: displayName
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex gap-1 items-center",
          children: [/* @__PURE__ */ jsx(TimeIcon, {
            className: "hidden sm:block flex-grow-0 flex-shrink-0 w-4 h-4"
          }), /* @__PURE__ */ jsx("p", {
            className: "text-2xs w-full",
            children: /* @__PURE__ */ jsx(RelativeTime, {
              value: post.created
            })
          })]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: clsx("inline-block self-stretch relative"),
        children: /* @__PURE__ */ jsx("p", {
          className: "inline text-sm break-words",
          children: /* @__PURE__ */ jsx(ContentCard, {
            post
          })
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-grow relative",
      children: /* @__PURE__ */ jsx(PostMenu, {
        post,
        className: "top-0 mt-0 mr-0 z-10"
      })
    })]
  });
};

const ChatCssOverrides$1 = createGlobalStyle`
  #body, body {
    background-color: white;
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    position: absolute;
  }

  html {
    overflow: hidden;    
  }
  
  #root > * {
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    position: absolute;
  }
`;

const useTabVisibility = () => {
  const [isVisible, setIsVisible] = useState(typeof document === "undefined" ? true : document.visibilityState === "visible");
  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === "visible");
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  return isVisible;
};

const useNotification = () => {
  const [permission, setPermission] = useState("default");
  const history = useHistory();
  useEffect(() => {
    const requestPermission = async () => {
      if (typeof Notification !== "undefined" && permission !== "granted") {
        const result = await Notification.requestPermission();
        setPermission(result);
      }
    };
    requestPermission();
  }, [permission]);
  const sendNotification = (title, options, redirectPath) => {
    console.log("9999999999999999999999999999999999999", title);
    if (typeof Notification === "undefined") {
      console.warn("Notifications are not supported by this browser.");
      return;
    }
    if (permission === "granted") {
      const notification = new Notification(title, options);
      notification.onclick = (event) => {
        event.preventDefault();
        window.focus();
        if (redirectPath) {
          history.push(redirectPath);
        }
      };
    } else {
      console.warn("Notification permission not granted.");
    }
  };
  return { sendNotification };
};

const notified = {};
const useNotifyChatMessage = ({
  enabled
}) => {
  const isVisible = useTabVisibility();
  const {
    sendNotification
  } = useNotification();
  const {
    activities$
  } = useContext(ActivityContext);
  activities$.useSubscription((message) => {
    const {
      type
    } = message;
    if (!enabled) {
      return;
    }
    if (type === "chat") {
      const {
        postId,
        circleId,
        title,
        author
      } = message;
      if (notified[postId]) {
        return;
      }
      notified[postId] = true;
      const text = `${author} : ${title}`;
      const url = `/trans/circle-chat/${circleId}`;
      if (isVisible) ; else {
        sendNotification("New chat message", {
          body: text
        }, url);
      }
    }
  });
};
const ChatNavigation = () => {
  const {
    circle,
    membership
  } = useCircleContext();
  const api = useApi();
  const [enabled, setEnabled] = useState(true);
  const {
    mail_prefs
  } = membership || {};
  const {
    chat_off
  } = mail_prefs || {};
  useNotifyChatMessage({
    enabled
  });
  useEffect(() => {
    setEnabled(!chat_off);
  }, [chat_off]);
  const onNotifications = async () => {
    if (!membership) {
      return;
    }
    const notify = !enabled;
    setEnabled(notify);
    try {
      await api.post({
        path: `/groups/${circle._id}/_chat_notifications`,
        body: {
          notify
        }
      });
    } catch (error) {
      setEnabled(!notify);
      errorToast({
        error
      });
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 sm:justify-start items-center w-full  bg-white shadow-lg relative px-1",
    style: {
      boxShadow: "0px 7px 15px 0 rgba(0,0,0,0.25)"
    },
    children: [/* @__PURE__ */ jsx("div", {
      className: "hidden lg:block",
      children: /* @__PURE__ */ jsx(HamburgerMenu, {})
    }), /* @__PURE__ */ jsx(SearchInput, {
      noSimpleSearch: true
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex justify-end items-center relative gap-4  ltr:ml-auto rtl:mr-auto",
      children: [/* @__PURE__ */ jsx(LanguageSelectionMenu, {}), /* @__PURE__ */ jsx(StyledButton, {
        icon: enabled ? TbMessage : TbMessageOff,
        className: "group relative",
        onClick: onNotifications,
        children: /* @__PURE__ */ jsx(Tooltip, {
          children: "enable/disable notifications"
        })
      }), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circle) + "/membership",
        children: /* @__PURE__ */ jsxs(StyledButton, {
          icon: FaRegUserCircle,
          className: "group relative",
          children: [/* @__PURE__ */ jsx(CircleUsersBadge, {}), /* @__PURE__ */ jsx(Tooltip, {
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "group.tooltips.members"
            })
          })]
        })
      }), /* @__PURE__ */ jsx(ProfileIcon, {})]
    })]
  });
};

const BreadCrumbs = ({
  current
}) => {
  const {
    circle
  } = useCircleContext();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), /* @__PURE__ */ jsx(Next, {}), circle && circle.parent && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circle.parent),
        children: "..."
      }), /* @__PURE__ */ jsx(Next, {})]
    }), circle && /* @__PURE__ */ jsx(Link$2, {
      to: circleUrl(circle._id),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: circle.name
      })
    }), current && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: current
      })]
    })]
  });
};

const CardChip = styled(CardChip$1)`
    max-width: none;
    text-transform: none;
    margin: 0;
    margin-right: 0.1em;
    min-width: 30px;
`;
const SearchHelp = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("li", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "chat.search1"
      })
    }), /* @__PURE__ */ jsx("li", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "chat.search2"
      })
    }), /* @__PURE__ */ jsx("li", {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "chat.search3"
      })
    })]
  });
};
const VectorSearchResultsPanel = ({
  inChat,
  chatId
}) => {
  const {
    found,
    postsById,
    prompt,
    aiResponse,
    chunkTranslations = {},
    isAIMode,
    isSearchMode,
    chat,
    asyncId,
    websocketMessage,
    setWebsocketMessage
  } = useCircleSearchContext();
  const processed = websocketMessage && websocketMessage.processed;
  const {
    id
  } = useCircleContext();
  const displayHelp = !inChat || isSearchMode;
  const displayResults = !inChat || isSearchMode;
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    if (!found || !isSearchMode) {
      return;
    }
    ref.current.scrollIntoView({
      behavior: "smooth"
    });
  }, [isSearchMode, found]);
  const {
    activities$
  } = useActivityContext();
  activities$.useSubscription((msg) => {
    const message = msg;
    const {
      type
    } = message;
    if (type === "search-result" && asyncId === message.asyncId) {
      setWebsocketMessage(message);
    }
  });
  const minimizeSearchResult = isAIMode && !expanded;
  return /* @__PURE__ */ jsxs("div", {
    className: "text-sm sm:text-base flex flex-col gap-2 w-full",
    ref,
    children: [displayHelp && /* @__PURE__ */ jsxs(Fragment, {
      children: [!prompt && isAIMode && /* @__PURE__ */ jsx("p", {
        className: "p-2",
        children: /* @__PURE__ */ jsx(SearchHelp, {})
      }), !prompt && !isAIMode && /* @__PURE__ */ jsx("p", {
        className: "p-2",
        children: /* @__PURE__ */ jsx(SearchHelp, {})
      })]
    }), displayResults && /* @__PURE__ */ jsxs(Fragment, {
      children: [(aiResponse || asyncId || processed) && isAIMode && /* @__PURE__ */ jsx("div", {
        className: "bg-[#00A5B6] p-2 rounded-lg font-semibold text-white m-1",
        dir: "auto",
        children: "AI analysis of the Search results"
      }), (aiResponse || processed) && isAIMode && /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: aiResponse || processed
        },
        className: "p-1 min-w-0",
        dir: "auto"
      }), asyncId && !processed && /* @__PURE__ */ jsx("div", {
        className: "relative h-5",
        children: /* @__PURE__ */ jsx(MuiSpinner, {
          timeout: 0
        })
      }), found && found.length === 0 && /* @__PURE__ */ jsx("div", {
        children: "No search results found"
      }), found && found.length > 0 && /* @__PURE__ */ jsxs("div", {
        className: "bg-[#00A5B6] p-2 rounded-lg font-semibold text-white flex items-center gap-2",
        dir: "auto",
        children: [/* @__PURE__ */ jsxs("span", {
          children: ["AI search results (", found.length, ") "]
        }), isAIMode && /* @__PURE__ */ jsx(IconButton$5, {
          onClick: () => setExpanded((v) => !v),
          children: !expanded ? /* @__PURE__ */ jsx(BsArrowsCollapse, {
            color: "white"
          }) : /* @__PURE__ */ jsx(BsChevronExpand, {
            color: "white"
          })
        })]
      }), minimizeSearchResult && found && found.length && /* @__PURE__ */ jsx("div", {
        className: "w-full h-20"
      }), !minimizeSearchResult && found && found.map((one, i) => {
        const {
          text,
          score,
          metadata
        } = one;
        const {
          postId,
          persons,
          locations,
          organizations,
          circleId,
          chunkId,
          type
        } = metadata || {};
        const post = postsById[postId];
        const translation = chunkTranslations[postId] || {};
        const showUrl = circleId !== chatId;
        const isChat = circleId === chat;
        const externalUrl = externalPostUrl(post);
        const isInternal = !externalUrl && !isChat && post;
        const url = showUrl ? isChat ? `/trans/circle-chat/${id}` : externalUrl || (isInternal ? bookCairReaderUrl(post._id) : url4post(post)) : void 0;
        const getChunkUrl = () => {
          if (!showUrl) {
            return void 0;
          }
          const threadLength = post && post.thread && post.thread.length;
          const shouldUseChunkHash = !isChat && type !== "asset" && typeof chunkId === "number" && (!threadLength || isPage(post)) && !externalUrl;
          if (!shouldUseChunkHash) {
            return url;
          }
          if (isInternal) {
            return `${url}#?chunk=${postId}-${chunkId}`;
          }
          if (isPage(post)) {
            return `${url}&chunk=${postId}-${chunkId}`;
          }
          return `${url}#?chunk=${postId}-${chunkId}`;
        };
        const chunkUrl = getChunkUrl();
        const description = getChunkText(post, translation.text || text);
        const {
          email,
          address,
          phone,
          url: assetUrl
        } = getPostAssetFields(post, {});
        const {
          address: eventAddress
        } = getEventData(post, {});
        const title = translation.title || (post ? post.title : "open");
        return /* @__PURE__ */ jsxs("div", {
          dir: "auto",
          className: "flex flex-col gap-3 p-3 bg-white card-shadow overflow-hidden leading-3 text-black rounded-lg w-full text-sm",
          children: [(type === "event" || type === "asset") && /* @__PURE__ */ jsx("a", {
            href: url,
            className: "no-underline mx-2",
            children: /* @__PURE__ */ jsx("span", {
              className: "text-sm break-words",
              children: title
            })
          }), (address || eventAddress) && /* @__PURE__ */ jsx("a", {
            href: chunkUrl,
            className: "no-underline font-semibold",
            children: /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2 flex-wrap mx-2 ",
              children: [/* @__PURE__ */ jsx("span", {
                children: "address:"
              }), " ", /* @__PURE__ */ jsx("span", {
                children: address || eventAddress
              })]
            })
          }), /* @__PURE__ */ jsx("div", {
            className: "mx-2 leading-normal font-semibold",
            "data-testid": "description",
            children: /* @__PURE__ */ jsx("a", {
              href: chunkUrl,
              className: "no-underline",
              children: description
            })
          }), phone && /* @__PURE__ */ jsx("a", {
            href: chunkUrl,
            className: "no-underline font-semibold",
            children: /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2 flex-wrap mx-2 ",
              children: [/* @__PURE__ */ jsx("span", {
                children: "phone:"
              }), " ", /* @__PURE__ */ jsx("span", {
                children: phone
              })]
            })
          }), email && /* @__PURE__ */ jsx("a", {
            href: chunkUrl,
            className: "no-underline font-semibold",
            children: /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2 flex-wrap mx-2 ",
              children: [/* @__PURE__ */ jsx("span", {
                children: "email:"
              }), " ", /* @__PURE__ */ jsx("span", {
                children: email
              })]
            })
          }), assetUrl && /* @__PURE__ */ jsx("a", {
            href: chunkUrl,
            className: "no-underline font-semibold",
            children: /* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2 flex-wrap mx-2 ",
              children: [/* @__PURE__ */ jsx("span", {
                children: "web:"
              }), " ", /* @__PURE__ */ jsx("span", {
                children: assetUrl
              })]
            })
          }), type !== "event" && type !== "asset" && /* @__PURE__ */ jsx("a", {
            href: url,
            className: "no-underline mx-2",
            children: /* @__PURE__ */ jsx("span", {
              className: "text-sm break-words",
              children: title
            })
          }), persons && persons.length > 0 && /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-2 flex-wrap mx-2",
            children: [/* @__PURE__ */ jsx("span", {
              className: "font-semibold",
              children: "Persons:"
            }), persons.map((value) => /* @__PURE__ */ jsx(CardChip, {
              children: value
            }, value))]
          }), locations && locations.length > 0 && /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-2 flex-wrap mx-2",
            children: [/* @__PURE__ */ jsx("span", {
              className: "font-semibold",
              children: "Locations:"
            }), locations.map((value) => /* @__PURE__ */ jsx(CardChip, {
              children: value
            }, value))]
          }), organizations && organizations.length > 0 && /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-2 flex-wrap mx-2",
            children: [/* @__PURE__ */ jsx("span", {
              className: "font-semibold",
              children: "Organizations:"
            }), organizations.map((value) => /* @__PURE__ */ jsx(CardChip, {
              children: value
            }, value))]
          }), /* @__PURE__ */ jsx("div", {
            className: "flex justify-start",
            children: /* @__PURE__ */ jsxs("span", {
              className: "mx-2 rounded-lg",
              children: ["Similarities index: ", Math.round(score * 100) / 100]
            })
          })]
        }, i);
      })]
    })]
  });
};

const CircleChatPageTest = () => {
  return /* @__PURE__ */ jsx("div", {
    children: "Use page /trans/circle-chat/CIRCLE_ID?test=1"
  });
};
const LoadChatPanel$1 = ({
  circleId,
  test,
  chatId
}) => {
  return /* @__PURE__ */ jsx(CirclePageProviders, {
    circleId,
    children: /* @__PURE__ */ jsx(EditCirclePostsContextProvider, {
      children: /* @__PURE__ */ jsx(ChatPanelInner1$1, {
        test,
        chatId,
        circleId
      })
    })
  });
};
const JoinCirclePanel = ({}) => {
  const {
    membership,
    circle
  } = useChatContext();
  if (!membership) {
    return /* @__PURE__ */ jsxs("span", {
      className: "inline",
      children: ["You are not member of the Chat circle. Join ", /* @__PURE__ */ jsx("span", {
        className: "underline",
        children: /* @__PURE__ */ jsx("a", {
          href: circleUrl(circle),
          children: "this circle"
        })
      }), " first."]
    });
  }
  return null;
};
const SetupRootChatContext = () => {
  const {
    authenticationRequired
  } = useProfileContext();
  const {
    membership,
    circle
  } = useCircleContext();
  const {
    setMembership,
    setCircle,
    setAuthenticationRequired
  } = useChatContext();
  useEffect(() => {
    setAuthenticationRequired(authenticationRequired);
  }, [authenticationRequired]);
  useEffect(() => {
    setMembership(membership);
  }, [membership]);
  useEffect(() => {
    setCircle(circle);
  }, [circle]);
  return null;
};
const ChatPanelInner1$1 = ({
  test,
  chatId,
  circleId
}) => {
  const {
    membership,
    authenticationRequired
  } = useChatContext();
  return /* @__PURE__ */ jsx(CircleSearchContextProvider, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "ns w-full p-2 flex flex-col gap-4 text-sm h-full overflow-hidden",
      children: [/* @__PURE__ */ jsxs(LoadCircleData, {
        circleId: chatId,
        children: [/* @__PURE__ */ jsx(SetupRootChatContext, {}), /* @__PURE__ */ jsx(ChatNavigation, {}), /* @__PURE__ */ jsx(BreadCrumbs, {
          current: /* @__PURE__ */ jsx("a", {
            href: `#?chat=${circleId}`,
            children: "Chat"
          })
        }), /* @__PURE__ */ jsx(AuthDialog, {
          open: authenticationRequired,
          onClose: () => {
          }
        }), !authenticationRequired && /* @__PURE__ */ jsx(JoinCirclePanel, {})]
      }), membership && /* @__PURE__ */ jsx(ChatPanelInner, {
        test,
        chatId
      })]
    })
  });
};
const ChatPanelInner = ({
  test,
  chatId
}) => {
  const postsEndRef = useRef(null);
  const isMobile = useIsMobile();
  const {
    id
  } = useCircleContext();
  const state = useCirclePostsState$2(id, {
    chat: true,
    chatId,
    limit: 30
  });
  const {
    firstLoaded,
    all: posts1,
    updatePost,
    moreLoading,
    loadMore,
    state: {
      pinned
    }
  } = state;
  const [posts, setPosts] = useState([]);
  const [pinnedPosts, setPinnedPosts] = useState([]);
  useEffect(() => {
    if (!posts1) {
      return;
    }
    setPosts([...posts1.filter((v) => !pinned[v._id])].reverse());
    setPinnedPosts([...posts1.filter((v) => pinned[v._id])]);
  }, [posts1, pinned]);
  useEffect(() => {
    if (!posts) {
      return;
    }
    setTimeout(() => scrollToTheLast(), 50);
  }, [posts && posts.length]);
  const api = useApi();
  const {
    onClick: onTranslateClear,
    loading: loadingClear
  } = useLoading(async () => {
    postsEndRef.current.scrollIntoView({
      behavior: "smooth"
    });
  });
  const {
    onClick: onCreate,
    loading: loadingCreate
  } = useLoading(async () => {
    await api.post({
      path: `/groups/chat/create`,
      body: {
        circleId: id
      }
    });
  });
  const scrollToTheLast = () => {
    if (postsEndRef.current) {
      postsEndRef.current.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  return /* @__PURE__ */ jsx(CirclePostsStateContextProvider$1, {
    state,
    children: /* @__PURE__ */ jsxs("div", {
      className: clsx("flex gap-2 flex-col w-full overflow-x-hidden flex-grow"),
      children: [test && /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2",
        children: [/* @__PURE__ */ jsx(LoadingButton, {
          onClick: onTranslateClear,
          variant: "contained",
          className: "w-52",
          loading: loadingClear,
          children: "Scroll to last"
        }), /* @__PURE__ */ jsx(LoadingButton, {
          onClick: onCreate,
          variant: "contained",
          className: "w-52",
          loading: loadingCreate,
          children: "Create"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-grow overflow-x-hidden overflow-y-auto",
        children: [/* @__PURE__ */ jsx("div", {
          className: "flex-grow"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-1 items-center flex-grow justify-start sm:max-w-3xl max-w-full",
          children: [/* @__PURE__ */ jsx(VectorSearchResultsPanel, {
            inChat: true,
            chatId: id
          }), firstLoaded && /* @__PURE__ */ jsx(LoadingButton, {
            className: "w-full",
            loading: moreLoading,
            onClick: loadMore,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "chat.loadMore"
            })
          }), /* @__PURE__ */ jsxs(ContentContextProvider, {
            fontSize: isMobile ? 12 : 14,
            children: [pinnedPosts.map((post) => /* @__PURE__ */ jsx(ChatMessageCard, {
              post,
              selected: true
            }, post._id)), /* @__PURE__ */ jsx(RenderCirclePosts, {
              data: posts,
              error: void 0,
              children: (post) => /* @__PURE__ */ jsx(ChatMessageCard, {
                post,
                selected: false
              }, post._id)
            })]
          }), /* @__PURE__ */ jsx("div", {
            ref: postsEndRef
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "flex-grow"
        })]
      }), /* @__PURE__ */ jsx(TinyChatEditor, {
        updatePost
      })]
    })
  });
};
const CircleChatTest = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(ChatCssOverrides$1, {}), /* @__PURE__ */ jsx(CircleChatPageTest, {})]
  });
};

const Wrapper$2 = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const ChatPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/chat";
  if (pathname.startsWith(prefix + "/circle")) {
    return /* @__PURE__ */ jsx(CircleChatTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$2, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/circle/",
        children: "Chats"
      })
    })]
  });
};

const StorageTest = () => {
  const api = useApi();
  const [file, setFile] = useState();
  const {
    onClick: onDrop,
    loading
  } = useLoading(async (accepted) => {
    setFile(accepted[0]);
  });
  const {
    onClick: onProcess,
    loading: loadingProcess
  } = useLoading(async () => {
    await api.upload({
      0: file,
      onProgress: () => {
      },
      path: "/playground/uploads/storage"
    });
  });
  const dropzone = useDropzone({
    onDrop
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns w-full p-2 flex flex-col gap-4 text-sm h-full overflow-auto relative",
      children: [/* @__PURE__ */ jsx("div", {
        className: "font-semibold text-lg m-auto",
        children: /* @__PURE__ */ jsx("span", {
          children: "Storage test "
        })
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ createElement(DropZone$1, {
        ...dropzone,
        key: String(loading)
      }, loading && /* @__PURE__ */ jsx("div", {
        className: "absolute inset-0 flex items-center justify-center",
        children: /* @__PURE__ */ jsx(CircularProgress, {
          size: 24
        })
      })), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx("div", {
        className: "flex gap-2 items-center",
        children: !file ? null : /* @__PURE__ */ jsx(LoadingButton, {
          loading: loadingProcess,
          disabled: !file,
          onClick: onProcess,
          background: "red",
          children: "Upload"
        })
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {})]
    })]
  });
};

gql`
  query GetSession($token: String!) {
    getSession(token: $token) {
      token
      userId
      expiresAt
    }
  }
`;
const BasicGraphQLTest = () => {
  const api = useApi();
  const [result, setResult] = useState();
  const graphQLClient = useGraphQLClientFn();
  const {
    onClick: onTest,
    loading: loadingTest
  } = useLoading(async () => {
    const graphqlClient = await graphQLClient();
    const result2 = await graphqlClient.request(GetSessionDocument, {
      token: "123"
    });
    console.log("!!!!!!!!!", result2);
    setResult(result2);
  });
  const {
    onClick: onYourAuthentication,
    loading: loadingYourAuthentication
  } = useLoading(async () => {
    const header = await authorizationHeader(api);
    console.log("!!!!!!!!!", header);
    setResult(header);
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns w-full p-2 flex flex-col gap-4 text-sm h-full overflow-auto relative",
      children: [/* @__PURE__ */ jsx("div", {
        className: "font-semibold text-lg m-auto",
        children: /* @__PURE__ */ jsx("span", {
          children: "Basic GraphQL test "
        })
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(Result, {
        children: result
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center",
        children: [/* @__PURE__ */ jsx(LoadingButton, {
          loading: loadingYourAuthentication,
          onClick: onYourAuthentication,
          children: "Your authentication header"
        }), /* @__PURE__ */ jsx(LoadingButton, {
          loading: loadingTest,
          onClick: onTest,
          children: "Test"
        })]
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {})]
    })]
  });
};

const Wrapper$1 = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const GraphQLPlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib/graphql";
  if (pathname.startsWith(prefix + "/basic")) {
    return /* @__PURE__ */ jsx(BasicGraphQLTest, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper$1, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: "./..",
        children: "Level Up"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/basic/",
        children: "Basic"
      })
    })]
  });
};

const Wrapper = styled.div`
  &>div {
    padding: 10px;
    overflow: auto;
  } 
`;
const CorePlayground = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/playground/lib";
  if (pathname.startsWith(prefix + "/form")) {
    return /* @__PURE__ */ jsx(FormTest, {});
  }
  if (pathname.startsWith(prefix + "/storage")) {
    return /* @__PURE__ */ jsx(StorageTest, {});
  }
  if (pathname.startsWith(prefix + "/google-analytics")) {
    return /* @__PURE__ */ jsx(GoogleAnalyticsPlayground, {});
  }
  if (pathname.startsWith(prefix + "/mobile")) {
    return /* @__PURE__ */ jsx(MobilePlayground, {});
  }
  if (pathname.startsWith(prefix + "/chat")) {
    return /* @__PURE__ */ jsx(ChatPlayground, {});
  }
  if (pathname.startsWith(prefix + "/graphql")) {
    return /* @__PURE__ */ jsx(GraphQLPlayground, {});
  }
  if (pathname.startsWith(prefix + "/circles")) {
    return /* @__PURE__ */ jsx(CirclesPlayground, {});
  }
  if (pathname.startsWith(prefix + "/posts")) {
    return /* @__PURE__ */ jsx(PostsPlayground, {});
  }
  if (pathname.startsWith(prefix + "/single-circle")) {
    return /* @__PURE__ */ jsx(CirclePlayground, {});
  }
  if (pathname.startsWith(prefix + "/assets")) {
    return /* @__PURE__ */ jsx(AssetsPlayground, {});
  }
  if (pathname.startsWith(prefix + "/ai")) {
    return /* @__PURE__ */ jsx(AIPlayground, {});
  }
  if (pathname.startsWith(prefix + "/profile")) {
    return /* @__PURE__ */ jsx(ProfilePlayground, {});
  }
  if (pathname.startsWith(prefix + "/core")) {
    return /* @__PURE__ */ jsx(CoreLibComponentsPlayground, {});
  }
  if (pathname.startsWith(prefix + "/activity")) {
    return /* @__PURE__ */ jsx(ActivityPlayground, {});
  }
  if (pathname.startsWith(prefix + "/activity-dashboard")) {
    return /* @__PURE__ */ jsx(ActivityDashboard, {});
  }
  if (pathname.startsWith(prefix + "/circle-item-subcomponents")) {
    return /* @__PURE__ */ jsx(CicrleListItemComponentsTest, {});
  }
  if (pathname.startsWith(prefix + "/circle-item-old")) {
    return /* @__PURE__ */ jsx(CircleItemTest, {});
  }
  if (pathname.startsWith(prefix + "/discover-circles")) {
    return /* @__PURE__ */ jsx(DiscoverCircles, {});
  }
  if (pathname.startsWith(prefix + "/activity-dashboard")) {
    return /* @__PURE__ */ jsx(ActivityDashboard, {});
  }
  return /* @__PURE__ */ jsxs(Wrapper, {
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/chat/",
        children: "Chat"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/graphql/",
        children: "GraphQL"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/storage/",
        children: "Storage"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/mobile/",
        children: "Mobile"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/google-analytics/",
        children: "Google Analytics"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/form/",
        children: "Form"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/posts/",
        children: "Posts"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/circles/",
        children: "Circles"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/assets/",
        children: "New Assets"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/ai/",
        children: "AI"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/profile/",
        children: "Profile"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/single-circle/",
        children: "Circle"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/core/",
        children: "Core components"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/activity/",
        children: "Activity"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/circle-item-old/",
        children: "Circles Item (should be splitted)"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/circle-item-subcomponents/",
        children: "Circles Item Subcomponents"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/discover-circles/",
        children: "Discover Circles"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/form/",
        children: "Assets Form"
      })
    }), /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx("a", {
        href: prefix + "/activity-dashboard/",
        children: "Activity Dashboard"
      })
    })]
  });
};

const selectIntroStepElement = (name) => {
  return document.querySelectorAll(`[data-intro='${name}']`)[0];
};
const filterIntroSteps = (steps) => {
  return steps.filter((s) => s.element || s.title);
};
const stepDescription = (id) => {
  return {
    id
  };
};
const preprocessSteps = (steps) => {
  return filterIntroSteps(steps.map((s) => {
    return {
      ...s,
      element: selectIntroStepElement(s.description.id)
    };
  }));
};

const PostLink = ({
  postId,
  children
}) => {
  const scrollToPost = useScrollToPostFn();
  const onClick = (event) => {
    scrollToPost(postId);
    event.stopPropagation();
    event.preventDefault();
  };
  return /* @__PURE__ */ jsx(Link$1, {
    underline: "always",
    className: "cursor-pointer",
    onClick,
    children
  });
};

const DetailsListItem = styled(ListItem)`
    &.MuiListItem-root {
        padding-left: ${({
  theme
}) => theme.spacing(4)}px;
    }
`;

const OpenVoteDetailsItem = ({
  postId
}) => {
  const openVote = () => {
    dispatchPostEvent(OPEN_VOTE_EVENT, {
      postId
    });
  };
  return /* @__PURE__ */ jsxs(DetailsListItem, {
    button: true,
    onClick: openVote,
    children: [/* @__PURE__ */ jsx(ListItemIcon, {
      children: /* @__PURE__ */ jsx(RiScales3Fill, {})
    }), /* @__PURE__ */ jsx(ListItemText, {
      primary: "Vote"
    })]
  });
};

const ListItemDetails = ({
  open,
  setOpen
}) => {
  return /* @__PURE__ */ jsx(IconButton$5, {
    onClick: () => setOpen((v) => !v),
    children: open ? /* @__PURE__ */ jsx(ExpandLess, {}) : /* @__PURE__ */ jsx(ExpandMore$1, {})
  });
};

const OpenAddNoteDetailsItem = ({
  postId
}) => {
  const openAddNote = () => {
    dispatchPostEvent(OPEN_ADD_NOTE_EVENT, {
      postId
    });
  };
  return /* @__PURE__ */ jsxs(DetailsListItem, {
    button: true,
    onClick: openAddNote,
    children: [/* @__PURE__ */ jsx(ListItemIcon, {
      children: /* @__PURE__ */ jsx(AiFillPushpin, {})
    }), /* @__PURE__ */ jsx(ListItemText, {
      primary: "Add note"
    })]
  });
};

const NoteTypeIcon = ({
  type
}) => {
  switch (type) {
    case "question":
      return /* @__PURE__ */ jsx(BsQuestion, {});
    case "important":
      return /* @__PURE__ */ jsx(BsExclamation, {});
    case "link":
      return /* @__PURE__ */ jsx(IoMdLink, {});
    case "error":
      return /* @__PURE__ */ jsx(BiError, {});
    case "idea":
      return /* @__PURE__ */ jsx(HiOutlineLightBulb, {});
  }
  return null;
};
const Grid = styled(Grid$1)`
    & .MuiList-root {
        border: none;
        font-size: 1.5rem;
        margin: 5px;
    }
`;
const noteTypes = ["question", "important", "link", "error", "idea"];
const NoteTypeSelector = ({
  onChange
}) => {
  const [noteType, setNoteType] = React__default.useState();
  const onChangeNoteType = (event, newType) => {
    setNoteType(newType);
    onChange(event, newType);
  };
  return /* @__PURE__ */ jsx(Grid, {
    container: true,
    alignItems: "center",
    children: /* @__PURE__ */ jsx(IconContext.Provider, {
      value: {
        size: "24px"
      },
      children: /* @__PURE__ */ jsx(ToggleButtonGroup, {
        value: noteType,
        exclusive: true,
        onChange: onChangeNoteType,
        children: noteTypes.map((type) => {
          return /* @__PURE__ */ jsx(ToggleButton$1, {
            value: type,
            children: /* @__PURE__ */ jsx(NoteTypeIcon, {
              type
            })
          }, type);
        })
      })
    })
  });
};

const noteItemWidth = 200;
const ItemTextWrapper = styled.span`
    max-width: ${noteItemWidth}px;
    display: block;
    overflow: hidden;
    overflow-wrap: break-word;
    max-height: 60px;
    word-break: break-all;
`;
const LineWrapper = styled.span`
    max-width: ${noteItemWidth}px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;
const Secondary = ({
  note
}) => {
  const {
    text,
    post: postId
  } = note;
  return /* @__PURE__ */ jsx(PostLink, {
    postId,
    children: /* @__PURE__ */ jsx(ItemTextWrapper, {
      children: text
    })
  });
};
const NotesListItem = ({
  note
}) => {
  const {
    type,
    post: postId
  } = note;
  const name = getPersonName(note.user);
  const [open, setOpen] = React__default.useState(false);
  const primary = /* @__PURE__ */ jsx(LineWrapper, {
    children: name
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(ListItem, {
      children: [/* @__PURE__ */ jsx(ListItemAvatar, {
        children: /* @__PURE__ */ jsx(NoteTypeIcon, {
          type
        })
      }), /* @__PURE__ */ jsx(ListItemText, {
        primary,
        secondary: /* @__PURE__ */ jsx(Secondary, {
          note
        })
      }), /* @__PURE__ */ jsx(ListItemDetails, {
        open,
        setOpen
      })]
    }, `${note._id}`), /* @__PURE__ */ jsx(Collapse, {
      in: open,
      timeout: "auto",
      unmountOnExit: true,
      children: /* @__PURE__ */ jsxs(List, {
        component: "div",
        disablePadding: true,
        children: [/* @__PURE__ */ jsx(OpenVoteDetailsItem, {
          postId
        }), /* @__PURE__ */ jsx(OpenAddNoteDetailsItem, {
          postId
        })]
      })
    })]
  });
};
const PageNotesList = () => {
  const responses = useResponsesDataContext();
  if (!responses) {
    return null;
  }
  const {
    lastNotes: notes = []
  } = responses;
  return /* @__PURE__ */ jsx(PostPageList, {
    children: notes.map((note) => /* @__PURE__ */ jsx(NotesListItem, {
      note
    }, note._id))
  });
};

const useNotes = () => {
  const {
    post: loaded
  } = usePostContext();
  const api = useApi();
  const postId = loaded && loaded._id;
  const {
    data,
    mutate
  } = useSWR(postId && `/notes/${postId}`, (path) => api.makeRequest({
    path
  }), swrLoadOnce);
  usePostEmitterSubscription(NOTE_ADDED_EVENT, (e) => {
    if (postId === e.postId) {
      mutate(e);
    }
  }, [postId]);
  usePostEmitterSubscription(POST_UPDATE_EVENT, (e) => {
    mutate();
  }, [postId]);
  const notes = data && data.notes || [];
  return notes;
};
const useAddNote = ({
  type,
  text,
  setInput
}) => {
  const {
    usePostLoaded,
    useRefreshResponses
  } = useAppComponents();
  if (!usePostLoaded || !useRefreshResponses) {
    return null;
  }
  const api = useApi();
  const rootPost = usePostLoaded();
  const refreshResponses = useRefreshResponses(rootPost && rootPost._id);
  const {
    post: loaded
  } = usePostContext();
  const postId = loaded && loaded._id;
  return useLoading(async (event) => {
    event.stopPropagation();
    event.preventDefault();
    const body = {
      text: text.current,
      type: type.current
    };
    const {
      notes,
      notesInfo
    } = await api.makeRequest({
      path: `/notes/${postId}`,
      method: "POST",
      body
    });
    dispatchPostEvent(NOTE_ADDED_EVENT, {
      postId,
      notes,
      notesInfo
    });
    setInput("");
    await refreshResponses();
    await delay$1();
  });
};

const LastNotesAccordion = ({}) => {
  return /* @__PURE__ */ jsxs(Accordion, {
    TransitionProps: {
      unmountOnExit: true
    },
    children: [/* @__PURE__ */ jsxs(NsAccordionSummary, {
      expandIcon: /* @__PURE__ */ jsx(ExpandMore$1, {}),
      "aria-controls": "recent-notes-content",
      id: "panel1c-header",
      children: [/* @__PURE__ */ jsx(AiFillPushpin, {}), /* @__PURE__ */ jsx(Typography, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: `accordion.recent_notes`
        })
      })]
    }), /* @__PURE__ */ jsx(AccordionDetails, {
      children: /* @__PURE__ */ jsx(PageNotesList, {})
    })]
  });
};

const useRating = () => {
  const {
    rating
  } = usePostContext();
  return formatRatingValue(rating);
};
const formatRatingValue = (rating) => {
  if (!rating) {
    return null;
  }
  const value = rating.value;
  const content = !value.down && !value.up ? "0" : `+${value.up}/-${value.down}`;
  return content;
};

const VoteDialogIcon = () => {
  return /* @__PURE__ */ jsx(DialogIcon, {
    children: /* @__PURE__ */ jsx(RiScales3Fill, {
      size: 24
    })
  });
};
const Badge = styled(Badge$2)`
    & .MuiBadge-badge {
        transform: scale(1) translate(100%, 0);
    }
`;
const VoteDialogTitle = () => {
  const content = useRating();
  if (!content) {
    return /* @__PURE__ */ jsx("div", {
      children: "configure voting first"
    });
  }
  return /* @__PURE__ */ jsx(Badge, {
    badgeContent: content,
    color: "primary",
    children: "Vote"
  });
};

const UserVotesList = () => {
  const {
    rating,
    post
  } = usePostContext();
  const api = useApi();
  const ratingId = rating && rating._id;
  const postId = post._id;
  const {
    data,
    mutate
  } = useSWR(ratingId && `/rating/${ratingId}/votes`, (path) => api.makeRequest({
    path
  }), swrLoadOnce);
  usePostEmitterSubscription("post-vote", (e) => {
    if (postId === e.postId) {
      mutate(e);
    }
  }, [postId]);
  usePostEmitterSubscription(POST_UPDATE_EVENT, (e) => {
    mutate();
  }, [postId]);
  const votes = data && data.votes || [];
  return /* @__PURE__ */ jsx(List, {
    children: votes.map((vote) => {
      const name = getPersonName(vote.user);
      const up = vote.up;
      const primary = name;
      const secondary = vote.text ? vote.text : void 0;
      const Icon = up ? FiThumbsUp : FiThumbsDown;
      return /* @__PURE__ */ jsxs(ListItem, {
        children: [/* @__PURE__ */ jsx(ListItemAvatar, {
          children: /* @__PURE__ */ jsx(Icon, {})
        }), /* @__PURE__ */ jsx(ListItemText, {
          primary,
          secondary
        })]
      }, `${vote._id}`);
    })
  });
};

const Dialog$1 = styled(Dialog$6)`
  && .MuiIconButton-root, && .MuiToggleButton-root {
    padding: 4px;
  }
  & .MuiDialogContent-root {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  & .MuiList-root {
    overflow-y: auto;
  }
`;
const UDPollInput = () => {
  const api = useApi();
  const [text, setText] = useState("");
  const {
    loadResponses
  } = usePostInfoContext();
  const {
    post: loaded,
    rating,
    userVote
  } = usePostContext();
  const ratingId = rating && rating._id;
  const {
    onClick: vote,
    loading
  } = useLoading(async (up) => {
    loaded._id;
    const body = {
      text,
      up
    };
    await api.makeRequest({
      path: `/rating/${ratingId}/vote`,
      method: "POST",
      body
    });
    await loadResponses();
    setText("");
  });
  const handleChange = (e) => {
    setText(e.target.value);
  };
  const disabled = !rating || loading || !!userVote;
  return /* @__PURE__ */ jsx(OutlinedInput, {
    autoFocus: true,
    value: userVote ? "Thank you for your vote" : text,
    onChange: handleChange,
    disabled,
    startAdornment: /* @__PURE__ */ jsxs(InputAdornment, {
      position: "start",
      children: [/* @__PURE__ */ jsx(IconButton$5, {
        onClick: () => vote(1),
        disabled,
        color: "primary",
        children: /* @__PURE__ */ jsx(FiThumbsUp, {})
      }), /* @__PURE__ */ jsx(IconButton$5, {
        onClick: () => vote(0),
        disabled,
        children: /* @__PURE__ */ jsx(FiThumbsDown, {})
      })]
    }),
    endAdornment: void 0
  });
};
const YourRating = () => {
  const {
    userVote
  } = usePostContext();
  const vote = userVote;
  if (!vote) {
    return null;
  }
  const content = vote.up ? "+1" : "-1";
  return /* @__PURE__ */ jsx(Badge$2, {
    badgeContent: content,
    color: "primary",
    children: "Your vote"
  });
};
const LastVotePanel = () => {
  const {
    rating
  } = usePostContext();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      children: rating && rating.description
    }), /* @__PURE__ */ jsx(YourRating, {}), /* @__PURE__ */ jsx(UserVotesList, {}), /* @__PURE__ */ jsx(UDPollInput, {})]
  });
};
const UsersVoteDialog = ({
  open,
  setClosed
}) => {
  const {
    profile
  } = usePostInfoContext();
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog$1, {
    onClose: () => setClosed(true),
    "aria-labelledby": "customized-dialog-title",
    open,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      icon: /* @__PURE__ */ jsx(VoteIcon, {
        ...commonIconProps
      }),
      "data-testid": "UsersVoteDialog",
      onClose: () => setClosed(true),
      children: /* @__PURE__ */ jsx(VoteDialogTitle, {})
    }), /* @__PURE__ */ jsxs(DialogContent, {
      dividers: true,
      children: [profile && /* @__PURE__ */ jsx(LastVotePanel, {}), !profile && /* @__PURE__ */ jsx(RequiresRegistration, {})]
    })]
  });
};

const useVotes = () => {
  const {
    post: loaded
  } = usePostContext();
  const api = useApi();
  const postId = loaded && loaded._id;
  const {
    data,
    mutate
  } = useSWR(postId && `/ratings-configurable/posts/${postId}`, (path) => api.makeRequest({
    path
  }), swrLoadOnce);
  usePostEmitterSubscription(RATING_CREATED_EVENT, (e) => {
    if (postId === e.postId) {
      mutate();
    }
  }, [postId]);
  usePostEmitterSubscription(POST_UPDATE_EVENT, (e) => {
    mutate();
  }, [postId]);
  const ratings = data && data.ratings || [];
  return ratings;
};
const VoteRoundsList = React__default.memo(() => {
  const ratings = useVotes();
  const total = ratings.length;
  if (!total) {
    return null;
  }
  const reversed = ratings.slice().reverse();
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(List, {
      subheader: /* @__PURE__ */ jsx(ListSubheader, {
        disableSticky: true,
        component: "div",
        id: "voting-list-subheader",
        children: "Voting rounds so far"
      }),
      children: reversed.map((rating, i) => {
        const name = getPersonName(rating.creator);
        const description = rating.description ? " " + rating.description : "";
        const ratingFormatted = formatRatingValue(rating);
        const active = i === total - 1 ? "(Active) " : "";
        const primary = `${i + 1}. ${active} (${ratingFormatted})` + description;
        const secondary = name;
        return /* @__PURE__ */ jsx(ListItem, {
          children: /* @__PURE__ */ jsx(ListItemText, {
            primary,
            secondary
          })
        }, `${rating._id}`);
      })
    })
  });
});

const VoteAdmin = () => {
  const api = useApi();
  const {
    post: rootPost,
    loadResponses
  } = usePostInfoContext();
  const [description, setDescription] = useState("");
  const onNoteTextChange = (e) => {
    const value = e.target.value;
    setDescription(value);
  };
  const {
    post: loaded
  } = usePostContext();
  const postId = loaded._id;
  const {
    onClick: onAdd,
    loading
  } = useLoading(async (event) => {
    event.stopPropagation();
    event.preventDefault();
    const {
      rating
    } = await api.makeRequest({
      path: `/posts/${postId}/ratings-configurable`,
      method: "POST",
      body: {
        description
      }
    });
    dispatchPostEvent("post-rating", {
      postId,
      rating
    });
    setDescription("");
    await loadResponses();
    await delay$1();
  });
  return /* @__PURE__ */ jsxs(DialogContent, {
    onKeyPress: (ev) => {
      if (ev.key === "Enter") {
        onAdd(ev);
      }
    },
    dividers: true,
    children: [/* @__PURE__ */ jsx(VoteRoundsList, {}), /* @__PURE__ */ jsx(OutlinedInput, {
      autoFocus: true,
      placeholder: "Short description",
      value: description,
      onChange: onNoteTextChange,
      disabled: loading || !loaded
    }), /* @__PURE__ */ jsx(LoadingButton, {
      startIcon: /* @__PURE__ */ jsx(BsPlay, {}),
      fullWidth: true,
      disabled: !loaded,
      onClick: onAdd,
      loading,
      children: "Start new round"
    })]
  });
};
const Dialog = styled(Dialog$6)`
  & .MuiDialogContent-root {
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  & .MuiList-root {
    overflow-y: auto;
  }  
`;
const ConfigVoteDialog = ({
  open,
  handleClose
}) => {
  if (!open) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Dialog, {
    onClose: () => handleClose(true),
    "aria-labelledby": "customized-dialog-title",
    open,
    BackdropProps: {
      style: {
        backgroundColor: "transparent"
      }
    },
    children: [/* @__PURE__ */ jsx(DialogTitle, {
      icon: /* @__PURE__ */ jsx(DialogIcon, {
        children: /* @__PURE__ */ jsx(RiScales3Fill, {
          size: 24
        })
      }),
      "data-testid": "voting-config-dialog",
      onClose: () => handleClose(true),
      children: "Testing for Consent"
    }), /* @__PURE__ */ jsx(VoteAdmin, {})]
  });
};

const VoteListItem = ({
  poll
}) => {
  const {
    creator,
    post
  } = poll;
  const [open, setOpen] = React__default.useState(false);
  const name = getPersonName(creator);
  const title = post.title;
  const text = title.slice(0, 100);
  const primary = /* @__PURE__ */ jsx(LineWrapper, {
    children: name
  });
  const postId = post._id;
  const link = /* @__PURE__ */ jsx(PostLink, {
    postId,
    children: /* @__PURE__ */ jsx(LineWrapper, {
      children: text
    })
  });
  const secondary = poll.description ? /* @__PURE__ */ jsxs(Fragment, {
    children: [link, /* @__PURE__ */ jsx(ItemTextWrapper, {
      children: poll.description
    })]
  }) : link;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(ListItem, {
      children: [/* @__PURE__ */ jsx(ListItemText, {
        primary,
        secondary
      }), /* @__PURE__ */ jsx(ListItemDetails, {
        open,
        setOpen
      })]
    }, `${poll._id}`), /* @__PURE__ */ jsx(Collapse, {
      in: open,
      timeout: "auto",
      unmountOnExit: true,
      children: /* @__PURE__ */ jsxs(List, {
        component: "div",
        disablePadding: true,
        children: [/* @__PURE__ */ jsx(OpenVoteDetailsItem, {
          postId
        }), /* @__PURE__ */ jsx(OpenAddNoteDetailsItem, {
          postId
        })]
      })
    })]
  });
};
const PageVotedList = () => {
  const responses = useResponsesDataContext();
  if (!responses) {
    return null;
  }
  const {
    lastRatings: voted = []
  } = responses || {};
  return /* @__PURE__ */ jsx(PostPageList, {
    children: voted.map((poll) => /* @__PURE__ */ jsx(VoteListItem, {
      poll
    }, poll._id))
  });
};

const LastVotedAccordion = ({}) => {
  return /* @__PURE__ */ jsxs(Accordion, {
    TransitionProps: {
      unmountOnExit: true
    },
    children: [/* @__PURE__ */ jsxs(NsAccordionSummary, {
      expandIcon: /* @__PURE__ */ jsx(ExpandMore$1, {}),
      "aria-controls": "user-recordings-settings-content",
      id: "panel1c-header",
      children: [/* @__PURE__ */ jsx(RiScales3Fill, {}), /* @__PURE__ */ jsx(Typography, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: `accordion.recent_votes`
        })
      })]
    }), /* @__PURE__ */ jsx(AccordionDetails, {
      children: /* @__PURE__ */ jsx(PageVotedList, {})
    })]
  });
};

const LockIcon = (props) => /* @__PURE__ */ jsx("svg", {
  viewBox: "0 0 40 40",
  ...props,
  children: /* @__PURE__ */ jsx("g", {
    children: /* @__PURE__ */ jsx("path", {
      d: "m29.4 14.5c1.7 0 3.1 1.4 3.1 3.2v15.6c0 1.7-1.4 3.1-3.1 3.1h-18.8c-1.7 0-3.1-1.4-3.1-3.1v-15.6c0-1.8 1.4-3.2 3.1-3.2h1.6v-3.1c0-4.3 3.5-7.8 7.8-7.8s7.8 3.5 7.8 7.8v3.1h1.6z m-9.4 14.3c1.7 0 3.1-1.5 3.1-3.2s-1.4-3.1-3.1-3.1-3.1 1.4-3.1 3.1 1.4 3.2 3.1 3.2z m4.8-14.3v-3.1c0-2.7-2.1-4.8-4.8-4.8s-4.8 2.2-4.8 4.8v3.1h9.6z"
    })
  })
});

const prefix = "/trans/groups";
const TransientGroupApprove = ({
  circleId
}) => {
  return /* @__PURE__ */ jsx(CircleApprovalPanel, {
    circleId
  });
};
const TransientGroups = () => {
  const match = useRouteMatch(prefix + "/:id/:slug");
  if (!match) {
    return /* @__PURE__ */ jsx(TransNotFound, {});
  }
  const id = match.params.id;
  const slug = match.params.slug;
  if (slug === "approve") {
    return /* @__PURE__ */ jsx(TransientGroupApprove, {
      circleId: id
    });
  }
  return /* @__PURE__ */ jsx(TransNotFound, {});
};

const eventTypes = ["Music", "Culture", "Training", "Meeting", "Sport", "Information"];
const eventTypeName = {
  "Announce Event": "Information"
};
const eventPriorities = ["normal", "promote"];
const timeInfoForEvent = (timeState) => {
  const {
    date1,
    time1,
    timezone,
    date2,
    time2
  } = timeState;
  const startTime = new Date(date1.getTime() + findClosestTime(time1));
  const endTime = new Date(date2.getTime() + findClosestTime(time2));
  const selectedTime = localDateTime(startTime);
  const duration = endTime.getTime() - startTime.getTime();
  return {
    selectedTime,
    duration,
    timezone
  };
};
const AssociateAssetPanel$1 = ({
  postId
}) => {
  const [assetId, setAssetId] = useState("none");
  const [eventType, setEventType] = useState(eventTypes[0]);
  const [priority, setPriority] = useState(eventPriorities[0]);
  const timeState = useTimePanelState();
  const {
    membership
  } = usePostInfoContext();
  const {
    data: post
  } = usePost(postId);
  const circleId = post && post.group.group._id;
  const api = useApi();
  const history = useHistory();
  const onSuccess = () => {
    if (!isLocalPlayground()) {
      window.close();
    }
  };
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    if (assetId === "none") {
      onDelete();
      return;
    }
    const {
      selectedTime,
      duration,
      timezone
    } = timeInfoForEvent(post.type === "article" ? timeState : new EventTemporalData(post.event));
    if (duration <= 0) {
      errorToast({
        error: "End day should be after start day!"
      });
      return;
    }
    await api.post({
      path: `/posts/${postId}/asset`,
      body: {
        post: postId,
        asset: assetId,
        eventType,
        priority,
        selectedTime,
        duration,
        timezone
      }
    });
    toast("Saved!");
    onSuccess();
  });
  const {
    onClick: onDelete,
    loading: deleteLoading
  } = useLoading(async () => {
    await api.delete({
      path: `/asset/posts/${postId}`
    });
    setAssetId("none");
    onSuccess();
  });
  const onCancel = () => {
    onSuccess();
  };
  const {
    onClick: onOpenAsset,
    loading: openingAsset
  } = useLoading(async () => {
    const post2 = await api.loadPostById({
      _id: assetId
    });
    history.push(url4post(post2));
  });
  const {
    data
  } = useAssets(circleId);
  const {
    data: postAsset
  } = usePostAssets(postId);
  useEffect(() => {
    if (!postAsset) {
      return;
    }
    const {
      connection
    } = postAsset;
    if (!connection) {
      return;
    }
    const {
      asset,
      eventType: eventType2,
      priority: priority2
    } = connection;
    setAssetId(asset._id);
    setEventType(eventType2 || eventTypes[0]);
    setPriority(priority2 || eventPriorities[0]);
    const timeData = new EventTemporalData(connection);
    const {
      time1,
      date1,
      date2,
      time2,
      tzOffset,
      timezone
    } = timeData;
    const {
      setDate1,
      setDate2,
      setTzOffset,
      setTime1,
      setTime2,
      setTimezone
    } = timeState;
    setDate1(date1);
    setTimezone(timezone || getUserTimezone());
    setTzOffset(tzOffset);
    setDate2(date2);
    setTime1(time1);
    setTime2(time2);
  }, [postAsset]);
  const handleChangeTypeChange = async (e) => {
    const value = e.target.value;
    setEventType(value);
  };
  const handleChangePriority = async (e) => {
    const value = e.target.value;
    setPriority(value);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "ns w-full p-2 flex flex-col gap-1",
    children: [/* @__PURE__ */ jsx(EventTitle, {}), /* @__PURE__ */ jsxs(FormControl$1, {
      className: "w-full",
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "asset-category-label",
        children: "Event Type"
      }), /* @__PURE__ */ jsx(Select$1, {
        labelId: "asset-category-label",
        value: eventType,
        variant: "outlined",
        onChange: handleChangeTypeChange,
        children: eventTypes.map((type) => {
          return /* @__PURE__ */ jsx(MenuItem, {
            value: eventTypeName[type] || type,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "event.types." + (eventTypeName[type] || type)
            })
          }, type);
        })
      })]
    }), /* @__PURE__ */ jsx(AssetSelector, {
      assetId,
      setAssetId,
      assets: data && data.assets
    }), post && post.type === "article" && /* @__PURE__ */ jsx(TimePanel, {
      state: timeState
    }), /* @__PURE__ */ jsxs(FormControl$1, {
      className: "w-full",
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "asset-category-label",
        children: "Event Priority"
      }), /* @__PURE__ */ jsx(Select$1, {
        labelId: "asset-category-label",
        value: priority,
        variant: "outlined",
        disabled: !isAdmin(membership),
        onChange: handleChangePriority,
        children: eventPriorities.map((type) => {
          return /* @__PURE__ */ jsx(MenuItem, {
            value: type,
            children: type
          });
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-1",
      children: [/* @__PURE__ */ jsx(LoadingButton, {
        onClick: onCancel,
        children: "Cancel"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onSave,
        loading: saveLoading,
        children: "Save"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onDelete,
        loading: deleteLoading,
        children: "Delete"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onOpenAsset,
        loading: openingAsset,
        hidden: !assetId || assetId === "none",
        children: "Open Asset"
      })]
    })]
  });
};
const EventTitle = () => {
  const {
    post
  } = usePostInfoContext();
  return /* @__PURE__ */ jsx(Link$2, {
    to: url4post(post),
    children: /* @__PURE__ */ jsx("h1", {
      className: "text-base font-semibold",
      children: post && post.title || ""
    })
  });
};

const AssetSelector = ({
  assetId,
  assets,
  setAssetId
}) => {
  const handleChange = async (e) => {
    const value = e.target.value;
    setAssetId(value);
  };
  return /* @__PURE__ */ jsxs(FormControl$1, {
    className: "w-full",
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: "asset-category-label",
      children: "Select asset"
    }), /* @__PURE__ */ jsxs(Select$1, {
      labelId: "asset-category-label",
      value: assetId,
      variant: "outlined",
      onChange: handleChange,
      children: [/* @__PURE__ */ jsx(MenuItem, {
        value: "none",
        children: "none"
      }), (assets || []).map((asset) => {
        return /* @__PURE__ */ jsx(MenuItem, {
          value: asset._id,
          children: asset.title
        });
      })]
    })]
  });
};
const StartNewEventPage = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const postId = path[1] === "post-connect-asset" && path[2];
  return /* @__PURE__ */ jsxs(LoadPostViewData, {
    postId,
    dialog: true,
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(AssociateAssetPanel$1, {
      postId
    })]
  });
};

const AssociateAssetPanel = ({
  postId
}) => {
  const {
    profile
  } = useProfileContext();
  const [dashboard, setDashboard] = useState(profile && profile.dashboard);
  const {
    data
  } = useJoinedCircles();
  useEffect(() => {
    if (!profile) {
      return;
    }
    setDashboard(profile.dashboard);
  }, [profile]);
  console.log("111111111111111111", data);
  const api = useApi();
  const onSuccess = () => {
    if (!isLocalPlayground()) {
      window.close();
    }
  };
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    await api.post({
      path: "/users/update",
      body: {
        dashboard
      }
    });
    toast("Saved!");
    onSuccess();
  });
  const handleChangeDashboard = async (e) => {
    const value = e.target.value;
    setDashboard(value);
  };
  const circles = data ? data.values : [];
  return /* @__PURE__ */ jsxs("div", {
    className: "ns w-full p-2 flex flex-col gap-1",
    children: [/* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsxs("span", {
        children: ["Current dashboard: ", profile && profile.dashboard || "<not set>"]
      })
    }), /* @__PURE__ */ jsxs(FormControl$1, {
      className: "w-full",
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "asset-category-label",
        children: "Dashboard"
      }), /* @__PURE__ */ jsxs(Select$1, {
        labelId: "asset-category-label",
        value: dashboard || "/",
        variant: "outlined",
        onChange: handleChangeDashboard,
        children: [/* @__PURE__ */ jsx(MenuItem, {
          value: "/",
          children: 'System ("/")'
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "/groups",
          children: 'My Circles ("/groups")'
        }), circles.map((membership) => {
          const {
            group: {
              _id,
              name
            }
          } = membership;
          return /* @__PURE__ */ jsx(MenuItem, {
            value: "/groups/" + _id,
            children: name
          }, _id);
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex gap-1",
      children: /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onSave,
        loading: saveLoading,
        children: "Save"
      })
    })]
  });
};
const ConfigureDashboard = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const postId = path[1] === "post-connect-asset" && path[2];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(AssociateAssetPanel, {
      postId
    })]
  });
};

const noop$2 = () => null;
const EditPostContext = React__default.createContext({
  timeState: void 0,
  draft: void 0,
  update: noop$2,
  publish: noop$2,
  updateEvent: noop$2,
  group: null,
  membership: null,
  invitation: null
});
const useEditPostContext = () => {
  return React__default.useContext(EditPostContext);
};

const ListItemSecondaryAction = styled(ListItemSecondaryAction$1)`
  && > .MuiCheckbox-root {
    padding-left: 25px;
    padding-right: 25px;
  }
`;
const UserItem = ({
  user,
  checked,
  onSelected
}) => {
  const onChange = () => {
    onSelected(user, !checked);
  };
  return /* @__PURE__ */ jsxs(ListItem, {
    button: true,
    children: [/* @__PURE__ */ jsx(Badge$1, {
      user,
      inSeparateWindow: true
    }), /* @__PURE__ */ jsx(ListItemSecondaryAction, {
      children: /* @__PURE__ */ jsx(Checkbox$1, {
        edge: "end",
        onChange,
        checked
      })
    })]
  });
};
const createParticipant = (user, role) => {
  return {
    _id: user._id,
    username: user.username,
    avatar: user.avatar,
    firstname: user.firstname,
    lastname: user.lastname,
    role
  };
};
const ParticipantsList = ({
  participants,
  role,
  onSelected
}) => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsx(List, {
      className: "",
      subheader: /* @__PURE__ */ jsx(ListSubheader, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "compose.event.roles." + role
        })
      }),
      children: Object.values(participants).filter((p) => p.role === role).map((user) => {
        return /* @__PURE__ */ jsx(UserItem, {
          user,
          checked: true,
          onSelected
        }, user._id);
      })
    })
  });
};
const ParticipantsByRoleList = ({
  participants,
  onSelected
}) => {
  const roles = Object.keys(Object.values(participants).reduce((roles2, p) => {
    roles2[p.role] = true;
    return roles2;
  }, {}));
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "",
      children: [" ", roles.map((role) => /* @__PURE__ */ jsx(ParticipantsList, {
        role,
        participants,
        onSelected
      }, role)), " "]
    })
  });
};
const filterUsers = (found, filter) => {
  if (!found) {
    return [];
  }
  if (!filter) {
    return found.slice(0, 5);
  }
  const lowerCaseFilter = filter.toLocaleLowerCase();
  return found.filter((u) => {
    const username = u.username.toLocaleLowerCase();
    const email = u.email.toLocaleLowerCase();
    const firstName = typeof u.firstname === "string" ? u.firstname.toLocaleLowerCase() : void 0;
    const lastName = typeof u.lastname === "string" ? u.lastname.toLocaleLowerCase() : void 0;
    return username.indexOf(lowerCaseFilter) !== -1 || email.indexOf(lowerCaseFilter) !== -1 || firstName && firstName.indexOf(lowerCaseFilter) !== -1 || lastName && lastName.indexOf(lowerCaseFilter) !== -1;
  });
};
const Suggestions = ({
  participants,
  onSelected,
  found,
  filter
}) => {
  const user2Item = (type) => (user) => {
    const participant = participants[user._id];
    return /* @__PURE__ */ jsx(UserItem, {
      user,
      checked: !!participant,
      onSelected
    }, user._id);
  };
  const filtered = filterUsers(found, filter);
  return /* @__PURE__ */ jsxs(List, {
    dense: true,
    subheader: /* @__PURE__ */ jsx(ListSubheader, {
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "compose.event.suggested"
      })
    }),
    children: [!found && /* @__PURE__ */ jsx(MuiSpinner, {}), found && !found.length && "Not found", found && !!found.length && !filtered.length && "Not found", filtered.map(user2Item())]
  });
};
styled(Hidden)`
    margin-left: ${({
  theme
}) => theme.spacing(2)}px;
    color: #4D4D4D;
`;
styled(Hidden)`
    margin: ${({
  theme
}) => theme.spacing(2)}px 0;
    color: #4D4D4D;
`;
const OneLine = styled.div`
    display: flex;
    align-items: center;
`;
const roleNames = ["host", "expert", "moderator", "speaker", "guest_expert", "panelist", "participant", "trainer"];
const AddKeyParticipants = () => {
  const {
    draft,
    update
  } = useEditPostContext();
  const groupId = draft && draft.group.group._id;
  const api = useApi();
  const [role, setRole] = useState("host");
  const [filter, setFilter] = useState();
  const draftParticipants = useRef();
  const [participants, setParticipants] = useState(() => ({}));
  if (draft.participants !== draftParticipants.current) {
    draftParticipants.current = draft.participants;
    setParticipants(draft.participants.reduce((participants2, it) => {
      participants2[it._id] = it;
      return participants2;
    }, {}));
  }
  const participantsRef = useRef();
  const executingRef = useRef();
  participantsRef.current = participants;
  const saveDraft = useCallback(async ({
    user,
    selected,
    onlyParticipants
  }) => {
    if (executingRef.current) {
      return;
    }
    executingRef.current = true;
    const prev = participantsRef.current;
    const participants2 = {
      ...prev
    };
    if (user) {
      if (selected) {
        participants2[user._id] = createParticipant(user, role);
      } else {
        delete participants2[user._id];
      }
    }
    setParticipants(participants2);
    try {
      await update({
        ...draft,
        onlyParticipants,
        participants: Object.values(participants2)
      });
    } catch (error) {
      errorToast({
        error
      });
      setParticipants(prev);
    } finally {
      executingRef.current = false;
    }
  }, [api, draft, role]);
  const onUserSelected = useCallback(async (user, selected) => {
    return saveDraft({
      user,
      selected
    });
  }, [saveDraft]);
  const filterChange = (event) => {
    setFilter(event.target.value);
  };
  const roleChange = (event) => {
    setRole(event.target.value);
  };
  const {
    data
  } = useSWR(`groups/${groupId}/members`, () => api.loadMembers({
    group: groupId
  }), swrLoadOnce);
  const found = data && data.values && data.values.map((m) => m.user);
  const onOnlyParticipants = (event) => {
    saveDraft({
      onlyParticipants: !event.target.checked
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col w-full",
    children: [/* @__PURE__ */ jsx(TextField$1, {
      variant: "standard",
      value: filter || "",
      onChange: filterChange,
      label: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "compose.event.by_name_and_email"
      })
    }), /* @__PURE__ */ jsxs(OneLine, {
      children: [/* @__PURE__ */ jsx(Checkbox$1, {
        edge: "end",
        onChange: onOnlyParticipants,
        checked: !draft.onlyParticipants
      }), /* @__PURE__ */ jsx("div", {
        style: {
          marginLeft: 16
        },
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: `event.all_party`
        })
      })]
    }), /* @__PURE__ */ jsx(OneLine, {
      children: /* @__PURE__ */ jsxs(FormControl, {
        children: [/* @__PURE__ */ jsx(InputLabel, {
          id: "role-select-label",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "compose.event.role"
          })
        }), /* @__PURE__ */ jsx(Select$1, {
          labelId: "role-select-label",
          id: "role-select",
          value: role,
          label: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "compose.event.role"
          }),
          onChange: roleChange,
          children: roleNames.map((name) => /* @__PURE__ */ jsx(MenuItem, {
            value: name,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "compose.event.roles." + name
            })
          }, name))
        })]
      })
    }), /* @__PURE__ */ jsxs(PersonNameContext.Provider, {
      value: {
        addUserName: true
      },
      children: [/* @__PURE__ */ jsx(Suggestions, {
        found,
        participants,
        onSelected: onUserSelected,
        filter
      }), /* @__PURE__ */ jsx(ParticipantsByRoleList, {
        participants,
        onSelected: onUserSelected
      })]
    })]
  });
};

const SelectAssetDialog = ({
  onClose,
  onSponsorChange
}) => {
  const {
    draft: edited
  } = useEditPostContext();
  const windowRef = useRef();
  const draftRef = useRef();
  const api = useApi();
  const createPost = useCreatePostFn2();
  useInterval(async () => {
    if (!windowRef.current || !windowRef.current.closed) {
      return;
    }
    const post = await api.loadPostByDraft(draftRef.current && draftRef.current._id);
    windowRef.current = null;
    if (!post) {
      return;
    }
    onSponsorChange(post);
    onClose();
  }, 300);
  const {
    onClick: createAsset,
    loading
  } = useLoading(async () => {
    const draft = draftRef.current = await createPost("asset", postCircleId(edited));
    windowRef.current = window.open(editPostUrl2(draft) + "#?close=1", "Create Asset");
  });
  return /* @__PURE__ */ jsxs(ConfirmDialog, {
    title: "Select sponsor organization",
    open: true,
    content: /* @__PURE__ */ jsx("span", {
      children: "An Asset must be selected for this Event, would you like to create one? "
    }),
    onClose,
    children: [/* @__PURE__ */ jsx(LoadingButton, {
      onClick: () => createAsset("PRIVATE"),
      loading,
      children: "Create"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onClose,
      children: "Cancel"
    })]
  });
};

const useUpsertDraftFn = () => {
  const api = useApi();
  const create = async (update) => {
    const {
      title = "New post",
      content,
      tags,
      ...other
    } = update;
    const system = [];
    const draft = withRetry(async () => await api.upsertDraft({
      attachments: [],
      tags: [...system, ...tags],
      title,
      content,
      ...other
    }));
    return draft;
  };
  return create;
};

const EditPostContextProvider = ({
  children,
  draftId,
  ui
}) => {
  const parent = useEditPostContext();
  const [draft, setDraft] = useState();
  const {
    data
  } = useDraft(draftId);
  const timeState = useTimePanelState();
  const {
    data: circleData
  } = useCircle(postGroupId(draft));
  const api = useApi();
  const updateDraft = useUpsertDraftFn();
  const {
    run: updateThrottled
  } = useThrottleFn((updated) => {
    updateDraft(updated);
  });
  useEffect(() => {
    if (!data) {
      return;
    }
    const timeData = new EventTemporalData(data.event);
    const {
      time1,
      date1,
      date2,
      time2,
      tzOffset,
      timezone
    } = timeData;
    const {
      setDate1,
      setDate2,
      setTzOffset,
      setTime1,
      setTime2,
      setTimezone
    } = timeState;
    setDate1(date1);
    setTimezone(timezone || getUserTimezone());
    setTzOffset(tzOffset);
    setDate2(date2);
    setTime1(time1);
    setTime2(time2);
  }, [data]);
  const updateRequest = (u) => {
    const result = {
      ...draft,
      ...u
    };
    if (draft.type === "event") {
      result.event = {
        ...draft.event,
        ...u.event,
        ...timeInfoForEvent(timeState)
      };
    }
    return result;
  };
  const publish = useMemoizedFn(async (u = {}) => {
    const request = updateRequest(u);
    if (request.event && request.event.duration <= 0) {
      errorToast({
        error: "End day should be after start day!"
      });
      return;
    }
    const updated = await updateDraft(request);
    const result = withRetry(async () => await api.publish(updated));
    updateDraftCache(updated);
    setDraft(request);
    return result;
  });
  const update = useMemoizedFn(async (u) => {
    const updated = updateRequest(u);
    updateThrottled(updated);
    setDraft(updated);
  });
  const updateEvent = useMemoizedFn(async (u) => {
    const updated = updateRequest({
      event: u
    });
    updateThrottled(updated);
    setDraft(updated);
  });
  useEffect(() => {
    if (!data) {
      return;
    }
    setDraft({
      ...data
    });
  }, [data]);
  const context = useMemo(() => {
    return {
      parent,
      ui: ui || parent.ui,
      draft,
      update,
      updateEvent,
      publish,
      timeState,
      ...circleData
    };
  }, [draft, circleData, timeState, ui || parent.ui, parent]);
  const circleContext = useMemo(() => {
    return {
      circle: draft && draft.group.group,
      membership: circleData && circleData.membership
    };
  }, [draft, circleData]);
  const event$ = useEventEmitter();
  return /* @__PURE__ */ jsx(PostInfoContext.Provider, {
    value: {
      post: draft,
      event$
    },
    children: /* @__PURE__ */ jsx(EditPostContext.Provider, {
      value: context,
      children: /* @__PURE__ */ jsx(CircleContext.Provider, {
        value: circleContext,
        children: draft && children
      })
    })
  });
};

const GoogleFixCss = createGlobalStyle`
    .pac-container {
        z-index: 10000 !important;
    }
`;

const TagsPicker = (props) => {
  const intl = useIntl();
  const [options, setOptions] = useState([]);
  const api = useApi();
  const [tags, setTags] = useState([]);
  const {
    update,
    draft
  } = useEditPostContext();
  const {
    tags: userTags = []
  } = draft;
  const system = [];
  const renderTags = useMemoizedFn((value, getTagProps) => {
    return value.map((option, index) => {
      const props2 = getTagProps({
        index
      });
      if (index < system.length) {
        props2.onDelete = null;
      }
      return /* @__PURE__ */ jsx(Tag, {
        label: option,
        ...props2
      }, option);
    });
  });
  const onChange = useMemoizedFn((event, newValue) => {
    console.log("newValue", newValue);
    update({
      tags: newValue.slice(system.length).map((t) => t.toLowerCase().replace(/\s+/g, " "))
    });
  });
  useDeepCompareEffect(() => {
    setTags([...system, ...userTags].map((t) => t.toLowerCase().replace(/\s+/g, " ")));
  }, [system, userTags]);
  console.log("tags:", tags);
  return /* @__PURE__ */ jsx(TagsWrapper, {
    ...props,
    children: /* @__PURE__ */ jsx(Autocomplete$1, {
      multiple: true,
      id: "tags-filled",
      options,
      value: tags,
      freeSolo: true,
      renderTags,
      renderInput: (params) => /* @__PURE__ */ jsx(TextField$1, {
        ...params,
        placeholder: intl.formatMessage({
          id: "event.addTags"
        })
      }),
      onChange,
      onInputChange: async (_event, newInputValue) => {
        const result = await api.suggestTags({
          filter: newInputValue,
          range: {
            start: 1,
            end: 10
          }
        });
        const tags2 = (result.values || []).map((v) => v.tag);
        setOptions(tags2);
      }
    })
  });
};

const EditEventPageInner = ({
  children,
  className
}) => {
  const history = useHistory();
  const api = useApi();
  const [autocomplete, setAutocomplete] = useState();
  const [nameAutocomplete, setNameAutocomplete] = useState();
  const initGoogleMaps = useInitGoogleMapsFn();
  const addressRef = useRef();
  const nameRef = useRef();
  const attrRef = useRef();
  const [expanded, setExpanded] = useState(false);
  const [sponsors, setSponsors] = useState([]);
  const [selectAsset, setSelectAsset] = useState(false);
  useEffect(() => {
    if (!autocomplete) {
      return;
    }
    setupAutocomplete(autocomplete);
  }, [autocomplete]);
  useEffect(() => {
    if (!nameAutocomplete) {
      return;
    }
    setupAutocomplete(nameAutocomplete, false);
  }, [nameAutocomplete]);
  useAsyncEffect(errorsReported(async () => {
    if (!await initGoogleMaps()) {
      return;
    }
    const autocomplete2 = new google.maps.places.Autocomplete(addressRef.current);
    setAutocomplete(autocomplete2);
    const nameAutocomplete2 = new google.maps.places.Autocomplete(nameRef.current);
    setNameAutocomplete(nameAutocomplete2);
  }), []);
  const {
    editor,
    setEditor,
    images_upload_handler
  } = useTinyEditorSetup$1();
  const {
    draft,
    publish,
    timeState,
    updateEvent,
    membership,
    group
  } = useEditPostContext();
  const {
    name,
    address,
    eventType,
    priority,
    url,
    label,
    label2,
    url2,
    sponsor
  } = draft && draft.event || {};
  const handleChangeTypeChange = async (e) => {
    const value = e.target.value;
    updateEvent({
      eventType: value
    });
  };
  const handleChangePriority = async (e) => {
    const value = e.target.value;
    updateEvent({
      priority: value
    });
  };
  const {
    onClick: onSave,
    loading
  } = useLoading(async () => {
    if (!sponsor) {
      setSelectAsset(true);
      return;
    }
    const result = await publish({
      content: getContentInfo(editor.getContent())
    });
    if (!result) {
      return;
    }
    onSaved();
  });
  const setupAutocomplete = (autocomplete2, isAddress = true) => {
    const handle = autocomplete2.addListener("place_changed", async () => {
      const place = autocomplete2.getPlace();
      console.log("place:", place);
      const json = placeDetails(place);
      if (isAddress) {
        const update = {
          address: json.address,
          location: json.location
        };
        if (!name) {
          update.name = json.fullName || json.name;
        }
        updateEvent(update);
      } else {
        updateEvent({
          address: json.address,
          location: json.location,
          name: json.fullName || json.name
        });
      }
    });
    return () => {
      if (!autocomplete2) {
        return;
      }
      google.maps.event.removeListener(handle);
    };
  };
  const handleEventUpdate = (name2) => async (e) => {
    const value = e.target.value;
    updateEvent({
      [name2]: value
    });
  };
  const onSaved = () => {
    history.replace(circleUrl(draft.group.group));
  };
  const onCancel = () => {
    onSaved();
  };
  const onSponsorChange = useMemoizedFn((event, newValue) => {
    console.log("newValue", newValue);
    const isPost = newValue && typeof newValue === "object";
    updateEvent({
      sponsor: isPost && newValue.title,
      sponsorId: isPost && newValue._id
    });
  });
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("ns sm:px-[54px] text-base w-full pb-4 min-h-screen", className),
    "data-testid": "EditEventPage",
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(GoogleFixCss, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex w-full flex-col gap-2 p-2",
      children: [/* @__PURE__ */ jsx(PostNavigation, {}), /* @__PURE__ */ jsx(PostTextBreadCrumbs, {}), /* @__PURE__ */ jsxs(FormControl$1, {
        className: "w-full",
        children: [/* @__PURE__ */ jsx(InputLabel, {
          id: "asset-category-label",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.eventType"
          })
        }), /* @__PURE__ */ jsx(Select$1, {
          labelId: "asset-category-label",
          value: eventType || "",
          variant: "outlined",
          onChange: handleChangeTypeChange,
          children: eventTypes.map((type) => {
            return /* @__PURE__ */ jsx(MenuItem, {
              value: eventTypeName[type] || type,
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "event.types." + (eventTypeName[type] || type)
              })
            }, type);
          })
        })]
      }), /* @__PURE__ */ jsxs(Frame$4, {
        title: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.describe"
        }),
        children: [/* @__PURE__ */ jsx(TinyEditor, {
          content: draft.content.nsHtml,
          setEditor,
          settings: {
            height: 230,
            auto_focus: "none",
            menubar: false,
            images_upload_handler
          }
        }), /* @__PURE__ */ jsx(TagsPicker, {})]
      }), /* @__PURE__ */ jsx(Frame$4, {
        title: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.startAndEnd"
        }),
        children: /* @__PURE__ */ jsx(TimePanel, {
          state: timeState
        })
      }), /* @__PURE__ */ jsxs(Frame$4, {
        title: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.location"
        }),
        children: [/* @__PURE__ */ jsx(TextField$1, {
          value: name || "",
          inputRef: nameRef,
          label: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.name"
          }),
          onChange: handleEventUpdate("name"),
          variant: "outlined"
        }), /* @__PURE__ */ jsx(TextField$1, {
          value: address || "",
          inputRef: addressRef,
          label: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.address"
          }),
          onChange: handleEventUpdate("address"),
          variant: "outlined"
        }), /* @__PURE__ */ jsx(TextField$1, {
          value: label || "",
          label: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "compose.event.label"
          }),
          onChange: handleEventUpdate("label"),
          variant: "outlined"
        }), /* @__PURE__ */ jsx(TextField$1, {
          value: url || "",
          label: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "compose.event.url"
          }),
          onChange: handleEventUpdate("url"),
          variant: "outlined"
        })]
      }), /* @__PURE__ */ jsxs(FormControl$1, {
        className: "w-full",
        children: [/* @__PURE__ */ jsx(InputLabel, {
          id: "asset-category-label",
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.priority"
          })
        }), /* @__PURE__ */ jsx(Select$1, {
          labelId: "asset-category-label",
          value: priority || eventPriorities[0],
          variant: "outlined",
          disabled: !isAdmin(membership),
          onChange: handleChangePriority,
          children: eventPriorities.map((type) => {
            return /* @__PURE__ */ jsx(MenuItem, {
              value: type,
              children: type
            }, type);
          })
        })]
      }), /* @__PURE__ */ jsx(Autocomplete$1, {
        id: "tags-filled",
        options: sponsors,
        value: sponsor || "",
        renderInput: (params) => /* @__PURE__ */ jsx(TextField$1, {
          ...params,
          label: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.sponsor"
          }),
          variant: "outlined"
        }),
        getOptionLabel: (option) => typeof option === "object" ? option.title : option || "",
        onChange: onSponsorChange,
        onInputChange: async (_event, newInputValue) => {
          const {
            sponsors: sponsors2
          } = await api.get({
            path: "/sponsors/" + (newInputValue || "_ALL") + (group ? "?circle=" + (group.ancestry[0] || group._id) : "")
          });
          setSponsors(sponsors2);
        }
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex  flex-col gap-2 -ml-2 -mr-2",
        children: [/* @__PURE__ */ jsx("div", {
          className: "w-full flex items-center p-2 bg-[#F5F5F5]",
          children: /* @__PURE__ */ jsxs(DetailsButton, {
            variant: "outlined",
            onClick: () => setExpanded((v) => !v),
            children: [expanded && /* @__PURE__ */ jsx("div", {
              className: "flex-grow",
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "event.collapse"
              })
            }), !expanded && /* @__PURE__ */ jsx("div", {
              className: "flex-grow",
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "event.moreInfo"
              })
            })]
          })
        }), /* @__PURE__ */ jsx(Collapse, {
          in: expanded,
          timeout: "auto",
          children: /* @__PURE__ */ jsxs("div", {
            className: "flex w-full flex-col gap-2",
            children: [/* @__PURE__ */ jsx(TextField$1, {
              value: label2 || "",
              label: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "compose.event.label2"
              }),
              onChange: handleEventUpdate("label2"),
              variant: "outlined"
            }), /* @__PURE__ */ jsx(TextField$1, {
              value: url2 || "",
              label: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "compose.event.url2"
              }),
              onChange: handleEventUpdate("url2"),
              variant: "outlined"
            }), /* @__PURE__ */ jsx(Frame$4, {
              title: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "event.roles"
              }),
              children: /* @__PURE__ */ jsx(AddKeyParticipants, {})
            })]
          })
        })]
      }), selectAsset && /* @__PURE__ */ jsx(SelectAssetDialog, {
        onClose: () => setSelectAsset(false),
        onSponsorChange: (post) => onSponsorChange(null, post)
      }), children, /* @__PURE__ */ jsxs("div", {
        className: "w-full flex gap-2",
        children: [/* @__PURE__ */ jsx(LoadingButton, {
          onClick: onCancel,
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.cancel"
          })
        }), /* @__PURE__ */ jsx(LoadingButton, {
          onClick: onSave,
          loading,
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "event.save"
          })
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      ref: attrRef
    })]
  });
};
const Frame$4 = ({
  title,
  children
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 p-2 border-[#F5F5F5] rounded-xl border mt-2 bg-white relative",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold -mt-5 text-base mx-4 px-2 text-gray-500",
      children: title
    }), children]
  });
};
const EditEventPageInner1 = (props) => {
  const {
    draft
  } = useEditPostContext();
  if (!draft) {
    return null;
  }
  return /* @__PURE__ */ jsx(EditEventPageInner, {
    ...props
  });
};
const EditEventPage = (props) => {
  const location = useLocation();
  const {
    draftId: paramDraftId,
    ...other
  } = props;
  let all;
  const draftId = paramDraftId || (all = location.pathname.split("/").filter((v) => v)) && all[all.length - 1];
  return /* @__PURE__ */ jsx(EditPostContextProvider, {
    draftId,
    children: /* @__PURE__ */ jsx(EditEventPageInner1, {
      ...other
    }, draftId)
  });
};

const CircleConfigure = () => {
  const [header, setHeader] = useState("");
  const [footer, setFooter] = useState("");
  const [mapFooter, setMapFooter] = useState("");
  const [mobileMapFooter, setMobileMapFooter] = useState("");
  const {
    circle
  } = useCircleContext();
  useEffect(() => {
    if (!circle) {
      return;
    }
    const {
      header_url,
      footer_url,
      map_footer_url,
      mobile_map_footer_url
    } = circle;
    setHeader(header_url);
    setFooter(footer_url);
    setMapFooter(map_footer_url);
    setMobileMapFooter(mobile_map_footer_url);
  }, [circle]);
  const api = useApi();
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    await api.post({
      path: `/groups/${circleId}/_partial`,
      body: {
        footer_url: footer,
        header_url: header,
        map_footer_url: mapFooter,
        mobile_map_footer_url: mobileMapFooter
      }
    });
    if (isLocalhost()) {
      return;
    }
    window.close();
  });
  if (!circle) {
    return null;
  }
  const {
    _id: circleId
  } = circle;
  const handleChange = (setter) => (e) => {
    setter(e.target.value);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "ns w-full p-2 flex flex-col gap-2 text-sm",
    children: [/* @__PURE__ */ jsx("h1", {
      className: "font-semibold text-base p-1",
      children: "Configure Circle's UI elements"
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "URL of header image",
      value: header,
      onChange: handleChange(setHeader),
      className: "w-full"
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "URL of footer image",
      value: footer,
      onChange: handleChange(setFooter),
      className: "w-full"
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "URL of the Map footer image",
      value: mapFooter,
      onChange: handleChange(setMapFooter),
      className: "w-full"
    }), /* @__PURE__ */ jsx(TextField$1, {
      autoFocus: true,
      label: "URL of the mobile Map footer image",
      value: mobileMapFooter,
      onChange: handleChange(setMobileMapFooter),
      className: "w-full"
    }), /* @__PURE__ */ jsx("div", {
      className: "flex gap-1",
      children: /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onSave,
        loading: saveLoading,
        children: "Save"
      })
    })]
  });
};
const CircleConfigPage = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[2] ? path[2] : circleIdDefault;
  return /* @__PURE__ */ jsxs(LoadCircleData, {
    circleId,
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(CircleConfigure, {})]
  });
};

const MapClusteringConfigPageInner = () => {
  const isCircleAdmin = useIsCircleAdmin();
  if (!isCircleAdmin) {
    return null;
  }
  return /* @__PURE__ */ jsxs(CircleMarkerClusteringProvider, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(QuickViewDialog, {}), /* @__PURE__ */ jsx(ConfigureClusteringPanel, {}), /* @__PURE__ */ jsx(GoogleMapArea, {
      className: "ns w-full h-full",
      fullHeight: true
    })]
  });
};
const MapClusteringConfigPage = () => {
  const circleIdDefault = isLocalhost() ? "64370230a961a77ffb941cc2" : "63348e7a6e0d43384ca3ab93";
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[1] === "map-clustering-config" && path[2] ? path[2] : circleIdDefault;
  return /* @__PURE__ */ jsx(LoadCircleData, {
    circleId,
    children: /* @__PURE__ */ jsx(MapClusteringConfigPageInner, {})
  });
};

const MANUAL_MODE = 0;
const SCHEDULE_MODE = 1;
const DISABLED_MODE = 2;
const useAssistant$1 = (id, options) => {
  const api = useApi();
  const result = useSWR(id ? `/group-assistant/${id}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const IMAGE_SIZE$2 = 128;
const MaybeAvatar$2 = ({
  avatar
}) => {
  if (avatar) {
    return /* @__PURE__ */ jsx(ScaledImageProxy, {
      className: "rounded-full border-2 border-black/30 outline-none",
      uuid: avatar.uuid,
      w: IMAGE_SIZE$2,
      h: IMAGE_SIZE$2,
      crop: true
    });
  }
  return /* @__PURE__ */ jsx("div", {
    style: {
      minWidth: IMAGE_SIZE$2,
      minHeight: IMAGE_SIZE$2,
      width: IMAGE_SIZE$2,
      height: IMAGE_SIZE$2
    },
    className: "rounded-full border-2 border-black/30 outline-none"
  });
};
const Frame$3 = ({
  title,
  children
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 p-2 border-[#F5F5F5] rounded-xl border mt-2 bg-white relative",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold -mt-5 text-base mx-4 px-2 text-gray-500",
      children: title
    }), children]
  });
};
const CanEdit = ({
  children
}) => {
  const canExecute = useCanExecutePrompt();
  if (!canExecute) {
    return /* @__PURE__ */ jsx("div", {
      children: "You can not edit AI Assistants"
    });
  }
  return /* @__PURE__ */ jsx(Fragment, {
    children
  });
};
const ButtonSimple = styled(Button)`
  & .MuiButton-label {
    text-transform: none;
  }

`;
const ConfigureAssistant = ({
  id
}) => {
  const timeState = useTimePanelState();
  const {
    data
  } = useAssistant$1(id);
  const [assistant, setAssistant] = useState(null);
  const [sponsors, setSponsors] = useState([]);
  const [showUIPromptsConfig, setShowUIPromptsConfig] = useState(false);
  useEffect(() => {
    if (!data) {
      return;
    }
    const {
      assistant: assistant2
    } = data;
    setAssistant(assistant2);
    const timeData = new EventTemporalData(assistant2);
    const {
      time1,
      date1,
      date2,
      time2,
      tzOffset,
      timezone
    } = timeData;
    const {
      setDate1,
      setDate2,
      setTzOffset,
      setTime1,
      setTime2,
      setTimezone
    } = timeState;
    setDate1(date1);
    setTimezone(timezone || getUserTimezone());
    setTzOffset(tzOffset);
    setDate2(date2);
    setTime1(time1);
    setTime2(time2);
  }, [data]);
  const api = useApi();
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    const request = {
      ...assistant,
      ...timeInfoForEvent(timeState)
    };
    await api.post({
      path: `/group-assistant`,
      body: request
    });
    if (request.duration <= 0) {
      if (assistantMode === SCHEDULE_MODE) {
        errorToast({
          error: "End day should be after start day!"
        });
        return;
      }
      request.duration = 0;
    }
    if (isLocalhost()) {
      return;
    }
    const {
      group: group2
    } = assistant;
    window.location.href = circleUrl(group2);
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const onFiles = useMemoizedFn(async (acceptedFiles, onProgress) => {
    const saved = acceptedFiles.length ? await errorsReported(async () => {
      const saved2 = await uploadFiles(api, acceptedFiles, onProgress);
      return saved2;
    }, {
      message: "Failed to upload files."
    })() : [null];
    setAssistant((a) => {
      return {
        ...a,
        avatar: saved[0]
      };
    });
    onProgress(void 0);
    setDialogOpen(false);
  });
  const onPromptChange = useMemoizedFn((event, newValue) => {
    console.log("newValue", newValue);
    const isPost = newValue && typeof newValue === "object";
    setAssistant({
      ...assistant,
      prompt: isPost && newValue || null
    });
  });
  if (!assistant) {
    return null;
  }
  const {
    name,
    description,
    period,
    avatar,
    group,
    prompt,
    prompts = []
  } = assistant;
  const assistantMode = assistant.mode || MANUAL_MODE;
  const handleChange = (name2) => (e) => {
    const value = name2 === "period" ? parseInt(e.target.value) : e.target.value;
    setAssistant((a) => {
      return {
        ...a,
        [name2]: value
      };
    });
  };
  const onAddPrompt = () => {
    const updated = [{
      prompt: null,
      name: "New Prompt",
      position: "comment.menu"
    }, ...prompts];
    setAssistant({
      ...assistant,
      prompts: updated
    });
  };
  const onCancel = () => {
    const {
      group: group2
    } = assistant;
    window.location.href = circleUrl(group2);
  };
  const modeProps = (mode) => {
    return {
      variant: mode === assistantMode ? "contained" : "outlined",
      onClick: () => setAssistant({
        ...assistant,
        mode
      })
    };
  };
  return /* @__PURE__ */ jsx(LoadCircleData, {
    circleId: group,
    children: /* @__PURE__ */ jsx(CanEdit, {
      children: /* @__PURE__ */ jsxs("div", {
        className: "ns w-full p-2 flex flex-col gap-4 text-sm",
        children: [/* @__PURE__ */ jsx(AssistantNavigation, {
          assistant
        }), /* @__PURE__ */ jsx(BreadCrumbs, {}), /* @__PURE__ */ jsxs(Frame$3, {
          title: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.details"
          }),
          children: [/* @__PURE__ */ jsx(TextField$1, {
            label: "ai.name",
            value: name,
            onChange: handleChange("name"),
            className: "w-full"
          }), /* @__PURE__ */ jsx(TextField$1, {
            label: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "ai.description"
            }),
            multiline: true,
            rows: 4,
            value: description,
            onChange: handleChange("description"),
            variant: "outlined",
            className: "w-full"
          }), /* @__PURE__ */ jsxs("div", {
            onClick: () => setDialogOpen(true),
            className: "cursor-pointer flex items-center gap-3",
            children: [dialogOpen && /* @__PURE__ */ jsx(UploadFileDialog, {
              open: dialogOpen,
              onClose: () => setDialogOpen(false),
              onFiles,
              title: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.selectAvatar"
              }),
              dropzone: {
                maxFiles: 1
              }
            }), /* @__PURE__ */ jsx(MaybeAvatar$2, {
              avatar
            }), /* @__PURE__ */ jsx("div", {
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.selectIcon"
              })
            })]
          })]
        }), /* @__PURE__ */ jsxs(Frame$3, {
          title: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.operation"
          }),
          children: [/* @__PURE__ */ jsxs("div", {
            className: "w-full flex gap-1 items-center",
            children: [/* @__PURE__ */ jsx(Autocomplete$1, {
              id: "prompt",
              options: sponsors,
              className: "flex-grow",
              value: prompt || "",
              renderInput: (params) => /* @__PURE__ */ jsx(TextField$1, {
                ...params,
                label: /* @__PURE__ */ jsx(FormattedMessage, {
                  id: "ai.selectMainPrompt"
                }),
                variant: "outlined"
              }),
              getOptionLabel: (option) => typeof option === "object" ? option.title : option || "",
              onChange: onPromptChange,
              onInputChange: async (_event, newInputValue) => {
                const {
                  sponsors: sponsors2
                } = await api.get({
                  path: "/group-assistant/prompts/" + (newInputValue || "_ALL")
                });
                setSponsors(sponsors2);
              }
            }), prompt && /* @__PURE__ */ jsx("a", {
              href: url4post(prompt),
              target: "_blank",
              children: /* @__PURE__ */ jsx(MdOutlineOpenInNew, {})
            })]
          }), /* @__PURE__ */ jsx(TimePanel, {
            state: timeState,
            noValidation: assistantMode !== SCHEDULE_MODE
          }), /* @__PURE__ */ jsx(TextField$1, {
            label: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "ai.freq"
            }),
            value: period || 0,
            onChange: handleChange("period"),
            className: "w-full"
          }), /* @__PURE__ */ jsxs(ButtonGroup, {
            size: "small",
            color: "primary",
            "aria-label": "type",
            children: [/* @__PURE__ */ jsx(Button, {
              ...modeProps(MANUAL_MODE),
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.manual"
              })
            }), /* @__PURE__ */ jsx(Button, {
              ...modeProps(SCHEDULE_MODE),
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.schedule"
              })
            }), /* @__PURE__ */ jsx(Button, {
              ...modeProps(DISABLED_MODE),
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.off"
              })
            })]
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "w-full flex items-center",
          children: /* @__PURE__ */ jsxs(DetailsButton, {
            variant: "outlined",
            onClick: () => setShowUIPromptsConfig((v) => !v),
            children: [showUIPromptsConfig && /* @__PURE__ */ jsx("div", {
              className: "flex-grow",
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.hideUI"
              })
            }), !showUIPromptsConfig && /* @__PURE__ */ jsx("div", {
              className: "flex-grow",
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.showUI"
              })
            })]
          })
        }), /* @__PURE__ */ jsx(Collapse, {
          in: showUIPromptsConfig,
          timeout: "auto",
          children: /* @__PURE__ */ jsxs(Frame$3, {
            title: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "ai.promptSelection"
            }),
            children: [/* @__PURE__ */ jsx(ButtonSimple, {
              onClick: onAddPrompt,
              variant: "contained",
              color: "primary",
              className: "w-16",
              children: /* @__PURE__ */ jsx(FormattedMessage, {
                id: "ai.add"
              })
            }), prompts.map(({
              prompt: prompt2,
              name: name2,
              position
            }, id2) => {
              const onPromptChange2 = (event, newValue) => {
                const isPost = newValue && typeof newValue === "object";
                const prompt3 = isPost && newValue || null;
                const updated = prompts.map((v, i) => {
                  if (i !== id2) {
                    return v;
                  }
                  return {
                    ...v,
                    prompt: prompt3
                  };
                });
                const update = {
                  ...assistant,
                  prompts: updated
                };
                if (!assistant.prompt) {
                  update.prompt = prompt3;
                }
                setAssistant(update);
              };
              const handleChange2 = (name3) => (e) => {
                const value = e.target.value;
                const updated = prompts.map((v, i) => {
                  if (i !== id2) {
                    return v;
                  }
                  return {
                    ...v,
                    [name3]: value
                  };
                });
                setAssistant({
                  ...assistant,
                  prompts: updated
                });
              };
              const onDelete = () => {
                const updated = prompts.filter((v, i) => i !== id2);
                setAssistant({
                  ...assistant,
                  prompts: updated
                });
              };
              return /* @__PURE__ */ jsxs("div", {
                className: "w-full flex flex-col gap-2",
                children: [/* @__PURE__ */ jsxs("div", {
                  className: "w-full flex gap-1 items-center",
                  children: [/* @__PURE__ */ jsx(Autocomplete$1, {
                    id: "prompt",
                    className: "flex-grow",
                    options: sponsors,
                    value: prompt2 || "",
                    renderInput: (params) => /* @__PURE__ */ jsx(TextField$1, {
                      ...params,
                      label: /* @__PURE__ */ jsx(FormattedMessage, {
                        id: "ai.selectPrompt"
                      }),
                      variant: "outlined"
                    }),
                    getOptionLabel: (option) => typeof option === "object" ? option.title : option || "",
                    onChange: onPromptChange2,
                    onInputChange: async (_event, newInputValue) => {
                      const {
                        sponsors: sponsors2
                      } = await api.get({
                        path: "/group-assistant/prompts/" + (newInputValue || "_ALL")
                      });
                      setSponsors(sponsors2);
                    }
                  }), prompt2 && /* @__PURE__ */ jsx("a", {
                    href: url4post(prompt2),
                    target: "_blank",
                    children: /* @__PURE__ */ jsx(MdOutlineOpenInNew, {})
                  })]
                }), /* @__PURE__ */ jsxs(Select$1, {
                  labelId: "function-label",
                  value: position || "post.menu",
                  variant: "outlined",
                  onChange: handleChange2("position"),
                  children: [/* @__PURE__ */ jsx(MenuItem, {
                    value: "comment.menu",
                    children: /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "ai.thread"
                    })
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "editor.menu",
                    children: /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "ai.editor"
                    })
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "editor.content",
                    children: "Content Assistant"
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "circle.menu",
                    children: /* @__PURE__ */ jsx(FormattedMessage, {
                      id: "ai.circle"
                    })
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "search",
                    children: "Search"
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "search.vector",
                    children: "Search (Vector)"
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "search.book",
                    children: "Search Book"
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "post.metadata",
                    children: "Post metadata"
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "aichat.enhance",
                    children: "AI Chat (Enhance)"
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "aichat.assist",
                    children: "AI Chat (Assist)"
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "aichat.submit",
                    children: "AI Chat (Submit)"
                  }), /* @__PURE__ */ jsx(MenuItem, {
                    value: "aichat.suggest",
                    children: "AI Chat (Suggest)"
                  })]
                }), /* @__PURE__ */ jsx(TextField$1, {
                  label: /* @__PURE__ */ jsx(FormattedMessage, {
                    id: "ai.alias"
                  }),
                  value: name2,
                  onChange: handleChange2("name"),
                  className: "w-full"
                }), /* @__PURE__ */ jsx(ButtonSimple, {
                  onClick: onDelete,
                  variant: "contained",
                  color: "primary",
                  className: "w-16",
                  children: /* @__PURE__ */ jsx(FormattedMessage, {
                    id: "ai.delete"
                  })
                })]
              }, id2);
            })]
          })
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex gap-3",
          children: [/* @__PURE__ */ jsx(LoadingButton, {
            variant: "contained",
            size: "small",
            onClick: onCancel,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "ai.cancel"
            })
          }), /* @__PURE__ */ jsx(LoadingButton, {
            onClick: onSave,
            loading: saveLoading,
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "ai.save"
            })
          })]
        })]
      })
    })
  });
};
const CircleAssistant = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const id = path[2];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(ConfigureAssistant, {
      id
    })]
  });
};

const useAssistantLogUsage = (executionId, options) => {
  const api = useApi();
  const result = useSWR(executionId ? `/group-assistant/usage/${executionId}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};

const LLMUsageInfo = ({
  executionId
}) => {
  const {
    data,
    error,
    isValidating
  } = useAssistantLogUsage(executionId);
  if (error) {
    return /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm italic",
      children: "Failed to load LLM usage info"
    });
  }
  if (!data && isValidating) {
    return /* @__PURE__ */ jsx("div", {
      className: "text-gray-500 text-sm italic",
      children: "Loading LLM usage info..."
    });
  }
  if (!data || !data.usage || data.usage.length === 0) {
    return /* @__PURE__ */ jsx("div", {
      className: "text-gray-500 text-sm italic",
      children: "No LLM usage info"
    });
  }
  const {
    usage
  } = data;
  const totalPromptTokens = usage.reduce((sum, item) => sum + (item.tokenUsage.promptTokens || 0), 0);
  const totalCompletionTokens = usage.reduce((sum, item) => sum + (item.tokenUsage.completionTokens || 0), 0);
  const totalTokens = usage.reduce((sum, item) => sum + (item.tokenUsage.totalTokens || 0), 0);
  const modelsUsed = [...new Set(usage.map((item) => item.modelName).filter(Boolean))];
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold text-sm",
      children: "LLM Usage Summary:"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center flex-wrap",
      children: [modelsUsed.length > 0 && /* @__PURE__ */ jsx(Chip$1, {
        label: `Models: ${modelsUsed.join(", ")}`,
        size: "small",
        variant: "outlined"
      }), totalPromptTokens > 0 && /* @__PURE__ */ jsx(Chip$1, {
        label: `Prompt: ${totalPromptTokens.toLocaleString()} tokens`,
        size: "small",
        variant: "outlined"
      }), totalCompletionTokens > 0 && /* @__PURE__ */ jsx(Chip$1, {
        label: `Completion: ${totalCompletionTokens.toLocaleString()} tokens`,
        size: "small",
        variant: "outlined"
      }), totalTokens > 0 && /* @__PURE__ */ jsx(Chip$1, {
        label: `Total: ${totalTokens.toLocaleString()} tokens`,
        size: "small",
        variant: "outlined",
        color: "primary"
      })]
    }), usage.length > 1 && /* @__PURE__ */ jsxs("details", {
      className: "mt-2",
      children: [/* @__PURE__ */ jsxs("summary", {
        className: "cursor-pointer text-sm text-gray-600 hover:text-gray-800",
        children: ["View detailed breakdown (", usage.length, " requests)"]
      }), /* @__PURE__ */ jsx("div", {
        className: "mt-2 space-y-2",
        children: usage.map((item, index) => /* @__PURE__ */ jsxs("div", {
          className: "pl-4 border-l-2 border-gray-200",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "text-xs text-gray-600",
            children: ["Request ", index + 1, " \u2022 ", item.modelName || "Unknown model", item.created && /* @__PURE__ */ jsxs("span", {
              className: "ml-2",
              children: ["\u2022 ", new Date(item.created).toLocaleString()]
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex gap-1 mt-1",
            children: [item.tokenUsage.promptTokens && /* @__PURE__ */ jsxs("span", {
              className: "text-xs",
              children: ["Prompt: ", item.tokenUsage.promptTokens.toLocaleString()]
            }), item.tokenUsage.completionTokens && /* @__PURE__ */ jsxs("span", {
              className: "text-xs",
              children: ["\u2022 Completion: ", item.tokenUsage.completionTokens.toLocaleString()]
            }), item.tokenUsage.totalTokens && /* @__PURE__ */ jsxs("span", {
              className: "text-xs font-medium",
              children: ["\u2022 Total: ", item.tokenUsage.totalTokens.toLocaleString()]
            })]
          })]
        }, item._id || index))
      })]
    })]
  });
};

const AssistantLogItemDetails = ({
  item,
  onToggle
}) => {
  const api = useApi();
  const {
    _id,
    started,
    externalOutput,
    externalInput: externalInputRaw,
    result: results
  } = item;
  const externalInput = !externalInputRaw ? [] : externalInputRaw.filter((v) => v);
  const {
    onClick: onResubmit,
    loading: resubmitting
  } = useLoading(async () => {
    await api.post({
      path: `/ai/group/resubmit`,
      body: {
        ids: externalInput
      }
    });
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col justify-stretch px-2",
    children: [/* @__PURE__ */ jsx("div", {
      className: "cursor-pointer underline",
      onClick: onToggle,
      children: "More:"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["id: ", _id]
      }), /* @__PURE__ */ jsxs("div", {
        children: ["time: ", started]
      })]
    }), externalOutput && externalOutput.length > 0 && /* @__PURE__ */ jsxs("div", {
      className: "flex gap-1",
      children: [/* @__PURE__ */ jsx("div", {
        children: "Output:"
      }), externalOutput.map((one) => /* @__PURE__ */ jsx("div", {
        children: one
      }, one))]
    }), externalInput.length > 0 && /* @__PURE__ */ jsxs("div", {
      className: "flex gap-1 items-center",
      children: [/* @__PURE__ */ jsx("div", {
        children: "Input:"
      }), externalInput.map((one) => /* @__PURE__ */ jsx("div", {
        children: one
      }, one)), /* @__PURE__ */ jsx(LoadingButton, {
        variant: "outlined",
        loading: resubmitting,
        onClick: () => onResubmit(),
        children: "Resubmit"
      })]
    }), results && results.length > 0 && results.map((one) => /* @__PURE__ */ jsx("div", {
      children: one
    }, one)), /* @__PURE__ */ jsx(LLMUsageInfo, {
      executionId: _id
    })]
  });
};

const AssistantLogsItem$1 = ({
  item
}) => {
  const [showMore, setShowMore] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [result, setResult] = useState("");
  const {
    started,
    errors,
    post,
    _id,
    title,
    reply,
    status,
    notes
  } = item;
  const errorStatus = errors && errors.length > 0;
  const onResult = () => {
    setResult(result ? null : reply);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col justify-stretch",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx(RelativeTime, {
          value: started
        })
      }), notes && notes.length > 0 && notes.map((note) => /* @__PURE__ */ jsx(Chip$1, {
        label: note,
        size: "small"
      }, note)), errorStatus && /* @__PURE__ */ jsx("div", {
        className: "bg-red-500 rounded p-0.5 cursor-pointer",
        onClick: () => setShowErrors((e) => !e),
        children: errors.length + " errors"
      }), /* @__PURE__ */ jsx(Chip$1, {
        label: status,
        size: "small"
      }), !errorStatus && status === "finished" && /* @__PURE__ */ jsx(Chip$1, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.success"
        }),
        size: "small"
      }), title && !post && /* @__PURE__ */ jsx("div", {
        className: "underline cursor-pointer",
        onClick: onResult,
        children: title
      }), post && /* @__PURE__ */ jsx("a", {
        href: url4post(post),
        className: "underline",
        children: post.title
      }), /* @__PURE__ */ jsx("div", {
        className: "grow"
      }), /* @__PURE__ */ jsx("div", {
        className: "underline cursor-pointer",
        onClick: () => setShowMore((v) => !v),
        children: "more.."
      })]
    }, _id), showMore && /* @__PURE__ */ jsx(AssistantLogItemDetails, {
      item,
      onToggle: () => setShowMore(false)
    }), result && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "cursor-pointer underline",
        onClick: () => setResult(null),
        children: "AI result:"
      }), /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: result
        }
      })]
    }), showErrors && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "cursor-pointer underline",
        onClick: () => setShowErrors((e) => !e),
        children: [errors.length + " errors", ":"]
      }), errors.map((error, i) => /* @__PURE__ */ jsxs("div", {
        className: "p-2",
        children: [i + 1, ". ", error]
      }, error))]
    })]
  });
};

const useAssistantLogs$1 = ({
  id,
  size = 50,
  feedback
}, options) => {
  const api = useApi();
  const result = useSWR(id ? [`/group-assistant/logs/${id}`, size] : null, async (path) => {
    const data = await api.get({
      path: path + "?size=" + size + "&feedback=" + (feedback ? 1 : "")
    });
    return data;
  }, {
    ...swrLoadOnce,
    refreshInterval: 1e3 * 60 * 5,
    ...options
  });
  return {
    ...result
  };
};

const useAssistantService = (id, options) => {
  const api = useApi();
  const result = useSWR(id ? `/assistants/group-assistant/${id}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const IMAGE_SIZE$1 = 128;
const MaybeAvatar$1 = ({
  avatar
}) => {
  if (avatar) {
    return /* @__PURE__ */ jsx(ScaledImageProxy, {
      className: "rounded-full border-2 border-black/30 outline-none",
      uuid: avatar.uuid,
      w: IMAGE_SIZE$1,
      h: IMAGE_SIZE$1,
      crop: true
    });
  }
  return /* @__PURE__ */ jsx("div", {
    style: {
      minWidth: IMAGE_SIZE$1,
      minHeight: IMAGE_SIZE$1,
      width: IMAGE_SIZE$1,
      height: IMAGE_SIZE$1
    },
    className: "rounded-full border-2 border-black/30 outline-none"
  });
};
const AssistantLogs$1 = ({
  id,
  assistant
}) => {
  const [size, setSize] = useState(50);
  const {
    data,
    mutate
  } = useAssistantLogs$1({
    id,
    size
  });
  const logs = data && data.logs || [];
  const handleChange = (e) => {
    const value = e.target.value;
    setSize(parseInt(value) || 50);
  };
  useEffect(() => {
    mutate();
  }, [assistant]);
  const {
    name
  } = assistant;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex bg-[#00A5B6]  p-2 text-white text-lg rounded-md w-full gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["Activities log for ", name]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex-grow"
      }), /* @__PURE__ */ jsx("a", {
        href: `/trans/circle-feedback-assistant/${id}`,
        className: "underline",
        children: "feedback"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2",
      children: [/* @__PURE__ */ jsx(TextField$1, {
        defaultValue: size || "",
        onChange: handleChange,
        label: "Number of records",
        variant: "outlined"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => mutate(),
        variant: "outlined",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.update"
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2 p-2 w-full justify-stretch",
      children: logs.map((item) => /* @__PURE__ */ jsx(AssistantLogsItem$1, {
        item
      }, item._id))
    })]
  });
};
const ServiceState = ({
  id,
  refresh
}) => {
  const {
    data,
    mutate
  } = useAssistantService(id);
  if (!data) {
    return null;
  }
  const {
    id: found,
    lastExecuted
  } = data && data.state || {};
  const onRefresh = () => {
    mutate();
    refresh();
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: ["\u25CB", /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.service"
      }), ": ", found ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.running"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.notRunning"
      })]
    }), "\u25CB", lastExecuted && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.lastExecuted"
        }), ": ", /* @__PURE__ */ jsx(RelativeTime, {
          value: lastExecuted
        })]
      }), "\u25CB"]
    }), /* @__PURE__ */ jsx("div", {
      className: "underline cursor-pointer",
      onClick: onRefresh,
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.refresh"
      })
    })]
  });
};
const AssistantViewInner = ({
  id
}) => {
  const timeState = useTimePanelState();
  const {
    data,
    mutate
  } = useAssistant$2(id);
  const [assistant, setAssistant] = useState(null);
  useEffect(() => {
    if (!data) {
      return;
    }
    const {
      assistant: assistant2
    } = data;
    setAssistant(assistant2);
    const timeData = new EventTemporalData(assistant2);
    const {
      time1,
      date1,
      date2,
      time2,
      tzOffset,
      timezone
    } = timeData;
    const {
      setDate1,
      setDate2,
      setTzOffset,
      setTime1,
      setTime2,
      setTimezone
    } = timeState;
    setDate1(date1);
    setTimezone(timezone || getUserTimezone());
    setTzOffset(tzOffset);
    setDate2(date2);
    setTime1(time1);
    setTime2(time2);
  }, [data, data && data.counter]);
  if (!assistant) {
    return null;
  }
  const {
    name,
    description,
    avatar,
    group,
    user,
    paused,
    active
  } = assistant;
  const assistantMode = assistant.mode || MANUAL_MODE$1;
  const modeProps = (mode) => {
    return {
      className: clsx("p-2 border-blue-400", mode !== DISABLED_MODE$1 && "border-r", assistantMode === mode && "bg-blue-400")
    };
  };
  return /* @__PURE__ */ jsx(LoadCircleData, {
    circleId: group,
    children: /* @__PURE__ */ jsxs("div", {
      className: "ns w-full p-2 flex flex-col gap-4 text-sm",
      children: [/* @__PURE__ */ jsx(AssistantNavigation, {
        assistant,
        edit: true
      }), /* @__PURE__ */ jsx(BreadCrumbs, {}), /* @__PURE__ */ jsx(MaybeAvatar$1, {
        avatar
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full gap-1",
        children: [/* @__PURE__ */ jsx("div", {
          className: "w-1/2 flex bg-[#4A90CE] p-2 text-white text-lg rounded-md",
          children: name
        }), /* @__PURE__ */ jsxs("div", {
          className: "w-1/2 flex bg-[#00A5B6]  p-2 text-white text-lg rounded-md",
          children: [/* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.createdBy"
          }), "\xA0", getPersonName(user)]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex w-full",
        children: description
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex bg-red-400  p-2 text-white text-lg rounded-md justify-center gap-2 items-center",
        children: [/* @__PURE__ */ jsx("div", {
          children: !paused && active ? /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.active"
          }) : /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.notActive"
          })
        }), /* @__PURE__ */ jsx(ServiceState, {
          id,
          refresh: mutate
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "rounded-md flex gap-0 p-0 border-blue-400 border w-max ",
        children: [/* @__PURE__ */ jsx("div", {
          ...modeProps(MANUAL_MODE$1),
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.manual"
          })
        }), /* @__PURE__ */ jsx("div", {
          ...modeProps(SCHEDULE_MODE$1),
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.schedule"
          })
        }), /* @__PURE__ */ jsx("div", {
          ...modeProps(DISABLED_MODE$1),
          children: /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.off"
          })
        })]
      }), assistant && /* @__PURE__ */ jsx(AssistantControls, {
        assistant,
        setAssistant
      }), /* @__PURE__ */ jsx(AssistantLogs$1, {
        id,
        assistant
      })]
    })
  });
};
const AssistantControls = ({
  assistant,
  setAssistant
}) => {
  const canExecute = useCanExecutePrompt();
  const assistantMode = assistant.mode || MANUAL_MODE$1;
  const api = useApi();
  const {
    onClick: onActivate,
    loading: activating
  } = useLoading(async () => {
    const {
      _id,
      active: active2
    } = assistant;
    const request = {
      _id,
      active: !active2
    };
    await api.post({
      path: `/group-assistant`,
      body: request
    });
    setAssistant({
      ...assistant,
      active: !active2
    });
  });
  const {
    onClick: onPause,
    loading: pausing
  } = useLoading(async () => {
    const {
      _id,
      paused: paused2
    } = assistant;
    const request = {
      _id,
      paused: !paused2
    };
    await api.post({
      path: `/group-assistant`,
      body: request
    });
    setAssistant({
      ...assistant,
      paused: !paused2
    });
  });
  if (!canExecute) {
    return null;
  }
  const {
    paused,
    active
  } = assistant;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2",
    children: [/* @__PURE__ */ jsx(LoadingButton, {
      variant: "outlined",
      loading: activating,
      onClick: () => onActivate(),
      disabled: assistantMode !== MANUAL_MODE$1,
      children: active ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.stop"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.start"
      })
    }), /* @__PURE__ */ jsx(LoadingButton, {
      variant: "outlined",
      onClick: () => onPause(),
      loading: pausing,
      disabled: assistantMode !== MANUAL_MODE$1 && assistantMode !== SCHEDULE_MODE$1,
      children: paused ? /* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.continue"
      }) : /* @__PURE__ */ jsx(FormattedMessage, {
        id: "ai.pause"
      })
    })]
  });
};
const CircleAssistantView = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const id = path[2];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(AssistantViewInner, {
      id
    })]
  });
};

const PostViewRedirect = () => {
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const _id = path[2];
  const api = useApi();
  useAsyncEffect(async () => {
    const post = await api.loadPostById({
      _id
    });
    history.replace(url4post(post));
  });
  return null;
};

const useAssistantLogs = (type, size = 50, options) => {
  const api = useApi();
  const result = useSWR([`/async-execution/last`, size, type], async (path) => {
    const data = await api.get({
      path: path + "?size=" + size + "&type=" + type
    });
    return data;
  }, {
    ...swrLoadOnce,
    refreshInterval: 1e3 * 60 * 5,
    ...options
  });
  return {
    ...result
  };
};
const AssistantLogsItem = ({
  item
}) => {
  useApi();
  const [showMore, setShowMore] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [result, setResult] = useState("");
  const {
    started,
    error,
    _id,
    result: results,
    status,
    notes
  } = item;
  const errorStatus = error && error.length > 0;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col justify-stretch",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx(RelativeTime, {
          value: started
        })
      }), notes && notes.length > 0 && notes.map((note) => /* @__PURE__ */ jsx(Chip$1, {
        label: note,
        size: "small"
      }, note)), errorStatus && /* @__PURE__ */ jsxs("div", {
        className: "bg-red-500 rounded p-0.5 cursor-pointer",
        onClick: () => setShowErrors((e) => !e),
        children: [" ", error.length + " errors"]
      }), /* @__PURE__ */ jsx(Chip$1, {
        label: status,
        size: "small"
      }), !errorStatus && status === "finished" && /* @__PURE__ */ jsx(Chip$1, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.success"
        }),
        size: "small"
      }), /* @__PURE__ */ jsx("div", {
        className: "grow"
      }), /* @__PURE__ */ jsx("div", {
        className: "underline cursor-pointer",
        onClick: () => setShowMore((v) => !v),
        children: "more.."
      })]
    }, _id), showMore && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "cursor-pointer underline",
        onClick: () => setShowMore(false),
        children: "More:"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center",
        children: [/* @__PURE__ */ jsxs("div", {
          children: ["id: ", _id]
        }), /* @__PURE__ */ jsxs("div", {
          children: ["time: ", started]
        })]
      }), results && results.length > 0 && results.map((one) => /* @__PURE__ */ jsx("div", {
        children: one
      }, one))]
    }), result && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "cursor-pointer underline",
        onClick: () => setResult(null),
        children: "AI result:"
      }), /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: result
        }
      })]
    }), showErrors && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "cursor-pointer underline",
        onClick: () => setShowErrors((e) => !e),
        children: [error.length + " errors", ":"]
      }), error.map((error2, i) => /* @__PURE__ */ jsxs("div", {
        className: "p-2",
        children: [i + 1, ". ", error2]
      }, error2))]
    })]
  });
};
const Frame$2 = ({
  title,
  children
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 p-2 border-[#F5F5F5] rounded-xl border mt-2 bg-white relative",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold -mt-5 text-base mx-4 px-2 text-gray-500",
      children: title
    }), children]
  });
};
const AssistantLogs = () => {
  const [size, setSize] = useState(50);
  const {
    data,
    mutate
  } = useAssistantLogs("an.tickers", size);
  const logs = data && data.logs || [];
  const handleChange = (e) => {
    const value = e.target.value;
    setSize(parseInt(value) || 50);
  };
  return /* @__PURE__ */ jsxs(Frame$2, {
    title: "Logs of all updates (manual and running overnight). Press the UPDATE button to monitor the state of the recent ticker import",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-2",
      children: [/* @__PURE__ */ jsx(TextField$1, {
        defaultValue: size || "",
        onChange: handleChange,
        label: "Number of records",
        variant: "outlined"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => mutate(),
        variant: "outlined",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.update"
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2 p-2 w-full justify-stretch",
      children: logs.map((item) => /* @__PURE__ */ jsx(AssistantLogsItem, {
        item
      }, item._id))
    })]
  });
};
const ANTickersPanel = () => {
  const api = useApi();
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    await api.post({
      path: `/ai/import-tickers`,
      body: {
        translator_options: {}
      }
    });
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 flex-col",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold",
      children: "Page to import (update) tickers using Alliance News API"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSave,
      className: "w-52",
      loading: saveLoading,
      children: "Update tickers"
    }), /* @__PURE__ */ jsx(AssistantLogs, {})]
  });
};
const ANTickersPage = () => {
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  if (!isInstanceAdmin) {
    return /* @__PURE__ */ jsx("div", {
      children: "Only instance admin can configure circle translation"
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx("div", {
      className: "p-2",
      children: /* @__PURE__ */ jsx(ANTickersPanel, {})
    })]
  });
};

const ANRootInner = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/trans/alliancenews";
  if (pathname.startsWith(prefix + "/tickers")) {
    return /* @__PURE__ */ jsx(ANTickersPage, {});
  }
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-2 p-2",
    children: /* @__PURE__ */ jsx("a", {
      href: prefix + "/tickers",
      className: "underline",
      children: "Tickers config"
    })
  });
};
const ANRoot = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(ANRootInner, {})]
  });
};

const ShowJsonDialog = ({
  onClose,
  title,
  data
}) => {
  return /* @__PURE__ */ jsx(ConfirmDialog, {
    title,
    open: true,
    content: /* @__PURE__ */ jsx("div", {
      className: "flex flex-col justify-stretch px-2 overflow-auto max-w-full",
      children: /* @__PURE__ */ jsx("pre", {
        children: JSON.stringify(data, null, 2)
      })
    }),
    onClose,
    children: /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onClose,
      children: "Cancel"
    })
  });
};

const SelectMyCircle = ({
  title,
  changeGroup,
  groupId,
  ...props
}) => {
  const {
    data
  } = useMyCircles$1();
  const handleChange = async (e) => {
    const id = e.target.value;
    const circle = data && data.find((circle2) => circle2._id === id);
    changeGroup(id, circle);
  };
  return /* @__PURE__ */ jsxs(FormControl$1, {
    ...props,
    children: [/* @__PURE__ */ jsx(InputLabel, {
      id: "asset-circle-label",
      children: title || "Save to"
    }), /* @__PURE__ */ jsx(Select$1, {
      labelId: "asset-circle-label",
      value: groupId || "",
      variant: "outlined",
      onChange: handleChange,
      children: data && data.map((circle) => {
        return /* @__PURE__ */ jsx(MenuItem, {
          value: circle._id,
          children: circle.name
        }, circle._id);
      })
    })]
  });
};

const mapServiceLocationToAssetFields = (serviceLocation) => {
  const location = serviceLocation.location || {};
  const address = location.physical_addresses && location.physical_addresses.length > 0 ? location.physical_addresses[0] : {};
  const latitude = location.latitude || 0;
  const longitude = location.longitude || 0;
  const contacts = serviceLocation.contacts && serviceLocation.contacts.length > 0 ? serviceLocation.contacts[0] : {};
  const phones = contacts.phones && contacts.phones.length > 0 ? contacts.phones[0] : {};
  const regular_schedule = serviceLocation.regular_schedule || [];
  const cost_options = serviceLocation.cost_options || [];
  const service_taxonomys = serviceLocation.service_taxonomys || [];
  return {
    streetNumber: "",
    fullName: location.name || "",
    shortName: location.name || "",
    postcode: address.postal_code || "",
    state: address.state_province || "",
    country: address.country || "",
    address: `${address.address_1 || ""}, ${address.city || ""}, ${address.country || ""}`,
    locality: address.city || "",
    location: {
      lat: latitude,
      lng: longitude
    },
    placeId: location.id || "",
    name: location.name || "",
    ward: "",
    category: "",
    type: "",
    subType: "",
    activity: "",
    subActivity: [],
    url: location.url || "",
    phone: phones.number || "",
    email: contacts.email || "",
    shortDescription: serviceLocation.description || "",
    openingTimes: regular_schedule.map((schedule) => `${schedule.byday || ""} ${schedule.opens_at || ""} - ${schedule.closes_at || ""}`).join(", "),
    charges: cost_options.map((cost) => `${cost.amount || ""} ${cost.option || ""}`).join(", "),
    tags: service_taxonomys.map((taxonomy) => taxonomy.taxonomy && taxonomy.taxonomy.name ? taxonomy.taxonomy.name : ""),
    status: "Entry",
    files: [],
    googlePhotos: []
  };
};
const filterFields = (asset) => {
  const essentialFields = ["postcode", "name", "address", "phone", "email", "shortDescription", "openingTimes", "charges", "tags"];
  return Object.entries(asset).filter(([key, value]) => essentialFields.includes(key) && value && value.length > 0);
};
const updateAssetFields = (draft, u) => {
  const title = "name" in u ? u.name : draft.title;
  const data = draft.form && draft.form.data;
  const updated = {
    ...draft,
    title,
    form: {
      data: {
        ...data,
        ...u
      }
    }
  };
  return updated;
};
const useOpenRefCreateAsset = () => {
  const api = useApi();
  const upsertDraft = useUpsertDraftFn$1();
  const createPostFn = useCreatePostFn2();
  const {
    onClick: createPost,
    loading
  } = useLoading(async (v) => {
    const {
      json: fields,
      group
    } = v;
    const draft = await createPostFn("asset", group);
    const updated = updateAssetFields(draft, fields);
    const draft1 = await upsertDraft(updated);
    const result = await api.publish(draft1);
    return result;
  });
  return {
    createPost,
    loading
  };
};
const AssetListItem = ({
  asset,
  group
}) => {
  const [post, setPost] = useState();
  const filteredFields = filterFields(asset);
  const {
    createPost,
    loading
  } = useOpenRefCreateAsset();
  const onCreate = async () => {
    const post2 = await createPost({
      json: asset,
      group
    });
    setPost(post2);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex border p-4 mb-4 rounded-lg shadow-md items-center gap-2",
    children: [filteredFields.map(([key, value]) => /* @__PURE__ */ jsxs("div", {
      className: "mb-2",
      children: [/* @__PURE__ */ jsxs("strong", {
        className: "capitalize",
        children: [key.replace(/([A-Z])/g, " $1"), ": "]
      }), Array.isArray(value) ? value.join(", ") : value]
    }, key)), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col",
      children: /* @__PURE__ */ jsx(LoadingButton, {
        loading,
        onClick: onCreate,
        children: "create"
      })
    }), post && /* @__PURE__ */ jsx("div", {
      className: "underline",
      children: /* @__PURE__ */ jsx("a", {
        href: url4post(post),
        children: "open"
      })
    })]
  });
};
const AssetList = ({
  assets,
  group
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: "container mx-auto p-4",
    children: assets.map((asset, index) => /* @__PURE__ */ jsx(AssetListItem, {
      asset,
      group
    }, index))
  });
};
const useImportedItems = ({
  size,
  filter,
  start
}, options) => {
  const api = useApi();
  const result = useSWR([`/playground/openref/all`, start, size, filter], async (path) => {
    const data = await api.get({
      path: path + "?size=" + size + "&filter=" + encodeURIComponent(filter) + "&start=" + start
    });
    return data;
  }, {
    ...swrLoadOnce,
    refreshInterval: 1e3 * 60 * 5,
    ...options
  });
  return {
    ...result
  };
};
const extractServiceAreas = (json) => {
  if (json.details && Array.isArray(json.details.service_areas)) {
    return json.details.service_areas.map((area) => ({
      serviceArea: area.service_area || "",
      extent: area.extent || "",
      id: area.id || ""
    }));
  }
  return [];
};
const OpenRefItem = ({
  item,
  group
}) => {
  useApi();
  const [json, setJson] = useState(false);
  useState(false);
  useState(false);
  useState("");
  const {
    uuid,
    data
  } = item;
  const {
    name
  } = data;
  const areas = extractServiceAreas(data);
  const assetFieldsArray = data.details && data.details.service_at_locations && data.details.service_at_locations.map(mapServiceLocationToAssetFields) || [];
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col justify-stretch max-w-full",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [areas.length && /* @__PURE__ */ jsx("div", {
        children: areas.map((area) => area.serviceArea).filter((v) => v).map((label) => /* @__PURE__ */ jsx(Chip$1, {
          label,
          size: "small"
        }))
      }), /* @__PURE__ */ jsx("div", {
        children: name
      }), /* @__PURE__ */ jsx("div", {
        className: "underline cursor-pointer",
        onClick: () => setJson((v) => !v),
        children: "json.."
      })]
    }), json && /* @__PURE__ */ jsx(ShowJsonDialog, {
      title: "JSON item",
      onClose: () => setJson((v) => !v),
      data
    }), /* @__PURE__ */ jsx(AssetList, {
      assets: assetFieldsArray,
      group
    })]
  });
};
const Frame$1 = ({
  title,
  children
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 p-2 border-[#F5F5F5] rounded-xl border mt-2 bg-white relative",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold -mt-5 text-base mx-4 px-2 text-gray-500",
      children: title
    }), children]
  });
};
const ImportedEntries = ({
  filter,
  group
}) => {
  const [start, setStart] = useState(0);
  const [size, setSize] = useState(50);
  const {
    data,
    mutate
  } = useImportedItems({
    size,
    filter,
    start
  });
  const items = data && data.data || [];
  const handleChange = (e) => {
    const value = e.target.value;
    setSize(parseInt(value) || 50);
  };
  const handleChangeStart = (e) => {
    const value = e.target.value;
    setStart(parseInt(value) || 0);
  };
  return /* @__PURE__ */ jsxs(Frame$1, {
    title: "Show all imported entries",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-2",
      children: [/* @__PURE__ */ jsx(TextField$1, {
        defaultValue: start || 0,
        onChange: handleChangeStart,
        label: "begin from",
        variant: "outlined"
      }), /* @__PURE__ */ jsx(TextField$1, {
        defaultValue: size || "",
        onChange: handleChange,
        label: "Number of records",
        variant: "outlined"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => mutate(),
        variant: "outlined",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.update"
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2 p-2 w-full justify-stretch",
      children: items.map((item) => /* @__PURE__ */ jsx(OpenRefItem, {
        item,
        group
      }, item.uuid))
    })]
  });
};
const useServiceAreaCounts = (options) => {
  const api = useApi();
  const result = useSWR([`/playground/openref/service-areas`], async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result,
    ...result.data
  };
};
const FiltersComponent = ({
  filter,
  setFilter
}) => {
  const handleFilterClick = (service_area) => {
    setFilter(service_area);
  };
  const clearFilter = () => {
    setFilter("");
  };
  const {
    counts = []
  } = useServiceAreaCounts();
  return /* @__PURE__ */ jsxs("div", {
    className: "p-4",
    children: [/* @__PURE__ */ jsx("h2", {
      className: "text-2xl font-bold mb-4",
      children: "Service Areas"
    }), /* @__PURE__ */ jsx("ul", {
      className: "space-y-2",
      children: counts.map((area) => /* @__PURE__ */ jsxs("li", {
        className: `p-2 border rounded cursor-pointer ${filter === area.service_area ? "bg-blue-200" : "bg-white"}`,
        onClick: () => handleFilterClick(area.service_area),
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-semibold",
          children: area.service_area
        }), /* @__PURE__ */ jsxs("span", {
          className: "text-gray-600",
          children: ["(", area.count, ")"]
        })]
      }, area.service_area))
    }), filter && /* @__PURE__ */ jsxs("div", {
      className: "mt-4",
      children: [/* @__PURE__ */ jsxs("p", {
        className: "text-lg mb-4",
        children: ["Selected Filter: ", /* @__PURE__ */ jsx("span", {
          className: "font-semibold",
          children: filter
        })]
      }), /* @__PURE__ */ jsx("button", {
        className: "px-4 py-2 bg-red-500 text-white rounded",
        onClick: clearFilter,
        children: "Clear Filter"
      })]
    })]
  });
};
const OpenRefsPanel = () => {
  const [group, setGroup] = useState("");
  const [filter, setFilter] = useState("");
  const api = useApi();
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    await api.get({
      path: `/playground/openref/import`
    });
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 flex-col overflow-auto",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold",
      children: "Page to import assets from Open Ref"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSave,
      className: "w-52",
      loading: saveLoading,
      children: "Import JSON files"
    }), /* @__PURE__ */ jsx(SelectMyCircle, {
      groupId: group,
      changeGroup: setGroup
    }), /* @__PURE__ */ jsx(FiltersComponent, {
      filter,
      setFilter
    }), /* @__PURE__ */ jsx(ImportedEntries, {
      filter,
      group
    })]
  });
};
const ImportOpenRefPage = () => {
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  if (!isInstanceAdmin) {
    return /* @__PURE__ */ jsx("div", {
      children: "Only instance admin can configure circle translation"
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx("div", {
      className: "p-2",
      children: /* @__PURE__ */ jsx(OpenRefsPanel, {})
    })]
  });
};

const ALL_MODE = 0;
const SELECTED_MODE = 2;
const useAssistant = (id, options) => {
  const api = useApi();
  const result = useSWR(id ? `/group-assistant/${id}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const IMAGE_SIZE = 128;
const MaybeAvatar = ({
  avatar
}) => {
  if (avatar) {
    return /* @__PURE__ */ jsx(ScaledImageProxy, {
      className: "rounded-full border-2 border-black/30 outline-none",
      uuid: avatar.uuid,
      w: IMAGE_SIZE,
      h: IMAGE_SIZE,
      crop: true
    });
  }
  return /* @__PURE__ */ jsx("div", {
    style: {
      minWidth: IMAGE_SIZE,
      minHeight: IMAGE_SIZE,
      width: IMAGE_SIZE,
      height: IMAGE_SIZE
    },
    className: "rounded-full border-2 border-black/30 outline-none"
  });
};
const cleanHeadline = (headline) => "*" + headline.split("\\*").join("*").split("*").join("").trim();
const escapeHtml = (str) => {
  const map = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  };
  return str.replace(/[&<>"']/g, function(m) {
    return map[m];
  });
};
const AssistantFeedbackItem = ({
  item,
  mode,
  selectedFeedback,
  onSelectionChange
}) => {
  const api = useApi();
  const [showMore, setShowMore] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [result, setResult] = useState("");
  const {
    started,
    errors,
    post,
    _id,
    title,
    reply,
    result: results,
    status,
    notes,
    externalOutput,
    externalInput: externalInputRaw,
    feedback
  } = item;
  const externalInput = !externalInputRaw ? [] : externalInputRaw.filter((v) => v);
  const errorStatus = errors && errors.length > 0;
  const onResult = () => {
    setResult(result ? null : reply);
  };
  const {
    onClick: onResubmit,
    loading: resubmitting
  } = useLoading(async () => {
    await api.post({
      path: `/ai/group/resubmit`,
      body: {
        ids: externalInput
      }
    });
  });
  results && results.map(cleanHeadline).map(escapeHtml);
  if (!feedback) {
    return null;
  }
  if (mode === SELECTED_MODE) {
    const hasSelected = Object.values(feedback).some(({
      uuid
    }) => {
      return selectedFeedback.has(`${_id}-${uuid}`);
    });
    if (!hasSelected) {
      return null;
    }
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col justify-stretch",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx(RelativeTime, {
          value: started
        })
      }), notes && notes.length > 0 && notes.map((note) => /* @__PURE__ */ jsx(Chip$1, {
        label: note,
        size: "small"
      }, note)), errorStatus && /* @__PURE__ */ jsxs("div", {
        className: "bg-red-500 rounded p-0.5 cursor-pointer",
        onClick: () => setShowErrors((e) => !e),
        children: [" ", errors.length + " errors"]
      }), /* @__PURE__ */ jsx(Chip$1, {
        label: status,
        size: "small"
      }), !errorStatus && status === "finished" && /* @__PURE__ */ jsx(Chip$1, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.success"
        }),
        size: "small"
      }), title && /* @__PURE__ */ jsx("div", {
        className: "underline cursor-pointer",
        onClick: onResult,
        children: title
      }), /* @__PURE__ */ jsx("div", {
        className: "grow"
      }), /* @__PURE__ */ jsx("div", {
        className: "underline cursor-pointer",
        onClick: () => setShowMore((v) => !v),
        children: "more.."
      })]
    }, _id), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [Object.entries(feedback).map(([uuid, feedback2]) => {
        const isSelected = selectedFeedback.has(`${_id}-${uuid}`);
        if (mode === SELECTED_MODE && !isSelected) {
          return null;
        }
        return /* @__PURE__ */ jsx(HeadlineFeedback, {
          id: _id,
          feedback: feedback2,
          isSelected,
          onSelectionChange: (selected) => onSelectionChange(_id, uuid, selected)
        }, uuid);
      }), showMore && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx("div", {
          className: "cursor-pointer underline",
          onClick: () => setShowMore(false),
          children: "More:"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex gap-2 items-center",
          children: [/* @__PURE__ */ jsxs("div", {
            children: ["id: ", _id]
          }), /* @__PURE__ */ jsxs("div", {
            children: ["time: ", started]
          })]
        }), externalOutput && externalOutput.length > 0 && /* @__PURE__ */ jsxs("div", {
          className: "flex gap-1",
          children: [/* @__PURE__ */ jsx("div", {
            children: "Output:"
          }), externalOutput.map((one) => /* @__PURE__ */ jsx("div", {
            children: one
          }, one))]
        }), externalInput.length > 0 && /* @__PURE__ */ jsxs("div", {
          className: "flex gap-1 items-center",
          children: [/* @__PURE__ */ jsx("div", {
            children: "Input:"
          }), externalInput.map((one) => /* @__PURE__ */ jsx("div", {
            children: one
          }, one)), /* @__PURE__ */ jsx(LoadingButton, {
            variant: "outlined",
            loading: resubmitting,
            onClick: () => onResubmit(),
            children: "Resubmit"
          })]
        })]
      })]
    }), result && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "cursor-pointer underline",
        onClick: () => setResult(null),
        children: "AI result:"
      }), /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: result
        }
      })]
    }), showErrors && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "cursor-pointer underline",
        onClick: () => setShowErrors((e) => !e),
        children: [errors.length + " errors", ":"]
      }), errors.map((error, i) => /* @__PURE__ */ jsxs("div", {
        className: "p-2",
        children: [i + 1, ". ", error]
      }, error))]
    })]
  });
};
const HeadlineFeedback = ({
  feedback,
  id,
  isSelected,
  onSelectionChange: onSelectionChange1
}) => {
  const api = useApi();
  useState(false);
  const {
    initial,
    updated,
    comment,
    uuid
  } = feedback;
  const [commentValue, setCommentValue] = useState(comment);
  const onSelectionChange = (selected) => {
    onSelectionChange1(selected);
    try {
      doSave(selected);
    } catch (error) {
      onSelectionChange1(!selected);
      throw error;
    }
  };
  useEffect(() => {
    if (comment !== commentValue) {
      setCommentValue(comment);
    }
  }, [comment]);
  const handleChangeComment = (e) => {
    const value = e.target.value;
    setCommentValue(value);
  };
  const {
    onClick: doSave,
    loading: loadingOnSave
  } = useLoading(async (selected) => {
    await api.post({
      path: "/ai/assistant/feedback",
      body: {
        id,
        feedback: {
          ...feedback,
          comment: commentValue,
          saved: selected
        }
      }
    });
  });
  const onSave = () => {
    doSave(isSelected);
  };
  return /* @__PURE__ */ jsx(Fragment$1, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex items-start gap-2",
      children: [/* @__PURE__ */ jsx(Checkbox$1, {
        checked: isSelected,
        onChange: (e) => onSelectionChange(e.target.checked),
        color: "primary"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex gap-2",
          children: [/* @__PURE__ */ jsx("div", {
            className: "font-semibold",
            children: "AI-Generated Headline:"
          }), /* @__PURE__ */ jsx("div", {
            children: initial
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex gap-2",
          children: [/* @__PURE__ */ jsx("div", {
            className: "font-semibold",
            children: "Editor Corrected Headline:"
          }), /* @__PURE__ */ jsx("div", {
            children: updated
          })]
        }), /* @__PURE__ */ jsx(TextField$1, {
          label: "comment",
          multiline: true,
          rows: 4,
          value: commentValue || "",
          onChange: handleChangeComment,
          variant: "outlined",
          className: "w-full"
        }), /* @__PURE__ */ jsx(Tooltip$2, {
          title: "Optional comment save",
          children: /* @__PURE__ */ jsx(LoadingButton, {
            onClick: onSave,
            loading: loadingOnSave,
            children: "Save Comment"
          })
        })]
      })]
    })
  }, uuid);
};
const useFeedbackFns = () => {
  const api = useApi();
  const createPost = async (id, selectedItems) => {
    return await api.post({
      path: "/ai/assistant/feedback-post",
      body: {
        assistant: id,
        selectedItems
      }
    });
  };
  const updateFeedback = async (id) => {
    return await api.post({
      path: "/ai/assistant/server-feedback",
      body: {
        assistant: id
      }
    });
  };
  return {
    createPost,
    updateFeedback
  };
};
const createSelectedFeedbackFromLogs = (logs) => {
  const selectedSet = new Set();
  logs.forEach((log) => {
    if (log.feedback) {
      Object.entries(log.feedback).forEach(([uuid, feedbackData]) => {
        if (feedbackData.saved) {
          selectedSet.add(`${log._id}-${uuid}`);
        }
      });
    }
  });
  return selectedSet;
};
const AssistantFeedback = ({
  id,
  assistant
}) => {
  const {
    createPost,
    updateFeedback
  } = useFeedbackFns();
  const [mode, setMode] = useState(ALL_MODE);
  const [selectedFeedback, setSelectedFeedback] = useState(new Set());
  const [logs, setLogs] = useState([]);
  const [size, setSize] = useState(50);
  const {
    data,
    mutate
  } = useAssistantLogs$1({
    id,
    size,
    feedback: true
  });
  const {
    name,
    lastFeedback
  } = assistant;
  const [lastFeedbackTime, setLastFeedbackTime] = useState(lastFeedback);
  useEffect(() => {
    setLastFeedbackTime(lastFeedback);
  }, [lastFeedback]);
  const handleSelectionChange = (executionId, uuid, selected) => {
    setSelectedFeedback((prev) => {
      const newSet = new Set(prev);
      const key = `${executionId}-${uuid}`;
      if (selected) {
        newSet.add(key);
      } else {
        newSet.delete(key);
      }
      return newSet;
    });
  };
  const {
    onClick: onUpdateFeedbackPost,
    loading: loadingCreated
  } = useLoading(async () => {
    const selectedItems = [];
    logs.forEach((log) => {
      if (log.feedback) {
        Object.entries(log.feedback).forEach(([uuid, feedbackData]) => {
          if (selectedFeedback.has(`${log._id}-${uuid}`)) {
            selectedItems.push({
              executionId: log._id,
              uuid,
              ...feedbackData
            });
          }
        });
      }
    });
    const {
      lastFeedback: lastFeedback2
    } = await createPost(id, selectedItems);
    setLastFeedbackTime(lastFeedback2);
  });
  const modeProps = (buttonMode) => {
    return {
      variant: buttonMode === mode ? "contained" : "outlined",
      onClick: () => setMode(buttonMode)
    };
  };
  useEffect(() => {
    const logs2 = data && data.logs || [];
    setLogs(logs2);
    setSelectedFeedback(createSelectedFeedbackFromLogs(logs2));
  }, [data && data.logs]);
  const handleChange = (e) => {
    const value = e.target.value;
    setSize(parseInt(value) || 50);
  };
  const {
    onClick: onUpdateFeedback,
    loading: loadingOnServer
  } = useLoading(async () => {
    await updateFeedback(id);
    mutate();
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs(ButtonGroup, {
      size: "small",
      color: "primary",
      "aria-label": "type",
      children: [/* @__PURE__ */ jsx(Button, {
        ...modeProps(ALL_MODE),
        children: "all"
      }), /* @__PURE__ */ jsxs(Button, {
        ...modeProps(SELECTED_MODE),
        children: ["saved items (", selectedFeedback.size, ")"]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex bg-[#00A5B6]  p-2 text-white text-lg rounded-md w-full",
      children: [/* @__PURE__ */ jsxs("div", {
        children: ["Editorial feedback for ", name]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex-grow"
      }), /* @__PURE__ */ jsx("a", {
        href: `/trans/circle-view-assistant/${id}`,
        className: "underline",
        children: "activities"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: [/* @__PURE__ */ jsx("div", {
        children: "Last feedback update time:"
      }), /* @__PURE__ */ jsx(RelativeTime, {
        value: lastFeedbackTime
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/* @__PURE__ */ jsx(TextField$1, {
        defaultValue: size || "",
        onChange: handleChange,
        label: "Number of records",
        variant: "outlined"
      }), /* @__PURE__ */ jsx(Button, {
        onClick: () => mutate(),
        variant: "outlined",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.update"
        })
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onUpdateFeedback,
        variant: "outlined",
        loading: loadingOnServer,
        children: "Feedback"
      }), /* @__PURE__ */ jsxs(LoadingButton, {
        onClick: onUpdateFeedbackPost,
        variant: "outlined",
        loading: loadingCreated,
        disabled: selectedFeedback.size === 0,
        children: ["Create post (", selectedFeedback.size, " selected)"]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2 p-2 w-full justify-stretch",
      children: logs.map((item) => /* @__PURE__ */ jsx(AssistantFeedbackItem, {
        item,
        mode,
        selectedFeedback,
        onSelectionChange: handleSelectionChange
      }, item._id))
    })]
  });
};
const AssistantFeedbackInner = ({
  id
}) => {
  const api = useApi();
  const timeState = useTimePanelState();
  const {
    data
  } = useAssistant(id);
  const [assistant, setAssistant] = useState(null);
  const [feedback, setFeedback] = useState("");
  const [time, setTime] = useState("");
  const [total, setTotal] = useState(0);
  const [autoSave, setAutoSave] = useState(false);
  useEffect(() => {
    if (!data) {
      return;
    }
    const {
      assistant: assistant2
    } = data;
    setAssistant(assistant2);
    const timeData = new EventTemporalData(assistant2);
    const {
      time1,
      date1,
      date2,
      time2,
      tzOffset,
      timezone
    } = timeData;
    const {
      setDate1,
      setDate2,
      setTzOffset,
      setTime1,
      setTime2,
      setTimezone
    } = timeState;
    setDate1(date1);
    setTimezone(timezone || getUserTimezone());
    setTzOffset(tzOffset);
    setDate2(date2);
    setTime1(time1);
    setTime2(time2);
    setFeedback(assistant2.feedback);
    setTime(assistant2.feedbackTime);
    setTotal(assistant2.feedbackItems);
    setAutoSave(assistant2.feedbackEnabled);
  }, [data]);
  if (!assistant) {
    return null;
  }
  const {
    name,
    description,
    avatar,
    group,
    user,
    paused,
    active
  } = assistant;
  const updateAssistant = async (update) => {
    const {
      _id
    } = assistant;
    const request = {
      _id,
      ...update
    };
    await api.post({
      path: `/group-assistant`,
      body: request
    });
  };
  const handleChangePost = async (e) => {
    const value = e.target.value;
    await updateAssistant({
      feedback: value
    });
    setFeedback(value);
  };
  const handleChangeTime = async (e) => {
    const value = e.target.value;
    await updateAssistant({
      feedbackTime: value
    });
    setTime(value);
  };
  const handleChangeTotal = async (e) => {
    const value = parseInt(e.target.value) || 0;
    await updateAssistant({
      feedbackItems: value
    });
    setTotal(value);
  };
  const handleChangeEnabled = async (e) => {
    const value = !autoSave;
    await updateAssistant({
      feedbackEnabled: value
    });
    setAutoSave(value);
  };
  return /* @__PURE__ */ jsx(LoadCircleData, {
    circleId: group,
    children: /* @__PURE__ */ jsxs("div", {
      className: "ns w-full p-2 flex flex-col gap-4 text-sm",
      children: [/* @__PURE__ */ jsx(AssistantNavigation, {
        assistant,
        edit: true
      }), /* @__PURE__ */ jsx(BreadCrumbs, {}), /* @__PURE__ */ jsx(MaybeAvatar, {
        avatar
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full gap-2 items-center",
        children: [/* @__PURE__ */ jsx(TextField$1, {
          className: "flex-grow max-w-2xl",
          defaultValue: feedback || "",
          onChange: handleChangePost,
          label: "Post ID for feedback",
          variant: "outlined"
        }), feedback && /* @__PURE__ */ jsx(Link$1, {
          href: `/trans/post-view/${feedback}`,
          underline: "always",
          children: "Open Post"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full gap-2 items-center",
        children: [/* @__PURE__ */ jsx(TextField$1, {
          className: "flex-grow max-w-2xl",
          defaultValue: time || "",
          onChange: handleChangeTime,
          label: "Post autosave time (hh:mm)",
          variant: "outlined"
        }), /* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Checkbox$1, {
            checked: autoSave,
            onChange: handleChangeEnabled,
            name: "checkedB",
            color: "primary"
          }),
          label: "Enable"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex w-full gap-2 items-center",
        children: /* @__PURE__ */ jsx(TextField$1, {
          className: "flex-grow max-w-2xl",
          defaultValue: typeof total === "number" ? total : "",
          onChange: handleChangeTotal,
          label: "Items in post",
          variant: "outlined"
        })
      }), /* @__PURE__ */ jsx(AssistantFeedback, {
        id,
        assistant
      })]
    })
  });
};
const CircleAssistantFeedbackView = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const id = path[2];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(AssistantFeedbackInner, {
      id
    })]
  });
};

const isStale = (last, started) => {
  const now = Date.now();
  const FIFTEEN_MINUTES = 15 * 60 * 1e3;
  const ONE_DAY = 24 * 60 * 60 * 1e3;
  const lastTime = last ? new Date(last).getTime() : now;
  const startedTime = started ? new Date(started).getTime() : lastTime;
  const timeSinceLastUpdate = now - lastTime;
  const timeSinceStart = now - startedTime;
  return timeSinceLastUpdate > FIFTEEN_MINUTES || timeSinceStart > ONE_DAY;
};
const isYoung = (execution) => {
  const started = execution.started;
  if (!started) {
    return false;
  }
  const YOUNG_AGE = 1 * 60 * 1e3;
  const now = Date.now();
  const startedTime = new Date(started).getTime();
  if (isNaN(startedTime)) {
    return false;
  }
  return now - startedTime < YOUNG_AGE;
};
const isStaleAsyncExecution = (execution) => {
  const {
    last,
    started
  } = execution;
  return isStale(last, started);
};

const MAX_MESSAGES$4 = 30;
const MAX_LOGS$2 = 100;
const useTrackCoordinatorJob = () => {
  const api = useApi();
  const jwt = useJwt();
  const isMountedRef = useRef(true);
  const [params, setParams] = useState(null);
  const [counter, setCounter] = useState(0);
  const [messages, setMessages] = useState([]);
  const [logs, setLogs] = useState([]);
  const [progress, setProgress] = useState(null);
  const [isComplete, setIsComplete] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const url = useMemo(() => {
    if (!counter || !jwt || !params) {
      return null;
    }
    const { executionId } = params;
    const queryParams = {
      token: jwt,
      executionId
    };
    return api.buildUrl("/admin/rag/track-coordinator-job", queryParams);
  }, [counter, api, jwt, params]);
  const addMessage = useMemoizedFn((event, data) => {
    if (!isMountedRef.current)
      return;
    const newMessage = {
      id: Date.now().toString() + Math.random(),
      event,
      timestamp: new Date(),
      data
    };
    setMessages((prev) => {
      const updated = [newMessage, ...prev];
      return updated.slice(0, MAX_MESSAGES$4);
    });
  });
  const {
    isConnected,
    error: sseError,
    disconnect,
    reconnect
  } = useSSEConnection({
    url: url || "",
    enabled: counter > 0 && !connectionError && !!url,
    dependencies: [counter],
    onOpen: () => {
      if (!isMountedRef.current)
        return;
      setIsComplete(false);
      setConnectionError(null);
      setMessages([]);
      setLogs([]);
      setProgress(null);
    },
    onError: (err) => {
      if (!isMountedRef.current)
        return;
      console.error("SSE connection error:", err);
      setConnectionError(new Error("Connection error"));
    },
    onClose: () => {
    }
  }, [
    {
      event: "progress",
      handler: (data) => {
        addMessage("progress", data);
        if (!isMountedRef.current)
          return;
        setProgress(data);
      }
    },
    {
      event: "complete",
      handler: (data) => {
        addMessage("complete", data);
        if (!isMountedRef.current)
          return;
        setIsComplete(true);
        setTimeout(() => {
          if (isMountedRef.current) {
            disconnect();
          }
        }, 100);
      }
    },
    {
      event: "failed",
      handler: (data) => {
        const errorData = data || {};
        const errorMessage = errorData.message || errorData.error || String(data) || "Unknown error";
        addMessage("failed", { message: errorMessage, ...errorData });
        if (!isMountedRef.current)
          return;
        setConnectionError(new Error(errorMessage));
        setTimeout(() => {
          if (isMountedRef.current) {
            disconnect();
          }
        }, 100);
      }
    },
    {
      event: "log",
      handler: (logEvent) => {
        addMessage("log", logEvent);
        if (!isMountedRef.current)
          return;
        setLogs((prev) => {
          const updated = [...prev, logEvent];
          return updated.slice(-MAX_LOGS$2);
        });
      }
    }
  ]);
  useEffect(() => {
    if (!isMountedRef.current)
      return;
    if (sseError) {
      setConnectionError(sseError);
    }
  }, [sseError]);
  const mutate = useMemoizedFn(() => {
    reconnect();
  });
  const start = useMemoizedFn((startParams) => {
    setParams(startParams);
    setCounter((c) => c + 1);
    setConnectionError(null);
  });
  const clear = useMemoizedFn(() => {
    setConnectionError(null);
    setMessages([]);
    setLogs([]);
    setProgress(null);
  });
  return {
    messages,
    logs,
    progress,
    isConnected,
    isComplete,
    error: connectionError,
    isValidating: isConnected,
    start,
    clear,
    disconnect,
    mutate
  };
};

const BullMQProgressTracker = ({
  executionId,
  refresh
}) => {
  const [isTracking, setIsTracking] = useState(false);
  const {
    progress,
    isComplete,
    error: connectionError,
    start,
    disconnect,
    mutate,
    isConnected
  } = useTrackCoordinatorJob();
  useEffect(() => {
    if (!isTracking && executionId) {
      setIsTracking(true);
      start({
        executionId
      });
    }
    return () => {
      if (isTracking) {
        disconnect();
        setIsTracking(false);
      }
    };
  }, [executionId]);
  useEffect(() => {
    if (isComplete && isTracking) {
      setIsTracking(false);
      disconnect();
    }
    if (refresh) {
      setTimeout(() => {
        refresh();
      }, 500);
    }
  }, [isComplete, isTracking]);
  const handleRetry = () => {
    setIsTracking(true);
    mutate();
  };
  if (!isTracking && !connectionError) {
    return null;
  }
  if (connectionError) {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 px-2 py-1 bg-red-50 rounded text-sm",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-red-600",
        children: "Connection error"
      }), /* @__PURE__ */ jsxs("button", {
        onClick: handleRetry,
        className: "flex items-center gap-1 text-red-600 hover:text-red-700 underline",
        children: [/* @__PURE__ */ jsx(MdRefresh, {
          size: 14
        }), /* @__PURE__ */ jsx("span", {
          children: "Retry"
        })]
      })]
    });
  }
  if (isComplete && progress) {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 text-sm text-green-600",
      children: [/* @__PURE__ */ jsx("span", {
        children: "\u2713"
      }), /* @__PURE__ */ jsxs("span", {
        children: ["Completed: ", progress.completed]
      }), progress.failed > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-red-600",
        children: ["Failed: ", progress.failed]
      })]
    });
  }
  if (!progress || !isConnected) {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2 text-sm text-gray-500",
      children: [/* @__PURE__ */ jsx(Spinner, {
        size: "sm"
      }), /* @__PURE__ */ jsx("span", {
        children: "Connecting..."
      })]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-2 text-sm",
    children: [/* @__PURE__ */ jsx(Spinner, {
      size: "sm"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: [progress.completed > 0 && /* @__PURE__ */ jsx(Chip$1, {
        label: `\u2713 ${progress.completed}`,
        size: "small",
        style: {
          backgroundColor: "#10b981",
          color: "white"
        }
      }), progress.inProgress > 0 && /* @__PURE__ */ jsx(Chip$1, {
        label: `\u27F3 ${progress.inProgress}`,
        size: "small",
        style: {
          backgroundColor: "#3b82f6",
          color: "white"
        }
      }), progress.failed > 0 && /* @__PURE__ */ jsx(Chip$1, {
        label: `\u2717 ${progress.failed}`,
        size: "small",
        style: {
          backgroundColor: "#ef4444",
          color: "white"
        }
      })]
    }), progress.timestamp && /* @__PURE__ */ jsx("span", {
      className: "text-gray-400",
      children: /* @__PURE__ */ jsx(RelativeTime, {
        value: progress.timestamp
      })
    })]
  });
};

const useResumeExecution = (executionId, setItem) => {
  const api = useApi();
  const {
    addToast
  } = useToast();
  const {
    execute,
    isLoading,
    error
  } = useAsyncOperation(async () => {
    const result = await api.post({
      path: "/rag/resume-circle-indexing",
      body: {
        executionId
      }
    });
    const {
      execution,
      skipped,
      reason
    } = result;
    if (skipped) {
      addToast({
        type: "error",
        title: "Failed to resume",
        message: reason
      });
    }
    if (execution) {
      setItem(execution);
    }
    return result;
  });
  return {
    resume: execute,
    isLoading,
    error
  };
};

const AsyncExecutionItem = ({
  item: itemParameter,
  depth = 0,
  refresh
}) => {
  useState(false);
  const [showMore, setShowMore] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [result, setResult] = useState("");
  const [item, setItem] = useState(itemParameter);
  useEffect(() => {
    setItem(itemParameter);
  }, [itemParameter]);
  const {
    data,
    started,
    error,
    _id,
    title,
    status,
    notes,
    input,
    processed = 0,
    circles = [],
    last,
    children = []
  } = item;
  const {
    resume,
    isLoading: resumeLoading
  } = useResumeExecution(_id, setItem);
  const {
    circleId
  } = input || {};
  const errorStatus = error && error.length > 0;
  const stale = isStaleAsyncExecution(item);
  const waiting = !stale && status === "executing";
  const api = useApi();
  const {
    addToast
  } = useToast();
  const stopExecution = useAsyncOperation(async () => {
    const {
      execution,
      stopped
    } = await api.post({
      path: `/vector/stop-execution`,
      body: {
        executionId: _id
      }
    });
    setItem(execution);
    addToast({
      type: "success",
      title: "Execution stopped",
      message: `Stopped ${stopped.children} execution`
    });
  });
  const hasBullMQJob = data && data.coordinatorJobId;
  const shouldShowBullMQProgress = hasBullMQJob && status === "executing" && !stale;
  const canResume = hasBullMQJob || true;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col justify-stretch",
    style: {
      paddingLeft: depth > 0 ? "20px" : "0",
      borderLeft: depth > 0 ? "2px solid #E5E7EB" : "none"
    },
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center relative",
      children: [waiting && /* @__PURE__ */ jsx(MuiSpinner, {}), status && /* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx(RelativeTime, {
          value: started
        })
      }), notes && notes.length > 0 && notes.map((note) => /* @__PURE__ */ jsx(Chip$1, {
        label: note,
        size: "small"
      }, note)), errorStatus && /* @__PURE__ */ jsx("div", {
        className: "bg-red-500 rounded p-0.5 cursor-pointer",
        onClick: () => setShowErrors((e) => !e),
        children: error.length + " errors"
      }), status && /* @__PURE__ */ jsx(Chip$1, {
        label: status,
        size: "small"
      }), stale && status === "executing" && /* @__PURE__ */ jsx(Chip$1, {
        label: "stuck",
        size: "small"
      }), !errorStatus && status === "finished" && status && /* @__PURE__ */ jsx(Chip$1, {
        label: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.success"
        }),
        size: "small"
      }), title && /* @__PURE__ */ jsx("a", {
        href: circleUrl(circleId),
        children: /* @__PURE__ */ jsx("div", {
          className: "underline cursor-pointer",
          children: title
        })
      }), status && /* @__PURE__ */ jsxs("div", {
        children: ["processed: ", processed]
      }), last && status && /* @__PURE__ */ jsx(Chip$1, {
        label: /* @__PURE__ */ jsx(RelativeTime, {
          value: last
        }),
        size: "small"
      }), /* @__PURE__ */ jsx("div", {
        className: "grow"
      }), !status && /* @__PURE__ */ jsx(Tooltip$1, {
        content: "Stop execution",
        children: /* @__PURE__ */ jsx(MdStop, {
          className: "cursor-pointer text-red-500 hover:text-red-700 w-5 h-5",
          onClick: () => stopExecution.execute()
        })
      }), status && /* @__PURE__ */ jsx("div", {
        className: "underline cursor-pointer",
        onClick: () => setShowMore((v) => !v),
        children: "more.."
      })]
    }, _id), shouldShowBullMQProgress && /* @__PURE__ */ jsx(BullMQProgressTracker, {
      executionId: _id,
      refresh
    }), showMore && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "cursor-pointer underline",
        onClick: () => setShowMore(false),
        children: "More:"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center",
        children: [/* @__PURE__ */ jsxs("div", {
          children: ["Job ID: ", _id]
        }), /* @__PURE__ */ jsxs("div", {
          children: ["Job started: ", started]
        })]
      }), canResume && /* @__PURE__ */ jsx(ActionButton, {
        onClick: resume,
        disabled: resumeLoading,
        style: {
          marginLeft: 8,
          padding: "2px 10px",
          fontSize: 12,
          cursor: resumeLoading ? "not-allowed" : "pointer",
          opacity: resumeLoading ? 0.6 : 1
        },
        children: resumeLoading ? "Resuming\u2026" : "Resume"
      }), /* @__PURE__ */ jsx("div", {
        children: "Circles:"
      }), circles.length > 0 && circles.map((circle) => {
        const {
          _id: _id2,
          name
        } = circle;
        return /* @__PURE__ */ jsx("div", {
          className: "underline",
          children: /* @__PURE__ */ jsx("a", {
            href: circleUrl(_id2),
            children: name
          })
        }, _id2);
      })]
    }), result && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "cursor-pointer underline",
        onClick: () => setResult(null),
        children: "AI result:"
      }), /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: result
        }
      })]
    }), showErrors && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-stretch px-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "cursor-pointer underline",
        onClick: () => setShowErrors((e) => !e),
        children: [error.length + " errors", ":"]
      }), error.map((error2, i) => /* @__PURE__ */ jsxs("div", {
        className: "p-2",
        children: [i + 1, ". ", error2]
      }, error2))]
    }), children && children.length > 0 && /* @__PURE__ */ jsx("div", {
      className: "mt-1",
      children: children.map((child) => /* @__PURE__ */ jsx(AsyncExecutionItem, {
        item: child,
        depth: depth + 1
      }, child._id))
    })]
  });
};

const VECTOR_INDEX_EXECUTION_TYPE = "vector.index";
const NORMAL_REFRESH_INTERVAL = 3 * 60 * 1e3;
const FAST_REFRESH_INTERVAL = 10 * 1e3;
const needFrequentUpdates = (executions) => {
  if (!executions || executions.length === 0) {
    return false;
  }
  for (const execution of executions) {
    if (execution.status === "executing" && !isStaleAsyncExecution(execution)) {
      return true;
    }
    if (!execution.status && isYoung(execution)) {
      return true;
    }
    if (needFrequentUpdates(execution.children)) {
      return true;
    }
  }
  return false;
};
const useExecutionsArray = ({
  circleId,
  type = VECTOR_INDEX_EXECUTION_TYPE
}) => {
  const api = useApi();
  const {
    data,
    mutate
  } = useSWR(circleId ? [`/async-execution/group`, circleId, type] : null, async () => {
    return await api.get({
      path: `/async-execution/group/?group=${circleId}&type=${type}`
    });
  }, {
    refreshInterval: (data2) => {
      if (!data2 || !data2.executions) {
        return NORMAL_REFRESH_INTERVAL;
      }
      const {
        executions
      } = data2;
      if (needFrequentUpdates(executions)) {
        console.log("FAST_REFRESH_INTERVAL");
        return FAST_REFRESH_INTERVAL;
      }
      console.log("NORMAL_REFRESH_INTERVAL");
      return NORMAL_REFRESH_INTERVAL;
    },
    revalidateOnFocus: false
  });
  const array = data && data.executions || [];
  const addExecutions = useMemoizedFn((executions) => {
    const all = {};
    array.forEach(({
      _id
    }) => {
      all[_id] = true;
    });
    const added = executions.filter(({
      _id
    }) => !all[_id]);
    if (!added.length) {
      return;
    }
    mutate({
      executions: [...added, ...array]
    });
  });
  const addExecution = useMemoizedFn((obj) => {
    if (array.find(({
      _id
    }) => _id === obj._id)) {
      return;
    }
    mutate({
      executions: [obj, ...array]
    });
  });
  return {
    executions: array,
    addExecution,
    addExecutions,
    refresh: mutate
  };
};

const Frame = ({
  title,
  headerRight,
  children
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 p-2 border-[#F5F5F5] rounded-xl border mt-2 bg-white relative",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between -mt-5 mx-4 px-2",
      children: [/* @__PURE__ */ jsx("div", {
        className: "font-semibold text-base text-gray-500",
        children: title
      }), headerRight && /* @__PURE__ */ jsx("div", {
        className: "text-sm text-gray-400",
        children: headerRight
      })]
    }), children]
  });
};

const useGraphQLErrorHandling = () => {
  const [errorMessages, setErrorMessages] = useState([]);
  const handleGraphQLErrors = (error) => {
    let messages;
    if (error && error.response && error.response.errors) {
      messages = error.response.errors.map((err) => err.message);
      setErrorMessages(messages);
    } else {
      messages = ["An unexpected error occurred. Please try again later."];
      setErrorMessages(messages);
    }
    return messages;
  };
  const clearErrors = () => {
    setErrorMessages([]);
  };
  return {
    errorMessages,
    handleGraphQLErrors,
    clearErrors
  };
};

const errorHTML4Array = (errors) => {
  if (errors.length === 0) {
    return "";
  }
  return `
    <strong>Error:</strong>
    <ul>
      ${errors.map((message) => `<li>${message}</li>`).join("")}
    </ul>
  `;
};

const useMutation = (document) => {
  const graphQLClient = useGraphQLClientFn();
  const { errorMessages, handleGraphQLErrors, clearErrors } = useGraphQLErrorHandling();
  const mutate = async (variables) => {
    try {
      const graphqlClient = await graphQLClient();
      const result = await graphqlClient.request(document, variables);
      return result;
    } catch (error) {
      console.error("mutation failed:", error);
      const errors = handleGraphQLErrors(error);
      throw new Error(errorHTML4Array(errors));
    }
  };
  return {
    mutate,
    errorMessages,
    handleGraphQLErrors,
    clearErrors
  };
};

gql$1`
  mutation SaveBatchCircleOptions($input: BatchSaveCircleOptionsInput!) {
    saveBatchCircleOptions(input: $input)
  }
`;
const useSaveBatchCircleOptionsMutation = () => {
  const {
    mutate,
    errorMessages,
    handleGraphQLErrors,
    clearErrors
  } = useMutation(SaveBatchCircleOptionsDocument);
  const saveCircleOptions = async (variables) => {
    return await mutate(variables);
  };
  return {
    saveCircleOptions,
    errorMessages,
    handleGraphQLErrors,
    clearErrors
  };
};

const CLASSIFICATION_OPTIONS = "classification";
const ChunkClassificationConfig = ({
  circleId,
  addExecution,
  classificationControls
}) => {
  useApi();
  const {
    data,
    isValidating
  } = useCircleOptions({
    input: {
      circleId,
      types: [CLASSIFICATION_OPTIONS]
    }
  });
  const {
    saveCircleOptions,
    errorMessages
  } = useSaveBatchCircleOptionsMutation();
  const {
    addToast
  } = useToast();
  const [file, setFile] = useState(null);
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [namedEntities, setNamedEntities] = useState(false);
  const [modelName, setModelName] = useState("");
  const options = data && data.batchCircleOptions.options[0].options;
  useEffect(() => {
    if (options) {
      setConfig(options);
      setNamedEntities(options.namedEntities || false);
      setModelName(options.modelName || "");
    }
  }, [options]);
  useEffect(() => {
    if (config) {
      setConfig({
        ...config,
        namedEntities,
        modelName
      });
    }
  }, [namedEntities, modelName]);
  const {
    execute: onSaveClassification,
    isLoading: savingClassification
  } = useAsyncOperation(async () => {
    const configToSave = config ? {
      ...config,
      namedEntities,
      modelName
    } : {
      namedEntities,
      modelName
    };
    await saveCircleOptions({
      input: {
        circleId,
        options: [{
          type: CLASSIFICATION_OPTIONS,
          options: configToSave
        }]
      }
    });
    console.log("Re-running classification with updated schema:", configToSave);
    addToast({
      type: "success",
      message: "Save classification configuration"
    });
  });
  const validateClassificationConfig = (data2) => {
    try {
      return {
        json: data2,
        namedEntities,
        modelName
      };
    } catch (err) {
      setError(err.message);
      return null;
    }
  };
  const handleFileDrop = useCallback(async (acceptedFiles) => {
    const jsonFile = acceptedFiles[0];
    if (!jsonFile)
      return;
    if (!jsonFile.name.endsWith(".json")) {
      setError("Please upload a JSON file");
      return;
    }
    setFile(jsonFile);
    setLoading(true);
    setError(null);
    try {
      const text = await jsonFile.text();
      const data2 = JSON.parse(text);
      const validConfig = validateClassificationConfig(data2);
      if (validConfig) {
        setConfig({
          ...validConfig,
          name: jsonFile.name
        });
        setError(null);
        addToast({
          type: "success",
          message: `Loaded classification categories`
        });
      }
    } catch (err) {
      setError("Invalid JSON file format");
      setConfig(null);
    } finally {
      setLoading(false);
    }
  }, [namedEntities, modelName]);
  const handleRemoveConfig = useCallback(() => {
    setFile(null);
    setConfig(null);
    setError(null);
  }, []);
  const dropzone = useDropzone({
    onDrop: handleFileDrop,
    accept: [".json"],
    maxFiles: 1
  });
  return /* @__PURE__ */ jsx(Fragment, {
    children: /* @__PURE__ */ jsxs("div", {
      className: "border border-gray-200 rounded-lg p-2",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-xl font-semibold mb-4",
        children: "Classifications"
      }), classificationControls, /* @__PURE__ */ jsxs(FormSection, {
        className: "mb-4",
        children: [/* @__PURE__ */ jsx(Checkbox, {
          checked: namedEntities,
          onChange: (event) => setNamedEntities(event.target.checked),
          label: "Named Entities extraction (people, organizations, places)"
        }), /* @__PURE__ */ jsx(TextInput, {
          value: modelName,
          onChange: (event) => setModelName(event.target.value),
          label: "LLM Model Name",
          placeholder: "e.g., gpt-5.5, claude-3-sonnet, deepseek-chat",
          helperText: "Specify which AI model to use for classification"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-4 p-4 border border-gray-200 rounded-lg",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "text-lg font-semibold",
          children: "Custom classifications"
        }), /* @__PURE__ */ jsx("div", {
          className: "text-sm text-gray-600",
          children: "Upload a JSON file containing classification categories to automatically categorize chunks"
        }), /* @__PURE__ */ createElement(DropZone, {
          ...dropzone,
          key: String(loading)
        }, loading && /* @__PURE__ */ jsx("div", {
          className: "absolute inset-0 flex items-center justify-center bg-white bg-opacity-75",
          children: /* @__PURE__ */ jsx(Spinner, {})
        })), error && /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded text-sm text-red-700",
          children: [/* @__PURE__ */ jsx(MdOutlineClose, {
            className: "text-red-500"
          }), error]
        }), config && config.json && /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-3",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2",
              children: [/* @__PURE__ */ jsx(MdOutlineCheck, {
                className: "text-green-600"
              }), /* @__PURE__ */ jsxs("span", {
                className: "text-sm font-medium text-green-700",
                children: [/* @__PURE__ */ jsx("span", {
                  children: "Configuration loaded"
                }), /* @__PURE__ */ jsx("span", {
                  children: ":"
                }), /* @__PURE__ */ jsx("span", {
                  children: config.name
                })]
              })]
            }), /* @__PURE__ */ jsx("button", {
              onClick: handleRemoveConfig,
              className: "text-sm text-red-600 hover:text-red-700 underline",
              children: "Remove"
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "p-3 bg-gray-50 rounded",
            children: [/* @__PURE__ */ jsx("div", {
              className: "text-sm font-medium mb-2",
              children: "Categories loaded"
            }), /* @__PURE__ */ jsx("div", {
              className: "flex flex-wrap gap-2"
            })]
          }), config.description && /* @__PURE__ */ jsxs("div", {
            className: "text-sm text-gray-600",
            children: [/* @__PURE__ */ jsx("span", {
              className: "font-medium",
              children: "Description:"
            }), " ", config.description]
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: "text-xs text-gray-500 bg-gray-100 py-2",
          children: "Categories loaded"
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "gray",
          size: "sm",
          isLoading: savingClassification,
          loadingText: "Re-running...",
          onClick: onSaveClassification,
          leftIcon: !savingClassification && /* @__PURE__ */ jsx(MdOutlinePlayArrow, {
            className: "h-4 w-4"
          }),
          children: "Save Classification"
        })]
      })]
    })
  });
};

const IndexingOptionsPanel = ({
  options,
  onChange
}) => {
  const handleOptionChange = (key) => (event) => {
    onChange({
      ...options,
      [key]: event.target.checked
    });
  };
  return /* @__PURE__ */ jsx(CollapsibleSection, {
    title: "Indexing Options (Advanced)",
    defaultCollapsed: true,
    variant: "default",
    titleSize: "sm",
    contentSize: "sm",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx(Checkbox, {
        checked: options.recreateChunks,
        onChange: handleOptionChange("recreateChunks"),
        label: "Recreate chunks"
      }), /* @__PURE__ */ jsx(Checkbox, {
        checked: options.recalculateEmbeddings,
        onChange: handleOptionChange("recalculateEmbeddings"),
        label: "Recalculate embeddings"
      }), /* @__PURE__ */ jsx(Checkbox, {
        checked: options.extractCategories,
        onChange: handleOptionChange("extractCategories"),
        label: "Extract categories"
      }), /* @__PURE__ */ jsx(Checkbox, {
        checked: options.extractEntities,
        onChange: handleOptionChange("extractEntities"),
        label: "Extract entities"
      })]
    })
  });
};

const TRANSLATE_QUERY_LANGUAGE_OPTIONS = [{
  value: "en",
  label: "English"
}, {
  value: "ar",
  label: "Arabic"
}, {
  value: "ku",
  label: "Kurdish (Sorani)"
}];
const TranslateQueryLanguagesConfig = ({
  languages,
  onChange
}) => {
  const toggle = (lang) => (event) => {
    if (event.target.checked) {
      onChange([...languages, lang]);
      return;
    }
    onChange(languages.filter((l) => l !== lang));
  };
  return /* @__PURE__ */ jsxs(FormSection, {
    title: "Query translation",
    variant: "outlined",
    children: [/* @__PURE__ */ jsx("p", {
      className: "text-xs text-gray-600",
      children: "When languages are selected, search queries are also translated into each one and matched against content in that language. Leave empty to search only in the query's own language (default)."
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col gap-2",
      children: TRANSLATE_QUERY_LANGUAGE_OPTIONS.map(({
        value,
        label
      }) => /* @__PURE__ */ jsx(Checkbox, {
        checked: languages.includes(value),
        onChange: toggle(value),
        label
      }, value))
    })]
  });
};

const EmbeddingModelsConfig = ({
  useOpenAiEmbeddings,
  useQwenEmbeddings,
  onChangeUseOpenAiEmbeddings,
  onChangeUseQwenEmbeddings
}) => {
  return /* @__PURE__ */ jsxs(FormSection, {
    title: "Embeddings",
    variant: "outlined",
    children: [/* @__PURE__ */ jsx("p", {
      className: "text-xs text-gray-600",
      children: "Which embedding model(s) this circle computes on every post save. Enabling Qwen alongside OpenAI computes both on every save - useful for comparing recall side by side, but doubles embedding API cost for as long as it's on."
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx(Checkbox, {
        checked: useOpenAiEmbeddings,
        onChange: (event) => onChangeUseOpenAiEmbeddings(event.target.checked),
        label: "Use OpenAI embeddings"
      }), /* @__PURE__ */ jsx(Checkbox, {
        checked: useQwenEmbeddings,
        onChange: (event) => onChangeUseQwenEmbeddings(event.target.checked),
        label: "Use Qwen embeddings (testing)"
      })]
    })]
  });
};

const BreadcrumbRow = ({
  children,
  className
}) => /* @__PURE__ */ jsx("div", {
  className: clsx("flex justify-start items-center w-full relative gap-1.5 flex-wrap", className),
  children
});

const CircleBreadcrumbView = ({
  circleId,
  circle,
  current
}) => {
  const parent = circle && circle.parent;
  return /* @__PURE__ */ jsxs(BreadcrumbRow, {
    className: "mb-4",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), parent && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(parent),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: parent.name
        })
      })]
    }), circle && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circleId),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: circle.name
        })
      })]
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(StyledBreadCrumb, {
      children: current
    })]
  });
};

const CircleBreadcrumb = ({
  circleId,
  current
}) => {
  const {
    data: circleData
  } = useCircle(circleId);
  const circle = circleData && circleData.group;
  return /* @__PURE__ */ jsx(CircleBreadcrumbView, {
    circleId,
    circle,
    current
  });
};

const VectorSearchConfigurationPanel = ({
  circleId
}) => {
  const [type, setType] = useState("bulk");
  const [group, setGroup] = useState(null);
  const [groups, setGroups] = useState([]);
  const [index, setIndex] = useState("");
  const [model, setModel] = useState("");
  const [assistant, setAssistant] = useState("");
  const [collection, setCollection] = useState("");
  const [aiSearch, setAISearch] = useState(false);
  const [namedEntities, setNamedEntities] = useState(false);
  const [comments, setComments] = useState(false);
  const [useOpenAiEmbeddings, setUseOpenAiEmbeddings] = useState(true);
  const [useQwenEmbeddings, setUseQwenEmbeddings] = useState(false);
  const [alpha, setAlpha] = useState("");
  const {
    data: circleData
  } = useCircle(circleId);
  const [embeddings, setEmbeddings] = useState(false);
  const [tree, setTree] = useState(false);
  const [minScore, setMinScore] = useState("");
  const [chunkSize, setChunkSize] = useState("");
  const [itemCount, setItemCount] = useState("");
  const [tagsToExclude, setTagsToExclude] = useState("");
  const [translateLanguages, setTranslateLanguages] = useState([]);
  const [translateModelName, setTranslateModelName] = useState("");
  const {
    executions,
    addExecution,
    addExecutions,
    refresh
  } = useExecutionsArray({
    circleId,
    type: type === "bulk" ? VECTOR_INDEX_EXECUTION_TYPE : VECTOR_INDEX_EXECUTION_TYPE + ".update"
  });
  const [indexingOptions, setIndexingOptions] = useState({
    recreateChunks: true,
    recalculateEmbeddings: true,
    extractCategories: true,
    extractEntities: true
  });
  const circle = circleData && circleData.group;
  useEffect(() => {
    if (!circle) {
      return;
    }
    setEmbeddings(circle.embeddings || false);
    setAISearch(circle.aiSearch || false);
  }, [circle && circle.embeddings]);
  const {
    data
  } = useVectorSearchOptions(circleId);
  useDeepCompareEffect(() => {
    if (!data) {
      return;
    }
    const {
      index: index2,
      model: model2,
      collection: collection2,
      namedEntities: namedEntities2,
      comments: comments2,
      minScore: minScore2,
      chunkSize: chunkSize2,
      assistant: assistant2,
      itemCount: itemCount2,
      tagsToExclude: tagsToExclude2,
      circles = [],
      alpha: alpha2,
      translateQuery,
      useOpenAiEmbeddings: useOpenAiEmbeddings2,
      useQwenEmbeddings: useQwenEmbeddings2
    } = data.options;
    setIndex(index2);
    setModel(model2);
    setCollection(collection2);
    setNamedEntities(namedEntities2 || false);
    setComments(comments2 || false);
    setUseOpenAiEmbeddings(useOpenAiEmbeddings2 !== false);
    setUseQwenEmbeddings(useQwenEmbeddings2 || false);
    setMinScore(typeof minScore2 === "number" ? String(minScore2) : "");
    setChunkSize(typeof chunkSize2 === "number" ? String(chunkSize2) : "");
    setAssistant(assistant2 || "");
    setItemCount(typeof itemCount2 === "number" ? String(itemCount2) : "");
    setAlpha(typeof alpha2 === "number" ? String(alpha2) : "0.5");
    setTagsToExclude(tagsToExclude2 ? tagsToExclude2.join(", ") : "");
    setGroups(circles || []);
    setTranslateLanguages(translateQuery && translateQuery.languages || []);
    setTranslateModelName(translateQuery && translateQuery.modelName || "");
  }, [data && data.options]);
  const api = useApi();
  const handleChange = (setter, type2 = "text") => (e) => {
    const value = type2 === "text" ? e.target.value : parseFloat(e.target.value);
    setter(value || "");
  };
  const indexBullMQ = useAsyncOperation(async () => {
    const {
      executions: executions2
    } = await api.post({
      path: `/vector/circle-index-bullmq`,
      body: {
        circleId,
        indexingOptions
      }
    });
    addExecutions(executions2.map((_id) => ({
      _id,
      status: ""
    })));
  });
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async (reIndex = true) => {
    const type2 = "vector-store";
    const options = {
      model,
      index,
      collection,
      namedEntities,
      comments,
      useOpenAiEmbeddings,
      useQwenEmbeddings,
      minScore: minScoreValue(),
      chunkSize: chunkSizeValue(),
      assistant,
      itemCount: itemCountValue(),
      tagsToExclude: tagsToExclude.split(",").map((v) => v.trim()),
      circles: groups || [],
      alpha: alphaValue(),
      translateQuery: translateLanguages.length || translateModelName ? {
        languages: translateLanguages.length ? translateLanguages : void 0,
        modelName: translateModelName || void 0
      } : void 0
    };
    setMinScore(typeof options.minScore === "number" ? String(options.minScore) : "");
    setChunkSize(typeof options.chunkSize === "number" ? String(options.chunkSize) : "");
    setItemCount(typeof options.itemCount === "number" ? String(options.itemCount) : "");
    setAlpha(typeof options.alpha === "number" ? String(options.alpha) : "0.5");
    const booleanProperties = ["elastic", "comments", "namedEntities", "useOpenAiEmbeddings", "useQwenEmbeddings"];
    const unset = [];
    Object.entries(options).forEach(([name, value]) => {
      if (value || value === 0) {
        return;
      }
      if (booleanProperties.includes(name)) {
        return;
      }
      unset.push(name);
    });
    await api.post({
      path: `/admin/options`,
      body: {
        type: type2,
        circleId,
        options,
        unset,
        tree
      }
    });
    if (circleId) {
      await api.post({
        path: `/groups/${circleId}/_partial`,
        body: {
          tree,
          embeddings,
          aiSearch
        }
      });
      if (embeddings) {
        if (reIndex) {
          await indexBullMQ.execute();
        }
      } else {
        await api.post({
          path: `/admin/vector/circle-clear`,
          body: {
            circleId
          }
        });
      }
      if (!isLocalhost() && !embeddings) {
        window.location.href = circleUrl(circleId);
      }
    }
  });
  const chunkSizeValue = () => {
    const value = parseFloat(chunkSize);
    if (isNaN(value)) {
      return null;
    }
    if (typeof value === "number" && value < 0.05) {
      return 0.05;
    }
    return value > 200 ? 200 : value;
  };
  const minScoreValue = () => {
    const value = parseFloat(minScore);
    if (isNaN(value)) {
      return null;
    }
    if (value < 0) {
      return 0;
    }
    return value > 1 ? 1 : value;
  };
  const alphaValue = () => {
    const value = parseFloat(alpha);
    return isNaN(value) ? 0.5 : Math.max(0, Math.min(1, value));
  };
  const itemCountValue = () => {
    const value = parseInt(itemCount);
    if (isNaN(value)) {
      return null;
    }
    if (value < 1) {
      return 1;
    }
    return value;
  };
  const onAddCircle = () => {
    if (!group) {
      return;
    }
    const {
      _id,
      name
    } = group;
    setGroups([...groups, {
      _id,
      name
    }]);
  };
  const onDeleteCircle = (id) => {
    setGroups((groups2) => groups2.filter((g) => g._id !== id));
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 flex-col ns",
    children: [/* @__PURE__ */ jsx(CircleBreadcrumb, {
      circleId,
      current: "Configure AI Assisted Search"
    }), /* @__PURE__ */ jsxs("div", {
      className: "font-semibold",
      children: [/* @__PURE__ */ jsx("span", {
        children: "Configure AI assisted search "
      }), circle && /* @__PURE__ */ jsx("a", {
        href: circleUrl(circleId),
        children: /* @__PURE__ */ jsxs("span", {
          className: "underline",
          children: [" for the circle ", circle.name]
        })
      })]
    }), /* @__PURE__ */ jsxs(Frame, {
      title: "Add Circles to AI Search",
      children: [circle && groups.length > 0 && groups.map((group2) => {
        const {
          _id,
          name
        } = group2;
        return /* @__PURE__ */ jsxs("div", {
          className: "flex items-center",
          children: [/* @__PURE__ */ jsx("div", {
            className: "flex-grow underline",
            children: /* @__PURE__ */ jsx("a", {
              href: circleUrl(_id),
              children: name
            })
          }), /* @__PURE__ */ jsx(LoadingButton, {
            onClick: () => onDeleteCircle(_id),
            className: "w-10",
            children: "delete"
          })]
        }, _id);
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2",
        children: [/* @__PURE__ */ jsx(SelectMyCircle, {
          groupId: group && group._id,
          changeGroup: (_id, circle2) => setGroup(circle2),
          className: "flex-grow",
          title: "Select circle"
        }), /* @__PURE__ */ jsx(LoadingButton, {
          onClick: onAddCircle,
          className: "w-10",
          disabled: !group,
          children: "Add"
        })]
      })]
    }), /* @__PURE__ */ jsx(Checkbox, {
      checked: embeddings,
      onChange: (event) => setEmbeddings(event.target.checked),
      label: "Vector-Index Circle's content"
    }), /* @__PURE__ */ jsx("div", {
      className: "flex gap-2",
      children: /* @__PURE__ */ jsx(Checkbox, {
        checked: aiSearch,
        onChange: (event) => setAISearch(event.target.checked),
        label: "AI search"
      })
    }), /* @__PURE__ */ jsx(Checkbox, {
      checked: comments,
      onChange: (event) => setComments(event.target.checked),
      label: "Index comments"
    }), /* @__PURE__ */ jsx(EmbeddingModelsConfig, {
      useOpenAiEmbeddings,
      useQwenEmbeddings,
      onChangeUseOpenAiEmbeddings: setUseOpenAiEmbeddings,
      onChangeUseQwenEmbeddings: setUseQwenEmbeddings
    }), /* @__PURE__ */ jsx(FormSection, {
      className: "mb-4",
      children: /* @__PURE__ */ jsx(TextInput, {
        value: alpha || "",
        onChange: handleChange(setAlpha),
        label: "Vector search weight (0=text only, 1=vector only)",
        helperText: `Text weight: ${((1 - alphaValue()) * 100).toFixed(0)}%, Vector weight: ${(alphaValue() * 100).toFixed(0)}%`
      })
    }), /* @__PURE__ */ jsx(TranslateQueryLanguagesConfig, {
      languages: translateLanguages,
      onChange: setTranslateLanguages
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("label", {
        className: "text-sm font-medium text-gray-700",
        children: "Query translation model"
      }), /* @__PURE__ */ jsx(ModelSelector, {
        value: translateModelName,
        onChange: setTranslateModelName,
        listId: "translate-query-model",
        placeholder: "Google (default)"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-center",
      children: [/* @__PURE__ */ jsx(TextInput, {
        value: assistant || "",
        className: "flex-grow",
        onChange: handleChange(setAssistant),
        label: "CAIR ID"
      }), assistant && /* @__PURE__ */ jsx("div", {
        className: "underline",
        children: /* @__PURE__ */ jsx("a", {
          href: `/trans/circle-assistant/${assistant}`,
          children: "open"
        })
      })]
    }), /* @__PURE__ */ jsx(TextInput, {
      value: tagsToExclude || "",
      onChange: handleChange(setTagsToExclude),
      label: "Exclude tags"
    }), /* @__PURE__ */ jsx(TextInput, {
      value: minScore || "",
      onChange: handleChange(setMinScore),
      label: "Min similarity score (0-1)"
    }), /* @__PURE__ */ jsx(TextInput, {
      value: chunkSize || "",
      onChange: handleChange(setChunkSize),
      label: "Chunk size (in 1K characters)"
    }), /* @__PURE__ */ jsx(TextInput, {
      value: itemCount || "",
      onChange: handleChange(setItemCount),
      label: "Number of items to return"
    }), /* @__PURE__ */ jsx(ChunkClassificationConfig, {
      addExecution,
      circleId
    }), /* @__PURE__ */ jsx(IndexingOptionsPanel, {
      options: indexingOptions,
      onChange: setIndexingOptions
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: ["Indexing type:", /* @__PURE__ */ jsx("div", {
        className: clsx(type !== "bulk" && "underline", "cursor-pointer"),
        onClick: () => setType("bulk"),
        children: "bulk"
      }), /* @__PURE__ */ jsx("div", {
        className: clsx(type !== "update" && "underline", "cursor-pointer"),
        onClick: () => setType("update"),
        children: "update"
      })]
    }), /* @__PURE__ */ jsx(ExecutionsDisplay, {
      executions,
      refresh
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2",
      children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
        onClick: () => onSave(false),
        className: "w-52",
        loading: saveLoading,
        children: /* @__PURE__ */ jsx("span", {
          children: "Save"
        })
      }), /* @__PURE__ */ jsxs(LoadingButtonTW, {
        onClick: () => onSave(true),
        className: "w-52",
        loading: saveLoading,
        children: [/* @__PURE__ */ jsx("span", {
          children: "Save"
        }), circle && /* @__PURE__ */ jsx("span", {
          children: "\xA0&\xA0Index"
        })]
      })]
    })]
  });
};
const ExecutionsDisplay = ({
  executions,
  refresh
}) => {
  const [showAll, setShowAll] = useState(false);
  const displayedExecutions = showAll ? executions : executions.slice(0, 3);
  const hasMore = executions.length > 3;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "text-sm font-medium text-gray-700",
      children: ["Executions (", executions.length, ")"]
    }), displayedExecutions.map((execution) => /* @__PURE__ */ jsx(AsyncExecutionItem, {
      item: execution,
      refresh
    }, execution._id)), hasMore && /* @__PURE__ */ jsx("button", {
      onClick: () => setShowAll(!showAll),
      className: "text-sm text-blue-600 hover:text-blue-700 hover:underline text-left",
      children: showAll ? "Show less" : `Show ${executions.length - 3} more`
    })]
  });
};

const VectorSearchPanel = () => {
  useDimensionsState();
  const [name, setName] = useState("vector1");
  const [circleId, setCircleId] = useState("");
  const {
    prompt,
    setPrompt,
    onSearch: onSearchRequest
  } = useCircleSearchContext();
  const api = useApi();
  const {
    executions,
    addExecution
  } = useExecutionsArray({
    circleId
  });
  const handleIndexNameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const handleCircleIdChange = (e) => {
    const value = e.target.value;
    setCircleId(value);
  };
  const handleQuestionChange = (e) => {
    const value = e.target.value;
    setPrompt(value);
  };
  const {
    onClick: onCreate,
    loading: createLoading
  } = useLoading(async () => {
    await api.post({
      path: `/admin/vector/create`,
      body: {
        name
      }
    });
  });
  const {
    onClick: onDrop,
    loading: dropLoading
  } = useLoading(async () => {
    await api.post({
      path: `/admin/vector/drop`,
      body: {
        name
      }
    });
  });
  const {
    onClick: onIndexCircle,
    loading: indexCircleLoading
  } = useLoading(async () => {
    const {
      execution
    } = await api.post({
      path: `/vector/circle-index`,
      body: {
        circleId
      }
    });
    addExecution({
      _id: execution,
      status: "started"
    });
  });
  const {
    onClick: onClearCircle,
    loading: clearCircleLoading
  } = useLoading(async () => {
    await api.post({
      path: `/admin/vector/circle-clear`,
      body: {
        circleId
      }
    });
  });
  const {
    onClick: onSearch,
    loading: searchLoading
  } = useLoading(async () => {
    await onSearchRequest();
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "flex gap-2 flex-col",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold",
      children: "Page to create/update search indexes"
    }), /* @__PURE__ */ jsx(TextField$1, {
      defaultValue: name || "",
      onChange: handleIndexNameChange,
      label: "Name of the index",
      variant: "outlined"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onCreate,
      className: "w-52",
      loading: createLoading,
      children: "Create index"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onDrop,
      className: "w-52",
      loading: dropLoading,
      children: "Drop index"
    }), /* @__PURE__ */ jsx("div", {
      className: "font-semibold",
      children: "Index circle"
    }), /* @__PURE__ */ jsx(TextField$1, {
      defaultValue: circleId || "",
      onChange: handleCircleIdChange,
      label: "ID of circle",
      variant: "outlined"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onIndexCircle,
      className: "w-52",
      loading: indexCircleLoading,
      children: "Index circle"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onClearCircle,
      className: "w-52",
      loading: clearCircleLoading,
      children: "Clear data"
    }), executions.map((execution) => {
      return /* @__PURE__ */ jsx(AsyncExecutionItem, {
        item: execution
      }, execution._id);
    }), /* @__PURE__ */ jsx(VectorSearchConfigurationPanel, {}), /* @__PURE__ */ jsx("div", {
      className: "font-semibold",
      children: "Search"
    }), /* @__PURE__ */ jsx(TextField$1, {
      defaultValue: prompt || "",
      onChange: handleQuestionChange,
      label: "Ask your question",
      variant: "outlined"
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSearch,
      className: "w-52",
      loading: searchLoading,
      children: "Search"
    }), /* @__PURE__ */ jsx(VectorSearchResultsPanel, {})]
  });
};

const VectorSearchPage = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    profile
  } = useProfileContext();
  if (parts.length === 3) {
    if (!profile) {
      return null;
    }
    if (!isInstanceAdmin) {
      return /* @__PURE__ */ jsx("div", {
        children: "Only instance admin can configure circle translation"
      });
    }
    return /* @__PURE__ */ jsxs(ToastProvider, {
      children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
        className: "p-2",
        children: /* @__PURE__ */ jsx(CircleSearchContextProvider, {
          children: /* @__PURE__ */ jsx(VectorSearchPanel, {})
        })
      }), /* @__PURE__ */ jsx(ToastContainer, {})]
    });
  }
  const circleId = parts[3];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "p-2",
      children: /* @__PURE__ */ jsx(VectorSearchConfigurationPanel, {
        circleId
      })
    }), /* @__PURE__ */ jsx(ToastContainer, {})]
  });
};

const useCategoryDimensions = (circleId, options) => {
  const api = useApi();
  const result = useSWR(circleId ? `/admin/vector/categories?circleId=${circleId}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    refreshInterval: 1e3 * 60 * 5,
    ...options
  });
  return {
    ...result
  };
};

const useChunksByCategory = (params, options) => {
  const api = useApi();
  const {
    circleId,
    categoryCode,
    limit = 100
  } = params;
  const queryParams = new URLSearchParams({
    circleId,
    ...limit && {
      limit: limit.toString()
    },
    ...categoryCode && {
      categoryCode
    }
  });
  const result = useSWR(circleId ? `/admin/vector/chunks-by-category?${queryParams.toString()}` : null, async (path) => {
    const data2 = await api.get({
      path
    });
    return data2;
  }, {
    ...swrLoadOnce,
    refreshInterval: 1e3 * 60 * 5,
    ...options
  });
  const data = result.data;
  return {
    ...result,
    chunks: data && data.chunks || [],
    total: data && data.total || 0,
    categoryCode: data && data.categoryCode
  };
};

const chunkCardStyles = cva("p-4 border rounded-lg transition-colors duration-200 cursor-pointer", {
  variants: {
    variant: {
      default: "border-gray-200 bg-white hover:bg-gray-50",
      selected: "border-blue-500 bg-blue-50"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const categoryBadgeStyles = cva("inline-block px-2 py-1 text-xs font-medium rounded-full", {
  variants: {
    type: {
      ai: "bg-blue-100 text-blue-800",
      curator: "bg-green-100 text-green-800"
    }
  },
  defaultVariants: {
    type: "ai"
  }
});
const ChunksPanel = ({
  circleId,
  categoryCode,
  limit = 100,
  onChunkSelect
}) => {
  const [selectedChunk, setSelectedChunk] = useState(null);
  const [expandedChunks, setExpandedChunks] = useState(new Set());
  const {
    data,
    error,
    isValidating: isLoading,
    chunks,
    total
  } = useChunksByCategory({
    circleId,
    categoryCode,
    limit
  });
  const handleChunkClick = (chunk) => {
    const newSelection = selectedChunk && selectedChunk._id === chunk._id ? null : chunk;
    setSelectedChunk(newSelection);
    if (onChunkSelect) {
      onChunkSelect(newSelection);
    }
  };
  const toggleChunkExpansion = (chunkId, event) => {
    event.stopPropagation();
    const newExpanded = new Set(expandedChunks);
    if (newExpanded.has(chunkId)) {
      newExpanded.delete(chunkId);
    } else {
      newExpanded.add(chunkId);
    }
    setExpandedChunks(newExpanded);
  };
  const truncateText = (text, maxLength = 200) => {
    if (text.length <= maxLength)
      return text;
    return text.substring(0, maxLength) + "...";
  };
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };
  if (isLoading) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-4 border border-gray-200 rounded-lg",
      children: [/* @__PURE__ */ jsxs("h3", {
        className: "text-lg font-semibold mb-4",
        children: ["Chunks ", categoryCode && `in ${categoryCode}`]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-center py-8",
        children: [/* @__PURE__ */ jsx("div", {
          className: "animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"
        }), /* @__PURE__ */ jsx("span", {
          className: "ml-2 text-gray-600",
          children: "Loading chunks..."
        })]
      })]
    });
  }
  if (error) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-4 border border-red-200 rounded-lg bg-red-50",
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-lg font-semibold mb-2 text-red-800",
        children: "Error Loading Chunks"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-red-600 text-sm",
        children: "Failed to load chunks. Please try again."
      })]
    });
  }
  if (!chunks || chunks.length === 0) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-4 border border-gray-200 rounded-lg",
      children: [/* @__PURE__ */ jsxs("h3", {
        className: "text-lg font-semibold mb-4",
        children: ["Chunks ", categoryCode && `in ${categoryCode}`]
      }), /* @__PURE__ */ jsx("div", {
        className: "text-gray-500 text-sm py-4",
        children: categoryCode ? `No chunks found for category "${categoryCode}".` : "No chunks found for this circle."
      })]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "p-4 border border-gray-200 rounded-lg",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between mb-4",
      children: [/* @__PURE__ */ jsxs("h3", {
        className: "text-lg font-semibold",
        children: ["Chunks ", categoryCode && `in ${categoryCode}`]
      }), /* @__PURE__ */ jsxs("div", {
        className: "text-sm text-gray-600",
        children: [chunks.length, " of ", total, " chunks", selectedChunk && /* @__PURE__ */ jsx("span", {
          className: "ml-2 text-blue-600",
          children: "\u2022 Selected"
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "space-y-4 flex-grow overflow-y-auto",
      children: chunks.map((chunk) => {
        const isExpanded = expandedChunks.has(chunk._id.toString());
        const isSelected = selectedChunk && selectedChunk._id === chunk._id;
        return /* @__PURE__ */ jsxs("div", {
          onClick: () => handleChunkClick(chunk),
          className: chunkCardStyles({
            variant: isSelected ? "selected" : "default"
          }),
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex items-start justify-between mb-2",
            children: [/* @__PURE__ */ jsxs("div", {
              className: "flex items-center gap-2",
              children: [/* @__PURE__ */ jsxs("span", {
                className: "text-xs font-mono text-gray-500",
                children: ["#", chunk.chunkId]
              }), /* @__PURE__ */ jsx("span", {
                className: "text-xs text-gray-500",
                children: formatDate(chunk.modified)
              })]
            }), /* @__PURE__ */ jsx("button", {
              onClick: (e) => toggleChunkExpansion(chunk._id.toString(), e),
              className: "text-xs text-blue-600 hover:text-blue-800 underline",
              children: isExpanded ? "Collapse" : "Expand"
            })]
          }), /* @__PURE__ */ jsx("div", {
            className: "mb-3",
            children: /* @__PURE__ */ jsx("p", {
              className: "text-sm text-gray-700 leading-relaxed",
              children: isExpanded ? chunk.text : truncateText(chunk.text)
            })
          }), chunk.categories && chunk.categories.length > 0 && /* @__PURE__ */ jsxs("div", {
            className: "mb-2",
            children: [/* @__PURE__ */ jsx("div", {
              className: "text-xs font-medium text-gray-600 mb-1",
              children: "Categories:"
            }), /* @__PURE__ */ jsx("div", {
              className: "flex flex-wrap gap-1",
              children: chunk.categories.map((category, index) => /* @__PURE__ */ jsx("span", {
                className: categoryBadgeStyles({
                  type: category.assigned_by === "curator" ? "curator" : "ai"
                }),
                title: `${category.specific_label} (${category.assigned_by}${category.confidence_score ? `, confidence: ${category.confidence_score}` : ""})`,
                children: category.full_code
              }, index))
            })]
          }), chunk.categoryCodes && chunk.categoryCodes.length > 0 && (!chunk.categories || chunk.categories.length === 0) && /* @__PURE__ */ jsxs("div", {
            className: "mb-2",
            children: [/* @__PURE__ */ jsx("div", {
              className: "text-xs font-medium text-gray-600 mb-1",
              children: "Category Codes:"
            }), /* @__PURE__ */ jsx("div", {
              className: "flex flex-wrap gap-1",
              children: chunk.categoryCodes.map((code, index) => /* @__PURE__ */ jsx("span", {
                className: "inline-block px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-700",
                children: code
              }, index))
            })]
          }), chunk.tags && chunk.tags.length > 0 && /* @__PURE__ */ jsxs("div", {
            className: "mb-2",
            children: [/* @__PURE__ */ jsx("div", {
              className: "text-xs font-medium text-gray-600 mb-1",
              children: "Tags:"
            }), /* @__PURE__ */ jsx("div", {
              className: "flex flex-wrap gap-1",
              children: chunk.tags.map((tag, index) => /* @__PURE__ */ jsx("span", {
                className: "inline-block px-2 py-1 text-xs rounded bg-gray-200 text-gray-600",
                children: tag
              }, index))
            })]
          }), chunk.persons && chunk.persons.length > 0 || chunk.organizations && chunk.organizations.length > 0 || chunk.locations && chunk.locations.length > 0 ? /* @__PURE__ */ jsxs("div", {
            className: "text-xs text-gray-500",
            children: [chunk.persons && chunk.persons.length > 0 && /* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "font-medium",
                children: "Persons:"
              }), " ", chunk.persons.join(", ")]
            }), chunk.organizations && chunk.organizations.length > 0 && /* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "font-medium",
                children: "Organizations:"
              }), " ", chunk.organizations.join(", ")]
            }), chunk.locations && chunk.locations.length > 0 && /* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("span", {
                className: "font-medium",
                children: "Locations:"
              }), " ", chunk.locations.join(", ")]
            })]
          }) : null, /* @__PURE__ */ jsx("div", {
            className: "mt-2 pt-2 border-t border-gray-100",
            children: /* @__PURE__ */ jsxs("div", {
              className: "flex items-center justify-between text-xs text-gray-500",
              children: [/* @__PURE__ */ jsxs("span", {
                children: ["Post ID: ", chunk.postId]
              }), /* @__PURE__ */ jsx("span", {
                className: "capitalize",
                children: chunk.type
              })]
            })
          })]
        }, chunk._id.toString());
      })
    }), selectedChunk && /* @__PURE__ */ jsx("div", {
      className: "mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between",
        children: [/* @__PURE__ */ jsxs("span", {
          className: "text-sm font-medium text-blue-800",
          children: ["Selected chunk #", selectedChunk.chunkId]
        }), /* @__PURE__ */ jsx("button", {
          onClick: () => handleChunkClick(selectedChunk),
          className: "text-sm text-blue-600 hover:text-blue-800 underline",
          children: "Clear selection"
        })]
      })
    })]
  });
};

const categoryCodeStyles = cva("px-3 py-2 rounded-md text-sm font-medium cursor-pointer transition-colors duration-200 border", {
  variants: {
    variant: {
      default: "bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-200",
      selected: "bg-blue-500 text-white border-blue-500 hover:bg-blue-600"
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const CategoryDimensionsPanel = ({
  circleId,
  onCategorySelect
}) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const {
    data,
    error,
    isValidating: isLoading
  } = useCategoryDimensions(circleId);
  const handleCategoryClick = (categoryCode) => {
    const newSelection = selectedCategory === categoryCode ? null : categoryCode;
    setSelectedCategory(newSelection);
    if (onCategorySelect) {
      onCategorySelect(newSelection);
    }
  };
  if (isLoading) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-4 border border-gray-200 rounded-lg",
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-lg font-semibold mb-4",
        children: "Category Codes"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-center py-8",
        children: [/* @__PURE__ */ jsx("div", {
          className: "animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"
        }), /* @__PURE__ */ jsx("span", {
          className: "ml-2 text-gray-600",
          children: "Loading categories..."
        })]
      })]
    });
  }
  if (error) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-4 border border-red-200 rounded-lg bg-red-50",
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-lg font-semibold mb-2 text-red-800",
        children: "Error Loading Categories"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-red-600 text-sm",
        children: "Failed to load category codes. Please try again."
      })]
    });
  }
  if (!data || !data.uniqueCategoryCodes || data.uniqueCategoryCodes.length === 0) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-4 border border-gray-200 rounded-lg",
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-lg font-semibold mb-4",
        children: "Category Codes"
      }), /* @__PURE__ */ jsx("div", {
        className: "text-gray-500 text-sm py-4",
        children: "No category codes found for this circle."
      })]
    });
  }
  const {
    uniqueCategoryCodes
  } = data;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "p-4 border border-gray-200 rounded-lg",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between mb-4",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "text-lg font-semibold",
          children: "Category Codes"
        }), /* @__PURE__ */ jsxs("div", {
          className: "text-sm text-gray-600",
          children: [uniqueCategoryCodes.length, " categories", selectedCategory && /* @__PURE__ */ jsxs("span", {
            className: "ml-2 text-blue-600",
            children: ["\u2022 Selected: ", selectedCategory]
          })]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-wrap gap-2",
        children: uniqueCategoryCodes.map((categoryCode) => /* @__PURE__ */ jsx("button", {
          onClick: () => handleCategoryClick(categoryCode),
          className: categoryCodeStyles({
            variant: selectedCategory === categoryCode ? "selected" : "default"
          }),
          children: categoryCode
        }, categoryCode))
      }), selectedCategory && /* @__PURE__ */ jsx("div", {
        className: "mt-4 p-3 bg-blue-50 border border-blue-200 rounded-md",
        children: /* @__PURE__ */ jsxs("div", {
          className: "flex items-center justify-between",
          children: [/* @__PURE__ */ jsxs("span", {
            className: "text-sm font-medium text-blue-800",
            children: ["Selected: ", selectedCategory]
          }), /* @__PURE__ */ jsx("button", {
            onClick: () => handleCategoryClick(selectedCategory),
            className: "text-sm text-blue-600 hover:text-blue-800 underline",
            children: "Clear selection"
          })]
        })
      })]
    }), /* @__PURE__ */ jsx(ChunksPanel, {
      circleId,
      categoryCode: selectedCategory
    })]
  });
};

const VectorSearchCategories = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    profile
  } = useProfileContext();
  if (parts.length !== 4 || !profile || !isInstanceAdmin) {
    return null;
  }
  const circleId = parts[3];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx("div", {
      className: "p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(CategoryDimensionsPanel, {
        circleId
      })
    })]
  });
};

const VectorSearchSimple = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const isInstanceAdmin = useIsInstanceAdmin();
  const {
    profile
  } = useProfileContext();
  if (parts.length !== 4 || !profile || !isInstanceAdmin) {
    return null;
  }
  const circleId = parts[3];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(CategoryDimensionsPanel, {
        circleId
      })
    })]
  });
};

const MAX_MESSAGES$3 = 30;
const MAX_LOGS$1 = 100;
const useCreateAllElasticIndices = () => {
  const api = useApi();
  const jwt = useJwt();
  const isMountedRef = useRef(true);
  const [params, setParams] = useState({
    dimensions: 4096,
    recreate: false
  });
  const [counter, setCounter] = useState(0);
  const {
    dimensions = 4096,
    recreate = false,
    requestId: providedRequestId
  } = params;
  const [messages, setMessages] = useState([]);
  const [logs, setLogs] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const requestId = useMemo(() => {
    return providedRequestId || ulid();
  }, [providedRequestId, counter]);
  const url = useMemo(() => {
    if (!counter || !jwt) {
      return null;
    }
    const queryParams = {
      token: jwt,
      dimensions: dimensions.toString(),
      recreate: recreate.toString(),
      trace: "true",
      requestId
    };
    return api.buildUrl("/admin/vector/create-all-elastic", queryParams);
  }, [counter, api, jwt, dimensions, recreate, requestId]);
  const addMessage = useMemoizedFn((event, data) => {
    if (!isMountedRef.current)
      return;
    const newMessage = {
      id: Date.now().toString() + Math.random(),
      event,
      timestamp: new Date(),
      data
    };
    setMessages((prev) => {
      const updated = [newMessage, ...prev];
      return updated.slice(0, MAX_MESSAGES$3);
    });
  });
  const {
    isConnected,
    error: sseError,
    disconnect,
    reconnect
  } = useSSEConnection({
    url: url || "",
    enabled: counter > 0 && !!url,
    dependencies: [counter],
    onOpen: () => {
      if (!isMountedRef.current)
        return;
      setIsComplete(false);
      setConnectionError(null);
      setMessages([]);
      setLogs([]);
    },
    onError: (err) => {
      if (!isMountedRef.current)
        return;
      console.error("SSE connection error:", err);
      setConnectionError(new Error("Connection error"));
    },
    onClose: () => {
    }
  }, [
    {
      event: "progress",
      handler: (data) => {
        addMessage("progress", data);
      }
    },
    {
      event: "complete",
      handler: (data) => {
        addMessage("complete", data);
        if (!isMountedRef.current)
          return;
        setIsComplete(true);
        setTimeout(() => {
          if (isMountedRef.current) {
            disconnect();
          }
        }, 100);
      }
    },
    {
      event: "error",
      handler: (data) => {
        const errorData = data || {};
        const errorMessage = errorData.message || errorData.error || String(data) || "Unknown error";
        addMessage("failed", { message: errorMessage, ...errorData });
        if (!isMountedRef.current)
          return;
        setConnectionError(new Error(errorMessage));
        setTimeout(() => {
          if (isMountedRef.current) {
            disconnect();
          }
        }, 100);
      }
    },
    {
      event: "log",
      handler: (logEvent) => {
        addMessage("log", logEvent);
        if (!isMountedRef.current)
          return;
        setLogs((prev) => {
          const updated = [...prev, logEvent];
          return updated.slice(-MAX_LOGS$1);
        });
      }
    }
  ]);
  useEffect(() => {
    if (!isMountedRef.current)
      return;
    if (sseError) {
      setConnectionError(sseError);
    }
  }, [sseError]);
  const mutate = useMemoizedFn(() => {
    reconnect();
  });
  const start = useMemoizedFn((startParams) => {
    if (startParams) {
      setParams((prev) => ({ ...prev, ...startParams }));
    }
    setCounter((c) => c + 1);
    setConnectionError(null);
  });
  const clear = useMemoizedFn(() => {
    setMessages([]);
    setLogs([]);
    setConnectionError(null);
  });
  const setDimensions = useMemoizedFn((dims) => {
    setParams((prev) => ({ ...prev, dimensions: dims }));
  });
  const setRecreate = useMemoizedFn((rec) => {
    setParams((prev) => ({ ...prev, recreate: rec }));
  });
  return {
    messages,
    logs,
    isConnected,
    isComplete,
    error: connectionError,
    isValidating: isConnected,
    requestId,
    dimensions,
    recreate,
    setDimensions,
    setRecreate,
    start,
    clear,
    disconnect,
    mutate
  };
};

const MAX_MESSAGES$2 = 30;
const MAX_LOGS = 100;
const useDropAllElasticIndices = () => {
  const api = useApi();
  const jwt = useJwt();
  const isMountedRef = useRef(true);
  const [params, setParams] = useState({});
  const [counter, setCounter] = useState(0);
  const { requestId: providedRequestId } = params;
  const [messages, setMessages] = useState([]);
  const [logs, setLogs] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [connectionError, setConnectionError] = useState(null);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const requestId = useMemo(() => {
    return providedRequestId || ulid();
  }, [providedRequestId, counter]);
  const url = useMemo(() => {
    if (!counter || !jwt) {
      return null;
    }
    const queryParams = {
      token: jwt,
      trace: "true",
      requestId
    };
    return api.buildUrl("/admin/vector/drop-all-elastic", queryParams);
  }, [counter, api, jwt, requestId]);
  const addMessage = useMemoizedFn((event, data) => {
    if (!isMountedRef.current)
      return;
    const newMessage = {
      id: Date.now().toString() + Math.random(),
      event,
      timestamp: new Date(),
      data
    };
    setMessages((prev) => {
      const updated = [newMessage, ...prev];
      return updated.slice(0, MAX_MESSAGES$2);
    });
  });
  const {
    isConnected,
    error: sseError,
    disconnect,
    reconnect
  } = useSSEConnection({
    url: url || "",
    enabled: counter > 0 && !!url,
    dependencies: [counter],
    onOpen: () => {
      if (!isMountedRef.current)
        return;
      setIsComplete(false);
      setConnectionError(null);
      setMessages([]);
      setLogs([]);
    },
    onError: (err) => {
      if (!isMountedRef.current)
        return;
      console.error("SSE connection error:", err);
      setConnectionError(new Error("Connection error"));
    },
    onClose: () => {
    }
  }, [
    {
      event: "progress",
      handler: (data) => {
        addMessage("progress", data);
      }
    },
    {
      event: "complete",
      handler: (data) => {
        addMessage("complete", data);
        if (!isMountedRef.current)
          return;
        setIsComplete(true);
        setTimeout(() => {
          if (isMountedRef.current) {
            disconnect();
          }
        }, 100);
      }
    },
    {
      event: "failed",
      handler: (data) => {
        const errorData = data || {};
        const errorMessage = errorData.message || errorData.error || String(data) || "Unknown error";
        addMessage("failed", { message: errorMessage, ...errorData });
        if (!isMountedRef.current)
          return;
        setConnectionError(new Error(errorMessage));
        setTimeout(() => {
          if (isMountedRef.current) {
            disconnect();
          }
        }, 100);
      }
    },
    {
      event: "log",
      handler: (logEvent) => {
        addMessage("log", logEvent);
        if (!isMountedRef.current)
          return;
        setLogs((prev) => {
          const updated = [...prev, logEvent];
          return updated.slice(-MAX_LOGS);
        });
      }
    }
  ]);
  useEffect(() => {
    if (!isMountedRef.current)
      return;
    if (sseError) {
      setConnectionError(sseError);
    }
  }, [sseError]);
  const mutate = useMemoizedFn(() => {
    reconnect();
  });
  const start = useMemoizedFn((startParams) => {
    if (startParams) {
      setParams((prev) => ({ ...prev, ...startParams }));
    }
    setCounter((c) => c + 1);
    setConnectionError(null);
  });
  const clear = useMemoizedFn(() => {
    setConnectionError(null);
    setMessages([]);
    setLogs([]);
  });
  return {
    messages,
    logs,
    isConnected,
    isComplete,
    error: connectionError,
    isValidating: isConnected,
    requestId,
    start,
    clear,
    disconnect,
    mutate
  };
};

const ElasticAllIndicesPanel = () => {
  const createOp = useCreateAllElasticIndices();
  const dropOp = useDropAllElasticIndices();
  const anyOperationRunning = createOp.isConnected || dropOp.isConnected;
  const handleClearAll = () => {
    createOp.clear();
    dropOp.clear();
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("h1", {
        className: "text-2xl font-semibold",
        children: "Bulk Index Operations"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-gray-600",
        children: "Create or drop Elasticsearch indices for all instances with trace mode enabled"
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4 p-4 bg-gray-50 rounded-md",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "Configuration"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-4",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-2",
          children: [/* @__PURE__ */ jsx("label", {
            className: "text-sm font-medium",
            children: "Embedding Model:"
          }), /* @__PURE__ */ jsxs("select", {
            value: createOp.dimensions,
            onChange: (e) => createOp.setDimensions(parseInt(e.target.value)),
            className: "px-3 py-1 text-sm border border-gray-300 rounded",
            disabled: anyOperationRunning,
            children: [/* @__PURE__ */ jsx("option", {
              value: 4096,
              children: "Qwen (4096 dimensions)"
            }), /* @__PURE__ */ jsx("option", {
              value: 3072,
              children: "OpenAI (3072 dimensions)"
            })]
          })]
        }), /* @__PURE__ */ jsx(Checkbox, {
          checked: createOp.recreate,
          onChange: (e) => createOp.setRecreate(e.target.checked),
          label: "Recreate existing indices",
          disabled: anyOperationRunning
        })]
      })]
    }), (createOp.requestId || dropOp.requestId) && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2 text-sm",
      children: [createOp.isConnected && createOp.requestId && /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-blue-50 rounded font-mono",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-semibold text-blue-700",
          children: "Create Request ID:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-blue-900",
          children: createOp.requestId
        })]
      }), dropOp.isConnected && dropOp.requestId && /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-red-50 rounded font-mono",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-semibold text-red-700",
          children: "Drop Request ID:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-red-900",
          children: dropOp.requestId
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "Operations"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-3",
        children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: createOp.isConnected,
          onClick: () => createOp.start(),
          disabled: anyOperationRunning,
          background: "blue",
          children: "Create All Indices"
        }), /* @__PURE__ */ jsx(LoadingButtonTW, {
          loading: dropOp.isConnected,
          onClick: () => dropOp.start(),
          disabled: anyOperationRunning,
          background: "red",
          children: "Drop All Indices"
        }), (createOp.messages.length > 0 || dropOp.messages.length > 0) && /* @__PURE__ */ jsx("button", {
          onClick: handleClearAll,
          className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
          children: "Clear All"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-4 text-sm flex-wrap",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Create:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: createOp.isConnected ? "text-blue-600" : "text-gray-400",
          children: createOp.isConnected ? "Running" : "Idle"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Drop:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: dropOp.isConnected ? "text-red-600" : "text-gray-400",
          children: dropOp.isConnected ? "Running" : "Idle"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Messages:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-gray-600",
          children: createOp.messages.length + dropOp.messages.length
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "px-3 py-2 bg-gray-50 rounded",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: "Logs:"
        }), " ", /* @__PURE__ */ jsx("span", {
          className: "text-gray-600",
          children: createOp.logs.length + dropOp.logs.length
        })]
      })]
    }), createOp.error && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-sm font-medium text-red-700 mb-2",
        children: "Create Operation Error:"
      }), /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: createOp.error
      })]
    }), dropOp.error && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-sm font-medium text-red-700 mb-2",
        children: "Drop Operation Error:"
      }), /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: dropOp.error
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), createOp.messages.length > 0 && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between",
        children: [/* @__PURE__ */ jsxs("h2", {
          className: "text-lg font-semibold",
          children: ["Create Operation Progress", createOp.isComplete && /* @__PURE__ */ jsx("span", {
            className: "ml-2 text-sm text-green-600",
            children: "(Completed)"
          })]
        }), /* @__PURE__ */ jsx("button", {
          onClick: createOp.clear,
          className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
          children: "Clear"
        })]
      }), /* @__PURE__ */ jsx(SSEMessagesList, {
        messages: createOp.messages,
        emptyMessage: "No create operation messages yet"
      })]
    }), createOp.messages.length > 0 && dropOp.messages.length > 0 && /* @__PURE__ */ jsx(HorizontalRuler$2, {}), dropOp.messages.length > 0 && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between",
        children: [/* @__PURE__ */ jsxs("h2", {
          className: "text-lg font-semibold",
          children: ["Drop Operation Progress", dropOp.isComplete && /* @__PURE__ */ jsx("span", {
            className: "ml-2 text-sm text-red-600",
            children: "(Completed)"
          })]
        }), /* @__PURE__ */ jsx("button", {
          onClick: dropOp.clear,
          className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100",
          children: "Clear"
        })]
      }), /* @__PURE__ */ jsx(SSEMessagesList, {
        messages: dropOp.messages,
        emptyMessage: "No drop operation messages yet"
      })]
    })]
  });
};

const ElasticIndicesPanel = () => {
  useState("");
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("h1", {
        className: "text-2xl font-semibold",
        children: "Elasticsearch Indices Management"
      }), /* @__PURE__ */ jsx("p", {
        className: "text-gray-600",
        children: "Monitor and manage Elasticsearch indices for circle RAG functionality"
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(ElasticAllIndicesPanel, {})]
  });
};

const ElasticIndicesTest = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(ElasticIndicesTestInner, {})
  });
};
const ElasticIndicesTestInner = () => {
  const {
    profile
  } = useProfileContext();
  const isInstanceAdmin = useIsInstanceAdmin();
  if (!profile) {
    return null;
  }
  if (!isInstanceAdmin) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-4",
      children: /* @__PURE__ */ jsx("div", {
        className: "bg-yellow-50 border border-yellow-200 rounded-md p-4",
        children: /* @__PURE__ */ jsx("p", {
          className: "text-yellow-800",
          children: "Only instance administrators can manage Elasticsearch indices."
        })
      })
    });
  }
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-4 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(ElasticIndicesPanel, {})
    })]
  });
};

const TranslateSimpleForm = ({
  state,
  onUpdate,
  disabled = false
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsx(Checkbox, {
      label: "Force re-translation",
      checked: !!state.force,
      onChange: (e) => onUpdate({
        force: e.target.checked
      }),
      disabled,
      helperText: "Re-translate even if a fresh translation is already cached"
    }), /* @__PURE__ */ jsx(LanguageSelect, {
      label: "Target Language",
      value: state.targetLang || "",
      onChange: (value) => onUpdate({
        targetLang: value
      }),
      disabled
    }), /* @__PURE__ */ jsx(TextInput, {
      type: "number",
      label: "Timeout (seconds)",
      value: ((state.timeoutMs || 6e4) / 1e3).toString(),
      onChange: (e) => onUpdate({
        timeoutMs: (parseInt(e.target.value) || 60) * 1e3
      }),
      disabled,
      placeholder: "60",
      helperText: "Per-page time limit before a translation attempt is retried"
    }), /* @__PURE__ */ jsx(TextInput, {
      label: "Model Name",
      value: state.modelName,
      onChange: (e) => onUpdate({
        modelName: e.target.value
      }),
      disabled,
      placeholder: "gpt-5.5"
    }), /* @__PURE__ */ jsx(Checkbox, {
      label: "Save translation to content",
      helperText: "Replaces post HTML with translated text, preserving original for re-translation",
      checked: state.saveToContent || false,
      onChange: (e) => onUpdate({
        saveToContent: e.target.checked
      }),
      disabled
    })]
  });
};

const useTranslationTask = () => {
  const taskOp = useTaskOperation({
    executeEndpoint: "/translate/post"
  });
  const startTranslation = useMemoizedFn(async ({
    input,
    config
  }) => {
    await taskOp.startTask({
      input,
      data: {
        translatorOptions: config
      }
    });
  });
  return {
    ...taskOp,
    startTranslation
  };
};

const FinalTranslationSection = ({
  finalTranslation
}) => {
  if (!finalTranslation) {
    return null;
  }
  return /* @__PURE__ */ jsx(CollapsibleSection, {
    title: "Final Translation",
    defaultCollapsed: false,
    variant: "elevated",
    headerVariant: "primary",
    contentVariant: "subtle",
    children: /* @__PURE__ */ jsx("div", {
      className: "prose max-w-none",
      children: /* @__PURE__ */ jsx("div", {
        className: "bg-white p-4 rounded border border-gray-200",
        children: /* @__PURE__ */ jsx("pre", {
          className: "whitespace-pre-wrap text-sm font-sans text-gray-800",
          children: finalTranslation
        })
      })
    })
  });
};

const useTranslateInitialState = (postId) => {
  const { testDelay, testHang } = useQueryStringParams();
  const [state, setState] = useState({
    postId,
    sourceLang: "en",
    targetLang: "ar",
    domain: "technology",
    modelName: "gpt-4o",
    testDelayMs: testDelay ? Number(testDelay) : void 0,
    testNeverResolve: testHang === "true"
  });
  const updateState = useMemoizedFn((updates) => {
    setState((prev) => ({ ...prev, ...updates }));
  });
  return {
    state,
    updateState
  };
};

const PostInfoHeader = ({
  post
}) => {
  if (!post) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className: "bg-gray-50 border border-gray-200 rounded-lg p-4",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex-1",
        children: [/* @__PURE__ */ jsxs("a", {
          href: `/trans/post-view/${post._id}`,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "text-lg font-semibold text-blue-600 hover:text-blue-800 underline inline-flex items-center gap-2 group",
          children: [/* @__PURE__ */ jsx("span", {
            children: post.title || "Untitled Post"
          }), /* @__PURE__ */ jsx(MdOpenInNew, {
            className: "w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity"
          })]
        }), post.author && /* @__PURE__ */ jsxs("div", {
          className: "text-sm text-gray-600 mt-1",
          children: ["by ", getPersonName(post.author)]
        })]
      }), post.tags && post.tags.length > 0 && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-wrap gap-1 ml-4",
        children: [post.tags.slice(0, 3).map((tag) => /* @__PURE__ */ jsx("span", {
          className: "text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded",
          children: tag
        }, tag)), post.tags.length > 3 && /* @__PURE__ */ jsxs("span", {
          className: "text-xs text-gray-500",
          children: ["+", post.tags.length - 3, " more"]
        })]
      })]
    })
  });
};

const SSEExecutionSection = ({
  title,
  messages,
  isConnected,
  isComplete,
  error,
  onClear,
  defaultCollapsed = true,
  emptyMessage = "No messages yet",
  showProgress = true
}) => {
  if (messages.length === 0 && !error && !isConnected) {
    return null;
  }
  const latestProgress = showProgress ? getLatestProgress(messages) : null;
  const renderStatusBadge = () => {
    if (error) {
      return /* @__PURE__ */ jsx("span", {
        className: "text-sm text-red-600 font-medium",
        children: "Error"
      });
    }
    if (isComplete) {
      return /* @__PURE__ */ jsx("span", {
        className: "text-sm text-green-600 font-medium",
        children: "Completed"
      });
    }
    if (isConnected) {
      return /* @__PURE__ */ jsx("span", {
        className: "text-sm text-blue-600 font-medium",
        children: "Running"
      });
    }
    return /* @__PURE__ */ jsx("span", {
      className: "text-sm text-gray-500 font-medium",
      children: "Idle"
    });
  };
  const renderProgressInfo = () => {
    if (!latestProgress)
      return null;
    const progressText = formatProgress(latestProgress);
    const percentage = calculateProgressPercentage(latestProgress);
    return /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-3",
      children: [percentage > 0 && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx("div", {
          className: "w-24 h-2 bg-gray-200 rounded-full overflow-hidden",
          children: /* @__PURE__ */ jsx("div", {
            className: "h-full bg-blue-500 transition-all duration-300",
            style: {
              width: `${percentage}%`
            }
          })
        }), /* @__PURE__ */ jsxs("span", {
          className: "text-xs text-gray-600 font-mono",
          children: [percentage, "%"]
        })]
      }), /* @__PURE__ */ jsx("span", {
        className: "text-sm text-gray-700",
        children: progressText
      })]
    });
  };
  return /* @__PURE__ */ jsx(CollapsibleSection, {
    title,
    defaultCollapsed,
    variant: "card",
    renderHeader: (expanded, onToggle) => /* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between w-full gap-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-3 flex-1 min-w-0",
        children: [/* @__PURE__ */ jsx(ToggleButton, {
          expanded,
          onToggle,
          variant: "default",
          size: "md"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-1 flex-1 min-w-0",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-3",
            children: [/* @__PURE__ */ jsx("h2", {
              className: "text-lg font-semibold",
              children: title
            }), renderStatusBadge()]
          }), latestProgress && /* @__PURE__ */ jsx("div", {
            className: "flex items-center gap-2",
            children: renderProgressInfo()
          })]
        })]
      }), onClear && /* @__PURE__ */ jsx("button", {
        onClick: (e) => {
          e.stopPropagation();
          onClear();
        },
        className: "text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded hover:bg-gray-100 flex-shrink-0",
        children: "Clear"
      })]
    }),
    children: /* @__PURE__ */ jsx(SSEMessagesList, {
      messages,
      emptyMessage
    })
  });
};

const TranslateSimplePanel = ({
  postId
}) => {
  const translate = useTranslationTask();
  useState(null);
  const state = useTranslateInitialState(postId);
  const {
    data: post,
    isValidating: isLoadingPost
  } = usePost(postId);
  const complete = translate.complete;
  const finalTranslation = complete && complete.finalTranslation;
  const isTranslating = translate.isCreatingTask || translate.isConnected;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx("h1", {
        className: "text-2xl font-semibold",
        children: "Translate Post"
      }), /* @__PURE__ */ jsxs("p", {
        className: "text-gray-600",
        children: ["Post ID: ", postId]
      }), translate.taskExecutionId && /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-gray-500",
        children: ["Task ID: ", translate.taskExecutionId]
      })]
    }), isLoadingPost && /* @__PURE__ */ jsx("div", {
      className: "bg-gray-50 border border-gray-200 rounded-lg p-4",
      children: /* @__PURE__ */ jsx("div", {
        className: "text-gray-500",
        children: "Loading post information..."
      })
    }), post && /* @__PURE__ */ jsx(PostInfoHeader, {
      post
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(TranslateSimpleForm, {
      state: state.state,
      onUpdate: state.updateState,
      disabled: isTranslating
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(LoadingButtonTW, {
      loading: translate.isCreatingTask || translate.isConnected,
      onClick: () => translate.startTranslation({
        input: {
          postId
        },
        config: state.state
      }),
      disabled: translate.isCreatingTask || translate.isConnected,
      background: "blue",
      children: translate.isCreatingTask ? "Creating Task..." : "Translate Post"
    }), translate.error && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-sm font-medium text-red-700 mb-2",
        children: "Translation Error:"
      }), /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: translate.error
      })]
    }), /* @__PURE__ */ jsx(SSEProgressPanel, {
      messages: translate.messages,
      isConnected: translate.isConnected,
      isComplete: translate.isComplete,
      error: translate.error,
      variant: "default"
    }), /* @__PURE__ */ jsx(SSEExecutionSection, {
      title: "Translation Details",
      messages: translate.messages,
      isConnected: translate.isConnected,
      isComplete: translate.isComplete,
      error: translate.error,
      onClear: translate.clear,
      defaultCollapsed: true,
      emptyMessage: "No translation messages yet",
      showProgress: true
    }), translate.isComplete && finalTranslation && /* @__PURE__ */ jsx(FinalTranslationSection, {
      finalTranslation
    })]
  });
};

const TranslationSimplePage = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(TranslationPageInner, {})
  });
};
const TranslationPageInner = () => {
  const parts = location.pathname.split("/").filter((v) => v);
  const postId = parts[parts.findIndex((v) => v === "translate-post") + 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-4 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(TranslateSimplePanel, {
        postId
      })
    })]
  });
};

const CM_BASE = "https://cdn.jsdelivr.net/npm/codemirror@6.65.7";
const CM_JS_URL = `${CM_BASE}/lib/codemirror.min.js`;
const CM_CSS_URL = `${CM_BASE}/lib/codemirror.min.css`;
const CM_YAML_URL = `${CM_BASE}/mode/yaml/yaml.min.js`;
const CM_THEME_URL = `${CM_BASE}/theme/material-darker.min.css`;
const CM_THEME_NAME = "material-darker";
const loadCm = () => Promise.all([loadStylesheet(CM_CSS_URL), loadStylesheet(CM_THEME_URL), loadJsLibs([CM_JS_URL, CM_YAML_URL])]).then(() => void 0);
const YamlEditor = ({
  value,
  onChange,
  readOnly = false,
  height = "400px",
  className = "",
  onReady
}) => {
  const textareaRef = useRef(null);
  const editorRef = useRef(null);
  const onChangeRef = useRef(onChange);
  const valueRef = useRef(value);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);
  useEffect(() => {
    valueRef.current = value;
  }, [value]);
  useEffect(() => {
    if (!textareaRef.current)
      return;
    let cancelled = false;
    loadCm().then(() => {
      if (cancelled || !textareaRef.current)
        return;
      const editor = window.CodeMirror.fromTextArea(textareaRef.current, {
        mode: "yaml",
        theme: CM_THEME_NAME,
        lineNumbers: true,
        lineWrapping: false,
        indentWithTabs: false,
        tabSize: 2,
        indentUnit: 2,
        readOnly,
        autoCloseBrackets: true,
        matchBrackets: true,
        extraKeys: {
          Tab: "indentMore",
          "Shift-Tab": "indentLess"
        }
      });
      editor.setValue(valueRef.current);
      editor.setSize(null, height);
      editor.getDoc().markClean();
      editor.on("change", () => {
        if (onChangeRef.current)
          onChangeRef.current(editor.getValue());
      });
      editorRef.current = editor;
      setLoading(false);
      if (onReady)
        onReady(editor);
    }).catch((err) => {
      if (!cancelled)
        setError(err.message);
    });
    return () => {
      cancelled = true;
      if (editorRef.current) {
        editorRef.current.getWrapperElement().remove();
        editorRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    const editor = editorRef.current;
    if (!editor || editor.getValue() === value)
      return;
    editor.setValue(value);
  }, [value]);
  useEffect(() => {
    const editor = editorRef.current;
    if (!editor)
      return;
    editor.setOption("readOnly", readOnly);
  }, [readOnly]);
  useEffect(() => {
    const editor = editorRef.current;
    if (!editor)
      return;
    editor.setSize(null, height);
    editor.refresh();
  }, [height]);
  return /* @__PURE__ */ jsxs("div", {
    className: ["relative w-full rounded-md overflow-hidden border border-gray-700", className].join(" "),
    children: [/* @__PURE__ */ jsx("textarea", {
      ref: textareaRef,
      className: "hidden"
    }), loading && !error && /* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-center bg-gray-900 text-gray-400 text-sm",
      style: {
        height
      },
      children: "Loading editor\u2026"
    }), error && /* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-center bg-red-950 text-red-400 text-sm px-4",
      style: {
        height
      },
      children: error
    })]
  });
};

const SAMPLE_OCR_CONFIG = `# OCR Workload Configuration
# \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500

# Deployment platform.
# Allowed values: 'aws' (ECS Fargate) | 'k8s' (Kubernetes)
platform: aws

# ECS: cluster name  |  K8s: namespace
clusterName: my-ecs-cluster

# ECS: service name  |  K8s: deployment name
serviceName: ocr-worker

# Set to false to disable auto-scaling entirely
enabled: true

scaler:
  # Minimum number of running containers (must be >= 1)
  minCapacity: 1

  # Maximum number of containers the scaler may launch
  maxCapacity: 10

  # Minimum time between two consecutive scale actions (milliseconds)
  # 300000 = 5 minutes \u2014 prevents rapid oscillation under variable load
  cooldownPeriod: 300000
`;

const JSYAML_CDN_URL = "https://cdn.jsdelivr.net/npm/js-yaml@4/dist/js-yaml.min.js";
const useYamlParser = () => {
  const [loading, setLoading] = useState(!window.jsyaml);
  const [error, setError] = useState(null);
  const [parser, setParser] = useState(window.jsyaml ? makeParser() : null);
  useEffect(() => {
    if (window.jsyaml)
      return;
    let cancelled = false;
    loadJsLibs([JSYAML_CDN_URL]).then(() => {
      if (cancelled)
        return;
      setParser(makeParser());
      setLoading(false);
    }).catch((err) => {
      if (cancelled)
        return;
      setError(err instanceof Error ? err : new Error(String(err)));
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return { parser, loading, error };
};
const makeParser = () => ({
  load: (input) => window.jsyaml.load(input),
  loadAll: (input) => window.jsyaml.loadAll(input),
  dump: (obj) => window.jsyaml.dump(obj)
});

const useOcrWorkloadConfig = (options) => {
  const api = useApi();
  const result = useSWR("/workload/ocr/config", async () => {
    const data = await api.get({
      path: "/workload/ocr/config"
    });
    return data.config;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result,
    config: result.data
  };
};

const useOcrWorkloadConfigYaml = () => {
  const { config, isValidating: configLoading, error: configError } = useOcrWorkloadConfig();
  const { parser, loading: parserLoading, error: parserError } = useYamlParser();
  const [yaml, setYaml] = useState(null);
  useEffect(() => {
    if (!parser || !config)
      return;
    setYaml(parser.dump(config));
  }, [parser, config]);
  return {
    yaml: yaml || "",
    setYaml,
    isLoading: parserLoading || configLoading || yaml === null,
    error: parserError || configError,
    parser
  };
};

const useOcrWorkloadConfigSave = (yaml) => {
  const api = useApi();
  const { parser } = useYamlParser();
  const { addToast } = useToast();
  const [parseError, setParseError] = useState(null);
  const save = useAsyncOperation(async () => {
    if (!parser)
      return;
    setParseError(null);
    let parsed;
    try {
      parsed = parser.load(yaml);
    } catch (err) {
      setParseError(err instanceof Error ? err.message : String(err));
      return;
    }
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      setParseError("Configuration must be a YAML mapping (key: value pairs)");
      return;
    }
    await api.makeRequest({ path: "/workload/ocr/config", method: "PUT", body: parsed });
    addToast({ type: "success", title: "Saved", message: "OCR workload configuration updated" });
  }, { showErrorToast: true });
  return { save, parseError };
};

const OcrWorkloadConfigPanel = () => {
  const {
    yaml,
    setYaml,
    isLoading,
    error: loadError
  } = useOcrWorkloadConfigYaml();
  const {
    save,
    parseError
  } = useOcrWorkloadConfigSave(yaml);
  return /* @__PURE__ */ jsx("div", {
    className: "p-4 max-w-5xl",
    children: /* @__PURE__ */ jsxs("div", {
      className: "grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6",
      children: [/* @__PURE__ */ jsxs(Frame, {
        title: "OCR Workload Configuration",
        children: [isLoading && /* @__PURE__ */ jsx("p", {
          className: "text-sm text-gray-400 py-2",
          children: "Loading\u2026"
        }), !isLoading && loadError && /* @__PURE__ */ jsx("p", {
          className: "text-sm text-red-500 py-2",
          children: loadError instanceof Error ? loadError.message : String(loadError)
        }), !loadError && /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx(YamlEditor, {
            value: yaml,
            onChange: setYaml,
            height: "320px"
          }), parseError && /* @__PURE__ */ jsx("p", {
            className: "mt-2 text-xs text-red-500 font-mono",
            children: parseError
          }), /* @__PURE__ */ jsx("div", {
            className: "flex items-center gap-3 mt-3",
            children: /* @__PURE__ */ jsx(LoadingButtonTW, {
              loading: save.isLoading,
              background: "primary",
              onClick: save.execute,
              children: "Save"
            })
          })]
        })]
      }), /* @__PURE__ */ jsx(Frame, {
        title: "Sample configuration",
        children: /* @__PURE__ */ jsx(YamlEditor, {
          value: SAMPLE_OCR_CONFIG,
          readOnly: true,
          height: "320px"
        })
      })]
    })
  });
};
const OcrWorkloadConfigPage = () => /* @__PURE__ */ jsxs(ToastProvider, {
  children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx(OcrWorkloadConfigPanel, {}), /* @__PURE__ */ jsx(ToastContainer, {})]
});

const POLL_INTERVAL_MS = 15e3;
const useOcrMonitorState = () => {
  const api = useApi();
  const result = useSWR("/workload/ocr/monitor/state", async () => api.get({ path: "/workload/ocr/monitor/state" }), {
    refreshInterval: POLL_INTERVAL_MS,
    revalidateOnFocus: false
  });
  return { ...result, state: result.data };
};

const STATE_COLORS = {
  completed: "text-green-400",
  active: "text-blue-400",
  waiting: "text-yellow-400",
  delayed: "text-yellow-400",
  prioritized: "text-yellow-400",
  "waiting-children": "text-yellow-400",
  failed: "text-red-400",
  unknown: "text-gray-400"
};
const STEP_ICON = {
  ok: "\u2713",
  warn: "\u26A0",
  fail: "\u2717"
};
const STEP_COLOR = {
  ok: "text-green-400",
  warn: "text-yellow-400",
  fail: "text-red-400"
};
const Row = ({
  label,
  children
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex gap-2 text-sm",
  children: [/* @__PURE__ */ jsx("span", {
    className: "text-gray-400 w-32 shrink-0",
    children: label
  }), /* @__PURE__ */ jsx("span", {
    className: "text-gray-100 break-all",
    children
  })]
});
const JobMeta = ({
  s
}) => /* @__PURE__ */ jsx(Frame, {
  title: "Job",
  children: /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-1.5",
    children: [/* @__PURE__ */ jsx(Row, {
      label: "Job ID",
      children: /* @__PURE__ */ jsx("span", {
        className: "font-mono text-xs",
        children: s.jobId
      })
    }), /* @__PURE__ */ jsx(Row, {
      label: "State",
      children: /* @__PURE__ */ jsx("span", {
        className: STATE_COLORS[s.state],
        children: s.state
      })
    }), /* @__PURE__ */ jsx(Row, {
      label: "Attempts",
      children: s.attemptsMade
    }), s.processedOn && /* @__PURE__ */ jsx(Row, {
      label: "Started",
      children: /* @__PURE__ */ jsx(RelativeTime, {
        value: new Date(s.processedOn)
      })
    }), s.finishedOn && /* @__PURE__ */ jsx(Row, {
      label: "Finished",
      children: /* @__PURE__ */ jsx(RelativeTime, {
        value: new Date(s.finishedOn)
      })
    }), s.failedReason && /* @__PURE__ */ jsx(Row, {
      label: "Error",
      children: /* @__PURE__ */ jsx("span", {
        className: "text-red-400",
        children: s.failedReason
      })
    }), s.message && /* @__PURE__ */ jsx(Row, {
      label: "Message",
      children: s.message
    })]
  })
});
const DiagnosticSteps = ({
  steps
}) => /* @__PURE__ */ jsx(Frame, {
  title: "Diagnostic steps",
  children: /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-1",
    children: steps.map((step, i) => /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 text-sm items-start",
      children: [/* @__PURE__ */ jsx("span", {
        className: `w-4 shrink-0 ${STEP_COLOR[step.status]}`,
        children: STEP_ICON[step.status]
      }), /* @__PURE__ */ jsx("span", {
        className: "text-gray-300 w-40 shrink-0",
        children: step.name
      }), /* @__PURE__ */ jsx("span", {
        className: "text-gray-400 flex-1",
        children: step.message
      }), /* @__PURE__ */ jsxs("span", {
        className: "text-gray-500 text-xs shrink-0",
        children: [step.durationMs, "ms"]
      })]
    }, i))
  })
});
const ScaleActionPanel = ({
  s
}) => {
  const sa = s.result && s.result.scaleAction;
  if (!sa)
    return null;
  return /* @__PURE__ */ jsx(Frame, {
    title: "Scale action",
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-1.5",
      children: [/* @__PURE__ */ jsx(Row, {
        label: "Triggered",
        children: /* @__PURE__ */ jsx("span", {
          className: sa.triggered ? "text-blue-400" : "text-gray-400",
          children: sa.triggered ? "yes" : "no"
        })
      }), sa.desiredCount !== void 0 && /* @__PURE__ */ jsx(Row, {
        label: "Desired count",
        children: sa.desiredCount
      }), sa.skippedReason && /* @__PURE__ */ jsx(Row, {
        label: "Skipped reason",
        children: sa.skippedReason
      })]
    })
  });
};
const OcrMonitorStatePanel = () => {
  const {
    state,
    isValidating,
    error
  } = useOcrMonitorState();
  const headerRight = /* @__PURE__ */ jsx("span", {
    className: "text-xs text-gray-500",
    children: isValidating ? "refreshing\u2026" : "auto-refreshes every 15 s"
  });
  if (error) {
    return /* @__PURE__ */ jsx(Frame, {
      title: "OCR Monitor State",
      headerRight,
      children: /* @__PURE__ */ jsx("p", {
        className: "text-sm text-red-400",
        children: error instanceof Error ? error.message : String(error)
      })
    });
  }
  if (!state) {
    return /* @__PURE__ */ jsx(Frame, {
      title: "OCR Monitor State",
      headerRight,
      children: /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-400",
        children: "Loading\u2026"
      })
    });
  }
  if (!state.jobId) {
    return /* @__PURE__ */ jsx(Frame, {
      title: "OCR Monitor State",
      headerRight,
      children: /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-400",
        children: state.message || "No monitor job found"
      })
    });
  }
  const result = state.result;
  const steps = result && result.report && result.report.steps;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-base font-medium text-gray-200",
        children: "OCR Monitor State"
      }), headerRight]
    }), /* @__PURE__ */ jsxs("div", {
      className: "grid grid-cols-1 lg:grid-cols-2 gap-4",
      children: [/* @__PURE__ */ jsx(JobMeta, {
        s: state
      }), /* @__PURE__ */ jsx(ScaleActionPanel, {
        s: state
      })]
    }), result && /* @__PURE__ */ jsx(Frame, {
      title: "Last run",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-1.5 mb-3",
        children: [/* @__PURE__ */ jsx(Row, {
          label: "Summary",
          children: /* @__PURE__ */ jsx("span", {
            className: result.report.success ? "text-green-400" : "text-red-400",
            children: result.report.summary
          })
        }), /* @__PURE__ */ jsx(Row, {
          label: "Ran at",
          children: /* @__PURE__ */ jsx(RelativeTime, {
            value: new Date(result.ranAt)
          })
        })]
      })
    }), steps && steps.length > 0 && /* @__PURE__ */ jsx(DiagnosticSteps, {
      steps
    })]
  });
};
const OcrMonitorStatePage = () => /* @__PURE__ */ jsx("div", {
  className: "p-4 max-w-4xl",
  children: /* @__PURE__ */ jsx(OcrMonitorStatePanel, {})
});

const buildIndexCirclesSSEUrl = (api, circleIds, startNew, token) => api.buildUrl("/circle-search/index-all", {
  circles: circleIds.join(","),
  token,
  new: startNew ? "1" : void 0
});

const initialState = {
  phase: "idle",
  circlesDone: 0,
  circlesTotal: 0,
  currentCircleId: void 0,
  circles: {},
  resumedAfter: void 0,
  error: void 0
};
const totalPostsIndexed = (state) => {
  let sum = 0;
  const ids = Object.keys(state.circles);
  for (let i = 0; i < ids.length; i++) {
    sum += state.circles[ids[i]].processed;
  }
  return sum;
};
const useCircleIndexer = (circleIds) => {
  const api = useApi();
  const jwt = useJwt();
  const [state, setState] = useState(initialState);
  const [runId, setRunId] = useState(0);
  const [url, setUrl] = useState("");
  const start = useMemoizedFn(() => {
    if (!circleIds || circleIds.length === 0) {
      setState({ ...initialState, phase: "failed", error: "No circles selected to index." });
      return;
    }
    if (!jwt) {
      setState({ ...initialState, phase: "failed", error: "Not authenticated \u2014 please sign in and try again." });
      return;
    }
    setState({ ...initialState, phase: "indexing" });
    setUrl(buildIndexCirclesSSEUrl(api, circleIds, true, jwt));
    setRunId((prev) => prev + 1);
  });
  const handlers = useMemo(() => [
    {
      event: "status",
      handler: (data) => {
        setState((prev) => ({
          ...prev,
          circlesTotal: data.total
        }));
      }
    },
    {
      event: "resumed",
      handler: (data) => {
        setState((prev) => ({
          ...prev,
          resumedAfter: data.afterCircleId
        }));
      }
    },
    {
      event: "circle",
      handler: (data) => {
        setState((prev) => {
          const circles = { ...prev.circles };
          if (prev.currentCircleId && circles[prev.currentCircleId]) {
            circles[prev.currentCircleId] = {
              ...circles[prev.currentCircleId],
              status: "done"
            };
          }
          const existing = circles[data.circleId];
          circles[data.circleId] = {
            circleId: data.circleId,
            processed: existing ? existing.processed : 0,
            total: existing ? existing.total : 0,
            status: "indexing"
          };
          return {
            ...prev,
            circlesDone: data.done,
            circlesTotal: data.total,
            currentCircleId: data.circleId,
            circles
          };
        });
      }
    },
    {
      event: "progress",
      handler: (data) => {
        setState((prev) => {
          const circles = { ...prev.circles };
          circles[data.circleId];
          circles[data.circleId] = {
            circleId: data.circleId,
            processed: data.processed,
            total: data.total,
            status: "indexing"
          };
          return { ...prev, circles };
        });
      }
    },
    {
      event: "complete",
      handler: (data) => {
        setState((prev) => {
          const circles = { ...prev.circles };
          if (prev.currentCircleId && circles[prev.currentCircleId]) {
            circles[prev.currentCircleId] = {
              ...circles[prev.currentCircleId],
              status: "done"
            };
          }
          return {
            ...prev,
            phase: "complete",
            circlesDone: data.indexed,
            circlesTotal: data.total,
            currentCircleId: void 0,
            circles
          };
        });
      }
    },
    {
      event: "failed",
      handler: (data) => {
        setState((prev) => ({
          ...prev,
          phase: "failed",
          error: data && data.error ? data.error : "Indexing failed"
        }));
      }
    }
  ], []);
  useSSEConnection({
    url,
    enabled: state.phase === "indexing" && url !== "",
    withCredentials: true,
    maxReconnectAttempts: 0,
    dependencies: [runId]
  }, handlers);
  const canStart = Boolean(jwt) && circleIds.length > 0;
  return { state, start, canStart };
};

const ProgressBar = ({
  processed,
  total
}) => {
  const pct = total > 0 ? Math.round(processed / total * 100) : 0;
  return /* @__PURE__ */ jsx("div", {
    className: "h-2 w-full rounded bg-gray-100 overflow-hidden",
    children: /* @__PURE__ */ jsx("div", {
      className: "h-full bg-blue-500 transition-all duration-300",
      style: {
        width: `${pct}%`
      }
    })
  });
};
const statusLabel = {
  pending: "Pending",
  indexing: "Indexing\u2026",
  done: "Done"
};
const CircleRow = ({
  circle,
  name
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col gap-1 py-2",
  children: [/* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-between gap-2",
    children: [/* @__PURE__ */ jsx("span", {
      className: "text-sm text-gray-700 truncate",
      children: name || circle.circleId
    }), /* @__PURE__ */ jsxs("span", {
      className: "text-xs text-gray-400 shrink-0",
      children: [statusLabel[circle.status], " \u2014 ", circle.processed, " / ", circle.total]
    })]
  }), /* @__PURE__ */ jsx(ProgressBar, {
    processed: circle.processed,
    total: circle.total
  })]
});
const CircleSearchIndexScreen = ({
  circleId,
  compact
}) => {
  const {
    data: circleData = {},
    isValidating: loadingCircle,
    error: circleError
  } = useCircle(circleId);
  const anchor = circleData.group;
  const anchorName = anchor && anchor.name ? anchor.name : "";
  const {
    data: subCircles
  } = useSubCircles(circleId);
  const [includeSub, setIncludeSub] = useState(false);
  const nameById = useMemo(() => {
    const map = {};
    if (anchor && anchor._id)
      map[anchor._id] = anchor.name;
    if (subCircles) {
      for (let i = 0; i < subCircles.length; i++) {
        const c = subCircles[i];
        map[c._id] = c.name;
      }
    }
    return map;
  }, [anchor, subCircles]);
  const circleIds = useMemo(() => {
    const ids = [circleId];
    if (includeSub && subCircles) {
      for (let i = 0; i < subCircles.length; i++) {
        ids.push(subCircles[i]._id);
      }
    }
    return ids;
  }, [circleId, includeSub, subCircles]);
  const {
    state,
    start,
    canStart
  } = useCircleIndexer(circleIds);
  const isMulti = circleIds.length > 1;
  const isIndexing = state.phase === "indexing";
  const hasSubCircles = subCircles && subCircles.length > 0;
  const handleStart = useMemoizedFn(() => start());
  const toggleSub = useMemoizedFn((event) => setIncludeSub(event.target.checked));
  const rows = useMemo(() => {
    return circleIds.map((id) => {
      const existing = state.circles[id];
      if (existing)
        return existing;
      return {
        circleId: id,
        processed: 0,
        total: 0,
        status: "pending"
      };
    });
  }, [circleIds, state.circles]);
  return /* @__PURE__ */ jsxs("div", {
    className: "ns flex flex-col gap-4 p-4 max-w-3xl mx-auto w-full",
    children: [!compact && /* @__PURE__ */ jsx("div", {
      className: "flex items-center justify-between gap-3",
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 min-w-0",
        children: [/* @__PURE__ */ jsx("h1", {
          className: "text-base font-medium text-gray-900 shrink-0",
          children: "Search index"
        }), /* @__PURE__ */ jsx("code", {
          className: "text-xs text-gray-400 bg-gray-100 px-2 py-0.5 rounded font-mono truncate",
          children: circleId
        })]
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "rounded-lg border border-gray-200 bg-white p-4",
      children: loadingCircle && !anchor ? /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 text-sm text-gray-400",
        children: [/* @__PURE__ */ jsx(Spinner, {
          size: "sm"
        }), "Loading circle\u2026"]
      }) : circleError ? /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: "Could not load circle info."
      }) : /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-1",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-xs uppercase tracking-wide text-gray-400",
          children: "Circle"
        }), /* @__PURE__ */ jsx("span", {
          className: "text-sm font-medium text-gray-900 truncate",
          children: anchorName || "(unnamed)"
        })]
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "rounded-lg border border-gray-200 bg-white p-4 flex flex-col gap-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between gap-3",
        children: [/* @__PURE__ */ jsxs("p", {
          className: "text-sm text-gray-500",
          children: ["Index all top-level posts in", isMulti ? ` ${circleIds.length} circles` : " this circle", " for search."]
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "primary",
          size: "sm",
          isLoading: isIndexing,
          disabled: !canStart,
          onClick: handleStart,
          leftIcon: /* @__PURE__ */ jsx(MdSearch, {
            size: 16
          }),
          children: isIndexing ? "Indexing\u2026" : "Index"
        })]
      }), !canStart && !isIndexing && state.phase !== "failed" && /* @__PURE__ */ jsx("p", {
        className: "text-xs text-gray-400",
        children: circleIds.length === 0 ? "No circles to index yet." : "Preparing \u2014 waiting for authentication\u2026"
      }), hasSubCircles && /* @__PURE__ */ jsx(Checkbox, {
        checked: includeSub,
        onChange: toggleSub,
        disabled: isIndexing,
        label: `Include ${subCircles.length} subcircle(s)`
      }), isMulti && (isIndexing || state.phase === "complete") && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-1",
        children: [/* @__PURE__ */ jsx(ProgressBar, {
          processed: state.circlesDone,
          total: state.circlesTotal
        }), /* @__PURE__ */ jsxs("span", {
          className: "text-xs text-gray-400",
          children: [state.circlesDone, " / ", state.circlesTotal, " circles indexed"]
        })]
      }), (isIndexing || state.phase === "complete") && /* @__PURE__ */ jsx("div", {
        className: "divide-y divide-gray-100",
        children: rows.map((row) => /* @__PURE__ */ jsx(CircleRow, {
          circle: row,
          name: nameById[row.circleId] || ""
        }, row.circleId))
      }), state.phase === "complete" && /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-green-600",
        children: ["Done \u2014 indexed ", totalPostsIndexed(state), " post(s)", isMulti && ` across ${state.circlesTotal} circle(s)`, "."]
      }), state.phase === "failed" && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx(ErrorPanel$1, {
          error: state.error || "Indexing failed."
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          size: "sm",
          onClick: handleStart,
          leftIcon: /* @__PURE__ */ jsx(MdSearch, {
            size: 16
          }),
          children: "Retry"
        })]
      })]
    })]
  });
};

const CircleSearchIndexPage = () => /* @__PURE__ */ jsx(BookCairPrototypePage, {
  routeSegment: "circle-search",
  children: (circleId) => circleId ? /* @__PURE__ */ jsx(CircleSearchIndexScreen, {
    circleId
  }) : /* @__PURE__ */ jsxs("div", {
    className: "p-6 text-sm text-gray-500",
    children: ["No circleId \u2014 append", " ", /* @__PURE__ */ jsxs("code", {
      className: "font-mono bg-gray-100 px-1 rounded",
      children: ["/", "{circleId}"]
    }), " ", "to the URL."]
  })
});

const SEARCH_FILTERS_OPTIONS = "search-filters";
const toFilterType = (t) => {
  switch (t) {
    case "number":
      return "number";
    case "Date":
      return "date";
    case "string":
    case "string[]":
    case "enum":
      return "string";
    default:
      return null;
  }
};
const isFilterable = (field) => toFilterType(field.type) !== null;
const MetadataFilterFieldsPage = () => {
  const location = useLocation();
  const segments = location.pathname.split("/").filter((v) => v);
  const circleId = segments[segments.length - 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(MetadataFilterFieldsPageInner, {
      circleId
    })]
  });
};
const MetadataFilterFieldsPageInner = ({
  circleId
}) => {
  const {
    data: circleData
  } = useCircle(circleId);
  const {
    data,
    isValidating,
    mutate
  } = useCircleOptions({
    input: {
      circleId,
      types: [SEARCH_FILTERS_OPTIONS]
    }
  });
  const {
    saveCircleOptions,
    errorMessages
  } = useSaveBatchCircleOptionsMutation();
  const {
    addToast
  } = useToast();
  const [selected, setSelected] = useState([]);
  useEffect(() => {
    const groups = data && data.batchCircleOptions && data.batchCircleOptions.options;
    const entry = groups && groups.find((o) => o.type === SEARCH_FILTERS_OPTIONS);
    const saved = entry && entry.options && entry.options.filters;
    if (Array.isArray(saved)) {
      setSelected(saved);
    }
  }, [data]);
  const toggle = useMemoizedFn((field) => {
    const type = toFilterType(field.type);
    if (!type)
      return;
    setSelected((prev) => prev.some((f) => f.field === field.shortName) ? prev.filter((f) => f.field !== field.shortName) : [...prev, {
      field: field.shortName,
      type
    }]);
  });
  const {
    execute: onSave,
    isLoading: saving
  } = useAsyncOperation(async () => {
    await saveCircleOptions({
      input: {
        circleId,
        options: [{
          type: SEARCH_FILTERS_OPTIONS,
          options: {
            filters: selected
          }
        }]
      }
    });
    await mutate();
    addToast({
      type: "success",
      message: "Search filters saved"
    });
  });
  const circle = circleData && circleData.group;
  const loading = !circle && !circleData;
  if (loading) {
    return /* @__PURE__ */ jsx(LoadingOverlay, {
      isOpen: true,
      message: "Loading circle..."
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("ns sm:px-[54px] text-base w-full pb-4 min-h-screen"),
    "data-testid": "MetadataFilterFieldsPage",
    children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex w-full flex-col gap-4 p-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between gap-3",
        children: [/* @__PURE__ */ jsx(CircleFilterBreadcrumb, {
          circle
        }), /* @__PURE__ */ jsx(ActionButton, {
          onClick: onSave,
          disabled: saving,
          children: "Save"
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-1",
        children: [/* @__PURE__ */ jsx("h1", {
          className: "text-lg font-semibold",
          children: "Search filter fields"
        }), /* @__PURE__ */ jsxs("p", {
          className: "text-sm text-gray-500",
          children: ["Select the metadata fields readers can filter by when searching this circle. ", selected.length, " selected."]
        })]
      }), errorMessages && errorMessages.length > 0 && /* @__PURE__ */ jsx("div", {
        className: "rounded-md bg-red-50 px-3 py-2 text-sm text-red-700",
        children: errorMessages.join(" ")
      }), /* @__PURE__ */ jsx(FieldGroup, {
        title: "General metadata",
        fields: metadataFields,
        selected,
        onToggle: toggle,
        busy: isValidating
      }), /* @__PURE__ */ jsx(FieldGroup, {
        title: "Interview metadata",
        fields: interviewFields,
        selected,
        onToggle: toggle,
        busy: isValidating
      })]
    })]
  });
};
const CircleFilterBreadcrumb = ({
  circle
}) => {
  const parent = circle && circle.parent;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), parent && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(parent),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: "..."
        })
      })]
    }), circle && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circle),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: circle.name
        })
      })]
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(StyledBreadCrumb, {
      children: "Search filters"
    })]
  });
};
const FieldGroup = ({
  title,
  fields,
  selected,
  onToggle,
  busy
}) => {
  const count = fields.filter((f) => selected.some((s) => s.field === f.shortName)).length;
  return /* @__PURE__ */ jsxs("section", {
    className: "rounded-lg border border-gray-200 bg-white",
    children: [/* @__PURE__ */ jsxs("header", {
      className: "flex items-center justify-between border-b border-gray-100 px-4 py-2.5",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-sm font-semibold text-gray-800",
        children: title
      }), /* @__PURE__ */ jsxs("span", {
        className: "text-xs text-gray-400",
        children: [count, " / ", fields.length]
      })]
    }), /* @__PURE__ */ jsx("ul", {
      className: "divide-y divide-gray-100",
      children: fields.map((field) => /* @__PURE__ */ jsx(FieldRow, {
        field,
        checked: selected.some((s) => s.field === field.shortName),
        onToggle,
        disabled: busy || !isFilterable(field)
      }, field.shortName))
    })]
  });
};
const typeBadge = cva("inline-block rounded px-1.5 py-0.5 text-[11px] font-medium leading-none", {
  variants: {
    type: {
      string: "bg-slate-100 text-slate-600",
      number: "bg-amber-100 text-amber-700",
      Date: "bg-sky-100 text-sky-700",
      "string[]": "bg-violet-100 text-violet-700",
      enum: "bg-emerald-100 text-emerald-700",
      attachment: "bg-gray-100 text-gray-400"
    }
  },
  defaultVariants: {
    type: "string"
  }
});
const FieldRow = ({
  field,
  checked,
  onToggle,
  disabled
}) => {
  const filterable = isFilterable(field);
  return /* @__PURE__ */ jsxs("li", {
    className: clsx("flex items-start gap-3 px-4 py-3", disabled && !filterable && "opacity-60"),
    children: [/* @__PURE__ */ jsx("div", {
      className: "pt-0.5",
      children: /* @__PURE__ */ jsx(Checkbox, {
        checked,
        disabled,
        onChange: () => onToggle(field),
        "aria-label": field.name
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex min-w-0 flex-1 flex-col gap-0.5",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-sm font-medium text-gray-800",
          children: field.name
        }), /* @__PURE__ */ jsx("span", {
          className: typeBadge({
            type: field.type
          }),
          children: field.type
        }), /* @__PURE__ */ jsx("code", {
          className: "text-[11px] text-gray-400",
          children: field.shortName
        })]
      }), /* @__PURE__ */ jsx("p", {
        className: "text-xs leading-snug text-gray-500",
        children: filterable ? field.description : "Not available as a filter."
      })]
    })]
  });
};

const MigrationRunnerBreadcrumb = ({
  circleId
}) => {
  const {
    data: circleData
  } = useCircle(circleId);
  const circle = circleData && circleData.group;
  const parent = circle && circle.parent;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), parent && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(parent),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: "..."
        })
      })]
    }), circle && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circleId),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: circle.name
        })
      })]
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(StyledBreadCrumb, {
      children: "RAG Migrations"
    })]
  });
};

const MIGRATION_CATALOG = [
  {
    key: "rootpostid-postkind",
    label: "1. RootPostId + PostKind backfill",
    path: "/rag/migrations/rootpostid-postkind/run"
  },
  {
    key: "chunk-metadata",
    label: "2. Chunk metadata resync",
    path: "/rag/migrations/chunk-metadata/run"
  },
  {
    key: "chunk-orphan-audit",
    label: "3. Chunk orphan audit",
    path: "/rag/migrations/chunk-orphan-audit/run"
  },
  {
    key: "sorani-field",
    label: "4. Sorani search field backfill",
    path: "/rag/migrations/sorani-field/run"
  },
  {
    key: "entity-values-backfill",
    label: "5. Entity values backfill",
    path: "/entity-values/migrations/backfill/run"
  },
  {
    key: "unindexed-post-backfill",
    label: "6. Unindexed post backfill",
    path: "/rag/migrations/unindexed-post-backfill/run"
  },
  {
    key: "qwen-embedding-backfill",
    label: "7. Qwen embedding backfill (test circle only)",
    path: "/rag/migrations/qwen-embedding-backfill/run"
  }
];
const migrationDefByKey = (key) => {
  const found = MIGRATION_CATALOG.find((def) => def.key === key);
  return found ? found : MIGRATION_CATALOG[0];
};

const migrationOptions = MIGRATION_CATALOG.map((def) => ({
  value: def.key,
  label: def.label
}));
const MigrationRunSelector = ({
  routeCircleId,
  onExecute
}) => {
  const [migrationKey, setMigrationKey] = useState(MIGRATION_CATALOG[0].key);
  const [scoped, setScoped] = useState(routeCircleId ? true : false);
  const [circleIdsText, setCircleIdsText] = useState(routeCircleId || "");
  const [force, setForce] = useState(false);
  const onCircleIdsChange = useMemoizedFn((e) => {
    setCircleIdsText(e.target.value);
  });
  const execute = useMemoizedFn(() => {
    const circleIds = scoped ? circleIdsText.split(",").map((v) => v.trim()).filter((v) => v.length > 0) : [];
    onExecute({
      migrationKey,
      circleIds,
      force
    });
  });
  return /* @__PURE__ */ jsxs(FormSection, {
    className: "flex flex-col gap-3 w-full max-w-xl",
    children: [/* @__PURE__ */ jsx(Select, {
      label: "Migration",
      value: migrationKey,
      onChange: setMigrationKey,
      options: migrationOptions
    }), /* @__PURE__ */ jsx(Switch, {
      label: "Process selected circles only",
      checked: scoped,
      onChange: setScoped
    }), scoped && /* @__PURE__ */ jsx(TextInput, {
      label: "Circle IDs (comma separated)",
      value: circleIdsText,
      onChange: onCircleIdsChange,
      helperText: "Leave a single id to run against just this circle, or add more separated by commas"
    }), /* @__PURE__ */ jsx(Switch, {
      label: "Force re-run if already finished",
      checked: force,
      onChange: setForce,
      helperText: "Only affects a migration that already completed for this exact scope \u2014 an in-progress or stopped run always resumes"
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "primary",
      onClick: execute,
      children: "Execute"
    })]
  });
};

const MAX_RECONNECT_ATTEMPTS = 1e6;
const useMigrationSSE = (run) => {
  const api = useApi();
  const jwt = useJwt();
  const def = migrationDefByKey(run.migrationKey);
  const [phase, setPhase] = useState("connecting");
  const [force, setForce] = useState(run.force);
  const [initialStatus, setInitialStatus] = useState(null);
  const [progress, setProgress] = useState(null);
  const [result, setResult] = useState(null);
  const [failure, setFailure] = useState(null);
  const gotFirstMessageRef = useRef(false);
  const url = useMemo(() => {
    if (!jwt) {
      return "";
    }
    const params = { token: jwt };
    if (force) {
      params.force = "true";
    }
    if (run.circleIds.length > 0) {
      params.circleIds = run.circleIds.join(",");
    }
    return api.buildUrl(def.path, params);
  }, [api, jwt, force, run.circleIds, def.path]);
  const handleProgress = useMemoizedFn((data) => {
    if (!gotFirstMessageRef.current) {
      gotFirstMessageRef.current = true;
      setInitialStatus(data);
      if (force) {
        setForce(false);
      }
    }
    setPhase("running");
    setProgress(data);
  });
  const handleComplete = useMemoizedFn((data) => {
    setResult(data);
    setPhase("complete");
  });
  const handleFailed = useMemoizedFn((data) => {
    setFailure(data);
    setPhase("failed");
  });
  const { isConnected, disconnect, reconnect } = useSSEConnection({
    url,
    enabled: url !== "" && (phase === "connecting" || phase === "running"),
    maxReconnectAttempts: MAX_RECONNECT_ATTEMPTS
  }, [
    { event: "progress", handler: handleProgress },
    { event: "complete", handler: handleComplete },
    { event: "failed", handler: handleFailed }
  ]);
  const stop = useMemoizedFn(() => {
    disconnect();
    setPhase("stopped");
  });
  const resume = useMemoizedFn(() => {
    setFailure(null);
    setPhase("connecting");
    reconnect();
  });
  return { phase, initialStatus, progress, result, failure, isConnected, stop, resume };
};

const CircleNameChip = ({
  circleId
}) => {
  const {
    data
  } = useCircle(circleId);
  const circle = data && data.group;
  return /* @__PURE__ */ jsx("a", {
    href: circleUrl(circleId),
    className: "text-blue-600 underline",
    children: circle ? circle.name : circleId
  });
};

const HIDDEN_STAT_KEYS = ["lastCircleId", "lastPostId", "mappingApplied"];
const phaseLabel = (phase) => {
  if (phase === "connecting")
    return "Connecting\u2026";
  if (phase === "running")
    return "Running";
  if (phase === "stopped")
    return "Stopped";
  if (phase === "complete")
    return "Complete";
  if (phase === "failed")
    return "Failed";
  return phase;
};
const phaseTextClass = (phase) => {
  if (phase === "complete")
    return "text-green-700";
  if (phase === "failed")
    return "text-red-700";
  if (phase === "stopped")
    return "text-gray-500";
  return "text-blue-700";
};
const StatsGrid = ({
  stats
}) => {
  const keys = Object.keys(stats).filter((k) => HIDDEN_STAT_KEYS.indexOf(k) === -1);
  if (keys.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", {
    className: "grid grid-cols-2 gap-x-4 gap-y-1 text-sm",
    children: keys.map((key) => /* @__PURE__ */ jsxs("div", {
      className: "flex justify-between gap-2 border-b border-gray-100 py-0.5",
      children: [/* @__PURE__ */ jsx("span", {
        className: "text-gray-500",
        children: key
      }), /* @__PURE__ */ jsx("span", {
        className: "font-medium",
        children: String(stats[key])
      })]
    }, key))
  });
};
const MigrationRunCard = ({
  run,
  onRemove
}) => {
  const def = migrationDefByKey(run.migrationKey);
  const {
    phase,
    initialStatus,
    progress,
    result,
    failure,
    stop,
    resume
  } = useMigrationSSE(run);
  const latest = progress ? progress : initialStatus;
  const stats = latest ? latest.stats : result ? result.stats : null;
  const processed = latest ? latest.processed : 0;
  const currentCircleId = progress ? progress.circleId : void 0;
  const canStop = phase === "connecting" || phase === "running";
  const canResume = phase === "stopped" || phase === "failed";
  const canDismiss = phase === "complete" || phase === "failed";
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 rounded-md border border-gray-200 p-3",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-col",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: def.label
        }), /* @__PURE__ */ jsx("span", {
          className: `text-xs ${phaseTextClass(phase)}`,
          children: phaseLabel(phase)
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [canStop && /* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          size: "sm",
          onClick: stop,
          children: "Stop"
        }), canResume && /* @__PURE__ */ jsx(ActionButton, {
          intent: "primary",
          size: "sm",
          onClick: resume,
          children: "Resume"
        }), canDismiss && /* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          size: "sm",
          onClick: () => onRemove(run.id),
          children: "Dismiss"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-wrap items-center gap-1 text-xs text-gray-500",
      children: [run.circleIds.length === 0 && /* @__PURE__ */ jsx("span", {
        children: "All circles"
      }), run.circleIds.map((circleId) => /* @__PURE__ */ jsx(CircleNameChip, {
        circleId
      }, circleId)), run.force && /* @__PURE__ */ jsx("span", {
        className: "rounded bg-amber-100 px-1.5 py-0.5 text-amber-700",
        children: "force"
      })]
    }), initialStatus && /* @__PURE__ */ jsxs("div", {
      className: "text-xs text-gray-500",
      children: ["Resuming from processed=", initialStatus.processed, initialStatus.error && initialStatus.error.length > 0 ? `, ${initialStatus.error.length} prior error(s)` : ""]
    }), currentCircleId && /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-1 text-xs text-gray-500",
      children: ["Current circle: ", /* @__PURE__ */ jsx(CircleNameChip, {
        circleId: currentCircleId
      })]
    }), stats && /* @__PURE__ */ jsx(StatsGrid, {
      stats
    }), processed > 0 && /* @__PURE__ */ jsxs("div", {
      className: "text-xs text-gray-500",
      children: [processed, " circle(s) processed"]
    }), failure && /* @__PURE__ */ jsx("div", {
      className: "rounded bg-red-50 px-2 py-1 text-sm text-red-700",
      children: failure.message ? failure.message : "Migration failed"
    }), result && phase === "complete" && /* @__PURE__ */ jsx("div", {
      className: "text-xs text-green-700",
      children: result.alreadyFinished ? "Already finished on a previous run" : "Finished this run"
    })]
  });
};

const MigrationRunsList = ({
  runs,
  onRemove
}) => {
  if (runs.length === 0) {
    return /* @__PURE__ */ jsx("div", {
      className: "text-sm text-gray-500",
      children: "No migrations running yet \u2014 pick one above and click Execute."
    });
  }
  return /* @__PURE__ */ jsx("div", {
    className: "flex w-full flex-col gap-3",
    children: runs.map((run) => /* @__PURE__ */ jsx(MigrationRunCard, {
      run,
      onRemove
    }, run.id))
  });
};

const createRunId = () => {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
};
const useMigrationRuns = () => {
  const [runs, setRuns] = useState([]);
  const addRun = useMemoizedFn((input) => {
    const run = { ...input, id: createRunId() };
    setRuns((prev) => [run, ...prev]);
  });
  const removeRun = useMemoizedFn((id) => {
    setRuns((prev) => prev.filter((r) => r.id !== id));
  });
  return { runs, addRun, removeRun };
};

const ROUTE_SEGMENT = "rag-migrations";
const MigrationRunnerPage = () => {
  const location = useLocation();
  const all = location.pathname.split("/").filter((v) => v);
  const last = all[all.length - 1];
  const circleId = last === ROUTE_SEGMENT ? "" : last;
  const {
    runs,
    addRun,
    removeRun
  } = useMigrationRuns();
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns w-full min-h-screen pb-4 p-2 sm:px-[54px]",
      "data-testid": "MigrationRunnerPage",
      children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsxs("div", {
        className: "flex w-full flex-col items-start gap-4",
        children: [/* @__PURE__ */ jsx(MigrationRunnerBreadcrumb, {
          circleId
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-2",
          children: [/* @__PURE__ */ jsx("h1", {
            className: "text-2xl font-bold",
            children: "RAG Migrations"
          }), /* @__PURE__ */ jsx("p", {
            className: "max-w-2xl text-sm text-gray-600",
            children: "Run a registered migration against one or more circles, or against every eligible circle in this instance. Each run keeps streaming progress until you stop it \u2014 closing the tab or clicking Stop is safe, Resume picks up where it left off."
          })]
        }), /* @__PURE__ */ jsx(MigrationRunSelector, {
          routeCircleId: circleId,
          onExecute: addRun
        }), /* @__PURE__ */ jsx(MigrationRunsList, {
          runs,
          onRemove: removeRun
        })]
      })]
    })]
  });
};

const DEV_TOOLS = [
  {
    label: "Test Corpus",
    description: "Import and export test content (directories, JSON bundles) to run the search agent against.",
    href: (circleId) => `/trans/admin/test-corpus/${circleId}`
  },
  {
    label: "Test Agent",
    description: "Run a question through the agentic search loop and inspect the round-by-round trace.",
    href: (circleId) => `/trans/admin/agent-test/${circleId}`
  },
  {
    label: "Agent Chat",
    description: "Multi-turn conversation prototype \u2014 threads persisted via ConversationService.",
    href: (circleId) => `/trans/admin/agent-chat-desktop/${circleId}`
  },
  {
    label: "Circle Posts Operations",
    description: "Combine, translate, duplicate, or bulk-unpublish posts in this circle.",
    href: (circleId) => `/trans/combine-posts/${circleId}`
  },
  {
    label: "Configure Circle AI Search",
    description: "Vector search settings - hybrid weighting, item counts, minimum score.",
    href: (circleId) => `/trans/admin/vector-search-index/${circleId}`
  },
  {
    label: "Configure Search Filters",
    description: "Which metadata fields readers can filter search results by.",
    href: (circleId) => `/trans/admin/configure-filters/${circleId}`
  },
  {
    label: "Configure Categories",
    description: "Classification schema and category dimensions for this circle.",
    href: (circleId) => `/trans/admin/vector-search-categories/${circleId}`
  }
];

const CircleDeveloperDashboardPage = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const circleId = parts[3];
  const isDeveloper = useIsDeveloper();
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  if (!isDeveloper) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-4 text-sm text-gray-500",
      children: "Only developers can view this page."
    });
  }
  if (!circleId) {
    return null;
  }
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns p-2 h-full flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx(CircleBreadcrumb, {
        circleId,
        current: "Developer Dashboard"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-1",
        children: [/* @__PURE__ */ jsx("h1", {
          className: "text-lg font-semibold",
          children: "Circle Developer Dashboard"
        }), /* @__PURE__ */ jsx("p", {
          className: "text-sm text-gray-500",
          children: "Internal tools for this circle - visible to developers only."
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-2 max-w-2xl",
        children: DEV_TOOLS.map((tool) => /* @__PURE__ */ jsxs("a", {
          href: tool.href(circleId),
          className: "flex flex-col gap-0.5 border border-gray-200 rounded-lg px-4 py-3 hover:border-blue-300 hover:bg-blue-50 transition-colors",
          children: [/* @__PURE__ */ jsx("span", {
            className: "text-sm font-medium text-gray-900",
            children: tool.label
          }), /* @__PURE__ */ jsx("span", {
            className: "text-xs text-gray-500",
            children: tool.description
          })]
        }, tool.label))
      })]
    }), /* @__PURE__ */ jsx(ToastContainer, {})]
  });
};

const tabsBarVariants = cva("flex", {
  variants: {
    variant: {
      underline: "border-b border-gray-200",
      pill: "gap-1 p-1 bg-gray-100 rounded-lg"
    }
  },
  defaultVariants: {
    variant: "underline"
  }
});
const tabItemVariants = cva("inline-flex items-center font-medium transition-colors focus:outline-none disabled:opacity-40 disabled:pointer-events-none", {
  variants: {
    variant: {
      underline: "px-4 py-2 text-sm border-b-2 -mb-px",
      pill: "px-3 py-1.5 text-sm rounded-md"
    },
    active: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [{
    variant: "underline",
    active: true,
    className: "border-blue-600 text-blue-600"
  }, {
    variant: "underline",
    active: false,
    className: "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
  }, {
    variant: "pill",
    active: true,
    className: "bg-white text-gray-900 shadow-sm"
  }, {
    variant: "pill",
    active: false,
    className: "text-gray-500 hover:text-gray-700"
  }],
  defaultVariants: {
    variant: "underline",
    active: false
  }
});
const Tabs = ({
  tabs,
  value,
  onChange,
  variant,
  className
}) => /* @__PURE__ */ jsx("div", {
  className: tabsBarVariants({
    variant,
    className
  }),
  role: "tablist",
  children: tabs.map((tab) => /* @__PURE__ */ jsx("button", {
    role: "tab",
    "aria-selected": tab.key === value,
    disabled: tab.disabled,
    onClick: () => onChange(tab.key),
    className: tabItemVariants({
      variant,
      active: tab.key === value
    }),
    children: tab.label
  }, tab.key))
});

const useBookPaths = () => {
  const api = useApi();
  const { data, error, mutate } = useSWR(api ? "test-corpus-book-paths" : null, () => api.get({ path: "/test-corpus/book-paths" }), swrLoadOnce);
  return {
    paths: data && data.paths || [],
    isLoading: !error && !data,
    error,
    mutate
  };
};

const usePreviewImportDirectory = () => {
  const api = useApi();
  return useAsyncOperation(async (params) => {
    const result = await api.post({
      path: "/test-corpus/import-directory",
      body: { ...params, dryRun: true }
    });
    if (!result || !Array.isArray(result.books)) {
      throw new Error("The server did not return a preview - check that /test-corpus/import-directory supports dryRun and bookPaths.");
    }
    return result.books;
  });
};
const useImportDirectory = () => {
  const api = useApi();
  return useAsyncOperation(async (params) => {
    return api.post({
      path: "/test-corpus/import-directory",
      body: params
    });
  });
};

const BookPathList = ({
  paths,
  selectedPaths,
  onChange
}) => {
  const [filter, setFilter] = useState("");
  const filtered = useMemo(() => paths.filter((p) => p.toLowerCase().includes(filter.toLowerCase())), [paths, filter]);
  const toggle = (path) => {
    const next = new Set(selectedPaths);
    if (next.has(path)) {
      next.delete(path);
    } else {
      next.add(path);
    }
    onChange(next);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: [/* @__PURE__ */ jsx(TextInput, {
        value: filter,
        onChange: (e) => setFilter(e.target.value),
        placeholder: "Filter by path\u2026",
        className: "flex-1"
      }), /* @__PURE__ */ jsx("button", {
        onClick: () => onChange(new Set(filtered)),
        className: "text-xs text-blue-600 hover:text-blue-800 font-medium whitespace-nowrap",
        children: "Select all"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "border border-gray-200 rounded-md divide-y divide-gray-100 max-h-96 overflow-y-auto",
      children: [filtered.map((path) => /* @__PURE__ */ jsxs("label", {
        className: "flex items-center gap-3 px-3 py-2 hover:bg-gray-50 cursor-pointer",
        children: [/* @__PURE__ */ jsx("input", {
          type: "checkbox",
          checked: selectedPaths.has(path),
          onChange: () => toggle(path),
          className: "rounded border-gray-300 text-blue-600 focus:ring-blue-400"
        }), /* @__PURE__ */ jsx("span", {
          className: "text-xs font-mono text-gray-600 truncate",
          children: path
        })]
      }, path)), filtered.length === 0 && /* @__PURE__ */ jsx("div", {
        className: "px-3 py-6 text-sm text-gray-400 text-center",
        children: "No book paths match."
      })]
    })]
  });
};

const ImportPreviewList = ({
  entries,
  selectedPaths,
  onToggle
}) => /* @__PURE__ */ jsxs("div", {
  className: "border border-gray-200 rounded-md divide-y divide-gray-100",
  children: [entries.map((entry) => /* @__PURE__ */ jsxs("label", {
    className: "flex items-start gap-3 px-3 py-2.5 cursor-pointer hover:bg-gray-50",
    children: [/* @__PURE__ */ jsx("input", {
      type: "checkbox",
      checked: selectedPaths.has(entry.path),
      onChange: () => onToggle(entry.path),
      className: "mt-0.5 rounded border-gray-300 text-blue-600 focus:ring-blue-400 shrink-0"
    }), /* @__PURE__ */ jsxs("div", {
      className: "min-w-0 flex-1",
      children: [/* @__PURE__ */ jsx("div", {
        className: "text-sm text-gray-800 break-words",
        dir: entry.lang === "ar" ? "rtl" : "ltr",
        children: entry.title
      }), /* @__PURE__ */ jsx("div", {
        className: "text-xs text-gray-400 font-mono break-words",
        children: entry.path
      }), entry.similarTo && /* @__PURE__ */ jsxs("div", {
        className: "text-xs text-blue-600 mt-1",
        children: ['looks similar to "', entry.similarTo.title, '" (', Math.round(entry.similarTo.score * 100), "% match) \u2014 still your call"]
      })]
    }), entry.willBe === "skipped" && /* @__PURE__ */ jsx(Chip, {
      variant: "warning",
      size: "sm",
      children: "already at this path"
    })]
  }, entry.path)), entries.length === 0 && /* @__PURE__ */ jsx("div", {
    className: "px-3 py-6 text-sm text-gray-400 text-center",
    children: "Nothing to show."
  })]
});

const ImportResultSummary = ({
  summary,
  onReset
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col gap-3 border border-gray-200 rounded-lg bg-gray-50 px-4 py-3",
  children: [/* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-3",
    children: [/* @__PURE__ */ jsxs(Chip, {
      variant: "success",
      size: "sm",
      children: [summary.booksCreated, " created"]
    }), /* @__PURE__ */ jsxs(Chip, {
      variant: "warning",
      size: "sm",
      children: [summary.booksSkipped, " skipped"]
    }), summary.errors.length > 0 && /* @__PURE__ */ jsxs(Chip, {
      variant: "error",
      size: "sm",
      children: [summary.errors.length, " failed"]
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "secondary",
      onClick: onReset,
      className: "ml-auto text-xs px-3 py-1",
      children: "Run again"
    })]
  }), summary.errors.length > 0 && /* @__PURE__ */ jsx("ul", {
    className: "flex flex-col gap-1 text-xs text-red-700",
    children: summary.errors.map((err) => /* @__PURE__ */ jsxs("li", {
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-mono",
        children: err.path
      }), ": ", err.message]
    }, err.path))
  })]
});

const ImportCorpusTab = ({
  circleId
}) => {
  const {
    paths,
    isLoading: pathsLoading,
    error: pathsError
  } = useBookPaths();
  const [selectedPaths, setSelectedPaths] = useState(new Set());
  const [stage, setStage] = useState("browse");
  const [previewEntries, setPreviewEntries] = useState([]);
  const [confirmedPaths, setConfirmedPaths] = useState(new Set());
  const [summary, setSummary] = useState(null);
  const preview = usePreviewImportDirectory();
  const doImport = useImportDirectory();
  const runPreview = useMemoizedFn(async () => {
    const entries = await preview.execute({
      circleId,
      bookPaths: Array.from(selectedPaths)
    });
    setPreviewEntries(entries);
    setConfirmedPaths(new Set(entries.map((entry) => entry.path)));
    setStage("previewed");
  });
  const toggleConfirmed = useMemoizedFn((path) => {
    setConfirmedPaths((prev) => {
      const next = new Set(prev);
      if (next.has(path)) {
        next.delete(path);
      } else {
        next.add(path);
      }
      return next;
    });
  });
  const runImport = useMemoizedFn(async () => {
    const result = await doImport.execute({
      circleId,
      bookPaths: Array.from(confirmedPaths)
    });
    setSummary(result);
    setStage("done");
  });
  const reset = useMemoizedFn(() => {
    setStage("browse");
    setSelectedPaths(new Set());
    setPreviewEntries([]);
    setConfirmedPaths(new Set());
    setSummary(null);
  });
  if (pathsLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: "flex justify-center py-12",
      children: /* @__PURE__ */ jsx(Spinner, {})
    });
  }
  if (pathsError) {
    return /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: pathsError
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [stage === "browse" && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(BookPathList, {
        paths,
        selectedPaths,
        onChange: setSelectedPaths
      }), /* @__PURE__ */ jsxs(ActionButton, {
        intent: "primary",
        onClick: runPreview,
        disabled: selectedPaths.size === 0,
        isLoading: preview.isLoading,
        className: "self-start px-4 py-2",
        children: ["Preview import (", selectedPaths.size, ")"]
      }), preview.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: preview.error
      })]
    }), stage === "previewed" && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("p", {
        className: "text-xs text-gray-500",
        children: "Nothing has been created yet."
      }), /* @__PURE__ */ jsx(ImportPreviewList, {
        entries: previewEntries,
        selectedPaths: confirmedPaths,
        onToggle: toggleConfirmed
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2",
        children: [/* @__PURE__ */ jsxs(ActionButton, {
          intent: "primary",
          onClick: runImport,
          disabled: confirmedPaths.size === 0,
          isLoading: doImport.isLoading,
          className: "px-4 py-2",
          children: ["Import ", confirmedPaths.size, " book", confirmedPaths.size === 1 ? "" : "s"]
        }), /* @__PURE__ */ jsx(ActionButton, {
          intent: "secondary",
          onClick: () => setStage("browse"),
          className: "px-4 py-2",
          children: "Back"
        })]
      }), doImport.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: doImport.error
      })]
    }), stage === "done" && summary && /* @__PURE__ */ jsx(ImportResultSummary, {
      summary,
      onReset: reset
    })]
  });
};

const readBundleFile = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => {
    try {
      resolve(JSON.parse(reader.result));
    } catch (parseError) {
      reject(new Error("Not a valid JSON file"));
    }
  };
  reader.onerror = () => reject(reader.error);
  reader.readAsText(file);
});
const usePreviewImportBundle = () => {
  const api = useApi();
  return useAsyncOperation(async (params) => {
    const { file, circleId, pathPrefix } = params;
    const bundle = await readBundleFile(file);
    const result = await api.post({
      path: "/test-corpus/import-bundle",
      body: { circleId, bundle, pathPrefix, dryRun: true }
    });
    if (!result || !Array.isArray(result.books)) {
      throw new Error("The server did not return a preview - check that /test-corpus/import-bundle supports dryRun.");
    }
    return { bundle, entries: result.books };
  });
};
const useConfirmImportBundle = () => {
  const api = useApi();
  return useAsyncOperation(async (params) => {
    return api.post({
      path: "/test-corpus/import-bundle",
      body: params
    });
  });
};

const RootPathField = ({
  value,
  onChange,
  label,
  helperText
}) => /* @__PURE__ */ jsx(TextInput, {
  label: label || "Path",
  value,
  onChange: (e) => onChange(e.target.value),
  placeholder: "baghdad-history",
  helperText,
  className: "font-mono"
});

const detectCommonRoot = (paths) => {
  const roots = new Set(paths.map((p) => {
    const idx = p.lastIndexOf("/");
    return idx === -1 ? "" : p.slice(0, idx);
  }));
  return roots.size === 1 ? Array.from(roots)[0] || null : null;
};
const JsonImportTab = ({
  circleId
}) => {
  const [stage, setStage] = useState("empty");
  const [fileName, setFileName] = useState("");
  const [rootPath, setRootPath] = useState("");
  const [previewedRootPath, setPreviewedRootPath] = useState("");
  const [bundle, setBundle] = useState(null);
  const [entries, setEntries] = useState([]);
  const [selectedPaths, setSelectedPaths] = useState(new Set());
  const [summary, setSummary] = useState(null);
  const fileRef = useRef(null);
  const preview = usePreviewImportBundle();
  const confirm = useConfirmImportBundle();
  const runPreview = useMemoizedFn(async (file) => {
    fileRef.current = file;
    setFileName(file.name);
    const result = await preview.execute({
      file,
      circleId,
      pathPrefix: rootPath || void 0
    });
    setBundle(result.bundle);
    setEntries(result.entries);
    setSelectedPaths(new Set(result.entries.map((entry) => entry.path)));
    const effectiveRootPath = rootPath || detectCommonRoot(result.entries.map((entry) => entry.bookPath)) || "";
    setRootPath(effectiveRootPath);
    setPreviewedRootPath(effectiveRootPath);
    setStage("previewed");
  });
  const dropzone = useDropzone({
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        runPreview(file);
      }
    },
    accept: [".json"],
    maxFiles: 1,
    multiple: false
  });
  const rePreview = useMemoizedFn(() => {
    if (fileRef.current) {
      runPreview(fileRef.current);
    }
  });
  const toggle = useMemoizedFn((path) => {
    setSelectedPaths((prev) => {
      const next = new Set(prev);
      if (next.has(path)) {
        next.delete(path);
      } else {
        next.add(path);
      }
      return next;
    });
  });
  const runImport = useMemoizedFn(async () => {
    if (!bundle) {
      return;
    }
    const selectedBookPaths = new Set(entries.filter((entry) => selectedPaths.has(entry.path)).map((entry) => entry.bookPath));
    const filteredBundle = {
      ...bundle,
      books: bundle.books.filter((book) => selectedBookPaths.has(book.path))
    };
    const result = await confirm.execute({
      bundle: filteredBundle,
      circleId,
      pathPrefix: rootPath || void 0
    });
    setSummary(result);
    setStage("done");
  });
  const reset = useMemoizedFn(() => {
    setStage("empty");
    setFileName("");
    setBundle(null);
    setEntries([]);
    setSelectedPaths(new Set());
    setSummary(null);
    fileRef.current = null;
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [stage === "empty" && /* @__PURE__ */ jsx(DropZone, {
      ...dropzone,
      className: "min-h-32",
      children: /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-500 mb-2",
        children: "Upload a post bundle (.json)"
      })
    }), stage !== "empty" && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 text-sm text-gray-700",
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-mono text-xs",
          children: fileName
        }), /* @__PURE__ */ jsxs("span", {
          className: "text-xs text-gray-400 ml-auto",
          children: [entries.length, " posts in file"]
        })]
      }), /* @__PURE__ */ jsx(RootPathField, {
        value: rootPath,
        onChange: setRootPath,
        label: "Import under path",
        helperText: "Applies to every post below - change it to import fresh copies instead of matching existing ones."
      }), rootPath !== previewedRootPath && /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        onClick: rePreview,
        isLoading: preview.isLoading,
        className: "self-start text-xs px-3 py-1",
        children: "Re-check against this path"
      }), stage === "previewed" && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(ImportPreviewList, {
          entries,
          selectedPaths,
          onToggle: toggle
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex items-center gap-3",
          children: [/* @__PURE__ */ jsxs(ActionButton, {
            intent: "primary",
            onClick: runImport,
            disabled: selectedPaths.size === 0 || rootPath !== previewedRootPath,
            isLoading: confirm.isLoading,
            className: "px-4 py-2",
            children: ["Import ", selectedPaths.size, " selected"]
          }), /* @__PURE__ */ jsx(ActionButton, {
            intent: "secondary",
            onClick: reset,
            className: "px-4 py-2",
            children: "Cancel"
          })]
        }), confirm.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
          error: confirm.error
        })]
      }), stage === "done" && summary && /* @__PURE__ */ jsx(ImportResultSummary, {
        summary,
        onReset: reset
      })]
    }), preview.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: preview.error
    })]
  });
};

const paginationVariants = cva("flex items-center min-w-0", {
  variants: {
    variant: {
      default: "gap-4",
      compact: "gap-2",
      minimal: "gap-1"
    },
    size: {
      sm: "text-xs",
      md: "text-sm",
      lg: "text-base"
    },
    justify: {
      between: "justify-between",
      start: "justify-start",
      center: "justify-center",
      end: "justify-end"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md",
    justify: "between"
  }
});
const PaginationControls = ({
  current,
  total,
  onPageChange,
  variant,
  size,
  justify,
  className,
  additionalControls,
  onFocus,
  readOnly,
  maxInlinePages = 10
}) => {
  const [inputValue, setInputValue] = useState((current + 1).toString());
  const isFirst = current === 0;
  const isLast = current === total - 1;
  useEffect(() => {
    setInputValue((current + 1).toString());
  }, [current]);
  const handlePrevious = () => {
    if (!isFirst) {
      onPageChange(current - 1);
    }
  };
  const handleNext = () => {
    if (!isLast) {
      onPageChange(current + 1);
    }
  };
  const handlePageJump = (value) => {
    const pageNumber = parseInt(value);
    if (pageNumber >= 1 && pageNumber <= total) {
      onPageChange(pageNumber - 1);
    } else {
      setInputValue((current + 1).toString());
    }
  };
  const useInlinePages = total <= maxInlinePages;
  const buttonSize = size === "lg" ? "lg" : size === "sm" ? "sm" : "md";
  return /* @__PURE__ */ jsxs("div", {
    className: paginationVariants({
      variant,
      size,
      justify,
      className
    }),
    children: [useInlinePages ? /* @__PURE__ */ jsx("div", {
      className: "flex items-center gap-1",
      children: Array.from({
        length: total
      }, (_, i) => /* @__PURE__ */ jsx(ActionButton, {
        intent: i === current ? "primary" : "white",
        size: size === "lg" ? "lg" : "sm",
        onClick: () => i === current && readOnly ? onFocus && onFocus() : onPageChange(i),
        "aria-label": `Page ${i + 1}`,
        "aria-current": i === current ? "page" : void 0,
        children: i + 1
      }, i))
    }) : /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: [/* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: buttonSize,
        onClick: handlePrevious,
        disabled: isFirst,
        "aria-label": "Previous page",
        children: /* @__PURE__ */ jsx(MdChevronLeft, {
          className: "w-5 h-5"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-1 text-gray-600",
        children: [readOnly ? /* @__PURE__ */ jsx("button", {
          onClick: onFocus,
          className: "w-12 px-1 py-1 text-sm border border-gray-300 rounded text-center hover:border-blue-400 hover:bg-gray-50 transition-colors",
          "aria-label": `Go to page ${inputValue}`,
          children: inputValue
        }) : /* @__PURE__ */ jsx("input", {
          type: "number",
          min: "1",
          max: total,
          value: inputValue,
          onChange: (e) => setInputValue(e.target.value),
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              handlePageJump(inputValue);
            }
          },
          onFocus,
          onBlur: () => handlePageJump(inputValue),
          className: "w-12 px-1 py-1 text-sm border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
          "aria-label": `Page ${current + 1} of ${total}`
        }), /* @__PURE__ */ jsx("span", {
          className: "text-gray-400",
          children: "/"
        }), /* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: total
        })]
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: buttonSize,
        onClick: handleNext,
        disabled: isLast,
        "aria-label": "Next page",
        children: /* @__PURE__ */ jsx(MdChevronRight, {
          className: "w-5 h-5"
        })
      })]
    }), additionalControls && /* @__PURE__ */ jsx("div", {
      className: "flex items-center gap-2",
      children: additionalControls
    })]
  });
};

const usePostsList = (options = {}) => {
  const api = useApi();
  const { circleId, limit = 20, skip = 0 } = options;
  const { data, error, mutate } = useSWR(["posts-list", circleId, limit, skip], async () => {
    const response = await api.post({
      path: "/posts/list",
      body: {
        circleId,
        limit,
        skip
      }
    });
    return response;
  }, {
    ...swrLoadOnce,
    refreshInterval: 0
  });
  return {
    posts: data && data.posts || [],
    total: data && data.total || 0,
    hasMore: data && data.hasMore || false,
    isLoading: !error && !data,
    error,
    mutate
  };
};

const downloadJson = (bundle, filename) => {
  const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
const useExportBundle = () => {
  const api = useApi();
  return useAsyncOperation(async (params) => {
    const bundle = await api.post({
      path: "/test-corpus/export-bundle",
      body: params
    });
    downloadJson(bundle, "post-bundle.json");
    return bundle;
  });
};

const existingSuffix = (post, rootPath) => {
  const path = post.metadata && post.metadata.path;
  const prefix = `${rootPath}/`;
  return path && path.startsWith(prefix) ? path.slice(prefix.length) : null;
};
const detectDefaultRootPath = (posts) => {
  const firstPath = posts.map((post) => post.metadata && post.metadata.path).find(Boolean);
  if (firstPath) {
    return firstPath.split("/")[0];
  }
  const firstTag = posts.map((post) => post.tags && post.tags[0]).find(Boolean);
  return firstTag || "";
};
const slugify = (text) => text.toLowerCase().replace(/['"]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 48);
const suggestSlug = (post) => {
  const fromTitle = slugify(post.title || "");
  if (fromTitle) {
    return fromTitle;
  }
  return `post-${post._id.slice(-6)}`;
};

const usePostPathSelection = (posts, rootPath, allowReassign) => {
  const [selected, setSelected] = useState(new Set());
  const [suffixes, setSuffixes] = useState({});
  const seedSuggestion = (post) => {
    const existing = existingSuffix(post, rootPath);
    if (existing && !allowReassign) {
      return;
    }
    setSuffixes((prev) => prev[post._id] ? prev : { ...prev, [post._id]: existing || suggestSlug(post) });
  };
  const toggle = useMemoizedFn((postId) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(postId)) {
        next.delete(postId);
      } else {
        next.add(postId);
      }
      return next;
    });
    const post = posts.find((p) => p._id === postId);
    if (post) {
      seedSuggestion(post);
    }
  });
  const selectAll = useMemoizedFn(() => {
    setSelected(new Set(posts.map((post) => post._id)));
    posts.forEach(seedSuggestion);
  });
  const clearSelection = useMemoizedFn(() => {
    setSelected(new Set());
  });
  const setSuffix = useMemoizedFn((postId, value) => {
    setSuffixes((prev) => ({ ...prev, [postId]: value }));
  });
  const reset = useMemoizedFn(() => {
    setSelected(new Set());
    setSuffixes({});
  });
  const isReady = (postId) => {
    const post = posts.find((p) => p._id === postId);
    if (!post) {
      return false;
    }
    if (allowReassign) {
      return Boolean((suffixes[postId] || "").trim());
    }
    return Boolean(existingSuffix(post, rootPath) || (suffixes[postId] || "").trim());
  };
  const readyCount = Array.from(selected).filter(isReady).length;
  return { selected, suffixes, toggle, selectAll, clearSelection, setSuffix, reset, readyCount };
};

const PostPathList = ({
  posts,
  rootPath,
  selected,
  onToggle,
  onSelectAll,
  onClearSelection,
  suffixes,
  onSuffixChange,
  allowReassign
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col gap-2",
  children: [/* @__PURE__ */ jsxs("div", {
    className: "flex items-center justify-between",
    children: [/* @__PURE__ */ jsxs("span", {
      className: "text-xs text-gray-500",
      children: [selected.size, " of ", posts.length, " selected"]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-3",
      children: [/* @__PURE__ */ jsx("button", {
        onClick: onSelectAll,
        className: "text-xs text-blue-600 hover:text-blue-800 font-medium",
        children: "Select all"
      }), /* @__PURE__ */ jsx("button", {
        onClick: onClearSelection,
        className: "text-xs text-gray-500 hover:text-gray-800 font-medium",
        children: "Clear"
      })]
    })]
  }), /* @__PURE__ */ jsxs("div", {
    className: "border border-gray-200 rounded-md divide-y divide-gray-100",
    children: [posts.map((post) => {
      const existing = existingSuffix(post, rootPath);
      const locked = existing && !allowReassign;
      return /* @__PURE__ */ jsxs("div", {
        className: "flex items-start gap-3 px-3 py-2.5",
        children: [/* @__PURE__ */ jsx("input", {
          type: "checkbox",
          checked: selected.has(post._id),
          onChange: () => onToggle(post._id),
          className: "mt-0.5 rounded border-gray-300 text-blue-600 focus:ring-blue-400 shrink-0"
        }), /* @__PURE__ */ jsx("div", {
          className: "min-w-0 flex-1",
          children: /* @__PURE__ */ jsx("div", {
            className: "text-sm text-gray-800 break-words",
            children: post.title
          })
        }), locked ? /* @__PURE__ */ jsxs("span", {
          className: "w-48 shrink-0 text-xs font-mono text-gray-400 text-right break-words",
          children: [existing, " (already here)"]
        }) : /* @__PURE__ */ jsx("input", {
          value: suffixes[post._id] || "",
          onChange: (e) => onSuffixChange(post._id, e.target.value),
          disabled: !selected.has(post._id),
          placeholder: existing || suggestSlug(post),
          className: "w-48 shrink-0 text-xs font-mono border border-gray-200 rounded px-2 py-1 disabled:bg-gray-50 disabled:text-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300"
        })]
      }, post._id);
    }), posts.length === 0 && /* @__PURE__ */ jsx("div", {
      className: "px-3 py-6 text-sm text-gray-400 text-center",
      children: "No posts in this circle yet."
    })]
  })]
});

const POSTS_PER_PAGE$2 = 20;
const JsonExportTab = ({
  circleId
}) => {
  const [rootPath, setRootPath] = useState("");
  const [rootPathTouched, setRootPathTouched] = useState(false);
  const [page, setPage] = useState(0);
  const {
    posts,
    total,
    isLoading,
    error
  } = usePostsList({
    circleId,
    limit: POSTS_PER_PAGE$2,
    skip: page * POSTS_PER_PAGE$2
  });
  const totalPages = Math.ceil(total / POSTS_PER_PAGE$2);
  const exportBundle = useExportBundle();
  const {
    selected,
    suffixes,
    toggle,
    selectAll,
    clearSelection,
    setSuffix,
    readyCount
  } = usePostPathSelection(posts, rootPath);
  useEffect(() => {
    if (!rootPathTouched && posts.length) {
      setRootPath(detectDefaultRootPath(posts));
    }
  }, [posts, rootPathTouched]);
  const handleRootPathChange = useMemoizedFn((value) => {
    setRootPathTouched(true);
    setRootPath(value);
  });
  const runExport = useMemoizedFn(async () => {
    const exportPosts = Array.from(selected).map((postId) => {
      const post = posts.find((p) => p._id === postId);
      const suffix = post && existingSuffix(post, rootPath) || suffixes[postId];
      return {
        postId,
        path: `${rootPath}/${suffix}`
      };
    });
    await exportBundle.execute({
      posts: exportPosts
    });
  });
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: "flex justify-center py-12",
      children: /* @__PURE__ */ jsx(Spinner, {})
    });
  }
  if (error) {
    return /* @__PURE__ */ jsx(ErrorPanel$1, {
      error
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsx(RootPathField, {
      value: rootPath,
      onChange: handleRootPathChange,
      label: "Path root"
    }), /* @__PURE__ */ jsx(PostPathList, {
      posts,
      rootPath,
      selected,
      onToggle: toggle,
      onSelectAll: selectAll,
      onClearSelection: clearSelection,
      suffixes,
      onSuffixChange: setSuffix
    }), totalPages > 1 && /* @__PURE__ */ jsx(PaginationControls, {
      current: page,
      total: totalPages,
      onPageChange: setPage,
      variant: "compact",
      justify: "center"
    }), /* @__PURE__ */ jsxs(ActionButton, {
      intent: "primary",
      onClick: runExport,
      disabled: selected.size === 0 || readyCount !== selected.size,
      isLoading: exportBundle.isLoading,
      className: "self-start px-4 py-2",
      children: ["Download bundle (", selected.size, ")"]
    }), exportBundle.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: exportBundle.error
    })]
  });
};

const useExportToDirectory = () => {
  const api = useApi();
  return useAsyncOperation(async (params) => {
    return api.post({
      path: "/test-corpus/export-to-directory",
      body: params
    });
  });
};

const POSTS_PER_PAGE$1 = 20;
const SaveToFilesTab = ({
  circleId
}) => {
  const [rootPath, setRootPath] = useState("");
  const [rootPathTouched, setRootPathTouched] = useState(false);
  const [page, setPage] = useState(0);
  const [saved, setSaved] = useState(null);
  const {
    posts,
    total,
    isLoading,
    error
  } = usePostsList({
    circleId,
    limit: POSTS_PER_PAGE$1,
    skip: page * POSTS_PER_PAGE$1
  });
  const totalPages = Math.ceil(total / POSTS_PER_PAGE$1);
  const exportToDirectory = useExportToDirectory();
  const {
    selected,
    suffixes,
    toggle,
    selectAll,
    clearSelection,
    setSuffix,
    reset,
    readyCount
  } = usePostPathSelection(posts, rootPath);
  useEffect(() => {
    if (!rootPathTouched && posts.length) {
      setRootPath(detectDefaultRootPath(posts));
    }
  }, [posts, rootPathTouched]);
  const handleRootPathChange = useMemoizedFn((value) => {
    setRootPathTouched(true);
    setRootPath(value);
  });
  const runSave = useMemoizedFn(async () => {
    const results = [];
    for (const postId of selected) {
      const post = posts.find((p) => p._id === postId);
      const suffix = post && existingSuffix(post, rootPath) || suffixes[postId];
      const {
        path
      } = await exportToDirectory.execute({
        postId,
        relativePath: `${rootPath}/${suffix}`
      });
      results.push({
        postId,
        title: post && post.title || postId,
        path
      });
    }
    setSaved(results);
  });
  const startOver = useMemoizedFn(() => {
    setSaved(null);
    reset();
  });
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: "flex justify-center py-12",
      children: /* @__PURE__ */ jsx(Spinner, {})
    });
  }
  if (error) {
    return /* @__PURE__ */ jsx(ErrorPanel$1, {
      error
    });
  }
  if (saved) {
    return /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2 max-w-2xl",
      children: [saved.map((entry) => /* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2 text-sm",
        children: [/* @__PURE__ */ jsx("span", {
          className: "text-gray-700",
          children: entry.title
        }), /* @__PURE__ */ jsx("span", {
          className: "font-mono text-xs text-gray-400 ml-auto",
          children: entry.path
        })]
      }, entry.postId)), /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        onClick: startOver,
        className: "self-start text-xs px-3 py-1",
        children: "Save more"
      })]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsx(RootPathField, {
      value: rootPath,
      onChange: handleRootPathChange,
      label: "Save under path"
    }), /* @__PURE__ */ jsx(PostPathList, {
      posts,
      rootPath,
      selected,
      onToggle: toggle,
      onSelectAll: selectAll,
      onClearSelection: clearSelection,
      suffixes,
      onSuffixChange: setSuffix
    }), totalPages > 1 && /* @__PURE__ */ jsx(PaginationControls, {
      current: page,
      total: totalPages,
      onPageChange: setPage,
      variant: "compact",
      justify: "center"
    }), /* @__PURE__ */ jsxs(ActionButton, {
      intent: "primary",
      onClick: runSave,
      disabled: selected.size === 0 || readyCount !== selected.size,
      isLoading: exportToDirectory.isLoading,
      className: "self-start px-4 py-2",
      children: ["Save ", selected.size, " post", selected.size === 1 ? "" : "s", " to disk"]
    }), exportToDirectory.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: exportToDirectory.error
    })]
  });
};

const TABS = [{
  key: "import",
  label: "Import Corpus"
}, {
  key: "jsonImport",
  label: "JSON Import"
}, {
  key: "jsonExport",
  label: "JSON Export"
}, {
  key: "save",
  label: "Save to Files"
}];
const TestCorpusPage = ({
  circleId
}) => {
  const [tab, setTab] = useState("import");
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns p-2 h-full flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx(CircleBreadcrumb, {
        circleId,
        current: /* @__PURE__ */ jsxs(BreadcrumbRow, {
          children: [/* @__PURE__ */ jsx(Link$2, {
            to: `/trans/admin/circle-dev-dashboard/${circleId}`,
            className: "underline",
            children: "Developer Dashboard"
          }), /* @__PURE__ */ jsx(Next, {}), "Test Corpus"]
        })
      }), /* @__PURE__ */ jsx(Tabs, {
        tabs: TABS,
        value: tab,
        onChange: setTab
      }), tab === "import" && /* @__PURE__ */ jsx(ImportCorpusTab, {
        circleId
      }), tab === "jsonImport" && /* @__PURE__ */ jsx(JsonImportTab, {
        circleId
      }), tab === "jsonExport" && /* @__PURE__ */ jsx(JsonExportTab, {
        circleId
      }), tab === "save" && /* @__PURE__ */ jsx(SaveToFilesTab, {
        circleId
      })]
    }), /* @__PURE__ */ jsx(ToastContainer, {})]
  });
};

const TestCorpusRoute = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const circleId = parts[3];
  const isDeveloper = useIsDeveloper();
  if (!isDeveloper) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-4 text-sm text-gray-500",
      children: "Only developers can view this page."
    });
  }
  if (!circleId) {
    return null;
  }
  return /* @__PURE__ */ jsx(TestCorpusPage, {
    circleId
  });
};

const AgentTestPage = ({
  circleId
}) => {
  const [question, setQuestion] = useState("");
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsxs("div", {
      className: "ns p-2 h-full flex flex-col gap-4 max-w-4xl",
      children: [/* @__PURE__ */ jsx(CircleBreadcrumb, {
        circleId,
        current: /* @__PURE__ */ jsxs(BreadcrumbRow, {
          children: [/* @__PURE__ */ jsx(Link$2, {
            to: `/trans/admin/circle-dev-dashboard/${circleId}`,
            className: "underline",
            children: "Developer Dashboard"
          }), /* @__PURE__ */ jsx(Next, {}), "Test Agent"]
        })
      }), /* @__PURE__ */ jsx("textarea", {
        value: question,
        onChange: (e) => setQuestion(e.target.value),
        dir: "auto",
        rows: 3,
        placeholder: "Test question\u2026",
        className: "w-full border border-gray-300 rounded px-3 py-2 text-sm"
      }), /* @__PURE__ */ jsx(AgentInvestigationPanel, {
        circleId,
        question
      })]
    })]
  });
};

const AgentTestRoute = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const circleId = parts[3];
  const isDeveloper = useIsDeveloper();
  if (!isDeveloper) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-4 text-sm text-gray-500",
      children: "Only developers can view this page."
    });
  }
  if (!circleId) {
    return null;
  }
  return /* @__PURE__ */ jsx(AgentTestPage, {
    circleId
  });
};

const NsPageShellInner = ({
  children,
  fullViewport,
  className
}) => /* @__PURE__ */ jsxs(ToastProvider, {
  children: [/* @__PURE__ */ jsx(ToastContainer, {}), fullViewport && /* @__PURE__ */ jsx(FullViewportCssOverrides, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
    className: className !== void 0 ? className : "ns h-full",
    children
  })]
});
const NsPageShell = (props) => /* @__PURE__ */ jsx(SWRProfileContextProvider, {
  children: /* @__PURE__ */ jsx(ProfileCDNImageContextProvider, {
    children: /* @__PURE__ */ jsx(NsPageShellInner, {
      ...props
    })
  })
});

const bubble = cva("max-w-[80%] px-[13px] py-[9px] rounded-[14px] w-fit", {
  variants: {
    role: {
      user: "self-end bg-[var(--cair-accent)] text-[color:var(--cair-accent-foreground)] rounded-br-[4px]",
      assistant: "self-start bg-[var(--cair-surface)] border border-[var(--cair-border)] text-[color:var(--cair-text)] rounded-bl-[4px]"
    }
  }
});
const MessageBubble = ({
  role,
  children
}) => /* @__PURE__ */ jsx("div", {
  className: bubble({
    role
  }),
  dir: "auto",
  children
});

const renderAnswer = (turn, onRefClick) => {
  if (turn.phase === "pending")
    return null;
  if (turn.phase === "failed") {
    return /* @__PURE__ */ jsx(MessageBubble, {
      role: "assistant",
      children: /* @__PURE__ */ jsx("span", {
        className: "text-[color:var(--cair-text-tertiary)] text-[length:var(--cair-text-small)]",
        children: turn.message
      })
    });
  }
  return /* @__PURE__ */ jsx(MessageBubble, {
    role: "assistant",
    children: /* @__PURE__ */ jsx(AnswerBody, {
      answer: turn.phase === "streaming" ? turn.partialAnswerHtml : turn.answerHtml,
      refs: turn.sources,
      isSubmitting: turn.phase === "streaming",
      onRefClick
    })
  });
};
const ConversationThreadView = ({
  turns,
  pendingTurn,
  onRefClick
}) => {
  const allTurns = pendingTurn ? [...turns, pendingTurn] : turns;
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col gap-[20px] w-full text-[color:var(--cair-text)]",
    style: {
      fontFamily: "var(--cair-reader-font-family)",
      fontSize: "var(--cair-reader-font-size)",
      lineHeight: "var(--cair-reader-line-spacing)"
    },
    children: allTurns.map((turn, index) => /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-[8px] w-full",
      children: [/* @__PURE__ */ jsx(MessageBubble, {
        role: "user",
        children: turn.question
      }), renderAnswer(turn, onRefClick)]
    }, "turnId" in turn ? turn.turnId : index))
  });
};

const deriveThreadTitle = (question) => question.length > 40 ? question.slice(0, 40) + "\u2026" : question;

const isHttpUrl = (value) => !!value && (value.startsWith("http://") || value.startsWith("https://"));
const toAnswerRef = (citation) => ({
  id: citation.citationId,
  excerpt: citation.title || "",
  location: citation.publicationDate || "",
  pageId: citation.postId,
  chunkId: citation.chunkId != null ? String(citation.chunkId) : void 0,
  href: isHttpUrl(citation.rights) ? citation.rights : void 0
});
const useConversationThreadConnection = ({ circleId }) => {
  const api = useApi();
  const [threadRootPostId, setThreadRootPostId] = useState(null);
  const [turns, setTurns] = useState([]);
  const [pendingTurn, setPendingTurn] = useState(null);
  const [sseUrl, setSseUrl] = useState(null);
  const pendingTurnRef = useRef(null);
  useEffect(() => {
    pendingTurnRef.current = pendingTurn;
  }, [pendingTurn]);
  const creatingThreadRef = useRef(null);
  const settleTurn = useMemoizedFn((turn) => {
    setTurns((prev) => [...prev, turn]);
    setPendingTurn(null);
    setSseUrl(null);
  });
  useSSEConnection({
    url: sseUrl || "",
    enabled: !!sseUrl,
    dependencies: [sseUrl]
  }, [
    {
      event: "sources",
      handler: (data) => {
        const current = pendingTurnRef.current;
        if (current && current.phase === "streaming") {
          setPendingTurn({ ...current, sources: data.sources.map(toAnswerRef) });
        }
      }
    },
    {
      event: "answer-chunk",
      handler: (data) => {
        const current = pendingTurnRef.current;
        if (current && current.phase === "streaming") {
          setPendingTurn({ ...current, partialAnswerHtml: current.partialAnswerHtml + data.delta });
        }
      }
    },
    {
      event: "complete",
      handler: (data) => {
        const current = pendingTurnRef.current;
        if (!current)
          return;
        settleTurn({
          phase: "complete",
          question: current.question,
          answerHtml: data.answerHtml,
          sources: data.sources.map(toAnswerRef),
          turnId: data.turnId
        });
      }
    },
    {
      event: "failed",
      handler: (data) => {
        const current = pendingTurnRef.current;
        if (!current)
          return;
        settleTurn({ phase: "failed", question: current.question, message: data.message });
      }
    }
  ]);
  const ensureThread = useMemoizedFn((question) => {
    if (threadRootPostId)
      return Promise.resolve(threadRootPostId);
    if (creatingThreadRef.current)
      return creatingThreadRef.current;
    const promise = api.get({ path: "conversations/threads/new", params: { circleId, title: deriveThreadTitle(question) } }).then((res) => {
      setThreadRootPostId(res.threadRootPostId);
      return res.threadRootPostId;
    });
    creatingThreadRef.current = promise;
    return promise;
  });
  const sendQuestion = useMemoizedFn(async (question) => {
    setPendingTurn({ phase: "streaming", question, partialAnswerHtml: "" });
    let rootId;
    try {
      rootId = await ensureThread(question);
    } catch (error) {
      setPendingTurn({ phase: "failed", question, message: "Could not start conversation" });
      return;
    }
    const jwt = await api.loadJwt();
    const { executionId } = await api.post({
      path: "tasks/create",
      body: { input: { threadRootPostId: rootId, circleId, question } }
    });
    const url = api.buildUrl("playground/agent-chat/turns/sse", { executionId, token: jwt });
    setSseUrl(url);
  });
  const openThread = useMemoizedFn(async (rootId) => {
    setSseUrl(null);
    setPendingTurn(null);
    const { turns: loadedTurns } = await api.get({ path: `conversations/threads/${rootId}` });
    setThreadRootPostId(rootId);
    setTurns(loadedTurns);
  });
  const startNewThread = useMemoizedFn(() => {
    setSseUrl(null);
    setPendingTurn(null);
    setThreadRootPostId(null);
    setTurns([]);
    creatingThreadRef.current = null;
  });
  return { threadRootPostId, turns, pendingTurn, sendQuestion, openThread, startNewThread };
};

const ConversationThreadContext = createContext(null);
const useConversationThread = () => {
  const ctx = useContext(ConversationThreadContext);
  if (!ctx) {
    throw new Error("useConversationThread must be used inside ConversationThreadProvider");
  }
  return ctx;
};

const ConversationThreadProvider = ({
  circleId,
  children
}) => {
  const value = useConversationThreadConnection({
    circleId
  });
  return /* @__PURE__ */ jsx(ConversationThreadContext.Provider, {
    value,
    children
  });
};

const AgentChatLayout = ({
  header,
  left,
  main,
  right,
  maximized
}) => /* @__PURE__ */ jsxs("div", {
  className: "flex flex-col h-full w-full bg-[var(--cair-surface-background)]",
  children: [/* @__PURE__ */ jsx("div", {
    className: "flex-none",
    children: header
  }), /* @__PURE__ */ jsxs("div", {
    className: "flex flex-1 min-h-0",
    children: [left && maximized !== "right" && /* @__PURE__ */ jsx("div", {
      className: (maximized === "left" ? "flex-1" : "flex-none w-[240px] border-r border-[var(--cair-border)]") + " min-h-0 overflow-y-auto",
      children: left
    }), !maximized && /* @__PURE__ */ jsx("div", {
      className: "flex-1 min-w-0",
      children: main
    }), right && maximized !== "left" && /* @__PURE__ */ jsx("div", {
      className: (maximized === "right" ? "flex-1" : "flex-none w-[320px] border-l border-[var(--cair-border)]") + " min-h-0 overflow-y-auto",
      children: right
    })]
  })]
});

const AgentChatLayoutContext = createContext(null);
const useAgentChatLayoutContext = () => {
  const ctx = useContext(AgentChatLayoutContext);
  if (!ctx) {
    throw new Error("useAgentChatLayoutContext must be used inside AgentChatLayoutProvider");
  }
  return ctx;
};

const useAgentChatHashState = ({ threadRootPostId, openThread, startNewThread }) => {
  const history = useHistory();
  const params = useQueryStringParams();
  useEffect(() => {
    if (params.thread && params.thread !== threadRootPostId) {
      openThread(params.thread);
    }
  }, [params.thread]);
  useEffect(() => {
    if (threadRootPostId && threadRootPostId !== params.thread) {
      history.push({ hash: "?" + object2QueryString({ thread: threadRootPostId }) });
    }
  }, [threadRootPostId]);
  const navigateToThread = (id) => {
    history.push({ hash: "?" + object2QueryString({ thread: id }) });
  };
  const navigateToNewThread = () => {
    startNewThread();
    history.push({ hash: "" });
  };
  return { navigateToThread, navigateToNewThread };
};

const useThreadHistory = (circleId) => {
  const api = useApi();
  const { data, loading, refresh } = useRequest(() => api.get({ path: "conversations/threads/list", params: { circleId } }), { refreshDeps: [circleId] });
  const threads = data && data.threads ? data.threads : [];
  return { threads, loading, refresh };
};

const ThreadHistoryPanel = ({
  circleId,
  activeThreadId,
  onSelect,
  onNewThread,
  onClose
}) => {
  const api = useApi();
  const {
    threads,
    refresh
  } = useThreadHistory(circleId);
  const {
    turns
  } = useConversationThread();
  const [confirmDropId, setConfirmDropId] = useState(null);
  const [dropProgress, setDropProgress] = useState(null);
  const [dropSseUrl, setDropSseUrl] = useState(null);
  const [dropError, setDropError] = useState(null);
  useUpdateEffect(() => {
    refresh();
  }, [activeThreadId, turns.length]);
  useSSEConnection({
    url: dropSseUrl || "",
    enabled: !!dropSseUrl,
    dependencies: [dropSseUrl]
  }, [{
    event: "progress",
    handler: (data) => setDropProgress(data)
  }, {
    event: "complete",
    handler: () => {
      const droppedId = confirmDropId;
      setDropSseUrl(null);
      setDropProgress(null);
      setConfirmDropId(null);
      refresh();
      if (droppedId && droppedId === activeThreadId) {
        onNewThread();
      }
    }
  }, {
    event: "failed",
    handler: () => {
      setDropSseUrl(null);
      setDropProgress(null);
      setDropError("Could not drop this conversation. Please try again.");
    }
  }]);
  const handleDrop = async () => {
    if (!confirmDropId)
      return;
    setDropError(null);
    const {
      executionId
    } = await api.post({
      path: "tasks/create",
      body: {
        input: {
          threadRootPostId: confirmDropId
        }
      }
    });
    const jwt = await api.loadJwt();
    setDropSseUrl(api.buildUrl("conversations/threads/:id/drop/sse", {
      executionId,
      token: jwt
    }));
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "relative flex flex-col h-full max-h-[70vh] w-full bg-[var(--cair-surface)]",
    children: [onClose && /* @__PURE__ */ jsx("button", {
      type: "button",
      onClick: onClose,
      "aria-label": "Close",
      className: "absolute top-[8px] right-[8px] z-10 w-[32px] h-[32px] flex items-center justify-center rounded-[6px] text-[color:var(--cair-text-secondary)] hover:bg-[var(--cair-surface-elevated-hover)]",
      children: /* @__PURE__ */ jsx(MdClose, {
        size: 16
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-1 min-h-0 overflow-y-auto px-[8px] py-[12px]",
      children: /* @__PURE__ */ jsx(CollapsibleSection, {
        title: "History",
        variant: "minimal",
        defaultCollapsed: false,
        renderHeader: (expanded, onToggle) => /* @__PURE__ */ jsxs("button", {
          type: "button",
          onClick: onToggle,
          className: "flex items-center gap-[4px] w-full text-left text-[length:var(--cair-text-small)] font-medium text-[color:var(--cair-text-secondary)]",
          children: [expanded ? /* @__PURE__ */ jsx(MdExpandMore, {
            size: 16
          }) : /* @__PURE__ */ jsx(MdChevronRight, {
            size: 16
          }), "History"]
        }),
        children: /* @__PURE__ */ jsx("div", {
          className: "flex flex-col gap-[4px]",
          children: threads.map((t) => /* @__PURE__ */ jsxs("div", {
            className: "group flex items-center gap-[4px] px-[4px] py-[6px] rounded-[6px] " + (t.threadRootPostId === activeThreadId ? "bg-[var(--cair-selection)]" : "hover:bg-[var(--cair-surface-elevated-hover)]"),
            children: [/* @__PURE__ */ jsx("button", {
              type: "button",
              className: "flex-1 text-left truncate text-[length:var(--cair-text-small)] " + (t.threadRootPostId === activeThreadId ? "text-[color:var(--cair-text)] font-medium" : "text-[color:var(--cair-text-secondary)]"),
              onClick: () => onSelect(t.threadRootPostId),
              children: t.title
            }), /* @__PURE__ */ jsx(DropdownMenu, {
              icon: /* @__PURE__ */ jsx(MdMoreHoriz, {
                size: 16
              }),
              "aria-label": "Thread actions",
              size: "sm",
              variant: "ghost",
              className: "opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-opacity !px-[4px] !py-[4px]",
              groups: [{
                items: [{
                  label: "Drop",
                  variant: "danger",
                  onClick: () => setConfirmDropId(t.threadRootPostId)
                }]
              }]
            })]
          }, t.threadRootPostId))
        })
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "flex-none px-[8px] py-[12px] border-t border-[var(--cair-border)]",
      children: /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairSubtle",
        size: "xs",
        rounded: "sm",
        onClick: onNewThread,
        children: "+ New conversation"
      })
    }), /* @__PURE__ */ jsx(ConfirmationOverlay, {
      isOpen: !!confirmDropId,
      title: "Drop this conversation?",
      message: dropProgress ? `Unpublishing ${dropProgress.current} of ${dropProgress.total}\u2026` : "This cannot be undone.",
      confirmText: "Drop",
      confirmIntent: "danger",
      isLoading: !!dropSseUrl,
      error: dropError,
      onConfirm: handleDrop,
      onCancel: () => {
        setConfirmDropId(null);
        setDropProgress(null);
        setDropError(null);
      }
    })]
  });
};

const AGENT_CHAT_PANELS = [
  {
    id: "history",
    side: "left",
    label: "History",
    component: ({
      ctx
    }) => /* @__PURE__ */ jsx(ThreadHistoryPanel, {
      circleId: ctx.circleId,
      activeThreadId: ctx.threadRootPostId,
      onSelect: ctx.navigateToThread,
      onNewThread: ctx.navigateToNewThread,
      onClose: ctx.mode === "mobile" ? () => ctx.togglePanel("left", "history") : void 0
    })
  },
  {
    id: "config",
    side: "right",
    label: "Configuration",
    component: ({
      ctx
    }) => /* @__PURE__ */ jsx(ReaderPreferencesPanel, {
      onClose: () => ctx.togglePanel("right", "config")
    })
  }
];

const AgentChatPage = ({
  circleId
}) => /* @__PURE__ */ jsx(CairTokensProvider, {
  children: /* @__PURE__ */ jsx(ConversationThreadProvider, {
    circleId,
    children: /* @__PURE__ */ jsx(AgentChatPageBody, {
      circleId
    })
  })
});
const AgentChatPageBody = ({
  circleId
}) => {
  const [query, setQuery] = useState("");
  const {
    threadRootPostId,
    turns,
    pendingTurn,
    sendQuestion,
    openThread,
    startNewThread
  } = useConversationThread();
  const {
    mode,
    isCompact,
    openPanelIds,
    togglePanel,
    maximized
  } = useAgentChatLayoutContext();
  const {
    navigateToThread,
    navigateToNewThread
  } = useAgentChatHashState({
    threadRootPostId,
    openThread,
    startNewThread
  });
  const handleSubmit = () => {
    if (!query.trim())
      return;
    sendQuestion(query.trim());
    setQuery("");
  };
  const resolvePanel = (side) => {
    const panelId = openPanelIds[side];
    const def = AGENT_CHAT_PANELS.find((p) => p.id === panelId && p.side === side);
    if (!def)
      return null;
    const Panel = def.component;
    return /* @__PURE__ */ jsx(Panel, {
      ctx: {
        circleId,
        threadRootPostId,
        navigateToThread,
        navigateToNewThread,
        togglePanel,
        mode,
        isCompact
      }
    });
  };
  const useInFlow = mode === "desktop" && !isCompact;
  const renderSidePanelHost = (side) => {
    if (useInFlow)
      return null;
    const panelId = openPanelIds[side];
    const def = AGENT_CHAT_PANELS.find((p) => p.id === panelId && p.side === side);
    if (!def)
      return null;
    const content = resolvePanel(side);
    const onClose = () => togglePanel(side, def.id);
    if (mode === "mobile") {
      return /* @__PURE__ */ jsx(Dialog$3, {
        placement: "bottom",
        isOpen: true,
        onClose,
        children: content
      });
    }
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx("div", {
        className: "fixed inset-0 z-[29] bg-[var(--cair-neutral-overlay)]",
        onClick: onClose
      }), /* @__PURE__ */ jsx("div", {
        className: "fixed top-0 bottom-0 w-[320px] z-[30] bg-[var(--cair-surface)] overflow-y-auto " + (side === "left" ? "left-0 border-r border-[var(--cair-border)]" : "right-0 border-l border-[var(--cair-border)]"),
        children: content
      })]
    });
  };
  const leftPanelDef = AGENT_CHAT_PANELS.find((p) => p.side === "left");
  const isLeftOpen = !!openPanelIds.left;
  const rightPanelDef = AGENT_CHAT_PANELS.find((p) => p.side === "right");
  const isRightOpen = !!openPanelIds.right;
  const header = /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-[8px] px-[16px] py-[8px] bg-[var(--cair-surface)] border-b border-[var(--cair-border)]",
    children: [leftPanelDef && /* @__PURE__ */ jsx(ActionButton, {
      intent: "cairSubtle",
      size: "xs",
      rounded: "sm",
      "aria-label": isLeftOpen ? "Collapse panel" : "Expand panel",
      onClick: () => togglePanel("left", leftPanelDef.id),
      children: isLeftOpen ? /* @__PURE__ */ jsx(MdChevronLeft, {
        size: 18
      }) : /* @__PURE__ */ jsx(MdChevronRight, {
        size: 18
      })
    }), rightPanelDef && /* @__PURE__ */ jsx(ActionButton, {
      intent: "cairSubtle",
      size: "xs",
      rounded: "sm",
      className: "ml-auto",
      "aria-label": isRightOpen ? "Close configuration" : "Open configuration",
      onClick: () => togglePanel("right", rightPanelDef.id),
      children: /* @__PURE__ */ jsx(MdSettings, {
        size: 18
      })
    })]
  });
  const main = /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col h-full w-full max-w-[720px] mx-auto",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex-1 overflow-y-auto px-[16px] py-[20px]",
      children: /* @__PURE__ */ jsx(ConversationThreadView, {
        turns,
        pendingTurn
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-[8px] items-end px-[16px] py-[12px] border-t border-[var(--cair-border)]",
      children: [/* @__PURE__ */ jsx(VoiceTextInput, {
        value: query,
        onChange: setQuery,
        placeholder: "Ask a question\u2026"
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "cairPrimary",
        size: "sm",
        rounded: "sm",
        onClick: handleSubmit,
        children: "Send"
      })]
    })]
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(AgentChatLayout, {
      header,
      left: useInFlow ? resolvePanel("left") : null,
      main,
      right: useInFlow ? resolvePanel("right") : null,
      maximized
    }), renderSidePanelHost("left"), renderSidePanelHost("right")]
  });
};

const DEFAULT_AGENT_CHAT_LAYOUT_PREFS = {
  openPanelIds: { left: null, right: null },
  pinnedRightPanelId: null
};
const useAgentChatLayoutPrefs = () => useLocalStorageState$1("cair:agent-chat-layout", {
  defaultValue: DEFAULT_AGENT_CHAT_LAYOUT_PREFS
});

configResponsive({
  md: 768,
  lg: 992
});
const AgentChatLayoutProvider = ({
  children,
  forcedMode
}) => {
  const responsive = useResponsive();
  const mode = forcedMode || (responsive.md ? "desktop" : "mobile");
  const isCompact = !responsive.lg;
  const [prefs, setPrefs] = useAgentChatLayoutPrefs();
  const [maximized, setMaximized] = useState(null);
  const togglePanel = (side, panelId) => {
    setPrefs((prev) => ({
      ...prev,
      openPanelIds: {
        ...prev.openPanelIds,
        [side]: prev.openPanelIds[side] === panelId ? null : panelId
      }
    }));
  };
  const value = {
    mode,
    isCompact,
    openPanelIds: prefs.openPanelIds,
    togglePanel,
    maximized,
    setMaximized
  };
  return /* @__PURE__ */ jsx(AgentChatLayoutContext.Provider, {
    value,
    children
  });
};

const AgentChatDesktopRoute = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const circleId = parts[parts.length - 1];
  return /* @__PURE__ */ jsx(NsPageShell, {
    fullViewport: true,
    children: /* @__PURE__ */ jsx(AgentChatLayoutProvider, {
      children: circleId ? /* @__PURE__ */ jsx(AgentChatPage, {
        circleId
      }) : null
    })
  });
};

const AgentChatMobileRoute = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const circleId = parts[parts.length - 1];
  return /* @__PURE__ */ jsx(NsPageShell, {
    fullViewport: true,
    children: /* @__PURE__ */ jsx(AgentChatLayoutProvider, {
      forcedMode: "mobile",
      children: circleId ? /* @__PURE__ */ jsx(AgentChatPage, {
        circleId
      }) : null
    })
  });
};

const AdminRootInner = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const prefix = "/trans/admin";
  if (pathname.startsWith(prefix + "/vector-search-index")) {
    return /* @__PURE__ */ jsx(VectorSearchPage, {});
  }
  if (pathname.startsWith(prefix + "/configure-filters")) {
    return /* @__PURE__ */ jsx(MetadataFilterFieldsPage, {});
  }
  if (pathname.startsWith(prefix + "/execute-migrations")) {
    return /* @__PURE__ */ jsx(MigrationRunnerPage, {});
  }
  if (pathname.startsWith(prefix + "/vector-search-categories")) {
    return /* @__PURE__ */ jsx(VectorSearchCategories, {});
  }
  if (pathname.startsWith(prefix + "/vector-search-simple")) {
    return /* @__PURE__ */ jsx(VectorSearchSimple, {});
  }
  if (pathname.startsWith(prefix + "/elastic-indices")) {
    return /* @__PURE__ */ jsx(ElasticIndicesTest, {});
  }
  if (pathname.startsWith(prefix + "/workload-config")) {
    return /* @__PURE__ */ jsx(OcrWorkloadConfigPage, {});
  }
  if (pathname.startsWith(prefix + "/workload-monitor")) {
    return /* @__PURE__ */ jsx(OcrMonitorStatePage, {});
  }
  if (pathname.startsWith(prefix + "/translate-post")) {
    return /* @__PURE__ */ jsx(TranslationSimplePage, {});
  }
  if (pathname.startsWith(prefix + "/circle-search")) {
    return /* @__PURE__ */ jsx(CircleSearchIndexPage, {});
  }
  if (pathname.startsWith(prefix + "/test-corpus")) {
    return /* @__PURE__ */ jsx(TestCorpusRoute, {});
  }
  if (pathname.startsWith(prefix + "/agent-test")) {
    return /* @__PURE__ */ jsx(AgentTestRoute, {});
  }
  if (pathname.startsWith(prefix + "/agent-chat-desktop")) {
    return /* @__PURE__ */ jsx(AgentChatDesktopRoute, {});
  }
  if (pathname.startsWith(prefix + "/agent-chat-mobile")) {
    return /* @__PURE__ */ jsx(AgentChatMobileRoute, {});
  }
  if (pathname.startsWith(prefix + "/circle-dev-dashboard")) {
    return /* @__PURE__ */ jsx(CircleDeveloperDashboardPage, {});
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 p-2 underline",
    children: [/* @__PURE__ */ jsx("a", {
      href: prefix + "/vector-search-index",
      className: "underline",
      children: "Vector search index"
    }), /* @__PURE__ */ jsx("a", {
      href: prefix + "/configure-filters",
      className: "underline",
      children: "Configure CircleFilters"
    }), /* @__PURE__ */ jsx("a", {
      href: prefix + "/execute-migrations",
      className: "underline",
      children: "Run Migrations"
    }), /* @__PURE__ */ jsx("a", {
      href: prefix + "/elastic-indices",
      className: "underline",
      children: "Elasticsearch indices"
    }), /* @__PURE__ */ jsx("a", {
      href: prefix + "/workload-config",
      className: "underline",
      children: "OCR workload configuration"
    }), /* @__PURE__ */ jsx("a", {
      href: prefix + "/workload-monitor",
      className: "underline",
      children: "OCR monitor state"
    })]
  });
};
const AdminRoot = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(AdminRootInner, {})]
  });
};

const useChatCircle = (circleId, options) => {
  const api = useApi();
  const result = useSWR(circleId ? [`/public/groups/chat/create`, circleId] : null, async (path) => {
    try {
      return await api.post({
        path,
        body: {
          circleId
        }
      });
    } catch (e) {
      return {
        group: null
      };
    }
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const CircleChatInner = ({
  id,
  test
}) => {
  const {
    data
  } = useChatCircle(id);
  if (!data) {
    return null;
  }
  if (!data.group) {
    return /* @__PURE__ */ jsx("div", {
      className: "text-red-500",
      children: "No Chat found!"
    });
  }
  const circleId = data.group._id;
  return /* @__PURE__ */ jsx(ChatContextProvider, {
    children: /* @__PURE__ */ jsx(LoadChatPanel$1, {
      circleId,
      test,
      chatId: id
    })
  });
};
const CircleChatPage = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const id = path[2];
  const queryParams = new URLSearchParams(location.search);
  const test = queryParams.get("test");
  return /* @__PURE__ */ jsx(SearchContextProvider, {
    children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
      children: /* @__PURE__ */ jsxs(ActivityContextProvider, {
        children: [/* @__PURE__ */ jsx(ChatCssOverrides$1, {}), /* @__PURE__ */ jsx(CircleChatInner, {
          id,
          test
        })]
      })
    })
  });
};

const ChatCssOverrides = createGlobalStyle`
  #body, body {
    background-color: white;
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    position: absolute;
  }

  html {
    overflow: hidden;    
  }
  
  #root > * {
    min-width: 100%;
    width: 100%;
    max-width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    position: absolute;
  }
`;

const NORMAL_IMAGE_SIZE = 85;
const BIG_IMAGE_SIZE = 100;
const SMALL_IMAGE_SIZE = 50;
const getImageSize = (size) => {
  if (typeof size === "number") {
    return size;
  }
  switch (size) {
    case "small":
      return SMALL_IMAGE_SIZE;
    case "big":
      return BIG_IMAGE_SIZE;
    case "normal":
    default:
      return NORMAL_IMAGE_SIZE;
  }
};
const getImageUuid = (image) => {
  if (typeof image === "string") {
    return image;
  }
  return image && image.uuid || "";
};
const CircleImage = ({
  image,
  size = "normal",
  className = "",
  onClick,
  alt = "Circle image"
}) => {
  const imageSize = getImageSize(size);
  const uuid = getImageUuid(image);
  if (!uuid) {
    return /* @__PURE__ */ jsx("div", {
      className: `rounded-full bg-gray-200 flex items-center justify-center ${className}`,
      style: {
        width: imageSize,
        height: imageSize,
        minWidth: imageSize,
        minHeight: imageSize
      },
      children: /* @__PURE__ */ jsx("span", {
        className: "text-gray-400 text-xs",
        children: "No image"
      })
    });
  }
  return /* @__PURE__ */ jsx(ScaledImageTwProxy, {
    className: `rounded-full ${className}`,
    uuid,
    w: imageSize,
    h: imageSize,
    crop: true,
    onClick
  });
};

const noop$1 = () => null;
const AiChatContext = React__default.createContext({
  membership: null,
  circle: null,
  setMembership: noop$1,
  setCircle: noop$1,
  setAuthenticationRequired: noop$1
});
const useAiChatContext = () => {
  return useContext(AiChatContext);
};
const AiChatContextProvider = ({
  children
}) => {
  const [circle, setCircle] = useState();
  const [membership, setMembership] = useState();
  const [authenticationRequired, setAuthenticationRequired] = useState(false);
  const context = useMemo(() => {
    return {
      circle,
      membership,
      setMembership,
      setCircle,
      authenticationRequired,
      setAuthenticationRequired
    };
  }, [circle, membership]);
  return /* @__PURE__ */ jsx(AiChatContext.Provider, {
    value: context,
    children
  });
};

const LoadChatPanel = ({
  circleId,
  test,
  chatId,
  actualCircleId
}) => {
  return /* @__PURE__ */ jsx(CirclePageProviders, {
    circleId,
    children: /* @__PURE__ */ jsx(EditCirclePostsContextProvider, {
      children: /* @__PURE__ */ jsx(ChatPanelInner1, {
        test,
        chatId,
        circleId,
        actualCircleId
      })
    })
  });
};
const iframe = (circle_id) => `<iframe style="height: 100%; width: 100%; font-family: 'droid_arabic_kufi', 'roboto', 'serif' !important;" scrolling="yes" title="fx." src="${isLocalhost() ? "http" : "https"}://${window.location.host}/static/apps/sessions/#/aichat/${circle_id}?embedded=1" frameborder="no" allowtransparency="true" allowfullscreen="true"></iframe>`;
function Iframe(props) {
  return /* @__PURE__ */ jsx("div", {
    style: {
      height: "100%"
    },
    dangerouslySetInnerHTML: {
      __html: props.iframe ? props.iframe : ""
    }
  });
}
const crumbClass = "text-base font-medium flex items-center whitespace-nowrap";
const Chevron = () => /* @__PURE__ */ jsx(MdKeyboardArrowRight, {
  size: 20,
  color: "#4D4D4E",
  className: "shrink-0"
});
const GoToBookCairLink = ({
  className
}) => /* @__PURE__ */ jsxs(Link$2, {
  to: bookCairDashboardUrl(),
  target: "_blank",
  rel: "noopener noreferrer",
  className: `flex flex-row items-center gap-2 whitespace-nowrap underline rounded-lg ${className || ""}`,
  style: {
    color: "#1E2C44",
    fontSize: "14px",
    fontWeight: 500
  },
  children: [/* @__PURE__ */ jsx("img", {
    src: iqraIcon,
    alt: "",
    width: 20,
    height: 20,
    className: "shrink-0"
  }), /* @__PURE__ */ jsx(FormattedMessage, {
    id: "dashboard.goToBookCair",
    defaultMessage: "Go to BOOK CAIR"
  })]
});
const AiChatBreadCrumbs = () => {
  const {
    circle,
    membership
  } = useCircleContext();
  const dashboardUrl = useDashboardLink();
  const showFullPath = useIsInstanceAdmin() || isAdmin(membership);
  return /* @__PURE__ */ jsx("header", {
    className: "hidden md:flex flex-col items-start w-full box-border h-[65px] py-3 px-6 gap-2",
    style: {
      background: "#F2F2F2",
      borderBottom: "1px solid #B3B3B3",
      boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)"
    },
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-row justify-between items-center w-full self-stretch h-[40px] gap-2",
      children: [/* @__PURE__ */ jsx("nav", {
        className: "flex flex-row items-center gap-2 min-w-0 overflow-hidden",
        children: showFullPath ? /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx(Link$2, {
            to: dashboardUrl,
            className: crumbClass,
            style: {
              color: "#808081"
            },
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "dashboard.breadcrumb"
            })
          }), /* @__PURE__ */ jsx(Chevron, {}), /* @__PURE__ */ jsx(Link$2, {
            to: myCirclesUrl(),
            className: crumbClass,
            style: {
              color: "#808081"
            },
            children: /* @__PURE__ */ jsx(FormattedMessage, {
              id: "dashboard.circles"
            })
          }), /* @__PURE__ */ jsx(Chevron, {}), circle && circle.parent && /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx(Link$2, {
              to: circleUrl(circle.parent),
              className: crumbClass,
              style: {
                color: "#808081"
              },
              children: "..."
            }), /* @__PURE__ */ jsx(Chevron, {})]
          }), circle && /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx(Link$2, {
              to: circleUrl(circle._id),
              className: `${crumbClass} truncate`,
              style: {
                color: "#808081"
              },
              children: circle.name
            }), /* @__PURE__ */ jsx(Chevron, {})]
          }), /* @__PURE__ */ jsx("span", {
            className: crumbClass,
            style: {
              color: "#1E2C44"
            },
            children: "AI Chat"
          })]
        }) : /* @__PURE__ */ jsxs(Fragment, {
          children: [circle && circle.image && /* @__PURE__ */ jsx(CircleImage, {
            image: circle.image,
            size: 28,
            className: "shrink-0"
          }), /* @__PURE__ */ jsx("span", {
            className: `${crumbClass} truncate`,
            style: {
              color: "#1E2C44"
            },
            children: circle && circle.name
          })]
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-row items-center gap-4 shrink-0",
        children: [/* @__PURE__ */ jsx(GoToBookCairLink, {}), /* @__PURE__ */ jsx("span", {
          className: "shrink-0",
          style: {
            width: "1px",
            height: "28px",
            background: "#B3B3B3"
          }
        }), /* @__PURE__ */ jsx(ProfileIcon, {})]
      })]
    })
  });
};
const ChatPanelInner1 = ({
  test,
  chatId,
  circleId,
  actualCircleId
}) => {
  useAiChatContext();
  return /* @__PURE__ */ jsx("div", {
    style: {
      padding: 0,
      gap: 0
    },
    className: "ns w-full flex flex-col gap-0 text-sm h-full overflow-hidden",
    children: /* @__PURE__ */ jsxs(LoadCircleData, {
      circleId: actualCircleId,
      children: [/* @__PURE__ */ jsx(AiChatBreadCrumbs, {}), /* @__PURE__ */ jsx(Iframe, {
        iframe: iframe(actualCircleId)
      })]
    })
  });
};

const useAiChatCircle = (circleId, options) => {
  const api = useApi();
  const result = useSWR(circleId ? [`/public/groups/chat/create`, circleId] : null, async (path) => {
    try {
      return await api.post({
        path,
        body: {
          circleId
        }
      });
    } catch (e) {
      return {
        group: null
      };
    }
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const CircleAiChatInner = ({
  id,
  test,
  actualCircleId
}) => {
  const {
    data
  } = useAiChatCircle(id);
  if (!data) {
    return null;
  }
  if (!data.group) {
    return /* @__PURE__ */ jsx("div", {
      className: "text-red-500",
      children: "No AI Chat found!"
    });
  }
  const circleId = data.group._id;
  return /* @__PURE__ */ jsx(AiChatContextProvider, {
    children: /* @__PURE__ */ jsx(LoadChatPanel, {
      circleId,
      test,
      chatId: id,
      actualCircleId
    })
  });
};
const CircleAiChatPage = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const id = path[2];
  const queryParams = new URLSearchParams(location.search);
  const test = queryParams.get("test");
  return /* @__PURE__ */ jsx(SearchContextProvider, {
    children: /* @__PURE__ */ jsx(WebsocketsContextProvider, {
      children: /* @__PURE__ */ jsxs(ActivityContextProvider, {
        children: [/* @__PURE__ */ jsx(ChatCssOverrides, {}), /* @__PURE__ */ jsx(CircleAiChatInner, {
          id,
          test,
          actualCircleId: id
        })]
      })
    })
  });
};

const useExternal$1 = (id, options) => {
  const api = useApi();
  const result = useSWR(id ? `/groups/external/circle-configuration/${id}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const HarvestedURLsPanel$1 = ({
  circleId
}) => {
  const api = useApi();
  const {
    data,
    mutate
  } = useExternal$1(circleId);
  const [all, setAll] = useState([]);
  const history = useHistory();
  useEffect(() => {
    if (!data) {
      return;
    }
    const all2 = data.data || [];
    if (all2.find((one) => !one.uuid)) {
      setAll(all2.map((one) => {
        if (one.uuid) {
          return one;
        }
        return {
          uuid: ulid(),
          ...one
        };
      }));
    } else {
      setAll(all2);
    }
  }, [data && data.data]);
  const save = async () => {
    await api.post({
      path: `/groups/external/circle-configuration/${circleId}`,
      body: {
        group: circleId,
        data: all
      }
    });
    mutate();
    return;
  };
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    await save();
    history.push(circleUrl(circleId));
  });
  const onAdd = () => {
    const updated = [{
      url: "",
      uuid: ulid()
    }, ...all];
    setAll(updated);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "ns w-full p-2 flex flex-col gap-1",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold text-base mx-4 px-2 text-gray-500",
      children: "Harvested"
    }), /* @__PURE__ */ jsxs(FormControl$1, {
      className: "w-full",
      children: [/* @__PURE__ */ jsx(ButtonSimple, {
        onClick: onAdd,
        variant: "contained",
        color: "primary",
        className: "w-16",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.add"
        })
      }), all.map((one, id) => {
        const {
          url
        } = one;
        return /* @__PURE__ */ jsx(SingleExternal$1, {
          one,
          all,
          setAll,
          id,
          circleId
        }, url);
      })]
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSave,
      variant: "contained",
      color: "primary",
      loading: saveLoading,
      children: "Save"
    })]
  });
};
const SingleExternal$1 = ({
  one,
  all,
  setAll,
  id,
  circleId
}) => {
  const [html, setHtml] = useState("");
  const [title, setTitle] = useState("");
  const [showHtml, setShowHtml] = useState(false);
  const api = useApi();
  const onDelete = () => {
    const updated = all.filter((v, i) => i !== id);
    setAll(updated);
  };
  const {
    onClick: onExtract,
    loading: extractLoading
  } = useLoading(async () => {
    const {
      html: html2,
      title: title2
    } = await api.post({
      path: `/groups/external/extract`,
      body: one
    });
    setHtml(html2);
    setTitle(title2);
    setShowHtml(true);
  });
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    const {
      html: html2,
      title: title2,
      post: post2
    } = await api.post({
      path: `/groups/external/save`,
      body: {
        ...one,
        circleId
      }
    });
    setHtml(html2);
    setTitle(title2);
    const updated = all.map((v, i) => {
      if (i !== id) {
        return v;
      }
      return {
        ...v,
        post: post2
      };
    });
    setAll(updated);
  });
  const handleChange = (name) => (e) => {
    const value = e.target.value;
    const updated = all.map((v, i) => {
      if (i !== id) {
        return v;
      }
      return {
        ...v,
        [name]: value
      };
    });
    setAll(updated);
  };
  const {
    url,
    type,
    post
  } = one;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2",
    children: [html && showHtml && /* @__PURE__ */ jsx(ConfirmDialog, {
      open: true,
      title: "Extracted HTML: " + title,
      content: /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      }),
      onClose: () => setShowHtml(false)
    }), html && !showHtml && /* @__PURE__ */ jsx("div", {
      className: "underline cursor-pointer",
      onClick: () => setShowHtml(true),
      children: "show html"
    }), post && /* @__PURE__ */ jsx("div", {
      className: "underline",
      children: /* @__PURE__ */ jsx("a", {
        href: `/trans/post-view/${post}`,
        children: "open post"
      })
    }), /* @__PURE__ */ jsx(TextField$1, {
      label: "URL",
      value: url,
      onChange: handleChange("url"),
      className: "w-full"
    }), /* @__PURE__ */ jsxs(FormControl$1, {
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "tool",
        children: "tool"
      }), /* @__PURE__ */ jsxs(Select$1, {
        labelId: "tool",
        value: type || "axios",
        variant: "outlined",
        onChange: handleChange("type"),
        children: [/* @__PURE__ */ jsx(MenuItem, {
          value: "axios",
          children: "axios"
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "puppeteer",
          children: "puppeteer"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center w-full gap-2",
      children: [/* @__PURE__ */ jsx(ButtonSimple, {
        onClick: onDelete,
        variant: "contained",
        color: "primary",
        className: "w-16",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.delete"
        })
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onExtract,
        variant: "contained",
        color: "primary",
        loading: extractLoading,
        children: "Extract HTML"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onSave,
        variant: "contained",
        color: "primary",
        loading: saveLoading,
        children: "Save post"
      })]
    })]
  }, id);
};
const ConfigureCircleHarvesting = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[2];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(HarvestedURLsPanel$1, {
      circleId
    })]
  });
};

const useExternal = (id, options) => {
  const api = useApi();
  const result = useSWR(id ? `/groups/external/circle-configuration/${id}` : null, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const checkWordPressRESTAPI = async (url, config, onUpdate) => {
  try {
    let normalizedUrl = url;
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      normalizedUrl = `https://${url}`;
    }
    normalizedUrl = normalizedUrl.replace(/\/$/, "");
    if (normalizedUrl.includes("/wp-json/wp/v2/")) {
      return true;
    }
    const urlObj = new URL(normalizedUrl);
    const baseUrl = `${urlObj.protocol}//${urlObj.hostname}`;
    const apiUrl = `${baseUrl}/wp-json/wp/v2/posts`;
    onUpdate(config.uuid, {
      url: apiUrl,
      status: "idle",
      error: void 0,
      wordpress_validated: void 0
    });
    return true;
  } catch (error) {
    console.log("WordPress check failed:", error);
    return false;
  }
};
const createDefaultConfig = (partialConfig = {}) => ({
  uuid: partialConfig.uuid || ulid(),
  url: partialConfig.url || "",
  method: partialConfig.method || "scraper",
  verify_ssl: partialConfig.verify_ssl !== void 0 ? partialConfig.verify_ssl : true,
  use_playwright: partialConfig.use_playwright !== void 0 ? partialConfig.use_playwright : true,
  timeout: partialConfig.timeout || 3e4,
  enable_crawling: partialConfig.enable_crawling !== void 0 ? partialConfig.enable_crawling : false,
  max_crawl_pages: partialConfig.max_crawl_pages || 3,
  auto_exclude: partialConfig.auto_exclude !== void 0 ? partialConfig.auto_exclude : false,
  extract_article: partialConfig.extract_article !== void 0 ? partialConfig.extract_article : false,
  status: partialConfig.status || "idle",
  custom_selector: partialConfig.custom_selector,
  exclude_selector: partialConfig.exclude_selector,
  title_selector: partialConfig.title_selector,
  session_id: partialConfig.session_id,
  progress: partialConfig.progress,
  current_step: partialConfig.current_step,
  error: partialConfig.error,
  result: partialConfig.result,
  post_id: partialConfig.post_id,
  wordpress_validated: partialConfig.wordpress_validated
});
const HarvestedURLsPanel = ({
  circleId
}) => {
  const api = useApi();
  const {
    data,
    mutate
  } = useExternal(circleId);
  const [all, setAll] = useState([]);
  const history = useHistory();
  useEffect(() => {
    if (!data) {
      return;
    }
    const savedConfigs = data.data || [];
    const processedConfigs = savedConfigs.length > 0 ? savedConfigs.map((config) => {
      if (Object.keys(config).length <= 3 || !config.status) {
        return createDefaultConfig(config);
      }
      const baseConfig = createDefaultConfig(config);
      return {
        ...baseConfig,
        status: "idle",
        progress: void 0,
        current_step: void 0,
        error: void 0,
        result: void 0,
        post_id: config.post_id || void 0,
        session_id: void 0
      };
    }) : [createDefaultConfig()];
    setAll(processedConfigs);
  }, [data && data.data]);
  const save = async () => {
    const configsToSave = all.map((config) => ({
      uuid: config.uuid,
      url: config.url,
      method: config.method,
      custom_selector: config.custom_selector,
      exclude_selector: config.exclude_selector,
      title_selector: config.title_selector,
      verify_ssl: config.verify_ssl,
      use_playwright: config.use_playwright,
      timeout: config.timeout,
      enable_crawling: config.enable_crawling,
      max_crawl_pages: config.max_crawl_pages,
      auto_exclude: config.auto_exclude,
      extract_article: config.extract_article,
      post_id: config.post_id
    }));
    await api.post({
      path: `/groups/external/circle-configuration/${circleId}`,
      body: {
        group: circleId,
        data: configsToSave
      }
    });
    mutate();
    toast("Configuration saved successfully! \u{1F4BE}");
    return;
  };
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    await save();
    history.push(circleUrl(circleId));
  });
  const onAdd = () => {
    const updated = [createDefaultConfig(), ...all];
    setAll(updated);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "ns w-full p-2 flex flex-col gap-1",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between mb-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-3",
        children: [/* @__PURE__ */ jsx(ButtonSimple, {
          onClick: () => history.push(circleUrl(circleId)),
          variant: "outlined",
          color: "primary",
          className: "flex items-center gap-2",
          children: "\u2190 Back to Circle"
        }), /* @__PURE__ */ jsx("h2", {
          className: "font-bold px-1",
          children: "WAIR Harvested"
        })]
      }), /* @__PURE__ */ jsx(ButtonSimple, {
        onClick: onAdd,
        variant: "contained",
        color: "primary",
        className: "w-32",
        children: "Add new URL"
      })]
    }), /* @__PURE__ */ jsx(FormControl$1, {
      className: "w-full mb-4",
      children: all.map((one, id) => {
        const {
          uuid
        } = one;
        return /* @__PURE__ */ jsx(SingleExternal, {
          one,
          all,
          setAll,
          id,
          circleId
        }, uuid);
      })
    }), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onSave,
      variant: "contained",
      color: "primary",
      loading: saveLoading,
      children: "Save"
    })]
  });
};
const SingleExternal = ({
  one,
  all,
  setAll,
  id,
  circleId
}) => {
  const [html, setHtml] = useState("");
  const [title, setTitle] = useState("");
  const [showHtml, setShowHtml] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");
  const api = useApi();
  const onDelete = () => {
    const updated = all.filter((v, i) => i !== id);
    setAll(updated);
  };
  const prepareContentForNsHtml = (resultData, fallbackContent) => {
    if (resultData && resultData.contentHtml && resultData.contentHtml.trim() !== "") {
      return resultData.contentHtml;
    }
    const content = fallbackContent || "";
    const hasHtmlTags = /<[^>]+>/.test(content);
    if (!hasHtmlTags && content.trim() !== "") {
      return `<p>${content}</p>`;
    }
    console.log("finalContent", content);
    return content;
  };
  const updateConfig = (uuid, updates) => {
    setAll(all.map((config) => config.uuid === uuid ? {
      ...config,
      ...updates
    } : config));
  };
  const {
    onClick: onExtract,
    loading: extractLoading
  } = useLoading(async () => {
    try {
      if (one.method === "wordpress") {
        updateConfig(one.uuid, {
          status: "validating_wordpress",
          current_step: "Checking WordPress REST API availability...",
          progress: 0
        });
        const isWordPressValid = await checkWordPressRESTAPI(one.url, one, updateConfig);
        if (!isWordPressValid) {
          updateConfig(one.uuid, {
            status: "error",
            error: "This website does not support WordPress REST API access. Please use the default scraping method instead.",
            wordpress_validated: false
          });
          toast("\u274C WordPress REST API not available. Please switch to 'Scraper' method or check if the site supports WordPress REST API.");
          return;
        }
        updateConfig(one.uuid, {
          status: "processing",
          current_step: "WordPress REST API validated. Starting scraping...",
          progress: 10,
          wordpress_validated: true
        });
        toast("\u2705 WordPress REST API validated successfully!");
      }
      const responseData = await api.post({
        path: `/wair/start-scrape`,
        body: {
          url: one.url,
          custom_selector: one.custom_selector || void 0,
          exclude_selector: one.exclude_selector || void 0,
          title_selector: one.title_selector || void 0,
          verify_ssl: one.verify_ssl,
          use_playwright: one.use_playwright,
          timeout: one.timeout,
          enable_crawling: one.enable_crawling,
          max_crawl_pages: one.max_crawl_pages,
          auto_exclude: one.auto_exclude,
          extract_article: one.extract_article,
          wordpress_json: one.method === "wordpress"
        }
      });
      if (responseData.session_id) {
        updateConfig(one.uuid, {
          session_id: responseData.session_id,
          status: responseData.status === "completed" ? "completed" : "processing",
          progress: responseData.status === "completed" ? 100 : 20
        });
        if (responseData.status === "completed") {
          await fetchResultWithRetry(responseData.session_id, one.uuid, updateConfig);
        } else {
          pollProgress(responseData.session_id);
        }
      } else {
        throw new Error("No session ID returned from scraping API");
      }
    } catch (error2) {
      updateConfig(one.uuid, {
        status: "error",
        error: error2.message || "Failed to start scraping"
      });
      toast(`Scraping failed: ${error2.message || "Unknown error"}`);
    }
  });
  const fetchResultWithRetry = async (sessionId, configUuid, updateConfig2, maxRetries = 3) => {
    let retryCount = 0;
    const baseDelay = 2e3;
    while (retryCount < maxRetries) {
      try {
        console.log(`Attempting to fetch result (attempt ${retryCount + 1}/${maxRetries}) for session: ${sessionId}`);
        const resultData = await api.get({
          path: `/wair/result/${sessionId}`
        });
        if (resultData && resultData.data && Object.keys(resultData.data).length > 0) {
          console.log("Successfully fetched result data");
          updateConfig2(configUuid, {
            result: resultData.data,
            status: "completed",
            progress: 100
          });
          return;
        } else {
          throw new Error("Empty or invalid result data received");
        }
      } catch (error2) {
        retryCount++;
        console.warn(`Attempt ${retryCount} failed to fetch result:`, error2);
        if (retryCount >= maxRetries) {
          console.error("All retry attempts failed");
          updateConfig2(configUuid, {
            status: "error",
            error: `Failed to fetch result after ${maxRetries} attempts. Please try again.`
          });
          toast(`Failed to fetch scraping results after ${maxRetries} attempts. Please try scraping again.`);
          return;
        }
        const delay = baseDelay * Math.pow(2, retryCount - 1);
        console.log(`Waiting ${delay}ms before retry...`);
        updateConfig2(configUuid, {
          current_step: `Retrying to fetch results... (attempt ${retryCount + 1}/${maxRetries})`
        });
        await new Promise((resolve) => setTimeout(resolve, delay));
      }
    }
  };
  const pollProgress = async (sessionId) => {
    const interval = setInterval(async () => {
      try {
        const progressData = await api.get({
          path: `/wair/progress/${sessionId}`
        });
        updateConfig(one.uuid, {
          status: progressData.status,
          progress: progressData.progress || 0,
          current_step: progressData.current_step,
          error: progressData.error
        });
        if (progressData.status === "completed") {
          clearInterval(interval);
          await fetchResultWithRetry(sessionId, one.uuid, updateConfig);
        } else if (progressData.status === "error") {
          clearInterval(interval);
          toast(`Scraping failed: ${progressData.error || "Unknown error"}`);
        }
      } catch (error2) {
        clearInterval(interval);
        updateConfig(one.uuid, {
          status: "error",
          error: "Failed to fetch progress"
        });
      }
    }, 2e3);
  };
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    if (!one.result)
      return;
    try {
      if (one.method === "wordpress" && one.result.wordpress_json && one.result.wordpress_json.raw_data) {
        const wpPosts = one.result.wordpress_json.raw_data;
        const createdPosts = [];
        const totalPosts = wpPosts.length;
        for (const post of wpPosts) {
          try {
            const postData2 = {
              type: "article",
              content: {
                nsTitle: post.title.rendered,
                nsHtml: prepareContentForNsHtml(one.result, post.content.rendered || post.excerpt.rendered || "")
              },
              tags: post.categories ? post.categories.map(String) : ["wordpress"],
              group: {
                group: circleId,
                privacy: null
              },
              metadata: {
                title: post.title.rendered,
                author: post.yoast_head_json && post.yoast_head_json.author ? post.yoast_head_json.author : "",
                summary: post.excerpt.rendered,
                publicationDate: post.date || new Date().toISOString(),
                documentType: "Article",
                rights: post.link
              }
            };
            console.log("Creating draft for post:", post.title.rendered);
            const draftResponse2 = await api.post({
              path: "/drafts/_new",
              body: postData2
            });
            if (!draftResponse2 || !draftResponse2._id) {
              throw new Error("No draft ID received from draft creation");
            }
            console.log("Draft created with ID:", draftResponse2._id);
            console.log("Publishing draft:", draftResponse2._id);
            const publishResponse2 = await api.post({
              path: `/drafts/${draftResponse2._id}/_publish`,
              body: {
                draft: postData2
              }
            });
            console.log("Post published:", publishResponse2.post_id || draftResponse2._id);
            createdPosts.push(publishResponse2.post_id || draftResponse2._id);
            await new Promise((resolve) => setTimeout(resolve, 1e3));
          } catch (postError) {
            console.error("Error processing post:", post.title.rendered, postError);
            toast(`Failed to process post "${post.title.rendered}": ${postError instanceof Error ? postError.message : "Unknown error"}`);
          }
        }
        if (createdPosts.length > 0) {
          updateConfig(one.uuid, {
            post_id: createdPosts.join(",")
          });
          toast(`Successfully created and published ${createdPosts.length} out of ${totalPosts} WordPress posts! \u{1F389}`);
        } else {
          throw new Error("Failed to create any posts");
        }
        return;
      }
      if (one.result.crawled_pages && one.result.crawled_pages.pages && Array.isArray(one.result.crawled_pages.pages)) {
        const crawledPages = one.result.crawled_pages.pages;
        const createdPosts = [];
        const skippedPages = [];
        let totalProcessed = 0;
        console.log(`Processing crawling results: main article + ${crawledPages.length} crawled pages...`);
        const hasMainArticle = one.result.article && one.result.article.content;
        if (hasMainArticle) {
          try {
            const mainArticle = one.result.article;
            const title3 = mainArticle.title || one.result.title || "Untitled";
            let content2 = mainArticle.content;
            const author2 = mainArticle.author || "";
            const date2 = mainArticle.date || "";
            if (mainArticle.primary_image) {
              content2 = `<img src="${mainArticle.primary_image}" alt="${title3}" style="max-width: 100%; height: auto; margin-bottom: 20px;" />
${content2}`;
            }
            if (mainArticle.images && mainArticle.images.length > 0) {
              const otherImages = mainArticle.images.filter((img) => img !== mainArticle.primary_image);
              if (otherImages.length > 0) {
                const imagesHtml = otherImages.map((img) => `<img src="${img}" alt="Article image" style="max-width: 100%; height: auto; margin: 10px 0;" />`).join("\n");
                content2 = `${content2}
${imagesHtml}`;
              }
            }
            const tags2 = title3.split(" ").filter((tag) => tag.length > 2).slice(0, 10);
            const postData2 = {
              type: "article",
              content: {
                nsTitle: title3,
                nsHtml: prepareContentForNsHtml(one.result, content2),
                nsText: content2.replace(/<[^>]*>/g, "")
              },
              tags: tags2.length > 0 ? tags2 : ["article"],
              group: {
                group: circleId,
                privacy: null
              },
              metadata: {
                title: title3,
                author: author2,
                summary: mainArticle.description || content2.replace(/<[^>]*>/g, "").substring(0, 200),
                publicationDate: date2 || new Date().toISOString(),
                documentType: "Article",
                rights: one.url,
                wordCount: mainArticle.word_count || 0
              }
            };
            console.log(`Creating draft for main article: ${title3}`);
            const draftResponse2 = await api.post({
              path: "/drafts/_new",
              body: postData2
            });
            if (!draftResponse2 || !draftResponse2._id) {
              throw new Error("No draft ID received from main article draft creation");
            }
            console.log(`Publishing main article draft: ${draftResponse2._id}`);
            const publishResponse2 = await api.post({
              path: `/drafts/${draftResponse2._id}/_publish`,
              body: {
                draft: postData2
              }
            });
            console.log(`Main article post published: ${title3}`);
            createdPosts.push(publishResponse2.post_id || draftResponse2._id);
            totalProcessed++;
            await new Promise((resolve) => setTimeout(resolve, 1e3));
          } catch (mainArticleError) {
            console.error("Error processing main article:", mainArticleError);
            skippedPages.push({
              url: one.url,
              reason: `Main article error: ${mainArticleError instanceof Error ? mainArticleError.message : "Unknown error"}`
            });
          }
        }
        for (const page of crawledPages) {
          try {
            if (!page.content || page.content.trim() === "" || page.title === "No title found" || !page.title || page.word_count === 0) {
              skippedPages.push({
                url: page.url,
                reason: "No content or invalid title"
              });
              continue;
            }
            const tags2 = page.title.split(" ").filter((tag) => tag.length > 2).slice(0, 10);
            let content2 = page.content;
            if (page.primary_image) {
              content2 = `<img src="${page.primary_image}" alt="${page.title}" style="max-width: 100%; height: auto; margin-bottom: 20px;" />
${content2}`;
            }
            if (page.images && page.images.length > 0) {
              const otherImages = page.images.filter((img) => img !== page.primary_image);
              if (otherImages.length > 0) {
                const imagesHtml = otherImages.map((img) => `<img src="${img}" alt="Page image" style="max-width: 100%; height: auto; margin: 10px 0;" />`).join("\n");
                content2 = `${content2}
${imagesHtml}`;
              }
            }
            const postData2 = {
              type: "article",
              content: {
                nsTitle: page.title,
                nsHtml: prepareContentForNsHtml(page, content2),
                nsText: content2.replace(/<[^>]*>/g, "")
              },
              tags: tags2.length > 0 ? tags2 : ["crawled"],
              group: {
                group: circleId,
                privacy: null
              },
              metadata: {
                title: page.title,
                author: "",
                summary: page.content_preview || page.content.replace(/<[^>]*>/g, "").substring(0, 200),
                publicationDate: new Date(page.scraped_at * 1e3).toISOString() || new Date().toISOString(),
                documentType: "Article",
                rights: page.url,
                wordCount: page.word_count,
                linksFound: page.links_found,
                isCrawledPage: true
              }
            };
            console.log(`Creating draft for crawled page: ${page.title}`);
            const draftResponse2 = await api.post({
              path: "/drafts/_new",
              body: postData2
            });
            if (!draftResponse2 || !draftResponse2._id) {
              throw new Error("No draft ID received from draft creation");
            }
            console.log(`Publishing draft: ${draftResponse2._id}`);
            const publishResponse2 = await api.post({
              path: `/drafts/${draftResponse2._id}/_publish`,
              body: {
                draft: postData2
              }
            });
            console.log(`Post published for: ${page.title}`);
            createdPosts.push(publishResponse2.post_id || draftResponse2._id);
            totalProcessed++;
            await new Promise((resolve) => setTimeout(resolve, 1e3));
          } catch (pageError) {
            console.error("Error processing crawled page:", page.title, pageError);
            skippedPages.push({
              url: page.url,
              reason: `Error: ${pageError instanceof Error ? pageError.message : "Unknown error"}`
            });
          }
        }
        if (createdPosts.length > 0) {
          updateConfig(one.uuid, {
            post_id: createdPosts.join(",")
          });
          let message = `Successfully created and published ${createdPosts.length} posts! \u{1F389}`;
          if (skippedPages.length > 0) {
            message += ` (Skipped ${skippedPages.length} pages without content)`;
          }
          toast(message);
        } else {
          toast("No posts were created - all pages were skipped due to missing content.");
        }
        console.log("Crawling summary:", {
          mainArticleProcessed: hasMainArticle,
          crawledPagesTotal: crawledPages.length,
          totalCreated: createdPosts.length,
          totalSkipped: skippedPages.length,
          skippedDetails: skippedPages
        });
        return;
      }
      const hasArticle = one.result.article && one.result.article.article_content;
      const title2 = hasArticle ? one.result.article.article_content.title : one.result.title;
      const content = hasArticle ? one.result.article.article_content.content : one.result.content;
      const author = hasArticle && one.result.article.article_content.author ? one.result.article.article_content.author : "";
      const date = hasArticle && one.result.article.article_content.date ? one.result.article.article_content.date : "";
      const tags = title2.split(" ");
      const postData = {
        type: "article",
        content: {
          nsTitle: `${title2}${author ? ` - ${author}` : ""}`,
          nsHtml: prepareContentForNsHtml(one.result, previewHtml || content),
          nsText: (content || "").replace(/<[^>]*>/g, "")
        },
        tags,
        group: {
          group: circleId,
          privacy: null
        },
        metadata: {
          title: title2,
          author,
          summary: content,
          publicationDate: date || new Date().toISOString(),
          documentType: "Article",
          rights: one.url
        }
      };
      console.log("Creating draft with data:", postData);
      const draftResponse = await api.post({
        path: "/drafts/_new",
        body: postData
      });
      if (!draftResponse || !draftResponse._id) {
        throw new Error("No draft ID received from draft creation");
      }
      console.log("Draft created successfully:", draftResponse);
      console.log(`Publishing draft with ID: ${draftResponse._id}`);
      const publishResponse = await api.post({
        path: `/drafts/${draftResponse._id}/_publish`,
        body: {
          draft: postData
        }
      });
      console.log("Draft published successfully:", publishResponse);
      updateConfig(one.uuid, {
        post_id: publishResponse.post_id || draftResponse._id
      });
      toast("Post created and published successfully!");
    } catch (error2) {
      console.error("Error in post creation process:", error2);
      const errorMessage = error2 instanceof Error ? error2.message : "Unknown error";
      toast(`Failed to create post: ${errorMessage}`);
      throw error2;
    }
  });
  const handleChange = (name) => (e) => {
    let value = e.target.value;
    if (name === "timeout") {
      value = parseInt(e.target.value) || 0;
    } else if (name === "max_crawl_pages") {
      let numValue = parseInt(e.target.value) || 3;
      numValue = Math.max(1, Math.min(20, numValue));
      value = numValue;
    }
    const updated = all.map((v, i) => {
      if (i !== id) {
        return v;
      }
      return {
        ...v,
        [name]: value
      };
    });
    setAll(updated);
  };
  const handleBooleanChange = (name) => (e) => {
    const value = e.target.checked;
    const updated = all.map((v, i) => {
      if (i !== id) {
        return v;
      }
      let updatedConfig = {
        ...v,
        [name]: value
      };
      if (name === "enable_crawling" && value) {
        updatedConfig.use_playwright = true;
      }
      return updatedConfig;
    });
    setAll(updated);
  };
  const handleHtmlCapture = React__default.useCallback((html2) => {
    console.log("Handling HTML capture:", html2);
    setPreviewHtml(html2);
  }, []);
  const PreviewContentWithCapture = ({
    config,
    onHtmlCapture
  }) => {
    const previewRef = React__default.useRef(null);
    React__default.useEffect(() => {
      if (previewRef.current) {
        console.log("Capturing preview HTML...");
        const html2 = previewRef.current.innerHTML;
        console.log("Captured HTML:", html2);
        onHtmlCapture(html2);
      }
    }, [config.result, onHtmlCapture]);
    if (!config.result)
      return null;
    if (config.result.crawled_pages && config.result.crawled_pages.pages && Array.isArray(config.result.crawled_pages.pages)) {
      const crawledPages = config.result.crawled_pages.pages;
      const validPages = crawledPages.filter((page) => page.content && page.content.trim() !== "" && page.title !== "No title found" && page.title && page.word_count > 0);
      const hasMainArticle = config.result.article && config.result.article.content;
      const totalPosts = validPages.length + (hasMainArticle ? 1 : 0);
      validPages.slice(0, hasMainArticle ? 2 : 3);
      const allPages = [];
      if (hasMainArticle) {
        const mainArticle = config.result.article;
        let content2 = mainArticle.content;
        if (mainArticle.primary_image) {
          content2 = `<img src="${mainArticle.primary_image}" alt="${mainArticle.title}" style="max-width: 100%; height: auto; margin-bottom: 20px;" />
${content2}`;
        }
        if (mainArticle.images && mainArticle.images.length > 0) {
          const otherImages = mainArticle.images.filter((img) => img !== mainArticle.primary_image);
          if (otherImages.length > 0) {
            const imagesHtml = otherImages.map((img) => `<img src="${img}" alt="Article image" style="max-width: 100%; height: auto; margin: 10px 0;" />`).join("\n");
            content2 = `${content2}
${imagesHtml}`;
          }
        }
        allPages.push({
          url: config.url,
          title: mainArticle.title || config.result.title || "Untitled",
          content: content2,
          content_preview: mainArticle.description || content2.replace(/<[^>]*>/g, "").substring(0, 200),
          word_count: mainArticle.word_count || 0,
          links_found: 0,
          scraped_at: Date.now() / 1e3,
          isMainArticle: true
        });
      }
      allPages.push(...validPages);
      return /* @__PURE__ */ jsxs("div", {
        ref: previewRef,
        className: "max-h-96 overflow-y-auto",
        children: [/* @__PURE__ */ jsxs(Typography, {
          variant: "h6",
          className: "mb-2",
          children: ["Crawling Results Preview (", totalPosts, " total posts)"]
        }), /* @__PURE__ */ jsxs(Typography, {
          variant: "body2",
          className: "mb-4",
          children: [hasMainArticle ? `1 main article + ${validPages.length} crawled pages` : `${validPages.length} crawled pages`, " | Skipped: ", crawledPages.length - validPages.length]
        }), allPages.map((page, index) => /* @__PURE__ */ jsxs("div", {
          className: "mb-6 p-4 border rounded",
          children: [/* @__PURE__ */ jsx("h3", {
            className: "text-lg font-semibold mb-2",
            children: page.title
          }), /* @__PURE__ */ jsxs("p", {
            className: "text-sm text-gray-600 mb-2",
            children: ["URL: ", /* @__PURE__ */ jsx("a", {
              href: page.url,
              target: "_blank",
              rel: "noopener noreferrer",
              className: "text-blue-600 hover:underline",
              children: page.url
            })]
          }), /* @__PURE__ */ jsxs("p", {
            className: "text-sm text-gray-600 mb-2",
            children: ["Word count: ", page.word_count, " ", page.links_found > 0 && `| Links found: ${page.links_found}`]
          }), /* @__PURE__ */ jsxs("p", {
            className: "text-sm text-gray-600 mb-2",
            children: ["Scraped: ", new Date(page.scraped_at * 1e3).toLocaleDateString()]
          }), page.content_preview && /* @__PURE__ */ jsxs("div", {
            className: "text-sm text-gray-700 mb-2",
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Preview:"
            }), /* @__PURE__ */ jsx("p", {
              className: "mt-1",
              children: page.content_preview
            })]
          }), page.content && /* @__PURE__ */ jsx("div", {
            className: "prose max-w-none",
            children: /* @__PURE__ */ jsx("div", {
              dangerouslySetInnerHTML: {
                __html: page.content.substring(0, 300) + (page.content.length > 300 ? "..." : "")
              }
            })
          })]
        }, page.url || index)), crawledPages.length - validPages.length > 0 && /* @__PURE__ */ jsx("div", {
          className: "mt-2 p-2 bg-yellow-50 rounded",
          children: /* @__PURE__ */ jsxs(Typography, {
            variant: "body2",
            className: "text-yellow-800",
            children: ["\u26A0\uFE0F ", crawledPages.length - validPages.length, " pages will be skipped due to missing content or invalid titles."]
          })
        })]
      });
    }
    if (config.method === "wordpress" && Array.isArray(config.result.wordpress_json) && config.result.wordpress_json.raw_data) {
      const wpPosts = config.result.wordpress_json;
      const previewPosts = wpPosts.slice(0, 3);
      return /* @__PURE__ */ jsxs("div", {
        ref: previewRef,
        className: "max-h-96 overflow-y-auto",
        children: [/* @__PURE__ */ jsxs(Typography, {
          variant: "h6",
          className: "mb-2",
          children: ["WordPress Posts Preview (showing first 3 of ", wpPosts.length, ")"]
        }), /* @__PURE__ */ jsxs(Typography, {
          variant: "body2",
          className: "mb-4",
          children: ["Source URL: ", config.url]
        }), previewPosts.map((post, index) => /* @__PURE__ */ jsxs("div", {
          className: "mb-6 p-4 border rounded",
          children: [/* @__PURE__ */ jsx("h3", {
            className: "text-lg font-semibold mb-2",
            children: post.title
          }), /* @__PURE__ */ jsxs("p", {
            className: "text-sm text-gray-600 mb-2",
            children: ["By: ", post.author, " | Date: ", new Date(post.date).toLocaleDateString()]
          }), /* @__PURE__ */ jsxs("p", {
            className: "text-sm text-gray-600 mb-2",
            children: ["URL: ", /* @__PURE__ */ jsx("a", {
              href: post.url,
              target: "_blank",
              rel: "noopener noreferrer",
              children: post.url
            })]
          }), post.tags && post.tags.length > 0 && /* @__PURE__ */ jsxs("p", {
            className: "text-sm text-gray-600 mb-2",
            children: ["Tags: ", post.tags.join(", ")]
          }), post.excerpt && /* @__PURE__ */ jsxs("div", {
            className: "text-sm text-gray-700 mb-2",
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Excerpt:"
            }), /* @__PURE__ */ jsx("div", {
              dangerouslySetInnerHTML: {
                __html: post.excerpt
              }
            })]
          }), post.content && /* @__PURE__ */ jsx("div", {
            className: "prose max-w-none",
            children: /* @__PURE__ */ jsx("div", {
              dangerouslySetInnerHTML: {
                __html: post.content
              }
            })
          })]
        }, post.id || index)), wpPosts.length > 3 && /* @__PURE__ */ jsx("div", {
          className: "mt-4 p-2 bg-blue-50 rounded",
          children: /* @__PURE__ */ jsxs(Typography, {
            variant: "body2",
            className: "text-blue-800",
            children: ["\u{1F4A1} This is a preview of the first 3 posts. When you create posts, all ", wpPosts.length, " posts will be processed."]
          })
        })]
      });
    }
    const hasArticle = config.result.article && config.result.article.article_content;
    const title2 = hasArticle ? config.result.article.article_content.title : config.result.title;
    const content = hasArticle ? config.result.article.article_content.content : config.result.content;
    return /* @__PURE__ */ jsxs("div", {
      ref: previewRef,
      className: "max-h-96 overflow-y-auto",
      children: [/* @__PURE__ */ jsx(Typography, {
        variant: "h6",
        className: "mb-2",
        children: title2
      }), /* @__PURE__ */ jsxs(Typography, {
        variant: "body2",
        className: "mb-4",
        children: ["Source URL: ", config.url]
      }), hasArticle ? /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("h1", {
          children: config.result.article.article_content.title
        }), config.result.article.article_content.author && /* @__PURE__ */ jsxs("h2", {
          children: ["Author: ", config.result.article.article_content.author]
        }), config.result.article.article_content.date && /* @__PURE__ */ jsxs("h2", {
          children: ["Date: ", config.result.article.article_content.date]
        }), config.result.article.article_content.primary_image && /* @__PURE__ */ jsx("img", {
          src: config.result.article.article_content.primary_image,
          alt: "Primary Image"
        }), config.result.article.article_content.images && config.result.article.article_content.images.length > 0 && config.result.article.article_content.images.map((image, index) => /* @__PURE__ */ jsx("img", {
          src: image,
          alt: `Image ${index + 1}`
        }, index)), content && /* @__PURE__ */ jsx("div", {
          className: "prose max-w-none",
          dangerouslySetInnerHTML: {
            __html: content
          }
        })]
      }) : /* @__PURE__ */ jsx("div", {
        className: "prose max-w-none",
        dangerouslySetInnerHTML: {
          __html: content
        }
      })]
    });
  };
  const {
    url,
    method,
    verify_ssl,
    use_playwright,
    timeout,
    enable_crawling,
    max_crawl_pages,
    auto_exclude,
    extract_article,
    post_id,
    status,
    progress,
    current_step,
    error,
    result,
    wordpress_validated,
    custom_selector,
    exclude_selector,
    title_selector
  } = one;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 border rounded-lg bg-white shadow-sm mb-3",
    children: [html && showHtml && /* @__PURE__ */ jsx(ConfirmDialog, {
      open: true,
      title: "Extracted HTML: " + title,
      content: /* @__PURE__ */ jsx("div", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      }),
      onClose: () => setShowHtml(false)
    }), html && !showHtml && /* @__PURE__ */ jsx("div", {
      className: "underline cursor-pointer",
      onClick: () => setShowHtml(true),
      children: "show html"
    }), /* @__PURE__ */ jsx("div", {
      className: "mb-3",
      children: /* @__PURE__ */ jsx(TextField$1, {
        label: "URL",
        value: url,
        onChange: handleChange("url"),
        className: "w-full",
        variant: "outlined",
        size: "small",
        placeholder: method === "wordpress" ? "https://yoursite.com" : "https://example.com/article-url",
        helperText: method === "wordpress" ? "Enter your WordPress site base URL (we'll automatically validate REST API access)" : "Enter the full URL of the webpage you want to scrape."
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "mb-3 p-3 bg-gray-50 rounded border",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "text-sm font-semibold text-gray-700 mb-2",
        children: ["Method", wordpress_validated && method === "wordpress" && /* @__PURE__ */ jsx("span", {
          className: "ml-2 text-green-600 text-sm",
          children: "\u2705 Validated"
        })]
      }), /* @__PURE__ */ jsxs(FormGroup, {
        row: true,
        className: "gap-4",
        children: [/* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Checkbox$1, {
            checked: method === "wordpress",
            onChange: (e) => {
              handleChange("method")({
                target: {
                  value: "wordpress"
                }
              });
            },
            size: "small"
          }),
          label: "WordPress API"
        }), /* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Checkbox$1, {
            checked: method === "scraper",
            onChange: (e) => {
              handleChange("method")({
                target: {
                  value: "scraper"
                }
              });
            },
            size: "small"
          }),
          label: "Default Scraper"
        })]
      }), method === "wordpress" && /* @__PURE__ */ jsx(Typography, {
        variant: "caption",
        className: "text-blue-600 mt-1 block",
        children: "\u{1F4A1} WordPress API will automatically validate REST API access before scraping"
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "mb-3",
      children: /* @__PURE__ */ jsx(TextField$1, {
        label: "Timeout (ms)",
        type: "number",
        value: timeout,
        onChange: handleChange("timeout"),
        className: "w-full",
        variant: "outlined",
        size: "small"
      })
    }), method !== "wordpress" && /* @__PURE__ */ jsxs("div", {
      className: "mb-3 p-3 bg-gray-50 rounded border",
      children: [/* @__PURE__ */ jsx("div", {
        className: "text-sm font-semibold text-gray-700 mb-3",
        children: "Advanced Selectors"
      }), /* @__PURE__ */ jsxs("div", {
        className: "space-y-2",
        children: [/* @__PURE__ */ jsx(TextField$1, {
          label: "Custom Selector",
          value: custom_selector || "",
          onChange: handleChange("custom_selector"),
          className: "w-full",
          variant: "outlined",
          size: "small",
          helperText: "CSS selector for specific content. Examples: .article-content, #main-content, article"
        }), /* @__PURE__ */ jsx(TextField$1, {
          label: "Exclude Selector",
          value: exclude_selector || "",
          onChange: handleChange("exclude_selector"),
          className: "w-full",
          variant: "outlined",
          size: "small",
          helperText: "CSS selector for content to exclude. Examples: .sidebar, .ads, footer"
        }), /* @__PURE__ */ jsx(TextField$1, {
          label: "Title Selector",
          value: title_selector || "",
          onChange: handleChange("title_selector"),
          className: "w-full",
          variant: "outlined",
          size: "small",
          helperText: "Enter CSS selector for the page title. If not provided, we'll try to find the title automatically. Examples: .article-title, #post-title, h1.main-title, article h1"
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "mb-3 p-3 bg-gray-50 rounded border",
      children: [/* @__PURE__ */ jsx("div", {
        className: "text-sm font-semibold text-gray-700 mb-3",
        children: "Settings"
      }), /* @__PURE__ */ jsxs(FormGroup, {
        className: "grid grid-cols-2 gap-2",
        children: [/* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Switch$1, {
            checked: use_playwright,
            onChange: handleBooleanChange("use_playwright"),
            size: "small",
            color: "primary"
          }),
          label: /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col",
            children: [/* @__PURE__ */ jsxs("span", {
              className: `text-sm ${use_playwright ? "text-green-700 font-medium" : "text-gray-600"}`,
              children: ["Browser Engine ", use_playwright ? "\u2713" : ""]
            }), /* @__PURE__ */ jsx("span", {
              className: "text-xs text-gray-500 mt-1",
              children: "Enable this to use a real browser engine for JavaScript-rendered content."
            })]
          })
        }), /* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Switch$1, {
            checked: enable_crawling,
            onChange: handleBooleanChange("enable_crawling"),
            size: "small",
            color: "primary"
          }),
          label: /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col",
            children: [/* @__PURE__ */ jsxs("span", {
              className: `text-sm ${enable_crawling ? "text-green-700 font-medium" : "text-gray-600"}`,
              children: ["Smart Crawling ", enable_crawling ? "\u2713" : ""]
            }), /* @__PURE__ */ jsx("span", {
              className: "text-xs text-gray-500 mt-1",
              children: "Advanced Feature: When enabled, the scraper will follow links found on the main page and scrape each linked page (one level deep only). Warning: This may take significantly longer and make many requests. Perfect for news sites to get full article content for each news item. Note: Browser Engine will be automatically enabled for Smart Crawling."
            })]
          })
        }), enable_crawling && /* @__PURE__ */ jsx("div", {
          className: "col-span-2 ml-8 mb-2",
          children: /* @__PURE__ */ jsx(TextField$1, {
            label: "Max Pages to Crawl",
            type: "number",
            value: max_crawl_pages,
            onChange: handleChange("max_crawl_pages"),
            className: "w-full",
            variant: "outlined",
            size: "small",
            inputProps: {
              min: 1,
              max: 20
            },
            helperText: "Number of pages to crawl (1-20). Default is 3."
          })
        }), /* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Switch$1, {
            checked: auto_exclude,
            onChange: handleBooleanChange("auto_exclude"),
            size: "small",
            color: "primary"
          }),
          label: /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col",
            children: [/* @__PURE__ */ jsxs("span", {
              className: `text-sm ${auto_exclude ? "text-green-700 font-medium" : "text-gray-600"}`,
              children: ["Auto-exclude Common Elements ", auto_exclude ? "\u2713" : ""]
            }), /* @__PURE__ */ jsx("span", {
              className: "text-xs text-gray-500 mt-1",
              children: "Auto-exclude common elements (footer, navbar, ads, etc.)"
            })]
          })
        }), /* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Switch$1, {
            checked: extract_article,
            onChange: handleBooleanChange("extract_article"),
            size: "small",
            color: "primary"
          }),
          label: /* @__PURE__ */ jsxs("div", {
            className: "flex flex-col",
            children: [/* @__PURE__ */ jsxs("span", {
              className: `text-sm ${extract_article ? "text-green-700 font-medium" : "text-gray-600"}`,
              children: ["Extract Article Content ", extract_article ? "\u2713" : ""]
            }), /* @__PURE__ */ jsx("span", {
              className: "text-xs text-gray-500 mt-1",
              children: "When enabled, the scraper will intelligently extract the main article content and primary image from individual news articles. Perfect for individual news articles (e.g., news/12345) to get clean content and main image. Uses advanced content detection algorithms including semantic HTML analysis and readability scoring. Automatically detects article URLs and enables this feature when appropriate."
            })]
          }),
          className: "col-span-2"
        })]
      })]
    }), (status === "processing" || status === "validating_wordpress") && /* @__PURE__ */ jsxs("div", {
      className: "mb-3 p-3 bg-blue-50 border border-blue-200 rounded",
      children: [/* @__PURE__ */ jsxs(Typography, {
        variant: "body2",
        className: "mb-2 text-blue-800 font-medium",
        children: ["\u{1F504} ", current_step || "Processing..."]
      }), status === "validating_wordpress" && /* @__PURE__ */ jsx(Typography, {
        variant: "caption",
        className: "text-blue-600 block mb-2",
        children: "Validating WordPress REST API..."
      }), progress !== void 0 && /* @__PURE__ */ jsx("div", {
        className: "w-full bg-blue-200 rounded-full h-2",
        children: /* @__PURE__ */ jsx("div", {
          className: "bg-blue-600 h-2 rounded-full transition-all duration-300",
          style: {
            width: `${progress}%`
          }
        })
      })]
    }), status === "error" && /* @__PURE__ */ jsxs("div", {
      className: "mb-3 p-3 bg-red-50 border border-red-200 rounded",
      children: [/* @__PURE__ */ jsxs(Typography, {
        variant: "body2",
        className: "mb-2 text-red-700 font-medium",
        children: ["\u274C Error: ", error]
      }), error && error.includes("WordPress REST API") && /* @__PURE__ */ jsx(ButtonSimple, {
        variant: "outlined",
        size: "small",
        className: "text-blue-600 border-blue-600 hover:bg-blue-50",
        onClick: () => updateConfig(one.uuid, {
          method: "scraper",
          status: "idle",
          error: void 0,
          wordpress_validated: void 0
        }),
        children: "\u{1F504} Switch to Default Scraper"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "pt-3 border-t border-gray-200",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between w-full mb-2",
        children: [/* @__PURE__ */ jsxs(ButtonSimple, {
          onClick: onDelete,
          variant: "outlined",
          color: "secondary",
          size: "small",
          className: "text-red-600 border-red-300 hover:bg-red-50",
          children: ["\u{1F5D1}\uFE0F ", /* @__PURE__ */ jsx(FormattedMessage, {
            id: "ai.delete"
          })]
        }), /* @__PURE__ */ jsx(LoadingButton, {
          onClick: onExtract,
          variant: "contained",
          color: "primary",
          loading: extractLoading,
          disabled: !url || status === "processing" || status === "validating_wordpress",
          size: "small",
          children: extractLoading ? "\u{1F504} Starting..." : status === "validating_wordpress" ? "\u{1F50D} Validating WordPress..." : method === "wordpress" ? "\u{1F4E5} Fetch WordPress Posts" : "\u{1F50D} Scrape to JSON"
        })]
      }), status === "completed" && result && /* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-center w-full gap-2",
        children: [/* @__PURE__ */ jsxs(ButtonSimple, {
          variant: "outlined",
          onClick: () => setShowPreview(true),
          size: "small",
          className: "flex-1",
          children: ["\u{1F441}\uFE0F Preview", result.crawled_pages && result.crawled_pages.pages.length > 0 ? (() => {
            const validPages = result.crawled_pages.pages.filter((page) => page.content && page.content.trim() !== "" && page.title !== "No title found" && page.title && page.word_count > 0).length;
            const hasMainArticle = result.article && result.article.content ? 1 : 0;
            const totalPosts = validPages + hasMainArticle;
            return ` (${totalPosts} posts)`;
          })() : result.source === "wordpress" ? ` (${result.total_count} posts)` : ""]
        }), /* @__PURE__ */ jsx(LoadingButton, {
          onClick: onSave,
          variant: "contained",
          color: "primary",
          loading: saveLoading,
          size: "small",
          className: "flex-1",
          children: saveLoading ? "\u{1F504} Creating..." : result.crawled_pages && result.crawled_pages.pages.length > 0 ? (() => {
            const validPages = result.crawled_pages.pages.filter((page) => page.content && page.content.trim() !== "" && page.title !== "No title found" && page.title && page.word_count > 0).length;
            const hasMainArticle = result.article && result.article.content ? 1 : 0;
            const totalPosts = validPages + hasMainArticle;
            return `\u{1F4DD} Create ${totalPosts} Posts`;
          })() : result.source === "wordpress" ? `\u{1F4DD} Create ${result.total_count} Posts` : "\u{1F4DD} Create Post"
        })]
      })]
    }), showPreview && result && /* @__PURE__ */ jsxs(Dialog$6, {
      open: showPreview,
      onClose: () => setShowPreview(false),
      maxWidth: "md",
      fullWidth: true,
      children: [/* @__PURE__ */ jsx(DialogTitle$1, {
        children: (() => {
          const hasArticle = result.article && result.article.article_content;
          const title2 = hasArticle ? result.article.article_content.title : result.title;
          return `Preview: ${title2 || "Untitled"}`;
        })()
      }), /* @__PURE__ */ jsx(DialogContent, {
        children: /* @__PURE__ */ jsx(PreviewContentWithCapture, {
          config: one,
          onHtmlCapture: handleHtmlCapture
        })
      }), /* @__PURE__ */ jsx(DialogActions, {
        children: /* @__PURE__ */ jsx(ButtonSimple, {
          onClick: () => setShowPreview(false),
          children: "Close"
        })
      })]
    })]
  });
};
const ConfigureCircleHarvestingWair = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleId = path[2];
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(HarvestedURLsPanel, {
      circleId
    })]
  });
};

const useUserMobiles = (options) => {
  const api = useApi();
  const result = useSWR(`/playground/user-mobiles`, async (path) => {
    const data = await api.get({
      path
    });
    return data;
  }, {
    ...swrLoadOnce,
    ...options
  });
  return {
    ...result
  };
};
const createMobile = () => {
  return {
    appId: "25a1a7c7-e70f-4102-b6a3-b7a29bb64d08",
    created: new Date()
  };
};
const UserMobile = ({
  mobile,
  all,
  setAll
}) => {
  const onDelete = () => {
    const updated = all.filter((v) => v !== mobile);
    setAll(updated);
  };
  const handleChange = (name) => (e) => {
    const value = e.target.value;
    const updated = all.map((v) => {
      if (v !== mobile) {
        return v;
      }
      return {
        ...v,
        [name]: value
      };
    });
    setAll(updated);
  };
  const {
    appId,
    player
  } = mobile;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-2",
    children: [/* @__PURE__ */ jsx(TextField$1, {
      label: "App Id",
      value: appId || "",
      onChange: handleChange("appId"),
      className: "w-full"
    }), /* @__PURE__ */ jsx(TextField$1, {
      label: "player",
      value: player || "",
      onChange: handleChange("player"),
      className: "w-full"
    }), /* @__PURE__ */ jsxs(FormControl$1, {
      children: [/* @__PURE__ */ jsx(InputLabel, {
        id: "App",
        children: "App"
      }), /* @__PURE__ */ jsxs(Select$1, {
        labelId: "App",
        value: appId || "",
        variant: "outlined",
        onChange: handleChange("appId"),
        children: [/* @__PURE__ */ jsx(MenuItem, {
          value: "",
          children: "None"
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "25a1a7c7-e70f-4102-b6a3-b7a29bb64d08",
          children: "Mushtareck"
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "4db17ce4-9998-4480-b6a3-839de4bcb425",
          children: "NewsSocialNews"
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "e30843e8-e4a0-403a-b6b4-7a52898808ec",
          children: "PCEC"
        }), /* @__PURE__ */ jsx(MenuItem, {
          value: "b3577250-ff5e-4b2b-bcab-89e02b30b119",
          children: "YourMap"
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "flex items-center w-full gap-2",
      children: /* @__PURE__ */ jsx(ButtonSimple, {
        onClick: onDelete,
        variant: "contained",
        color: "primary",
        className: "w-16",
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "ai.delete"
        })
      })
    })]
  });
};
const UserMobilesPanel = ({}) => {
  const api = useApi();
  const [all, setAll] = useState([]);
  const {
    data
  } = useUserMobiles();
  useEffect(() => {
    if (!data) {
      return;
    }
    const {
      mobiles = []
    } = data || {};
    setAll(mobiles);
  }, [data && data.mobiles]);
  const {
    onClick: onChatPush,
    loading: chatPushLoading
  } = useLoading(async () => {
    const result = await api.post({
      path: `/playground/push-user-mobile`,
      body: {}
    });
    const {
      error,
      log
    } = result;
    console.log("results:", result);
    if (error) {
      errorToast({
        error
      });
    }
    if (log && log.length) {
      toast(`message was successfully sent to: ${log.flatMap((v) => v.mobiles).length} mobiles`);
    }
  });
  const {
    onClick: onSave,
    loading: saveLoading
  } = useLoading(async () => {
    const {
      mobiles
    } = await api.post({
      path: `/playground/save-user-mobiles`,
      body: {
        mobiles: all
      }
    });
    setAll(mobiles);
  });
  const {
    onClick: onVerify,
    loading: verifyLoading
  } = useLoading(async () => {
    await api.post({
      path: `/playground/user-send-verifications`,
      body: {}
    });
  });
  const onAdd = () => {
    setAll([...all, createMobile()]);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "ns w-full p-2 flex flex-col gap-1",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-semibold text-base mx-4 px-2 text-gray-500",
      children: "User Mobiles"
    }), /* @__PURE__ */ jsx(FormControl$1, {
      className: "w-full",
      children: all.map((mobile) => {
        const {
          _id,
          created
        } = mobile;
        return /* @__PURE__ */ jsx(UserMobile, {
          mobile,
          all,
          setAll
        }, String(_id) + created);
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2",
      children: [/* @__PURE__ */ jsx(LoadingButton, {
        onClick: onChatPush,
        variant: "contained",
        color: "primary",
        loading: chatPushLoading,
        children: "Send chat notification"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onSave,
        variant: "contained",
        color: "primary",
        loading: saveLoading,
        children: "Save"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onAdd,
        variant: "contained",
        color: "primary",
        loading: false,
        children: "Add New"
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: onVerify,
        variant: "contained",
        color: "primary",
        loading: verifyLoading,
        children: "Send Verification Pin"
      })]
    })]
  });
};
const UserMobiles = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(UserMobilesPanel, {})]
  });
};

const useSavePostMetadataMutation = () => {
  const {
    mutate,
    errorMessages,
    handleGraphQLErrors,
    clearErrors
  } = useMutation(savePostMetadataDocument);
  const saveSavePostMetadata = async (variables) => {
    return await mutate(variables);
  };
  return {
    saveSavePostMetadata,
    errorMessages,
    handleGraphQLErrors,
    clearErrors
  };
};

const usePostMetadataEditor = (postId) => {
  const { data, error: fetchError, mutate: revalidate } = usePostMetadata({ postId });
  const [metadata, setMetadata] = useState({});
  const { saveSavePostMetadata, errorMessages, handleGraphQLErrors, clearErrors } = useSavePostMetadataMutation();
  useEffect(() => {
    if (fetchError) {
      handleGraphQLErrors(fetchError);
    }
    if (!data)
      return;
    const post = data.post;
    const { tags, title, metadata: postMetadata, author, content, created } = post;
    const { nsHtml } = content;
    setMetadata({
      tags,
      title,
      creationDate: created,
      publicationDate: created,
      summary: extractSummary(nsHtml),
      author: getPersonName(author),
      ...postMetadata
    });
  }, [data, fetchError]);
  const save = useMemoizedFn(async () => {
    await saveSavePostMetadata({ postId, metadata });
  });
  return {
    data,
    metadata,
    setMetadata,
    save,
    revalidate,
    errorMessages,
    clearErrors,
    loading: !data && !fetchError
  };
};

const PostMetadataContext = createContext(null);
const usePostMetadataCtx = () => {
  const ctx = useContext(PostMetadataContext);
  if (!ctx)
    throw new Error("usePostMetadataCtx must be used inside PostMetadataProvider");
  return ctx;
};
const PostMetadataProvider = ({
  postId,
  sections,
  onAfterSave,
  children
}) => {
  const editor = usePostMetadataEditor(postId);
  return /* @__PURE__ */ jsx(PostMetadataContext.Provider, {
    value: {
      ...editor,
      sections,
      onAfterSave
    },
    children
  });
};

const ErrorBox = ({
  messages,
  onClose
}) => {
  const errorBoxRef = useRef(null);
  useDeepCompareEffect(() => {
    if (messages.length > 0 && errorBoxRef.current) {
      errorBoxRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }, [messages]);
  return /* @__PURE__ */ jsxs("div", {
    ref: errorBoxRef,
    className: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4",
    role: "alert",
    children: [/* @__PURE__ */ jsx("strong", {
      className: "font-bold",
      children: "Error:"
    }), /* @__PURE__ */ jsx("ul", {
      className: "ml-4 mt-2",
      children: messages.map((message, index) => /* @__PURE__ */ jsx("li", {
        className: "list-disc",
        children: message
      }, index))
    }), /* @__PURE__ */ jsx("button", {
      onClick: onClose,
      className: "absolute top-0 bottom-0 right-0 px-4 py-3",
      children: /* @__PURE__ */ jsx("span", {
        className: "text-red-500 hover:text-red-800",
        children: "\xD7"
      })
    })]
  });
};

const fieldLabel = (field, intl) => field.labelId ? intl.formatMessage({ id: field.labelId, defaultMessage: field.name }) : field.name;
const fieldDescription = (field, intl) => field.descriptionId ? intl.formatMessage({ id: field.descriptionId, defaultMessage: field.description }) : field.description;
const sectionLabel = (section, intl) => section.labelId ? intl.formatMessage({ id: section.labelId, defaultMessage: section.label }) : section.label;

const ImagePicker = ({
  value,
  onChange,
  label,
  helperText,
  accept = [".jpeg", ".png", ".gif"],
  maxSizeMB = 5,
  previewSize = 150,
  showPreview = true,
  disabled = false
}) => {
  const api = useApi();
  const {
    instanceName,
    cdnRoot
  } = useCDNImageContext();
  const uploadOperation = useAsyncOperation(async (file) => {
    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > maxSizeMB) {
      throw new Error(`File size (${fileSizeMB.toFixed(2)}MB) exceeds ${maxSizeMB}MB limit`);
    }
    const attachments = await api.upload({
      0: file,
      path: "/uploads"
    });
    const attachment = attachments[0];
    onChange(attachment);
    return attachment;
  });
  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles[0]) {
      uploadOperation.execute(acceptedFiles[0]);
    }
  }, [uploadOperation.execute]);
  const dropzone = useDropzone({
    onDrop,
    accept,
    maxFiles: 1,
    disabled: disabled || uploadOperation.isLoading
  });
  const getPreviewUrl = (attachment) => {
    return `${cdnRoot}${instanceName}/${attachment.uuid}?w=${previewSize}&h=${previewSize}&fit=facearea&facepad=10&auto=format`;
  };
  const handleRemove = (e) => {
    e.stopPropagation();
    onChange(null);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [label && /* @__PURE__ */ jsx("label", {
      className: "text-sm font-medium text-gray-700",
      children: label
    }), /* @__PURE__ */ jsxs("div", {
      className: "relative",
      children: [value && showPreview ? /* @__PURE__ */ jsxs("div", {
        className: "relative inline-block",
        children: [/* @__PURE__ */ jsx("img", {
          src: getPreviewUrl(value),
          alt: label || "Preview",
          className: "rounded-lg border-2 border-gray-300 object-cover",
          style: {
            width: `${previewSize}px`,
            height: `${previewSize}px`
          }
        }), !disabled && /* @__PURE__ */ jsx("button", {
          type: "button",
          onClick: handleRemove,
          className: "absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors flex items-center justify-center",
          "aria-label": "Remove image",
          children: "\xD7"
        })]
      }) : /* @__PURE__ */ jsxs("div", {
        ...dropzone.getRootProps(),
        className: `
                            border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors
                            ${uploadOperation.isLoading || disabled ? "bg-gray-50 cursor-not-allowed border-gray-300" : dropzone.isDragActive ? "bg-blue-50 border-blue-400" : "bg-white border-gray-300 hover:border-blue-400 hover:bg-gray-50"}
                        `,
        children: [/* @__PURE__ */ jsx("input", {
          ...dropzone.getInputProps()
        }), uploadOperation.isLoading ? /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col items-center gap-2",
          children: [/* @__PURE__ */ jsx(Spinner, {
            size: "md"
          }), /* @__PURE__ */ jsx("p", {
            className: "text-sm text-gray-600",
            children: "Uploading..."
          })]
        }) : /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col items-center gap-2",
          children: [/* @__PURE__ */ jsx("svg", {
            className: "w-12 h-12 text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ jsx("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            })
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsxs("p", {
              className: "text-sm text-gray-600",
              children: [/* @__PURE__ */ jsx("span", {
                className: "text-blue-500 font-medium",
                children: "Click to upload"
              }), " ", "or drag and drop"]
            }), /* @__PURE__ */ jsxs("p", {
              className: "text-xs text-gray-500 mt-1",
              children: [accept.map((ext) => ext.toUpperCase()).join(", "), " ", "(max ", maxSizeMB, "MB)"]
            })]
          })]
        })]
      }), uploadOperation.error && /* @__PURE__ */ jsx("div", {
        className: "mt-2 p-2 bg-red-50 border border-red-200 rounded text-sm text-red-700",
        children: uploadOperation.error.message
      })]
    }), helperText && !uploadOperation.error && /* @__PURE__ */ jsx("span", {
      className: "text-xs text-gray-500",
      children: helperText
    })]
  });
};

const MetadataInputSection = ({
  post,
  metadataFields,
  values = {},
  onChange
}) => {
  const [formValues, setFormValues] = useState(values);
  const [tagInput, setTagInput] = useState("");
  const intl = useIntl();
  useEffect(() => {
    setFormValues(values);
  }, [values]);
  const handleInputChange = (shortName, value) => {
    const newValues = {
      ...formValues
    };
    if (value === null || value === void 0) {
      delete newValues[shortName];
    } else {
      newValues[shortName] = value;
    }
    setFormValues(newValues);
    if (onChange) {
      onChange(newValues);
    }
  };
  const handleTagAdd = (shortName) => {
    if (tagInput.trim()) {
      const currentTags = formValues[shortName] || [];
      const newTags = [...currentTags, tagInput.trim()];
      handleInputChange(shortName, newTags);
      setTagInput("");
    }
  };
  const handleTagRemove = (shortName, tagToRemove) => {
    const currentTags = formValues[shortName] || [];
    const newTags = currentTags.filter((tag) => tag !== tagToRemove);
    handleInputChange(shortName, newTags);
  };
  const renderField = (field) => {
    const value = formValues[field.shortName];
    const label = fieldLabel(field, intl);
    const description = fieldDescription(field, intl);
    switch (field.type) {
      case "Date": {
        const stringDate = (value instanceof Date ? value.toISOString() : typeof value === "string" ? value : "").slice(0, 10);
        return /* @__PURE__ */ jsx(TextField$1, {
          label,
          type: "date",
          value: stringDate,
          onChange: (e) => handleInputChange(field.shortName, new Date(e.target.value)),
          fullWidth: true,
          margin: "normal",
          InputLabelProps: {
            shrink: true
          },
          helperText: description
        }, field.shortName);
      }
      case "string[]": {
        const tags = value || [];
        return /* @__PURE__ */ jsxs("div", {
          className: "mb-4",
          children: [/* @__PURE__ */ jsx("div", {
            className: "flex flex-wrap gap-2 mb-2",
            children: tags.map((tag) => /* @__PURE__ */ jsx(Chip$1, {
              label: tag,
              onDelete: () => handleTagRemove(field.shortName, tag),
              size: "small"
            }, tag))
          }), /* @__PURE__ */ jsx(TextField$1, {
            label,
            value: tagInput,
            onChange: (e) => setTagInput(e.target.value),
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleTagAdd(field.shortName);
              }
            },
            fullWidth: true,
            margin: "normal",
            helperText: description || "Press Enter to add a tag",
            InputProps: {
              endAdornment: /* @__PURE__ */ jsx(Tooltip$2, {
                title: description,
                children: /* @__PURE__ */ jsx(IconButton$5, {
                  size: "small",
                  children: /* @__PURE__ */ jsx(HiInformationCircle, {})
                })
              })
            }
          })]
        }, field.shortName);
      }
      case "enum":
        return /* @__PURE__ */ jsxs(FormControl$1, {
          fullWidth: true,
          margin: "normal",
          children: [/* @__PURE__ */ jsx(InputLabel, {
            children: label
          }), /* @__PURE__ */ jsx(Select$1, {
            value: value || "",
            onChange: (e) => handleInputChange(field.shortName, e.target.value),
            children: (field.options || []).map((option) => /* @__PURE__ */ jsx(MenuItem, {
              value: option,
              children: option
            }, option))
          }), description && /* @__PURE__ */ jsx(Typography, {
            variant: "caption",
            className: "mt-1 text-gray-500",
            children: description
          })]
        }, field.shortName);
      case "attachment": {
        const attachment = value;
        const config = field.attachmentConfig || {};
        return /* @__PURE__ */ jsx("div", {
          className: "mb-4",
          children: /* @__PURE__ */ jsx(ImagePicker, {
            value: attachment,
            onChange: (newAttachment) => handleInputChange(field.shortName, newAttachment),
            label,
            helperText: description,
            accept: config.accept,
            maxSizeMB: config.maxSizeMB,
            previewSize: config.previewSize,
            showPreview: config.showPreview
          })
        }, field.shortName);
      }
      case "number":
        return /* @__PURE__ */ jsx(TextField$1, {
          label,
          type: "number",
          value: value !== void 0 ? value : "",
          onChange: (e) => {
            const parsed = parseFloat(e.target.value);
            handleInputChange(field.shortName, isNaN(parsed) ? "" : parsed);
          },
          fullWidth: true,
          margin: "normal",
          helperText: description
        }, field.shortName);
      default:
        return /* @__PURE__ */ jsx(TextField$1, {
          label,
          value: value || "",
          onChange: (e) => handleInputChange(field.shortName, e.target.value),
          fullWidth: true,
          margin: "normal",
          multiline: field.shortName === "summary" || field.shortName === "description",
          rows: field.shortName === "summary" ? 3 : 1,
          helperText: description
        }, field.shortName);
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "space-y-4",
    children: [/* @__PURE__ */ jsxs(Typography, {
      variant: "h6",
      component: "h2",
      className: "mb-4",
      children: ["Metadata for\xA0", /* @__PURE__ */ jsx("span", {
        className: "underline text-blue-500",
        children: /* @__PURE__ */ jsx(Link$2, {
          to: url4post(post),
          target: "_blank",
          children: formValues["title"]
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "grid grid-cols-1 gap-4",
      children: metadataFields.map(renderField)
    })]
  });
};

const MetadataEditorShell = () => {
  const history = useHistory();
  const intl = useIntl();
  const {
    data,
    metadata,
    setMetadata,
    save,
    sections,
    onAfterSave,
    errorMessages,
    clearErrors
  } = usePostMetadataCtx();
  const [activeTab, setActiveTab] = useState(sections.length > 0 ? sections[0].tab : "");
  const {
    onClick: onSave,
    loading: loadingSave
  } = useLoading(async () => {
    await save();
    if (onAfterSave) {
      onAfterSave();
    } else if (!isLocalhost() && data && data.post) {
      history.push(url4post(data.post));
    }
  });
  const activeSection = sections.find((s) => s.tab === activeTab) || null;
  const post = data && data.post;
  const circleId = post && post.group && post.group.group && post.group.group._id;
  const accessType = post && (post.accessType || "free");
  return /* @__PURE__ */ jsxs("div", {
    children: [errorMessages.length > 0 && /* @__PURE__ */ jsx(ErrorBox, {
      messages: errorMessages,
      onClose: clearErrors
    }), sections.length > 1 && /* @__PURE__ */ jsx("div", {
      className: "flex border-b border-gray-200 mb-6",
      children: sections.map((section) => /* @__PURE__ */ jsx("button", {
        onClick: () => setActiveTab(section.tab),
        className: ["px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors", activeTab === section.tab ? "border-blue-600 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700"].join(" "),
        children: sectionLabel(section, intl)
      }, section.tab))
    }), activeSection && /* @__PURE__ */ jsxs("div", {
      children: [activeSection.component && React__default.createElement(activeSection.component), activeSection.fields && activeSection.fields.length > 0 && /* @__PURE__ */ jsx(MetadataInputSection, {
        post,
        metadataFields: activeSection.fields,
        values: metadata,
        onChange: setMetadata
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx("div", {
      className: "flex gap-2 items-center",
      children: /* @__PURE__ */ jsx(LoadingButton, {
        disabled: errorMessages.length > 0 || !data,
        loading: loadingSave,
        onClick: onSave,
        children: "Save"
      })
    }), post && circleId && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
        className: "mt-4 mb-2",
        children: [/* @__PURE__ */ jsx("h3", {
          className: "text-lg font-semibold mb-3",
          children: "Quick Links"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-wrap gap-2",
          children: [/* @__PURE__ */ jsx("a", {
            href: bookCairDesktopUrl(post._id),
            target: "_blank",
            rel: "noreferrer",
            className: "text-sm text-blue-600 underline",
            children: "Reader (desktop)"
          }), /* @__PURE__ */ jsx("a", {
            href: bookCairMobileUrl(post._id),
            target: "_blank",
            rel: "noreferrer",
            className: "text-sm text-blue-600 underline",
            children: "Reader (mobile)"
          }), (accessType === "purchase" || accessType === "free_donation" || accessType === "subscription") && /* @__PURE__ */ jsx("a", {
            href: bookCairPaymentUrl(post._id),
            target: "_blank",
            rel: "noreferrer",
            className: "text-sm text-blue-600 underline",
            children: "Payment page"
          }), /* @__PURE__ */ jsx("a", {
            href: bookCairBrowseUrl(circleId),
            target: "_blank",
            rel: "noreferrer",
            className: "text-sm text-blue-600 underline",
            children: "Browse books"
          })]
        })]
      })]
    })]
  });
};

const useConfigurePostAccess = () => {
  const { mutate, errorMessages, handleGraphQLErrors, clearErrors } = useMutation(configurePostAccessDocument);
  const configurePostAccess = async (variables) => {
    return await mutate(variables);
  };
  return {
    configurePostAccess,
    errorMessages,
    handleGraphQLErrors,
    clearErrors
  };
};

const useConfigureCircleStripe = () => {
  const { mutate, errorMessages, handleGraphQLErrors, clearErrors } = useMutation(configureCircleStripeDocument);
  const configureCircleStripe = async (variables) => {
    return await mutate(variables);
  };
  return {
    configureCircleStripe,
    errorMessages,
    handleGraphQLErrors,
    clearErrors
  };
};

const ACCESS_TYPE_LABELS = {
  free: "Free",
  free_donation: "Free with Donation",
  purchase: "One-Time Purchase",
  subscription: "Subscription",
  domain: "Domain Restricted",
  admin: "Admin Only"
};
const ACCESS_TYPE_DESCRIPTIONS = {
  free: "Freely accessible to all circle members.",
  free_donation: "Freely accessible; readers may optionally donate.",
  purchase: "Readers pay a one-time fee to access this book.",
  subscription: "Access requires an active circle subscription. Configure Stripe price IDs below.",
  domain: "Access is restricted to users with allowed email domains.",
  admin: "Only circle admins can access this book."
};
const GRANT_TYPE_LABELS = {
  cash: "Cash",
  pay_later: "Pay Later",
  courtesy: "Courtesy",
  other: "Other"
};
const BookPricingSection = ({
  postId,
  circleId,
  initialAccessType = "free",
  initialPrice,
  initialAllowedDomains = [],
  initialSubscriptionMonthlyPrice,
  initialSubscriptionYearlyPrice,
  onSaved
}) => {
  const api = useApi();
  const [accessType, setAccessType] = useState(initialAccessType || "free");
  const [price, setPrice] = useState(initialPrice != null ? String(initialPrice / 100) : "");
  const [allowedDomains, setAllowedDomains] = useState(initialAllowedDomains);
  const [domainInput, setDomainInput] = useState("");
  const [monthlyPrice, setMonthlyPrice] = useState(initialSubscriptionMonthlyPrice != null ? String(initialSubscriptionMonthlyPrice / 100) : "");
  const [yearlyPrice, setYearlyPrice] = useState(initialSubscriptionYearlyPrice != null ? String(initialSubscriptionYearlyPrice / 100) : "");
  useEffect(function() {
    setAccessType(initialAccessType || "free");
  }, [initialAccessType]);
  useEffect(function() {
    setPrice(initialPrice != null ? String(initialPrice / 100) : "");
  }, [initialPrice]);
  useEffect(function() {
    setAllowedDomains(initialAllowedDomains);
  }, [initialAllowedDomains.join(",")]);
  useEffect(function() {
    setMonthlyPrice(initialSubscriptionMonthlyPrice != null ? String(initialSubscriptionMonthlyPrice / 100) : "");
  }, [initialSubscriptionMonthlyPrice]);
  useEffect(function() {
    setYearlyPrice(initialSubscriptionYearlyPrice != null ? String(initialSubscriptionYearlyPrice / 100) : "");
  }, [initialSubscriptionYearlyPrice]);
  const [grantedUsers, setGrantedUsers] = useState([]);
  const [loadingGrants, setLoadingGrants] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchingUsers, setSearchingUsers] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [grantType, setGrantType] = useState("cash");
  const [grantAmount, setGrantAmount] = useState("");
  const [grantNote, setGrantNote] = useState("");
  const [grantingAccess, setGrantingAccess] = useState(false);
  const [grantError, setGrantError] = useState("");
  const {
    configurePostAccess,
    errorMessages: postErrors,
    clearErrors: clearPostErrors
  } = useConfigurePostAccess();
  const {
    configureCircleStripe,
    errorMessages: circleErrors,
    clearErrors: clearCircleErrors
  } = useConfigureCircleStripe();
  const allErrors = [...postErrors, ...circleErrors];
  const clearAllErrors = () => {
    clearPostErrors();
    clearCircleErrors();
  };
  const showGrantSection = accessType === "purchase" || accessType === "subscription";
  const fetchGrantedUsers = useCallback(function() {
    if (!api || !postId)
      return;
    setLoadingGrants(true);
    api.get({
      path: "ua/payments/admin/posts/" + postId + "/purchases"
    }).then(function(res) {
      if (res && Array.isArray(res)) {
        setGrantedUsers(res);
      } else if (res && res.data && Array.isArray(res.data)) {
        setGrantedUsers(res.data);
      } else {
        setGrantedUsers([]);
      }
    }).catch(function(err) {
      console.error("Failed to fetch granted users:", err);
      setGrantedUsers([]);
    }).finally(function() {
      setLoadingGrants(false);
    });
  }, [api, postId]);
  useEffect(function() {
    if (showGrantSection) {
      fetchGrantedUsers();
    }
  }, [showGrantSection, fetchGrantedUsers]);
  useEffect(function() {
    if (!api || searchQuery.length < 2) {
      setSearchResults([]);
      return;
    }
    var timer = setTimeout(function() {
      setSearchingUsers(true);
      api.get({
        path: "ua/payments/admin/users/search?q=" + encodeURIComponent(searchQuery)
      }).then(function(res) {
        if (Array.isArray(res)) {
          setSearchResults(res);
        } else if (res && res.data && Array.isArray(res.data)) {
          setSearchResults(res.data);
        } else {
          setSearchResults([]);
        }
      }).catch(function(err) {
        console.error("User search error:", err);
        setSearchResults([]);
      }).finally(function() {
        setSearchingUsers(false);
      });
    }, 400);
    return function() {
      clearTimeout(timer);
    };
  }, [api, searchQuery]);
  var handleGrantAccess = function() {
    if (!api || !selectedUser)
      return;
    setGrantingAccess(true);
    setGrantError("");
    var parsedAmount = grantAmount ? Math.round(parseFloat(grantAmount) * 100) : 0;
    api.post({
      path: "ua/payments/admin/grant-access",
      body: {
        userId: selectedUser._id,
        documentId: postId,
        grantType,
        amount: parsedAmount,
        note: grantNote || void 0
      }
    }).then(function() {
      setSelectedUser(null);
      setSearchQuery("");
      setSearchResults([]);
      setGrantAmount("");
      setGrantNote("");
      fetchGrantedUsers();
    }).catch(function(err) {
      var msg = err && err.message || "Failed to grant access";
      if (err && err.status === 409) {
        msg = "This user already has access to this book.";
      }
      setGrantError(msg);
    }).finally(function() {
      setGrantingAccess(false);
    });
  };
  var handleRevokeAccess = function(purchaseId) {
    if (!api)
      return;
    if (!window.confirm("Are you sure you want to revoke this access?"))
      return;
    api.delete({
      path: "ua/payments/admin/grant-access/" + purchaseId
    }).then(function() {
      fetchGrantedUsers();
    }).catch(function(err) {
      console.error("Revoke access error:", err);
      alert("Failed to revoke access: " + (err && err.message || "Unknown error"));
    });
  };
  const {
    onClick: onSave,
    loading
  } = useLoading(async () => {
    clearAllErrors();
    const parsedPrice = price ? Math.round(parseFloat(price) * 100) : void 0;
    await configurePostAccess({
      postId,
      accessType,
      price: parsedPrice,
      allowedDomains: accessType === "domain" ? allowedDomains : void 0
    });
    if (accessType === "subscription" && circleId && (monthlyPrice || yearlyPrice)) {
      const parsedMonthly = monthlyPrice ? Math.round(parseFloat(monthlyPrice) * 100) : void 0;
      const parsedYearly = yearlyPrice ? Math.round(parseFloat(yearlyPrice) * 100) : void 0;
      const hasExistingPrices = initialSubscriptionMonthlyPrice != null || initialSubscriptionYearlyPrice != null;
      const monthlyChanged = parsedMonthly !== (initialSubscriptionMonthlyPrice != null ? initialSubscriptionMonthlyPrice : void 0);
      const yearlyChanged = parsedYearly !== (initialSubscriptionYearlyPrice != null ? initialSubscriptionYearlyPrice : void 0);
      if (hasExistingPrices && (monthlyChanged || yearlyChanged)) {
        const confirmed = window.confirm("This circle already has subscription prices configured. Saving will create new prices on Stripe and replace the existing ones.\n\nExisting subscribers will keep their current price until they renew.\n\nAre you sure you want to update the prices?");
        if (!confirmed)
          return;
      }
      await configureCircleStripe({
        circleId,
        monthlyPrice: parsedMonthly,
        yearlyPrice: parsedYearly
      });
    }
    if (onSaved)
      onSaved();
  });
  const handleDomainAdd = () => {
    const trimmed = domainInput.trim().toLowerCase();
    if (trimmed && !allowedDomains.includes(trimmed)) {
      setAllowedDomains([...allowedDomains, trimmed]);
      setDomainInput("");
    }
  };
  const handleDomainRemove = (domain) => {
    setAllowedDomains(allowedDomains.filter((d) => d !== domain));
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "mt-8",
      children: [/* @__PURE__ */ jsx(Typography, {
        variant: "h6",
        component: "h3",
        children: "Book Access & Pricing"
      }), allErrors.length > 0 && /* @__PURE__ */ jsx(ErrorBox, {
        messages: allErrors,
        onClose: clearAllErrors
      }), /* @__PURE__ */ jsxs(FormControl$1, {
        fullWidth: true,
        margin: "normal",
        children: [/* @__PURE__ */ jsx(InputLabel, {
          children: "Access Type"
        }), /* @__PURE__ */ jsx(Select$1, {
          value: accessType,
          onChange: (e) => setAccessType(e.target.value),
          children: Object.keys(ACCESS_TYPE_LABELS).map((type) => /* @__PURE__ */ jsx(MenuItem, {
            value: type,
            children: ACCESS_TYPE_LABELS[type]
          }, type))
        }), /* @__PURE__ */ jsx(Typography, {
          variant: "caption",
          className: "mt-1 text-gray-500",
          children: ACCESS_TYPE_DESCRIPTIONS[accessType]
        })]
      }), accessType === "purchase" && /* @__PURE__ */ jsx(TextField$1, {
        label: "Price (USD)",
        type: "number",
        value: price,
        onChange: (e) => setPrice(e.target.value),
        fullWidth: true,
        margin: "normal",
        inputProps: {
          min: 0.01,
          step: 0.01
        },
        helperText: "Set the one-time purchase price in US dollars (e.g. 9.99)."
      }), accessType === "subscription" && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(TextField$1, {
          label: "Monthly Price (USD)",
          type: "number",
          value: monthlyPrice,
          onChange: (e) => setMonthlyPrice(e.target.value),
          fullWidth: true,
          margin: "normal",
          inputProps: {
            min: 1,
            step: 0.01
          },
          helperText: "Monthly subscription price in US dollars (e.g. 8.99). Stripe product and price will be created automatically."
        }), /* @__PURE__ */ jsx(TextField$1, {
          label: "Yearly Price (USD)",
          type: "number",
          value: yearlyPrice,
          onChange: (e) => setYearlyPrice(e.target.value),
          fullWidth: true,
          margin: "normal",
          inputProps: {
            min: 1,
            step: 0.01
          },
          helperText: "Yearly subscription price in US dollars (e.g. 79.99). Leave empty for monthly-only subscriptions."
        })]
      }), accessType === "domain" && /* @__PURE__ */ jsxs("div", {
        className: "mb-4",
        children: [/* @__PURE__ */ jsx(Typography, {
          variant: "subtitle1",
          component: "label",
          className: "block mb-2",
          children: "Allowed Domains"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex gap-2 mb-2",
          children: [/* @__PURE__ */ jsx(TextField$1, {
            placeholder: "example.com",
            value: domainInput,
            onChange: (e) => setDomainInput(e.target.value),
            onKeyPress: (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleDomainAdd();
              }
            },
            size: "small",
            className: "flex-1",
            helperText: "Only users with email addresses from these domains can access this book."
          }), /* @__PURE__ */ jsx("button", {
            type: "button",
            onClick: handleDomainAdd,
            className: "px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors",
            children: "Add"
          })]
        }), /* @__PURE__ */ jsx(Box, {
          className: "flex flex-wrap gap-1",
          children: allowedDomains.map((domain) => /* @__PURE__ */ jsx(Chip$1, {
            label: domain,
            onDelete: () => handleDomainRemove(domain),
            size: "small",
            color: "primary",
            variant: "outlined"
          }, domain))
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex gap-2 items-center pt-2",
        children: /* @__PURE__ */ jsx(LoadingButton, {
          loading,
          onClick: onSave,
          children: "Save Access Settings"
        })
      })]
    }), showGrantSection && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
        className: "mt-8",
        children: [/* @__PURE__ */ jsx(Typography, {
          variant: "h6",
          component: "h3",
          children: "Grant Access (Offline Payment)"
        }), /* @__PURE__ */ jsx(Typography, {
          variant: "body2",
          className: "mt-1 mb-4 text-gray-500",
          children: "Manually grant access to users who paid offline (cash, bank transfer, etc)."
        }), grantError && /* @__PURE__ */ jsx(ErrorBox, {
          messages: [grantError],
          onClose: function() {
            setGrantError("");
          }
        }), /* @__PURE__ */ jsxs("div", {
          className: "mb-4",
          children: [/* @__PURE__ */ jsx(TextField$1, {
            label: "Search User",
            placeholder: "Search by name, email, or username...",
            value: searchQuery,
            onChange: function(e) {
              setSearchQuery(e.target.value);
              setSelectedUser(null);
            },
            fullWidth: true,
            margin: "normal",
            helperText: selectedUser ? "Selected: " + (selectedUser.firstname || "") + " " + (selectedUser.lastname || "") + " (" + selectedUser.email + ")" : "Type at least 2 characters to search."
          }), searchQuery.length >= 2 && !selectedUser && /* @__PURE__ */ jsxs("div", {
            className: "border rounded bg-white max-h-[200px] overflow-y-auto",
            style: {
              border: "1px solid #ddd"
            },
            children: [searchingUsers && /* @__PURE__ */ jsxs("div", {
              className: "p-3 text-center",
              children: [/* @__PURE__ */ jsx(CircularProgress, {
                size: 20
              }), /* @__PURE__ */ jsx("span", {
                className: "ml-2 text-sm text-gray-500",
                children: "Searching..."
              })]
            }), !searchingUsers && searchResults.length === 0 && /* @__PURE__ */ jsx("div", {
              className: "p-3 text-center text-sm text-gray-500",
              children: "No users found"
            }), searchResults.map(function(user) {
              return /* @__PURE__ */ jsxs("div", {
                className: "px-3 py-2 cursor-pointer hover:bg-gray-100 flex justify-between items-center",
                onClick: function() {
                  setSelectedUser(user);
                  setSearchQuery(user.email);
                  setSearchResults([]);
                },
                children: [/* @__PURE__ */ jsxs("div", {
                  children: [/* @__PURE__ */ jsx("div", {
                    className: "text-sm font-medium",
                    children: (user.firstname || "") + " " + (user.lastname || "")
                  }), /* @__PURE__ */ jsx("div", {
                    className: "text-xs text-gray-500",
                    children: user.email
                  })]
                }), /* @__PURE__ */ jsxs("div", {
                  className: "text-xs text-gray-400",
                  children: ["@", user.username]
                })]
              }, user._id);
            })]
          })]
        }), selectedUser && /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-4 mb-4",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex gap-4",
            children: [/* @__PURE__ */ jsxs(FormControl$1, {
              style: {
                minWidth: 160
              },
              margin: "normal",
              children: [/* @__PURE__ */ jsx(InputLabel, {
                children: "Payment Method"
              }), /* @__PURE__ */ jsx(Select$1, {
                value: grantType,
                onChange: function(e) {
                  setGrantType(e.target.value);
                },
                children: Object.keys(GRANT_TYPE_LABELS).map(function(key) {
                  return /* @__PURE__ */ jsx(MenuItem, {
                    value: key,
                    children: GRANT_TYPE_LABELS[key]
                  }, key);
                })
              })]
            }), /* @__PURE__ */ jsx(TextField$1, {
              label: "Amount Paid (USD)",
              type: "number",
              value: grantAmount,
              onChange: function(e) {
                setGrantAmount(e.target.value);
              },
              margin: "normal",
              inputProps: {
                min: 0,
                step: 0.01
              },
              helperText: "0 for courtesy/free grants",
              style: {
                width: 180
              }
            })]
          }), /* @__PURE__ */ jsx(TextField$1, {
            label: "Note (optional)",
            value: grantNote,
            onChange: function(e) {
              setGrantNote(e.target.value);
            },
            fullWidth: true,
            margin: "normal",
            placeholder: "e.g. Paid cash at office, receipt #123",
            helperText: "Add any reference or notes about this offline payment."
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex gap-2 items-center",
            children: [/* @__PURE__ */ jsx(LoadingButton, {
              loading: grantingAccess,
              onClick: handleGrantAccess,
              children: "Grant Access"
            }), /* @__PURE__ */ jsx("button", {
              type: "button",
              onClick: function() {
                setSelectedUser(null);
                setSearchQuery("");
                setGrantAmount("");
                setGrantNote("");
                setGrantError("");
              },
              className: "px-4 py-2 text-gray-600 hover:text-gray-800",
              children: "Cancel"
            })]
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: "mt-6",
          children: [/* @__PURE__ */ jsx(Typography, {
            variant: "subtitle1",
            component: "h4",
            className: "mb-2",
            children: "Users with Access"
          }), loadingGrants && /* @__PURE__ */ jsx("div", {
            className: "py-4 text-center",
            children: /* @__PURE__ */ jsx(CircularProgress, {
              size: 24
            })
          }), !loadingGrants && grantedUsers.length === 0 && /* @__PURE__ */ jsx(Typography, {
            variant: "body2",
            className: "text-gray-500 py-4",
            children: "No users have been granted access yet."
          }), !loadingGrants && grantedUsers.length > 0 && /* @__PURE__ */ jsxs(Table, {
            size: "small",
            children: [/* @__PURE__ */ jsx(TableHead, {
              children: /* @__PURE__ */ jsxs(TableRow, {
                children: [/* @__PURE__ */ jsx(TableCell, {
                  children: "User"
                }), /* @__PURE__ */ jsx(TableCell, {
                  children: "Type"
                }), /* @__PURE__ */ jsx(TableCell, {
                  children: "Amount"
                }), /* @__PURE__ */ jsx(TableCell, {
                  children: "Note"
                }), /* @__PURE__ */ jsx(TableCell, {
                  children: "Date"
                }), /* @__PURE__ */ jsx(TableCell, {
                  style: {
                    width: 48
                  }
                })]
              })
            }), /* @__PURE__ */ jsx(TableBody, {
              children: grantedUsers.map(function(grant) {
                var isAdminGrant = grant.grantType != null;
                return /* @__PURE__ */ jsxs(TableRow, {
                  children: [/* @__PURE__ */ jsxs(TableCell, {
                    children: [/* @__PURE__ */ jsx("div", {
                      className: "text-sm font-medium",
                      children: grant.userName
                    }), /* @__PURE__ */ jsx("div", {
                      className: "text-xs text-gray-500",
                      children: grant.userEmail
                    })]
                  }), /* @__PURE__ */ jsx(TableCell, {
                    children: /* @__PURE__ */ jsx(Chip$1, {
                      label: grant.grantType ? GRANT_TYPE_LABELS[grant.grantType] || grant.grantType : "Stripe",
                      size: "small",
                      color: isAdminGrant ? "default" : "primary",
                      variant: "outlined"
                    })
                  }), /* @__PURE__ */ jsx(TableCell, {
                    children: "$" + (grant.amount / 100).toFixed(2)
                  }), /* @__PURE__ */ jsx(TableCell, {
                    children: /* @__PURE__ */ jsx("span", {
                      className: "text-sm text-gray-500",
                      children: grant.note || "\u2014"
                    })
                  }), /* @__PURE__ */ jsx(TableCell, {
                    children: /* @__PURE__ */ jsx("span", {
                      className: "text-sm text-gray-500",
                      children: new Date(grant.purchasedAt).toLocaleDateString()
                    })
                  }), /* @__PURE__ */ jsx(TableCell, {
                    children: isAdminGrant && /* @__PURE__ */ jsx(IconButton$5, {
                      size: "small",
                      onClick: function() {
                        handleRevokeAccess(grant.purchaseId);
                      },
                      title: "Revoke access",
                      children: /* @__PURE__ */ jsx(MdDelete, {
                        size: 18,
                        color: "#ef4444"
                      })
                    })
                  })]
                }, grant.purchaseId);
              })
            })]
          })]
        })]
      })]
    })]
  });
};

const PostBreadcrumbView = ({
  post
}) => {
  if (!post) {
    return null;
  }
  const circle = post.group && post.group.group;
  const circleId = circle && circle._id;
  const title = post.metadata && post.metadata.title || post.title || "Untitled Post";
  return /* @__PURE__ */ jsx(CircleBreadcrumbView, {
    circleId,
    circle,
    current: /* @__PURE__ */ jsx(Link$2, {
      to: url4post(post),
      className: "underline",
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: title.slice(0, 50)
      })
    })
  });
};

const PostMetadataBreadcrumb = () => {
  const {
    data
  } = usePostMetadataCtx();
  return /* @__PURE__ */ jsx(PostBreadcrumbView, {
    post: data && data.post
  });
};

const PricingTab = () => {
  const {
    data
  } = usePostMetadataCtx();
  if (!data || !data.post)
    return null;
  const post = data.post;
  const group = post.group && post.group.group;
  if (!group)
    return null;
  return /* @__PURE__ */ jsx(BookPricingSection, {
    postId: post._id,
    circleId: group._id,
    initialAccessType: post.accessType || void 0,
    initialPrice: post.price,
    initialAllowedDomains: post.allowedDomains || [],
    initialSubscriptionMonthlyPrice: group.subscriptionMonthlyPrice,
    initialSubscriptionYearlyPrice: group.subscriptionYearlyPrice
  });
};
const defaultSections = [{
  tab: "core",
  label: "General",
  labelId: "meta.tab.core",
  fields: metadataFields
}, {
  tab: "pricing",
  label: "Pricing & Access",
  labelId: "meta.tab.pricing",
  component: PricingTab
}];
const PostMetadata = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const postId = path[2];
  return /* @__PURE__ */ jsx(NsPageShell, {
    children: /* @__PURE__ */ jsx("div", {
      className: "p-6 max-w-4xl mx-auto",
      children: /* @__PURE__ */ jsxs(PostMetadataProvider, {
        postId,
        sections: defaultSections,
        children: [/* @__PURE__ */ jsx(PostMetadataBreadcrumb, {}), /* @__PURE__ */ jsx(MetadataEditorShell, {})]
      })
    })
  });
};

const loadPostSimple = async (api, postId, options = { language: "" }) => {
  try {
    return await withRetry(() => loadPage(api, postId, options));
  } catch (error) {
    console.error(`Failed to load post ${postId}:`, error);
    return null;
  }
};

const getPageCacheKey = (pageId, language) => [`/post-view/${pageId}`, language];
const useLoadPageSimple = (pageId) => {
  const api = useApi();
  const language = "";
  const { data, error, isValidating: isLoading, mutate } = useSWR(pageId ? getPageCacheKey(pageId, language) : null, async () => {
    return loadPostSimple(api, pageId, { language });
  }, {
    ...swrLoadOnce
  });
  const reload = useMemoizedFn(async () => {
    await mutate();
  });
  return {
    page: data || null,
    isLoading,
    error,
    reload
  };
};
const updatePostViewCache = (post, language = "") => mutate(getPageCacheKey(post._id, language), post, false);

const PaginatedEditor = ({}) => {
  const api = useApi();
  const {
    draft,
    ui,
    update
  } = useEditPostContext();
  const {
    addToast
  } = useToast();
  const [currentPageIndex1, setCurrentPageIndex] = useState(0);
  const totalPages = draft && draft.pages && draft.pages.length || 0;
  const currentPageIndex = currentPageIndex1 < totalPages ? currentPageIndex1 : currentPageIndex1 > 0 ? currentPageIndex1 - 1 : 0;
  const changeCurrentPageIndex = useMemoizedFn(async (id) => {
    try {
      await ui.onSave();
      setCurrentPageIndex(id);
    } catch (e) {
      console.error(e);
    }
  });
  const {
    execute: handleSave,
    isLoading: isSaving
  } = useAsyncOperation(async () => {
    await ui.onSave();
    addToast({
      type: "success",
      title: "Success",
      message: `Page ${currentPageIndex + 1} saved successfully`,
      duration: 3e3
    });
  }, {
    showErrorToast: true,
    errorTitle: "Save Failed",
    onError: (error) => {
      console.error("Failed to save:", error);
    }
  });
  const handleDropPage = useMemoizedFn(async () => {
    const post = ui.currentPost.current;
    if (!post) {
      throw new Error("No post was selected yet!");
    }
    const {
      _id,
      pages
    } = draft;
    const draftUpdate = {
      _id,
      pages: pages.filter((_, index) => index !== currentPageIndex)
    };
    await withRetry(async () => await api.publish(draftUpdate));
    update(draftUpdate);
    await api.unpublishPost(post);
  });
  const {
    open: openDropConfirmation,
    confirmationProps
  } = useConfirmation({
    onConfirm: handleDropPage,
    title: "Drop Page",
    message: `Are you sure you want to remove page ${currentPageIndex + 1}? This action cannot be undone.`,
    confirmText: "Drop Page",
    cancelText: "Cancel",
    confirmIntent: "danger"
  });
  const {
    execute: handleInsertPage
  } = useAsyncOperation(async () => {
    const post = ui.currentPost.current;
    if (!post) {
      throw new Error("No post was selected yet!");
    }
    ui.setIsBusy(true);
    console.log("Insert page after", currentPageIndex);
    const title = "New page";
    const createdPost = {
      ...post,
      responseTo: post.thread[0],
      content: getContentInfo(title),
      title,
      documentPageNumber: 1,
      features: ["page"]
    };
    ["_id", "name", "draft", "created", "modified"].forEach((n) => delete createdPost[n]);
    const createdDraft = await withRetry(async () => api.upsertDraft(createdPost));
    const created = await withRetry(async () => api.publish(createdDraft));
    const {
      _id,
      pages
    } = draft;
    const draftUpdate = {
      _id,
      pages: pages.flatMap((page, index) => index === currentPageIndex ? [created._id, page] : page)
    };
    await withRetry(async () => await api.publish(draftUpdate));
    update(draftUpdate);
    ui.setIsBusy(false);
  }, {
    onError() {
      ui.setIsBusy(false);
    }
  });
  if (!totalPages) {
    return null;
  }
  const currentPageId = draft.pages[currentPageIndex];
  const pageControls = /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(ActionButton, {
      intent: "white",
      size: "sm",
      onClick: () => ui.setIsMain(true),
      "aria-label": "Main",
      title: "Edit main page",
      children: "Main"
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "white",
      size: "sm",
      onClick: handleSave,
      isLoading: isSaving,
      "aria-label": "Save current page",
      title: "Save current page",
      children: /* @__PURE__ */ jsx(MdSave, {
        className: "w-6 h-6"
      })
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "white",
      size: "sm",
      onClick: openDropConfirmation,
      "aria-label": "Drop current page",
      title: "Drop current page",
      children: /* @__PURE__ */ jsx(MdDelete, {
        className: "w-6 h-6"
      })
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "white",
      size: "sm",
      onClick: handleInsertPage,
      "aria-label": "Insert new page",
      title: "Insert new page after current",
      children: /* @__PURE__ */ jsx(MdAdd, {
        className: "w-6 h-6"
      })
    })]
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "space-y-4",
    children: [/* @__PURE__ */ jsx(PaginationControls, {
      current: currentPageIndex,
      total: totalPages,
      onPageChange: changeCurrentPageIndex,
      additionalControls: pageControls,
      justify: "end"
    }), /* @__PURE__ */ jsx(FindDraftForPage, {
      postId: currentPageId
    }, currentPageId), /* @__PURE__ */ jsx(ConfirmationOverlay, {
      ...confirmationProps
    })]
  });
};
const FindDraftForPage = ({
  postId
}) => {
  const {
    page: post
  } = useLoadPageSimple(postId);
  const {
    ui
  } = useEditPostContext();
  ui.currentPost.current = post;
  if (!post) {
    return null;
  }
  return /* @__PURE__ */ jsx(EditPostWithContext, {
    draftId: post.draft
  }, post.draft);
};

const EditPost = () => {
  const {
    draft,
    ui
  } = useEditPostContext();
  const {
    isMain
  } = ui;
  const hasPages = draft && draft.pages && draft.pages.length > 0;
  if (!draft) {
    return null;
  }
  if (hasPages && !isMain) {
    return /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx(PaginatedEditor, {})
    });
  }
  if (!hasPages) {
    return /* @__PURE__ */ jsx(Editor, {}, draft._id);
  }
  return /* @__PURE__ */ jsx(EditMain, {});
};
const EditMain = () => {
  const {
    draft,
    ui,
    publish
  } = useEditPostContext();
  const {
    editor
  } = ui;
  const {
    execute,
    isLoading: loading
  } = useAsyncOperation(async (post) => {
    ui.setIsBusy(true);
    await publish(post);
    ui.setIsBusy(false);
  }, {
    onError() {
      ui.setIsBusy(false);
    }
  });
  const onSave = useMemoizedFn(async () => {
    if (!editor.isDirty()) {
      return;
    }
    const content = getContentInfo(editor.getContent());
    await withRetry(() => execute({
      content
    }));
    editor.setDirty(false);
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-2",
      children: [/* @__PURE__ */ jsx(ActionButton, {
        intent: "white",
        size: "sm",
        onClick: () => ui.setIsMain(false),
        "aria-label": "Main",
        title: "Edit main page",
        children: "Pages"
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "white",
        size: "sm",
        onClick: onSave,
        isLoading: loading,
        "aria-label": "Save main page",
        title: "Save main page",
        children: /* @__PURE__ */ jsx(MdSave, {
          className: "w-6 h-6"
        })
      })]
    }), /* @__PURE__ */ jsx(Editor, {}, draft._id)]
  });
};
const Editor = () => {
  const context = useEditPostContext();
  const {
    draft,
    publish,
    parent,
    ui
  } = context;
  const {
    editor,
    setEditor,
    setOnSave,
    currentPage,
    images_upload_handler,
    setup_callback
  } = ui;
  currentPage.current = context;
  const {
    execute,
    isLoading: loading
  } = useAsyncOperation(async (post) => {
    ui.setIsBusy(true);
    await publish(post);
    ui.setIsBusy(false);
  }, {
    onError() {
      ui.setIsBusy(false);
    }
  });
  const onSave = useMemoizedFn(async () => {
    if (!editor.isDirty()) {
      return;
    }
    const content = getContentInfo(editor.getContent());
    await withRetry(() => execute({
      content
    }));
    editor.setDirty(false);
  });
  useEffect(() => {
    setOnSave(() => onSave);
    return () => {
      setOnSave(null);
      currentPage.current = null;
    };
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "space-y-4",
      children: /* @__PURE__ */ jsx(TinyEditor, {
        content: draft.content.nsHtml,
        setEditor,
        autoresize: true,
        settings: {
          height: 230,
          auto_focus: "none",
          menubar: false,
          images_upload_handler,
          setup: setup_callback
        }
      })
    }), !parent && /* @__PURE__ */ jsx("div", {
      className: "w-full flex gap-2",
      children: /* @__PURE__ */ jsx(LoadingButtonTW, {
        onClick: onSave,
        loading,
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "event.save"
        })
      })
    })]
  });
};

const EditPostWithContext = ({
  draftId,
  before: Before,
  ui
}) => {
  return /* @__PURE__ */ jsxs(EditPostContextProvider, {
    draftId,
    ui,
    children: [Before && /* @__PURE__ */ jsx(Before, {}), /* @__PURE__ */ jsx(EditPost, {})]
  });
};

const getPostUrl = (draftId) => `drafts/${draftId}/post`;
const useLoadPostByDraft = (draftId, options) => {
  const api = useApi();
  const {
    data: post,
    error,
    isValidating: isLoading,
    mutate
  } = useSWR(draftId ? getPostUrl(draftId) : null, () => api.loadPostByDraft(draftId), {
    ...swrLoadOnce,
    ...options
  });
  return {
    post,
    error,
    isLoading,
    mutate,
    isError: !!error
  };
};

const EditPostPage = () => {
  const location = useLocation();
  const [isBusy, setIsBusy] = useState(false);
  const [isMain, setIsMain] = useState(false);
  const {
    editor,
    setEditor,
    images_upload_handler,
    setup_callback
  } = useTinyEditorSetup$1();
  const [onSave, setOnSave] = useState();
  const currentPage = useRef();
  const currentPost = useRef();
  const all = location.pathname.split("/").filter((v) => v);
  const draftId = all[all.length - 1];
  const ui = {
    isBusy,
    setIsBusy,
    editor,
    setEditor,
    onSave,
    setOnSave,
    currentPage,
    currentPost,
    images_upload_handler,
    setup_callback,
    isMain,
    setIsMain
  };
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsxs("div", {
      className: clsx("ns sm:px-[54px] text-base w-full pb-4 min-h-screen"),
      "data-testid": "EditPostPage",
      children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx(LoadingOverlay, {
        isOpen: isBusy,
        message: "Saving post..."
      }), /* @__PURE__ */ jsx("div", {
        className: "flex w-full flex-col gap-2 p-2",
        children: /* @__PURE__ */ jsx(EditPostWithContext, {
          ui,
          draftId,
          before: EditPosHeader
        })
      })]
    })]
  });
};
const EditPosHeader = () => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PostNavigation, {}), /* @__PURE__ */ jsx(PostTextBreadCrumbs, {
      panel: /* @__PURE__ */ jsx(ViewPage, {})
    })]
  });
};
const ViewPage = () => {
  const {
    post: draft
  } = usePostInfoContext();
  const {
    post
  } = useLoadPostByDraft(draft && draft._id);
  return /* @__PURE__ */ jsx("a", {
    href: url4post(post),
    children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
      className: "cursor-pointer underline",
      children: "Post View"
    })
  });
};

const postItemVariants = cva("flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors", {
  variants: {
    selected: {
      true: "bg-blue-50 border-blue-300 border",
      false: "bg-white hover:bg-gray-50 border border-gray-200"
    }
  },
  defaultVariants: {
    selected: false
  }
});
const PostSelector = ({
  posts,
  selectedPostIds,
  onSelectionChange,
  isLoading
}) => {
  const togglePost = useMemoizedFn((postId) => {
    const isSelected = selectedPostIds.includes(postId);
    if (isSelected) {
      onSelectionChange(selectedPostIds.filter((id) => id !== postId));
    } else {
      onSelectionChange([...selectedPostIds, postId]);
    }
  });
  const selectAll = useMemoizedFn(() => {
    const allIds = posts.map((p) => p._id);
    onSelectionChange(allIds);
  });
  const clearSelection = useMemoizedFn(() => {
    onSelectionChange([]);
  });
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: "flex justify-center items-center h-32",
      children: /* @__PURE__ */ jsx(Spinner, {})
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex justify-between items-center mb-4 p-2",
      children: [/* @__PURE__ */ jsxs("span", {
        className: "text-sm text-gray-600",
        children: [selectedPostIds.length, " of ", posts.length, " selected"]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2",
        children: [/* @__PURE__ */ jsx("button", {
          onClick: selectAll,
          className: "px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded",
          children: "Select All"
        }), /* @__PURE__ */ jsx("button", {
          onClick: clearSelection,
          className: "px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded",
          children: "Clear"
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "space-y-2 overflow-y-auto flex-grow",
      children: posts.map((post) => {
        const isSelected = selectedPostIds.includes(post._id);
        return /* @__PURE__ */ jsxs("div", {
          onClick: () => togglePost(post._id),
          className: postItemVariants({
            selected: isSelected
          }),
          children: [isSelected ? /* @__PURE__ */ jsx(MdCheckBox, {
            className: "text-blue-500 text-xl flex-shrink-0"
          }) : /* @__PURE__ */ jsx(MdCheckBoxOutlineBlank, {
            className: "text-gray-400 text-xl flex-shrink-0"
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex-grow min-w-0",
            children: [/* @__PURE__ */ jsx("h4", {
              className: "font-medium text-gray-900 truncate",
              children: post.title || "Untitled Post"
            }), post.type && /* @__PURE__ */ jsxs("span", {
              className: "text-xs text-gray-500",
              children: ["Type: ", post.type]
            }), /* @__PURE__ */ jsx(PostMetadataFields, {
              post
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-2 flex-shrink-0",
            onClick: (event) => event.stopPropagation(),
            children: [/* @__PURE__ */ jsx("a", {
              href: url4post(post),
              target: "_blank",
              rel: "noopener noreferrer",
              title: "View post",
              className: "text-gray-500 hover:text-blue-600",
              children: /* @__PURE__ */ jsx(HiExternalLink, {})
            }), /* @__PURE__ */ jsx("a", {
              href: editMetadataUrl(post),
              target: "_blank",
              rel: "noopener noreferrer",
              title: "Edit metadata",
              className: "text-gray-500 hover:text-blue-600",
              children: /* @__PURE__ */ jsx(HiTag, {})
            })]
          })]
        }, post._id);
      })
    })]
  });
};

const DEFAULT_OPTIONS = {
  maxTextSizePerPage: 3e3
};
const extractPagesFromHtml = (htmlContent, options = DEFAULT_OPTIONS) => {
  if (!htmlContent)
    return [];
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const pageElements = doc.querySelectorAll(".pdf-page");
  if (pageElements.length > 0) {
    return extractFromPdfPages(pageElements);
  }
  return extractFromTopLevelElements(doc.body, options);
};
const extractFromPdfPages = (pageElements) => {
  const pages = [];
  pageElements.forEach((pageElement) => {
    const pageHtml = pageElement.innerHTML;
    const textElement = pageElement.querySelector(".pdf-page-text");
    const text = textElement && textElement.textContent ? textElement.textContent.trim() : void 0;
    pages.push({
      html: pageHtml,
      text
    });
  });
  return pages;
};
const extractFromTopLevelElements = (body, options) => {
  const pages = [];
  const rootElements = getEffectiveRootElements(body);
  if (rootElements.length === 0) {
    return [];
  }
  let currentPageHtml = "";
  let currentPageText = "";
  const maxSize = options.maxTextSizePerPage || DEFAULT_OPTIONS.maxTextSizePerPage;
  rootElements.forEach((element, index) => {
    const elementHtml = element.outerHTML;
    const elementText = (element.textContent || "").trim();
    if (currentPageText.length > 0 && currentPageText.length + elementText.length > maxSize) {
      pages.push({
        html: currentPageHtml,
        text: currentPageText
      });
      currentPageHtml = elementHtml;
      currentPageText = elementText;
    } else {
      currentPageHtml += elementHtml;
      currentPageText += " " + elementText;
    }
    if (index === rootElements.length - 1) {
      pages.push({
        html: currentPageHtml,
        text: currentPageText.trim()
      });
    }
  });
  return pages;
};
const getEffectiveRootElements = (body) => {
  let currentRoot = body;
  while (currentRoot.children.length === 1) {
    const singleChild = currentRoot.children[0];
    const wrapperTags = ["DIV", "SECTION", "ARTICLE", "MAIN"];
    if (wrapperTags.includes(singleChild.tagName)) {
      if (singleChild.children.length > 0) {
        currentRoot = singleChild;
        continue;
      }
    }
    break;
  }
  const meaningfulElements = [];
  Array.from(currentRoot.children).forEach((child) => {
    const element = child;
    const textContent = (element.textContent || "").trim();
    if (textContent.length === 0) {
      return;
    }
    if (["SCRIPT", "STYLE"].includes(element.tagName)) {
      return;
    }
    meaningfulElements.push(element);
  });
  return meaningfulElements;
};
const getPageCount = (htmlContent, options) => {
  return extractPagesFromHtml(htmlContent, options).length;
};

const createPagePosts = async (api, mainPost, extractedPages, onProgress) => {
  const pageIds = [];
  const rootId = mainPost._id;
  const totalPages = extractedPages.length;
  let currentPage = 0;
  for (const page of extractedPages) {
    currentPage++;
    if (onProgress) {
      onProgress({
        currentPage,
        totalPages
      });
    }
    const content = getContentInfo(page.html);
    const pagePost = {
      ...mainPost,
      responseTo: rootId,
      content,
      title: content.nsTitle,
      documentPageNumber: 1,
      features: ["page"]
    };
    const {
      published
    } = await copyAndPublish(api, pagePost);
    pageIds.push(published._id);
  }
  return {
    pageIds
  };
};
const copyAndPublish = async (api, post) => {
  const fieldsToDelete = ["_id", "name", "draft", "created", "modified", "pages"];
  fieldsToDelete.forEach((field) => delete post[field]);
  const draft = await withRetry(() => api.upsertDraft(post));
  const published = await withRetry(() => api.publish(draft));
  return {
    draft,
    published
  };
};
const updatePost = async (api, update, _id) => {
  const draft = await withRetry(() => api.upsertDraft({
    _id,
    ...update
  }));
  const published = await withRetry(() => api.publish(draft));
  return {
    draft,
    published
  };
};
const createMainPost = async (api, mainPost) => {
  const content = getContentInfo("");
  const pagePost = {
    ...mainPost,
    content
  };
  return await copyAndPublish(api, pagePost);
};

const extractPagesFromPost = async (api, post) => {
  if (post.pages && post.pages.length > 0) {
    const pagePosts = [];
    for (const pageId of post.pages) {
      const page = await loadPage(api, pageId, { language: "" });
      pagePosts.push(page);
    }
    return pagePosts.filter((p) => p && p.content && p.content.nsHtml).map((p, index) => ({
      html: p.content.nsHtml,
      pageNumber: index + 1
    }));
  }
  if (post.content && post.content.nsHtml) {
    return extractPagesFromHtml(post.content.nsHtml);
  }
  return [];
};

const useCreateMultiPagePost = ({ page, group, onProgress }) => {
  const api = useApi();
  const { execute: handleCreatePost, isLoading: isCreating } = useAsyncOperation(useMemoizedFn(async () => {
    if (!page || (!page.pages || !page.pages.length) && (!page.content || !page.content.nsHtml)) {
      console.log("No HTML content to extract pages from");
      return;
    }
    const extractedPages = await extractPagesFromPost(api, page);
    if (extractedPages.length === 0) {
      console.log("No pages found to extract");
      return;
    }
    const templatePost = {
      ...page,
      group: {
        group
      },
      features: ["book"]
    };
    const { published: mainPost, draft: mainDraft } = await createMainPost(api, templatePost);
    const { pageIds } = await createPagePosts(api, mainPost, extractedPages, onProgress);
    await updatePost(api, {
      _id: mainDraft._id,
      pages: pageIds
    });
    console.log(`Created ${pageIds.length} page posts`);
    return { mainPost, mainDraft };
  }));
  return {
    handleCreatePost,
    isCreating
  };
};

const useAddPagesToPost = (sourcePost, targetPost, onProgress) => {
  const api = useApi();
  const { execute: handleAddPages, isLoading: isAdding } = useAsyncOperation(useMemoizedFn(async () => {
    if (!sourcePost || !targetPost) {
      throw new Error("Source or target post missing");
    }
    const extractedPages = await extractPagesFromPost(api, sourcePost);
    if (extractedPages.length === 0) {
      throw new Error("No pages found to extract");
    }
    const { pageIds } = await createPagePosts(api, targetPost, extractedPages, onProgress);
    const existingPageIds = targetPost.pages || [];
    const allPageIds = [...existingPageIds, ...pageIds];
    const { draft, published } = await updatePost(api, {
      pages: allPageIds
    }, targetPost.draft);
    console.log(`Added ${pageIds.length} pages to existing post`);
    updatePostViewCache(published);
    return {
      updatedPost: published,
      updatedDraft: draft,
      addedPageCount: pageIds.length
    };
  }));
  return {
    handleAddPages,
    isAdding
  };
};

const noop = () => null;
const PostOperationsContext = React__default.createContext({
  group: null,
  setGroup: noop
});
const usePostOperationsContext = () => {
  return React__default.useContext(PostOperationsContext);
};

const SelectedPostItem = ({
  postId,
  targetPost,
  onSetTargetPost,
  onPostCreated
}) => {
  const {
    group
  } = usePostOperationsContext();
  const {
    page,
    isLoading
  } = useLoadPageSimple(postId);
  const [createdPostId, setCreatedPostId] = useState();
  const {
    handleCreatePost,
    isCreating
  } = useCreateMultiPagePost({
    page,
    group
  });
  const {
    handleAddPages: handleAddPagesRaw,
    isAdding
  } = useAddPagesToPost(page, targetPost);
  const handleAddPages = async () => {
    const {
      updatedPost
    } = await handleAddPagesRaw();
    onSetTargetPost(updatedPost);
  };
  const isTarget = targetPost && targetPost._id === postId;
  const hasPages = page && page.pages && page.pages.length > 0;
  useEffect(() => {
    if (!targetPost && hasPages) {
      onSetTargetPost((v) => v ? v : page);
    }
  }, [hasPages, targetPost]);
  const handleCreate = async () => {
    const result = await handleCreatePost();
    if (result && result.mainPost) {
      setCreatedPostId(result.mainPost._id);
      if (onPostCreated) {
        onPostCreated(result.mainPost._id);
      }
    }
  };
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-4 border rounded bg-gray-50",
      children: "Loading..."
    });
  }
  if (!page)
    return null;
  let pageCount = 0;
  if (hasPages) {
    pageCount = page.pages.length;
  } else if (page.content && page.content.nsHtml) {
    pageCount = getPageCount(page.content.nsHtml);
  }
  return /* @__PURE__ */ jsxs("div", {
    className: `p-4 border rounded bg-white ${isTarget ? "ring-2 ring-blue-500 border-blue-500" : ""}`,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center gap-2",
        children: [/* @__PURE__ */ jsx("h4", {
          className: "font-medium underline",
          children: /* @__PURE__ */ jsx("a", {
            href: url4post(page),
            children: page.title || "Untitled"
          })
        }), isTarget && /* @__PURE__ */ jsx("span", {
          className: "text-xs bg-blue-500 text-white px-2 py-1 rounded",
          children: "TARGET"
        })]
      }), pageCount > 0 && /* @__PURE__ */ jsxs("span", {
        className: "text-sm text-gray-600",
        children: [pageCount, " ", pageCount === 1 ? "page" : "pages"]
      })]
    }), (hasPages || pageCount > 0) && /* @__PURE__ */ jsxs("div", {
      className: "mt-3 flex justify-start gap-2 items-center",
      children: [hasPages && /* @__PURE__ */ jsx(LoadingButtonTW, {
        onClick: () => onSetTargetPost(page),
        size: "sm",
        background: "whiteOutline",
        disabled: isTarget,
        children: isTarget ? "Current Target" : "Set as Target"
      }), /* @__PURE__ */ jsx(LoadingButtonTW, {
        onClick: handleCreate,
        loading: isCreating,
        size: "sm",
        background: "whiteOutline",
        children: hasPages ? "Duplicate post" : "Create Post"
      }), /* @__PURE__ */ jsx(LoadingButtonTW, {
        onClick: handleAddPages,
        loading: isAdding,
        size: "sm",
        background: "whiteOutline",
        disabled: isTarget || !targetPost,
        children: "Append to target"
      }), createdPostId && /* @__PURE__ */ jsx("a", {
        href: `/trans/post-view/${createdPostId}`,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "flex items-center gap-1 text-blue-500 hover:text-blue-700 transition-colors",
        title: "View created post",
        children: /* @__PURE__ */ jsx(MdOpenInNew, {
          className: "w-4 h-4"
        })
      })]
    })]
  });
};

const TranslateBatchPanel = ({
  postIds,
  onBack
}) => {
  const translate = useTranslationTask();
  const state = useTranslateInitialState(postIds[0]);
  const complete = translate.complete;
  const finalTranslation = complete && complete.finalTranslation;
  const isTranslating = translate.isCreatingTask || translate.isConnected;
  const lastRetry = translate.messages.find((m) => m.event === "retry");
  const retryDetails = lastRetry && lastRetry.data && lastRetry.data.details;
  const currentDetails = translate.current && translate.current.details;
  const progressDetails = translate.progress && translate.progress.details;
  const liveCounts = progressDetails && progressDetails.counts;
  const finalCounts = complete && {
    translated: complete.translatedCount,
    skipped: complete.skippedCount
  };
  const displayCounts = finalCounts ? finalCounts : liveCounts;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex justify-between items-center",
        children: [/* @__PURE__ */ jsxs("h2", {
          className: "text-xl font-semibold",
          children: ["Translate ", postIds.length, " Selected Posts"]
        }), /* @__PURE__ */ jsx("button", {
          onClick: onBack,
          className: "px-4 py-2 text-gray-600 hover:text-gray-800",
          children: "Back to Selection"
        })]
      }), /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-gray-600",
        children: ["Posts: ", postIds.join(", ")]
      }), translate.taskExecutionId && /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-gray-500",
        children: ["Task ID: ", translate.taskExecutionId]
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(TranslateSimpleForm, {
      state: state.state,
      onUpdate: state.updateState,
      disabled: isTranslating
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(LoadingButtonTW, {
      loading: translate.isCreatingTask || translate.isConnected,
      onClick: () => translate.startTranslation({
        input: {
          postId: postIds
        },
        config: state.state
      }),
      disabled: translate.isCreatingTask || translate.isConnected,
      background: "green",
      children: translate.isCreatingTask ? "Creating Task..." : "Translate All Posts"
    }), translate.error && /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx("h3", {
        className: "text-sm font-medium text-red-700 mb-2",
        children: "Translation Error:"
      }), /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: translate.error
      })]
    }), displayCounts && /* @__PURE__ */ jsxs("div", {
      className: "text-sm text-gray-600",
      children: ["Translated ", displayCounts.translated, " \xB7 Skipped ", displayCounts.skipped]
    }), !translate.isComplete && currentDetails && /* @__PURE__ */ jsxs("div", {
      className: "text-sm text-gray-600 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2",
      children: ["Currently translating: ", /* @__PURE__ */ jsx("span", {
        className: "font-medium",
        children: currentDetails.postTitle
      }), " ", "\u2014 page ", currentDetails.pageIndex, " of ", currentDetails.totalPages, " ", "(post ", currentDetails.postIndex, " of ", currentDetails.totalPosts, ")"]
    }), !translate.isComplete && retryDetails && /* @__PURE__ */ jsxs("div", {
      className: "text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2",
      children: ["Retrying page ", retryDetails.pageIndex, " of ", retryDetails.totalPages, ' in "', retryDetails.postTitle, '"', " ", "(attempt ", retryDetails.attempt, "/", retryDetails.maxRetries, "): ", retryDetails.message]
    }), /* @__PURE__ */ jsx(SSEProgressPanel, {
      messages: translate.messages,
      isConnected: translate.isConnected,
      isComplete: translate.isComplete,
      error: translate.error,
      variant: "default"
    }), /* @__PURE__ */ jsx(SSEExecutionSection, {
      title: "Translation Details",
      messages: translate.messages,
      isConnected: translate.isConnected,
      isComplete: translate.isComplete,
      error: translate.error,
      onClear: translate.clear,
      defaultCollapsed: true,
      emptyMessage: "No translation messages yet",
      showProgress: true
    }), translate.isComplete && finalTranslation && /* @__PURE__ */ jsx(FinalTranslationSection, {
      finalTranslation
    })]
  });
};

const MAX_MESSAGES$1 = 30;
const useDuplicateTask = () => {
  const api = useApi();
  const jwt = useJwt();
  const [taskExecutionId, setTaskExecutionId] = useState("");
  const [messages, setMessages] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [complete, setComplete] = useState();
  const [sseError, setSseError] = useState("");
  const addMessage = useMemoizedFn((event, data) => {
    setMessages((prev) => {
      const next = {
        id: Date.now().toString() + Math.random(),
        event,
        timestamp: new Date(),
        data
      };
      return [next, ...prev].slice(0, MAX_MESSAGES$1);
    });
  });
  const { execute: createTask, isLoading: isCreatingTask, error: createError } = useAsyncOperation(async (input) => {
    setIsComplete(false);
    setComplete(void 0);
    setMessages([]);
    setSseError("");
    const result = await api.post({
      path: "/tasks/create",
      body: { input }
    });
    setTaskExecutionId(result.executionId);
  });
  const url = taskExecutionId ? api.buildUrl("/posts/actions/duplicate", { token: jwt, executionId: taskExecutionId }) : "";
  const { isConnected } = useSSEConnection({ url, enabled: url !== "" }, [
    {
      event: "progress",
      handler: (data) => addMessage("progress", data)
    },
    {
      event: "complete",
      handler: (data) => {
        addMessage("complete", data);
        setComplete(data);
        setIsComplete(true);
        setTaskExecutionId("");
      }
    },
    {
      event: "failed",
      handler: (data) => {
        addMessage("failed", data);
        const message = data && data.message ? data.message : "Duplication failed";
        setSseError(message);
        setTaskExecutionId("");
      }
    }
  ]);
  const startDuplicate = useMemoizedFn((input) => {
    createTask(input);
  });
  const clear = useMemoizedFn(() => {
    setMessages([]);
    setIsComplete(false);
    setComplete(void 0);
    setSseError("");
  });
  return {
    startDuplicate,
    isCreatingTask,
    isConnected,
    taskExecutionId,
    messages,
    isComplete,
    complete,
    error: createError || sseError || void 0,
    clear
  };
};

const DuplicateCirclePanel = ({
  postIds,
  onBack
}) => {
  const {
    group,
    setGroup
  } = usePostOperationsContext();
  const [unpublishSourceAfter, setUnpublishSourceAfter] = useState(false);
  const duplicate = useDuplicateTask();
  const isBusy = duplicate.isCreatingTask || duplicate.isConnected;
  const runDuplicate = useMemoizedFn(() => {
    duplicate.startDuplicate({
      postId: postIds,
      targetCircleId: group,
      unpublishSourceAfter
    });
  });
  const {
    open: confirmMove,
    confirmationProps
  } = useConfirmation({
    onConfirm: runDuplicate,
    title: "Move posts to another circle",
    message: `This copies ${postIds.length} post(s) to the selected circle, then unpublishes the ${postIds.length} original post(s). Old links will redirect to the copies. This cannot be undone.`,
    confirmText: "Move posts",
    cancelText: "Cancel",
    confirmIntent: "danger"
  });
  const onSubmit = useMemoizedFn(() => {
    if (unpublishSourceAfter) {
      confirmMove();
    } else {
      runDuplicate();
    }
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex justify-between items-center",
        children: [/* @__PURE__ */ jsxs("h2", {
          className: "text-xl font-semibold",
          children: [unpublishSourceAfter ? "Move" : "Copy", " ", postIds.length, " Selected Posts"]
        }), /* @__PURE__ */ jsx("button", {
          onClick: onBack,
          className: "px-4 py-2 text-gray-600 hover:text-gray-800",
          children: "Back to Selection"
        })]
      }), /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-gray-600",
        children: ["Posts: ", postIds.join(", ")]
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(SelectMyCircle, {
      groupId: group,
      changeGroup: (_id, circle) => setGroup(_id),
      title: "Select a destination Circle"
    }), /* @__PURE__ */ jsx(Checkbox, {
      checked: unpublishSourceAfter,
      onChange: (event) => setUnpublishSourceAfter(event.target.checked),
      label: "Unpublish the original posts after copying (move instead of copy)",
      disabled: isBusy
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(LoadingButtonTW, {
      loading: isBusy,
      onClick: onSubmit,
      disabled: isBusy || !group,
      background: "blue",
      children: duplicate.isCreatingTask ? "Creating Task..." : unpublishSourceAfter ? "Move Posts" : "Copy Posts"
    }), duplicate.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: duplicate.error,
      variant: "compact"
    }), /* @__PURE__ */ jsx(SSEProgressPanel, {
      messages: duplicate.messages,
      isConnected: duplicate.isConnected,
      isComplete: duplicate.isComplete,
      error: duplicate.error,
      variant: "default"
    }), /* @__PURE__ */ jsx(SSEExecutionSection, {
      title: unpublishSourceAfter ? "Move Details" : "Copy Details",
      messages: duplicate.messages,
      isConnected: duplicate.isConnected,
      isComplete: duplicate.isComplete,
      error: duplicate.error,
      onClear: duplicate.clear,
      defaultCollapsed: true,
      emptyMessage: "No messages yet",
      showProgress: true
    }), /* @__PURE__ */ jsx(ConfirmationOverlay, {
      ...confirmationProps
    })]
  });
};

const useBulkUnpublish = () => {
  const api = useApi();
  const [isRunning, setIsRunning] = useState(false);
  const [processed, setProcessed] = useState(0);
  const [total, setTotal] = useState(0);
  const [succeeded, setSucceeded] = useState([]);
  const [skipped, setSkipped] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const run = useMemoizedFn(async (postIds) => {
    setIsRunning(true);
    setIsComplete(false);
    setProcessed(0);
    setTotal(postIds.length);
    setSucceeded([]);
    setSkipped([]);
    const localSucceeded = [];
    const localSkipped = [];
    for (const postId of postIds) {
      try {
        await api.unpublishPost({ _id: postId });
        localSucceeded.push(postId);
      } catch (err) {
        const message = err && err.message ? err.message : "Unpublish failed";
        const status = err && err.status;
        console.error(`Bulk unpublish: skipped post ${postId} \u2014 ${message}`, err);
        localSkipped.push({ postId, message, status });
      }
      setProcessed((prev) => prev + 1);
      setSucceeded([...localSucceeded]);
      setSkipped([...localSkipped]);
    }
    setIsRunning(false);
    setIsComplete(true);
    return { succeeded: localSucceeded, skipped: localSkipped };
  });
  const reset = useMemoizedFn(() => {
    setIsRunning(false);
    setProcessed(0);
    setTotal(0);
    setSucceeded([]);
    setSkipped([]);
    setIsComplete(false);
  });
  return {
    run,
    reset,
    isRunning,
    processed,
    total,
    succeeded,
    skipped,
    isComplete
  };
};

const BulkUnpublishPanel = ({
  postIds,
  onBack
}) => {
  const unpublish = useBulkUnpublish();
  const runUnpublish = useMemoizedFn(() => {
    unpublish.run(postIds);
  });
  const {
    open: confirmUnpublish,
    confirmationProps
  } = useConfirmation({
    onConfirm: runUnpublish,
    title: "Unpublish posts",
    message: `This will unpublish ${postIds.length} post(s). Unpublished posts are removed from the circle but can be restored by republishing them individually. Continue?`,
    confirmText: "Unpublish posts",
    cancelText: "Cancel",
    confirmIntent: "danger"
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex justify-between items-center",
        children: [/* @__PURE__ */ jsxs("h2", {
          className: "text-xl font-semibold",
          children: ["Unpublish ", postIds.length, " Selected Posts"]
        }), /* @__PURE__ */ jsx("button", {
          onClick: onBack,
          className: "px-4 py-2 text-gray-600 hover:text-gray-800",
          children: "Back to Selection"
        })]
      }), /* @__PURE__ */ jsxs("p", {
        className: "text-sm text-gray-600",
        children: ["Posts: ", postIds.join(", ")]
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(LoadingButtonTW, {
      loading: unpublish.isRunning,
      onClick: confirmUnpublish,
      disabled: unpublish.isRunning,
      background: "blue",
      children: unpublish.isRunning ? `Unpublishing ${unpublish.processed} of ${unpublish.total}...` : "Unpublish Posts"
    }), unpublish.isComplete && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2 rounded border border-gray-200 p-4",
      children: [/* @__PURE__ */ jsxs("p", {
        className: "text-sm font-medium text-gray-800",
        children: [unpublish.succeeded.length, " of ", postIds.length, " post(s) unpublished."]
      }), unpublish.skipped.length > 0 && /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-1",
        children: [/* @__PURE__ */ jsxs("p", {
          className: "text-sm font-medium text-red-700",
          children: [unpublish.skipped.length, " post(s) skipped:"]
        }), /* @__PURE__ */ jsx("ul", {
          className: "text-sm text-red-700 list-disc pl-5",
          children: unpublish.skipped.map((skip) => /* @__PURE__ */ jsxs("li", {
            children: [skip.postId, " \u2014 ", skip.message]
          }, skip.postId))
        })]
      })]
    }), /* @__PURE__ */ jsx(ConfirmationOverlay, {
      ...confirmationProps
    })]
  });
};

const MAX_MESSAGES = 30;
const usePromptBatchTask = () => {
  const api = useApi();
  const jwt = useJwt();
  const isMountedRef = useRef(true);
  const [executionId, setExecutionId] = useState("");
  const [counter, setCounter] = useState(0);
  const [isCreatingTask, setIsCreatingTask] = useState(false);
  const [createError, setCreateError] = useState(null);
  const [messages, setMessages] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [complete, setComplete] = useState();
  const [connectionError, setConnectionError] = useState(null);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const url = useMemo(() => {
    if (!counter || !jwt || !executionId) {
      return "";
    }
    return api.buildUrl("/posts/actions/execute-prompt", { token: jwt, executionId });
  }, [counter, api, jwt, executionId]);
  const addMessage = useMemoizedFn((event, data) => {
    if (!isMountedRef.current)
      return;
    setMessages((prev) => {
      const next = {
        id: Date.now().toString() + Math.random(),
        event,
        timestamp: new Date(),
        data
      };
      return [next, ...prev].slice(0, MAX_MESSAGES);
    });
  });
  const { isConnected, error: sseError, disconnect } = useSSEConnection({
    url,
    enabled: counter > 0 && !!url,
    dependencies: [counter],
    onOpen: () => {
      if (!isMountedRef.current)
        return;
      setIsComplete(false);
      setConnectionError(null);
      setMessages([]);
      setComplete(void 0);
    },
    onError: () => {
      if (!isMountedRef.current)
        return;
      setConnectionError(new Error("Connection error"));
    }
  }, [
    {
      event: "progress",
      handler: (data) => {
        addMessage("progress", data);
      }
    },
    {
      event: "complete",
      handler: (data) => {
        addMessage("complete", data);
        if (!isMountedRef.current)
          return;
        setComplete(data);
        setIsComplete(true);
        setTimeout(() => {
          if (isMountedRef.current)
            disconnect();
        }, 100);
      }
    },
    {
      event: "failed",
      handler: (data) => {
        const message = data && data.message || "Bulk prompt execution failed";
        addMessage("failed", { message });
        if (!isMountedRef.current)
          return;
        setConnectionError(new Error(message));
        setTimeout(() => {
          if (isMountedRef.current)
            disconnect();
        }, 100);
      }
    }
  ]);
  const startPromptBatch = useMemoizedFn(async (input) => {
    setIsCreatingTask(true);
    setCreateError(null);
    setIsComplete(false);
    setComplete(void 0);
    setMessages([]);
    try {
      const result = await api.post({
        path: "/tasks/create",
        body: { input }
      });
      if (!isMountedRef.current)
        return;
      setExecutionId(result.executionId);
      setCounter((c) => c + 1);
    } catch (error) {
      if (!isMountedRef.current)
        return;
      setCreateError(error);
    } finally {
      if (isMountedRef.current)
        setIsCreatingTask(false);
    }
  });
  const clear = useMemoizedFn(() => {
    setMessages([]);
    setComplete(void 0);
    setIsComplete(false);
    setConnectionError(null);
    setCreateError(null);
  });
  return {
    startPromptBatch,
    isCreatingTask,
    isConnected,
    isComplete,
    complete,
    messages,
    error: createError || connectionError || sseError,
    clear
  };
};

const getPromptId$1 = (prompt) => {
  if (!prompt)
    return null;
  if (typeof prompt === "string")
    return prompt;
  return prompt._id && String(prompt._id) || null;
};
const sameOption = (a, b) => !!a && a.assistantId === b.assistantId && a.promptId === b.promptId;
const PromptBatchPanel = ({
  postIds,
  circleId,
  position,
  title = "Run Prompt",
  onBack
}) => {
  const {
    data
  } = useAssistants(circleId);
  const promptOptions = useMemo(() => {
    const assistants = data && data.assistants || [];
    const options = [];
    assistants.forEach((assistant) => {
      const prompts = assistant.prompts || [];
      prompts.forEach((p) => {
        if (p.position !== position)
          return;
        const promptId = getPromptId$1(p.prompt);
        if (!promptId)
          return;
        options.push({
          assistantId: assistant._id,
          promptId,
          label: assistant.name || String(assistant._id)
        });
      });
    });
    return options;
  }, [data, position]);
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    if (promptOptions.length === 0) {
      if (selected)
        setSelected(null);
      return;
    }
    if (!selected || !promptOptions.some((p) => sameOption(selected, p))) {
      setSelected(promptOptions[0]);
    }
  }, [promptOptions]);
  const task = usePromptBatchTask();
  const isBusy = task.isCreatingTask || task.isConnected;
  const runPrompt = useMemoizedFn(() => {
    if (!selected)
      return;
    task.startPromptBatch({
      postId: postIds,
      assistantId: selected.assistantId,
      promptId: selected.promptId,
      circleId
    });
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full flex flex-col gap-6",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex justify-between items-center",
      children: [/* @__PURE__ */ jsxs("h2", {
        className: "text-xl font-semibold",
        children: [title, " \u2014 ", postIds.length, " Selected Posts"]
      }), /* @__PURE__ */ jsx("button", {
        onClick: onBack,
        className: "px-4 py-2 text-gray-600 hover:text-gray-800",
        children: "Back to Selection"
      })]
    }), promptOptions.length === 0 ? /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: `No assistant prompt configured at position "${position}" for this circle`,
      variant: "compact"
    }) : /* @__PURE__ */ jsx("select", {
      value: selected ? `${selected.assistantId}:${selected.promptId}` : "",
      onChange: (event) => {
        const found = promptOptions.find((p) => `${p.assistantId}:${p.promptId}` === event.target.value);
        setSelected(found || null);
      },
      className: "border rounded px-3 py-2",
      disabled: isBusy,
      children: promptOptions.map((p) => /* @__PURE__ */ jsx("option", {
        value: `${p.assistantId}:${p.promptId}`,
        children: p.label
      }, `${p.assistantId}:${p.promptId}`))
    }), /* @__PURE__ */ jsx(LoadingButtonTW, {
      loading: isBusy,
      onClick: runPrompt,
      disabled: isBusy || !selected,
      background: "blue",
      children: task.isCreatingTask ? "Creating Task..." : "Run Prompt"
    }), task.error && /* @__PURE__ */ jsx(ErrorPanel$1, {
      error: task.error,
      variant: "compact"
    }), /* @__PURE__ */ jsx(SSEProgressPanel, {
      messages: task.messages,
      isConnected: task.isConnected,
      isComplete: task.isComplete,
      error: task.error,
      variant: "default"
    }), task.complete && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsxs("h3", {
        className: "text-sm font-semibold text-gray-700",
        children: ["Processed Posts (", task.complete.result.results.length, ")"]
      }), task.complete.result.results.map((item) => {
        const fieldNames = Object.keys(item.updatedFields);
        return /* @__PURE__ */ jsxs("div", {
          className: "flex items-center justify-between border rounded px-3 py-2 gap-3",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "flex flex-col gap-1 min-w-0",
            children: [/* @__PURE__ */ jsx("span", {
              className: "font-medium truncate",
              children: item.title
            }), /* @__PURE__ */ jsx("div", {
              className: "flex gap-1 flex-wrap",
              children: fieldNames.length > 0 ? fieldNames.map((key) => /* @__PURE__ */ jsx("span", {
                className: "text-xs bg-blue-50 text-blue-700 rounded px-2 py-0.5",
                children: key
              }, key)) : /* @__PURE__ */ jsx("span", {
                className: "text-xs text-gray-400",
                children: "no fields changed"
              })
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex items-center gap-2 shrink-0",
            children: [/* @__PURE__ */ jsx("a", {
              href: url4post({
                _id: item.postId
              }),
              target: "_blank",
              title: "View post",
              children: /* @__PURE__ */ jsx(HiExternalLink, {})
            }), /* @__PURE__ */ jsx(Link$2, {
              to: editMetadataUrl({
                _id: item.postId,
                tags: item.tags
              }),
              title: "Edit metadata",
              children: /* @__PURE__ */ jsx(HiTag, {})
            })]
          })]
        }, item.postId);
      }), task.complete.result.failures.map((failure) => /* @__PURE__ */ jsx(ErrorPanel$1, {
        error: failure.title + ": " + failure.error,
        variant: "compact"
      }, failure.postId))]
    }), /* @__PURE__ */ jsx(SSEExecutionSection, {
      title: "Execution Details",
      messages: task.messages,
      isConnected: task.isConnected,
      isComplete: task.isComplete,
      error: task.error,
      onClear: task.clear,
      defaultCollapsed: true,
      emptyMessage: "No messages yet",
      showProgress: true
    })]
  });
};

const POSTS_PER_PAGE = 20;
const CombinePostsPanel = ({
  circleId
}) => {
  const [selectedPostIds, setSelectedPostIds] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [showSelectedView, setShowSelectedView] = useState(false);
  const [operationMode, setOperationMode] = useState(null);
  const [targetPost, setTargetPost] = useState(null);
  const {
    group,
    setGroup
  } = usePostOperationsContext();
  const {
    data: circleData = {}
  } = useCircle(circleId);
  const {
    group: circle
  } = circleData;
  const {
    posts,
    total,
    isLoading,
    error
  } = usePostsList({
    circleId,
    limit: POSTS_PER_PAGE,
    skip: currentPage * POSTS_PER_PAGE
  });
  const totalPages = Math.ceil(total / POSTS_PER_PAGE);
  const addNewPostToSelected = useMemoizedFn((postId) => {
    setSelectedPostIds((prevIds) => [postId, ...prevIds]);
  });
  const handleStartOperation = useMemoizedFn((mode) => {
    setOperationMode(mode);
    setShowSelectedView(true);
  });
  const handleBack = useMemoizedFn(() => {
    setShowSelectedView(false);
    setOperationMode(null);
  });
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col h-full",
    children: [/* @__PURE__ */ jsx(CircleBreadcrumb, {
      circleId,
      current: "Circle Posts Operations"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col flex-grow overflow-y-auto w-full",
      children: [!showSelectedView ? /* @__PURE__ */ jsxs("h2", {
        className: "text-xl font-semibold mb-4",
        children: ["Circle Posts Operations", circle && /* @__PURE__ */ jsx("a", {
          href: circleUrl(circleId),
          className: "ml-2 text-blue-600 hover:underline font-normal text-base",
          rel: "noreferrer",
          children: circle.name
        })]
      }) : operationMode === "translate" ? /* @__PURE__ */ jsx(TranslateBatchPanel, {
        postIds: selectedPostIds,
        onBack: handleBack
      }) : operationMode === "duplicate" ? /* @__PURE__ */ jsx(DuplicateCirclePanel, {
        postIds: selectedPostIds,
        onBack: handleBack
      }) : operationMode === "unpublish" ? /* @__PURE__ */ jsx(BulkUnpublishPanel, {
        postIds: selectedPostIds,
        onBack: handleBack
      }) : operationMode === "metadata" ? /* @__PURE__ */ jsx(PromptBatchPanel, {
        postIds: selectedPostIds,
        circleId,
        position: "post.metadata",
        title: "Update Metadata",
        onBack: handleBack
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx("h2", {
          className: "text-xl font-semibold mb-4",
          children: operationMode === "combine" ? "Convert to a Multi-page Post" : "Selected Posts"
        }), operationMode === "combine" && /* @__PURE__ */ jsx(SelectMyCircle, {
          groupId: group,
          changeGroup: (_id, circle2) => setGroup(_id),
          title: "Select a destination Circle"
        })]
      }), error && /* @__PURE__ */ jsx(ErrorPanel$1, {
        error,
        variant: "compact",
        className: "mb-4"
      }), showSelectedView && operationMode !== "translate" ? operationMode === "combine" ? /* @__PURE__ */ jsx("div", {
        className: "flex flex-col space-y-2 flex-grow overflow-y-auto w-full",
        children: selectedPostIds.map((postId) => /* @__PURE__ */ jsx(SelectedPostItem, {
          postId,
          targetPost,
          onSetTargetPost: setTargetPost,
          onPostCreated: addNewPostToSelected
        }, postId))
      }) : null : !showSelectedView ? /* @__PURE__ */ jsxs(Fragment, {
        children: [totalPages > 1 && /* @__PURE__ */ jsx(PaginationControls, {
          current: currentPage,
          total: totalPages,
          onPageChange: setCurrentPage,
          className: "mt-4",
          variant: "compact",
          justify: "center"
        }), /* @__PURE__ */ jsx(PostSelector, {
          posts,
          selectedPostIds,
          onSelectionChange: setSelectedPostIds,
          isLoading
        })]
      }) : null]
    }), /* @__PURE__ */ jsxs("div", {
      className: "mt-4 flex justify-end gap-2 border-t pt-4",
      children: [showSelectedView && operationMode !== null && /* @__PURE__ */ jsx("button", {
        onClick: handleBack,
        className: "px-4 py-2 text-gray-600 hover:text-gray-800",
        children: "\u2190 Back to Selection"
      }), !showSelectedView && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsxs(LoadingButtonTW, {
          onClick: () => handleStartOperation("translate"),
          disabled: selectedPostIds.length < 1 || error,
          background: "green",
          children: ["Translate (", selectedPostIds.length, ")"]
        }), /* @__PURE__ */ jsxs(LoadingButtonTW, {
          onClick: () => handleStartOperation("combine"),
          disabled: selectedPostIds.length < 1 || error,
          background: "blue",
          children: ["Combine (", selectedPostIds.length, ")"]
        }), /* @__PURE__ */ jsxs(LoadingButtonTW, {
          onClick: () => handleStartOperation("duplicate"),
          disabled: selectedPostIds.length < 1 || error,
          background: "blue",
          children: ["Duplicate / Change Circle (", selectedPostIds.length, ")"]
        }), /* @__PURE__ */ jsxs(LoadingButtonTW, {
          onClick: () => handleStartOperation("unpublish"),
          disabled: selectedPostIds.length < 1 || error,
          background: "blue",
          children: ["Unpublish (", selectedPostIds.length, ")"]
        }), /* @__PURE__ */ jsxs(LoadingButtonTW, {
          onClick: () => handleStartOperation("metadata"),
          disabled: selectedPostIds.length < 1 || error,
          background: "blue",
          children: ["Execute Prompt (", selectedPostIds.length, ")"]
        })]
      })]
    })]
  });
};

const PostOperationsContextProvider = ({
  children,
  circleId
}) => {
  const [group, setGroup] = useState(circleId);
  const context = useMemo(() => {
    return {
      group,
      setGroup
    };
  }, [group]);
  return /* @__PURE__ */ jsx(PostOperationsContext.Provider, {
    value: context,
    children
  });
};

const CombinePostsPage = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(CombinePostsPageInner, {})
  });
};
const CombinePostsPageInner = () => {
  const location = useLocation();
  const parts = location.pathname.split("/").filter((v) => v);
  const {
    profile
  } = useProfileContext();
  if (!profile) {
    return null;
  }
  const circleId = parts[parts.findIndex((v) => v === "combine-posts") + 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx("div", {
      className: "ns p-2 h-full flex flex-col",
      children: /* @__PURE__ */ jsx(PostOperationsContextProvider, {
        circleId,
        children: /* @__PURE__ */ jsx(CombinePostsPanel, {
          circleId
        })
      })
    })]
  });
};

async function pollTtsJob$1(api, jobId, opts = {}) {
  const intervalMs = opts.intervalMs || 2e3;
  const timeoutMs = opts.timeoutMs || 5 * 60 * 1e3;
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    await new Promise((r) => setTimeout(r, intervalMs));
    const res = await api.get({
      path: `/tts/status/${jobId}`
    });
    if (res && res.status === "success")
      return res;
    if (res && res.status === "failed")
      throw new Error(res && res.error || "TTS generation failed");
  }
  throw new Error("TTS generation timed out");
}
const PROVIDERS = {
  openai: {
    label: "OpenAI",
    models: [{
      value: "tts-1",
      label: "TTS-1 (Standard)"
    }, {
      value: "tts-1-hd",
      label: "TTS-1-HD (High Definition)"
    }, {
      value: "gpt-4o-mini-tts",
      label: "GPT-4o Mini TTS (Budget)"
    }],
    voices: [{
      value: "alloy",
      label: "Alloy"
    }, {
      value: "echo",
      label: "Echo"
    }, {
      value: "fable",
      label: "Fable"
    }, {
      value: "onyx",
      label: "Onyx"
    }, {
      value: "nova",
      label: "Nova"
    }, {
      value: "shimmer",
      label: "Shimmer"
    }],
    languages: [{
      value: "en-US",
      label: "English (US)"
    }, {
      value: "en-GB",
      label: "English (UK)"
    }, {
      value: "ar-XA",
      label: "Arabic"
    }, {
      value: "de-DE",
      label: "German"
    }, {
      value: "fr-FR",
      label: "French"
    }, {
      value: "es-ES",
      label: "Spanish"
    }],
    formats: ["mp3", "wav", "opus", "aac", "flac"]
  },
  google: {
    label: "Google Cloud",
    models: [{
      value: "standard",
      label: "Standard"
    }, {
      value: "wavenet",
      label: "WaveNet"
    }, {
      value: "neural2",
      label: "Neural2"
    }, {
      value: "studio",
      label: "Studio (Premium)"
    }, {
      value: "journey",
      label: "Journey"
    }],
    voices: {
      "en-US": [{
        value: "en-US-Standard-A",
        label: "Standard A (Female)"
      }, {
        value: "en-US-Standard-B",
        label: "Standard B (Male)"
      }, {
        value: "en-US-Wavenet-A",
        label: "Wavenet A (Female)"
      }, {
        value: "en-US-Wavenet-B",
        label: "Wavenet B (Male)"
      }, {
        value: "en-US-Neural2-A",
        label: "Neural2 A (Female)"
      }, {
        value: "en-US-Neural2-D",
        label: "Neural2 D (Male)"
      }, {
        value: "en-US-Studio-O",
        label: "Studio O (Female)"
      }, {
        value: "en-US-Studio-Q",
        label: "Studio Q (Male)"
      }],
      "en-GB": [{
        value: "en-GB-Standard-A",
        label: "Standard A (Female)"
      }, {
        value: "en-GB-Standard-B",
        label: "Standard B (Male)"
      }, {
        value: "en-GB-Wavenet-A",
        label: "Wavenet A (Female)"
      }, {
        value: "en-GB-Wavenet-B",
        label: "Wavenet B (Male)"
      }, {
        value: "en-GB-Neural2-A",
        label: "Neural2 A (Female)"
      }, {
        value: "en-GB-Neural2-D",
        label: "Neural2 D (Male)"
      }],
      "ar-XA": [{
        value: "ar-XA-Standard-A",
        label: "Standard A (Female)"
      }, {
        value: "ar-XA-Standard-B",
        label: "Standard B (Male)"
      }, {
        value: "ar-XA-Wavenet-A",
        label: "Wavenet A (Female)"
      }, {
        value: "ar-XA-Wavenet-B",
        label: "Wavenet B (Male)"
      }],
      "de-DE": [{
        value: "de-DE-Standard-A",
        label: "Standard A (Female)"
      }, {
        value: "de-DE-Standard-B",
        label: "Standard B (Male)"
      }, {
        value: "de-DE-Wavenet-A",
        label: "Wavenet A (Female)"
      }, {
        value: "de-DE-Wavenet-B",
        label: "Wavenet B (Male)"
      }, {
        value: "de-DE-Neural2-A",
        label: "Neural2 A (Female)"
      }, {
        value: "de-DE-Neural2-D",
        label: "Neural2 D (Male)"
      }],
      "fr-FR": [{
        value: "fr-FR-Standard-A",
        label: "Standard A (Female)"
      }, {
        value: "fr-FR-Standard-B",
        label: "Standard B (Male)"
      }, {
        value: "fr-FR-Wavenet-A",
        label: "Wavenet A (Female)"
      }, {
        value: "fr-FR-Wavenet-B",
        label: "Wavenet B (Male)"
      }, {
        value: "fr-FR-Neural2-A",
        label: "Neural2 A (Female)"
      }, {
        value: "fr-FR-Neural2-D",
        label: "Neural2 D (Male)"
      }],
      "es-ES": [{
        value: "es-ES-Standard-A",
        label: "Standard A (Female)"
      }, {
        value: "es-ES-Standard-B",
        label: "Standard B (Male)"
      }, {
        value: "es-ES-Wavenet-B",
        label: "Wavenet B (Male)"
      }, {
        value: "es-ES-Neural2-A",
        label: "Neural2 A (Female)"
      }, {
        value: "es-ES-Neural2-D",
        label: "Neural2 D (Male)"
      }]
    },
    languages: [{
      value: "en-US",
      label: "English (US)"
    }, {
      value: "en-GB",
      label: "English (UK)"
    }, {
      value: "ar-XA",
      label: "Arabic"
    }, {
      value: "de-DE",
      label: "German"
    }, {
      value: "fr-FR",
      label: "French"
    }, {
      value: "es-ES",
      label: "Spanish"
    }],
    formats: ["mp3", "wav", "ogg"]
  }
};
const AudioPlayer = ({
  audioUrl,
  duration
}) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [audioDuration, setAudioDuration] = useState(duration || 0);
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio)
      return;
    const handleTimeUpdate = () => setCurrentTime(audio.currentTime);
    const handleLoadedMetadata = () => setAudioDuration(audio.duration);
    const handleEnded = () => setIsPlaying(false);
    audio.addEventListener("timeupdate", handleTimeUpdate);
    audio.addEventListener("loadedmetadata", handleLoadedMetadata);
    audio.addEventListener("ended", handleEnded);
    return () => {
      audio.removeEventListener("timeupdate", handleTimeUpdate);
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
      audio.removeEventListener("ended", handleEnded);
    };
  }, [audioUrl]);
  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio)
      return;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };
  const handleSeek = (e) => {
    const audio = audioRef.current;
    if (!audio)
      return;
    audio.currentTime = parseFloat(e.target.value);
  };
  const formatTime = (time) => {
    const mins = Math.floor(time / 60);
    const secs = Math.floor(time % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "p-4 bg-gray-100 rounded-lg",
    children: [/* @__PURE__ */ jsx("audio", {
      ref: audioRef,
      src: audioUrl
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-4",
      children: [/* @__PURE__ */ jsx("button", {
        onClick: togglePlay,
        className: "w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700",
        children: isPlaying ? "\u23F8" : "\u25B6"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex-1",
        children: [/* @__PURE__ */ jsx("input", {
          type: "range",
          min: 0,
          max: audioDuration || 100,
          value: currentTime,
          onChange: handleSeek,
          className: "w-full"
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex justify-between text-sm text-gray-600",
          children: [/* @__PURE__ */ jsx("span", {
            children: formatTime(currentTime)
          }), /* @__PURE__ */ jsx("span", {
            children: formatTime(audioDuration)
          })]
        })]
      })]
    })]
  });
};
const TTSPanel = ({
  circleId
}) => {
  const api = useApi();
  const [sourceType, setSourceType] = useState("static");
  const [text, setText] = useState("");
  const [postId, setPostId] = useState("");
  const [pageId, setPageId] = useState("");
  const [usePageId, setUsePageId] = useState(false);
  const [provider, setProvider] = useState("openai");
  const [model, setModel] = useState("tts-1");
  const [voice, setVoice] = useState("echo");
  const [language, setLanguage] = useState("en-US");
  const [format, setFormat] = useState("mp3");
  const [savedConfig, setSavedConfig] = useState(null);
  const [isLoadingConfig, setIsLoadingConfig] = useState(false);
  const [isSavingConfig, setIsSavingConfig] = useState(false);
  const [configHasChanges, setConfigHasChanges] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const fetchConfiguration = async () => {
    if (!circleId)
      return;
    setIsLoadingConfig(true);
    try {
      const response = await api.get({
        path: `/admin/options?type=tts-config&circleId=${circleId}`
      });
      if (response && response.options) {
        setSavedConfig(response.options);
        setProvider(response.options.provider || "openai");
        setModel(response.options.model || "tts-1");
        setVoice(response.options.voice || "echo");
        setLanguage(response.options.language || "en-US");
        setFormat(response.options.format || "mp3");
      }
    } catch (err) {
      console.error("Failed to fetch TTS configuration:", err);
    } finally {
      setIsLoadingConfig(false);
    }
  };
  useEffect(() => {
    if (circleId) {
      fetchConfiguration();
    }
  }, [circleId]);
  const saveConfiguration = async () => {
    if (!circleId) {
      toast("Circle ID is required to save configuration");
      return;
    }
    setIsSavingConfig(true);
    try {
      const configPayload = {
        type: "tts-config",
        circleId,
        options: {
          provider,
          model,
          voice,
          language: provider === "openai" ? "" : language,
          format
        },
        updated: new Date().toISOString()
      };
      await api.post({
        path: "/admin/options",
        body: configPayload
      });
      setSavedConfig(configPayload.options);
      setConfigHasChanges(false);
      toast("TTS configuration saved successfully!");
    } catch (err) {
      console.error("Failed to save TTS configuration:", err);
      toast("Failed to save TTS configuration");
    } finally {
      setIsSavingConfig(false);
    }
  };
  useEffect(() => {
    if (savedConfig) {
      const hasChanges = provider !== savedConfig.provider || model !== savedConfig.model || voice !== savedConfig.voice || provider === "google" && language !== savedConfig.language || format !== savedConfig.format;
      setConfigHasChanges(hasChanges);
    }
  }, [provider, model, voice, language, format, savedConfig]);
  useEffect(() => {
    if (provider === "openai") {
      setModel("tts-1");
      setVoice("echo");
    } else {
      setModel("wavenet");
      setLanguage("en-US");
      setVoice("en-US-Wavenet-A");
    }
    setFormat("mp3");
  }, [provider]);
  useEffect(() => {
    if (provider === "google") {
      const voices = PROVIDERS.google.voices[language];
      if (voices && voices.length > 0) {
        setVoice(voices[0].value);
      }
    }
  }, [language, provider]);
  const {
    onClick: onGenerate,
    loading
  } = useLoading(async () => {
    setError(null);
    setResult(null);
    try {
      const body = {
        provider,
        model,
        voice,
        language,
        format
      };
      if (sourceType === "static") {
        if (!text.trim()) {
          toast("Please enter some text");
          return;
        }
        body.text = text;
      } else {
        if (!postId.trim()) {
          toast("Please enter a Post ID");
          return;
        }
        body.contentId = postId;
        body.contentType = "post";
        if (usePageId && pageId.trim()) {
          body.pageId = pageId;
        }
      }
      let response = await api.post({
        path: "/tts/generate",
        body
      });
      if (response.success && response.status === "pending" && response.jobId) {
        response = await pollTtsJob$1(api, response.jobId);
      }
      if (response.success && response.data) {
        setResult(response.data);
        toast("Audio generated successfully!");
      } else {
        throw new Error(response.error || "Failed to generate audio");
      }
    } catch (err) {
      const message = err.message || "Failed to generate audio";
      setError(message);
      toast(message);
      if (message.includes("pageId is required") || message.includes("specify which page")) {
        setUsePageId(true);
      }
    }
  });
  const providerConfig = PROVIDERS[provider];
  const googleVoices = provider === "google" ? PROVIDERS.google.voices[language] || [] : [];
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 flex flex-col gap-4",
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-2xl font-semibold",
      children: "Text-to-Speech Generator"
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), circleId && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "p-4 bg-blue-50 border border-blue-200 rounded-lg",
        children: [/* @__PURE__ */ jsx("h2", {
          className: "text-xl font-semibold mb-3",
          children: "Circle TTS Configuration"
        }), /* @__PURE__ */ jsx("p", {
          className: "text-sm text-gray-600 mb-4",
          children: "Configure default TTS settings for this circle. These settings will be used as defaults for all TTS generations."
        }), isLoadingConfig ? /* @__PURE__ */ jsx("div", {
          className: "text-center py-4",
          children: "Loading configuration..."
        }) : /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col gap-4",
          children: [/* @__PURE__ */ jsxs("div", {
            className: "grid grid-cols-2 gap-4",
            children: [/* @__PURE__ */ jsxs(FormControl$1, {
              variant: "outlined",
              fullWidth: true,
              children: [/* @__PURE__ */ jsx(InputLabel, {
                children: "Provider"
              }), /* @__PURE__ */ jsxs(Select$1, {
                value: provider,
                onChange: (e) => setProvider(e.target.value),
                label: "Provider",
                children: [/* @__PURE__ */ jsx(MenuItem, {
                  value: "openai",
                  children: "OpenAI"
                }), /* @__PURE__ */ jsx(MenuItem, {
                  value: "google",
                  children: "Google Cloud"
                })]
              })]
            }), /* @__PURE__ */ jsxs(FormControl$1, {
              variant: "outlined",
              fullWidth: true,
              children: [/* @__PURE__ */ jsx(InputLabel, {
                children: "Model"
              }), /* @__PURE__ */ jsx(Select$1, {
                value: model,
                onChange: (e) => setModel(e.target.value),
                label: "Model",
                children: PROVIDERS[provider].models.map((m) => /* @__PURE__ */ jsx(MenuItem, {
                  value: m.value,
                  children: m.label
                }, m.value))
              })]
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "grid grid-cols-2 gap-4",
            children: [provider === "google" && /* @__PURE__ */ jsxs(FormControl$1, {
              variant: "outlined",
              fullWidth: true,
              children: [/* @__PURE__ */ jsx(InputLabel, {
                children: "Language"
              }), /* @__PURE__ */ jsx(Select$1, {
                value: language,
                onChange: (e) => setLanguage(e.target.value),
                label: "Language",
                children: PROVIDERS[provider].languages.map((l) => /* @__PURE__ */ jsx(MenuItem, {
                  value: l.value,
                  children: l.label
                }, l.value))
              })]
            }), /* @__PURE__ */ jsxs(FormControl$1, {
              variant: "outlined",
              fullWidth: true,
              children: [/* @__PURE__ */ jsx(InputLabel, {
                children: "Voice"
              }), /* @__PURE__ */ jsx(Select$1, {
                value: voice,
                onChange: (e) => setVoice(e.target.value),
                label: "Voice",
                children: provider === "openai" ? PROVIDERS.openai.voices.map((v) => /* @__PURE__ */ jsx(MenuItem, {
                  value: v.value,
                  children: v.label
                }, v.value)) : (PROVIDERS.google.voices[language] || []).map((v) => /* @__PURE__ */ jsx(MenuItem, {
                  value: v.value,
                  children: v.label
                }, v.value))
              })]
            }), /* @__PURE__ */ jsxs(FormControl$1, {
              variant: "outlined",
              fullWidth: true,
              children: [/* @__PURE__ */ jsx(InputLabel, {
                children: "Format"
              }), /* @__PURE__ */ jsx(Select$1, {
                value: format,
                onChange: (e) => setFormat(e.target.value),
                label: "Format",
                children: PROVIDERS[provider].formats.map((f) => /* @__PURE__ */ jsx(MenuItem, {
                  value: f,
                  children: f.toUpperCase()
                }, f))
              })]
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: "flex gap-2 justify-end",
            children: [/* @__PURE__ */ jsx(LoadingButton, {
              onClick: fetchConfiguration,
              variant: "outlined",
              color: "primary",
              disabled: isSavingConfig,
              children: "Reset"
            }), /* @__PURE__ */ jsx(LoadingButton, {
              onClick: saveConfiguration,
              variant: "contained",
              color: "primary",
              loading: isSavingConfig,
              disabled: !configHasChanges,
              children: "Save Configuration"
            })]
          }), savedConfig && /* @__PURE__ */ jsxs("div", {
            className: "text-sm text-gray-600",
            children: ["Last updated: ", savedConfig.updated ? new Date(savedConfig.updated).toLocaleString() : "Never"]
          })]
        })]
      }), /* @__PURE__ */ jsx(HorizontalRuler$2, {})]
    }), /* @__PURE__ */ jsx("h2", {
      className: "text-xl font-semibold",
      children: "Generate Audio"
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-2",
      children: [/* @__PURE__ */ jsx(FormLabel, {
        component: "legend",
        children: "Text Source"
      }), /* @__PURE__ */ jsxs(RadioGroup, {
        row: true,
        value: sourceType,
        onChange: (e) => setSourceType(e.target.value),
        children: [/* @__PURE__ */ jsx(FormControlLabel, {
          value: "static",
          control: /* @__PURE__ */ jsx(Radio, {}),
          label: "Static Text"
        }), /* @__PURE__ */ jsx(FormControlLabel, {
          value: "post",
          control: /* @__PURE__ */ jsx(Radio, {}),
          label: "From Post"
        })]
      })]
    }), sourceType === "static" ? /* @__PURE__ */ jsx(TextField$1, {
      label: "Text to Convert",
      value: text,
      onChange: (e) => setText(e.target.value),
      multiline: true,
      rows: 4,
      variant: "outlined",
      fullWidth: true,
      placeholder: "Enter the text you want to convert to speech..."
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(TextField$1, {
        label: "Post ID",
        value: postId,
        onChange: (e) => setPostId(e.target.value),
        variant: "outlined",
        fullWidth: true,
        placeholder: "Enter the MongoDB Post ID (e.g., 507f1f77bcf86cd799439011)",
        helperText: "The text content will be extracted from this post"
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-col gap-2",
        children: [/* @__PURE__ */ jsx(FormControlLabel, {
          control: /* @__PURE__ */ jsx(Checkbox$1, {
            checked: usePageId,
            onChange: (e) => setUsePageId(e.target.checked),
            color: "primary"
          }),
          label: "Use Page ID (for book content)"
        }), usePageId && /* @__PURE__ */ jsx(TextField$1, {
          label: "Page ID",
          value: pageId,
          onChange: (e) => setPageId(e.target.value),
          variant: "outlined",
          fullWidth: true,
          placeholder: "Enter the Page ID",
          helperText: "Required for book content with multiple pages"
        })]
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx("div", {
      className: "mb-2",
      children: /* @__PURE__ */ jsx("p", {
        className: "text-sm text-gray-600",
        children: circleId && savedConfig ? "These settings are loaded from the circle configuration. You can modify them for this generation only." : "Configure TTS settings for this generation."
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "grid grid-cols-2 gap-4",
      children: [/* @__PURE__ */ jsxs(FormControl$1, {
        variant: "outlined",
        fullWidth: true,
        children: [/* @__PURE__ */ jsx(InputLabel, {
          children: "Provider"
        }), /* @__PURE__ */ jsxs(Select$1, {
          value: provider,
          onChange: (e) => setProvider(e.target.value),
          label: "Provider",
          children: [/* @__PURE__ */ jsx(MenuItem, {
            value: "openai",
            children: "OpenAI"
          }), /* @__PURE__ */ jsx(MenuItem, {
            value: "google",
            children: "Google Cloud"
          })]
        })]
      }), /* @__PURE__ */ jsxs(FormControl$1, {
        variant: "outlined",
        fullWidth: true,
        children: [/* @__PURE__ */ jsx(InputLabel, {
          children: "Model"
        }), /* @__PURE__ */ jsx(Select$1, {
          value: model,
          onChange: (e) => setModel(e.target.value),
          label: "Model",
          children: providerConfig.models.map((m) => /* @__PURE__ */ jsx(MenuItem, {
            value: m.value,
            children: m.label
          }, m.value))
        })]
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "grid grid-cols-2 gap-4",
      children: [provider === "google" && /* @__PURE__ */ jsxs(FormControl$1, {
        variant: "outlined",
        fullWidth: true,
        children: [/* @__PURE__ */ jsx(InputLabel, {
          children: "Language"
        }), /* @__PURE__ */ jsx(Select$1, {
          value: language,
          onChange: (e) => setLanguage(e.target.value),
          label: "Language",
          children: providerConfig.languages.map((l) => /* @__PURE__ */ jsx(MenuItem, {
            value: l.value,
            children: l.label
          }, l.value))
        })]
      }), /* @__PURE__ */ jsxs(FormControl$1, {
        variant: "outlined",
        fullWidth: true,
        children: [/* @__PURE__ */ jsx(InputLabel, {
          children: "Voice"
        }), /* @__PURE__ */ jsx(Select$1, {
          value: voice,
          onChange: (e) => setVoice(e.target.value),
          label: "Voice",
          children: provider === "openai" ? PROVIDERS.openai.voices.map((v) => /* @__PURE__ */ jsx(MenuItem, {
            value: v.value,
            children: v.label
          }, v.value)) : googleVoices.map((v) => /* @__PURE__ */ jsx(MenuItem, {
            value: v.value,
            children: v.label
          }, v.value))
        })]
      }), /* @__PURE__ */ jsxs(FormControl$1, {
        variant: "outlined",
        fullWidth: true,
        children: [/* @__PURE__ */ jsx(InputLabel, {
          children: "Format"
        }), /* @__PURE__ */ jsx(Select$1, {
          value: format,
          onChange: (e) => setFormat(e.target.value),
          label: "Format",
          children: providerConfig.formats.map((f) => /* @__PURE__ */ jsx(MenuItem, {
            value: f,
            children: f.toUpperCase()
          }, f))
        })]
      })]
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsx(LoadingButton, {
      onClick: onGenerate,
      variant: "contained",
      color: "primary",
      loading,
      disabled: sourceType === "static" ? !text.trim() : !postId.trim(),
      children: "Generate Audio"
    }), error && /* @__PURE__ */ jsx("div", {
      className: "p-3 bg-red-50 border border-red-200 rounded text-red-700",
      children: error
    }), result && /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col gap-4",
      children: [/* @__PURE__ */ jsx("h2", {
        className: "text-lg font-semibold",
        children: "Generated Audio"
      }), /* @__PURE__ */ jsx(AudioPlayer, {
        audioUrl: result.audioUrl,
        duration: result.duration
      }), /* @__PURE__ */ jsx("div", {
        className: "p-4 bg-gray-50 rounded border text-sm",
        children: /* @__PURE__ */ jsxs("div", {
          className: "grid grid-cols-2 gap-2",
          children: [/* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Provider:"
            }), " ", result.provider]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Model:"
            }), " ", result.model]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Voice:"
            }), " ", result.voice]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Language:"
            }), " ", result.language]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Format:"
            }), " ", result.format]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Duration:"
            }), " ", result.duration && result.duration.toFixed(2), "s"]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Size:"
            }), " ", (result.size / 1024).toFixed(2), " KB"]
          }), /* @__PURE__ */ jsxs("div", {
            children: [/* @__PURE__ */ jsx("strong", {
              children: "Cached:"
            }), " ", result.cached ? "Yes" : "No"]
          }), result.cost && /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("strong", {
                children: "Cost:"
              }), " $", result.cost.amount && result.cost.amount.toFixed(6)]
            }), /* @__PURE__ */ jsxs("div", {
              children: [/* @__PURE__ */ jsx("strong", {
                children: "Characters:"
              }), " ", result.cost.charactersProcessed]
            })]
          })]
        })
      }), /* @__PURE__ */ jsx("a", {
        href: result.audioUrl,
        download: `tts-${result.cacheId}.${result.format}`,
        className: "text-blue-600 underline",
        children: "Download Audio File"
      })]
    })]
  });
};
const TTSPage = ({
  circleId: circleIdProp
}) => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleIdFromUrl = path[2];
  const circleId = circleIdProp || circleIdFromUrl;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(TTSPanel, {
      circleId
    })]
  });
};

async function pollTtsJob(api, jobId, opts = {}) {
  const intervalMs = opts.intervalMs || 2e3;
  const timeoutMs = opts.timeoutMs || 5 * 60 * 1e3;
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    await new Promise((r) => setTimeout(r, intervalMs));
    const res = await api.get({
      path: `/tts/status/${jobId}`
    });
    if (res && res.status === "success")
      return res;
    if (res && res.status === "failed")
      throw new Error(res && res.error || "TTS generation failed");
  }
  throw new Error("TTS generation timed out");
}
const PAGE_LIMIT_WARN = 50;
const ConfigSummary = ({
  config,
  circleId
}) => {
  if (!config) {
    return /* @__PURE__ */ jsxs("div", {
      className: "p-3 bg-yellow-50 border border-yellow-200 rounded",
      children: ["No TTS configuration saved for this circle yet.", " ", /* @__PURE__ */ jsx("a", {
        className: "text-blue-600 underline",
        href: `/trans/tts/${circleId}`,
        target: "_blank",
        rel: "noreferrer",
        children: "Set one up first"
      }), "."]
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "p-4 bg-blue-50 border border-blue-200 rounded",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-start justify-between gap-4",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "text-sm",
        children: [/* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("strong", {
            children: "Provider:"
          }), " ", config.provider]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("strong", {
            children: "Model:"
          }), " ", config.model]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("strong", {
            children: "Voice:"
          }), " ", config.voice]
        }), config.provider === "google" && /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("strong", {
            children: "Language:"
          }), " ", config.language]
        }), /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("strong", {
            children: "Format:"
          }), " ", config.format]
        }), config.updated && /* @__PURE__ */ jsxs("div", {
          className: "text-gray-600 mt-1",
          children: ["Last updated: ", new Date(config.updated).toLocaleString()]
        })]
      }), /* @__PURE__ */ jsx("a", {
        className: "text-blue-600 underline whitespace-nowrap",
        href: `/trans/tts/${circleId}`,
        target: "_blank",
        rel: "noreferrer",
        children: "Edit config"
      })]
    }), /* @__PURE__ */ jsxs("p", {
      className: "text-xs text-gray-700 mt-3",
      children: ["Changing the config does ", /* @__PURE__ */ jsx("strong", {
        children: "not"
      }), " overwrite existing audio. Re-run conversion to use the new voice as the default for playback."]
    })]
  });
};
const RowItem = ({
  row,
  onRetry
}) => {
  const statusColor = row.status === "ready" ? "text-green-700" : row.status === "error" ? "text-red-700" : row.status === "converting" ? "text-blue-700" : row.status === "queued" ? "text-gray-700" : "text-gray-500";
  return /* @__PURE__ */ jsxs("div", {
    className: "p-3 border rounded flex flex-col gap-2",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center justify-between gap-3",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex-1 min-w-0",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "text-sm font-medium truncate",
          children: [row.index + 1, ". ", row.title || row.pageId]
        }), /* @__PURE__ */ jsxs("div", {
          className: `text-xs ${statusColor}`,
          children: [row.status === "ready" && (row.cached ? "Already converted (cached)" : "Ready"), row.status === "converting" && "Converting\u2026", row.status === "queued" && "Queued", row.status === "idle" && "Idle", row.status === "error" && `Error: ${row.error}`]
        })]
      }), row.status === "ready" && row.duration != null && /* @__PURE__ */ jsxs("div", {
        className: "text-xs text-gray-600 whitespace-nowrap",
        children: [row.duration.toFixed(1), "s", row.cost != null && ` \xB7 $${row.cost.toFixed(5)}`]
      }), row.status === "error" && /* @__PURE__ */ jsx("button", {
        onClick: onRetry,
        className: "text-blue-600 underline text-sm",
        children: "Retry"
      })]
    }), row.status === "ready" && row.audioUrl && /* @__PURE__ */ jsx("audio", {
      controls: true,
      src: row.audioUrl,
      className: "w-full"
    })]
  });
};
const TTSConverterPanel = ({
  circleId
}) => {
  const api = useApi();
  const [postId, setPostId] = useState("");
  const [loadingPost, setLoadingPost] = useState(false);
  const [postTitle, setPostTitle] = useState("");
  const [isBook, setIsBook] = useState(false);
  const [rows, setRows] = useState([]);
  const [resolvedParentId, setResolvedParentId] = useState("");
  const [singlePageMode, setSinglePageMode] = useState(false);
  const [config, setConfig] = useState(null);
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [running, setRunning] = useState(false);
  const runningRef = useRef(false);
  const runConfigRef = useRef(null);
  const [configDrift, setConfigDrift] = useState(false);
  const [concurrency, setConcurrency] = useState(3);
  const fetchConfig = async () => {
    if (!circleId)
      return null;
    setLoadingConfig(true);
    try {
      const response = await api.get({
        path: `/admin/options?type=tts-config&circleId=${circleId}`
      });
      if (response && response.options) {
        const cfg = {
          ...response.options,
          updated: response.updated
        };
        setConfig(cfg);
        return cfg;
      }
      setConfig(null);
      return null;
    } catch (err) {
      console.error("Failed to fetch TTS configuration:", err);
      setConfig(null);
      return null;
    } finally {
      setLoadingConfig(false);
    }
  };
  useEffect(() => {
    fetchConfig();
  }, [circleId]);
  const buildBookRows = (post) => {
    const pages = Array.isArray(post.pages) ? post.pages : [];
    return pages.map((p, i) => {
      const pid = typeof p === "string" ? p : p && p._id;
      const ptitle = p && typeof p === "object" && p.title ? p.title : "";
      return {
        pageId: String(pid),
        index: i,
        title: ptitle ? ptitle.slice(0, 80) : `Page ${i + 1}`,
        status: "idle"
      };
    });
  };
  const loadPost = async (mode) => {
    const id = postId.trim();
    if (!id) {
      toast("Please enter a Post ID");
      return;
    }
    setLoadingPost(true);
    setRows([]);
    setIsBook(false);
    setPostTitle("");
    setResolvedParentId("");
    setSinglePageMode(false);
    setConfigDrift(false);
    try {
      const post = await api.get({
        path: `/post-view/${id}`
      });
      if (!post || !post._id) {
        toast("Post not found");
        return;
      }
      setPostTitle(post.title || "");
      const parentId = String(post._id);
      setResolvedParentId(parentId);
      const pages = Array.isArray(post.pages) ? post.pages : [];
      const typedIsChild = pages.length > 0 && parentId !== id;
      const useSingle = mode === "page" || mode !== "book" && typedIsChild;
      if (useSingle && typedIsChild) {
        setIsBook(true);
        setSinglePageMode(true);
        const matched = pages.find((p) => String(typeof p === "string" ? p : p && p._id) === id);
        const ptitle = matched && typeof matched === "object" ? matched.title || "" : "";
        setRows([{
          pageId: id,
          index: 0,
          title: ptitle ? ptitle.slice(0, 80) : "Selected page",
          status: "idle"
        }]);
      } else if (pages.length > 0) {
        setIsBook(true);
        setSinglePageMode(false);
        setRows(buildBookRows(post));
      } else {
        setIsBook(false);
        setSinglePageMode(false);
        setRows([{
          pageId: parentId,
          index: 0,
          title: (post.title || "Single post").slice(0, 80),
          status: "idle"
        }]);
      }
    } catch (err) {
      console.error(err);
      toast(err && err.message || "Failed to load post");
    } finally {
      setLoadingPost(false);
    }
  };
  const updateRow = (pageId, patch) => {
    setRows((prev) => prev.map((r) => r.pageId === pageId ? {
      ...r,
      ...patch
    } : r));
  };
  const convertOne = async (row, cfg) => {
    updateRow(row.pageId, {
      status: "converting",
      error: void 0
    });
    try {
      const body = {
        contentId: isBook ? resolvedParentId : row.pageId,
        contentType: "post",
        provider: cfg.provider,
        model: cfg.model,
        voice: cfg.voice,
        language: cfg.language,
        format: cfg.format
      };
      if (isBook)
        body.pageId = row.pageId;
      let response = await api.post({
        path: "/tts/generate",
        body
      });
      if (!response || !response.success) {
        throw new Error(response && response.error || "Failed to generate audio");
      }
      if (response.status === "pending" && response.jobId) {
        response = await pollTtsJob(api, response.jobId);
      }
      if (!response.success || !response.data) {
        throw new Error(response && response.error || "Failed to generate audio");
      }
      const data = response.data;
      updateRow(row.pageId, {
        status: "ready",
        audioUrl: data.audioUrl,
        duration: data.duration,
        cost: data.cost && data.cost.amount,
        cached: data.cached
      });
      return true;
    } catch (err) {
      updateRow(row.pageId, {
        status: "error",
        error: err && err.message || "Failed"
      });
      return false;
    }
  };
  const runWith = async (cfg) => {
    runConfigRef.current = {
      ...cfg
    };
    runningRef.current = true;
    setRunning(true);
    setRows((prev) => prev.map((r) => r.status === "ready" ? r : {
      ...r,
      status: "queued",
      error: void 0
    }));
    const queue = rows.filter((r) => r.status !== "ready");
    const limit = Math.max(1, Math.min(10, concurrency | 0 || 1));
    let cursor = 0;
    const worker = async () => {
      while (runningRef.current) {
        const idx = cursor++;
        if (idx >= queue.length)
          break;
        await convertOne(queue[idx], runConfigRef.current);
      }
    };
    await Promise.all(Array.from({
      length: Math.min(limit, queue.length)
    }, worker));
    runningRef.current = false;
    setRunning(false);
  };
  const startRun = async () => {
    if (!config) {
      toast("No TTS configuration saved for this circle");
      return;
    }
    if (rows.length === 0) {
      toast("Load a post first");
      return;
    }
    setConfigDrift(false);
    await runWith(config);
  };
  const stopRun = () => {
    runningRef.current = false;
    setRunning(false);
  };
  const resumeRun = async () => {
    const fresh = await fetchConfig();
    if (!fresh) {
      toast("No TTS configuration saved for this circle");
      return;
    }
    const snap = runConfigRef.current;
    if (snap) {
      const drift = snap.provider !== fresh.provider || snap.model !== fresh.model || snap.voice !== fresh.voice || snap.language !== fresh.language || snap.format !== fresh.format;
      setConfigDrift(drift);
    }
    await runWith(fresh);
  };
  const retryRow = async (row) => {
    if (!config)
      return;
    await convertOne(row, runConfigRef.current || config);
  };
  const readyCount = useMemo(() => rows.filter((r) => r.status === "ready").length, [rows]);
  const errorCount = useMemo(() => rows.filter((r) => r.status === "error").length, [rows]);
  const allReady = rows.length > 0 && readyCount === rows.length;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full p-4 flex flex-col gap-4",
    children: [/* @__PURE__ */ jsx("h1", {
      className: "text-2xl font-semibold",
      children: "Convert Post / Book to TTS"
    }), /* @__PURE__ */ jsx("p", {
      className: "text-sm text-gray-600",
      children: "Generates audio per page using this circle's saved TTS configuration. Existing audio for other configurations is preserved."
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), loadingConfig ? /* @__PURE__ */ jsx("div", {
      children: "Loading configuration\u2026"
    }) : /* @__PURE__ */ jsx(ConfigSummary, {
      config,
      circleId: circleId || ""
    }), /* @__PURE__ */ jsx(HorizontalRuler$2, {}), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 items-end",
      children: [/* @__PURE__ */ jsx(TextField$1, {
        label: "Post / Book ID",
        value: postId,
        onChange: (e) => setPostId(e.target.value),
        variant: "outlined",
        fullWidth: true,
        placeholder: "e.g. 68ef55c383f2faddcd471697",
        disabled: running
      }), /* @__PURE__ */ jsx(LoadingButton, {
        onClick: () => loadPost("auto"),
        variant: "outlined",
        color: "primary",
        loading: loadingPost,
        disabled: running || !postId.trim(),
        children: "Load"
      })]
    }), resolvedParentId && resolvedParentId !== postId.trim() && /* @__PURE__ */ jsxs("div", {
      className: "p-3 bg-blue-50 border border-blue-200 rounded text-sm flex items-center justify-between gap-3",
      children: [/* @__PURE__ */ jsxs("span", {
        children: ["The id you entered is a page inside a book. Convert", " ", /* @__PURE__ */ jsx("strong", {
          children: singlePageMode ? "this page only" : "the whole book"
        }), "?"]
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2",
        children: [/* @__PURE__ */ jsx("button", {
          className: `px-2 py-1 rounded border ${singlePageMode ? "bg-blue-600 text-white" : "bg-white"}`,
          onClick: () => loadPost("page"),
          disabled: running || loadingPost,
          children: "This page"
        }), /* @__PURE__ */ jsx("button", {
          className: `px-2 py-1 rounded border ${!singlePageMode ? "bg-blue-600 text-white" : "bg-white"}`,
          onClick: () => loadPost("book"),
          disabled: running || loadingPost,
          children: "Whole book"
        })]
      })]
    }), rows.length > 0 && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        className: "text-sm",
        children: [/* @__PURE__ */ jsx("strong", {
          children: postTitle || postId
        }), " \u2014 ", singlePageMode ? "1 selected page" : isBook ? `${rows.length} pages` : "single post", " \xB7 ", readyCount, "/", rows.length, " ready", errorCount > 0 && ` \xB7 ${errorCount} error${errorCount > 1 ? "s" : ""}`]
      }), rows.length > PAGE_LIMIT_WARN && /* @__PURE__ */ jsxs("div", {
        className: "p-3 bg-yellow-50 border border-yellow-200 rounded text-sm",
        children: ["More than ", PAGE_LIMIT_WARN, " pages. Keep this tab open until conversion finishes."]
      }), configDrift && /* @__PURE__ */ jsx("div", {
        className: "p-3 bg-yellow-50 border border-yellow-200 rounded text-sm",
        children: "Circle TTS config changed since the run started. Resuming with the new config \u2014 pages already converted remain on the previous voice."
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex gap-2 items-center",
        children: [!running ? /* @__PURE__ */ jsx(LoadingButton, {
          onClick: allReady ? () => {
          } : readyCount > 0 ? resumeRun : startRun,
          variant: "contained",
          color: "primary",
          disabled: !config || allReady,
          children: allReady ? "All Done" : readyCount > 0 ? "Resume" : "Start"
        }) : /* @__PURE__ */ jsx(LoadingButton, {
          onClick: stopRun,
          variant: "outlined",
          color: "secondary",
          children: "Stop"
        }), /* @__PURE__ */ jsx(TextField$1, {
          label: "Concurrent pages",
          type: "number",
          size: "small",
          variant: "outlined",
          value: concurrency === 0 ? "" : concurrency,
          onChange: (e) => {
            const v = e.target.value;
            if (v === "") {
              setConcurrency(0);
              return;
            }
            const n = parseInt(v, 10);
            if (Number.isFinite(n))
              setConcurrency(Math.max(0, Math.min(10, n)));
          },
          onBlur: () => {
            if (!concurrency || concurrency < 1)
              setConcurrency(1);
          },
          inputProps: {
            min: 1,
            max: 10,
            style: {
              width: 150
            }
          },
          disabled: running,
          title: "Pages converted in parallel (1\u201310). Lower if you see 429 rate-limit errors. OpenAI tts-1-hd tier-1 is 7 req/min."
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "flex flex-col gap-2",
        children: rows.map((row) => /* @__PURE__ */ jsx(RowItem, {
          row,
          onRetry: () => retryRow(row)
        }, row.pageId))
      })]
    })]
  });
};
const TTSConverterPage = ({
  circleId: circleIdProp
}) => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const circleIdFromUrl = path[2];
  const circleId = circleIdProp || circleIdFromUrl;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(PageCssOverrides$1, {}), /* @__PURE__ */ jsx(TTSConverterPanel, {
      circleId
    })]
  });
};

const parseRoute = () => {
  const parts = window.location.pathname.split("/");
  const postId = parts[3];
  const uuid = parts[4];
  if (!postId || !uuid)
    return null;
  return {
    postId,
    uuid
  };
};
const AttachmentWorkspacePage = () => {
  const route = parseRoute();
  if (!route) {
    return /* @__PURE__ */ jsx(NsPageShell, {
      children: /* @__PURE__ */ jsx("div", {
        className: "p-8 text-sm text-red-500",
        children: "Invalid URL \u2014 expected /trans/attachment/:postId/:uuid"
      })
    });
  }
  return /* @__PURE__ */ jsx(NsPageShell, {
    children: /* @__PURE__ */ jsx(PostAttachmentsProvider, {
      postId: route.postId,
      children: /* @__PURE__ */ jsx(AttachmentProvider, {
        uuid: route.uuid,
        children: /* @__PURE__ */ jsx(AttachmentWorkspaceInner, {})
      })
    })
  });
};

const interviewSections = [{
  tab: "core",
  label: "General",
  labelId: "meta.tab.core",
  fields: metadataFields
}, {
  tab: "interview",
  label: "Interview",
  labelId: "meta.tab.interview",
  fields: interviewFields
}];

const InterviewPostMetadata = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter((p) => p);
  const postId = path[2];
  return /* @__PURE__ */ jsx(NsPageShell, {
    children: /* @__PURE__ */ jsx("div", {
      className: "p-6 max-w-4xl mx-auto",
      children: /* @__PURE__ */ jsxs(PostMetadataProvider, {
        postId,
        sections: interviewSections,
        children: [/* @__PURE__ */ jsx(PostMetadataBreadcrumb, {}), /* @__PURE__ */ jsx(MetadataEditorShell, {})]
      })
    })
  });
};

const NumberInputPopover = ({
  reference,
  isOpen,
  onClose,
  onConfirm,
  min = 1,
  max,
  initial = min,
  label,
  confirmLabel = "Go",
  placement = "top"
}) => {
  const [value, setValue] = useState(String(initial));
  const inputRef = useRef(null);
  const floatingRef = useRef(null);
  const {
    refs,
    x,
    y,
    strategy
  } = useFloating({
    placement,
    middleware: [offset(8), flip(), shift({
      padding: 8
    })],
    whileElementsMounted: autoUpdate
  });
  useEffect(() => {
    refs.setReference(reference);
  }, [reference]);
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    setValue(String(initial));
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }, 0);
  }, [isOpen, initial]);
  useClickAway(onClose, floatingRef);
  if (!isOpen) {
    return null;
  }
  const handleConfirm = () => {
    const num = parseInt(value);
    if (isNaN(num) || num < min || max !== void 0 && num > max) {
      return;
    }
    onConfirm(num);
    onClose();
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleConfirm();
    }
    if (e.key === "Escape") {
      onClose();
    }
  };
  return /* @__PURE__ */ jsx(FloatingPortal, {
    children: /* @__PURE__ */ jsxs("div", {
      ref: (el) => {
        refs.setFloating(el);
        floatingRef.current = el;
      },
      style: {
        position: strategy,
        top: y || 0,
        left: x || 0,
        pointerEvents: "auto"
      },
      className: "z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-3 flex items-center gap-2",
      children: [label && /* @__PURE__ */ jsx("span", {
        className: "text-sm text-gray-600 whitespace-nowrap",
        children: label
      }), /* @__PURE__ */ jsx("input", {
        ref: inputRef,
        type: "number",
        min,
        max,
        value,
        onChange: (e) => setValue(e.target.value),
        onKeyDown: handleKeyDown,
        className: "w-16 px-2 py-1 text-sm border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
      }), /* @__PURE__ */ jsx(ActionButton, {
        size: "sm",
        intent: "primary",
        onClick: handleConfirm,
        children: confirmLabel
      })]
    })
  });
};

const dividerVariants = cva("bg-gray-200 flex-shrink-0", {
  variants: {
    orientation: {
      horizontal: "w-full h-px",
      vertical: "h-5 w-px"
    },
    size: {
      sm: "",
      md: "",
      lg: ""
    }
  },
  compoundVariants: [{
    orientation: "vertical",
    size: "sm",
    className: "h-3"
  }, {
    orientation: "vertical",
    size: "md",
    className: "h-5"
  }, {
    orientation: "vertical",
    size: "lg",
    className: "h-7"
  }, {
    orientation: "horizontal",
    size: "sm",
    className: "my-1"
  }, {
    orientation: "horizontal",
    size: "md",
    className: "my-2"
  }, {
    orientation: "horizontal",
    size: "lg",
    className: "my-4"
  }],
  defaultVariants: {
    orientation: "vertical",
    size: "md"
  }
});
const Divider = ({
  orientation,
  size,
  className
}) => /* @__PURE__ */ jsx("span", {
  className: dividerVariants({
    orientation,
    size,
    className
  }),
  role: "separator",
  "aria-orientation": orientation || "vertical"
});

const InterviewPageNav = ({
  onSave,
  isSaving
}) => {
  const {
    pageCount,
    currentPageIndex,
    setCurrentPageIndex,
    addPage,
    removePage,
    lastPageIndex,
    movePage
  } = useInterviewEditor();
  const [movePopoverOpen, setMovePopoverOpen] = useState(false);
  const moveButtonRef = useRef(null);
  const handleMove = (targetPage) => {
    movePage(currentPageIndex, targetPage - 1);
  };
  const total = pageCount;
  const current = currentPageIndex === null ? lastPageIndex : currentPageIndex;
  const onPageChange = (index) => {
    setCurrentPageIndex(index);
  };
  const {
    open: openDropConfirmation,
    confirmationProps
  } = useConfirmation({
    onConfirm: () => removePage(currentPageIndex),
    title: "Remove Page",
    message: `Are you sure you want to remove page ${currentPageIndex !== null ? currentPageIndex + 1 : ""}? This action cannot be undone.`,
    confirmText: "Remove Page",
    cancelText: "Cancel",
    confirmIntent: "danger"
  });
  const additionalControls = /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Divider, {}), /* @__PURE__ */ jsx(ActionButton, {
      intent: "white",
      size: "sm",
      onClick: addPage,
      "aria-label": "Add page",
      title: "Add page after current",
      children: /* @__PURE__ */ jsx(MdAdd, {
        className: "w-4 h-4"
      })
    }), currentPageIndex !== null && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(ActionButton, {
        intent: "white",
        size: "sm",
        onClick: openDropConfirmation,
        "aria-label": "Remove page",
        title: "Remove current page",
        children: /* @__PURE__ */ jsx(MdDelete, {
          className: "w-4 h-4"
        })
      }), /* @__PURE__ */ jsx(Divider, {}), /* @__PURE__ */ jsx(ActionButton, {
        ref: moveButtonRef,
        intent: "white",
        size: "sm",
        onClick: () => setMovePopoverOpen(true),
        tooltip: "Move page to position",
        children: /* @__PURE__ */ jsx(MdSwapVert, {
          className: "w-4 h-4"
        })
      }), /* @__PURE__ */ jsx(NumberInputPopover, {
        reference: moveButtonRef.current,
        isOpen: movePopoverOpen,
        onClose: () => setMovePopoverOpen(false),
        onConfirm: handleMove,
        min: 1,
        max: pageCount,
        initial: currentPageIndex !== null ? currentPageIndex + 1 : 1,
        label: "Move to page:",
        confirmLabel: "Move"
      })]
    }), /* @__PURE__ */ jsx(Divider, {}), /* @__PURE__ */ jsx(ActionButton, {
      intent: "white",
      size: "sm",
      onClick: onSave,
      isLoading: isSaving,
      "aria-label": "Save",
      title: "Save",
      children: /* @__PURE__ */ jsx(MdSave, {
        className: "w-4 h-4"
      })
    })]
  });
  const onFocus = () => {
    if (currentPageIndex === null) {
      setCurrentPageIndex(lastPageIndex);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex items-center gap-1",
      children: [pageCount > 0 && /* @__PURE__ */ jsx(ActionButton, {
        intent: currentPageIndex === null ? "primary" : "whiteOutline",
        size: "sm",
        onClick: () => setCurrentPageIndex(currentPageIndex === null ? lastPageIndex : null),
        "aria-current": currentPageIndex === null ? "page" : void 0,
        title: currentPageIndex === null ? "Switch to last page" : "Switch to main",
        children: "Main"
      }), total > 0 && /* @__PURE__ */ jsx(PaginationControls, {
        current,
        total,
        onPageChange,
        justify: "start",
        onFocus,
        additionalControls,
        readOnly: currentPageIndex === null
      }), total === 0 && additionalControls]
    }), /* @__PURE__ */ jsx(ConfirmationOverlay, {
      ...confirmationProps
    })]
  });
};

const InterviewPublishButton = ({
  onSave
}) => {
  const {
    publish
  } = useInterviewEditor();
  const {
    execute,
    isLoading
  } = useAsyncOperation(async () => {
    await onSave();
    await publish();
  }, {
    showSuccessToast: "Post published successfully",
    successTitle: "Published",
    showErrorToast: true
  });
  const onClick = useMemoizedFn(() => execute());
  return /* @__PURE__ */ jsxs(ActionButton, {
    intent: "primary",
    size: "sm",
    onClick,
    isLoading,
    tooltip: "Save and notify circle followers",
    children: [/* @__PURE__ */ jsx(MdPublish, {
      className: "w-4 h-4 mr-1"
    }), "Publish"]
  });
};

const InterviewPageEditor = ({
  postId
}) => {
  const {
    save,
    appendHtmlCommand
  } = useInterviewEditor();
  const {
    editor,
    setEditor,
    images_upload_handler
  } = useTinyEditorSetup$1();
  const prevAppendHtmlCommand = useRef(appendHtmlCommand);
  useEffect(() => {
    if (!editor || appendHtmlCommand === prevAppendHtmlCommand.current || !appendHtmlCommand)
      return;
    editor.setContent(editor.getContent() + appendHtmlCommand.html);
    editor.setDirty(true);
  }, [appendHtmlCommand]);
  const {
    post,
    loading,
    error
  } = useLoadInterview(postId);
  const {
    execute,
    isLoading: isSaving
  } = useAsyncOperation(async () => {
    if (!editor || !editor.isDirty()) {
      return;
    }
    const content = getContentInfo(editor.getContent());
    await withRetry(() => save(postId, {
      content,
      title: content.nsTitle,
      image: content.nsImage
    }));
    editor.setDirty(false);
  });
  useEffect(() => {
    if (!editor || !post) {
      return;
    }
    editor.setContent(post.content && post.content.nsHtml ? post.content.nsHtml : "");
    editor.setDirty(false);
  }, [editor, !!post]);
  useEffect(() => {
    return () => {
      execute();
    };
  }, []);
  useInterval(() => {
    execute();
  }, 3e4);
  const onSave = useMemoizedFn(() => execute());
  if (loading) {
    return /* @__PURE__ */ jsx(LoadingOverlay, {
      isOpen: true,
      message: "Loading page..."
    });
  }
  if (error || !post) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-4 text-red-600 text-sm",
      children: "Failed to load page content."
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsx(InterviewPageNav, {
      onSave,
      isSaving
    }), /* @__PURE__ */ jsx(TinyEditor, {
      content: post.content && post.content.nsHtml ? post.content.nsHtml : "",
      setEditor,
      autoresize: true,
      settings: {
        height: 400,
        auto_focus: "none",
        menubar: false,
        images_upload_handler
      }
    }), /* @__PURE__ */ jsx("div", {
      className: "flex justify-end",
      children: /* @__PURE__ */ jsx(InterviewPublishButton, {
        onSave
      })
    })]
  });
};

const InterviewBreadcrumb = () => {
  const {
    root
  } = useInterviewEditor();
  const circleId = circleIdForPost(root);
  const {
    data: circleData
  } = useCircle(circleId);
  const circle = circleData && circleData.group || root && root.group.group;
  const parent = circle && circle.parent;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex justify-start items-center w-full relative gap-1.5 flex-wrap",
    children: [/* @__PURE__ */ jsx(DashboardLink, {}), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: myCirclesUrl(),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: /* @__PURE__ */ jsx(FormattedMessage, {
          id: "dashboard.circles"
        })
      })
    }), parent && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(parent),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: "..."
        })
      })]
    }), circle && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
        to: circleUrl(circle._id),
        children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
          children: circle.name
        })
      })]
    }), /* @__PURE__ */ jsx(Next, {}), /* @__PURE__ */ jsx(Link$2, {
      to: url4post(root),
      children: /* @__PURE__ */ jsx(StyledBreadCrumb, {
        children: root.title || "Interview"
      })
    })]
  });
};

const INITIAL_STATE = {
  phase: "idle",
  result: null,
  error: null
};
const useExecuteAssistantPrompt = (params) => {
  const api = useApi();
  const jwt = useJwt();
  const [state, setState] = useState(INITIAL_STATE);
  const [url, setUrl] = useState("");
  const execute = useMemoizedFn(() => {
    const { assistantId, circleId, promptId, postId } = params;
    setState({ phase: "running", result: null, error: null });
    const query = { assistantId, circleId, promptId, token: jwt };
    if (postId) {
      query.postId = postId;
    }
    setUrl(api.buildUrl("/ui-assistants/execute", query));
  });
  const reset = useMemoizedFn(() => {
    setUrl("");
    setState(INITIAL_STATE);
  });
  useSSEConnection({
    url,
    enabled: url !== "",
    maxReconnectAttempts: 0
  }, [
    {
      event: "complete",
      handler: (data) => {
        setUrl("");
        setState({
          phase: "done",
          result: data && data.result ? data.result : null,
          error: null
        });
      }
    },
    {
      event: "failed",
      handler: (data) => {
        setUrl("");
        setState({
          phase: "error",
          result: null,
          error: data && data.message ? data.message : "Unknown error"
        });
      }
    }
  ]);
  return { ...state, execute, reset };
};

const AssistantPromptButton = ({
  assistantId,
  circleId,
  promptId,
  postId,
  label,
  onResult
}) => {
  const {
    phase,
    result,
    error,
    execute,
    reset
  } = useExecuteAssistantPrompt({
    assistantId,
    circleId,
    promptId,
    postId
  });
  useEffect(() => {
    if (phase === "done" && result && onResult) {
      onResult(result);
    }
  }, [phase, result]);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2",
    children: [/* @__PURE__ */ jsx(ActionButton, {
      intent: "primary",
      size: "sm",
      onClick: execute,
      isLoading: phase === "running",
      loadingText: "Running\u2026",
      children: label || "Run"
    }), error && /* @__PURE__ */ jsxs("div", {
      className: "text-sm text-red-600",
      children: [error, /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "xs",
        onClick: reset,
        className: "ml-2",
        children: "Retry"
      })]
    }), phase === "done" && result && /* @__PURE__ */ jsx("div", {
      className: "prose prose-sm max-w-none",
      dangerouslySetInnerHTML: {
        __html: result
      }
    })]
  });
};

const MetadataAiDiff = ({
  current,
  proposed,
  onApply,
  onDiscard
}) => {
  const [rejected, setRejected] = useState(new Set());
  const toggleReject = useMemoizedFn((key) => {
    setRejected((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  });
  const onApplyClick = useMemoizedFn(() => {
    const accepted = {};
    Object.keys(proposed).forEach((k) => {
      if (!rejected.has(k)) {
        accepted[k] = proposed[k];
      }
    });
    onApply(accepted);
  });
  const rows = Object.keys(proposed);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 rounded border border-blue-200 bg-blue-50 p-3 text-sm",
    children: [/* @__PURE__ */ jsx("div", {
      className: "font-medium text-blue-800",
      children: "AI suggested changes"
    }), /* @__PURE__ */ jsxs("table", {
      className: "w-full text-xs",
      children: [/* @__PURE__ */ jsx("thead", {
        children: /* @__PURE__ */ jsxs("tr", {
          className: "text-left text-gray-500",
          children: [/* @__PURE__ */ jsx("th", {
            className: "pb-1 pr-2 font-normal",
            children: "Field"
          }), /* @__PURE__ */ jsx("th", {
            className: "pb-1 pr-2 font-normal",
            children: "Current"
          }), /* @__PURE__ */ jsx("th", {
            className: "pb-1 pr-2 font-normal",
            children: "Suggested"
          }), /* @__PURE__ */ jsx("th", {
            className: "pb-1 font-normal"
          })]
        })
      }), /* @__PURE__ */ jsx("tbody", {
        children: rows.map((key) => {
          const isRejected = rejected.has(key);
          return /* @__PURE__ */ jsxs("tr", {
            className: isRejected ? "opacity-40 line-through" : "",
            children: [/* @__PURE__ */ jsx("td", {
              className: "py-0.5 pr-2 font-mono text-gray-600",
              children: key
            }), /* @__PURE__ */ jsx("td", {
              className: "py-0.5 pr-2 text-gray-400",
              children: String(current[key] || "\u2014")
            }), /* @__PURE__ */ jsx("td", {
              className: "py-0.5 pr-2 text-gray-900",
              children: String(proposed[key])
            }), /* @__PURE__ */ jsx("td", {
              className: "py-0.5",
              children: /* @__PURE__ */ jsx("button", {
                onClick: () => toggleReject(key),
                className: "text-xs text-gray-400 hover:text-red-500 underline",
                children: isRejected ? "restore" : "reject"
              })
            })]
          }, key);
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex gap-2 pt-1",
      children: [/* @__PURE__ */ jsx(ActionButton, {
        intent: "primary",
        size: "sm",
        onClick: onApplyClick,
        children: "Apply"
      }), /* @__PURE__ */ jsx(ActionButton, {
        intent: "secondary",
        size: "sm",
        onClick: onDiscard,
        children: "Discard all"
      })]
    })]
  });
};

const POSITION = "post.metadata";
const getPromptId = (prompt) => {
  if (!prompt)
    return null;
  if (typeof prompt === "string")
    return prompt;
  return prompt._id && String(prompt._id) || null;
};
const stripEmpty = (obj) => {
  const out = {};
  Object.keys(obj).forEach((key) => {
    const v = obj[key];
    if (v === null || v === void 0)
      return;
    if (typeof v === "string" && v.trim() === "")
      return;
    if (Array.isArray(v) && v.length === 0)
      return;
    out[key] = v;
  });
  return out;
};
const changedOnly = (current, proposed) => {
  const cur = current || {};
  const out = {};
  Object.keys(proposed).forEach((key) => {
    if (JSON.stringify(cur[key]) !== JSON.stringify(proposed[key])) {
      out[key] = proposed[key];
    }
  });
  return out;
};
const MetadataAiButtons = () => {
  const {
    root
  } = useInterviewEditor();
  const circleId = circleIdForPost(root);
  const {
    data
  } = useAssistants(circleId);
  const {
    metadata,
    setMetadata
  } = usePostMetadataCtx();
  const {
    showSuccess,
    showError
  } = useToastHelpers();
  const [pendingChanges, setPendingChanges] = useState(null);
  const assistants = data && data.assistants || [];
  const entries = [];
  assistants.forEach((assistant) => {
    const prompts = assistant.prompts || [];
    prompts.forEach((p) => {
      if (p.position === POSITION && p.prompt) {
        const promptId = getPromptId(p.prompt);
        if (promptId) {
          entries.push({
            assistantId: assistant._id,
            promptId,
            name: p.name
          });
        }
      }
    });
  });
  const onResult = useMemoizedFn((result) => {
    try {
      const parsed = JSON.parse(result);
      if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
        showError("AI returned an unexpected format");
        return;
      }
      const meaningful = changedOnly(metadata, stripEmpty(parsed));
      if (Object.keys(meaningful).length === 0) {
        showSuccess("AI found nothing new to add");
        setPendingChanges(null);
        return;
      }
      setPendingChanges(meaningful);
    } catch (e) {
      showError("Could not parse AI response as JSON");
    }
  });
  const onApply = useMemoizedFn((accepted) => {
    setMetadata({
      ...metadata,
      ...accepted
    });
    setPendingChanges(null);
    showSuccess("Metadata updated \u2014 review and save");
  });
  const onDiscard = useMemoizedFn(() => {
    setPendingChanges(null);
  });
  if (!entries.length) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-2 pt-2",
    children: [entries.map(({
      assistantId,
      promptId,
      name
    }) => /* @__PURE__ */ jsx(AssistantPromptButton, {
      assistantId,
      circleId,
      promptId,
      postId: root._id,
      label: name || "Fill with AI",
      onResult
    }, assistantId + promptId)), pendingChanges && /* @__PURE__ */ jsx(MetadataAiDiff, {
      current: metadata,
      proposed: pendingChanges,
      onApply,
      onDiscard
    })]
  });
};

const InterviewEditor = () => {
  const {
    currentPostId,
    currentPageIndex,
    root
  } = useInterviewEditor();
  const {
    showSuccess
  } = useToastHelpers();
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col gap-4",
    children: [/* @__PURE__ */ jsx(InterviewBreadcrumb, {}), /* @__PURE__ */ jsx(CollapsibleSection, {
      title: "Media",
      defaultCollapsed: false,
      keepMounted: true,
      variant: "default",
      titleSize: "sm",
      toggleSize: "sm",
      children: /* @__PURE__ */ jsx(PostAttachmentsScreen, {
        postId: root._id,
        compact: true
      })
    }), /* @__PURE__ */ jsx(CollapsibleSection, {
      title: "Body text",
      defaultCollapsed: true,
      keepMounted: true,
      variant: "default",
      titleSize: "sm",
      toggleSize: "sm",
      children: /* @__PURE__ */ jsx(InterviewPageEditor, {
        postId: currentPostId
      }, currentPostId)
    }), /* @__PURE__ */ jsx(CollapsibleSection, {
      title: "Metadata",
      defaultCollapsed: true,
      keepMounted: true,
      variant: "default",
      titleSize: "sm",
      toggleSize: "sm",
      children: /* @__PURE__ */ jsxs(PostMetadataProvider, {
        postId: root._id,
        sections: interviewSections,
        onAfterSave: () => {
          showSuccess("Metadata saved");
        },
        children: [/* @__PURE__ */ jsx(MetadataEditorShell, {}), /* @__PURE__ */ jsx(MetadataAiButtons, {})]
      })
    })]
  });
};

const EditInterviewPage = () => {
  const location = useLocation();
  const all = location.pathname.split("/").filter((v) => v);
  const postId = all[all.length - 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(EditInterviewPageInner, {
      postId
    })]
  });
};
const EditInterviewPageInner = ({
  postId
}) => {
  const {
    post,
    loading,
    error
  } = useLoadInterview(postId);
  if (loading) {
    return /* @__PURE__ */ jsx(LoadingOverlay, {
      isOpen: true,
      message: "Loading interview..."
    });
  }
  if (error || !post) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-8 text-red-600",
      children: "Failed to load interview."
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("ns sm:px-[54px] text-base w-full pb-4 min-h-screen"),
    "data-testid": "EditInterviewPage",
    children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx(InterviewEditorProvider, {
      initialPost: post,
      children: /* @__PURE__ */ jsx("div", {
        className: "flex w-full flex-col gap-2 p-2",
        children: /* @__PURE__ */ jsx(InterviewEditor, {})
      })
    })]
  });
};

const InterviewEditContentLink = () => {
  const {
    root
  } = useInterviewEditor();
  const history = useHistory();
  return /* @__PURE__ */ jsx(IconButton$2, {
    onClick: () => history.push(editInterviewUrl(root)),
    title: "Edit content",
    "aria-label": "Edit content",
    children: /* @__PURE__ */ jsx(MdEdit, {})
  });
};
const InterviewEditMetadataLink = () => {
  const {
    root
  } = useInterviewEditor();
  const history = useHistory();
  return /* @__PURE__ */ jsx(IconButton$2, {
    onClick: () => history.push(editMetadataUrl(root)),
    title: "Edit metadata",
    "aria-label": "Edit metadata",
    children: /* @__PURE__ */ jsx(HiTag, {})
  });
};
const InterviewNavLinks = () => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-1",
    children: [/* @__PURE__ */ jsx(InterviewEditMetadataLink, {}), /* @__PURE__ */ jsx(InterviewEditContentLink, {})]
  });
};

const PublishDraftButton = ({
  onSave
}) => {
  const {
    publishDraft
  } = useInterviewEditor();
  const history = useHistory();
  const {
    execute,
    isLoading
  } = useAsyncOperation(async () => {
    await onSave();
    const newPost = await publishDraft();
    history.push(postCircleUrl(newPost));
  }, {
    showSuccessToast: "Post published successfully",
    successTitle: "Published",
    showErrorToast: true
  });
  const onClick = useMemoizedFn(() => execute());
  return /* @__PURE__ */ jsxs(ActionButton, {
    intent: "primary",
    size: "sm",
    onClick,
    isLoading,
    tooltip: "Publish to the target circle",
    children: [/* @__PURE__ */ jsx(MdPublish, {
      className: "w-4 h-4 mr-1"
    }), "Publish"]
  });
};

const InterviewUploadActions = () => {
  const {
    root
  } = useInterviewEditor();
  const {
    data: circleData
  } = useCircle(circleIdForPost(root));
  const api = useApi();
  const history = useHistory();
  const {
    execute: doUnpublish,
    isLoading
  } = useAsyncOperation(async () => {
    await api.unpublishPost({
      _id: root._id
    });
    const circle = circleData && circleData.group || root.group.group;
    history.push(circleUrl(circle._id));
  });
  const {
    open,
    confirmationProps
  } = useConfirmation({
    onConfirm: () => doUnpublish(),
    title: "Unpublish interview",
    message: "Are you sure you want to unpublish this interview?"
  });
  const noOpSave = async () => {
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex items-center gap-2",
    children: [/* @__PURE__ */ jsx(InterviewNavLinks, {}), /* @__PURE__ */ jsx(PublishDraftButton, {
      onSave: noOpSave
    }), /* @__PURE__ */ jsx(ActionButton, {
      intent: "danger",
      size: "sm",
      isLoading,
      leftIcon: /* @__PURE__ */ jsx(MdUnpublished, {
        size: 16
      }),
      onClick: open,
      children: "Cancel"
    }), /* @__PURE__ */ jsx(ConfirmationOverlay, {
      ...confirmationProps
    })]
  });
};

const InterviewUploadPage = () => {
  const location = useLocation();
  const all = location.pathname.split("/").filter((v) => v);
  const postId = all[all.length - 1];
  return /* @__PURE__ */ jsxs(ToastProvider, {
    children: [/* @__PURE__ */ jsx(ToastContainer, {}), /* @__PURE__ */ jsx(InterviewUploadPageInner, {
      postId
    })]
  });
};
const InterviewUploadPageInner = ({
  postId
}) => {
  const {
    post,
    loading,
    error
  } = useLoadInterview(postId);
  const circleId = post ? circleIdForPost(post) : "";
  const {
    data: circleData
  } = useCircle(circleId);
  const circle = circleData && circleData.group;
  if (loading) {
    return /* @__PURE__ */ jsx(LoadingOverlay, {
      isOpen: true,
      message: "Loading interview..."
    });
  }
  if (error || !post) {
    return /* @__PURE__ */ jsx("div", {
      className: "p-8 text-red-600",
      children: "Failed to load interview."
    });
  }
  return /* @__PURE__ */ jsxs("div", {
    className: clsx("ns sm:px-[54px] text-base w-full pb-4 min-h-screen"),
    "data-testid": "InterviewUploadPage",
    children: [/* @__PURE__ */ jsx(PageCssOverrides, {}), /* @__PURE__ */ jsx(InterviewEditorProvider, {
      initialPost: post,
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex w-full flex-col items-start gap-4 p-2",
        children: [/* @__PURE__ */ jsxs("div", {
          className: "flex items-center justify-between gap-3 w-full",
          children: [/* @__PURE__ */ jsx(InterviewBreadcrumb, {}), /* @__PURE__ */ jsx(InterviewUploadActions, {})]
        }), /* @__PURE__ */ jsxs("div", {
          className: "flex flex-col items-start gap-2",
          children: [/* @__PURE__ */ jsx("h1", {
            className: "text-2xl font-bold",
            children: "Create Multimedia Post"
          }), circle && /* @__PURE__ */ jsxs("p", {
            className: "text-gray-600 font-semibold",
            children: ["For circle:", /* @__PURE__ */ jsx("a", {
              href: circleUrl(circle._id),
              className: "text-blue-600",
              children: /* @__PURE__ */ jsx("span", {
                className: "underline mx-2",
                children: circle.name
              })
            })]
          }), /* @__PURE__ */ jsx("p", {
            className: "text-sm text-gray-600 max-w-2xl",
            children: "Please upload all elements of an Interview below such as Word document, Images, audio, or Video file. You can use the Folder option to upload all Interview elements in one step."
          })]
        }), /* @__PURE__ */ jsx(PostAttachmentsScreen, {
          postId: post._id,
          layout: "full"
        })]
      })
    })]
  });
};

const TransNotFound = () => {
  return /* @__PURE__ */ jsx("span", {
    children: "no such page"
  });
};
const TransientRootInner = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const path = location.pathname.split("/").filter((p) => p);
  const prefix = "/trans";
  if (pathname.startsWith(prefix + "/groups")) {
    return /* @__PURE__ */ jsx(TransientGroups, {});
  }
  if (pathname.startsWith(prefix + "/post-connect-asset")) {
    return /* @__PURE__ */ jsx(StartNewEventPage, {});
  }
  if (pathname.startsWith(prefix + "/post-view")) {
    return /* @__PURE__ */ jsx(PostViewRedirect, {});
  }
  if (pathname.startsWith(prefix + "/configure-dashboard")) {
    return /* @__PURE__ */ jsx(ConfigureDashboard, {});
  }
  if (pathname.startsWith(prefix + "/configure-harvesting")) {
    return /* @__PURE__ */ jsx(ConfigureCircleHarvesting, {});
  }
  if (pathname.startsWith(prefix + "/configure-wair-harvesting")) {
    return /* @__PURE__ */ jsx(ConfigureCircleHarvestingWair, {});
  }
  if (pathname.startsWith(prefix + "/user-mobiles")) {
    return /* @__PURE__ */ jsx(UserMobiles, {});
  }
  if (pathname.startsWith(prefix + "/configure-circle-map")) {
    return /* @__PURE__ */ jsx(CircleMapConfigPage, {});
  }
  if (pathname.startsWith(prefix + "/map-clustering-config")) {
    return /* @__PURE__ */ jsx(MapClusteringConfigPage, {});
  }
  if (pathname.startsWith(prefix + "/circle-map")) {
    return /* @__PURE__ */ jsx(CircleMapPage, {});
  }
  if (pathname.startsWith(prefix + "/circle-config-ui")) {
    return /* @__PURE__ */ jsx(CircleConfigPage, {});
  }
  if (pathname.startsWith(prefix + "/circle-config-translation")) {
    return /* @__PURE__ */ jsx(ConfigureTranslationPage, {});
  }
  if (pathname.startsWith(prefix + "/circle-assistant")) {
    return /* @__PURE__ */ jsx(CircleAssistant, {});
  }
  if (pathname.startsWith(prefix + "/import-openref")) {
    return /* @__PURE__ */ jsx(ImportOpenRefPage, {});
  }
  if (pathname.startsWith(prefix + "/alliancenews")) {
    return /* @__PURE__ */ jsx(ANRoot, {});
  }
  if (pathname.startsWith(prefix + "/admin")) {
    return /* @__PURE__ */ jsx(AdminRoot, {});
  }
  if (pathname.startsWith(prefix + "/circle-view-assistant")) {
    return /* @__PURE__ */ jsx(CircleAssistantView, {});
  }
  if (pathname.startsWith(prefix + "/circle-feedback-assistant")) {
    return /* @__PURE__ */ jsx(CircleAssistantFeedbackView, {});
  }
  if (pathname.startsWith(prefix + "/circle-chat")) {
    return /* @__PURE__ */ jsx(CircleChatPage, {});
  }
  if (pathname.startsWith(prefix + "/ai-chat")) {
    return /* @__PURE__ */ jsx(CircleAiChatPage, {});
  }
  if (pathname.startsWith(prefix + "/pdf-import")) {
    return /* @__PURE__ */ jsx(MultiImportPage, {});
  }
  if (pathname.startsWith(prefix + "/post-metadata")) {
    return /* @__PURE__ */ jsx(PostMetadata, {});
  }
  if (pathname.startsWith(prefix + "/interview-metadata")) {
    return /* @__PURE__ */ jsx(InterviewPostMetadata, {});
  }
  if (pathname.startsWith(prefix + "/config")) {
    return /* @__PURE__ */ jsx(ConfigurationPage, {
      page: "welcome"
    });
  }
  if (pathname.startsWith(prefix + "/edit-asset")) {
    return /* @__PURE__ */ jsx(EditAssetPage, {});
  }
  if (pathname.startsWith(prefix + "/edit-event")) {
    return /* @__PURE__ */ jsx(EditEventPage, {});
  }
  if (pathname.startsWith(prefix + "/edit-post")) {
    return /* @__PURE__ */ jsx(EditPostPage, {});
  }
  if (pathname.startsWith(prefix + "/edit-interview")) {
    return /* @__PURE__ */ jsx(EditInterviewPage, {});
  }
  if (pathname.startsWith(prefix + "/upload-interview")) {
    return /* @__PURE__ */ jsx(InterviewUploadPage, {});
  }
  if (pathname.startsWith(prefix + "/combine-posts")) {
    return /* @__PURE__ */ jsx(CombinePostsPage, {});
  }
  if (pathname.startsWith(prefix + "/attachment")) {
    return /* @__PURE__ */ jsx(AttachmentWorkspacePage, {});
  }
  if (pathname.startsWith(prefix + "/tts-converter")) {
    const circleId = path[2];
    return /* @__PURE__ */ jsx(TTSConverterPage, {
      circleId
    });
  }
  if (pathname.startsWith(prefix + "/tts")) {
    const circleId = path[2];
    return /* @__PURE__ */ jsx(TTSPage, {
      circleId
    });
  }
  return /* @__PURE__ */ jsx(TransNotFound, {});
};
const TransientRoot = () => {
  return /* @__PURE__ */ jsx(SWRProfileContextProvider, {
    children: /* @__PURE__ */ jsx(TransientRootInner, {})
  });
};

const usePasskeyEnroll = () => {
  const api = useApi();
  const [available, setAvailable] = useState(false);
  const [count, setCount] = useState(null);
  useEffect(() => {
    {
      return;
    }
  }, []);
  const enroll = useAsyncOperation(async () => {
    try {
      const options = await api.webauthnRegisterOptions();
      const attestation = await startRegistration(options);
      const result = await api.webauthnRegisterVerify({ response: attestation });
      setCount(result.credentialCount);
    } catch (e) {
      console.error("passkey enroll failed:", e && e.name, e && e.message, e);
      throw e;
    }
  }, { showErrorToast: false });
  return {
    available,
    count,
    hasPasskey: (count || 0) > 0,
    enroll
  };
};

const PasskeyEnrollButton = () => {
  const {
    available,
    hasPasskey,
    enroll
  } = usePasskeyEnroll();
  if (!available) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(LoadingButtonTW, {
      background: "secondary",
      loading: enroll.isLoading,
      onClick: () => enroll.execute(),
      className: "w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: enroll.isSuccess || hasPasskey ? "auth.passkeyAdded" : "auth.passkeyAdd"
      })
    }), enroll.error && /* @__PURE__ */ jsx("div", {
      className: "text-red-500 text-sm w-full",
      children: /* @__PURE__ */ jsx(FormattedMessage, {
        id: "auth.passkeyEnrollFailed"
      })
    })]
  });
};

export { API, APIProvider, ARABIC, AVAILABLE_LANGUAGES, AccessContext, AccessContextProvider, AccessDenied, AccessDeniedCircle, AccessDeniedPostView, ActivityContext, ActivityContextProvider, AdditionalEventControls, AdminToolsContext, AdminToolsContextProvider, AdminToolsPanel, AdminToolsToggle, AdminVoteButton, AllResponses, ApiContext, AppComponentsContext, AppComponentsContextProvider, AppError, ArticleMenu, ArticleSummaryCore, ArticleSummaryCore2, AssetsPlayground, AssistantIcon, AttendeesPopup, AuthorAndMeta, AuthorName, Avatar, BLOCK_EVENT_SAVE, BackOff, Badge$1 as Badge, Block, BlockContext, BlockContextProvider, BlocksContext, BlocksContextProvider, BlocksEditorDialog, BlocksList$1 as BlocksList, BlocksOrderContext, BlocksOrderContextProvider, BlocksToolbar, BookAuthGate, BookCairDashboardPageLive, BookCairDesktopLive, BookCairLivePage, BookCairMobileLive, BookCairProfilePageLive, BrowseBooksPageLive, CDNImageContext, CairPaymentPageLive, CairWelcomeBar, CairWelcomeBarConnected, CalendarIcon, Card, CardStyled, CardWithHeader, ChangeCirclePrivacyDialog, ChangeCirclePrivacyMenuItem, ChangePassword$1 as ChangePassword, CircleAccess, CircleAccessV2, CircleApiContext, CircleApiNoop, CircleApprovalPanel, CircleAssistantsList, CircleAssistantsListTest, CircleCard$1 as CircleCard, CircleContext, CircleContextProvider, CircleHeader, CircleHeaderImage, CircleHeaderImageInnerV2, CircleHeaderImageV2, CircleItem, CircleMenu, CircleModalDialogsContextProvider, CirclePage, CirclePageProviders, CirclePostRepliesBadge, CirclePostRepliesIcon, CirclePostVotingIcon, CirclePostsIcon, CirclePostsStateContext, CirclePostsStateContextProvider, CircleSearchContext, CircleSearchContextProvider, CircleStatTypes, CircleVotingIcon, ColumnButton, ConfigVoteDialog, ConfigurablePageTest, ConfigurationPage, ConfigureNotificationsDialog, ConfigureTabsDialog, ConfirmDeleteCircle, ConfirmDialog, ConfirmLogin, ConfirmationCode$1 as ConfirmationCode, Content$3 as Content, ContentCard, ContentContext, ContentContextProvider, ContextLinkToggle, ControlsContainer, CorePlayground, CreateAssetDialog, CreateAssetDialogV2, CssLink, CustomLanding, DAY, DEFAULT_LANGUAGE, DashboardPage, DashboardPageContextProvider, DefaultPostTypeDialog, DeleteCircleMenuItem, DetailsListItem, DialogIcon, DialogTitle, Disclosure, DiscoverCircleItem, DiscoverPage, DiscoverPageContextProvider, GiDiscussion as DiscussionIcon, DownloadCalendarMenuItem, DropZone$1 as DropZone, DropZoneContainer, DropZoneSection, DurationSelector, EDIT_PROFILE_URL, EMPTY_RANGE, Emitter, EmptyList$1 as EmptyList, EndDateSelector, EndDateTimeSelector, EndTimeSelector, EntityName, ErrorMessage, ErrorPanel$2 as ErrorPanel, ErrorPanelCircle, ErrorPanelPostView, ErrorPanelV2, ErrorPlaceholder, EventControls, EventData, EventImage, EventParticipantsList, EventParticipantsList2, EventPostSteps, EventStatus, EventTemporalData, ExecutePromptMenuItem, FILE_CDN_ROOT, FillForm, FinishEventButton, FlagPostMenuItem, FlaggedMessage, ForgotPassword$1 as ForgotPassword, FormActions, FormActionsHelper, FormContext, FormContextProvider, FormControl, FormDataContext, FormDataContextProvider, FormDatePicker, FormFieldHelper, FormHelper, FormView, GPopup, GirlIcon, GlobalCss, GoogleAuthContext, GoogleAuthContextProvider, GoogleAuthHelper, GoogleButton, GuestWithJoinOption, HOUR, HelpContext, HelpContextProvider, I18nProvider, IMAGE_CDN_ROOT, Image, ImportantMessage, InfoBox, InfoButton, InfoMessage, InvitesContext, InvitesContextProvider, InvitesList, ItemTextWrapper, JoinDialog, KeyboardDatePicker, LabelledField, LandingPage, LandingPagesTest, LanguageSelectionContext, LanguageSelectionContextProvider, LastNotesAccordion, LastVotedAccordion, LineWrapper, LinkToggle, ListItemDetails, LoadCircleData, LoadingButton, LoadingButtonStyled, LoadingPlaceholder$1 as LoadingPlaceholder, LockIcon, LoginForm$1 as LoginForm, LoginTextField, MINUTES, MemberLink, Mention, MoveAssetDialog, MoveToCircleList, MuiProvider, MuiSpinner, MyCircleVotingIcon, MyCirclesList, MyCirclesNavigation, MyCirclesPage, MyCirclesWithActivity, MyLibraryPageLive, NOTE_ADDED_EVENT, NS_CSS_PREFIX, NativeEventContext, NativeEventContextProvider, NewCustomLanding, NoteTypeIcon, NoteTypeSelector, NotificationsActionItem, NotificationsButton, NotificationsContext, NotificationsContextProvider, NotificationsList$1 as NotificationsList, NotificationsListItem, NotificationsPage, NotificationsTitle, NsAccordionSummary, Numbering, NumberingAndAuthor, ONE_DAY_IN_MILLISECONDS, ONE_HOUR_IN_MILLISECONDS, ONE_MINUTE_IN_MILLISECONDS, OPEN_ADD_NOTE_EVENT, OPEN_VOTE_EVENT, OpenAddNoteDetailsItem, OpenBrowser, OpenFullPostViewLink, OpenLastMobilePushNotifications, OpenStartNewEventMenuItem, OpenVoteDetailsItem, OpenedContext, OpenedContextProvider, OverflowIcon$2 as OverflowIcon, OverflowMenu, POST_UPDATE_EVENT, PROFILE_URL, PageCssOverrides$1 as PageCssOverrides, PageNotesList, PageVotedList, ParticipantsForRole, PasskeyEnrollButton, PaymentResultPageLive, PersonName, PersonNameContext, PhoneOtpFields, PhoneOtpForm, PlaygroundLink, PleaseWait, PleaseWaitDelayed, PleaseWaitV2, Polling, PostCard$2 as PostCard, PostContext, PostContextProvider, PostEditorContextProvider, PostFeatures, PostIcons, PostLink, PostListItemHeader, PostNotificationMessage, PostOnlineUsersDialog, PostPageList, PostPageVisitor, PostTinyEditor, PostTitle$2 as PostTitle, PostUpdatesContext, PostUpdatesContextProvider, PostViewDataContextCoreProvider, PostViewDataHelper, PostViewPage, PostVisitorContext, PostVoteButton, PostVotingIcon, PostWrapper, PostsElasticTest, PostsListItemAuthor, PostsOverflow, PrimaryButton, PrimaryButtonStyled, PrivacyDialog, PrivacyPolicyDialog, PrivacyText, ProfileBreadCrumbs, ProfileContext, ProfileContextProvider, ProfilePageNavigation, PurchasesPageLive, RATING_CREATED_EVENT, ReadTime, ReferencesCard, RegistrationContext, RegistrationContextProvider, RegistrationForm$1 as RegistrationForm, RelativeTime, RequiresRegistration, ResponseHeader, ResponseOuterDiv, ResponseRoutesContext, ResponseRoutesProvider, ResponseTagsPicker, ResponseTitle, ResponsesContext, ResponsesContextProvider, ResponsesDataContext, ResponsesDataContextProvider, ResponsesRoot, ResponsesToolbar, ResponsiveImageProxy as ResponsiveImage, ResponsiveImageImgix, ResponsiveImageProxy, SCROLL_TO_EVENT, ScaledImageProxy as ScaledImage, ScaledImageImgix, ScaledImageProxy, ScaledImageWrapper, RiScales3Fill as ScalesIcon, SearchContextProvider, SelectTimezone, SetupPushNotifications, SharePublishedPost, SharingButtons, ShowNotificationsPanel, SignUpOrLoginPanel, SignUpOrLoginPanel2, SimplePlayer, SimpleRecorder, SimpleRecorderContext, SimpleRecorderContextProvider, SimpleRecorderContextProviderInner, SingleNumber, SortResponsesButton, Staging, StartNewDiscussionThreadButton, TIME_TO_PREPARE, Tags$1 as Tags, TermsAndConditionsDialog, TermsText, TestPromptMenuItem, TextField, ThreadCard, FiThumbsDown as ThumbsDownIcon, FiThumbsUp as ThumbsUpIcon, TimeFormSelector, TimeFormSelectorStateless, TimeSelector, Title$2 as Title, Toasts, TransNotFound, TransientRoot, USER_VOTED_EVENT, UnFlagPostMenuItem, UpdateInfo, UploadButton, UploadFileDialog, UserPostVoteButton, UserVotesList, UsersOnlineButton, UsersVoteDialog, ViewingAsGuest, VisibilityController, VoteDialogIcon, VoteDialogTitle, VoteRoundsList, WebsocketsContext, WebsocketsContextProvider, WelcomeHtml, WelcomePage, WelcomeToCircleButton, WelcomeToPageButton, WhenLoggedIn, WhenNotLoggedIn, adminsToolsVisibleKey, approveCircle, beginningOfTheDay, biometricAvailability, bookCairBrowseUrl, bookCairDashboardUrl, bookCairDesktopUrl, bookCairLibraryUrl, bookCairMobileUrl, bookCairPaymentResultUrl, bookCairPaymentUrl, bookCairProfileUrl, bookCairPurchasesUrl, bookCairReaderUrl, buildQueryString, canUseDOM, changeCirclePrivacyApi, checkDevConsoleAlert, circleIdForPost, circleMembersUrl, circlePostUrl, circleUrl, circleWillBeApproved, clearBiometricToken, contentInfoFromDiv, createEvent, createPostUrl, dashboardUrl, dateTime2Day, defaultBlocks, defaultOrder, delay$1 as delay, detectTextDirection, dispatchPostEvent, dispatchResponseEvent, editCircleAssistantUrl, editPostUrl, editPostUrl2, embeddedVideoIndex, emitterSubscription, errorMessage, errorToast, errorsReported, eventCalendarLink, eventPageUrl, extractImage, extractImage2, extractResponsesData, extractSummary, extractTitle, extractTitle2, fileTypeIcon, filterIntroSteps, findClosestTime, flatten, flattenResponses, formControlCss, formatGMTOffset, formatRatingValue, getBiometricToken, getBlockComponent, getBrowserLanguage, getClosestDefault, getContentInfo, getDirection$1 as getDirection, getDirectionality, getEventStatusId$1 as getEventStatusId, getEventStatusInfo, getLanguage, getLanguageOptions, getLoginUrl, getPersonName, getPostTypeIcon, getQueryStringParams, getSearchParam, getTiny, getTinyEditorById, getTranslation, getUserTimezone, gtag, headingElement, highlightPostWrapperCss, humanFileSize, imageDimensions, implementEventEmitter, importDocumentUrl, info, initTiny, isAdmin, isAuthor, isExpoWrapper, isInstanceAdmin, isLocalPlayground, isLocalhost, isMobileWrapper, isNsContent, isRtlText, isSSR, isStaging, isValidDate, isValidTag, keepChatsHistory, keepPostsHistory, keepVotesHistory, listRequest2Redux, loadCirclePosts, loadCircleReferences, loadJsLibs, loadPage, loadPolyfills, loadPost, loadPostCircleData, loadPostViewData, loadResponses, localDateTime, logToNative, memberProfileUrl, mobileAppOs, mutatePostResponses, myCirclesUrl, noop$u as noop, noteTypes, nsEnvironment, objectId, openBrowserAsync, openSettings, pageView, positionRelativePage, postAudienceUrl, postCalendarLink, postCircleId, postCircleUrl, postEmitter, postUrl, preprocessSteps, redirectUrl, replaceTitle, resolveTextDirection, responsesEmitter, runOnLogin, savePostAudio, scrollIntoView, selectIntroStepElement, setBlockComponent, showDesktopNotifications, showToastsConfig, stepDescription, storeBiometricToken, swrLoadOnce, tagUrl, toast, url4post, useAccessContext, useActivityContext, useAddNote, useApi, useAppComponents, useAssetEditor, useAutoJoinCircleFn, useBlockContext, useBlockSaver, useBlocksContext, useBlocksOrderContext, useCDNImageContext, useCalendar, useCanExecutePrompt, useCheckActivity, useCheckActivityBadge, useCircleApiContext, useCircleContext, useCircleModalDialogsContext, useCirclePostItems, useCirclePostsState, useCirclePostsStateContext, useCircleSearchContext, useClearSearchContext, useConfiguredTabs, useContentContext, useCreateDraftToEditFn, useDashboardPageContext, useDateStyles, useDaysAgoString, useDirectionality, useDiscoverPageContext, useDraftEditor, useEventPostPagePath, useFormActions, useFormContext, useFormData, useFormField, useGTagPageView, useGetJwtTokenFn, useGoogleApiAccessToken, useGoogleAuthHelper, useGuestWithJoinOptionV2, useHelpContext, useInitGTag, useInviteNewMembersFn, useInvitesContext, useIsCircleAdmin, useIsDrafts, useIsInstanceAdmin, useIsNewsSocial, useJss, useJwtCookies, useLanguage, useLanguageSelectionContext, useLoadResponses, useLoading, useLoginButtons, useLoginFn, useNativeEventContext, useNotes, useNotificationsContext, useNotificationsLastDayString, useOnEditClickFn, useOnLoginSuccess, useOpenEditEventFn, useOpenResponse, useOpenSettingsDialog, useOpened, usePasskeyEnroll, usePersonName, usePostContext, usePostEditorContext, usePostEmitterSubscription, usePostGroupData, usePostRefreshResponses, usePostUpdatesContext, usePostViewDataHelper, usePostVisitorContext, usePrivacyPolicy, useProfileContext, useQueryStringParams, useRating, useRegistrationContext, useResponseEmitterSubscription, useResponseRoutesContext, useResponsesContext, useResponsesDataContext, useResponsesDataCore, useSearchContext, useSearchContext2, useSearchFilter$1 as useSearchFilter, useSetOnLoginAction, useSetOnLoginUrl, useSimpleRecorderContext, useTestPrompt, useTheme$1 as useTheme, useTimezones, useUnFlagPost, useUpdateEditedDraftFn, useVisibilityController, useVisibilitySensor, useVotes, useVotesActivity, useWebsocketSubscription, useWebsockets, useWelcomeToCircle, userOrMeSlug, videoIndex, viewCircleAssistantUrl, youTubeIndex };
